export const QUESTIONS = [
  {
    "id": 2000,
    "question": "Alyssa is responsible for her organization's security awareness program. She <strong>is</strong> concerned that changes in technology may make the content outdated. <br>What control can she put in place to protect against this risk?",
    "choice_a": "Gamification",
    "choice_b": "Computer-based training",
    "choice_c": "Content Reviews",
    "choice_d": "Live training",
    "correct_answer": "C",
    "explanation": "Alyssa should use periodic content reviews to continually verify that the content in her program meets the organization's needs and is up-to-date based upon the evolving risk landscape. She may do this using a combination of computer-based training, live training, and gamification, but those techniques do not necessarily verify that the content is updated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      66,
      53,
      1,
      47
    ],
    "source": ""
  },
  {
    "id": 2001,
    "question": "Gavin is creating a report to management on the results of his most recent risk assessment. In his report, he would like to identify the remaining level of risk to the organization after adopting security controls. <br>What term best describes this current level of risk?",
    "choice_a": "Inherent risk",
    "choice_b": "Residual risk",
    "choice_c": "Control risk",
    "choice_d": "Mitigated risk",
    "correct_answer": "B",
    "explanation": "The residual risk is the level of risk that remains after controls have been applied to mitigate risks. Inherent risk is the original risk that existed prior to the controls. Control risk is new risk introduced by the addition of controls to the environment. Mitigated risk is the risk that has been addressed by existing controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      42,
      70,
      49,
      45
    ],
    "source": ""
  },
  {
    "id": 2002,
    "question": "Francine is a security specialist for an online service provider in the United States. She recently received a claim from a copyright holder that a user is storing information on her service that violates the third party's copyright. <br>What law governs the actions that Francine must take?",
    "choice_a": "Copyright Act",
    "choice_b": "Lanham Act",
    "choice_c": "Digital Millennium Copyright Act",
    "choice_d": "Gramm Leach Bliley Act",
    "correct_answer": "C",
    "explanation": "The Digital Millennium Copyright Act (DMCA) sets forth the requirements for online service providers when handling copyright complaints received from third parties. The Copyright Act creates the mechanics for issuing and enforcing copyrights but does not cover the actions of online service providers. The Lanham Act regulates the issuance of trademarks to protect intellectual property. The Gramm-Leach-Bliley Act regulates the handling of personal financial information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      100,
      987,
      110,
      117
    ],
    "source": ""
  },
  {
    "id": 2003,
    "question": "FlyAway Travel has offices in both the European Union (EU) and the United States and transfers personal information between those offices regularly. They have recently received a request from an EU customer requesting that their account be terminated. <br>Under the General Data Protection Regulation (GDPR), which requirement for processing personal information states that individuals may request that their data no longer be disseminated or processed?",
    "choice_a": "The right to access",
    "choice_b": "Privacy by design",
    "choice_c": "The right to be forgotten",
    "choice_d": "The right of data portability",
    "correct_answer": "C",
    "explanation": "The right to be forgotten, also known as the right to erasure, guarantees the data subject the ability to have their information removed from processing or use. It may be tied to consent given for data processing; if a subject revokes consent for processing, the data controller may need to take additional steps, including erasure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      114,
      118,
      109,
      105
    ],
    "source": ""
  },
  {
    "id": 2004,
    "question": "After conducting a qualitative risk assessment of her organization, Sally recommends purchasing cybersecurity breach insurance. <br>What type of risk response behavior is she recommending?",
    "choice_a": "Accept",
    "choice_b": "Transfer",
    "choice_c": "Reduce",
    "choice_d": "Reject",
    "correct_answer": "B",
    "explanation": "Purchasing insurance is a means of transferring risk. If Sally had worked to decrease the likelihood of the events occurring, she would have been using a reduce or risk mitigation strategy, while simply continuing to function as the organization has would be an example of an acceptance strategy. Rejection, or denial of the risk, is not a valid strategy, even though it occurs!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      70,
      52,
      44,
      41
    ],
    "source": ""
  },
  {
    "id": 2005,
    "question": "Which one of the following elements of information is not considered personally identifiable information that would trigger most United States (U.S.) state data breach laws?",
    "choice_a": "Student identification number",
    "choice_b": "Social Security number",
    "choice_c": "Driver's license number",
    "choice_d": "Credit card number",
    "correct_answer": "A",
    "explanation": "Most state data breach notification laws are modeled after California's data breach notification law, which covers Social Security number, driver's license number, state identification card number, credit/debit card numbers, and bank account numbers (in conjunction with a PIN or password). California's breach notification law also protects some items not commonly found in other state laws, including medical records and health insurance information. These laws are separate and distinct from privacy laws, such as the California Consumer Privacy Act (CCPA), which regulates the handling of personal information more broadly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      118,
      114,
      105,
      115
    ],
    "source": ""
  },
  {
    "id": 2007,
    "question": "Henry recently assisted one of his co-workers in preparing for the CISSP exam. During this process, Henry disclosed confidential information about the content of the exam, in violation of Canon IV of the Code of Ethics: \"Advance and protect the profession.\" <br>Who may bring ethics charges against Henry for this violation?",
    "choice_a": "Anyone may bring charges.",
    "choice_b": "Any certified or licensed professional may bring charges.",
    "choice_c": "Only Henry's employer may bring charges.",
    "choice_d": "Only the affected employee may bring charges.",
    "correct_answer": "B",
    "explanation": "This is a question about who has standing to bring an ethics complaint. The group of individuals who has standing differs based upon the violated canon. In this case, we are examining Canon IV, which permits any certified or licensed professional who subscribes to a code of ethics to bring charges. Charges of violations of Canons I or II may be brought by anyone. Charges of violations of Canon III may only be brought by a principal with an employer/contractor relationship with the accused.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      957,
      955,
      956,
      17,
      11
    ],
    "source": ""
  },
  {
    "id": 2008,
    "question": "Wanda is working with one of her organization's European Union business partners to facilitate the exchange of customer information. Wanda's organization is located in the United States. <br>What would be the best method for Wanda to use to ensure GDPR compliance?",
    "choice_a": "Binding corporate rules",
    "choice_b": "Privacy Shield",
    "choice_c": "Standard contractual clauses",
    "choice_d": "Safe harbor",
    "correct_answer": "C",
    "explanation": "The European Union provides standard contractual clauses that may be used to facilitate data transfer. That would be the best choice in a case where two different companies are sharing data. If the data were being shared internally within a company, binding corporate rules would also be an option. The EU/U.S. Privacy Shield was a safe harbor agreement that would previously have allowed the transfer but is no longer valid.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      119,
      118,
      105,
      114
    ],
    "source": ""
  },
  {
    "id": 2009,
    "question": "Yolanda is the chief privacy officer for a financial institution and is researching privacy requirements related to customer checking accounts. <br>Which one of the following laws is most likely to apply to this situation?",
    "choice_a": "GLBA",
    "choice_b": "SOX",
    "choice_c": "HIPAA",
    "choice_d": "FERPA",
    "correct_answer": "A",
    "explanation": "The Gramm-Leach-Bliley Act (GLBA) contains provisions regulating the privacy of customer financial information. It applies specifically to financial institutions. <br>The Sarbanes Oxley (SOX) Act regulates the financial reporting activities of publicly traded companies. <br>The Health Insurance Portability and Accountability Act (HIPAA) regulates the handling of protected health information (PHI). <br>The Family Educational Rights and Privacy Act (FERPA) regulates the handling of student educational records.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      105,
      118,
      117,
      108
    ],
    "source": ""
  },
  {
    "id": 2010,
    "question": "Tim's organization recently received a contract to conduct sponsored research as a government contractor. <br>What law now likely applies to the information systems involved in this contract?",
    "choice_a": "FISMA",
    "choice_b": "PCI DSS",
    "choice_c": "HIPAA",
    "choice_d": "GISRA",
    "correct_answer": "A",
    "explanation": "The Federal Information Security Management Act (FISMA) specifically applies to government contractors. The Government Information Security Reform Act (GISRA) was the precursor to FISMA and expired in November 2002. HIPAA and PCI DSS apply to healthcare and credit card information, respectively.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      880,
      19,
      116,
      117
    ],
    "source": ""
  },
  {
    "id": 2011,
    "question": "Chris is advising travelers from his organization who will be visiting many different countries overseas. He is concerned about compliance with export control laws. <br>Which of the following technologies is most likely to trigger these regulations?",
    "choice_a": "Memory chips",
    "choice_b": "Office productivity applications",
    "choice_c": "Hard drives",
    "choice_d": "Encryption software",
    "correct_answer": "D",
    "explanation": "The export of encryption software to certain countries is regulated under U.S. export control laws. Memory chips, office productivity applications, and hard drives are unlikely to be covered by these regulations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      99,
      100,
      12,
      30
    ],
    "source": ""
  },
  {
    "id": 2012,
    "question": "Bobbi is investigating a security incident and discovers that an attacker began with a normal user account but managed to exploit a system vulnerability to provide that account with administrative rights. <br>What type of attack took place under the STRIDE threat model?",
    "choice_a": "Spoofing",
    "choice_b": "Repudiation",
    "choice_c": "Tampering",
    "choice_d": "Elevation of privilege",
    "correct_answer": "D",
    "explanation": "In an elevation of privilege attack, the attacker transforms a limited user account into an account with greater privileges, powers, and/or access to the system. Spoofing attacks falsify an identity, while repudiation attacks attempt to deny accountability for an action. Tampering attacks attempt to violate the integrity of information or resources.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      25,
      26,
      23,
      2
    ],
    "source": ""
  },
  {
    "id": 2013,
    "question": "You are completing your business continuity planning effort and have decided that you want to accept one of the risks. <br>What should you do next?",
    "choice_a": "Implement new security controls to reduce the risk level.",
    "choice_b": "Design a disaster recovery plan.",
    "choice_c": "Repeat the business impact assessment.",
    "choice_d": "Document your decision-making process.",
    "correct_answer": "D",
    "explanation": "Whenever you choose to accept a risk, you should maintain detailed documentation of the risk acceptance process to satisfy auditors in the future. This should happen before implementing security controls, designing a disaster recovery plan, or repeating the business impact analysis (BIA).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      93,
      91,
      88,
      87,
      83
    ],
    "source": ""
  },
  {
    "id": 2014,
    "question": "You are completing a review of the controls used to protect a media storage facility in your organization and would like to properly categorize each control that is currently in place. <br>Which of the following control categories accurately describe a fence around a facility? (Select all that apply.)",
    "choice_a": "Physical",
    "choice_b": "Detection",
    "choice_c": "Deterrent",
    "choice_d": "Preventive",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "A fence does not have the ability to detect intrusions. It does, however, have the ability to prevent and deter an intrusion. Fences are an example of a physical control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      47,
      10,
      2,
      54,
      59
    ],
    "source": ""
  },
  {
    "id": 2015,
    "question": "Tony is developing a business continuity plan and is having difficulty prioritizing resources because of the difficulty of combining information about tangible and intangible assets. <br>What would be the most effective risk assessment approach for him to use?",
    "choice_a": "Quantitative risk assessment",
    "choice_b": "Qualitative risk assessment",
    "choice_c": "Neither quantitative nor qualitative risk assessment",
    "choice_d": "Combination of quantitative and qualitative risk assessment",
    "correct_answer": "D",
    "explanation": "Tony would see the best results by combining elements of quantitative and qualitative risk assessment. Quantitative risk assessment excels at analyzing financial risk, while qualitative risk assessment is a good tool for intangible risks. Combining the two techniques provides a well-rounded risk picture.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      44,
      96,
      83,
      87,
      70
    ],
    "source": ""
  },
  {
    "id": 2016,
    "question": "Vincent believes that a former employee took trade secret information from his firm and brought it with him to a competitor. He wants to pursue legal action. <br>Under what law could he pursue charges?",
    "choice_a": "Copyright law",
    "choice_b": "Lanham Act",
    "choice_c": "Glass-Steagall Act",
    "choice_d": "Economic Espionage Act",
    "correct_answer": "D",
    "explanation": "The Economic Espionage Act imposes fines and jail sentences on anyone found guilty of stealing trade secrets from a U.S. corporation. It gives true teeth to the intellectual property rights of trade secret owners. Copyright law does not apply in this situation because there is no indication that the information was copyrighted. The Lanham Act applies to trademark protection cases. The Glass-Steagall Act was a banking reform act that is not relevant in this situation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      103,
      97,
      100,
      98
    ],
    "source": ""
  },
  {
    "id": 2017,
    "question": "Which one of the following principles imposes a standard of care upon an individual that is broad and equivalent to what one would expect from a reasonable person under the circumstances?",
    "choice_a": "Due diligence",
    "choice_b": "Separation of duties",
    "choice_c": "Due care",
    "choice_d": "Least privilege",
    "correct_answer": "C",
    "explanation": "The due care principle states that an individual should react in a situation using the same level of care that would be expected from any reasonable person. It is a very broad standard. The due diligence principle is a more specific component of due care that states that an individual assigned a responsibility should exercise due care to complete it accurately and in a timely manner.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      15,
      11,
      17,
      32
    ],
    "source": ""
  },
  {
    "id": 2018,
    "question": "Brenda's organization recently completed the acquisition of a competitor firm. <br>Which one of the following tasks would be LEAST likely to be part of the organizational processes addressed during the acquisition?",
    "choice_a": "Consolidation of security functions",
    "choice_b": "Integration of security tools",
    "choice_c": "Protection of intellectual property",
    "choice_d": "Documentation of security policies",
    "correct_answer": "C",
    "explanation": "The protection of intellectual property is a greater concern during a divestiture, where a subsidiary is being spun off into a separate organization, than an acquisition, where one firm has purchased another. Acquisition concerns include consolidating security functions and policies as well as integrating security tools.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      77,
      78,
      103,
      41
    ],
    "source": ""
  },
  {
    "id": 2019,
    "question": "Kelly believes that an employee engaged in the unauthorized use of computing resources for a side business. After consulting with management, she decides to launch an administrative investigation. <br>What is the burden of proof that she must meet in this investigation?",
    "choice_a": "Preponderance of the evidence",
    "choice_b": "Beyond a reasonable doubt",
    "choice_c": "Beyond the shadow of a doubt",
    "choice_d": "There is no standard",
    "correct_answer": "D",
    "explanation": "Unlike criminal or civil cases, administrative investigations are an internal matter, and there is no set standard of proof that Kelly must apply. However, it would still be wise for her organization to include a standard burden of proof in their own internal procedures to ensure the thoroughness and fairness of investigations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      99,
      117,
      15,
      22
    ],
    "source": ""
  },
  {
    "id": 2020,
    "question": "Keenan Systems recently developed a new manufacturing process for microprocessors. The company wants to license the technology to other companies for use but wants to prevent unauthorized use of the technology. <br>What type of intellectual property protection is best suited for this situation?",
    "choice_a": "Patent",
    "choice_b": "Trade secret",
    "choice_c": "Copyright",
    "choice_d": "Trademark",
    "correct_answer": "A",
    "explanation": "Patents and trade secrets can both protect intellectual property related to a manufacturing process. Trade secrets are appropriate only when the details can be tightly controlled within an organization, so a patent is the appropriate solution in this case. Copyrights are used to protect creative works, while trademarks are used to protect names, logos, and symbols.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      987,
      103,
      110,
      35
    ],
    "source": ""
  },
  {
    "id": 2021,
    "question": "Which one of the following actions might be taken as part of a business continuity plan?",
    "choice_a": "Restoring from backup tapes",
    "choice_b": "Implementing RAID",
    "choice_c": "Relocating to a cold site",
    "choice_d": "Restarting business operations",
    "correct_answer": "B",
    "explanation": "RAID technology provides fault tolerance for hard drive failures and is an example of a business continuity action. Restoring from backup tapes, relocating to a cold site, and restarting business operations are all disaster recovery actions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      88,
      89,
      93
    ],
    "source": ""
  },
  {
    "id": 2022,
    "question": "When developing a business impact analysis, the team should first create a list of assets. <br>What should happen next?",
    "choice_a": "Identify vulnerabilities in each asset.",
    "choice_b": "Determine the risks facing the asset.",
    "choice_c": "Develop a value for each asset.",
    "choice_d": "Identify threats facing each asset.",
    "correct_answer": "C",
    "explanation": "After developing a list of assets, the business impact analysis team should assign values to each asset. The other activities listed here occur only after the assets are assigned values.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      86,
      87,
      96,
      74
    ],
    "source": ""
  },
  {
    "id": 2023,
    "question": "Mike recently implemented an intrusion prevention system designed to block common network attacks from affecting his organization. <br>What type of risk management strategy is Mike pursuing?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk avoidance",
    "choice_c": "Risk mitigation",
    "choice_d": "Risk transference",
    "correct_answer": "C",
    "explanation": "Risk mitigation strategies attempt to lower the probability and/or impact of a risk occurring. Intrusion prevention systems attempt to reduce the probability of a successful attack and are, therefore, examples of risk mitigation. Risk acceptance involves making a conscious decision to accept a risk as-is with no further action.  Risk avoidance alters business activities to make a risk irrelevant.  Risk transfer shifts the costs of a risk to another organization, such as an insurance company.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      70,
      41,
      44,
      50
    ],
    "source": ""
  },
  {
    "id": 2024,
    "question": "Laura has been asked to perform an SCA. <br>What type of organization is she most likely in?",
    "choice_a": "Higher education",
    "choice_b": "Banking",
    "choice_c": "Government",
    "choice_d": "Healthcare",
    "correct_answer": "C",
    "explanation": "A security controls assessment (SCA) most often refers to a formal U.S. government process for assessing security controls and is often paired with a Security Test and Evaluation (ST&E) process. This means that Laura is probably part of a government organization or contractor.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      881,
      882,
      13,
      47
    ],
    "source": ""
  },
  {
    "id": 2025,
    "question": "Carl is a federal agent investigating a computer crime case. He identified an attacker who engaged in illegal conduct and wants to pursue a case against that individual that will lead to imprisonment. <br>What standard of proof must Carl meet?",
    "choice_a": "Beyond the shadow of a doubt",
    "choice_b": "Preponderance of the evidence",
    "choice_c": "Beyond a reasonable doubt",
    "choice_d": "Majority of the evidence",
    "correct_answer": "C",
    "explanation": "There are two steps to answering this question. First, you must realize that for the case to lead to imprisonment, it must be the result of a criminal investigation. Next, you must know that the standard of proof for a criminal investigation is normally the beyond a reasonable doubt standard.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      100,
      97,
      101,
      113,
      102
    ],
    "source": ""
  },
  {
    "id": 2026,
    "question": "The International Information Systems Security Certification Consortium uses the logo shown here to represent itself online and in a variety of forums. <br>What type of intellectual property protection may it use to protect its rights in this logo?<br><img src=\"/question_assets/CISSP/1_image1.png\"/>",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trade secret",
    "choice_d": "Trademark",
    "correct_answer": "D",
    "explanation": "Trademark protection extends to words and symbols used to represent an organization, product, or service in the marketplace. Copyrights are used to protect creative works.  Patents and trade secrets are used to protect inventions and similar intellectual property.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      987,
      986,
      985,
      117
    ],
    "source": ""
  },
  {
    "id": 2027,
    "question": "Mary is helping a computer user who sees the following message appear on his computer screen. <br>What type of attack has occurred?<br><img src=\"/question_assets/CISSP/1_image2.png\"/>",
    "choice_a": "Availability",
    "choice_b": "Confidentiality",
    "choice_c": "Disclosure",
    "choice_d": "Distributed",
    "correct_answer": "A",
    "explanation": "The message displayed is an example of ransomware, which encrypts the contents of a user's computer to prevent legitimate use. This is an example of an availability attack. There is no indication that the data was disclosed to others, so there is no confidentiality/disclosure risk.  There is also no indication that other systems were involved in a distributed attack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      52,
      2,
      65
    ],
    "source": ""
  },
  {
    "id": 2028,
    "question": "Which one of the following organizations would not be automatically subject to the privacy and security requirements of HIPAA if they engage in electronic transactions?",
    "choice_a": "Healthcare provider",
    "choice_b": "Health and fitness application developer",
    "choice_c": "Health information clearinghouse",
    "choice_d": "Health insurance plan",
    "correct_answer": "B",
    "explanation": "A health and fitness application developer would not necessarily be collecting or processing healthcare data, and the terms of HIPAA do not apply to this category of business. HIPAA regulates three types of entities-healthcare providers, health information clearinghouses, and health insurance plans-as well as the business associates of any of those covered entities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      880,
      118,
      1046,
      105,
      108
    ],
    "source": ""
  },
  {
    "id": 2029,
    "question": "John's network begins to experience symptoms of slowness. Upon investigation, he realizes that the network is being bombarded with TCP SYN packets and believes that his organization is the victim of a denial-of-service attack. <br>What principle of information security is being violated?",
    "choice_a": "Availability",
    "choice_b": "Integrity",
    "choice_c": "Confidentiality",
    "choice_d": "Denial",
    "correct_answer": "A",
    "explanation": "A smurf attack is an example of a denial-of-service attack, which jeopardizes the availability of a targeted network. Smurf attacks do not target integrity or confidentiality.  While this is a denial of service attack, denial is not the correct answer because you are asked which principle is violated, not what type of attack took place.  Denial of service attacks target resource availability.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      5,
      20,
      11,
      2
    ],
    "source": ""
  },
  {
    "id": 2030,
    "question": "Renee is designing the long-term security plan for her organization and has a three- to five-year planning horizon. Her primary goal is to align the security function with the broader plans and objectives of the business. <br>What type of plan is she developing?",
    "choice_a": "Operational",
    "choice_b": "Tactical",
    "choice_c": "Summary",
    "choice_d": "Strategic",
    "correct_answer": "D",
    "explanation": "Strategic plans have a long-term planning horizon of up to five years in most cases. They are designed to strategically align the security function with the business' objectives. Operational and tactical plans have shorter horizons of a year or less.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      14,
      32,
      15,
      1
    ],
    "source": ""
  },
  {
    "id": 2031,
    "question": "Gina is working to protect a logo that her company will use for a new product they are launching. She has questions about the intellectual property protection process for this logo. <br>What U.S. government agency would be best able to answer her questions?",
    "choice_a": "USPTO",
    "choice_b": "Library of Congress",
    "choice_c": "NSA",
    "choice_d": "NIST",
    "correct_answer": "A",
    "explanation": "First, you must realize that a trademark is the correct intellectual property protection mechanism for a logo. Therefore, Gina should contact the United States Patent and Trademark Office (USPTO), which bears responsibility for the registration of trademarks. The Library of Congress administers the copyright program. The National Security Agency (NSA) and the National Institute for Standards and Technology (NIST) play no role in intellectual property protection.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      986,
      987,
      985,
      100
    ],
    "source": ""
  },
  {
    "id": 2032,
    "question": "The Acme Widgets Company is putting new controls in place for its accounting department. Management is concerned that a rogue accountant may be able to create a new false vendor and then issue checks to that vendor as payment for services that were never rendered. <br>What security control can best help prevent this situation?",
    "choice_a": "Mandatory vacation",
    "choice_b": "Separation of duties",
    "choice_c": "Defense in depth",
    "choice_d": "Job rotation",
    "correct_answer": "B",
    "explanation": "When following the separation of duties principle, organizations divide critical tasks into discrete components and ensure that no one individual has the ability to perform both actions. This prevents a single rogue individual from performing that task in an unauthorized manner. Mandatory vacations and job rotations are designed to detect fraud, not prevent it.  Defense in depth is not the relevant principle here because the answer is seeking an initial control.  We may choose to add additional controls at a later date, but the primary objective here would be to implement separation of duties.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      36,
      31,
      47,
      62,
      33
    ],
    "source": ""
  },
  {
    "id": 2033,
    "question": "Which one of the following categories of organizations is most likely to be covered by the provisions of FISMA?",
    "choice_a": "Banks",
    "choice_b": "Defense contractors",
    "choice_c": "School districts",
    "choice_d": "Hospitals",
    "correct_answer": "B",
    "explanation": "The U.S. Federal Information Security Management Act (FISMA) applies to federal government agencies and contractors. Of the entities listed, a defense contractor is the most likely to have government contracts subject to FISMA.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      881,
      882,
      880,
      99
    ],
    "source": ""
  },
  {
    "id": 2034,
    "question": "Robert is responsible for securing systems used to process credit card information. <br>What security control framework should guide his actions?",
    "choice_a": "HIPAA",
    "choice_b": "PCI DSS",
    "choice_c": "SOX",
    "choice_d": "GLBA",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) governs the storage, processing, and transmission of credit card information. The Sarbanes Oxley (SOX) Act regulates the financial reporting activities of publicly traded companies.  The Health Insurance Portability and Accountability Act (HIPAA) regulates the handling of protected health information (PHI).  The Gramm Leach Bliley Act (GLBA) regulates the handling of personal financial information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      19,
      50,
      1,
      14
    ],
    "source": ""
  },
  {
    "id": 2035,
    "question": "Which one of the following individuals is normally responsible for fulfilling the operational data protection responsibilities delegated by senior management, such as validating data integrity, testing backups, and managing security policies?",
    "choice_a": "Data custodian",
    "choice_b": "Data owner",
    "choice_c": "User",
    "choice_d": "Auditor",
    "correct_answer": "A",
    "explanation": "The data custodian role is assigned to an individual who is responsible for implementing the security controls defined by policy and senior management. The data owner does bear ultimate responsibility for these tasks, but the data owner is typically a senior leader who delegates operational responsibility to a data custodian.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      20,
      1,
      14,
      47
    ],
    "source": ""
  },
  {
    "id": 2036,
    "question": "Alan works for an e-commerce company that recently had some content stolen by another website and republished without permission. <br>What type of intellectual property protection would best preserve Alan's company's rights?",
    "choice_a": "Trade secret",
    "choice_b": "Copyright",
    "choice_c": "Trademark",
    "choice_d": "Patent",
    "correct_answer": "B",
    "explanation": "Written works, such as website content, are normally protected by copyright law. Trade secret status would not be appropriate here because the content is online and available outside the company. Patents protect inventions, and trademarks protect words and symbols used to represent a brand, neither of which is relevant in this scenario.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      987,
      104,
      117,
      6
    ],
    "source": ""
  },
  {
    "id": 2037,
    "question": "Florian receives a flyer from a U.S.federal government agency announcing that a new administrative law will affect his business operations. <br>Where should he go to find the text of the law?",
    "choice_a": "United States Code",
    "choice_b": "Supreme Court rulings",
    "choice_c": "Code of Federal Regulations",
    "choice_d": "Compendium of Laws",
    "correct_answer": "C",
    "explanation": "The Code of Federal Regulations (CFR) contains the text of all administrative laws promulgated by federal agencies. The United States Code contains criminal and civil law. Supreme Court rulings contain interpretations of law and are not laws themselves. The Compendium of Laws does not exist.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      117,
      102,
      98
    ],
    "source": ""
  },
  {
    "id": 2038,
    "question": "Tom enables an application firewall provided by his cloud infrastructure as a service provider that is designed to block many types of application attacks. <br>When viewed from a risk management perspective, what metric is Tom attempting to lower by implementing this countermeasure?",
    "choice_a": "Impact",
    "choice_b": "RPO",
    "choice_c": "MTO",
    "choice_d": "Likelihood",
    "correct_answer": "D",
    "explanation": "Installing a device that will block attacks is an attempt to lower risk by reducing the likelihood of a successful application attack. Adding a firewall will not address the impact of a risk, the recovery point objective (RPO) or the maximum tolerable outage (MTO).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      2,
      84,
      88,
      85
    ],
    "source": ""
  },
  {
    "id": 2039,
    "question": "Which one of the following individuals would be the most effective organizational owner for an information security program?",
    "choice_a": "CISSP-certified analyst",
    "choice_b": "Chief information officer (CIO)",
    "choice_c": "Manager of network security",
    "choice_d": "President and CEO",
    "correct_answer": "B",
    "explanation": "The owner of information security programs may be different from the individuals responsible for implementing the controls. This person should be as senior an individual as possible who is able to focus on the management of the security program. The president and CEO would not be an appropriate choice because an executive at this level is unlikely to have the time necessary to focus on security. Of the remaining choices, the CIO is the most senior position who would be the strongest advocate at the executive level.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      15,
      11,
      17,
      14,
      1
    ],
    "source": ""
  },
  {
    "id": 2040,
    "question": "What important function do senior managers normally fill on a business continuity planning team?",
    "choice_a": "Arbitrating disputes about criticality",
    "choice_b": "Evaluating the legal environment",
    "choice_c": "Training staff",
    "choice_d": "Designing failure controls",
    "correct_answer": "A",
    "explanation": "Senior managers play several business continuity planning roles. These include setting priorities, obtaining resources, and arbitrating disputes among team members.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      79,
      78,
      95,
      80,
      82
    ],
    "source": ""
  },
  {
    "id": 2041,
    "question": "You are the CISO for a major hospital system and are preparing to sign a contract with a software as a service (SaaS) email vendor and want to perform a control assessment to ensure that its business continuity planning measures are reasonable. <br>What type of audit might you request to meet this goal?",
    "choice_a": "SOC 1",
    "choice_b": "FISMA",
    "choice_c": "PCI DSS",
    "choice_d": "SOC 2",
    "correct_answer": "D",
    "explanation": "The Service Organizations Control audit program includes business continuity controls in a SOC 2, but not SOC 1, audit. Although FISMA and PCI DSS may audit business continuity, they would not apply to an email service used by a hospital.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      81,
      74,
      83,
      2,
      115
    ],
    "source": ""
  },
  {
    "id": 2042,
    "question": "Gary is analyzing a security incident and, during his investigation, encounters a user who denies having performed an action that Gary believes he did perform. <br>What type of threat has taken place under the STRIDE model?",
    "choice_a": "Repudiation",
    "choice_b": "Information disclosure",
    "choice_c": "Tampering",
    "choice_d": "Elevation of privilege",
    "correct_answer": "A",
    "explanation": "Repudiation threats allow an attacker to deny having performed an action or activity without the other party being able to prove differently. There is no evidence that the attacker engaged in information disclosure, tampering, or elevation of privilege.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      23,
      26,
      3,
      17
    ],
    "source": ""
  },
  {
    "id": 2043,
    "question": "Beth is the security administrator for a public school district. She is implementing a new student information system and is testing the code to ensure that students are not able to alter their own grades. <br>What principle of information security is Beth enforcing?",
    "choice_a": "Integrity",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Denial",
    "correct_answer": "A",
    "explanation": "Integrity controls, such as the one Beth is implementing in this example, are designed to prevent the unauthorized modification of information. There is no evidence of an attack against availability or confidentiality.  Denial is an objective of attackers, rather than of security professionals and is not relevant in this scenario that targets integrity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      5,
      6,
      11,
      48
    ],
    "source": ""
  },
  {
    "id": 2044,
    "question": "Which one of the following issues is not normally addressed in a service-level agreement (SLA)?",
    "choice_a": "Confidentiality of customer information",
    "choice_b": "Failover time",
    "choice_c": "Uptime",
    "choice_d": "Maximum consecutive downtime",
    "correct_answer": "A",
    "explanation": "SLAs do not normally address issues of data confidentiality. Those provisions are normally included in a nondisclosure agreement (NDA).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      35,
      39,
      1045,
      20
    ],
    "source": ""
  },
  {
    "id": 2045,
    "question": "Joan is seeking to protect a piece of computer software that she developed under intellectual property law. <br>Which one of the following avenues of protection would not apply to a piece of software?",
    "choice_a": "Trademark",
    "choice_b": "Copyright",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "A",
    "explanation": "Trademarks protect words and images that represent a product or service and would not protect computer software.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      103,
      987,
      985,
      110,
      117
    ],
    "source": ""
  },
  {
    "id": 2046,
    "question": "Juniper Content is a web content development company with 40 employees located in two offices: one in New York and a smaller office in the San Francisco Bay Area. Each office has a local area network protected by a perimeter firewall. The local area network (LAN) contains modern switch equipment connected to both wired and wireless networks. <br>Each office has its own file server, and the information technology (IT) team runs software every hour to synchronize files between the two servers, distributing content between the offices. These servers are primarily used to store images and other files related to web content developed by the company. The team also uses a SaaS-based email and document collaboration solution for much of their work. <br>You are the newly appointed IT manager for Juniper Content, and you are working to augment existing security controls to improve the organization's security. <br>Users in the two offices would like to access each other's file servers over the internet. <br>What control would provide confidentiality for those communications?",
    "choice_a": "Digital signatures",
    "choice_b": "Virtual private network",
    "choice_c": "Virtual LAN",
    "choice_d": "Digital content management",
    "correct_answer": "B",
    "explanation": "Virtual private networks (VPNs) provide secure communications channels over otherwise insecure networks (such as the internet) using encryption. If you establish a VPN connection between the two offices, users in one office could securely access content located on the other office's server over the internet. Digital signatures are used to provide nonrepudiation, not confidentiality. Virtual LANs (VLANs) provide network segmentation on local networks but do not cross the internet. Digital content management solutions are designed to manage web content, not access shared files located on a file server.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      47,
      10,
      6
    ],
    "source": ""
  },
  {
    "id": 2047,
    "question": "Juniper Content is a web content development company with 40 employees located in two offices: one in New York and a smaller office in the San Francisco Bay Area. Each office has a local area network protected by a perimeter firewall. The local area network (LAN) contains modern switch equipment connected to both wired and wireless networks. <br>Each office has its own file server, and the information technology (IT) team runs software every hour to synchronize files between the two servers, distributing content between the offices. These servers are primarily used to store images and other files related to web content developed by the company. The team also uses a SaaS-based email and document collaboration solution for much of their work. <br>You are the newly appointed IT manager for Juniper Content, and you are working to augment existing security controls to improve the organization's security. <br>You are also concerned about the availability of data stored on each office's server. You would like to add technology that would enable continued access to files located on the server even if a hard drive in a server fails. <br>What control allows you to add robustness without adding additional servers?",
    "choice_a": "Server clustering",
    "choice_b": "Load balancing",
    "choice_c": "RAID",
    "choice_d": "Scheduled backups",
    "correct_answer": "C",
    "explanation": "RAID uses additional hard drives to protect the server against the failure of a single device. Load balancing and server clustering do add robustness but require the addition of a server. Scheduled backups protect against data loss but do not provide immediate access to data in the event of a hard drive failure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      47,
      82,
      96,
      95
    ],
    "source": ""
  },
  {
    "id": 2048,
    "question": "Juniper Content is a web content development company with 40 employees located in two offices: one in New York and a smaller office in the San Francisco Bay Area. Each office has a local area network protected by a perimeter firewall. The local area network (LAN) contains modern switch equipment connected to both wired and wireless networks. <br>Each office has its own file server, and the information technology (IT) team runs software every hour to synchronize files between the two servers, distributing content between the offices. These servers are primarily used to store images and other files related to web content developed by the company. The team also uses a SaaS-based email and document collaboration solution for much of their work. <br>You are the newly appointed IT manager for Juniper Content, and you are working to augment existing security controls to improve the organization's security. <br>Finally, there are historical records stored on the server that are extremely important to the business and should never be modified. You would like to add an integrity control that allows you to verify on a periodic basis that the files were not modified. <br>What control can you add?",
    "choice_a": "Hashing",
    "choice_b": "ACLs",
    "choice_c": "Read-only attributes",
    "choice_d": "Firewalls",
    "correct_answer": "A",
    "explanation": "Hashing allows you to computationally verify that a file has not been modified between hash evaluations. ACLs and read-only attributes are useful controls that may help you prevent unauthorized modification, but they cannot verify that files were not modified. Firewalls are network security controls and do not verify file integrity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      47,
      54,
      8,
      20
    ],
    "source": ""
  },
  {
    "id": 2049,
    "question": "Beth is a human resources specialist preparing to assist in the termination of an employee. <br>Which of the following is not typically part of a termination process?",
    "choice_a": "An exit interview",
    "choice_b": "Recovery of property",
    "choice_c": "Account termination",
    "choice_d": "Signing an NCA",
    "correct_answer": "D",
    "explanation": "Signing a noncompete or nondisclosure agreement is typically done at hiring. Exit interviews, recovery of organizational property, and account termination are all common elements of a termination process. During the exit interview, the team may choose to review employment agreements and policies that remain in force, such as a noncompete or nondisclosure agreement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      35,
      39,
      68,
      112
    ],
    "source": ""
  },
  {
    "id": 2050,
    "question": "Frances is reviewing her organization's business continuity plan documentation for completeness. <br>Which one of the following is not normally included in business continuity plan documentation?",
    "choice_a": "Statement of accounts",
    "choice_b": "Statement of importance",
    "choice_c": "Statement of priorities",
    "choice_d": "Statement of organizational responsibility",
    "correct_answer": "A",
    "explanation": "Business continuity plan documentation normally includes the continuity planning goals, a statement of importance, statement of priorities, statement of organizational responsibility, statement of urgency and timing, risk assessment and risk acceptance and mitigation documentation, a vital records program, emergency response guidelines, and documentation for maintaining and testing the plan.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      93,
      92,
      94,
      91,
      96
    ],
    "source": ""
  },
  {
    "id": 2051,
    "question": "An accounting employee at Doolittle Industries was recently arrested for participation in an embezzlement scheme. The employee transferred money to a personal account and then shifted funds around between other accounts every day to disguise the fraud for months. <br>Which one of the following controls might have best allowed the earlier detection of this fraud?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Defense in depth",
    "choice_d": "Mandatory vacation",
    "correct_answer": "D",
    "explanation": "Mandatory vacation programs require that employees take continuous periods of time off each year and revoke their system privileges during that time. The purpose of these required vacation periods is to disrupt any attempt to engage in the cover-up actions necessary to hide fraud and result in exposing the threat. Separation of duties, least privilege, and defense in depth controls all may help prevent the fraud in the first place but are unlikely to speed the detection of fraud that has already occurred.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      69,
      36,
      47,
      7,
      68
    ],
    "source": ""
  },
  {
    "id": 2052,
    "question": "Jeff would like to adopt an industry-standard approach for assessing the processes his organization uses to manage risk. <br>What maturity model would be most appropriate for his use?",
    "choice_a": "CMM",
    "choice_b": "SW-CMM",
    "choice_c": "RMM",
    "choice_d": "COBIT",
    "correct_answer": "C",
    "explanation": "The Risk Maturity Model (RMM) is specifically designed for the purpose of assessing enterprise risk management programs. Jeff could conceivably use the more generic capability maturity model (CMM), but this would not be as good of a fit. The software capability maturity model (SW-CMM) is designed for assessing development projects, not risk management efforts. The Control Objectives for Information Technology (COBIT) are a set of security control objectives and not a maturity model.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      72,
      50,
      41,
      44
    ],
    "source": ""
  },
  {
    "id": 2053,
    "question": "Chris' organization recently suffered an attack that rendered their website inaccessible to paying customers for several hours. <br>Which information security goal was most directly impacted?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Denial",
    "correct_answer": "C",
    "explanation": "Denial-of-service (DoS) attacks and distributed denial-of-service (DDoS) attacks try to disrupt the availability of information systems and networks by flooding a victim with traffic or otherwise disrupting service.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      5,
      95,
      82,
      77
    ],
    "source": ""
  },
  {
    "id": 2054,
    "question": "Yolanda is writing a document that will provide configuration information regarding the minimum level of security that every system in the organization must meet. <br>What type of document is she preparing?",
    "choice_a": "Policy",
    "choice_b": "Baseline",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "B",
    "explanation": "Baselines provide the minimum level of security that every system throughout the organization must meet. This type of information would not appear in a policy, guideline, or procedure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      15,
      13,
      10,
      72
    ],
    "source": ""
  },
  {
    "id": 2055,
    "question": "Who should receive initial business continuity plan training in an organization?",
    "choice_a": "Senior executives",
    "choice_b": "Those with specific business continuity roles",
    "choice_c": "Everyone in the organization",
    "choice_d": "First responders",
    "correct_answer": "C",
    "explanation": "Everyone in the organization should receive basic training on the nature and scope of the business continuity program. Those with specific roles, such as first responders and senior executives, should also receive detailed, role-specific training.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      92,
      78,
      79,
      65,
      94
    ],
    "source": ""
  },
  {
    "id": 2056,
    "question": "James is conducting a risk assessment for his organization and is attempting to assign an asset value to the servers in his data center. The organization's primary concern is ensuring that it has sufficient funds available to rebuild the data center in the event it is damaged or destroyed. <br>Which one of the following asset valuation methods would be most appropriate in this situation?",
    "choice_a": "Purchase cost",
    "choice_b": "Depreciated cost",
    "choice_c": "Replacement cost",
    "choice_d": "Opportunity cost",
    "correct_answer": "C",
    "explanation": "If the organization's primary concern is the cost of rebuilding the data center, James should use the replacement cost method to determine the current market price for equivalent servers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      43,
      42,
      44,
      83,
      82
    ],
    "source": ""
  },
  {
    "id": 2057,
    "question": "Roger's organization suffered a breach of customer credit card records. <br>Under the terms of PCI DSS, what organization may choose to pursue an investigation of this matter?",
    "choice_a": "FBI",
    "choice_b": "Local law enforcement",
    "choice_c": "Bank",
    "choice_d": "PCI SSC",
    "correct_answer": "C",
    "explanation": "PCI DSS is a standard promulgated by the Payment Card Industry Security Standards Council (PCI SSC), but is enforced through contractual relationships between merchants and their banks. Therefore, the bank would be the appropriate entity to initiate an investigation under PCI DSS. Local and federal law enforcement agencies (such as the FBI) could decide to pursue a criminal investigation if the circumstances warrant, but they do not have the authority to enforce PCI DSS requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      1050,
      100,
      20,
      97
    ],
    "source": ""
  },
  {
    "id": 2058,
    "question": "Rick recently engaged critical employees in each of his organization's business units to ask for their assistance with his security awareness program. They will be responsible for sharing security messages with their peers and answering questions about cybersecurity matters. <br>What term best describes this relationship?",
    "choice_a": "Security champion",
    "choice_b": "Security expert",
    "choice_c": "Gamification",
    "choice_d": "Peer review",
    "correct_answer": "A",
    "explanation": "This is an example of a security champion program that uses individuals employed in other roles in a business unit to share security messaging. The individuals in these roles are not necessarily security experts and do not have a peer review role.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      65,
      67,
      32,
      11,
      14
    ],
    "source": ""
  },
  {
    "id": 2059,
    "question": "Frank discovers a keylogger hidden on the laptop of his company's chief executive officer. <br>What information security principle is the keylogger most likely designed to disrupt?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Denial",
    "correct_answer": "A",
    "explanation": "Keyloggers monitor the keystrokes of an individual and report them back to an attacker. They are designed to steal sensitive information, a disruption of the goal of confidentiality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      55,
      31,
      1
    ],
    "source": ""
  },
  {
    "id": 2060,
    "question": "Elise is helping her organization prepare to evaluate and adopt a new cloud-based human resource management (HRM) system vendor. <br>What would be the most appropriate minimum security standard for her to require of possible vendors?",
    "choice_a": "Compliance with all laws and regulations",
    "choice_b": "Handling information in the same manner the organization would",
    "choice_c": "Elimination of all identified security risks",
    "choice_d": "Compliance with the vendor's own policies",
    "correct_answer": "B",
    "explanation": "The most appropriate standard to use as a baseline when evaluating vendors is to determine whether the vendor's security controls meet the organization's own standards. Compliance with laws and regulations should be included in that requirement and are a necessary, but not sufficient, condition for working with the vendor. Vendor compliance with their own policies also fits into the category of necessary, but not sufficient, controls, as the vendor's policy may be weaker than the organization's own requirements. The elimination of all identified security risks is an impossible requirement for a potential vendor to meet.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      38,
      22,
      1,
      15
    ],
    "source": ""
  },
  {
    "id": 2061,
    "question": "The following graphic shows the NIST risk management framework with step 4 missing. <br><img src=\"/question_assets/CISSP/1_image3.png\"/> <br>What is the missing step?",
    "choice_a": "Assess security controls.",
    "choice_b": "Determine control gaps.",
    "choice_c": "Remediate control gaps.",
    "choice_d": "Evaluate user activity.",
    "correct_answer": "A",
    "explanation": "The fourth step of the NIST risk management framework is assessing security controls. This is an important component of the process. The organization has already categorized the system, selected appropriate controls, and implemented those controls. Before authorizing the use of the system, they must assess the effectiveness of those controls to ensure that they meet security requirements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      50,
      54,
      41,
      47,
      53
    ],
    "source": ""
  },
  {
    "id": 2062,
    "question": "HAL Systems recently decided to stop offering public NTP services because of a fear that its NTP servers would be used in amplification DDoS attacks. <br>What type of risk management strategy did HAL pursue with respect to its NTP services?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk acceptance",
    "choice_c": "Risk transference",
    "choice_d": "Risk avoidance",
    "correct_answer": "D",
    "explanation": "HAL Systems decided to stop offering the service because of the risk. This is an example of a risk avoidance strategy. The company altered its operations in a manner that eliminates the risk of NTP misuse. Risk acceptance involves making a conscious decision to accept a risk as-is with no further action.  Risk mitigation takes measures to reduce the likelihood and/or impact of a risk.  Risk transfer shifts the costs of a risk to another organization, such as an insurance company.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      41,
      70,
      44,
      49
    ],
    "source": ""
  },
  {
    "id": 2063,
    "question": "Susan is working with the management team in her company to classify data in an attempt to apply extra security controls that will limit the likelihood of a data breach. <br>What principle of information security is Susan trying to enforce?",
    "choice_a": "Availability",
    "choice_b": "Denial",
    "choice_c": "Confidentiality",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "Confidentiality controls prevent the disclosure of sensitive information to unauthorized individuals. Limiting the likelihood of a data breach is an attempt to prevent unauthorized disclosure.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      47,
      8,
      15
    ],
    "source": ""
  },
  {
    "id": 2064,
    "question": "Which one of the following components should be included in an organization's emergency response guidelines?",
    "choice_a": "List of individuals who should be notified of an emergency incident",
    "choice_b": "Long-term business continuity protocols",
    "choice_c": "Activation procedures for the organization's cold sites",
    "choice_d": "Contact information for ordering equipment",
    "correct_answer": "A",
    "explanation": "The emergency response guidelines should include the immediate steps an organization should follow in response to an emergency situation. These include immediate response procedures, a list of individuals who should be notified of the emergency, and secondary response procedures for first responders. They do not include long-term actions such as activating business continuity protocols, ordering equipment, or activating DR sites.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      93,
      95,
      75,
      88,
      83
    ],
    "source": ""
  },
  {
    "id": 2065,
    "question": "Chas recently completed the development of his organization's business continuity plan. <br>Who is the ideal person to approve an organization's business continuity plan?",
    "choice_a": "Chief information officer",
    "choice_b": "Chief executive officer",
    "choice_c": "Chief information security officer",
    "choice_d": "Chief operating officer",
    "correct_answer": "B",
    "explanation": "Although the CEO will not normally serve on a BCP team, it is best to obtain top-level management approval for your plan to increase the likelihood of successful adoption.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      79,
      933,
      15,
      92
    ],
    "source": ""
  },
  {
    "id": 2066,
    "question": "Which one of the following actions is not normally part of the project scope and planning phase of business continuity planning?",
    "choice_a": "Structured analysis of the organization",
    "choice_b": "Review of the legal and regulatory landscape",
    "choice_c": "Creation of a BCP team",
    "choice_d": "Documentation of the plan",
    "correct_answer": "D",
    "explanation": "The project scope and planning phase includes four actions: a structured analysis of the organization, the creation of a BCP team, an assessment of available resources, and an analysis of the legal and regulatory landscape.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      74,
      77,
      78,
      80
    ],
    "source": ""
  },
  {
    "id": 2067,
    "question": "Gary is implementing a new website architecture that uses multiple small web servers behind a load balancer. <br>What principle of information security is Gary seeking to enforce?",
    "choice_a": "Denial",
    "choice_b": "Confidentiality",
    "choice_c": "Integrity",
    "choice_d": "Availability",
    "correct_answer": "D",
    "explanation": "Keeping a server up and running is an example of an availability control because it increases the likelihood that a server will remain available to answer user requests.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      95,
      82,
      15,
      11
    ],
    "source": ""
  },
  {
    "id": 2068,
    "question": "Becka recently signed a contract with an alternate data processing facility that will provide her company with space in the event of a disaster. The facility includes HVAC, power, and communications circuits but no hardware. <br>What type of facility is Becka using?",
    "choice_a": "Cold site",
    "choice_b": "Warm site",
    "choice_c": "Hot site",
    "choice_d": "Mobile site",
    "correct_answer": "A",
    "explanation": "A cold site includes the basic capabilities required for data center operations: space, power, HVAC, and communications, but it does not include any of the hardware required to restore operations. Warm sites, hot sites, and mobile sites would all include hardware.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      82,
      77,
      78,
      696
    ],
    "source": ""
  },
  {
    "id": 2069,
    "question": "Greg's company recently experienced a significant data breach involving the personal data of many of their customers. <br>Which breach laws should they review to ensure that they are taking appropriate action?",
    "choice_a": "The breach laws in the state where they are headquartered.",
    "choice_b": "The breach laws of states they do business in.",
    "choice_c": "Only federal breach laws.",
    "choice_d": "Breach laws only cover government agencies, not private businesses.",
    "correct_answer": "B",
    "explanation": "In general, companies should be aware of the breach laws in any location where they do business. U.S. states have a diverse collection of breach laws and requirements, meaning that in this case, Greg's company may need to review many different breach laws to determine which they may need to comply with if they conduct business in the state or with the state's residents.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      118,
      108,
      114,
      100
    ],
    "source": ""
  },
  {
    "id": 2070,
    "question": "Ben is seeking a control objective framework that is widely accepted around the world and focuses specifically on information security controls. <br>Which one of the following frameworks would best meet his needs?",
    "choice_a": "ITIL",
    "choice_b": "ISO 27002",
    "choice_c": "CMM",
    "choice_d": "PMBOK Guide",
    "correct_answer": "B",
    "explanation": "ISO 27002 is an international standard focused on information security and titled \"Information technology\u2014Security techniques\u2014Code of practice for information security management.\" The Information Technology Infrastructure Library (ITIL) does contain security management practices, but it is not the sole focus of the document, and the ITIL security section is derived from ISO 27002. The Capability Maturity Model (CMM) is focused on software development, and the Project Management Body of Knowledge (PMBOK) Guide focuses on project management.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      50,
      47,
      14,
      11
    ],
    "source": ""
  },
  {
    "id": 2071,
    "question": "Matt works for a telecommunications firm and was approached by a federal agent seeking assistance with wiretapping one of Matt's clients pursuant to a search warrant. <br>Which one of the following laws requires that communications service providers cooperate with law enforcement requests?",
    "choice_a": "ECPA",
    "choice_b": "CALEA",
    "choice_c": "Privacy Act",
    "choice_d": "HITECH Act",
    "correct_answer": "B",
    "explanation": "The Communications Assistance to Law Enforcement Act (CALEA) requires that all communications carriers make wiretaps possible for law enforcement officials who have an appropriate court order.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      682,
      683,
      107,
      105,
      97
    ],
    "source": ""
  },
  {
    "id": 2072,
    "question": "Every year, Gary receives privacy notices in the mail from financial institutions where he has accounts. <br>What law requires the institutions to send Gary these notices?",
    "choice_a": "FERPA",
    "choice_b": "GLBA",
    "choice_c": "HIPAA",
    "choice_d": "HITECH",
    "correct_answer": "B",
    "explanation": "The Gramm-Leach-Bliley Act (GLBA) places strict privacy regulations on financial institutions, including providing written notice of privacy practices to customers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      105,
      100,
      118,
      99
    ],
    "source": ""
  },
  {
    "id": 2073,
    "question": "Which one of the following agreements typically requires that a vendor not disclose confidential information learned during the scope of an engagement?",
    "choice_a": "NCA",
    "choice_b": "SLA",
    "choice_c": "NDA",
    "choice_d": "RTO",
    "correct_answer": "C",
    "explanation": "Nondisclosure agreements (NDAs) typically require either mutual or one-way confidentiality in a business relationship. Service-level agreements specify service uptime and other performance measures. Noncompete agreements (NCAs) limit the future employment possibilities of employees. Recovery time objectives (RTOs) are used in business continuity planning.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      35,
      680,
      39,
      104,
      38
    ],
    "source": ""
  },
  {
    "id": 2074,
    "question": "The ISC2 Code of Ethics applies to all CISSP holders. <br>Which of the following is not one of the four mandatory canons of the code?",
    "choice_a": "Protect society, the common good, the necessary public trust and confidence, and the infrastructure.",
    "choice_b": "Disclose breaches of privacy, trust, and ethics.",
    "choice_c": "Provide diligent and competent service to the principles.",
    "choice_d": "Advance and protect the profession.",
    "correct_answer": "B",
    "explanation": "The ISC2 Code of Ethics also includes \"Act honorably, honestly, justly, responsibly, and legally\" but does not specifically require credential holders to disclose all breaches of privacy, trust, or ethics.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      955,
      956,
      957,
      15,
      14
    ],
    "source": ""
  },
  {
    "id": 2075,
    "question": "Which one of the following stakeholders is not typically included on a business continuity planning team?",
    "choice_a": "Core business function leaders",
    "choice_b": "Information technology staff",
    "choice_c": "CEO",
    "choice_d": "Support departments",
    "correct_answer": "C",
    "explanation": "While senior management should be represented on the BCP team, it would be highly unusual for the CEO to fill this role personally.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      78,
      95,
      79,
      76,
      77
    ],
    "source": ""
  },
  {
    "id": 2076,
    "question": "Ben is designing a messaging system for a bank and would like to include a feature that allows the recipient of a message to prove to a third party that the message did indeed come from the purported originator. <br>What goal is Ben trying to achieve?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Integrity",
    "choice_d": "Nonrepudiation",
    "correct_answer": "D",
    "explanation": "Nonrepudiation allows a recipient to prove to a third party that a message came from a purported source. Authentication would provide proof to Ben that the sender was authentic, but Ben would not be able to prove this to a third party.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      685,
      686,
      31,
      4,
      2
    ],
    "source": ""
  },
  {
    "id": 2077,
    "question": "What principle of information security states that an organization should implement overlapping security controls whenever possible?",
    "choice_a": "Least privilege",
    "choice_b": "Separation of duties",
    "choice_c": "Defense in depth",
    "choice_d": "Security through obscurity",
    "correct_answer": "C",
    "explanation": "Defense in depth states that organizations should have overlapping security controls designed to meet the same security objectives whenever possible. This approach provides security in the event of a single control failure. Least privilege ensures that an individual only has the minimum set of permissions necessary to carry out their assigned job functions and does not require overlapping controls.  Separation of duties requires that one person not have permission to perform two separate actions that, when combined, carry out a sensitive function.  Security through obscurity attempts to hide the details of security controls to add security to them.  Neither separation of duties nor security through obscurity involve overlapping controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      47,
      36,
      33,
      1
    ],
    "source": ""
  },
  {
    "id": 2078,
    "question": "Ryan is a CISSP-certified cybersecurity professional working in a nonprofit organization. <br>Which of the following ethical obligations apply to his work?  (Select all that apply.)",
    "choice_a": "ISC2 Code of Ethics",
    "choice_b": "Organizational code of ethics",
    "choice_c": "Federal code of ethics",
    "choice_d": "RFC 1087",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "All ISC2 certified professionals are required to comply with the ISC2 Code of Ethics. All employees of an organization are required to comply with the organization's code of ethics. The federal code of ethics (or, more formally, the Code of Ethics for Government Service) would not apply to a nonprofit organization, as it only applies to federal employees. RFC 1087 does provide a code of ethics for the internet, but it is not binding on any individual.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      955,
      956,
      957,
      11,
      17
    ],
    "source": ""
  },
  {
    "id": 2079,
    "question": "Ben is responsible for the security of payment card information stored in a database. Policy directs that he removes the information from the database, but he cannot do this for operational reasons. He obtained an exception to policy and is seeking an appropriate compensating control to mitigate the risk. <br>What would be his best option?",
    "choice_a": "Purchasing insurance",
    "choice_b": "Encrypting the database contents",
    "choice_c": "Removing the data",
    "choice_d": "Objecting to the exception",
    "correct_answer": "B",
    "explanation": "Ben should encrypt the data to provide an additional layer of protection as a compensating control. The organization has already made a policy exception, so he should not react by objecting to the exception or removing the data without authorization. Purchasing insurance may transfer some of the risk but is not a mitigating control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      8,
      47,
      4,
      20,
      1
    ],
    "source": ""
  },
  {
    "id": 2080,
    "question": "The Domer Industries risk assessment team recently conducted a qualitative risk assessment and developed a matrix similar to the one shown here. <br><img src=\"/question_assets/CISSP/1_image4.png\"/> <br>Which quadrant contains the risks that require the most immediate attention?",
    "choice_a": "I",
    "choice_b": "II",
    "choice_c": "III",
    "choice_d": "IV",
    "correct_answer": "A",
    "explanation": "The risk assessment team should pay the most immediate attention to those risks that appear in quadrant I. These are the risks with a high probability of occurring and a high impact on the organization if they do occur.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      26,
      44,
      70,
      73,
      49
    ],
    "source": ""
  },
  {
    "id": 2081,
    "question": "Tom is planning to terminate an employee this afternoon for fraud and expects that the meeting will be somewhat hostile. He is coordinating the meeting with human resources and wants to protect the company against damage. <br>Which one of the following steps is most important to coordinate in time with the termination meeting?",
    "choice_a": "Informing other employees of the termination",
    "choice_b": "Retrieving the employee's photo ID",
    "choice_c": "Calculating the final paycheck",
    "choice_d": "Revoking electronic access rights",
    "correct_answer": "D",
    "explanation": "Electronic access to company resources must be carefully coordinated. An employee who retains access after being terminated may use that access to take retaliatory action. On the other hand, if access is terminated too early, the employee may figure out that he or she is about to be terminated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      68,
      112,
      15,
      11
    ],
    "source": ""
  },
  {
    "id": 2082,
    "question": "Rolando is a risk manager with a large-scale enterprise. The firm recently evaluated the risk of California mudslides on its operations in the region and determined that the cost of responding outweighed the benefits of any controls it could implement. The company chose to take no action at this time. <br>What risk management strategy did Rolando's organization pursue?",
    "choice_a": "Risk avoidance",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk transference",
    "choice_d": "Risk acceptance",
    "correct_answer": "D",
    "explanation": "In a risk acceptance strategy, the organization decides that taking no action is the most beneficial route to managing a risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      41,
      43,
      44,
      49
    ],
    "source": ""
  },
  {
    "id": 2083,
    "question": "Helen is the owner of a U.S. website that provides information for middle and high school students preparing for exams. She is writing the site's privacy policy and would like to ensure that it complies with the provisions of the Children's Online Privacy Protection Act (COPPA). <br>What is the cutoff age below which parents must give consent in advance of the collection of personal information from their children under COPPA?",
    "choice_a": "13",
    "choice_b": "15",
    "choice_c": "17",
    "choice_d": "18",
    "correct_answer": "A",
    "explanation": "COPPA requires that websites obtain advance parental consent for the collection of personal information from children under the age of 13.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      688,
      689,
      106,
      690,
      107
    ],
    "source": ""
  },
  {
    "id": 2084,
    "question": "Tom is considering locating a business in the downtown area of Miami, Florida. He consults the FEMA flood plain map for the region, shown here, and determines that the area he is considering lies within a 100-year flood plain. <br><img src=\"/question_assets/CISSP/1_image5.png\"/> <br>What is the ARO of a flood in this area?",
    "choice_a": "100",
    "choice_b": "1",
    "choice_c": "0.1",
    "choice_d": "0.01",
    "correct_answer": "D",
    "explanation": "The annualized rate of occurrence (ARO) is the frequency at which you should expect a risk to materialize each year. In a 100-year flood plain, risk analysts expect a flood to occur once every 100 years, or 0.01 times per year.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      691,
      45,
      695,
      875,
      85
    ],
    "source": ""
  },
  {
    "id": 2085,
    "question": "You discover that a user on your network has been using the Wireshark tool, as shown here. Further investigation revealed that he was using it for illicit purposes. <br><img src=\"/question_assets/CISSP/1_image6.png\"/> <br>What pillar of information security has most likely been violated?",
    "choice_a": "Integrity",
    "choice_b": "Denial",
    "choice_c": "Availability",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "Wireshark is a protocol analyzer and may be used to eavesdrop on network connections. Eavesdropping is an attack against confidentiality.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      24,
      23,
      41,
      11
    ],
    "source": ""
  },
  {
    "id": 2086,
    "question": "Alan is performing threat modeling and decides that it would be useful to decompose the system into the core elements shown here. <br><img src=\"/question_assets/CISSP/1_image7.png\"/> <br>What tool is he using?",
    "choice_a": "Vulnerability assessment",
    "choice_b": "Fuzzing",
    "choice_c": "Reduction analysis",
    "choice_d": "Data modeling",
    "correct_answer": "C",
    "explanation": "In reduction analysis, the security professional breaks the system down into five core elements: trust boundaries, data flow paths, input points, privileged operations, and details about security controls.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      25,
      23,
      10,
      8,
      41
    ],
    "source": ""
  },
  {
    "id": 2088,
    "question": "Which type of business impact assessment tool is most appropriate when attempting to evaluate the impact of a failure on customer confidence?",
    "choice_a": "Quantitative",
    "choice_b": "Qualitative",
    "choice_c": "Annualized loss expectancy",
    "choice_d": "Reduction",
    "correct_answer": "B",
    "explanation": "Qualitative tools are often used in business impact assessment to capture the impact on intangible factors such as customer confidence, employee morale, and reputation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      44,
      96,
      87,
      73
    ],
    "source": ""
  },
  {
    "id": 2089,
    "question": "Ryan is a security risk analyst for an insurance company. He is currently examining a scenario in which a malicious hacker might use a SQL injection attack to deface a web server due to a missing patch in the company's web application. <br>In this scenario, what is the threat?",
    "choice_a": "Unpatched web application",
    "choice_b": "Web defacement",
    "choice_c": "Malicious hacker",
    "choice_d": "Operating system",
    "correct_answer": "C",
    "explanation": "Risks are the combination of a threat and a vulnerability. Threats are the external forces seeking to undermine security, such as the malicious hacker in this case. Vulnerabilities are the internal weaknesses that might allow a threat to succeed. In this case, the missing patch is the vulnerability. In this scenario, if the malicious hacker (threat) attempts a SQL injection attack against the unpatched server (vulnerability), the result is website defacement.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      2,
      26,
      23,
      49
    ],
    "source": ""
  },
  {
    "id": 2090,
    "question": "Henry is the risk manager for Atwood Landing, a resort community in the midwestern United States. The resort's main data center is located in northern Indiana in an area that is prone to tornados. Henry recently undertook a replacement cost analysis and determined that rebuilding and reconfiguring the data center would cost $10 million. <br>Henry consulted with tornado experts, data center specialists, and structural engineers. Together, they determined that a typical tornado would cause approximately $5 million of damage to the facility. The meteorologists determined that Atwood's facility lies in an area where they are likely to experience a tornado once every 200 years. <br>Based upon the information in this scenario, what is the exposure factor for the effect of a tornado on Atwood Landing's data center?",
    "choice_a": "10 percent",
    "choice_b": "25 percent",
    "choice_c": "50 percent",
    "choice_d": "75 percent",
    "correct_answer": "C",
    "explanation": "The exposure factor is the percentage of the facility that risk managers expect will be damaged if a risk materializes. It is calculated by dividing the amount of damage by the asset value. In this case, that is $5 million in damage divided by the $10 million facility value, or 50 percent.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      86,
      43,
      42,
      26
    ],
    "source": ""
  },
  {
    "id": 2091,
    "question": "Henry is the risk manager for Atwood Landing, a resort community in the midwestern United States. The resort's main data center is located in northern Indiana in an area that is prone to tornados. Henry recently undertook a replacement cost analysis and determined that rebuilding and reconfiguring the data center would cost $10 million. <br>Henry consulted with tornado experts, data center specialists, and structural engineers. Together, they determined that a typical tornado would cause approximately $5 million of damage to the facility. The meteorologists determined that Atwood's facility lies in an area where they are likely to experience a tornado once every 200 years. <br>Based upon the information in this scenario, what is the annualized rate of occurrence for a tornado at Atwood Landing's data center?",
    "choice_a": "0.0025",
    "choice_b": "0.005",
    "choice_c": "0.01",
    "choice_d": "0.015",
    "correct_answer": "B",
    "explanation": "The annualized rate of occurrence is the number of times that risk analysts expect a risk to happen in any given year. In this case, the analysts expect tornados once every 200 years, or 0.005 times per year.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      691,
      874,
      85,
      83,
      42
    ],
    "source": ""
  },
  {
    "id": 2092,
    "question": "Henry is the risk manager for Atwood Landing, a resort community in the midwestern United States. The resort's main data center is located in northern Indiana in an area that is prone to tornados. Henry recently undertook a replacement cost analysis and determined that rebuilding and reconfiguring the data center would cost $10 million. <br>Henry consulted with tornado experts, data center specialists, and structural engineers. Together, they determined that a typical tornado would cause approximately $5 million of damage to the facility. The meteorologists determined that Atwood's facility lies in an area where they are likely to experience a tornado once every 200 years. <br>Based upon the information in this scenario, what is the annualized loss expectancy for a tornado at Atwood Landing's data center?",
    "choice_a": "$25,000",
    "choice_b": "$50,000",
    "choice_c": "$250,000",
    "choice_d": "$500,000",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy is calculated by multiplying the single loss expectancy (SLE) by the annualized rate of occurrence (ARO). In this case, the SLE is $5,000,000, and the ARO is 0.005. Multiplying these numbers together gives you the ALE of $25,000.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      86,
      695,
      875,
      935
    ],
    "source": ""
  },
  {
    "id": 2093,
    "question": "John is analyzing an attack against his company in which the attacker found comments embedded in HTML code that provided the clues needed to exploit a software vulnerability. <br>Using the STRIDE model, what type of attack did he uncover?",
    "choice_a": "Spoofing",
    "choice_b": "Repudiation",
    "choice_c": "Information disclosure",
    "choice_d": "Elevation of privilege",
    "correct_answer": "C",
    "explanation": "Information disclosure attacks rely upon the revelation of private, confidential, or controlled information. Programming comments embedded in HTML code are an example of this type of attack.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      3,
      4,
      6,
      25
    ],
    "source": ""
  },
  {
    "id": 2094,
    "question": "Chris is worried that the laptops that his organization has recently acquired were modified by a third party to include keyloggers before they were delivered. <br>Where should he focus his efforts to prevent this?",
    "choice_a": "His supply chain",
    "choice_b": "His vendor contracts",
    "choice_c": "His post-purchase build process",
    "choice_d": "The original equipment manufacturer (OEM)",
    "correct_answer": "A",
    "explanation": "Supply chain management can help ensure the security of hardware, software, and services that an organization acquires. Chris should focus on each step that his laptops take from the original equipment manufacturer to delivery.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      27,
      116,
      20,
      2
    ],
    "source": ""
  },
  {
    "id": 2095,
    "question": "In her role as a developer for an online bank, Lisa is required to submit her code for testing and review. After it passes through this process and it is approved, another employee moves the code to the production environment. <br>What security management does this process describe?",
    "choice_a": "Regression testing",
    "choice_b": "Code review",
    "choice_c": "Change management",
    "choice_d": "Fuzz testing",
    "correct_answer": "C",
    "explanation": "Change management is a critical control process that involves systematically managing change. Without it, Lisa might simply deploy her code to production without oversight, documentation, or testing. Regression testing focuses on testing to ensure that new code doesn't bring back old flaws, while fuzz testing feeds unexpected input to code. Code review reviews the source code itself and may be involved in the change management process but isn't what is described here.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      14,
      13,
      41,
      15
    ],
    "source": ""
  },
  {
    "id": 2096,
    "question": "After completing the first year of his security awareness program, Charles reviews the data about how many staff completed training compared to how many were assigned the training to determine whether he hit the 95 percent completion rate he was aiming for. <br>What is this type of measure called?",
    "choice_a": "A KPI",
    "choice_b": "A metric",
    "choice_c": "An awareness control",
    "choice_d": "A return on investment rate",
    "correct_answer": "A",
    "explanation": "Charles is tracking a key performance indicator (KPI). A KPI is used to measure performance (and success). Without a definition of success, this would simply be a metric, but Charles is working toward a known goal and can measure against it. There is not a return investment calculation in this problem, and the measure is not a control.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      67,
      66,
      1,
      2,
      40
    ],
    "source": ""
  },
  {
    "id": 2097,
    "question": "Which of the following is not typically included in a prehire screening process?",
    "choice_a": "A drug test",
    "choice_b": "A background check",
    "choice_c": "Social media review",
    "choice_d": "Fitness evaluation",
    "correct_answer": "D",
    "explanation": "A fitness evaluation is not a typical part of a hiring process. Drug tests, background checks, and social media checks are all common parts of current hiring practices.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      34,
      677,
      39,
      65
    ],
    "source": ""
  },
  {
    "id": 2098,
    "question": "Which of the following would normally be considered a supply chain risk? (Select all that apply.)",
    "choice_a": "Adversary tampering with hardware prior while being shipped to the end customer",
    "choice_b": "Adversary hacking into a web server run by the organization in an IaaS environment",
    "choice_c": "Adversary using social engineering to compromise an employee of a SaaS vendor to gain access to customer accounts",
    "choice_d": "Adversary conducting a denial-of-service attack using a botnet",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Supply chain risks occur when the adversary is interfering with the delivery of goods or services from a supplier to the customer. This might involve tampering with hardware before the customer receives it or using social engineering to compromise a vendor employee. Hacking into a web server run in an IaaS environment is not a supply chain risk because the web server is already under the control of the customer. Using a botnet to conduct a denial-of-service attack does not involve any supply chain elements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      27,
      29,
      61,
      116
    ],
    "source": ""
  },
  {
    "id": 2100,
    "question": "Control Objectives for Information and Related Technology (COBIT) is a framework for information technology (IT) management and governance. <br>Which data management role is most likely to select and apply COBIT to balance the need for security controls against business requirements?",
    "choice_a": "Business owners",
    "choice_b": "Data processors",
    "choice_c": "Data owners",
    "choice_d": "Data stewards",
    "correct_answer": "A",
    "explanation": "Business owners have to balance the need to provide value with regulatory, security, and other requirements. This makes the adoption of a common framework like COBIT attractive. Data owners are more likely to ask that those responsible for control selection identify a standard to use. Data processors are required to perform specific actions under regulations like the EU GDPR. Finally, in many organizations, data stewards are internal roles that oversee how data is used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      143,
      138,
      851,
      126
    ],
    "source": ""
  },
  {
    "id": 2101,
    "question": "Nadia's company is operating a hybrid cloud environment with some on-site systems and some cloud-based systems. She has satisfactory monitoring on-site, but needs to apply security policies to both the activities her users engage in and to report on exceptions with her growing number of cloud services. <br>What type of tool is best suited to this purpose?",
    "choice_a": "A NGFW",
    "choice_b": "A CASB",
    "choice_c": "An IDS",
    "choice_d": "A SOAR",
    "correct_answer": "B",
    "explanation": "The best option for Nadia is a cloud access security broker (CASB). A CASB is designed to sit between a cloud environment and the users who use it, and it provides monitoring and policy enforcement capabilities. A next-generation firewall (NGFW), an intrusion detection system (IDS), and a security operations and response (SOAR) tool could each provide some insight into what is going on, but they are not purpose built and designed for this like the CASB is. The NGFW and IDS are most likely to provide insight into traffic patterns and behaviors, while the SOAR is primarily intended to monitor other systems and centralize data for response, making it potentially the least useful in this specific scenario.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      127,
      125,
      124,
      126
    ],
    "source": ""
  },
  {
    "id": 2102,
    "question": "When media is labeled based on the classification of the data it contains, what rule is typically applied regarding labels?",
    "choice_a": "The data is labeled based on its integrity requirements.",
    "choice_b": "The media is labeled based on the highest classification level of the data it contains.",
    "choice_c": "The media is labeled with all levels of classification of the data it contains.",
    "choice_d": "The media is labeled with the lowest level of classification of the data it contains.",
    "correct_answer": "B",
    "explanation": "Media is typically labeled with the highest classification level of data it contains. This prevents the data from being handled or accessed at a lower classification level. Data integrity requirements may be part of a classification process but don't independently drive labeling in a classification scheme.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      121,
      123,
      697,
      144
    ],
    "source": ""
  },
  {
    "id": 2103,
    "question": "Which one of the following administrative processes assists organizations in assigning appropriate levels of security control to sensitive information?",
    "choice_a": "Data classification",
    "choice_b": "Remanence",
    "choice_c": "Transmitting data",
    "choice_d": "Clearing",
    "correct_answer": "A",
    "explanation": "The need to protect sensitive data drives data classification. Classifying data allows organizations to focus on data that needs to be protected rather than spending effort on less important data. Remanence describes data left on media after an attempt is made to remove the data. Transmitting data isn't a driver for an administrative process to protect sensitive data, and clearing is a technical process for removing data from media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      121,
      143,
      125,
      128
    ],
    "source": ""
  },
  {
    "id": 2104,
    "question": "How can a data retention policy help to reduce liabilities?",
    "choice_a": "By ensuring that unneeded data isn't retained",
    "choice_b": "By ensuring that incriminating data is destroyed",
    "choice_c": "By ensuring that data is securely wiped so it cannot be restored for legal discovery",
    "choice_d": "By reducing the cost of data storage required by law",
    "correct_answer": "A",
    "explanation": "A data retention policy can help to ensure that outdated data is purged, removing potential additional costs for discovery. Many organizations have aggressive retention policies to both reduce the cost of storage and limit the amount of data that is kept on hand and discoverable. Data retention policies are not designed to destroy incriminating data, and legal requirements for data retention must still be met.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      850,
      852,
      125,
      132
    ],
    "source": ""
  },
  {
    "id": 2105,
    "question": "Staff in an information technology (IT) department who are delegated responsibility for day-to-day tasks hold what data role?",
    "choice_a": "Business owner",
    "choice_b": "User",
    "choice_c": "Data processor",
    "choice_d": "Custodian",
    "correct_answer": "D",
    "explanation": "Custodians are delegated the role of handling day-to-day tasks by managing and overseeing how data is handled, stored, and protected. Data processors are systems used to process data. Business owners are typically project or system owners who are tasked with making sure systems provide value to their users or customers.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      139,
      143,
      851,
      989
    ],
    "source": ""
  },
  {
    "id": 2106,
    "question": "Helen's company uses a simple data lifecycle as shown in the figure here. <br><img src=\"/question_assets/CISSP/2_image1.png\"/><br>What stage should come first in their data lifecycle?",
    "choice_a": "Data policy creation",
    "choice_b": "Data labeling",
    "choice_c": "Data collection",
    "choice_d": "Data analysis",
    "correct_answer": "C",
    "explanation": "In a typical data lifecycle, collection is the first stage. Once collected, data can be analyzed, used, stored, and disposed of at the end of its useful life. Policies may be created at any time, and organizations often have data before they have policies. Labels are added to data during the analysis, usage, or retention cycle.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      132,
      128,
      850,
      133
    ],
    "source": ""
  },
  {
    "id": 2107,
    "question": "Ben has been tasked with identifying security controls for systems covered by his organization's information classification system. <br>Why might Ben choose to use a security baseline?",
    "choice_a": "It applies in all circumstances, allowing consistent security controls.",
    "choice_b": "They are approved by industry standards bodies, preventing liability.",
    "choice_c": "They provide a good starting point that can be tailored to organizational needs.",
    "choice_d": "They ensure that systems are always in a secure state.",
    "correct_answer": "C",
    "explanation": "Security baselines provide a starting point to scope and tailor security controls to your organization's needs. They aren't always appropriate to specific organizational needs, they cannot ensure that systems are always in a secure state, and they do not prevent liability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      141,
      121,
      124,
      143
    ],
    "source": ""
  },
  {
    "id": 2108,
    "question": "Megan wants to prepare media to allow for its reuse in an environment operating at the same sensitivity level. <br>Which of the following is the best option to meet her needs?",
    "choice_a": "Clearing",
    "choice_b": "Erasing",
    "choice_c": "Purging",
    "choice_d": "Sanitization",
    "correct_answer": "A",
    "explanation": "Clearing describes preparing media for reuse. When media is cleared, unclassified data is written over all addressable locations on the media. Once that's completed, the media can be reused. Erasing is the deletion of files or media and may not include all of the data on the device or media, making it the worst choice here. Purging is a more intensive form of clearing for reuse in lower-security areas, and sanitization is a series of processes that removes data from a system or media while ensuring that the data is unrecoverable by any means.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      144,
      130,
      1026,
      125
    ],
    "source": ""
  },
  {
    "id": 2109,
    "question": "Mikayla wants to identify data that should be classified that already exists in her environment. <br>What type of tool is best suited to identifying data like Social Security numbers, credit card numbers, and similar well-understood data formats?",
    "choice_a": "Manual searching",
    "choice_b": "A sensitive data scanning tool",
    "choice_c": "An asset metadata search tool",
    "choice_d": "A data loss prevention system (DLP)",
    "correct_answer": "B",
    "explanation": "Sensitive data scanning tools are designed to scan for and flag sensitive data types using known formatting and structure. Social Security numbers, credit card numbers, and other regularly structured data that follows known rules can be identified and then addressed as needed. Manual searching is a massive undertaking for an organization with even a relatively small amount of data; asset metadata needs to be set first and would have already been identified; and a DLP system looks for data that is in transit using rules rather than hunting down data at rest and in storage.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      144,
      124,
      143,
      125
    ],
    "source": ""
  },
  {
    "id": 2110,
    "question": "What issue is common to spare sectors and bad sectors on hard drives as well as over provisioned space on modern SSDs?",
    "choice_a": "They can be used to hide data.",
    "choice_b": "They can only be degaussed.",
    "choice_c": "They are not addressable, resulting in data remanence.",
    "choice_d": "They may not be cleared, resulting in data remanence.",
    "correct_answer": "D",
    "explanation": "Spare sectors, bad sectors, and space provided for wear leveling on SSDs (over provisioned space) may all contain data that was written to the space that will not be cleared when the drive is wiped. This is a form of data remanence and is a concern for organizations that do not want data to potentially be accessible. Many wiping utilities only deal with currently addressable space on the drive. SSDs cannot be degaussed, and wear leveling space cannot be reliably used to hide data. These spaces are still addressable by the drive, although they may not be seen by the operating system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      1024,
      129,
      144,
      130,
      1026
    ],
    "source": ""
  },
  {
    "id": 2111,
    "question": "Naomi knows that commercial data is typically classified based on different criteria than government data. <br>Which of the following is not a common criterion for commercial data classification?",
    "choice_a": "Useful lifespan",
    "choice_b": "Data value",
    "choice_c": "Impact to national security",
    "choice_d": "Regulatory or legal requirements",
    "correct_answer": "C",
    "explanation": "Commercial data classification often takes into account the value of the data, any regulatory or legal requirements that may apply to the data, and how long the data is useful\u2014its lifespan. The impact to national security is more typically associated with government classification schemes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      124,
      125,
      126,
      143
    ],
    "source": ""
  },
  {
    "id": 2112,
    "question": "Your organization regularly handles three types of data: information that it shares with customers, information that it uses internally to conduct business, and trade secret information that offers the organization significant competitive advantages. Information shared with customers is used and stored on web servers, while both the internal business data and the trade secret information are stored on internal file servers and employee workstations. <br>What term best describes data that is resident in system memory?",
    "choice_a": "Data at rest",
    "choice_b": "Buffered data",
    "choice_c": "Data in use",
    "choice_d": "Data in motion",
    "correct_answer": "C",
    "explanation": "Data is often considered based on the data state that it is in. Data can be at rest (on a drive or other storage medium), in use and thus in memory or a buffer and often decrypted for use, or in transit over a network. Data that is resident in system memory is considered data in use.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      702,
      700,
      706
    ],
    "source": ""
  },
  {
    "id": 2113,
    "question": "Your organization regularly handles three types of data: information that it shares with customers, information that it uses internally to conduct business, and trade secret information that offers the organization significant competitive advantages. Information shared with customers is used and stored on web servers, while both the internal business data and the trade secret information are stored on internal file servers and employee workstations. <br>What technique could you use to mark your trade secret information in case it was released or stolen and you need to identify it?",
    "choice_a": "Classification",
    "choice_b": "Symmetric encryption",
    "choice_c": "Watermarks",
    "choice_d": "Metadata",
    "correct_answer": "C",
    "explanation": "A watermark is used to digitally label data and can be used to indicate ownership, as well as to assist a digital rights management (DRM) system in identifying data that should be protected. Encryption would have prevented the data from being accessed if it was lost, while classification is part of the set of security practices that can help make sure the right controls are in place. Finally, metadata is used to label data and might help a data loss prevention system flag it before it leaves your organization.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      124,
      127,
      144,
      143
    ],
    "source": ""
  },
  {
    "id": 2114,
    "question": "Your organization regularly handles three types of data: information that it shares with customers, information that it uses internally to conduct business, and trade secret information that offers the organization significant competitive advantages. Information shared with customers is used and stored on web servers, while both the internal business data and the trade secret information are stored on internal file servers and employee workstations. <br>What type of encryption is best suited for use on the file servers for the proprietary data, and how might you secure the data when it is in motion?",
    "choice_a": "TLS at rest and AES in motion",
    "choice_b": "AES at rest and TLS in motion",
    "choice_c": "VPN at rest and TLS in motion",
    "choice_d": "DES at rest and AES in motion",
    "correct_answer": "B",
    "explanation": "AES is a strong modern symmetric encryption algorithm that is appropriate for encrypting data at rest. TLS is frequently used to secure data when it is in transit. A virtual private network is not necessarily an encrypted connection and would be used for data in motion, while DES is an outdated algorithm and should not be used for data that needs strong security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      124,
      702,
      144,
      120
    ],
    "source": ""
  },
  {
    "id": 2115,
    "question": "What does labeling data allow a DLP system to do?",
    "choice_a": "The DLP system can detect labels and apply appropriate protections based on rules.",
    "choice_b": "The DLP system can adjust labels based on changes in the classification scheme.",
    "choice_c": "The DLP system can modify labels to permit requested actions.",
    "choice_d": "The DLP system can delete unlabeled data.",
    "correct_answer": "A",
    "explanation": "Data loss prevention (DLP) systems can use labels on data to determine the appropriate controls to apply to the data. Most DLP systems won't modify labels in real time and typically don't work directly with firewalls to stop traffic. Deleting unlabeled data would cause big problems for organizations that haven't labeled every piece of data!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      127,
      128,
      144,
      125
    ],
    "source": ""
  },
  {
    "id": 2116,
    "question": "Why is it cost effective to purchase high-quality media to contain sensitive data?",
    "choice_a": "Expensive media is less likely to fail.",
    "choice_b": "The value of the data often far exceeds the cost of the media.",
    "choice_c": "Expensive media is easier to encrypt.",
    "choice_d": "More expensive media typically improves data integrity.",
    "correct_answer": "B",
    "explanation": "The value of the data contained on media often exceeds the cost of the media, making more expensive media that may have a longer life span or additional capabilities like encryption support a good choice. While expensive media may be less likely to fail, the reason it makes sense is the value of the data, not just that it is less likely to fail. In general, the cost of the media doesn't have anything to do with the ease of encryption, and data integrity isn't ensured by better media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      120,
      129,
      123,
      124
    ],
    "source": ""
  },
  {
    "id": 2117,
    "question": "Chris is responsible for workstations throughout his company and knows that some of the company's workstations are used to handle both proprietary information and highly sensitive trade secrets. <br>Which option best describes what should happen at the end of their life (EOL) for workstations he is responsible for?",
    "choice_a": "Erasing",
    "choice_b": "Clearing",
    "choice_c": "Sanitization",
    "choice_d": "Destruction",
    "correct_answer": "D",
    "explanation": "Destruction is the most complete method of ensuring that data cannot be exposed, and organizations often opt to destroy either the drive or the entire workstation or device to ensure that data cannot be recovered or exposed. Sanitization is a combination of processes that ensure that data from a system cannot be recovered by any means. Erasing and clearing are both prone to mistakes and technical problems that can result in remnant data and don't make sense for systems that handled proprietary information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      130,
      133,
      144,
      123
    ],
    "source": ""
  },
  {
    "id": 2118,
    "question": "Fred wants to classify his organization's data using common labels: private, sensitive, public, and proprietary. <br>Which of the following should he apply to his highest classification level based on common industry practices?",
    "choice_a": "Private",
    "choice_b": "Sensitive",
    "choice_c": "Public",
    "choice_d": "Proprietary",
    "correct_answer": "D",
    "explanation": "Common practice makes proprietary or confidential data the most sensitive data. Private data is internal business data that shouldn't be exposed but that doesn't meet the threshold for confidential or proprietary data. Sensitive data may help attackers or otherwise create risk, and public data is just that\u2014data that is or can be made public.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      121,
      128,
      143,
      124
    ],
    "source": ""
  },
  {
    "id": 2119,
    "question": "What scenario describes data at rest?",
    "choice_a": "Data in an IP sec tunnel",
    "choice_b": "Data in an e-commerce transaction",
    "choice_c": "Data stored on a hard drive",
    "choice_d": "Data stored in RAM",
    "correct_answer": "C",
    "explanation": "Data at rest is inactive data that is physically stored. Data in an IPsec tunnel or part of an e-commerce transaction is data in motion. Data in RAM is ephemeral and is not inactive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      706,
      700,
      702
    ],
    "source": ""
  },
  {
    "id": 2120,
    "question": "If you are selecting a security standard for a Windows 10 system that processes credit cards, what security standard is your best choice?",
    "choice_a": "Microsoft's Windows 10 security baseline",
    "choice_b": "The CIS Windows 10 baseline",
    "choice_c": "PCI DSS",
    "choice_d": "The NSA Windows 10 Secure Host Baseline",
    "correct_answer": "C",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) provides the set of requirements for credit card processing systems. The Microsoft, NSA, and CIS baseline are all useful for building a Windows 10 security standard, but the PCI DSS standard is a better answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      140,
      126,
      120,
      124
    ],
    "source": ""
  },
  {
    "id": 2121,
    "question": "The Center for Internet Security (CIS) works with subject matter experts from a variety of industries to create lists of security controls for operating systems, mobile devices, server software, and network devices. Your organization has decided to use the CIS benchmarks for your systems. Answer the following questions based on this decision. <br>The CIS benchmarks are an example of what practice?",
    "choice_a": "Conducting a risk assessment",
    "choice_b": "Implementing data labeling",
    "choice_c": "Proper system ownership",
    "choice_d": "Using security baselines",
    "correct_answer": "D",
    "explanation": "The CIS benchmarks are an example of a security baseline. A risk assessment would help identify which controls were needed, and proper system ownership is an important part of making sure baselines are implemented and maintained. Data labeling can help ensure that controls are applied to the right systems and data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      141,
      142,
      138,
      123
    ],
    "source": ""
  },
  {
    "id": 2122,
    "question": "The Center for Internet Security (CIS) works with subject matter experts from a variety of industries to create lists of security controls for operating systems, mobile devices, server software, and network devices. Your organization has decided to use the CIS benchmarks for your systems. Answer the following questions based on this decision. <br>Adjusting the CIS benchmarks to your organization's mission and your specific IT systems would involve what two processes?",
    "choice_a": "Scoping and selection",
    "choice_b": "Scoping and tailoring",
    "choice_c": "Base lining and tailoring",
    "choice_d": "Tailoring and selection",
    "correct_answer": "B",
    "explanation": "Scoping involves selecting only the controls that are appropriate for your IT systems, while tailoring matches your organization's mission and the controls from a selected baseline. Base lining is the process of configuring a system or software to match a baseline or building a baseline itself. Selection isn't a technical term used for any of these processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      142,
      698,
      138
    ],
    "source": ""
  },
  {
    "id": 2123,
    "question": "The Center for Internet Security (CIS) works with subject matter experts from a variety of industries to create lists of security controls for operating systems, mobile devices, server software, and network devices. Your organization has decided to use the CIS benchmarks for your systems. Answer the following questions based on this decision. <br>How should you determine which controls from the baseline should be applied to a given system or software package?",
    "choice_a": "Consult the custodians of the data.",
    "choice_b": "Select based on the data classification of the data it stores or handles.",
    "choice_c": "Apply the same controls to all systems.",
    "choice_d": "Consult the business owner of the process the system or data supports.",
    "correct_answer": "B",
    "explanation": "The controls implemented from a security baseline should match the data classification of the data used or stored on the system. Custodians are trusted to ensure the day-to-day security of the data and should do so by ensuring that the baseline is met and maintained. Business owners often have a conflict of interest between functionality and data security, and of course, applying the same controls everywhere is expensive and may not meet business needs or be a responsible use of resources.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      124,
      138,
      140,
      141,
      143
    ],
    "source": ""
  },
  {
    "id": 2124,
    "question": "The company that Henry works for operates in the EU and collects data about their customers. They send that data to a third party to analyze and provide reports to help the company make better business decisions. <br>What term best describes the third-party analysis company?",
    "choice_a": "The data controller",
    "choice_b": "The data owner",
    "choice_c": "The data subject",
    "choice_d": "The data processor",
    "correct_answer": "D",
    "explanation": "The third-party company is a data processor\u2014they process data on behalf of Henry's company, which is a data controller. The data is collected about data subjects. Data owners are tasked with making decisions about data, such as who receives access to it and how it is used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      988,
      138,
      989,
      990
    ],
    "source": ""
  },
  {
    "id": 2125,
    "question": "The government defense contractor that Selah works for has recently shut down a major research project and is planning on reusing the hundreds of thousands of dollars of systems and data storage tapes used for the project for other purposes. When Selah reviews the company's internal processes, she finds that she can't reuse the tapes and that the manual says they should be destroyed. <br>Why isn't Selah allowed to degauss and then reuse the tapes to save her employer money?",
    "choice_a": "Data permanence may be an issue.",
    "choice_b": "Data remanence is a concern.",
    "choice_c": "The tapes may suffer from bitrot.",
    "choice_d": "Data from tapes can't be erased by degaussing.",
    "correct_answer": "B",
    "explanation": "Many organizations require the destruction of media that contains data at higher levels of classification. Often the cost of the media is lower than the potential costs of data exposure, and it is difficult to guarantee that reused media doesn't contain remnant data. Tapes can be erased by degaussing, but degaussing is not always fully effective. Bitrot describes the slow loss of data on aging media, while data permanence is a term sometimes used to describe the life span of data and media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      130,
      133,
      125,
      124
    ],
    "source": ""
  },
  {
    "id": 2126,
    "question": "Information maintained about an individual that can be used to distinguish or trace their identity is known as what type of information?",
    "choice_a": "Personally identifiable information (PII)",
    "choice_b": "Personal health information (PHI)",
    "choice_c": "Social Security number (SSN)",
    "choice_d": "Secure identity information (SII)",
    "correct_answer": "A",
    "explanation": "NIST Special Publication 800-122 defines PII as any information that can be used to distinguish or trace an individual's identity, such as name, Social Security number, date and place of birth, mother's maiden name, biometric records, and other information that is linked or linkable to an individual such as medical, educational, financial, and employment information. PHI is health-related information about a specific person, Social Security numbers are issued to individuals in the United States, and SII is a made-up term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      703,
      120,
      143,
      126,
      142
    ],
    "source": ""
  },
  {
    "id": 2127,
    "question": "Which of the following information security risks to data at rest would result in the greatest reputational impact on an organization?",
    "choice_a": "Improper classification",
    "choice_b": "Data breach",
    "choice_c": "Decryption",
    "choice_d": "An intentional insider threat",
    "correct_answer": "B",
    "explanation": "Typically, data breaches cause the greatest reputational damage as a result of threats to data at rest. Data at rest with a high level of sensitivity is often encrypted to help prevent this. Decryption is not as significant of a threat if strong encryption is used and encryption keys are well secured. Insider threats are a risk, but the majority of insider threat issues are unintentional rather than intentional, making this risk less likely in most organizations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      120,
      124,
      122,
      132
    ],
    "source": ""
  },
  {
    "id": 2128,
    "question": "Full disk encryption like Microsoft's Bit Locker is used to protect data in what state?",
    "choice_a": "Data in transit",
    "choice_b": "Data at rest",
    "choice_c": "Unlabeled data",
    "choice_d": "Labeled data",
    "correct_answer": "B",
    "explanation": "Full disk encryption only protects data at rest. Since it encrypts the full disk, it does not distinguish between labeled and unlabeled data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      700,
      125,
      124
    ],
    "source": ""
  },
  {
    "id": 2129,
    "question": "The company that Katie works for provides its staff with mobile phones for employee use, with new phones issued every two years. <br>What scenario best describes this type of practice when the phones themselves are still usable and receiving operating system updates?",
    "choice_a": "EOL",
    "choice_b": "Planned obsolescence",
    "choice_c": "EOS",
    "choice_d": "Device risk management",
    "correct_answer": "C",
    "explanation": "This is an example of an end-of-support (EOS) scenario. The company is intentionally ending support and needs to address what happens to the devices next\u2014secure disposal, destruction, or re-sale\u2014depending on data security requirements and policies set by the company. EOL is when a device or software is no longer made or supported, in contrast to end of support, which may be when it is no longer serviced, including via patches, upgrades, or organizational maintenance. Planned obsolescence and device risk management are not terms that are used on the exam.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      877,
      847,
      133,
      849,
      851
    ],
    "source": ""
  },
  {
    "id": 2130,
    "question": "What is the primary purpose of data classification?",
    "choice_a": "It quantifies the cost of a data breach.",
    "choice_b": "It prioritizes IT expenditures.",
    "choice_c": "It allows compliance with breach notification laws.",
    "choice_d": "It identifies the value of the data to the organization.",
    "correct_answer": "D",
    "explanation": "Classification identifies the value of data to an organization. This can often help drive IT expenditure prioritization and could help with rough cost estimates if a breach occurred, but that's not the primary purpose. Finally, most breach laws call out specific data types for notification rather than requiring organizations to classify data themselves.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      143,
      124,
      125,
      123
    ],
    "source": ""
  },
  {
    "id": 2131,
    "question": "Fred's organization allows downgrading of systems for reuse after projects have been finished and the systems have been purged. <br>What concern should Fred raise about the reuse of the systems from his Top Secret classified project for a future project classified as Secret?",
    "choice_a": "The Top Secret data may be commingled with the Secret data, resulting in a need to relabel the system.",
    "choice_b": "The cost of the sanitization process may exceed the cost of new equipment.",
    "choice_c": "The data may be exposed as part of the sanitization process.",
    "choice_d": "The organization's DLP system may flag the new system due to the difference in data labels.",
    "correct_answer": "B",
    "explanation": "Downgrading systems and media is rare due to the difficulty of ensuring that sanitization is complete. The need to completely wipe (or destroy) the media that systems use means that the cost of reuse is often significant and may exceed the cost of purchasing a new system or media. The goal of purging is to ensure that no data remains, so commingling data should not be a concern, nor should the exposure of the data; only staff with the proper clearance should handle the systems! Finally, a DLP system should flag data based on labels, not on the system it comes from.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      130,
      144,
      121,
      123
    ],
    "source": ""
  },
  {
    "id": 2132,
    "question": "Which of the following concerns should not be part of the decision when classifying data?",
    "choice_a": "The cost to classify the data",
    "choice_b": "The sensitivity of the data",
    "choice_c": "The amount of harm that exposure of the data could cause",
    "choice_d": "The value of the data to the organization",
    "correct_answer": "A",
    "explanation": "Classification should be conducted based on the value of the data to the organization, its sensitivity, and the amount of harm that could result from exposure of the data. Cost should be considered when implementing controls and is weighed against the damage that exposure would create.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      124,
      125,
      120,
      121
    ],
    "source": ""
  },
  {
    "id": 2133,
    "question": "Which of the following is the least effective method of removing data from media?",
    "choice_a": "Degaussing",
    "choice_b": "Purging",
    "choice_c": "Erasing",
    "choice_d": "Clearing",
    "correct_answer": "C",
    "explanation": "Erasing, which describes a typical deletion process in many operating systems, typically removes only the link to the file and leaves the data that makes up the file itself. The data will remain in place but not indexed until the space is needed and it is overwritten. Degaussing works only on magnetic media, but it can be quite effective on it. Purging and clearing both describe more elaborate removal processes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      130,
      144,
      1026,
      1024
    ],
    "source": ""
  },
  {
    "id": 2134,
    "question": "The healthcare company that Amanda works for handles HIPAA data as well as internal business data, protected health information, and day-to-day business communications. Its internal policy uses the following requirements for securing HIPAA data at rest and in transit. <br><img src=\"/question_assets/CISSP/2_image2.png\"/><br>What encryption technology would be appropriate for HIPAA documents in transit?",
    "choice_a": "Bit Locker",
    "choice_b": "DES",
    "choice_c": "TLS",
    "choice_d": "SSL",
    "correct_answer": "C",
    "explanation": "TLS is a modern encryption method used to encrypt and protect data in transit. Bit Locker is a full disk encryption technology used for data at rest. DES and SSL are both outdated encryption methods and should not be used for data that requires high levels of security.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      700,
      144,
      125,
      126
    ],
    "source": ""
  },
  {
    "id": 2135,
    "question": "The healthcare company that Amanda works for handles HIPAA data as well as internal business data, protected health information, and day-to-day business communications. Its internal policy uses the following requirements for securing HIPAA data at rest and in transit. <br>Amanda's employer asks Amanda to classify patient X-ray data that has an internal patient identifier associated with it but does not have any way to directly identify a patient. The company's data owner believes that exposure of the data could cause damage (but not exceptional damage) to the organization. <br><img src=\"/question_assets/CISSP/2_image2.png\"/><br>How should Amanda classify the data?",
    "choice_a": "Public",
    "choice_b": "Sensitive",
    "choice_c": "Private",
    "choice_d": "Confidential",
    "correct_answer": "C",
    "explanation": "We know that the data classification will not be the top-level classification of Confidential because the loss of the data would not cause severe damage. This means we have to choose between private (PHI) and sensitive (confidential). Calling this private due to the patient's personal health information fits the classification scheme, giving us the correct answer.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      120,
      124,
      121,
      138
    ],
    "source": ""
  },
  {
    "id": 2136,
    "question": "The healthcare company that Amanda works for handles HIPAA data as well as internal business data, protected health information, and day-to-day business communications. Its internal policy uses the following requirements for securing HIPAA data at rest and in transit. <br><img src=\"/question_assets/CISSP/2_image2.png\"/><br>What technology could Amanda's employer implement to help prevent confidential data from being emailed out of the organization?",
    "choice_a": "DLP",
    "choice_b": "IDS",
    "choice_c": "A firewall",
    "choice_d": "UDP",
    "correct_answer": "A",
    "explanation": "A data loss prevention (DLP) system or software is designed to identify labeled data or data that fits specific patterns and descriptions to help prevent it from leaving the organization. An IDS is designed to identify intrusions. Although some IDS systems can detect specific types of sensitive data using pattern matching, they have no ability to stop traffic. A firewall uses rules to control traffic routing, while UDP is a network protocol.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      124,
      128,
      144,
      135
    ],
    "source": ""
  },
  {
    "id": 2137,
    "question": "Jacob's organization uses the US government's data classification system, which includes Top Secret, Secret, Confidential, and Unclassified ratings (from most sensitive to least). Jacob encounters a system that contains Secret, Confidential, and Top Secret data. <br>How should it be classified?",
    "choice_a": "Top Secret",
    "choice_b": "Confidential",
    "choice_c": "Secret",
    "choice_d": "Mixed classification",
    "correct_answer": "A",
    "explanation": "When data is stored in a mixed classification environment, it is typically classified based on the highest classification of data included. In this case, the US government's highest classification is Top Secret. Mixed classification is not a valid classification in this scheme.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      143,
      124,
      128,
      140
    ],
    "source": ""
  },
  {
    "id": 2138,
    "question": "Elle is planning her organization's asset retention efforts and wants to establish when the company will remove assets from use. <br>Which of the following is typically the last event in a manufacturer or software provider's lifecycle?",
    "choice_a": "End of life",
    "choice_b": "End of support",
    "choice_c": "End of sales",
    "choice_d": "General availability",
    "correct_answer": "B",
    "explanation": "The end of support of a device or product typically occurs after the end of life and end of sales. Support may continue for a period of months or even years, but eventually support stops too. General availability is found during the main part of a lifecycle, rather than at the end, and helps note when the product is out of testing and can be acquired or used by customers or others instead of specific groups like beta testers or early release partners.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      877,
      847,
      849,
      133,
      879
    ],
    "source": ""
  },
  {
    "id": 2139,
    "question": "Amanda has been asked to ensure that her organization's controls assessment procedures match the specific systems that the company uses. <br>What activity best matches this task?",
    "choice_a": "Asset management",
    "choice_b": "Compliance",
    "choice_c": "Scoping",
    "choice_d": "Tailoring",
    "correct_answer": "D",
    "explanation": "Tailoring ensures that assessment methods are appropriate to the systems, services, and other assets that are being validated and is the best answer here. Scoping is a related term and involves setting the boundaries of security control implementations. Asset management involves how assets are overseen throughout their lifecycle, and compliance is a broad term that describes ensuring that regulations, contractual terms, or other requirements are met.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      142,
      138,
      143
    ],
    "source": ""
  },
  {
    "id": 2140,
    "question": "Chris is responsible for his organization's security standards and has guided the selection and implementation of a security baseline for Windows PCs in his organization. <br>How can Chris most effectively make sure that the workstations he is responsible for are being checked for compliance and that settings are being applied as necessary?",
    "choice_a": "Assign users to spot-check baseline compliance.",
    "choice_b": "Use Microsoft Group Policy.",
    "choice_c": "Create startup scripts to apply policy at system start.",
    "choice_d": "Periodically review the baselines with the data owner and system owners.",
    "correct_answer": "B",
    "explanation": "Group Policy provides the ability to monitor and apply settings in a security baseline. Manual checks by users and using startup scripts provide fewer reviews and may be prone to failure, while periodic review of the baseline won't result in compliance being checked.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      141,
      698,
      851,
      852
    ],
    "source": ""
  },
  {
    "id": 2141,
    "question": "Frank is reviewing his company's data lifecycle and wants to place appropriate controls around the data collection phase. <br>Which of the following ensures that data subjects agree to the processing of their data?",
    "choice_a": "Retention",
    "choice_b": "Consent",
    "choice_c": "Certification",
    "choice_d": "Remanence",
    "correct_answer": "B",
    "explanation": "Providing consent, or agreeing to data collection and use, is important in many data collection scenarios and may be required by law. Remanence occurs when data remains in place, sometimes inadvertently, after it should have been removed or disposed of. Retention is the intentional process of keeping and managing data. Certification is not a data lifecycle process element.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      138,
      125,
      133,
      989
    ],
    "source": ""
  },
  {
    "id": 2142,
    "question": "As a DBA, Amy's data role in her organization includes technical implementations of the data policies and standards, as well as managing the data structures that the data is stored in. <br>What data role best fits what Amy does?",
    "choice_a": "Data custodian",
    "choice_b": "Data owner",
    "choice_c": "Data processor",
    "choice_d": "Data user",
    "correct_answer": "A",
    "explanation": "Amy is a data custodian and is responsible for the technical environment, including things like database structures and the technical implementations of data policies. Some organizations may overlap other data roles, including data controllers or data stewards, but the best answer here is a data custodian. Amy is not a data user and is not a data processor who uses the data on behalf of a data controller.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      989,
      851,
      850
    ],
    "source": ""
  },
  {
    "id": 2143,
    "question": "The company Jim works for suffered from a major data breach in the past year and now wants to ensure that it knows where data is located and if it is being transferred, is being copied to a thumb drive, or is in a network file share where it should not be. <br>Which of the following solutions is best suited to tagging, monitoring, and limiting where files are transferred to?",
    "choice_a": "DRM",
    "choice_b": "DLP",
    "choice_c": "A network IPS",
    "choice_d": "Antivirus",
    "correct_answer": "B",
    "explanation": "A data loss prevention (DLP) system can tag, monitor, and limit where files are transferred to. Jim's company may also elect to use digital rights management tools in combination with a data loss prevention system, but DRM controls how data can be used, not where files are transferred to or where they exist at any point in time in most cases. An intrusion prevention system (IPS) may be able to detect files that are being sent across a network but won't stop files from being copied on workstations or thumbdrives. Antivirus is not designed for this purpose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      144,
      128,
      124,
      134
    ],
    "source": ""
  },
  {
    "id": 2144,
    "question": "What security measure can provide an additional security control in the event that backup tapes are stolen or lost?",
    "choice_a": "Keep multiple copies of the tapes.",
    "choice_b": "Replace tape media with hard drives.",
    "choice_c": "Use appropriate security labels.",
    "choice_d": "Use AES-256 encryption.",
    "correct_answer": "D",
    "explanation": "Using strong encryption, like AES-256, can help ensure that loss of removable media like tapes doesn't result in a data breach. Security labels may help with handling processes, but they won't help once the media is stolen or lost. Having multiple copies will ensure that you can still access the data but won't increase the security of the media. Finally, using hard drives instead of tape only changes the media type and not the risk from theft or loss.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      124,
      144,
      129,
      132
    ],
    "source": ""
  },
  {
    "id": 2145,
    "question": "Joe works at a major pharmaceutical research and development company and has been tasked with writing his organization's data retention policy. As part of its legal requirements, the organization must comply with the US Food and Drug Administration's Code of Federal Regulations Title 21. To do so, it is required to retain records with electronic signatures. <br>Why would a signature be part of a retention requirement?",
    "choice_a": "It ensures that someone has reviewed the data.",
    "choice_b": "It provides confidentiality.",
    "choice_c": "It ensures that the data has been changed.",
    "choice_d": "It validates who approved the data.",
    "correct_answer": "D",
    "explanation": "Electronic signatures, as used in this rule, prove that the signature was provided by the intended signer. Electronic signatures as part of the FDA code are intended to ensure that electronic records are \"trustworthy, reliable, and generally equivalent to paper records and handwritten signatures executed on paper.\" Signatures cannot provide confidentiality or integrity and don't ensure that someone has reviewed the data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      850,
      851,
      852,
      142,
      125
    ],
    "source": ""
  },
  {
    "id": 2146,
    "question": "Susan wants to manage her data's lifecycle based on retention rules. <br>What technique can she use to ensure that data that has reached the end of its lifecycle can be identified and disposed of based on her organization's disposal processes?",
    "choice_a": "Rotation",
    "choice_b": "DRM",
    "choice_c": "DLP",
    "choice_d": "Tagging",
    "correct_answer": "D",
    "explanation": "Tags that include information about the lifespan of the data and when it has expired can help with lifecycle management processes. Tags can be as simple as timestamps, or they can include additional metadata like the data type, creator, or purpose that can help inform the retention and disposal process. Rotation of files like logs is commonly done to limit how much space they take up, but rotation itself does not address disposal requirements and information that would guide the disposal process. DRM, or digital rights management, and DLP, or data loss prevention, both address data security and use but not disposal.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      133,
      125,
      851,
      138
    ],
    "source": ""
  },
  {
    "id": 2147,
    "question": "Ben has been asked to scrub data to remove data that is no longer needed by his organization. <br>What phase of the data lifecycle is Ben most likely operating in?",
    "choice_a": "Data retention",
    "choice_b": "Data maintenance",
    "choice_c": "Data remanence",
    "choice_d": "Data collection",
    "correct_answer": "B",
    "explanation": "During the data maintenance phase of a typical data lifecycle, activities like data scrubbing occur to remove unneeded, incorrect, or out-of-date data. Data retention is not a phase; instead, it is a decision that organizations make based on requirements, laws, or their own needs. Data remanence is also not a phase. Data remanence describes the problem of data that remains after data is removed. Finally, in the data collection phase, data is acquired and may be scrubbed, but the question describes a process occurring after data is no longer needed, not during acquisition.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      125,
      131,
      133,
      850,
      130
    ],
    "source": ""
  },
  {
    "id": 2149,
    "question": "Alex works for a government agency that is required to meet US federal government requirements for data security. To meet these requirements, Alex has been tasked with making sure data is identifiable by its classification level when it is created. <br>What should Alex do to the data?",
    "choice_a": "Classify the data.",
    "choice_b": "Encrypt the data.",
    "choice_c": "Label the data.",
    "choice_d": "Apply DRM to the data.",
    "correct_answer": "C",
    "explanation": "Data labels are crucial to identify the classification level of information contained on the media, and labeling data at creation helps to ensure that it is properly handled throughout its lifecycle. Digital rights management (DRM) tools provide ways to control how data is used, while encrypting it can help maintain the confidentiality and integrity of the data. Classifying the data is necessary to label it, but it doesn't automatically place a label on the data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      121,
      123,
      143,
      124
    ],
    "source": ""
  },
  {
    "id": 2150,
    "question": "Ben is following the National Institute of Standards and Technology (NIST) Special Publication 800-88 guidelines for sanitization and disposition as shown here. He is handling information that his organization classified as sensitive, which is a moderate security categorization in the NIST model. <br><img src=\"/question_assets/CISSP/2_image3.png\"/><br>If the media is going to be sold as surplus, what process does Ben need to follow?",
    "choice_a": "Destroy, validate, document",
    "choice_b": "Clear, purge, document",
    "choice_c": "Purge, document, validate",
    "choice_d": "Purge, validate, document",
    "correct_answer": "D",
    "explanation": "The NIST SP 800-88 process for sanitization and disposition shows that media that will be reused and was classified at a moderate level should be purged and then that purge should be validated. Finally, it should be documented.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      130,
      125,
      144,
      123
    ],
    "source": ""
  },
  {
    "id": 2151,
    "question": "What methods are often used to protect data in transit?",
    "choice_a": "Telnet, ISDN, UDP",
    "choice_b": "Bit Locker, File Vault",
    "choice_c": "AES, Serpent, IDEA",
    "choice_d": "TLS, VPN, IP sec",
    "correct_answer": "D",
    "explanation": "Data in transit is data that is traversing a network or is otherwise in motion. TLS, VPNs, and IPsec tunnels are all techniques used to protect data in transit. AES, Serpent, and IDEA are all symmetric algorithms, while Telnet, ISDN, and UDP are all protocols. Bit Locker and File Vault are both used to encrypt data, but they protect only stored data, not data in transit.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      702,
      700,
      706
    ],
    "source": ""
  },
  {
    "id": 2152,
    "question": "Which one of the following data roles bears ultimate organizational responsibility for data?",
    "choice_a": "System owners",
    "choice_b": "Business owners",
    "choice_c": "Data owners",
    "choice_d": "Mission owners",
    "correct_answer": "C",
    "explanation": "The data owner has ultimate responsibility for data belonging to an organization and is typically the CEO, president, or another senior employee. Business and mission owners typically own processes or programs. System owners own a system that processes sensitive data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      851,
      143,
      989,
      988
    ],
    "source": ""
  },
  {
    "id": 2153,
    "question": "Shandra wants to secure an encryption key. <br>Which location would be the most difficult to protect, if the key was kept and used in that location?",
    "choice_a": "On a local network",
    "choice_b": "On disk",
    "choice_c": "In memory",
    "choice_d": "On a public network",
    "correct_answer": "C",
    "explanation": "The most difficult location to secure for encryption keys and similar highly sensitive information is in active memory because the data needs to be decrypted to be used. When data is at rest on a drive or in transit via either a local or public network, it can be encrypted until it reaches its destination, and you can use strong encryption in each of those circumstances.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      706,
      702,
      124
    ],
    "source": ""
  },
  {
    "id": 2154,
    "question": "Chris has recently been hired into a new organization. The organization that Chris belongs to uses the following classification process. <br><ol><li>Criteria are set for classifying data. </li><li>Data owners are established for each type of data. </li><li>Data is classified. </li><li>Required controls are selected for each classification. </li><li>Baseline security standards are selected for the organization. </li><li>Controls are scoped and tailored. </li><li>Controls are applied and enforced. </li><li>Access is granted and managed. </li></ol><br>If Chris is one of the data owners for the organization, what steps in this process is he most likely responsible for?",
    "choice_a": "He is responsible for steps 3, 4, and 5.",
    "choice_b": "He is responsible for steps 1, 2, and 3.",
    "choice_c": "He is responsible for steps 5, 6, and 7.",
    "choice_d": "All of the steps are his direct responsibility.",
    "correct_answer": "A",
    "explanation": "Chris is most likely to be responsible for classifying the data that he owns as well as assisting with or advising the system owners on security requirements and control selection. In an organization with multiple data owners, Chris is unlikely to set criteria for classifying data on his own. As a data owner, Chris will also not typically have direct responsibility for scoping, tailoring, applying, or enforcing those controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      124,
      140,
      141
    ],
    "source": ""
  },
  {
    "id": 2155,
    "question": "Chris has recently been hired into a new organization. The organization that Chris belongs to uses the following classification process. <br><ol><li>Criteria are set for classifying data. </li><li>Data owners are established for each type of data. </li><li>Data is classified. </li><li>Required controls are selected for each classification. </li><li>Baseline security standards are selected for the organization. </li><li>Controls are scoped and tailored. </li><li>Controls are applied and enforced. </li><li>Access is granted and managed. </li></ol><br>Chris manages a team of system administrators. <br>What data role are they fulfilling if they conduct steps 6, 7, and 8 of the classification process?",
    "choice_a": "They are system owners and administrators.",
    "choice_b": "They are administrators and custodians.",
    "choice_c": "They are data owners and administrators.",
    "choice_d": "They are custodians and users.",
    "correct_answer": "B",
    "explanation": "The system administrators are acting in the roles of data administrators who grant access and will also act as custodians who are tasked with the day-to-day application of security controls. They are not acting as data owners who own the data itself. Typically, system administrators are delegated authority by system owners, such as a department head, and of course they are tasked with providing access to users.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      140,
      124,
      851
    ],
    "source": ""
  },
  {
    "id": 2156,
    "question": "Chris has recently been hired into a new organization. The organization that Chris belongs to uses the following classification process. <br><ol><li>Criteria are set for classifying data. </li><li>Data owners are established for each type of data. </li><li>Data is classified. </li><li>Required controls are selected for each classification. </li><li>Baseline security standards are selected for the organization. </li><li>Controls are scoped and tailored. </li><li>Controls are applied and enforced. </li><li>Access is granted and managed. </li></ol><br>If Chris's company operates in the European Union and has been contracted to handle the data for a third party, what role is his company operating in when it uses this process to classify and handle data?",
    "choice_a": "Business owners",
    "choice_b": "Mission owners",
    "choice_c": "Data processors",
    "choice_d": "Data administrators",
    "correct_answer": "C",
    "explanation": "Third-party organizations that process personal data on behalf of a data controller are known as data processors. The organization that they are contracting with would act in the role of the business or mission owners, and others within Chris's organization would have the role of data administrators, granting access as needed to the data based on their operational procedures and data classification.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      988,
      143,
      142,
      141
    ],
    "source": ""
  },
  {
    "id": 2157,
    "question": "Chris has been put in charge of his organization's IT service management effort, and part of that effort includes creating an inventory of both tangible and intangible assets. As a security professional, you have been asked to provide Chris with security-related guidance on each of the following topics. Your goal is to provide Chris with the best answer from each of the options, knowing that in some cases more than one of the answers could be acceptable. <br>Chris needs to identify all of the active systems and devices on the network. <br>Which of the following techniques will give him the most complete list of connected devices?",
    "choice_a": "Query Active Directory for a list of all computer objects.",
    "choice_b": "Perform a port scan of all systems on the network.",
    "choice_c": "Ask all staff members to fill out a form listing all of their systems and devices.",
    "choice_d": "Use network logs to identify all connected devices and track them down from there.",
    "correct_answer": "D",
    "explanation": "While it can be a lot of work, the most complete inventory of active systems and devices can be created by determining what is connected to the network and then finding those assets. Port scans can help to find some systems, but firewalls and other security solutions can prevent systems from being discovered. Staff may not know about all of the systems and devices on the network or may presume that someone else will provide information about shared resources such as printers, security cameras, or other devices. Active Directory is unlikely to contain all devices, particularly if an inventory is needed!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      849,
      123,
      128,
      140,
      701
    ],
    "source": ""
  },
  {
    "id": 2158,
    "question": "Chris has been put in charge of his organization's IT service management effort, and part of that effort includes creating an inventory of both tangible and intangible assets. As a security professional, you have been asked to provide Chris with security-related guidance on each of the following topics. Your goal is to provide Chris with the best answer from each of the options, knowing that in some cases more than one of the answers could be acceptable. <br>Chris knows that his inventory is only accurate at the moment it was completed. <br>How can he best ensure that it remains up-to-date?",
    "choice_a": "Perform a point-in-time query of network connected devices and update the list based on what is found.",
    "choice_b": "Ensure that procurement and acquisition processes add new devices to the inventory before they are deployed.",
    "choice_c": "Require every employee to provide an updated inventory of devices they are responsible for on a quarterly basis.",
    "choice_d": "Manually verify every device in service at each organizational location on a yearly basis.",
    "correct_answer": "B",
    "explanation": "In most organizations, changing processes so that new systems and devices are added to inventory before they are deployed is the first step in making sure asset inventories are current. Yearly or quarterly updates are too infrequent for most organizations and will lead to gaps as devices are forgotten.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      849,
      879,
      133,
      123,
      140
    ],
    "source": ""
  },
  {
    "id": 2159,
    "question": "Chris has been put in charge of his organization's IT service management effort, and part of that effort includes creating an inventory of both tangible and intangible assets. As a security professional, you have been asked to provide Chris with security-related guidance on each of the following topics. Your goal is to provide Chris with the best answer from each of the options, knowing that in some cases more than one of the answers could be acceptable. <br>Chris knows that his organization has more than just physical assets. In fact, his organization's business involves significant intellectual property assets, including designs and formulas. Chris needs to track and inventory those assets as well. <br>How can he most effectively ensure that he can identify and manage data throughout his organization based on its classification or type?",
    "choice_a": "Track file extensions for common data types.",
    "choice_b": "Ensure that data is collected in specific network share locations based on the data type and group that works with it.",
    "choice_c": "Use metadata tagging based on data type or security level.",
    "choice_d": "Automatically tag data by file extension type.",
    "correct_answer": "C",
    "explanation": "Chris should use metadata tagging to allow him to use technical tools like DLP and DRM to handle and track data based on its type and content. File extensions do not reveal data security or type, and relying on network share locations to secure data or inventory will lead to gaps in security as files are moved, copied, or stored locally.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      127,
      124,
      143,
      123
    ],
    "source": ""
  },
  {
    "id": 2160,
    "question": "Chris has been put in charge of his organization's IT service management effort, and part of that effort includes creating an inventory of both tangible and intangible assets. As a security professional, you have been asked to provide Chris with security-related guidance on each of the following topics. Your goal is to provide Chris with the best answer from each of the options, knowing that in some cases more than one of the answers could be acceptable. <br>Chris has been tasked with identifying intangible assets but needs to provide his team with a list of the assets they will be inventorying. <br>Which of the following is not an example of an intangible asset?",
    "choice_a": "Patents",
    "choice_b": "Databases",
    "choice_c": "Formulas",
    "choice_d": "Employees",
    "correct_answer": "D",
    "explanation": "Patents, databases, and formulas are all examples of intangible assets. Tangible assets include things like hardware, cables, and buildings. Personnel assets include employees, and most organizations would be quite concerned if their employees were intangible!",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      123,
      125,
      128,
      133
    ],
    "source": ""
  },
  {
    "id": 2161,
    "question": "Which of the following is not a common requirement for the collection of data under data privacy laws and statutes?",
    "choice_a": "Only data that is needed is collected.",
    "choice_b": "Data should be obtained lawfully and via fair methods.",
    "choice_c": "Data should only be collected with the consent of the individual whose data is being collected.",
    "choice_d": "Data should be collected from all individuals equally.",
    "correct_answer": "D",
    "explanation": "There is no requirement that data collection be equal or equivalent. Instead, data collection statutes and other requirements often require that only required data is collected, that individuals are made aware of the data collection, and that they consent to the collection. Similarly, data should only be collected lawfully and via fair methods.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      126,
      132,
      143,
      125
    ],
    "source": ""
  },
  {
    "id": 2162,
    "question": "Susan works in an organization that labels all removable media with the classification level of the data it contains, including public data. <br>Why would Susan's employer label all media instead of labeling only the media that contains data that could cause harm if it was exposed?",
    "choice_a": "It is cheaper to order all pre labeled media.",
    "choice_b": "It prevents sensitive media from not being marked by mistake.",
    "choice_c": "It prevents reuse of public media for sensitive data.",
    "choice_d": "Labeling all media is required by HIPAA.",
    "correct_answer": "B",
    "explanation": "Requiring all media to have a label means that when unlabeled media is found, it should immediately be considered suspicious. This helps to prevent mistakes that might leave sensitive data unlabeled. Pre labeled media is not necessarily cheaper (nor may it make sense to buy!), while reusing public media simply means that it must be classified based on the data it now contains. HIPAA does not have specific media labeling requirements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      123,
      128,
      121,
      124,
      143
    ],
    "source": ""
  },
  {
    "id": 2163,
    "question": "Data stored in RAM is best characterized as what type of data?",
    "choice_a": "Data at rest",
    "choice_b": "Data in use",
    "choice_c": "Data in transit",
    "choice_d": "Data at large",
    "correct_answer": "B",
    "explanation": "Data in use is data that is in a temporary storage location while an application or process is using it. Thus, data in memory is best described as data in use or ephemeral data. Data at rest is in storage, while data in transit is traveling over a network or other channel. Data at large is a made-up term.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      706,
      700,
      127
    ],
    "source": ""
  },
  {
    "id": 2164,
    "question": "What issue is the validation portion of the NIST SP 800-88 sample certificate of sanitization (shown here) intended to help prevent?<br><img src=\"/question_assets/CISSP/2_image4.png\"/>",
    "choice_a": "Destruction",
    "choice_b": "Reuse",
    "choice_c": "Data remanence",
    "choice_d": "Attribution",
    "correct_answer": "C",
    "explanation": "Validation processes are conducted to ensure that the sanitization process was completed, avoiding data remanence. A form like this one helps to ensure that each device has been checked and that it was properly wiped, purged, or sanitized. This can allow reuse, does not prevent destruction, and does not help with attribution, which is a concept used with encryption to prove who created or sent a file.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      129,
      144,
      125,
      133
    ],
    "source": ""
  },
  {
    "id": 2165,
    "question": "Why is declassification rarely chosen as an option for media reuse?",
    "choice_a": "Purging is sufficient for sensitive data.",
    "choice_b": "Sanitization is the preferred method of data removal.",
    "choice_c": "It is more expensive than new media and may still fail.",
    "choice_d": "Clearing is required first.",
    "correct_answer": "C",
    "explanation": "Ensuring that data cannot be recovered is difficult, and the time and effort required to securely and completely wipe media as part of declassification can exceed the cost of new media. Sanitization, purging, and clearing may be part of declassification, but they are not reasons that it is not frequently chosen as an option for organizations with data security concerns.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      130,
      144,
      133,
      125
    ],
    "source": ""
  },
  {
    "id": 2166,
    "question": "Incineration, crushing, shredding, and disintegration all describe what stage in the lifecycle of media?",
    "choice_a": "Sanitization",
    "choice_b": "Degaussing",
    "choice_c": "Purging",
    "choice_d": "Destruction",
    "correct_answer": "D",
    "explanation": "Destruction is the final stage in the lifecycle of media and can be done via disintegration, incineration, or a variety of other methods that result in the media and data being non recoverable. Sanitization is a combination of processes used when data is being removed from a system or media. Purging is an intense form of clearing, and degaussing uses strong magnetic fields to wipe data from magnetic media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      125,
      144,
      133,
      130
    ],
    "source": ""
  },
  {
    "id": 2167,
    "question": "What term is used to describe information like prescriptions and X-rays?",
    "choice_a": "PHI",
    "choice_b": "Proprietary data",
    "choice_c": "PID",
    "choice_d": "PII",
    "correct_answer": "A",
    "explanation": "PHI is protected health information. Personally identifiable information (PII) is any information that can identify an individual. Proprietary data is information that helps organizations maintain a competitive edge or that they want to keep to their own organization or a controlled set of individuals. PID is not a term used for data classification.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      143,
      126,
      124,
      138
    ],
    "source": ""
  },
  {
    "id": 2168,
    "question": "Why might an organization use unique screen backgrounds or designs on workstations that deal with data of different classification levels?",
    "choice_a": "To indicate the software version in use",
    "choice_b": "To promote a corporate message",
    "choice_c": "To promote availability",
    "choice_d": "To indicate the classification level of the data or system",
    "correct_answer": "D",
    "explanation": "Handling requirements and tools include visual indicators like a distinctive screen background and can help employees remember what level of classification they are dealing with and thus the handling requirements that they are expected to follow.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      699,
      697,
      128,
      140,
      123
    ],
    "source": ""
  },
  {
    "id": 2169,
    "question": "Charles has been asked to downgrade the media used for storage of private data for his organization. <br>What process should Charles follow?",
    "choice_a": "Degauss the drives, and then relabel them with a lower classification level.",
    "choice_b": "Pulverize the drives, and then reclassify them based on the data they contain.",
    "choice_c": "Follow the organization's purging process, and then downgrade and replace labels.",
    "choice_d": "Relabel the media, and then follow the organization's purging process to ensure that the media matches the label.",
    "correct_answer": "C",
    "explanation": "If an organization allows media to be downgraded, the purging process should be followed, and then the media should be relabeled. Degaussing may be used for magnetic media but won't handle all types of media. Pulverizing would destroy the media, preventing reuse, while relabeling first could lead to mistakes that result in media that hasn't been purged entering use.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      128,
      130,
      125,
      133
    ],
    "source": ""
  },
  {
    "id": 2170,
    "question": "Which of the following tasks is not performed by a system owner per NIST SP 800-18?",
    "choice_a": "Develops a system security plan",
    "choice_b": "Establishes rules for appropriate use and protection of data",
    "choice_c": "Identifies and implements security controls",
    "choice_d": "Ensures that system users receive appropriate security training",
    "correct_answer": "B",
    "explanation": "The data owner, as defined by NIST SP 800-18, is responsible for establishing rules for the appropriate use and protection of data. This role is distinct from that of the system owner, who is primarily responsible for developing the system security plan, identifying and implementing security controls, and ensuring that system users receive appropriate security training. These tasks are critical for maintaining the overall security of the system, whereas the data owner focuses on the governance and protection of the data itself.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      851,
      143,
      141,
      140
    ],
    "source": ""
  },
  {
    "id": 2171,
    "question": "NIST SP 800-60 provides a process shown in the following diagram to assess information systems. <br><img src=\"/question_assets/CISSP/2_image5.png\"/><br>What process does this diagram show?",
    "choice_a": "Selecting a standard and implementing it",
    "choice_b": "Categorizing and selecting controls",
    "choice_c": "Base lining and selecting controls",
    "choice_d": "Categorizing and sanitizing",
    "correct_answer": "B",
    "explanation": "In the NIST SP 800-60 diagram, the process determines appropriate categorization levels resulting in security categorization and then uses that as an input to determine controls. Standard selection would occur at an organizational level, while base lining occurs when systems are configured to meet a baseline. Sanitization would require the intentional removal of data from machines or media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      140,
      141,
      142,
      121,
      124
    ],
    "source": ""
  },
  {
    "id": 2172,
    "question": "The following diagram shows a typical workstation and server and their connections to each other and the internet. <br><img src=\"/question_assets/CISSP/2_image6.png\"/><br>Which letters on this diagram are locations where you might find data at rest?",
    "choice_a": "A, B, and C",
    "choice_b": "C and E",
    "choice_c": "A and E",
    "choice_d": "B, D, and F",
    "correct_answer": "C",
    "explanation": "A and E can both be expected to have data at rest. C, the internet, is an unknown, and the data can't be guaranteed to be at rest. B, D, and F are all data in transit across network links.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      122,
      701,
      702,
      706
    ],
    "source": ""
  },
  {
    "id": 2173,
    "question": "The following diagram shows a typical workstation and server and their connections to each other and the internet. <br><img src=\"/question_assets/CISSP/2_image6.png\"/><br>What would be the best way to secure data at points B, D, and F?",
    "choice_a": "AES-256",
    "choice_b": "SSL",
    "choice_c": "TLS",
    "choice_d": "3DES",
    "correct_answer": "C",
    "explanation": "B, D, and F all show network links. Of the answers provided, Transport Layer Security (TLS) provides the best security for data in motion. AES-256 and 3DES are both symmetric ciphers and are more likely to be used for data at rest. SSL has been replaced with TLS and should not be a preferred solution.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      144,
      700,
      702,
      122,
      706
    ],
    "source": ""
  },
  {
    "id": 2174,
    "question": "The following diagram shows a typical workstation and server and their connections to each other and the internet. <br><img src=\"/question_assets/CISSP/2_image6.png\"/><br>What is the best way to secure files that are sent from workstation A via the internet service (C) to remote server E?",
    "choice_a": "Use AES at rest at point A, and use TLS in transit via B and D.",
    "choice_b": "Encrypt the data files and send them.",
    "choice_c": "Use 3DES and TLS to provide double security.",
    "choice_d": "Use full disk encryption at A and E, and use SSL at B and D.",
    "correct_answer": "B",
    "explanation": "Sending a file that is encrypted before it leaves means that exposure of the file in transit will not result in a confidentiality breach and the file will remain secure until decrypted at location E. Since answers A, C, and D do not provide any information about what happens at point C, they should be considered insecure, as the file may be at rest at point C in an unencrypted form.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      700,
      702,
      124
    ],
    "source": ""
  },
  {
    "id": 2175,
    "question": "Susan needs to provide a set of minimum security requirements for email. <br>What steps should she recommend for her organization to ensure that the email remains secure?",
    "choice_a": "All email should be encrypted.",
    "choice_b": "All email should be encrypted and labeled.",
    "choice_c": "Sensitive email should be encrypted and labeled.",
    "choice_d": "Only highly sensitive email should be encrypted.",
    "correct_answer": "C",
    "explanation": "Encrypting and labeling sensitive email will ensure that it remains confidential and can be identified. Performing these actions only on sensitive email will reduce the cost and effort of encrypting all email, allowing only sensitive email to be the focus of the organization's efforts. Only encrypting highly sensitive email not only skips labeling but might expose other classifications of email that shouldn't be exposed.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      124,
      143,
      122,
      140
    ],
    "source": ""
  },
  {
    "id": 2176,
    "question": "How can a data retention policy reduce liabilities?",
    "choice_a": "By reducing the amount of storage in use",
    "choice_b": "By limiting the number of data classifications",
    "choice_c": "By reducing the amount of data that may need to be produced for lawsuits",
    "choice_d": "By reducing the legal penalties for noncompliance",
    "correct_answer": "C",
    "explanation": "Data retention policies can reduce the amount of old logs and other files that may need to be produced during a legal case. That can reduce organizational risk, but retention policies need to be in place well before a legal hold is filed. Reducing storage in use does not reduce liability, but it can reduce financial costs, and data retention policies don't tend to limit the number of classifications in use. Legal penalties are not impacted by a retention policy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      850,
      851,
      132,
      125
    ],
    "source": ""
  },
  {
    "id": 2177,
    "question": "What data role does a system that is used to process data have?",
    "choice_a": "Mission owner",
    "choice_b": "Data owner",
    "choice_c": "Data processor",
    "choice_d": "Custodian",
    "correct_answer": "C",
    "explanation": "Systems used to process data are data processors. Data owners are typically CEOs or other very senior staff, custodians are granted rights to perform day-to-day tasks when handling data, and mission owners are typically program or information system owners.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      988,
      989,
      143,
      851
    ],
    "source": ""
  },
  {
    "id": 2178,
    "question": "Which one of the following is not considered PII under US federal government regulations?",
    "choice_a": "Name",
    "choice_b": "Social Security number",
    "choice_c": "Student ID number",
    "choice_d": "ZIP code",
    "correct_answer": "D",
    "explanation": "Personally identifiable information includes any information that can uniquely identify an individual. This would include name, Social Security number, and any other unique identifier (including a student ID number). ZIP code, by itself, does not uniquely identify an individual.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      703,
      704,
      120,
      137,
      136
    ],
    "source": ""
  },
  {
    "id": 2179,
    "question": "What type of health information is the Health Insurance Portability and Accountability Act required to protect?",
    "choice_a": "PII",
    "choice_b": "PHI",
    "choice_c": "SHI",
    "choice_d": "HPHI",
    "correct_answer": "B",
    "explanation": "Protected health information, or PHI, includes a variety of data in multiple formats, including oral and recorded data, such as that created or received by healthcare providers, employers, and life insurance providers. PHI must be protected by HIPAA. PII is personally identifiable information. SHI and HPHI are both made-up acronyms.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      120,
      126,
      143,
      122,
      138
    ],
    "source": ""
  },
  {
    "id": 2180,
    "question": "The system that Ian has built replaces data in a database field with a randomized string of characters that remains the same for each instance of that data. <br>What technique has he used?",
    "choice_a": "Data masking",
    "choice_b": "Tokenization",
    "choice_c": "Anonymization",
    "choice_d": "DES",
    "correct_answer": "B",
    "explanation": "Tokenization replaces other data with a random string of characters. These tokens are then matched to the actual values for secure lookups as needed. Anonymization removes all personally identifiable data to ensure that the original subject cannot be identified. Data masking obscures some, but not all, data. Pseudonymization uses a pseudonym or alias to replace other information.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      136,
      143,
      120,
      144,
      124
    ],
    "source": ""
  },
  {
    "id": 2181,
    "question": "Juanita's company processes credit cards and wants to select appropriate data security standards. <br>What data security standard is she most likely to need to use and comply with?",
    "choice_a": "CC-Comply",
    "choice_b": "PCI-DSS",
    "choice_c": "GLBA",
    "choice_d": "GDPR",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard, or PCI-DSS, is a credit card industry data security standard that defines how businesses must handle information related to credit cards. CC-Comply was made up for this question. GLBA, or Gramm-Leach-Bliley, modernized financial institution standards, and GDPR is an EU data privacy regulation.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      126,
      136,
      125,
      124
    ],
    "source": ""
  },
  {
    "id": 2182,
    "question": "What is the best method to sanitize a solid-state drive (SSD)?",
    "choice_a": "Clearing",
    "choice_b": "Zero fill",
    "choice_c": "Disintegration",
    "choice_d": "Degaussing",
    "correct_answer": "C",
    "explanation": "Due to problems with remnant data, the U.S. National Security Agency requires physical destruction of SSDs. This process, known as disintegration, results in very small fragments via a shredding process. Zero fill wipes a drive by replacing data with zeros, degaussing uses magnets to wipe magnetic media, and clearing is the process of preparing media for reuse.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      1024,
      130,
      144,
      133
    ],
    "source": ""
  },
  {
    "id": 2183,
    "question": "As shown in the following security lifecycle diagram (loosely based on the NIST reference architecture), NIST uses a five-step process for risk management. Using your knowledge of data roles and practices, answer the following questions based on the NIST framework process. <br><img src=\"/question_assets/CISSP/2_image7.png\"/><br>What data role will own responsibility for step 1, the categorization of information systems; to whom will they delegate step 2; and what data role will be responsible for step 3?",
    "choice_a": "Data owners, system owners, custodians",
    "choice_b": "Data processors, custodians, users",
    "choice_c": "Business owners, administrators, custodians",
    "choice_d": "System owners, business owners, administrators",
    "correct_answer": "A",
    "explanation": "The data owner bears responsibility for categorizing information systems and delegates selection of controls to system owners, while custodians implement the controls. Users don't perform any of these actions, while business owners are tasked with ensuring that systems are fulfilling their business purpose.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      140,
      141,
      124
    ],
    "source": ""
  },
  {
    "id": 2184,
    "question": "As shown in the following security lifecycle diagram (loosely based on the NIST reference architecture), NIST uses a five-step process for risk management. Using your knowledge of data roles and practices, answer the following questions based on the NIST framework process. <br><img src=\"/question_assets/CISSP/2_image7.png\"/><br>If the systems that are being assessed all handle credit card information (and no other sensitive data), at what step would the PCI DSS first play an important role?",
    "choice_a": "Step 1",
    "choice_b": "Step 2",
    "choice_c": "Step 3",
    "choice_d": "Step 4",
    "correct_answer": "B",
    "explanation": "PCI DSS provides a set of required security controls and standards. Step 2 would be guided by the requirements of  PCI DSS. PCI DSS will not greatly influence step 1 because all of the systems handle credit card information, making PCI DSS apply to all systems covered. Steps 3 and 4 will be conducted after PCI DSS has guided the decisions in step 2.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      142,
      140,
      141,
      126,
      124
    ],
    "source": ""
  },
  {
    "id": 2185,
    "question": "As shown in the following security lifecycle diagram (loosely based on the NIST reference architecture), NIST uses a five-step process for risk management. Using your knowledge of data roles and practices, answer the following questions based on the NIST framework process. <br><img src=\"/question_assets/CISSP/2_image7.png\"/><br>What data security role is primarily responsible for step 5?",
    "choice_a": "Data owners",
    "choice_b": "Data processors",
    "choice_c": "Custodians",
    "choice_d": "Users",
    "correct_answer": "C",
    "explanation": "Custodians are tasked with the day-to-day monitoring of the integrity and security of data. Step 5 requires monitoring, which is a custodial task. A data owner may grant rights to custodians but will not be responsible for conducting monitoring. Data processors process data on behalf of the data controller, and a user simply uses the data via a computing system.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      989,
      143,
      125,
      140
    ],
    "source": ""
  },
  {
    "id": 2186,
    "question": "Susan's organization performs a secure disk wipe process on hard drives before they are sent to a third-party organization to be shredded. <br>What issue is her organization attempting to avoid?",
    "choice_a": "A. Data retention that is longer than defined in policy",
    "choice_b": "Mishandling of drives by the third party",
    "choice_c": "Classification mistakes",
    "choice_d": "Data permanence",
    "correct_answer": "B",
    "explanation": "Susan's organization is limiting its risk by sending drives that have been sanitized before they are destroyed. This limits the possibility of a data breach if drives are mishandled by the third party, allowing them to be stolen, resold, or simply copied. The destruction of the drives will handle any issues with data remanence, while classification mistakes are not important if the drives have been destroyed. Wiping the data before destruction does not make a meaningful difference for data retention policy concerns. Data permanence and the life span of the data are not important on a destroyed drive.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      130,
      1026,
      129,
      990,
      133
    ],
    "source": ""
  },
  {
    "id": 2187,
    "question": "Mike wants to track hardware assets as devices and equipment are moved throughout his organization. <br>What type of system can help do this without requiring staff to individually check bar codes or serial numbers?",
    "choice_a": "A visual inventory",
    "choice_b": "WiFi MAC address tracking",
    "choice_c": "RFID tags",
    "choice_d": "Steganography",
    "correct_answer": "C",
    "explanation": "RFID tags are a common solution for tracking hardware assets and equipment. They can be queried wirelessly at varying ranges depending on the tags and may be built-in to hand-held readers or even included in doorways or arches to track items as they enter or leave a facility. Visual inventory relies on staff checking items, MAC addresses are hardware addresses for networked devices and not every asset in inventory is likely to have a wireless network capability\u2014or to be on! Steganography is hiding messages in images and doesn't help at all with inventory.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      849,
      123,
      128,
      133,
      879
    ],
    "source": ""
  },
  {
    "id": 2188,
    "question": "Retaining and maintaining information for as long as it is needed is known as what?",
    "choice_a": "Data storage policy",
    "choice_b": "Data storage",
    "choice_c": "Asset maintenance",
    "choice_d": "Record retention",
    "correct_answer": "D",
    "explanation": "Record retention is the process of retaining and maintaining information for as long as it is needed. A data storage policy describes how and why data is stored, while data storage is the process of actually keeping the data. Asset maintenance is a non information-security-related process for maintaining physical assets.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      851,
      852,
      125,
      138
    ],
    "source": ""
  },
  {
    "id": 2189,
    "question": "Which of the following activities is not a consideration during data classification?",
    "choice_a": "Who can access the data",
    "choice_b": "What the impact would be if the data was lost or breached",
    "choice_c": "How much the data cost to create",
    "choice_d": "What protection regulations may be required for the data",
    "correct_answer": "C",
    "explanation": "The cost of the data is not directly included in the classification process. Instead, the impact to the organization if the data were exposed or breached is considered. Who can access the data and what regulatory or compliance requirements cover the data are also important considerations.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      124,
      126,
      125,
      138
    ],
    "source": ""
  },
  {
    "id": 2190,
    "question": "What type of encryption is typically used for data at rest?",
    "choice_a": "Asymmetric encryption",
    "choice_b": "Symmetric encryption",
    "choice_c": "DES",
    "choice_d": "OTP",
    "correct_answer": "B",
    "explanation": "Symmetric encryption like AES is typically used for data at rest. Asymmetric encryption is often used during transactions or communications when the ability to have public and private keys is necessary. DES is an outdated encryption standard, and OTP is the acronym for onetime password.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      702,
      124,
      706
    ],
    "source": ""
  },
  {
    "id": 2191,
    "question": "Which data role is tasked with apply rights that provide appropriate access to staff members?",
    "choice_a": "Data processors",
    "choice_b": "Business owners",
    "choice_c": "Custodians",
    "choice_d": "Administrators",
    "correct_answer": "D",
    "explanation": "Administrators have the rights to apply the permissions to access and handle data. Custodians are trusted with day-to-day data handling tasks. Business owners are typically system or project owners, and data processors are systems used to process data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      139,
      143,
      851,
      856
    ],
    "source": ""
  },
  {
    "id": 2192,
    "question": "What element of asset security is often determined by identifying an asset's owner?",
    "choice_a": "It identifies the individual(s) responsible for protecting the asset.",
    "choice_b": "It provides a law enforcement contact in case of theft.",
    "choice_c": "It helps establish the value of the asset.",
    "choice_d": "It determines the security classification of the asset.",
    "correct_answer": "A",
    "explanation": "Knowing the asset's owner also tells you who is responsible for protecting the asset or for delegating that task. While asset owners may be law enforcement contacts, this is not a critical item for asset security. It does not directly help you to establish the value of the asset or to set security classification levels for an asset.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      851,
      856,
      858
    ],
    "source": ""
  },
  {
    "id": 2193,
    "question": "Fred is preparing to send backup tapes off-site to a secure third-party storage facility. <br>What steps should Fred take before sending the tapes to that facility?",
    "choice_a": "Ensure that the tapes are handled the same way the original media would be handled based on their classification.",
    "choice_b": "Increase the classification level of the tapes because they are leaving the possession of the company.",
    "choice_c": "Purge the tapes to ensure that classified data is not lost.",
    "choice_d": "Decrypt the tapes in case they are lost in transit.",
    "correct_answer": "A",
    "explanation": "Tapes may be vulnerable to theft or loss in transit. That means that tapes that are leaving their normal storage facility should be handled according to the organization's classification schemes and handling requirements. Purging the tapes would cause the loss of data, while increasing the classification level of the tapes. The tapes should be encrypted rather than decrypted.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      124,
      132,
      128,
      131
    ],
    "source": ""
  },
  {
    "id": 2194,
    "question": "Which of the following does not describe data in motion?",
    "choice_a": "Data on a backup tape that is being shipped to a storage facility",
    "choice_b": "Data in a TCP packet",
    "choice_c": "Data in an e-commerce transaction",
    "choice_d": "Data in files being copied between locations",
    "correct_answer": "A",
    "explanation": "The correct answer is the tape that is being shipped to a storage facility. You might think that the tape in shipment is \"in motion,\" but the concept is that the data is not being accessed and is instead in storage rather than being sent across a network. Data in a TCP packet, in an e-commerce transaction, or in local RAM is in motion and is actively being used.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      706,
      707,
      144,
      122,
      700
    ],
    "source": ""
  },
  {
    "id": 2195,
    "question": "A new law is passed that would result in significant financial harm to your company if the data that it covers was stolen or inadvertently released. <br>What should your organization do about this?",
    "choice_a": "Select a new security baseline.",
    "choice_b": "Relabel the data.",
    "choice_c": "Encrypt all of the data at rest and in transit.",
    "choice_d": "Review its data classifications and classify the data appropriately.",
    "correct_answer": "D",
    "explanation": "When the value of data changes due to legal, compliance, or business reasons, reviewing classifications and reclassifying the data is an appropriate response. Once the review is complete, data can be reclassified and handled according to its classification level. Simply relabeling the data avoids the classification process and may not result in the data being handled appropriately. Similarly, selecting a new baseline or simply encrypting the data may not handle all of the needs that the changes affecting the data create.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      125,
      124,
      121,
      138
    ],
    "source": ""
  },
  {
    "id": 2196,
    "question": "Which of the following data roles are typically found inside of a company instead of as a third-party contracting relationship?  (Select all that apply.)",
    "choice_a": "Data owners",
    "choice_b": "Data controllers",
    "choice_c": "Data custodians",
    "choice_d": "Data processors",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Data owners, controllers, and custodians are typically found inside of a company, while data processors are typically third parties.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      139,
      988,
      989,
      990
    ],
    "source": ""
  },
  {
    "id": 2197,
    "question": "What commercial data classification is most appropriate for data contained on corporate websites?",
    "choice_a": "Private",
    "choice_b": "Sensitive",
    "choice_c": "Public",
    "choice_d": "Proprietary",
    "correct_answer": "C",
    "explanation": "Public data is just that\u2014information that can be made public without any harm to the organization, and in fact, it is often information that the organization wants to make available. Private information should stay private inside of an organization, sensitive data may cause damage to the mission of the organization if exposed, and proprietary or confidential information is the most sensitive data that an organization wants to protect.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      121,
      143,
      123,
      124,
      697
    ],
    "source": ""
  },
  {
    "id": 2198,
    "question": "Matthew is the security administrator for a consulting firm and must enforce access controls that restrict users' access based upon their previous activity. For example, once a consultant accesses data belonging to Acme Cola, a consulting client, they may no longer access data belonging to any of Acme's competitors. <br>What security model best fits Matthew's needs?",
    "choice_a": "Clark-Wilson",
    "choice_b": "Biba",
    "choice_c": "Bell-LaPadula",
    "choice_d": "Brewer-Nash",
    "correct_answer": "D",
    "explanation": "The Brewer-Nash model allows access controls to change dynamically based upon a user's actions. It is often used in environments like Matthew's to implement a \"Chinese wall\" between data belonging to different clients.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      220,
      228,
      217,
      219,
      218
    ],
    "source": ""
  },
  {
    "id": 2199,
    "question": "Referring to the figure shown here, what is the earliest stage of a fire where it is possible to use detection technology to identify it?<br><img src=\"/question_assets/CISSP/3_image1.png\"/>",
    "choice_a": "Incipient",
    "choice_b": "Smoke",
    "choice_c": "Flame",
    "choice_d": "Heat",
    "correct_answer": "A",
    "explanation": "Fires may be detected as early as the incipient stage. During this stage, air ionization takes place, and specialized incipient fire detection systems can identify these changes to provide early warning of a fire.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      709,
      710,
      314,
      326,
      327
    ],
    "source": ""
  },
  {
    "id": 2200,
    "question": "Ralph is designing a physical security infrastructure for a new computing facility that will remain largely unstaffed. He plans to implement motion detectors in the facility but would also like to include a secondary verification control for physical presence. <br>Which one of the following would best meet his needs?",
    "choice_a": "CCTV",
    "choice_b": "IPS",
    "choice_c": "Turnstiles",
    "choice_d": "Faraday cages",
    "correct_answer": "A",
    "explanation": "Closed-circuit television (CCTV) systems act as a secondary verification mechanism for physical presence because they allow security officials to view the interior of the facility when a motion alarm sounds to determine the current occupants and their activities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      327,
      309,
      305,
      324
    ],
    "source": ""
  },
  {
    "id": 2201,
    "question": "Harry would like to retrieve a lost encryption key from a database that uses m of n control, with m = 4 and n = 8. <br>What is the minimum number of escrow agents required to retrieve the key?",
    "choice_a": "2",
    "choice_b": "4",
    "choice_c": "8",
    "choice_d": "12",
    "correct_answer": "B",
    "explanation": "In an m of n control system, at least m of n possible escrow agents must collaborate to retrieve an encryption key from the escrow database.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      712,
      713,
      148,
      161,
      714
    ],
    "source": ""
  },
  {
    "id": 2202,
    "question": "Fran's company is considering purchasing a web-based email service from a vendor and eliminating its own email server environment as a cost-saving measure. <br>What type of cloud computing environment is Fran's company considering?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "CaaS",
    "choice_d": "PaaS",
    "correct_answer": "A",
    "explanation": "This is an example of a vendor offering a fully functional application as a web-based service. Therefore, it fits under the definition of software as a service (SaaS). In infrastructure as a service (IaaS), compute as a service (CaaS), and platform as a service (PaaS) approaches, the customer provides their own software. In this example, the vendor is providing the email software, so none of those choices is appropriate.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      210,
      265,
      186,
      187
    ],
    "source": ""
  },
  {
    "id": 2203,
    "question": "Bob is a security administrator with the U.S.federal government and wants to choose a digital signature approach that is an approved part of the federal Digital Signature Standard under FIPS 186-4. <br>Which one of the following encryption algorithms is not an acceptable choice for use in digital signatures?",
    "choice_a": "DSA",
    "choice_b": "HAVAL",
    "choice_c": "RSA",
    "choice_d": "ECDSA",
    "correct_answer": "B",
    "explanation": "The Digital Signature Standard approves three encryption algorithms for use in digital signatures: the Digital Signature Algorithm (DSA); the Rivest, Shamir, Adleman (RSA) algorithm; and the Elliptic Curve DSA (ECDSA) algorithm. HAVAL is a hash function, not an encryption algorithm. While hash functions are used as part of the digital signature process, they do not provide encryption.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      178,
      175,
      174,
      172,
      168
    ],
    "source": ""
  },
  {
    "id": 2204,
    "question": "Harry would like to access a document owned by Sally and stored on a file server. Applying the subject/object model to this scenario, who or what is the subject of the resource request?",
    "choice_a": "Harry",
    "choice_b": "Sally",
    "choice_c": "Server",
    "choice_d": "Document",
    "correct_answer": "A",
    "explanation": "In the subject/object model of access control, the user or process making the request for a resource is the subject of that request. In this example, Harry is requesting resource access and is, therefore, the subject.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      218,
      215,
      228,
      213
    ],
    "source": ""
  },
  {
    "id": 2205,
    "question": "Michael is responsible for forensic investigations and is investigating a medium-severity security incident that involved the defacement of a corporate website. The web server in question ran on a virtualization platform, and the marketing team would like to get the website up and running as quickly as possible. <br>What would be the most reasonable next step for Michael to take?",
    "choice_a": "Keep the website offline until the investigation is complete.",
    "choice_b": "Take the virtualization platform offline as evidence.",
    "choice_c": "Take a snapshot of the compromised system and use that for the investigation.",
    "choice_d": "Ignore the incident and focus on quickly restoring the website.",
    "correct_answer": "C",
    "explanation": "Michael should conduct his investigation, but there is a pressing business need to bring the website back online. The most reasonable course of action would be to take a snapshot of the compromised system and use the snapshot for the investigation, restoring the website to operation as quickly as possible while using the results of the investigation to improve the security of the site.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      215,
      228,
      211,
      305
    ],
    "source": ""
  },
  {
    "id": 2206,
    "question": "Helen is a software engineer and is developing code that she would like to restrict to running within an isolated sandbox for security purposes. <br>What software development technique is Helen using?",
    "choice_a": "Bounds",
    "choice_b": "Input validation",
    "choice_c": "Confinement",
    "choice_d": "TCB",
    "correct_answer": "C",
    "explanation": "Using a sandbox is an example of confinement, where the system restricts the access of a particular process to limit its ability to affect other processes running on the same system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      248,
      289,
      211,
      213
    ],
    "source": ""
  },
  {
    "id": 2207,
    "question": "What concept describes the degree of confidence that an organization has that its controls satisfy security requirements?",
    "choice_a": "Trust",
    "choice_b": "Credentialing",
    "choice_c": "Verification",
    "choice_d": "Assurance",
    "correct_answer": "D",
    "explanation": "Assurance is the degree of confidence that an organization has that its security controls are correctly implemented. It must be continually monitored and reverified.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      213,
      221,
      228,
      215,
      211
    ],
    "source": ""
  },
  {
    "id": 2208,
    "question": "What type of security vulnerability are developers most likely to introduce into code when they seek to facilitate their own access, for testing purposes, to software they developed?",
    "choice_a": "Maintenance hook",
    "choice_b": "Cross-site scripting",
    "choice_c": "SQL injection",
    "choice_d": "Buffer overflow",
    "correct_answer": "A",
    "explanation": "Maintenance hooks, otherwise known as backdoors, provide developers with easy access to a system, bypassing normal security controls. If not removed prior to finalizing code, they pose a significant security vulnerability if an attacker discovers the maintenance hook.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      294,
      292,
      213,
      204,
      293
    ],
    "source": ""
  },
  {
    "id": 2209,
    "question": "In the figure shown here, Sally is blocked from reading the file due to the Biba integrity model. Sally has a Secret security clearance, and the file has a Confidential classification. <br><img src=\"/question_assets/CISSP/3_image2.png\"/><br>What principle of the Biba model is being enforced?",
    "choice_a": "Simple Security Property",
    "choice_b": "Simple Integrity Property",
    "choice_c": "*-Security Property",
    "choice_d": "*-Integrity Property",
    "correct_answer": "B",
    "explanation": "The Simple Integrity Property states that an individual may not read a file classified at a lower security level than the individual's security clearance.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      229,
      228,
      219,
      215
    ],
    "source": ""
  },
  {
    "id": 2210,
    "question": "Tom is responsible for maintaining the security of systems used to control industrial processes located within a power plant. <br>What term is used to describe these systems?",
    "choice_a": "POWER",
    "choice_b": "SCADA",
    "choice_c": "HAVAL",
    "choice_d": "COBOL",
    "correct_answer": "B",
    "explanation": "Supervisory control and data acquisition (SCADA) systems are used to control and gather data from industrial processes. They are commonly found in power plants and other industrial environments.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      253,
      301,
      260,
      263,
      324
    ],
    "source": ""
  },
  {
    "id": 2211,
    "question": "Sonia recently removed an encrypted hard drive from a laptop and moved it to a new device because of a hardware failure. She is having difficulty accessing encrypted content on the drive despite the fact that she knows the user's password. <br>What hardware security feature is likely causing this problem?",
    "choice_a": "TCB",
    "choice_b": "TPM",
    "choice_c": "NIACAP",
    "choice_d": "RSA",
    "correct_answer": "B",
    "explanation": "The Trusted Platform Module (TPM) is a hardware security technique that stores an encryption key on a chip on the motherboard and prevents someone from accessing an encrypted drive by installing it in another computer.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      185,
      291,
      215,
      243,
      228
    ],
    "source": ""
  },
  {
    "id": 2212,
    "question": "Chris wants to verify that a software package that he downloaded matches the original version. <br>What hashing tool should he use if he believes that technically sophisticated attackers may have replaced the software package with a version containing a backdoor?",
    "choice_a": "MD5",
    "choice_b": "3DES",
    "choice_c": "SHA1",
    "choice_d": "SHA 256",
    "correct_answer": "D",
    "explanation": "Intentional collisions have been created with MD5, and a real-world collision attack against SHA 1 was announced in early 2017. 3DES is not a hashing tool, leaving SHA 256 (sometimes called SHA 2) as the only real choice that Chris has in this list.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      173,
      174,
      155,
      199,
      197
    ],
    "source": ""
  },
  {
    "id": 2213,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>If Alice wants to send Bob a message that is encrypted for confidentiality, what key does she use to encrypt the message?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "C",
    "explanation": "In an asymmetric cryptosystem, the sender of a message encrypts the message using the recipient's public key. The recipient may then decrypt that message using their own private key, which only they should possess.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      200,
      176,
      167,
      154,
      198
    ],
    "source": ""
  },
  {
    "id": 2214,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When Bob receives the encrypted message from Alice, what key does he use to decrypt the message's plaintext content?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "D",
    "explanation": "When Bob receives the message, he uses his own private key to decrypt it. Since he is the only one with his private key, he is the only one who should be able to decrypt it, thus preserving confidentiality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      176,
      200,
      167,
      198,
      154
    ],
    "source": ""
  },
  {
    "id": 2215,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>Which one of the following keys would Bob not possess in this scenario?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "B",
    "explanation": "Each user retains their private key as secret information. In this scenario, Bob would only have access to his own private key and would not have access to the private key of Alice or any other user.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      167,
      176,
      198,
      183,
      179
    ],
    "source": ""
  },
  {
    "id": 2216,
    "question": "Alice and Bob would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>Alice would also like to digitally sign the message that she sends to Bob. <br>What key should she use to create the digital signature?",
    "choice_a": "Alice's public key",
    "choice_b": "Alice's private key",
    "choice_c": "Bob's public key",
    "choice_d": "Bob's private key",
    "correct_answer": "B",
    "explanation": "Alice creates the digital signature using her own private key. Then Bob, or any other user, can verify the digital signature using Alice's public key.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      176,
      200,
      175,
      154,
      198
    ],
    "source": ""
  },
  {
    "id": 2217,
    "question": "What name is given to the random value added to a password in an attempt to defeat rainbow table attacks?",
    "choice_a": "Hash",
    "choice_b": "Salt",
    "choice_c": "Extender",
    "choice_d": "Rebar",
    "correct_answer": "B",
    "explanation": "The salt is a random value added to a password before it is hashed by the operating system. The salt is then stored in a password file with the hashed password. This increases the complexity of cryptanalytic attacks by negating the usefulness of attacks that use precomputed hash values, such as rainbow tables.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      199,
      994,
      172,
      173
    ],
    "source": ""
  },
  {
    "id": 2218,
    "question": "Which one of the following is not an attribute of a hashing algorithm?",
    "choice_a": "They require a cryptographic key.",
    "choice_b": "They are irreversible.",
    "choice_c": "It is very difficult to find two messages with the same hash value.",
    "choice_d": "They take variable-length input.",
    "correct_answer": "A",
    "explanation": "Hash functions do not include any element of secrecy and, therefore, do not require a cryptographic key.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      172,
      155,
      152,
      199,
      146
    ],
    "source": ""
  },
  {
    "id": 2219,
    "question": "What type of fire suppression system fills with water after a valve opens when the initial stages of a fire are detected and then requires a sprinkler head heat activation before dispensing water?",
    "choice_a": "Wet pipe",
    "choice_b": "Dry pipe",
    "choice_c": "Deluge",
    "choice_d": "Preaction",
    "correct_answer": "D",
    "explanation": "A preaction fire suppression system activates in two steps. The pipes fill with water once the early signs of a fire are detected. The system does not dispense water until heat sensors on the sprinkler heads trigger the second phase.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      314,
      710,
      709,
      326
    ],
    "source": ""
  },
  {
    "id": 2220,
    "question": "Susan would like to configure IPsec in a manner that provides confidentiality for the content of packets. <br>What component of IPsec provides this capability?",
    "choice_a": "AH",
    "choice_b": "ESP",
    "choice_c": "IKE",
    "choice_d": "ISAKMP",
    "correct_answer": "B",
    "explanation": "The Encapsulating Security Payload (ESP) protocol provides confidentiality and integrity for packet contents. It encrypts packet payloads and provides limited authentication and protection against replay attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      189,
      145,
      164,
      153,
      195
    ],
    "source": ""
  },
  {
    "id": 2221,
    "question": "Which one of the following cryptographic goals protects against the risks posed when a device is lost or stolen?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Authentication",
    "choice_c": "Integrity",
    "choice_d": "Confidentiality",
    "correct_answer": "D",
    "explanation": "The greatest risk when a device is lost or stolen is that sensitive data contained on the device will fall into the wrong hands. Confidentiality protects against this risk. Nonrepudiation is when the recipient of a message can prove the originator's identity to a third party. Authentication is a means of proving one's identity. Integrity demonstrates that information has not been modified since transmission.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      164,
      185,
      275,
      324
    ],
    "source": ""
  },
  {
    "id": 2222,
    "question": "Joanna wants to review the status of the industrial control systems her organization uses for building control. <br>What type of systems should she inquire about access to?",
    "choice_a": "SCADA",
    "choice_b": "DSS",
    "choice_c": "BAS",
    "choice_d": "ICS-CSS",
    "correct_answer": "A",
    "explanation": "Supervisory Control and Data Acquisition systems, or SCADA systems, provide a graphical interface to monitor industrial control systems (ICS). Joanna should ask about access to her organization's SCADA systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      253,
      301,
      299,
      263,
      258
    ],
    "source": ""
  },
  {
    "id": 2223,
    "question": "In the figure shown here, Harry's request to write to the data file is blocked. Harry has a Secret security clearance, and the data file has a Confidential classification. <br><img src=\"/question_assets/CISSP/3_image3.png\"/><br>What principle of the Bell-LaPadula model blocked this request?",
    "choice_a": "Simple Security Property",
    "choice_b": "Simple Integrity Property",
    "choice_c": "*-Security Property",
    "choice_d": "Discretionary Security Property",
    "correct_answer": "C",
    "explanation": "The *-Security Property states that an individual may not write to a file at a lower classification level than that of the individual. This is also known as the confinement property.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      228,
      215,
      218,
      219
    ],
    "source": ""
  },
  {
    "id": 2224,
    "question": "Florian and Tobias would like to begin communicating using a symmetric cryptosystem, but they have no prearranged secret and are not able to meet in person to exchange keys. <br>What algorithm can they use to securely exchange the secret key?",
    "choice_a": "IDEA",
    "choice_b": "Diffie-Hellman",
    "choice_c": "RSA",
    "choice_d": "MD5",
    "correct_answer": "B",
    "explanation": "The Diffie-Hellman algorithm allows for the secure exchange of symmetric encryption keys over a public network. IDEA and RSA are encryption algorithms. MD5 is a hashing function.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      169,
      184,
      161,
      154,
      165
    ],
    "source": ""
  },
  {
    "id": 2225,
    "question": "Carl's organization recently underwent a user access review. At the conclusion of the review, the auditors noted several cases of privilege creep. <br>What security principle was violated?",
    "choice_a": "Fail securely",
    "choice_b": "Keep it simple",
    "choice_c": "Trust but verify",
    "choice_d": "Least privilege",
    "correct_answer": "D",
    "explanation": "The principle of least privilege says that an employee should have only the minimum necessary privileges required to perform their jobs. Privilege creep indicates that an employee has accumulated permissions that they no longer require, indicating a violation of the least privilege principle. The trust but verify principle says that organizations should use auditing to ensure that control objectives are met. The fail securely principle says that security controls should default to a secure state in the event of a control failure. The keep it simple principle says that security controls and other technologies should remain as simple as possible while still completing their objectives.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      715,
      717,
      208,
      204,
      201
    ],
    "source": ""
  },
  {
    "id": 2226,
    "question": "Matt's organization recently adopted a zero-trust network architecture. <br>Under this approach, which one of the following criteria would be LEAST appropriate to use when granting a subject access to resources?",
    "choice_a": "Password",
    "choice_b": "Two-factor authentication",
    "choice_c": "IP address",
    "choice_d": "Biometric scan",
    "correct_answer": "C",
    "explanation": "In a zero-trust network architecture, access control decisions should never be made based upon a system's location on the network. Therefore, an IP address should never be used and would be the least appropriate of these options. While the other options have differing levels of security (two-factor authentication is clearly stronger than a password or biometrics alone), they do not violate the principles of a zero-trust network architecture.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      207,
      208,
      213,
      201,
      215
    ],
    "source": ""
  },
  {
    "id": 2227,
    "question": "Colin is the chief privacy officer for a nonprofit organization and is assisting with the team's transition to a Privacy by Design approach. <br>Which of the following principles is not a component of this approach?",
    "choice_a": "Proactive, not reactive",
    "choice_b": "Privacy as the default setting",
    "choice_c": "End-to-end security",
    "choice_d": "Defense in depth",
    "correct_answer": "D",
    "explanation": "While defense in depth is a strong security principle, it is not a component of Privacy by Design. The following are the seven principles of the Privacy by Design model. <br><ol><li>Proactive, not reactive; preventive, not remedial </li><li>Privacy as the default setting </li><li>Privacy embedded into design </li><li>Full functionality\u2014positive-sum, not zero-sum </li><li>End-to-end security\u2014full lifecycle protection </li><li>Visibility and transparency\u2014keep it open </li><li>Respect for user privacy\u2014keep it user-centric.</li></ol>",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      209,
      227,
      206,
      230,
      226
    ],
    "source": ""
  },
  {
    "id": 2228,
    "question": "What cryptographic principle stands behind the idea that cryptographic algorithms should be open to public inspection?",
    "choice_a": "Security through obscurity",
    "choice_b": "Kerckhoffs' principle",
    "choice_c": "Defense in depth",
    "choice_d": "Heisenburg principle",
    "correct_answer": "B",
    "explanation": "Kerckhoffs' principle says that a cryptographic system should be secure even if everything about the system, except the key, is public knowledge.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      146,
      152,
      203,
      151,
      202
    ],
    "source": ""
  },
  {
    "id": 2229,
    "question": "Ryan is developing a physical access plan for his organization's data center and wants to implement the security control indicated by the arrow in this diagram. <br><img src=\"/question_assets/CISSP/3_image4.png\"/><br>What is the name of this control?",
    "choice_a": "Mantrap",
    "choice_b": "Turnstile",
    "choice_c": "Intrusion prevention system",
    "choice_d": "Portal",
    "correct_answer": "A",
    "explanation": "Mantraps use two sets of doors to control access to a facility. This may be used to prevent piggybacking by monitoring use of the mantrap to allow only a single individual to enter a facility at a time. They may also be used to allow manual inspection of individuals or perform other security screening. Mantraps are also commonly known as access control vestibules.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      308,
      325,
      320,
      321,
      327
    ],
    "source": ""
  },
  {
    "id": 2230,
    "question": "Which one of the following does not describe a standard physical security requirement for wiring closets?",
    "choice_a": "Place only in areas monitored by security guards.",
    "choice_b": "Do not store flammable items in the closet.",
    "choice_c": "Use sensors on doors to log entries.",
    "choice_d": "Perform regular inspections of the closet.",
    "correct_answer": "A",
    "explanation": "While it would be ideal to have wiring closets in a location where they are monitored by security staff, this is not feasible in most environments. Wiring closets must be distributed geographically in multiple locations across each building used by an organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      307,
      328,
      324,
      308,
      321
    ],
    "source": ""
  },
  {
    "id": 2231,
    "question": "In the figure shown here, Sally is blocked from writing to the data file by the Biba integrity model. Sally has a Secret security clearance, and the file is classified Top Secret. <br><img src=\"/question_assets/CISSP/3_image5.png\"/><br>What principle is preventing her from writing to the file?",
    "choice_a": "Simple Security Property",
    "choice_b": "Simple Integrity Property",
    "choice_c": "*-Security Property",
    "choice_d": "*-Integrity Property",
    "correct_answer": "D",
    "explanation": "The *-Integrity Property states that a subject cannot modify an object at a higher integrity level than that possessed by the subject.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      228,
      219,
      215,
      201
    ],
    "source": ""
  },
  {
    "id": 2232,
    "question": "Lana recently implemented a new process in her organization where managers who are responsible for granting users access to a system are not permitted to participate in access reviews. <br>What principle is she enforcing?",
    "choice_a": "Two-person control",
    "choice_b": "Least privilege",
    "choice_c": "Privilege creep",
    "choice_d": "Separation of duties",
    "correct_answer": "D",
    "explanation": "The separation of duties principle says that no employee should have permission to perform two tasks that, when combined, would pose a security risk. In this situation, an employee auditing their own work would create a conflict of interest, so Lana has implemented a separation of duties. Two-person control is closely related, but it requires that two different employees approve an action. If she required that two managers approve new accounts, that would be an example of two-person control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      219,
      220,
      712,
      713,
      715
    ],
    "source": ""
  },
  {
    "id": 2233,
    "question": "Which of the following statements about system development are correct? (Select all that apply.)",
    "choice_a": "Systems should be designed to operate in a secure manner if the user performs no other configuration.",
    "choice_b": "Systems should be designed to fall back to a secure state if they experience an error.",
    "choice_c": "Systems should be designed to incorporate security as a design feature.",
    "choice_d": "Systems should be designed in a manner that keeps their functionality as simple as possible.",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "All of these statements are correct. The idea that systems should be designed to operate in a secure manner if the user performs no other configuration is the secure defaults principle. The idea that systems should be designed to fall back to a secure state if they experience an error is the fail securely principle. The idea that systems should be designed to incorporate security as a design feature is the security by design principle. The idea that systems should be designed in a manner that keeps their functionality as simple as possible is the keep it simple principle.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      227,
      211,
      204,
      205,
      206
    ],
    "source": ""
  },
  {
    "id": 2234,
    "question": "Alan is reviewing a system that has been assigned the EAL1 evaluation assurance level under the Common Criteria. <br>What is the degree of assurance that he may have about the system?",
    "choice_a": "It has been functionally tested.",
    "choice_b": "It has been structurally tested.",
    "choice_c": "It has been formally verified, designed, and tested.",
    "choice_d": "It has been methodically designed, tested, and reviewed.",
    "correct_answer": "A",
    "explanation": "EAL1 assurance applies when the system in question has been functionally tested. It is the lowest level of assurance under the Common Criteria.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      228,
      223,
      215,
      292
    ],
    "source": ""
  },
  {
    "id": 2235,
    "question": "Jake works for a research organization that is seeking to deploy a grid computing system that will perform cycle scavenging on user workstations to conduct research tasks that require high-performance computing. <br>What is the most significant risk associated with this operation?",
    "choice_a": "Data confidentiality",
    "choice_b": "Isolation breach",
    "choice_c": "Data integrity",
    "choice_d": "Data availability",
    "correct_answer": "B",
    "explanation": "The system can be designed in a manner that protects the confidentiality, integrity, and availability of data. The research workstations included in the grid are from internal users, minimizing the risk of distributing the data. However, an isolation breach in the distributed computing client could be catastrophic, allowing someone who compromises the controller to assume control of every device in the organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      255,
      251,
      256,
      215,
      207
    ],
    "source": ""
  },
  {
    "id": 2236,
    "question": "Eimear's software development team uses an approach that creates many discrete software objects and then binds them together using APIs. <br>What term best describes this architecture?",
    "choice_a": "Micro services",
    "choice_b": "Function-as-a-service",
    "choice_c": "Containerization",
    "choice_d": "Virtualization",
    "correct_answer": "A",
    "explanation": "This is an example of a micro services architecture. Each of the component micro services performs a discrete task and then communicates with other micro services using APIs. This might be accomplished using FaaS cloud computing, containerization, and/or virtualization, but there is no indication whether those services are being used in the scenario.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      298,
      270,
      265,
      211,
      226
    ],
    "source": ""
  },
  {
    "id": 2237,
    "question": "Adam recently configured permissions on an NTFS file system to describe the access that different users may have to a file by listing each user individually. <br>What did Adam create?",
    "choice_a": "An access control list",
    "choice_b": "An access control entry",
    "choice_c": "Role-based access control",
    "choice_d": "Mandatory access control",
    "correct_answer": "A",
    "explanation": "Adam created a list of individual users who may access the file. This is an access control list, which consists of multiple access control entries. It includes the names of users, so it is not role-based, and Adam was able to modify the list, so it is not mandatory access control.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      214,
      201,
      215,
      213
    ],
    "source": ""
  },
  {
    "id": 2238,
    "question": "Betty is concerned about the use of buffer overflow attacks against a custom application developed for use in her organization. <br>What security control would provide the strongest defense against these attacks?",
    "choice_a": "Firewall",
    "choice_b": "Intrusion detection system",
    "choice_c": "Parameter checking",
    "choice_d": "Vulnerability scanning",
    "correct_answer": "C",
    "explanation": "Parameter checking, or input validation, is used to ensure that input provided by users to an application matches the expected parameters for the application. Developers may use parameter checking to ensure that input does not exceed the expected length, preventing a buffer overflow attack.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      211,
      224,
      228,
      262,
      281
    ],
    "source": ""
  },
  {
    "id": 2239,
    "question": "Which one of the following combinations of controls best embodies the defense in depth principle?",
    "choice_a": "Encryption of email and network intrusion detection",
    "choice_b": "Cloud access security brokers (CASB) and security awareness training",
    "choice_c": "Data loss prevention and multifactor authentication",
    "choice_d": "Network firewall and host firewall",
    "correct_answer": "D",
    "explanation": "The defense-in-depth principle suggests using multiple overlapping security controls to achieve the same control objective. Network and host firewalls are both designed to limit network traffic and therefore are an example of defense in depth. The encryption of email and network intrusion detection are unrelated controls and do not satisfy the same objective. The same is true for the combination of CASB and security awareness training and the combination of DLP and multifactor authentication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      263,
      206,
      215,
      201,
      145
    ],
    "source": ""
  },
  {
    "id": 2240,
    "question": "James is working with a Department of Defense system that is authorized to simultaneously handle information classified at the Secret and Top Secret levels. <br>What type of system is he using?",
    "choice_a": "Single state",
    "choice_b": "Unclassified",
    "choice_c": "Compartmented",
    "choice_d": "Multistate",
    "correct_answer": "D",
    "explanation": "Multistate systems are certified to handle data from different security classifications simultaneously by implementing protection mechanisms that segregate data appropriately.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      228,
      292,
      213,
      216,
      225
    ],
    "source": ""
  },
  {
    "id": 2241,
    "question": "Kyle is being granted access to a military computer system that uses System High mode. <br>What is not true about Kyle's security clearance requirements?",
    "choice_a": "Kyle must have a clearance for the highest level of classification processed by the system, regardless of his access.",
    "choice_b": "Kyle must have access approval for all information processed by the system.",
    "choice_c": "Kyle must have a valid need to know for all information processed by the system.",
    "choice_d": "Kyle must have a valid security clearance.",
    "correct_answer": "C",
    "explanation": "For systems running in System High mode, the user must have a valid security clearance for all information processed by the system, access approval for all information processed by the system, and a valid need to know for some, but not necessarily all, information processed by the system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      228,
      215,
      222,
      213,
      201
    ],
    "source": ""
  },
  {
    "id": 2242,
    "question": "Gary intercepts a communication between two individuals and suspects that they are exchanging secret messages. The content of the communication appears to be the image shown here. <br>What type of technique may the individuals use to hide messages inside this image?<br><img src=\"/question_assets/CISSP/3_image6.png\"/>",
    "choice_a": "Visual cryptography",
    "choice_b": "Steganography",
    "choice_c": "Cryptographic hashing",
    "choice_d": "Transport layer security",
    "correct_answer": "B",
    "explanation": "Steganography is the art of using cryptographic techniques to embed secret messages within other content. Some steganographic algorithms work by making alterations to the least significant bits of the many bits that make up image files.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      188,
      145,
      149,
      172,
      175
    ],
    "source": ""
  },
  {
    "id": 2243,
    "question": "Philip is developing a new security tool that will be used by individuals in many different subsidiaries of his organization. He chooses to use Docker to deploy the tool to simplify configuration. <br>What term best describes this approach?",
    "choice_a": "Virtualization",
    "choice_b": "Abstraction",
    "choice_c": "Simplification",
    "choice_d": "Containerization",
    "correct_answer": "D",
    "explanation": "All of these terms accurately describe this use of technology. However, the use of Docker is best described as a containerization technology, so this is the best possible answer choice.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      274,
      230,
      211,
      226,
      264
    ],
    "source": ""
  },
  {
    "id": 2244,
    "question": "In the ring protection model shown here, what ring contains the operating system's kernel?<br><img src=\"/question_assets/CISSP/3_image7.png\"/>",
    "choice_a": "Ring 0",
    "choice_b": "Ring 1",
    "choice_c": "Ring 2",
    "choice_d": "Ring 3",
    "correct_answer": "A",
    "explanation": "The kernel lies within the central ring, Ring 0. Conceptually, Ring 1 contains other operating system components. Ring 2 is used for drivers and protocols. User-level programs and applications run at Ring 3. Rings 0 through 2 run in privileged mode while Ring 3 runs in user mode. It is important to note that many modern operating systems do not fully implement this model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      719,
      718,
      236,
      720,
      215
    ],
    "source": ""
  },
  {
    "id": 2245,
    "question": "In an infrastructure as a service (IaaS) environment where a vendor supplies a customer with access to storage services, who is normally responsible for removing sensitive data from drives that are taken out of service?",
    "choice_a": "Customer's security team",
    "choice_b": "Customer's storage team",
    "choice_c": "Customer's vendor management team",
    "choice_d": "Vendor",
    "correct_answer": "D",
    "explanation": "In an infrastructure as a service environment, security duties follow a shared responsibility model. Since the vendor is responsible for managing the storage hardware, the vendor would retain responsibility for destroying or wiping drives as they are taken out of service. However, it is still the customer's responsibility to validate that the vendor's sanitization procedures meet their requirements prior to utilizing the vendor's storage services.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      226,
      311,
      328,
      213
    ],
    "source": ""
  },
  {
    "id": 2246,
    "question": "During a system audit, Casey notices that the private key for her organization's web server has been stored in a public Amazon S3 storage bucket for more than a year. <br>Which one of the following actions should she take first?",
    "choice_a": "Remove the key from the bucket.",
    "choice_b": "Notify all customers that their data may have been exposed.",
    "choice_c": "Request a new certificate using a new key.",
    "choice_d": "Nothing, because the private key should be accessible for validation.",
    "correct_answer": "C",
    "explanation": "The first thing Casey should do is notify her management, but after that, replacing the certificate and using proper key management practices with the new certificate's key should be at the top of her list.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      721,
      183,
      181,
      187,
      198
    ],
    "source": ""
  },
  {
    "id": 2247,
    "question": "Which one of the following systems assurance processes provides an independent third-party evaluation of a system's controls that may be trusted by many different organizations?",
    "choice_a": "Certification",
    "choice_b": "Definition",
    "choice_c": "Verification",
    "choice_d": "Accreditation",
    "correct_answer": "C",
    "explanation": "The verification process is similar to the certification process in that it validates security controls. Verification may go a step further by involving a third-party testing service and compiling results that may be trusted by many different organizations. Accreditation is the act of management formally accepting an evaluating system, not evaluating the system itself.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      223,
      228,
      226,
      222
    ],
    "source": ""
  },
  {
    "id": 2248,
    "question": "Darcy's organization is deploying serverless computing technology to better meet the needs of developers and users. In a serverless model, who is normally responsible for configuring operating system security controls?",
    "choice_a": "Software developer",
    "choice_b": "Cyber security professional",
    "choice_c": "Cloud architect",
    "choice_d": "Vendor",
    "correct_answer": "D",
    "explanation": "In a serverless computing model, the vendor does not expose details of the operating system to its customers. Therefore, the vendor retains full responsibility for configuring it securely under the shared responsibility model of cloud computing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      211,
      226,
      213,
      215
    ],
    "source": ""
  },
  {
    "id": 2249,
    "question": "Harold is assessing the susceptibility of his environment to hardware failures and would like to identify the expected lifetime of a piece of hardware. <br>What measure should he use for this?",
    "choice_a": "MTTR",
    "choice_b": "MTTF",
    "choice_c": "RTO",
    "choice_d": "MTO",
    "correct_answer": "B",
    "explanation": "The mean time to failure (MTTF) provides the average amount of time before a device of that particular specification fails.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      262,
      243,
      324,
      256
    ],
    "source": ""
  },
  {
    "id": 2250,
    "question": "Chris is designing a cryptographic system for use within his company. The company has 1,000 employees, and they plan to use an asymmetric encryption system. They would like the system to be set up so that any pair of arbitrary users may communicate privately. <br>How many total keys will they need?",
    "choice_a": "500",
    "choice_b": "1000",
    "choice_c": "2000",
    "choice_d": "4950",
    "correct_answer": "C",
    "explanation": "Asymmetric cryptosystems use a pair of keys for each user. In this case, with 1,000 users, the system will require 2,000 keys.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      167,
      183,
      165,
      152
    ],
    "source": ""
  },
  {
    "id": 2251,
    "question": "Gary is concerned about applying consistent security settings to the many mobile devices used throughout his organization. <br>What technology would best assist with this challenge?",
    "choice_a": "MDM",
    "choice_b": "IPS",
    "choice_c": "IDS",
    "choice_d": "SIEM",
    "correct_answer": "A",
    "explanation": "Mobile Device Management (MDM) products provide a consistent, centralized interface for applying security configuration settings to mobile devices.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      277,
      281,
      285,
      283,
      284
    ],
    "source": ""
  },
  {
    "id": 2252,
    "question": "Alice sent a message to Bob. Bob would like to demonstrate to Charlie that the message he received definitely came from Alice. <br>What goal of cryptography is Bob attempting to achieve?",
    "choice_a": "Authentication",
    "choice_b": "Confidentiality",
    "choice_c": "Nonrepudiation",
    "choice_d": "Integrity",
    "correct_answer": "C",
    "explanation": "Nonrepudiation occurs when the recipient of a message is able to demonstrate to a third party that the message came from the purported sender.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      145,
      198,
      200,
      177
    ],
    "source": ""
  },
  {
    "id": 2253,
    "question": "Rhonda is considering the use of new identification cards for physical access control in her organization. She comes across a military system that uses the card shown here. <br><img src=\"/question_assets/CISSP/3_image8.png\"/><br>What type of card is this?",
    "choice_a": "Smart card",
    "choice_b": "Proximity card",
    "choice_c": "Magnetic stripe card",
    "choice_d": "Phase three card",
    "correct_answer": "A",
    "explanation": "The card shown in the image has a smart chip underneath the American flag. Therefore, it is an example of a smart card. This is the most secure type of identification card technology.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      305,
      321,
      324,
      319,
      318
    ],
    "source": ""
  },
  {
    "id": 2254,
    "question": "Gordon is concerned about the possibility that hackers may be able to use the Van Eck radiation phenomenon to remotely read the contents of computer monitors in a restricted work area within his facility. <br>What technology would protect against this type of attack?",
    "choice_a": "TCSEC",
    "choice_b": "SCSI",
    "choice_c": "GHOST",
    "choice_d": "TEMPEST",
    "correct_answer": "D",
    "explanation": "The TEMPEST program creates technology that is not susceptible to Van Eck phreaking attacks because it reduces or suppresses natural electromagnetic emanations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      300,
      311,
      324,
      208
    ],
    "source": ""
  },
  {
    "id": 2255,
    "question": "Jorge believes that an attacker has obtained the hash of the Kerberos service account from one of his organization's Active Directory servers. <br>What type of attack would this enable?",
    "choice_a": "Golden ticket",
    "choice_b": "Kerberoasting",
    "choice_c": "Pass the ticket",
    "choice_d": "Brute force",
    "correct_answer": "A",
    "explanation": "Golden ticket attacks use the hash of the Kerberos service account to create tickets in an Active Directory environment. Kerberoasting attacks rely on collected TGS tickets. Pass the ticket attacks rely on tickets harvested from the lsass process. Brute-force attacks depend on random guessing without any additional information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      172,
      195,
      199,
      145
    ],
    "source": ""
  },
  {
    "id": 2256,
    "question": "Sherry conducted an inventory of the cryptographic technologies in use within her organization and found the following algorithms and protocols in use. <br>Which one of these technologies should she replace because it is no longer considered secure?",
    "choice_a": "MD5",
    "choice_b": "AES",
    "choice_c": "PGP",
    "choice_d": "WPA3",
    "correct_answer": "A",
    "explanation": "The MD5 hash algorithm has known collisions and, as of 2005, is no longer considered secure for use in modern environments. The AES, PGP, and WPA3 algorithms are all still considered secure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      174,
      155,
      173,
      157,
      158
    ],
    "source": ""
  },
  {
    "id": 2257,
    "question": "Robert is investigating a security breach and discovers the Mimikatz tool installed on a system in his environment. <br>What type of attack has likely taken place?",
    "choice_a": "Password cracking",
    "choice_b": "Pass the hash",
    "choice_c": "MAC spoofing",
    "choice_d": "ARP poisoning",
    "correct_answer": "B",
    "explanation": "The use of the Mimikatz tool is indicative of an attempt to capture user password hashes for use in a pass-the-hash attack against Microsoft Active Directory accounts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      199,
      193,
      208,
      255,
      213
    ],
    "source": ""
  },
  {
    "id": 2258,
    "question": "Tom is a cryptanalyst and is working on breaking a cryptographic algorithm's secret key. He has a copy of an intercepted message that is encrypted, and he also has a copy of the decrypted version of that message. He wants to use both the encrypted message and its decrypted plaintext to retrieve the secret key for use in decrypting other messages. <br>What type of attack is Tom engaging in?",
    "choice_a": "Chosen ciphertext",
    "choice_b": "Chosen plaintext",
    "choice_c": "Known plaintext",
    "choice_d": "Brute force",
    "correct_answer": "C",
    "explanation": "In a known plaintext attack, the attacker has a copy of the encrypted message along with the plaintext message used to generate that ciphertext. In a chosen plaintext attack, the attacker has the ability to choose the plaintext to be encrypted. In a chosen ciphertext attack, the attacker can choose the ciphertext output. In a brute-force attack, the attacker simply tries all possible key combinations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      996,
      196,
      146,
      153,
      158
    ],
    "source": ""
  },
  {
    "id": 2259,
    "question": "A hacker recently violated the integrity of data in James's company by modifying a file using a precise timing attack. The attacker waited until James verified the integrity of a file's contents using a hash value and then modified the file between the time that James verified the integrity and read the contents of the file. <br>What type of attack took place?",
    "choice_a": "Social engineering",
    "choice_b": "TOCTOU",
    "choice_c": "Data diddling",
    "choice_d": "Parameter checking",
    "correct_answer": "B",
    "explanation": "In a time of check to time of use (TOCTOU) attack, the attacker exploits the difference in time between when a security control is verified and the data protected by the control is actually used.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      219,
      172,
      215,
      228,
      201
    ],
    "source": ""
  },
  {
    "id": 2260,
    "question": "Carl is deploying a set of video sensors that will be placed in remote locations as part of a research project. Due to connectivity limitations, he would like to perform as much image processing and computation as possible on the device itself before sending results back to the cloud for further analysis. <br>What computing model would best meet his needs?",
    "choice_a": "Serverless computing",
    "choice_b": "Edge computing",
    "choice_c": "IaaS computing",
    "choice_d": "SaaS computing",
    "correct_answer": "B",
    "explanation": "In this case, most cloud service models (including IaaS, SaaS, and serverless/FaaS) would require transmitting most information back to the cloud. The edge computing service model would be far more appropriate, as it places computing power at the sensor, minimizing the data that must be sent back to the cloud over limited connectivity network links.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      259,
      254,
      262,
      251,
      230
    ],
    "source": ""
  },
  {
    "id": 2261,
    "question": "What action can you take to prevent accidental data disclosure due to wear leveling on an SSD device before reusing the drive?",
    "choice_a": "Reformatting",
    "choice_b": "Disk encryption",
    "choice_c": "Degaussing",
    "choice_d": "Physical destruction",
    "correct_answer": "B",
    "explanation": "Encrypting data on SSD drives does protect against wear leveling. Disk formatting does not effectively remove data from any device. Degaussing is only effective for magnetic media. Physically destroying the drive would not permit reuse.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      239,
      185,
      328,
      244,
      279
    ],
    "source": ""
  },
  {
    "id": 2262,
    "question": "Johnson Widgets strictly limits access to total sales volume information, classifying it as a competitive secret. However, shipping clerks have unrestricted access to order records to facilitate transaction completion. A shipping clerk recently pulled all of the individual sales records for a quarter from the database and totaled them up to determine the total sales volume. <br>What type of attack occurred?",
    "choice_a": "Social engineering",
    "choice_b": "Inference",
    "choice_c": "Aggregation",
    "choice_d": "Data diddling",
    "correct_answer": "C",
    "explanation": "In an aggregation attack, individual(s) use their access to specific pieces of information to piece together a larger picture that they are not authorized to access.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      201,
      213,
      218,
      228,
      296
    ],
    "source": ""
  },
  {
    "id": 2263,
    "question": "What physical security control broadcasts false emanations constantly to mask the presence of true electromagnetic emanations from computing equipment?",
    "choice_a": "Faraday cage",
    "choice_b": "Copper-infused windows",
    "choice_c": "Shielded cabling",
    "choice_d": "White noise",
    "correct_answer": "D",
    "explanation": "While all of the controls mentioned protect against unwanted electromagnetic emanations, only white noise is an active control. White noise generates false emanations that effectively \"jam\" the true emanations from electronic equipment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      312,
      305,
      325,
      308
    ],
    "source": ""
  },
  {
    "id": 2264,
    "question": "In a software as a service cloud computing environment, who is normally responsible for ensuring that appropriate firewall controls are in place to protect the application?",
    "choice_a": "Customer's security team",
    "choice_b": "Vendor",
    "choice_c": "Customer's networking team",
    "choice_d": "Customer's infrastructure management team",
    "correct_answer": "B",
    "explanation": "In a software as a service environment, the customer has no access to any underlying infrastructure, so firewall management is a vendor responsibility under the cloud computing shared responsibility model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      210,
      263,
      265,
      226
    ],
    "source": ""
  },
  {
    "id": 2265,
    "question": "Alice has read permissions on an object, and she would like Bob to have those same rights. <br>Which one of the rules in the Take-Grant protection model would allow her to complete this operation?",
    "choice_a": "Create rule",
    "choice_b": "Remove rule",
    "choice_c": "Grant rule",
    "choice_d": "Take rule",
    "correct_answer": "C",
    "explanation": "The grant rule allows a subject to grant rights that it possesses on an object to another subject.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      228,
      217,
      219,
      201
    ],
    "source": ""
  },
  {
    "id": 2266,
    "question": "As part of his incident response process, Charles securely wipes the drive of a compromised machine and reinstalls the operating system (OS) from original media. Once he is done, he patches the machine fully and applies his organization's security templates before reconnecting the system to the network. Almost immediately after the system is returned to service, he discovers that it has reconnected to the same botnet it was part of before. <br>Where should Charles look for the malware that is causing this behavior?",
    "choice_a": "The operating system partition",
    "choice_b": "The system BIOS or firmware",
    "choice_c": "The system memory",
    "choice_d": "The installation media",
    "correct_answer": "B",
    "explanation": "The system Charles is remediating may have a firmware or BIOS infection, with malware resident on the system board. While uncommon, this type of malware can be difficult to find and remove. Since he used original media, it is unlikely that the malware came from the software vendor. Charles wiped the system partition, and the system would have been rebooted before being rebuilt, thus clearing system memory.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      291,
      262,
      215,
      294,
      222
    ],
    "source": ""
  },
  {
    "id": 2267,
    "question": "Lauren implements ASLR to help prevent system compromises. <br>What technique has she used to protect her system?",
    "choice_a": "Encryption",
    "choice_b": "Mandatory access control",
    "choice_c": "Memory address randomization",
    "choice_d": "Discretionary access control",
    "correct_answer": "C",
    "explanation": "Lauren has implemented address space layout randomization, a memory protection methodology that randomizes memory locations, which prevents attackers from using known address spaces and contiguous memory regions to execute code via overflow or stack smashing attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      224,
      720,
      236,
      290,
      238
    ],
    "source": ""
  },
  {
    "id": 2268,
    "question": "Alan intercepts an encrypted message and wants to determine what type of algorithm was used to create the message. He first performs a frequency analysis and notes that the frequency of letters in the message closely matches the distribution of letters in the English language. <br>What type of cipher was most likely used to create this message?",
    "choice_a": "Substitution cipher",
    "choice_b": "AES",
    "choice_c": "Transposition cipher",
    "choice_d": "3DES",
    "correct_answer": "C",
    "explanation": "This message was most likely encrypted with a transposition cipher. The use of a substitution cipher, a category that includes AES and 3DES, would change the frequency distribution so that it did not mirror that of the English language. This type of attack, where the attacker only has access to an encrypted message, is also known as a ciphertext-only attack.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      149,
      196,
      151,
      166,
      996
    ],
    "source": ""
  },
  {
    "id": 2270,
    "question": "Grace would like to implement application control technology in her organization. Users often need to install new applications for research and testing purposes, and she does not want to interfere with that process. At the same time, she would like to block the use of known malicious software. <br>What type of application control would be appropriate in this situation?",
    "choice_a": "Blacklisting",
    "choice_b": "Graylisting",
    "choice_c": "Whitelisting",
    "choice_d": "Bluelisting",
    "correct_answer": "A",
    "explanation": "The blacklisting approach to application control allows users to install any software they wish except for packages specifically identified by the administrator as prohibited. This would be an appropriate approach in a scenario where users should be able to install any non malicious software they wish to use.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      281,
      289,
      270,
      206,
      211
    ],
    "source": ""
  },
  {
    "id": 2271,
    "question": "Warren is designing a physical intrusion detection system for use in a sensitive media storage facility and wants to include technology that issues an alert if the communications lines for the alarm system are unexpectedly cut. <br>What technology would meet this requirement?",
    "choice_a": "Heartbeat sensor",
    "choice_b": "Emanation security",
    "choice_c": "Motion detector",
    "choice_d": "Faraday cage",
    "correct_answer": "A",
    "explanation": "Heartbeat sensors send periodic status messages from the alarm system to the monitoring center. The monitoring center triggers an alarm if it does not receive a status message for a prolonged period of time, indicating that communications were disrupted.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      310,
      327,
      309,
      311,
      302
    ],
    "source": ""
  },
  {
    "id": 2272,
    "question": "John and Gary are negotiating a business transaction, and John must demonstrate to Gary that he has access to a system. He engages in an electronic version of the \"magic door\" scenario shown here. <br><img src=\"/question_assets/CISSP/3_image9.png\"/><br>What technique is John using?",
    "choice_a": "Split-knowledge proof",
    "choice_b": "Zero-knowledge proof",
    "choice_c": "Logical proof",
    "choice_d": "Mathematical proof",
    "correct_answer": "B",
    "explanation": "In a zero-knowledge proof, one individual demonstrates to another that they can achieve a result that requires sensitive information without actually disclosing the sensitive information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      148,
      169,
      172,
      291,
      152
    ],
    "source": ""
  },
  {
    "id": 2273,
    "question": "After scanning all of the systems on his wireless network, Mike notices that one system is identified as an iOS device running a massively out-of-date version of Apple's mobile operating system. When he investigates further, he discovers that the device is an original iPad and that it cannot be updated to a current secure version of the operating system. <br>What would be the best option for handling this device?",
    "choice_a": "Retire or replace the device.",
    "choice_b": "Isolate the device on a dedicated wireless network.",
    "choice_c": "Install a firewall on the tablet.",
    "choice_d": "Reinstall the OS.",
    "correct_answer": "A",
    "explanation": "When operating system patches are no longer available for mobile devices, the best option is typically to retire or replace the device. Building isolated networks will not stop the device from being used for browsing or other purposes, which means it is likely to continue to be exposed to threats. Installing a firewall will not remediate the security flaws in the OS, although it may help somewhat. Finally, reinstalling the OS will not allow new updates or fix the root issue.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      275,
      282,
      262,
      208
    ],
    "source": ""
  },
  {
    "id": 2274,
    "question": "Tonya believes that an attacker was able to eavesdrop on legitimate HTTPS communications between her users and remote web servers by engaging in a DNS poisoning attack. After conducting DNS poisoning, what technique would an attacker likely use to conduct this eavesdropping?",
    "choice_a": "Man-in-the-middle",
    "choice_b": "Brute force",
    "choice_c": "Timing",
    "choice_d": "Meet-in-the-middle",
    "correct_answer": "A",
    "explanation": "In a man-in-the-middle attack, the attacker tricks the user into establishing a connection with the attacker. The attacker then establishes a connection to the legitimate server and relays communications between the two, eavesdropping on the contents. A meet-in-the-middle attack is an attack against cryptographic algorithms that use multiple rounds of encryption. There is no indication in the scenario that the attacker used an exhaustive brute-force attack or a specialized timing attack to achieve their goals.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      197,
      187,
      179,
      195,
      246
    ],
    "source": ""
  },
  {
    "id": 2275,
    "question": "Howard is choosing a cryptographic algorithm for his organization, and he would like to choose an algorithm that supports the creation of digital signatures. <br>Which one of the following algorithms would meet his requirement?",
    "choice_a": "RSA",
    "choice_b": "3DES",
    "choice_c": "AES",
    "choice_d": "Blowfish",
    "correct_answer": "A",
    "explanation": "Digital signatures are possible only when using an asymmetric encryption algorithm. Of the algorithms listed, only RSA is asymmetric and supports digital signature capabilities.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      154,
      168,
      176,
      178,
      200
    ],
    "source": ""
  },
  {
    "id": 2276,
    "question": "Laura is responsible for securing her company's web-based applications and wants to conduct an educational program for developers on common web application security vulnerabilities. <br>Where can she turn for a concise listing of the most common web application issues?",
    "choice_a": "CVE",
    "choice_b": "NSA",
    "choice_c": "OWASP",
    "choice_d": "CSA",
    "correct_answer": "C",
    "explanation": "The Open Web Application Security Project (OWASP) produces an annual list of the top ten web application security issues that developers and security professionals around the world rely upon for education and training purposes. The OWASP vulnerabilities form the basis for many web application security testing products.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      187,
      281,
      192,
      274,
      270
    ],
    "source": ""
  },
  {
    "id": 2277,
    "question": "The Bell-LaPadula and Biba models implement state machines in a fashion that uses what specific state machine model?",
    "choice_a": "Information flow",
    "choice_b": "Noninterference",
    "choice_c": "Cascading",
    "choice_d": "Feedback",
    "correct_answer": "A",
    "explanation": "The information flow model applies state machines to the flow of information. The Bell-LaPadula model applies the information flow model to confidentiality while the Biba model applies it to integrity.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      216,
      217,
      228,
      229,
      219
    ],
    "source": ""
  },
  {
    "id": 2278,
    "question": "During a third-party vulnerability scan and security test, Danielle's employer recently discovered that the embedded systems that were installed to manage her company's new buildings have a severe remote access vulnerability. The manufacturer has gone out of business, and there is no patch or update for the devices. <br>What should Danielle recommend that her employer do about the hundreds of devices that are vulnerable?",
    "choice_a": "Identify a replacement device model and replace every device.",
    "choice_b": "Turn off all of the devices.",
    "choice_c": "Move the devices to a secure and isolated network segment.",
    "choice_d": "Reverse engineer the devices and build an in-house patch.",
    "correct_answer": "C",
    "explanation": "The most reasonable choice presented is to move the devices to a secure and isolated network segment. This will allow the devices to continue to serve their intended function while preventing them from being compromised. All of the other scenarios either create major new costs or deprive her organization of the functionality that the devices were purchased to provide.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      263,
      262,
      208,
      305,
      215
    ],
    "source": ""
  },
  {
    "id": 2279,
    "question": "What type of motion detector senses changes in the electromagnetic fields in monitored areas?",
    "choice_a": "Infrared",
    "choice_b": "Wave pattern",
    "choice_c": "Capacitance",
    "choice_d": "Photoelectric",
    "correct_answer": "C",
    "explanation": "Capacitance motion detectors monitor the electromagnetic field in a monitored area, sensing disturbances that correspond to motion.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      327,
      309,
      240,
      262,
      263
    ],
    "source": ""
  },
  {
    "id": 2280,
    "question": "Mike has been tasked with preventing an outbreak of malware like Mirai, a botnet that targeted IP-based cameras and routers. <br>What type of systems should be protected in his organization?",
    "choice_a": "Servers",
    "choice_b": "SCADA",
    "choice_c": "Mobile devices",
    "choice_d": "Internet of Things (IoT) devices",
    "correct_answer": "D",
    "explanation": "Mirai targeted \"Internet of Things\" devices, including routers, cameras, and DVRs. As organizations bring an increasing number of devices like these into their corporate networks, protecting both internal and external targets from insecure, infrequently updated, and often vulnerable IoT devices is increasingly important.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      262,
      211,
      206,
      272
    ],
    "source": ""
  },
  {
    "id": 2281,
    "question": "Which one of the following statements is correct about the Biba model of access control?",
    "choice_a": "It addresses confidentiality and integrity.",
    "choice_b": "It addresses integrity and availability.",
    "choice_c": "It prevents covert channel attacks.",
    "choice_d": "It focuses on protecting objects from integrity threats.",
    "correct_answer": "D",
    "explanation": "The Biba model focuses only on protecting integrity and does not provide protection against confidentiality or availability threats. It also does not provide protection against covert channel attacks. The Biba model focuses on external threats and assumes that internal threats are addressed programmatically.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      229,
      228,
      219,
      293
    ],
    "source": ""
  },
  {
    "id": 2282,
    "question": "In Transport Layer Security, what type of key is used to encrypt the actual content of communications between a web server and a client?",
    "choice_a": "Ephemeral session key",
    "choice_b": "Client's public key",
    "choice_c": "Server's public key",
    "choice_d": "Server's private key",
    "correct_answer": "A",
    "explanation": "In TLS, both the server and the client communicate using an ephemeral symmetric session key. They exchange this key using asymmetric cryptography, but all encrypted content is protected using symmetric cryptography.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      187,
      184,
      153,
      165,
      169
    ],
    "source": ""
  },
  {
    "id": 2283,
    "question": "Beth would like to include technology in a secure area of her data center to protect against unwanted electromagnetic emanations. <br>What technology would assist her with this goal?",
    "choice_a": "Heartbeat sensor",
    "choice_b": "Faraday cage",
    "choice_c": "Piggybacking",
    "choice_d": "WPA2",
    "correct_answer": "B",
    "explanation": "A Faraday cage is a metal skin that prevents electromagnetic emanations from exiting. It is a rarely used technology because it is unwieldy and expensive, but it is quite effective at blocking unwanted radiation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      240,
      324,
      308,
      312,
      302
    ],
    "source": ""
  },
  {
    "id": 2284,
    "question": "In a virtualized computing environment, what component is responsible for enforcing separation between guest machines?",
    "choice_a": "Guest operating system",
    "choice_b": "Hypervisor",
    "choice_c": "Kernel",
    "choice_d": "Protection manager",
    "correct_answer": "B",
    "explanation": "The hypervisor is responsible for coordinating access to physical hardware and enforcing isolation between different virtual machines running on the same physical platform.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      267,
      268,
      290,
      212,
      274
    ],
    "source": ""
  },
  {
    "id": 2285,
    "question": "Rick is an application developer who works primarily in Python. He recently decided to evaluate a new service where he provides his Python code to a vendor who then executes it on their server environment. <br>What type of cloud computing environment is this service?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "CaaS",
    "correct_answer": "B",
    "explanation": "Cloud computing systems where the customer only provides application code for execution on a vendor-supplied computing platform are examples of platform as a service (PaaS) computing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      269,
      210,
      226,
      254
    ],
    "source": ""
  },
  {
    "id": 2286,
    "question": "A component failure in the primary HVAC system leads to a high temperature alarm in the data center that Kim manages. After resolving the issue, what should Kim consider to prevent future issues like this?",
    "choice_a": "A closed loop chiller",
    "choice_b": "Redundant cooling systems",
    "choice_c": "Swamp coolers",
    "choice_d": "Relocating the data center to a colder climate",
    "correct_answer": "B",
    "explanation": "A well-designed data center should have redundant systems and capabilities for each critical part of its infrastructure. That means that power, cooling, and network connectivity should all be redundant. Kim should determine how to ensure that a single system failure cannot take her data center offline.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      326,
      302,
      1027,
      313,
      205
    ],
    "source": ""
  },
  {
    "id": 2287,
    "question": "Tommy is planning to implement a power conditioning UPS for a rack of servers in his data center. <br>Which one of the following conditions will the UPS be unable to protect against if it persists for an extended period of time?",
    "choice_a": "Fault",
    "choice_b": "Blackout",
    "choice_c": "Sag",
    "choice_d": "Noise",
    "correct_answer": "B",
    "explanation": "UPSs are designed to protect against short-term power losses, such as power faults. When they conduct power conditioning, they are also able to protect against sags and noise. UPSs have limited-life batteries and are not able to maintain continuous operating during a sustained blackout.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      312,
      916,
      917,
      918,
      324
    ],
    "source": ""
  },
  {
    "id": 2288,
    "question": "Which one of the following humidity values is within the acceptable range for a data center operation?",
    "choice_a": "0 percent",
    "choice_b": "10 percent",
    "choice_c": "25 percent",
    "choice_d": "40 percent",
    "correct_answer": "D",
    "explanation": "Data center humidity should be maintained between 20 percent and 80 percent. Values below this range increase the risk of static electricity, while values above this range may generate moisture that damages equipment.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      313,
      326,
      308,
      324,
      315
    ],
    "source": ""
  },
  {
    "id": 2289,
    "question": "Kristen's organization suffered a ransomware infection and has lost access to critical business data. She is considering paying the ransom to regain access to her data. <br>Which of the following statements about this payment are correct?  (Select all that apply.)",
    "choice_a": "Payment of the ransom may be illegal.",
    "choice_b": "Payment of the ransom may result in further demands for payments.",
    "choice_c": "Payment of the ransom guarantees access to the decryption key.",
    "choice_d": "Payment of the ransom may cause a data breach.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Payment of a ransom often results in the release of a decryption key, but this is not guaranteed by any means. There is also no link between the payment of a ransom and a future data breach, as an attacker may choose to release confidential information regardless of whether the ransom was paid. Depending upon applicable jurisdictions, payment of a ransom may be illegal under corrupt practices laws or embargoes against terrorist organizations. For example, the U.S. Office of Foreign Assets Control (OFAC) issued an advisory in 2020 stating that ransom payments may violate sanctions. Payment of a ransom may also cause attackers to consider the victim a \"mark\" and demand future payments in exchange for continued access to their data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      208,
      222,
      201,
      228
    ],
    "source": ""
  },
  {
    "id": 2290,
    "question": "Alex's employer creates most of their work output as PDF files. Alex is concerned about limiting the audience for the PDF files to those individuals who have paid for them. <br>What technology can he use to most effectively control the access to and distribution of these files?",
    "choice_a": "EDM",
    "choice_b": "Encryption",
    "choice_c": "Digital signatures",
    "choice_d": "DRM",
    "correct_answer": "D",
    "explanation": "Alex can use digital rights management technology to limit use of the PDFs to paying customers. While DRM is rarely a perfect solution, in this case, it may fit his organization's needs. EDM is electronic dance music, which his customers may appreciate but which won't solve the problem. Encryption and digital signatures can help to keep the files secure and to prove who they came from but won't solve the rights management issue Alex is tackling.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1054,
      1056,
      175,
      154,
      213
    ],
    "source": ""
  },
  {
    "id": 2291,
    "question": "As part of his team's forensic investigation process, Matt signs out drives and other evidence from an evidence storage facility before working with them. <br>What type of documentation is he creating?",
    "choice_a": "Criminal",
    "choice_b": "Chain of custody",
    "choice_c": "Civil",
    "choice_d": "CYA",
    "correct_answer": "B",
    "explanation": "Matt is helping to maintain the chain of custody documentation for his electronic evidence. This can be important if his organization needs to prove that the digital evidence they handled has not been tampered with. A better process would involve more than one person to ensure that no tampering was possible.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      328,
      320,
      222,
      291
    ],
    "source": ""
  },
  {
    "id": 2292,
    "question": "Todd believes that a digital certificate used by his organization has been compromised and he wants to add it to the certificate revocation list (CRL). <br>What element of the certificate goes on the CRL?",
    "choice_a": "Serial number",
    "choice_b": "Public key",
    "choice_c": "Digital signature",
    "choice_d": "Private key",
    "correct_answer": "A",
    "explanation": "The certificate revocation list contains the serial numbers of digital certificates issued by a certificate authority that have later been revoked.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      937,
      181,
      722,
      179,
      180
    ],
    "source": ""
  },
  {
    "id": 2293,
    "question": "Alison is examining a digital certificate presented to her by her bank's website. <br>Which one of the following requirements is not necessary for her to trust the digital certificate?",
    "choice_a": "She knows that the server belongs to the bank.",
    "choice_b": "She trusts the certificate authority.",
    "choice_c": "She verifies that the certificate is not listed on a CRL.",
    "choice_d": "She verifies the digital signature on the certificate.",
    "correct_answer": "A",
    "explanation": "The point of the digital certificate is to prove to Alison that the server belongs to the bank, so she does not need to have this trust in advance. To trust the certificate, she must verify the CA's digital signature on the certificate, trust the CA, verify that the certificate is not listed on a CRL, and verify that the certificate contains the name of the bank.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      179,
      181,
      180,
      175,
      937
    ],
    "source": ""
  },
  {
    "id": 2294,
    "question": "Which one of the following is an example of a covert timing channel when used to exfiltrate information from an organization?",
    "choice_a": "Sending an electronic mail message",
    "choice_b": "Posting a file on a peer-to-peer file sharing service",
    "choice_c": "Typing with the rhythm of Morse code",
    "choice_d": "Writing data to a shared memory space",
    "correct_answer": "C",
    "explanation": "Covert channels use surreptitious communications' paths. Covert timing channels alter the use of a resource in a measurable fashion to exfiltrate information. If a user types using a specific rhythm of Morse code, this is an example of a covert timing channel. Someone watching or listening to the keystrokes could receive a secret message with no trace of the message left in logs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      293,
      300,
      216,
      995,
      228
    ],
    "source": ""
  },
  {
    "id": 2295,
    "question": "Which one of the following would be a reasonable application for the use of self-signed digital certificates?",
    "choice_a": "Digital commerce website",
    "choice_b": "Banking application",
    "choice_c": "Internal scheduling application",
    "choice_d": "Customer portal",
    "correct_answer": "C",
    "explanation": "Self-signed digital certificates should be used only for internal-facing applications, where the user base trusts the internally generated digital certificate.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      179,
      181,
      186,
      187,
      291
    ],
    "source": ""
  },
  {
    "id": 2296,
    "question": "Ron is investigating a security incident that took place at a highly secure government facility. He believes that encryption keys were stolen during the attack and finds evidence that the attackers used dry ice to freeze an encryption component. <br>What type of attack was likely attempted?",
    "choice_a": "Side channel attack",
    "choice_b": "Brute-force attack",
    "choice_c": "Timing attack",
    "choice_d": "Fault injection attack",
    "correct_answer": "D",
    "explanation": "In a fault injection attack, the attacker attempts to compromise the integrity of a cryptographic device by causing some type of external fault. For example, they might use high-voltage electricity, high or low temperature, or other factors to cause a malfunction that undermines the security of the device. Side-channel attacks seek to use information about system activity and retrieve information that is actively being encrypted. Brute-force attacks attempt every possible valid combination for a key or password. In a timing attack, the attacker measures precisely how long cryptographic operations take to complete, gaining information about the cryptographic process that may be used to undermine its security.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      194,
      995,
      195,
      291,
      262
    ],
    "source": ""
  },
  {
    "id": 2297,
    "question": "Gary wants to distribute a large file and prefers a peer-to-peer CDN. <br>Which of the following is the most common example of this type of technology?",
    "choice_a": "CloudFlare",
    "choice_b": "BitTorrent",
    "choice_c": "Amazon CloudFront",
    "choice_d": "Akamai Edge",
    "correct_answer": "B",
    "explanation": "BitTorrent is an example of a peer-to-peer (P2P) content delivery network. It is commonly used for legitimate purposes to distribute large files like Linux ISOs and other freely distributed software packages and files in addition to its less legitimate uses. CloudFlare, CloudFront, and Akamai's Edge are all hosted CDNs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      358,
      406,
      430,
      376
    ],
    "source": ""
  },
  {
    "id": 2299,
    "question": "Ben has connected his laptop to his tablet PC using an 802.11ac connection. <br>What wireless network mode has he used to connect these devices?",
    "choice_a": "Infrastructure mode",
    "choice_b": "Wired extension mode",
    "choice_c": "Ad hoc mode",
    "choice_d": "Standalone mode",
    "correct_answer": "C",
    "explanation": "Ben is using ad hoc mode, which directly connects two clients. It can be easy to confuse this with standalone mode, which connects clients using a wireless access point but not to wired resources like a central network. Infrastructure mode connects endpoints to a central network, not directly to each other. Finally, wired extension mode uses a wireless access point to link wireless clients to a wired network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      359,
      388,
      389,
      382,
      368
    ],
    "source": ""
  },
  {
    "id": 2300,
    "question": "Selah's and Nick's PCs simultaneously send traffic by transmitting at the same time. <br>What network term describes the range of systems on a network that could be affected by this same issue?",
    "choice_a": "The subnet",
    "choice_b": "The supernet",
    "choice_c": "A collision domain",
    "choice_d": "A broadcast domain",
    "correct_answer": "C",
    "explanation": "A collision domain is the set of systems that could cause a collision if they transmitted at the same time. Systems outside a collision domain cannot cause a collision if they send at the same time. This is important, as the number of systems in a collision domain increases the likelihood of network congestion due to an increase in collisions. A broadcast domain is the set of systems that can receive a broadcast from each other. A subnet is a logical division of a network, while a supernet is made up of two or more networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      1014,
      378,
      382,
      355,
      330
    ],
    "source": ""
  },
  {
    "id": 2301,
    "question": "Sarah is manually reviewing a packet capture of TCP traffic and finds that a system is setting the RST flag in the TCP packets it sends repeatedly during a short period of time. <br>What does this flag mean in the TCP packet header?",
    "choice_a": "RST flags mean \"Rest.\" The server needs traffic to briefly pause.",
    "choice_b": "RST flags mean \"Relay-set.\" The packets will be forwarded to the address set in the packet.",
    "choice_c": "RST flags mean \"Resume Standard.\" Communications will resume in their normal format.",
    "choice_d": "RST means \"Reset.\" The TCP session will be disconnected.",
    "correct_answer": "D",
    "explanation": "The RST flag is used to reset or disconnect a session. It can be resumed by restarting the connection via a new three-way handshake.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      725,
      724,
      869,
      334,
      868
    ],
    "source": ""
  },
  {
    "id": 2303,
    "question": "Michele wants to replace FTP traffic with a secure replacement. <br>What secure protocol should she select instead?",
    "choice_a": "TFTP",
    "choice_b": "HFTPS",
    "choice_c": "SecFTP",
    "choice_d": "SFTP",
    "correct_answer": "D",
    "explanation": "Both FTP/S and SFTP are commonly used as replacement insecure FTP services. SFTP offers the advantage of using SSH for transfers, making it easy to use existing firewall rules. TFTP is trivial FTP, an insecure quick transfer method often used to transfer files for network devices, among other uses. HFTPS and SecFTP were made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      904,
      335,
      906,
      350,
      416
    ],
    "source": ""
  },
  {
    "id": 2304,
    "question": "Jake has been told that there is a layer 3 problem with his network. <br>Which of the following is associated with layer 3 in the OSI model?",
    "choice_a": "IP addresses",
    "choice_b": "TCP and UDP protocols",
    "choice_c": "MAC addresses",
    "choice_d": "Sending and receiving bits via hardware",
    "correct_answer": "A",
    "explanation": "The Network layer, or layer 3, uses IP addresses for logical addressing. TCP and UDP protocols are used at the Transport layer, which is layer 4. Hardware addresses are used at layer 2, the Data Link layer, and sending and receiving bits via hardware is done at the Physical layer (layer 1).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      330,
      345,
      331,
      744,
      378
    ],
    "source": ""
  },
  {
    "id": 2305,
    "question": "Frank is responsible for ensuring that his organization has reliable, supported network hardware. <br>Which of the following is not a common concern for network administrators as they work to ensure their network continues to be operational?",
    "choice_a": "If the devices have vendor support",
    "choice_b": "If the devices are under warranty",
    "choice_c": "If major devices support redundant power supplies",
    "choice_d": "If all devices support redundant power supplies",
    "correct_answer": "D",
    "explanation": "Most networks include many edge devices like wireless access points and edge switches. These devices often have a single power supply to balance cost against reliability and will simply be replaced if they fail. More critical devices like routers and core switches are typically equipped with redundant power supplies to ensure that larger segments of the network do not fail if a component fails. Of course, making sure devices are supported so they get updates and that they are under warranty are both common practices for supportable networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      378,
      404,
      358,
      1012
    ],
    "source": ""
  },
  {
    "id": 2307,
    "question": "Which one of the following protocols is commonly used to provide back-end authentication services for a VPN?",
    "choice_a": "HTTPS",
    "choice_b": "RADIUS",
    "choice_c": "ESP",
    "choice_d": "AH",
    "correct_answer": "B",
    "explanation": "The Remote Access Dial In User Service (RADIUS) protocol was originally designed to support dial-up modem connections but is still commonly used for VPN-based authentication. HTTPS is not an authentication protocol. ESP and AH are IPsec protocols but do not provide authentication services for other systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      362,
      392,
      390,
      401,
      416
    ],
    "source": ""
  },
  {
    "id": 2308,
    "question": "Isaac wants to ensure that his VoIP session initialization is secure. <br>What protocol should he ensure is enabled and required?",
    "choice_a": "SVOIP",
    "choice_b": "PBSX",
    "choice_c": "SIPS",
    "choice_d": "SRTP",
    "correct_answer": "C",
    "explanation": "SIPS, the secure version of the Session Initialization Protocol for VoIP, adds TLS encryption to keep the session initialization process secure. SVOIP and PBSX are not real protocols, but SRTP is the secure version of RTP, the Real time Transport Protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      353,
      350,
      332,
      335,
      395
    ],
    "source": ""
  },
  {
    "id": 2309,
    "question": "Chris is designing layered network security for his organization. <br><img src=\"/question_assets/CISSP/4_image1.png\"/> <br>What type of firewall design is shown in the diagram?",
    "choice_a": "A single-tier firewall",
    "choice_b": "A two-tier firewall",
    "choice_c": "A three-tier firewall",
    "choice_d": "A four-tier firewall",
    "correct_answer": "B",
    "explanation": "The firewall in the diagram has two protected zones behind it, making it a two-tier firewall design.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      375,
      357,
      950,
      388
    ],
    "source": ""
  },
  {
    "id": 2310,
    "question": "Chris is designing layered network security for his organization. <br><img src=\"/question_assets/CISSP/4_image1.png\"/> <br>If the VPN grants remote users the same access to network and system resources as local workstations have, what security issue should Chris raise?",
    "choice_a": "VPN users will not be able to access the web server.",
    "choice_b": "There is no additional security issue; the VPN concentrator's logical network location matches the logical network location of the workstations.",
    "choice_c": "Web server traffic is not subjected to stateful inspection.",
    "choice_d": "VPN users should only connect from managed PCs.",
    "correct_answer": "D",
    "explanation": "Remote PCs that connect to a protected network need to comply with security settings and standards that match those required for the internal network. The VPN concentrator logically places remote users in the protected zone behind the firewall, but that means user workstations (and users) must be trusted in the same way that local workstations are.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      401,
      411,
      427,
      379,
      437
    ],
    "source": ""
  },
  {
    "id": 2312,
    "question": "Susan is deploying a routing protocol that maintains a list of destination networks with metrics that include the distance in hops to them and the direction traffic should be sent to them. <br>What type of protocol is she using?",
    "choice_a": "A link-state protocol",
    "choice_b": "A link-distance protocol",
    "choice_c": "A destination metric protocol",
    "choice_d": "A distance-vector protocol",
    "correct_answer": "D",
    "explanation": "Distance-vector protocols use metrics including the direction and distance in hops to remote networks to make decisions. A link-state routing protocol considers the shortest distance to a remote network. Destination metric and link-distance protocols don't exist.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      331,
      333,
      345,
      330,
      389
    ],
    "source": ""
  },
  {
    "id": 2313,
    "question": "Ben has configured his network to not broadcast an SSID. <br>Why might Ben disable SSID broadcast, and how could his SSID be discovered?",
    "choice_a": "Disabling SSID broadcast prevents attackers from discovering the encryption key. The SSID can be recovered from decrypted packets.",
    "choice_b": "Disabling SSID broadcast hides networks from unauthorized personnel. The SSID can be discovered using a wireless sniffer.",
    "choice_c": "Disabling SSID broadcast prevents issues with beacon frames. The SSID can be recovered by reconstructing the BSSID.",
    "choice_d": "Disabling SSID broadcast helps avoid SSID conflicts. The SSID can be discovered by attempting to connect to the network.",
    "correct_answer": "B",
    "explanation": "Disabling SSID broadcast can help prevent unauthorized personnel from attempting to connect to the network. Since the SSID is still active, it can be discovered by using a wireless sniffer. Encryption keys are not related to SSID broadcast, beacon frames are used to broadcast the SSID, and it is possible to have multiple networks with the same SSID.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      360,
      369,
      370,
      375,
      379
    ],
    "source": ""
  },
  {
    "id": 2318,
    "question": "During a security assessment, Jim discovers that the organization he is working with uses a multilayer protocol to handle SCADA systems and recently connected the SCADA network to the rest of the organization's production network. <br>What concern should he raise about serial data transfers carried via TCP/IP?",
    "choice_a": "SCADA devices that are now connected to the network can now be attacked over the network.",
    "choice_b": "Serial data over TCP/IP cannot be encrypted.",
    "choice_c": "Serial data cannot be carried in TCP packets.",
    "choice_d": "TCP/IP's throughput can allow for easy denial-of-service attacks against serial devices.",
    "correct_answer": "A",
    "explanation": "Multilayer protocols like DNP3 allow SCADA and other systems to use TCP/IP-based networks to communicate. Many SCADA devices were never designed to be exposed to a network, and adding them to a potentially insecure network can create significant risks. TLS or other encryption can be used on TCP packets, meaning that even serial data can be protected. Serial data can be carried via TCP packets because TCP packets don't care about their content; it is simply another payload. Finally, TCP/IP does not have a specific throughput as designed, so issues with throughput are device-level issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      351,
      333,
      352,
      412,
      436
    ],
    "source": ""
  },
  {
    "id": 2319,
    "question": "Ben provides networking and security services for a small chain of coffee shops. The coffee shop chain wants to provide secure, free wireless for customers. <br>Which of the following is the best option available to Ben to allow customers to connect securely to his wireless network without needing a user account if Ben does not need to worry about protocol support issues?",
    "choice_a": "Use WPA2 in PSK mode.",
    "choice_b": "Use WPA3 in SAE mode.",
    "choice_c": "Use WPA2 in Enterprise mode.",
    "choice_d": "Use a captive portal.",
    "correct_answer": "B",
    "explanation": "WPA3's new SAE (simultaneous authentication of equals) mode improves on WPA2's PSK mode by allowing for secure authentication between clients and the wireless network without enterprise user accounts. If Ben needed to worry about support for WPA3, which may not be available to all systems that may want to connect, he might have to choose WPA2. A captive portal is often used with open guest networks, and Enterprise mode requires user accounts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      361,
      367,
      362,
      391,
      359
    ],
    "source": ""
  },
  {
    "id": 2320,
    "question": "Alicia's company has implemented multifactor authentication using SMS messages to provide a numeric code. <br>What is the primary security concern that Alicia may want to express about this design?",
    "choice_a": "SMS messages are not encrypted.",
    "choice_b": "SMS messages can be spoofed by senders.",
    "choice_c": "SMS messages may be received by more than one phone.",
    "choice_d": "SMS messages may be stored on the receiving phone.",
    "correct_answer": "A",
    "explanation": "SMS messages are not encrypted, meaning that they could be sniffed and captured. While using two factors is more secure than a single factor, SMS is one of the less secure ways to implement two-factor authentication because of this. SMS messages can be spoofed, can be received by more than one phone, and are typically stored on the recipient's phone. The primary threat here, however, is the unencrypted message itself.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      401,
      391,
      362,
      409,
      400
    ],
    "source": ""
  },
  {
    "id": 2321,
    "question": "What speed and frequency range are used by 802.11n?",
    "choice_a": "5 GHz only",
    "choice_b": "900 MHz and 2.4 GHz",
    "choice_c": "2.4GHz and 5 GHz",
    "choice_d": "2.4 GHz only",
    "correct_answer": "C",
    "explanation": "802.11n can operate on both the 2.4 and 5 GHz frequency range. The 900 MHz range has frequently been used for phones and non-WiFi wireless networks as well as other amateur radio uses. Knowing that multiple ranges are available and that they may behave differently based on how many access points are in use and whether other devices that may cause interference on that band are in the area can be important for wireless network deployments.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      359,
      366,
      389,
      360,
      370
    ],
    "source": ""
  },
  {
    "id": 2322,
    "question": "The Address Resolution Protocol (ARP) and the Reverse Address Resolution Protocol (RARP) operate at what layer of the OSI model?",
    "choice_a": "Layer 1",
    "choice_b": "Layer 2",
    "choice_c": "Layer 3",
    "choice_d": "Layer 4",
    "correct_answer": "B",
    "explanation": "ARP and RARP operate at the Data Link layer, the second layer of the OSI model. Both protocols deal with physical hardware addresses, which are used above the Physical layer (layer 1) and below the Network layer (layer 3), thus falling at the Data Link layer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      330,
      331,
      387,
      338,
      349
    ],
    "source": ""
  },
  {
    "id": 2323,
    "question": "Which of the following is a converged protocol that allows storage mounts over TCP, and which is frequently used as a lower-cost alternative to Fibre Channel?",
    "choice_a": "MPLS",
    "choice_b": "SDN",
    "choice_c": "VoIP",
    "choice_d": "iSCSI",
    "correct_answer": "D",
    "explanation": "iSCSI is a converged protocol that allows location-independent file services over traditional network technologies. It costs less than traditional Fibre Channel. VoIP is Voice over IP, SDN is software-defined networking, and MPLS is Multiprotocol Label Switching, a technology that uses path labels instead of network addresses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      352,
      354,
      434,
      333,
      335
    ],
    "source": ""
  },
  {
    "id": 2324,
    "question": "Chris is building an Ethernet network and knows that he needs to span a distance of more than 150 meters with his 1000BaseT network. <br>What network technology should he use to help with this?",
    "choice_a": "Install a repeater, a switch, or a concentrator before 100 meters.",
    "choice_b": "Use Category 7 cable, which has better shielding for higher speeds.",
    "choice_c": "Install a gateway to handle the distance.",
    "choice_d": "Use STP cable to handle the longer distance at high speeds.",
    "correct_answer": "A",
    "explanation": "A repeater, switch, or concentrator will amplify the signal, ensuring that the 100-meter distance limitation of 1000BaseT is not an issue. A gateway would be useful if network protocols were changing, while Cat7 cable is appropriate for a 10Gbps network at much shorter distances. STP cable is limited to 155 Mbps and 100 meters, which would leave Chris with network problems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      730,
      731,
      381,
      1012,
      732
    ],
    "source": ""
  },
  {
    "id": 2325,
    "question": "Selah's organization has used a popular messaging service for a number of years. Recently, concerns have been raised about the use of messaging. <br><img src=\"/question_assets/CISSP/4_image2.png\"/><br>What protocol is the messaging traffic most likely to use based on the diagram?",
    "choice_a": "SLACK",
    "choice_b": "HTTP",
    "choice_c": "SMTP",
    "choice_d": "HTTPS",
    "correct_answer": "B",
    "explanation": "The use of TCP port 80 indicates that the messaging service is using the HTTP protocol. Slack is a messaging service that runs over HTTPS, which uses port 443. SMTP is an email protocol that uses port 25.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      393,
      338,
      408,
      729,
      727
    ],
    "source": ""
  },
  {
    "id": 2326,
    "question": "Selah's organization has used a popular messaging service for a number of years. Recently, concerns have been raised about the use of messaging. <br><img src=\"/question_assets/CISSP/4_image2.png\"/><br>What security concern does sending internal communications from A to B raise?",
    "choice_a": "The firewall does not protect system B.",
    "choice_b": "System C can see the broadcast traffic from system A to B.",
    "choice_c": "It is traveling via an unencrypted protocol.",
    "choice_d": "Messaging does not provide nonrepudation.",
    "correct_answer": "C",
    "explanation": "HTTP traffic is typically sent via TCP 80. Unencrypted HTTP traffic can be easily captured at any point between A and B, meaning that the messaging solution chosen does not provide confidentiality for the organization's corporate communications.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      335,
      389,
      412,
      409,
      375
    ],
    "source": ""
  },
  {
    "id": 2327,
    "question": "Selah's organization has used a popular messaging service for a number of years. Recently, concerns have been raised about the use of messaging. <br><img src=\"/question_assets/CISSP/4_image2.png\"/><br>How could Selah's company best address a desire for secure messaging for users of internal systems A and C?",
    "choice_a": "Use a third-party messaging service.",
    "choice_b": "Implement and use a locally hosted service.",
    "choice_c": "Use HTTPS.",
    "choice_d": "Discontinue use of messaging and instead use email, which is more secure.",
    "correct_answer": "B",
    "explanation": "If a business need requires messaging, using a local messaging server is the best option. This prevents traffic from traveling to a third-party server and can offer additional benefits such as logging, archiving, and control of security options like the use of encryption.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      727,
      729,
      430,
      428,
      403
    ],
    "source": ""
  },
  {
    "id": 2328,
    "question": "Which of the following drawbacks is a concern when multilayer protocols are allowed?",
    "choice_a": "A range of protocols may be used at higher layers.",
    "choice_b": "Covert channels are allowed.",
    "choice_c": "Filters cannot be bypassed.",
    "choice_d": "Encryption can't be incorporated at multiple layers.",
    "correct_answer": "B",
    "explanation": "Multilayer protocols create three primary concerns for security practitioners: they can conceal covert channels (and thus covert channels are allowed), filters can be bypassed by traffic concealed in layered protocols, and the logical boundaries put in place by network segments can be bypassed under some circumstances. Multilayer protocols allow encryption at various layers and support a range of protocols at higher layers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      351,
      412,
      350,
      333,
      374
    ],
    "source": ""
  },
  {
    "id": 2329,
    "question": "Which of the following is not an example of a converged protocol?",
    "choice_a": "MIME",
    "choice_b": "FCoE",
    "choice_c": "iSCSI",
    "choice_d": "VoIP",
    "correct_answer": "A",
    "explanation": "Fibre Channel over Ethernet (FCoE), Internet Small Computer Systems Interface (iSCSI), and Voice over Internet Protocol (VoIP) are all examples of converged protocols that combine specialized protocols with standard protocols like TCP/IP. MIME, Multipurpose Internet Mail Extensions, is not a converged protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      352,
      353,
      351,
      335,
      389
    ],
    "source": ""
  },
  {
    "id": 2330,
    "question": "Chris uses a cellular hot spot to provide internet access when he is traveling. If he leaves the hot spot connected to his PC while his PC is on his organization's corporate network, what security issue might he cause?",
    "choice_a": "Traffic may not be routed properly, exposing sensitive data.",
    "choice_b": "His system may act as a bridge from the internet to the local network.",
    "choice_c": "His system may be a portal for a reflected DDoS attack.",
    "choice_d": "Security administrators may not be able to determine his IP address if a security issue occurs.",
    "correct_answer": "B",
    "explanation": "When a workstation or other device is connected simultaneously to both a secure network and a nonsecure network like the internet, it may act as a bridge, bypassing the security protections located at the edge of a corporate network. It is unlikely that traffic will be routed improperly leading to the exposure of sensitive data, as traffic headed to internal systems and networks is unlikely to be routed to the external network. Reflected DDoS attacks are used to hide identities rather than to connect through to an internal network, and security administrators of managed systems should be able to determine both the local and wireless IP addresses his system uses.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      379,
      375,
      400,
      357,
      430
    ],
    "source": ""
  },
  {
    "id": 2332,
    "question": "What features can IPsec provide for secure communication?",
    "choice_a": "Encryption, access control, nonrepudiation and message authentication.",
    "choice_b": "Protocol convergence, content distribution, micro-segmentation, and network virtualization",
    "choice_c": "Encryption, authorization, nonrepudiation, and message integrity checking",
    "choice_d": "Micro-segmentation, network virtualization, encryption, and message authentication",
    "correct_answer": "A",
    "explanation": "IPsec, or Internet Protocol Security, can provide encryption, access control, nonrepudiation, and message authentication using public key cryptography. It does not provide authorization, protocol convergence, content distribution, or the other items listed.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      416,
      350,
      411,
      412,
      436
    ],
    "source": ""
  },
  {
    "id": 2333,
    "question": "Casey has been asked to determine if Zigbee network traffic can be secured in transit. <br>What security mechanism does Zigbee use to protect data traffic?",
    "choice_a": "3DES encryption",
    "choice_b": "AES encryption",
    "choice_c": "ROT13 encryption",
    "choice_d": "Blowfish encryption",
    "correct_answer": "B",
    "explanation": "Zigbee uses AES to protect network traffic, providing integrity and confidentiality controls. It does not use 3DES, and ROT13 is a simple rotational cipher you might find in a cereal box or secret decoder ring.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      734,
      364,
      411,
      412,
      333
    ],
    "source": ""
  },
  {
    "id": 2334,
    "question": "Sue modifies her MAC address to one that is allowed on a network that uses MAC filtering to provide security. <br>What is the technique Sue used, and what non-security issue could her actions cause?",
    "choice_a": "Broadcast domain exploit, address conflict",
    "choice_b": "Spoofing, token loss",
    "choice_c": "Spoofing, address conflict",
    "choice_d": "Sham EUI creation, token loss",
    "correct_answer": "C",
    "explanation": "The process of using a fake MAC (Media Access Control) address is called spoofing, and spoofing a MAC address already in use on the network can lead to an address collision, preventing traffic from reaching one or both systems. Tokens are used in token ring networks, which are outdated, and EUI refers to an Extended Unique Identifier, another term for MAC address, but token loss is still not the issue. Broadcast domains refer to the set of machines a host can send traffic to via a broadcast message.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      420,
      418,
      382,
      331,
      349
    ],
    "source": ""
  },
  {
    "id": 2335,
    "question": "Joanna wants to deploy 4G LTE as an out-of-band management solution for devices at remote sites. <br>Which of the following security capabilities is not commonly available from 4G service providers?",
    "choice_a": "Encryption capabilities",
    "choice_b": "Device-based authentication",
    "choice_c": "Dedicated towers and antennas for secure service subscribers",
    "choice_d": "SIM-based authentication",
    "correct_answer": "C",
    "explanation": "While security features vary from provider to provider, encryption, device-based authentication (for example, using certificates), and SIM-based authentication are all common options for 4G connectivity solutions. Joanna should work with her provider to determine what capabilities are available and assess whether they meet her needs.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      372,
      400,
      401,
      416,
      417
    ],
    "source": ""
  },
  {
    "id": 2336,
    "question": "SMTP, HTTP, and SNMP all occur at what layer of the OSI model?",
    "choice_a": "Layer 4",
    "choice_b": "Layer 5",
    "choice_c": "Layer 6",
    "choice_d": "Layer 7",
    "correct_answer": "D",
    "explanation": "Application-specific protocols are handled at layer 7, the Application layer of the OSI model.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      335,
      330,
      742,
      336,
      389
    ],
    "source": ""
  },
  {
    "id": 2338,
    "question": "Selah wants to provide port-based authentication on her network to ensure that clients must authenticate before using the network. <br>What technology is an appropriate solution for this requirement?",
    "choice_a": "802.11a",
    "choice_b": "802.3",
    "choice_c": "802.15.1",
    "choice_d": "802.1x",
    "correct_answer": "D",
    "explanation": "802.1x provides port-based authentication and can be used with technologies like EAP, the Extensible Authentication Protocol. 802.11a is a wireless standard, 802.3 is the standard for Ethernet, and 802.15.1 was the original Bluetooth IEEE standard.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      392,
      391,
      437,
      362,
      393
    ],
    "source": ""
  },
  {
    "id": 2339,
    "question": "Ben has deployed a 1000BaseT gigabit network and needs to run a cable across a large building. If Ben is running his link directly from a switch to another switch in that building, what is the maximum distance Ben can cover according to the 1000BaseT specification?",
    "choice_a": "2 kilometers",
    "choice_b": "500 meters",
    "choice_c": "185 meters",
    "choice_d": "100 meters",
    "correct_answer": "D",
    "explanation": "1000 BaseT is capable of a 100-meter run according to its specifications. For longer distances and exterior runs, a fiber-optic cable is typically used in modern networks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      730,
      381,
      731,
      378,
      1012
    ],
    "source": ""
  },
  {
    "id": 2340,
    "question": "What security control does MAC cloning attempt to bypass for wired networks?",
    "choice_a": "Port security",
    "choice_b": "VLAN hopping",
    "choice_c": "802.1q trunking",
    "choice_d": "Etherkiller prevention",
    "correct_answer": "A",
    "explanation": "Port security prevents unrecognized or unpermitted systems from connecting to a network port based on their MAC address. Cloning a permitted or legitimate MAC address attempts to bypass this. VLAN hopping and 802.1q trunking attacks attempt to access other subnets by encapsulating packets so they will be unwrapped and directed to the other subnet. Etherkiller prevention is not a security setting or control.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      420,
      393,
      419,
      421,
      349
    ],
    "source": ""
  },
  {
    "id": 2341,
    "question": "The company that Kathleen works for has moved to remote work for most employees and wants to ensure that the multimedia collaboration platform that they use for voice, video, and text-based collaboration is secure. <br>Which of the following security options will provide the best user experience while providing appropriate security for communications?",
    "choice_a": "Require software-based VPN to the corporate network for all use of the collaboration platform.",
    "choice_b": "Require the use of SIPS and SRTP for all communications.",
    "choice_c": "Use TLS for all traffic for the collaboration platform.",
    "choice_d": "Deploy secure VPN endpoints to each remote location and use a point-to-point VPN for communications.",
    "correct_answer": "C",
    "explanation": "Most modern applications support TLS throughout their communications allowing clients to securely connect to the service and to encrypt communications. VPN, either in software or hardware form, will be more complex and unwieldy. Software-based VPN would be more flexible, and hardware-based VPN would be more expensive and more complex. SIPS and SRTP are appropriate for a VoIP environment, but are not generally a complete solution for a modern multimedia collaboration platform like Microsoft Teams, Zoom, or WebEx.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      403,
      401,
      353,
      395,
      412
    ],
    "source": ""
  },
  {
    "id": 2342,
    "question": "Chris wants to use a low-power, personal area network wireless protocol for a device he is designing. <br>Which of the following wireless protocols is best suited to creating small, low-power devices that can connect to each other at relatively short distances across buildings or rooms?",
    "choice_a": "WiFi",
    "choice_b": "Zigbee",
    "choice_c": "NFC",
    "choice_d": "Infrared",
    "correct_answer": "B",
    "explanation": "Zigbee is designed for this type of low-power, Internet of Things network, and would be the best option for Chris. Some versions of Bluetooth are designed to operate in low-power mode as well, but Bluetooth isn't in this list of answers. WiFi requires more power, NFC is very short range and would not work across a building or room, and infrared requires line of sight and is rarely used for that reason.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      734,
      733,
      735,
      364,
      365
    ],
    "source": ""
  },
  {
    "id": 2344,
    "question": "Cameron is worried about distributed denial-of-service attacks against his company's primary web application. <br>Which of the following options will provide the most resilience against large-scale DDoS attacks?",
    "choice_a": "A CDN",
    "choice_b": "Increasing the number of servers in the web application server cluster",
    "choice_c": "Contract for DDoS mitigation services via the company's ISP",
    "choice_d": "Increasing the amount of bandwidth available from one or more ISPs",
    "correct_answer": "A",
    "explanation": "A content delivery network, or CDN, run by a major provider can handle large-scale DDoS attacks more easily than any of the other solutions. Using DDoS mitigation techniques via an ISP is the next most useful capability, followed by both increases in bandwidth and increases in the number of servers in the web application cluster.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      394,
      378,
      333,
      427
    ],
    "source": ""
  },
  {
    "id": 2345,
    "question": "There are four common VPN protocols. <br>Which group listed contains all of the common VPN protocols?",
    "choice_a": "PPTP, LTP, L2TP, IPsec",
    "choice_b": "PPP, L2TP, IPsec, VNC",
    "choice_c": "PPTP, L2F, L2TP, IPsec",
    "choice_d": "PPTP, L2TP, IPsec, SPAP",
    "correct_answer": "C",
    "explanation": "PPTP, L2F, L2TP, and IPsec are the most common VPN protocols. TLS is also used for an increasingly large percentage of VPN connections and may appear at some point in the CISSP exam. PPP is a dial-up protocol, LTP is not a protocol, and SPAP is the Shiva Password Authentication Protocol sometimes used with PPTP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      415,
      416,
      411,
      350,
      437
    ],
    "source": ""
  },
  {
    "id": 2346,
    "question": "Wayne wants to deploy a secure voice communication network. <br>Which of the following techniques should he consider? (Select all that apply.)",
    "choice_a": "Use a dedicated VLAN for VoIP phones and devices.",
    "choice_b": "Require the use of SIPS and SRTP.",
    "choice_c": "Require the use of VPN for all remote VoIP devices.",
    "choice_d": "Implement a VoIP IPS.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Wayne should consider the use of a dedicated VLAN for VoIP devices to help separate them from other networked devices, and he should also require the use of SIPS and SRTP, both secure protocols that will keep his VoIP traffic encrypted. Requiring the use of VPN for all remote VoIP devices is not necessary if SIPS and SRTP are in use, and a specific IPS for VoIP is not a typical deployment in most organizations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      353,
      438,
      866,
      397,
      350
    ],
    "source": ""
  },
  {
    "id": 2347,
    "question": "Which OSI layer includes electrical specifications, protocols, and interface standards?",
    "choice_a": "The Transport layer",
    "choice_b": "The Device layer",
    "choice_c": "The Physical layer",
    "choice_d": "The Data Link layer",
    "correct_answer": "C",
    "explanation": "The Physical layer includes electrical specifications, protocols, and standards that allow control of throughput, handling line noise, and a variety of other electrical interface and signaling requirements. The OSI layer doesn't have a Device layer. The Transport layer connects the Network and Session layers, and the Data Link layer packages packets from the network layer for transmission and receipt by devices operating on the Physical layer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      330,
      743,
      389,
      387,
      378
    ],
    "source": ""
  },
  {
    "id": 2348,
    "question": "Ben is designing a WiFi network and has been asked to choose the most secure option for the network. <br>Which wireless security standard should he choose?",
    "choice_a": "WPA2",
    "choice_b": "WPA",
    "choice_c": "WEP",
    "choice_d": "WPA3",
    "correct_answer": "D",
    "explanation": "WPA3, the replacement for WPA2, adds security features including a new mode called simultaneous authentication of equals that replaces the pre-shared key mode from WPA2 with a more secure option. Overall, it provides security improvements, but may not be immediately implemented due to time for hardware and software to fully support it. WPA2 has been the most commonly deployed wireless security standard having replaced WPA and WEP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      361,
      369,
      362,
      363,
      370
    ],
    "source": ""
  },
  {
    "id": 2350,
    "question": "Segmentation, sequencing, and error checking all occur at what layer of the OSI model that is associated with SSL, TLS, and UDP?",
    "choice_a": "The Transport layer",
    "choice_b": "The Network layer",
    "choice_c": "The Session layer",
    "choice_d": "The Presentation layer",
    "correct_answer": "A",
    "explanation": "The Transport layer provides logical connections between devices, including end-to-end transport services to ensure that data is delivered. Transport layer protocols include TCP, UDP, SSL, and TLS.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      332,
      330,
      350,
      333,
      387
    ],
    "source": ""
  },
  {
    "id": 2351,
    "question": "The Windows <code>ipconfig</code> command displays the following information. <br>BC-5F-F4-7B-4B-7. <br>What term describes this, and what information can usually be gathered from it?",
    "choice_a": "The IP address, the network location of the system",
    "choice_b": "The MAC address, the network interface card's manufacturer",
    "choice_c": "The MAC address, the media type in use",
    "choice_d": "The IPv6 client ID, the network interface card's manufacturer",
    "correct_answer": "B",
    "explanation": "Machine Access Control (MAC) addresses are the hardware address the machine uses for layer 2 communications. The MAC addresses include an organizationally unique identifier (OUI), which identifies the manufacturer. MAC addresses can be changed, so this is not a guarantee of accuracy, but under normal circumstances you can tell what manufacturer made the device by using the MAC address.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      331,
      387,
      338,
      418,
      367
    ],
    "source": ""
  },
  {
    "id": 2353,
    "question": "Ben is reviewing network traffic in his datacenter, and sees traffic that is sent from a SQL server to a web server in the same VLAN. <br>How should he describe this traffic?",
    "choice_a": "North/South",
    "choice_b": "East/West",
    "choice_c": "Input/Output",
    "choice_d": "Sideways",
    "correct_answer": "B",
    "explanation": "East/west traffic is the term used for communications in the same network segment. North/south traffic is entering or exiting a network segment. Input/output is not a term used in for this. Lateral movement describes attackers moving between systems, but sideways traffic is not a commonly used term.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      737,
      736,
      423,
      738,
      950
    ],
    "source": ""
  },
  {
    "id": 2354,
    "question": "What is the default subnet mask for a Class B network?",
    "choice_a": "255.0.0.0",
    "choice_b": "255.255.0.0",
    "choice_c": "255.254.0.0",
    "choice_d": "255.255.255.0",
    "correct_answer": "B",
    "explanation": "A Class B network holds 2^16 systems, and its default network mask is 255.255.0.0.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      740,
      739,
      348,
      439,
      355
    ],
    "source": ""
  },
  {
    "id": 2357,
    "question": "Selah's organization has deployed VoIP phones on the same switches that the desktop PCs are on. <br>What security issue could this create, and what solution would help?",
    "choice_a": "VLAN hopping; use physically separate switches.",
    "choice_b": "VLAN hopping; use encryption.",
    "choice_c": "Caller ID spoofing; MAC filtering.",
    "choice_d": "Denial-of-service attacks; use a firewall between networks.",
    "correct_answer": "A",
    "explanation": "VLAN hopping between the voice and computer VLANs can be accomplished when devices share the same switch infrastructure. Using physically separate switches can prevent this attack. Encryption won't help with VLAN hopping because it relies on header data that the switch needs to read (and this is unencrypted), while Caller ID spoofing is an inherent problem with VoIP systems. A denial of service is always a possibility, but it isn't specifically a VoIP issue and a firewall may not stop the problem if it's on a port that must be allowed through.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      421,
      419,
      353,
      395,
      438
    ],
    "source": ""
  },
  {
    "id": 2358,
    "question": "Susan is designing her organization's new network infrastructure for a branch office. <br>Susan wants to use a set of nonroutable IP addresses for the location's internal network addresses. Using your knowledge of secure network design principles and IP networking, which of the following IP ranges are usable for that purpose? (Select all that apply.)",
    "choice_a": "172.16.0.0/12",
    "choice_b": "192.168.0.0/16",
    "choice_c": "128.192.0.0/24",
    "choice_d": "10.0.0.0/8",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "RFC 1918 defines three address ranges as private (non routable) IP address ranges: 10.0.0.0/8, 172.16.0.0/12, and 192.168.0.0/16. Any of these would work, but many organizations use the 192.168.0.0/16 range for smaller sites or opt to carve out sections of the 10.0.0.0/8 range for multiple remote sites.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      425,
      949,
      950,
      423,
      736
    ],
    "source": ""
  },
  {
    "id": 2359,
    "question": "Susan is designing her organization's new network infrastructure for a branch office. <br>Susan knows that she will need to implement a WiFi network for her customers and wants to gather information about the customers, such as their email address, without having to provide them with a wireless network password or key. <br>What type of solution would provide this combination of features?",
    "choice_a": "NAC",
    "choice_b": "A captive portal",
    "choice_c": "Pre-shared keys",
    "choice_d": "WPA3's SAE mode",
    "correct_answer": "B",
    "explanation": "A captive portal is a popular solution that you may be familiar with from hotels and coffee shops. They combine the ability to gather data from customers with an open network, so customer data will not be encrypted. This avoids the need to distribute network passwords but means that customers must ensure their own traffic is encrypted if they are worried about security.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      362,
      363,
      389,
      335,
      401
    ],
    "source": ""
  },
  {
    "id": 2360,
    "question": "Susan is designing her organization's new network infrastructure for a branch office. <br>With her wireless network set up, Susan moves on to ensuring that her network will remain operational even if disruptions occur. <br>What is the simplest way she can ensure that her network devices, including her router, access points, and network switches, stay on if a brownout or other temporary power issue occurs?",
    "choice_a": "Purchase and install a generator with an automatic start.",
    "choice_b": "Deploy dual power supplies for all network devices.",
    "choice_c": "Install UPS systems to cover all network devices that must remain online.",
    "choice_d": "Contract with multiple different power companies for redundant power.",
    "correct_answer": "C",
    "explanation": "A UPS system, or uninterruptible power supply, is designed to provide backup power during brief power disruptions ranging from power sags and brownouts to temporary power failures. For a longer outage, Susan will still want a generator or even a secondary power feed from another power grid or provider if possible, but for this specific scenario, a UPS will meet her needs. Dual power supplies help when the concern is losing power from one power supply and would be a great idea for her most critical network devices, but it is rare to have dual power supplies for edge devices like access points or edge switches.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      385,
      406,
      1012,
      359,
      389
    ],
    "source": ""
  },
  {
    "id": 2362,
    "question": "Data streams occur at what three layers of the OSI model?",
    "choice_a": "Application, Presentation, and Session",
    "choice_b": "Presentation, Session, and Transport",
    "choice_c": "Physical, Data Link, and Network",
    "choice_d": "Data Link, Network, and Transport",
    "correct_answer": "A",
    "explanation": "Data streams are associated with the Application, Presentation, and Session layers. Once they reach the Transport layer, they become segments (TCP) or datagrams (UDP). From there, they are converted to packets at the Network layer, frames at the Data Link layer, and bits at the Physical layer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      330,
      387,
      332,
      742,
      333
    ],
    "source": ""
  },
  {
    "id": 2363,
    "question": "Lucca wants to protect endpoints that are in production use but that are no longer supported and cannot be patched from network attacks. <br>What should he do to best protect these devices?",
    "choice_a": "Install a firewall on the device.",
    "choice_b": "Disable all services and open ports on the devices.",
    "choice_c": "Place a hardware network security device in front of the devices.",
    "choice_d": "Unplug the devices from the network because they cannot be properly secured.",
    "correct_answer": "C",
    "explanation": "If the devices still need to be in production but cannot be patched, Lucca's best option is to use a separate security device to protect them. It may be tempting to simply install a firewall on the device or to disable all the services it exposes to the network, but some devices may not have firewall software available, and even if they do, the underlying operating system may have vulnerabilities in its implementation of its network stack or other software that even a firewall could not protect. Unplugging devices that are needed for protection does not resolve the need to keep them online.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      375,
      357,
      412,
      400,
      333
    ],
    "source": ""
  },
  {
    "id": 2366,
    "question": "During a troubleshooting process, the support technician that Alyssa is talking to states that the problem is a layer 3 problem. <br>Which of the following possible issues is not a layer 3 problem?",
    "choice_a": "A TTL mismatch",
    "choice_b": "An MTU mismatch",
    "choice_c": "An incorrect ACL",
    "choice_d": "A broken network cable",
    "correct_answer": "D",
    "explanation": "A broken network cable is a layer 1 problem. If you encounter a problem like this and aren't sure, look for the answer that has a different situation or set of assumptions. Here you have three questions that occur at the network (layer 3), all of which have software or protocol implications. A broken network cable is a completely different type of issue and should stand out. Be careful, though! The exam is likely to give you two potentially valid answers to choose from, so work to get rid of the two least likely answers and spend your time on the remaining options.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      744,
      743,
      330,
      378,
      345
    ],
    "source": ""
  },
  {
    "id": 2367,
    "question": "During a review of her organization's network, Angela discovered that it was suffering from broadcast storms and that contractors, guests, and organizational administrative staff were on the same network segment. <br>What design change should Angela recommend?",
    "choice_a": "Require encryption for all users.",
    "choice_b": "Install a firewall at the network border.",
    "choice_c": "Enable spanning tree loop detection.",
    "choice_d": "Segment the network based on functional requirements.",
    "correct_answer": "D",
    "explanation": "Network segmentation can reduce issues with performance as well as diminish the chance of broadcast storms by limiting the number of systems in a segment. This decreases broadcast traffic visible to each system and can reduce congestion. Segmentation can also help provide security by separating functional groups that don't need to be able to access each other's systems. Installing a firewall at the border would only help with inbound and outbound traffic, not cross-network traffic. Spanning tree loop prevention helps prevent loops in Ethernet networks (for example, when you plug a switch into a switch via two ports on each), but it won't solve broadcast storms that aren't caused by a loop or security issues. Encryption might help prevent some problems between functional groups, but it won't stop them from scanning other systems, and it definitely won't stop a broadcast storm!",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      355,
      419,
      1014,
      356,
      378
    ],
    "source": ""
  },
  {
    "id": 2369,
    "question": "Ben is an information security professional at an organization that is replacing its physical servers with cloud-hosted virtual machines. As the organization builds its virtual environment, it is moving toward a hybrid cloud operational model with some systems and services remaining in its local data center and others hosted in the cloud. The following diagram shows the local data center and cloud VPC's network IP ranges, which you should consider as you answer the questions. <br><img src=\"/question_assets/CISSP/4_image3.png\"/><br>Ben wants to ensure that the instance-to-instance (system-to-system) traffic in his cloud-hosted infrastructure as a service environment is secure. <br>What can he do to fully ensure that the virtualized network traffic is not being captured and analyzed?",
    "choice_a": "Prevent the installation of a packet sniffer on all hosts.",
    "choice_b": "Disable promiscuous mode for all virtual network interfaces.",
    "choice_c": "Disallow the use of any virtual taps.",
    "choice_d": "Encrypt all traffic between hosts.",
    "correct_answer": "D",
    "explanation": "In an infrastructure as a service (IaaS) environment, the company that provides cloud environment has final control of all the virtual machines and networks. Thus, to protect data, the best option is to encrypt the data. Unfortunately,Ben cannot fully ensure that traffic in his environment is not being captured and must rely on the cloud hosting provider for that assurance. While preventing the installation of packet sniffers and taps and ensuring that promiscuous mode cannot be enabled are useful habits in an environment that you control, this will not provide the same control in a cloud environment.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      412,
      413,
      436,
      430,
      354
    ],
    "source": ""
  },
  {
    "id": 2370,
    "question": "Ben is an information security professional at an organization that is replacing its physical servers with cloud-hosted virtual machines. As the organization builds its virtual environment, it is moving toward a hybrid cloud operational model with some systems and services remaining in its local data center and others hosted in the cloud. The following diagram shows the local data center and cloud VPC's network IP ranges, which you should consider as you answer the questions. <br><img src=\"/question_assets/CISSP/4_image3.png\"/><br>What issue is most likely to occur due to the subnets configured for the data center and VPC?",
    "choice_a": "IP address conflicts",
    "choice_b": "Routing loops",
    "choice_c": "MAC address conflicts",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "Using the same IP range for an on-site and cloud-hosted data center can be helpful when designing a flat network, but addresses must be carefully managed and allocated even in a space as big as the 10.0.0.0/24 range. If addresses are not properly managed, conflicts may arise that could disrupt production services. MAC address conflicts should not arise unless addresses are manually changed or virtual machines are replicated without changing their MAC addresses. There is nothing in the problem to suggest routing issues.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      737,
      425,
      949,
      331,
      338
    ],
    "source": ""
  },
  {
    "id": 2371,
    "question": "Ben is an information security professional at an organization that is replacing its physical servers with cloud-hosted virtual machines. As the organization builds its virtual environment, it is moving toward a hybrid cloud operational model with some systems and services remaining in its local data center and others hosted in the cloud. The following diagram shows the local data center and cloud VPC's network IP ranges, which you should consider as you answer the questions. <br><img src=\"/question_assets/CISSP/4_image3.png\"/><br>Ben wants to use multiple internet service providers (ISPs) to connect to his cloud VPC to ensure reliable access and bandwidth. <br>What technology can he use to manage and optimize those connections?",
    "choice_a": "FCoE",
    "choice_b": "VXLAN",
    "choice_c": "SDWAN",
    "choice_d": "LiFi",
    "correct_answer": "C",
    "explanation": "A software-defined wide area network, or SD-WAN, is commonly used to manage multiple ISPs and other connectivity options to ensure speed, reliability, and bandwidth design goals are all met. Ben can use SD-WAN capabilities to accomplish his goals to make his hybrid cloud environment successful. Fibre Channel over Ethernet (FCoE) is a storage protocol; VXLAN is used for extensible virtual LANs, not WANs; and LiFi uses visible and infrared light to transfer data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      354,
      333,
      394,
      417,
      406
    ],
    "source": ""
  },
  {
    "id": 2374,
    "question": "Mark is concerned about the physical security of his network cables. <br>What type of network connection would be the hardest to tap without specialized equipment?",
    "choice_a": "WiFi",
    "choice_b": "Bluetooth",
    "choice_c": "Cat5/Cat6 twisted pair",
    "choice_d": "Fiber optic",
    "correct_answer": "D",
    "explanation": "Fiber-optic cable is the most difficult of the listed types of network to capture data from without specialized equipment. Given access to a fiber-optic cable and specialized equipment to tap it, or with access to the endpoints of a fiber-optic cable and an optical tap, access can still be obtained. In either case, disruption may be observed when the cable is cut, spliced, or disconnected, and many attackers will not have access, skills, or the tools needed to do so. WiFi and Bluetooth traffic can be captured using standard wireless cards and tools, and data carried by twisted-pair Ethernet cables is easily captured using commodity tools.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      381,
      422,
      334,
      359,
      435
    ],
    "source": ""
  },
  {
    "id": 2375,
    "question": "Rich wants to connect his network to a building a half-mile away from his current location. There are trees and terrain features along the way, but a road passes between the trees to the other location. <br>What type of transmission media is best suited to this type of deployment?",
    "choice_a": "Ethernet cable with repeaters every 200 to 300 yards",
    "choice_b": "A WiFi directional antenna",
    "choice_c": "Fiber-optic cable",
    "choice_d": "A LiFi system",
    "correct_answer": "C",
    "explanation": "Buried fiber-optic cable is best suited to long distances, particularly when there are trees or other obstacles blocking line of sight that may interfere with WiFi or LiFi deployments. Ethernet's distance limitations mean that repeaters would need to be powered, and there is no description of other structures or power along the path.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      381,
      730,
      731,
      378,
      730
    ],
    "source": ""
  },
  {
    "id": 2376,
    "question": "What challenge is most common for endpoint security system deployments?",
    "choice_a": "Compromises",
    "choice_b": "The volume of data",
    "choice_c": "Monitoring encrypted traffic on the network",
    "choice_d": "Handling non-TCP protocols",
    "correct_answer": "B",
    "explanation": "Endpoint security solutions face challenges due to the sheer volume of data that they can create. When each workstation is generating data about events, this can be a massive amount of data. Endpoint security solutions should reduce the number of compromises when properly implemented, and they can also help by monitoring traffic after it is decrypted on the local host. Finally, non-TCP protocols are relatively uncommon on modern networks, making this a relatively rare concern for endpoint security system implementations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      379,
      380,
      1002,
      404,
      1000
    ],
    "source": ""
  },
  {
    "id": 2377,
    "question": "What type of address is 127.0.0.1?",
    "choice_a": "A public IP address",
    "choice_b": "An RFC 1918 address",
    "choice_c": "An APIPA address",
    "choice_d": "A loopback address",
    "correct_answer": "D",
    "explanation": "The IP address 127.0.0.1 is a loopback address and will resolve to the local machine. Public addresses are non\u2013RFC 1918, non-reserved addresses. RFC 1918 addresses are reserved and include ranges like 10.x.x.x. An APIPA address is a self-assigned address used when a DHCP server cannot be found.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      425,
      949,
      895,
      950,
      423
    ],
    "source": ""
  },
  {
    "id": 2378,
    "question": "Susan is writing a best practices statement for her organizational users who need to use Bluetooth. She knows that there are many potential security issues with Bluetooth and wants to provide the best advice she can. <br>Which of the following sets of guidance should Susan include?",
    "choice_a": "Use Bluetooth's built-in strong encryption, change the default PIN on your device, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "choice_b": "Use Bluetooth only for those activities that are not confidential, change the default PIN on your device, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "choice_c": "Use Bluetooth's built-in strong encryption, use extended (eight digits or longer) Bluetooth PINs, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "choice_d": "Use Bluetooth only for those activities that are not confidential, use extended (eight digits or longer) Bluetooth PINs, turn off discovery mode, and turn off Bluetooth when it's not in active use.",
    "correct_answer": "B",
    "explanation": "Since Bluetooth doesn't provide strong encryption, it should only be used for activities that are not confidential. Bluetooth PINs are four-digit codes that often default to 0000. Turning it off and ensuring that your devices are not in discovery mode can help prevent Bluetooth attacks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      364,
      388,
      734,
      365,
      369
    ],
    "source": ""
  },
  {
    "id": 2379,
    "question": "What type of networking device is most commonly used to assign endpoint systems to VLANs?",
    "choice_a": "Firewall",
    "choice_b": "Router",
    "choice_c": "Switch",
    "choice_d": "Hub",
    "correct_answer": "C",
    "explanation": "The assignment of endpoint systems to VLANs is normally performed by a network switch.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      421,
      388,
      439,
      420,
      375
    ],
    "source": ""
  },
  {
    "id": 2381,
    "question": "Michelle is told that the organization that she is joining uses anSD-WAN controller architecture to manage their WAN connections. <br>What can she assume about how the network is managed and controlled?  (Select all that apply.)",
    "choice_a": "The network uses predefined rules to optimize performance.",
    "choice_b": "The network conducts continuous monitoring to support better performance.",
    "choice_c": "The network uses self-learning techniques to respond to changes in the network.",
    "choice_d": "All connections are managed by the organization's primary Internet service provider.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "SD-WAN implementations typically perform all of these functions, combining active data collection via monitoring and response via self-learning and machine intelligence techniques, and then applying predefined rules to take action to make the network perform as desired. SD-WAN does not imply or require that all connections are managed by the organization's primary internet service provider. In fact, SD-WANs are often used to handle multiple ISPs to allow for failover and redundancy.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      429,
      354,
      394,
      406,
      427
    ],
    "source": ""
  },
  {
    "id": 2382,
    "question": "Which of the following shows the layers of the OSI model in correct order, from layer 1 to layer 7? Place the layers of the OSI model shown here in the appropriate order, from layer 1 to layer 7.",
    "choice_a": "Layer 1 = Data Link; Layer 2 = Physical; Layer 3 = Network; Layer 4 = Transport; Layer 5 = Session; Layer 6 = Presentation; Layer 7 = Applications",
    "choice_b": "Layer 1 = Physical; Layer 2 = Data Link; Layer 3 = Network; Layer 4 = Transport; Layer 5 = Session; Layer 6 = Presentation; Layer 7 = Applications",
    "choice_c": "Layer 1 = Physical; Layer 2 = Data Link; Layer 3 = Network; Layer 4 = Transport; Layer 5 = Session; Layer 6 = Applications; Layer 7 = Presentation",
    "choice_d": "Layer 1 = Physical; Layer 2 = Data Link; Layer 3 = Network; Layer 4 = Session; Layer 5 = Transport; Layer 6 = Presentation; Layer 7 = Applications",
    "correct_answer": "B",
    "explanation": "The OSI layers in order from layer 1 to layer 7 are as follows. <br><ol><li>Physical </li><li>Data Link </li><li>Network </li><li>Transport </li><li>Session </li><li>Presentation </li><li>Application.</li></ol>",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      330,
      742,
      387,
      389,
      332
    ],
    "source": ""
  },
  {
    "id": 2383,
    "question": "Valerie enables port security on the switches on her network. <br>What type of attack is she most likely trying to prevent?",
    "choice_a": "IP spoofing",
    "choice_b": "MAC aggregation",
    "choice_c": "CAM table flooding",
    "choice_d": "VLAN hopping",
    "correct_answer": "C",
    "explanation": "Valerie is most likely trying to prevent CAM table flooding by preventing large numbers of MAC addresses from being used on a single port. If CAM table flooding is successful, switches will not know where to send traffic and resort to sending all traffic to every port, potentially exposing traffic to attackers. IP spoofing and VLAN hopping are not prevented by port security, which focuses on hardware (MAC) addresses. MAC aggregation was made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      418,
      420,
      349,
      393,
      419
    ],
    "source": ""
  },
  {
    "id": 2384,
    "question": "Alaina wants to ensure that systems are compliant with her network security settings before they are allowed on the network and wants to ensure that she can test and validate system settings as possible. <br>What type of NAC system should she deploy?",
    "choice_a": "A pre-admit, clientless NAC system",
    "choice_b": "A postadmission, client-based NAC system",
    "choice_c": "A pre-admit, client-based NAC system",
    "choice_d": "A postadmission, clientless NAC system",
    "correct_answer": "C",
    "explanation": "A pre-admit, client-based NAC system will test systems before they are allowed on the network using a client that can determine more about a system than a clientless model can. Postadmission tests after clients are already on the network and clientless versions are useful when installing clients isn't possible for systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      377,
      392,
      391,
      379,
      401
    ],
    "source": ""
  },
  {
    "id": 2385,
    "question": "Derek wants to deploy redundant core routers, as shown in the diagram. <br><img src=\"/question_assets/CISSP/4_image4.png\"/><br>What model of high availability clustering will provide him with the greatest throughput?",
    "choice_a": "Active/active",
    "choice_b": "Line interactive",
    "choice_c": "Active/passive",
    "choice_d": "Nearline",
    "correct_answer": "A",
    "explanation": "An active/active pair can use the full throughput capability of both devices, but normal deployment models will design to the maximum throughput of a single device to avoid disruption in the event that one of the pair fails. Active/passive designs can only handle the throughput of a single device and allow the secondary device to remain ready to operate but not passing traffic until it is needed. Line interactive is a term often used to describe UPS systems that filter power instead of passing it through, and near-line is a term used to describe backups that are not online but can be retrieved relatively quickly.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      406,
      404,
      373,
      394,
      375
    ],
    "source": ""
  },
  {
    "id": 2387,
    "question": "What is a frequent concern for systems that require high-performing internet connectivity when satellite internet is the only available option?",
    "choice_a": "Security",
    "choice_b": "Compatibility with protocols like LiFi",
    "choice_c": "Compatibility with protocols like Zigbee",
    "choice_d": "Latency",
    "correct_answer": "D",
    "explanation": "Most existing satellite internet systems have relatively high latency. Newer low Earth orbit satellites like Starlink appear to provide better latency than higher orbits, but latency and susceptibility to interference from weather are both common concerns for satellite-based systems.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      371,
      434,
      394,
      358,
      433
    ],
    "source": ""
  },
  {
    "id": 2388,
    "question": "What layer of an SDN implementation uses programs to communicate needs for resources via APIs?",
    "choice_a": "The data plane",
    "choice_b": "The control plane",
    "choice_c": "The application plane",
    "choice_d": "The monitoring plane",
    "correct_answer": "C",
    "explanation": "The application plane of a software-defined network (SDN) is where applications run that use application programming interfaces (APIs) to communicate with the SDN about needed resources. The control plane receives instructions and sends them to the network. The last common plane is the devices themselves.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      354,
      386,
      330,
      333,
      1012
    ],
    "source": ""
  },
  {
    "id": 2389,
    "question": "Which of the following is not a drawback of multilayer protocols?",
    "choice_a": "They can allow filters and rules to be bypassed.",
    "choice_b": "They can operate at higher OSI levels.",
    "choice_c": "They can allow covert channels.",
    "choice_d": "They can allow network segment boundaries to be bypassed.",
    "correct_answer": "B",
    "explanation": "Common drawbacks of multilayer protocols are that they can bypass filters, allow or create covert channels, and allow network segment boundaries to be bypassed. The ability to operate at higher OSI layer levels is normally considered a benefit.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      351,
      330,
      412,
      331,
      333
    ],
    "source": ""
  },
  {
    "id": 2390,
    "question": "Place the following layers of the TCP/IP model in order, starting with the Application layer and moving down the stack. <br><ol><li>Application layer </li><li>Network Access layer </li><li>Internet layer </li><li>Transport layer</li></ol>",
    "choice_a": "1, 2, 3, 4",
    "choice_b": "1, 4, 2, 3",
    "choice_c": "1, 4, 3, 2",
    "choice_d": "4, 1, 3, 2",
    "correct_answer": "C",
    "explanation": "In order, the layers are: Application layer, Transport layer, Internet layer, and Network Access layer.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      333,
      387,
      345,
      337,
      335
    ],
    "source": ""
  },
  {
    "id": 2392,
    "question": "What are two primary advantages that 5G networks have over 4G networks? (Select all that apply.)",
    "choice_a": "Anti-jamming features",
    "choice_b": "Enhanced subscriber identity protection",
    "choice_c": "Mutual authentication capabilities",
    "choice_d": "Multifactor authentication",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "5G technology includes both a new mutual authentication capability and additional protections for subscriber identities. It does not have specific anti-jamming security features and does not specifically use multifactor authentication.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      372,
      362,
      390,
      411,
      401
    ],
    "source": ""
  },
  {
    "id": 2393,
    "question": "What function does VXLAN perform in a data center environment?",
    "choice_a": "It removes limitations due to maximum distance for Ethernet cables.",
    "choice_b": "It allows multiple subnets to exist in the same IP space with hosts using the same IP addresses.",
    "choice_c": "It tunnels layer 2 connections over a layer 3 network, stretching them across the underlying layer 3 network.",
    "choice_d": "All of the above",
    "correct_answer": "C",
    "explanation": "VXLAN tunnels layer 2 connections over a layer 3 network, in essence extending a LAN over distances or networks that it might not otherwise function over. It does not remove the distance limitations of Ethernet cables, nor does it allow multiple subnets to use the same IP space\u2014that requires NAT or other technologies that remap addresses to avoid conflicts.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      357,
      412,
      331,
      330,
      732
    ],
    "source": ""
  },
  {
    "id": 2394,
    "question": "Chris is setting up a hotel network and needs to ensure that systems in each room or suite can connect to each other, but systems in other suites or rooms cannot. At the same time, he needs to ensure that all systems in the hotel can reach the internet. <br>What solution should he recommend as the most effective business solution?",
    "choice_a": "Per-room VPNs",
    "choice_b": "VLANs",
    "choice_c": "Port security",
    "choice_d": "Firewalls",
    "correct_answer": "B",
    "explanation": "VLANs can be used to logically separate groups of network ports while still providing access to an uplink. Per-room VPNs would create significant overhead for support as well as create additional expenses. Port security is used to limit what systems can connect to ports, but it doesn't provide network security between systems. Finally, while firewalls might work, they would add expense and complexity without adding any benefits over a VLAN solution.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      419,
      421,
      393,
      375,
      427
    ],
    "source": ""
  },
  {
    "id": 2395,
    "question": "During a forensic investigation, Charles is able to determine the Media Access Control (MAC) address of a system that was connected to a compromised network. Charles knows that MAC addresses are tied back to a manufacturer or vendor and are part of the fingerprint of the system. To which OSI layer does a MAC address belong?",
    "choice_a": "The Application layer",
    "choice_b": "The Session layer",
    "choice_c": "The Physical layer",
    "choice_d": "The Data Link layer",
    "correct_answer": "D",
    "explanation": "MAC addresses and their organizationally unique identifiers are used at the Data Link layer to identify systems on a network. The Application and Session layers don't care about physical addresses, while the Physical layer involves electrical connectivity and handling physical interfaces rather than addressing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      331,
      387,
      330,
      1012,
      338
    ],
    "source": ""
  },
  {
    "id": 2396,
    "question": "Mikayla is reviewing her organization's VoIP environment configuration and finds a diagram that shows the following design. <br><img src=\"/question_assets/CISSP/4_image5.png\"/><br>What concern should she express?",
    "choice_a": "The voice connection is unencrypted and could be listened to.",
    "choice_b": "There are no security issues in this diagram.",
    "choice_c": "The session initialization connection is unencrypted and could be viewed.",
    "choice_d": "Both the session initialization and voice data connection are unencrypted and could be captured and analyzed.",
    "correct_answer": "C",
    "explanation": "This diagram shows the use of SIP instead of SIPS, meaning that the session initialization protocol is not encrypted. Fortunately, the voice data via secure real-time transport protocol, or SRTP is encrypted. Mikayla should look into using SIPS in addition to SRTP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      353,
      395,
      438,
      396,
      397
    ],
    "source": ""
  },
  {
    "id": 2398,
    "question": "Jim's organization-wide implementation of IDaaS offers broad support for cloud-based applications. Jim's company does not have internal identity management staff and does not use centralized identity services. Instead, they rely upon Active Directory for AAA services. <br>Which of the following options should Jim recommend to best handle the company's on-site identity needs?",
    "choice_a": "Integrate on-site systems using OAuth.",
    "choice_b": "Use an on-premises third-party identity service.",
    "choice_c": "Integrate on-site systems using SAML.",
    "choice_d": "Design an internal solution to handle the organization's unique needs.",
    "correct_answer": "B",
    "explanation": "Since Jim's organization is using a cloud-based identity as a service solution, a third-party, on-premises identity service can provide the ability to integrate with the IDaaS solution, and the company's use of Active Directory is widely supported by third-party vendors. OAuth is used to log in to third-party websites using existing credentials and would not meet the needs described. SAML is a markup language and would not meet the full set of AAA needs. Since the organization is using Active Directory, a custom in-house solution is unlikely to be as effective as a preexisting third-party solution and may take far more time and expense to implement.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      452,
      451,
      476,
      453,
      441
    ],
    "source": ""
  },
  {
    "id": 2400,
    "question": "Voice pattern recognition is what type of authentication factor?",
    "choice_a": "Something you know",
    "choice_b": "Something you have",
    "choice_c": "Something you are",
    "choice_d": "Somewhere you are",
    "correct_answer": "C",
    "explanation": "Voice pattern recognition is \"something you are,\" a biometric authentication factor, because it measures a physical characteristic of the individual authenticating.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      443,
      445,
      459,
      461,
      748
    ],
    "source": ""
  },
  {
    "id": 2401,
    "question": "If Susan's organization requires her to log in with her username, a PIN, a password, and a retina scan, how many distinct authentication factor types has she used?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "B",
    "explanation": "Susan has used two distinct types of factors: the PIN and password are both Type 1 factors, and the retina scan is a Type 3 factor. Her username is not a factor.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      443,
      459,
      445,
      444,
      446
    ],
    "source": ""
  },
  {
    "id": 2402,
    "question": "Charles wants to deploy a credential management system (CMS). He wants to keep the keys as secure as possible. <br>Which of the following is the best design option for his CMS implementation?",
    "choice_a": "Use AES-256 instead of 3DES.",
    "choice_b": "Use long keys.",
    "choice_c": "Use an HSM.",
    "choice_d": "Change passphrases regularly.",
    "correct_answer": "C",
    "explanation": "Hardware Security Modules, or HSMs, are the most secure way to store keys associated with a CMS. They provide enhanced key management capabilities and are often required to be FIPS certified. In addition to these advantages, an HSM can improve cryptographic performance for the organization due to dedicated hardware designed for just that purpose. Long keys and using AES-256 are good practices, but an HSM provides greater security and will require appropriate cryptographic controls already. Changing passphrases can be challenging across an organization; instead, securing the passphrases and keys is more important and reasonable for most organizations.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      909,
      453,
      444,
      1059,
      447
    ],
    "source": ""
  },
  {
    "id": 2403,
    "question": "Brian is a researcher at a major university. As part of his research, he logs into a computing cluster hosted at another institution using his own university's credentials. Once logged in, he is able to access the cluster and use resources based on his role in a research project, as well as using resources and services in his home organization. <br>What has Brian's home university implemented to make this happen?",
    "choice_a": "Domain stacking",
    "choice_b": "Federated identity management",
    "choice_c": "Domain nesting",
    "choice_d": "Hybrid login",
    "correct_answer": "B",
    "explanation": "Brian's organization is using a federated identity management approach where multiple organizations allow identities to be used across the organizations. Each organization needs to proof their own staff members' identities and provide them with rights and role information that will allow them to use resources within the federated identity environment.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      474,
      460,
      452,
      481
    ],
    "source": ""
  },
  {
    "id": 2405,
    "question": "What major issue often results from decentralized access control?",
    "choice_a": "Access outages may occur.",
    "choice_b": "Control is not consistent.",
    "choice_c": "Control is too granular.",
    "choice_d": "Training costs are high.",
    "correct_answer": "B",
    "explanation": "Decentralized access control can result in less consistency because the individuals tasked with control may interpret policies and requirements differently and may perform their roles in different ways. Access outages, overly granular control, and training costs may occur, depending on specific implementations, but they are not commonly identified issues with decentralized access control.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      450,
      472,
      491,
      470,
      471
    ],
    "source": ""
  },
  {
    "id": 2406,
    "question": "Callback to a landline phone number is an example of what type of factor?",
    "choice_a": "Something you know",
    "choice_b": "Somewhere you are",
    "choice_c": "Something you have",
    "choice_d": "Something you are",
    "correct_answer": "B",
    "explanation": "A callback to a landline phone number is an example of a \"somewhere you are\" factor because of the fixed physical location of a wired phone. A callback to a mobile phone would be a \"something you have\" factor.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      745,
      746,
      747,
      446,
      443
    ],
    "source": ""
  },
  {
    "id": 2411,
    "question": "What type of access controls allow the owner of a file to grant other users access to it using an access control list?",
    "choice_a": "Role-based",
    "choice_b": "Nondiscretionary",
    "choice_c": "Rule-based",
    "choice_d": "Discretionary",
    "correct_answer": "D",
    "explanation": "When the owner of a file makes the decisions about who has rights or access privileges to it, they are using discretionary access control. Role-based access controls would grant access based on a subject's role, while rule-based controls would base the decision on a set of rules or requirements. Nondiscretionary access controls apply a fixed set of rules to an environment to manage access. Nondiscretionary access controls include rule-, role-, and lattice-based access controls.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      465,
      491,
      493,
      466,
      468
    ],
    "source": ""
  },
  {
    "id": 2412,
    "question": "Alex's job requires him to see protected health information (PHI) to ensure proper treatment of patients. His access to their medical records does not provide access to patient addresses or billing information. <br>What access control concept best describes this control?",
    "choice_a": "Separation of duties",
    "choice_b": "Constrained interfaces",
    "choice_c": "Context-dependent control",
    "choice_d": "Need to know",
    "correct_answer": "D",
    "explanation": "Need to know is applied when subjects like Alex have access to only the data they need to accomplish their job. Separation of duties is used to limit fraud and abuse by having multiple employees perform parts of a task. Constrained interfaces restrict what a user can see or do and would be a reasonable answer if need to know did not describe his access more completely in this scenario. Context-dependent control relies on the activity being performed to apply controls, and this question does not specify a workflow or process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      470,
      464,
      466,
      457,
      471
    ],
    "source": ""
  },
  {
    "id": 2416,
    "question": "Jacob is planning his organization's biometric authentication system and is considering retina scans. <br>What concern may be raised about retina scans by others in his organization?",
    "choice_a": "Retina scans can reveal information about medical conditions.",
    "choice_b": "Retina scans are painful because they require a puff of air in the user's eye.",
    "choice_c": "Retina scanners are the most expensive type of biometric device.",
    "choice_d": "Retina scanners have a high false positive rate and will cause support issues.",
    "correct_answer": "A",
    "explanation": "Retina scans can reveal additional information, including high blood pressure and pregnancy, causing privacy concerns. Newer retina scans don't require a puff of air, and retina scanners are not the most expensive biometric factor. Their false positive rate can typically be adjusted in software, allowing administrators to adjust their acceptance rate as needed to balance usability and security.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      749,
      748,
      750,
      443,
      446
    ],
    "source": ""
  },
  {
    "id": 2417,
    "question": "Mandatory access control is based on what type of model?",
    "choice_a": "Discretionary",
    "choice_b": "Group-based",
    "choice_c": "Lattice-based",
    "choice_d": "Rule-based",
    "correct_answer": "C",
    "explanation": "Mandatory access control systems are based on a lattice-based model. Lattice-based models use a matrix of classification labels to compartmentalize data. Discretionary access models allow object owners to determine access to the objects they control, role-based access controls are often group-based, and rule-based access controls like firewall ACLs apply rules to all subjects they apply to.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      472,
      491,
      465,
      466
    ],
    "source": ""
  },
  {
    "id": 2418,
    "question": "Greg wants to control access to iPads used throughout his organization as point-of-sale terminals. <br>Which of the following methods should he use to allow logical access control for the devices in a shared environment?",
    "choice_a": "Use a shared PIN for all point-of-sale terminals to make them easier to use.",
    "choice_b": "Use OAuth to allow cloud logins for each user.",
    "choice_c": "Issue a unique PIN to each user for the iPad they are issued.",
    "choice_d": "Use Active Directory and user accounts for logins to the iPads using the AD userID and password.",
    "correct_answer": "D",
    "explanation": "Using an enterprise authentication system like Active Directory that requires individuals to log in with their credentials provides the ability to determine who was logged in if a problem occurs and also allows Greg to quickly and easily remove users who are terminated or switch roles. Using a shared PIN provides no accountability, while unique PINs per user on specifically issued iPads mean that others will not be able to log in. OAuth alone does not provide the services and features Greg needs\u2014it is an authorization service, not an authentication service.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      1020,
      441,
      450,
      440
    ],
    "source": ""
  },
  {
    "id": 2419,
    "question": "What is the best way to provide accountability for the use of identities?",
    "choice_a": "Logging",
    "choice_b": "Authorization",
    "choice_c": "Digital signatures",
    "choice_d": "Type 1 authentication",
    "correct_answer": "A",
    "explanation": "Logging systems can provide accountability for identity systems by tracking the actions, changes, and other activities a user or account performs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1074,
      1073,
      479,
      457,
      927
    ],
    "source": ""
  },
  {
    "id": 2420,
    "question": "Jim has worked in human relations, payroll, and customer service roles in his company over the past few years. <br>What type of process should his company perform to ensure that he has appropriate rights?",
    "choice_a": "Re-provisioning",
    "choice_b": "Account review",
    "choice_c": "Privilege creep",
    "choice_d": "Account revocation",
    "correct_answer": "B",
    "explanation": "As an employee's role changes, they often experience privilege creep, which is the accumulation of old rights and roles. Account review is the process of reviewing accounts and ensuring that their rights match their owners' role and job requirements. Account revocation removes accounts, while re-provisioning might occur if an employee was terminated and returned or took a leave of absence and returned.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      457,
      458,
      466,
      455,
      456
    ],
    "source": ""
  },
  {
    "id": 2421,
    "question": "Biba is what type of access control model?",
    "choice_a": "MAC",
    "choice_b": "DAC",
    "choice_c": "Role BAC",
    "choice_d": "ABAC",
    "correct_answer": "A",
    "explanation": "Biba uses a lattice to control access and is a form of the mandatory access control (MAC) model. It does not use rules, roles, or attributes, nor does it allow user discretion. Users can create content at their level or lower but cannot decide who gets access, levels are not roles, and attributes are not used to make decisions on access control.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      491,
      472,
      465,
      466
    ],
    "source": ""
  },
  {
    "id": 2422,
    "question": "Which of the following is a client/server protocol designed to allow network access servers to authenticate remote users by sending access request messages to a central server?",
    "choice_a": "Kerberos",
    "choice_b": "EAP",
    "choice_c": "RADIUS",
    "choice_d": "OAuth",
    "correct_answer": "C",
    "explanation": "RADIUS is an AAA protocol used to provide authentication and authorization; it's often used for modems, wireless networks, and network devices. It uses network access servers to send access requests to central RADIUS servers. Kerberos is a ticket-based authentication protocol; OAuth is an open standard for authentication allowing the use of credentials from one site on third-party sites; and EAP is the Extensible Authentication Protocol, an authentication framework often used for wireless networks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      479,
      492,
      459,
      441,
      451
    ],
    "source": ""
  },
  {
    "id": 2423,
    "question": "Henry is working with a web application development team on their authentication and authorization process for his company's new application. The team wants to make session IDs as secure as possible. <br>Which of the following is not a best practice that Henry should recommend?",
    "choice_a": "The session ID token should be predictable.",
    "choice_b": "The session ID should have at least 64 bits of entropy.",
    "choice_c": "The session length should be at least 128 bits.",
    "choice_d": "The session ID should be meaningless.",
    "correct_answer": "A",
    "explanation": "Web application development best practices currently recommend the use of long session IDs (128 bits or longer) that have sufficient entropy (randomness) to ensure that they will not be easily duplicated or brute forced. It is also a best practice to make sure the session ID itself is meaningless to prevent information disclosure attacks. Session IDs should expire, however, because a session that never expires could eventually be brute forced even if all of these recommendations were met.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      454,
      976,
      978,
      977,
      460
    ],
    "source": ""
  },
  {
    "id": 2425,
    "question": "What type of access control best describes NAC's posture assessment capability?",
    "choice_a": "A mandatory access control",
    "choice_b": "A risk-based access control",
    "choice_c": "A discretionary access control",
    "choice_d": "A role-based access control",
    "correct_answer": "B",
    "explanation": "NAC's posturing capability determines if a system is sufficiently secure and compliant enough to connect to a network. This is a form of risk-based access control, as systems that are not compliant are considered higher risk and either are placed in a quarantine and remediation network or zone or are prohibited from connecting to the network until they are compliant.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      469,
      491,
      470,
      441,
      457
    ],
    "source": ""
  },
  {
    "id": 2426,
    "question": "When an application or system allows a logged-in user to perform specific actions, it is an example of what?",
    "choice_a": "Roles",
    "choice_b": "Group management",
    "choice_c": "Logins",
    "choice_d": "Authorization",
    "correct_answer": "D",
    "explanation": "Authorization provides a user with capabilities or rights. Roles and group management are both methods that could be used to match users with rights. Logins are used to validate a user.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      463,
      462,
      466,
      470,
      448
    ],
    "source": ""
  },
  {
    "id": 2427,
    "question": "Alex has been employed by his company for more than a decade and has held a number of positions in the company. During an audit, it is discovered that he has access to shared folders and applications because of his former roles. <br>What issue has Alex's company encountered?",
    "choice_a": "Excessive provisioning",
    "choice_b": "Unauthorized access",
    "choice_c": "Privilege creep",
    "choice_d": "Account review",
    "correct_answer": "C",
    "explanation": "Privilege creep occurs when users retain from roles they held previously rights they do not need to accomplish their current job. Unauthorized access occurs when an unauthorized user accesses files. Excessive provisioning is not a term used to describe permissions issues, and account review would help find issues like this.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      457,
      466,
      470,
      455,
      456
    ],
    "source": ""
  },
  {
    "id": 2428,
    "question": "Geoff wants to prevent privilege escalation attacks in his organization. <br>Which of the following practices is most likely to prevent horizontal privilege escalation?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Limiting permissions for groups and accounts",
    "choice_c": "Disabling unused ports and services",
    "choice_d": "Sanitizing user inputs to applications",
    "correct_answer": "A",
    "explanation": "Multifactor authentication is most likely to limit horizontal privilege escalation by making it difficult to access user accounts and to authenticate to a compromised account. Limiting permissions for groups and accounts can also help, but disabling unused ports and services and sanitizing user inputs both address threats that are most frequently associated with vertical privilege escalation attacks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      484,
      446,
      470,
      489,
      753
    ],
    "source": ""
  },
  {
    "id": 2429,
    "question": "Jim's Microsoft Exchange environment includes servers that are located in local data centers at multiple business offices around the world as well as an Office 365 deployment for employees who are not located at one of those offices. Identities are created and used in both environments and will work in both. <br>What type of federated system is Jim running?",
    "choice_a": "A primary cloud system",
    "choice_b": "A primary on-premise system",
    "choice_c": "A hybrid system",
    "choice_d": "A multitenant system",
    "correct_answer": "C",
    "explanation": "Hybrid systems use both on-premises and cloud identity and services to provide resources and tools in both environments. While they can be complex, hybrid systems also provide a migration path to a fully cloud deployment or for a fault tolerant design that can handle on-premises or cloud outages while remaining functional.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      452,
      451,
      460,
      476,
      441
    ],
    "source": ""
  },
  {
    "id": 2430,
    "question": "What type of access control scheme is shown in the following table? <br><img src=\"/question_assets/CISSP/5_image8.png\"/>",
    "choice_a": "RBAC",
    "choice_b": "DAC",
    "choice_c": "MAC",
    "choice_d": "TBAC",
    "correct_answer": "C",
    "explanation": "Mandatory access controls use a lattice or matrix to describe how classification labels relate to each other. In this image, classification levels are set for each of the labels shown. A discretionary access control (DAC) system would show how the owner of the objects allows access. RBAC could be either rule- or role-based access control and would use either system-wide rules or roles. Task-based access control (TBAC) would list tasks for users.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      472,
      466,
      467,
      463
    ],
    "source": ""
  },
  {
    "id": 2431,
    "question": "Michelle's company is creating a new division by splitting the marketing and communications departments into two separate groups. She wants to create roles that provide access to resources used by each group. <br>What should she do to maintain the appropriate security and rights for each group?",
    "choice_a": "Put both the marketing and communications teams into the existing group because they will have similar access requirements.",
    "choice_b": "Keep the marketing team in the existing group and create a new communications group based on their specific needs.",
    "choice_c": "Keep the communications team in the existing group and create a new marketing group based on their specific needs.",
    "choice_d": "Create two new groups, assess which rights they need to perform their roles, and then add additional rights if required.",
    "correct_answer": "D",
    "explanation": "Copying existing rights to new groups that have different needs will often result in overly broad privileges. Michelle should create new groups, move all staff into the appropriate groups, and then ensure that they have the access and permissions they need.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      466,
      470,
      458,
      457,
      465
    ],
    "source": ""
  },
  {
    "id": 2432,
    "question": "When a subject claims an identity, what process is occurring?",
    "choice_a": "Login",
    "choice_b": "Identification",
    "choice_c": "Authorization",
    "choice_d": "Token presentation",
    "correct_answer": "B",
    "explanation": "The process of a subject claiming or professing an identity is known as identification. Authorization verifies the identity of a subject by checking a factor like a password. Logins typically include both identification and authorization, and token presentation is a type of authentication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      441,
      461,
      448,
      443,
      446
    ],
    "source": ""
  },
  {
    "id": 2434,
    "question": "Susan's organization is updating its password policy and wants to use the strongest possible passwords. <br>What password requirement will have the highest impact in preventing brute-force attacks?",
    "choice_a": "Change maximum age from 1 year to 180 days.",
    "choice_b": "Increase the minimum password length from 8 characters to 16 characters.",
    "choice_c": "Increase the password complexity so that at least three character classes (such as uppercase, lowercase, numbers, and symbols) are required.",
    "choice_d": "Retain a password history of at least four passwords to prevent reuse.",
    "correct_answer": "B",
    "explanation": "Password complexity is driven by length, and a longer password will be more effective against brute-force attacks than a shorter password. Each character of additional length increases the difficulty by the size of the potential character set (for example, a single lowercase character makes the passwords 26 times more difficult to crack). While each of the other settings is useful for a strong password policy, they won't have the same impact on brute-force attacks.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      485,
      447,
      489,
      845,
      1058
    ],
    "source": ""
  },
  {
    "id": 2435,
    "question": "Alaina is performing a regularly scheduled review for service accounts. <br>Which of the following events should she be most concerned about?",
    "choice_a": "An interactive login for the service account",
    "choice_b": "A password change for the service account",
    "choice_c": "Limitations placed on the service account's rights",
    "choice_d": "Local use of the service account",
    "correct_answer": "A",
    "explanation": "Interactive login for a service account is a critical warning sign, either of compromise or bad administrative practices. In either case, Alaina should immediately work to determine why the account logged in, what occurred, and if the interactive login was done remotely or locally. A remote interactive login for a service account in any professionally maintained environment is an almost guaranteed sign of compromise. Password changes for service accounts may be done as part of ongoing password expiration processes, limitations should always be placed on service accounts rights to ensure that they are only those required, and a local use of the service account as part of the service is a normal event.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      926,
      927,
      457,
      490,
      449
    ],
    "source": ""
  },
  {
    "id": 2436,
    "question": "When might an organization using biometrics choose to allow a higher FRR instead of a higher FAR?",
    "choice_a": "When security is more important than usability",
    "choice_b": "When false rejection is not a concern due to data quality",
    "choice_c": "When the CER of the system is not known",
    "choice_d": "When the CER of the system is very high",
    "correct_answer": "A",
    "explanation": "Organizations that have very strict security requirements that don't have a tolerance for false acceptance want to lower the false acceptance rate, or FAR, to be as near to zero as possible. That often means that the false rejection rate, or FRR, increases. Different biometric technologies or a better registration method can help improve biometric performance, but false rejections due to data quality are not typically a concern with modern biometric systems. In this case, knowing the crossover error rate, or CER, or having a very high CER doesn't help the decision.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      459,
      748,
      749,
      750
    ],
    "source": ""
  },
  {
    "id": 2437,
    "question": "After recent reports of undesired access to workstations after hours, Derek has been asked to find a way to ensure that maintenance staff cannot log in to workstations in business offices. The maintenance staff members do have systems in their break rooms and their offices for the organization, which they still need access to. <br>What should Derek do to meet this need?",
    "choice_a": "Require multifactor authentication and only allow office staff to have multifactor tokens.",
    "choice_b": "Use rule-based access control to prevent logins after hours in the business area.",
    "choice_c": "Use role-based access control by setting up a group that contains all maintenance staff and then give that group rights to log into only the designated workstations.",
    "choice_d": "Use geofencing to only allow logins in maintenance areas.",
    "correct_answer": "C",
    "explanation": "The most efficient use of Derek's time would be to create a group that is populated with all maintenance staff and then to give that group login rights only to the designated PCs. While time-based constraints might help, in this case, it would continue to allow maintenance staff to log in to PCs they are not intended for use during business hours, leaving a gap in the control. Multifactor authentication as described does not meet the requirements of the scenario but may be a good idea overall for greater security for authentication across the organization. Geofencing is typically not accurate enough to rely on inside of buildings for specific PCs.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      472,
      470,
      465,
      471,
      462
    ],
    "source": ""
  },
  {
    "id": 2438,
    "question": "Nick wants to do session management for his web application. <br>Which of the following are common web application session management techniques or methods?  (Select all that apply.)",
    "choice_a": "IP tracking",
    "choice_b": "Cookies",
    "choice_c": "URL rewriting",
    "choice_d": "TLS tokens",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Common session management techniques include the use of cookies, hidden form fields, URL rewriting, and built-in frameworks like Java's HTTPSession. IP tracking may be included in session information but is not itself a complete session identifier, and TLS token binding is used to make TLS sessions more secure, not to provide session identification.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      454,
      976,
      460,
      451,
      477
    ],
    "source": ""
  },
  {
    "id": 2439,
    "question": "Alex is in charge of SAML integration with a major third-party partner that provides a variety of business productivity services for his organization. <br>Alex is concerned about eavesdropping on the SAML traffic and also wants to ensure that forged assertions will not be successful. <br><img src=\"/question_assets/CISSP/5_image3.png\"/><br>What should he do to prevent these potential attacks?",
    "choice_a": "Use SAML's secure mode to provide secure authentication.",
    "choice_b": "Implement TLS using a strong cipher suite, which will protect against both types of attacks.",
    "choice_c": "Implement TLS using a strong cipher suite and use digital signatures.",
    "choice_d": "Implement TLS using a strong cipher suite and message hashing.",
    "correct_answer": "C",
    "explanation": "TLS provides message confidentiality and integrity, which can prevent eavesdropping. When paired with digital signatures, which provide integrity and authentication, forged assertions can also be defeated. SAML does not have a security mode and relies on TLS and digital signatures to ensure security if needed. Message hashing without a signature would help prevent modification of the message but won't necessarily provide authentication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      474,
      481,
      488,
      476,
      903
    ],
    "source": ""
  },
  {
    "id": 2440,
    "question": "Alex is in charge of SAML integration with a major third-party partner that provides a variety of business productivity services for his organization. <br>If Alex's organization is one that is primarily made up of off-site, traveling users, what availability risk does integration of critical business applications to on-site authentication create, and how could he solve it? <br><img src=\"/question_assets/CISSP/5_image3.png\"/>",
    "choice_a": "Third-party integration may not be trustworthy; use SSL and digital signatures.",
    "choice_b": "If the home organization is offline, traveling users won't be able to access third-party applications; implement a hybrid cloud/local authentication system.",
    "choice_c": "Local users may not be properly redirected to the third-party services; implement a local gateway.",
    "choice_d": "Browsers may not properly redirect; use host files to ensure that issues with redirects are resolved.",
    "correct_answer": "B",
    "explanation": "Integration with cloud-based third parties that rely on local authentication can fail if the local organization's internet connectivity or servers are offline. Adopting a hybrid cloud and local authentication system can ensure that internet or server outages are handled, allowing authentication to work regardless of where the user is or if their home organization is online. Using encrypted and signed communication does not address availability, redirects are a configuration issue with the third party, and a local gateway won't handle remote users. Also, host files don't help with availability issues with services other than DNS.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      452,
      476,
      759,
      903,
      478
    ],
    "source": ""
  },
  {
    "id": 2441,
    "question": "Alex is in charge of SAML integration with a major third-party partner that provides a variety of business productivity services for his organization. <br>What solution can best help address concerns about third parties that control SSO redirects as shown in step 2 in the diagram? <br><img src=\"/question_assets/CISSP/5_image3.png\"/>",
    "choice_a": "An awareness campaign about trusted third parties",
    "choice_b": "TLS",
    "choice_c": "Handling redirects at the local site",
    "choice_d": "Implementing an IPS to capture SSO redirect attacks",
    "correct_answer": "A",
    "explanation": "While many solutions are technical, if a trusted third party redirects to an unexpected authentication site, awareness is often the best defense. Using TLS would keep the transaction confidential but would not prevent the redirect. Handling redirects locally works only for locally hosted sites, and using a third-party service requires off-site redirects. An IPS might detect an attacker's redirect, but tracking the multitude of load-balanced servers most large providers use can be challenging, if not impossible. In addition, an IPS relies on visibility into the traffic, and SAML integrations should be encrypted for security, which would require a man-in-the-middle type of IPS to be configured.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      474,
      476,
      903,
      471,
      481
    ],
    "source": ""
  },
  {
    "id": 2442,
    "question": "Susan has been asked to recommend whether her organization should use a MAC scheme or a DAC scheme. If flexibility and scalability are important requirements for implementing access controls, which scheme should she recommend and why?",
    "choice_a": "MAC, because it provides greater scalability and flexibility because you can simply add more labels as needed",
    "choice_b": "DAC, because allowing individual administrators to make choices about the objects they control provides scalability and flexibility",
    "choice_c": "MAC, because compartmentalization is well suited to flexibility and adding compartments will allow it to scale well",
    "choice_d": "DAC, because a central decision process allows quick responses and will provide scalability by reducing the number of decisions required and flexibility by moving those decisions to a central authority",
    "correct_answer": "B",
    "explanation": "Discretionary access control (DAC) can provide greater scalability by leveraging many administrators, and those administrators can add flexibility by making decisions about access to their objects without fitting into an inflexible mandatory access control system (MAC). MAC is more secure due to the strong set of controls it provides, but it does not scale as well as DAC and is relatively inflexible in comparison.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      465,
      468,
      472,
      491,
      493
    ],
    "source": ""
  },
  {
    "id": 2443,
    "question": "Which of the following tools is not typically used to verify that a provisioning process was followed in a way that ensures that the organization's security policy is being followed?",
    "choice_a": "Log review",
    "choice_b": "Manual review of permissions",
    "choice_c": "Signature-based detection",
    "choice_d": "Review the audit trail",
    "correct_answer": "C",
    "explanation": "While signature-based detection is used to detect attacks, review of provisioning processes typically involves checking logs, reviewing the audit trail, or performing a manual review of permissions granted during the provisioning process.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      455,
      457,
      441,
      471,
      460
    ],
    "source": ""
  },
  {
    "id": 2445,
    "question": "During a penetration test, Chris recovers a file containing hashed passwords for the system he is attempting to access. <br>What type of attack is most likely to succeed against the hashed passwords?",
    "choice_a": "A brute-force attack",
    "choice_b": "A pass-the-hash attack",
    "choice_c": "A rainbow table attack",
    "choice_d": "A salt recovery attack",
    "correct_answer": "C",
    "explanation": "Rainbow tables are databases of pre-hashed passwords paired with high-speed lookup functions. Since they can quickly compare known hashes against those in a file, using rainbow tables is the fastest way to quickly determine passwords from hashes. A brute-force attack may eventually succeed but will be very slow against most hashes. Pass-the-hash attacks rely on sniffed or otherwise acquired NTLM or LanMan hashes being sent to a system to avoid the need to know a user's password. Salts are data added to a hash to avoid the use of tools like rainbow tables. A salt added to a password means the hash won't match a rainbow table generated without the same salt.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      486,
      485,
      1058,
      489,
      488
    ],
    "source": ""
  },
  {
    "id": 2446,
    "question": "Google's identity integration with a variety of organizations and applications across domains is an example of which of the following?",
    "choice_a": "PKI",
    "choice_b": "Federation",
    "choice_c": "Single sign-on",
    "choice_d": "Provisioning",
    "correct_answer": "B",
    "explanation": "Google's federation with other applications and organizations allows single sign-on as well as management of their electronic identity and its related attributes. While this is an example of SSO, it goes beyond simple single sign-on. Provisioning provides accounts and rights, and a public key infrastructure is used for certificate management.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      480,
      451,
      460,
      452,
      481
    ],
    "source": ""
  },
  {
    "id": 2447,
    "question": "Amanda starts at her new job and finds that she has access to a variety of systems that she does not need to accomplish her job. <br>What problem has she encountered?",
    "choice_a": "Privilege creep",
    "choice_b": "Rights collision",
    "choice_c": "Least privilege",
    "choice_d": "Excessive privileges",
    "correct_answer": "D",
    "explanation": "When users have more rights than they need to accomplish their job, they have excessive privileges. This is a violation of the concept of least privilege. Unlike creeping privileges, this is a provisioning or rights management issue rather than a problem of retention of rights the user needed but no longer requires. Rights collision is a made-up term and thus is not an issue here.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      457,
      925,
      455,
      462,
      471
    ],
    "source": ""
  },
  {
    "id": 2448,
    "question": "When Chris verifies an individual's identity and adds a unique identifier like a user ID to an identity system, what process has occurred?",
    "choice_a": "Identity proofing",
    "choice_b": "Registration",
    "choice_c": "Directory management",
    "choice_d": "Session management",
    "correct_answer": "B",
    "explanation": "Registration is the process of adding a user to an identity management system. This includes creating their unique identifier and adding any attribute information that is associated with their identity. Proofing occurs when the user provides information to prove who they are. Directories are managed to maintain lists of users, services, and other items. Session management tracks application and user sessions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      442,
      455,
      460,
      454,
      451
    ],
    "source": ""
  },
  {
    "id": 2449,
    "question": "Selah wants to provide accountability for actions performed via her organization's main line of business application. <br>What controls are most frequently used to provide accountability in a situation like this?  (Select all that apply.)",
    "choice_a": "Enable audit logging.",
    "choice_b": "Provide every staff member with a unique account and enable multifactor authentication.",
    "choice_c": "Enable time- and location-based login requirements.",
    "choice_d": "Provide every staff member with a unique account and require a self-selected password.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Audit logging when combined with user accounts that can reliably be expected to only be accessible to a specific user due to the use of multifactor authentication is frequently used to provide strong accountability for actions taken via systems and applications. A password can be shared, making it less reliable, and time and location requirements are useful security controls but do not impact accountability.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1073,
      1074,
      489,
      443,
      457
    ],
    "source": ""
  },
  {
    "id": 2450,
    "question": "Charles wants to provide authorization services as part of his web application. <br>What standard should he use if he wants to integrate easily with other web identity providers?",
    "choice_a": "OpenID",
    "choice_b": "TACACS+",
    "choice_c": "RADIUS",
    "choice_d": "OAuth",
    "correct_answer": "D",
    "explanation": "OAuth is the most widely used open standard for authorization and delegation of rights for cloud services. OpenID is used for authentication, and TACAC+ and RADIUS are primarily used on-site for authentication and authorization for network devices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      476,
      757,
      475,
      758,
      1020
    ],
    "source": ""
  },
  {
    "id": 2451,
    "question": "The company that Cameron works for uses a system that allows users to request privileged access to systems when necessary. Cameron requests access, and the request is pre-approved due to his role. He is then able to access the system to perform the task. Once he is done, the rights are removed. <br>What type of system is he using?",
    "choice_a": "Zero trust",
    "choice_b": "Federated identity management",
    "choice_c": "Single sign-on",
    "choice_d": "Just-in-time access",
    "correct_answer": "D",
    "explanation": "Cameron is using a just-in-time (JIT) system that provides the access needed when it is needed. A zero trust system requires authentication and authorization when actions are performed but does not necessarily require privileges to be granted and removed when they are needed.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      469,
      466,
      470,
      457,
      441
    ],
    "source": ""
  },
  {
    "id": 2452,
    "question": "Elle is responsible for building a banking website. She needs proof of the identity of the users who register for the site. <br>How should she validate user identities?",
    "choice_a": "Require users to create unique questions that only they will know.",
    "choice_b": "Require new users to bring their driver's license or passport in person to the bank.",
    "choice_c": "Use information that both the bank and the user have such as questions pulled from their credit report.",
    "choice_d": "Call the user on their registered phone number to verify that they are who they claim to be.",
    "correct_answer": "C",
    "explanation": "Identity proofing can be done by comparing user information that the organization already has, like account numbers or personal information. Requiring users to create unique questions can help with future support by providing a way for them to do password resets. Using a phone call only verifies that the individual who created the account has the phone that they registered and won't prove their identity. In-person verification would not fit the business needs of most websites.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      442,
      459,
      455,
      441,
      461
    ],
    "source": ""
  },
  {
    "id": 2453,
    "question": "Susan's organization is part of a federation that allows users from multiple organizations to access resources and services at other federated sites. When Susan wants to use a service at a partner site, which identity provider is used?",
    "choice_a": "Susan's home organization's identity provider",
    "choice_b": "The service provider's identity provider",
    "choice_c": "Both their identity provider and the service provider's identity provider",
    "choice_d": "The service provider creates a new identity",
    "correct_answer": "A",
    "explanation": "Federations use a user's home organization's identity provider (IDP). Service providers query those identity providers when the user attempts to authenticate to the service and, if the request is validated, allow access based on the rules and policies set for the service based on attributes that may be relevant that are provided by the IDP.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      474,
      480,
      451,
      452,
      476
    ],
    "source": ""
  },
  {
    "id": 2454,
    "question": "A new customer at a bank that uses fingerprint scanners to authenticate its users is surprised when he scans his fingerprint and is logged in to another customer's account. <br>What type of biometric factor error occurred?",
    "choice_a": "A registration error",
    "choice_b": "A Type 1 error",
    "choice_c": "A Type 2 error",
    "choice_d": "A time of use, method of use error",
    "correct_answer": "C",
    "explanation": "Type 2 errors occur in biometric systems when an invalid subject is incorrectly authenticated as a valid user. In this case, nobody except the actual customer should be validated when fingerprints are scanned. Type 1 errors occur when a valid subject is not authenticated; if the existing customer was rejected, it would be a Type 1 error. Registration is the process of adding users, but registration errors and time of use, method of use errors are not specific biometric authentication terms.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      459,
      443,
      748,
      442
    ],
    "source": ""
  },
  {
    "id": 2455,
    "question": "What type of access control is typically used by firewalls?",
    "choice_a": "Discretionary access controls",
    "choice_b": "Rule-based access controls",
    "choice_c": "Task-based access control",
    "choice_d": "Mandatory access controls",
    "correct_answer": "B",
    "explanation": "Firewalls use rule-based access control, or Rule-BAC, in their access control lists and apply rules created by administrators to all traffic that passes through them. DAC, or discretionary access control, allows owners to determine who can access objects they control, while task-based access control lists tasks for users. MAC, or mandatory access control, uses classifications to determine access.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      467,
      472,
      463,
      465,
      468
    ],
    "source": ""
  },
  {
    "id": 2456,
    "question": "When you input a user ID and password, you are performing what important identity and access management activity?",
    "choice_a": "Authorization",
    "choice_b": "Validation",
    "choice_c": "Authentication",
    "choice_d": "Login",
    "correct_answer": "C",
    "explanation": "When you input a username and password, you are authenticating yourself by providing a unique identifier and a verification that you are the person who should have that identifier (the password). Authorization is the process of determining what a user is allowed to do. Validation and login both describe elements of what is happening in the process; however, they aren't the most important identity and access management activity.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      441,
      443,
      446,
      442,
      489
    ],
    "source": ""
  },
  {
    "id": 2457,
    "question": "Kathleen works for a data center hosting facility that provides physical data center space for individuals and organizations. Until recently, each client was given a magnetic-strip-based keycard to access the section of the facility where their servers are located, and they were also given a key to access the cage or rack where their servers reside. In the past month, a number of servers have been stolen, but the logs for the passcards show only valid IDs. <br>What is Kathleen's best option to make sure that the users of the passcards are who they are supposed to be?",
    "choice_a": "Add a reader that requires a PIN for passcard users.",
    "choice_b": "Add a camera system to the facility to observe who is accessing servers.",
    "choice_c": "Add a biometric factor.",
    "choice_d": "Replace the magnetic stripe keycards with smartcards.",
    "correct_answer": "C",
    "explanation": "Kathleen should implement a biometric factor. The cards and keys are an example of a Type 2 factor, or \"something you have.\" Using a smart card replaces this with another Type 2 factor, but the cards could still be loaned out or stolen. Adding a PIN suffers from the same problem: a PIN can be stolen. Adding cameras doesn't prevent access to the facility and thus doesn't solve the immediate problem (but it is a good idea!).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      443,
      446,
      444,
      750
    ],
    "source": ""
  },
  {
    "id": 2458,
    "question": "Theresa wants to allow her staff to securely store and manage passwords for systems including service accounts and other rarely used administrative credentials. <br>What type of tool should she implement to enable this?",
    "choice_a": "Single sign-on",
    "choice_b": "A federated identity system",
    "choice_c": "A password manager",
    "choice_d": "A multifactor authentication system",
    "correct_answer": "C",
    "explanation": "Enterprise password management tools allow passwords to be securely generated, stored, and managed. They can provide logs of who uses passwords, when they were updated, and if they meet complexity and other requirements. Of course, this means that the keys to your environment are all in one place, so securing and managing the enterprise password manager is very important!",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      453,
      447,
      457,
      927,
      441
    ],
    "source": ""
  },
  {
    "id": 2459,
    "question": "Olivia wants to limit the commands that a user can run via <code>sudo</code> to limit the potential for privilege escalation attacks. <br>What Linux file should she modify to allow this?",
    "choice_a": "The bash <code>.bin</code> configuration file",
    "choice_b": "The <code>sudoers</code> file",
    "choice_c": "The bash <code>.allowed</code> configuration file",
    "choice_d": "The <code>sudont</code> file",
    "correct_answer": "B",
    "explanation": "The <code>sudoers</code> file can list the specific users who can use <code>sudo</code> as well as the commands or directories that are allowed for them.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      752,
      1073,
      751,
      753,
      470
    ],
    "source": ""
  },
  {
    "id": 2460,
    "question": "Which objects and subjects have a label in a MAC model?",
    "choice_a": "Objects and subjects that are classified as Confidential, Secret, or Top Secret have a label.",
    "choice_b": "All objects have a label, and all subjects have a compartment.",
    "choice_c": "All objects and subjects have a label.",
    "choice_d": "All subjects have a label and all objects have a compartment.",
    "correct_answer": "C",
    "explanation": "In a mandatory access control system, all subjects and objects have a label. Compartments may or may not be used, but there is not a specific requirement for either subjects or objects to be compartmentalized. The specific labels of Confidential, Secret, and Top Secret are not required by MAC.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      491,
      472,
      462,
      463
    ],
    "source": ""
  },
  {
    "id": 2461,
    "question": "Chris is the identity architect for a growing e-commerce website that wants to leverage social identity. To do this, he and his team intend to allow users to use their existing Google accounts as their primary accounts when using the e-commerce site. This means that when a new user initially connects to the e-commerce platform, they are given the choice between using their Google account using OAuth 2.0 or creating a new account on the platform using their own email address and a password of their choice. <br><img src=\"/question_assets/CISSP/5_image4.png\"/><br>When the e-commerce application creates an account for a Google user, where should that user's password be stored?",
    "choice_a": "The password is stored in the e-commerce application's database.",
    "choice_b": "The password is stored in memory on the e-commerce application's server.",
    "choice_c": "The password is stored in Google's account management system.",
    "choice_d": "The password is never stored; instead, a salted hash is stored in Google's account management system.",
    "correct_answer": "D",
    "explanation": "Passwords are never stored for web applications in a well-designed environment. Instead, salted hashes are stored and compared to passwords after they are salted and hashed. If the hashes match, the user is authenticated.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      489,
      485,
      844,
      475,
      476
    ],
    "source": ""
  },
  {
    "id": 2462,
    "question": "Chris is the identity architect for a growing e-commerce website that wants to leverage social identity. To do this, he and his team intend to allow users to use their existing Google accounts as their primary accounts when using the e-commerce site. This means that when a new user initially connects to the e-commerce platform, they are given the choice between using their Google account using OAuth 2.0 or creating a new account on the platform using their own email address and a password of their choice. <br><img src=\"/question_assets/CISSP/5_image4.png\"/><br>Which of the following is responsible for user authentication for Google users?",
    "choice_a": "The e-commerce application.",
    "choice_b": "Both the e-commerce application and Google servers.",
    "choice_c": "Google servers.",
    "choice_d": "The diagram does not provide enough information to determine this.",
    "correct_answer": "C",
    "explanation": "When a third-party site integrates via OAuth 2.0, authentication is handled by the service provider's servers. In this case, Google is acting as the service provider for user authentication. Authentication for local users who create their own accounts would occur in the e-commerce application (or a related server), but that is not the question that is asked here.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      476,
      475,
      474,
      1020,
      453
    ],
    "source": ""
  },
  {
    "id": 2463,
    "question": "Chris is the identity architect for a growing e-commerce website that wants to leverage social identity. To do this, he and his team intend to allow users to use their existing Google accounts as their primary accounts when using the e-commerce site. This means that when a new user initially connects to the e-commerce platform, they are given the choice between using their Google account using OAuth 2.0 or creating a new account on the platform using their own email address and a password of their choice. <br><img src=\"/question_assets/CISSP/5_image4.png\"/><br>What type of attack is the creation and exchange of state tokens intended to prevent?",
    "choice_a": "XSS",
    "choice_b": "CSRF",
    "choice_c": "SQL injection",
    "choice_d": "XACML",
    "correct_answer": "B",
    "explanation": "The anti-forgery state token exchanged during OAuth sessions is intended to prevent cross-site request forgery. This makes sure that the unique session token with the authentication response from Google's OAuth service is available to verify that the user, not an attacker, is making a request. XSS attacks focus on scripting and would have script tags involved, SQL injection would have SQL code included, and XACML is the eXtensible Access Control Markup Language, not a type of attack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      475,
      474,
      489,
      481,
      476
    ],
    "source": ""
  },
  {
    "id": 2464,
    "question": "Questions like \"What is your pet's name?\" are examples of what type of identity proofing?",
    "choice_a": "Knowledge-based authentication",
    "choice_b": "Dynamic knowledge-based authentication",
    "choice_c": "Out-of-band identity proofing",
    "choice_d": "A Type 3 authentication factor",
    "correct_answer": "A",
    "explanation": "Knowledge-based authentication relies on preset questions such as \"What is your pet's name?\" and the answers. It can be susceptible to attacks because of the availability of the answers on social media or other sites. Dynamic knowledge-based authentication relies on facts or data that the user already knows that can be used to create questions they can answer on an as-needed basis (for example, a previous address or a school they attended). Out-of-band identity proofing relies on an alternate channel like a phone call or text message. Finally, Type 3 authentication factors are biometric, or \"something you are,\" rather than knowledge-based.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      442,
      459,
      443,
      446,
      489
    ],
    "source": ""
  },
  {
    "id": 2465,
    "question": "Madhuri creates a table that includes assigned privileges, objects, and subjects to manage access control for the systems she is responsible for. Each time a subject attempts to access an object, the systems check the table to ensure that the subject has the appropriate rights to the objects. <br>What type of access control system is Madhuri using?",
    "choice_a": "A capability table",
    "choice_b": "An access control list",
    "choice_c": "An access control matrix",
    "choice_d": "A subject/object rights management system",
    "correct_answer": "C",
    "explanation": "An access control matrix is a table that lists objects, subjects, and their privileges. Access control lists focus on objects and which subjects can access them. Capability tables list subjects and what objects they can access. Subject/object rights management systems are not based on an access control model.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      463,
      465,
      466,
      491,
      472
    ],
    "source": ""
  },
  {
    "id": 2466,
    "question": "During a review of support tickets, Ben's organization discovered that password changes accounted for more than a quarter of its help desk's cases. <br>Which of the following options would be most likely to decrease that number significantly?",
    "choice_a": "Two-factor authentication",
    "choice_b": "Biometric authentication",
    "choice_c": "Self-service password reset",
    "choice_d": "Passphrases",
    "correct_answer": "C",
    "explanation": "Self-service password reset tools typically have a significant impact on the number of password reset contacts that a help desk has. Two-factor and biometric authentication both add complexity and may actually increase the number of contacts. Passphrases can be easier to remember than traditional complex passwords and may decrease calls, but they don't have the same impact that a self-service system does.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      755,
      756,
      754,
      443,
      750
    ],
    "source": ""
  },
  {
    "id": 2467,
    "question": "Brian's large organization has used RADIUS for AAA services for its network devices for years and has recently become aware of security issues with the unencrypted information transferred during authentication. <br>How should Brian implement encryption for RADIUS?",
    "choice_a": "Use the built-in encryption in RADIUS.",
    "choice_b": "Implement RADIUS over its native UDP using TLS for protection.",
    "choice_c": "Implement RADIUS over TCP using TLS for protection.",
    "choice_d": "Use an AES256 pre-shared cipher between devices.",
    "correct_answer": "C",
    "explanation": "RADIUS supports TLS over TCP. RADIUS does not have a supported TLS mode over UDP. AES pre-shared symmetric ciphers are not a supported solution and would be difficult to both implement and maintain in a large environment, and the built-in encryption in RADIUS only protects passwords.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      479,
      492,
      488,
      459,
      441
    ],
    "source": ""
  },
  {
    "id": 2468,
    "question": "Jim wants to allow cloud-based applications to act on his behalf to access information from other sites. <br>Which of the following tools can allow that?",
    "choice_a": "Kerberos",
    "choice_b": "OAuth",
    "choice_c": "OpenID",
    "choice_d": "LDAP",
    "correct_answer": "B",
    "explanation": "OAuth provides the ability to access resources from another service and would meet Jim's needs. OpenID would allow him to use an account from another service with his application, and Kerberos and LDAP are used more frequently for in-house services.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      758,
      1020,
      476,
      475,
      492
    ],
    "source": ""
  },
  {
    "id": 2469,
    "question": "Ben's organization has had an issue with unauthorized access to applications and workstations during the lunch hour when employees aren't at their desk. <br>What are the best types of session management solutions for Ben to recommend to help prevent this type of access?",
    "choice_a": "Use session IDs for all access and verify system IP addresses of all workstations.",
    "choice_b": "Set session timeouts for applications and use password-protected screensavers with inactivity timeouts on workstations.",
    "choice_c": "Use session IDs for all applications, and use password-protected screensavers with inactivity timeouts on workstations.",
    "choice_d": "Set session timeouts for applications and verify system IP addresses of all workstations.",
    "correct_answer": "B",
    "explanation": "Since physical access to the workstations is part of the problem, setting application timeouts and password-protected screensavers with relatively short inactivity timeouts can help prevent unauthorized access. Using session IDs for all applications and verifying system IP addresses would be helpful for online attacks against applications.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      454,
      976,
      978,
      440,
      461
    ],
    "source": ""
  },
  {
    "id": 2470,
    "question": "What type of authentication scenario is shown in the following diagram? <br><img src=\"/question_assets/CISSP/5_image5.png\"/>",
    "choice_a": "Hybrid federation",
    "choice_b": "On-premise federation",
    "choice_c": "Cloud federation",
    "choice_d": "Kerberos federation",
    "correct_answer": "A",
    "explanation": "This diagram shows an example of hybrid federation where authentication occurs on-premises and services are provided through a federated identity service in the cloud.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      452,
      480,
      474,
      460,
      451
    ],
    "source": ""
  },
  {
    "id": 2471,
    "question": "Chris wants to control access to his facility while still identifying individuals. He also wants to ensure that the individuals are the people who are being admitted without significant ongoing costs. <br>Which solutions from the following options would meet all of these requirements?  (Select all that apply.)",
    "choice_a": "Security guards and photo identification badges",
    "choice_b": "RFID badges and readers with PIN pads",
    "choice_c": "Magstripe badges and readers with PIN pads",
    "choice_d": "Security guards and magstripe readers",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The best answers in the scenario that Chris faces are either RFID or magstripe readers and PIN pads. Guards create ongoing expenses, and any solution without a PIN will allow a stolen or cloned badge to be used without validating that the person accessing the building is a legitimate user. While a guard can prevent a stolen badge and PIN combination, this is only used in environments where the cost is justifiable.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      443,
      745,
      489,
      445,
      483
    ],
    "source": ""
  },
  {
    "id": 2472,
    "question": "A device like Yubikey or Titan Security Key is what type of Type 2 authentication factor?",
    "choice_a": "A token",
    "choice_b": "A biometric identifier",
    "choice_c": "A smart card",
    "choice_d": "A PIV",
    "correct_answer": "A",
    "explanation": "Yubikeys, Titan Security Keys, and similar devices are examples of tokens. PIV stands for personal identity verification and is a full multifactor authentication solution, not a device. Biometric identifiers are something you are, and a smart card is a card with an embedded chip.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      444,
      443,
      745,
      446,
      459
    ],
    "source": ""
  },
  {
    "id": 2473,
    "question": "What authentication technology can be paired with OAuth to perform identity verification and obtain user profile information using a RESTful API?",
    "choice_a": "SAML",
    "choice_b": "Shibboleth",
    "choice_c": "OpenID Connect",
    "choice_d": "Higgins",
    "correct_answer": "C",
    "explanation": "OpenID Connect is a RESTful, JSON-based authentication protocol that, when paired with OAuth, can provide identity verification and basic profile information. SAML is the Security Assertion Markup Language, Shibboleth is a federated identity solution designed to allow web-based SSO, and Higgins is an open source project designed to provide users with control over the release of their identity information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      476,
      475,
      492,
      899,
      758
    ],
    "source": ""
  },
  {
    "id": 2474,
    "question": "Jim wants to implement an access control scheme that will ensure that users cannot delegate access. He also wants to enforce access control at the operating system level. <br>What access control mechanism best fits these requirements?",
    "choice_a": "Role-based access control",
    "choice_b": "Discretionary access control",
    "choice_c": "Mandatory access control",
    "choice_d": "Attribute-based access control",
    "correct_answer": "C",
    "explanation": "In a mandatory access control system, the operating system enforces access control, and users cannot delegate rights. Discretionary access control allows users to delegate rights, and neither attribute nor role-based access control specifically meets these requirements.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      465,
      491,
      472,
      470
    ],
    "source": ""
  },
  {
    "id": 2476,
    "question": "Ben uses a software-based token that changes its code every minute. <br>What type of token is he using?",
    "choice_a": "Asynchronous",
    "choice_b": "Smart card",
    "choice_c": "Synchronous",
    "choice_d": "Static",
    "correct_answer": "C",
    "explanation": "Synchronous soft tokens, such as Google Authenticator, use a time-based algorithm that generates a constantly changing series of codes. Asynchronous tokens typically require a challenge to be entered on the token to allow it to calculate a response, which the server compares to the response it expects. Smartcards typically present a certificate but may have other token capabilities built-in. Static tokens are physical devices that can contain credentials and include smart cards and memory cards.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      444,
      443,
      745,
      489,
      453
    ],
    "source": ""
  },
  {
    "id": 2478,
    "question": "Michelle works for a financial services company and wants to register customers for her web application. <br>What type of authentication mechanism could she use for the initial login if she wants to quickly and automatically verify that the person is who they claim to be without having a previous relationship with them?",
    "choice_a": "Request their Social Security number.",
    "choice_b": "Use knowledge-based authentication.",
    "choice_c": "Perform manual identity verification.",
    "choice_d": "Use a biometric factor.",
    "correct_answer": "B",
    "explanation": "Knowledge-based authentication is used by some financial institutions to validate the identity of new users. It uses information from tax and financial records that is unlikely to be available to others, allowing new users to provide details like their last credit card payment, mortgage payment, or other information to validate their identity. A Social Security number is somewhat trivial to acquire via paid services or other means, and manually validating identities is neither quick nor automatic. A biometric factor would require a previous enrollment, making this unsuitable for new customers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      442,
      443,
      445,
      750,
      455
    ],
    "source": ""
  },
  {
    "id": 2479,
    "question": "Megan's company wants to use Google accounts to allow users to quickly adopt their web application. <br>What common cloud federation technologies will Megan need to implement? (Select all that apply.)",
    "choice_a": "Kerberos",
    "choice_b": "OpenID",
    "choice_c": "OAuth",
    "choice_d": "RADIUS",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Google accounts like many cloud identity providers rely on OpenID and OAuth. Kerberos is used for on-premises environments, and RADIUS is frequently used for authentication and authorization for network devices and services like VPN.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      476,
      1020,
      492,
      757,
      451
    ],
    "source": ""
  },
  {
    "id": 2480,
    "question": "Session ID length and session ID entropy are both important to prevent what type of attack?",
    "choice_a": "Denial of service",
    "choice_b": "Cookie theft",
    "choice_c": "Session guessing",
    "choice_d": "Man-in-the-middle attacks",
    "correct_answer": "C",
    "explanation": "Best practices for session management involve a long session ID (often 128 bits or longer) and enough randomness or entropy to make it hard to guess session IDs. This makes brute-force or algorithmic guessing attacks unlikely unless there is a flaw in the implementation. These do not prevent denial-of-service or man-in-the-middle attacks, and cookie attacks are focused on acquiring and reading or reusing cookies in most scenarios.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      454,
      1059,
      485,
      486,
      483
    ],
    "source": ""
  },
  {
    "id": 2482,
    "question": "Isabelle wants to prevent privilege escalation attacks via her organization's service accounts. <br>Which of the following security practices is best suited to this?",
    "choice_a": "Remove unnecessary rights.",
    "choice_b": "Disable interactive login for service accounts.",
    "choice_c": "Limit when accounts can log in.",
    "choice_d": "Use meaningless or randomized names for service accounts.",
    "correct_answer": "A",
    "explanation": "The most important step in securing service accounts is to ensure that they have only the rights that are absolutely needed to accomplish the task they are designed for. Disabling interactive logins is important as well and would be the next best answer. Limiting when accounts can log in and using randomized or meaningless account names can both be helpful in some circumstances but are far less important.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      470,
      751,
      926,
      457,
      466
    ],
    "source": ""
  },
  {
    "id": 2485,
    "question": "Kristen wants to control access to an application in her organization based on a combination of staff member's job titles, the permissions each group of titles need for the application, and the time of day and location. <br>What type of control scheme should she select?",
    "choice_a": "ABAC",
    "choice_b": "DAC",
    "choice_c": "MAC",
    "choice_d": "Role BAC",
    "correct_answer": "A",
    "explanation": "Attributes used for ABAC often fall into one of four categories: subject attributes like department or title; action attributes like the ability to view, edit, or delete; object attributes that describe the object that can be impacted; and contextual attributes like location, time, or elements. Discretionary access control would place these decisions in the hands of trusted subjects, MAC would enforce it at the operating system level, and role BAC would use only roles instead of the full set of criteria Kristen wants to apply.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      472,
      491,
      468,
      466,
      469
    ],
    "source": ""
  },
  {
    "id": 2486,
    "question": "When Alex sets the permissions shown in the following image as one of many users on a Linux server, what type of access control model is he leveraging? <br><img src=\"/question_assets/CISSP/5_image6.png\"/>",
    "choice_a": "Role-based access control",
    "choice_b": "Rule-based access control",
    "choice_c": "Mandatory access control (MAC)",
    "choice_d": "Discretionary access control (DAC)",
    "correct_answer": "D",
    "explanation": "The Linux filesystem allows the owners of objects to determine the access rights that subjects have to them. This means that it is a discretionary access control. If the system enforced a role-based access control, Alex wouldn't set the controls; they would be set based on the roles assigned to each subject. A rule-based access control system would apply rules throughout the system, and a mandatory access control system uses classification labels.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      465,
      491,
      472,
      468,
      466
    ],
    "source": ""
  },
  {
    "id": 2487,
    "question": "Joanna leads her organization's identity management team and wants to ensure that roles are properly updated when staff members change to new positions. <br>What issue should she focus on for those staff members to avoid future issues with role definition?",
    "choice_a": "Registration",
    "choice_b": "Privilege creep",
    "choice_c": "Deprovisioning",
    "choice_d": "Accountability",
    "correct_answer": "B",
    "explanation": "Privilege creep is a constant concern when staff change roles over time. Privileges from previous roles may be easy to forget or to retain during transition because staff may continue to help cover the tasks or processes the individual previously performed. Over time, these forgotten rights and privileges can stack, leaving the staff member with rights that their current role should not have. Registration is a concern for new staff, while de-provisioning is a concern for departing staff. Accountability is typically provided by IAM systems by authenticating and logging access and privilege usage.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      466,
      457,
      458,
      470,
      455
    ],
    "source": ""
  },
  {
    "id": 2488,
    "question": "What type of authorization mechanism is shown in the following chart? <br><img src=\"/question_assets/CISSP/5_image7.png\"/>",
    "choice_a": "RBAC",
    "choice_b": "ABAC",
    "choice_c": "MAC",
    "choice_d": "DAC",
    "correct_answer": "A",
    "explanation": "This is a role-based access control (RBAC) chart noting that each group has specific rights by roles. Attribute-based access control (ABAC) would use other attributes including things like location, mandatory access control (MAC) would be enforced by the operating system, and discretionary access control (DAC) allows subjects like users to set rights on objects they control.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      466,
      491,
      467,
      465,
      468
    ],
    "source": ""
  },
  {
    "id": 2490,
    "question": "Brian wants to explain the benefits of an on-premise federation approach for identity to his organization's leadership. <br>Which of the following is not a common benefit of a federated identity system?",
    "choice_a": "Ease of account management",
    "choice_b": "Single sign-on",
    "choice_c": "Prevention of brute-force attacks",
    "choice_d": "Increased productivity",
    "correct_answer": "C",
    "explanation": "Single sign-on (SSO) is part of identity federation. It also means that account management is simpler since multiple accounts don't have to be maintained for users who need to access systems and resources across the federation. Productivity can increase because staff don't have to remember multiple logins and can use SSO to log in once instead of multiple times. It does not, however, do anything to prevent brute-force attacks, and in fact, a single account with broad access can make it easier for an attacker to gain that broader access unless solutions like multifactor authentication are put in place.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      480,
      489,
      469,
      446
    ],
    "source": ""
  },
  {
    "id": 2491,
    "question": "The bank that Aaron works for wants to allow customers to use a new add-on application from a third-party partner they are working with. Since not every customer will want or need an account, Aaron has suggested that the bank use a SAML-based workflow that creates an account when a user downloads the app and tries to log in. <br>What type of provisioning system has he suggested?",
    "choice_a": "JIT",
    "choice_b": "OpenID",
    "choice_c": "OAuth",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "A JIT, or just-in-time, provisioning mechanism creates accounts when they are needed rather than creating them in advance. This is an effective method to limit the number of accounts being maintained and can be useful if user account numbers are part of a licensing agreement. OAuth, OpenID, and Kerberos are not mentioned in the question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      761,
      460,
      455,
      476,
      1020
    ],
    "source": ""
  },
  {
    "id": 2492,
    "question": "What authentication protocol does Windows use by default for Active Directory systems?",
    "choice_a": "RADIUS",
    "choice_b": "Kerberos",
    "choice_c": "OAuth",
    "choice_d": "TACACS+",
    "correct_answer": "B",
    "explanation": "Windows uses Kerberos for authentication. RADIUS is typically used for wireless networks, modems, and network devices, while OAuth is primarily used for web applications. TACACS+ is used for network devices.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      477,
      492,
      478,
      451,
      480
    ],
    "source": ""
  },
  {
    "id": 2493,
    "question": "Valerie needs to control access to applications that are deployed to mobile devices in a BYOD environment. <br>What type of solution will best allow her to exercise control over the applications while ensuring that they do not leave remnant data on the devices used by her end users?",
    "choice_a": "Deploy the applications to the BYOD devices and require unique PINs on every device.",
    "choice_b": "Deploy the application to desktop systems and require users to use remote desktop to access them using enterprise authentication.",
    "choice_c": "Deploy the applications to the BYOD devices using application containers and require unique PINs on every device.",
    "choice_d": "Use a virtual hosted application environment that requires authentication using enterprise credentials.",
    "correct_answer": "D",
    "explanation": "When very high levels of control are needed or when endpoint devices cannot be trusted, using a centralized environment with remote connectivity and enterprise authentication can provide appropriate security.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      450,
      451,
      469,
      449,
      489
    ],
    "source": ""
  },
  {
    "id": 2494,
    "question": "During a port scan, Susan discovers a system running services on TCP and UDP 137\u2013139 and TCP 445, as well as TCP 1433. <br>What type of system is she likely to find if she connects to the machine?",
    "choice_a": "A Linux email server",
    "choice_b": "A Windows SQL server",
    "choice_c": "A Linux file server",
    "choice_d": "A Windows workstation",
    "correct_answer": "B",
    "explanation": "TCP and UDP ports 137\u2013139 are used for NetBIOS services, whereas 445 is used for Active Directory. TCP 1433 is the default port for Microsoft SQL, indicating that this is probably a Windows server providing SQL services.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      764,
      763,
      788,
      787,
      1021
    ],
    "source": ""
  },
  {
    "id": 2495,
    "question": "Which of the following is a method used to automatically design new software tests and to ensure the quality of tests?",
    "choice_a": "Code auditing",
    "choice_b": "Static code analysis",
    "choice_c": "Regression testing",
    "choice_d": "Mutation testing",
    "correct_answer": "D",
    "explanation": "Mutation testing modifies a program in small ways and then tests that mutant to determine if it behaves as it should or if it fails. This technique is used to design and test software tests through mutation. Static code analysis and regression testing are both means of testing code, whereas code auditing is an analysis of source code rather than a means of designing and testing software tests.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      1004,
      494,
      776,
      1005
    ],
    "source": ""
  },
  {
    "id": 2496,
    "question": "During a port scan, Naomi found TCP port 443 open on a system. <br>Which tool is best suited to scanning the service that is most likely running on that port?",
    "choice_a": "zzuf",
    "choice_b": "Nikto",
    "choice_c": "Metasploit",
    "choice_d": "sqlmap",
    "correct_answer": "B",
    "explanation": "TCP port 443 normally indicates an HTTPS server. Nikto is useful for vulnerability scanning web servers and applications and is the best choice listed for a web server. Metasploit includes some scanning functionality but is not a purpose-built tool for vulnerability scanning. zzuf is a fuzzing tool and isn't relevant for vulnerability scans, whereas sqlmap is a SQL injection testing tool.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      763,
      788,
      775,
      776
    ],
    "source": ""
  },
  {
    "id": 2497,
    "question": "What message logging standard is commonly used by network devices, Linux and Unix systems, and many other enterprise devices?",
    "choice_a": "Syslog",
    "choice_b": "Netlog",
    "choice_c": "Eventlog",
    "choice_d": "Remote Log Protocol (RLP)",
    "correct_answer": "A",
    "explanation": "Syslog is a widely used protocol for event and message logging. Eventlog, netlog, and Remote Log Protocol are all made-up terms.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      774,
      772,
      782,
      783
    ],
    "source": ""
  },
  {
    "id": 2498,
    "question": "Alex wants to use an automated tool to fill web application forms to test for format string vulnerabilities. <br>What type of tool should he use?",
    "choice_a": "A black box",
    "choice_b": "A brute-force tool",
    "choice_c": "A fuzzer",
    "choice_d": "A static analysis tool",
    "correct_answer": "C",
    "explanation": "Fuzzers are tools that are designed to provide invalid or unexpected input to applications, testing for vulnerabilities like format string vulnerabilities, buffer overflow issues, and other problems. A static analysis relies on examining code without running the application or code and thus would not fill forms as part of a web application. Brute-force tools attempt to bypass security by trying every possible combination for passwords or other values. A black box is a type of penetration test where the testers do not know anything about the environment.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      775,
      776,
      777,
      494,
      495
    ],
    "source": ""
  },
  {
    "id": 2499,
    "question": "Susan needs to scan a system for vulnerabilities, and she wants to use an open source tool to test the system remotely. <br>Which of the following tools will meet her requirements and allow vulnerability scanning?",
    "choice_a": "Nmap",
    "choice_b": "OpenVAS",
    "choice_c": "MBSA",
    "choice_d": "Nessus",
    "correct_answer": "B",
    "explanation": "OpenVAS is an open source vulnerability scanning tool that will provide Susan with a report of the vulnerabilities that it can identify from a remote, network-based scan. Nmap is an open source port scanner. Both the Microsoft Baseline Security Analyzer (MBSA) and Nessus are closed-source tools, although Nessus was originally open source.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      788,
      763,
      789,
      861
    ],
    "source": ""
  },
  {
    "id": 2500,
    "question": "Morgan is implementing a vulnerability management system that uses standards-based components to score and evaluate the vulnerabilities it finds. <br>Which of the following is most commonly used to provide a severity score for vulnerabilities?",
    "choice_a": "CCE",
    "choice_b": "CVSS",
    "choice_c": "CPE",
    "choice_d": "OVAL",
    "correct_answer": "B",
    "explanation": "CVSS, the Common Vulnerability Scoring System, is used to describe the severity of security vulnerabilities. CCE is Common Configuration Enumeration, a naming system for configuration issues. CPE is Common Platform Enumeration, which names operating systems, applications, and devices. OVAL is a language for describing security testing procedures.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      789,
      502,
      787,
      861,
      860
    ],
    "source": ""
  },
  {
    "id": 2501,
    "question": "Jim has been contracted to perform a penetration test of a bank's primary branch. To make the test as real as possible, he has not been given any information about the bank other than its name and address. <br>What type of penetration test has Jim agreed to perform?",
    "choice_a": "A crystal-box penetration test",
    "choice_b": "A gray-box penetration test",
    "choice_c": "A black-box penetration test",
    "choice_d": "A white-box penetration test",
    "correct_answer": "C",
    "explanation": "Jim has agreed to a black-box penetration test, which provides no information about the organization, its systems, or its defenses. A crystal- or white-box penetration test provides all of the information an attacker needs, whereas a gray-box penetration test provides some, but not all, information.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1078,
      1080,
      771,
      501,
      495
    ],
    "source": ""
  },
  {
    "id": 2502,
    "question": "In a response to a request for proposal, Susan receives an SSAE 18 SOC report. If she wants a report that includes operating effectiveness detail, what should Susan ask for as follow-up and why?",
    "choice_a": "A SOC 2 Type II report, because Type I does not cover operating effectiveness",
    "choice_b": "A SOC 1 Type I report, because SOC 2 does not cover operating effectiveness",
    "choice_c": "A SOC 2 Type I report, because SOC 2 Type II does not cover operating effectiveness",
    "choice_d": "A SOC 3 report, because SOC 1 and SOC 2 reports are outdated",
    "correct_answer": "A",
    "explanation": "The key to answering this question correctly is understanding the difference between SOC 1 and SOC 2 reports, and Type I and Type II audits. SOC 1 reports cover financial reporting, and SOC 2 reports look at security. Type I audits only cover a single point in time and are based upon management descriptions of controls. They do not include an assessment of operating effectiveness. Type II audits cover a period of time and do include an assessment of operating effectiveness.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      767,
      766,
      793,
      768,
      795
    ],
    "source": ""
  },
  {
    "id": 2504,
    "question": "A zero-day vulnerability is announced for the popular Apache web server in the middle of a workday. In Jacob's role as an information security analyst, he needs to quickly scan his network to determine what servers are vulnerable to the issue. <br>What is Jacob's best route to quickly identify vulnerable systems?",
    "choice_a": "Immediately run Nessus against all of the servers to identify which systems are vulnerable.",
    "choice_b": "Review the CVE database to find the vulnerability information and patch information.",
    "choice_c": "Create a custom IDS or IPS signature.",
    "choice_d": "Identify affected versions and check systems for that version number using an automated scanner.",
    "correct_answer": "D",
    "explanation": "In many cases when an exploit is initially reported, there are no prebuilt signatures or detections for vulnerability scanners, and the CVE database may not immediately have information about the attack. Jacob's best option is to quickly gather information and review potentially vulnerable servers based on their current configuration. As more information becomes available, signatures and CVE information are likely to be published. Unfortunately for Jacob, IDS and IPS signatures will only detect attacks and won't detect whether systems are vulnerable unless he sees the systems being exploited.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      789,
      860,
      861,
      502
    ],
    "source": ""
  },
  {
    "id": 2505,
    "question": "What type of testing is used to ensure that separately developed software modules properly exchange data?",
    "choice_a": "Fuzzing",
    "choice_b": "Dynamic testing",
    "choice_c": "Interface testing",
    "choice_d": "API checksums",
    "correct_answer": "C",
    "explanation": "Interface testing is used to ensure that software modules properly meet interface specifications and thus will properly exchange data. Dynamic testing tests software in a running environment, whereas fuzzing is a type of dynamic testing that feeds invalid input to running software to test error and input handling. API checksums are not a testing technique.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      494,
      775,
      496,
      1004
    ],
    "source": ""
  },
  {
    "id": 2506,
    "question": "Selah wants to provide security assessment information to customers who want to use her organization's cloud services. <br>Which of the following options should she select to ensure that the greatest number of customers are satisfied with the assessment information?",
    "choice_a": "Use an internal audit team to self-assess against internal metrics.",
    "choice_b": "Use a third-party auditor.",
    "choice_c": "Use internal technical staff who know the systems.",
    "choice_d": "Use an internal audit team to self-assess against a common standard like COBIT.",
    "correct_answer": "B",
    "explanation": "Using a third-party auditor from a well-known and well-regarded firm is often the best option when providing audit and compliance information to third parties. Selah could engage an appropriate vendor for an SOC 2 Type II engagement as one example of a reasonable option to provide detail to her customers. Internal staff assessing to a common standard like COBIT would be the next most acceptable option on this list, with an internal standard less useful than that. Finally, internal nonaudit staff are the least useful in this circumstance.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      795,
      794,
      766,
      1006,
      1007
    ],
    "source": ""
  },
  {
    "id": 2507,
    "question": "Yasmine has been asked to consider a breach and attack simulation system. <br>What type of system should she look for?",
    "choice_a": "A ticket and change management system designed to help manage incidents",
    "choice_b": "A system that runs incident response simulations for blue teams to test their skills",
    "choice_c": "A system that combines red and blue team techniques with automation",
    "choice_d": "A security operations and response (SOAR) system",
    "correct_answer": "C",
    "explanation": "BAS, or Breach and Attack Simulation, systems are systems that combine red team (attack) and blue team (defense) techniques together with automation to simulate advanced persistent threats and other advanced threat actors when run against your environment. This allows a variety of threats to be replicated and assessed in an environment without as much overhead as a fully staffed purple team would.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1080,
      1078,
      1079,
      501,
      502
    ],
    "source": ""
  },
  {
    "id": 2508,
    "question": "Monica wants to gather information about security awareness in her organization. <br>What technique is most frequently used to assess security awareness?",
    "choice_a": "Phishing simulators",
    "choice_b": "Gamified applications",
    "choice_c": "Assessment tests",
    "choice_d": "Surveys",
    "correct_answer": "D",
    "explanation": "Most organizations use surveys to assess security awareness. Phishing simulators are also frequently used, but only test awareness of phishing issues and techniques, not general security awareness. Gamified applications are continuing to grow in popularity, but the ease of use and availability of surveys makes them the most popular. Finally, assessment tests may be used when compliance knowledge assessments are required to meet a specific standard, but testing is not as common as surveying.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      501,
      502,
      863,
      1006,
      1007
    ],
    "source": ""
  },
  {
    "id": 2509,
    "question": "Jim has been contracted to conduct a gray-box penetration test, and his clients have provided him with the following information about their networks so that he can scan them: <br>    Data center: 10.10.10.0/24 <br>    Sales: 10.10.11.0/24 <br>    Billing: 10.10.12.0/24 <br>    Wireless: 192.168.0.0/16 <br>What problem will Jim encounter if he is contracted to conduct a scan from off-site?",
    "choice_a": "The IP ranges are too large to scan efficiently.",
    "choice_b": "The IP addresses provided cannot be scanned.",
    "choice_c": "The IP ranges overlap and will cause scanning issues.",
    "choice_d": "The IP addresses provided are RFC 1918 addresses.",
    "correct_answer": "D",
    "explanation": "The IP addresses that his clients have provided are RFC 1918 nonroutable IP addresses, and Jim will not be able to scan them from off-site. To succeed in his penetration test, he will have to either first penetrate their network border or place a machine inside their network to scan from the inside. IP addresses overlapping is not a real concern for scanning, and the ranges can easily be handled by current scanning systems.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      769,
      771,
      770,
      787,
      859
    ],
    "source": ""
  },
  {
    "id": 2510,
    "question": "Mark's company has been notified that there is a flaw in their web application. The anonymous individual has notified them that they have two weeks to fix it before the details of the flaw are published along with example exploit code. <br>What industry norm is the individual who contacted Mark's company violating?",
    "choice_a": "Zero-day reporting",
    "choice_b": "Ethical disclosure",
    "choice_c": "Ethical hacking",
    "choice_d": "The ISC2 vulnerability disclosure ethics statement",
    "correct_answer": "B",
    "explanation": "Ethical (or responsible) disclosure practices will provide companies and organizations with a reasonable period of time to fix a flaw and to get that fix into the hands of their customers. Two weeks is unlikely to be a reasonable amount of time for this. Unfortunately, Mark may not be able to persuade the individual to make a different decision, and Mark's company will need to determine what to do about the issue.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      497,
      502,
      498,
      501,
      862
    ],
    "source": ""
  },
  {
    "id": 2511,
    "question": "The company that Jennifer works for has implemented a central logging infrastructure, as shown in the following image. Use this diagram and your knowledge of logging systems to answer the following questions. <br>Jennifer needs to ensure that all Windows systems provide identical logging information to the SIEM. <br><img src=\"/question_assets/CISSP/6_image1.png\"/><br>How can she best ensure that all Windows desktops have the same log settings?",
    "choice_a": "Perform periodic configuration audits.",
    "choice_b": "Use Group Policy.",
    "choice_c": "Use Local Policy.",
    "choice_d": "Deploy a Windows syslog client.",
    "correct_answer": "B",
    "explanation": "Group Policy enforced by Active Directory can ensure consistent logging settings and can provide regular enforcement of policy on systems. Periodic configuration audits won't catch changes made between audits, and local policies can drift due to local changes or differences in deployments. A Windows syslog client will enable the Windows systems to send syslog to the SIEM appliance but won't ensure consistent logging of events.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      773,
      774,
      772,
      498,
      782
    ],
    "source": ""
  },
  {
    "id": 2512,
    "question": "The company that Jennifer works for has implemented a central logging infrastructure, as shown in the following image. Use this diagram and your knowledge of logging systems to answer the following questions. <br>During normal operations, Jennifer's team uses the SIEM appliance to monitor for exceptions received via syslog. <br><img src=\"/question_assets/CISSP/6_image1.png\"/><br>What system shown does not natively have support for syslog events?",
    "choice_a": "Enterprise wireless access points",
    "choice_b": "Windows desktop systems",
    "choice_c": "Linux web servers",
    "choice_d": "Enterprise firewall devices",
    "correct_answer": "B",
    "explanation": "Windows systems generate logs in the Windows native logging format. To send syslog events, Windows systems require a helper application or tool. Enterprise wireless access points, firewalls, and Linux systems all typically support syslog.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      772,
      774,
      783,
      764
    ],
    "source": ""
  },
  {
    "id": 2513,
    "question": "The company that Jennifer works for has implemented a central logging infrastructure, as shown in the following image. Use this diagram and your knowledge of logging systems to answer the following questions. <br><img src=\"/question_assets/CISSP/6_image1.png\"/><br>What technology should an organization use for each of the devices shown in the diagram to ensure that logs can be time sequenced across the entire infrastructure?",
    "choice_a": "Syslog",
    "choice_b": "NTP",
    "choice_c": "Logsync",
    "choice_d": "SNAP",
    "correct_answer": "B",
    "explanation": "Network Time Protocol (NTP) can ensure that systems are using the same time, allowing time sequencing for logs throughout a centralized logging infrastructure. Syslog is a way for systems to send logs to a logging server and won't address time sequencing. Neither logsync nor SNAP is an industry term.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      772,
      774,
      773,
      502
    ],
    "source": ""
  },
  {
    "id": 2514,
    "question": "During a penetration test, Michelle needs to identify systems, but she hasn't gained sufficient access on the system she is using to generate raw packets. <br>What type of scan should she run to verify the most open services?",
    "choice_a": "A TCP connect scan",
    "choice_b": "A TCP SYN scan",
    "choice_c": "A UDP scan",
    "choice_d": "An ICMP scan",
    "correct_answer": "A",
    "explanation": "When a tester does not have raw packet creation privileges, such as when they have not escalated privileges on a compromised host, a TCP connect scan can be used. TCP SYN scans require elevated privileges on most Linux systems due to the need to write raw packets. A UDP scan will miss most services that are provided via TCP, and an ICMP is merely a ping sweep of systems that respond to pings and won't identify services at all.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      771,
      764,
      765,
      495,
      496
    ],
    "source": ""
  },
  {
    "id": 2515,
    "question": "During a port scan using nmap, Joseph discovers that a system shows two ports open that cause him immediate worry:<br>    21/open :<br>    23/open :<br>What services are likely running on those ports?",
    "choice_a": "SSH and FTP",
    "choice_b": "FTP and Telnet",
    "choice_c": "SMTP and Telnet",
    "choice_d": "POP3 and SMTP",
    "correct_answer": "B",
    "explanation": "Joseph may be surprised to discover FTP (TCP port 21) and Telnet (TCP port 23) open on his network since both services are unencrypted and have been largely replaced by SSH, and SCP or SFTP. SSH uses port 22, SMTP uses port 25, and POP3 uses port 110.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      763,
      787,
      788,
      789,
      859
    ],
    "source": ""
  },
  {
    "id": 2516,
    "question": "Aaron wants to validate his compliance with PCI-DSS. His company is a large commercial organization with millions of dollars in transactions a year. <br>What is the most common method of conducting this type of testing for large organizations?",
    "choice_a": "Self-assessment",
    "choice_b": "To conduct a thirty-party assessment using COBIT",
    "choice_c": "To partner with another company and trade assessments between the organizations",
    "choice_d": "To conduct a third-party assessment using a qualified security assessor",
    "correct_answer": "D",
    "explanation": "Large organizations hire QSAs, or qualified security assessors, to conduct compliance checks. Third-party certification is required for large organizations by PCI-DSS, although smaller organizations can self-certify.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1006,
      793,
      795,
      1007,
      864
    ],
    "source": ""
  },
  {
    "id": 2517,
    "question": "What method is commonly used to assess how well software testing covered the potential uses of an application?",
    "choice_a": "A test coverage analysis",
    "choice_b": "A source code review",
    "choice_c": "A fuzz analysis",
    "choice_d": "A code review report",
    "correct_answer": "A",
    "explanation": "A test coverage analysis is often used to provide insight into how well testing covered the set of use cases that an application is being tested for. Source code reviews look at the code of a program for bugs, not necessarily at a use case analysis, whereas fuzzing tests invalid inputs. A code review report might be generated as part of a source code review.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      778,
      1004,
      780,
      494
    ],
    "source": ""
  },
  {
    "id": 2518,
    "question": "Testing that is focused on functions that a system should not allow is an example of what type of testing?",
    "choice_a": "Use case testing",
    "choice_b": "Manual testing",
    "choice_c": "Misuse case testing",
    "choice_d": "Dynamic testing",
    "correct_answer": "C",
    "explanation": "Testing how a system could be misused, or misuse testing, focuses on behaviors that are not what the organization desires or that are counter to the proper function of a system or application. Use case testing is used to verify whether a desired functionality works. Dynamic testing is used to determine how code handles variables that change over time, whereas manual testing is just what it implies: testing code by hand.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      494,
      775,
      778,
      496
    ],
    "source": ""
  },
  {
    "id": 2519,
    "question": "What type of monitoring uses simulated traffic to a website to monitor performance?",
    "choice_a": "Log analysis",
    "choice_b": "Synthetic monitoring",
    "choice_c": "Passive monitoring",
    "choice_d": "Simulated transaction analysis",
    "correct_answer": "B",
    "explanation": "Synthetic monitoring uses emulated or recorded transactions to monitor for performance changes in response time, functionality, or other performance monitors. Passive monitoring uses a span port or other method to copy traffic and monitor it in real time. Log analysis is typically performed against actual log data but can be performed on simulated traffic to identify issues. Simulated transaction analysis is not an industry term.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      498,
      501,
      494,
      779
    ],
    "source": ""
  },
  {
    "id": 2520,
    "question": "Derek wants to ensure that his organization tracks all changes to accounts through their lifecycle. <br>What type of tool should he invest in for his organization?",
    "choice_a": "A directory service like LDAP",
    "choice_b": "An IAM system",
    "choice_c": "A SIEM",
    "choice_d": "An EDR system",
    "correct_answer": "B",
    "explanation": "Identity and access management (IAM) systems combine lifecycle management and monitoring tools to ensure that identity and authorization are properly handled throughout an organization. Derek should invest in a capable IAM system and ensure that it is configured to use appropriate workflows and to generate the logs and reports that he needs. EDR systems are endpoint detection and response tools and are used to protect against compromise by advanced attackers.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      499,
      498,
      772,
      783,
      501
    ],
    "source": ""
  },
  {
    "id": 2521,
    "question": "Jim uses a tool that scans a system for available services and then connects to them to collect banner information to determine what version of the service is running. It then provides a report detailing what it gathers, basing results on service fingerprinting, banner information, and similar details it gathers combined with CVE information. <br>What type of tool is Jim using?",
    "choice_a": "A port scanner",
    "choice_b": "A service validator",
    "choice_c": "A vulnerability scanner",
    "choice_d": "A patch management tool",
    "correct_answer": "C",
    "explanation": "Vulnerability scanners that do not have administrative rights to access a machine or that are not using an agent scan remote machines to gather information, including fingerprints from responses to queries and connections, banner information from services, and related data. CVE information is Common Vulnerability and Exposure information, or vulnerability information. A port scanner gathers information about what service ports are open, although some port scanners blur the line between port and vulnerability scanners. Patch management tools typically run as an agent on a system to allow them to both monitor patch levels and update the system as needed. Service validation typically involves testing the functionality of a service, not its banner and response patterns.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      788,
      860,
      859,
      861
    ],
    "source": ""
  },
  {
    "id": 2522,
    "question": "Emily builds a script that sends data to a web application that she is testing. Each time the script runs, it sends a series of transactions with data that fits the expected requirements of the web application to verify that it responds to typical customer behavior. <br>What type of transactions is she using, and what type of test is this?",
    "choice_a": "Synthetic, passive monitoring",
    "choice_b": "Synthetic, use case testing",
    "choice_c": "Actual, dynamic monitoring",
    "choice_d": "Actual, fuzzing",
    "correct_answer": "B",
    "explanation": "Emily is using synthetic transactions, which can use recorded or generated transactions, and is conducting use case testing to verify that the application responds properly to actual use cases. Neither actual data nor dynamic monitoring is an industry term. Fuzzing involves sending unexpected inputs to a program to see how it responds. Passive monitoring uses a network tap or other capture technology to allow monitoring of actual traffic to a system or application.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      776,
      775,
      495,
      778
    ],
    "source": ""
  },
  {
    "id": 2523,
    "question": "What passive monitoring technique records all user interaction with an application or website to ensure quality and performance?",
    "choice_a": "Client/server testing",
    "choice_b": "Real user monitoring",
    "choice_c": "Synthetic user monitoring",
    "choice_d": "Passive user recording",
    "correct_answer": "B",
    "explanation": "Real user monitoring (RUM) is a passive monitoring technique that records user interaction with an application or system to ensure performance and proper application behavior. RUM is often used as part of a predeployment process using the actual user interface. The other answers are all made up\u2014synthetic monitoring uses simulated behavior, but synthetic user monitoring is not a testing method. Similarly, passive monitoring monitors actual traffic, but passive user recording is not an industry term or technique. Client/server testing merely describes one possible architecture.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      494,
      498,
      502,
      775
    ],
    "source": ""
  },
  {
    "id": 2524,
    "question": "Earlier this year, the information security team at Jim's employer identified a vulnerability in the web server that Jim is responsible for maintaining. He immediately applied the patch and is sure that it installed properly, but the vulnerability scanner has continued to incorrectly flag the system as vulnerable. What should Jim do to deal with the issue so that it does not continue to be flagged incorrectly?",
    "choice_a": "Uninstall and reinstall the patch.",
    "choice_b": "Ask the information security team to flag the system as patched and not vulnerable to that particular flaw.",
    "choice_c": "Update the version information in the web server's configuration.",
    "choice_d": "Review the vulnerability report and use alternate remediation options.",
    "correct_answer": "B",
    "explanation": "Jim should ask the information security team to flag the issue as resolved if he is sure the patch was installed. Many vulnerability scanners rely on version information or banner information and may flag patched versions if the software provider does not update the information they see. Uninstalling and reinstalling the patch will not change this. Changing the version information may not change all of the details that are being flagged by the scanner and may cause issues at a later date. Reviewing the vulnerability information for a workaround may be a good idea but should not be necessary if the proper patch is installed; it can create maintenance issues later.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      860,
      861,
      787,
      789,
      502
    ],
    "source": ""
  },
  {
    "id": 2525,
    "question": "Angela wants to test a web browser's handling of unexpected data using an automated tool. <br>What tool should she choose?",
    "choice_a": "Nmap",
    "choice_b": "zzuf",
    "choice_c": "Nessus",
    "choice_d": "Nikto",
    "correct_answer": "B",
    "explanation": "zzuf is the only fuzzer on the list, and zzuf is specifically designed to work with tools like web browsers, image viewers, and similar software by modifying network and file input to application. Nmap is a port scanner, Nessus is a vulnerability scanner, and Nikto is a web server scanner.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      776,
      775,
      787,
      494,
      777
    ],
    "source": ""
  },
  {
    "id": 2527,
    "question": "Why should passive scanning be conducted in addition to implementing wireless security technologies like wireless intrusion detection systems?",
    "choice_a": "It can help identify rogue devices.",
    "choice_b": "It can test the security of the wireless network via scripted attacks.",
    "choice_c": "Their short dwell time on each wireless channel can allow them to capture more packets.",
    "choice_d": "They can help test wireless IDS or IPS systems.",
    "correct_answer": "A",
    "explanation": "Passive scanning can help identify rogue devices by capturing MAC address vendor IDs that do not match deployed devices, by verifying that systems match inventories of organizationally owned hardware by hardware address, and by monitoring for rogue SSIDs or connections. <br>Scripted attacks are part of active scanning rather than passive scanning, and active scanning is useful for testing IDS or IPS systems, whereas passive scanning will not be detected by detection systems. Finally, a shorter dwell time can actually miss troublesome traffic, so balancing dwell time versus coverage is necessary for passive wireless scanning efforts.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1079,
      787,
      860,
      859,
      498
    ],
    "source": ""
  },
  {
    "id": 2528,
    "question": "Paul is reviewing the approval process for a penetration test and wants to ensure that it has appropriate management review. <br>Who should he ensure has approved the request for a penetration test for a business system?",
    "choice_a": "The change advisory board",
    "choice_b": "Senior management",
    "choice_c": "The systems administrator for the system",
    "choice_d": "The service owner",
    "correct_answer": "B",
    "explanation": "In most organizations, senior management needs to approve penetration tests due to the risk to the organization and the potential impact of the test. In a small number of organizations, the service owner may be able to make this decision, but penetration tests often have broader impacts than a single service, meaning that senior management is the proper path. Change advisory boards approve changes, not penetration tests, and system administrators may be advised of the test but do not have the authority in most organizations to sign off on a penetration test.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      863,
      1078,
      1080,
      502,
      789
    ],
    "source": ""
  },
  {
    "id": 2529,
    "question": "What term describes software testing that is intended to uncover new bugs introduced by patches or configuration changes?",
    "choice_a": "Nonregression testing",
    "choice_b": "Evolution testing",
    "choice_c": "Smoke testing",
    "choice_d": "Regression testing",
    "correct_answer": "D",
    "explanation": "Regression testing, which is a type of functional or unit testing, tests to ensure that changes have not introduced new issues. Nonregression testing checks to see whether a change has had the effect it was supposed to, smoke testing focuses on simple problems with impact on critical functionality, and evolution testing is not a software testing technique.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      779,
      494,
      778,
      1003
    ],
    "source": ""
  },
  {
    "id": 2530,
    "question": "Which of the following tools cannot identify a target's operating system for a penetration tester?",
    "choice_a": "Nmap",
    "choice_b": "Nessus",
    "choice_c": "Nikto",
    "choice_d": "sqlmap",
    "correct_answer": "D",
    "explanation": "Nmap, Nessus, and Nikto all have OS fingerprinting or other operating system identification capabilities. sqlmap is designed to perform automated detection and testing of SQL injection flaws and does not provide OS detection.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      788,
      763,
      860,
      771,
      1078
    ],
    "source": ""
  },
  {
    "id": 2531,
    "question": "Susan needs to predict high-risk areas for her organization and wants to use metrics to assess risk trends as they occur. <br>What should she do to handle this?",
    "choice_a": "Perform yearly risk assessments.",
    "choice_b": "Hire a penetration testing company to regularly test organizational security.",
    "choice_c": "Identify and track key risk indicators.",
    "choice_d": "Monitor logs and events using a SIEM device.",
    "correct_answer": "C",
    "explanation": "Key risk indicators are used to tell those in charge of risk management how risky an activity is and how much impact changes are having on that risk profile. Identifying key risk indicators and monitoring them can help to identify high-risk areas earlier in their lifecycle. Yearly risk assessments may be a good idea, but only provide a point-in-time view, whereas penetration tests may miss out on risks that are not directly security-related. Monitoring logs and events using a SIEM device can help detect issues as they occur but won't necessarily show trends in risk.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      502,
      789,
      498,
      860,
      784
    ],
    "source": ""
  },
  {
    "id": 2532,
    "question": "What major difference separates synthetic and passive monitoring?",
    "choice_a": "Synthetic monitoring works only after problems have occurred.",
    "choice_b": "Passive monitoring cannot detect functionality issues.",
    "choice_c": "Passive monitoring works only after problems have occurred.",
    "choice_d": "Synthetic monitoring cannot detect functionality issues.",
    "correct_answer": "C",
    "explanation": "Passive monitoring works only after issues have occurred because it requires actual traffic. Synthetic monitoring uses simulated or recorded traffic and thus can be used to proactively identify problems. Both synthetic and passive monitoring can be used to detect functionality issues.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      498,
      502,
      501,
      787
    ],
    "source": ""
  },
  {
    "id": 2533,
    "question": "Chris uses the standard penetration testing methodology shown here. Use this methodology and your knowledge of penetration testing to answer questions about tool usage during a penetration test. <br><img src=\"/question_assets/CISSP/6_image2.png\"/><br>What task is the most important during Phase 1, Planning?",
    "choice_a": "Building a test lab",
    "choice_b": "Getting authorization",
    "choice_c": "Gathering appropriate tools",
    "choice_d": "Determining if the test is white, black, or gray box",
    "correct_answer": "B",
    "explanation": "Getting authorization is the most critical element in the planning phase. Permission, and the \"get out of jail free card\" that demonstrates that organizational leadership is aware of the issues that a penetration test could cause, is the first step in any penetration test. Gathering tools and building a lab, as well as determining what type of test will be conducted, are all important, but nothing should happen without permission.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      863,
      864,
      1078,
      1080,
      1007
    ],
    "source": ""
  },
  {
    "id": 2534,
    "question": "Chris uses the standard penetration testing methodology shown here. Use this methodology and your knowledge of penetration testing to answer questions about tool usage during a penetration test. <br><img src=\"/question_assets/CISSP/6_image2.png\"/><br>Which of the following tools is most likely to be used during discovery?",
    "choice_a": "Nessus",
    "choice_b": "john",
    "choice_c": "Nmap",
    "choice_d": "Nikto",
    "correct_answer": "C",
    "explanation": "Discovery can include both active and passive discovery. Port scanning is commonly done during discovery to assess what services the target provides, and nmap is one of the most popular tools used for this purpose. Nessus and Nikto might be used during the vulnerability scanning phase, and john, a password cracker, can be used to recover passwords during the exploitation phase.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      763,
      764,
      765,
      1078
    ],
    "source": ""
  },
  {
    "id": 2535,
    "question": "Chris uses the standard penetration testing methodology shown here. Use this methodology and your knowledge of penetration testing to answer questions about tool usage during a penetration test. <br><img src=\"/question_assets/CISSP/6_image2.png\"/><br>Which of these concerns is the most important to address during planning to ensure that the reporting phase does not cause problems?",
    "choice_a": "Which CVE format to use",
    "choice_b": "How the vulnerability data will be stored and sent",
    "choice_c": "Which targets are off-limits",
    "choice_d": "How long the report should be",
    "correct_answer": "B",
    "explanation": "Penetration test reports often include information that could result in additional exposure if they were accidentally released or stolen. Therefore, determining how vulnerability data should be stored and sent is critical. Problems with off-limits targets are more likely to result in issues during the vulnerability assessment and exploitation phase, and reports should not be limited in length but should be as long as they need to be to accomplish the goals of the test.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      497,
      502,
      861,
      862,
      789
    ],
    "source": ""
  },
  {
    "id": 2536,
    "question": "What four types of coverage criteria are commonly used when validating the work of a code testing suite?",
    "choice_a": "Input, statement, branch, and condition coverage",
    "choice_b": "Function, statement, branch, and condition coverage",
    "choice_c": "API, branch, bounds, and condition coverage",
    "choice_d": "Bounds, branch, loop, and condition coverage",
    "correct_answer": "B",
    "explanation": "Code coverage testing most frequently requires that every function has been called, that each statement has been executed, that all branches have been fully explored, and that each condition has been evaluated for all possibilities. API, input, and loop testing are not common types of code coverage testing measures.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1004,
      496,
      1003,
      1005,
      778
    ],
    "source": ""
  },
  {
    "id": 2537,
    "question": "As part of his role as a security manager, Jacob provides the following chart to his organization's management team. <br><img src=\"/question_assets/CISSP/6_image3.png\"/><br>What type of measurement is he providing for them?",
    "choice_a": "A coverage rate measure",
    "choice_b": "A key performance indicator",
    "choice_c": "A time to live metric",
    "choice_d": "A business criticality indicator",
    "correct_answer": "B",
    "explanation": "Time to remediate a vulnerability is a commonly used key performance indicator for security teams. Time to live measures how long a packet can exist in hops, business criticality is a measure used to determine how important a service or system is to an organization, and coverage rates are used to measure how effective code testing is.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      502,
      789,
      787,
      498,
      499
    ],
    "source": ""
  },
  {
    "id": 2538,
    "question": "What does using unique user IDs for all users provide when reviewing logs?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "Accountability",
    "correct_answer": "D",
    "explanation": "Unique user IDs provide accountability when paired with auditable logs to provide that a specific user took any given action. Confidentiality, availability, and integrity can be provided through other means like encryption, systems design, and digital signatures.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      499,
      772,
      774,
      502
    ],
    "source": ""
  },
  {
    "id": 2539,
    "question": "Which of the following is not an interface that is typically tested during the software testing process?",
    "choice_a": "APIs",
    "choice_b": "Network interfaces",
    "choice_c": "UIs",
    "choice_d": "Physical interfaces",
    "correct_answer": "B",
    "explanation": "Application programming interfaces (APIs), user interfaces (UIs), and physical interfaces are all important to test when performing software testing. Network interfaces, while important to test, fall under network/infrastructure testing rather than software interface testing. ",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      494,
      496,
      1003,
      1005
    ],
    "source": ""
  },
  {
    "id": 2540,
    "question": "Alan's organization uses the Security Content Automation Protocol (SCAP) to standardize its vulnerability management program. <br>Which component of SCAP can Alan use to reconcile the identity of vulnerabilities generated by different security assessment tools?",
    "choice_a": "OVAL",
    "choice_b": "XCCDF",
    "choice_c": "CVE",
    "choice_d": "SCE",
    "correct_answer": "C",
    "explanation": "The Common Vulnerabilities and Exposures (CVE) database provides a consistent reference for identifying security vulnerabilities. The Open Vulnerability and Assessment Language (OVAL) is used to describe the security condition of a system. The Extensible Configuration Checklist Description Format (XCCDF) is used to create security checklists in a standardized fashion. The Script Check Engine (SCE) is designed to make scripts interoperable with security policy definitions.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      789,
      787,
      502,
      498,
      1006
    ],
    "source": ""
  },
  {
    "id": 2541,
    "question": "Susan is reviewing software testing coverage data and sees the information shown in the following figure. <br><img src=\"/question_assets/CISSP/6_image4.png\"/><br>What can she determine about this testing process?  (Select all that apply.)",
    "choice_a": "The testing does not have full coverage.",
    "choice_b": "Test 4 completed with no failures.",
    "choice_c": "Test 2 failed to run successfully.",
    "choice_d": "The testing needs to be run a fifth time.",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Test 2's total failure is likely due to a failed test run, but the tests overall show continued improvement with a full success in test 4. At this point, most testing processes would consider the testing complete. This does not show coverage, and there is no reason to run a fifth run if the fourth test was successful.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      780,
      779,
      778,
      1004,
      502
    ],
    "source": ""
  },
  {
    "id": 2542,
    "question": "Which of the following strategies is not a reasonable approach for remediating a vulnerability identified by a vulnerability scanner?",
    "choice_a": "Install a patch.",
    "choice_b": "Use a workaround fix.",
    "choice_c": "Update the banner or version number.",
    "choice_d": "Use an application layer firewall or IPS to prevent attacks against the identified vulnerability.",
    "correct_answer": "C",
    "explanation": "Simply updating the version that an application provides may stop the vulnerability scanner from flagging it, but it won't fix the underlying issue. Patching, using workarounds, or installing an application layer firewall or IPS can all help to remediate or limit the impact of the vulnerability.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      861,
      789,
      787,
      860,
      859
    ],
    "source": ""
  },
  {
    "id": 2543,
    "question": "During a penetration test, Selah calls her target's help desk claiming to be the senior assistant to an officer of the company. She requests that the help desk reset the officer's password because of an issue with his laptop while traveling and persuades them to do so. <br>What type of attack has she successfully completed?",
    "choice_a": "Zero knowledge",
    "choice_b": "Help desk spoofing",
    "choice_c": "Social engineering",
    "choice_d": "Black box",
    "correct_answer": "C",
    "explanation": "Selah's social engineering attack succeeded in persuading a staff member at the help desk to change a password for someone who they not only couldn't see, but who they couldn't verify actually needed their password reset. Black box and zero knowledge are both terms describing penetration tests without information about the organization or system, and help desk spoofing is not an industry term.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      501,
      1078,
      1080,
      499,
      498
    ],
    "source": ""
  },
  {
    "id": 2544,
    "question": "In this image, what issue may occur due to the log handling settings? <br><img src=\"/question_assets/CISSP/6_image5.png\"/>",
    "choice_a": "Log data may be lost when the log is archived.",
    "choice_b": "Log data may be overwritten.",
    "choice_c": "Log data may not include needed information.",
    "choice_d": "Log data may fill the system disk.",
    "correct_answer": "D",
    "explanation": "The menu shown will archive logs when they reach the maximum size allowed (20 MB). These archives will be retained, which could fill the disk. Log data will not be overwritten, and log data should not be lost when the data is archived. The question does not include enough information to determine if needed information may not be logged.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      782,
      781,
      498,
      774,
      783
    ],
    "source": ""
  },
  {
    "id": 2545,
    "question": "Which of the following is not a hazard associated with penetration testing?",
    "choice_a": "Application crashes",
    "choice_b": "Denial of service",
    "choice_c": "Blackouts",
    "choice_d": "Data corruption",
    "correct_answer": "C",
    "explanation": "Penetration tests typically do not involve blackouts. Application crashes; denial of service due to system, network, or application failures; and even data corruption can all be hazards of penetration tests.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      771,
      1080,
      787,
      775,
      777
    ],
    "source": ""
  },
  {
    "id": 2546,
    "question": "Which NIST special publication covers the assessment of security and privacy controls?",
    "choice_a": "800-12",
    "choice_b": "800-53A",
    "choice_c": "800-34",
    "choice_d": "800-86",
    "correct_answer": "B",
    "explanation": "NIST SP 800-53A is titled \"Assessing Security and Privacy Controls in Federal Information Systems and Organizations: Building Effective Assessment Plans\" and covers methods for assessing and measuring controls. NIST 800-12 is an introduction to computer security, 800-34 covers contingency planning, and 800-86 is the \"Guide to Integrating Forensic Techniques into Incident Response.\".",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      789,
      787,
      860,
      502,
      1080
    ],
    "source": ""
  },
  {
    "id": 2549,
    "question": "If Kara's primary concern is preventing administrative connections to the server, which port should she block?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "1433",
    "correct_answer": "A",
    "explanation": "Port 22 is used by the Secure Shell (SSH) protocol for administrative connections. If Kara wants to restrict administrative connections, she should block access on this port.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      763,
      787,
      788,
      765,
      764
    ],
    "source": ""
  },
  {
    "id": 2550,
    "question": "During a third-party audit, Jim's company receives a finding that states, \"The administrator should review backup success and failure logs on a daily basis and take action in a timely manner to resolve reported exceptions.\" What potential problem does this finding indicate?",
    "choice_a": "Administrators will not know if the backups succeeded or failed.",
    "choice_b": "The backups may not be properly logged.",
    "choice_c": "The backups may not be usable.",
    "choice_d": "The backup logs may not be properly reviewed.",
    "correct_answer": "C",
    "explanation": "The audit finding indicates that the backup administrator may not be monitoring backup logs and taking appropriate action based on what they report, thus resulting in potentially unusable backups. Issues with review, logging, or being aware of the success or failure of backups are less important than not having usable backups.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      785,
      784,
      786,
      500,
      498
    ],
    "source": ""
  },
  {
    "id": 2551,
    "question": "Jim is helping his organization decide on audit standards for use throughout their international organization. <br>Which of the following is not an IT standard that Jim's organization is likely to use as part of its audits?",
    "choice_a": "COBIT",
    "choice_b": "SSAE-18",
    "choice_c": "ITIL",
    "choice_d": "ISO 27001",
    "correct_answer": "C",
    "explanation": "ITIL, which originally stood for IT Infrastructure Library, is a set of practices for IT service management and is not typically used for auditing. COBIT, or the Control Objectives for Information and Related Technology, ISO 27001, and SSAE-18, or the Statement on Standards for Attestation Engagements number 18, are all used for auditing.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      793,
      766,
      1007,
      864,
      862
    ],
    "source": ""
  },
  {
    "id": 2552,
    "question": "Nicole wants to conduct a standards-based audit of her organization. <br>Which of the following is commonly used to describe common requirements for information systems?",
    "choice_a": "IEC",
    "choice_b": "COBIT",
    "choice_c": "FISA",
    "choice_d": "DMCA",
    "correct_answer": "B",
    "explanation": "COBIT, the Control Objectives for Information and Related Technologies, is commonly used as an audit framework for organizations. The DMCA is the Digital Millennium Copyright Act, IEC is the International Electrotechnical Consortium and defines standards for electrotechnology, and FISA is the Federal Intelligence Surveillance Act, not an audit standard.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      793,
      766,
      768,
      862,
      1006
    ],
    "source": ""
  },
  {
    "id": 2553,
    "question": "Kelly's team conducts regression testing on each patch that they release. <br>What key performance measure should they maintain to measure the effectiveness of their testing?",
    "choice_a": "Time to remediate vulnerabilities",
    "choice_b": "A measure of the rate of defect recurrence",
    "choice_c": "A weighted risk trend",
    "choice_d": "A measure of the specific coverage of their testing",
    "correct_answer": "B",
    "explanation": "Kelly's team is using regression testing, which is intended to prevent the recurrence of issues. This means that measuring the rate of defect recurrence is an appropriate measure for their work. Time to remediate vulnerabilities is associated with activities like patching, rather than preparing the patch, whereas a weighted risk trend is used to measure risk over time to an organization. Finally, specific coverage may be useful to determine if they are fully testing their effort, but regression testing is more specifically covered by defect recurrence rates.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      502,
      780,
      496,
      1003,
      1004
    ],
    "source": ""
  },
  {
    "id": 2554,
    "question": "Which of the following types of code review is not typically performed by a human?",
    "choice_a": "Software inspections",
    "choice_b": "Pair programming",
    "choice_c": "Static program analysis",
    "choice_d": "Software walk-throughs",
    "correct_answer": "C",
    "explanation": "Static program reviews are typically performed by an automated tool. Program understanding, program comprehension, pair programming, software inspections, and software walk-throughs are all human-centric methods for reviewing code.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      494,
      1021,
      1022,
      496,
      775
    ],
    "source": ""
  },
  {
    "id": 2555,
    "question": "Susan is the lead of a quality assurance team at her company. The team has been tasked with the testing for a major release of their company's core software product. <br>Susan's team of software testers are required to test every code path, including those that will only be used when an error condition occurs. <br>What type of testing environment does her team need to ensure complete code coverage?",
    "choice_a": "White box",
    "choice_b": "Gray box",
    "choice_c": "Black box",
    "choice_d": "Dynamic",
    "correct_answer": "A",
    "explanation": "To fully test code, a white-box test is required. Without full visibility of the code, error conditions or other code could be missed, making a gray-box or black-box test an inappropriate solution. Using dynamic testing that runs against live code could also result in some conditions being missed due to sections of code not being exposed to typical usage.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      494,
      496,
      1004,
      1003,
      778
    ],
    "source": ""
  },
  {
    "id": 2556,
    "question": "Susan is the lead of a quality assurance team at her company. The team has been tasked with the testing for a major release of their company's core software product. <br>As part of the continued testing of their new application, Susan's quality assurance team has designed a set of test cases for a series of black-box tests. These functional tests are then run, and a report is prepared explaining what has occurred. <br>What type of report is typically generated during this testing to indicate test metrics?",
    "choice_a": "A test coverage report",
    "choice_b": "A penetration test report",
    "choice_c": "A code coverage report",
    "choice_d": "A line coverage report",
    "correct_answer": "A",
    "explanation": "A test coverage report measures how many of the test cases have been completed and is used as a way to provide test metrics when using test cases. A penetration test report is provided when a penetration test is conducted\u2014this is not a penetration test. A code coverage report covers how much of the code has been tested, and a line coverage report is a type of code coverage report.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      778,
      1003,
      1005,
      779
    ],
    "source": ""
  },
  {
    "id": 2557,
    "question": "Susan is the lead of a quality assurance team at her company. The team has been tasked with the testing for a major release of their company's core software product. <br>As part of their code coverage testing, Susan's team runs the analysis in a nonproduction environment using logging and tracing tools. <br>Which of the following types of code issues is most likely to be missed during testing due to this change in the operating environment?",
    "choice_a": "Improper bounds checking",
    "choice_b": "Input validation",
    "choice_c": "A race condition",
    "choice_d": "Pointer manipulation",
    "correct_answer": "C",
    "explanation": "The changes from a testing environment with instrumentation inserted into the code and the production environment for the code can mask timing-related issues like race conditions. Bounds checking, input validation, and pointer manipulation are all related to coding issues rather than environmental issues and are more likely to be discoverable in a test environment.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1003,
      1005,
      496,
      775,
      494
    ],
    "source": ""
  },
  {
    "id": 2558,
    "question": "Robin recently conducted a vulnerability scan and found a critical vulnerability on a server that handles sensitive information. <br>What should Robin do next?",
    "choice_a": "Patching",
    "choice_b": "Reporting",
    "choice_c": "Remediation",
    "choice_d": "Validation",
    "correct_answer": "D",
    "explanation": "Once a vulnerability scanner identifies a potential problem, validation is necessary to verify that the issue exists. Reporting, patching, or other remediation actions can be conducted once the vulnerability has been confirmed.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      859,
      860,
      861,
      789,
      502
    ],
    "source": ""
  },
  {
    "id": 2559,
    "question": "The automated code testing and integration that Andrea ran as part of her organization's CI/CD pipeline errored out. <br>What should Andrea do with the code if the company needs the code to go live immediately?",
    "choice_a": "Manually bypass the test.",
    "choice_b": "Review error logs to identify the problem.",
    "choice_c": "Rerun the test to see if it works.",
    "choice_d": "Send the code back to the developer for a fix.",
    "correct_answer": "B",
    "explanation": "While handling errors and exceptions can be something of an art, the first thing to do in circumstances like these is to review error logs and notifications to try to find out what went wrong. From there, Andrea can make a decision to remediate a problem, send the code back for a fix, or take another action. She might even opt to send the code forward if the error occurred after testing was completed and was with the process flow or another noncritical element, but would only do so if she was absolutely certain that was the case.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      494,
      496,
      1003,
      1005,
      498
    ],
    "source": ""
  },
  {
    "id": 2560,
    "question": "Michelle wants to compare vulnerabilities she has discovered in her data center based on how exploitable they are, if exploit code exists, and how hard they are to remediate. <br>What scoring system should she use to compare vulnerability metrics like these?",
    "choice_a": "CSV",
    "choice_b": "NVD",
    "choice_c": "VSS",
    "choice_d": "CVSS",
    "correct_answer": "D",
    "explanation": "The Common Vulnerability Scoring System (CVSS) includes metrics and calculation tools for exploitability, impact, how mature exploit code is, and how vulnerabilities can be remediated, as well as a means to score vulnerabilities against users' unique requirements. NVD is the National Vulnerability Database, CSV is short for comma-separated values, and Visual SourceSafe (VSS) is an irrelevant term related to software development rather than vulnerability management.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      789,
      787,
      861,
      859,
      860
    ],
    "source": ""
  },
  {
    "id": 2561,
    "question": "During a port scan of his network, Alex finds that a number of hosts respond on TCP ports 80, 443, 515, and 9100 in offices throughout his organization. <br>What type of devices is Alex likely discovering?",
    "choice_a": "Web servers",
    "choice_b": "File servers",
    "choice_c": "Wireless access points",
    "choice_d": "Printers",
    "correct_answer": "D",
    "explanation": "Network-enabled printers often provided services via TCP 515 and 9100, and have both nonsecure and secure web-enabled management interfaces on TCP 80 and 443. Web servers, access points, and file servers would not typically provide service on the LPR and LPD ports (515 and 9100).",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      763,
      787,
      789,
      498,
      861
    ],
    "source": ""
  },
  {
    "id": 2562,
    "question": "Nikto, Burp Suite, and Wapiti are all examples of what type of tool?",
    "choice_a": "Web application vulnerability scanners",
    "choice_b": "Code review tools",
    "choice_c": "Vulnerability scanners",
    "choice_d": "Port scanners",
    "correct_answer": "A",
    "explanation": "Nikto, Burp Suite, and Wapiti are all web application vulnerability scanners, tools designed specifically to scan web servers and applications. While they share some functionality with broader vulnerability scanners and port scanning tools, they have a narrower focus and typically have deeper capabilities than vulnerability scanners.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      775,
      776,
      494,
      860
    ],
    "source": ""
  },
  {
    "id": 2563,
    "question": "Frank's team is testing a new API that his company's developers have built for their application infrastructure. <br>Which of the following is not a common API issue that you would expect Frank's team to find?",
    "choice_a": "Improper encryption",
    "choice_b": "Object-level authorization issues",
    "choice_c": "User authentication issues",
    "choice_d": "Lack of rate limiting",
    "correct_answer": "A",
    "explanation": "APIs typically transfer data for web application via HTTPS, meaning that the API itself is not responsible for encryption. If Frank's team discovers that TLS is not enabled, they will need to work with the infrastructure or systems administration team to ensure that TLS is enabled and in use rather than making API changes. Authorization for object access, authentication weaknesses, and rate limiting are all common API issues. If you're not familiar with the types of issues you might encounter in APIs, you can read more about them in the OWASP API security top 10 at <code>github.com/OWASP/API-Security/blob/master/2019/en/dist/owasp-api-security-top-10.pdf.</code>",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      494,
      775,
      776,
      777
    ],
    "source": ""
  },
  {
    "id": 2564,
    "question": "Jim is working with a penetration testing contractor who proposes using Metasploit as part of her penetration testing effort. <br>What should Jim expect to occur when Metasploit is used?",
    "choice_a": "Systems will be scanned for vulnerabilities.",
    "choice_b": "Systems will have known vulnerabilities exploited.",
    "choice_c": "Services will be probed for buffer overflow and other unknown flaws.",
    "choice_d": "Systems will be tested for zero-day exploits.",
    "correct_answer": "B",
    "explanation": "Metasploit is an exploitation package that is designed to assist penetration testers. A tester using Metasploit can exploit known vulnerabilities for which an exploit has been created or can create their own exploits using the tool. While Metasploit provides built-in access to some vulnerability scanning functionality, a tester using Metasploit should primarily be expected to perform actual tests of exploitable vulnerabilities. Similarly, Metasploit supports creating buffer overflow attacks, but it is not a purpose-built buffer overflow testing tool, and of course, testing systems for zero-day exploits doesn't work unless they have been released.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      775,
      776,
      1078,
      1080
    ],
    "source": ""
  },
  {
    "id": 2565,
    "question": "Susan needs to ensure that the interactions between the components of her e-commerce application are all handled properly. She intends to verify communications, error handling, and session management capabilities throughout her infrastructure. <br>What type of testing is she planning to conduct?",
    "choice_a": "Misuse case testing",
    "choice_b": "Fuzzing",
    "choice_c": "Regression testing",
    "choice_d": "Interface testing",
    "correct_answer": "D",
    "explanation": "Susan is conducting interface testing. Interface testing involves testing system or application components to ensure that they work properly together. Misuse case testing focuses on how an attacker might misuse the application and would not test normal cases. Fuzzing attempts to send unexpected input and might be involved in interface testing, but it won't cover the full set of concerns. Regression testing is conducted when testing changes and is used to ensure that the application or system functions as it did before the update or change.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      775,
      776,
      778,
      779
    ],
    "source": ""
  },
  {
    "id": 2566,
    "question": "Jim is designing his organization's log management systems and knows that he needs to carefully plan to handle the organization's log data. <br>Which of the following is not a factor that Jim should be concerned with?",
    "choice_a": "The volume of log data",
    "choice_b": "A lack of sufficient log sources",
    "choice_c": "Data storage security requirements",
    "choice_d": "Network bandwidth",
    "correct_answer": "B",
    "explanation": "Not having enough log sources is not a common consideration in log management system design, although it may be a worry for security managers who can't capture the data they need. Log management system designs must take into account the volume of log data and the network bandwidth it consumes, the security of the data, and the amount of effort required to analyze the data.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      781,
      783,
      782,
      774
    ],
    "source": ""
  },
  {
    "id": 2567,
    "question": "Ryan's organization wants to ensure that proper account management is occurring but does not have a central identity and access management tool in place. Ryan has a limited amount of time to do his verification process. <br>What is his best option to test the account management process as part of an internal audit?",
    "choice_a": "Validate all accounts changed in the past 90 days.",
    "choice_b": "Select high-value administrative accounts for validation.",
    "choice_c": "Validate all account changes in the past 180 days.",
    "choice_d": "Validate a random sample of accounts.",
    "correct_answer": "D",
    "explanation": "Random sampling of accounts is the recommended best practice if all accounts cannot be validated. Selecting only recently changed accounts will not identify long-term issues or historic issues, and only checking high-value accounts will not show if there are issues or bad practices with other account types.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      499,
      502,
      1007,
      862,
      498
    ],
    "source": ""
  },
  {
    "id": 2568,
    "question": "When a Windows system is rebooted, what type of log is generated?",
    "choice_a": "Error",
    "choice_b": "Warning",
    "choice_c": "Information",
    "choice_d": "Failure audit",
    "correct_answer": "C",
    "explanation": "Rebooting a Windows machine results in an information log entry. Windows defines five types of events: errors, which indicate a significant problem; warnings, which may indicate future problems; information, which describes successful operation; success audits, which record successful security accesses; and failure audits, which record failed security access attempts.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      782,
      773,
      783,
      781
    ],
    "source": ""
  },
  {
    "id": 2569,
    "question": "During a review of access logs, Alex notices that Michelle logged into her workstation in New York at 8 a.m. daily but that she was recorded as logging into her department's main web application shortly after 3 a.m. daily. <br>What common logging issue has Alex likely encountered?",
    "choice_a": "Inconsistent log formatting",
    "choice_b": "Modified logs",
    "choice_c": "Inconsistent timestamps",
    "choice_d": "Multiple log sources",
    "correct_answer": "C",
    "explanation": "Inconsistent timestamps are a common problem, often caused by improperly set time zones or due to differences in how system clocks are set. In this case, a consistent time difference often indicates that one system uses local time, and the other is using Greenwich mean time (GMT). Logs from multiple sources tend to cause problems with centralization and collection, whereas different log formats can create challenges in parsing log data. Finally, modified logs are often a sign of intrusion or malicious intent.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      772,
      773,
      783,
      502
    ],
    "source": ""
  },
  {
    "id": 2570,
    "question": "What type of vulnerability scan accesses configuration information from the systems it is run against as well as information that can be accessed via services available via the network?",
    "choice_a": "Authenticated scans",
    "choice_b": "Web application scans",
    "choice_c": "Unauthenticated scans",
    "choice_d": "Port scans",
    "correct_answer": "A",
    "explanation": "Authenticated scans use a read-only account to access configuration files, allowing more accurate testing of vulnerabilities. Web application scans, unauthenticated scans, and port scans don't have access to configuration files unless they are inadvertently exposed.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      859,
      861,
      494,
      775
    ],
    "source": ""
  },
  {
    "id": 2572,
    "question": "Ben's organization has begun to use STRIDE to assess its software and has identified threat agents and the business impacts that these threats could have. Now they are working to identify appropriate controls for the issues they have identified. <br>Ben's team is attempting to categorize a transaction identification issue that is caused by use of a symmetric key shared by multiple servers. <br>What STRIDE category should this fall into?",
    "choice_a": "Information disclosure",
    "choice_b": "Denial of service",
    "choice_c": "Tampering",
    "choice_d": "Repudiation",
    "correct_answer": "D",
    "explanation": "Since a shared symmetric key could be used by any of the servers, transaction identification problems caused by a shared key are likely to involve a repudiation issue. If encrypted transactions cannot be uniquely identified by a server, they cannot be proved to have come from a specific server.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 2573,
    "question": "Ben's organization has begun to use STRIDE to assess its software and has identified threat agents and the business impacts that these threats could have. Now they are working to identify appropriate controls for the issues they have identified. <br>Ben wants to use a third-party service to help assess denial-of-service attack vulnerabilities due the amount of traffic during denial-of-service attacks. <br>What type of engagement should he suggest to his organization?",
    "choice_a": "A social engineering engagement",
    "choice_b": "A penetration test",
    "choice_c": "Load or stress testing",
    "choice_d": "Testing using a fuzzer",
    "correct_answer": "C",
    "explanation": "Ben should engage a company that can perform a load or stress test to validate how the application performs under both expected and extreme loads so that he knows what a denial-of-service attack based on load will look like. Social engineering does not test the ability of sites to handle load, and penetration testers may conduct denial-of-service attacks but typically do not. Fuzzers send random input to test how applications handle unexpected input rather than relying on extreme load. They might help test for flaws that could result in a denial-of-service condition, but the question specifically asks about load-based conditions, not software flaws.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      496,
      778,
      780,
      775,
      495
    ],
    "source": ""
  },
  {
    "id": 2574,
    "question": "Chris is troubleshooting an issue with his organization's SIEM reporting. After analyzing the issue, he believes that the timestamps on log entries from different systems are inconsistent. <br>What protocol can he use to resolve this issue?",
    "choice_a": "SSH",
    "choice_b": "FTP",
    "choice_c": "TLS",
    "choice_d": "NTP",
    "correct_answer": "D",
    "explanation": "The Network Time Protocol (NTP) allows the synchronization of system clocks with a standardized time source. The Secure Shell (SSH) protocol provides encrypted administrative connections to servers. The File Transfer Protocol (FTP) is used for data exchange. Transport Layer Security (TLS) is an encryption process used to protect information in transit over a network.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      498,
      772,
      774,
      783,
      782
    ],
    "source": ""
  },
  {
    "id": 2575,
    "question": "Ryan is considering the use of fuzz testing in his web application testing program. <br>Which one of the following statements about fuzz testing should Ryan consider when making his decision?",
    "choice_a": "Fuzzers only find complex faults.",
    "choice_b": "Testers must manually generate input.",
    "choice_c": "Fuzzers may not fully cover the code.",
    "choice_d": "Fuzzers can't reproduce errors.",
    "correct_answer": "C",
    "explanation": "Fuzz testers are capable of automatically generating input sequences to test an application. Therefore, testers do not need to manually generate input, although they may do so if they want. Fuzzers can reproduce errors (and thus, \"fuzzers can't reproduce errors\" is not an issue) but typically don't fully cover the code\u2014code coverage tools are usually paired with fuzzers to validate how much coverage was possible. Fuzzers are often limited to simple errors because they won't handle business logic or attacks that require knowledge from the application user.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      775,
      776,
      1003,
      496,
      777
    ],
    "source": ""
  },
  {
    "id": 2576,
    "question": "Ken is designing a testing process for software developed by his team. He is designing a test that verifies that every line of code was executed during the test. <br>What type of analysis is Ken performing?",
    "choice_a": "Branch coverage",
    "choice_b": "Condition coverage",
    "choice_c": "Function coverage",
    "choice_d": "Statement coverage",
    "correct_answer": "D",
    "explanation": "Statement coverage tests verify that every line of code was executed during the test. Branch coverage verifies that every <code>if</code> statement was executed under all <code>if</code> and <code>else</code> conditions. Condition coverage verifies that every logical test in the code was executed under all sets of inputs. Function coverage verifies that every function in the code was called and returns results.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1004,
      1003,
      496,
      778,
      775
    ],
    "source": ""
  },
  {
    "id": 2577,
    "question": "During a port scan, Ben uses nmap's default settings and sees the following results. <br><img src=\"/question_assets/CISSP/6_image6.png\"/><br>If Ben is conducting a penetration test, what should his next step be after receiving these results?",
    "choice_a": "Connect to the web server using a web browser.",
    "choice_b": "Connect via Telnet to test for vulnerable accounts.",
    "choice_c": "Identify interesting ports for further scanning.",
    "choice_d": "Use sqlmap against the open databases.",
    "correct_answer": "C",
    "explanation": "After scanning for open ports using a port scanning tool like nmap, penetration testers will identify interesting ports and then conduct vulnerability scans to determine what services may be vulnerable. This will perform many of the same activities that connecting via a web server will and will typically be more useful than trying to manually test for vulnerable accounts via Telnet. sqlmap would typically be used after a vulnerability scanner identifies additional information about services, and the vulnerability scanner will normally provide a wider range of useful information.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      763,
      765,
      859,
      789
    ],
    "source": ""
  },
  {
    "id": 2578,
    "question": "During a port scan, Ben uses nmap's default settings and sees the following results. <br><img src=\"/question_assets/CISSP/6_image6.png\"/><br>Based on the scan results, what operating system (OS) was the system that was scanned most likely running?",
    "choice_a": "Windows Desktop",
    "choice_b": "Linux",
    "choice_c": "Network device",
    "choice_d": "Windows Server",
    "correct_answer": "B",
    "explanation": "The system is likely a Linux system. The system shows X11, as well as login, shell, and nfs ports, all of which are more commonly found on Linux systems than Windows systems or network devices. This system is also very poorly secured; many of the services running on it should not be exposed in a modern secure network.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      788,
      763,
      764,
      859,
      861
    ],
    "source": ""
  },
  {
    "id": 2579,
    "question": "During a port scan, Ben uses nmap's default settings and sees the following results. <br><img src=\"/question_assets/CISSP/6_image6.png\"/><br>Ben's manager expresses concern about the coverage of his scan. <br>Why might his manager have this concern?",
    "choice_a": "Ben did not test UDP services.",
    "choice_b": "Ben did not discover ports outside the \"well-known ports.\"",
    "choice_c": "Ben did not perform OS fingerprinting.",
    "choice_d": "Ben tested only a limited number of ports.",
    "correct_answer": "D",
    "explanation": "Nmap only scans 1000 TCP and UDP ports by default, including ports outside the 0\u20131024 range of \"well-known\" ports. By using the defaults for nmap, Ben missed 64,535 ports. OS fingerprinting won't cover more ports but would have provided a best guess of the OS running on the scanned system.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      763,
      765,
      788,
      496
    ],
    "source": ""
  },
  {
    "id": 2580,
    "question": "Lucca is reviewing his organization's disaster recovery process data and notes that the MTD for the business's main website is two hours. <br>What does he know about the RTO for the site when he does testing and validation?",
    "choice_a": "It needs to be less than two hours.",
    "choice_b": "It needs to be at least two hours.",
    "choice_c": "The MTD is too short and needs to be longer.",
    "choice_d": "The RTO is too short and needs to be longer.",
    "correct_answer": "A",
    "explanation": "When Lucca reviews the recovery time objective (RTO) data, he needs to ensure that the organization can recover from an outage in less than two hours based on the maximum tolerable downtime (MTD) of two hours.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      790,
      791,
      792,
      786,
      500
    ],
    "source": ""
  },
  {
    "id": 2581,
    "question": "Diana has engaged third-party auditors and wants to release an audit attestation to third parties without including details of the audit. <br>What type of SSAE 18 SOC report should she request?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SOC 4",
    "correct_answer": "C",
    "explanation": "Diana should request an SOC 3 report, which is intended  for distribution to third parties. They include the auditor's opinions and management assertions, along with information about the service organization. SOC3 reports are specifically intended for external release, unlike SOC 1 (financial reporting) and SOC 2 (confidential security and privacy) engagements.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      794,
      795,
      793,
      766,
      1006
    ],
    "source": ""
  },
  {
    "id": 2582,
    "question": "While reviewing the software testing output for her organization's new application, Madhuri notices that the application has produced errors that included directory and file information shown to the web application tester. <br>What issue should she include in her report about the application?",
    "choice_a": "It does not perform proper exception handling.",
    "choice_b": "The software does not handle misuse case testing properly.",
    "choice_c": "Debugging statements need to be removed.",
    "choice_d": "The code was not fully tested due to errors.",
    "correct_answer": "A",
    "explanation": "Showing end users error information about the code, particularly with directory and file information included, means that the application does not perform proper exception handling. Errors should be logged or noted in a way that the administrator can handle, but end users (and attackers!) should not see that information. The software may be handling misuse properly, as the problem does not note if this was due to normal testing or misuse testing. There is no information about debugging code causing the output, and test coverage was not noted in the question.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      494,
      775,
      777,
      779,
      498
    ],
    "source": ""
  },
  {
    "id": 2584,
    "question": "The president of Josh's company is concerned about a significant increase in cryptographic malware that is impacting other companies in their industry. She has asked John to ensure that the company's data will be recoverable if malware strikes and encrypts their production systems. <br>What process does Josh need to undertake to be able to tell her that the company is covered?",
    "choice_a": "Encrypt all sensitive data.",
    "choice_b": "Hash all of the organization's data to detect cryptographic malware.",
    "choice_c": "Perform backup verification.",
    "choice_d": "Use anti-encryption technology to prevent the malware from encrypting drives.",
    "correct_answer": "C",
    "explanation": "Validating that the organization has secure and usable backups is Josh's best answer. If cryptographic malware strikes, the best answer is to have backups that you can rely on and that will not also be encrypted, which means a separation of systems and potentially a need to do versioning so that unencrypted backups are not replaced by encrypted and thus inaccessible versions. Encrypting sensitive data won't stop attackers from re-encrypting it, making it inaccessible. Hashing to detect the attack won't stop it or make it possible to recover, and anti-encryption technology does what the option suggests does not exist.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      786,
      500,
      784,
      785,
      791
    ],
    "source": ""
  },
  {
    "id": 2585,
    "question": "Joanna is her organization's CISO, and in her security operations oversight role she wants to ensure that management oversight is happening for security-related changes. <br>What system should she focus on to track this type of data in most organizations?",
    "choice_a": "The SIEM system",
    "choice_b": "The IPS system",
    "choice_c": "The CMS tool",
    "choice_d": "The ITSM tool",
    "correct_answer": "D",
    "explanation": "IT service management, or ITSM, tools include change management and thus the type of approvals and review processes that Joanna is looking for. An SIEM helps with security logs and events, an IPS looks for intrusions and unwanted traffic, and a CMS is a content management tool.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      863,
      864,
      502,
      792,
      768
    ],
    "source": ""
  },
  {
    "id": 2586,
    "question": "Henry wants to validate that his backups are working. <br>Which of the following options is the best way for him to ensure that the backups will be useful in a true disaster recovery scenario?",
    "choice_a": "Periodically restore a random file to ensure that the backups are working.",
    "choice_b": "Review configurations and settings on a regular schedule to validate backup settings.",
    "choice_c": "Review the backup logs to ensure no errors are occurring.",
    "choice_d": "Regularly perform full restores from backups to validate their success.",
    "correct_answer": "D",
    "explanation": "All of these are useful parts of a backup strategy, but performing full restores from backups on a regular basis is the best option listed. If regular restores work, then individual files will be recoverable, but individual files may not show larger issues with backups. Configuration and setting reviews are important but will not validate the backups themselves, and error messages can indicate problems but won't demonstrate intact logs either.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      500,
      786,
      792,
      791,
      784
    ],
    "source": ""
  },
  {
    "id": 2587,
    "question": "What type of vulnerabilities will not be found by a vulnerability scanner?",
    "choice_a": "Local vulnerabilities",
    "choice_b": "Service vulnerabilities",
    "choice_c": "Zero-day vulnerabilities",
    "choice_d": "Vulnerabilities that require authentication",
    "correct_answer": "C",
    "explanation": "Vulnerability scanners cannot detect vulnerabilities for which they do not have a test, plug-in, or signature. Signatures often include version numbers, service fingerprints, or configuration data. They can detect local vulnerabilities as well as those that require authentication if they are provided with credentials, and of course, they can detect service vulnerabilities.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      789,
      859,
      860,
      861
    ],
    "source": ""
  },
  {
    "id": 2588,
    "question": "Jacinda wants to measure the effectiveness of her security training as one of her security metrics. <br>Which of the following measures are the most useful for assessing the effectiveness of security awareness training?  (Select all that apply.)",
    "choice_a": "How many people took the training",
    "choice_b": "The level of security awareness before and after the training",
    "choice_c": "The length of the training in hours",
    "choice_d": "The number of training events each individual attended this year",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "The number of staff who took a given training and the average change in their awareness from before the training to after the training can provide insight into how many trained staff you have and how impactful the training was. Over time, this will allow you to determine if your training is helping and if awareness is increasing. The length of the training does not assess its impact; in addition, the number of events each individual attended does not mean that staff are becoming more aware.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      501,
      502,
      498,
      499,
      500
    ],
    "source": ""
  },
  {
    "id": 2589,
    "question": "Elaine has discovered a previously unknown critical vulnerability in a product that her organization uses. Her organization has a strong commitment to ethical disclosure, and Elaine wants to follow common ethical disclosure practices. <br>What should she do first?",
    "choice_a": "Build an in-house remediation or control and then publicly disclosure the vulnerability to prompt the vendor to patch it quickly.",
    "choice_b": "Build an in-house remediation or control and then notify the vendor of the issue.",
    "choice_c": "Notify the vendor and give them a reasonable amount of time to fix the issue.",
    "choice_d": "Publicly disclose the vulnerability so that the vendor will patch it in an appropriate amount of time.",
    "correct_answer": "C",
    "explanation": "Ethical (or responsible) disclosure norms include notifying the vendor and providing them with a reasonable amount of time to remediate the issue. Public disclosures before notifying the vendor or in a short period of time are considered unethical in most circumstances. While this time frame varies, 90 to 120 days is not uncommon across the industry due to the complexity of software and other technologies.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      497,
      502,
      863,
      1006,
      501
    ],
    "source": ""
  },
  {
    "id": 2590,
    "question": "NIST Special Publication 800-115, the Technical Guide to Information Security Testing and Assessment, provides NIST's process for penetration testing. Use this image as well as your knowledge of penetration testing to answer the questions. <br><img src=\"/question_assets/CISSP/6_image7.png\"/><br>Which of the following is not a part of the discovery phase?",
    "choice_a": "Hostname and IP address information gathering",
    "choice_b": "Service information capture",
    "choice_c": "Dumpster diving",
    "choice_d": "Privilege escalation",
    "correct_answer": "D",
    "explanation": "Privilege escalation occurs during the attack phase of a penetration test. Host and service information gathering, as well as activities like dumpster diving that can provide information about the organization, its systems, and security, are all part of the discovery phase.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1078,
      1080,
      787,
      771,
      777
    ],
    "source": ""
  },
  {
    "id": 2591,
    "question": "NIST Special Publication 800-115, the Technical Guide to Information Security Testing and Assessment, provides NIST's process for penetration testing. Use this image as well as your knowledge of penetration testing to answer the questions. <br><img src=\"/question_assets/CISSP/6_image7.png\"/><br>NIST specifies four attack phase steps: gaining access, escalating privileges, system browsing, and installing additional tools. Once attackers install additional tools, what phase will a penetration tester typically return to?",
    "choice_a": "Discovery",
    "choice_b": "Gaining access",
    "choice_c": "Escalating privileges",
    "choice_d": "System browsing",
    "correct_answer": "B",
    "explanation": "Once additional tools have been installed, penetration testers will typically use them to gain additional access. From there they can further escalate privileges, search for new targets or data, and, once again, install more tools to allow them to pivot further into infrastructure or systems.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1078,
      1080,
      776,
      775,
      494
    ],
    "source": ""
  },
  {
    "id": 2592,
    "question": "NIST Special Publication 800-115, the Technical Guide to Information Security Testing and Assessment, provides NIST's process for penetration testing. Use this image as well as your knowledge of penetration testing to answer the questions. <br><img src=\"/question_assets/CISSP/6_image7.png\"/><br>Which of the following is not a typical part of a penetration test report?",
    "choice_a": "A list of identified vulnerabilities",
    "choice_b": "All sensitive data that was gathered during the test",
    "choice_c": "Risk ratings for each issue discovered",
    "choice_d": "Mitigation guidance for issues identified",
    "correct_answer": "B",
    "explanation": "Penetration testing reports often do not include the specific data captured during the assessment, as the readers of the report may not be authorized to access all of the data, and exposure of the report could result in additional problems for the organization. A listing of the issues discovered, risk ratings, and remediation guidance are all common parts of a penetration test report.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      771,
      1078,
      1080,
      861,
      795
    ],
    "source": ""
  },
  {
    "id": 2593,
    "question": "Mary is reviewing the availability controls for the system architecture shown here. <br><img src=\"/question_assets/CISSP/7_image1.png\"/><br>What technology is shown that provides fault tolerance for the database servers?",
    "choice_a": "Failover cluster",
    "choice_b": "UPS",
    "choice_c": "Tape backup",
    "choice_d": "Cold site",
    "correct_answer": "A",
    "explanation": "The illustration shows an example of a failover cluster, where DB1 and DB2 are both configured as database servers. At any given time, only one will function as the active database server, while the other remains ready to assume responsibility if the first one fails. While the environment may use UPS, tape backup, and cold sites as disaster recovery and business continuity controls, they are not shown in the diagram.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      577,
      575,
      572,
      576,
      837
    ],
    "source": ""
  },
  {
    "id": 2594,
    "question": "Joe is the security administrator for an ERP system. He is preparing to create accounts for several new employees. <br>What default access should he give to all of the new employees as he creates the accounts?",
    "choice_a": "Read only",
    "choice_b": "Editor",
    "choice_c": "Administrator",
    "choice_d": "No access",
    "correct_answer": "D",
    "explanation": "The principle of least privilege should guide Joe in this case. He should apply no access permissions by default and then give each user the necessary permissions to perform their job responsibilities. Read only, editor, and administrator permissions may be necessary for one or more of these users, but those permissions should be assigned based upon business need and not by default.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      503,
      535,
      533,
      523,
      543
    ],
    "source": ""
  },
  {
    "id": 2595,
    "question": "Tim is configuring a privileged account management solution for his organization. <br>Which one of the following is not a privileged administrative activity that should be automatically sent to a log of superuser actions?",
    "choice_a": "Purging log entries",
    "choice_b": "Restoring a system from backup",
    "choice_c": "Logging into a workstation",
    "choice_d": "Managing user accounts",
    "correct_answer": "C",
    "explanation": "While most organizations would want to log attempts to log in to a workstation, this is not considered a privileged administrative activity and would go through normal logging processes.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      506,
      533,
      535,
      557,
      556
    ],
    "source": ""
  },
  {
    "id": 2596,
    "question": "When one of the employees of Alice's company calls in for support, she uses a code word that the company agreed to use if employees were being forced to perform an action. <br>What is this scenario called?",
    "choice_a": "Social engineering",
    "choice_b": "Duress",
    "choice_c": "Force majeure",
    "choice_d": "Stockholm syndrome",
    "correct_answer": "B",
    "explanation": "Duress, or being under threat of violence or other constraints, is a concern for organizations such as banks, jewelry stores, or other organizations where an attacker may attempt to force an employee to perform actions. Organizations that expect that a scenario like this may occur will often use duress code words that let others know that they are performing actions under threat.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      509,
      508,
      511,
      605,
      599
    ],
    "source": ""
  },
  {
    "id": 2597,
    "question": "Jordan is preparing to bring evidence into court after a cybersecurity incident investigation. He is responsible for preparing the physical artifacts, including affected servers and mobile devices. <br>What type of evidence consists entirely of tangible items that may be brought into a court of law?",
    "choice_a": "Documentary evidence",
    "choice_b": "Parol evidence",
    "choice_c": "Testimonial evidence",
    "choice_d": "Real evidence",
    "correct_answer": "D",
    "explanation": "Real evidence consists of things that may actually be brought into a courtroom as evidence. For example, real evidence includes hard disks, weapons, and items containing fingerprints. Documentary evidence consists of written items that may or may not be in tangible form. Testimonial evidence is verbal testimony given by witnesses with relevant information. The parol evidence rule says that when an agreement is put into written form, the written document is assumed to contain all the terms of the agreement.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      601,
      615,
      602,
      886,
      888
    ],
    "source": ""
  },
  {
    "id": 2598,
    "question": "Lauren wants to ensure that her users only run software that her organization has approved. <br>What technology should she deploy?",
    "choice_a": "Blacklisting",
    "choice_b": "Configuration management",
    "choice_c": "Whitelisting",
    "choice_d": "Graylisting",
    "correct_answer": "C",
    "explanation": "A whitelist of allowed applications will ensure that Lauren's users can run only the applications that she preapproves. Blacklists would require her to maintain a list of every application that she doesn't want to allow, which is an almost impossible task. Graylisting is not a technology option, and configuration management can be useful for making sure the right applications are on a PC but typically can't directly prevent users from running undesired applications or programs.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      871,
      872,
      550,
      523,
      544
    ],
    "source": ""
  },
  {
    "id": 2599,
    "question": "Colin is responsible for managing his organization's use of cybersecurity deception technologies. <br>Which one of the following should he use on a honeypot system to consume an attacker's time while alerting administrators?",
    "choice_a": "Honeynet",
    "choice_b": "Pseudoflaw",
    "choice_c": "Warning banner",
    "choice_d": "Darknet",
    "correct_answer": "B",
    "explanation": "A pseudoflaw is a false vulnerability in a system that may distract an attacker. A honeynet is a network of multiple honeypots that creates a more sophisticated environment for intruders to explore, rather than a feature Colin could use <italic>on</italic> a honeypot. A darknet is a segment of unused network address space that should have no network activity and, therefore, may be easily used to monitor for illicit activity. A warning banner is a legal tool used to notify intruders that they are not authorized to access a system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      549,
      556,
      541,
      542,
      511
    ],
    "source": ""
  },
  {
    "id": 2600,
    "question": "Toni responds to the desk of a user who reports slow system activity. Upon checking outbound network connections from that system, Toni notices a large amount of social media traffic originating from the system. The user does not use social media, and when Toni checks the accounts in question, they contain strange messages that appear encrypted. <br>What is the most likely cause of this traffic?",
    "choice_a": "Other users are relaying social media requests through the user's computer.",
    "choice_b": "The user's computer is part of a botnet.",
    "choice_c": "The user is lying about her use of social media.",
    "choice_d": "Someone else is using the user's computer when she is not present.",
    "correct_answer": "B",
    "explanation": "Social media is commonly used as a command-and-control system for botnet activity. The most likely scenario here is that the user's computer was infected with malware and joined to a botnet. This accounts for both the unusual social media traffic and the slow system activity.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      545,
      560,
      550,
      603,
      611
    ],
    "source": ""
  },
  {
    "id": 2601,
    "question": "John deploys his website to multiple regions using load balancers around the world through his cloud infrastructure as a service provider. <br>What availability concept is he using?",
    "choice_a": "Multiple processing sites",
    "choice_b": "Warm sites",
    "choice_c": "Cold sites",
    "choice_d": "A honeynet",
    "correct_answer": "A",
    "explanation": "John's design provides multiple processing sites, distributing load to multiple regions. Not only does this provide business continuity and disaster recovery functionality, but it also means that his design will be more resilient to denial-of-service attacks.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      582,
      914,
      578,
      610,
      569
    ],
    "source": ""
  },
  {
    "id": 2602,
    "question": "Jim would like to identify compromised systems on his network that may be participating in a botnet. He plans to do this by watching for connections made to known command-and-control servers. <br>Which one of the following techniques would be most likely to provide this information if Jim has access to a list of known servers?",
    "choice_a": "NetFlow records",
    "choice_b": "IDS logs",
    "choice_c": "Authentication logs",
    "choice_d": "RFC logs",
    "correct_answer": "A",
    "explanation": "NetFlow records contain an entry for every network communication session that took place on a network and can be compared to a list of known malicious hosts. IDS logs may contain a relevant record, but it is less likely because they would create log entries only if the traffic triggers the IDS, as opposed to NetFlow records, which encompass all communications. Authentication logs and RFC logs would not have records of any network traffic.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      554,
      548,
      603,
      556,
      841
    ],
    "source": ""
  },
  {
    "id": 2603,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>As Gary decides what access permissions he should grant to each user, what principle should guide his decisions about default permissions?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Aggregation",
    "choice_d": "Separation of privileges",
    "correct_answer": "B",
    "explanation": "Gary should follow the least privilege principle and assign users only the permissions they need to perform their job responsibilities. Aggregation is a term used to describe the unintentional accumulation of privileges over time, also known as privilege creep. Separation of duties and separation of privileges are principles used to secure sensitive processes.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      503,
      533,
      506,
      526
    ],
    "source": ""
  },
  {
    "id": 2604,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>As Gary designs the program, he uses the matrix shown here. <br><img src=\"/question_assets/CISSP/7_image2.png\"/><br>What principle of information security does this matrix most directly help enforce?",
    "choice_a": "Segregation of duties",
    "choice_b": "Aggregation",
    "choice_c": "Two-person control",
    "choice_d": "Defense in depth",
    "correct_answer": "A",
    "explanation": "The matrix shown in the figure is known as a segregation of duties matrix. It is used to ensure that one person does not obtain two privileges that would create a potential conflict. Aggregation is a term used to describe the unintentional accumulation of privileges over time, also known as privilege creep. Two-person control is used when two people must work together to perform a sensitive action. Defense in depth is a general security principle used to describe a philosophy of overlapping security controls.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      504,
      533,
      535,
      505,
      503
    ],
    "source": ""
  },
  {
    "id": 2605,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>Gary is preparing to create an account for a new user and assign privileges to the HR database. <br>What two elements of information must Gary verify before granting this access?",
    "choice_a": "Credentials and need to know",
    "choice_b": "Clearance and need to know",
    "choice_c": "Password and clearance",
    "choice_d": "Password and biometric scan",
    "correct_answer": "B",
    "explanation": "Before granting access, Gary should verify that the user has a valid security clearance and a business need to know the information. Gary is performing an authorization task, so he does not need to verify the user's credentials, such as a password or biometric scan.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      503,
      535,
      506,
      616,
      613
    ],
    "source": ""
  },
  {
    "id": 2606,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>Gary is preparing to develop controls around access to root encryption keys and would like to apply a principle of security designed specifically for very sensitive operations. <br>Which principle should he apply?",
    "choice_a": "Least privilege",
    "choice_b": "Defense in depth",
    "choice_c": "Security through obscurity",
    "choice_d": "Two-person control",
    "correct_answer": "D",
    "explanation": "Gary should follow the principle of two-person control by requiring simultaneous action by two separate authorized individuals to gain access to the encryption keys. He should also apply the principles of least privilege and defense in depth, but these principles apply to all operations and are not specific to sensitive operations. Gary should avoid the security through obscurity principle, the reliance upon the secrecy of security mechanisms to provide security for a system or process.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      504,
      533,
      535,
      503,
      526
    ],
    "source": ""
  },
  {
    "id": 2607,
    "question": "Gary was recently hired as the first chief information security officer (CISO) for a local government agency. The agency recently suffered a security breach and is attempting to build a new information security program. Gary would like to apply some best practices for security operations as he is designing this program. <br>How often should Gary and his team conduct a review of the privileged access that a user has to sensitive systems?  (Select all that apply.)",
    "choice_a": "On a periodic basis",
    "choice_b": "When a user leaves the organization",
    "choice_c": "When a user changes roles",
    "choice_d": "On a daily basis",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Privileged access reviews are one of the most critical components of an organization's security program because they ensure that only authorized users have access to perform the most sensitive operations. They should take place whenever a user with privileged access leaves the organization or changes roles as well as on a regular, recurring basis. However, it is not reasonable to expect that these time-consuming reviews would take place on a daily basis.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      506,
      533,
      535,
      505,
      556
    ],
    "source": ""
  },
  {
    "id": 2608,
    "question": "Which one of the following terms is often used to describe a collection of unrelated patches released in a large collection?",
    "choice_a": "Hotfix",
    "choice_b": "Update",
    "choice_c": "Security fix",
    "choice_d": "Service pack",
    "correct_answer": "D",
    "explanation": "Hotfixes, updates, and security fixes are all synonyms for single patches designed to correct a single problem. Service packs are collections of many different updates that serve as a major update to an operating system or application.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      529,
      528,
      524,
      596,
      572
    ],
    "source": ""
  },
  {
    "id": 2609,
    "question": "Tonya is collecting evidence from a series of systems that were involved in a cybersecurity incident. A colleague suggests that she use a forensic disk controller for the collection process. <br>What is the function of this device?",
    "choice_a": "Masking error conditions reported by the storage device",
    "choice_b": "Transmitting write commands to the storage device",
    "choice_c": "Intercepting and modifying or discarding commands sent to the storage device",
    "choice_d": "Preventing data from being returned by a read operation sent to the device",
    "correct_answer": "C",
    "explanation": "A forensic disk controller performs four functions. One of those, write blocking, intercepts write commands sent to the device and prevents them from modifying data on the device. The other three functions include returning data requested by a read operation, returning access-significant information from the device, and reporting errors from the device back to the forensic host.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      603,
      886,
      602,
      541,
      601
    ],
    "source": ""
  },
  {
    "id": 2610,
    "question": "Lydia is processing access control requests for her organization. She comes across a request where the user does have the required security clearance, but there is no business justification for the access. Lydia denies this request. <br>What security principle is she following?",
    "choice_a": "Need to know",
    "choice_b": "Least privilege",
    "choice_c": "Separation of duties",
    "choice_d": "Two-person control",
    "correct_answer": "A",
    "explanation": "Lydia is following the need to know principle. While the user may have the appropriate security clearance to access this information, there is no business justification provided, so she does not know that the user has an appropriate need to know the information.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      503,
      533,
      535,
      593,
      511
    ],
    "source": ""
  },
  {
    "id": 2611,
    "question": "Helen is tasked with implementing security controls in her organization that might be used to deter fraudulent insider activity. <br>Which one of the following mechanisms would be LEAST useful to her work?",
    "choice_a": "Job rotation",
    "choice_b": "Mandatory vacations",
    "choice_c": "Incident response",
    "choice_d": "Two-person control",
    "correct_answer": "C",
    "explanation": "Job rotation and mandatory vacations deter fraud by increasing the likelihood that it will be detected. Two-person control deters fraud by requiring collusion between two employees. Incident response does not normally serve as a deterrent mechanism.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      505,
      504,
      556,
      543,
      538
    ],
    "source": ""
  },
  {
    "id": 2612,
    "question": "Matt wants to ensure that critical network traffic from systems throughout his company is prioritized over web browsing and social media use at this company. <br>What technology can he use to do this?",
    "choice_a": "VLANs",
    "choice_b": "QoS",
    "choice_c": "VPN",
    "choice_d": "ISDN",
    "correct_answer": "B",
    "explanation": "Quality of service is a feature found on routers and other network devices that can prioritize specific network traffic. QoS policies define which traffic is prioritized, and traffic is then handled based on the policy.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      578,
      560,
      544,
      526,
      577
    ],
    "source": ""
  },
  {
    "id": 2613,
    "question": "Tom is responding to a recent security incident and is seeking information on the approval process for a recent modification to a system's security settings. <br>Where would he most likely find this information?",
    "choice_a": "Change log",
    "choice_b": "System log",
    "choice_c": "Security log",
    "choice_d": "Application log",
    "correct_answer": "A",
    "explanation": "The change log contains information about approved changes and the change management process. While other logs may contain details about the change's effect, the audit trail for change management would be found in the change log.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      527,
      534,
      556,
      554,
      528
    ],
    "source": ""
  },
  {
    "id": 2614,
    "question": "Staff from Susan's company often travel internationally and require connectivity to corporate systems for their work. Susan believes that these users may be targeted for corporate espionage activities because of the technologies that her company is developing and wants to include advice in the security training provided to international travelers. <br>What practice should Susan recommend that they adopt for connecting to networks while they travel?",
    "choice_a": "Only connect to public WiFi.",
    "choice_b": "Use a VPN for all connections.",
    "choice_c": "Only use websites that support TLS.",
    "choice_d": "Do not connect to networks while traveling.",
    "correct_answer": "B",
    "explanation": "While it may be tempting to tell her staff to simply not connect to any network, Susan knows that they will need connectivity to do their work. Using a VPN to connect their laptops and mobile devices to a trusted network and ensuring that all traffic is tunneled through the VPN is her best bet to secure their internet usage. Susan may also want to ensure that they take \"clean\" laptops and devices that do not contain sensitive information or documents and that those systems are fully wiped and reviewed when they return.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      510,
      511,
      609,
      516,
      524
    ],
    "source": ""
  },
  {
    "id": 2615,
    "question": "Ricky is seeking a list of information security vulnerabilities in applications, devices, and operating systems. <br>Which one of the following threat intelligence sources would be most useful to him?",
    "choice_a": "OWASP",
    "choice_b": "Bugtraq",
    "choice_c": "Microsoft Security Bulletins",
    "choice_d": "CVE",
    "correct_answer": "D",
    "explanation": "The Common Vulnerability and Exposures (CVE) dictionary contains standardized information on many different security issues. The Open Web Application Security Project (OWASP) contains general guidance on web application security issues but does not track specific vulnerabilities or go beyond web applications. The Bugtraq mailing list and Microsoft Security Bulletins are good sources of vulnerability information but are not comprehensive databases of known issues.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      531,
      564,
      529,
      534,
      532
    ],
    "source": ""
  },
  {
    "id": 2616,
    "question": "Which of the following would normally be considered an example of a disaster when performing disaster recovery planning?   (Select all that apply.)",
    "choice_a": "Hacking incident",
    "choice_b": "Flood",
    "choice_c": "Fire",
    "choice_d": "Terrorism",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "A disaster is any event that can disrupt normal IT operations and can be either natural or manmade. Hacking and terrorism are examples of manmade disasters, while flooding and fire are examples of natural disasters.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      569,
      570,
      571,
      572,
      574
    ],
    "source": ""
  },
  {
    "id": 2617,
    "question": "Glenda would like to conduct a disaster recovery test and is seeking a test that will allow a review of the plan with no disruption to normal information system activities and as minimal a commitment of time as possible. <br>What type of test should she choose?",
    "choice_a": "Tabletop exercise",
    "choice_b": "Parallel test",
    "choice_c": "Full interruption test",
    "choice_d": "Checklist review",
    "correct_answer": "D",
    "explanation": "The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems. During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      594,
      597,
      593,
      596,
      587
    ],
    "source": ""
  },
  {
    "id": 2618,
    "question": "Which one of the following is not an example of a backup tape rotation scheme?",
    "choice_a": "Grandfather/Father/Son",
    "choice_b": "Meet in the middle",
    "choice_c": "Tower of Hanoi",
    "choice_d": "Six Cartridge Weekly",
    "correct_answer": "B",
    "explanation": "The Grandfather/Father/Son, Tower of Hanoi, and Six Cartridge Weekly schemes are all different approaches to rotating backup media that balance reuse of media with data retention concerns. Meet- in-the-middle is a cryptographic attack against 2DES encryption.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      589,
      588,
      517,
      518,
      515
    ],
    "source": ""
  },
  {
    "id": 2619,
    "question": "Helen is implementing a new security mechanism for granting employees administrative privileges in the accounting system. She designs the process so that both the employee's manager and the accounting manager must approve the request before the access is granted. <br>What information security principle is Helen enforcing?",
    "choice_a": "Least privilege",
    "choice_b": "Two-person control",
    "choice_c": "Job rotation",
    "choice_d": "Separation of duties",
    "correct_answer": "B",
    "explanation": "In this scenario, Helen designed a process that requires the concurrence of two people to perform a sensitive action. This is an example of two-person control. This is different from separation of duties, where one individual may not have two separate permissions that, when combined, might allow an unwanted action. Separation of duties applied to a situation like this one might say that the same person may not have both the ability to initiate a request and the ability to approve a request. Least privilege says that an individual should have only the necessary permissions required to carry out their job function. Job rotation is a scheme that has users periodically shift job functions in order to detect malfeasance.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      504,
      533,
      505,
      543,
      526
    ],
    "source": ""
  },
  {
    "id": 2620,
    "question": "Frank is considering the use of different types of evidence in an upcoming criminal matter. <br>Which one of the following is not a requirement for evidence to be admissible in court?",
    "choice_a": "The evidence must be relevant.",
    "choice_b": "The evidence must be material.",
    "choice_c": "The evidence must be tangible.",
    "choice_d": "The evidence must be competently acquired.",
    "correct_answer": "C",
    "explanation": "Evidence provided in court must be relevant to determining a fact in question, material to the case at hand, and competently obtained. Evidence does not need to be tangible. Witness testimony is an example of intangible evidence that may be offered in court.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      601,
      615,
      602,
      603,
      607
    ],
    "source": ""
  },
  {
    "id": 2621,
    "question": "Harold recently completed leading the postmortem review of a security incident. <br>What documentation should he prepare next?",
    "choice_a": "A lessons learned document",
    "choice_b": "A risk assessment",
    "choice_c": "A remediation list",
    "choice_d": "A mitigation checklist",
    "correct_answer": "A",
    "explanation": "A lessons learned document is often created and distributed to involved parties after a postmortem review to ensure that those who were involved in the incident and others who may benefit from the knowledge are aware of what they can do to prevent future issues and to improve response in the event that one occurs.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      540,
      537,
      565,
      595,
      921
    ],
    "source": ""
  },
  {
    "id": 2622,
    "question": "Beth is creating a new cybersecurity incident response team (CSIRT) and would like to determine the appropriate team membership. <br>Which of the following groups would she normally include? (Select all that apply.)",
    "choice_a": "Information security",
    "choice_b": "Law enforcement",
    "choice_c": "Senior management",
    "choice_d": "Public affairs",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "CSIRT representation normally includes at least representatives of senior management, information security professionals, legal representatives, public affairs staff, and engineering/technical staff. Law enforcement personnel would not be included on such a team and would only be consulted as necessary.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      930,
      921,
      607,
      541,
      605
    ],
    "source": ""
  },
  {
    "id": 2623,
    "question": "Sam is responsible for backing up his company's primary file server. He configured a backup schedule that performs full backups every Monday evening at 9 p.m. and differential backups on other days of the week at that same time. Files change according to the information shown in the following figure. <br><img src=\"/question_assets/CISSP/7_image3.png\"/><br>How many files will be copied in Wednesday's backup?",
    "choice_a": "2",
    "choice_b": "3",
    "choice_c": "5",
    "choice_d": "6",
    "correct_answer": "C",
    "explanation": "In this scenario, all the files on the server will be backed up on Monday evening during the full backup. The differential backup on Wednesday will then copy all files modified since the last full backup. These include files 1, 2, 3, 5, and 6: a total of five files.<br><img src=\"/question_assets/CISSP/7_image3.png\"/>",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      588,
      598,
      596,
      592,
      595
    ],
    "source": ""
  },
  {
    "id": 2624,
    "question": "Which one of the following security tools is not capable of generating an active response to a security event?",
    "choice_a": "IPS",
    "choice_b": "Firewall",
    "choice_c": "IDS",
    "choice_d": "Antivirus software",
    "correct_answer": "C",
    "explanation": "Intrusion detection systems (IDSs) provide only passive responses, such as alerting administrators to a suspected attack. Intrusion prevention systems and firewalls, on the other hand, may take action to block an attack attempt. Antivirus software also may engage in active response by quarantining suspect files.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      547,
      548,
      566,
      561,
      544
    ],
    "source": ""
  },
  {
    "id": 2625,
    "question": "Scott is responsible for disposing of disk drives that have been pulled from his company's SAN as they are retired. <br>Which of the following options should he avoid if the data on the SAN is considered highly sensitive by his organization?",
    "choice_a": "Destroy them physically.",
    "choice_b": "Sign a contract with the SAN vendor that requires appropriate disposal and provides a certification process.",
    "choice_c": "Reformat each drive before it leaves the organization.",
    "choice_d": "Use a secure wipe tool like DBAN.",
    "correct_answer": "C",
    "explanation": "Physical destruction, an appropriate contract with certification, and secure wiping are all reasonable options. In each case, a careful inventory and check should be done to ensure that each drive is handled appropriately. Reformatting drives can leave remnant data, making this a poor data lifecycle choice for drives that contain sensitive data.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      518,
      515,
      512,
      541,
      540
    ],
    "source": ""
  },
  {
    "id": 2627,
    "question": "Which one of the following types of agreements is the most formal document that contains expectations about availability and other performance parameters between a service provider and a customer?",
    "choice_a": "Service-level agreement (SLA)",
    "choice_b": "Operational-level agreement (OLA)",
    "choice_c": "Memorandum of understanding (MOU)",
    "choice_d": "Statement of work (SOW)",
    "correct_answer": "A",
    "explanation": "The service-level agreement (SLA) is between a service provider and a customer and documents in a formal manner expectations around availability, performance, and other parameters. An MOU may cover the same items but is not as formal a document. An OLA is between internal service organizations and does not involve customers. An SOW is an addendum to a contract describing work to be performed.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      507,
      796,
      915,
      519,
      528
    ],
    "source": ""
  },
  {
    "id": 2628,
    "question": "As the CIO of a large organization, Clara would like to adopt standard processes for managing IT activities. <br>Which one of the following frameworks focuses on IT service management and includes topics such as change management, configuration management, and service-level agreements?",
    "choice_a": "ITIL",
    "choice_b": "PMBOK",
    "choice_c": "PCI DSS",
    "choice_d": "TOGAF",
    "correct_answer": "A",
    "explanation": "The IT Infrastructure Library (ITIL) framework focuses on IT service management. The Project Management Body of Knowledge (PMBOK) provides a common core of project management expertise. The Payment Card Industry Data Security Standard (PCI DSS) contains regulations for credit card security. The Open Group Architecture Framework (TOGAF) focuses on IT architecture issues.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      796,
      534,
      527,
      523,
      524
    ],
    "source": ""
  },
  {
    "id": 2629,
    "question": "Richard is experiencing issues with the quality of network service on his organization's network. The primary symptom is that packets are consistently taking too long to travel from their source to their destination. <br>What term describes the issue Richard is facing?",
    "choice_a": "Jitter",
    "choice_b": "Packet loss",
    "choice_c": "Interference",
    "choice_d": "Latency",
    "correct_answer": "D",
    "explanation": "Latency is a delay in the delivery of packets from their source to their destination. Jitter is a variation in the latency for different packets. Packet loss is the disappearance of packets in transit that requires retransmission. Interference is electrical noise or other disruptions that corrupt the contents of packets.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 2630,
    "question": "Joe wants to test a program he suspects may contain malware. <br>What technology can he use to isolate the program while it runs?",
    "choice_a": "ASLR",
    "choice_b": "Sandboxing",
    "choice_c": "Clipping",
    "choice_d": "Process isolation",
    "correct_answer": "B",
    "explanation": "Running the program in a sandbox provides secure isolation that can prevent the malware from impacting other applications or systems. If Joe uses appropriate instrumentation, he can observe what the program does, what changes it makes, and any communications it may attempt. ASLR is a memory location randomization technology, process isolation keeps processes from impacting each other, but a sandbox typically provides greater utility in a scenario like this since it can be instrumented and managed in a way that better supports investigations, and clipping is a term often used in signal processing.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      604,
      541,
      599,
      605,
      556
    ],
    "source": ""
  },
  {
    "id": 2631,
    "question": "Which one of the following is an example of a non-natural disaster?",
    "choice_a": "Hurricane",
    "choice_b": "Flood",
    "choice_c": "Mudslide",
    "choice_d": "Transformer explosion",
    "correct_answer": "D",
    "explanation": "A transformer explosion is a failure of a human-made electrical component. Flooding, mudslides, and hurricanes are all examples of natural disasters.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      592,
      569,
      586,
      594,
      508
    ],
    "source": ""
  },
  {
    "id": 2633,
    "question": "Javier is verifying that only IT system administrators have the ability to log on to servers used for administrative purposes. <br>What principle of information security is he enforcing?",
    "choice_a": "Need to know",
    "choice_b": "Least privilege",
    "choice_c": "Two-person control",
    "choice_d": "Transitive trust",
    "correct_answer": "B",
    "explanation": "The principle of least privilege says that an individual should only have the privileges necessary to complete their job functions. Removing administrative privileges from nonadministrative users is an example of least privilege.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      503,
      533,
      506,
      505
    ],
    "source": ""
  },
  {
    "id": 2634,
    "question": "Which one of the following is not a basic preventative measure that you can take to protect your systems and applications against attack?",
    "choice_a": "Implement intrusion detection and prevention systems.",
    "choice_b": "Maintain current patch levels on all operating systems and applications.",
    "choice_c": "Remove unnecessary accounts and services.",
    "choice_d": "Conduct forensic imaging of all systems.",
    "correct_answer": "D",
    "explanation": "There is no need to conduct forensic imaging as a preventative measure. Rather, forensic imaging should be used during the incident response process. Maintaining patch levels, implementing intrusion detection/prevention, and removing unnecessary services and accounts are all basic preventative measures.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      544,
      548,
      547,
      539,
      540
    ],
    "source": ""
  },
  {
    "id": 2636,
    "question": "Which one of the following is an example of a computer security incident?  (Select all that apply.)",
    "choice_a": "Failure of a backup to complete properly",
    "choice_b": "System access recorded in a log",
    "choice_c": "Unauthorized vulnerability scan of a file server",
    "choice_d": "Update of antivirus signatures",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Security incidents negatively affect the confidentiality, integrity, or availability of information or assets and/or violate a security policy. The unauthorized vulnerability scan of a server does violate security policy and may negatively affect the security of that system, so it qualifies as a security incident. The failure of a backup to complete properly jeopardizes availability and is, therefore, also a security incident. The logging of system access and update of antivirus signatures are all routine actions that do not violate policy or jeopardize security, so they are all events rather than incidents.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      536,
      543,
      538,
      531,
      554
    ],
    "source": ""
  },
  {
    "id": 2637,
    "question": "Roland is a physical security specialist in an organization that has a large amount of expensive lab equipment that often moves around the facility. <br>Which one of the following technologies would provide the most automation of an inventory control process in a cost-effective manner?",
    "choice_a": "IPS",
    "choice_b": "WiFi",
    "choice_c": "RFID",
    "choice_d": "Ethernet",
    "correct_answer": "C",
    "explanation": "Radio Frequency IDentification (RFID) technology is a cost-effective way to track items around a facility. While WiFi could be used for the same purpose, it would be much more expensive to implement.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      513,
      853,
      854,
      508,
      556
    ],
    "source": ""
  },
  {
    "id": 2638,
    "question": "Connor's company recently experienced a denial-of-service attack that Connor believes came from an inside source. If true, what type of event has the company experienced?",
    "choice_a": "Espionage",
    "choice_b": "Confidentiality breach",
    "choice_c": "Sabotage",
    "choice_d": "Integrity breach",
    "correct_answer": "C",
    "explanation": "An attack committed against an organization by an insider, such as an employee, is known as sabotage. Espionage and confidentiality breaches involve the theft of sensitive information, which is not alleged to have occurred in this case. Integrity breaches involve the unauthorized modification of information, which is not described in this scenario.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      611,
      608,
      605,
      599,
      602
    ],
    "source": ""
  },
  {
    "id": 2639,
    "question": "Evan detects an attack against a server in his organization and examines the TCP flags on a series of packets, shown in the following diagram. <br><img src=\"/question_assets/CISSP/7_image4.png\"/><br>What type of attack most likely took place?",
    "choice_a": "SYN flood",
    "choice_b": "Ping flood",
    "choice_c": "Smurf",
    "choice_d": "Fraggle",
    "correct_answer": "A",
    "explanation": "In a SYN flood attack, the attacker sends a large number of SYN packets to a system but does not respond to the SYN/ACK packets, attempting to overwhelm the attacked system's connection state table with half-open connections.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      546,
      567,
      553,
      563,
      561
    ],
    "source": ""
  },
  {
    "id": 2640,
    "question": "Florian is building a disaster recovery plan for his organization and would like to determine the amount of time that a particular IT service may be down without causing serious damage to business operations. <br>What variable is Florian calculating?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "SLA",
    "correct_answer": "B",
    "explanation": "The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. Service-level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      580,
      569,
      588,
      584,
      598
    ],
    "source": ""
  },
  {
    "id": 2641,
    "question": "Which of the following would normally be classified as zero-day attacks?",
    "choice_a": "An attacker who is new to the world of hacking",
    "choice_b": "A database attack that places the date 00/00/0000 in data tables in an attempt to exploit flaws in business logic",
    "choice_c": "An attack previously unknown to the security community",
    "choice_d": "An attack that sets the operating system date and time to 00/00/0000 and 00:00:00",
    "correct_answer": "C",
    "explanation": "Zero-day attacks are those that are previously unknown to the security community and, therefore, have no available patch. These are especially dangerous attacks because they may be highly effective until a solution becomes available. The other attacks described here are all known attacks and would not be classified as zero-day events.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      873,
      529,
      544,
      566,
      609
    ],
    "source": ""
  },
  {
    "id": 2643,
    "question": "During an incident investigation, investigators meet with a system administrator who may have information about the incident but is not a suspect. <br>What type of conversation is taking place during this meeting?",
    "choice_a": "Interview",
    "choice_b": "Interrogation",
    "choice_c": "Both an interview and an interrogation",
    "choice_d": "Neither an interview nor an interrogation",
    "correct_answer": "A",
    "explanation": "Interviews occur when investigators meet with an individual who may have information relevant to their investigation but is not a suspect. If the individual is a suspect, then the meeting is an interrogation.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      799,
      605,
      599,
      541,
      959
    ],
    "source": ""
  },
  {
    "id": 2644,
    "question": "What technique has been used to protect the intellectual property in the following image? <br><img src=\"/question_assets/CISSP/7_image5.png\"/>",
    "choice_a": "Steganography",
    "choice_b": "Clipping",
    "choice_c": "Sampling",
    "choice_d": "Watermarking",
    "correct_answer": "D",
    "explanation": "The image clearly contains the watermark of the U.S. Geological Survey (USGS), which ensures that anyone seeing the image knows its origin. It is not possible to tell from looking at the image whether steganography was used. Sampling and clipping are data analysis techniques and are not used to protect images.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      559,
      558,
      891,
      889,
      890
    ],
    "source": ""
  },
  {
    "id": 2645,
    "question": "You are working to evaluate the risk of flood to an area as part of a business continuity planning (BCP) effort. You consult the flood maps from the Federal Emergency Management Agency (FEMA). According to those maps, the area lies within a 200-year flood plain. <br>What is the annualized rate of occurrence (ARO) of a flood in that region?",
    "choice_a": "200",
    "choice_b": "0.01",
    "choice_c": "0.02",
    "choice_d": "0.005",
    "correct_answer": "D",
    "explanation": "The annualized rate of occurrence (ARO) is the expected number of times an incident will occur each year. In the case of a 200-year flood plain, planners should expect a flood once every 200 years. This is equivalent to a 1/200 chance of a flood in any given year, or 0.005 floods per year.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      953,
      952,
      954,
      928,
      586
    ],
    "source": ""
  },
  {
    "id": 2646,
    "question": "Which one of the following individuals poses the greatest risk to security in most well-defended organizations?",
    "choice_a": "Political activist",
    "choice_b": "Malicious insider",
    "choice_c": "Script kiddie",
    "choice_d": "Thrill attacker",
    "correct_answer": "B",
    "explanation": "While all hackers with malicious intent pose a risk to the organization, the malicious insider poses the greatest risk to security because they likely have legitimate access to sensitive systems that may be used as a launching point for an attack. Other attackers do not begin with this advantage.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      611,
      511,
      503,
      533,
      1043
    ],
    "source": ""
  },
  {
    "id": 2647,
    "question": "Veronica is considering the implementation of a database recovery mechanism recommended by a consultant. In the recommended approach, an automated process will move database backups from the primary facility to an off-site location each night. <br>What type of database recovery technique is the consultant describing?",
    "choice_a": "Remote journaling",
    "choice_b": "Remote mirroring",
    "choice_c": "Electronic vaulting",
    "choice_d": "Transaction logging",
    "correct_answer": "C",
    "explanation": "In an electronic vaulting approach, automated technology moves database backups from the primary database server to a remote site on a scheduled basis, typically daily. Transaction logging is not a recovery technique alone; it is a process for generating the logs used in remote journaling. Remote journaling transfers transaction logs to a remote site on a more frequent basis than electronic vaulting, typically hourly. Remote mirroring maintains a live database server at the backup site and mirrors all transactions at the primary site on the server at the backup site.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      584,
      598,
      582,
      517,
      594
    ],
    "source": ""
  },
  {
    "id": 2648,
    "question": "When designing an access control scheme, Hilda set up roles so that the same person does not have the ability to provision a new user account and assign superuser privileges to an account. <br>What information security principle is Hilda following?",
    "choice_a": "Least privilege",
    "choice_b": "Separation of duties",
    "choice_c": "Job rotation",
    "choice_d": "Security through obscurity",
    "correct_answer": "B",
    "explanation": "Hilda's design follows the principle of separation of duties. Giving one user the ability to both create new accounts and grant administrative privileges combines two actions that would result in a significant security change that should be divided among two users.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      504,
      533,
      535,
      503,
      556
    ],
    "source": ""
  },
  {
    "id": 2649,
    "question": "Patrick was charged with implementing a threat hunting program for his organization. <br>Which one of the following is the basic assumption of a threat hunting program that he should use as he plans his work?",
    "choice_a": "Security controls were designed using a defense-in-depth strategy.",
    "choice_b": "Audits may uncover control deficiencies.",
    "choice_c": "Attackers may already be present on the network.",
    "choice_d": "Defense mechanisms may contain unpatched vulnerabilities.",
    "correct_answer": "C",
    "explanation": "While all of these assumptions are valid premises that Patrick might have going into the exercise, the basic assumption of a threat hunting exercise is the so-called presumption of compromise. This means that Patrick should assume that attackers have already gained access to his system and then hunt for indicators of their presence.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      564,
      1043,
      921,
      561,
      544
    ],
    "source": ""
  },
  {
    "id": 2650,
    "question": "Brian is developing the training program for his organization's disaster recovery program and would like to make sure that participants understand when disaster activity concludes. <br>Which one of the following events marks the completion of a disaster recovery process?",
    "choice_a": "Securing property and life safety",
    "choice_b": "Restoring operations in an alternate facility",
    "choice_c": "Restoring operations in the primary facility",
    "choice_d": "Standing down first responders",
    "correct_answer": "C",
    "explanation": "The end goal of the disaster recovery process is restoring normal business operations in the primary facility. All of the other actions listed may take place during the disaster recovery process, but the process is not complete until the organization is once again functioning normally in its primary facilities.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      591,
      592,
      587,
      586,
      595
    ],
    "source": ""
  },
  {
    "id": 2651,
    "question": "Melanie suspects that someone is using malicious software to steal computing cycles from her company. <br>Which one of the following security tools would be in the best position to detect this type of incident?",
    "choice_a": "NIDS",
    "choice_b": "Firewall",
    "choice_c": "HIDS",
    "choice_d": "DLP",
    "correct_answer": "C",
    "explanation": "A host-based intrusion detection system (HIDS) may be able to detect unauthorized processes running on a system. The other controls mentioned, network intrusion detection systems (NIDSs), firewalls, and DLP systems, are network-based and may not notice rogue processes.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      547,
      566,
      548,
      568,
      1043
    ],
    "source": ""
  },
  {
    "id": 2652,
    "question": "Brandon observes that an authorized user of a system on his network recently misused his account to exploit a system vulnerability against a shared server that allowed him to gain root access to that server. <br>What type of attack took place?",
    "choice_a": "Denial-of-service",
    "choice_b": "Privilege escalation",
    "choice_c": "Reconnaissance",
    "choice_d": "Brute force",
    "correct_answer": "B",
    "explanation": "The scenario describes a privilege escalation attack where a malicious insider with authorized access to a system misused that access to gain privileged credentials.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      506,
      533,
      503,
      611,
      556
    ],
    "source": ""
  },
  {
    "id": 2653,
    "question": "Carla has worked for her company for 15 years and has held a variety of different positions. Each time she changed positions, she gained new privileges associated with that position, but no privileges were ever taken away. <br>What concept describes the sets of privileges she has accumulated?",
    "choice_a": "Entitlement",
    "choice_b": "Aggregation",
    "choice_c": "Transitivity",
    "choice_d": "Isolation",
    "correct_answer": "B",
    "explanation": "Carla's account has experienced aggregation, where privileges accumulated over time. This condition is also known as privilege creep and likely constitutes a violation of the least privilege principle.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      503,
      533,
      506,
      543
    ],
    "source": ""
  },
  {
    "id": 2654,
    "question": "During what phase of the incident response process do administrators take action to limit the effect or scope of an incident?",
    "choice_a": "Detection",
    "choice_b": "Response",
    "choice_c": "Mitigation",
    "choice_d": "Recovery",
    "correct_answer": "C",
    "explanation": "The mitigation phase of incident response focuses on actions that can contain the damage incurred during an incident. This includes limiting the scope and or effectiveness of the incident. The detection phase identifies that an incident is taking place. The response phase includes steps taken to assemble a team and triage the incident. The recovery phase resumes normal operations.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      539,
      537,
      919,
      540,
      538
    ],
    "source": ""
  },
  {
    "id": 2655,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>At this point in the incident response process, what term best describes what has occurred in Ann's organization?",
    "choice_a": "Security occurrence",
    "choice_b": "Security incident",
    "choice_c": "Security event",
    "choice_d": "Security intrusion",
    "correct_answer": "C",
    "explanation": "At this point in the process, Ann has no reason to believe that any actual security compromise or policy violation took place, so this situation does not meet the criteria for a security incident or intrusion. Rather, the alert generated by the intrusion detection system is simply a security event requiring further investigation. Security occurrence is not a term commonly used in incident handling.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      538,
      537,
      565,
      566,
      547
    ],
    "source": ""
  },
  {
    "id": 2656,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>Ann continues her investigation and realizes that the traffic generating the alert is abnormally high volumes of inbound UDP traffic on port 53. <br>What service typically uses this port?",
    "choice_a": "DNS",
    "choice_b": "SSH/SCP",
    "choice_c": "SSL/TLS",
    "choice_d": "HTTP",
    "correct_answer": "A",
    "explanation": "DNS traffic commonly uses port 53 for both TCP and UDP communications. SSH and SCP use TCP port 22. SSL and TLS do not have ports assigned to them but are commonly used for HTTPS traffic on port 443. Unencrypted web traffic over HTTP often uses port 80.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      566,
      547,
      560,
      538,
      553
    ],
    "source": ""
  },
  {
    "id": 2657,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>As Ann analyzes the traffic further, she realizes that the traffic is coming from many different sources and has overwhelmed the network, preventing legitimate uses. The inbound packets are responses to queries that she does not see in outbound traffic. The responses are abnormally large for their type. <br>What type of attack should Ann suspect?",
    "choice_a": "Reconnaissance",
    "choice_b": "Malicious code",
    "choice_c": "System penetration",
    "choice_d": "Denial-of-service",
    "correct_answer": "D",
    "explanation": "The attack described in this scenario has all the hallmarks of a denial-of-service attack. More specifically, Ann's organization is likely experiencing a DNS amplification attack where an attacker sends false requests to third-party DNS servers with a forged source IP address belonging to the targeted system. Because the attack uses UDP requests, there is no three-way handshake. The attack packets are carefully crafted to elicit a lengthy response from a short query. The purpose of these queries is to generate responses headed to the target system that are sufficiently large and numerous enough to overwhelm the targeted network or system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      546,
      567,
      566,
      538,
      560
    ],
    "source": ""
  },
  {
    "id": 2658,
    "question": "Ann is a security professional for a midsize business and typically handles log analysis and security monitoring tasks for her organization. One of her roles is to monitor alerts originating from the organization's intrusion detection system. The system typically generates several dozen alerts each day, and many of those alerts turn out to be false alarms after her investigation. <br>This morning, the intrusion detection system alerted because the network began to receive an unusually high volume of inbound traffic. Ann received this alert and began looking into the origin of the traffic. <br>Now that Ann understands that an attack has taken place that violates her organization's security policy, what term best describes what has occurred in Ann's organization?",
    "choice_a": "Security occurrence",
    "choice_b": "Security incident",
    "choice_c": "Security event",
    "choice_d": "Security intrusion",
    "correct_answer": "B",
    "explanation": "Now that Ann suspects an attack against her organization, she has sufficient evidence to declare a security incident. The attack underway seems to have undermined the availability of her network, meeting one of the criteria for a security incident. This is an escalation beyond a security event but does not reach the level of an intrusion because there is no evidence that the attacker has even attempted to gain access to systems on Ann's network. Security occurrence is not a term commonly used in incident handling.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      538,
      543,
      547,
      566,
      541
    ],
    "source": ""
  },
  {
    "id": 2659,
    "question": "Frank is seeking to introduce a hacker's laptop in court as evidence against the hacker. The laptop does contain logs that indicate the hacker committed the crime, but the court ruled that the search of the apartment that resulted in police finding the laptop was unconstitutional. <br>What admissibility criteria prevents Frank from introducing the laptop as evidence?",
    "choice_a": "Materiality",
    "choice_b": "Relevance",
    "choice_c": "Hearsay",
    "choice_d": "Competence",
    "correct_answer": "D",
    "explanation": "To be admissible, evidence must be relevant, material, and competent. The laptop in this case is clearly material because it contains logs related to the crime in question. It is also relevant because it provides evidence that ties the hacker to the crime. It is not competent because the evidence was not legally obtained.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      601,
      605,
      602,
      615,
      599
    ],
    "source": ""
  },
  {
    "id": 2660,
    "question": "Gordon suspects that a hacker has penetrated a system belonging to his company. The system does not contain any regulated information, and Gordon wants to conduct an investigation on behalf of his company. He has permission from his supervisor to conduct the investigation. <br>Which of the following statements is true?",
    "choice_a": "Gordon is legally required to contact law enforcement before beginning the investigation.",
    "choice_b": "Gordon may not conduct his own investigation.",
    "choice_c": "Gordon's investigation may include examining the contents of hard disks, network traffic, and any other systems or information belonging to the company.",
    "choice_d": "Gordon may ethically perform \"hack back\" activities after identifying the perpetrator.",
    "correct_answer": "C",
    "explanation": "Gordon may conduct his investigation as he wishes and use any information that is legally available to him, including information and systems belonging to his employer. There is no obligation to contact law enforcement. However, Gordon may not perform \"hack back\" activities because those may constitute violations of the law and/or ISC2 Code of Ethics.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      613,
      616,
      607,
      605,
      614
    ],
    "source": ""
  },
  {
    "id": 2661,
    "question": "Which one of the following tools provides an organization with the greatest level of protection against a software vendor going out of business?",
    "choice_a": "Service-level agreement",
    "choice_b": "Escrow agreement",
    "choice_c": "Mutual assistance agreement",
    "choice_d": "PCI DSS compliance agreement",
    "correct_answer": "B",
    "explanation": "Software escrow agreements place a copy of the source code for a software package in the hands of an independent third party who will turn the code over to the customer if the vendor ceases business operations. Service-level agreements, mutual assistance agreements, and compliance agreements all lose some or all of their effectiveness if the vendor goes out of business.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      590,
      598,
      597,
      583,
      928
    ],
    "source": ""
  },
  {
    "id": 2662,
    "question": "Fran is considering new human resources policies for her bank that will deter fraud. She plans to implement a mandatory vacation policy. <br>What is typically considered the shortest effective length of a mandatory vacation?",
    "choice_a": "Two days",
    "choice_b": "Four days",
    "choice_c": "One week",
    "choice_d": "One month",
    "correct_answer": "C",
    "explanation": "Most security professionals recommend at least one, and preferably two, weeks of vacation to deter fraud. The idea is that fraudulent schemes will be uncovered during the time that the employee is away and does not have the access required to perpetuate a cover-up.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      505,
      533,
      506,
      511,
      599
    ],
    "source": ""
  },
  {
    "id": 2663,
    "question": "Which of the following events would constitute a security incident?  (Select all that apply.)",
    "choice_a": "An attempted network intrusion",
    "choice_b": "A successful database intrusion",
    "choice_c": "A malware infection",
    "choice_d": "A successful attempt to access a file",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E",
      "F"
    ],
    "explanation": "Any attempt to undermine the security of an organization or violation of a security policy is a security incident. All of the events described meet this definition and should be treated as an incident, with one exception. A successful attempt to access a file is certainly a security event, but it is not a security incident unless it is established that the individual accessing the file was not authorized to do so.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      536,
      543,
      556,
      541,
      604
    ],
    "source": "",
    "choice_e": "A violation of a confidentiality policy",
    "choice_f": "An unsuccessful attempt to remove information from a secured area"
  },
  {
    "id": 2664,
    "question": "Amanda is configuring her organization's firewall to implement egress filtering. <br>Which one of the following traffic types should be blocked by her organization's egress filtering policy?  (Select all that apply.)",
    "choice_a": "Traffic rapidly scanning many IP addresses on port 22",
    "choice_b": "Traffic with a broadcast destination",
    "choice_c": "Traffic with a source address from an external network",
    "choice_d": "Traffic with a destination address on an external network",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Egress filtering scans outbound traffic for potential security policy violations. This includes traffic that is likely malicious, such as an outbound SSH scan on port 22. It also includes traffic that appears to be part of an attack or misconfiguration, such as sending traffic to a broadcast destination address. Finally, it includes spoofed traffic generated by internal systems, which may bear a source address from an external network. The normal traffic that the firewall should expect to see is that bearing a destination address on an external network.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      551,
      559,
      554,
      566,
      548
    ],
    "source": ""
  },
  {
    "id": 2665,
    "question": "Allie is responsible for reviewing authentication logs on her organization's network. She does not have the time to review all logs, so she decides to choose only records where there have been four or more invalid authentication attempts. <br>What technique is Allie using to reduce the size of the pool?",
    "choice_a": "Sampling",
    "choice_b": "Random selection",
    "choice_c": "Clipping",
    "choice_d": "Statistical analysis",
    "correct_answer": "C",
    "explanation": "The two main methods of choosing records from a large pool for further analysis are sampling and clipping. Sampling uses statistical techniques to choose a sample that is representative of the entire pool, while clipping uses threshold values to select those records that exceed a predefined threshold because they may be of most interest to analysts.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      889,
      558,
      891,
      554,
      538
    ],
    "source": ""
  },
  {
    "id": 2666,
    "question": "You are performing an investigation into a potential bot infection on your network and want to perform a forensic analysis of the information that passed between different systems on your network and those on the internet. You believe that the information was likely encrypted. You are beginning your investigation after the activity concluded. <br>What would be the best and easiest way to obtain the source of this information?",
    "choice_a": "Packet captures",
    "choice_b": "NetFlow data",
    "choice_c": "Intrusion detection system logs",
    "choice_d": "Centralized authentication records",
    "correct_answer": "B",
    "explanation": "NetFlow data contains information on the source, destination, and size of all network communications and is routinely saved as a matter of normal activity. Packet capture data would provide relevant information, but it must be captured during the suspicious activity and cannot be re-created after the fact unless the organization is already conducting 100 percent packet capture, which is rare. Additionally, the use of encryption limits the effectiveness of packet capture. Intrusion detection system logs would not likely contain relevant information because the encrypted traffic would probably not match intrusion signatures. Centralized authentication records would not contain information about network traffic.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      603,
      558,
      547,
      607,
      541
    ],
    "source": ""
  },
  {
    "id": 2667,
    "question": "Which one of the following tools helps system administrators by providing a standard, secure template of configuration settings for operating systems and applications?",
    "choice_a": "Security guidelines",
    "choice_b": "Security policy",
    "choice_c": "Baseline configuration",
    "choice_d": "Running configuration",
    "correct_answer": "C",
    "explanation": "Baseline configurations serve as the starting point for configuring secure systems and applications. They contain the security settings necessary to comply with an organization's security policy and may then be customized to meet the specific needs of an implementation. While security policies and guidelines may contain information needed to secure a system, they do not contain a set of configuration settings that may be applied to a system. The running configuration of a system is the set of currently applied settings, which may or may not be secure. In this case, Allie is only selecting records that exceed an invalid login threshold, making this an example of clipping.  She is not using statistical techniques to select a subset of records, so this is not an example of sampling.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      524,
      798,
      525,
      523,
      526
    ],
    "source": ""
  },
  {
    "id": 2668,
    "question": "What type of disaster recovery test activates the alternate processing facility and uses it to conduct transactions but leaves the primary site up and running?",
    "choice_a": "Full interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Checklist review",
    "choice_d": "Tabletop exercise",
    "correct_answer": "B",
    "explanation": "During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      594,
      597,
      585,
      582,
      593
    ],
    "source": ""
  },
  {
    "id": 2669,
    "question": "During which phase of the incident response process would an analyst receive an intrusion detection system alert and verify its accuracy?",
    "choice_a": "Response",
    "choice_b": "Mitigation",
    "choice_c": "Detection",
    "choice_d": "Reporting",
    "correct_answer": "C",
    "explanation": "Both the receipt of alerts and the verification of their accuracy occur during the Detection phase of the incident response process.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      538,
      537,
      547,
      919,
      566
    ],
    "source": ""
  },
  {
    "id": 2670,
    "question": "Kevin is developing a continuous security monitoring strategy for his organization. <br>Which one of the following is not normally used when determining assessment and monitoring frequency?",
    "choice_a": "Threat intelligence",
    "choice_b": "System categorization/impact level",
    "choice_c": "Security control operational burden",
    "choice_d": "Organizational risk tolerance",
    "correct_answer": "C",
    "explanation": "According to NIST SP 800-137, organizations should use the following factors to determine assessment and monitoring frequency: security control volatility, system categorizations/impact levels, security controls or specific assessment objects providing critical functions, security controls with identified weaknesses, organizational risk tolerance, threat information, vulnerability information, risk assessment results, the output of monitoring strategy reviews, and reporting requirements.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      557,
      566,
      560,
      1042,
      543
    ],
    "source": ""
  },
  {
    "id": 2671,
    "question": "Hunter is reviewing his organization's monitoring strategy and identifying new technologies that they might deploy. His assessment reveals that the firm is not doing enough to monitor employee activity on endpoint devices. <br>Which one of the following technologies would best meet his needs?",
    "choice_a": "EDR",
    "choice_b": "IPS",
    "choice_c": "IDS",
    "choice_d": "UEBA",
    "correct_answer": "D",
    "explanation": "All of these technologies have the potential to monitor user behavior on endpoint devices. The key to answering this question correctly is realizing the emphasis on the user. Intrusion detection and prevention systems (IDSs/IPSs) focus on network and host behavior. Endpoint detection and response (EDR) systems focus on endpoint devices. User and entity behavior analytics (UEBA) solutions focus on the user and, therefore, would be the best way to meet Hunter's requirement.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      1042,
      1043,
      566,
      548,
      547
    ],
    "source": ""
  },
  {
    "id": 2672,
    "question": "Bruce is seeing quite a bit of suspicious activity on his network. After consulting records in his SIEM, it appears that an outside entity is attempting to connect to all of his systems using a TCP connection on port 22. <br>What type of scanning is the outsider likely engaging in?",
    "choice_a": "FTP scanning",
    "choice_b": "Telnet scanning",
    "choice_c": "SSH scanning",
    "choice_d": "HTTP scanning",
    "correct_answer": "C",
    "explanation": "SSH uses TCP port 22, so this attack is likely an attempt to scan for open or weakly secured SSH servers. FTP uses ports 20 and 21. Telnet uses port 23, and HTTP uses port 80.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      567,
      547,
      564,
      542,
      608
    ],
    "source": ""
  },
  {
    "id": 2673,
    "question": "Dylan believes that a database server in his environment was compromised using a SQL injection attack. <br>Which one of the following actions would Dylan most likely take during the remediation phase of the attack?",
    "choice_a": "Rebuilding the database from backups",
    "choice_b": "Adding input validation to a web application",
    "choice_c": "Reviewing firewall logs",
    "choice_d": "Reviewing database logs",
    "correct_answer": "B",
    "explanation": "Remediation activities seek to address the issue that caused the incident. In this case, that was a web application that was open to SQL injection attack. Adding input validation seeks to remediate this vulnerability. Rebuilding the database is a recovery action, while reviewing logs is done as part of the detection and response effort.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      920,
      540,
      537,
      539,
      538
    ],
    "source": ""
  },
  {
    "id": 2674,
    "question": "Roger recently accepted a new position as a security professional at a company that runs its entire IT infrastructure within an IaaS environment. <br>Which one of the following would most likely be the responsibility of Roger's firm?",
    "choice_a": "Configuring the network firewall",
    "choice_b": "Applying hypervisor updates",
    "choice_c": "Patching operating systems",
    "choice_d": "Wiping drives prior to disposal",
    "correct_answer": "C",
    "explanation": "In an infrastructure as a service environment, the vendor is responsible for hardware- and network-related responsibilities. These include configuring network firewalls, maintaining the hypervisor, and managing physical equipment. The customer retains responsibility for patching operating systems on its virtual machine instances.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      913,
      519,
      915,
      529,
      535
    ],
    "source": ""
  },
  {
    "id": 2675,
    "question": "What technique can application developers use to test applications in an isolated virtualized environment before allowing them on a production network?",
    "choice_a": "Penetration testing",
    "choice_b": "Sandboxing",
    "choice_c": "White-box testing",
    "choice_d": "Black-box testing",
    "correct_answer": "B",
    "explanation": "Sandboxing is a technique where application developers (or the recipients of an untrusted application) may test the code in a virtualized environment that is isolated from production systems. White-box testing, black-box testing, and penetration testing are all common software testing techniques but do not require the use of an isolated system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      568,
      531,
      527,
      529,
      873
    ],
    "source": ""
  },
  {
    "id": 2676,
    "question": "Gina is the firewall administrator for a small business and recently installed a new firewall. After seeing signs of unusually heavy network traffic, she checked the intrusion detection system, which reported that a SYN flood attack was underway. <br>What firewall configuration change can Gina make to most effectively prevent this attack?",
    "choice_a": "Block SYN from known IPs.",
    "choice_b": "Block SYN from unknown IPs.",
    "choice_c": "Enable SYN-ACK spoofing at the firewall.",
    "choice_d": "Disable TCP.",
    "correct_answer": "C",
    "explanation": "While it may not immediately seem like the obvious answer, many firewalls have a built-in anti\u2013SYN flood defense that responds to SYNs on behalf of protected systems. Once the remote system proves to be a legitimate connection by continuing the three-way handshake, the rest of the TCP session is passed through. If the connection proves to be an attack, the firewall handles the additional load using appropriate mitigation techniques. Blocking SYNs from known or unknown IP addresses is likely to cause issues with systems that should be able to connect, and turning off TCP will break most modern network services!",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      546,
      567,
      551,
      548,
      544
    ],
    "source": ""
  },
  {
    "id": 2677,
    "question": "Nancy is leading an effort to modernize her organization's anti-malware protection and would like to add endpoint detection and response (EDR) capabilities. <br>Which of the following actions are normally supported by EDR systems?  (Select all that apply.)",
    "choice_a": "Analyzing endpoint memory, filesystem, and network activity for signs of malicious activity",
    "choice_b": "Automatically isolating possible malicious activity to contain the potential damage",
    "choice_c": "Conducting simulated phishing campaigns",
    "choice_d": "Integration with threat intelligence sources",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "EDR platforms do not conduct simulated phishing campaigns. The most common features of EDR systems are analyzing endpoint memory, filesystem, and network activity for signs of malicious activity; isolating possible malicious activity to contain the potential damage; integrating with threat intelligence sources; and integrating with other incident response mechanisms.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      538,
      564,
      561,
      548,
      541
    ],
    "source": ""
  },
  {
    "id": 2678,
    "question": "Alan is assessing the potential for using machine learning and artificial intelligence in his cybersecurity program. <br>Which of the following activities is most likely to benefit from this technology?",
    "choice_a": "Intrusion detection",
    "choice_b": "Account provisioning",
    "choice_c": "Firewall rule modification",
    "choice_d": "Media sanitization",
    "correct_answer": "A",
    "explanation": "While any cybersecurity activity has the potential to benefit from machine learning and artificial intelligence capabilities, this technology really shines when used for pattern detection and anomaly detection problems. This is the type of activity performed by an intrusion detection system, and, therefore, this system would benefit the most from the use of ML/AI technology.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      566,
      562,
      1043,
      1042,
      538
    ],
    "source": ""
  },
  {
    "id": 2679,
    "question": "Timber Industries recently got into a dispute with a customer. During a meeting with his account representative, the customer stood up and declared, \"There is no other solution. We will have to take this matter to court.\" He then left the room. When does Timber Industries have an obligation to begin preserving evidence?",
    "choice_a": "Immediately",
    "choice_b": "Upon receipt of a notice of litigation from opposing attorneys",
    "choice_c": "Upon receipt of a subpoena",
    "choice_d": "Upon receipt of a court order",
    "correct_answer": "A",
    "explanation": "Companies have an obligation to preserve evidence whenever they believe that the threat of litigation is imminent. The statement made by this customer that \"we will have to take this matter to court\" is a clear threat of litigation and should trigger the preservation of any related documents and records.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      541,
      605,
      607,
      599,
      604
    ],
    "source": ""
  },
  {
    "id": 2680,
    "question": "Candace is designing a backup strategy for her organization's file server. She would like to perform a backup every weekday that has the smallest possible storage footprint. <br>What type of backup should she perform?",
    "choice_a": "Incremental backup",
    "choice_b": "Full backup",
    "choice_c": "Differential backup",
    "choice_d": "Transaction log backup",
    "correct_answer": "A",
    "explanation": "Incremental backups provide the option that includes the smallest amount of data. In this case, that would be only the data modified since the most recent incremental backup. A differential backup would back up all data modified since the last full backup, which would be a substantial amount. The full backup would include all information on the server. Transaction log backups are specifically designed to support database servers and would not be effective on a file server.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      588,
      589,
      596,
      592,
      586
    ],
    "source": ""
  },
  {
    "id": 2681,
    "question": "Darcy is a computer security specialist who is assisting with the prosecution of a hacker. The prosecutor requests that Darcy give testimony in court about whether, in her opinion, the logs and other records in a case are indicative of a hacking attempt. <br>What type of evidence is Darcy being asked to provide?",
    "choice_a": "Expert opinion",
    "choice_b": "Direct evidence",
    "choice_c": "Real evidence",
    "choice_d": "Documentary evidence",
    "correct_answer": "A",
    "explanation": "Expert opinion evidence allows individuals to offer their opinion based upon the facts in evidence and their personal knowledge. Expert opinion evidence may be offered only if the court accepts the witness as an expert in a particular field. Direct evidence is when witnesses testify about their direct observations. Real evidence consists of tangible items brought into court as evidence. Documentary evidence consists of written records used as evidence in court.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      601,
      615,
      603,
      605,
      599
    ],
    "source": ""
  },
  {
    "id": 2682,
    "question": "Which one of the following techniques is not commonly used to remove unwanted remnant data from magnetic tapes?",
    "choice_a": "Physical destruction",
    "choice_b": "Degaussing",
    "choice_c": "Overwriting",
    "choice_d": "Reformatting",
    "correct_answer": "D",
    "explanation": "The standard methods for clearing magnetic tapes, according to the NIST Guidelines for Media Sanitization, are overwriting the tape with nonsensitive data, degaussing, and physical destruction via shredding or incineration. Reformatting a tape does not remove remnant data.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      518,
      517,
      603,
      541,
      516
    ],
    "source": ""
  },
  {
    "id": 2683,
    "question": "Sally is building a new server for use in her environment and plans to implement RAID level 1 as a storage availability control. <br>What is the minimum number of physical hard disks that she needs to implement this approach?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Five",
    "correct_answer": "B",
    "explanation": "RAID level 1, also known as disk mirroring, uses two disks that contain identical information. If one disk fails, the other contains the data needed for the system to continue operation.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      576,
      836,
      835,
      575,
      837
    ],
    "source": ""
  },
  {
    "id": 2684,
    "question": "Jerome is conducting a forensic investigation and is reviewing database server logs to investigate query contents for evidence of SQL injection attacks. <br>What type of analysis is he performing?",
    "choice_a": "Hardware analysis",
    "choice_b": "Software analysis",
    "choice_c": "Network analysis",
    "choice_d": "Media analysis",
    "correct_answer": "B",
    "explanation": "The analysis of application logs is one of the core tasks of software analysis. This is the correct answer because SQL injection attacks are application attacks.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      606,
      842,
      841,
      602,
      603
    ],
    "source": ""
  },
  {
    "id": 2685,
    "question": "Quigley Computing regularly ships tapes of backup data across the country to a secondary facility. These tapes contain confidential information. <br>What is the most important security control that Quigley can use to protect these tapes?",
    "choice_a": "Locked shipping containers",
    "choice_b": "Private couriers",
    "choice_c": "Data encryption",
    "choice_d": "Media rotation",
    "correct_answer": "C",
    "explanation": "Quigley may choose to use any or all of these security controls, but data encryption is, by far, the most important control. It protects the confidentiality of data stored on the tapes, which are most vulnerable to theft while in transit between two secure locations.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      517,
      515,
      520,
      574,
      512
    ],
    "source": ""
  },
  {
    "id": 2686,
    "question": "Carolyn is concerned that users on her network may be storing sensitive information, such as Social Security numbers, on their hard drives without proper authorization or security controls. <br>What third-party security service can she implement to best detect this activity?",
    "choice_a": "IDS",
    "choice_b": "IPS",
    "choice_c": "DLP",
    "choice_d": "TLS",
    "correct_answer": "C",
    "explanation": "Data loss prevention (DLP) systems may identify sensitive information stored on endpoint systems or in transit over a network. This is their primary purpose. DLP systems are commonly available as a third party managed service offering. Intrusion detection and prevention systems (IDSs/IPSs) may be used to identify some sensitive information using signatures built for that purpose, but this is not the primary role of those tools and they would not be as effective as DLP systems at this task. TLS is a network encryption protocol that may be used to protect sensitive information, but it does not have any ability to identify sensitive information.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      522,
      566,
      548,
      556,
      511
    ],
    "source": ""
  },
  {
    "id": 2687,
    "question": "Gavin is the disaster recovery team leader for his organization, which is currently in the response phase of an incident that has severe customer impact. Gavin just received a phone call from a reporter asking for details on the root cause and an estimated recovery time. Gavin has this information at his fingertips. <br>What should he do?",
    "choice_a": "Provide the information to the reporter.",
    "choice_b": "Request a few minutes to gather the information and return the call.",
    "choice_c": "Refer the matter to the public relations department.",
    "choice_d": "Refuse to provide any information.",
    "correct_answer": "C",
    "explanation": "Disaster recovery teams should always refer media inquiries to the public relations team to ensure a coordinated, consistent response. They should not attempt to answer questions themselves.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      581,
      586,
      593,
      587,
      613
    ],
    "source": ""
  },
  {
    "id": 2688,
    "question": "Pauline is reviewing her organization's emergency management plans. <br>What should be the highest priority when creating these plans?",
    "choice_a": "Protection of mission-critical data",
    "choice_b": "Preservation of operational systems",
    "choice_c": "Collection of evidence",
    "choice_d": "Preservation of safety",
    "correct_answer": "D",
    "explanation": "All of these considerations are important when developing an emergency management plan. However, the safety of human life should always be the overwhelming priority, above all other considerations.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      508,
      581,
      587,
      928,
      507
    ],
    "source": ""
  },
  {
    "id": 2689,
    "question": "Barry is the CIO of an organization that recently suffered a serious operational issue that required activation of the disaster recovery plan. He would like to conduct a lessons learned session to review the incident. <br>Who would be the best facilitator for this session?",
    "choice_a": "Barry, as chief information officer",
    "choice_b": "Chief information security officer",
    "choice_c": "Disaster recovery team leader",
    "choice_d": "External consultant",
    "correct_answer": "D",
    "explanation": "Barry should recruit an independent moderator to facilitate the session. Having a moderator who was not directly involved in the effort encourages honest and open feedback. While it is not necessary to use an external consultant, they may easily fill this role. While it is also possible to find a qualified internal employee to fill this position, it should not be someone who was involved in the incident response effort or has a major stake in the plan, such as Barry, the CISO, or the DR team leader.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      595,
      537,
      607,
      592,
      586
    ],
    "source": ""
  },
  {
    "id": 2690,
    "question": "Brent is reviewing the controls that will protect his organization in the event of a sustained period of power loss. <br>Which one of the following solutions would best meet his needs?",
    "choice_a": "Redundant servers",
    "choice_b": "Uninterruptible power supply (UPS)",
    "choice_c": "Generator",
    "choice_d": "RAID",
    "correct_answer": "C",
    "explanation": "Generators are capable of providing backup power for a sustained period of time in the event of a power loss, but they take time to activate. Uninterruptible power supplies (UPS) provide immediate, battery-driven power for a short period of time to cover momentary losses of power, which would not cover a sustained period of power loss. RAID and redundant servers are high-availability controls but do not cover power loss scenarios.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      577,
      575,
      598,
      573,
      592
    ],
    "source": ""
  },
  {
    "id": 2691,
    "question": "Susan provides a public RESTful API for her organization's data but wants to limit its use to trusted partners. She intends to use API keys. <br>What other recommendation would you give Susan to limit the potential abuse of the service?",
    "choice_a": "Limit request rates",
    "choice_b": "Force HTTP-only requests",
    "choice_c": "Avoid tokens due to bandwidth constraints",
    "choice_d": "Blacklist HTTP methods such as GET, POST, and PUT",
    "correct_answer": "A",
    "explanation": "Limiting request rates can prevent abuse of APIs like this one. The other suggestions are all poor recommendations. In general, requests should require HTTPS, tokens are used for security using tools like JSON web tokens (JWT), and HTTP methods may be restricted, but GET, POST, and PUT are some of the most common methods used for API access and are far more typically whitelisted.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      803,
      802,
      804,
      828,
      627
    ],
    "source": ""
  },
  {
    "id": 2692,
    "question": "Darren is conducting a threat hunting exercise and would like to look for botnet indicators of compromise. <br>Which of the following are common ways that attackers leverage botnets?  (Select all that apply.)",
    "choice_a": "Mining cryptocurrency",
    "choice_b": "Conducting brute-force attacks",
    "choice_c": "Scanning for vulnerable systems",
    "choice_d": "Conducting man-in-the-middle attacks",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Botnets are used for a wide variety of malicious purposes, including scanning the network for vulnerable systems, conducting brute-force attacks against other systems, mining cryptocurrency, and sending out spam messages. They are not commonly used to conduct man-in-the-middle attacks, which are normally waged through DNS poisoning or similar mechanisms.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      645,
      642,
      674,
      648,
      646
    ],
    "source": ""
  },
  {
    "id": 2693,
    "question": "Which one of the following statements is not true about code review?",
    "choice_a": "Code review should be a peer-driven process that includes multiple developers.",
    "choice_b": "Code review may be automated.",
    "choice_c": "Code review occurs during the design phase.",
    "choice_d": "Code reviewers may expect to review several hundred lines of code per hour.",
    "correct_answer": "C",
    "explanation": "Code review takes place after code has been developed, which occurs after the design phase of the system's development lifecycle (SDLC). Code review may use a combination of manual and automated techniques or rely solely on one or the other. It should be a peer-driven process that includes developers who did not write the code. Developers should expect to complete the review of around 300 lines per hour, on average.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      963,
      806,
      833,
      621,
      818
    ],
    "source": ""
  },
  {
    "id": 2694,
    "question": "Kathleen is reviewing the Ruby code shown here. <br><img src=\"/question_assets/CISSP/8_image1.png\"/><br>What security technique is this code using?",
    "choice_a": "Parameterization",
    "choice_b": "Typecasting",
    "choice_c": "Gem cutting",
    "choice_d": "Stored procedures",
    "correct_answer": "A",
    "explanation": "This code is an example of parameterization, which can help avoid SQL injection. Note that each parameter has a placeholder, which is then passed to the query.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      658,
      661,
      668,
      659,
      675
    ],
    "source": ""
  },
  {
    "id": 2695,
    "question": "Jessica is reviewing her organization's change management process and would like to verify that changes to software include acceptance testing. <br>Which process is responsible for achieving this goal?",
    "choice_a": "Request control",
    "choice_b": "Change control",
    "choice_c": "Release control",
    "choice_d": "Configuration control",
    "correct_answer": "C",
    "explanation": "One of the responsibilities of the release control process is ensuring that the process includes acceptance testing that confirms that any alterations to end-user work tasks are understood and functional prior to code release. The request control, change control, and configuration control processes do not include acceptance testing.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      624,
      625,
      640,
      1032,
      833
    ],
    "source": ""
  },
  {
    "id": 2696,
    "question": "Ashley is investigating an attack that compromised an account of one of her users. In the attack, the attacker forced the submission of an authenticated request to a third-party site by exploiting trust relationships in the user's browser. <br>What type of attack most likely took place?",
    "choice_a": "XSS",
    "choice_b": "CSRF",
    "choice_c": "SQL injection",
    "choice_d": "Session hijacking",
    "correct_answer": "B",
    "explanation": "Cross-site request forgery (XSRF or CSRF) attacks exploit the trust that sites have in a user's browser by attempting to force the submission of authenticated requests to third-party sites. Session hijacking attacks attempt to steal previously authenticated sessions but do not force the browser to submit requests. SQL injection directly attacks a database through a web application. Cross-site scripting uses reflected input to trick a user's browser into executing untrusted code from a trusted site.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      666,
      667,
      658,
      1010,
      668
    ],
    "source": ""
  },
  {
    "id": 2697,
    "question": "Arnold is creating a new software package and is making use of the OpenSSL library. <br>What term best describes the library he is using?",
    "choice_a": "Open source",
    "choice_b": "COTS",
    "choice_c": "Third-party",
    "choice_d": "Managed",
    "correct_answer": "A",
    "explanation": "The OpenSSL package is a widely used implementation of TLS encryption that is available as an open source package. It is not commercial off-the-shelf software (COTS). While it might be developed by third parties, it is more accurate to describe it as open source. The library is available as code for free use, but not as a managed service.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      961,
      618,
      670,
      621,
      628
    ],
    "source": ""
  },
  {
    "id": 2698,
    "question": "Jaime is a technical support analyst and is asked to visit a user whose computer is displaying the error message shown here. <br><img src=\"/question_assets/CISSP/8_image2.png\"/><br>What state has this computer entered?",
    "choice_a": "Fail open",
    "choice_b": "Irrecoverable error",
    "choice_c": "Memory exhaustion",
    "choice_d": "Fail secure",
    "correct_answer": "D",
    "explanation": "error message shown in the figure is the infamous \"Blue Screen of Death\" that occurs when a Windows system experiences a dangerous failure and enters a fail secure state. If the system had \"failed open,\" it would have continued operation. The error described is a memory fault that is likely recoverable by rebooting the system. There is no indication that the system has run out of usable memory.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      620,
      673,
      813,
      672,
      621
    ],
    "source": ""
  },
  {
    "id": 2699,
    "question": "Joshua is developing a software threat modeling program for his organization. <br>Which of the following are appropriate goals for the program?  (Select all that apply.)",
    "choice_a": "To reduce the number of security-related design flaws",
    "choice_b": "To reduce the number of security-related coding flaws",
    "choice_c": "To reduce the severity of non-security-related flaws",
    "choice_d": "To reduce the number of threat vectors",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Software threat modeling is designed to reduce the number of security-related design and coding flaws as well as the severity of other flaws. The developer or evaluator of software has no control over the threat environment, because it is external to the organization.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      807,
      621,
      622,
      654,
      668
    ],
    "source": ""
  },
  {
    "id": 2700,
    "question": "In the diagram shown here, which is an example of a method? <br><img src=\"/question_assets/CISSP/8_image3.png\"/>",
    "choice_a": "<code>Account</code>",
    "choice_b": "<code>Owner</code>",
    "choice_c": "<code>AddFunds</code>",
    "choice_d": "<code>Balance</code>",
    "correct_answer": "C",
    "explanation": "In the diagram, <code>Account</code> is the name of the class. <code>Owner</code> and <code>Balance</code> are attributes of that class. <code>AddFunds</code> and <code>RemoveFunds</code> are methods of the class.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      805,
      806,
      621,
      623,
      622
    ],
    "source": ""
  },
  {
    "id": 2701,
    "question": "Wanda is reviewing the application development documentation used by her organization and finds the lifecycle illustration shown here. <br><img src=\"/question_assets/CISSP/8_image4.png\"/><br>What application development method is her organization using?",
    "choice_a": "Waterfall",
    "choice_b": "Spiral",
    "choice_c": "Agile",
    "choice_d": "RAD",
    "correct_answer": "D",
    "explanation": "Rapid Application Development, or RAD, focuses on fast development and the ability to quickly adjust to changing requirements. RAD uses four phases: requirements planning, user design, construction, and cutover.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      1034,
      621,
      1033,
      623
    ],
    "source": ""
  },
  {
    "id": 2702,
    "question": "Which one of the following testing methodologies typically works without access to source code?",
    "choice_a": "Dynamic testing",
    "choice_b": "Static testing",
    "choice_c": "White-box testing",
    "choice_d": "Code review",
    "correct_answer": "A",
    "explanation": "Dynamic testing of software typically occurs in a black-box environment where the tester does not have access to the source code. Static testing, white-box testing, and code review approaches all require access to the source code of the application.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      626,
      963,
      621,
      670,
      662
    ],
    "source": ""
  },
  {
    "id": 2703,
    "question": "Lucca is analyzing a web application that his organization acquired from a third-party vendor. Lucca determined that the application contains a flaw that causes users who are logged in to be able to take actions they should not be able to in their role. <br>What type of security vulnerability should this be classified as?",
    "choice_a": "Data validation",
    "choice_b": "Session management",
    "choice_c": "Authorization",
    "choice_d": "Error handling",
    "correct_answer": "C",
    "explanation": "Given the list of options here, the root cause is most likely an issue with an authorization check that does not properly limit users to the authorization that they should have. Data validation issues are more likely to allow injection attacks or to allow bad data to be input, while session management issues would allow session hijacking or might actually cause them to be logged in as another user. Finally, error handling would show up as a problem when errors occurred, which this problem does not indicate.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      662,
      663,
      629,
      620,
      655
    ],
    "source": ""
  },
  {
    "id": 2704,
    "question": "Bobby is investigating how an authorized database user is gaining access to information outside his normal clearance level. Bobby believes that the user is making use of a type of function that summarizes data. <br>What term describes this type of function?",
    "choice_a": "Inference",
    "choice_b": "Polymorphic",
    "choice_c": "Aggregate",
    "choice_d": "Modular",
    "correct_answer": "C",
    "explanation": "Aggregate functions summarize large amounts of data and provide only summary information as a result. When carefully crafted, aggregate functions may unintentionally reveal sensitive information.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      634,
      633,
      641,
      632,
      635
    ],
    "source": ""
  },
  {
    "id": 2705,
    "question": "Taylor would like to better protect the applications developed by her organization against buffer overflow attacks. <br>Which of the following controls would best provide this protection?",
    "choice_a": "Encryption",
    "choice_b": "Input validation",
    "choice_c": "Firewall",
    "choice_d": "Intrusion prevention system",
    "correct_answer": "B",
    "explanation": "The best protection against buffer overflow attacks is server-side input validation. This technique limits user input to approved ranges of values that fit within allocated buffers. While firewalls and intrusion prevention systems may contain controls that limit buffer overflows, it would be more effective to perform filtering on the application server. Encryption cannot protect against buffer overflow attacks.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      654,
      668,
      620,
      669,
      661
    ],
    "source": ""
  },
  {
    "id": 2706,
    "question": "Kayla recently completed a thorough risk analysis and mitigation review of the software developed by her team and identified three persistent issues: <br><ol><li>Cross-site scripting </li><li>SQL injection </li><li>Buffer overflows</li></ol><br>What is the most significant deficiency in her team's work identified by these issues?",
    "choice_a": "Lack of API security",
    "choice_b": "Improper error handling",
    "choice_c": "Improper or missing input validation",
    "choice_d": "Source code design issues",
    "correct_answer": "C",
    "explanation": "Each of these problems is caused by improper or missing input validation and can be resolved by handling inputs properly. In many cases, this can be done using libraries or methods already built into the language or framework that the developer is using.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      668,
      620,
      661,
      654,
      659
    ],
    "source": ""
  },
  {
    "id": 2707,
    "question": "Robert is a consultant who helps organizations create and develop mature software development practices. He prefers to use the Software Capability Maturity Model (SW-CMM) to evaluate the current and future status of organizations using both independent review and self-assessments. He is currently working with two different clients. <br>Acme Widgets is not very well organized with its software development practices. It does have a dedicated team of developers who do \"whatever it takes\" to get software out the door, but it does not have any formal processes. <br>Beta Particles is a company with years of experience developing software using formal, documented software development processes. It uses a standard model for software development but does not have quantitative management of those processes. <br>What phase of the SW-CMM should Robert report as the current status of Acme Widgets?",
    "choice_a": "Defined",
    "choice_b": "Repeatable",
    "choice_c": "Initial",
    "choice_d": "Managed",
    "correct_answer": "C",
    "explanation": "Acme Widgets is clearly in the initial stage of the SW-CMM. This stage is characterized by the absence of formal process. The company may still produce working code, but it does so in a disorganized fashion.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      640,
      624,
      622,
      621
    ],
    "source": ""
  },
  {
    "id": 2708,
    "question": "Robert is a consultant who helps organizations create and develop mature software development practices. He prefers to use the Software Capability Maturity Model (SW-CMM) to evaluate the current and future status of organizations using both independent review and self-assessments. He is currently working with two different clients. <br>Acme Widgets is not very well organized with its software development practices. It does have a dedicated team of developers who do \"whatever it takes\" to get software out the door, but it does not have any formal processes. <br>Beta Particles is a company with years of experience developing software using formal, documented software development processes. It uses a standard model for software development but does not have quantitative management of those processes. <br>Robert is working with Acme Widgets on a strategy to advance their software development practices. <br>What SW-CMM stage should be their next target milestone?",
    "choice_a": "Defined",
    "choice_b": "Repeatable",
    "choice_c": "Initial",
    "choice_d": "Managed",
    "correct_answer": "B",
    "explanation": "The Repeatable stage is the second stage in the SW-CMM, following the Initial stage. It should be the next milestone goal for Acme Widgets. The Repeatable stage is characterized by basic lifecycle management processes.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      640,
      624,
      622,
      833
    ],
    "source": ""
  },
  {
    "id": 2709,
    "question": "Robert is a consultant who helps organizations create and develop mature software development practices. He prefers to use the Software Capability Maturity Model (SW-CMM) to evaluate the current and future status of organizations using both independent review and self-assessments. He is currently working with two different clients. <br>Acme Widgets is not very well organized with its software development practices. It does have a dedicated team of developers who do \"whatever it takes\" to get software out the door, but it does not have any formal processes. <br>Beta Particles is a company with years of experience developing software using formal, documented software development processes. It uses a standard model for software development but does not have quantitative management of those processes. <br>What phase of the SW-CMM should Robert report as the current status of Beta Particles?",
    "choice_a": "Defined",
    "choice_b": "Repeatable",
    "choice_c": "Optimizing",
    "choice_d": "Managed",
    "correct_answer": "A",
    "explanation": "The Defined stage of the SW-CMM is marked by the presence of basic lifecycle management processes and reuse of code. It includes the use of requirements management, software project planning, quality assurance, and configuration management practices.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      640,
      622,
      624,
      621
    ],
    "source": ""
  },
  {
    "id": 2710,
    "question": "Robert is a consultant who helps organizations create and develop mature software development practices. He prefers to use the Software Capability Maturity Model (SW-CMM) to evaluate the current and future status of organizations using both independent review and self-assessments. He is currently working with two different clients. <br>Acme Widgets is not very well organized with its software development practices. It does have a dedicated team of developers who do \"whatever it takes\" to get software out the door, but it does not have any formal processes. <br>Beta Particles is a company with years of experience developing software using formal, documented software development processes. It uses a standard model for software development but does not have quantitative management of those processes. <br>Robert is also working with Beta Particles on a strategy to advance their software development practices. <br>What SW-CMM stage should be their next target milestone?",
    "choice_a": "Defined",
    "choice_b": "Repeatable",
    "choice_c": "Optimizing",
    "choice_d": "Managed",
    "correct_answer": "D",
    "explanation": "The Managed stage is the fourth stage in the SW-CMM, following the Defined stage. It should be the next milestone goal for Beta Particles. The Managed stage is characterized by the use of quantitative software development measures.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      640,
      624,
      622,
      626
    ],
    "source": ""
  },
  {
    "id": 2711,
    "question": "Which one of the following database keys is used to enforce referential integrity relationships between tables?",
    "choice_a": "Primary key",
    "choice_b": "Candidate key",
    "choice_c": "Foreign key",
    "choice_d": "Master key",
    "correct_answer": "C",
    "explanation": "Referential integrity ensures that records exist in a secondary table when they are referenced with a foreign key from another table. Foreign keys are the mechanism used to enforce referential integrity.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      840,
      630,
      838,
      839,
      632
    ],
    "source": ""
  },
  {
    "id": 2712,
    "question": "Brynn believes that a system in her organization may have been compromised by a macro virus. <br>Which one of the following files is most likely to be the culprit?",
    "choice_a": "<code>projections.doc</code>",
    "choice_b": "<code>command.com</code>",
    "choice_c": "<code>command.exe</code>",
    "choice_d": "<code>loopmaster.exe</code>",
    "correct_answer": "A",
    "explanation": "Macro viruses are most commonly found in office productivity documents, such as Microsoft Word documents that end in the <code>.doc</code> or <code>.docx </code>extension. They are not commonly found in executable files with the <code>.com</code> or <code>.exe</code> extension.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      808,
      809,
      810,
      643,
      644
    ],
    "source": ""
  },
  {
    "id": 2713,
    "question": "Victor created a database table that contains information on his organization's employees. The table contains the employee's user ID, three different telephone number fields (home, work, and mobile), the employee's office location, and the employee's job title. There are 16 records in the table. <br>What is the degree of this table?",
    "choice_a": "3",
    "choice_b": "4",
    "choice_c": "6",
    "choice_d": "16",
    "correct_answer": "C",
    "explanation": "The degree of a database table is the number of attributes in the table. Victor's table has six attributes: the employee's user ID, home telephone, office telephone, mobile telephone, office location, and job title.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      964,
      966,
      965,
      630,
      633
    ],
    "source": ""
  },
  {
    "id": 2714,
    "question": "Carrie is analyzing the application logs for her web-based application and comes across the following string:<br><code>../../../../../../../../../etc/passwd</code> <br>What type of attack was likely attempted against Carrie's application?",
    "choice_a": "Command injection",
    "choice_b": "Session hijacking",
    "choice_c": "Directory traversal",
    "choice_d": "Brute force",
    "correct_answer": "C",
    "explanation": "The string shown in the logs is characteristic of a directory traversal attack where the attacker attempts to force the web application to navigate up the file hierarchy and retrieve a file that should not normally be provided to a web user, such as the password file. The series of \"double dots\" is indicative of a directory traversal attack because it is the character string used to reference the directory one level up in a hierarchy.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      664,
      825,
      668,
      660,
      661
    ],
    "source": ""
  },
  {
    "id": 2715,
    "question": "When should a design review take place when following an SDLC approach to software development?",
    "choice_a": "After the code review",
    "choice_b": "After user acceptance testing",
    "choice_c": "After the development of functional requirements",
    "choice_d": "After the completion of unit testing",
    "correct_answer": "C",
    "explanation": "Design reviews should take place after the development of functional and control specifications but before the creation of code. The code review, unit testing, and functional testing all take place after the creation of code and, therefore, after the design review.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      621,
      622,
      623,
      620,
      963
    ],
    "source": ""
  },
  {
    "id": 2716,
    "question": "Tracy is preparing to apply a patch to her organization's enterprise resource planning system. She is concerned that the patch may introduce flaws that did not exist in prior versions, so she plans to conduct a test that will compare previous responses to input with those produced by the newly patched application. <br>What type of testing is Tracy planning?",
    "choice_a": "Unit testing",
    "choice_b": "Acceptance testing",
    "choice_c": "Regression testing",
    "choice_d": "Vulnerability testing",
    "correct_answer": "C",
    "explanation": "Regression testing is software testing that runs a set of known inputs against an application and then compares the results to those produced by an earlier version of the software. It is designed to capture unanticipated consequences of deploying new code versions prior to introducing them into a production environment.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      963,
      626,
      821,
      652,
      672
    ],
    "source": ""
  },
  {
    "id": 2717,
    "question": "What term is used to describe the level of confidence that software is free from vulnerabilities, either intentionally designed into the software or accidentally inserted at any time during its lifecycle, and that the software functions in the intended manner?",
    "choice_a": "Validation",
    "choice_b": "Accreditation",
    "choice_c": "Confidence interval",
    "choice_d": "Assurance",
    "correct_answer": "D",
    "explanation": "Assurance, when it comes to software, is the level of confidence that software is free from vulnerabilities, either intentionally designed into the software or accidentally inserted at any time during its lifecycle, and that the software functions in the intended manner. It is a term typically used in military and defense environments.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      621,
      622,
      625,
      626,
      623
    ],
    "source": ""
  },
  {
    "id": 2718,
    "question": "Victor recently took a new position at an online dating website and is responsible for leading a team of developers. He realized quickly that the developers are having issues with production code because they are working on different projects that result in conflicting modifications to the production code. <br>What process should Victor invest in improving?",
    "choice_a": "Request control",
    "choice_b": "Release control",
    "choice_c": "Change control",
    "choice_d": "Configuration control",
    "correct_answer": "C",
    "explanation": "The change control process is responsible for providing an organized framework within which multiple developers can create and test a solution prior to rolling it out in a production environment. Request control provides a framework for user requests. Release control manages the deployment of code into production. Configuration control ensures that changes to software versions are made in accordance with the change and configuration management policies.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1032,
      624,
      1030,
      625,
      640
    ],
    "source": ""
  },
  {
    "id": 2719,
    "question": "Tom is assessing security risks related to a database he manages. Examining user access controls, he determines that users have access to individual records in a table that match their clearances, but if they pull multiple records, that collection of facts has a higher classification than the classification of any of those facts standing alone and exceeds the permitted access. <br>What type of issue has Tom identified?",
    "choice_a": "Inference",
    "choice_b": "SQL injection",
    "choice_c": "Multilevel security",
    "choice_d": "Aggregation",
    "correct_answer": "D",
    "explanation": "Aggregation is a security issue that arises when a collection of facts has a higher classification than the classification of any of those facts standing alone. An inference problem occurs when an attacker can pull together pieces of less sensitive information and use them to derive information of greater sensitivity. SQL injection is a web application exploit. Multilevel security is a system control that allows the simultaneous processing of information at different classification levels.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      634,
      633,
      662,
      636,
      635
    ],
    "source": ""
  },
  {
    "id": 2720,
    "question": "Ron leads a team of software developers who find themselves often re-creating code that performs common functions. <br>What software development tool could he use to best address this situation?",
    "choice_a": "Code repositories",
    "choice_b": "Code libraries",
    "choice_c": "IDEs",
    "choice_d": "DAST",
    "correct_answer": "B",
    "explanation": "Code libraries are packages of reusable functions that may be incorporated into individual development projects. Ron could use libraries to easily share code among his team. Code repositories may be used to manage the distribution and updating of these libraries, but that is a second-order use case, making code libraries the best answer. Integrated development environments (IDEs) are tools used by developers to create software, while dynamic application security testing (DAST) is used to verify the correct implementation of code.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      618,
      816,
      670,
      628,
      640
    ],
    "source": ""
  },
  {
    "id": 2721,
    "question": "Vivian would like to hire a software tester to come in and evaluate a new web application from a user's perspective. <br>Which of the following tests best simulates that perspective?",
    "choice_a": "Black box",
    "choice_b": "Gray box",
    "choice_c": "Blue box",
    "choice_d": "White box",
    "correct_answer": "A",
    "explanation": "Black-box testing begins with no prior knowledge of the system implementation, simulating a user perspective. White-box and gray-box testing provide full and partial knowledge of the system, respectively, in advance of the test. Blue boxes are a phone hacking tool and are not used in software testing.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      626,
      662,
      621,
      833,
      623
    ],
    "source": ""
  },
  {
    "id": 2722,
    "question": "Referring to the database transaction shown here, what would happen if no account exists in the Accounts table with account number 1001? <br><img src=\"/question_assets/CISSP/8_image5.png\"/>",
    "choice_a": "The database would create a new account with this account number and give it a $250 balance.",
    "choice_b": "The database would ignore that command and still reduce the balance of the second account by $250.",
    "choice_c": "The database would roll back the transaction, ignoring the results of both commands.",
    "choice_d": "The database would generate an error message.",
    "correct_answer": "B",
    "explanation": "In this example, the two SQL commands are indeed bundled in a transaction, but it is not an error to issue an update command that does not match any rows. Therefore, the first command would \"succeed\" in updating zero rows and not generate an error or cause the transaction to roll back. The second command would then execute, reducing the balance of the second account by $250.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      812,
      811,
      813,
      620,
      630
    ],
    "source": ""
  },
  {
    "id": 2723,
    "question": "Brandon is a software developer seeking to integrate his software with a popular social media site. The site provides him with software libraries that he can use to better integrate his code as well as other tools that make his work easier. <br>What term best describes the service he is using?",
    "choice_a": "SDK",
    "choice_b": "DLP",
    "choice_c": "IDE",
    "choice_d": "API",
    "correct_answer": "A",
    "explanation": "Software development kits (SDKs) are code libraries and other tools made available to assist developers in creating code. An integrated development environment (IDE) may be a component of an SDK, but it is not necessarily part of every SDK. An application programming interface (API) is a set of functions made available to external developers, but the code does not execute on the users' machine, as would a code library or other SDK tools. Data loss prevention (DLP) capabilities are not a component of software development toolsets.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      815,
      670,
      816,
      814,
      640
    ],
    "source": ""
  },
  {
    "id": 2724,
    "question": "Kim is troubleshooting an application firewall that serves as a supplement to the organization's network and host firewalls and intrusion prevention system, providing added protection against web-based attacks. The issue the organization is experiencing is that the firewall technology suffers somewhat frequent restarts that render it unavailable for 10 minutes at a time. <br>What configuration might Kim consider to maintain availability during that period at the lowest cost to the company?",
    "choice_a": "High availability cluster",
    "choice_b": "Failover device",
    "choice_c": "Fail open",
    "choice_d": "Redundant disks",
    "correct_answer": "C",
    "explanation": "A fail open configuration may be appropriate in this case. In this configuration, the firewall would continue to pass traffic without inspection while it is restarting. This would minimize downtime, and the traffic would still be protected by the other security controls described in the scenario. Failover devices and high availability clusters would indeed increase availability, but at potentially significant expense. Redundant disks would not help in this scenario because no disk failure is described.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      669,
      833,
      670,
      624,
      623
    ],
    "source": ""
  },
  {
    "id": 2725,
    "question": "What type of security issue arises when an attacker can deduce a more sensitive piece of information by analyzing several pieces of information classified at a lower level?",
    "choice_a": "SQL injection",
    "choice_b": "Multilevel security",
    "choice_c": "Parameterization",
    "choice_d": "Inference",
    "correct_answer": "D",
    "explanation": "An inference problem occurs when an attacker can pull together pieces of less sensitive information and use them to derive information of greater sensitivity. SQL injection is a web application exploit. Multilevel security is a system control that allows the simultaneous processing of information at different classification levels. Parameterization is a security control used to reduce the likelihood of attacks that rely upon improper user input.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      634,
      633,
      636,
      658,
      662
    ],
    "source": ""
  },
  {
    "id": 2726,
    "question": "Greg is battling a malware outbreak in his organization. He used specialized malware analysis tools to capture samples of the malware from three different systems and noticed that the code is changing slightly from infection to infection. Greg believes that this is the reason that antivirus software is having a tough time defeating the outbreak. <br>What type of malware should Greg suspect is responsible for this security incident?",
    "choice_a": "Stealth virus",
    "choice_b": "Polymorphic virus",
    "choice_c": "Multipartite virus",
    "choice_d": "Encrypted virus",
    "correct_answer": "B",
    "explanation": "Polymorphic viruses mutate each time they infect a system by making adjustments to their code that assists them in evading signature detection mechanisms. Encrypted viruses also mutate from infection to infection but do so by encrypting themselves with different keys on each device.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      644,
      651,
      674,
      675,
      649
    ],
    "source": ""
  },
  {
    "id": 2727,
    "question": "Linda is reviewing posts to a user forum on her company's website, and when she browses a certain post, a message pops up in a dialog box on her screen reading \"Alert.\" She reviews the source code for the post and finds the following code snippet: <br><img src=\"/question_assets/CISSP/8_image13.png\"/><br>What vulnerability definitely exists on Linda's message board?",
    "choice_a": "Cross-site scripting",
    "choice_b": "Cross-site request forgery",
    "choice_c": "SQL injection",
    "choice_d": "Improper authentication",
    "correct_answer": "A",
    "explanation": "The message forum is clearly susceptible to a cross-site scripting (XSS) attack. The code that Linda discovered in the message is a definitive example of an attempt to conduct cross-site scripting, and the alert box that she received demonstrates that the vulnerability exists. The website may also be vulnerable to cross-site request forgery, SQL injection, improper authentication, and other attacks, but there is no evidence of this provided in the scenario.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      661,
      666,
      654,
      671,
      675
    ],
    "source": ""
  },
  {
    "id": 2728,
    "question": "Linda is reviewing posts to a user forum on her company's website, and when she browses a certain post, a message pops up in a dialog box on her screen reading \"Alert.\" She reviews the source code for the post and finds the following code snippet: <br><img src=\"/question_assets/CISSP/8_image13.png\"/><br>What was the likely motivation of the user who posted the message on the forum containing this code?",
    "choice_a": "Reconnaissance",
    "choice_b": "Theft of sensitive information",
    "choice_c": "Credential stealing",
    "choice_d": "Social engineering",
    "correct_answer": "A",
    "explanation": "The script that Linda discovered merely pops up a message on a user's screen and does not perform any more malicious action. This type of script, using an <code>alert()</code> call, is commonly used to probe websites for cross-site scripting vulnerabilities.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      661,
      649,
      668,
      659,
      654
    ],
    "source": ""
  },
  {
    "id": 2729,
    "question": "Linda is reviewing posts to a user forum on her company's website, and when she browses a certain post, a message pops up in a dialog box on her screen reading \"Alert.\" She reviews the source code for the post and finds the following code snippet: <br><img src=\"/question_assets/CISSP/8_image13.png\"/><br>Linda communicates with the vendor and determines that no patch is available to correct this vulnerability. <br>Which one of the following devices would best help her defend the application against further attack?",
    "choice_a": "VPN",
    "choice_b": "WAF",
    "choice_c": "DLP",
    "choice_d": "IDS",
    "correct_answer": "B",
    "explanation": "Web application firewalls (WAFs) sit in front of web applications and watch for potentially malicious web attacks, including cross-site scripting. They then block that traffic from reaching the web application. An intrusion detection system (IDS) may detect the attack but is unable to take action to prevent it. DLP and VPN solutions are unable to detect web application attacks.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      669,
      662,
      661,
      824,
      672
    ],
    "source": ""
  },
  {
    "id": 2730,
    "question": "Linda is reviewing posts to a user forum on her company's website, and when she browses a certain post, a message pops up in a dialog box on her screen reading \"Alert.\" She reviews the source code for the post and finds the following code snippet: <br><img src=\"/question_assets/CISSP/8_image13.png\"/><br>In further discussions with the vendor, Linda finds that they are willing to correct the issue but do not know how to update their software. <br>What technique would be most effective in mitigating the vulnerability of the application to this type of attack?",
    "choice_a": "Bounds checking",
    "choice_b": "Peer review",
    "choice_c": "Input validation",
    "choice_d": "OS patching",
    "correct_answer": "C",
    "explanation": "Input validation verifies that user-supplied input does not violate security conditions and is the most effective defense against cross-site scripting attacks. Bounds checking is a form of input validation, but it is typically used to ensure that numeric input falls within an acceptable range and is not applicable against cross-site scripting attacks. Peer review and OS patching are both good security practices but are unlikely to be effective against a cross-site scripting attack.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      668,
      620,
      824,
      661,
      672
    ],
    "source": ""
  },
  {
    "id": 2731,
    "question": "Hannah is a software developer working on creating statistical software using the R programming language. She uses the RStudio tool, shown here, to assist her in writing this code. <br><img src=\"/question_assets/CISSP/8_image6.png\"/><br>What term best describes this tool?",
    "choice_a": "SDK",
    "choice_b": "IDE",
    "choice_c": "API",
    "choice_d": "DLP",
    "correct_answer": "B",
    "explanation": "RStudio is a tool used to assist in the creation of code, otherwise known as an integrated development environment (IDE). Software development kits (SDKs) are code libraries and other tools made available to assist developers in creating code. An application programming interface (API) is a set of functions made available to external developers, but the code does not execute on the users' machine, as would a code library or other SDK tools. Data loss prevention (DLP) capabilities are not a component of software development toolsets.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      815,
      814,
      670,
      816,
      640
    ],
    "source": ""
  },
  {
    "id": 2733,
    "question": "Alan is deploying Java code to a variety of machines in his environment and must install the JVM on those machines first. <br>What term best describes the JVM in this case?",
    "choice_a": "Repository",
    "choice_b": "Change manager",
    "choice_c": "Runtime",
    "choice_d": "Sandbox",
    "correct_answer": "C",
    "explanation": "The JVM is the runtime virtual machine that allows the execution of Java code on a device. The JVM implements the Java sandbox, but that is only one of its many functions. The JVM itself is not a change manager or code repository.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      617,
      670,
      621,
      618,
      628
    ],
    "source": ""
  },
  {
    "id": 2734,
    "question": "Christine is nearing the final stages of testing a new software package. <br>Which one of the following types of software testing usually occurs last and is executed against test scenarios?",
    "choice_a": "Unit testing",
    "choice_b": "Integration testing",
    "choice_c": "User acceptance testing",
    "choice_d": "System testing",
    "correct_answer": "C",
    "explanation": "User acceptance testing (UAT) is typically the last phase of the testing process. It verifies that the solution developed meets user requirements and validates it against use cases. Unit testing, integration testing, and system testing are all conducted earlier in the process leading up to UAT.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      963,
      622,
      621,
      823,
      1032
    ],
    "source": ""
  },
  {
    "id": 2735,
    "question": "Alexis' organization recently moved to a CI/CD approach for software development where they intend to speed up the deployment of code supporting their website. <br>What is the most reasonable frequency that they can expect to achieve using this type of approach?",
    "choice_a": "Monthly deployments",
    "choice_b": "Weekly deployments",
    "choice_c": "Daily deployments",
    "choice_d": "Hundreds of daily deployments",
    "correct_answer": "D",
    "explanation": "When organizations adopt a continuous integration/continuous delivery (CI/CD) approach to software development, they may deploy code extremely rapidly. In fact, some organizations deploy new code to production hundreds or even thousands of times per day using this approach.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      625,
      817,
      818,
      640,
      832
    ],
    "source": ""
  },
  {
    "id": 2736,
    "question": "Amber is conducting a threat intelligence project and would like to find a source of information on threats to her organization's web applications. <br>Which of the following organizations is widely considered as the definitive source for information on web-based attack vectors?",
    "choice_a": "ISC2",
    "choice_b": "ISACA",
    "choice_c": "OWASP",
    "choice_d": "Mozilla Foundation",
    "correct_answer": "C",
    "explanation": "The Open Web Application Security Project (OWASP) is widely considered as the most authoritative source on web application security issues. They publish the OWASP Top Ten list that publicizes the most critical web application security issues.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      662,
      661,
      658,
      659,
      668
    ],
    "source": ""
  },
  {
    "id": 2737,
    "question": "Chris is a software developer, and he is actively writing code for an application. <br>What phase of the Agile process is he in?",
    "choice_a": "Planning",
    "choice_b": "Sprints",
    "choice_c": "Deployment",
    "choice_d": "Development",
    "correct_answer": "B",
    "explanation": "Chris is in an Agile sprint phase and is likely developing code based on user stories. Planning includes stakeholder stories, as well as design and test case preparation. Deployment includes the actual deployment of the application, as well as additional verification and testing.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1033,
      1035,
      622,
      640,
      625
    ],
    "source": ""
  },
  {
    "id": 2738,
    "question": "Alyssa's team recently implemented a new system that gathers information from a variety of different log sources, analyzes that information, and then triggers automated playbooks in response to security events. <br>What term best describes this technology?",
    "choice_a": "SIEM",
    "choice_b": "Log repositories",
    "choice_c": "IPS",
    "choice_d": "SOAR",
    "correct_answer": "D",
    "explanation": "Security information and event management (SIEM) systems do correlate information from multiple sources and perform analysis, but they stop short of providing automated playbook responses. That is the realm of security orchestration, automation, and response (SOAR) platforms. Intrusion prevention platforms have a more limited scope, allowing the blocking of traffic based upon analysis performed by the IPS itself. Log repositories simply collect log information and do not perform analysis.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      653,
      639,
      638,
      825,
      621
    ],
    "source": ""
  },
  {
    "id": 2739,
    "question": "Chris is reviewing the code of an opensource application that he is planning to use in his organization. He finds the code excerpt shown here:<br><code>int myarray[10]; </code> <br><code>myarray[10] = 8; </code> <br>What type of attack is taking place?",
    "choice_a": "Mismatched data types",
    "choice_b": "Overflow",
    "choice_c": "SQL injection",
    "choice_d": "Covert channel",
    "correct_answer": "B",
    "explanation": "This is an example of a specific type of buffer overflow known as an off-by-one error. The first line of the code defines an array of 10 elements, which would be numbered 0 through 9. The second line of code tries to place a value in the 11th element of the array (remember, array counting begins at 0!), which would cause an overflow.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      654,
      668,
      671,
      621,
      670
    ],
    "source": ""
  },
  {
    "id": 2740,
    "question": "Which one of the following database issues occurs when one transaction writes a value to the database that overwrites a value that was needed by transactions with earlier precedence?",
    "choice_a": "Dirty read",
    "choice_b": "Incorrect summary",
    "choice_c": "Lost update",
    "choice_d": "SQL injection",
    "correct_answer": "C",
    "explanation": "Lost updates occur when one transaction writes a value to the database that overwrites a value needed by transactions that have earlier precedence, causing those transactions to read an incorrect value. Dirty reads occur when one transaction reads a value from a database that was written by another transaction that did not commit. Incorrect summaries occur when one transaction is using an aggregate function to summarize data stored in a database while a second transaction is making modifications to the database, causing the summary to include incorrect information. SQL injection is a web application security flaw, not a database concurrency problem.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      633,
      632,
      634,
      811,
      813
    ],
    "source": ""
  },
  {
    "id": 2741,
    "question": "Belinda would like to better protect users of her organization's web application from cookie stealing attacks. <br>Which one of the following is the most effective control against this type of session hijacking attack?",
    "choice_a": "TLS",
    "choice_b": "Complex session cookies",
    "choice_c": "SSL",
    "choice_d": "Expiring cookies frequently",
    "correct_answer": "A",
    "explanation": "Transport Layer Security (TLS) provides the most effective defense against session hijacking because it encrypts all traffic between the client and server, preventing the attacker from stealing session credentials. Secure Sockets Layer (SSL) also encrypts traffic, but it is vulnerable to attacks against its encryption technology. Complex and expiring cookies are a good idea, but they are not sufficient protection against session hijacking.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      667,
      629,
      668,
      654,
      803
    ],
    "source": ""
  },
  {
    "id": 2742,
    "question": "In a software configuration management program, what is the primary role of the CAB?",
    "choice_a": "Approve the credentials of developers.",
    "choice_b": "Facilitate lessons learned sessions.",
    "choice_c": "Review and approve/reject code changes.",
    "choice_d": "Prioritize software development efforts.",
    "correct_answer": "C",
    "explanation": "The purpose of the change advisory board (CAB) is to review and then approve or reject proposed code changes. The CAB is not normally involved in the approval of developer credentials, the conduct of lessons learned sessions, or the prioritization of software development efforts.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      624,
      623,
      640,
      622,
      621
    ],
    "source": ""
  },
  {
    "id": 2743,
    "question": "Which one of the following tools is commonly used by software developers to interact with and manage code that is stored in code repositories?",
    "choice_a": "<code>grep</code>",
    "choice_b": "<code>git</code>",
    "choice_c": "<code>lsof</code>",
    "choice_d": "<code>gcc</code>",
    "correct_answer": "B",
    "explanation": "<code>git</code> is a version management tool that is very commonly used by developers to interact with code repositories, such as those hosted by GitHub. <code>grep</code> is a command-line tool used to search files for specific content. <code>lsof</code> is a command used to list the open files on a system. <code>gcc</code> is a C language compiler used to transform source code into executable code.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1030,
      628,
      670,
      814,
      816
    ],
    "source": ""
  },
  {
    "id": 2744,
    "question": "While evaluating a potential security incident, Harry comes across a log entry from a web server request showing that a user entered the following input into a form field: <br><code>CARROT'&1=1;-- </code> <br>What type of attack was attempted?",
    "choice_a": "Buffer overflow",
    "choice_b": "Cross-site scripting",
    "choice_c": "SQL injection",
    "choice_d": "Cross-site request forgery",
    "correct_answer": "C",
    "explanation": "The single quotation mark in the input field is a telltale sign that this is a SQL injection attack. The quotation mark is used to escape outside the SQL code's input field, and the text following is used to directly manipulate the SQL command sent from the web application to the database.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      658,
      661,
      668,
      620,
      672
    ],
    "source": ""
  },
  {
    "id": 2745,
    "question": "Which one of the following is not an effective control against SQL injection attacks?",
    "choice_a": "Escaping",
    "choice_b": "Client-side input validation",
    "choice_c": "Parameterization",
    "choice_d": "Limiting database permissions",
    "correct_answer": "B",
    "explanation": "Client-side input validation is not an effective control against any type of attack because the attacker can easily bypass the validation by altering the code on the client. Escaping restricted characters prevents them from being passed to the database, as does parameterization. Limiting database permissions prevents dangerous code from executing.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      658,
      661,
      620,
      668,
      672
    ],
    "source": ""
  },
  {
    "id": 2746,
    "question": "Jason is reviewing the documentation for a software development project and comes across the diagram shown here. <br><img src=\"/question_assets/CISSP/8_image7.png\"/><br>What type of diagram is he examining?",
    "choice_a": "WBS chart",
    "choice_b": "PERT chart",
    "choice_c": "Gantt chart",
    "choice_d": "Wireframe diagram",
    "correct_answer": "B",
    "explanation": "PERT charts use nodes to represent milestones or deliverables and then show the estimated time to move between milestones. Gantt charts use a different format with a row for each task and lines showing the expected duration of the task. Work breakdown structures are an earlier deliverable that divides project work into achievable tasks. Wireframe diagrams are used in web design.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      821,
      820,
      822,
      621,
      623
    ],
    "source": ""
  },
  {
    "id": 2747,
    "question": "In what software testing technique does the evaluator retest a large number of scenarios each time that the software changes to verify that the results are consistent with a standard baseline?",
    "choice_a": "Orthogonal array testing",
    "choice_b": "Pattern testing",
    "choice_c": "Matrix testing",
    "choice_d": "Regression testing",
    "correct_answer": "D",
    "explanation": "Regression testing is performed after developers make changes to an application. It reruns a number of test cases and compares the results to baseline results. Orthogonal array testing is a method for generating test cases based on statistical analysis. Pattern testing uses records of past software bugs to inform the analysis. Matrix testing develops a matrix of all possible inputs and outputs to inform the test plan.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      963,
      962,
      623,
      1032,
      675
    ],
    "source": ""
  },
  {
    "id": 2748,
    "question": "Haley is reviewing code created by her organization for its possible exposure to web application vulnerabilities. <br>Which one of the following conditions may make an application most vulnerable to a cross-site scripting (XSS) attack?",
    "choice_a": "Input validation",
    "choice_b": "Reflected input",
    "choice_c": "Unpatched server",
    "choice_d": "Promiscuous firewall rules",
    "correct_answer": "B",
    "explanation": "Cross-site scripting (XSS) attacks may take advantage of the use of reflected input in a web application where input provided by one user is displayed to another user. Input validation is a control used to prevent XSS attacks. XSS does not require an unpatched server or any firewall rules beyond those permitting access to the web application.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      668,
      620,
      824,
      674,
      662
    ],
    "source": ""
  },
  {
    "id": 2749,
    "question": "Roger is conducting a software test for a tax preparation application developed by his company. End users will access the application over the web, but Roger is conducting his test on the back end, evaluating the source code on the web server. <br>What type of test is Roger conducting?",
    "choice_a": "White box",
    "choice_b": "Gray box",
    "choice_c": "Blue box",
    "choice_d": "Black box",
    "correct_answer": "A",
    "explanation": "In a white-box test, the attacker has access to full implementation details of the system, including source code, prior to beginning the test. In gray-box testing, the attacker has partial knowledge. In black-box testing, the attacker has no knowledge of the system and tests it from a user perspective. Blue boxes are a phone hacking tool and are not used in software testing.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      626,
      621,
      833,
      628,
      670
    ],
    "source": ""
  },
  {
    "id": 2750,
    "question": "Which of the following statements is true about heuristic-based anti-malware software?",
    "choice_a": "It has a lower false positive rate than signature detection.",
    "choice_b": "It requires frequent definition updates to detect new malware.",
    "choice_c": "It has a higher likelihood of detecting zero-day exploits than signature detection.",
    "choice_d": "It monitors systems for files with content known to be viruses.",
    "correct_answer": "C",
    "explanation": "Heuristic-based anti-malware software has a higher likelihood of detecting a zero-day exploit than signature-based methods. Heuristic-based software does not require frequent signature updates because it does not rely upon monitoring systems for the presence of known malware. The trade-off with this approach is that it has a higher false positive rate than signature detection methods.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      651,
      674,
      649,
      653,
      642
    ],
    "source": ""
  },
  {
    "id": 2751,
    "question": "Martin is inspecting a system where the user reported unusual activity, including disk activity when the system is idle and abnormal CPU and network usage. He suspects that the machine is infected by a virus, but scans come up clean. <br>What malware technique might be in use here that would explain the clean scan results?",
    "choice_a": "File infector virus",
    "choice_b": "MBR virus",
    "choice_c": "Service injection virus",
    "choice_d": "Stealth virus",
    "correct_answer": "D",
    "explanation": "One possibility for the clean scan results is that the virus is using stealth techniques, such as intercepting read requests from the antivirus software and returning a correct-looking version of the infected file. The system may also be the victim of a zero-day attack, using a virus that is not yet included in the signature definition files provided by the antivirus vendor.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      644,
      651,
      649,
      642,
      652
    ],
    "source": ""
  },
  {
    "id": 2752,
    "question": "Tomas discovers a line in his application log that appears to correspond with an attempt to conduct a directory traversal attack. He believes the attack was conducted using URL encoding. The line reads as follows:<br><code>%252E%252E%252F%252E%252E%252Fetc/passwd</code> <br>What character is represented by the %252E value?",
    "choice_a": ".",
    "choice_b": ",",
    "choice_c": ";",
    "choice_d": "/",
    "correct_answer": "A",
    "explanation": "In URL encoding, the . character is replaced by %252E, and the / character is replaced by %252F. You can see this in the log entry, where the expected pattern of ../../ is replaced by <code>%252E%252E%252F%252E%252E%252F.</code>",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      823,
      824,
      668,
      664,
      825
    ],
    "source": ""
  },
  {
    "id": 2753,
    "question": "An attacker posted a message to a public discussion forum that contains an embedded malicious script that is not displayed to the user but executes on the user's system when read. <br>What type of attack is this?",
    "choice_a": "Persistent XSRF",
    "choice_b": "Nonpersistent XSRF",
    "choice_c": "Persistent XSS",
    "choice_d": "Nonpersistent XSS",
    "correct_answer": "C",
    "explanation": "Attacks where the malicious user tricks the victim's web browser into executing a script through the use of a third-party site are known as cross-site scripting (XSS) attacks. This particular attack is a persistent XSS attack because it remains on the discussion forum until an administrator discovers and deletes it, giving it the ability to affect many users.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1010,
      649,
      668,
      672,
      824
    ],
    "source": ""
  },
  {
    "id": 2754,
    "question": "Which one of the following is not a principle of the Agile software development process?",
    "choice_a": "Welcome changing requirements, even late in the development process.",
    "choice_b": "Maximizing the amount of work not done is essential.",
    "choice_c": "Clear documentation is the primary measure of progress.",
    "choice_d": "Build projects around motivated individuals.",
    "correct_answer": "C",
    "explanation": "The Agile Manifesto includes 12 principles for software development. Three of those are listed as answer choices: maximizing the amount of work not done is essential, build projects around motivated individuals, and welcome changing requirements throughout the development process. Agile does not, however, consider clear documentation the primary measure of progress. Instead, working software is the primary measure of progress.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      1033,
      1035,
      640,
      1034
    ],
    "source": ""
  },
  {
    "id": 2755,
    "question": "Gavin is an internal auditor tasked with examining the change management practices of his organization. He would like to review a series of changes made to a software package to determine whether they were properly documented. <br>Where should he turn for a description of each proposed change?",
    "choice_a": "CAB",
    "choice_b": "RFC",
    "choice_c": "SOAR",
    "choice_d": "SIEM",
    "correct_answer": "B",
    "explanation": "Each change should be the result of a reviewed and approved request for change (RFC). These RFCs may be approved by the change advisory board (CAB). The security information and event management (SIEM) and security orchestration, automation, and response (SOAR) platforms used by the organization would not normally contain information about the change management process.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      624,
      628,
      1032,
      640,
      622
    ],
    "source": ""
  },
  {
    "id": 2756,
    "question": "Neal is working with a DynamoDB database. The database is not structured like a relational database but allows Neal to store data using a key-value store. <br>What type of database is DynamoDB?",
    "choice_a": "Relational database",
    "choice_b": "Graph database",
    "choice_c": "Hierarchical database",
    "choice_d": "NoSQL database",
    "correct_answer": "D",
    "explanation": "A key-value store is an example of a NoSQL database that does not follow a relational or hierarchical model like traditional databases. A graph database is another example of a NoSQL database, but it uses nodes and edges to store data rather than keys and values.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      631,
      630,
      632,
      641,
      634
    ],
    "source": ""
  },
  {
    "id": 2757,
    "question": "In the transaction shown here, what would happen if the database failed in between the first and second update statements? <br><img src=\"/question_assets/CISSP/8_image5.png\"/>",
    "choice_a": "The database would credit the first account with $250 in funds but then not reduce the balance of the second account.",
    "choice_b": "The database would ignore the first command and only reduce the balance of the second account by $250.",
    "choice_c": "The database would roll back the transaction, ignoring the results of both commands.",
    "choice_d": "The database would successfully execute both commands.",
    "correct_answer": "C",
    "explanation": "A database failure in the middle of a transaction causes the rollback of the entire transaction. In this scenario, the database would not execute either command because doing so would violate the atomicity property of the transaction.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      632,
      811,
      813,
      630,
      635
    ],
    "source": ""
  },
  {
    "id": 2758,
    "question": "Tareck's organization makes use of a significant amount of COTS software. He recently discovered a significant buffer overflow vulnerability in the code of a COTS software package that is crucial to his business. <br>What is the most likely way that Tareck can get this corrected?",
    "choice_a": "Work with his software development team to modify the code.",
    "choice_b": "Notify the vendor and request a patch.",
    "choice_c": "Deploy an intrusion prevention system.",
    "choice_d": "Update firewall rules.",
    "correct_answer": "B",
    "explanation": "When using commercial off-the-shelf (COTS) software, customers do not generally have access to the source code and must depend upon the vendor to release security patches that correct vulnerabilities. Other controls, such as intrusion prevention systems and firewalls, may be able to help mitigate the issue, depending upon the nature of the flaw, but they will not correct it.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      961,
      654,
      657,
      618,
      670
    ],
    "source": ""
  },
  {
    "id": 2759,
    "question": "Which one of the following statements is true about software testing?",
    "choice_a": "Static testing works on runtime environments.",
    "choice_b": "Static testing performs code analysis.",
    "choice_c": "Dynamic testing uses automated tools, but static testing does not.",
    "choice_d": "Static testing is a more important testing technique than dynamic testing.",
    "correct_answer": "B",
    "explanation": "Static testing performs code analysis in an offline fashion, without actually executing the code. Dynamic testing evaluates code in a runtime environment. Both static and dynamic testing may use automated tools, and both are important security testing techniques.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      963,
      962,
      626,
      661,
      671
    ],
    "source": ""
  },
  {
    "id": 2760,
    "question": "David is working on developing a project schedule for a software development effort, and he comes across the chart shown here. <br><img src=\"/question_assets/CISSP/8_image8.png\"/><br>What type of chart is this?",
    "choice_a": "Work breakdown structure",
    "choice_b": "Functional requirements",
    "choice_c": "PERT chart",
    "choice_d": "Gantt chart",
    "correct_answer": "D",
    "explanation": "The chart shown in the figure is a Gantt chart, showing the proposed start and end dates for different activities. It is developed based on the work breakdown structure (WBS), which is developed based on functional requirements. Program Evaluation Review Technique (PERT) charts show the project schedule as a series of numbered nodes.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      821,
      822,
      624,
      621,
      622
    ],
    "source": ""
  },
  {
    "id": 2761,
    "question": "Barry is a software tester who is working with a new gaming application developed by his company. He is playing the game on a smartphone to conduct his testing in an environment that best simulates a normal end user, but he is referencing the source code as he conducts his test. <br>What type of test is Barry conducting?",
    "choice_a": "White box",
    "choice_b": "Black box",
    "choice_c": "Blue box",
    "choice_d": "Gray box",
    "correct_answer": "D",
    "explanation": "In a gray-box test, the tester evaluates the software from a user perspective but has access to the source code as the test is conducted. White-box tests also have access to the source code but perform testing from a developer's perspective. Black-box tests work from a user's perspective but do not have access to source code. Blue boxes are a telephone hacking tool and not a software testing technique.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      626,
      963,
      833,
      621,
      670
    ],
    "source": ""
  },
  {
    "id": 2762,
    "question": "Miguel recently completed a penetration test of the applications that his organization uses to handle sensitive information. During his testing, he discovered a condition where an attacker can exploit a timing condition to manipulate software into allowing him to perform an unauthorized action. <br>Which one of the following attack types fits this scenario?",
    "choice_a": "SQL injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Pass the hash",
    "choice_d": "TOC/TOU",
    "correct_answer": "D",
    "explanation": "The Time of Check to Time of Use (TOC/TOU) attack exploits timing differences between when a system verifies authorization and software uses that authorization to perform an action. It is an example of a race condition attack. The other three attacks mentioned do not depend on precise timing.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      655,
      662,
      658,
      667,
      654
    ],
    "source": ""
  },
  {
    "id": 2763,
    "question": "What part of the security review process are the input parameters shown in the diagram used for? <br><img src=\"/question_assets/CISSP/8_image9.png\"/>",
    "choice_a": "SQL injection review",
    "choice_b": "Sprint review",
    "choice_c": "Fagan inspection",
    "choice_d": "Attack surface identification",
    "correct_answer": "D",
    "explanation": "Each of these input parameters makes up part of the attack surface of the application. Attackers may opt to target any of them to attack the code or its supporting infrastructure.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      668,
      620,
      661,
      654,
      663
    ],
    "source": ""
  },
  {
    "id": 2764,
    "question": "What application security process can be described in these three major steps? <br><ol><li>Decomposing the application </li><li>Determining and ranking threats </li><li>Determining countermeasures and mitigation</li></ol>",
    "choice_a": "Fagan inspection",
    "choice_b": "Threat modeling",
    "choice_c": "Penetration testing",
    "choice_d": "Code review",
    "correct_answer": "B",
    "explanation": "Threat modeling commonly involves decomposing the application to understand it and how it interacts with other components or users. Next, identifying and ranking threats allows you to focus on the threats that should be prioritized. Finally, identifying how to mitigate those threats finishes the process. Once complete, an organization can take action to handle the threats that were identified with appropriate controls.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      807,
      662,
      668,
      626,
      661
    ],
    "source": ""
  },
  {
    "id": 2765,
    "question": "Which one of the following approaches to failure management is the most conservative from a security perspective?",
    "choice_a": "Fail open",
    "choice_b": "Fail mitigation",
    "choice_c": "Fail clear",
    "choice_d": "Fail closed",
    "correct_answer": "D",
    "explanation": "The fail closed approach prevents any activity from taking place during a system security failure and is the most conservative approach to failure management. Fail open takes the opposite philosophy, allowing all activity in the event of a security control failure. Fail clear and fail mitigation are not failure management approaches.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      621,
      624,
      623,
      833,
      806
    ],
    "source": ""
  },
  {
    "id": 2766,
    "question": "What software development model is shown in the figure? <br><img src=\"/question_assets/CISSP/8_image10.png\"/>",
    "choice_a": "Waterfall",
    "choice_b": "Agile",
    "choice_c": "Lean",
    "choice_d": "Spiral",
    "correct_answer": "D",
    "explanation": "The illustration shows the spiral model of software development. In this approach, developers use multiple iterations of a waterfall-style software development process. This becomes a \"loop\" of iterations through similar processes. The original waterfall approach does not iterate through the entire process repeatedly. Some variants do allow iteration, but only by allowing movement backward and forward one stage. The Agile approach to software development focuses on iterative improvement and does not follow a rigorous SDLC model. Lean is a process improvement methodology and not a software development model.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      640,
      621,
      1034,
      640
    ],
    "source": ""
  },
  {
    "id": 2767,
    "question": "Mark is considering replacing his organization's customer relationship management (CRM) solution with a new product that is available in the cloud. This new solution is completely managed by the vendor, and Mark's company will not have to write any code or manage any physical resources. <br>What type of cloud solution is Mark considering?",
    "choice_a": "IaaS",
    "choice_b": "CaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "D",
    "explanation": "In a software as a service solution, the vendor manages both the physical infrastructure and the complete application stack, providing the customer with access to a fully managed application.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      646,
      643,
      642,
      647,
      648
    ],
    "source": ""
  },
  {
    "id": 2768,
    "question": "Which one of the following change management processes is initiated by users rather than developers?",
    "choice_a": "Change request",
    "choice_b": "Change control",
    "choice_c": "Release control",
    "choice_d": "Design review",
    "correct_answer": "A",
    "explanation": "The request process begins with a user-initiated request for a feature. Change and release control are initiated by developers seeking to implement changes. Design review is a phase of the change approval process initiated by developers when they have a completed design.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      640,
      621,
      624,
      1030,
      628
    ],
    "source": ""
  },
  {
    "id": 2769,
    "question": "Teagan would like to better protect his organization against database inference attacks. <br>Which one of the following techniques is an effective countermeasure against these attacks?",
    "choice_a": "Input validation",
    "choice_b": "Parameterization",
    "choice_c": "Polyinstantiation",
    "choice_d": "Server-side validation",
    "correct_answer": "C",
    "explanation": "Polyinstantiation allows the storage of multiple different pieces of information in a database at different classification levels to prevent attackers from inferring anything about the absence of information. Input validation, server-side validation, and parameterization are all techniques used to prevent web application attacks and are not effective against inference attacks.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      634,
      633,
      635,
      630,
      641
    ],
    "source": ""
  },
  {
    "id": 2770,
    "question": "Ursula is a government web developer who recently created a public application that offers property records. She would like to make it available for other developers to integrate into their applications. <br>What can Ursula create to make it easiest for developers to call her code directly and integrate the output into their applications?",
    "choice_a": "Object model",
    "choice_b": "Data dictionary",
    "choice_c": "API",
    "choice_d": "Primary key",
    "correct_answer": "C",
    "explanation": "While Ursula may certainly use an object model, data dictionary, and primary key in her development effort, external developers cannot directly use them to access her code. An application programming interface (API) allows other developers to call Ursula's code from within their own without knowing the details of Ursula's implementation.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      892,
      627,
      828,
      619,
      628
    ],
    "source": ""
  },
  {
    "id": 2771,
    "question": "Nathan recently completed a software development project where he integrated the organization's network operations stack with their development processes. As a result, developers can modify firewall rules from their code on an as-needed basis. <br>What term best describes this ability?",
    "choice_a": "Agile",
    "choice_b": "IaC",
    "choice_c": "SDS",
    "choice_d": "DevOps",
    "correct_answer": "C",
    "explanation": "This is an example of software defined security (SDS), where security infrastructure may be easily manipulated by code. Answering this question is tricky because several of the other terms are closely related. Software-defined security is an example of infrastructure as code (IaC), but SDS is a more descriptive, and therefore better, answer. SDS is commonly used within an Agile development framework. The DevOps approach links together development and operations, but is generally called DevSecOps when it also includes SDS.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      625,
      640,
      818,
      622,
      1030
    ],
    "source": ""
  },
  {
    "id": 2772,
    "question": "TJ is inspecting a system where the user reported a strange error message and the inability to access files. He sees the window shown in this figure. <br><img src=\"/question_assets/CISSP/1_image2.png\"/><br>What type of malware should TJ suspect?",
    "choice_a": "Service injection",
    "choice_b": "Encrypted virus",
    "choice_c": "SQL injection",
    "choice_d": "Ransomware",
    "correct_answer": "D",
    "explanation": "Messages similar to the one shown in the figure are indicative of a ransomware attack. The attacker encrypts files on a user's hard drive and then demands a ransom, normally paid in Bitcoin, for the decryption key required to restore access to the original content. Encrypted viruses, on the other hand, use encryption to hide themselves from antivirus mechanisms and do not alter other contents on the system.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      647,
      644,
      642,
      651,
      675
    ],
    "source": ""
  },
  {
    "id": 2773,
    "question": "Charles is developing a mission-critical application that has a direct impact on human safety. Time and cost are less important than correctly functioning software. <br>Which of the following software development methodologies should he choose given these requirements?",
    "choice_a": "Agile",
    "choice_b": "DevOps",
    "choice_c": "Spiral",
    "choice_d": "Waterfall",
    "correct_answer": "D",
    "explanation": "Despite many organizations moving to Agile, DevOps, or other more responsive development methodologies, waterfall remains a strong contender when clear objectives and stable requirements are combined with a need to prevent flaws and to have a high level of control over the development process and output.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      640,
      621,
      1034,
      833
    ],
    "source": ""
  },
  {
    "id": 2774,
    "question": "Which one of the following types of artificial intelligence attempts to use complex computations to replicate the partial function of the human mind?",
    "choice_a": "Decision support systems",
    "choice_b": "Expert systems",
    "choice_c": "Knowledge bank",
    "choice_d": "Neural networks",
    "correct_answer": "D",
    "explanation": "Neural networks attempt to use complex computational techniques to model the behavior of the human mind. Knowledge banks are a component of expert systems, which are designed to capture and reapply human knowledge. Decision support systems are designed to provide advice to those carrying out standard procedures and are often driven by expert systems.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      639,
      637,
      638,
      641,
      1037
    ],
    "source": ""
  },
  {
    "id": 2775,
    "question": "At which level of the Software Capability Maturity Model (SW-CMM) does an organization introduce basic lifecycle management processes?",
    "choice_a": "Initial",
    "choice_b": "Repeatable",
    "choice_c": "Defined",
    "choice_d": "Managed",
    "correct_answer": "B",
    "explanation": "In level 2, the Repeatable level of the SW-CMM, an organization introduces basic lifecycle management processes. Reuse of code in an organized fashion begins, and repeatable results are expected from similar projects. The key process areas for this level include Requirements Management, Software Project Planning, Software Project Tracking and Oversight, Software Subcontract Management, Software Quality Assurance, and Software Configuration Management.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      640,
      621,
      622,
      624
    ],
    "source": ""
  },
  {
    "id": 2776,
    "question": "Lucas runs the accounting systems for his company. The morning after an employee was fired, systems began mysteriously losing information. Lucas suspects that the fired employee tampered with the systems prior to his departure. <br>What type of attack should Lucas suspect?",
    "choice_a": "Privilege escalation",
    "choice_b": "SQL injection",
    "choice_c": "Logic bomb",
    "choice_d": "Remote code execution",
    "correct_answer": "C",
    "explanation": "The critical fact in this question is that Lucas suspects the tampering took place before the employee departed. This is the signature of a logic bomb: malicious code that lies dormant until certain conditions are met. The other attack types listed here\u2014privilege escalation, SQL injection, and remote code execution\u2014would more likely take place in real time.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      648,
      656,
      642,
      661,
      654
    ],
    "source": ""
  },
  {
    "id": 2777,
    "question": "Which one of the following principles would not be favored in an Agile approach to software development?",
    "choice_a": "Processes and tools over individuals and interactions",
    "choice_b": "Working software over comprehensive documentation",
    "choice_c": "Customer collaboration over contract negotiations",
    "choice_d": "Responding to change over following a plan",
    "correct_answer": "A",
    "explanation": "The Agile approach to software development embraces four principles. It values individuals and interactions over processes and tools, working software over comprehensive documentation, customer collaboration over contract negotiation, and responding to change over following a plan.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1033,
      1035,
      622,
      640,
      1034
    ],
    "source": ""
  },
  {
    "id": 2778,
    "question": "What technique do API developers most commonly use to limit access to an API to authorized individuals and applications?",
    "choice_a": "Encryption",
    "choice_b": "Input validation",
    "choice_c": "API keys",
    "choice_d": "IP filters",
    "correct_answer": "C",
    "explanation": "API developers commonly use API keys to limit access to authorized users and applications. Encryption provides for confidentiality of information exchanged using an API but does not provide authentication. Input validation is an application security technique used to protect against malicious input. IP filters may be used to limit access to an API, but they are not commonly used because it is difficult to deploy an API with IP filters since the filters require constant modification and maintenance as endpoints change.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      627,
      802,
      828,
      893,
      671
    ],
    "source": ""
  },
  {
    "id": 2779,
    "question": "Reggie recently received a letter from his company's internal auditors scheduling the kickoff meeting for an assessment of his group. <br>Which of the following should Reggie not expect to learn during that meeting?",
    "choice_a": "Scope of the audit",
    "choice_b": "Purpose of the audit",
    "choice_c": "Expected timeframe",
    "choice_d": "Expected findings",
    "correct_answer": "D",
    "explanation": "An audit kickoff meeting should clearly describe the scope and purpose of the audit as well as the expected time frame. Auditors should never approach an audit with any expectations about what they will discover because the findings should only be developed based upon the results of audit examinations.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      829,
      831,
      830,
      813,
      1032
    ],
    "source": ""
  },
  {
    "id": 2780,
    "question": "Which one of the following is the proper order of steps in the waterfall model of software development?",
    "choice_a": "Requirements, Design, Testing, Coding, Maintenance",
    "choice_b": "Requirements, Design, Coding, Testing, Maintenance",
    "choice_c": "Design, Requirements, Coding, Testing, Maintenance",
    "choice_d": "Design, Requirements, Testing, Coding, Maintenance",
    "correct_answer": "B",
    "explanation": "In the waterfall model, the software development process follows five sequential steps that are, in order: Requirements, Design, Coding, Testing, and Maintenance.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      640,
      621,
      1034,
      623
    ],
    "source": ""
  },
  {
    "id": 2781,
    "question": "Renee is a software developer who writes code in Node.js for her organization. The company is considering moving from a self-hosted Node.js environment to one where Renee will run her code on application servers managed by a cloud vendor. <br>What type of cloud solution is Renee's company considering?",
    "choice_a": "IaaS",
    "choice_b": "CaaS",
    "choice_c": "PaaS",
    "choice_d": "SaaS",
    "correct_answer": "C",
    "explanation": "In a platform as a service solution, the customer supplies application code that the vendor then executes on its own infrastructure.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      818,
      833
    ],
    "source": ""
  },
  {
    "id": 2782,
    "question": "Tom is writing a software program that calculates the sales tax for online orders placed from various jurisdictions. The application includes a user-defined field that allows the entry of the total sale amount. Tom would like to ensure that the data entered in this field is a properly formatted dollar amount. <br>What technique should he use?",
    "choice_a": "Limit check",
    "choice_b": "Fail open",
    "choice_c": "Fail secure",
    "choice_d": "Input validation",
    "correct_answer": "D",
    "explanation": "Input validation ensures that the data provided to a program as input matches the expected parameters. Limit checks are a special form of input validation that ensure that the value remains within an expected range, but there was no range specified in this scenario. Fail open and fail secure are options when planning for possible system failures.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      620,
      668,
      654,
      672,
      661
    ],
    "source": ""
  },
  {
    "id": 2783,
    "question": "Brian is helping implement a new software testing methodology for his organization and would like to review the completeness of his toolkit. <br>Which of the following would be considered dynamic application security testing (DAST) tools? (Select all that apply.)",
    "choice_a": "Code review",
    "choice_b": "Fuzzing",
    "choice_c": "Static analysis",
    "choice_d": "Web application vulnerability scanning",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Dynamic application security tools conduct their testing by actually executing the code. This is the case for both fuzzing and web application vulnerability scanning. Code reviews and static analysis packages analyze the code itself but do not execute it, making them static application security testing (SAST) tools.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      963,
      962,
      806,
      807,
      622
    ],
    "source": ""
  },
  {
    "id": 2784,
    "question": "What approach to technology management integrates the three components of technology management shown in this illustration? <br><img src=\"/question_assets/CISSP/8_image12.png\"/>",
    "choice_a": "Agile",
    "choice_b": "Lean",
    "choice_c": "DevOps",
    "choice_d": "ITIL",
    "correct_answer": "C",
    "explanation": "The DevOps approach to technology management seeks to integrate software development, operations, and quality assurance in a seamless approach that builds collaboration between the three disciplines.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      832,
      640,
      625,
      833,
      834
    ],
    "source": ""
  },
  {
    "id": 2785,
    "question": "Olivia is conducting a risk analysis of a web application that her organization obtained from a third party and is concerned that it might contain vulnerabilities. <br>Which one of the following activities might she take to best mitigate the risk?",
    "choice_a": "Deploy a WAF.",
    "choice_b": "Implement strong encryption.",
    "choice_c": "Purchase an insurance policy.",
    "choice_d": "Discontinue use of the software.",
    "correct_answer": "A",
    "explanation": "Deploying a web application firewall (WAF) may reduce the likelihood or impact of a web application vulnerability and is, therefore, a good example of risk mitigation. Encryption is also a risk mitigation control, but it is less likely be effective against a web application security flaw. Purchasing an insurance policy is an example of risk transference, not risk mitigation. Discontinuing use of the software is an example of risk avoidance, not risk mitigation.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      669,
      962,
      621,
      662,
      675
    ],
    "source": ""
  },
  {
    "id": 2786,
    "question": "Which one of the following database concurrency issues occurs when one transaction reads information that was written to a database by a second transaction that never committed?",
    "choice_a": "Lost update",
    "choice_b": "SQL injection",
    "choice_c": "Incorrect summary",
    "choice_d": "Dirty read",
    "correct_answer": "D",
    "explanation": "Dirty reads occur when one transaction reads a value from a database that was written by another transaction that did not commit. Lost updates occur when one transaction writes a value to the database that overwrites a value needed by transactions that have earlier precedence, causing those transactions to read an incorrect value. Incorrect summaries occur when one transaction is using an aggregate function to summarize data stored in a database while a second transaction is making modifications to the database, causing the summary to include incorrect information. SQL injection is a web application security flaw, not a database concurrency problem.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      632,
      633,
      634,
      812,
      813
    ],
    "source": ""
  },
  {
    "id": 2787,
    "question": "What software development concept was pioneered by the Defense Department in the 1990s as an effort to bring together diverse product development teams?",
    "choice_a": "Integrated product team",
    "choice_b": "Agile methodology",
    "choice_c": "Scrum approach",
    "choice_d": "User stories",
    "correct_answer": "A",
    "explanation": "The integrated product team (IPT) approach brought together cross-functional teams and was designed by the Defense Department in 1995. It was a predecessor to the Agile methodology, which uses tools like the scrum approach and user stories to conduct software development work.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      983,
      982,
      640,
      622,
      623
    ],
    "source": ""
  },
  {
    "id": 2788,
    "question": "Frank is working to select a new cloud service that will provide object storage for an application being developed by his team. <br>What category of cloud service is Frank planning to use?",
    "choice_a": "SaaS",
    "choice_b": "IaaS",
    "choice_c": "FaaS",
    "choice_d": "PaaS",
    "correct_answer": "B",
    "explanation": "Storage is an infrastructure component and, therefore, an object storage service is an example of an infrastructure as a service (IaaS) cloud service. Software as a service (SaaS) models provide full applications managed by the provider. Platform as a service (PaaS) and function as a service (FaaS) approaches allow developers to run their own code on an infrastructure platform managed by the provider.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      818,
      803,
      833,
      806,
      636
    ],
    "source": ""
  },
  {
    "id": 2789,
    "question": "Lisa is attempting to prevent her network from being targeted by IP spoofing attacks as well as preventing her network from being the source of those attacks. <br>Which of the following rules are best practices that Lisa should configure at her network border?  (Select all that apply.)",
    "choice_a": "Block packets with internal source addresses from entering the network.",
    "choice_b": "Block packets with external source addresses from leaving the network.",
    "choice_c": "Block packets with public IP addresses from entering the network.",
    "choice_d": "Block packets with private IP addresses from exiting the network.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Packets with public IP addresses will routinely be allowed to enter the network, so you should not create a rule to block them, making this the correct answer. Packets with internal source addresses should never originate from outside the network, so they should be blocked from entering the network. Packets with external source addresses should never be found on the internal network, so they should be blocked from leaving the network. Finally, private IP addresses should never be used on the internet, so packets containing private IP addresses should be blocked from leaving the network.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      949,
      425,
      423,
      345,
      408
    ],
    "source": ""
  },
  {
    "id": 2790,
    "question": "Ed has been tasked with identifying a service that will provide a low-latency, high-performance, and high-availability way to host content for his employer. <br>What type of solution should he seek out to ensure that his employer's customers around the world can access their content quickly, easily, and reliably?",
    "choice_a": "A hot site",
    "choice_b": "A CDN",
    "choice_c": "Redundant servers",
    "choice_d": "A P2P CDN",
    "correct_answer": "B",
    "explanation": "A content distribution network (CDN) is designed to provide reliable, low-latency, geographically distributed content distribution. In this scenario, a CDN is an ideal solution. A P2P CDN like BitTorrent isn't a typical choice for a commercial entity, whereas redundant servers or a hot site can provide high availability but won't provide the remaining requirements.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      373,
      405,
      406,
      394,
      376
    ],
    "source": ""
  },
  {
    "id": 2791,
    "question": "Fran is building a forensic analysis workstation and is selecting a forensic disk controller to include in the setup. <br>Which of the following are functions of a forensic disk controller?  (Select all that apply.)",
    "choice_a": "Preventing the modification of data on a storage device",
    "choice_b": "Returning data requested from the device",
    "choice_c": "Reporting errors sent by the device to the forensic host",
    "choice_d": "Blocking read commands sent to the device",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "A forensic disk controller performs four functions. One of those, write blocking, intercepts write commands sent to the device and prevents them from modifying data on the device. The other three functions include returning data requested by a read operation, returning access-significant information from the device, and reporting errors from the device back to the forensic host. The controller should not prevent read commands from being sent to the device because those commands may return crucial information.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      603,
      886,
      602,
      607,
      960
    ],
    "source": ""
  },
  {
    "id": 2792,
    "question": "Mike is building a fault-tolerant server and wants to implement RAID 1. <br>How many physical disks are required to build this solution?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "5",
    "correct_answer": "B",
    "explanation": "RAID 1, disk mirroring, requires two physical disks that will contain copies of the same data.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      576,
      836,
      835,
      837,
      518
    ],
    "source": ""
  },
  {
    "id": 2793,
    "question": "Darren is troubleshooting an authentication issue for a Kerberized application used by his organization. He believes the issue is with the generation of session keys. <br>What Kerberos service should he investigate first?",
    "choice_a": "KDC",
    "choice_b": "TGT",
    "choice_c": "AS",
    "choice_d": "TGS",
    "correct_answer": "D",
    "explanation": "The TGS, or ticket-granting service (which is usually on the same server as the KDC), receives a TGT from the client. It validates the TGT and the user's rights to access the service they are requesting to use. The TGS then issues a ticket and session keys to the client. The AS serves as the authentication server, which forwards the username to the KDC. It's worth noting that the client doesn't communicate with the KDC directly. Instead, it will communicate with the TGT and the AS, which means KDC isn't an appropriate answer here.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      477,
      460,
      441,
      449,
      454
    ],
    "source": ""
  },
  {
    "id": 2794,
    "question": "Evelyn believes that one of her organization's vendors has breached a contractual obligation to protect sensitive data and would like to conduct an investigation into the circumstances. Based upon the results of the investigation, it is likely that Evelyn's organization will sue the vendor for breach of contract. <br>What term best describes the type of investigation that Evelyn is conducting?",
    "choice_a": "Administrative investigation",
    "choice_b": "Criminal investigation",
    "choice_c": "Civil investigation",
    "choice_d": "Regulatory investigation",
    "correct_answer": "C",
    "explanation": "This is an example of a civil investigation because it relates to a contract dispute and will likely wind up being litigated in civil court. Administrative investigations are for internal purposes and are not applicable when a third party is being investigated. Criminal and regulatory investigations may only be initiated by those with regulatory authority, typically government agencies.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      98,
      100,
      116,
      38,
      981
    ],
    "source": ""
  },
  {
    "id": 2795,
    "question": "Ivan is installing a motion detector to protect a sensitive work area that uses high-frequency microwave signal transmissions to identify potential intruders. <br>What type of detector is he installing?",
    "choice_a": "Infrared",
    "choice_b": "Heat-based",
    "choice_c": "Wave pattern",
    "choice_d": "Capacitance",
    "correct_answer": "C",
    "explanation": "Wave pattern motion detectors transmit ultrasonic or microwave signals into the monitor area, watching for changes in the returned signals bouncing off objects. Infrared head-based detectors watch for unusual heat patterns. Capacitance detectors work based upon electromagnetic fields.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 2796,
    "question": "Susan sets up a firewall that keeps track of the status of the communication between two systems and allows a remote system to respond to a local system only after the local system starts communication. <br>What type of firewall is Susan using?",
    "choice_a": "A static packet filtering firewall",
    "choice_b": "An application-level gateway firewall",
    "choice_c": "A stateful packet inspection firewall",
    "choice_d": "A circuit-level gateway firewall",
    "correct_answer": "C",
    "explanation": "Stateful packet inspection firewalls, also known as dynamic packet filtering firewalls, track the state of a conversation and can allow a response from a remote system based on an internal system being allowed to start the communication. Static packet filtering and circuit-level gateways only filter based on source, destination, and ports, whereas application-level gateway firewalls proxy traffic for specific applications.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      375,
      376,
      424,
      412,
      330
    ],
    "source": ""
  },
  {
    "id": 2797,
    "question": "Ben owns a coffeehouse and wants to provide wireless internet service for his customers. Ben's network is simple and uses a single consumer-grade wireless router and a cable modem connected via a commercial cable data contract. <br>How can Ben provide access control for his customers without having to provision user IDs before they connect while also gathering useful contact information for his business purposes?",
    "choice_a": "WPA2 PSK",
    "choice_b": "A captive portal",
    "choice_c": "Require customers to use a publicly posted password like \"BensCoffee\"",
    "choice_d": "WPA3 SAE",
    "correct_answer": "B",
    "explanation": "A captive portal can require those who want to connect to and use WiFi to provide an email address to connect. This allows Ben to provide easy-to-use wireless while meeting his business purposes. WPA2 PSK is the preshared key mode of WPA and won't provide information about users who are given a key. WPA3's SAE mode would be preferable to WPA2 PSK, but it still does not allow for the data gathering Ben desires. Sharing a password doesn't allow for data gathering either.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      367,
      361,
      369,
      388,
      359
    ],
    "source": ""
  },
  {
    "id": 2798,
    "question": "Ben owns a coffeehouse and wants to provide wireless internet service for his customers. Ben's network is simple and uses a single consumer-grade wireless router and a cable modem connected via a commercial cable data contract. <br>Ben intends to run an open (unencrypted) wireless network. <br>How should he connect his business devices?",
    "choice_a": "Run WPA3 on the same SSID.",
    "choice_b": "Set up a separate SSID using WPA3.",
    "choice_c": "Run the open network in Enterprise mode.",
    "choice_d": "Set up a separate wireless network using WEP.",
    "correct_answer": "B",
    "explanation": "Many modern wireless routers can provide multiple SSIDs. Ben can create a private, secure network for his business operations, but he will need to make sure that the customer and business networks are firewalled or otherwise logically separated from each other. Running WPA3 on the same SSID isn't possible without creating another wireless network and would cause confusion for customers (SSIDs aren't required to be unique). Running a network in Enterprise mode isn't used for open networks, and WEP is outdated and incredibly vulnerable.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      360,
      361,
      369,
      388,
      392
    ],
    "source": ""
  },
  {
    "id": 2799,
    "question": "Ben owns a coffeehouse and wants to provide wireless internet service for his customers. Ben's network is simple and uses a single consumer-grade wireless router and a cable modem connected via a commercial cable data contract. <br>After implementing the solution from the first question, Ben receives a complaint about users in his cafe hijacking other customers' web traffic, including using their usernames and passwords. <br>How is this possible?",
    "choice_a": "The password is shared by all users, making traffic vulnerable.",
    "choice_b": "A malicious user has installed a Trojan on the router.",
    "choice_c": "A user has ARP spoofed the router, making all traffic broadcast to all users.",
    "choice_d": "Open networks are unencrypted, making traffic easily sniffable.",
    "correct_answer": "D",
    "explanation": "Unencrypted open networks broadcast traffic in the clear. This means that unencrypted sessions to websites can be easily captured with a packet sniffer. Some tools like FireSheep have been specifically designed to capture sessions from popular websites. Fortunately, many now use TLS by default, but other sites still send user session information in the clear. Shared passwords are not the cause of the vulnerability, ARP spoofing isn't an issue with wireless networks, and a Trojan is designed to look like safe software, not to compromise a router.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      334,
      362,
      389,
      370,
      367
    ],
    "source": ""
  },
  {
    "id": 2800,
    "question": "Kevin is reviewing and updating the security documentation used by his organization. He would like to document some best practices for securing IoT devices that his team has developed over the past year. The practices are generalized in nature and do not cover specific devices. <br>What type of document would be best for this purpose?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "C",
    "explanation": "It is possible that Kevin could use any one of these documents. We should zero in on the portion of the question where it indicates that these are best practices. This implies that the advice is not mandatory and, therefore, would not go into a policy or standard. The fact that the advice is general in nature means that it is likely not well-suited to the step-by-step nature of a procedure. A guideline would be the perfect place to document these best practices.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      11,
      15,
      40,
      65,
      67
    ],
    "source": ""
  },
  {
    "id": 2801,
    "question": "Tom is tuning his security monitoring tools in an attempt to reduce the number of alerts received by administrators without missing important security events. He decides to configure the system to only report failed login attempts if there are five failed attempts to access the same account within a one-hour period of time. <br>What term best describes the technique that Tom is using?",
    "choice_a": "Thresholding",
    "choice_b": "Sampling",
    "choice_c": "Account lockout",
    "choice_d": "Clipping",
    "correct_answer": "D",
    "explanation": "Clipping is an analysis technique that only reports alerts after they exceed a set threshold. It is a specific form of sampling, which is a more general term that describes any attempt to excerpt records for review. Thresholding is not a commonly used term. Administrators may choose to configure automatic or manual account lockout after failed login attempts, but that is not described in the scenario.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      558,
      891,
      841,
      556,
      506
    ],
    "source": ""
  },
  {
    "id": 2802,
    "question": "Sally has been tasked with deploying an authentication, authorization, and accounting server for wireless network services in her organization and needs to avoid using proprietary technology. <br>What technology should she select?",
    "choice_a": "OAuth",
    "choice_b": "RADIUS",
    "choice_c": "XTACACS",
    "choice_d": "TACACS+",
    "correct_answer": "B",
    "explanation": "RADIUS is a common AAA technology used to provide services for dial-up, wireless networks, network devices, and a range of other systems. OAuth is an authentication protocol used to allow applications to act on a user's behalf without sharing the password and is used for many web applications. While both XTACACS and TACACS+ provide the functionality Sally is looking for, both are Cisco proprietary protocols.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      479,
      441,
      492,
      451,
      476
    ],
    "source": ""
  },
  {
    "id": 2803,
    "question": "An accounting clerk for Christopher's Cheesecakes does not have access to the salary information for individual employees but wanted to know the salary of a new hire. He pulled total payroll expenses for the pay period before the new person was hired and then pulled the same expenses for the following pay period. He computed the difference between those two amounts to determine the individual's salary. <br>What type of attack occurred?",
    "choice_a": "Salami slicing",
    "choice_b": "Data diddling",
    "choice_c": "Inference",
    "choice_d": "Social engineering",
    "correct_answer": "C",
    "explanation": "In an inference attack, the attacker uses several pieces of generic nonsensitive information to determine a specific sensitive value. In a salami slicing attack, the attacker siphons off minute quantities of money many times to accumulate a large amount of funds. In a data diddling attack, the attacker alters the contents of a database. Social engineering attacks exploit human psychology to achieve their goals.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      42,
      4,
      55,
      61,
      9
    ],
    "source": ""
  },
  {
    "id": 2804,
    "question": "Alice would like to have read permissions on an object and knows that Bob already has those rights and would like to give them to herself. <br>Which one of the rules in the Take-Grant protection model would allow her to complete this operation if the relationship exists between Alice and Bob?",
    "choice_a": "Take rule",
    "choice_b": "Grant rule",
    "choice_c": "Create rule",
    "choice_d": "Remote rule",
    "correct_answer": "A",
    "explanation": "The take rule allows a subject to take the rights belonging to another object. If Alice has take rights on Bob, she can give herself the same permissions that Bob already possesses.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      218,
      228,
      217,
      219,
      201
    ],
    "source": ""
  },
  {
    "id": 2805,
    "question": "During a log review, Danielle discovers a series of logs that show login failures: <br><img src=\"/question_assets/CISSP/9_image12.png\"/><br>What type of attack has Danielle discovered?",
    "choice_a": "A pass-the-hash attack",
    "choice_b": "A brute-force attack",
    "choice_c": "A man-in-the-middle attack",
    "choice_d": "A dictionary attack",
    "correct_answer": "B",
    "explanation": "Brute-force attacks try every possible password. In this attack, the password is changing by one letter at each attempt, which indicates that it is a brute-force attack. A dictionary attack would use dictionary words for the attack, whereas a man-in-the-middle or pass-the-hash attack would most likely not be visible in an authentication log except as a successful login.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      193,
      994,
      199,
      197,
      195
    ],
    "source": ""
  },
  {
    "id": 2806,
    "question": "Ben is designing a database-driven application and would like to ensure that two executing transactions do not affect each other by storing interim results in the database. <br>What property is he seeking to enforce?",
    "choice_a": "Atomicity",
    "choice_b": "Isolation",
    "choice_c": "Consistency",
    "choice_d": "Durability",
    "correct_answer": "B",
    "explanation": "Isolation requires that transactions operate separately from each other. Atomicity ensures that if any part of a database transaction fails, the entire transaction must be rolled back as if it never occurred. Consistency ensures that all transactions are consistent with the logical rules of the database, such as having a primary key. Durability requires that once a transaction is committed to the database it must be preserved. Together, these properties make up the ACID model.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      632,
      811,
      633,
      813,
      840
    ],
    "source": ""
  },
  {
    "id": 2807,
    "question": "Kim is the system administrator for a small business network that is experiencing security problems. She is in the office in the evening working on the problem, and nobody else is there. As she is watching, she can see that systems on the other side of the office that were previously behaving normally are now exhibiting signs of infection one after the other. <br>What type of malware is Kim likely dealing with?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Trojan horse",
    "choice_d": "Logic bomb",
    "correct_answer": "B",
    "explanation": "Worms have built-in propagation mechanisms that do not require user interaction, such as scanning for systems containing known vulnerabilities and then exploiting those vulnerabilities to gain access. Viruses and Trojan horses typically require user interaction to spread. Logic bombs do not spread from system to system but lie in wait until certain conditions are met, triggering the delivery of their payload.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      646,
      643,
      648,
      642,
      653
    ],
    "source": ""
  },
  {
    "id": 2808,
    "question": "Barb is reviewing the compliance obligations facing her organization and the types of liability that each one might incur. <br>Which of the following laws and regulations may involve criminal penalties if violated?  (Select all that apply.)",
    "choice_a": "FERPA",
    "choice_b": "HIPAA",
    "choice_c": "SOX",
    "choice_d": "PCI DSS",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) is a U.S. law governing the healthcare sector that does provide for criminal penalties. The Sarbanes\u2013Oxley (SOX) Act governs publicly traded corporations and also provides for criminal penalties. The Family Educational Rights and Privacy Act (FERPA) is a U.S. law governing educational records, but it does not provide for criminal penalties. PCI DSS, the Payment Card Industry Data Security Standard, is an industry standard for credit card operations and handling. Because it is not a law, PCI DSS violations cannot incur criminal sanctions.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      100,
      105,
      99,
      117,
      107
    ],
    "source": ""
  },
  {
    "id": 2809,
    "question": "Quentin is analyzing network traffic that he collected with Wireshark on a TCP/IP network. He would like to identify all new connections that were set up during his traffic collection. If he is looking for the three packets that constitute the TCP three-way handshake used to establish a new connection, what flags should be set on the first three packets?",
    "choice_a": "SYN, ACK, SYN/ACK",
    "choice_b": "PSH, RST, ACK",
    "choice_c": "SYN, SYN/ACK, ACK",
    "choice_d": "SYN, RST, FIN",
    "correct_answer": "C",
    "explanation": "The TCP three-way handshake consists of initial contact via a SYN, or synchronize flagged packet; which receives a response with a SYN/ACK, or synchronize and acknowledge flagged packet; which is acknowledged by the original sender with an ACK, or acknowledge packet. RST is used in TCP to reset a connection, PSH is used to send data immediately, and FIN is used to end a connection.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      883,
      869,
      724,
      725,
      337
    ],
    "source": ""
  },
  {
    "id": 2810,
    "question": "Daniel is selecting a new mobile device management (MDM) solution for his organization and is writing the RFP. He is trying to decide what features he should include as requirements after aligning his organization's security needs with an MDM platform's capabilities. <br>Which of the following are typical capabilities of MDM solutions?  (Select all that apply.)",
    "choice_a": "Remotely wiping the contents of a mobile device",
    "choice_b": "Assuming control of a nonregistered BYOD mobile device",
    "choice_c": "Enforcing the use of device encryption",
    "choice_d": "Managing device backups",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "MDM products do not have the capability of assuming control of a device not currently managed by the organization. This would be equivalent to hacking into a device owned by someone else and might constitute a crime. They do normally provide the ability to manage device backups, enforce the use of encryption, and remotely wipe the contents of mobile devices.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      120,
      144,
      125,
      143,
      856
    ],
    "source": ""
  },
  {
    "id": 2811,
    "question": "Jim is implementing an IDaaS solution for his organization. <br>What type of technology is he putting in place?",
    "choice_a": "Identity as a service",
    "choice_b": "Employee ID as a service",
    "choice_c": "Intrusion detection as a service",
    "choice_d": "OAuth",
    "correct_answer": "A",
    "explanation": "Identity as a service (IDaaS) provides an identity platform as a third-party service. This can provide benefits, including integration with cloud services and removing overhead for maintenance of traditional on-premises identity systems, but can also create risk due to third-party control of identity services and reliance on an off-site identity infrastructure.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      453,
      452,
      451,
      461,
      460
    ],
    "source": ""
  },
  {
    "id": 2812,
    "question": "Gina recently took the CISSP certification exam and then wrote a blog post that included the text of many of the exam questions that she experienced. <br>What aspect of the ISC2 Code of Ethics is most directly violated in this situation?",
    "choice_a": "Advance and protect the profession.",
    "choice_b": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_c": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_d": "Provide diligent and competent service to principals.",
    "correct_answer": "A",
    "explanation": "Gina's actions harm the CISSP certification and information security community by undermining the integrity of the examination process. While Gina also is acting dishonestly, the harm to the profession is more of a direct violation of the ISC2 Code of Ethics.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      955,
      957,
      956,
      65,
      14
    ],
    "source": ""
  },
  {
    "id": 2813,
    "question": "Gordon is conducting a risk assessment for his organization and determined the amount of damage that flooding is expected to cause to his facilities each year. <br>What metric has Gordon identified?",
    "choice_a": "ALE",
    "choice_b": "ARO",
    "choice_c": "SLE",
    "choice_d": "EF",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy (ALE) is the amount of damage that the organization expects to occur each year as the result of a given risk.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      86,
      934,
      695,
      87,
      41
    ],
    "source": ""
  },
  {
    "id": 2814,
    "question": "Greg would like to implement application control technology in his organization. He would like to limit users to installing only approved software on their systems. <br>What type of application control would be appropriate in this situation?",
    "choice_a": "Blacklisting",
    "choice_b": "Graylisting",
    "choice_c": "Whitelisting",
    "choice_d": "Bluelisting",
    "correct_answer": "C",
    "explanation": "The whitelisting approach to application control allows users to install only those software packages specifically approved by administrators. This would be an appropriate approach in a scenario where application installation needs to be tightly controlled.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      379,
      375,
      419,
      430,
      392
    ],
    "source": ""
  },
  {
    "id": 2815,
    "question": "Frank is the security administrator for a web server that provides news and information to people located around the world. His server received an unusually high volume of traffic that it could not handle and was forced to reject requests. Frank traced the source of the traffic back to a botnet. <br>What type of attack took place?",
    "choice_a": "Denial-of-service",
    "choice_b": "Reconnaissance",
    "choice_c": "Compromise",
    "choice_d": "Malicious insider",
    "correct_answer": "A",
    "explanation": "This is a clear example of a denial-of-service attack\u2014denying legitimate users authorized access to the system through the use of overwhelming traffic. It goes beyond a reconnaissance attack because the attacker is affecting the system, but it is not a compromise because the attacker did not attempt to gain access to the system. There is no reason to believe that a malicious insider was involved.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      567,
      608,
      563,
      544,
      511
    ],
    "source": ""
  },
  {
    "id": 2816,
    "question": "In the database table shown here, which column would be the best candidate for a primary key? <br><img src=\"/question_assets/CISSP/9_image1.png\"/>",
    "choice_a": "Company ID",
    "choice_b": "Company Name",
    "choice_c": "ZIP Code",
    "choice_d": "Sales Rep",
    "correct_answer": "A",
    "explanation": "The Company ID column is likely unique for each row in the table, making it the best choice for a primary key. There may be multiple companies that share the same name or ZIP code. Similarly, a single sales representative likely serves more than one company, making those fields unsuitable for use as a unique identifier.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      838,
      839,
      840,
      630,
      966
    ],
    "source": ""
  },
  {
    "id": 2817,
    "question": "Gwen is a cybersecurity professional for a financial services firm that maintains records of their customers. These records include personal information about each customer, including the customer's name, Social Security number, date and place of birth, and mother's maiden name. <br>What category best describes these records?",
    "choice_a": "PHI",
    "choice_b": "Proprietary data",
    "choice_c": "PII",
    "choice_d": "EDI",
    "correct_answer": "C",
    "explanation": "Personally identifiable information (PII) includes data that can be used to distinguish or trace that person's identity and also includes information like their medical, educational, financial, and employment information. PHI is personal health information, EDI is electronic data interchange, and proprietary data is used to maintain an organization's competitive advantage.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      106,
      108,
      4,
      109,
      3
    ],
    "source": ""
  },
  {
    "id": 2818,
    "question": "Bob is configuring egress filtering on his network, examining traffic destined for the internet. His organization uses the public address range 12.8.195.0/24. Packets with which one of the following destination addresses should Bob permit to leave the network?",
    "choice_a": "12.8.195.15",
    "choice_b": "10.8.15.9",
    "choice_c": "192.168.109.55",
    "choice_d": "129.53.44.124",
    "correct_answer": "D",
    "explanation": "129.53.44.124 is a valid public IP address and a legitimate destination for traffic leaving Bob's network. 12.8.195.15 is a public address on Bob's network and should not be a destination address on a packet leaving the network. 10.8.15.9 and 192.168.109.55 are both private IP addresses that should not be routed to the internet.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      559,
      535,
      526,
      560,
      556
    ],
    "source": ""
  },
  {
    "id": 2819,
    "question": "Brian is considering increasing the length of the cryptographic keys used by his organization. If he adds 8 bits to the encryption key, how many more possible keys will be added to the keyspace for the algorithm?",
    "choice_a": "The size of the keyspace will double.",
    "choice_b": "The size of the keyspace will increase by a factor of 8.",
    "choice_c": "The size of the keyspace will increase by a factor of 64.",
    "choice_d": "The size of the keyspace will increase by a factor of 256.",
    "correct_answer": "D",
    "explanation": "Binary keyspaces contain a number of keys equal to 2 raised to the power of the number of bits. Two to the eighth power is 256, so the keyspace will increase by a factor of 256.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      152,
      146,
      171,
      147,
      151
    ],
    "source": ""
  },
  {
    "id": 2820,
    "question": "Which of the following data assets may be safely and effectively disposed of using shredding?  (Select all that apply.)",
    "choice_a": "Paper records",
    "choice_b": "Credit cards",
    "choice_c": "Removable media",
    "choice_d": "SSD hard drives",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "Traditional office shredding machines may be used for the disposal of paper records and, depending upon their grade, may also be able to shred credit cards. Industrial shredders are capable of destroying larger pieces of equipment, including removable media and hard drives.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      129,
      130,
      133,
      125,
      850
    ],
    "source": ""
  },
  {
    "id": 2821,
    "question": "GAD Systems is concerned about the risk of hackers stealing sensitive information stored on a file server. They choose to pursue a risk mitigation strategy. <br>Which one of the following actions would support that strategy?",
    "choice_a": "Encrypting the files",
    "choice_b": "Deleting the files",
    "choice_c": "Purchasing cyber-liability insurance",
    "choice_d": "Taking no action",
    "correct_answer": "A",
    "explanation": "Encrypting the files reduces the probability that the data will be successfully stolen, so it is an example of risk mitigation. Deleting the files would be risk avoidance. Purchasing insurance would be risk transference. Taking no action would be risk acceptance.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      124,
      122,
      144,
      125,
      702
    ],
    "source": ""
  },
  {
    "id": 2822,
    "question": "Viola is conducting a user account audit to determine whether accounts have the appropriate level of permissions and that all permissions were approved through a formal process. The organization has approximately 50,000 user accounts and an annual employee turnover rate of 24 percent. <br>Which one of the following sampling approaches would be the most effective use of her time when choosing records for manual review?",
    "choice_a": "Select all records that have been modified during the past month.",
    "choice_b": "Ask access administrators to identify the accounts most likely to have issues and audit those.",
    "choice_c": "Select a random sample of records, either from the entire population or from the population of records that have changed during the audit period.",
    "choice_d": "Sampling is not effective in this situation, and all accounts should be audited.",
    "correct_answer": "C",
    "explanation": "Sampling should be done randomly to avoid human bias. Sampling is an effective process if it is done on a truly random sample of sufficient size to provide effective coverage of the userbase. It is infeasible for a single person to review every single record. In an organization of 50,000 users with a 24 percent annual turnover, it is likely that at least 1,000 of those records have changed in the last month. This is still too many records to review. Asking account administrators to select the records to review is a conflict of interest, as they are the group being audited.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      499,
      1007,
      862,
      502,
      498
    ],
    "source": ""
  },
  {
    "id": 2823,
    "question": "Lila is reviewing her organization's adverse termination process. In that process, when would be the most appropriate time to revoke a user's access privileges to digital systems?",
    "choice_a": "At the time the user is informed of the termination",
    "choice_b": "At the end of the last day of employment",
    "choice_c": "At the time the decision is made",
    "choice_d": "Several days after the last day of employment",
    "correct_answer": "A",
    "explanation": "In the case of an involuntary termination under adverse circumstances, the user is being fired and may have a negative and potentially hostile reaction. For this reason, it is important to terminate access immediately upon the user being informed of the termination. Terminating access prior to notification may tip the user off to the termination in advance. Leaving access privileges available after termination poses a risk of malicious insider activity.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      37,
      68,
      36,
      69,
      33
    ],
    "source": ""
  },
  {
    "id": 2824,
    "question": "William is reviewing log files that were stored on a system with a suspected compromise. He finds the log file shown here. <br><img src=\"/question_assets/CISSP/9_image2.png\"/><br>What type of log file is this?",
    "choice_a": "Firewall log",
    "choice_b": "Change log",
    "choice_c": "Application log",
    "choice_d": "System log",
    "correct_answer": "C",
    "explanation": "The file clearly shows HTTP requests, as evidenced by the many GET commands. Therefore, this is an example of an application log from an HTTP server.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      842,
      841,
      557,
      558,
      606
    ],
    "source": ""
  },
  {
    "id": 2825,
    "question": "Roger is reviewing a list of security vulnerabilities in his organization and rating them based upon their severity. <br>Which one of the following models would be most useful to his work?",
    "choice_a": "CVSS",
    "choice_b": "STRIDE",
    "choice_c": "PASTA",
    "choice_d": "ATT&CK",
    "correct_answer": "A",
    "explanation": "The Common Vulnerability Scoring System (CVSS) is a standardized approach to rating the severity of vulnerabilities and would be the most helpful tool for Roger's work. The STRIDE and ATT&CK models are used to classify the nature, not the severity, of threats. The PASTA model is designed to help with countermeasure selection.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      26,
      24,
      23,
      2,
      48
    ],
    "source": ""
  },
  {
    "id": 2826,
    "question": "An attacker recently called an organization's help desk and persuaded them to reset a password for another user's account. <br>What term best describes this attack?",
    "choice_a": "A human Trojan",
    "choice_b": "Social engineering",
    "choice_c": "Phishing",
    "choice_d": "Whaling",
    "correct_answer": "B",
    "explanation": "Social engineering exploits humans to allow attacks to succeed. Since help-desk employees are specifically tasked with being helpful, they may be targeted by attackers posing as legitimate employees. Trojans are a type of malware, whereas phishing is a targeted attack via electronic communication methods intended to capture passwords or other sensitive data. Whaling is a type of phishing aimed at high-profile or important targets.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      55,
      60,
      56,
      71,
      61
    ],
    "source": ""
  },
  {
    "id": 2827,
    "question": "Greg is evaluating a new vendor that will be supplying networking gear to his organization. Due to the nature of his organization's work, Greg is concerned that an attacker might attempt a supply chain exploit. Assuming that both Greg's organization and the vendor operate under reasonable security procedures, which one of the following activities likely poses the greatest supply chain risk to the equipment?",
    "choice_a": "Tampering by an unauthorized third party at the vendor's site",
    "choice_b": "Interception of devices in transit",
    "choice_c": "Misconfiguration by an administrator after installation",
    "choice_d": "Tampering by an unauthorized third party at Greg's site",
    "correct_answer": "B",
    "explanation": "If the vendor operates with reasonable security procedures, it is unlikely that the devices will be tampered with at the vendor's site. Similarly, if Greg's organization has reasonable security procedures, tampering at his site is also unlikely. Misconfiguration by an administrator is always possible, but this is a post-installation risk and not a supply chain risk. It is possible that devices will be intercepted and tampered with while in transit from the vendor to Greg's organization.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      28,
      27,
      29,
      38,
      116
    ],
    "source": ""
  },
  {
    "id": 2828,
    "question": "Kevin is operating in a single-level security environment and is seeking to classify information systems according to the type of information that they process. <br>What procedure would be the best way for him to assign asset classifications?",
    "choice_a": "Assign systems the classification of information that they most commonly process.",
    "choice_b": "Assign systems the classification of the highest level of information that they are expected to process regularly.",
    "choice_c": "Assign systems the classification of the highest level of information that they are ever expected to process.",
    "choice_d": "Assign all systems the same classification level.",
    "correct_answer": "C",
    "explanation": "In a single-level security environment, systems should be assigned the classification level of the highest classification of information they are ever expected to process. Systems may not process information that is above their classification level without reclassifying the system upwards.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      123,
      143,
      121,
      124,
      697
    ],
    "source": ""
  },
  {
    "id": 2829,
    "question": "The organization that Ben works for has a traditional onsite Active Directory environment that uses a manual provisioning process for each addition to their 350-employee company. As the company adopts new technologies, they are increasingly using software as a service applications to replace their internally developed software stack. <br>Ben has been tasked with designing an identity management implementation that will allow his company to use cloud services while supporting their existing systems. Using the logical diagram shown here, answer the following questions about the identity recommendations Ben should make. <br><img src=\"/question_assets/CISSP/9_image3.png\"/><br>If availability of authentication services is the organization's biggest priority, what type of identity platform should Ben recommend?",
    "choice_a": "On-site",
    "choice_b": "Cloud-based",
    "choice_c": "Hybrid",
    "choice_d": "Outsourced",
    "correct_answer": "C",
    "explanation": "A hybrid authentication service can provide authentication services both in the cloud and on-premises, ensuring that service outages due to interrupted links are minimized. An on-site service would continue to work during an internet outage but would not allow the e-commerce website to authenticate. A cloud service would leave the corporate location offline. Outsourcing authentication does not indicate whether the solution is on- or off-premises and thus isn't a useful answer.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      452,
      453,
      451,
      474,
      1017
    ],
    "source": ""
  },
  {
    "id": 2830,
    "question": "The organization that Ben works for has a traditional onsite Active Directory environment that uses a manual provisioning process for each addition to their 350-employee company. As the company adopts new technologies, they are increasingly using software as a service applications to replace their internally developed software stack. <br>Ben has been tasked with designing an identity management implementation that will allow his company to use cloud services while supporting their existing systems. Using the logical diagram shown here, answer the following questions about the identity recommendations Ben should make. <br><img src=\"/question_assets/CISSP/9_image3.png\"/><br>If Ben needs to share identity information with the business partner shown, what should he investigate?",
    "choice_a": "Single sign-on",
    "choice_b": "Multifactor authentication",
    "choice_c": "Federation",
    "choice_d": "IDaaS",
    "correct_answer": "C",
    "explanation": "Federation links identity information between multiple organizations. Federating with a business partner can allow identification and authorization to occur between them, making integration much easier. Single sign-on would reduce the number of times a user has to log in but will not facilitate the sharing of identity information. Multifactor can help secure authentication, but again doesn't help integrate with a third party. Finally, an identity as a service provider might provide federation but doesn't guarantee it.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      474,
      480,
      452,
      451,
      460
    ],
    "source": ""
  },
  {
    "id": 2831,
    "question": "The organization that Ben works for has a traditional onsite Active Directory environment that uses a manual provisioning process for each addition to their 350-employee company. As the company adopts new technologies, they are increasingly using software as a service applications to replace their internally developed software stack. <br>Ben has been tasked with designing an identity management implementation that will allow his company to use cloud services while supporting their existing systems. Using the logical diagram shown here, answer the following questions about the identity recommendations Ben should make. <br><img src=\"/question_assets/CISSP/9_image3.png\"/><br>What technology is likely to be involved when Ben's organization needs to provide authentication and authorization assertions to their cloud e-commerce application?",
    "choice_a": "Active Directory",
    "choice_b": "SAML",
    "choice_c": "RADIUS",
    "choice_d": "SPML",
    "correct_answer": "B",
    "explanation": "Security Assertion Markup Language (SAML) is frequently used to integrate cloud services and provides the ability to make authentication and authorization assertions. Active Directory integrations are possible but are less common for cloud service providers, and RADIUS is not typically used for integrations like this. Service Provisioning Markup Language (SPML) is used to provision users, resources, and services, not for authentication and authorization.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      474,
      476,
      481,
      451,
      1020
    ],
    "source": ""
  },
  {
    "id": 2832,
    "question": "Dave is responsible for password security in his organization and would like to strengthen the security of password files. He would like to defend his organization against the use of rainbow tables. <br>Which one of the following techniques is specifically designed to frustrate the use of rainbow tables?",
    "choice_a": "Password expiration policies",
    "choice_b": "Salting",
    "choice_c": "User education",
    "choice_d": "Password complexity policies",
    "correct_answer": "B",
    "explanation": "Rainbow tables use precomputed password hashes to conduct cracking attacks against password files. They may be frustrated by the use of salting, which adds a specified value to the password prior to hashing, making it much more difficult to perform precomputation. Password expiration policies, password complexity policies, and user education may all contribute to password security, but they are not direct defenses against the use of rainbow tables.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      486,
      1058,
      485,
      489,
      845
    ],
    "source": ""
  },
  {
    "id": 2833,
    "question": "Helen recently built a new system as part of her organization's deception campaign. The system is configured in a manner that makes it vulnerable to attack and that conveys that it might contain highly sensitive information. <br>What term best describes this system?",
    "choice_a": "Honeynet",
    "choice_b": "Darknet",
    "choice_c": "Honeypot",
    "choice_d": "Pseudoflaw",
    "correct_answer": "C",
    "explanation": "A honeypot is a decoy computer system used to bait intruders into attacking. A honeynet is a network of multiple honeypots that creates a more sophisticated environment for intruders to explore. A pseudoflaw is a false vulnerability in a system that may attract an attacker. A darknet is a segment of unused network address space that should have no network activity and, therefore, may be easily used to monitor for illicit activity.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      549,
      566,
      523,
      524,
      511
    ],
    "source": ""
  },
  {
    "id": 2834,
    "question": "Nandi is evaluating a set of candidate systems to replace a biometric authentication mechanism in her organization. <br>What metric would be the best way to compare the effectiveness of the different systems?",
    "choice_a": "FAR",
    "choice_b": "FRR",
    "choice_c": "CER",
    "choice_d": "FDR",
    "correct_answer": "C",
    "explanation": "The false acceptance rate (FAR) is the rate at which the system inadvertently admits an unauthorized user, while the false rejection rate (FRR) is the rate at which the system inadvertently rejects an authorized user. Both the FAR and FRR may be modified by adjusting the sensitivity of the system. The crossover error rate (CER) is the point where both the false acceptance rate and the false rejection rate cross. The CER is less subject to manipulation and is, therefore, the best metric to use for evaluating systems. The FDR is not a metric used to evaluate authentication systems.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      445,
      459,
      750,
      446,
      441
    ],
    "source": ""
  },
  {
    "id": 2835,
    "question": "Sean suspects that an individual in his company is smuggling out secret information despite his company's careful use of data loss prevention systems. He discovers that the suspect is posting photos, including the one shown here, to public internet message boards. <br>What type of technique may the individuals be using to hide messages inside this image? <br><img src=\"/question_assets/CISSP/9_image4.png\"/>",
    "choice_a": "Watermarking",
    "choice_b": "VPN",
    "choice_c": "Steganography",
    "choice_d": "Covert timing channel",
    "correct_answer": "C",
    "explanation": "Steganography is the art of using cryptographic techniques to embed secret messages within other content. Steganographic algorithms work by making invisible alterations to files, such as modifying the least significant bits of the many bits that make up image files. VPNs may be used to obscure secret communications, but they provide protection in transit and can't be used to embed information in an image. Watermarking does embed information in an image but with the intent of protecting intellectual property. A still image would not be used for a covert timing channel because it is a fixed file.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      188,
      293,
      145,
      216,
      151
    ],
    "source": ""
  },
  {
    "id": 2836,
    "question": "Roger is concerned that a third-party firm hired to develop code for an internal application will embed a backdoor in the code. The developer retains rights to the intellectual property and will only deliver the software in its final form. <br>Which one of the following languages would be least susceptible to this type of attack because it would provide Roger with code that is human-readable in its final form?",
    "choice_a": "JavaScript",
    "choice_b": "C",
    "choice_c": "C++",
    "choice_d": "Java",
    "correct_answer": "A",
    "explanation": "JavaScript is an interpreted language so the code is not compiled prior to execution, allowing Roger to inspect the contents of the code. C, C++, and Java are all compiled languages\u2014a compiler produces an executable file that is not human-readable.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      617,
      656,
      670,
      621,
      628
    ],
    "source": ""
  },
  {
    "id": 2837,
    "question": "Jesse is looking at the <code>/etc/passwd</code> file on a system configured to use shadowed passwords. <br>What should she expect to see in the password field of this file?",
    "choice_a": "Plaintext passwords",
    "choice_b": "Encrypted passwords",
    "choice_c": "Hashed passwords",
    "choice_d": "X",
    "correct_answer": "D",
    "explanation": "When a system is configured to use shadowed passwords, the <code>/etc/passwd</code> file contains only the character x in the place of a password. It would not contain any passwords, in either plaintext, encrypted, or hashed form.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      844,
      447,
      486,
      453,
      846
    ],
    "source": ""
  },
  {
    "id": 2838,
    "question": "Rob recently received a notice from a vendor that the EOL date is approaching for a firewall platform that is used in his organization. <br>What action should Rob take?",
    "choice_a": "Prepare to discontinue use of the platform as soon as possible.",
    "choice_b": "Immediately discontinue use of the device.",
    "choice_c": "Prepare to discontinue use of the device as part of the organization's normal planning cycle.",
    "choice_d": "No action is necessary.",
    "correct_answer": "C",
    "explanation": "The end-of-life (EOL) date for a product is normally the date that the vendor will stop selling a product. It is reasonable to continue using the product as long as support remains available. Rob should begin making plans to discontinue use of the product, pending the announcement of an end-of-support (EOS) date.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      877,
      847,
      849,
      133,
      879
    ],
    "source": ""
  },
  {
    "id": 2839,
    "question": "What principle states that an individual should make every effort to complete his or her responsibilities in an accurate and timely manner?",
    "choice_a": "Least privilege",
    "choice_b": "Separation of duties",
    "choice_c": "Due care",
    "choice_d": "Due diligence",
    "correct_answer": "D",
    "explanation": "The due care principle states that an individual should react in a situation using the same level of care that would be expected from any reasonable person. It is a very broad standard. The due diligence principle is a more specific component of due care that states that an individual assigned a responsibility should exercise due care to complete it accurately and in a timely manner. Least privilege says that an individual should have the minimum set of permissions necessary to carry out their work. Separation of duties says that no single person should have the right to perform two distinct tasks, which, when combined, constitute a highly privileged action.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      20,
      32,
      33,
      15,
      11
    ],
    "source": ""
  },
  {
    "id": 2840,
    "question": "Tony is developing a data classification system for his organization. <br>What factor should he use as the primary driver when determining the classification level of each category of information?",
    "choice_a": "Sensitivity",
    "choice_b": "Source",
    "choice_c": "Likelihood of theft",
    "choice_d": "Likelihood of data loss",
    "correct_answer": "A",
    "explanation": "Information should be classified based upon its sensitivity. This may be due to the value of the information to the organization, the damage caused if lost or compromised, or other factors. The source of the information is one possible contributing factor to the sensitivity level. The likelihood of loss or theft is a component of risk, but does not contribute to the classification level.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      143,
      121,
      120,
      124,
      123
    ],
    "source": ""
  },
  {
    "id": 2841,
    "question": "Perry is establishing information handling requirements for his organization. He discovers that the organization often needs to send sensitive information over the internet to a supplier and is concerned about it being intercepted. <br>What handling requirement would best protect against this risk?",
    "choice_a": "Require the use of transport encryption.",
    "choice_b": "Require proper classification and labeling.",
    "choice_c": "Require the use of data loss prevention technology.",
    "choice_d": "Require the use of storage encryption.",
    "correct_answer": "A",
    "explanation": "All of these controls are good practices for protecting sensitive information. However, Perry is most concerned about the risk of interception while in transit over the internet. Transport encryption would, therefore, be the most appropriate control, as anyone intercepting the information would be unable to read its contents. Storage encryption would protect against the theft of information at rest, rather than in transit over a network. Classification and labeling would not protect against interception. Data loss prevention technology may block the transfer entirely and would not meet the business requirement if it blocked the transmission and would not meet the security requirement if it did not detect the data transfer.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      190,
      225,
      145,
      152,
      211
    ],
    "source": ""
  },
  {
    "id": 2842,
    "question": "John is developing a tangible asset inventory for his organization. <br>Which of the following items would most likely be included in this inventory?  (Select all that apply.)",
    "choice_a": "Intellectual property",
    "choice_b": "Server hardware",
    "choice_c": "Files stored on servers",
    "choice_d": "Mobile devices",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Tangible asset inventories include physical items owned by the organization. This would include server hardware and mobile devices. Intellectual property and files stored on a server are not tangible property and would instead be included in an intangible asset inventory.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      123,
      849,
      128,
      143,
      124
    ],
    "source": ""
  },
  {
    "id": 2843,
    "question": "Maria is analyzing a security incident where she believes that an attacker gained access to a fiber-optic cable and installed a tap on that cable. <br>What layer of the OSI model did this attack occur at?",
    "choice_a": "Transport",
    "choice_b": "Network",
    "choice_c": "Data Link",
    "choice_d": "Physical",
    "correct_answer": "D",
    "explanation": "The Physical layer deals with the electrical impulses or optical pulses that are sent as bits to convey data. This is the layer where cable tapping would occur. Attacks at the Data Link, Network, or Transport layers would involve higher levels of activity in the OSI model, such as compromising a device and using a protocol analyzer to sniff network traffic.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      330,
      742,
      389,
      743,
      378
    ],
    "source": ""
  },
  {
    "id": 2844,
    "question": "Bert is considering the use of an infrastructure as a service cloud computing partner to provide virtual servers. <br>Which one of the following would be a vendor responsibility in this scenario?",
    "choice_a": "Maintaining the hypervisor",
    "choice_b": "Managing operating system security settings",
    "choice_c": "Maintaining the host firewall",
    "choice_d": "Configuring server access control",
    "correct_answer": "A",
    "explanation": "In an IaaS server environment, the customer retains responsibility for most server security operations under the shared responsibility model. This includes managing OS security settings, maintaining host firewalls, and configuring server access control. The vendor would be responsible for all security mechanisms at the hypervisor layer and below.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      834,
      818,
      962,
      628,
      833
    ],
    "source": ""
  },
  {
    "id": 2845,
    "question": "When Ben records data and then replays it against his test website to verify how it performs based on a real production workload, what type of performance monitoring is he undertaking?",
    "choice_a": "Passive",
    "choice_b": "Proactive",
    "choice_c": "Reactive",
    "choice_d": "Replay",
    "correct_answer": "B",
    "explanation": "Proactive monitoring, aka synthetic monitoring, uses recorded or generated traffic to test systems and software. Passive monitoring uses a network span, tap, or other device to capture traffic to be analyzed. Reactive and replay are not industry terms for types of monitoring.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      833,
      893,
      804,
      1011,
      803
    ],
    "source": ""
  },
  {
    "id": 2846,
    "question": "Kailey is reviewing a set of old records maintained by her organization and wants to dispose of them securely. She is unsure how long the organization should keep the records because they involve tax data. <br>How can Kailey determine whether the records may be disposed?",
    "choice_a": "Consult the organization's records retention policy.",
    "choice_b": "Consult IRS requirements.",
    "choice_c": "Retain the records for at least seven years.",
    "choice_d": "Retain the records permanently.",
    "correct_answer": "A",
    "explanation": "Kailey should consult her organization's record retentions policy to determine the appropriate length of time to preserve the records. The organization may be subject to tax requirements in this regard, and many accountants recommend preserving records for at least seven years, but the organization's own requirements may be stricter than these requirements.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      850,
      851,
      133,
      852,
      138
    ],
    "source": ""
  },
  {
    "id": 2847,
    "question": "Alan is considering the use of new identification cards in his organization that will be used for physical access control. He comes across a sample card and is unsure of the technology. He breaks it open and sees the following internal construction. <br><img src=\"/question_assets/CISSP/9_image5.png\"/><br>What type of card is this?",
    "choice_a": "Smart card",
    "choice_b": "Proximity card",
    "choice_c": "Magnetic stripe",
    "choice_d": "Phase-two card",
    "correct_answer": "B",
    "explanation": "The use of an electromagnetic coil inside the card indicates that this is a proximity card.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      853,
      854,
      855,
      503,
      533
    ],
    "source": ""
  },
  {
    "id": 2848,
    "question": "Mark is planning a disaster recovery test for his organization. He would like to perform a live test of the disaster recovery facility but does not want to disrupt operations at the primary facility. <br>What type of test should Mark choose?",
    "choice_a": "Full interruption test",
    "choice_b": "Checklist review",
    "choice_c": "Parallel test",
    "choice_d": "Tabletop exercise",
    "correct_answer": "C",
    "explanation": "During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      594,
      597,
      582,
      581,
      593
    ],
    "source": ""
  },
  {
    "id": 2849,
    "question": "Which one of the following is not a principle of the Agile approach to software development?",
    "choice_a": "The best architecture, requirements, and designs emerge from self-organizing teams.",
    "choice_b": "Deliver working software infrequently, with an emphasis on creating accurate code over longer timelines.",
    "choice_c": "Welcome changing requirements, even late in the development process.",
    "choice_d": "Simplicity is essential.",
    "correct_answer": "B",
    "explanation": "The Agile approach to software development embraces 12 core principles, found in the Agile Manifesto. One of these principles is that the best architecture, requirements, and designs emerge from self-organizing teams. Another is that teams should welcome changing requirements at any step in the process. A third is that simplicity is essential. The Agile approach emphasizes delivering software frequently, not infrequently.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      1033,
      1035,
      640,
      622,
      625
    ],
    "source": ""
  },
  {
    "id": 2850,
    "question": "During a security audit, Susan discovers that the organization is using hand geometry scanners as the access control mechanism for their secure data center. <br>What recommendation should Susan make about the use of hand geometry scanners?",
    "choice_a": "They have a high FRR and should be replaced.",
    "choice_b": "A second factor should be added because they are not a good way to reliably distinguish individuals.",
    "choice_c": "The hand geometry scanners provide appropriate security for the data center and should be considered for other high-security areas.",
    "choice_d": "They may create accessibility concerns, and an alternate biometric system should be considered.",
    "correct_answer": "B",
    "explanation": "Hand geometry scanners assess the physical dimensions of an individual's hand but do not verify other unique factors about the individual, or even verify if they are alive. This means that hand geometry scanners should not be implemented as the sole authentication factor for secure environments. Hand geometry scanners do not have an abnormally high FRR and do not stand out as a particular issue from an accessibility standpoint compared to other biometric systems.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 2851,
    "question": "Colleen is conducting a business impact assessment for her organization. <br>What metric provides important information about the amount of time that the organization may be without a service before causing irreparable harm?",
    "choice_a": "MTD",
    "choice_b": "ALE",
    "choice_c": "RPO",
    "choice_d": "RTO",
    "correct_answer": "A",
    "explanation": "The maximum tolerable downtime (MTD) is the amount of time that a business may be without a service before irreparable harm occurs. This measure is sometimes also called maximum tolerable outage (MTO) or maximum allowable downtime (MAD).",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      84,
      83,
      88,
      74,
      96
    ],
    "source": ""
  },
  {
    "id": 2852,
    "question": "Bailey is concerned that users around her organization are using sensitive information in a variety of cloud services and would like to enforce security policies consistently across those services. <br>What security control would be best suited for her needs?",
    "choice_a": "DRM",
    "choice_b": "IPS",
    "choice_c": "CASB",
    "choice_d": "DLP",
    "correct_answer": "C",
    "explanation": "Cloud access security brokers (CASB) are designed to enforce security policies consistently across cloud services and would best meet Bailey's needs. Data loss prevention (DLP) and digital rights management (DRM) solutions may be able to detect, block, and control some use of information in the cloud, but they would not provide a way to consistently enforce security policies across cloud platforms. Intrusion prevention systems (IPS) are designed to detect and block malicious activity and would not be relevant in this scenario.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      135,
      127,
      144,
      124,
      143
    ],
    "source": ""
  },
  {
    "id": 2853,
    "question": "Matt is designing a set of information handling requirements for his organization and would like to draw upon common industry practices. <br>Which of the following practices should Matt implement?  (Select all that apply.)",
    "choice_a": "Labeling both paper and electronic documents with their classification level",
    "choice_b": "Automatically granting senior executives full access to all classified information",
    "choice_c": "Automatically granting visitors access to information classified at the lowest level of sensitivity",
    "choice_d": "Encrypting sensitive information in transit and at rest",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Organizations should always label classified information in whatever form, paper or electronic, that it appears. This allows employees to apply proper handling procedures. It is also a common practice to encrypt sensitive information both at rest and in transit. Organizations should grant access to classified information on a need-to-know basis. Automatically granting access to information, whether it is to a visitor or a senior executive, should not occur.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      128,
      143,
      124,
      122,
      125
    ],
    "source": ""
  },
  {
    "id": 2854,
    "question": "Jerry is investigating an attack where the attacker stole an authentication token from a user's web session and used it to impersonate the user on the site. <br>What term best describes this attack?",
    "choice_a": "Masquerading",
    "choice_b": "Replay",
    "choice_c": "Spoofing",
    "choice_d": "Modification",
    "correct_answer": "B",
    "explanation": "Masquerading (or impersonation) attacks use stolen or falsified credentials to bypass authentication mechanisms. That term does describe this attack, but you should keep reading the answer choices even after finding a possible correct answer. In this case, replay attacks are a more specific type of masquerading attack that relies on captured authentication tokens, and this is, therefore, a better answer. Spoofing attacks rely on falsifying an identity like an IP address or hostname without credentials. Modification attacks occur when captured packets are modified and replayed to a system to attempt to perform an action.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      31,
      7,
      55,
      71,
      25
    ],
    "source": ""
  },
  {
    "id": 2855,
    "question": "Lisa wants to integrate with a cloud identity provider that uses OAuth 2.0, and she wants to select an appropriate authentication framework. <br>Which of the following best suits her needs?",
    "choice_a": "OpenID Connect",
    "choice_b": "SAML",
    "choice_c": "RADIUS",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "OpenID Connect is an authentication layer that works with OAuth 2.0 as its underlying authorization framework. It has been widely adopted by cloud service providers and is widely supported. SAML, RADIUS, and Kerberos are alternative authentication technologies but do not have the same level of seamless integration with OAuth.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      475,
      476,
      1020,
      492,
      758
    ],
    "source": ""
  },
  {
    "id": 2856,
    "question": "Owen recently designed a security access control structure that prevents a single user from simultaneously holding the role required to create a new vendor and the role required to issue a check. <br>What principle is Owen enforcing?",
    "choice_a": "Two-person control",
    "choice_b": "Least privilege",
    "choice_c": "Separation of duties",
    "choice_d": "Job rotation",
    "correct_answer": "C",
    "explanation": "This scenario describes separation of duties\u2014not allowing the same person to hold two roles that, when combined, are sensitive. While two-person control is a similar concept, it does not apply in this case because the scenario does not say that either action requires the concurrence of two users. Least privilege says that an individual should have the minimum set of permissions necessary to carry out their work. Job rotation moves people through jobs on a periodic basis to deter fraud.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      504,
      533,
      503,
      535,
      556
    ],
    "source": ""
  },
  {
    "id": 2857,
    "question": "Denise is preparing for a trial relating to a contract dispute between her company and a software vendor. The vendor is claiming that Denise made a verbal agreement that amended their written contract. <br>What rule of evidence should Denise raise in her defense?",
    "choice_a": "Real evidence rule",
    "choice_b": "Best evidence rule",
    "choice_c": "Parol evidence rule",
    "choice_d": "Testimonial evidence rule",
    "correct_answer": "C",
    "explanation": "The parol evidence rule states that when an agreement between two parties is put into written form, it is assumed to be the entire agreement unless amended in writing. The best evidence rule says that a copy of a document is not admissible if the original document is available. Real evidence and testimonial evidence are evidence types, not rules of evidence.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      615,
      602,
      607,
      601,
      599
    ],
    "source": ""
  },
  {
    "id": 2858,
    "question": "While Lauren is monitoring traffic on two ends of a network connection, she sees traffic that is inbound to a public IP address show up inside the production network. It is headed for an internal host with an RFC 1918 reserved destination address. <br>What technology should she expect is in use at the network border?",
    "choice_a": "NAT",
    "choice_b": "VLANs",
    "choice_c": "S/NAT",
    "choice_d": "BGP",
    "correct_answer": "A",
    "explanation": "Network Address Translation (NAT) translates an internal address to an external address. VLANs are used to logically divide networks, BGP is a routing protocol, and S/NAT is a made-up term.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      423,
      736,
      425,
      949,
      950
    ],
    "source": ""
  },
  {
    "id": 2859,
    "question": "Which of the following statements about SSAE-18 are correct?  (Select all that apply.)",
    "choice_a": "It mandates a specific control set.",
    "choice_b": "It is an attestation standard.",
    "choice_c": "It is used for external audits.",
    "choice_d": "It uses a framework, including SOC 1, SOC 2, and SOC 3 reports.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "SSAE-18 does not assert specific controls. Instead, it reviews the use and application of controls in an audited organization. It is an attestation standard, used for external audits, and forms part of the underlying framework for SOC 1, 2, and 3 reports.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      793,
      766,
      794,
      864,
      1006
    ],
    "source": ""
  },
  {
    "id": 2860,
    "question": "Elliott is using an asymmetric cryptosystem and would like to add a digital signature to a message. <br>What key should he use to encrypt the message digest?",
    "choice_a": "Elliott's private key",
    "choice_b": "Elliott's public key",
    "choice_c": "Recipient's private key",
    "choice_d": "Recipient's public key",
    "correct_answer": "A",
    "explanation": "When creating a digital signature, the sender of a message always encrypts the message digest with their own private key. The recipient (or any third party) may then verify the digital signature by decrypting it with the sender's public key and then comparing that decrypted signature with a message digest that the recipient computes themselves.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      176,
      175,
      198,
      200,
      154
    ],
    "source": ""
  },
  {
    "id": 2861,
    "question": "Greg is building a disaster recovery plan for his organization and would like to determine the amount of time that it should take to restore a particular IT service after an outage. <br>What variable is Greg calculating?",
    "choice_a": "MTD",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "SLA",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. Service-level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      580,
      588,
      584,
      569,
      598
    ],
    "source": ""
  },
  {
    "id": 2862,
    "question": "What business process typically requires sign-off from a manager before modifications are made to a system?",
    "choice_a": "SDN",
    "choice_b": "Release management",
    "choice_c": "Change management",
    "choice_d": "Versioning",
    "correct_answer": "C",
    "explanation": "Change management typically requires sign-off from a manager or supervisor before changes are made. This helps to ensure proper awareness and communication. SDN stands for software-defined networking, release management is the process that new software releases go through to be accepted, and versioning is used to differentiate versions of software, code, or other objects.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      624,
      640,
      625,
      1032,
      1030
    ],
    "source": ""
  },
  {
    "id": 2863,
    "question": "Jen is selecting a fire suppression system for her organization's data center and would like to narrow down the list of candidates. <br>Which one of the following suppression systems would be LEAST appropriate for use?",
    "choice_a": "Dry pipe",
    "choice_b": "Wet pipe",
    "choice_c": "Pre-action",
    "choice_d": "FM-200",
    "correct_answer": "B",
    "explanation": "Wet pipe suppression systems have water present in the pipes at all times, posing an unacceptable level of risk for a data center containing electronics that might be damaged if a pipe leaks. Dry pipe and pre-action systems only contain water when triggered in the event of a possible fire. FM-200 is a chemical suppressant commonly used in place of water in data centers.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      315,
      326,
      329,
      314,
      308
    ],
    "source": ""
  },
  {
    "id": 2864,
    "question": "The company Chris works for has notifications posted at each door reminding employees to be careful to not allow people to enter when they do. <br>Which type of control is this?",
    "choice_a": "Detective",
    "choice_b": "Physical",
    "choice_c": "Preventive",
    "choice_d": "Directive",
    "correct_answer": "D",
    "explanation": "Notifications and procedures like the signs posted at the company Chris works for are examples of directive access controls. Detective controls are designed to operate after the fact. The doors and the locks on them are examples of physical controls. Preventive controls are designed to stop an event and could also include the locks that are present on the doors.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      47,
      59,
      65,
      40,
      48
    ],
    "source": ""
  },
  {
    "id": 2865,
    "question": "Seth is designing the physical security controls for a new facility being constructed by his organization. He would like to deter attacks to the extent possible. <br>Which of the following controls serve as deterrents?  (Select all that apply.)",
    "choice_a": "Motion detectors",
    "choice_b": "Guard dogs",
    "choice_c": "Access control vestibules",
    "choice_d": "Lighting",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Deterrent controls seek to prevent an intruder from attempting an attack in the first place. Guard dogs have an intimidating presence that serves this purpose well. They do also serve to deny, detect, and delay intrusions depending upon their training. Lighting also deters attacks by making potential intrusions more visible, reducing the likelihood that an intruder will enter a well-lit area. Mantraps are intended to deny intruders access, rather than deter attempts. Motion detectors are intended to detect intruders rather than deter them.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      305,
      318,
      319,
      325,
      309
    ],
    "source": ""
  },
  {
    "id": 2866,
    "question": "Thomas recently signed an agreement for a serverless computing environment where his organization's developers will be able to write functions in Python and deploy them on the cloud provider's servers for execution. The cloud provider will manage the servers. <br>What term best describes this model?",
    "choice_a": "SaaS",
    "choice_b": "PaaS",
    "choice_c": "IaaS",
    "choice_d": "Containerization",
    "correct_answer": "B",
    "explanation": "This is an example of function as a service (FaaS) computing. However, FaaS is not listed as an answer choice, so you must also know that FaaS is a subcategory of platform as a service (PaaS) computing to answer this question correctly. This model does not necessarily take advantage of containerization. The cloud provider is managing the infrastructure and only making the platform available to customers, so it is not infrastructure as a service (IaaS). The customers are running their own code, so it is not software as a service (SaaS).",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      230,
      269,
      265,
      213,
      226
    ],
    "source": ""
  },
  {
    "id": 2867,
    "question": "An attacker has intercepted a large amount of data that was all encrypted with the same algorithm and encryption key. With no further information, which of the following cryptanalytic attacks are possible?  (Select all that apply.)",
    "choice_a": "Known plaintext",
    "choice_b": "Chosen ciphertext",
    "choice_c": "Frequency analysis",
    "choice_d": "Brute force",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "The attacker may attempt to perform frequency analysis or a brute force  attack against the large volume of encrypted ciphertext. As the attacker does not have access to the plaintext information, a known plaintext attack is not possible. The attacker also does not have the ability to encrypt information, so they cannot use a chosen ciphertext attack.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      196,
      194,
      199,
      146,
      152
    ],
    "source": ""
  },
  {
    "id": 2868,
    "question": "Alex has been with the university he works at for more than 10 years. During that time, he has been a system administrator and a database administrator, and he has worked in the university's help desk. He is now a manager for the team that runs the university's web applications. Using the provisioning diagram shown here, answer the following question. <br><img src=\"/question_assets/CISSP/9_image6.png\"/><br>If Alex hires a new employee and the employee's account is provisioned after HR manually inputs information into the provisioning system based on data Alex provides via a series of forms, what type of provisioning has occurred?",
    "choice_a": "Discretionary account provisioning",
    "choice_b": "Workflow-based account provisioning",
    "choice_c": "Automated account provisioning",
    "choice_d": "Self-service account provisioning",
    "correct_answer": "B",
    "explanation": "Provisioning that occurs through an established workflow, such as through an HR process, is workflow-based account provisioning. If Alex had set up accounts for his new hire on the systems he manages, he would have been using discretionary account provisioning. If the provisioning system allowed the new hire to sign up for an account on their own, they would have used self-service account provisioning, and if there was a central, software-driven process, rather than HR forms, it would have been automated account provisioning.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      760,
      455,
      458,
      460,
      1017
    ],
    "source": ""
  },
  {
    "id": 2869,
    "question": "Alex has been with the university he works at for more than 10 years. During that time, he has been a system administrator and a database administrator, and he has worked in the university's help desk. He is now a manager for the team that runs the university's web applications. Using the provisioning diagram shown here, answer the following question. <br><img src=\"/question_assets/CISSP/9_image6.png\"/><br>Alex has access to B, C, and D in the diagram. <br>What concern should he raise to the university's identity management team?",
    "choice_a": "The provisioning process did not give him the rights he needs.",
    "choice_b": "He has excessive privileges.",
    "choice_c": "Privilege creep may be taking place.",
    "choice_d": "Logging is not properly enabled.",
    "correct_answer": "C",
    "explanation": "As Alex has changed roles, he retained access to systems that he no longer administers. The provisioning system has provided rights to workstations and the application servers he manages, but he should not have access to the databases he no longer administers. Privilege levels are not specified, so we can't determine if he has excessive rights. Logging may or may not be enabled, but it isn't possible to tell from the diagram or problem.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      470,
      457,
      458,
      466,
      460
    ],
    "source": ""
  },
  {
    "id": 2870,
    "question": "Alex has been with the university he works at for more than 10 years. During that time, he has been a system administrator and a database administrator, and he has worked in the university's help desk. He is now a manager for the team that runs the university's web applications. Using the provisioning diagram shown here, answer the following question. <br><img src=\"/question_assets/CISSP/9_image6.png\"/><br>When Alex changes roles, what should occur?",
    "choice_a": "He should be de-provisioned, and a new account should be created.",
    "choice_b": "He should have his new rights added to his existing account.",
    "choice_c": "He should be provisioned for only the rights that match his role.",
    "choice_d": "He should have his rights set to match those of the person he is replacing.",
    "correct_answer": "C",
    "explanation": "When a user's role changes, they should be provisioned based on their role and other access entitlements. De-provisioning and re-provisioning are time-consuming and can lead to problems with changed IDs and how existing credentials work. Simply adding new rights leads to privilege creep, and matching another user's rights can lead to excessive privileges due to privilege creep for that other user.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      458,
      466,
      457,
      455,
      456
    ],
    "source": ""
  },
  {
    "id": 2871,
    "question": "Robert is reviewing a system that has been assigned the EAL2 evaluation assurance level under the Common Criteria. <br>What is the highest level of assurance that he may have about the system?",
    "choice_a": "It has been functionally tested.",
    "choice_b": "It has been structurally tested.",
    "choice_c": "It has been formally verified, designed, and tested.",
    "choice_d": "It has been semiformally designed and tested.",
    "correct_answer": "B",
    "explanation": "EAL2 assurance applies when the system has been structurally tested. It is the second-to-lowest level of assurance under the Common Criteria.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      621,
      623,
      622,
      654,
      668
    ],
    "source": ""
  },
  {
    "id": 2872,
    "question": "Adam is processing an access request for an end user. <br>What two items should he verify before granting the access?",
    "choice_a": "Separation and need to know",
    "choice_b": "Clearance and endorsement",
    "choice_c": "Clearance and need to know",
    "choice_d": "Second factor and clearance",
    "correct_answer": "C",
    "explanation": "Before granting any user access to information, Adam should verify that the user has an appropriate security clearance as well as a business need to know the information in question.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      470,
      471,
      442,
      457,
      448
    ],
    "source": ""
  },
  {
    "id": 2873,
    "question": "During what phase of the electronic discovery reference model does an organization ensure that potentially discoverable information is protected against alteration or deletion?",
    "choice_a": "Identification",
    "choice_b": "Preservation",
    "choice_c": "Collection",
    "choice_d": "Processing",
    "correct_answer": "B",
    "explanation": "During the preservation phase, the organization ensures that information related to the matter at hand is protected against intentional or unintentional alteration or deletion. The identification phase locates relevant information but does not preserve it. The collection phase occurs after preservation and gathers responsive information. The processing phase performs a rough cut of the collected information for relevance.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      600,
      615,
      605,
      541,
      599
    ],
    "source": ""
  },
  {
    "id": 2874,
    "question": "Dana is selecting a hash function for use in her organization and would like to balance a concern for a cryptographically strong hash with the speed and efficiency of the algorithm. <br>Which one of the following hash functions would best meet her needs?",
    "choice_a": "MD5",
    "choice_b": "RIPEMD",
    "choice_c": "SHA-2",
    "choice_d": "SHA-3",
    "correct_answer": "C",
    "explanation": "The original version of RIPEMD and the MD5 hash algorithm have known vulnerabilities and should no longer be used. SHA-2 and SHA-3 are both considered secure today and provide the same level of security. SHA-3 is, however, less efficient than SHA-2, making SHA-2 the better choice for Dana's needs.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      173,
      174,
      968,
      199,
      155
    ],
    "source": ""
  },
  {
    "id": 2875,
    "question": "Harry would like to access a document owned by Sally stored on a file server. Applying the subject/object model to this scenario, who or what is the object of the resource request?",
    "choice_a": "Harry",
    "choice_b": "Sally",
    "choice_c": "File server",
    "choice_d": "Document",
    "correct_answer": "D",
    "explanation": "In the subject/object model, the object is the resource being requested by a subject. In this example, Harry would like access to the document, making the document the object of the request.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      856,
      858,
      857,
      138,
      143
    ],
    "source": ""
  },
  {
    "id": 2876,
    "question": "What is the process that occurs when the Session layer removes the header from data sent by the Transport layer?",
    "choice_a": "Encapsulation",
    "choice_b": "Packet unwrapping",
    "choice_c": "De-encapsulation",
    "choice_d": "Payloading",
    "correct_answer": "C",
    "explanation": "The process of removing a header (and possibly a footer) from the data received from a previous layer in the OSI model is known as de-encapsulation. Encapsulation occurs when the header and/or footer are added. Payloads are part of a virus or malware package that are delivered to a target, and packet unwrapping is a made-up term.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      332,
      742,
      330,
      412,
      389
    ],
    "source": ""
  },
  {
    "id": 2877,
    "question": "Rob is reviewing his organization's campus for physical security using the Crime Prevention Through Environmental Design (CPTED) framework. <br>Which one of the following is NOT a strategy in this framework?",
    "choice_a": "Natural intrusion detection",
    "choice_b": "Natural access control",
    "choice_c": "Natural surveillance",
    "choice_d": "Natural territorial reinforcement",
    "correct_answer": "A",
    "explanation": "CPTED implements three strategies: natural access control, natural surveillance, and natural territorial reinforcement. Natural access control uses barricades and other physical elements to create a separation between secure and insecure spaces. Natural surveillance designs the environment to expose potential intruders to natural scrutiny by legitimate occupants. Natural territorial reinforcement uses fences, signs, and other elements to clearly define secure spaces. Natural intrusion detection is not an element of CPTED.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      304,
      305,
      320,
      309,
      327
    ],
    "source": ""
  },
  {
    "id": 2879,
    "question": "What type of risk assessment uses tools such as the one shown here? <br><img src=\"/question_assets/CISSP/9_image7.png\"/>",
    "choice_a": "Quantitative",
    "choice_b": "Loss expectancy",
    "choice_c": "Financial",
    "choice_d": "Qualitative",
    "correct_answer": "D",
    "explanation": "The use of a probability/impact matrix is the hallmark of a qualitative risk assessment. It uses subjective measures of probability and impact, such as \"high\" and \"low,\" in place of quantitative measures.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      44,
      26,
      70,
      73,
      96
    ],
    "source": ""
  },
  {
    "id": 2880,
    "question": "MAC models use three types of environments. <br>Which of the following is not a mandatory access control design?",
    "choice_a": "Hierarchical",
    "choice_b": "Bracketed",
    "choice_c": "Compartmentalized",
    "choice_d": "Hybrid",
    "correct_answer": "B",
    "explanation": "Mandatory access control systems can be hierarchical, where each domain is ordered and related to other domains above and below it; compartmentalized, where there is no relationship between each domain; or hybrid, where both hierarchy and compartments are used. There is no concept of bracketing in mandatory access control design.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      468,
      491,
      472,
      463,
      469
    ],
    "source": ""
  },
  {
    "id": 2881,
    "question": "Mandy is the team leader for a project team that includes six people. She would like to provide those people with the ability to communicate privately, such that any pair of people can exchange communications that are not subject to interception by anyone else (team member or nonteam member). She is using an asymmetric encryption algorithm. <br>How many keys are required to implement these requirements?",
    "choice_a": "6",
    "choice_b": "12",
    "choice_c": "15",
    "choice_d": "36",
    "correct_answer": "B",
    "explanation": "In an asymmetric encryption system, each participant needs a key pair (one public key and one private key). For a team of six people, this means a total of 6 key pairs, or 12 keys (6 public and 6 private). Each participant uses their own private key and the other person\u2019s public key to communicate securely. Therefore, the correct number of keys required is 12.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      167,
      154,
      198,
      200,
      165
    ],
    "source": ""
  },
  {
    "id": 2882,
    "question": "Sally is wiring a gigabit Ethernet network. <br>What are the minimum/common UTP cabling choices Sally should use for a 1000 Mbps Gigabit Ethernet network?",
    "choice_a": "Cat 5 and Cat 6",
    "choice_b": "Cat 5e and Cat 6",
    "choice_c": "Cat 4e and Cat 5e",
    "choice_d": "Cat 6 and Cat 7",
    "correct_answer": "B",
    "explanation": "Category 5e and Category 6 UTP cable are both rated to 1000 Mbps. Cat 5 (not Cat 5e) is only rated to 100 Mbps, whereas Cat 7 is rated to 10 Gbps. There is no Cat 4e.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      146,
      152,
      157,
      162,
      184
    ],
    "source": ""
  },
  {
    "id": 2883,
    "question": "Ursula is seeking to expand the reach and scalability of her organization's website. She would like to position copies of her data around the world in locations close to website visitors to reduce loading time and the burden on her servers. <br>What type of cloud service would best meet her needs?",
    "choice_a": "IaaS",
    "choice_b": "Containerization",
    "choice_c": "CDN",
    "choice_d": "SaaS",
    "correct_answer": "C",
    "explanation": "While Ursula may use a variety of different options to meet her needs, the best approach would be the use of a content delivery network (CDN). CDNs are specifically designed for this role, distributing content to many remote endpoints where it may be quickly loaded by local users.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      373,
      358,
      376,
      330,
      345
    ],
    "source": ""
  },
  {
    "id": 2884,
    "question": "Robert is the network administrator for a small business and recently installed a new firewall. After seeing signs of unusually heavy network traffic, he checked his intrusion detection system, which reported that a smurf attack was underway. <br>What firewall configuration change can Robert make to most effectively prevent this attack?",
    "choice_a": "Block the source IP address of the attack.",
    "choice_b": "Block inbound UDP traffic.",
    "choice_c": "Block the destination IP address of the attack.",
    "choice_d": "Block inbound ICMP traffic.",
    "correct_answer": "D",
    "explanation": "Smurf attacks use a distributed attack approach to send ICMP echo replies at a targeted system from many different source addresses. The most effective way to block this attack would be to block inbound ICMP traffic. Blocking the source addresses is not feasible because the attacker would likely simply change the source addresses. Blocking destination addresses would likely disrupt normal activity. The smurf attack does not use UDP, so blocking that traffic would have no effect.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      546,
      567,
      551,
      543,
      548
    ],
    "source": ""
  },
  {
    "id": 2885,
    "question": "Which one of the following types of firewalls does not have the ability to track connection status between different packets?",
    "choice_a": "Stateful inspection",
    "choice_b": "Application proxy",
    "choice_c": "Packet filter",
    "choice_d": "Next generation",
    "correct_answer": "C",
    "explanation": "Static packet filtering firewalls are known as first-generation firewalls and do not track connection state. Stateful inspection, application proxying, and next-generation firewalls all add connection state tracking capability.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      551,
      543,
      548,
      544,
      531
    ],
    "source": ""
  },
  {
    "id": 2886,
    "question": "Frances is concerned that equipment failures within her organization's servers will lead to a loss of power to those servers. <br>Which one of the following controls would best address this risk?",
    "choice_a": "Redundant power sources",
    "choice_b": "Backup generators",
    "choice_c": "Dual power supplies",
    "choice_d": "Uninterruptible power supplies",
    "correct_answer": "C",
    "explanation": "All of these controls serve to increase the reliability of power to a server. However, only dual power supplies address hardware issues that arise within the server, allowing the server to continue operation if one of the power supplies fails. Redundant power sources, backup generators, and uninterruptible power supplies (UPS) are designed to increase the reliability of power flowing to the server.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      385,
      394,
      379,
      333,
      330
    ],
    "source": ""
  },
  {
    "id": 2887,
    "question": "Peter is reviewing the remote access technologies used by his organization and would like to eliminate the use of any techniques that do not include built-in encryption. <br>Which of the following approaches should he retain?  (Select all that apply.)",
    "choice_a": "RDP",
    "choice_b": "Telnet",
    "choice_c": "SSH",
    "choice_d": "Dial-up",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "The Remote Desktop Protocol (RDP) and Secure Shell (SSH) are modern approaches to remote access that include encryption features. Telnet and dial-up are outdated approaches that do not provide encryption and should not be relied upon for secure access.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      905,
      350,
      335,
      401,
      412
    ],
    "source": ""
  },
  {
    "id": 2888,
    "question": "Matthew is experiencing issues with the quality of network service on his organization's network. The primary symptom is that packets are occasionally taking too long to travel from their source to their destination. The length of this delay changes for individual packets. <br>What term describes the issue Matthew is facing?",
    "choice_a": "Latency",
    "choice_b": "Jitter",
    "choice_c": "Packet loss",
    "choice_d": "Interference",
    "correct_answer": "B",
    "explanation": "Latency is a delay in the delivery of packets from their source to their destination. Jitter is a variation in the latency for different packets. Packet loss is the disappearance of packets in transit that requires retransmission. Interference is electrical noise or other disruptions that corrupt the contents of packets.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      259,
      938,
      256,
      251,
      146
    ],
    "source": ""
  },
  {
    "id": 2889,
    "question": "Gavin is an internal auditor working to assess his organization's cybersecurity posture. <br>Which of the following would be appropriate recipients of the reports he generates from his work? <ol type=\"A\"><li> Managers</li><li> Individual contributors</li><li> Suppliers</li><li> Board members</li></ol>(Select all that apply.)",
    "choice_a": "Managers",
    "choice_b": "Individual contributors",
    "choice_c": "Suppliers",
    "choice_d": "Board members",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "It is entirely appropriate to distribute internal audit reports to anyone in the organization who has a valid need to know. This may include both management and individual contributors responsible for remediating issues as well as board members charged with oversight. It would not normally be appropriate to distribute internal audit reports to external entities, such as suppliers and customers.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      862,
      863,
      864,
      793,
      795
    ],
    "source": ""
  },
  {
    "id": 2890,
    "question": "Kim is conducting testing of a web application developed by her organization and would like to ensure that it is accessible from all commonly used web browsers. <br>What type of testing should she conduct?",
    "choice_a": "Regression testing",
    "choice_b": "Interface testing",
    "choice_c": "Fuzzing",
    "choice_d": "White-box testing",
    "correct_answer": "B",
    "explanation": "Web applications communicate with web browsers via an interface, making interface testing the best answer here. Regression testing might be used as part of the interface test but is too specific to be the best answer. Similarly, the test might be a white-box, or full knowledge, test, but interface testing better describes this specific example. Fuzzing is less likely as part of a browser compatibility test, as it tests unexpected inputs, rather than functionality.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      963,
      626,
      621,
      826,
      668
    ],
    "source": ""
  },
  {
    "id": 2891,
    "question": "Kathleen is implementing an access control system for her organization and builds the following array:<br>     Reviewers: update files, delete files <br>     Submitters: upload files <br>     Editors: upload files, update files <br>     Archivists: delete files <br>What type of access control system has Kathleen implemented?",
    "choice_a": "Role-based access control",
    "choice_b": "Task-based access control",
    "choice_c": "Rule-based access control",
    "choice_d": "Discretionary access control",
    "correct_answer": "A",
    "explanation": "Role-based access control gives each user an array of permissions based on their position in the organization, such as the scheme shown here. Task-based access control is not a standard approach. Rule-based access controls use rules that apply to all subjects, which isn't something we see in the list. Discretionary access control gives object owners rights to choose how the objects they own are accessed, which is not what this list shows.",
    "topic_id": 5,
    "practice_test_id": 1,
    "related_articles": [
      466,
      472,
      491,
      467,
      473
    ],
    "source": ""
  },
  {
    "id": 2892,
    "question": "Alan is installing a fire suppression system that will activate after a fire breaks out and protect the equipment in the data center from extensive damage. <br>What metric is Alan attempting to lower?",
    "choice_a": "Likelihood",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "Impact",
    "correct_answer": "D",
    "explanation": "Fire suppression systems do not stop a fire from occurring but do reduce the damage that fires cause. This is an example of reducing risk by lowering the impact of an event.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      26,
      88,
      83,
      2,
      82
    ],
    "source": ""
  },
  {
    "id": 2893,
    "question": "Alan's Wrenches recently developed a new manufacturing process for its product. They plan to use this technology internally and not share it with others. They would like it to remain protected for as long as possible. <br>What type of intellectual property protection is best suited for this situation?",
    "choice_a": "Patent",
    "choice_b": "Copyright",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "D",
    "explanation": "Patents and trade secrets can both protect intellectual property in the form of a process. Patents require public disclosure and have expiration dates while trade secrets remain in force for as long as they remain secret. Therefore, trade secret protection most closely aligns with the company's goals.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      104,
      103,
      987,
      985,
      111
    ],
    "source": ""
  },
  {
    "id": 2894,
    "question": "Ben wants to interface with the National Vulnerability Database using a standardized protocol. <br>What option should he use to ensure that the tools he builds work with the data contained in the NVD?",
    "choice_a": "XACML",
    "choice_b": "SCML",
    "choice_c": "VSML",
    "choice_d": "SCAP",
    "correct_answer": "D",
    "explanation": "The Security Content Automation Protocol (SCAP) is a suite of specifications used to handle vulnerability and security configuration information. The National Vulnerability Database provided by NIST uses SCAP. XACML is the eXtensible Access Control Markup Language, an OASIS standard used for access control decisions, and neither VSML nor SCML is an industry term.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      531,
      534,
      563,
      529,
      532
    ],
    "source": ""
  },
  {
    "id": 2895,
    "question": "Ron's organization does not have the resources to conduct penetration testing that uses time-intensive manual techniques, but he would like to achieve some of the benefits of penetration testing. <br>Which one of the following techniques could he engage in that requires the least manual effort?",
    "choice_a": "White-box testing",
    "choice_b": "Black-box testing",
    "choice_c": "Gray-box testing",
    "choice_d": "Breach and attack simulation",
    "correct_answer": "D",
    "explanation": "Breach and attack simulation (BAS) platforms are intended to automate some aspects of penetration testing. These systems are designed to inject threat indicators onto systems and networks in an effort to trigger other security controls. White-box, gray-box, and black-box testing all involve more significant manual effort.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      1078,
      1080,
      1079,
      501,
      494
    ],
    "source": ""
  },
  {
    "id": 2896,
    "question": "In the figure shown here, Harry's request to read the data file is blocked. Harry has a Secret security clearance, and the data file has a Top Secret classification. <br><img src=\"/question_assets/CISSP/9_image8.png\"/><br>What principle of the Bell\u2013LaPadula model blocked this request?",
    "choice_a": "Simple Security Property",
    "choice_b": "Simple Integrity Property",
    "choice_c": "*-Security Property",
    "choice_d": "Discretionary Security Property",
    "correct_answer": "A",
    "explanation": "The Simple Security Property prevents an individual from reading information at a higher security level than his or her clearance allows. This is also known as the \"no read up\" rule. The Simple Integrity Property says that a user can't write data to a higher integrity level than their own. The *-Security Property says that users can't write data to a lower security level than their own. The Discretionary Security Property allows the use of a matrix to determine access permissions.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      217,
      228,
      215,
      213,
      218
    ],
    "source": ""
  },
  {
    "id": 2897,
    "question": "Norm is starting a new software project with a vendor that uses an SDLC approach to development. When he arrives on the job, he receives a document that has the sections shown here. <br><img src=\"/question_assets/CISSP/9_image9.png\"/><br>What type of planning document is this?",
    "choice_a": "Functional requirements",
    "choice_b": "Work breakdown structure",
    "choice_c": "Test analysis report",
    "choice_d": "Project plan",
    "correct_answer": "B",
    "explanation": "The work breakdown structure (WBS) is an important project management tool that divides the work done for a large project into smaller components. It is not a project plan because it does not describe timing or resources. Test analyses are used during later phases of the development effort to report test results. Functional requirements may be included in a work breakdown structure, but they are not the full WBS.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      821,
      622,
      833,
      621,
      820
    ],
    "source": ""
  },
  {
    "id": 2898,
    "question": "Kolin is searching for a network security solution that will allow him to help reduce zero-day attacks while using identities to enforce a security policy on systems before they connect to the network. <br>What type of solution should Kolin implement?",
    "choice_a": "A firewall",
    "choice_b": "A NAC system",
    "choice_c": "An intrusion detection system",
    "choice_d": "Port security",
    "correct_answer": "B",
    "explanation": "Network Access Control (NAC) systems can be used to authenticate users and then validate their system's compliance with a security standard before they are allowed to connect to the network. Enforcing security profiles can help reduce zero-day attacks, making NAC a useful solution. A firewall can't enforce system security policies, whereas an IDS can only monitor for attacks and alarm when they happen. Thus, neither a firewall nor an IDS meets Kolin's needs. Finally, port security is a MAC address\u2013based security feature that can only restrict which systems or devices can connect to a given port.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      393,
      375,
      379,
      391,
      427
    ],
    "source": ""
  },
  {
    "id": 2899,
    "question": "Gwen comes across an application that is running under a service account on a web server. The service account has full administrative rights to the server. <br>What principle of information security does this violate?",
    "choice_a": "Need to know",
    "choice_b": "Separation of duties",
    "choice_c": "Least privilege",
    "choice_d": "Job rotation",
    "correct_answer": "C",
    "explanation": "This scenario violates the least privilege principle because an application should never require full administrative rights to run. Gwen should update the service account to have only the privileges necessary to support the application.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      535,
      503,
      533,
      506,
      511
    ],
    "source": ""
  },
  {
    "id": 2900,
    "question": "Ed is developing a set of key performance and risk indicators for his organization's information security program. <br>Which of the following are commonly used indicators?  (Select all that apply.)",
    "choice_a": "Number of scheduled audits",
    "choice_b": "Time to resolve vulnerabilities",
    "choice_c": "Number of malicious site visit attempts",
    "choice_d": "Number of account compromises",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Organizations typically use the time to resolve vulnerabilities, the number of account compromises, and the number of attempts by users to visit malicious sites as indicators. The number of scheduled audits is not normally a measure of the performance of an information security team. A more appropriate indicator in this area is the number of repeat audit findings.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      502,
      498,
      861,
      501,
      499
    ],
    "source": ""
  },
  {
    "id": 2901,
    "question": "Kara is documenting the results of a vulnerability scan. After reviewing one finding, she determined that the vulnerability did exist. The team then implemented a configuration change that corrected the issue. <br>How should Kara classify this vulnerability in her report?",
    "choice_a": "True positive",
    "choice_b": "True negative",
    "choice_c": "False positive",
    "choice_d": "False negative",
    "correct_answer": "A",
    "explanation": "This is a true positive report because the scan detected the vulnerability and the vulnerability actually existed. The fact that the team later remediated the vulnerability could be noted in the report, but it does not change the result of the scan or its classification. True negatives occur when scans correctly note the absence of a vulnerability. False positives occur when scans report the presence of a vulnerability that does not actually exist. False negatives occur when scans report that no vulnerability exists when one does, in fact, exist.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      859,
      860,
      861,
      787,
      789
    ],
    "source": ""
  },
  {
    "id": 2902,
    "question": "During a web application vulnerability scanning test, Steve runs Nikto against a web server he believes may be vulnerable to attacks. Using the Nikto output shown here, answer the following question. <br><img src=\"/question_assets/CISSP/9_image10.png\"/><br>Why does Nikto flag the <code>/test</code> directory?",
    "choice_a": "The <code>/test</code> directory allows administrative access to PHP.",
    "choice_b": "It is used to store sensitive data.",
    "choice_c": "Test directories often contain scripts that can be misused.",
    "choice_d": "It indicates a potential compromise.",
    "correct_answer": "C",
    "explanation": "Test directories often include scripts that may have poor protections or may have other data that can be misused. There is not a default test directory that allows administrative access to PHP. Test directories are not commonly used to store sensitive data, nor is the existence of a test directory a common indicator of compromise.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      787,
      860,
      775,
      777,
      494
    ],
    "source": ""
  },
  {
    "id": 2903,
    "question": "During a web application vulnerability scanning test, Steve runs Nikto against a web server he believes may be vulnerable to attacks. Using the Nikto output shown here, answer the following question. <br><img src=\"/question_assets/CISSP/9_image10.png\"/><br>Why does Nikto identify directory indexing as an issue?",
    "choice_a": "It lists files in a directory.",
    "choice_b": "It may allow for XDRF.",
    "choice_c": "Directory indexing can result in a denial-of-service attack.",
    "choice_d": "Directory indexing is off by default, potentially indicating compromise.",
    "correct_answer": "A",
    "explanation": "Directory indexing may not initially seem like an issue during a penetration test, but simply knowing the name and location of files can provide an attacker with quite a bit of information about an organization, as well as a list of potentially accessible files. XDRF is not a type of attack, and indexing is not a denial-of-service attack vector. Directory indexing being turned on is typically either due to misconfiguration or design or because the server was not properly configured at setup, rather than being a sign of attack.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      787,
      860,
      771,
      495,
      777
    ],
    "source": ""
  },
  {
    "id": 2904,
    "question": "During a web application vulnerability scanning test, Steve runs Nikto against a web server he believes may be vulnerable to attacks. Using the Nikto output shown here, answer the following question. <br><img src=\"/question_assets/CISSP/9_image10.png\"/><br>Nikto lists OSVDB-877, noting that the system may be vulnerable to XST. <br>What would this type of attack allow an attacker to do?",
    "choice_a": "Use cross-site targeting.",
    "choice_b": "Steal a user's cookies.",
    "choice_c": "Counter SQL tracing.",
    "choice_d": "Modify a user's TRACE information.",
    "correct_answer": "B",
    "explanation": "Cross-site tracing (XST) leverages the HTTP TRACE or TRACK methods and could be used to steal a user's cookies via cross-site scripting (XSS). The other options are not industry terms for web application or web server attacks or vulnerabilities.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      531,
      544,
      550,
      608,
      563
    ],
    "source": ""
  },
  {
    "id": 2905,
    "question": "Who would be the most appropriate supervisor for an organization's chief audit executive (CAE)?",
    "choice_a": "CIO",
    "choice_b": "CISO",
    "choice_c": "CEO",
    "choice_d": "CFO",
    "correct_answer": "C",
    "explanation": "The chief audit executive (CAE) should report to the most senior possible leader to avoid conflicts of interest. Of the choices provided, the chief executive officer (CEO) is the most senior position and the best option. It is also possible to provide an added degree of independence by having the CAE report to the board of directors, either as a primary reporting line or as a dotted line relationship.",
    "topic_id": 6,
    "practice_test_id": 1,
    "related_articles": [
      862,
      1007,
      863,
      1006,
      1008
    ],
    "source": ""
  },
  {
    "id": 2906,
    "question": "Ursula believes that many individuals in her organization are storing sensitive information on their laptops in a manner that is unsafe and potentially violates the organization's security policy. <br>What control can she use to identify the presence of these files?",
    "choice_a": "Network DLP",
    "choice_b": "Network IPS",
    "choice_c": "Endpoint DLP",
    "choice_d": "Endpoint IPS",
    "correct_answer": "C",
    "explanation": "Data loss prevention (DLP) systems specialize in the identification of sensitive information. In this case, Ursula would like to identify the presence of this information on endpoint devices, so she should choose an endpoint DLP control. Network-based DLP would not detect stored information unless the user transmits it over the network. Intrusion prevention systems (IPSs) are designed to detect and block attacks in progress, not necessarily the presence of sensitive information.",
    "topic_id": 2,
    "practice_test_id": 1,
    "related_articles": [
      127,
      144,
      124,
      132,
      122
    ],
    "source": ""
  },
  {
    "id": 2907,
    "question": "In what cloud computing model does the customer build a cloud computing environment in his or her own data center or build an environment in another data center that is for the customer's exclusive use?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Hybrid cloud",
    "choice_d": "Shared cloud",
    "correct_answer": "B",
    "explanation": "In the private cloud computing model, the cloud computing environment is dedicated to a single organization and does not follow the shared tenancy model. The environment may be built by the company in its own data center or built by a vendor at a co-location site.",
    "topic_id": 3,
    "practice_test_id": 1,
    "related_articles": [
      230,
      259,
      256,
      254,
      269
    ],
    "source": ""
  },
  {
    "id": 2908,
    "question": "Which one of the following technologies is designed to prevent a web server going offline from becoming a single point of failure in a web application architecture?",
    "choice_a": "Load balancing",
    "choice_b": "Dual-power supplies",
    "choice_c": "IPS",
    "choice_d": "RAID",
    "correct_answer": "A",
    "explanation": "Load balancing helps to ensure that a failed server will not take a website or service offline. Dual power supplies only work to prevent failure of a power supply or power source. IPS can help to prevent attacks, and RAID can help prevent a disk failure from taking a system offline.",
    "topic_id": 7,
    "practice_test_id": 1,
    "related_articles": [
      575,
      577,
      521,
      835,
      578
    ],
    "source": ""
  },
  {
    "id": 2909,
    "question": "Alice wants to send Bob a message with the confidence that Bob will know the message was not altered while in transit. <br>What security goal is Alice trying to achieve?",
    "choice_a": "Confidentiality",
    "choice_b": "Nonrepudiation",
    "choice_c": "Authentication",
    "choice_d": "Integrity",
    "correct_answer": "D",
    "explanation": "Integrity ensures that unauthorized changes are not made to data while stored or in transit.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      3,
      5,
      686,
      685,
      8
    ],
    "source": ""
  },
  {
    "id": 2910,
    "question": "What network topology is shown here? <br><img src=\"/question_assets/CISSP/9_image11.png\"/>",
    "choice_a": "A ring",
    "choice_b": "A bus",
    "choice_c": "A star",
    "choice_d": "A mesh",
    "correct_answer": "C",
    "explanation": "A star topology uses a central connection device. Ethernet networks may look like a star, but they are actually a logical bus topology that is sometimes deployed in a physical star.",
    "topic_id": 4,
    "practice_test_id": 1,
    "related_articles": [
      865,
      867,
      866,
      389,
      356
    ],
    "source": ""
  },
  {
    "id": 2911,
    "question": "Monica is developing a software application that calculates an individual's body mass index for use in medical planning. She would like to include a control on the field where the physician enters an individual's weight to ensure that the weight falls within an expected range. <br>What type of control should Monica use?",
    "choice_a": "Fail open",
    "choice_b": "Fail secure",
    "choice_c": "Limit check",
    "choice_d": "Buffer bounds",
    "correct_answer": "C",
    "explanation": "Input validation ensures that the data provided to a program as input matches the expected parameters. Limit checks are a special form of input validation that ensure that the value remains within an expected range, as is the case described in this scenario. Fail open and fail secure are options when planning for possible system failures. Buffer bounds are not a type of software control.",
    "topic_id": 8,
    "practice_test_id": 1,
    "related_articles": [
      620,
      668,
      654,
      672,
      621
    ],
    "source": ""
  },
  {
    "id": 2912,
    "question": "James is building a disaster recovery plan for his organization and would like to determine the amount of acceptable data loss after an outage. <br>What variable is James determining?",
    "choice_a": "SLA",
    "choice_b": "RTO",
    "choice_c": "MTD",
    "choice_d": "RPO",
    "correct_answer": "D",
    "explanation": "The recovery point objective (RPO) identifies the maximum amount of data, measured in time, that may be lost during a recovery effort. The recovery time objective (RTO) is the amount of time expected to return an IT service or component to operation after a failure. The maximum tolerable downtime (MTD) is the longest amount of time that an IT service or component may be unavailable without causing serious damage to the organization. Service-level agreements (SLAs) are written contracts that document service expectations.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      580,
      588,
      584,
      586,
      569
    ],
    "source": ""
  },
  {
    "id": 2913,
    "question": "In his role, Chris is expected to protect the interests of the organization, and the customers whose information he is charged to protect. <br>What term describes the preparation and research undertaken before decisions and actions are made?",
    "choice_a": "Due care",
    "choice_b": "Compliance",
    "choice_c": "Due diligence",
    "choice_d": "Regulatory action",
    "correct_answer": "C",
    "explanation": "Due care and due diligence can be a confusing pair of terms to keep straight. Chris is engaging in due diligence when he does the preparation and research. Once that is done, he must use due care while undertaking the actions. This is often described in the context of the prudent person rule: would a prudent person have taken the action given the same knowledge?",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      20,
      32,
      41,
      677,
      81
    ],
    "source": ""
  },
  {
    "id": 2916,
    "question": "Tony wants to conduct a disaster recovery plan test exercise for his organization. <br>What type of exercise should he conduct if he wants it to be the most realistic event possible and is able to disrupt his organization's operations to conduct the exercise?",
    "choice_a": "Read-through",
    "choice_b": "Full interruption",
    "choice_c": "Walk-through",
    "choice_d": "Simulation",
    "correct_answer": "B",
    "explanation": "The most realistic but also most disruptive option for disaster recovery plan testing is a full interruption. The least obtrusive but also least similar to real-world scenarios is a read-through. After that, walk-throughs and simulations are each closer to a true scenario, but parallel operations is often the most popular option because it can be done without disrupting the organization and still reasonably test capabilities.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      594,
      597,
      596,
      592,
      580
    ],
    "source": ""
  },
  {
    "id": 2918,
    "question": "Ben works in an organization that uses a formal data governance program. He is consulting with an employee working on a project that created an entirely new class of data and wants to work with the appropriate individual to assign a classification level to that information. <br>Who is responsible for the assignment of information to a classification level?",
    "choice_a": "Data creator",
    "choice_b": "Data owner",
    "choice_c": "CISO",
    "choice_d": "Data custodian",
    "correct_answer": "B",
    "explanation": "The data owner is normally responsible for classifying information at an appropriate level. This role is typically filled by a senior manager or director, who then delegates operational responsibility to a data custodian.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      138,
      143,
      125,
      124,
      851
    ],
    "source": ""
  },
  {
    "id": 2919,
    "question": "James wants to ensure that his company's backups will survive a disaster that strikes the data center. <br>Which of the following options is the best solution to this concern?",
    "choice_a": "Off-site backups",
    "choice_b": "A grandfather/father/son backup tiering system",
    "choice_c": "Redundant backup systems",
    "choice_d": "Snapshots to a SAN or NAS",
    "correct_answer": "A",
    "explanation": "Off-site backups are the best option for disaster recovery in a scenario where a disaster directly impacts the data center. None of the other scenarios as described will directly address the issue, although snapshots to a remote storage location can act as a form of off-site backup.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      589,
      584,
      598,
      574,
      517
    ],
    "source": ""
  },
  {
    "id": 2920,
    "question": "Gabe is concerned about the security of passwords used as a cornerstone of his organization's information security program. <br>Which one of the following controls would provide the greatest improvement in Gabe's ability to authenticate users?",
    "choice_a": "More complex passwords",
    "choice_b": "User education against social engineering",
    "choice_c": "Multifactor authentication",
    "choice_d": "Addition of security questions based on personal knowledge",
    "correct_answer": "C",
    "explanation": "While all of the listed controls would improve authentication security, most simply strengthen the use of knowledge-based authentication. The best way to improve the authentication process would be to add a factor not based on knowledge through the use of multifactor authentication. This may include the use of biometric controls or token-based authentication.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      446,
      489,
      445,
      469,
      442
    ],
    "source": ""
  },
  {
    "id": 2921,
    "question": "The separation of network infrastructure from the control layer, combined with the ability to centrally program a network design in a vendor-neutral, standards-based implementation, is an example of what important concept?",
    "choice_a": "MPLS, a way to replace long network addresses with shorter labels and support a wide range of protocols",
    "choice_b": "FCoE, a converged protocol that allows common applications over Ethernet",
    "choice_c": "SDN, a converged protocol that allows network virtualization",
    "choice_d": "CDN, a converged protocol that makes common network designs accessible",
    "correct_answer": "C",
    "explanation": "Software-defined networking (SDN) is a converged protocol that allows virtualization concepts and practices to be applied to networks. MPLS handles a wide range of protocols like ATM, DSL, and others, but isn't intended to provide the centralization capabilities that SDN does. A content distribution network (CDN) is not a converged protocol, and FCoE is Fibre Channel over Ethernet, a converged protocol for storage.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      354,
      352,
      333,
      345,
      389
    ],
    "source": ""
  },
  {
    "id": 2922,
    "question": "Susan is preparing to decommission her organization's archival DVD-ROMs that contain Top Secret data. <br>How should she ensure that the data cannot be exposed?",
    "choice_a": "Degauss",
    "choice_b": "Zero wipe",
    "choice_c": "Pulverize",
    "choice_d": "Secure erase",
    "correct_answer": "C",
    "explanation": "The best way to ensure that data on DVDs is fully gone is to destroy them, and pulverizing DVDs is an appropriate means of destruction. DVD-ROMs are write-only media, meaning that secure erase and zero wipes won't work. Degaussing only works on magnetic media and cannot guarantee that there will be zero data remanence.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      129,
      130,
      1026,
      125,
      144
    ],
    "source": ""
  },
  {
    "id": 2923,
    "question": "Susan is worried about a complex change and wants to ensure that the organization can recover if the change does not go as planned. <br>What should she require in her role on the organization's change advisory board (CAB)?",
    "choice_a": "She should reject the change due to risk.",
    "choice_b": "She should require a second change review.",
    "choice_c": "She should ensure a backout plan exists.",
    "choice_d": "She should ensure a failover plan exists.",
    "correct_answer": "C",
    "explanation": "Backout plans are required in some change management processes to ensure that the thought process and procedures for what to do if something does not go as planned are needed. Validating backout plan quality can be just as important as the change, and you may find, in many organizations, if nobody is watching that backout plans may read, \"Undo the change we made.\" Rejecting the change won't fix the problem if the change has been made. Change review is useful to identify problems before the change is made. Failover plans are not a term commonly used in change management processes.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      527,
      974,
      534,
      596,
      528
    ],
    "source": ""
  },
  {
    "id": 2924,
    "question": "Angie is configuring egress monitoring on her network to provide added security. <br>Which one of the following packet types should Angie allow to leave the network headed for the internet?",
    "choice_a": "Packets with a source address from Angie's public IP address block",
    "choice_b": "Packets with a destination address from Angie's public IP address block",
    "choice_c": "Packets with a source address outside Angie's address block",
    "choice_d": "Packets with a source address from Angie's private address block",
    "correct_answer": "A",
    "explanation": "All packets leaving Angie's network should have a source address from her public IP address block. Packets with a destination address from Angie's network should not be leaving the network. Packets with source addresses from other networks are likely spoofed and should be blocked by egress filters. Packets with private IP addresses as sources or destinations should never be routed onto the internet.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      559,
      544,
      548,
      543,
      535
    ],
    "source": ""
  },
  {
    "id": 2926,
    "question": "Theresa is implementing a new access control system and wants to ensure that developers do not have the ability to move code from development systems into the production environment. She wants to ensure that a developer who checks in code cannot then approve their own code as part of the process. <br>What information security principle is she most directly enforcing?",
    "choice_a": "Separation of duties",
    "choice_b": "Two-person control",
    "choice_c": "Least privilege",
    "choice_d": "Job rotation",
    "correct_answer": "A",
    "explanation": "While developers may feel like they have a business need to be able to move code into production, the principle of separation of duties dictates that they should not have the ability to both write code and place it on a production server. The deployment of code is often performed by change management staff.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      219,
      213,
      220,
      228,
      292
    ],
    "source": ""
  },
  {
    "id": 2927,
    "question": "Which one of the following tools may be used to achieve the goal of nonrepudiation?",
    "choice_a": "Digital signature",
    "choice_b": "Symmetric encryption",
    "choice_c": "Firewall",
    "choice_d": "IDS",
    "correct_answer": "A",
    "explanation": "Applying a digital signature to a message allows the sender to achieve the goal of nonrepudiation. This allows the recipient of a message to prove to a third party that the message came from the purported sender. Symmetric encryption does not support nonrepudiation. Firewalls and IDS are network security tools that are not used to provide nonrepudiation.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      175,
      164,
      198,
      177,
      179
    ],
    "source": ""
  },
  {
    "id": 2928,
    "question": "In this diagram of the TCP three-way handshake, what should system A send to system B in step 3? <br><img src=\"/question_assets/CISSP/10_image1.png\"/>",
    "choice_a": "ACK",
    "choice_b": "SYN",
    "choice_c": "FIN",
    "choice_d": "RST",
    "correct_answer": "A",
    "explanation": "System A should send an ACK to end the three-way handshake. The TCP three-way handshake is SYN, SYN/ACK, ACK.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      868,
      883,
      869,
      724,
      884
    ],
    "source": ""
  },
  {
    "id": 2929,
    "question": "What RADIUS alternative is commonly used for Cisco network gear and supports two-factor authentication?",
    "choice_a": "RADIUS+",
    "choice_b": "TACACS+",
    "choice_c": "XTACACS",
    "choice_d": "Kerberos",
    "correct_answer": "B",
    "explanation": "TACACS+ is the most modern version of TACACS, the Terminal Access Controller Access-Control System. It is a Cisco proprietary protocol with added features beyond what RADIUS provides, meaning it is commonly used on Cisco networks. XTACACS is an earlier version, Kerberos is a network authentication protocol rather than a remote user authentication protocol, and RADIUS+ is a made-up term.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      479,
      492,
      446,
      461,
      459
    ],
    "source": ""
  },
  {
    "id": 2930,
    "question": "What two types of attacks are VoIP call managers and VoIP phones most likely to be susceptible to?",
    "choice_a": "DoS and malware",
    "choice_b": "Worms and Trojans",
    "choice_c": "DoS and host OS attacks",
    "choice_d": "Host OS attacks and buffer overflows",
    "correct_answer": "C",
    "explanation": "Call managers and VoIP phones can be thought of as servers or appliances and embedded or network devices. That means that the most likely threats that they will face are denial-of-service (DoS) attacks and attacks against the host operating system. Malware and Trojans are less likely to be effective against a server or embedded system that doesn't browse the internet or exchange data files; buffer overflows are usually aimed at specific applications or services.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      353,
      395,
      384,
      438,
      379
    ],
    "source": ""
  },
  {
    "id": 2931,
    "question": "Vivian works for a chain of retail stores and would like to use a software product that restricts the software used on point-of-sale terminals to those packages on a preapproved list. <br>What approach should Vivian use?",
    "choice_a": "Antivirus",
    "choice_b": "Heuristic",
    "choice_c": "Whitelist",
    "choice_d": "Blacklist",
    "correct_answer": "C",
    "explanation": "The blacklist approach to application control blocks certain prohibited packages but allows the installation of other software on systems. The whitelist approach uses the reverse philosophy and only allows approved software. It is worth noting that the terms <italic>blacklist</italic> and <italic>whitelist</italic> are increasingly deprecated and that you may encounter terms like <italic>block list</italic> or <italic>deny list</italic> and <italic>allow list</italic> as language and terminology shifts. As you prepare for the exam and your professional work, make sure to consider these equivalents. Antivirus software would only detect the installation of malicious software after the fact. Heuristic detection is a variant of antivirus software.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      871,
      872,
      873,
      568,
      550
    ],
    "source": ""
  },
  {
    "id": 2932,
    "question": "Hunter is the facilities manager for DataTech, a large data center management firm. He is evaluating the installation of a flood prevention system at one of DataTech's facilities. The facility and contents are valued at $100 million. Installing the new flood prevention system would cost $10 million. <br>Hunter consulted with flood experts and determined that the facility lies within a 200-year flood plain and that, if a flood occurred, it would likely cause $20 million in damage to the facility. <br>Based on the information in this scenario, what is the exposure factor for the effect of a flood on DataTech's data center?",
    "choice_a": "2 percent",
    "choice_b": "20 percent",
    "choice_c": "100 percent",
    "choice_d": "200 percent",
    "correct_answer": "B",
    "explanation": "The exposure factor is the percentage of the facility that risk managers expect will be damaged if a risk materializes. It is calculated by dividing the amount of damage by the asset value. In this case, that is $20 million in damage divided by the $100 million facility value, or 20 percent.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      45,
      86,
      42,
      43,
      26
    ],
    "source": ""
  },
  {
    "id": 2933,
    "question": "Hunter is the facilities manager for DataTech, a large data center management firm. He is evaluating the installation of a flood prevention system at one of DataTech's facilities. The facility and contents are valued at $100 million. Installing the new flood prevention system would cost $10 million. <br>Hunter consulted with flood experts and determined that the facility lies within a 200-year flood plain and that, if a flood occurred, it would likely cause $20 million in damage to the facility. <br>Based on the information in this scenario, what is the annualized rate of occurrence for a flood at DataTech's data center?",
    "choice_a": "0.002",
    "choice_b": "0.005",
    "choice_c": "0.02",
    "choice_d": "0.05",
    "correct_answer": "B",
    "explanation": "The annualized rate of occurrence is the number of times each year that risk analysts expect a risk to happen in any given year. In this case, the analysts expect floods once every 200 years, or 0.005 times per year.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      691,
      695,
      875,
      85,
      41
    ],
    "source": ""
  },
  {
    "id": 2934,
    "question": "Hunter is the facilities manager for DataTech, a large data center management firm. He is evaluating the installation of a flood prevention system at one of DataTech's facilities. The facility and contents are valued at $100 million. Installing the new flood prevention system would cost $10 million. <br>Hunter consulted with flood experts and determined that the facility lies within a 200-year flood plain and that, if a flood occurred, it would likely cause $20 million in damage to the facility. <br>Based on the information in this scenario, what is the annualized loss expectancy for a flood at DataTech's data center?",
    "choice_a": "$40,000",
    "choice_b": "$100,000",
    "choice_c": "$400,000",
    "choice_d": "$1,000,000",
    "correct_answer": "B",
    "explanation": "The annualized loss expectancy is calculated by multiplying the single loss expectancy (SLE) by the annualized rate of occurrence (ARO). In this case, the SLE is $20 million, and the ARO is 0.005. Multiplying these numbers together gives you the ALE of $100,000.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      695,
      86,
      693,
      875,
      45
    ],
    "source": ""
  },
  {
    "id": 2935,
    "question": "Which accounts are typically assessed during an account management assessment?",
    "choice_a": "A random sample",
    "choice_b": "Highly privileged accounts",
    "choice_c": "Recently generated accounts",
    "choice_d": "Accounts that have existed for long periods of time",
    "correct_answer": "B",
    "explanation": "The most frequent target of account management reviews are highly privileged accounts, as they create the greatest risk. Random samples are the second most likely choice. Accounts that have existed for a longer period of time are more likely to have a problem due to privilege creep than recently created accounts, but neither of these choices is likely unless there is a specific organizational reason to choose them.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      499,
      502,
      768,
      862,
      1007
    ],
    "source": ""
  },
  {
    "id": 2936,
    "question": "Cloud computing uses a shared responsibility model for security, where the vendor and customer both bear some responsibility for security. The division of responsibility depends upon the type of service used. Place the cloud service offerings listed here in order from the case where the customer bears the <italic>least</italic> responsibility to where the customer bears the <italic>most</italic> responsibility. <ol><li>IaaS </li><li>SaaS </li><li>PaaS</li></ol>",
    "choice_a": "1, 2, 3",
    "choice_b": "2, 1, 3",
    "choice_c": "3, 2, 1",
    "choice_d": "2, 3, 1",
    "correct_answer": "D",
    "explanation": "The cloud service offerings in order from the case where the customer bears the least responsibility to where the customer bears the most responsibility are SaaS, PaaS, and IaaS. In an infrastructure as a service (IaaS) cloud computing model, the customer retains responsibility for managing operating system and application security, while the vendor manages security at the hypervisor level and below. In a platform as a service (PaaS) environment, the vendor takes on responsibility for the operating system, but the customer writes and configures any applications. In a software as a service (SaaS) environment, the vendor takes on responsibility for the development and implementation of the application while the customer merely configures security settings within the application.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      230,
      211,
      267,
      202,
      208
    ],
    "source": ""
  },
  {
    "id": 2938,
    "question": "An emergency button under the desk is a common example of what type of physical security system?",
    "choice_a": "An airgap button",
    "choice_b": "A keylogger",
    "choice_c": "A pushbutton lock",
    "choice_d": "A duress system",
    "correct_answer": "D",
    "explanation": "Duress systems are intended to allow employees to notify security or others when they are in a dangerous situation or when they need help. Duress systems may be as simple as a push button and as complex as a code word or digital system that allows specific entries to trigger alarms while still performing a desired or deceptive but real-appearing action.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      509,
      508,
      510,
      505,
      533
    ],
    "source": ""
  },
  {
    "id": 2939,
    "question": "Henry runs Nikto against an Apache web server and receives the output shown here. <br><img src=\"/question_assets/CISSP/10_image2.png\"/><br>Which of the following statements is the least important to include in his report?",
    "choice_a": "The missing clickjacking x-frame options could be used to redirect input to a malicious site or frame.",
    "choice_b": "Cross-site scripting protections should be enabled, but aren't.",
    "choice_c": "Inode information leakage from a Linux system is a critical vulnerability allowing direct access to the filesystem using node references.",
    "choice_d": "The server is a Linux server.",
    "correct_answer": "C",
    "explanation": "Exposing inode information is not as important as the other information shown. Clickjacking and cross-site scripting are both important issues, and knowing that the server is a Linux server is also important.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      860,
      861,
      497,
      494,
      502
    ],
    "source": ""
  },
  {
    "id": 2940,
    "question": "George is assisting a prosecutor with a case against a hacker who attempted to break into the computer systems at George's company. He provides system logs to the prosecutor for use as evidence, but the prosecutor insists that George testify in court about how he gathered the logs. <br>What rule of evidence requires George's testimony?",
    "choice_a": "Testimonial evidence rule",
    "choice_b": "Parol evidence rule",
    "choice_c": "Best evidence rule",
    "choice_d": "Hearsay rule",
    "correct_answer": "D",
    "explanation": "The hearsay rule says that a witness cannot testify about what someone else told them, except under very specific exceptions. The courts have applied the hearsay rule to include the concept that attorneys may not introduce logs into evidence unless they are authenticated by the system administrator. In this question, scenario George might also be able to provide a sworn affidavit, but the question doesn't include that option. The best evidence rule states that copies of documents may not be submitted into evidence if the originals are available. The parol evidence rule states that if two parties enter into a written agreement, that written document is assumed to contain all of the terms of the agreement. Testimonial evidence is a type of evidence, not a rule of evidence.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      602,
      601,
      615,
      541,
      556
    ],
    "source": ""
  },
  {
    "id": 2941,
    "question": "Which of the following is not a valid use for key risk indicators (KRIs)?",
    "choice_a": "Provide warnings before issues occur.",
    "choice_b": "Provide real-time incident response information.",
    "choice_c": "Provide historical views of past incidents.",
    "choice_d": "Provide insight into risk tolerance for the organization.",
    "correct_answer": "B",
    "explanation": "While key risk indicators can provide useful information for organizational planning and a deeper understanding of how organizations view risk, KRIs are not a great way to handle a real-time security response. Monitoring and detection systems like IPS, SIEM, and other tools are better suited to handling actual attacks.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      41,
      50,
      2,
      26,
      54
    ],
    "source": ""
  },
  {
    "id": 2942,
    "question": "Which one of the following malware types uses built-in propagation mechanisms that exploit system vulnerabilities to spread?",
    "choice_a": "Trojan horse",
    "choice_b": "Worm",
    "choice_c": "Logic bomb",
    "choice_d": "Virus",
    "correct_answer": "B",
    "explanation": "Worms have built-in propagation mechanisms that do not require user interaction, such as scanning for systems containing known vulnerabilities and then exploiting those vulnerabilities to gain access. Viruses and Trojan horses typically require user interaction to spread. Logic bombs do not spread from system to system but lie in wait until certain conditions are met, triggering the delivery of their payload.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      568,
      550,
      566,
      532,
      544
    ],
    "source": ""
  },
  {
    "id": 2943,
    "question": "As part of your company's security team, you have been asked to advise on how to ensure that media is not improperly used or stored. <br>What solution will help staff members in your organization to handle media appropriately?",
    "choice_a": "Labeling with sensitivity levels",
    "choice_b": "Encrypting the sensitive media",
    "choice_c": "Dual control media systems",
    "choice_d": "A clear desk policy",
    "correct_answer": "A",
    "explanation": "As simple as the answer may seem, labeling media or even color coding it with sensitivity levels and ensuring staff are appropriately trained on what the levels mean will normally have the biggest impact. Encrypting media can help, but without the labels, files may be stored on inappropriate media. A clear desk policy can help if casual media theft is an issue but is not likely to be an important control in this scenario. Dual control is used to ensure that a task cannot be performed by a single staff member to avoid malfeasance and is not directly useful here.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      515,
      516,
      518,
      511,
      535
    ],
    "source": ""
  },
  {
    "id": 2944,
    "question": "Alaina wants to use a broadly adopted threat modeling framework for her organization's threat intelligence efforts. <br>Which of the following would you advise her to adopt if she wants to use pre-existing tools to help her threat modeling team integrate both internally created intelligence and external threat feed data?",
    "choice_a": "The Diamond Model of Intrusion Analysis",
    "choice_b": "ATT&CK",
    "choice_c": "Microsoft's Threat-JUMP modeling system",
    "choice_d": "Threat-EN",
    "correct_answer": "B",
    "explanation": "MITRE's ATT&CK framework is broadly adopted by threat modeling and threat intelligence organizations and is used as a default model in many software packages and tools. The Diamond Model specifically addresses how to think about intrusions but does not address broader threats, and the other answers were made up for this question.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      24,
      23,
      50,
      49,
      27
    ],
    "source": ""
  },
  {
    "id": 2945,
    "question": "Which one of the following is not a principle of the Agile approach to software development?",
    "choice_a": "The most efficient method of conveying information is electronic.",
    "choice_b": "Working software is the primary measure of progress.",
    "choice_c": "Simplicity is essential.",
    "choice_d": "Businesspeople and developers must work together daily.",
    "correct_answer": "A",
    "explanation": "The Agile approach to software development states that working software is the primary measure of progress, that simplicity is essential, and that businesspeople and developers must work together daily. It also states that the most efficient method of conveying information is face to face, not electronic.",
    "topic_id": 8,
    "practice_test_id": 2,
    "related_articles": [
      1033,
      622,
      1035,
      1034,
      640
    ],
    "source": ""
  },
  {
    "id": 2946,
    "question": "Harry is concerned that accountants within his organization will modify data to cover up fraudulent activity in accounts that they normally access. <br>Which one of the following controls would best defend against this type of attack?",
    "choice_a": "Encryption",
    "choice_b": "Access controls",
    "choice_c": "Integrity verification",
    "choice_d": "Firewalls",
    "correct_answer": "C",
    "explanation": "Encryption, access controls, and firewalls would not be effective in this example because the accountants have legitimate access to the data. Integrity verification software would protect against this attack by identifying unexpected changes in protected data.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      5,
      3,
      8,
      47,
      33
    ],
    "source": ""
  },
  {
    "id": 2948,
    "question": "Meena wants to ensure that her supply chain risks are well managed. <br>Which of the following is not a common practice she should include in her supply chain risk management (SCRM) plan?",
    "choice_a": "Use contractual controls such as insurance and liability limitations where appropriate.",
    "choice_b": "Sole source to provide vendor stability.",
    "choice_c": "Ensure multiple suppliers exist for critical components.",
    "choice_d": "Validate the financial stability of potential suppliers.",
    "correct_answer": "B",
    "explanation": "Sole sourcing can create additional fragility in supply chains due to reliance on a single supplier. Contractual controls including requirements for supplier insurance and liability limitations, having multiple suppliers, and validating their financial stability are all common ways to help reduce supply chain risk.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      27,
      28,
      52,
      46,
      20
    ],
    "source": ""
  },
  {
    "id": 2949,
    "question": "Using the following table and your knowledge of the auditing process, answer below question. <br><img src=\"/question_assets/CISSP/10_image3.png\"/><br>As they prepare to migrate their data center to an infrastructure as a service (IaaS) provider, Susan's company wants to understand the effectiveness of their new provider's security, integrity, and availability controls. <br>What SOC report would provide them with the most detail, including input from the auditor on the effectiveness of controls at the IaaS provider?",
    "choice_a": "SOC 1.",
    "choice_b": "SOC 2.",
    "choice_c": "SOC 3.",
    "choice_d": "None of the SOC reports is suited to this, and they should request another form of report.",
    "correct_answer": "B",
    "explanation": "SOC 2 reports are released under NDA to select partners or customers and can provide detail on the controls and any issues they may have. A SOC 1 report would only provide financial control information, and a SOC 3 report provides less information since it is publicly available.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      794,
      795,
      793,
      768,
      1006
    ],
    "source": ""
  },
  {
    "id": 2950,
    "question": "Using the following table and your knowledge of the auditing process, answer below question. <br><img src=\"/question_assets/CISSP/10_image3.png\"/><br>Susan wants to ensure that the audit report that her organization requested includes input from an external auditor and  information about control implementation over a period of time. <br>What type of report should she request?",
    "choice_a": "SOC 2, Type 1",
    "choice_b": "SOC 3, Type 1",
    "choice_c": "SOC 2, Type 2",
    "choice_d": "SOC 3, Type 2",
    "correct_answer": "C",
    "explanation": "An SOC 2, Type 2 report includes information about a data center's security, availability, processing integrity, confidentiality, and privacy, and includes an auditor's opinion on the operational effectiveness of the controls. SOC 3 does not have types, and an SOC 2 Type 1 is only conducted at a point in time.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      794,
      767,
      793,
      1006,
      768
    ],
    "source": ""
  },
  {
    "id": 2951,
    "question": "Using the following table and your knowledge of the auditing process, answer below question. <br><img src=\"/question_assets/CISSP/10_image3.png\"/><br>When Susan requests an SOC 2 report, she receives an SOC 1 report. <br>What issue should Susan raise?",
    "choice_a": "SOC 1 reports only reveal publicly available information.",
    "choice_b": "SOC 1 reports cover financial data.",
    "choice_c": "SOC 1 reports only cover a point in time.",
    "choice_d": "SOC 1 reports only use a three-month period for testing.",
    "correct_answer": "B",
    "explanation": "Susan asked for a security controls report (SOC 2) and received a financial internal controls report (SOC 1). This question doesn't specify whether a Type 1 or Type 2 report is desired, but most security practitioners will prefer a Type 2 report if they can get it since it tests the actual controls and their implementation instead of their descriptions.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      794,
      766,
      795,
      767,
      1006
    ],
    "source": ""
  },
  {
    "id": 2953,
    "question": "Bell\u2013LaPadula is an example of what type of access control model?",
    "choice_a": "DAC",
    "choice_b": "RBAC",
    "choice_c": "MAC",
    "choice_d": "ABAC",
    "correct_answer": "C",
    "explanation": "Bell\u2013LaPadula uses security labels on objects and clearances for subjects and is therefore a MAC model. It does not use discretionary, rule-based, role-based, or attribute-based access control.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      217,
      214,
      213,
      201,
      219
    ],
    "source": ""
  },
  {
    "id": 2954,
    "question": "Martha is the information security officer for a small college and is responsible for safeguarding the privacy of student records. <br>What law most directly applies to her situation?",
    "choice_a": "HIPAA",
    "choice_b": "HITECH",
    "choice_c": "COPPA",
    "choice_d": "FERPA",
    "correct_answer": "D",
    "explanation": "The Family Educational Rights and Privacy Act (FERPA) protects the privacy of students in any educational institution that accepts any form of federal funding.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      126,
      143,
      120,
      851,
      142
    ],
    "source": ""
  },
  {
    "id": 2955,
    "question": "What U.S. federal law mandates the security of protected health information?",
    "choice_a": "FERPA",
    "choice_b": "SAFE Act",
    "choice_c": "GLBA",
    "choice_d": "HIPAA",
    "correct_answer": "D",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) mandates the protection of protected health information (PHI). The SAFE Act deals with mortgages, the Graham\u2013Leach\u2013Bliley Act (GLBA) covers financial institutions, and FERPA deals with student data.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      126,
      120,
      142,
      143,
      125
    ],
    "source": ""
  },
  {
    "id": 2957,
    "question": "Susan is configuring her network devices to use syslog. <br>What should she set to ensure that she is notified about issues but does not receive normal operational issue messages?",
    "choice_a": "The facility code",
    "choice_b": "The log priority",
    "choice_c": "The security level",
    "choice_d": "The severity level",
    "correct_answer": "D",
    "explanation": "Implementations of syslog vary, but most provide a setting for severity level, allowing configuration of a value that determines what messages are sent. Typical severity levels include debug, informational, notice, warning, error, critical, alert, and emergency. The facility code is also supported by syslog, but is associated with which services are being logged. Security level and log priority are not typical syslog settings.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      557,
      558,
      843,
      538,
      548
    ],
    "source": ""
  },
  {
    "id": 2958,
    "question": "What RAID level is also known as disk mirroring?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 3",
    "choice_d": "RAID 5",
    "correct_answer": "B",
    "explanation": "In RAID 1, also known as disk mirroring, systems contain two physical disks. Each disk contains copies of the same data, and either one may be used in the event the other disk fails.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      576,
      836,
      835,
      572,
      598
    ],
    "source": ""
  },
  {
    "id": 2959,
    "question": "Isaac recently purchased a 48 port switch from his switch vendor. The switch vendor has announced that the model of switch that Isaac purchased will reach end of life next year. <br>What does this tell Isaac about the devices?",
    "choice_a": "The devices will stop being sold next year.",
    "choice_b": "The devices will stop functioning next year.",
    "choice_c": "The devices will no longer be supported next year.",
    "choice_d": "The devices will be supported for a minimum of three more years.",
    "correct_answer": "A",
    "explanation": "Most vendors use the term <italic>end of life</italic>, or EOL, to denote when the product will stop being sold. End of support typically comes sometime after end of life, and this problem does not specify when end of support (EOS) will occur. Devices will still function after end of life and likely after end of support, but security professionals should raise concerns about the security of devices or software after the end of support because patches and updates will likely no longer be available.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      877,
      847,
      849,
      133,
      879
    ],
    "source": ""
  },
  {
    "id": 2960,
    "question": "Surveys, interviews, and audits are all examples of ways to measure what important part of an organization's security posture?",
    "choice_a": "Code quality",
    "choice_b": "Service vulnerabilities",
    "choice_c": "Awareness",
    "choice_d": "Attack surface",
    "correct_answer": "C",
    "explanation": "Interviews, surveys, and audits are all useful for assessing awareness. Code quality is best judged by code review, service vulnerabilities are tested using vulnerability scanners and related tools, and the attack surface of an organization requires both technical and administrative review.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      40,
      47,
      2,
      13,
      11
    ],
    "source": ""
  },
  {
    "id": 2963,
    "question": "Fred's new employer has hired him for a position with access to their trade secrets and confidential internal data. <br>What legal tool should they use to help protect their data if he chooses to leave to work at a competitor?",
    "choice_a": "A stop-loss order",
    "choice_b": "An NDA",
    "choice_c": "An AUP",
    "choice_d": "Encryption",
    "correct_answer": "B",
    "explanation": "A nondisclosure agreement (NDA) is a legal agreement between two parties that specifies what data they will not disclose. NDAs are common in industries that have sensitive or trade secret information they do not want employees to take to new jobs. Encryption would only help in transit or at rest, and Fred will likely have access to the data in unencrypted form as part of his job. An AUP is an acceptable use policy, and a stop-loss order is used on the stock market.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      35,
      104,
      39,
      20,
      1
    ],
    "source": ""
  },
  {
    "id": 2964,
    "question": "Mark's company is involved in a civil case. <br>What evidentiary standard is he likely to need to meet?",
    "choice_a": "The real evidence standard",
    "choice_b": "Beyond a reasonable doubt",
    "choice_c": "Preponderance of evidence",
    "choice_d": "The documentary evidence standard",
    "correct_answer": "C",
    "explanation": "Civil cases typically rely on a preponderance of evidence. Criminal cases must be proven beyond a reasonable doubt. Real evidence is object evidence\u2014tangible things that can be brought into a court of law. Documentary evidence are written items used to prove facts. Neither of these is an evidentiary standard; instead, they describe types of evidence.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      981,
      98,
      100,
      97,
      979
    ],
    "source": ""
  },
  {
    "id": 2965,
    "question": "How many possible keys exist when using a cryptographic algorithm that has an 8-bit binary encryption key?",
    "choice_a": "16",
    "choice_b": "128",
    "choice_c": "256",
    "choice_d": "512",
    "correct_answer": "C",
    "explanation": "Binary keyspaces contain a number of keys equal to 2 raised to the power of the number of bits. Two to the eighth power is 256, so an 8-bit keyspace contains 256 possible keys.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      146,
      152,
      147,
      157,
      160
    ],
    "source": ""
  },
  {
    "id": 2966,
    "question": "What activity is being performed when you apply security controls based on the specific needs of the IT system that they will be applied to?",
    "choice_a": "Standardizing",
    "choice_b": "Baselining",
    "choice_c": "Scoping",
    "choice_d": "Editing",
    "correct_answer": "C",
    "explanation": "Scoping is the process of reviewing and selecting security controls based on the system that they will be applied to. Editing is not a commonly used term in this context. Baselines are used as a base set of security controls, often from a third-party organization that creates them. Standardization isn't a relevant term here.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      141,
      698,
      140,
      142,
      143
    ],
    "source": ""
  },
  {
    "id": 2968,
    "question": "Ben's job is to ensure that data is labeled with the appropriate sensitivity label. Since Ben works for the U.S. government, he has to apply the labels Unclassified, Confidential, Secret, and Top Secret to systems and media. If Ben is asked to label a system that handles Secret, Confidential, and Unclassified information, how should he label it?",
    "choice_a": "Mixed classification",
    "choice_b": "Confidential",
    "choice_c": "Top Secret",
    "choice_d": "Secret",
    "correct_answer": "D",
    "explanation": "Systems and media should be labeled with the highest level of sensitivity that they store or handle. In this case, based on the U.S. government classification scheme, the highest classification level in use on the system is Secret. Mixed classification provides no useful information about the level, whereas Top Secret and Confidential are too high and too low, respectively.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      121,
      123,
      128,
      143,
      697
    ],
    "source": ""
  },
  {
    "id": 2969,
    "question": "Susan has discovered that the smart card\u2013based locks used to keep the facility she works at secure are not effective because staff members are propping the doors open. She places signs on the doors reminding staff that leaving the door open creates a security issue, and she adds alarms that will sound if the doors are left open for more than five minutes. <br>What type of controls has she put into place?",
    "choice_a": "Physical",
    "choice_b": "Administrative",
    "choice_c": "Compensating",
    "choice_d": "Recovery",
    "correct_answer": "C",
    "explanation": "She has placed compensation controls in place. Compensation controls are used when controls like the locks in this example are not sufficient. While the alarm is a physical control, the signs she posted are not. Similarly, the alarms are not administrative controls. None of these controls helps to recover from an issue, and they are thus not recovery controls.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      47,
      48,
      65,
      40,
      8
    ],
    "source": ""
  },
  {
    "id": 2972,
    "question": "Lucca's manager does not want to adopt an open source software package for their organization's web application stack. <br>What software security advantage is the most important when considering open source software packages?",
    "choice_a": "The fact that the code is not compiled",
    "choice_b": "The fact the code is free",
    "choice_c": "The ability to inspect the code",
    "choice_d": "The ability to change the code",
    "correct_answer": "C",
    "explanation": "The ability to inspect open source software means that organizations can inspect it, but more importantly that others can and often have also inspected it. This results in software that has had far more review than some closed-source or commercial packages (although large organizations may perform more review). The ability to change the code can sometimes be important as well, but changing open source code in-house can create maintenance issues in the future. Open source software may be compiled, but the source will still be available. The code being free is not a security advantage or disadvantage.",
    "topic_id": 8,
    "practice_test_id": 2,
    "related_articles": [
      961,
      670,
      816,
      618,
      963
    ],
    "source": ""
  },
  {
    "id": 2973,
    "question": "As part of hiring a new employee, Kathleen's identity management team creates a new user object and ensures that the user object is available in the directories and systems where it is needed. <br>What is this process called?",
    "choice_a": "Registration",
    "choice_b": "Provisioning",
    "choice_c": "Population",
    "choice_d": "Authenticator loading",
    "correct_answer": "B",
    "explanation": "Provisioning includes the creation, maintenance, and removal of user objects from applications, systems, and directories. Registration occurs when users are enrolled in a biometric system; population and authenticator loading are not common industry terms.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      455,
      760,
      458,
      460,
      442
    ],
    "source": ""
  },
  {
    "id": 2974,
    "question": "What phase of the change management process for software occurs when changes are finalized?",
    "choice_a": "Request control",
    "choice_b": "Configuration control",
    "choice_c": "Release control",
    "choice_d": "Change control",
    "correct_answer": "C",
    "explanation": "Release control occurs after changes are finalized. With changes that are ready to be implemented in hand, release managers can follow their process with steps that typically include removing debugging code and conducting acceptance testing. Request control is the start of a process that allows users to submit change requests, while change control handles the process of ensuring quality assurance happens, that documentation is done, and that security testing is handled. Finally, configuration control is part of software configuration management, not the change process.",
    "topic_id": 8,
    "practice_test_id": 2,
    "related_articles": [
      624,
      625,
      640,
      626,
      628
    ],
    "source": ""
  },
  {
    "id": 2975,
    "question": "Alice is designing a cryptosystem for use by six users and would like to use a symmetric encryption algorithm. She wants any two users to be able to communicate with each other without worrying about eavesdropping by a third user. <br>How many symmetric encryption keys will she need to generate?",
    "choice_a": "6",
    "choice_b": "12",
    "choice_c": "15",
    "choice_d": "30",
    "correct_answer": "C",
    "explanation": "The formula for determining the number of encryption keys required by a symmetric algorithm is ((n*(n \u2212 1))/2). With six users, you will need ((6*5)/2), or 15 keys.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      153,
      154,
      165,
      152,
      184
    ],
    "source": ""
  },
  {
    "id": 2976,
    "question": "Which one of the following intellectual property protection mechanisms has the shortest duration in the United States?",
    "choice_a": "Copyright",
    "choice_b": "Patent",
    "choice_c": "Trademark",
    "choice_d": "Trade secret",
    "correct_answer": "B",
    "explanation": "Patents have the shortest duration of the techniques listed: at most, 20 years. Copyrights last for 70 years beyond the death of the author if owned by an individual, or 95 years from publication or 120 years from creation if owned by a corporation. Trademarks are renewable indefinitely, and trade secrets are protected as long as they remain secret.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      987,
      104,
      103,
      1053,
      1
    ],
    "source": ""
  },
  {
    "id": 2977,
    "question": "Gordon is developing a business continuity plan for a manufacturing company's IT operations. The company is located in North Dakota and currently evaluating the risk of earthquake. They choose to pursue a risk acceptance strategy. <br>Which one of the following actions is consistent with that strategy?",
    "choice_a": "Purchasing earthquake insurance",
    "choice_b": "Relocating the data center to a safer area",
    "choice_c": "Documenting the decision-making process",
    "choice_d": "Reengineering the facility to withstand the shock of an earthquake",
    "correct_answer": "C",
    "explanation": "In a risk acceptance strategy, the organization chooses to take no action other than documenting the risk. Purchasing insurance would be an example of risk transference. Relocating the data center would be risk avoidance. Reengineering the facility is an example of a risk mitigation strategy.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      46,
      41,
      49,
      70,
      44
    ],
    "source": ""
  },
  {
    "id": 2978,
    "question": "Carol would like to implement a control that protects her organization from the momentary loss of power to the data center. <br>Which control is most appropriate for her needs?",
    "choice_a": "Redundant servers",
    "choice_b": "RAID",
    "choice_c": "UPS",
    "choice_d": "Generator",
    "correct_answer": "C",
    "explanation": "Uninterruptible power supplies (UPSs) provide immediate, battery-driven power for a short period of time to cover momentary losses of power. Generators are capable of providing backup power for a sustained period of time in the event of a power loss, but they take time to activate. RAID and redundant servers are high-availability controls but do not cover power loss scenarios.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      312,
      917,
      918,
      916,
      324
    ],
    "source": ""
  },
  {
    "id": 2979,
    "question": "Ben has encountered problems with users in his organization reusing passwords, despite a requirement that they change passwords every 30 days. <br>What type of password setting should Ben employ to help prevent this issue?",
    "choice_a": "Longer minimum age",
    "choice_b": "Increased password complexity",
    "choice_c": "Implement password history",
    "choice_d": "Implement password length requirements",
    "correct_answer": "C",
    "explanation": "Password histories retain a list of previous passwords, preferably a list of salted hashes for previous passwords, to ensure that users don't reuse their previous passwords. Longer minimum age can help prevent users from changing their passwords and then changing them back but won't prevent a determined user from eventually getting their old password back. Length requirements and complexity requirements tend to drive users to reuse passwords if they're not paired with tools like single sign-on, password storage systems, or other tools that decrease the difficulty of password management.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      447,
      908,
      489,
      1058,
      451
    ],
    "source": ""
  },
  {
    "id": 2980,
    "question": "Chris is conducting a risk assessment for his organization and has determined the amount of damage that a single flood could be expected to cause to his facilities. <br>What metric has Chris identified?",
    "choice_a": "ALE",
    "choice_b": "SLE",
    "choice_c": "ARO",
    "choice_d": "AV",
    "correct_answer": "B",
    "explanation": "The Single Loss Expectancy (SLE) is the amount of damage that a risk is expected to cause each time that it occurs.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      86,
      695,
      875,
      935,
      694
    ],
    "source": ""
  },
  {
    "id": 2981,
    "question": "The removal of a hard drive from a PC before it is retired and sold as surplus is an example of what type of action?",
    "choice_a": "Purging",
    "choice_b": "Sanitization",
    "choice_c": "Degaussing",
    "choice_d": "Destruction",
    "correct_answer": "B",
    "explanation": "Sanitization includes steps such as removing the hard drive and other local storage from PCs before they are sold as surplus. Degaussing uses magnetic fields to wipe media; purging is an intense form of clearing used to ensure that data is removed and unrecoverable from media; and removing does not necessarily imply destruction of the drive.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      129,
      1026,
      130,
      133,
      144
    ],
    "source": ""
  },
  {
    "id": 2982,
    "question": "During which phase of the incident response process would an organization determine whether it is required to notify law enforcement officials or other regulators of the incident?",
    "choice_a": "Detection",
    "choice_b": "Recovery",
    "choice_c": "Remediation",
    "choice_d": "Reporting",
    "correct_answer": "D",
    "explanation": "During the Reporting phase, incident responders assess their obligations under laws and regulations to report the incident to government agencies and other regulators.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      539,
      537,
      605,
      541,
      565
    ],
    "source": ""
  },
  {
    "id": 2983,
    "question": "Every 90 days, the staff in Charles's department at his bank switch tasks as part of the organization's normal processes to ensure that an individual does not exploit their privileges. <br>What security practice is his organization engaging in?",
    "choice_a": "Dual control",
    "choice_b": "Job rotation",
    "choice_c": "Cross-training",
    "choice_d": "Offboarding",
    "correct_answer": "B",
    "explanation": "The bank that Charles works at is using job rotation to ensure that employees are not exploiting the rights and permissions that they have in their roles. The practice is intended to allow the next person in the role to identify irregularities and to prevent individuals from hiding malfeasance. Dual control requires two or more staff members to complete a task to ensure that a single employee cannot abuse their role. Cross-training is used to ensure that multiple staff members have the skills needed to perform a task or role so the loss of a staff member does not cause the organization's inability to perform the service.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      535,
      503,
      611,
      511,
      612
    ],
    "source": ""
  },
  {
    "id": 2984,
    "question": "Michelle is in charge of her organization's mobile device management efforts and handles lost and stolen devices. <br>Which of the following recommendations will provide the most assurance to her organization that data will not be lost if a device is stolen?",
    "choice_a": "Mandatory passcodes and application management",
    "choice_b": "Full device encryption and mandatory passcodes",
    "choice_c": "Remote wipe and GPS tracking",
    "choice_d": "Enabling GPS tracking and full device encryption",
    "correct_answer": "B",
    "explanation": "While full device encryption doesn't guarantee that data cannot be accessed, it provides Michelle's best option for preventing data from being lost with a stolen device when paired with a passcode. Mandatory passcodes and application management can help prevent application-based attacks and unwanted access to devices, but won't keep the data secure if the device is lost. Remote wipe and GPS location is useful if the thief allows the device to connect to a cellular or WiFi network. Unfortunately, many modern thieves immediately take steps to ensure that the device will not be trackable or allowed to connect to a network before they capture data or wipe the device for resale.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      278,
      185,
      277,
      279,
      285
    ],
    "source": ""
  },
  {
    "id": 2985,
    "question": "Susan's SMTP server does not authenticate senders before accepting and relaying email. <br>What is this security configuration issue known as?",
    "choice_a": "An email gateway",
    "choice_b": "An SMTP relay",
    "choice_c": "An X.400-compliant gateway",
    "choice_d": "An open relay",
    "correct_answer": "D",
    "explanation": "SMTP servers that don't authenticate users before relaying their messages are known as open relays. Open relays that are internet-exposed are typically quickly exploited to send email for spammers.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      204,
      942,
      940,
      186,
      208
    ],
    "source": ""
  },
  {
    "id": 2986,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>When the breach was discovered and the logs were reviewed, it was discovered that the attacker had purged the logs on the system that they compromised. <br>How can this be prevented in the future?",
    "choice_a": "Encrypt local logs.",
    "choice_b": "Require administrative access to change logs.",
    "choice_c": "Enable log rotation.",
    "choice_d": "Send logs to a bastion host.",
    "correct_answer": "D",
    "explanation": "Sending logs to a secure log server, sometimes called a bastion host, is the most effective way to ensure that logs survive a breach. Encrypting local logs won't stop an attacker from deleting them, and requiring administrative access won't stop attackers who have breached a machine and acquired escalated privileges. Log rotation archives logs based on time or file size and can also purge logs after a threshold is hit. Rotation won't prevent an attacker from purging logs.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      556,
      554,
      538,
      611,
      522
    ],
    "source": ""
  },
  {
    "id": 2987,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>How can Jack detect issues such as this using his organization's new centralized logging?",
    "choice_a": "Deploy and use an IDS.",
    "choice_b": "Send logs to a central logging server.",
    "choice_c": "Deploy and use a SIEM.",
    "choice_d": "Use syslog.",
    "correct_answer": "C",
    "explanation": "A security information and event management (SIEM) tool is designed to provide automated analysis and monitoring of logs and security events. A SIEM tool that receives access to logs can help detect and alert on events such as logs being purged or other breach indicators. An IDS can help detect intrusions, but IDSs are not typically designed to handle central logs. A central logging server can receive and store logs but won't help with analysis without taking additional actions. Syslog is simply a log format.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      557,
      554,
      558,
      556,
      538
    ],
    "source": ""
  },
  {
    "id": 2988,
    "question": "The large business that Jack works for has been using noncentralized logging for years. They have recently started to implement centralized logging, however, and as they reviewed logs, they discovered a breach that appeared to have involved a malicious insider. <br>How can Jack best ensure accountability for actions taken on systems in his environment?",
    "choice_a": "Log review and require digital signatures for each log.",
    "choice_b": "Require authentication for all actions taken and capture logs centrally.",
    "choice_c": "Log the use of administrative credentials and encrypt log data in transit.",
    "choice_d": "Require authorization and capture logs centrally.",
    "correct_answer": "B",
    "explanation": "Requiring authentication can help provide accountability by ensuring that any action taken can be tracked back to a specific user. Storing logs centrally ensures that users can't erase the evidence of actions that they have taken. Log review can be useful when identifying issues, but digital signatures are not a typical part of a logging environment. Logging the use of administrative credentials helps for those users but won't cover all users, and encrypting the logs doesn't help with accountability. Authorization helps, but being able to specifically identify users through authentication is more important.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      554,
      556,
      557,
      602,
      606
    ],
    "source": ""
  },
  {
    "id": 2989,
    "question": "Ed's organization has 5 IP addresses allocated to them by their ISP but needs to connect more than 100 computers and network devices to the internet. <br>What technology can he use to connect his entire network via the limited set of IP addresses he can use?",
    "choice_a": "IPsec",
    "choice_b": "PAT",
    "choice_c": "SDN",
    "choice_d": "IPX",
    "correct_answer": "B",
    "explanation": "Port Address Translation (PAT) is used to allow a network to use any IP address set inside without causing a conflict with the public internet. PAT is often confused with Network Address Translation (NAT), which maps one internal address to one external address. IPsec is a security protocol suite, software-defined networking (SDN) is a method of defining networks programmatically, and IPX is a non-IP network protocol.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      424,
      423,
      736,
      425,
      949
    ],
    "source": ""
  },
  {
    "id": 2990,
    "question": "What type of attack would the following precautions help prevent?<li>Requesting proof of identity</li><li>Requiring callback authorizations on voice-only requests</li><li>Not changing passwords via voice communications</li>",
    "choice_a": "DoS attacks",
    "choice_b": "Worms",
    "choice_c": "Social engineering",
    "choice_d": "Shoulder surfing",
    "correct_answer": "C",
    "explanation": "Each of the precautions listed helps to prevent social engineering by helping prevent exploitation of trust. Avoiding voice-only communications is particularly important, since establishing identity over the phone is difficult. The other listed attacks would not be prevented by these techniques.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      58,
      56,
      55,
      71,
      61
    ],
    "source": ""
  },
  {
    "id": 2991,
    "question": "The CIS benchmarks are an example of what sort of compliance tool?",
    "choice_a": "A security baseline",
    "choice_b": "A compliance standard",
    "choice_c": "A secure provisioning tool",
    "choice_d": "A security automation tool",
    "correct_answer": "A",
    "explanation": "The CIS benchmarks provide a useful security standard and baseline to assess systems against or to configure them to. Organizations can adapt and modify the baseline to meet their specific needs while speeding up deployment by using an accepted industry standard. They are not a compliance standard and do not provide provisioning or automation, but tools that do may use the benchmark as a standard to do so.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      524,
      798,
      523,
      525,
      529
    ],
    "source": ""
  },
  {
    "id": 2992,
    "question": "Residual data is another term for what type of data left after attempts have been made to erase it?",
    "choice_a": "Leftover data",
    "choice_b": "MBR",
    "choice_c": "Bitrot",
    "choice_d": "Remnant data",
    "correct_answer": "D",
    "explanation": "Remnant data is data that is left after attempts have been made to remove or erase it. Bitrot is a term used to describe aging media that decays over time. MBR is the master boot record, a boot sector found on hard drives and other media. Leftover data is not an industry term.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      130,
      144,
      129,
      1024,
      1025
    ],
    "source": ""
  },
  {
    "id": 2993,
    "question": "Which one of the following disaster recovery test types involves the actual activation of the disaster recovery facility?",
    "choice_a": "Simulation test",
    "choice_b": "Tabletop exercise",
    "choice_c": "Parallel test",
    "choice_d": "Checklist review",
    "correct_answer": "C",
    "explanation": "During a parallel test, the team activates the disaster recovery site for testing, but the primary site remains operational. A simulation test involves a role-play of a prepared scenario overseen by a moderator. Responses are assessed to help improve the organization's response process. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      594,
      597,
      598,
      593,
      581
    ],
    "source": ""
  },
  {
    "id": 2994,
    "question": "What access control system lets owners decide who has access to the objects they own?",
    "choice_a": "Role-based access control",
    "choice_b": "Task-based access control",
    "choice_c": "Discretionary access control",
    "choice_d": "Rule-based access control",
    "correct_answer": "C",
    "explanation": "Discretionary access control gives owners the right to decide who has access to the objects they own. Role-based access control uses administrators to make that decision for roles or groups of people with a role, task-based access control uses lists of tasks for each user, and rule-based access control applies a set of rules to all subjects.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      465,
      472,
      493,
      466,
      468
    ],
    "source": ""
  },
  {
    "id": 2995,
    "question": "Using a trusted channel and link encryption are both ways to prevent what type of access control attack?",
    "choice_a": "Brute force",
    "choice_b": "Spoofed login screens",
    "choice_c": "Man-in-the-middle attacks",
    "choice_d": "Dictionary attacks",
    "correct_answer": "C",
    "explanation": "Trusted paths that secure network traffic from capture and link encryption are both ways to help prevent man-in-the-middle attacks. Brute-force and dictionary attacks can both be prevented using back-off algorithms that slow down repeated attacks. Log analysis tools can also create dynamic firewall rules, or an IPS can block attacks like these in real time. Spoofed login screens can be difficult to prevent, although user awareness training can help.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      190,
      187,
      181,
      215,
      213
    ],
    "source": ""
  },
  {
    "id": 2996,
    "question": "Which one of the following is not one of the canons of the ISC2 Code of Ethics?",
    "choice_a": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_b": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_c": "Provide diligent and competent service to principals.",
    "choice_d": "Maintain competent records of all investigations and assessments.",
    "correct_answer": "D",
    "explanation": "The four canons of the ISC2 Code of Ethics are to protect society, the common good, the necessary public trust and confidence, and the infrastructure; act honorably, honestly, justly, responsibly, and legally; provide diligent and competent service to principals; and advance and protect the profession.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      955,
      956,
      957,
      15,
      14
    ],
    "source": ""
  },
  {
    "id": 2997,
    "question": "Which one of the following components should be included in an organization's emergency response guidelines?",
    "choice_a": "Immediate response procedures",
    "choice_b": "Long-term business continuity protocols",
    "choice_c": "Activation procedures for the organization's cold sites",
    "choice_d": "Contact information for ordering equipment",
    "correct_answer": "A",
    "explanation": "The emergency response guidelines should include the immediate steps an organization should follow in response to an emergency situation. These include immediate response procedures, a list of individuals who should be notified of the emergency, and secondary response procedures for first responders. They do not include long-term actions such as activating business continuity protocols, ordering equipment, or activating DR sites.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      587,
      538,
      537,
      581,
      561
    ],
    "source": ""
  },
  {
    "id": 2998,
    "question": "Ben is working on integrating a federated identity management system and needs to exchange authentication and authorization information for browser-based single sign-on. <br>What technology is his best option?",
    "choice_a": "HTML",
    "choice_b": "XACML",
    "choice_c": "SAML",
    "choice_d": "SPML",
    "correct_answer": "C",
    "explanation": "Security Assertion Markup Language (SAML) is the best choice for providing authentication and authorization information, particularly for browser-based SSO. HTML is primarily used for web pages, SPML is used to exchange user information for SSO, and XACML is used for access control policy markup.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      474,
      476,
      480,
      451,
      481
    ],
    "source": ""
  },
  {
    "id": 2999,
    "question": "What is the minimum interval at which an organization should conduct business continuity plan refresher training for those with specific business continuity roles?",
    "choice_a": "Weekly",
    "choice_b": "Monthly",
    "choice_c": "Semiannually",
    "choice_d": "Annually",
    "correct_answer": "D",
    "explanation": "Individuals with specific business continuity roles should receive training on at least an annual basis.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      92,
      94,
      80,
      932,
      931
    ],
    "source": ""
  },
  {
    "id": 3000,
    "question": "What three types of interfaces are typically tested during software testing?",
    "choice_a": "Network, physical, and application interfaces",
    "choice_b": "APIs, UIs, and physical interfaces",
    "choice_c": "Network interfaces, APIs, and UIs",
    "choice_d": "Application, programmatic, and user interfaces",
    "correct_answer": "B",
    "explanation": "Application programming interfaces (APIs), user interfaces (UIs), and physical interfaces are all tested during the software testing process. Network interfaces are not typically tested, and programmatic interfaces is another term for APIs.",
    "topic_id": 8,
    "practice_test_id": 2,
    "related_articles": [
      626,
      627,
      892,
      826,
      962
    ],
    "source": ""
  },
  {
    "id": 3003,
    "question": "Ben is selecting an encryption algorithm for use in an organization with 10,000 employees. He must facilitate communication between any two employees within the organization. <br>Which one of the following algorithms would allow him to meet this goal with the least time dedicated to key management?",
    "choice_a": "RSA",
    "choice_b": "IDEA",
    "choice_c": "3DES",
    "choice_d": "Skipjack",
    "correct_answer": "A",
    "explanation": "RSA is an asymmetric encryption algorithm that requires only two keys for each user. IDEA, 3DES, and Skipjack are all symmetric encryption algorithms and would require a key for every unique pair of users in the system.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      154,
      165,
      153,
      167,
      168
    ],
    "source": ""
  },
  {
    "id": 3005,
    "question": "What type of log file is shown in this figure? <br><img src=\"/question_assets/CISSP/10_image5.png\"/>",
    "choice_a": "Application",
    "choice_b": "Web server",
    "choice_c": "System",
    "choice_d": "Firewall",
    "correct_answer": "D",
    "explanation": "The log entries contained in this example show the allow/deny status for inbound and outbound TCP and UDP sessions. This is, therefore, an example of a firewall log.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      554,
      841,
      557,
      551,
      558
    ],
    "source": ""
  },
  {
    "id": 3006,
    "question": "Which one of the following activities transforms a zero-day vulnerability into a less dangerous attack vector?",
    "choice_a": "Discovery of the vulnerability",
    "choice_b": "Implementation of transport-layer encryption",
    "choice_c": "Reconfiguration of a firewall",
    "choice_d": "Release of a security patch",
    "correct_answer": "D",
    "explanation": "Zero-day vulnerabilities remain in the dangerous zero-day category until the release of a patch that corrects the vulnerability. At that time, it becomes the responsibility of IT professionals to protect their systems by applying the patch. Implementation of other security controls, such as encryption or firewalls, does not change the nature of the zero-day vulnerability.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      530,
      529,
      531,
      873,
      544
    ],
    "source": ""
  },
  {
    "id": 3007,
    "question": "Elle's organization has had to shift to remote work. Each staff member needs access to specific applications, and due to the quick shift, staff members are working from systems that may be home systems or borrowed laptops. <br>What is the best option for remote access in a situation like the one that Elle is facing?",
    "choice_a": "An IPsec VPN",
    "choice_b": "A dedicated fiber connection to each remote work location",
    "choice_c": "An HTML5-based VPN",
    "choice_d": "Use of remote desktop to connect to an existing workstation at the company's office building",
    "correct_answer": "C",
    "explanation": "An HTML5-based VPN will provide Elle's staff with access to the applications they need without requiring the installation of a client that might be challenging or impossible without managed machines. A client-based IPsec VPN provides additional opportunities for control that a broadly deployed base of directly accessed machines via RDP do not, making it the second-best choice here. Deploying fiber for direct connections for end users is not viable for most organizations based on cost and complexity.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      399,
      411,
      401,
      427,
      416
    ],
    "source": ""
  },
  {
    "id": 3009,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>When Matthew sends Richard a message, what key should he use to encrypt the message?",
    "choice_a": "Matthew's public key",
    "choice_b": "Matthew's private key",
    "choice_c": "Richard's public key",
    "choice_d": "Richard's private key",
    "correct_answer": "C",
    "explanation": "The sender of a message encrypts the message using the public key of the message recipient.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      176,
      198,
      200,
      154,
      186
    ],
    "source": ""
  },
  {
    "id": 3010,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>When Richard receives the message from Matthew, what key should he use to decrypt the message?",
    "choice_a": "Matthew's public key",
    "choice_b": "Matthew's private key",
    "choice_c": "Richard's public key",
    "choice_d": "Richard's private key",
    "correct_answer": "D",
    "explanation": "The recipient of a message uses his or her own private key to decrypt messages that were encrypted with the recipient's public key. This ensures that nobody other than the intended recipient can decrypt the message.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      176,
      198,
      167,
      200,
      154
    ],
    "source": ""
  },
  {
    "id": 3011,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>Matthew would like to enhance the security of his communication by adding a digital signature to the message. <br>What goal of cryptography are digital signatures intended to enforce?",
    "choice_a": "Secrecy",
    "choice_b": "Availability",
    "choice_c": "Confidentiality",
    "choice_d": "Nonrepudiation",
    "correct_answer": "D",
    "explanation": "Digital signatures enforce nonrepudiation. They prevent individuals from denying that they were the actual originator of a message.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      175,
      145,
      154,
      200,
      177
    ],
    "source": ""
  },
  {
    "id": 3012,
    "question": "Matthew and Richard are friends located in different physical locations who would like to begin communicating with each other using cryptography to protect the confidentiality of their communications. They exchange digital certificates to begin this process and plan to use an asymmetric encryption algorithm for the secure exchange of email messages. <br>When Matthew goes to add the digital signature to the message, what encryption key does he use to create the digital signature?",
    "choice_a": "Matthew's public key",
    "choice_b": "Matthew's private key",
    "choice_c": "Richard's public key",
    "choice_d": "Richard's private key",
    "correct_answer": "B",
    "explanation": "An individual creates a digital signature by encrypting the message digest with their own private key.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      176,
      175,
      154,
      200,
      155
    ],
    "source": ""
  },
  {
    "id": 3013,
    "question": "When Jim logs into a system, his password is compared to a hashed value stored in a database. <br>What is this process?",
    "choice_a": "Identification",
    "choice_b": "Hashing",
    "choice_c": "Tokenization",
    "choice_d": "Authentication",
    "correct_answer": "D",
    "explanation": "The comparison of a factor to validate an identity is known as authentication. Identification would occur when Jim presented his user ID. Tokenization is a process that converts a sensitive data element to a nonsensitive representation of that element. Hashing transforms a string of characters into a fixed-length value or key that represents the original string.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      172,
      199,
      175,
      213,
      146
    ],
    "source": ""
  },
  {
    "id": 3014,
    "question": "What is the top priority for security professionals when considering facility design?",
    "choice_a": "Limiting access to only approved personnel",
    "choice_b": "Ensuring that  the structure supports least privilege",
    "choice_c": "Ensuring the safety of personnel",
    "choice_d": "Limiting the potential for weather or other natural disasters to impact operations",
    "correct_answer": "C",
    "explanation": "The most important item in facility design is the safety of personnel. Once designs take that into account, security, operational effectiveness, and other concerns can be addressed.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      322,
      324,
      302,
      304,
      303
    ],
    "source": ""
  },
  {
    "id": 3015,
    "question": "Which of the following types of controls does not describe a mantrap?",
    "choice_a": "Deterrent",
    "choice_b": "Preventive",
    "choice_c": "Compensating",
    "choice_d": "Physical",
    "correct_answer": "C",
    "explanation": "A mantrap, which is composed of two sets of doors with an access mechanism that allows only one door to open at a time, is an example of a preventive access control because it can stop unwanted access by keeping intruders from accessing a facility due to an opened door or following legitimate staff in. It can serve as a deterrent by discouraging intruders who would be trapped in it without proper access, and of course, doors with locks are an example of a physical control. A compensating control attempts to make up for problems with an existing control or to add additional controls to improve a primary control.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      543,
      533,
      535,
      912,
      508
    ],
    "source": ""
  },
  {
    "id": 3016,
    "question": "Sally's organization needs to be able to prove that certain staff members sent emails, and she wants to adopt a technology that will provide that capability without changing their existing email system. <br>What is the technical term for the capability Sally needs to implement as the owner of the email system, and what tool could she use to do it?",
    "choice_a": "Integrity; IMAP",
    "choice_b": "Repudiation; encryption",
    "choice_c": "Nonrepudiation; digital signatures",
    "choice_d": "Authentication; DKIM",
    "correct_answer": "C",
    "explanation": "Sally needs to provide nonrepudiation, the ability to provably associate a given email with a sender. Digital signatures can provide nonrepudiation and are her best option. IMAP is a mail protocol, encryption can provide confidentiality, and DKIM is a tool for identifying domains that send email.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      175,
      145,
      186,
      154,
      179
    ],
    "source": ""
  },
  {
    "id": 3017,
    "question": "Which one of the following background checks is not normally performed during normal pre-hire activities?",
    "choice_a": "Credit check",
    "choice_b": "Reference verification",
    "choice_c": "Criminal records check",
    "choice_d": "Medical records check",
    "correct_answer": "D",
    "explanation": "In most situations, employers may not access medical information due to healthcare privacy laws. Reference checks, criminal records checks, and credit history reports are all typically found during pre-employment background checks.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      34,
      68,
      105,
      1046,
      20
    ],
    "source": ""
  },
  {
    "id": 3018,
    "question": "Naomi's organization limits data access to only those users with roles that require it for their job. <br>What key security operations practice does this describe?",
    "choice_a": "Least privilege",
    "choice_b": "Privileged account management",
    "choice_c": "Job rotation",
    "choice_d": "Privilege escalation",
    "correct_answer": "A",
    "explanation": "Naomi's organization operates under the concept of least privilege. Individuals only receive the rights that they need to accomplish their task. This also means that the organization will need to ensure that those rights do not accrue to users over time and that they are changed or removed when user roles change. Privileged account management is the process of properly managing accounts with higher levels of privilege like administrative accounts. Job rotation moves employees between roles to ensure that they do not take advantage of the role and that a new set of eyes can help identify problems. Privilege escalation is the process of gaining additional rights when attacking systems or services.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      533,
      503,
      535,
      506,
      505
    ],
    "source": ""
  },
  {
    "id": 3019,
    "question": "In the OSI model, when a packet changes from a data stream to a segment or a datagram, what layer has it traversed?",
    "choice_a": "The Transport layer",
    "choice_b": "The Application layer",
    "choice_c": "The Data Link layer",
    "choice_d": "The Physical layer",
    "correct_answer": "A",
    "explanation": "When a data stream is converted into a segment (TCP) or a datagram (UDP), it transitions from the Session layer to the Transport layer. This change from a message sent to an encoded segment allows it to then traverse the Network layer.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      332,
      333,
      387,
      330,
      331
    ],
    "source": ""
  },
  {
    "id": 3020,
    "question": "Tommy handles access control requests for his organization. A user approaches him and explains that he needs access to the human resources database in order to complete a head-count analysis requested by the CFO. <br>What has the user demonstrated successfully to Tommy?",
    "choice_a": "Clearance",
    "choice_b": "Separation of duties",
    "choice_c": "Need to know",
    "choice_d": "Isolation",
    "correct_answer": "C",
    "explanation": "The user has successfully explained a valid need to know the data\u2014completing the report requested by the CFO requires this access. However, the user has not yet demonstrated that they have appropriate clearance to access the information. A note from the CFO would meet this requirement.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      470,
      441,
      462,
      457,
      471
    ],
    "source": ""
  },
  {
    "id": 3022,
    "question": "What type of tool is most frequently used to match assets to users and owners in enterprises?",
    "choice_a": "An enterprise content management tool",
    "choice_b": "Barcoded property tags",
    "choice_c": "RFID-based property tags",
    "choice_d": "A system inventory",
    "correct_answer": "D",
    "explanation": "A system inventory is most frequently used to associate individuals with systems or devices. This can help when tracking their support history and aids in provisioning the proper tools, permissions, and data to a system. Both barcode and RFID property tags are used to identify systems, which can then be checked against a system inventory. Finally, enterprise content management tools are used to manage files and data as part of workflows and other business processes.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      138,
      123,
      849,
      143,
      851
    ],
    "source": ""
  },
  {
    "id": 3023,
    "question": "Alice would like to add another object to a security model and grant herself rights to that object. <br>Which one of the rules in the Take-Grant protection model would allow her to complete this operation?",
    "choice_a": "Take rule",
    "choice_b": "Grant rule",
    "choice_c": "Create rule",
    "choice_d": "Remove rule",
    "correct_answer": "C",
    "explanation": "The create rule allows a subject to create new objects and also creates an edge from the subject to that object, granting rights on the new object.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      218,
      228,
      216,
      201,
      219
    ],
    "source": ""
  },
  {
    "id": 3024,
    "question": "Which of the following concerns should not be on Amanda's list of potential issues when penetration testers suggest using Metasploit during their testing?",
    "choice_a": "Metasploit can only test vulnerabilities it has plug-ins for.",
    "choice_b": "Penetration testing only covers a point-in-time view of the organization's security.",
    "choice_c": "Tools like Metasploit can cause denial-of-service issues.",
    "choice_d": "Penetration testing cannot test process and policy.",
    "correct_answer": "A",
    "explanation": "Metasploit provides an extensible framework, allowing penetration testers to create their own exploits in addition to those that are built into the tool. Unfortunately, penetration testing can only cover the point in time when it is conducted. When conducting a penetration test, the potential to cause a denial of service due to a fragile service always exists, but it can test process and policy through social engineering and operational testing that validates how those processes and policies work.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      1078,
      1080,
      771,
      502,
      777
    ],
    "source": ""
  },
  {
    "id": 3026,
    "question": "Which ITU-T standard should Alex expect to see in use when he uses his smart card to provide a certificate to an upstream authentication service?",
    "choice_a": "X.500",
    "choice_b": "SPML",
    "choice_c": "X.509",
    "choice_d": "SAML",
    "correct_answer": "C",
    "explanation": "X.509 defines standards for public key certificates like those used with many smartcards. X.500 is a series of standards defining directory services. The Service Provisioning Markup Language (SPML) and the Security Assertion Markup Language (SAML) aren't standards that Alex should expect to see when using a smartcard to authenticate.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      179,
      180,
      308,
      182,
      181
    ],
    "source": ""
  },
  {
    "id": 3027,
    "question": "What type of websites are regulated under the terms of COPPA?",
    "choice_a": "Financial websites not run by financial institutions",
    "choice_b": "Healthcare websites that collect personal information",
    "choice_c": "Websites that collect information from children",
    "choice_d": "Financial websites run by financial institutions",
    "correct_answer": "C",
    "explanation": "The Children's Online Privacy Protection Act (COPPA) regulates websites that cater to children or knowingly collect information from children under the age of 13.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      688,
      690,
      689,
      106,
      114
    ],
    "source": ""
  },
  {
    "id": 3028,
    "question": "Tracy recently accepted an IT compliance position at a federal government agency that works very closely with the Defense Department on classified government matters. <br>Which one of the following laws is least likely to pertain to Tracy's agency?",
    "choice_a": "HIPAA",
    "choice_b": "FISMA",
    "choice_c": "HSA",
    "choice_d": "CFAA",
    "correct_answer": "A",
    "explanation": "The Health Insurance Portability and Accountability Act (HIPAA) applies to healthcare information and is unlikely to apply in this situation. The Federal Information Security Management Act (FISMA) and Government Information Security Reform Act regulate the activities of all government agencies. The Homeland Security Act (HSA) created the U.S. Department of Homeland Security and, more importantly for this question, included the Cyber Security Enhancement Act of 2002 and the Critical Infrastructure Information Act of 2002. The Computer Fraud and Abuse Act (CFAA) provides specific protections for systems operated by government agencies.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      102,
      881,
      880,
      105,
      97
    ],
    "source": ""
  },
  {
    "id": 3030,
    "question": "What two important factors does accountability for access control rely on?",
    "choice_a": "Identification and authorization",
    "choice_b": "Authentication and authorization",
    "choice_c": "Identification and authentication",
    "choice_d": "Accountability and authentication",
    "correct_answer": "C",
    "explanation": "Access control systems rely on identification and authentication to provide accountability. Effective authorization systems are desirable, but not required, since logs can provide information about who accessed what resources, even if access to those resources is not managed well. Of course, poor authorization management can create many other problems.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      441,
      461,
      463,
      446,
      454
    ],
    "source": ""
  },
  {
    "id": 3031,
    "question": "What part of the CIA triad does a checksum support?",
    "choice_a": "Availability",
    "choice_b": "Integrity",
    "choice_c": "Confidentiality",
    "choice_d": "Authenticity",
    "correct_answer": "B",
    "explanation": "Checksums validate whether a file or other data object has been changed or modified, and thus, they support integrity.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      3,
      6,
      8,
      2,
      9
    ],
    "source": ""
  },
  {
    "id": 3032,
    "question": "Scott's organization has configured their external IP address to be 192.168.1.25. When traffic is sent to their ISP, it never reaches its destination. <br>What problem is Scott's organization encountering?",
    "choice_a": "BGP is not set up properly.",
    "choice_b": "They have not registered their IP with their ISP.",
    "choice_c": "The IP address is a private, nonroutable address.",
    "choice_d": "192.168.1.25 is a reserved address for home routers.",
    "correct_answer": "C",
    "explanation": "The IP address 192.168.1.25 falls within the 192.168.0.0 to 192.168.255.255 range, which is defined by RFC 1918 as a private, nonroutable IP address range. Traffic from these addresses is not routable over the public internet, which is why Scott's organization is encountering issues. ISPs and public networks will not route traffic originating from these private IP addresses.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      425,
      949,
      423,
      738,
      950
    ],
    "source": ""
  },
  {
    "id": 3033,
    "question": "Jack's organization merges updates to their main application multiple times a day and then deploys it as code that is checked in and tested through their software development pipeline. <br>What type of model is this?",
    "choice_a": "Waterfall",
    "choice_b": "CI/CD",
    "choice_c": "SCM",
    "choice_d": "IDE",
    "correct_answer": "B",
    "explanation": "Jack's organization is using a continuous integration/continuous deliver (CI/CD) model where the application is updated and deployed on an ongoing basis. This can allow for an agile application but requires strong testing and validation practices to ensure that bad code doesn't make it into production. Waterfall is a development model that is based on a slower, precise process. SCM is software configuration management, and an IDE is an integrated development environment.",
    "topic_id": 8,
    "practice_test_id": 2,
    "related_articles": [
      625,
      640,
      622,
      626,
      628
    ],
    "source": ""
  },
  {
    "id": 3034,
    "question": "Sue's organization recently failed a security assessment because their network was a single flat broadcast domain, and sniffing traffic was possible between different functional groups. <br>What solution should she recommend to help prevent the issues that were identified?",
    "choice_a": "Use VLANs.",
    "choice_b": "Change the subnet mask for all systems.",
    "choice_c": "Deploy gateways.",
    "choice_d": "Turn on port security.",
    "correct_answer": "A",
    "explanation": "A well-designed set of VLANs based on functional groupings will logically separate segments of the network, making it difficult to have data exposure issues between VLANs. Changing the subnet mask will only modify the broadcast domain and will not fix issues with packet sniffing. Gateways would be appropriate if network protocols were different on different segments. Port security is designed to limit which systems can connect to a given port.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      419,
      356,
      1013,
      436,
      378
    ],
    "source": ""
  },
  {
    "id": 3035,
    "question": "Fred's data role requires him to maintain system security plans and to ensure that system users and support staff get the training they need about security practices and acceptable use. <br>What is the role that Fred is most likely to hold in the organization?",
    "choice_a": "Data owner",
    "choice_b": "System owner",
    "choice_c": "User",
    "choice_d": "Custodian",
    "correct_answer": "B",
    "explanation": "NIST SP 800-18 describes system owner responsibilities that include helping to develop system security plans, maintaining the plan, ensuring training, and identifying, implementing, and assessing security controls. A data owner is more likely to delegate these tasks to the system owner. Custodians may be asked to enforce those controls, whereas a user will be directly affected by them.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      138,
      143,
      140,
      851,
      126
    ],
    "source": ""
  },
  {
    "id": 3036,
    "question": "Sally is using IPsec's ESP component in transport mode. <br>What important information should she be aware of about transport mode?",
    "choice_a": "Transport mode provides full encryption of the entire IP packet.",
    "choice_b": "Transport mode adds a new, unencrypted header to ensure that packets reach their destination.",
    "choice_c": "Transport mode does not encrypt the header of the packet.",
    "choice_d": "Transport mode provides no encryption; only tunnel mode provides encryption.",
    "correct_answer": "C",
    "explanation": "ESP's Transport mode encrypts IP packet data but leaves the packet header unencrypted. Tunnel mode encrypts the entire packet and adds a new header to support transmission through the tunnel.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      413,
      416,
      412,
      414,
      401
    ],
    "source": ""
  },
  {
    "id": 3037,
    "question": "Which one of the following is not an essential process area for the Repeatable phase of the Software Capability Maturity Model (SW-CMM)?",
    "choice_a": "Software Project Planning",
    "choice_b": "Software Quality Management",
    "choice_c": "Software Project Tracking",
    "choice_d": "Software Subcontract Management",
    "correct_answer": "B",
    "explanation": "In level 2, the Repeatable level of the SW-CMM, an organization introduces basic lifecycle management processes. Reuse of code in an organized fashion begins, and repeatable results are expected from similar projects. The crucial process areas for this level include Requirements Management, Software Project Planning, Software Project Tracking and Oversight, Software Subcontract Management, Software Quality Assurance, and Software Configuration Management. Software Quality Management is a process that occurs during level 4, the Managed stage of the SW-CMM.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      623,
      640,
      622,
      624,
      626
    ],
    "source": ""
  },
  {
    "id": 3038,
    "question": "Ben wants to provide predictive information about his organization's risk exposure in an automated way as part of an ongoing organizational risk management plan. <br>What should he use to do this?",
    "choice_a": "KRIs",
    "choice_b": "Quantitative risk assessments",
    "choice_c": "KPIs",
    "choice_d": "Penetration tests",
    "correct_answer": "A",
    "explanation": "Key risk indicators (KRIs) are often used to monitor risk for organizations that establish an ongoing risk management program. Using automated data gathering and tools that allow data to be digested and summarized can provide predictive information about how organizational risks are changing. KPIs are key performance indicators, which are used to assess how an organization is performing. Quantitative risk assessments are good for point-in-time views with detailed valuation and measurement-based risk assessments, whereas a penetration test would provide details of how well an organization's security controls are working.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      41,
      70,
      73,
      49,
      50
    ],
    "source": ""
  },
  {
    "id": 3039,
    "question": "In the image shown here, what does system B send to system A at step 2 of the three-way TCP handshake? <br><img src=\"/question_assets/CISSP/11_image1.png\"/>",
    "choice_a": "SYN",
    "choice_b": "ACK",
    "choice_c": "FIN/ACK",
    "choice_d": "SYN/ACK",
    "correct_answer": "D",
    "explanation": "The three-way handshake is SYN, SYN/ACK, ACK. System B should respond with \"Synchronize and Acknowledge\" to System A after it receives a SYN.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      883,
      869,
      724,
      885,
      337
    ],
    "source": ""
  },
  {
    "id": 3040,
    "question": "Chris is conducting reconnaissance on a remote target and discovers that pings are allowed through his target's border firewall. <br>What can he learn by using ping to probe the remote network?",
    "choice_a": "Which systems respond to ping, a rough network topology, and potentially the location of additional firewalls",
    "choice_b": "A list of all of the systems behind the target's firewall",
    "choice_c": "The hostnames and time to live (TTL) for each pingable system, and the ICMP types allowed through the firewall",
    "choice_d": "Router advertisements, echo request responses, and potentially which hosts are tarpitted",
    "correct_answer": "A",
    "explanation": "Systems that respond to ping will show the time to live for packets that reach them. Since TTL is decremented at each hop, this can help build a rough network topology map. In addition, some firewalls respond differently to ping than a normal system, which means pinging a network can sometimes reveal the presence of firewalls that would otherwise be invisible. Hostnames are revealed by a DNS lookup, and ICMP types allowed through a firewall are not revealed by only performing a ping. ICMP can be used for router advertisements, but pinging won't show them!",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      771,
      788,
      770,
      769,
      776
    ],
    "source": ""
  },
  {
    "id": 3041,
    "question": "Jake is conducting a review of his organization's identity and access management program. During his review, he is verifying the privileges assigned to each user and ensuring that they match with business requirements. <br>What element of the program is he reviewing?",
    "choice_a": "Identification",
    "choice_b": "Accountability",
    "choice_c": "Authorization",
    "choice_d": "Authentication",
    "correct_answer": "C",
    "explanation": "Authorization defines what a subject can or can't do. Identification occurs when a subject claims an identity, accountability is provided by the logs and audit trail that track what occurs on a system, and authentication occurs when that identity is validated.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      441,
      462,
      457,
      461,
      470
    ],
    "source": ""
  },
  {
    "id": 3042,
    "question": "Faith is looking at the <code>/etc/passwd</code> file on a system configured to use shadowed passwords. When she examines a line in the file for a user with interactive login permissions, what should she expect to see in the password field?",
    "choice_a": "Plaintext password",
    "choice_b": "Hashed password",
    "choice_c": "X",
    "choice_d": "*",
    "correct_answer": "C",
    "explanation": "When a system uses shadowed passwords, the hashed password value is stored in <code>/etc/shadow</code> instead of <code>/etc/passwd</code>. The <code>/etc/passwd</code> file would not contain the password in plaintext or hashed form. Instead, it would contain an x to indicate that the password hash is in the shadow file. The * character is normally used to disable interactive logins to an account.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      844,
      845,
      846,
      489,
      456
    ],
    "source": ""
  },
  {
    "id": 3043,
    "question": "Berta is analyzing the logs of the Windows Firewall on one of her servers and comes across the entries shown in this figure. <br>What type of attack do these entries indicate? <br><img src=\"/question_assets/CISSP/11_image2.png\"/>",
    "choice_a": "SQL injection",
    "choice_b": "Port scan",
    "choice_c": "Teardrop",
    "choice_d": "Land",
    "correct_answer": "B",
    "explanation": "The log entries show the characteristic pattern of a port scan. The attacking system sends connection attempts to the target system against a series of commonly used ports.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      393,
      375,
      885,
      868,
      333
    ],
    "source": ""
  },
  {
    "id": 3044,
    "question": "Danielle is testing tax software, and part of her testing process requires her to input a variety of actual tax forms to verify that the software produces the right answers. <br>What type of testing is Danielle performing?",
    "choice_a": "Use case testing",
    "choice_b": "Dynamic testing",
    "choice_c": "Fuzzing",
    "choice_d": "Misuse testing",
    "correct_answer": "A",
    "explanation": "Testing for desired functionality is use case testing. Dynamic testing is used to determine how code handles variables that change over time. Misuse testing focuses on how code handles examples of misuse, and fuzzing feeds unexpected data as an input to see how the code responds.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      494,
      775,
      777,
      496,
      778
    ],
    "source": ""
  },
  {
    "id": 3045,
    "question": "After 10 years working in her organization, Cassandra is moving into her fourth role, this time as a manager in the accounting department. <br>What issue is likely to show up during an account review if her organization does not have strong account maintenance practices?",
    "choice_a": "An issue with least privilege",
    "choice_b": "Privilege creep",
    "choice_c": "Account creep",
    "choice_d": "Account termination",
    "correct_answer": "B",
    "explanation": "Privilege creep is a common problem when employees change roles over time and their privileges and permissions are not properly modified to reflect their new roles. Least privilege issues are a design or implementation problem, and switching roles isn't typically what causes them to occur. Account creep is not a common industry term, and account termination would imply that someone has removed her account instead of switching her to new groups or new roles.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      457,
      458,
      466,
      927,
      1065
    ],
    "source": ""
  },
  {
    "id": 3046,
    "question": "IP addresses like 10.10.10.10 and 172.19.24.21 are both examples of what type of IP address?",
    "choice_a": "Public IP addresses",
    "choice_b": "Prohibited IP addresses",
    "choice_c": "Private IP addresses",
    "choice_d": "Class B IP ranges",
    "correct_answer": "C",
    "explanation": "These are examples of private IP addresses. RFC1918 defines a set of private IP addresses for use in internal networks. These private addresses including 10.0.0.0 to 10.255.255.255, 172.16.0.0 to 172.31.255.255, and 192.168.0.0 to 196.168.255.255 should never be routable on the public internet.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      949,
      425,
      423,
      950,
      736
    ],
    "source": ""
  },
  {
    "id": 3047,
    "question": "Ben is reviewing the password recovery mechanism used by his website and discovers that the approach uses cognitive authentication through the use of security questions. <br>What is the major issue with this approach?",
    "choice_a": "It prevents the use of tokens.",
    "choice_b": "The question's answer may be easy to find on the internet.",
    "choice_c": "Cognitive passwords require users to think to answer the question, and not all users may be able to solve the problems presented.",
    "choice_d": "Cognitive passwords don't support long passwords.",
    "correct_answer": "B",
    "explanation": "A cognitive password authenticates users based on a series of facts or answers to questions that they know. Preset questions for cognitive passwords typically rely on common information about a user like their mother's maiden name or the name of their pet, and that information can frequently be found on the internet. The best cognitive password systems let users make up their own questions.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      442,
      446,
      485,
      755,
      447
    ],
    "source": ""
  },
  {
    "id": 3048,
    "question": "Megan needs to create a forensic copy of a hard drive that will be used in an investigation. <br>Which of the following tools is best suited to her work?",
    "choice_a": "xcopy",
    "choice_b": "dd",
    "choice_c": "DBAN",
    "choice_d": "ImageMagik",
    "correct_answer": "B",
    "explanation": "The Linux tool dd creates a bit-by-bit copy of the target drive that is well suited to forensic use, and special forensic versions of dd exist that can provide even more forensic features. Simply copying files using a tool like xcopy does not create a forensically sound copy. DBAN is a drive wiping tool and would cause Megan to lose the data she is seeking to copy. ImageMagik is a graphics manipulation and editing program.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      886,
      887,
      603,
      541,
      843
    ],
    "source": ""
  },
  {
    "id": 3049,
    "question": "Kay is selecting an application management approach for her organization. Employees need the flexibility to install software on their systems, but Kay wants to prevent them from installing certain prohibited packages. <br>What type of approach should she use?",
    "choice_a": "Antivirus",
    "choice_b": "Whitelist",
    "choice_c": "Blacklist",
    "choice_d": "Heuristic",
    "correct_answer": "C",
    "explanation": "The blacklist approach to application control blocks certain prohibited packages but allows the installation of other software on systems. The whitelist approach uses the reverse philosophy and only allows approved software. Antivirus software would only detect the installation of malicious software after the fact. Heuristic detection is a variant of antivirus software.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      871,
      873,
      568,
      550,
      543
    ],
    "source": ""
  },
  {
    "id": 3050,
    "question": "Donna is a security administrator for a healthcare provider located in the United States and is reviewing their payment processing system. It contains data relating to the past, present, or future payment for the provision of healthcare to an individual. <br>How would this information be classified under HIPAA?",
    "choice_a": "PCI",
    "choice_b": "Personal billing data",
    "choice_c": "PHI",
    "choice_d": "Personally identifiable information (PII)",
    "correct_answer": "C",
    "explanation": "Personal health information (PHI) is specifically defined by HIPAA to include information about an individual's medical bills. PCI could refer to the payment card industry's security standard but would only apply in relation to credit cards. PII is a broadly defined term for personally identifiable information, and personal billing data isn't a broadly used industry term.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      105,
      1046,
      108,
      118,
      4
    ],
    "source": ""
  },
  {
    "id": 3051,
    "question": "Harold's company has a strong password policy that requires a minimum length of 12 characters and the use of both alphanumeric characters and symbols. <br>What technique would be the most effective way for an attacker to compromise passwords in Harold's organization?",
    "choice_a": "Brute-force attack",
    "choice_b": "Dictionary attack",
    "choice_c": "Rainbow table attack",
    "choice_d": "Social engineering attack",
    "correct_answer": "D",
    "explanation": "A social engineering attack may trick a user into revealing their password to the attacker. Other attacks that depend on guessing passwords, such as brute-force attacks, rainbow table attacks, and dictionary attacks, are unlikely to be successful in light of the organization's strong password policy.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      193,
      994,
      199,
      196,
      172
    ],
    "source": ""
  },
  {
    "id": 3052,
    "question": "While traveling, James is held at knifepoint and forced to log into his laptop. <br>What is this called?",
    "choice_a": "Duress",
    "choice_b": "Antisocial engineering",
    "choice_c": "Distress",
    "choice_d": "Knifepoint hacking",
    "correct_answer": "A",
    "explanation": "When someone is forced to perform an action under threat, it is known as duress.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      509,
      508,
      510,
      607,
      541
    ],
    "source": ""
  },
  {
    "id": 3053,
    "question": "Brian recently joined an organization that runs the majority of its services on a virtualization platform located in its own data center but also leverages an IaaS provider for hosting its web services and a SaaS email system. <br>What term best describes the type of cloud environment this organization uses?",
    "choice_a": "Public cloud",
    "choice_b": "Dedicated cloud",
    "choice_c": "Private cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "D",
    "explanation": "The scenario describes a mix of public cloud and private cloud services. This is an example of a hybrid cloud environment.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      230,
      272,
      267,
      1027,
      226
    ],
    "source": ""
  },
  {
    "id": 3054,
    "question": "Cameron is responsible for backing up his company's primary file server. He configured a backup schedule that performs full backups every Monday evening at 9 p.m. and incremental backups on other days of the week at that same time. <br>How many files will be copied in Wednesday's backup? <br><img src=\"/question_assets/CISSP/11_image3.png\"/>",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "5",
    "choice_d": "6",
    "correct_answer": "B",
    "explanation": "In this scenario, all of the files on the server will be backed up on Monday evening during the full backup. Tuesday's incremental backup will include all files changed since Monday's full backup: files 1, 2, and 5. Wednesday's incremental backup will then include all files modified since Tuesday's incremental backup: files 3 and 6. Therefore, only two files are included in Wednesday's incremental backup.<br><img src=\"/question_assets/CISSP/11_image3.png\"/>",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      588,
      589,
      592,
      591,
      595
    ],
    "source": ""
  },
  {
    "id": 3055,
    "question": "Susan uses a span port to monitor traffic to her production website and uses a monitoring tool to identify performance issues in real time. <br>What type of monitoring is she conducting?",
    "choice_a": "Passive monitoring",
    "choice_b": "Active monitoring",
    "choice_c": "Synthetic monitoring",
    "choice_d": "Signature-based monitoring",
    "correct_answer": "A",
    "explanation": "Susan is performing passive monitoring, which uses a network tap or span port to capture traffic to analyze it without impacting the network or devices that it is used to monitor. Synthetic, or active, monitoring uses recorded or generated traffic to test for performance and other issues. Signature-based technologies include IDS, IPS, and anti-malware systems.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      547,
      548,
      559,
      556,
      564
    ],
    "source": ""
  },
  {
    "id": 3056,
    "question": "In what type of attack do attackers manage to insert themselves into a connection between a user and a legitimate website?",
    "choice_a": "Man-in-the-middle attack",
    "choice_b": "Fraggle attack",
    "choice_c": "Wardriving attack",
    "choice_d": "Meet-in-the-middle attack",
    "correct_answer": "A",
    "explanation": "In a man-in-the-middle attack, attackers manage to insert themselves into a connection between a user and a legitimate website, relaying traffic between the two parties while eavesdropping on the connection. Although similarly named, the meet-in-the-middle attack is a cryptographic attack that does not necessarily involve connection tampering. Fraggle is a network-based denial-of-service attack using UDP packets. Wardriving is a reconnaissance technique for discovering open or weakly secured wireless networks.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      55,
      71,
      61,
      56,
      2
    ],
    "source": ""
  },
  {
    "id": 3057,
    "question": "Which one of the following would be considered an example of infrastructure as a service cloud computing?",
    "choice_a": "Payroll system managed by a vendor and delivered over the web",
    "choice_b": "Application platform managed by a vendor that runs customer code",
    "choice_c": "Servers provisioned by customers on a vendor-managed virtualization platform",
    "choice_d": "Web-based email service provided by a vendor",
    "correct_answer": "C",
    "explanation": "One of the core capabilities of infrastructure as a service is providing servers on a vendor-managed virtualization platform. Web-based payroll and email systems are examples of software as a service. An application platform managed by a vendor that runs customer code is an example of platform as a service.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      818
    ],
    "source": ""
  },
  {
    "id": 3058,
    "question": "Darcy is an information security risk analyst for Roscommon Agricultural Products. She is currently trying to decide whether the company should purchase an upgraded fire suppression system for their primary data center. The data center facility has a replacement cost of $2 million. <br>After consulting with actuaries, data center managers, and fire subject-matter experts, Darcy determined that a typical fire would likely require the replacement of all equipment inside the building but not cause significant structural damage. Together, they estimated that recovering from the fire would cost $750,000. They also determined that the company can expect a fire of this magnitude once every 50 years. <br>Based on the information in this scenario, what is the exposure factor for the effect of a fire on the Roscommon Agricultural Products data center?",
    "choice_a": "7.5 percent",
    "choice_b": "15.0 percent",
    "choice_c": "27.5 percent",
    "choice_d": "37.5 percent",
    "correct_answer": "D",
    "explanation": "The exposure factor is the percentage of the facility that risk managers expect will be damaged if a risk materializes. It is calculated by dividing the amount of damage by the asset value. In this case, that is $750,000 in damage divided by the $2 million facility value, or 37.5 percent.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      45,
      42,
      43,
      41,
      48
    ],
    "source": ""
  },
  {
    "id": 3059,
    "question": "Darcy is an information security risk analyst for Roscommon Agricultural Products. She is currently trying to decide whether the company should purchase an upgraded fire suppression system for their primary data center. The data center facility has a replacement cost of $2 million. <br>After consulting with actuaries, data center managers, and fire subject-matter experts, Darcy determined that a typical fire would likely require the replacement of all equipment inside the building but not cause significant structural damage. Together, they estimated that recovering from the fire would cost $750,000. They also determined that the company can expect a fire of this magnitude once every 50 years. <br>Based on the information in this scenario, what is the annualized rate of occurrence for a fire at the Roscommon Agricultural Products data center?",
    "choice_a": "0.002",
    "choice_b": "0.005",
    "choice_c": "0.02",
    "choice_d": "0.05",
    "correct_answer": "C",
    "explanation": "The annualized rate of occurrence is the number of times each year that risk analysts expect a risk to happen. In this case, the analysts expect fires will occur once every 50 years, or 0.02 times per year.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      691,
      694,
      85,
      41,
      87
    ],
    "source": ""
  },
  {
    "id": 3060,
    "question": "Darcy is an information security risk analyst for Roscommon Agricultural Products. She is currently trying to decide whether the company should purchase an upgraded fire suppression system for their primary data center. The data center facility has a replacement cost of $2 million. <br>After consulting with actuaries, data center managers, and fire subject-matter experts, Darcy determined that a typical fire would likely require the replacement of all equipment inside the building but not cause significant structural damage. Together, they estimated that recovering from the fire would cost $750,000. They also determined that the company can expect a fire of this magnitude once every 50 years. <br>Based on the information in this scenario, what is the annualized loss expectancy for a fire at the Roscommon Agricultural Products data center?",
    "choice_a": "$15,000",
    "choice_b": "$25,000",
    "choice_c": "$75,000",
    "choice_d": "$750,000",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy is calculated by multiplying the single loss expectancy (SLE) by the annualized rate of occurrence (ARO). In this case, the SLE is $750,000, and the ARO is 0.02. Multiplying these numbers together gives you the ALE of $15,000.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      695,
      86,
      45,
      693,
      875
    ],
    "source": ""
  },
  {
    "id": 3061,
    "question": "Which one of the following techniques uses statistical methods to select a small number of log records from a large pool for further analysis with the goal of choosing a set of records that is representative of the entire pool?",
    "choice_a": "Clipping",
    "choice_b": "Randomization",
    "choice_c": "Sampling",
    "choice_d": "Selection",
    "correct_answer": "C",
    "explanation": "The two main methods of choosing records from a large pool for further analysis are sampling and clipping. Sampling uses statistical techniques to choose a sample that is representative of the entire pool, while clipping uses threshold values to select those records that exceed a predefined threshold because they may be of most interest to analysts.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      890,
      889,
      558,
      891,
      841
    ],
    "source": ""
  },
  {
    "id": 3062,
    "question": "Mike wants to ensure that third-party users of his service's API can be tracked to prevent abuse of the API. <br>What should he implement to help with this?",
    "choice_a": "Session IDs",
    "choice_b": "An API firewall",
    "choice_c": "API keys",
    "choice_d": "An API buffer",
    "correct_answer": "C",
    "explanation": "API keys, or application programming interface keys, are passed to services and identify the program, developer, or user. With this information, Mike can programmatically control API usage per user. Of course, if the keys are inadvertently exposed, the API keys themselves could be abused. Session IDs are typically used to identify users of an application, not an API. API firewalls and API buffers were made up for this question.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      627,
      802,
      803,
      804,
      893
    ],
    "source": ""
  },
  {
    "id": 3063,
    "question": "Fran is a web developer who works for an online retailer. Her boss asked her to create a way that customers can easily integrate themselves with Fran's company's site. They need to be able to check inventory in real time, place orders, and check order status programmatically without having to access the web page. <br>What can Fran create to most directly facilitate this interaction?",
    "choice_a": "API",
    "choice_b": "Web scraper",
    "choice_c": "Data dictionary",
    "choice_d": "Call center",
    "correct_answer": "A",
    "explanation": "An application programming interface (API) allows external users to directly call routines within Fran's code. They can embed API calls within scripts and other programs to automate interactions with Fran's company. A web scraper or call center might facilitate the same tasks, but they do not do so in a direct integration. Data dictionaries might provide useful information, but they also do not allow direct integration.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      892,
      1009,
      826,
      828,
      1011
    ],
    "source": ""
  },
  {
    "id": 3064,
    "question": "Todd's data center facility recently experienced a series of events that involved the momentary loss of power. <br>What term best describes these events?",
    "choice_a": "Fault",
    "choice_b": "Blackout",
    "choice_c": "Sag",
    "choice_d": "Brownout",
    "correct_answer": "A",
    "explanation": "A fault is a momentary loss of power. Blackouts are sustained complete losses of power. Sags and brownouts are not complete power disruptions but rather periods of low-voltage conditions.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      917,
      916,
      324,
      302,
      308
    ],
    "source": ""
  },
  {
    "id": 3065,
    "question": "Lauren's team of system administrators each deal with hundreds of systems with varying levels of security requirements and find it difficult to handle the multitude of usernames and passwords they each have. <br>What type of solution should she recommend to ensure that passwords are properly handled and that features like logging and password rotation occur?",
    "choice_a": "A credential management system",
    "choice_b": "A strong password policy",
    "choice_c": "Separation of duties",
    "choice_d": "Single sign-on",
    "correct_answer": "A",
    "explanation": "Lauren's team would benefit from a credential management system. Credential management systems offer features like password management, multi-factor authentication to retrieve passwords, logging, audit, and password rotation capabilities. A strong password policy would only make maintenance of passwords for many systems a more difficult task if done manually. Single sign-on would help if all the systems had the same sensitivity levels, but different credentials are normally required for higher-sensitivity systems.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      453,
      927,
      908,
      447,
      756
    ],
    "source": ""
  },
  {
    "id": 3066,
    "question": "Ed's Windows system can't connect to the network and <code>ipconfig</code> shows the following:<br>What has occurred on the system? <br><img src=\"/question_assets/CISSP/11_image4.png\"/>",
    "choice_a": "The system has been assigned an invalid IP address by its DHCP server.",
    "choice_b": "The system has a manually assigned IP address.",
    "choice_c": "The system has failed to get a DHCP address and has assigned itself an address.",
    "choice_d": "The subnet mask is set incorrectly, and the system cannot communicate with the gateway.",
    "correct_answer": "C",
    "explanation": "Windows systems will assign themselves an APIPA address between 169.254.0.1 and 169.254.255.254 if they cannot contact a DHCP server.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      896,
      895,
      897,
      425,
      439
    ],
    "source": ""
  },
  {
    "id": 3067,
    "question": "Gina is performing the initial creation of user accounts for a batch of new employees. <br>What phase of the provisioning process is she conducting?",
    "choice_a": "Enrollment",
    "choice_b": "Clearance verification",
    "choice_c": "Background checks",
    "choice_d": "Initialization",
    "correct_answer": "A",
    "explanation": "Enrollment, or registration, is the initial creation of a user account in the provisioning process. Clearance verification and background checks are sometimes part of the process that ensures that the identity of the person being enrolled matches who they claim to be. Initialization is not used to describe the provisioning process.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      455,
      460,
      1015,
      762,
      927
    ],
    "source": ""
  },
  {
    "id": 3068,
    "question": "Ravi is developing procedures for forensic investigations conducted by his organization and would like to differentiate based upon the evidentiary standards commonly used for each type of investigation. <br>What type of forensic investigation typically has the highest evidentiary standards?",
    "choice_a": "Administrative",
    "choice_b": "Criminal",
    "choice_c": "Civil",
    "choice_d": "Industry",
    "correct_answer": "B",
    "explanation": "Criminal forensic investigations typically have the highest standards for evidence, as they must be able to help prove the case beyond a reasonable doubt. Administrative investigations merely need to meet the standards of the organization and to be able to be defended in court, while civil investigations operate on a preponderance of evidence. There is not a category of forensic investigation referred to as \"industry\" in the CISSP exam's breakdown of forensic types.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      599,
      801,
      615,
      601,
      607
    ],
    "source": ""
  },
  {
    "id": 3069,
    "question": "What U.S. legal protection prevents law enforcement agencies from searching an American facility or electronic system with-out either probable cause or consent?",
    "choice_a": "First Amendment",
    "choice_b": "Fourth Amendment",
    "choice_c": "Fifth Amendment",
    "choice_d": "Fifteenth Amendment",
    "correct_answer": "B",
    "explanation": "The Fourth Amendment states, in part, that \"the right of the people to be secure in their persons, houses, papers and effects, against unreasonable searches and seizures, shall not be violated, and no Warrants shall issue, but upon probable cause, supported by Oath or affirmation, and particularly describing the place to be searched, and the persons or things to be seized.\" The First Amendment contains protections related to freedom of speech. The Fifth Amendment ensures that no person will be required to serve as a witness against themselves. The Fifteenth Amendment protects the voting rights of citizens.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      105,
      97,
      107,
      100,
      99
    ],
    "source": ""
  },
  {
    "id": 3070,
    "question": "Tom believes that a customer of his internet service provider has been exploiting a vulnerability in his system to read the email messages of other customers. If true, what law did the customer most likely violate?",
    "choice_a": "ECPA",
    "choice_b": "CALEA",
    "choice_c": "HITECH",
    "choice_d": "Privacy Act",
    "correct_answer": "A",
    "explanation": "The Electronic Communications Privacy Act (ECPA) makes it a crime to invade the electronic privacy of an individual. It prohibits the unauthorized monitoring of email and voicemail communications.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      105,
      117,
      97,
      100,
      118
    ],
    "source": ""
  },
  {
    "id": 3071,
    "question": "In the ring protection model shown here, what ring contains user programs and applications? <br><img src=\"/question_assets/CISSP/11_image5.png\"/>",
    "choice_a": "Ring 0",
    "choice_b": "Ring 1",
    "choice_c": "Ring 2",
    "choice_d": "Ring 3",
    "correct_answer": "D",
    "explanation": "The kernel lies within the central ring, Ring 0. Ring 1 contains other operating system components. Ring 2 is used for drivers and protocols. User-level programs and applications run at Ring 3. Rings 0\u20132 run in privileged mode, whereas Ring 3 runs in user mode.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3072,
    "question": "In virtualization platforms, what name is given to the module that is responsible for controlling access to physical resources by virtual resources?",
    "choice_a": "Guest machine",
    "choice_b": "SDN",
    "choice_c": "Kernel",
    "choice_d": "Hypervisor",
    "correct_answer": "D",
    "explanation": "The hypervisor runs within the virtualization platform and serves as the moderator between virtual resources and physical resources.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      267,
      272,
      271,
      270,
      274
    ],
    "source": ""
  },
  {
    "id": 3073,
    "question": "In which cloud computing model does a customer share computing infrastructure with other customers of the cloud vendor where one customer may not know the other's identity?",
    "choice_a": "Public cloud",
    "choice_b": "Private cloud",
    "choice_c": "Community cloud",
    "choice_d": "Shared cloud",
    "correct_answer": "A",
    "explanation": "In the public cloud computing model, the vendor builds a single platform that is shared among many different customers. This is also known as the shared tenancy model.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      230,
      254,
      255,
      259,
      208
    ],
    "source": ""
  },
  {
    "id": 3074,
    "question": "Justin recently participated in a disaster recovery plan test where the team sat together and discussed the response to a scenario but did not actually activate any disaster recovery controls. <br>What type of test did he participate in?",
    "choice_a": "Checklist review",
    "choice_b": "Full interruption test",
    "choice_c": "Parallel test",
    "choice_d": "Tabletop exercise",
    "correct_answer": "D",
    "explanation": "During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      594,
      597,
      593,
      596,
      581
    ],
    "source": ""
  },
  {
    "id": 3075,
    "question": "Susan wants to integrate her website to allow users to use accounts from sites like Google. <br>What technology should she adopt?",
    "choice_a": "Kerberos",
    "choice_b": "LDAP",
    "choice_c": "OpenID",
    "choice_d": "SESAME",
    "correct_answer": "C",
    "explanation": "OpenID is a widely supported standard that allows a user to use a single account to log in to multiple sites, and Google accounts are frequently used with OpenID.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      476,
      1020,
      451,
      492,
      480
    ],
    "source": ""
  },
  {
    "id": 3076,
    "question": "Tom is conducting a business continuity planning effort for Orange Blossoms, a fruit orchard located in Central Florida. During the assessment process, the committee determined that there is a small risk of snow in the region but that the cost of implementing controls to reduce the impact of that risk is not warranted. They elect to not take any specific action in response to the risk. <br>What risk management strategy is Orange Blossoms pursuing?",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk transference",
    "choice_c": "Risk avoidance",
    "choice_d": "Risk acceptance",
    "correct_answer": "D",
    "explanation": "Risk acceptance occurs when an organization determines that the costs involved in pursuing other risk management strategies are not justified and they choose not to pursue any action.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      46,
      41,
      70,
      44,
      87
    ],
    "source": ""
  },
  {
    "id": 3077,
    "question": "Paul is reviewing the contents of an audit report and discovers a finding that a manager in the accounting department has full access to perform every function in the financial system. <br>What security principles have most likely been violated? (Select all that apply.)",
    "choice_a": "Separation of duties",
    "choice_b": "Job rotation",
    "choice_c": "Management review",
    "choice_d": "Least privilege",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Accounting departments are normally required to separate sensitive duties, such as the ability to add a new vendor and issue a check. Allowing the manager to perform both of these actions would, therefore, violate the principle of separation of duties. Also, it is quite likely that the manager does not need all of these privileges to carry out their work, violating the principle of least privilege. There is no indication that the situation does not follow job rotation assignments or that the access was not properly granted and subject to a management review.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      533,
      504,
      503,
      535,
      505
    ],
    "source": ""
  },
  {
    "id": 3078,
    "question": "Jack's organization is a multinational nonprofit that has small offices in many developing countries throughout the world. They need to implement an access control system that allows flexibility and that can work despite poor internet connectivity at their locations. <br>What is the best type of access control design for Jack's organization?",
    "choice_a": "Centralized access control",
    "choice_b": "Mandatory access control",
    "choice_c": "Decentralized access control",
    "choice_d": "Rule-based access control",
    "correct_answer": "C",
    "explanation": "Decentralized access control makes sense because it allows local control over access. When network connectivity to a central control point is a problem or if rules and regulations may vary significantly from location to location, centralized control can be less desirable than decentralized control despite its challenges with consistency. Since the problem does not describe specific control needs, mandatory access control and rule-based access controls could fit the need but aren't the best answer.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      450,
      472,
      491,
      465,
      466
    ],
    "source": ""
  },
  {
    "id": 3079,
    "question": "What U.S. government classification label is applied to information that, if disclosed, could cause serious damage to national security and also requires that the damage that would be caused is able to be described or identified by the classification authority?",
    "choice_a": "Classified",
    "choice_b": "Secret",
    "choice_c": "Confidential",
    "choice_d": "Top Secret",
    "correct_answer": "B",
    "explanation": "The U.S. government classifies data that could reasonably be expected to cause damage to national security if disclosed, and for which the damage can be identified or described, as Secret. The U.S. government does not use Classified in its formal four levels of classification. Top Secret data could cause exceptionally grave damage, whereas Confidential data could be expected to cause damage.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      121,
      143,
      124,
      128,
      697
    ],
    "source": ""
  },
  {
    "id": 3080,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When the certificate authority (CA) created Renee's digital certificate, what key was contained within the body of the certificate?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "A",
    "explanation": "The purpose of a digital certificate is to provide the general public with an authenticated copy of the certificate subject's public key.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      179,
      198,
      176,
      200,
      183
    ],
    "source": ""
  },
  {
    "id": 3081,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When the certificate authority created Renee's digital certificate, what key did it use to digitally sign the completed certificate?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "D",
    "explanation": "The last step of the certificate creation process is the digital signature. During this step, the certificate authority signs the certificate using its own private key.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      179,
      198,
      176,
      175,
      180
    ],
    "source": ""
  },
  {
    "id": 3082,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>When Mike receives Renee's digital certificate, what key does he use to verify the authenticity of the certificate?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "C",
    "explanation": "When an individual receives a copy of a digital certificate, the person verifies the authenticity of that certificate by using the CA's public key to validate the digital signature contained on the certificate.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      176,
      175,
      180,
      198,
      179
    ],
    "source": ""
  },
  {
    "id": 3083,
    "question": "Mike and Renee would like to use an asymmetric cryptosystem to communicate with each other. They are located in different parts of the country but have exchanged encryption keys by using digital certificates signed by a mutually trusted certificate authority. <br>Mike would like to send Renee a private message using the information gained during this exchange. <br>What key should he use to encrypt the message?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "CA's public key",
    "choice_d": "CA's private key",
    "correct_answer": "A",
    "explanation": "Mike uses the public key that he extracted from Renee's digital certificate to encrypt the message that he would like to send to Renee.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      176,
      198,
      200,
      179,
      183
    ],
    "source": ""
  },
  {
    "id": 3084,
    "question": "Which one of the following tools may be used to directly violate the confidentiality of communications on an unencrypted VoIP network?",
    "choice_a": "Nmap",
    "choice_b": "Nessus",
    "choice_c": "Wireshark",
    "choice_d": "Nikto",
    "correct_answer": "C",
    "explanation": "Wireshark is a network monitoring tool that can capture and replay communications sent over a data network, including Voice over IP (VoIP) communications. Nmap, Nessus, and Nikto are all security tools that may identify security flaws in the network, but they do not directly undermine confidentiality because they do not have the ability to capture communications.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      334,
      353,
      436,
      438,
      395
    ],
    "source": ""
  },
  {
    "id": 3085,
    "question": "Which of the following is not true about the ISC2 Code of Ethics?",
    "choice_a": "Adherence to the code is a condition of certification.",
    "choice_b": "Failure to comply with the code may result in revocation of certification.",
    "choice_c": "The code applies to all members of the information security profession.",
    "choice_d": "Members who observe a breach of the code are required to report the possible violation.",
    "correct_answer": "C",
    "explanation": "The ISC2 Code of Ethics applies only to information security professionals who are members of ISC2. Adherence to the code is a condition of certification, and individuals found in violation of the code may have their certifications revoked. ISC2 members who observe a breach of the code are required to report the possible violation by following the ethics complaint procedures.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      956,
      955,
      957,
      11,
      15
    ],
    "source": ""
  },
  {
    "id": 3086,
    "question": "Which one of the following cryptographic algorithms supports the goal of nonrepudiation?",
    "choice_a": "Blowfish",
    "choice_b": "DES",
    "choice_c": "AES",
    "choice_d": "RSA",
    "correct_answer": "D",
    "explanation": "Nonrepudiation is only possible with an asymmetric encryption algorithm. RSA is an asymmetric algorithm. AES, DES, and Blowfish are all symmetric encryption algorithms that do not provide nonrepudiation.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      145,
      154,
      168,
      198,
      200
    ],
    "source": ""
  },
  {
    "id": 3087,
    "question": "Microsoft's STRIDE threat assessment framework uses six categories for threats: Spoofing, Tampering, Repudiation, Information Disclosure, Denial of Service, and Elevation of Privilege. If a penetration tester is able to modify audit logs, what STRIDE categories best describe this issue?",
    "choice_a": "Tampering and information disclosure",
    "choice_b": "Elevation of privilege and tampering",
    "choice_c": "Repudiation and denial of service",
    "choice_d": "Repudiation and tampering",
    "correct_answer": "D",
    "explanation": "Modification of audit logs will allow repudiation because the data cannot be trusted, and thus actions can be provably denied. The modification of the logs is also a direct example of tampering. It might initially be tempting to answer elevation of privileges and tampering, as the attacker made changes to files that should be protected, but this is an unknown without more information. Similarly, the attacker may have accessed the files, resulting in information disclosure in addition to tampering, but again, this is not specified in the question. Finally, this did not cause a denial of service, and thus that answer can be ignored.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      24,
      6,
      3,
      2,
      26
    ],
    "source": ""
  },
  {
    "id": 3088,
    "question": "Carmen is reviewing her organization's web architecture and realizes that the web server is often under heavy load from users in different regions of the world.  This load comes at unpredictable times.  She would like to find a solution that minimizes the burden on her organization's servers and places content geographically closer to the user to decrease load time. <br>What would be the best solution to Carmen's requirements?",
    "choice_a": "Load balancer",
    "choice_b": "Content delivery network",
    "choice_c": "TLS acceleration",
    "choice_d": "Web application firewall",
    "correct_answer": "B",
    "explanation": "Content delivery networks (CDNs) place endpoints at geographic locations around the world and then cache customer content at those endpoints.  The CDN servers then handle user requests for data, greatly reducing the burden on the organization's own servers and improving load time.  Load balancers would distribute the load among Carmen's own servers and would, therefore, not meet her requirements.  TLS acceleration may improve load time by reducing the burden of encryption on servers, but they would not place content closer to end users.  Web application firewalls would be used to protect the servers against attack, but this does not match Carmen's requirements.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      373,
      405,
      394,
      358,
      375
    ],
    "source": ""
  },
  {
    "id": 3089,
    "question": "Brian recently joined an organization that runs the majority of its services on a virtualization platform located in its own data center but also leverages an IaaS provider for hosting its web services and a SaaS email system. <br>What term best describes the type of cloud environment this organization uses?",
    "choice_a": "Public cloud",
    "choice_b": "Dedicated cloud",
    "choice_c": "Private cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "D",
    "explanation": "The scenario describes a mix of public cloud and private cloud services. This is an example of a hybrid cloud environment.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      127,
      135,
      144,
      138,
      139
    ],
    "source": ""
  },
  {
    "id": 3090,
    "question": "The government agency that Ben works at installed a new access control system. The system uses information such as Ben's identity, department, normal working hours, job category, and location to make authorization. <br>What type of access control system did Ben's employer adopt?",
    "choice_a": "Role-based access control",
    "choice_b": "Attribute-based access control",
    "choice_c": "Administrative access control",
    "choice_d": "System discretionary access control",
    "correct_answer": "B",
    "explanation": "Each of the attributes linked to Ben's access provides information for an attribute-based information control system. Attribute-based information controls like those described in NIST SP 800-162 can take many details about the user, actions, and objects into consideration before allowing access to occur. A role-based access control would simply consider Ben's role, whereas both administrative and system discretionary access controls are not commonly used terms to describe access controls.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      467,
      472,
      466,
      468,
      464
    ],
    "source": ""
  },
  {
    "id": 3091,
    "question": "Ben is building his organization's security awareness and training program and would like to include interactive activities that better engage users. <br>What techniques would best help him meet this goal?  (Select all that apply.)",
    "choice_a": "Policy reviews",
    "choice_b": "Gamification",
    "choice_c": "Classroom training",
    "choice_d": "Phishing simulations",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "All of these techniques are valid components of a security awareness and training program. However, users generally find policy reviews and classroom training boring. Gamification and phishing simulations are designed to bring interactivity to the effort and make it more interesting and engaging for users.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      66,
      65,
      71,
      55,
      57
    ],
    "source": ""
  },
  {
    "id": 3092,
    "question": "Andrew believes that a digital certificate belonging to his organization was compromised and would like to add it to a certificate revocation list (CRL). <br>Who must add the certificate to the CRL?",
    "choice_a": "Andrew",
    "choice_b": "The root authority for the top-level domain",
    "choice_c": "The CA that issued the certificate",
    "choice_d": "The revocation authority for the top-level domain",
    "correct_answer": "C",
    "explanation": "Certificates may only be added to a certificate revocation list by the certificate authority that created the digital certificate.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      180,
      937,
      722,
      181,
      179
    ],
    "source": ""
  },
  {
    "id": 3093,
    "question": "Amanda is considering the implementation of a database recovery mechanism recommended by a consultant. In the recommended approach, an automated process will move records of transactions from the primary site to a backup site on an hourly basis. <br>What type of database recovery technique is the consultant describing?",
    "choice_a": "Electronic vaulting",
    "choice_b": "Transaction logging",
    "choice_c": "Remote mirroring",
    "choice_d": "Remote journaling",
    "correct_answer": "D",
    "explanation": "Remote journaling transfers transaction logs to a remote site on a more frequent basis than electronic vaulting, typically hourly. Transaction logging is not a recovery technique alone; it is a process for generating the logs used in remote journaling. In an electronic vaulting approach, automated technology moves database backups from the primary database server to a remote site on a scheduled basis, typically daily. Remote mirroring maintains a live database server at the backup site and mirrors all transactions at the primary site on the server at the backup site.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      584,
      588,
      598,
      582,
      594
    ],
    "source": ""
  },
  {
    "id": 3094,
    "question": "Ron is working to classify information used by his organization and would like to include all information that might trigger a U.S. state data breach notification law in his classification scheme. <br>Which of the following categories of information should he include, assuming that they are connected to a specific individual?  (Select all that apply.)",
    "choice_a": "Bank account number and PIN",
    "choice_b": "Driver's license number",
    "choice_c": "Marital status",
    "choice_d": "Social Security number",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The specific data elements covered by state data breach notification laws vary from state to state, but most include Social Security numbers, drivers' license numbers, and bank account numbers when paired with a PIN. No state data breach notification laws include marital status as a covered element.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      126,
      120,
      703,
      704,
      143
    ],
    "source": ""
  },
  {
    "id": 3095,
    "question": "Which one of the following investigation types has the loosest standards for the collection and preservation of information?",
    "choice_a": "Civil investigation",
    "choice_b": "Operational investigation",
    "choice_c": "Criminal investigation",
    "choice_d": "Regulatory investigation",
    "correct_answer": "B",
    "explanation": "Operational investigations are performed by internal teams to troubleshoot performance or other technical issues. They are not intended to produce evidence for use in court and, therefore, do not have the rigid collection standards of criminal, civil, or regulatory investigations.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      981,
      100,
      95,
      20,
      49
    ],
    "source": ""
  },
  {
    "id": 3096,
    "question": "Sue was required to sign an NDA when she took a job at her new company. <br>Why did the company require her to sign it?",
    "choice_a": "To protect the confidentiality of their data",
    "choice_b": "To ensure that Sue did not delete their data",
    "choice_c": "To prevent Sue from directly competing with them in the future",
    "choice_d": "To require Sue to ensure the availability for their data as part of her job",
    "correct_answer": "A",
    "explanation": "Nondisclosure agreements (NDAs) are designed to protect the confidentiality of an organization's data, including trade secrets during and after the person's employment. NDAs do not protect against deletion or availability issues, and noncompete agreements would be required to stop competition.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      35,
      104,
      4,
      39,
      37
    ],
    "source": ""
  },
  {
    "id": 3097,
    "question": "Susan is concerned about the FAR associated with her biometric technology. <br>What is the best method to deal with the FAR?",
    "choice_a": "Adjust the CER.",
    "choice_b": "Change the sensitivity of the system to lower the FRR.",
    "choice_c": "Add a second factor.",
    "choice_d": "Replace the biometric system.",
    "correct_answer": "C",
    "explanation": "Adding a second factor can ensure that users who might be incorrectly accepted are not given access due to a higher than desired false acceptance rate (FAR) from accessing a system. The CER is the crossover between the false acceptance and false rejection rate (FRR) and is used as a way to measure the accuracy of biometric systems. Changing the sensitivity to lower the FRR may actually increase the FAR, and replacing a biometric system can be expensive in terms of time and cost.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      445,
      446,
      459,
      469,
      441
    ],
    "source": ""
  },
  {
    "id": 3098,
    "question": "Which data processing role in an organization is most likely to grant users access to information on a day-to-day basis?",
    "choice_a": "Business owners",
    "choice_b": "Data processors",
    "choice_c": "Data owners",
    "choice_d": "Data stewards",
    "correct_answer": "D",
    "explanation": "Data stewards carry out most of the operational responsibilities related to data management and would be the most likely to approve access requests. They have authority delegated to them by business and data owners. Data processors are required to perform specific actions under regulations like the EU GDPR.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      138,
      139,
      989,
      143,
      988
    ],
    "source": ""
  },
  {
    "id": 3099,
    "question": "Ron is the CISO of a U.S. company that is entering into a business partnership with a European firm. The European firm will be sending his company customer records to run through Ron's firm's proprietary credit scoring algorithm. <br>Under GDPR, what role will Ron's company have relative to the customer data?",
    "choice_a": "Data controller",
    "choice_b": "Data owner",
    "choice_c": "Data subject",
    "choice_d": "Data processor",
    "correct_answer": "D",
    "explanation": "Ron's company is a data processor in this instance, as it is receiving records from the European firm. The European firm is the data controller in this case, as they bear responsibility for the data. The individuals described in the records are the data subjects. Data owners are tasked with making decisions about data such as who receives access to it and how it is used.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      139,
      988,
      990,
      138,
      143
    ],
    "source": ""
  },
  {
    "id": 3100,
    "question": "Tonya recently introduced a new security control in her organization for emergency access to system administrator privileges. Under this procedure, two qualified administrators must agree to retrieve emergency credentials. <br>What term best describes this process?",
    "choice_a": "Separation of duties",
    "choice_b": "Least privilege",
    "choice_c": "Two-person control",
    "choice_d": "Multifactor authentication",
    "correct_answer": "C",
    "explanation": "This is an example of two-person control, where two people must concur to perform a sensitive action. Separation of duties is a slightly different principle, where one individual is prevented from holding the privileges to perform two separate actions that, when combined, would result in undesirable permissions. Least privilege says that an individual should have the minimum necessary set of permissions to carry out their job functions. There is no indication that least privilege is violated in this scenario. Multifactor authentication is an important security control, but the scenario does not mention whether the administrators use multifactor authentication to perform these activities.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      219,
      715,
      220,
      229,
      213
    ],
    "source": ""
  },
  {
    "id": 3101,
    "question": "Attackers who compromise websites often acquire databases of hashed passwords. <br>What technique can best protect these passwords against automated password cracking attacks that use precomputed values?",
    "choice_a": "Using the MD5 hashing algorithm",
    "choice_b": "Using the SHA-1 hashing algorithm",
    "choice_c": "Salting",
    "choice_d": "Double-hashing",
    "correct_answer": "C",
    "explanation": "Salting adds random text to the password before hashing in an attempt to defeat automated password cracking attacks that use precomputed values. MD5 and SHA-1 are both common hashing algorithms, so using them does not add any security. Double-hashing would only be a minor inconvenience for an attacker and would not be as effective as the use of salting.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      193,
      199,
      172,
      173,
      155
    ],
    "source": ""
  },
  {
    "id": 3102,
    "question": "Jim starts a new job as a system engineer, and he is reviewing a team document entitled \"Forensic Response Guidelines.\" <br>Which one of the following statements is not true?",
    "choice_a": "Jim must comply with the information in this document.",
    "choice_b": "The document contains information about forensic examinations.",
    "choice_c": "Jim should read the document thoroughly.",
    "choice_d": "The document is likely based on industry best practices.",
    "correct_answer": "A",
    "explanation": "Guidelines provide advice based on best practices developed throughout industry and organizations, but they are not compulsory. Compliance with guidelines is optional.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      22,
      41,
      15,
      13,
      74
    ],
    "source": ""
  },
  {
    "id": 3103,
    "question": "Evan is reviewing his access control system to ensure that no user is able to read information that is above their security clearance level. <br>What security model is he enforcing?",
    "choice_a": "Bell\u2013LaPadula",
    "choice_b": "Star security property",
    "choice_c": "Discretionary security property",
    "choice_d": "Biba",
    "correct_answer": "A",
    "explanation": "The Bell\u2013LaPadula model includes the simple security property, which says that no user should be able to read information above their security clearance level. It also includes the star property, which says that a subject should not be able to write data to an object below their security clearance level, and the discretionary security property, which uses access matrices to control access. The Biba integrity model says that users should not be able to read data below their security clearance level.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      217,
      228,
      214,
      215,
      216
    ],
    "source": ""
  },
  {
    "id": 3104,
    "question": "Ben needs to verify that the most recent patch for his organization's critical application did not introduce issues elsewhere. <br>What type of testing does Ben need to conduct to ensure this?",
    "choice_a": "Unit testing",
    "choice_b": "White box",
    "choice_c": "Regression testing",
    "choice_d": "Black box",
    "correct_answer": "C",
    "explanation": "Regression testing ensures proper functionality of an application or system after it has been changed. Unit testing focuses on testing each module of a program instead of against its previous functional state. White- and black-box testing both describe the amount of knowledge about a system or application, rather than a specific type or intent for testing.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      494,
      496,
      778,
      780,
      1021
    ],
    "source": ""
  },
  {
    "id": 3105,
    "question": "Tamara recently decided to purchase cyber-liability insurance to cover her company's costs in the event of a data breach. <br>What risk management strategy is she pursuing?",
    "choice_a": "Risk acceptance",
    "choice_b": "Risk mitigation",
    "choice_c": "Risk transference",
    "choice_d": "Risk avoidance",
    "correct_answer": "C",
    "explanation": "Risk transference involves shifting the impact of a potential risk from the organization incurring the risk to another organization. Insurance is a common example of risk transference.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      46,
      52,
      70,
      41,
      44
    ],
    "source": ""
  },
  {
    "id": 3106,
    "question": "Which of the following is not one of the four canons of the ISC2 Code of Ethics?",
    "choice_a": "Avoid conflicts of interest that may jeopardize impartiality.",
    "choice_b": "Protect society, the common good, necessary public trust and confidence, and the infrastructure.",
    "choice_c": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_d": "Provide diligent and competent service to principals.",
    "correct_answer": "A",
    "explanation": "The four canons of the ISC2 Code of Ethics are to protect society, the common good, the necessary public trust and confidence, and the infrastructure; act honorably, honestly, justly, responsibly, and legally; provide diligent and competent service to principals; and advance and protect the profession.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      955,
      956,
      15,
      14,
      47
    ],
    "source": ""
  },
  {
    "id": 3107,
    "question": "Jim wants to allow a partner organization's Active Directory forest (B) to access his domain forest's (A)'s resources but doesn't want to allow users in his domain to access B's resources. He also does not want the trust to flow upward through the domain tree as it is formed. <br>What should he do?",
    "choice_a": "Set up a two-way transitive trust.",
    "choice_b": "Set up a one-way transitive trust.",
    "choice_c": "Set up a one-way nontransitive trust.",
    "choice_d": "Set up a two-way nontransitive trust.",
    "correct_answer": "C",
    "explanation": "A trust that allows one forest to access another's resources without the reverse being possible is an example of a one-way trust. Since Jim doesn't want the trust path to flow as the domain tree is formed, this trust has to be nontransitive.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      901,
      902,
      903,
      465,
      471
    ],
    "source": ""
  },
  {
    "id": 3108,
    "question": "Susan's team is performing code analysis by manually reviewing the code for flaws. <br>What type of analysis are they performing?",
    "choice_a": "Gray box",
    "choice_b": "Static",
    "choice_c": "Dynamic",
    "choice_d": "Fuzzing",
    "correct_answer": "B",
    "explanation": "Susan's team is performing static analysis, which analyzes nonrunning code. Dynamic analysis uses running code, whereas gray-box assessments are a type of assessment done without full knowledge. Fuzzing feeds unexpected inputs to a program as part of dynamic analysis.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      626,
      962,
      807,
      621,
      670
    ],
    "source": ""
  },
  {
    "id": 3109,
    "question": "Kevin's organization recently suffered a ransomware attack, and he is considering paying the ransom. <br>Which of the following statements are true about paying the ransom? (Select all that apply.)",
    "choice_a": "There is no guarantee that he will receive the decryption key.",
    "choice_b": "The attackers have encrypted his data but do not have access to the data itself.",
    "choice_c": "Restoring from backup will not recover information.",
    "choice_d": "Paying ransoms may be illegal.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Kevin may choose to pay the ransom, and he may regain access to his data by doing so, but there is no guarantee that the attackers will deliver the decryption key after he makes payment. Additionally, the payment of the ransom may be illegal depending upon the circumstances. He cannot be sure that the attackers do not have access to his information, as the ransomware may have copied data for the attackers' use. Restoring from backup is a good method to regain access to information encrypted by ransomware.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3110,
    "question": "What feature of a Trusted Platform Module (TPM) creates a hash summary of the system configuration to verify that changes have not been made?",
    "choice_a": "Remote attestation",
    "choice_b": "Binding",
    "choice_c": "Sealing",
    "choice_d": "RNG",
    "correct_answer": "A",
    "explanation": "Remote attestation creates a hash value from the system configuration to confirm the integrity of the configuration. Binding and sealing are techniques used by the TPM to encrypt data. The random number generator (RNG) function of the TPM is used to support cryptographic operations.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      291,
      172,
      155,
      215,
      228
    ],
    "source": ""
  },
  {
    "id": 3111,
    "question": "Gary is concerned that the environmental controls in his organization's data center may not be effectively controlling humidity. <br>Which of the following circumstances may result from humidity issues? (Select all that apply.)",
    "choice_a": "Static electricity damaging equipment",
    "choice_b": "Fires in power supplies",
    "choice_c": "Corrosion of equipment",
    "choice_d": "Physical access control failures",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Situations where humidity is too high may result in the buildup of moisture and corrosion of equipment. If humidity falls too low, it may result in static electricity issues. Humidity issues generally do not contribute to fires or physical access control failures.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      313,
      326,
      322,
      305,
      327
    ],
    "source": ""
  },
  {
    "id": 3112,
    "question": "Evan recently built an alternate processing facility that includes all of the hardware and data necessary to restore operations in a matter of minutes or seconds. <br>What type of facility has he built?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Mobile site",
    "correct_answer": "A",
    "explanation": "<italic>Hot site:</italic> A site with dedicated storage and real-time data replication, often with shared equipment that allows restoration of service in a very short time. <br><italic>Warm site:</italic>A site that relies on shared storage and backups for recovery. <br><italic>Cold site:</italic>A rented space with power, cooling, and connectivity that can accept equipment as part of a recovery effort. <br><italic>Mobile site:</italic> Non-mainstream alternatives to traditional recovery sites. They typically consist of self-contained trailers or other easily relocated units. Mobile sites are usually configured as cold sites or warm sites, depending on the disaster recovery plan they are designed to support.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      582,
      598,
      584,
      585,
      580
    ],
    "source": ""
  },
  {
    "id": 3113,
    "question": "Hadley is reviewing network traffic logs and is searching for syslog activity on his network. When he creates a filter to look for this traffic, which UDP port should he include?",
    "choice_a": "443",
    "choice_b": "514",
    "choice_c": "515",
    "choice_d": "445",
    "correct_answer": "B",
    "explanation": "Syslog uses UDP port 514. TCP-based implementations of syslog typically use port 6514. The other ports may look familiar because they are commonly used TCP ports: 443 is HTTPS, 515 is the LPD print service, and 445 is used for Windows SMB.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      557,
      554,
      538,
      548,
      603
    ],
    "source": ""
  },
  {
    "id": 3114,
    "question": "Fred finds a packet that his protocol analyzer shows with both PSH and URG set. <br>What type of packet is he looking at, and what do the flags mean?",
    "choice_a": "A UDP packet; PSH and URG are used to indicate that the data should be sent at high speed.",
    "choice_b": "A TCP packet; PSH and URG are used to clear the buffer and indicate that the data is urgent.",
    "choice_c": "A TCP packet; PSH and URG are used to preset the header and indicate that the speed of the network is unregulated.",
    "choice_d": "A UDP packet; PSH and URG are used to indicate that the UDP buffer should be cleared and that the data is urgent.",
    "correct_answer": "B",
    "explanation": "PSH is a TCP flag used to clear the buffer, resulting in immediately sending data, and URG is the TCP urgent flag. These flags are not present in UDP headers.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      724,
      726,
      334,
      337,
      868
    ],
    "source": ""
  },
  {
    "id": 3115,
    "question": "What code review process is shown here? <br><img src=\"/question_assets/CISSP/11_image6.png\"/>",
    "choice_a": "Static inspection",
    "choice_b": "Fagan inspection",
    "choice_c": "Dynamic inspection",
    "choice_d": "Interface testing",
    "correct_answer": "B",
    "explanation": "Fagan inspection is a highly formalized review and testing process that uses planning, overview, preparation, inspection, rework, and follow-up steps. Static inspection looks at code without running it, dynamic inspection uses live programs, and interface testing tests where code modules interact.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      1021,
      1022,
      494,
      495,
      496
    ],
    "source": ""
  },
  {
    "id": 3116,
    "question": "During a log review, Karen discovers that the system she needs to gather logs from has the log setting shown here. <br><img src=\"/question_assets/CISSP/11_image7.png\"/><br>What problem is Karen likely to encounter?",
    "choice_a": "Too much log data will be stored on the system.",
    "choice_b": "The system is automatically purging archived logs.",
    "choice_c": "The logs will not contain the information needed.",
    "choice_d": "The logs will only contain the most recent 20 MB of log data.",
    "correct_answer": "D",
    "explanation": "The system is set to overwrite the logs and will replace the oldest log entries with new log entries when the file reaches 20 MB. The system is not purging archived logs because it is not archiving logs. Since there can only be 20 MB of logs, this system will not have stored too much log data, and the question does not provide enough information to know if there will be an issue with not having the information needed.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      843,
      555,
      557,
      558,
      889
    ],
    "source": ""
  },
  {
    "id": 3117,
    "question": "While investigating a widespread distributed denial-of-service attack, Matt types in the IP address of one of the attacking systems into his browser and sees the following page. <br>What type of devices is the botnet likely composed of? <br><img src=\"/question_assets/CISSP/11_image8.png\"/>",
    "choice_a": "SCADA",
    "choice_b": "Cloud infrastructure",
    "choice_c": "Web servers",
    "choice_d": "IoT",
    "correct_answer": "D",
    "explanation": "The image shown is from a network connected web camera. This is likely an Internet of Things (IoT) botnet, much like the Mirai botnet that had a major impact on world internet traffic in 2016.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      258,
      262,
      255,
      208,
      206
    ],
    "source": ""
  },
  {
    "id": 3118,
    "question": "Alejandro is an incident response analyst for a large corporation. He is on the midnight shift when an intrusion detection system alerts him to a potential brute-force password attack against one of the company's critical information systems. He performs an initial triage of the event before taking any additional action. <br>What stage of the incident response process is Alejandro currently conducting?",
    "choice_a": "Detection",
    "choice_b": "Response",
    "choice_c": "Recovery",
    "choice_d": "Mitigation",
    "correct_answer": "A",
    "explanation": "Alejandro is in the first stage of the incident response process, detection. During this stage, the intrusion detection system provides the initial alert, and Alejandro performs preliminary triaging to determine if an intrusion is actually taking place and whether the scenario fits the criteria for activating further steps of the incident response process (which include response, mitigation, reporting, recovery, remediation, and lessons learned).",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      537,
      538,
      565,
      566,
      547
    ],
    "source": ""
  },
  {
    "id": 3119,
    "question": "Alejandro is an incident response analyst for a large corporation. He is on the midnight shift when an intrusion detection system alerts him to a potential brute-force password attack against one of the company's critical information systems. He performs an initial triage of the event before taking any additional action. <br>If Alejandro's initial investigation determines that a security incident is likely taking place, what should be his next step?",
    "choice_a": "Investigate the root cause.",
    "choice_b": "File a written report.",
    "choice_c": "Activate the incident response team.",
    "choice_d": "Attempt to restore the system to normal operations.",
    "correct_answer": "C",
    "explanation": "After detection of a security incident, the next step in the process is response, which should follow the organization's formal incident response procedure. The first step of this procedure is activating the appropriate teams, including the organization's computer security incident response team (CSIRT).",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      538,
      537,
      565,
      540,
      921
    ],
    "source": ""
  },
  {
    "id": 3120,
    "question": "Alejandro is an incident response analyst for a large corporation. He is on the midnight shift when an intrusion detection system alerts him to a potential brute-force password attack against one of the company's critical information systems. He performs an initial triage of the event before taking any additional action. <br>As the incident response progresses, during which stage should the team conduct a root-cause analysis?",
    "choice_a": "Response",
    "choice_b": "Reporting",
    "choice_c": "Remediation",
    "choice_d": "Lessons learned",
    "correct_answer": "C",
    "explanation": "The root-cause analysis examines the incident to determine what allowed it to happen and provides critical information for repairing systems so that the incident does not recur. This is a component of the remediation step of the incident response process because the root-cause analysis output is necessary to fully remediate affected systems and processes.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      540,
      537,
      565,
      920,
      539
    ],
    "source": ""
  },
  {
    "id": 3121,
    "question": "Barry recently received a message from Melody that Melody encrypted using symmetric cryptography. <br>What key should Barry use to decrypt the message?",
    "choice_a": "Barry's public key",
    "choice_b": "Barry's private key",
    "choice_c": "Melody's public key",
    "choice_d": "Shared secret key",
    "correct_answer": "D",
    "explanation": "When using symmetric cryptography, the sender encrypts a message using a shared secret key, and the recipient then decrypts the message with that same key. Only asymmetric cryptography uses the concept of public and private key pairs.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      153,
      154,
      165,
      176,
      184
    ],
    "source": ""
  },
  {
    "id": 3122,
    "question": "After you do automated functional testing with 100 percent coverage of an application, what type of error is most likely to remain?",
    "choice_a": "Business logic errors",
    "choice_b": "Input validation errors",
    "choice_c": "Runtime errors",
    "choice_d": "Error handling errors",
    "correct_answer": "A",
    "explanation": "Business logic errors are most likely to be missed by automated functional testing. If a complete coverage code test was conducted, runtime, input validation, and error handling issues are likely to have been discovered by automated testing. Any automated system is more likely to miss business logic errors, because humans are typically necessary to understand business logic issues.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      621,
      833,
      813,
      620,
      661
    ],
    "source": ""
  },
  {
    "id": 3123,
    "question": "During what phase of the incident response process would security professionals analyze the process itself to determine whether any improvements are warranted?",
    "choice_a": "Lessons learned",
    "choice_b": "Remediation",
    "choice_c": "Recovery",
    "choice_d": "Reporting",
    "correct_answer": "A",
    "explanation": "During the lessons learned phase, analysts close out an incident by conducting a review of the entire incident response process. This may include making recommendations for improvements to the process that will streamline the efficiency and effectiveness of future incident response efforts.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      540,
      595,
      537,
      565,
      920
    ],
    "source": ""
  },
  {
    "id": 3124,
    "question": "What U.S. law prevents the removal of protection mechanisms placed on a copyrighted work by the copyright holder?",
    "choice_a": "HIPAA",
    "choice_b": "DMCA",
    "choice_c": "GLBA",
    "choice_d": "ECPA",
    "correct_answer": "B",
    "explanation": "The Digital Millennium Copyright Act (DMCA) prohibits attempts to circumvent copyright protection mechanisms placed on a protected work by the copyright holder. The Health Insurance Portability and Accountability Act (HIPAA) governs the security and privacy of protected health information. The Gramm-Leach-Bliley Act (GLBA) governs the security and privacy of financial information. The Electronic Communications Privacy Act (ECPA) restricts eavesdropping on private communications.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      103,
      117,
      100,
      118,
      104
    ],
    "source": ""
  },
  {
    "id": 3125,
    "question": "Linda is selecting a disaster recovery facility for her organization, and she wants to retain independence from other organizations as much as possible. She would like to choose a facility that balances cost and recovery time, allowing activation in about one week after a disaster is declared. <br>What type of facility should she choose?",
    "choice_a": "Cold site",
    "choice_b": "Warm site",
    "choice_c": "Mutual assistance agreement",
    "choice_d": "Hot site",
    "correct_answer": "B",
    "explanation": "Linda should choose a warm site. This approach balances cost and recovery time. Cold sites take a very long time to activate, measured in weeks or months. Hot sites activate immediately but are quite expensive. Mutual assistance agreements depend on the support of another organization.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      582,
      598,
      583,
      581,
      580
    ],
    "source": ""
  },
  {
    "id": 3126,
    "question": "Helen's organization handles large quantities of highly sensitive information. To help address this risk, she purchased a cyber-liability insurance policy. <br>What type of risk response action is Helen taking?",
    "choice_a": "Transfer",
    "choice_b": "Avoid",
    "choice_c": "Mitigate",
    "choice_d": "Accept",
    "correct_answer": "A",
    "explanation": "Purchasing insurance is a way to transfer risk to another entity. Risk avoidance actions change business processes to eliminate a risk. Risk mitigation activities reduce the likelihood or impact of a risk occurring. Risk acceptance takes no action to control the risk other than acknowledging its presence.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      46,
      52,
      70,
      41,
      49
    ],
    "source": ""
  },
  {
    "id": 3127,
    "question": "What type of penetration testing provides detail on the scope of a penetration test\u2014including items like what systems would be targeted\u2014but does not provide full visibility into the configuration or other details of the systems or networks the penetration tester must test?",
    "choice_a": "Crystal box",
    "choice_b": "White box",
    "choice_c": "Black box",
    "choice_d": "Gray box",
    "correct_answer": "D",
    "explanation": "Gray-box testing is a blend of crystal-box (or white-box) testing, which provides full information about a target, and black-box testing, which provides little or no knowledge about the target.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      1078,
      1080,
      771,
      494,
      497
    ],
    "source": ""
  },
  {
    "id": 3128,
    "question": "Joanna would like to implement multifactor authentication for access to a restricted work area in her building. <br>Which pairing of controls would best meet her requirement?",
    "choice_a": "ID card and PIN",
    "choice_b": "Password and retinal scan",
    "choice_c": "ID card and access token",
    "choice_d": "Retinal scan and fingerprint scan",
    "correct_answer": "A",
    "explanation": "The combination of an ID card (something you have) and a PIN (something you know) is a reasonable way to control access to a physical facility. The use of a password is not a user-friendly way to control access to a physical facility. The use of an ID card (something you have) in conjunction with an access token (something you have) does not constitute multifactor authentication because both are something you have factors. The same is true for the use of a retinal scan (something you are) and a fingerprint (something you are).",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      305,
      327,
      321,
      325,
      308
    ],
    "source": ""
  },
  {
    "id": 3129,
    "question": "What network topology is used by modern-day Ethernet networks?",
    "choice_a": "Star",
    "choice_b": "Mesh",
    "choice_c": "Ring",
    "choice_d": "Bus",
    "correct_answer": "A",
    "explanation": "Ethernet networks in modern organizations use a star topology, where each device is directly connected to the switch and receives only traffic intended for that device. This reduces the possibility of eavesdropping on other devices.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      865,
      867,
      378,
      419,
      436
    ],
    "source": ""
  },
  {
    "id": 3130,
    "question": "Reed would like to add capabilities to his network that allow him to hide the identities of his users from remote web servers. <br>Which one of the following tools would best meet his needs?",
    "choice_a": "Proxy server",
    "choice_b": "Content filter",
    "choice_c": "Malware filter",
    "choice_d": "Caching server",
    "correct_answer": "A",
    "explanation": "Proxy servers can act to anonymize web requests by hiding their true source IP addresses and removing identifying information. Content filters restrict the websites that users may access. Malware filters search for and block malicious code. Caching servers store local copies of frequently requested content to reduce loading time.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      376,
      417,
      436,
      399,
      379
    ],
    "source": ""
  },
  {
    "id": 3131,
    "question": "Evelyn is preparing a training program that will provide cybersecurity advice to users who often travel internationally. <br>Which of the following topics requires special training to ensure that users do not run afoul of U.S. export control laws?",
    "choice_a": "Encryption software",
    "choice_b": "Content filtering",
    "choice_c": "Firewall rules",
    "choice_d": "Phishing simulations",
    "correct_answer": "A",
    "explanation": "U.S. export control laws contain special provisions around the use of encryption technology, and Evelyn should include details about the software used by her firm in the training. These regulations do not affect content filtering controls, firewall rules, or phishing simulations.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      111,
      65,
      67,
      40,
      1
    ],
    "source": ""
  },
  {
    "id": 3132,
    "question": "Skip needs to transfer files from his PC to a remote server. <br>What should he use instead of FTP?",
    "choice_a": "SCP",
    "choice_b": "SSH",
    "choice_c": "HTTP",
    "choice_d": "Telnet",
    "correct_answer": "A",
    "explanation": "Skip should use SCP (Secure Copy), which is a secure file transfer method. SSH is a secure command-line and login protocol, whereas HTTP is used for unencrypted web traffic. Telnet is an unencrypted command-line and login protocol.",
    "topic_id": 4,
    "practice_test_id": 3,
    "related_articles": [
      905,
      335,
      904,
      350,
      401
    ],
    "source": ""
  },
  {
    "id": 3133,
    "question": "Ben's New York\u2013based commercial web service collects personal information from California residents. <br>What does the California Online Privacy Protection Act require Ben to do to be compliant?",
    "choice_a": "Ben must encrypt all personal data he receives.",
    "choice_b": "Ben must comply with the EU GDPR.",
    "choice_c": "Ben must have a conspicuously posted privacy policy on his site.",
    "choice_d": "Ben must provide notice and choice for users of his website.",
    "correct_answer": "C",
    "explanation": "The California Online Privacy Protection Act requires that commercial websites that collect personal information from users in California conspicuously post a privacy policy. The act does not require compliance with the EU GDPR, nor does it use the GDPR concepts of notice or choice, and it does not require encryption of all personal data.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      106,
      118,
      108,
      105,
      100
    ],
    "source": ""
  },
  {
    "id": 3134,
    "question": "Grayson is reviewing his organization's password policies and would like to follow modern best practices. <br>What is the recommended expiration period for passwords?",
    "choice_a": "30 days",
    "choice_b": "90 days",
    "choice_c": "180 days",
    "choice_d": "None",
    "correct_answer": "D",
    "explanation": "Modern recommendations from the National Institute of Standards and Technology (NIST) are that users should not be forced to change their passwords through the use of password expiration policies. More information on these recommendations may be found in NIST Special Publication (SP) 800-63B, \"Digital Identity Guidelines.\".",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      907,
      447,
      489,
      755,
      756
    ],
    "source": ""
  },
  {
    "id": 3135,
    "question": "A consortium of colleges and universities recently worked to integrate their authentication systems so that students registered at one institution may use their credentials to access services at other institutions. <br>What term best describes this arrangement?",
    "choice_a": "Federation",
    "choice_b": "Identity proofing",
    "choice_c": "Enrollment",
    "choice_d": "Provisioning",
    "correct_answer": "A",
    "explanation": "This is an example of federation, where user credentials from one organization are accepted as proof of identity by another organization. The users are not creating new accounts, so there is no identity proofing, enrollment, or provisioning activity taking place.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      460,
      476,
      761,
      442,
      459
    ],
    "source": ""
  },
  {
    "id": 3136,
    "question": "Olivia is selecting a new biometric authentication technology and is considering purchasing iris scanners. <br>What advantage do iris scans have over most other types of biometric factors?",
    "choice_a": "Iris scanners are harder to deceive.",
    "choice_b": "Irises don't change as much as other factors.",
    "choice_c": "Iris scanners are cheaper than other factors.",
    "choice_d": "Iris scans cannot be easily replicated.",
    "correct_answer": "B",
    "explanation": "Iris scans have a longer useful life than many other types of biometric factors because they don't change throughout a person's life span (unless the eye itself is damaged). Iris scanners can be fooled in some cases by high-resolution images of an eye, and iris scanners are not significantly cheaper than other scanners.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      748,
      745,
      443,
      459,
      750
    ],
    "source": ""
  },
  {
    "id": 3138,
    "question": "Matthew, Richard, and Christopher would like to exchange messages with each other using symmetric cryptography. They want to ensure that each individual can privately send a message to another individual without the third person being able to read the message. <br>How many keys do they need?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "6",
    "correct_answer": "C",
    "explanation": "They need a key for every possible pair of users in the cryptosystem. The first key would allow communication between Matthew and Richard. The second key would allow communication between Richard and Christopher. The third key would allow communication between Christopher and Matthew.",
    "topic_id": 3,
    "practice_test_id": 3,
    "related_articles": [
      153,
      165,
      152,
      145,
      167
    ],
    "source": ""
  },
  {
    "id": 3139,
    "question": "Colleen is responsible for protecting credit card numbers as part of her organization's efforts to comply with PCI DSS. She would like to select an appropriate control to protect those numbers while in transit over the network. <br>Which of the following controls would best meet this need?",
    "choice_a": "FDE",
    "choice_b": "SSL",
    "choice_c": "TPM",
    "choice_d": "TLS",
    "correct_answer": "D",
    "explanation": "All of these controls involve the use of encryption, but only Transport Layer Security (TLS) provides a strong, effective means for protecting data in transit. Secure Sockets Layer (SSL) is an outdated method for protecting data in transit that should no longer be used. Full disk encryption (FDE) provides encryption for data at rest. The Trusted Platform Module (TPM) manages encryption keys for use in FDE.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      122,
      700,
      702,
      142,
      144
    ],
    "source": ""
  },
  {
    "id": 3140,
    "question": "Joe is concerned about the confidentiality of email messages as they are transiting the internet from his organization's servers to their final destination. <br>What is the best way that Joe can ensure email confidentiality in motion?",
    "choice_a": "Use TLS between the client and server.",
    "choice_b": "Use SSL between the client and server.",
    "choice_c": "Encrypt the email content.",
    "choice_d": "Use a digital signature.",
    "correct_answer": "C",
    "explanation": "The SMTP protocol does not guarantee confidentiality between servers, making TLS or SSL between the client and server only a partial measure. Encrypting the email content can provide confidentiality; digital signatures can provide nonrepudiation.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      122,
      144,
      702,
      124,
      125
    ],
    "source": ""
  },
  {
    "id": 3141,
    "question": "Brenda is analyzing the web server logs after a successful compromise of her organization's web-based order processing application. She finds an entry in the log file showing that a user entered the following information as his last name when placing an order:<br><code>Smith';DROP TABLE orders;-- </code> <br>What type of attack was attempted?",
    "choice_a": "Buffer overflow",
    "choice_b": "Cross-site scripting",
    "choice_c": "Cross-site request forgery",
    "choice_d": "SQL injection",
    "correct_answer": "D",
    "explanation": "The single quotation mark in the input field is a telltale sign that this is a SQL injection attack. The quotation mark is used to escape outside the SQL code's input field, and the text following is used to directly manipulate the SQL command sent from the web application to the database.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      658,
      661,
      668,
      672,
      659
    ],
    "source": ""
  },
  {
    "id": 3142,
    "question": "Hannah's organization is implementing a new approach to user authentication that relies upon SAML. She would like to protect against eavesdropping on this traffic and also ensure that SAML traffic is not forged by an attacker. <br>What should she do to protect against both types of attack?",
    "choice_a": "Use SAML's secure mode to provide secure authentication.",
    "choice_b": "Implement TLS using a strong cipher suite, which will protect against both types of attacks.",
    "choice_c": "Implement TLS using a strong cipher suite and use digital signatures.",
    "choice_d": "Implement TLS using a strong cipher suite and message hashing.",
    "correct_answer": "C",
    "explanation": "TLS provides message confidentiality and integrity, which can prevent eavesdropping. When paired with digital signatures, which provide integrity and authentication, forged assertions can also be defeated. SAML does not have a security mode and relies on TLS and digital signatures to ensure security if needed. Message hashing without a signature would help prevent modification of the message but won't necessarily provide authentication.",
    "topic_id": 5,
    "practice_test_id": 3,
    "related_articles": [
      474,
      476,
      481,
      488,
      492
    ],
    "source": ""
  },
  {
    "id": 3143,
    "question": "What is the goal of the BCP process?",
    "choice_a": "RTO < MTD",
    "choice_b": "MTD < RTO",
    "choice_c": "RPO < MTD",
    "choice_d": "MTD < RPO",
    "correct_answer": "A",
    "explanation": "The goal of the business continuity planning process is to ensure that your recovery time objectives are all less than your maximum tolerable downtimes.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      74,
      84,
      88,
      95,
      93
    ],
    "source": ""
  },
  {
    "id": 3144,
    "question": "During which phase of the incident response process would administrators design new security controls intended to prevent a recurrence of the incident?",
    "choice_a": "Reporting",
    "choice_b": "Recovery",
    "choice_c": "Remediation",
    "choice_d": "Lessons learned",
    "correct_answer": "C",
    "explanation": "The remediation phase of incident handling focuses on conducting a root-cause analysis to identify the factors contributing to an incident and implementing new security controls, as needed.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      540,
      537,
      920,
      565,
      595
    ],
    "source": ""
  },
  {
    "id": 3145,
    "question": "Bethany received an email from one of her colleagues with an unusual attachment named <code>smime.p7s</code>. She does not recognize the attachment and is unsure what to do. <br>What is the most likely scenario?",
    "choice_a": "This is an encrypted email message.",
    "choice_b": "This is a phishing attack.",
    "choice_c": "This is embedded malware.",
    "choice_d": "This is a spoofing attack.",
    "correct_answer": "A",
    "explanation": "The S/MIME secure email format uses the P7S format for encrypted email messages. If the recipient does not have a mail reader that supports S/MIME, the message will appear with an attachment named <code>smime.p7s</code>.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3146,
    "question": "Kim is the database security administrator for Aircraft Systems, Inc. (ASI). ASI is a military contractor engaged in the design and analysis of aircraft avionics systems and regularly handles classified information on behalf of the government and other government contractors. Kim is concerned about ensuring the security of information stored in ASI databases. <br>Kim's database is a multilevel security database, and different ASI employees have different security clearances. The database contains information on the location of military aircraft containing ASI systems to allow ASI staff to monitor those systems. <br>Kim learned that the military is planning a classified mission that involves some ASI aircraft. She is concerned that employees not cleared for the mission may learn of it by noticing the movement of many aircraft to the region. Individual employees are cleared to know about the movement of an individual aircraft, but they are not cleared to know about the overall mission. <br>What type of attack is Kim concerned about?",
    "choice_a": "Aggregation",
    "choice_b": "SQL injection",
    "choice_c": "Inference",
    "choice_d": "Multilevel security",
    "correct_answer": "A",
    "explanation": "Aggregation is a security issue that arises when a collection of facts has a higher classification than the classification of any of those facts standing alone. An inference problem occurs when an attacker can deduce information of greater sensitivity from a lower security level fact. SQL injection is a web application exploit. Multilevel security is a system control that allows the simultaneous processing of information at different classification levels.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      634,
      633,
      636,
      658,
      635
    ],
    "source": ""
  },
  {
    "id": 3147,
    "question": "Kim is the database security administrator for Aircraft Systems, Inc. (ASI). ASI is a military contractor engaged in the design and analysis of aircraft avionics systems and regularly handles classified information on behalf of the government and other government contractors. Kim is concerned about ensuring the security of information stored in ASI databases. <br>Kim's database is a multilevel security database, and different ASI employees have different security clearances. The database contains information on the location of military aircraft containing ASI systems to allow ASI staff to monitor those systems. <br>What technique can Kim employ to prevent employees not cleared for the mission from learning the true location of the aircraft?",
    "choice_a": "Input validation",
    "choice_b": "Polyinstantiation",
    "choice_c": "Parameterization",
    "choice_d": "Server-side validation",
    "correct_answer": "B",
    "explanation": "Polyinstantiation allows the storage of multiple different pieces of information in a database at different classification levels to prevent attackers from conducting aggregation or inference attacks. Kim could store incorrect location information in the database at lower classification levels to prevent the aggregation attack in this scenario. Input validation, server-side validation, and parameterization are all techniques used to prevent web application attacks and are not effective against inference attacks.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      634,
      633,
      636,
      641,
      669
    ],
    "source": ""
  },
  {
    "id": 3148,
    "question": "Kim is the database security administrator for Aircraft Systems, Inc. (ASI). ASI is a military contractor engaged in the design and analysis of aircraft avionics systems and regularly handles classified information on behalf of the government and other government contractors. Kim is concerned about ensuring the security of information stored in ASI databases. <br>Kim's database is a multilevel security database, and different ASI employees have different security clearances. The database contains information on the location of military aircraft containing ASI systems to allow ASI staff to monitor those systems. <br>Kim's database uniquely identifies aircraft by using their tail number. <br>Which one of the following terms would not necessarily accurately describe the tail number?",
    "choice_a": "Database field",
    "choice_b": "Foreign key",
    "choice_c": "Primary key",
    "choice_d": "Candidate key",
    "correct_answer": "B",
    "explanation": "The tail number is a database field because it is stored in the database. It is also a primary key because the question states that the database uniquely identifies aircraft using this field. Any primary key is, by definition, also a candidate key. There is no information provided that the tail number is a foreign key used to reference a different database table.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      838,
      839,
      840,
      630,
      633
    ],
    "source": ""
  },
  {
    "id": 3149,
    "question": "Kim would like to create a key that enforces referential integrity for the database. <br>What type of key does she need to create?",
    "choice_a": "Primary key",
    "choice_b": "Foreign key",
    "choice_c": "Candidate key",
    "choice_d": "Master key",
    "correct_answer": "B",
    "explanation": "Foreign keys are used to create relationships between tables in a database. The database enforces referential integrity by ensuring that the foreign key used in a table has a corresponding record with that value as the primary key in the referenced table.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      840,
      630,
      838,
      632,
      635
    ],
    "source": ""
  },
  {
    "id": 3150,
    "question": "Doug is choosing a software development lifecycle model for use in a project he is leading to develop a new business application. He has clearly defined requirements and would like to choose an approach that places an early emphasis on developing comprehensive documentation. He does not have a need for the production of rapid prototypes or iterative improvement. <br>Which model is most appropriate for this scenario?",
    "choice_a": "Agile",
    "choice_b": "Waterfall",
    "choice_c": "Spiral",
    "choice_d": "DevOps",
    "correct_answer": "B",
    "explanation": "The waterfall model uses an approach that develops software sequentially, spending quite a bit of time up front on the development and documentation of requirements and design. The spiral and Agile models focus on iterative development and are appropriate when requirements are not well understood or iterative development is preferred. DevOps is an approach to integrating development and operations activities and is not an SDLC model.",
    "topic_id": 8,
    "practice_test_id": 3,
    "related_articles": [
      622,
      640,
      1034,
      621,
      625
    ],
    "source": ""
  },
  {
    "id": 3151,
    "question": "Which individual bears the ultimate responsibility for data protection tasks?",
    "choice_a": "Data owner",
    "choice_b": "Data custodian",
    "choice_c": "User",
    "choice_d": "Auditor",
    "correct_answer": "A",
    "explanation": "The data owner is a senior manager who bears ultimate responsibility for data protection tasks. The data owner typically delegates this responsibility to one or more data custodians.",
    "topic_id": 2,
    "practice_test_id": 3,
    "related_articles": [
      138,
      851,
      143,
      989,
      988
    ],
    "source": ""
  },
  {
    "id": 3152,
    "question": "Carla is conducting a web application security test and would like to automatically generate input that is used to test the application. <br>Which of the following tools would be best suited for this purpose?",
    "choice_a": "Static application testing tool",
    "choice_b": "White-box testing tool",
    "choice_c": "Brute force testing tool",
    "choice_d": "Fuzz testing tool",
    "correct_answer": "D",
    "explanation": "Fuzz testing tools are designed to provide invalid or unexpected input to applications, testing for vulnerabilities like format string vulnerabilities, buffer overflow issues, and other problems. A static analysis relies on examining code without running the application or code and thus would not fill forms as part of a web application. Brute-force tools attempt to bypass security by trying every possible combination for passwords or other values. A white box is a type of penetration test where the testers have full knowledge of the environment.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      775,
      776,
      777,
      494,
      495
    ],
    "source": ""
  },
  {
    "id": 3153,
    "question": "Warren's organization recently completed a massive phishing awareness campaign, and he would like to measure its effectiveness. <br>Which of the following tools would best provide this measurement?",
    "choice_a": "Survey",
    "choice_b": "Simulation",
    "choice_c": "Code review",
    "choice_d": "Third-party assessment",
    "correct_answer": "B",
    "explanation": "Warren could use a survey or third-party assessment to evaluate the effectiveness of the campaign, but the best evidence would be provided by a phishing simulation where the organization measures user responses to simulated phishing attacks. Code reviews would not be useful in evaluating the effectiveness of antiphishing campaigns.",
    "topic_id": 6,
    "practice_test_id": 3,
    "related_articles": [
      501,
      502,
      499,
      498,
      496
    ],
    "source": ""
  },
  {
    "id": 3154,
    "question": "Which one of the following controls would be most effective in detecting zero-day attack attempts?",
    "choice_a": "Signature-based intrusion detection",
    "choice_b": "Anomaly-based intrusion detection",
    "choice_c": "Strong patch management",
    "choice_d": "Full-disk encryption",
    "correct_answer": "B",
    "explanation": "Anomaly-based intrusion detection systems may identify a zero-day vulnerability because it deviates from normal patterns of activity. Signature-based detection methods would not be effective because there are no signatures for zero-day vulnerabilities. Strong patch management would not be helpful because, by definition, zero-day vulnerabilities do not have patches available. Full-disk encryption would not detect an attack because it is not a detective control.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      566,
      547,
      1043,
      543,
      548
    ],
    "source": ""
  },
  {
    "id": 3156,
    "question": "Which one of the following components should be included in an organization's emergency response guidelines?",
    "choice_a": "Secondary response procedures for incident responders",
    "choice_b": "Long-term business continuity protocols",
    "choice_c": "Activation procedures for the organization's cold sites",
    "choice_d": "Contact information for ordering equipment",
    "correct_answer": "A",
    "explanation": "The emergency response guidelines should include the immediate steps an organization should follow in response to an emergency situation. These include immediate response procedures, a list of individuals who should be notified of the emergency, and secondary response procedures for incident responders. They do not include long-term actions such as activating business continuity protocols, ordering equipment, or activating disaster recovery sites.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      587,
      538,
      561,
      581,
      537
    ],
    "source": ""
  },
  {
    "id": 3157,
    "question": "When Jim enters his organization's data center, he has to use a smart card and code to enter and is allowed through one set of doors. The first set of doors closes, and he must then use his card again to get through a second set, which locks behind him. <br>What type of control is this, and what is it called?",
    "choice_a": "A physical control; a one-way trapdoor",
    "choice_b": "A logical control; a dual-swipe authorization",
    "choice_c": "A directive control; a one-way access corridor",
    "choice_d": "A preventive access control; a mantrap",
    "correct_answer": "D",
    "explanation": "A mantrap uses two sets of doors, only one of which can open at a time. A mantrap is a type of preventive access control, although its implementation is a physical control.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      508,
      543,
      854,
      855,
      504
    ],
    "source": ""
  },
  {
    "id": 3158,
    "question": "Bill implemented RAID level 5 on a server that he operates using a total of three disks. <br>How many disks may fail without the loss of data?",
    "choice_a": "0",
    "choice_b": "1",
    "choice_c": "2",
    "choice_d": "3",
    "correct_answer": "B",
    "explanation": "RAID level 5 is also known as disk striping with parity. It uses three or more disks, with one disk containing parity information used to restore data to another disk in the event of failure. When used with three disks, RAID 5 is able to withstand the loss of a single disk.",
    "topic_id": 7,
    "practice_test_id": 3,
    "related_articles": [
      576,
      836,
      835,
      575,
      837
    ],
    "source": ""
  },
  {
    "id": 3159,
    "question": "What type of access control is intended to discover unwanted or unauthorized activity by providing information after the event has occurred?",
    "choice_a": "Preventive",
    "choice_b": "Corrective",
    "choice_c": "Detective",
    "choice_d": "Directive",
    "correct_answer": "C",
    "explanation": "Detective access controls operate after the fact and are intended to detect or discover unwanted access or activity. Preventive access controls are designed to prevent the activity from occurring, whereas corrective controls return an environment to its original status after an issue occurs. Directive access controls limit or direct the actions of subjects to ensure compliance with policies.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      47,
      48,
      69,
      37,
      13
    ],
    "source": ""
  },
  {
    "id": 3160,
    "question": "Which one of the following presents the most complex decoy environment for an attacker to explore during an intrusion attempt?",
    "choice_a": "Honeypot",
    "choice_b": "Darknet",
    "choice_c": "Honeynet",
    "choice_d": "Pseudoflaw",
    "correct_answer": "C",
    "explanation": "A honeypot is a decoy computer system used to bait intruders into attacking. A honeynet is a network of multiple honeypots that creates a more sophisticated environment for intruders to explore. A pseudoflaw is a false vulnerability in a system that may attract an attacker. A darknet is a segment of unused network address space that should have no network activity and, therefore, may be easily used to monitor for illicit activity.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      566,
      603,
      541,
      556,
      563
    ],
    "source": ""
  },
  {
    "id": 3161,
    "question": "Ben's organization is adopting biometric authentication for their high-security building's access control system. Using this chart, answer the question about their adoption of the technology. <br><img src=\"/question_assets/CISSP/12_image1.png\"/><br>Ben's company is considering configuring their systems to work at the level shown by point A on the diagram. What level are they setting the sensitivity to?",
    "choice_a": "The FRR crossover",
    "choice_b": "The FAR point",
    "choice_c": "The CER",
    "choice_d": "The CFR",
    "correct_answer": "C",
    "explanation": "The CER is the point where FAR and FRR cross over, and it is a standard assessment used to compare the accuracy of biometric devices.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      445,
      459,
      750,
      748,
      446
    ],
    "source": ""
  },
  {
    "id": 3162,
    "question": "Ben's organization is adopting biometric authentication for their high-security building's access control system. Using this chart, answer the question about their adoption of the technology. <br><img src=\"/question_assets/CISSP/12_image1.png\"/><br>At point B, what problem is likely to occur?",
    "choice_a": "False acceptance will be very high.",
    "choice_b": "False rejection will be very high.",
    "choice_c": "False rejection will be very low.",
    "choice_d": "False acceptance will be very low.",
    "correct_answer": "A",
    "explanation": "At point B, the false acceptance rate (FAR) is quite high, whereas the false rejection rate (FRR) is relatively low. This may be acceptable in some circumstances, but in organizations where a false acceptance can cause a major problem, it is likely that they should instead choose a point to the right of point A.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      445,
      750,
      446,
      469,
      441
    ],
    "source": ""
  },
  {
    "id": 3163,
    "question": "Ben's organization is adopting biometric authentication for their high-security building's access control system. Using this chart, answer the question about their adoption of the technology. <br><img src=\"/question_assets/CISSP/12_image1.png\"/><br>What should Ben do if the FAR and FRR shown in this diagram do not provide an acceptable performance level for his organization's needs?",
    "choice_a": "Adjust the sensitivity of the biometric devices.",
    "choice_b": "Assess other biometric systems to compare them.",
    "choice_c": "Move the CER.",
    "choice_d": "Adjust the FRR settings in software.",
    "correct_answer": "B",
    "explanation": "CER is a standard used to assess biometric devices. If the CER for this device does not fit the needs of the organization, Ben should assess other biometric systems to find one with a lower CER. Sensitivity is already accounted for in CER charts, and moving the CER isn't something Ben can do. FRR is not a setting in software, so Ben can't use that as an option either.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      445,
      459,
      750,
      748,
      446
    ],
    "source": ""
  },
  {
    "id": 3164,
    "question": "Ed is tasked with protecting information about his organization's customers, including their name, Social Security number, birthdate, and place of birth, as well as a variety of other information. <br>What is this information known as?",
    "choice_a": "PHI",
    "choice_b": "PII",
    "choice_c": "Personal protected data",
    "choice_d": "PID",
    "correct_answer": "B",
    "explanation": "Personally identifiable information (PII) can be used to distinguish a person's identity. Personal health information (PHI) includes data such as medical history, lab results, insurance information, and other details about a patient. Personal protected data is a made-up term, and PID is an acronym for process ID, the number associated with a running program or process.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      703,
      120,
      143,
      138,
      126
    ],
    "source": ""
  },
  {
    "id": 3165,
    "question": "What software development lifecycle model is shown in the following illustration? <br><img src=\"/question_assets/CISSP/12_image2.png\"/>",
    "choice_a": "Spiral",
    "choice_b": "Agile",
    "choice_c": "Boehm",
    "choice_d": "Waterfall",
    "correct_answer": "D",
    "explanation": "The figure shows the waterfall model, developed by Winston Royce. An important characteristic of this model is a series of sequential steps that include a feedback loop that allows the process to return one step prior to the current step when necessary.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      622,
      640,
      621,
      1034,
      833
    ],
    "source": ""
  },
  {
    "id": 3166,
    "question": "Encapsulation is the core concept that enables what type of protocol?",
    "choice_a": "Bridging",
    "choice_b": "Multilayer",
    "choice_c": "Hashing",
    "choice_d": "Storage",
    "correct_answer": "B",
    "explanation": "Encapsulation creates both the benefits and potential issues with multilayer protocols. Bridging can use various protocols but does not rely on encapsulation. Hashing and storage protocols typically do not rely on encapsulation as a core part of their functionality.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      351,
      412,
      742,
      411,
      352
    ],
    "source": ""
  },
  {
    "id": 3167,
    "question": "Amanda wants to use contacts from the existing Gmail accounts that new users for her application already have. <br>What protocol from the following options is used to provide secure delegated access for this type of use by many cloud providers?",
    "choice_a": "Open ID",
    "choice_b": "Kerberos",
    "choice_c": "OAuth",
    "choice_d": "SAML",
    "correct_answer": "C",
    "explanation": "OAuth is used to provide secure delegated access in scenarios exactly like this. OpenID is used to sign in using credentials from an identity provider to other services, such as when you log in with Google to other sites. SAML, or Security Assertion Markup Language, is used to make security assertions allowing authentication and authorizations between identity providers and service providers. Kerberos is mostly used inside of organizations instead of for federation, as this question focuses on.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      757,
      476,
      1020,
      451,
      899
    ],
    "source": ""
  },
  {
    "id": 3168,
    "question": "Which one of the following metrics specifies the amount of time that business continuity planners find acceptable for the restoration of service after a disaster?",
    "choice_a": "MTD",
    "choice_b": "RTO",
    "choice_c": "RPO",
    "choice_d": "MTO",
    "correct_answer": "B",
    "explanation": "The recovery time objective (RTO) is the amount of time that it may take to restore a service after a disaster without unacceptable impact on the business. The RTO for each service is identified during a business impact assessment.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      580,
      569,
      588,
      591,
      598
    ],
    "source": ""
  },
  {
    "id": 3169,
    "question": "Jill is working to procure new network hardware for her organization. She finds a gray market supplier that is importing the hardware from outside the country at a much lower price. <br>What security concern is the most significant for hardware acquired this way?",
    "choice_a": "The security of the hardware and firmware",
    "choice_b": "Availability of support for the hardware and software",
    "choice_c": "Whether the hardware is a legitimate product of the actual vendor",
    "choice_d": "The age of the hardware",
    "correct_answer": "A",
    "explanation": "Each of these answers may be a concern, but the overriding security concern is if the hardware and firmware can be trusted or may have been modified. Original equipment manufacturers (OEMs) have business reasons to ensure the security of their product, but third parties in the supply chain may not feel the same pressure. Both availability of support and whether the hardware is legitimate are also concerns, but less immediate security concerns. Finally, hardware may be older than expected, or may be used, refurbished, or otherwise not new.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      28,
      29,
      111,
      2,
      47
    ],
    "source": ""
  },
  {
    "id": 3170,
    "question": "What process is typically used to ensure data security for workstations that are being removed from service but that will be resold or otherwise reused?",
    "choice_a": "Destruction",
    "choice_b": "Erasing",
    "choice_c": "Sanitization",
    "choice_d": "Clearing",
    "correct_answer": "C",
    "explanation": "When done properly, a sanitization process fully ensures that data is not remnant on the system before it is reused. Clearing and erasing can both be failure prone, and of course, destruction wouldn't leave a machine or device to reuse.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      129,
      130,
      1026,
      133,
      1025
    ],
    "source": ""
  },
  {
    "id": 3171,
    "question": "Colleen is conducting a software test that is evaluating code for both security flaws and usability issues. She is working with the application from an end-user perspective and referencing the source code as she works her way through the product. <br>What type of testing is Colleen conducting?",
    "choice_a": "White box",
    "choice_b": "Blue box",
    "choice_c": "Gray box",
    "choice_d": "Black box",
    "correct_answer": "C",
    "explanation": "In a gray-box test, the tester evaluates the software from a user perspective but has access to the source code as the test is conducted. White-box tests also have access to the source code but perform testing from a developer's perspective. Black-box tests work from a user's perspective but do not have access to source code. Blue boxes are a telephone hacking tool and not a software testing technique. Note: as language changes, new terms like zero knowledge, partial knowledge, and full knowledge are starting to replace white-, gray-, and black-box testing terms.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      494,
      495,
      496,
      778,
      1003
    ],
    "source": ""
  },
  {
    "id": 3172,
    "question": "Harold is looking for a software development methodology that will help with a major issue he is seeing in his organization. Currently, developers and operations staff do not work together and are often seen as taking problems and \"throwing them over the fence\" to the other team. <br>What technology management approach is designed to alleviate this problem?",
    "choice_a": "ITIL",
    "choice_b": "Lean",
    "choice_c": "ITSM",
    "choice_d": "DevOps",
    "correct_answer": "D",
    "explanation": "The DevOps approach to technology management seeks to integrate software development, operations, and quality assurance in a cohesive effort. It specifically attempts to eliminate the issue of \"throwing problems over the fence\" by building collaborative relationships between members of the IT team.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      832,
      625,
      640,
      621,
      622
    ],
    "source": ""
  },
  {
    "id": 3173,
    "question": "NIST Special Publication 800-92, the Guide to Computer Security Log Management, describes four types of common challenges to log management: <li>Many log sources</li><li>Inconsistent log content</li><li>Inconsistent timestamps</li><li>Inconsistent log formats</li><br>Which of the following solutions is best suited to solving these issues?",
    "choice_a": "Implement SNMP for all logging devices.",
    "choice_b": "Implement a SIEM.",
    "choice_c": "Standardize on the Windows event log format for all devices and use NTP.",
    "choice_d": "Ensure that logging is enabled on all endpoints using their native logging formats and set their local time correctly.",
    "correct_answer": "B",
    "explanation": "A security information and event management (SIEM) tool is designed to centralize logs from many locations in many formats and to ensure that logs are read and analyzed despite differences between different systems and devices. The Simple Network Management Protocol (SNMP) is used for some log messaging but is not a solution that solves all of these problems. Most non-Windows devices, including network devices among others, are not designed to use the Windows event log format, although using NTP for time synchronization is a good idea. Finally, local logging is useful, but setting clocks individually will result in drift over time and won't solve the issue with many log sources.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      557,
      843,
      554,
      841,
      566
    ],
    "source": ""
  },
  {
    "id": 3175,
    "question": "Carlos is investigating the compromise of sensitive information in his organization. He believes that attackers managed to retrieve personnel information on all employees from the database and finds the following user-supplied input in a log entry for a web-based personnel management system: <br><code>Collins'&1=1;\u2013\u2013</code> <br>What type of attack took place, and how could it be prevented?",
    "choice_a": "SQL injection, use of stored procedures",
    "choice_b": "Buffer overflow, automatic buffer expansion",
    "choice_c": "Cross-site scripting, turning on XSS prevention on the web server",
    "choice_d": "Cross-site request forgery, requiring signed requests",
    "correct_answer": "A",
    "explanation": "The single quotation mark in the input field is a telltale sign that this is a SQL injection attack. The quotation mark is used to escape outside the SQL code's input field, and the text that follows is used to directly manipulate the SQL command sent from the web application to the database.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      658,
      661,
      668,
      620,
      675
    ],
    "source": ""
  },
  {
    "id": 3176,
    "question": "Which one of the following is a detailed, step-by-step document that describes the exact actions that individuals must complete?",
    "choice_a": "Policy",
    "choice_b": "Standard",
    "choice_c": "Guideline",
    "choice_d": "Procedure",
    "correct_answer": "D",
    "explanation": "Procedures are formal, mandatory documents that provide detailed, step-by-step actions required from individuals performing a task.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      22,
      65,
      69,
      17,
      15
    ],
    "source": ""
  },
  {
    "id": 3177,
    "question": "What purpose are the CIS benchmarks frequently used for in organizations?",
    "choice_a": "Secure coding standards",
    "choice_b": "Performance testing",
    "choice_c": "Baselining",
    "choice_d": "Monitoring metrics",
    "correct_answer": "C",
    "explanation": "The CIS benchmarks are configuration baselines that are frequently used to assess the security settings or configuration for devices and software. Baselining is the process of configuring and validating that a system  meets security configuration guidelines or standards.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      534,
      524,
      523,
      798,
      975
    ],
    "source": ""
  },
  {
    "id": 3179,
    "question": "Carlos is planning a design for a data center that will be constructed within a new four-story corporate headquarters. The building consists of a basement and three above-ground floors. <br>What is the best location for the data center?",
    "choice_a": "Basement",
    "choice_b": "First floor",
    "choice_c": "Second floor",
    "choice_d": "Third floor",
    "correct_answer": "C",
    "explanation": "Data centers should be located in the core of a building. Locating it on lower floors makes it susceptible to flooding and physical break-ins. Locating it on the top floor makes it vulnerable to wind and roof damage.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      910,
      911,
      912,
      508,
      592
    ],
    "source": ""
  },
  {
    "id": 3180,
    "question": "Chris is an information security professional for a major corporation, and as he is walking into the building, he notices that the door to a secure area has been left ajar. Physical security does not fall under his responsibility, but he takes immediate action by closing the door and informing the physical security team of his action. <br>What principle is Chris demonstrating?",
    "choice_a": "Due care",
    "choice_b": "Crime prevention through environmental design",
    "choice_c": "Separation of duties",
    "choice_d": "Informed consent",
    "correct_answer": "A",
    "explanation": "The due care principle states that an individual should react in a situation using the same level of care that would be expected from any reasonable person. It is a very broad standard. Crime prevention through environmental design is a design concept that focuses on making environments less conducive to illicit or unwanted actions. Separation of duties splits duties to ensure that a malicious actor cannot perform actions on their own like making a purchase and approving it. Informed consent is a term used in the medical industry that requires that a person's permission is required and that they must be aware of what the consequences of their actions could be.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      20,
      15,
      47,
      17,
      11
    ],
    "source": ""
  },
  {
    "id": 3181,
    "question": "Which one of the following investigation types always uses the beyond-a-reasonable-doubt standard of proof?",
    "choice_a": "Civil investigation",
    "choice_b": "Criminal investigation",
    "choice_c": "Operational investigation",
    "choice_d": "Regulatory investigation",
    "correct_answer": "B",
    "explanation": "Criminal investigations have high stakes with severe punishment for the offender that may include incarceration. Therefore, they use the strictest standard of evidence of all investigations: beyond a reasonable doubt. Civil investigations use a preponderance-of-the-evidence standard. Regulatory investigations may use whatever standard is appropriate for the venue where the evidence will be heard. This may include the beyond-a-reasonable-doubt standard, but it is not always used in regulatory investigations in the United States. Operational investigations do not use a standard of evidence.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      599,
      801,
      605,
      615,
      541
    ],
    "source": ""
  },
  {
    "id": 3182,
    "question": "Kristen wants to use multiple processing sites for her data, but does not want to pay for a full data center. <br>Which of the following options would you recommend as her best option if she wants to be able to quickly migrate portions of her custom application environment to facilities in multiple countries without having to wait to ship or acquire hardware?",
    "choice_a": "A cloud PaaS vendor",
    "choice_b": "A hosted data center provider",
    "choice_c": "A cloud IaaS vendor",
    "choice_d": "A data center vendor that provides rack, power, and remote hands services",
    "correct_answer": "C",
    "explanation": "A cloud IaaS vendor will allow Kristen to set up infrastructure as quickly as she can deploy and pay for it. A PaaS vendor provides a platform that would require her to migrate her custom application to it, likely taking longer than a hosted data center provider. A data center vendor that provides rack, power, and remote hands assistance fails the test based on Kristen's desire to not have to acquire or ship hardware.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      519,
      582,
      521,
      598,
      915
    ],
    "source": ""
  },
  {
    "id": 3183,
    "question": "What type of alternate processing facility contains the hardware necessary to restore operations but does not have a current copy of data?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Mobile site",
    "correct_answer": "B",
    "explanation": "Warm sites contain the hardware necessary to restore operations but do not have a current copy of data.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      582,
      598,
      583,
      586,
      597
    ],
    "source": ""
  },
  {
    "id": 3184,
    "question": "Which one of the following terms describes a period of momentary high voltage?",
    "choice_a": "Sag",
    "choice_b": "Brownout",
    "choice_c": "Spike",
    "choice_d": "Surge",
    "correct_answer": "C",
    "explanation": "A power spike is a momentary period of high voltage. A surge is a prolonged period of high voltage. Sags and brownouts are periods of low voltage.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      916,
      312,
      226,
      324,
      228
    ],
    "source": ""
  },
  {
    "id": 3185,
    "question": "Greg needs to label drives used for his company's medical insurance claims database. <br>What data label from the following list best matches the type of data he is dealing with?",
    "choice_a": "PII",
    "choice_b": "Secret",
    "choice_c": "Business confidential",
    "choice_d": "PHI",
    "correct_answer": "D",
    "explanation": "Medical insurance claims will contain private health information, or PHI. Greg should label the drives as containing PHI and then ensure that they are handled according to his organization's handling standards for that type of data.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      120,
      143,
      128,
      124,
      123
    ],
    "source": ""
  },
  {
    "id": 3187,
    "question": "Selah wants to ensure that vehicles cannot crash through into her company's entryway and front lobby while still remaining accessible to pedestrians and wheelchairs or other mobility devices. <br>What physical security control is best suited to this purpose?",
    "choice_a": "Fences",
    "choice_b": "Bollards",
    "choice_c": "Walls",
    "choice_d": "Stairs",
    "correct_answer": "B",
    "explanation": "Bollards are physical security solutions that are short and strong posts or similar solutions intended to stop vehicles from crashing through or passing an area. Bollards can be used to allow pedestrians and mobility devices to pass while stopping vehicles. Fences and walls will prevent individuals from passing through them, while stairs are challenging for most mobility devices.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      320,
      325,
      329,
      304,
      327
    ],
    "source": ""
  },
  {
    "id": 3188,
    "question": "Concho Controls is a midsize business focusing on building automation systems. It hosts a set of local file servers in its on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>What backup should Tara apply to the server first?",
    "choice_a": "Sunday's full backup",
    "choice_b": "Monday's differential backup",
    "choice_c": "Tuesday's differential backup",
    "choice_d": "Wednesday's differential backup",
    "correct_answer": "A",
    "explanation": "Tara first must achieve a system baseline. She does this by applying the most recent full backup to the new system. This is Sunday's full backup. Once Tara establishes this baseline, she may then proceed to apply differential backups to bring the system back to a more recent state.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      226,
      213,
      222,
      324,
      228
    ],
    "source": ""
  },
  {
    "id": 3189,
    "question": "Concho Controls is a midsize business focusing on building automation systems. It hosts a set of local file servers in its on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>How many backups in total must Tara apply to the system to make the data it contains as current as possible?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "B",
    "explanation": "To restore the system to as current a state as possible, Tara must first apply Sunday's full backup. She may then apply the most recent differential backup, from Wednesday at noon. Differential backups include all files that have changed since the most recent full backup, so the contents of Wednesday's backup contain all of the data that would be contained in Monday and Tuesday's backups, making the Monday and Tuesday backups irrelevant for this scenario.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3190,
    "question": "Concho Controls is a midsize business focusing on building automation systems. It hosts a set of local file servers in its on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>In this backup approach, some data may be irretrievably lost. <br>How long is the time period where any changes made will have been lost?",
    "choice_a": "3 hours.",
    "choice_b": "5 hours.",
    "choice_c": "8 hours.",
    "choice_d": "No data will be lost.",
    "correct_answer": "A",
    "explanation": "In this scenario, the differential backup was made at noon, and the server failed at 3 p.m. Therefore, any data modified or created between noon and 3 p.m. on Wednesday will not be contained on any backup and will be irretrievably lost.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      226,
      211,
      918,
      296,
      219
    ],
    "source": ""
  },
  {
    "id": 3191,
    "question": "Concho Controls is a midsize business focusing on building automation systems. It hosts a set of local file servers in its on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>If Tara followed the same schedule but switched the differential backups to incremental backups, how many backups in total would she need to apply to the system to make the data it contains as current as possible?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "D",
    "explanation": "By switching from differential to incremental backups, Tara's weekday backups will only contain the information changed since the previous day. Therefore, she must apply all of the available incremental backups. She would begin by restoring the Sunday full backup and then apply the Monday, Tuesday, and Wednesday incremental backups.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      308,
      313,
      324,
      305,
      296
    ],
    "source": ""
  },
  {
    "id": 3192,
    "question": "Concho Controls is a midsize business focusing on building automation systems. It hosts a set of local file servers in its on-premises data center that store customer proposals, building plans, product information, and other data that is critical to their business operations. <br>Tara works in the Concho Controls IT department and is responsible for designing and implementing the organization's backup strategy, among other tasks. She currently conducts full backups every Sunday evening at 8 p.m. and differential backups on Monday through Friday at noon. <br>Concho experiences a server failure at 3 p.m. on Wednesday. Tara rebuilds the server and wants to restore data from the backups. <br>If Tara made the change from differential to incremental backups and we assume that the same amount of information changes each day, which one of the following files would be the largest?",
    "choice_a": "Monday's incremental backup.",
    "choice_b": "Tuesday's incremental backup.",
    "choice_c": "Wednesday's incremental backup.",
    "choice_d": "All three will be the same size.",
    "correct_answer": "D",
    "explanation": "Each incremental backup contains only the information changed since the most recent full or incremental backup. If we assume that the same amount of information changes every day, each of the incremental backups would be roughly the same size.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3193,
    "question": "The following figure shows an example of an attack where Mal, the attacker, has redirected traffic from a user's system to their own, allowing them to read TLS encrypted traffic. <br><img src=\"/question_assets/CISSP/12_image3.png\"/><br>Which of the following terms best describes this attack?",
    "choice_a": "A DNS hijacking attack",
    "choice_b": "An ARP spoofing attack",
    "choice_c": "A man-in-the-middle attack",
    "choice_d": "A SQL injection attack",
    "correct_answer": "C",
    "explanation": "A man-in-the-middle (increasingly often referred to as a person-in-the-middle, or on-path) attack allows an attacker to redirect traffic and thus read or modify it. This can be completely transparent to the end user, making it a dangerous attack if the malicious actor is successful. DNS hijacking would change a system's domain name information, and there is no direct indication of that here. Similarly, ARP spoofing is one way to conduct a man-in-the-middle attack, but that detail is not here either. SQL injection is normally done via web applications to execute commands against a database server.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      197,
      187,
      275,
      179,
      195
    ],
    "source": ""
  },
  {
    "id": 3194,
    "question": "Bob has been tasked with writing a policy that describes how long data should be kept and when it should be purged. <br>What concept does this policy deal with?",
    "choice_a": "Data remanence",
    "choice_b": "Record retention",
    "choice_c": "Data redaction",
    "choice_d": "Audit logging",
    "correct_answer": "B",
    "explanation": "Record retention ensures that data is kept and maintained as long as it is needed and that it is purged when it is no longer necessary. Data remanence occurs when data is left behind after an attempt is made to remove it, whereas data redaction is not a technical term used to describe this effort. Finally, audit logging may be part of the records retained but doesn't describe the lifecycle of data.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      133,
      850,
      851,
      125,
      144
    ],
    "source": ""
  },
  {
    "id": 3195,
    "question": "Which component of IPsec provides authentication, integrity, and nonrepudiation?",
    "choice_a": "L2TP",
    "choice_b": "Encapsulating Security Payload",
    "choice_c": "Encryption Security Header",
    "choice_d": "Authentication Header",
    "correct_answer": "D",
    "explanation": "The Authentication Header provides authentication, integrity, and nonrepudiation for IPsec connections. The Encapsulating Security Payload provides encryption and thus provides confidentiality. It can also provide limited authentication. L2TP is an independent VPN protocol, and Encryption Security Header is a made-up term.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      416,
      350,
      413,
      412,
      415
    ],
    "source": ""
  },
  {
    "id": 3196,
    "question": "Renee notices that a system on her network recently received connection attempts on all 65,536 TCP ports from a single system during a short period of time. <br>What type of attack did Renee most likely experience?",
    "choice_a": "Denial-of-service",
    "choice_b": "Reconnaissance",
    "choice_c": "Malicious insider",
    "choice_d": "Compromise",
    "correct_answer": "B",
    "explanation": "The attack described in the scenario is a classic example of TCP scanning, a network reconnaissance technique that may precede other attacks. There is no evidence that the attack disrupted system availability, which would characterize a denial-of-service attack; that it was waged by a malicious insider; or that the attack resulted in the compromise of a system.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      563,
      546,
      567,
      556,
      608
    ],
    "source": ""
  },
  {
    "id": 3197,
    "question": "What type of Windows audit record describes events like an OS shutdown or a service being stopped?",
    "choice_a": "An application log",
    "choice_b": "A security log",
    "choice_c": "A system log",
    "choice_d": "A setup log",
    "correct_answer": "C",
    "explanation": "Windows system logs include reboots, shutdowns, and service state changes. Application logs record events generated by programs, security logs track events like logins and uses of rights, and setup logs track application setup.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      841,
      554,
      556,
      543,
      525
    ],
    "source": ""
  },
  {
    "id": 3198,
    "question": "Melissa is in charge of her organization's security compliance efforts and has been told that the organization does not install Windows patches until a month has passed since the patch has been released unless there is a zero-day exploit that is being actively exploited. <br>Why would the company delay patching like this?",
    "choice_a": "To minimize business impact of the installation",
    "choice_b": "To allow any flaws with the patch to be identified",
    "choice_c": "To prevent malware in the patches from being installed before it is identified",
    "choice_d": "To allow the patch to be distributed to all systems",
    "correct_answer": "B",
    "explanation": "Many organizations delay patches for a period of time to ensure that any previously unidentified flaws are found before the patches are installed throughout their organization. Melissa needs to balance business impact against security in her role and may choose to support this or to push for more aggressive installation practices depending on the organization's risk tolerance and security needs.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      529,
      530,
      531,
      544,
      526
    ],
    "source": ""
  },
  {
    "id": 3199,
    "question": "What level of RAID is also known as disk striping?",
    "choice_a": "RAID 0",
    "choice_b": "RAID 1",
    "choice_c": "RAID 5",
    "choice_d": "RAID 10",
    "correct_answer": "A",
    "explanation": "RAID level 0 is also known as disk striping. RAID 1 is called disk mirroring. RAID 5 is called disk striping with parity. RAID 10 is known as a stripe of mirrors.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      576,
      836,
      835,
      837,
      572
    ],
    "source": ""
  },
  {
    "id": 3202,
    "question": "Fred's company wants to ensure the integrity of email messages sent via its central email servers. If the confidentiality of the messages is not critical, what solution should Fred suggest?",
    "choice_a": "Digitally sign and encrypt all messages to ensure integrity.",
    "choice_b": "Digitally sign but don't encrypt all messages.",
    "choice_c": "Use TLS to protect messages, ensuring their integrity.",
    "choice_d": "Use a hashing algorithm to provide a hash in each message to prove that it hasn't changed.",
    "correct_answer": "B",
    "explanation": "Fred's company needs to protect integrity, which can be accomplished by digitally signing messages. Any change will cause the signature to be invalid. Encrypting isn't necessary because the company does not want to protect confidentiality. TLS can provide in-transit protection but won't protect integrity of the messages, and of course a hash used without a way to verify that the hash wasn't changed won't ensure integrity either.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      175,
      186,
      145,
      172,
      187
    ],
    "source": ""
  },
  {
    "id": 3203,
    "question": "The leadership at Susan's company has asked her to implement an access control system that can support rule declarations like \"Only allow access to salespeople from managed devices on the wireless network between 8 a.m. and 6 p.m.\" What type of access control system would be Susan's best choice?",
    "choice_a": "ABAC",
    "choice_b": "RBAC",
    "choice_c": "DAC",
    "choice_d": "MAC",
    "correct_answer": "A",
    "explanation": "An attribute-based access control (ABAC) system will allow Susan to specify details about subjects, objects, and access, allowing granular control. Although a rule-based access control system (RBAC) might allow this, the attribute-based access control system can be more specific and thus is more flexible. Discretionary access control (DAC) would allow object owners to make decisions, and mandatory access controls (MACs) would use classifications; neither of these capabilities was described in the requirements.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      467,
      472,
      491,
      465,
      468
    ],
    "source": ""
  },
  {
    "id": 3204,
    "question": "Nora's company operates servers on a five-year lifecycle. When they reach their end of life according to that process, the servers are sent to an e-waste recycler. <br>Which of the following is the most effective control that Nora could implement to ensure that a data breach does not occur due to remanent data?",
    "choice_a": "Zero wipe the drives before the servers leave the organization.",
    "choice_b": "Remove the drives and shred them.",
    "choice_c": "Reformat the drives before the servers are sent to the e-waste company.",
    "choice_d": "Require certificates of disposal from the e-waste company.",
    "correct_answer": "B",
    "explanation": "The most effective control is to remove the drives and shred them, removing any chance for the servers to leave with data remaining on them. A trustworthy company that can provide a certificate of disposal with appropriate contractual controls may be a reasonable and cost-efficient alternative, but the company may also then want to zero wipe drives before the systems leave to reduce the risk if a system makes it out of the recycler's control. The worst answer here is reformatting, which will not remove data.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      130,
      144,
      133,
      124,
      122
    ],
    "source": ""
  },
  {
    "id": 3205,
    "question": "Chris is deploying a gigabit Ethernet network using Category 6 cable between two buildings. <br>What is the maximum distance he can run the cable according to the Category 6 standard?",
    "choice_a": "50 meters",
    "choice_b": "100 meters",
    "choice_c": "200 meters",
    "choice_d": "300 meters",
    "correct_answer": "B",
    "explanation": "The maximum allowed length of a Cat 6 cable is 100 meters, or 328 feet. Long distances are typically handled by a fiber run or by using network devices like switches or repeaters\u2014not only because of the distance, but also because outdoor runs can experience lightning strikes, which won't affect fiber. Knowing that copper twisted pair has distance limitations can be important in many network designs and influences where switches and other devices are placed.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      730,
      731,
      378,
      732,
      381
    ],
    "source": ""
  },
  {
    "id": 3206,
    "question": "Howard is a security analyst working with an experienced computer forensics investigator. The investigator asks him to retrieve a forensic drive controller, but Howard cannot locate a device in the storage room with this name. <br>What is another name for a forensic drive controller?",
    "choice_a": "RAID controller",
    "choice_b": "Write blocker",
    "choice_c": "SCSI terminator",
    "choice_d": "Forensic device analyzer",
    "correct_answer": "B",
    "explanation": "One of the main functions of a forensic drive controller is preventing any command sent to a device from modifying data stored on the device. For this reason, forensic drive controllers are also often referred to as write blockers.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      603,
      606,
      602,
      886,
      888
    ],
    "source": ""
  },
  {
    "id": 3207,
    "question": "The web application that Saria's development team is working on needs to provide secure session management that can prevent hijacking of sessions using the cookies that the application relies on. <br>Which of the following techniques would be the best for her to recommend to prevent this?",
    "choice_a": "Set the Secure attribute for the cookies, thus forcing TLS.",
    "choice_b": "Set the Domain cookie attribute to <code>example.com</code> to limit cookie access to servers in the same domain.",
    "choice_c": "Set the Expires cookie attribute to less than a week.",
    "choice_d": "Set the HTTP Only attribute to require only unencrypted sessions.",
    "correct_answer": "A",
    "explanation": "Setting the Secure cookie will only allow cookies to be sent via HTTPS TLS or SSL sessions, preventing man-in-the-middle attacks that target cookies. The rest of the settings are problematic. For example, cookies are vulnerable to DNS spoofing. Domain cookies should usually have the narrowest possible scope, which is actually accomplished by not setting the Domain cookie. This allows only the originating server to access the cookie. Cookies without the Expires or Max-age attributes are ephemeral and will only be kept for the session, making them less vulnerable than stored cookies. Normally, the HTTP Only attribute is a good idea, but it prevents scripting rather than requiring unencrypted HTTP sessions.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      667,
      629,
      668,
      672,
      628
    ],
    "source": ""
  },
  {
    "id": 3209,
    "question": "What access control scheme labels subjects and objects and allows subjects to access objects when the labels match?",
    "choice_a": "DAC",
    "choice_b": "MAC",
    "choice_c": "Rule-based access control (RBAC)",
    "choice_d": "Role-based access control (RBAC)",
    "correct_answer": "B",
    "explanation": "Mandatory access control (MAC) applies labels to subjects and objects and allows subjects to access objects when their labels match. Discretionary access control (DAC) is controlled by the owner of objects, rule-based access control applies rules throughout a system, and role-based access control bases rights on roles, which are often handled as groups of users.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      468,
      491,
      465,
      466,
      467
    ],
    "source": ""
  },
  {
    "id": 3210,
    "question": "A cloud-based service that provides account provisioning, management, authentication, authorization, reporting, and monitoring capabilities is known as what type of service?",
    "choice_a": "PaaS",
    "choice_b": "IDaaS",
    "choice_c": "IaaS",
    "choice_d": "SaaS",
    "correct_answer": "B",
    "explanation": "Identity as a service (IDaaS) provides capabilities such as account provisioning, management, authentication, authorization, reporting, and monitoring. Platform as a service (PaaS), infrastructure as a service (IaaS), and software as a service (SaaS).",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      230,
      210,
      213,
      264,
      225
    ],
    "source": ""
  },
  {
    "id": 3211,
    "question": "Sally wants to secure her organization's VoIP systems. <br>Which of the following attacks is one that she shouldn't have to worry about?",
    "choice_a": "Eavesdropping",
    "choice_b": "Denial-of-service",
    "choice_c": "Blackboxing",
    "choice_d": "Caller ID spoofing",
    "correct_answer": "C",
    "explanation": "Eavesdropping, denial-of-service attacks, and caller ID spoofing are all common VoIP attacks. Blackboxing is a made-up answer, although various types of colored boxes were associated with phone phreaking.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      353,
      396,
      397,
      438,
      395
    ],
    "source": ""
  },
  {
    "id": 3212,
    "question": "Marty discovers that the access restrictions in his organization allow any user to log into the workstation assigned to any other user, even if they are from completely different departments. This type of access most directly violates which information security principle?",
    "choice_a": "Separation of duties",
    "choice_b": "Two-person control",
    "choice_c": "Need to know",
    "choice_d": "Least privilege",
    "correct_answer": "D",
    "explanation": "This broad access may indirectly violate all of the listed security principles, but it is most directly a violation of least privilege because it grants users privileges that they do not need for their job functions.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      715,
      201,
      213,
      218,
      215
    ],
    "source": ""
  },
  {
    "id": 3213,
    "question": "Fred needs to transfer files between two servers on an untrusted network. Since he knows the network isn't trusted, he needs to select an encrypted protocol that can ensure that his data remains secure. <br>What protocol should he choose?",
    "choice_a": "SSH",
    "choice_b": "TCP",
    "choice_c": "SFTP",
    "choice_d": "IPsec",
    "correct_answer": "C",
    "explanation": "The Secure File Transfer Protocol (SFTP) is specifically designed for encrypted file transfer. SSH is used for secure command-line access, whereas TCP is one of the bundles of internet protocols commonly used to transmit data across a network. IPsec could be used to create a tunnel to transfer the data but is not specifically designed for file transfer.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      904,
      905,
      335,
      350,
      416
    ],
    "source": ""
  },
  {
    "id": 3215,
    "question": "Use your knowledge of Kerberos authentication and authorization as well as the following diagram to answer the question. <br><img src=\"/question_assets/CISSP/12_image4.png\"/><br>If the client has already authenticated to the KDC, what does the client workstation send to the KDC at point A when it wants to access a resource?",
    "choice_a": "It resends the password",
    "choice_b": "A TGR",
    "choice_c": "Its TGT",
    "choice_d": "A service ticket",
    "correct_answer": "C",
    "explanation": "The client sends its existing valid TGT to the KDC and requests access to the resource.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      477,
      451,
      441,
      448,
      478
    ],
    "source": ""
  },
  {
    "id": 3216,
    "question": "Use your knowledge of Kerberos authentication and authorization as well as the following diagram to answer the question. <br><img src=\"/question_assets/CISSP/12_image4.png\"/><br>What occurs between steps A and B?",
    "choice_a": "The KDC verifies the validity of the TGT and whether the user has the right privileges for the requested resource.",
    "choice_b": "The KDC updates its access control list based on the data in the TGT.",
    "choice_c": "The KDC checks its service listing and prepares an updated TGT based on the service request.",
    "choice_d": "The KDC generates a service ticket to issue to the client.",
    "correct_answer": "A",
    "explanation": "The KDC must verify that the TGT is valid and whether the user has the right privileges to access the service it is requesting access to. If it does, it generates a service ticket and sends it to the client (step B).",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      477,
      487,
      441,
      462,
      470
    ],
    "source": ""
  },
  {
    "id": 3217,
    "question": "Use your knowledge of Kerberos authentication and authorization as well as the following diagram to answer the question. <br><img src=\"/question_assets/CISSP/12_image4.png\"/><br>What system or systems does the service that is being accessed use to validate the ticket?",
    "choice_a": "The KDC.",
    "choice_b": "The client workstation and the KDC.",
    "choice_c": "The client workstation supplies it in the form of a client-to-server ticket and an authenticator.",
    "choice_d": "The KVS.",
    "correct_answer": "C",
    "explanation": "When a client connects to a service server (SS), it sends the following two messages:<br>The client-to-server ticket, encrypted using the service's secret key <br>A new authenticator, including the client ID and timestamp that is encrypted using the client/server session key. <br>The server or service that is being accessed receives all of the data it needs in the service ticket. To do so, the client uses a client-to-server ticket received from the ticket granting service.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      477,
      487,
      449,
      441,
      448
    ],
    "source": ""
  },
  {
    "id": 3218,
    "question": "What does a service ticket (ST) provide in Kerberos authentication?",
    "choice_a": "It serves as the authentication host.",
    "choice_b": "It provides proof that the subject is authorized to access an object.",
    "choice_c": "It provides proof that a subject has authenticated through a KDC and can request tickets to access other objects.",
    "choice_d": "It provides ticket granting services.",
    "correct_answer": "B",
    "explanation": "The service ticket in Kerberos authentication provides proof that a subject is authorized to access an object. Ticket granting services are provided by the TGS. Proof that a subject has authenticated and can request tickets to other objects uses ticket-granting tickets, and authentication host is a made-up term.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      477,
      451,
      492,
      448,
      449
    ],
    "source": ""
  },
  {
    "id": 3219,
    "question": "Judy is preparing to conduct a business impact analysis. <br>What should her first step be in the process?",
    "choice_a": "Identify threats to the business.",
    "choice_b": "Identify risks to the organization.",
    "choice_c": "Identify business priorities.",
    "choice_d": "Conduct likelihood analysis.",
    "correct_answer": "C",
    "explanation": "The first step in a business impact analysis is to identify the business's priorities. Judy should ensure that business areas are all represented and that the functions of each department or area are assessed. Once that is done, she can move on to identifying risks, evaluating likelihood and impact, and then prioritizing the resources available to the business to address the identified priorities.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      84,
      83,
      95,
      77,
      88
    ],
    "source": ""
  },
  {
    "id": 3220,
    "question": "What is the most common risk that cellular phone hotspots create for business networks?",
    "choice_a": "They can provide attackers with a nonsecured network path into your network.",
    "choice_b": "They can be used like rogue access points for man-in-the-middle attacks.",
    "choice_c": "They allow wireless data to be intercepted.",
    "choice_d": "They are unencrypted and can be easily sniffed.",
    "correct_answer": "A",
    "explanation": "Organizations are most often concerned about hotspots creating an unsecured network connection into their secure network via laptops or other devices that are connected to them. Bridging a cellular connection to a network connection to the business's network creates a path that bypasses security controls. Hotspots could be used as rogue access points, but this is a less common scenario. They do not specifically allow wireless data to be intercepted and, in most modern implementations, are encrypted, thus limiting the likelihood of sniffing providing useful data.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      372,
      401,
      363,
      417,
      412
    ],
    "source": ""
  },
  {
    "id": 3221,
    "question": "Which one of the following fire suppression systems poses the greatest risk of accidental discharge that damages equipment in a data center?",
    "choice_a": "Wet pipe",
    "choice_b": "Dry pipe",
    "choice_c": "Deluge",
    "choice_d": "Preaction",
    "correct_answer": "A",
    "explanation": "Dry pipe, deluge, and preaction systems all use pipes that remain empty until the system detects signs of a fire. Wet pipe systems use pipes filled with water that may damage equipment if there is damage to a pipe.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      315,
      314,
      326,
      313,
      306
    ],
    "source": ""
  },
  {
    "id": 3222,
    "question": "Amanda's healthcare provider maintains such data as details about her health, treatments, and medical billing. <br>What type of data is this?",
    "choice_a": "Protected health information",
    "choice_b": "Personally identifiable information",
    "choice_c": "Protected health insurance",
    "choice_d": "Individual protected data",
    "correct_answer": "A",
    "explanation": "Protected health information (PHI) is defined by HIPAA to include health information used by healthcare providers, such as medical treatment, history, and billing. Personally identifiable information is information that can be used to identify an individual, which may be included in the PHI but isn't specifically this type of data. Protected health insurance and individual protected data are both made-up terms.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      120,
      143,
      126,
      703,
      144
    ],
    "source": ""
  },
  {
    "id": 3223,
    "question": "What type of code review is best suited to identifying business logic flaws?",
    "choice_a": "Mutational fuzzing",
    "choice_b": "Manual",
    "choice_c": "Generational fuzzing",
    "choice_d": "Interface testing",
    "correct_answer": "B",
    "explanation": "Manual testing uses human understanding of business logic to assess program flow and responses. Mutation or generational fuzzing will help determine how the program responds to expected inputs but does not test the business logic. Interface testing ensures that data exchange between modules works properly but does not focus on the logic of the program or application.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      963,
      626,
      806,
      621,
      833
    ],
    "source": ""
  },
  {
    "id": 3224,
    "question": "Something you know is an example of what type of authentication factor?",
    "choice_a": "Type 1",
    "choice_b": "Type 2",
    "choice_c": "Type 3",
    "choice_d": "Type 4",
    "correct_answer": "A",
    "explanation": "A Type 1 authentication factor is something you know. A Type 2 authentication factor is something you have, like a smartcard or hardware token. A Type 3 authentication factor is something you are, like a biometric identifier. There is no such thing as a Type 4 authentication factor.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      443,
      459,
      445,
      442,
      446
    ],
    "source": ""
  },
  {
    "id": 3225,
    "question": "Saria is the system owner for a healthcare organization. <br>What responsibilities does she have related to the data that resides on or is processed by the systems she owns?",
    "choice_a": "She has to classify the data.",
    "choice_b": "She has to make sure that appropriate security controls are in place to protect the data.",
    "choice_c": "She has to grant appropriate access to personnel.",
    "choice_d": "She bears sole responsibility for ensuring that data is protected at rest, in transit, and in use.",
    "correct_answer": "B",
    "explanation": "System owners develop and maintain system security plans with system administrators, and they have to ensure that appropriate security controls are in place on those systems. System owners also share responsibility for data protection with data owners. System administrators grant appropriate access and apply the controls, whereas data owners own the classification process.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      138,
      143,
      851,
      124,
      125
    ],
    "source": ""
  },
  {
    "id": 3226,
    "question": "During software testing, Jack diagrams how a hacker might approach the application he is reviewing and determines what requirements the hacker might have. He then tests how the system would respond to the attacker's likely behavior. <br>What type of testing is Jack conducting?",
    "choice_a": "Misuse case testing",
    "choice_b": "Use case testing",
    "choice_c": "Hacker use case testing",
    "choice_d": "Static code analysis",
    "correct_answer": "A",
    "explanation": "Jack is performing misuse case analysis, a process that tests code based on how it would perform if it was misused instead of used properly. Use case testing tests valid use cases, whereas static code analysis involves reviewing the code itself for flaws rather than testing the live software. Hacker use case testing isn't an industry term for a type of testing.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      626,
      962,
      963,
      662,
      621
    ],
    "source": ""
  },
  {
    "id": 3227,
    "question": "Rick's risk assessment for his company's web application noted that it could suffer from SQL injection attacks. <br>Which of the following mitigation techniques would you recommend Rick apply to help reduce this risk?  (Select all that apply.)",
    "choice_a": "Stored procedures",
    "choice_b": "Escaping all user-supplied input",
    "choice_c": "Parameterized queries",
    "choice_d": "Input validation",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "All of these options are useful to help prevent SQL injection. Stored procedures limit what can be done via the database server, and escaping user input makes dangerous characters less likely to be a problem. Parameterized queries limit what can be sent in a query, and input validation adds another layer of protection by limiting what can be successfully input by a user.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      669,
      658,
      620,
      668,
      672
    ],
    "source": ""
  },
  {
    "id": 3228,
    "question": "Chris has been assigned to scan a system on all of its possible TCP and UDP ports. <br>How many ports of each type must he scan to complete his assignment?",
    "choice_a": "65,536 TCP ports and 32,768 UDP ports",
    "choice_b": "1,024 common TCP ports and 32,768 ephemeral UDP ports",
    "choice_c": "65,536 TCP and 65,536 UDP ports",
    "choice_d": "16,384 TCP ports, and 16,384 UDP ports",
    "correct_answer": "C",
    "explanation": "Both TCP and UDP port numbers are a 16-digit binary number, which means there can be 216 ports, or 65,536 ports, numbered from 0 to 65,535.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      763,
      787,
      788,
      495,
      502
    ],
    "source": ""
  },
  {
    "id": 3229,
    "question": "CVE and the NVD both provide information about what?",
    "choice_a": "Vulnerabilities",
    "choice_b": "Markup languages",
    "choice_c": "Vulnerability assessment tools",
    "choice_d": "Penetration testing methodologies",
    "correct_answer": "A",
    "explanation": "MITRE's Common Vulnerabilities and Exploits (CVE) dictionary and NIST's National Vulnerability Database (NVD) both provide information about vulnerabilities.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      789,
      787,
      859,
      497,
      861
    ],
    "source": ""
  },
  {
    "id": 3230,
    "question": "Michelle wants to ensure that her company does not keep logs for longer than they need to. <br>What type of policy should she write and implement to ensure this?",
    "choice_a": "An EOL policy",
    "choice_b": "A data classification policy",
    "choice_c": "An EOS policy",
    "choice_d": "A record retention policy",
    "correct_answer": "D",
    "explanation": "Record retention policies are used to establish what data organizations retain and how long they will retain it for. Keeping data longer than necessary can increase risk to the organization, but having data when needed for investigations, legal compliance, or other business purposes is also important. EOL, or end of life, and EOS, or end of support, apply to hardware or software and not to data. Data classification policies are used to help classify data, which may influence how long it is retained, but classification policies themselves typically do not set retention timeframes.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      850,
      852,
      133,
      851,
      125
    ],
    "source": ""
  },
  {
    "id": 3232,
    "question": "What three important items should be considered if you are attempting to control the strength of signal for a wireless network as well as where it is accessible?",
    "choice_a": "Antenna placement, antenna type, antenna power levels",
    "choice_b": "Antenna design, power levels, use of a captive portal",
    "choice_c": "Antenna placement, antenna design, use of a captive portal",
    "choice_d": "Power levels, antenna placement, FCC minimum strength requirements",
    "correct_answer": "A",
    "explanation": "Antenna placement, antenna design, and power level control are the three important factors in determining where a signal can be accessed and how usable it is. A captive portal can be used to control user logins, and antenna design is part of antenna types. The FCC does provide maximum broadcast power guidelines but does not require a minimum power level.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      368,
      367,
      386,
      394,
      735
    ],
    "source": ""
  },
  {
    "id": 3233,
    "question": "What is the best way to ensure that data is unrecoverable from an SSD?",
    "choice_a": "Use the built-in erase commands.",
    "choice_b": "Use a random pattern wipe of 1s and 0s.",
    "choice_c": "Physically destroy the drive.",
    "choice_d": "Degauss the drive.",
    "correct_answer": "C",
    "explanation": "Physically destroying the drive is the best way to ensure that there is no remnant data on the drive. SSDs are flash media, which means that you can't degauss them, whereas both random pattern writes and the built-in erase commands have been shown to be problematic due to the wear leveling built into SSDs as well as differences in how they handle erase commands.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      130,
      129,
      144,
      125,
      124
    ],
    "source": ""
  },
  {
    "id": 3234,
    "question": "Alice sends a message to Bob and wants to ensure that Mal, a third party, does not read the contents of the message while in transit. <br>What goal of cryptography is Alice attempting to achieve?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Authentication",
    "choice_d": "Nonrepudiation",
    "correct_answer": "A",
    "explanation": "Confidentiality ensures that data cannot be read by unauthorized individuals while stored or in transit.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      145,
      164,
      200,
      186,
      187
    ],
    "source": ""
  },
  {
    "id": 3236,
    "question": "The company that Gary works for processes credit cards and operates under an industry standard for credit card handling. <br>Which of the following standards will his company need to comply with?",
    "choice_a": "ISO 27001",
    "choice_b": "FIPS 140",
    "choice_c": "PCI-DSS",
    "choice_d": "ISO 27002",
    "correct_answer": "C",
    "explanation": "PCI-DSS, or the Payment Card Industry Data Security Standard is the industry standard Gary's company will need to comply with. ISO27001 and 27002 are information security management standards. FIPS 140 is a standard for cryptographic modules.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      142,
      126,
      136,
      143,
      141
    ],
    "source": ""
  },
  {
    "id": 3237,
    "question": "James has opted to implement a NAC solution that uses a post-admission philosophy for its control of network connectivity. <br>What type of issues can't a strictly post-admission policy handle?",
    "choice_a": "Out-of-band monitoring",
    "choice_b": "Preventing an unpatched laptop from being exploited immediately after connecting to the network",
    "choice_c": "Denying access when user behavior doesn't match an authorization matrix",
    "choice_d": "Allowing a user access to a specific object when user behavior is allowed based on an authorization matrix",
    "correct_answer": "B",
    "explanation": "A post-admission philosophy allows or denies access based on user activity after connection. Since this doesn't check the status of a machine before it connects, it can't prevent the exploit of the system immediately after connection. This doesn't preclude out-of-band or in-band monitoring, but it does mean that a strictly post-admission policy won't handle system checks before the systems are admitted to the network.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      392,
      379,
      400,
      401,
      333
    ],
    "source": ""
  },
  {
    "id": 3238,
    "question": "Ben has built an access control list that lists the objects that his users are allowed to access. When users attempt to access an object that they don't have rights to, they are denied access, even though there isn't a specific rule that prevents it. <br>What access control principle is key to this behavior?",
    "choice_a": "Least privilege",
    "choice_b": "Implicit deny",
    "choice_c": "Explicit deny",
    "choice_d": "Final rule fall-through",
    "correct_answer": "B",
    "explanation": "The principle of implicit denial states that any action that is not explicitly allowed is denied. This is an important concept for firewall rules and other access control systems. Implementing least privilege ensures that subjects have only the rights they need to accomplish their job. While explicit deny and final rule fall-through may sound like important access control concepts, neither is.",
    "topic_id": 5,
    "practice_test_id": 4,
    "related_articles": [
      463,
      470,
      465,
      467,
      472
    ],
    "source": ""
  },
  {
    "id": 3239,
    "question": "Mary is a security risk analyst for an insurance company. She is currently examining a scenario where a hacker might use a SQL injection attack to deface a web server due to a missing patch in the company's web application. In this scenario, what is the risk?",
    "choice_a": "Unpatched web application",
    "choice_b": "Web defacement",
    "choice_c": "Hacker",
    "choice_d": "Operating system",
    "correct_answer": "B",
    "explanation": "Risks are the combination of a threat and a vulnerability. Threats are the external forces seeking to undermine security, such as the hacker in this case. Vulnerabilities are the internal weaknesses that might allow a threat to succeed. In this case, web defacement is the risk. In this scenario, if the hacker attempts a SQL injection attack (threat) against the unpatched server (vulnerability), the result is website defacement (risk).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      2,
      26,
      49,
      23,
      85
    ],
    "source": ""
  },
  {
    "id": 3240,
    "question": "The mean time to detect a compromise is what type of security measurement?",
    "choice_a": "An MTO",
    "choice_b": "A technical control objective",
    "choice_c": "A compliance objective",
    "choice_d": "A KPI",
    "correct_answer": "D",
    "explanation": "The mean time to detect a compromise is a security KPI, or key performance indicator. KPIs are used to determine how effective practices, procedures, and staff are.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      502,
      498,
      500,
      784,
      499
    ],
    "source": ""
  },
  {
    "id": 3242,
    "question": "In Jen's job as the network administrator for an industrial production facility, she is tasked with ensuring that the network is not susceptible to electromagnetic interference due to the large motors and other devices running on the production floor. <br>What type of network cabling should she choose if this concern is more important than cost and difficulty of installation?",
    "choice_a": "10Base2",
    "choice_b": "100BaseT",
    "choice_c": "1000BaseT",
    "choice_d": "Fiber optic",
    "correct_answer": "D",
    "explanation": "Fiber-optic cable is more expensive and can be harder to install than stranded copper cable or coaxial cable in some cases, but it isn't susceptible to electromagnetic interference (EMI). That makes it a great solution for Jen's problem, especially if she is deploying EMI-hardened systems to go with her EMI-resistant network cables.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      381,
      389,
      731,
      330,
      385
    ],
    "source": ""
  },
  {
    "id": 3243,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through its website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry-standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Bethany would like to put in place controls that provide an organized framework for company employees to suggest new website features that her team will develop. <br>What change management process facilitates this?",
    "choice_a": "Configuration control",
    "choice_b": "Change control",
    "choice_c": "Release control",
    "choice_d": "Request control",
    "correct_answer": "D",
    "explanation": "The request control process provides an organized framework within which users can request modifications, managers can conduct cost/benefit analyses, and developers can prioritize tasks.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      527,
      974,
      528,
      526,
      529
    ],
    "source": ""
  },
  {
    "id": 3244,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through its website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry-standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Bethany would also like to create a process that helps multiple developers work on code at the same time. <br>What change management process facilitates this?",
    "choice_a": "Configuration control",
    "choice_b": "Change control",
    "choice_c": "Release control",
    "choice_d": "Request control",
    "correct_answer": "B",
    "explanation": "Change control provides an organized framework within which multiple developers can create and test solutions prior to rolling them out into a production environment.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      527,
      974,
      528,
      796,
      526
    ],
    "source": ""
  },
  {
    "id": 3245,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through its website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry-standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Bethany is working with her colleagues to conduct user acceptance testing. <br>What change management process includes this task?",
    "choice_a": "Configuration control",
    "choice_b": "Change control",
    "choice_c": "Release control",
    "choice_d": "Request control",
    "correct_answer": "C",
    "explanation": "Release control includes acceptance testing to ensure that any alterations to end-user work tasks are understood and functional.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      527,
      974,
      528,
      596,
      593
    ],
    "source": ""
  },
  {
    "id": 3246,
    "question": "Jasper Diamonds is a jewelry manufacturer that markets and sells custom jewelry through its website. Bethany is the manager of Jasper's software development organization, and she is working to bring the company into line with industry-standard practices. She is developing a new change management process for the organization and wants to follow commonly accepted approaches. <br>Bethany noticed that some problems arise when system administrators update libraries without informing developers. <br>What change management process can assist with this problem?",
    "choice_a": "Configuration control",
    "choice_b": "Change control",
    "choice_c": "Release control",
    "choice_d": "Request control",
    "correct_answer": "A",
    "explanation": "Configuration control ensures that changes to software versions are made in accordance with the change control and configuration management process. Updates can be made only from authorized distributions in accordance with those policies.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      534,
      527,
      528,
      524,
      525
    ],
    "source": ""
  },
  {
    "id": 3248,
    "question": "Which one of the following is an example of risk transference?",
    "choice_a": "Building a guard shack",
    "choice_b": "Purchasing insurance",
    "choice_c": "Erecting fences",
    "choice_d": "Relocating facilities",
    "correct_answer": "B",
    "explanation": "Risk transference involves actions that shift risk from one party to another. Purchasing insurance is an example of risk transference because it moves risk from the insured to the insurance company.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      46,
      52,
      41,
      70,
      45
    ],
    "source": ""
  },
  {
    "id": 3249,
    "question": "What protocol takes the place of certificate revocation lists and adds real-time status verification?",
    "choice_a": "RTCP",
    "choice_b": "RTVP",
    "choice_c": "OCSP",
    "choice_d": "CSRTP",
    "correct_answer": "C",
    "explanation": "The Online Certificate Status Protocol (OCSP) eliminates the latency inherent in the use of certificate revocation lists by providing a means for real-time certificate verification.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      939,
      181,
      938,
      937,
      722
    ],
    "source": ""
  },
  {
    "id": 3250,
    "question": "Xavier's company has been using an increasing number of cloud services, and he is concerned that the security policies that the company has implemented in its existing data center are not being followed in the cloud. <br>Which of the following solutions is best suited to ensuring that policies are applied to all cloud services?",
    "choice_a": "A CIPS",
    "choice_b": "A CASB",
    "choice_c": "A CSG",
    "choice_d": "A CDLP",
    "correct_answer": "B",
    "explanation": "A cloud access security broker is a tool that sits between on-premises and cloud systems, monitoring traffic and enforcing security policies. This scenario exactly matches what a CASB is designed to do. The other answers were made up; none of these is an actual cloud security device or tool.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      135,
      127,
      125,
      126,
      143
    ],
    "source": ""
  },
  {
    "id": 3251,
    "question": "What process makes TCP a connection-oriented protocol?",
    "choice_a": "It works via network connections.",
    "choice_b": "It uses a handshake.",
    "choice_c": "It monitors for dropped connections.",
    "choice_d": "It uses a complex header.",
    "correct_answer": "B",
    "explanation": "TCP's use of a handshake process to establish communications makes it a connection-oriented protocol. TCP does not monitor for dropped connections, nor does the fact that it works via network connections make it connection-oriented.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      883,
      868,
      869,
      884,
      724
    ],
    "source": ""
  },
  {
    "id": 3252,
    "question": "Susan wants to build a security awareness program for her organization, but knows that keeping staff engaged is difficult. <br>Which of the following techniques is often associated with the use of points and scores as part of the assessment process?",
    "choice_a": "Gamification",
    "choice_b": "Phishing testing",
    "choice_c": "Security champions",
    "choice_d": "Social engineering evaluations",
    "correct_answer": "A",
    "explanation": "Gamification uses common components from games like points, scores, and competition to engage participants in a security awareness program. None of the other answers uses these together unless they use a gamification component.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      66,
      67,
      65,
      71,
      55
    ],
    "source": ""
  },
  {
    "id": 3253,
    "question": "You are conducting a qualitative risk assessment for your organization. The two important risk elements that should weigh most heavily in your analysis of risk are probability and ________________.",
    "choice_a": "Likelihood",
    "choice_b": "History",
    "choice_c": "Impact",
    "choice_d": "Cost",
    "correct_answer": "C",
    "explanation": "The two most important elements of a qualitative risk assessment are determining the probability and impact of each risk upon the organization. Likelihood is another word for probability. Cost should be taken into account but is only one element of impact, which also includes reputational damage, operational disruption, and other ill effects.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      44,
      70,
      26,
      73,
      41
    ],
    "source": ""
  },
  {
    "id": 3254,
    "question": "Using the OSI model, what format does the Data Link layer use to format messages received from higher up the stack?",
    "choice_a": "A data stream",
    "choice_b": "A frame",
    "choice_c": "A segment",
    "choice_d": "A datagram",
    "correct_answer": "B",
    "explanation": "When a message reaches the Data Link layer, it is called a frame. Data streams exist at the Application, Presentation, and Session layers, whereas segments and datagrams exist at the Transport layer (for TCP and UDP, respectively).",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      331,
      330,
      389,
      387,
      378
    ],
    "source": ""
  },
  {
    "id": 3255,
    "question": "What is the maximum penalty that may be imposed by an ISC2 peer review board when considering a potential ethics violation?",
    "choice_a": "Revocation of certification",
    "choice_b": "Termination of employment",
    "choice_c": "Financial penalty",
    "choice_d": "Suspension of certification",
    "correct_answer": "A",
    "explanation": "If the ISC2 peer review board finds that a certified individual has violated the ISC2 Code of Ethics, the board may revoke their certification. The board is not able to terminate an individual's employment or assess financial penalties.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      957,
      955,
      956,
      100,
      97
    ],
    "source": ""
  },
  {
    "id": 3256,
    "question": "Which one of the following statements about the SDLC is correct?",
    "choice_a": "The SDLC requires the use of an iterative approach to software development.",
    "choice_b": "The SDLC requires the use of a sequential approach to software development.",
    "choice_c": "The SDLC does not include training for end users and support staff.",
    "choice_d": "The waterfall methodology is compatible with the SDLC.",
    "correct_answer": "D",
    "explanation": "SDLC approaches include steps to provide operational training for support staff as well as end-user training. The SDLC may use one of many development models, including the waterfall and spiral models. The SDLC does not mandate the use of an iterative or sequential approach; it allows for either approach.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      622,
      640,
      621,
      1034,
      833
    ],
    "source": ""
  },
  {
    "id": 3257,
    "question": "In the diagram shown here, Harry is prevented from reading a file at a higher classification level than his security clearance. <br><img src=\"/question_assets/CISSP/12_image6.png\"/><br>What security model prevents this behavior?",
    "choice_a": "Bell\u2013LaPadula",
    "choice_b": "Biba",
    "choice_c": "Clark\u2013Wilson",
    "choice_d": "Brewer\u2013Nash",
    "correct_answer": "A",
    "explanation": "The Bell\u2013LaPadula model includes the Simple Security Property, which prevents an individual from reading information that is classified at a level higher than the individual's security clearance.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      217,
      228,
      215,
      218,
      292
    ],
    "source": ""
  },
  {
    "id": 3259,
    "question": "Travis is concerned about the security that his organization's use of Microsoft's BitLocker provides for systems. When are the systems most secure from data loss based on the encryption state of the drive if the systems are equipped with TPM and use full disk encryption?",
    "choice_a": "When they are booted up and running because the system monitors for drive access",
    "choice_b": "When the system is shutting down because keys are removed from memory",
    "choice_c": "When they are booting up because the TPM checks for a secure boot process",
    "choice_d": "When they are off because the drive is fully encrypted",
    "correct_answer": "D",
    "explanation": "The files on the drive are at their most secure when the system is off and the drive is encrypted and not in a readable state. BitLocker decrypts files as needed when in use, meaning that any time after the system is booted files may be accessed, particularly if the user is logged in and access to the system can be gained or if malware is running.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      185,
      291,
      145,
      215,
      225
    ],
    "source": ""
  },
  {
    "id": 3260,
    "question": "Andrea wants to ensure that her virtualized networks are secure between virtual environments. She uses virtual machine clusters in multiple locations in her state with third-party internet service providers between those locations. <br>Which of the following solutions is best suited to protecting her traffic if she runs a flattened layer 2 network between those locations?",
    "choice_a": "TLS",
    "choice_b": "BGP",
    "choice_c": "IPsec",
    "choice_d": "AES",
    "correct_answer": "C",
    "explanation": "An IPsec VPN will allow Andrea to keep her networks running as layer 2 flattened networks when necessary while providing the security for her traffic that she wants. TLS operates at a higher network layer, although traffic could be tunneled through it. BGP is a routing protocol, and AES is an encryption algorithm.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      413,
      412,
      331,
      419,
      401
    ],
    "source": ""
  },
  {
    "id": 3261,
    "question": "The company that Fred works for is reviewing the security of their company-issued cell phones. They issue 4G-capable smartphones running Android and iOS and use a mobile device management solution to deploy company software to the phones. The mobile device management software also allows the company to remotely wipe the phones if they are lost. <br>What security considerations should Fred's company require for sending sensitive data over the cellular network?",
    "choice_a": "They should use the same requirements as data over any public network.",
    "choice_b": "Cellular provider networks are private networks and should not require special consideration.",
    "choice_c": "Encrypt all traffic to ensure confidentiality.",
    "choice_d": "Require the use of WAP for all data sent from the phone.",
    "correct_answer": "A",
    "explanation": "Cellular networks have the same issues that any public network does. Encryption requirements should match those that the organization selects for other public networks like hotels, conference WiFi, and similar scenarios. Encrypting all data is difficult and adds overhead, so it should not be the default answer unless the company specifically requires it. WAP is a dated wireless application protocol and is not in broad use; requiring it would be difficult. WAP does provide TLS, which would help when in use.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      372,
      412,
      416,
      400,
      1002
    ],
    "source": ""
  },
  {
    "id": 3262,
    "question": "The company that Fred works for is reviewing the security of their company-issued cell phones. They issue 4G-capable smartphones running Android and iOS and use a mobile device management solution to deploy company software to the phones. The mobile device management software also allows the company to remotely wipe the phones if they are lost. <br>Fred intends to attend a major hacker conference this year and needs to connect to his employer's network during his time at the conference. <br>What should he do when connecting to his cellular provider's 4G network while at the conference?",
    "choice_a": "Continue normal usage.",
    "choice_b": "Discontinue all usage; towers can be spoofed.",
    "choice_c": "Only use trusted WiFi networks.",
    "choice_d": "Connect to his company's encrypted VPN service.",
    "correct_answer": "D",
    "explanation": "Fred's best option is to use an encrypted, trusted VPN service to tunnel all of his data usage. Trusted WiFi networks are unlikely to exist at a hacker conference, normal usage is dangerous due to the proliferation of technology that allows fake towers to be set up, and discontinuing all usage won't support Fred's business needs.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      372,
      417,
      414,
      401,
      416
    ],
    "source": ""
  },
  {
    "id": 3263,
    "question": "The company that Fred works for is reviewing the security of their company-issued cell phones. They issue 4G-capable smartphones running Android and iOS and use a mobile device management solution to deploy company software to the phones. The mobile device management software also allows the company to remotely wipe the phones if they are lost. <br>What are the most likely circumstances that would cause a remote wipe of a mobile phone to fail?",
    "choice_a": "The phone has a passcode on it.",
    "choice_b": "The phone cannot contact a network.",
    "choice_c": "The provider has not unlocked the phone",
    "choice_d": "The phone is in use.",
    "correct_answer": "B",
    "explanation": "Remote wipe tools are a useful solution, but they work only if the phone can access either a cellular or WiFi network. Remote wipe solutions are designed to wipe data from the phone regardless of whether it is in use or has a passcode. Providers unlock phones for use on other cellular networks rather than for wiping or other feature support.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      372,
      1001,
      401,
      417,
      399
    ],
    "source": ""
  },
  {
    "id": 3264,
    "question": "Elaine is developing a business continuity plan for her organization. <br>What value should she seek to minimize?",
    "choice_a": "AV",
    "choice_b": "SSL",
    "choice_c": "RTO",
    "choice_d": "MTO",
    "correct_answer": "C",
    "explanation": "The goal of business continuity planning exercises is to reduce the amount of time required to restore operations. This is done by minimizing the recovery time objective (RTO).",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      84,
      88,
      74,
      93,
      83
    ],
    "source": ""
  },
  {
    "id": 3265,
    "question": "Warren wants to conduct an internal security audit. He wants to use a broadly accepted audit framework so that he can more easily compare the results to other organizations. <br>Which of the following options should he select as his base audit framework?",
    "choice_a": "ITSM",
    "choice_b": "ATT&CK",
    "choice_c": "COBIT",
    "choice_d": "CIS",
    "correct_answer": "C",
    "explanation": "The COBIT, or Control Objectives for Information and related Technologies, framework describes common requirements that organizations should have in place for their information systems. It is the only audit or compliance framework on the list. ITSM is the acronym for Information Technology Service Management; CIS is the Center for Information Security, which provides guidelines for system security that can be used to assess systems but is not itself an audit framework; and ATT&CK is a framework for describing threats and attack methodologies.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      864,
      863,
      1006,
      1007,
      793
    ],
    "source": ""
  },
  {
    "id": 3266,
    "question": "Place the list of disaster recovery test types in order of their potential impact on the business, starting with the least impactful and progressing through the most impactful. <br><ol><li>Checklist review </li><li>Parallel test </li><li>Tabletop exercise </li><li>Full interruption test</li></ol>",
    "choice_a": "1, 2, 3, 4",
    "choice_b": "1, 3, 2, 4",
    "choice_c": "1, 3, 4, 2",
    "choice_d": "2, 1, 3, 4",
    "correct_answer": "B",
    "explanation": "The disaster recovery test types, listed in order of their potential impact on the business from the least impactful to the most impactful, are as follows: <br><ol><li>Checklist review </li><li>Tabletop exercise </li><li>Parallel test </li><li>Full interruption test</li></ol><br>Checklist reviews are the least impactful type of exercise because they do not even require a meeting. Each team member reviews the checklist on their own. Tabletop exercises are slightly more impactful because they require bringing together the DR team in the same room. Parallel tests require the activation of alternate processing sites and require significant resources. Full interruption tests are the most impactful type of exercise because they involve shifting operations to the alternate site and could disrupt production activity.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      594,
      597,
      592,
      591,
      595
    ],
    "source": ""
  },
  {
    "id": 3267,
    "question": "Jack's data center design calls for dual-power supplies in every critical server. <br>What part of the CIA triad is he addressing with this design decision?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Availability",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "Redundancy is part of many availability designs. Dual power supplies allow multiple levels of availability support; they allow you to connect servers to distinct power infrastructures and also provide the ability to run if a single power supply dies. Some servers are even set up to use more than two power supplies. Another approach to this type of availability is to use more systems, rather than more expensive systems with greater support for availability.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      5,
      3,
      90,
      95,
      46
    ],
    "source": ""
  },
  {
    "id": 3268,
    "question": "What step is missing from the IR process cycle diagram shown here? <br><img src=\"/question_assets/CISSP/12_image7.png\"/>",
    "choice_a": "Forensics",
    "choice_b": "Retribution",
    "choice_c": "Recovery",
    "choice_d": "Analysis",
    "correct_answer": "C",
    "explanation": "The CISSP CBK uses a six-stage process: Detection, Response, Mitigation, Reporting, Recovery, and Remediation. This diagram is missing Recovery. Other standards differ, using different terms or slightly different processes.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      919,
      537,
      539,
      540,
      921
    ],
    "source": ""
  },
  {
    "id": 3270,
    "question": "Megan wants to ensure that the new software as a service provider that her company is signing a contract with will make sure the service works all the time without disruptions. <br>Which of the following is often part of contracts to provide that assurance?",
    "choice_a": "An SLA",
    "choice_b": "An RPA",
    "choice_c": "An NDA",
    "choice_d": "An MOU",
    "correct_answer": "A",
    "explanation": "A service level agreement, or SLA, contains details about how the service will be provided, what level of outages or downtime is acceptable, and what remedies may exist in the case of outages or other issues. Megan should ensure that the SLA contains both appropriate performance guarantees and penalties that will be of sufficient magnitude to compensate her company for issues while motivating the service provider to maintain a reliable service. RPA is robotic process automation, an automation technology. NDA is a nondisclosure agreement, a legal document used to help control for the risk of information or data being exposed or shared. An MOU is a memorandum of understanding and is used when two organizations want to work together to document a shared vision or the goals they share.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      915,
      590,
      796,
      522,
      578
    ],
    "source": ""
  },
  {
    "id": 3272,
    "question": "Norm would like to conduct a disaster recovery test for his organization and wants to choose the most thorough type of test, recognizing that it may be quite disruptive. <br>What type of test should Norm choose?",
    "choice_a": "Full interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Tabletop exercise",
    "choice_d": "Checklist review",
    "correct_answer": "A",
    "explanation": "During a full interruption test, the team takes down the primary site and confirms that the disaster recovery site is capable of handling regular operations. The full interruption test is the most thorough test but also the most disruptive. During a parallel test, the team actually activates the disaster recovery site for testing, but the primary site remains operational. The checklist review is the least disruptive type of disaster recovery test. During a checklist review, team members each review the contents of their disaster recovery checklists on their own and suggest any necessary changes. During a tabletop exercise, team members come together and walk through a scenario without making any changes to information systems.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      594,
      597,
      593,
      596,
      595
    ],
    "source": ""
  },
  {
    "id": 3273,
    "question": "Ed is building a network that supports IPv6 but needs to connect it to an IPv4 network. <br>What type of device should Ed place between the networks?",
    "choice_a": "A switch",
    "choice_b": "A router",
    "choice_c": "A bridge",
    "choice_d": "A gateway",
    "correct_answer": "D",
    "explanation": "Ed's best option is to install an IPv6 to IPv4 gateway that can translate traffic between the networks. A bridge would be appropriate for different types of networks, whereas a router would make sense if the networks were similar. A modern switch might be able to carry both types of traffic but wouldn't be much help translating between the two protocols.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      346,
      378,
      423,
      347,
      333
    ],
    "source": ""
  },
  {
    "id": 3274,
    "question": "Henry's company has deployed an extensive IoT infrastructure for building monitoring that includes environmental controls, occupancy sensors, and a variety of other sensors and controllers that help manage the building. <br>Which of the following security concerns should Henry report as the most critical in his analysis of the IoT deployment?",
    "choice_a": "The lack of local storage space for security logs that is common to IoT devices.",
    "choice_b": "The IoT devices may not have a separate administrative interface, allowing anybody on the same network to attempt to log into them and making brute-force attacks possible.",
    "choice_c": "The IoT devices may not support strong encryption for communications, exposing the log and sensor data to interception on the network.",
    "choice_d": "The long-term support and patching model for the IoT devices may create security and operational risk for the organization.",
    "correct_answer": "D",
    "explanation": "Henry's biggest concern should be the long-term security and supportability of the IoT devices. As these devices are increasingly embedded in buildings and infrastructure, the support model and security model are important to understand. Both the lack of separate administrative access and the lack of strong encryption can be addressed by placing the IoT devices on a dedicated subnet or network that prevents other users from accessing the devices directly. This will help limit the risk without undue expense or complexity and is a common practice. Finally, lack of storage space can be a concern, but is not the most important when looking at the risks IoT devices can create.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      258,
      262,
      215,
      211,
      230
    ],
    "source": ""
  },
  {
    "id": 3275,
    "question": "Isaac wants to use a connectionless protocol to transfer data because he needs to optimize speed of transmission over reliability. <br>Which protocol should he select?",
    "choice_a": "ICMP",
    "choice_b": "TCP",
    "choice_c": "UDP",
    "choice_d": "SNMP",
    "correct_answer": "C",
    "explanation": "UDP, the User Datagram Protocol, is a connectionless, best-effort protocol that is often used when sending data quickly without strong requirements for reliability features like error correction and detection or flow control to make sense. TCP is connection-oriented and provides those and other reliability features. ICMP, the Internet Control Message Protocol, is used to check routes and paths as well as availability, but is not used for significant data transfer in normal cases. SNMP is a network management monitoring protocol.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      337,
      724,
      345,
      336,
      394
    ],
    "source": ""
  },
  {
    "id": 3276,
    "question": "Which one of the following actions is not required under the EU General Data Protection Regulation?",
    "choice_a": "Organizations must allow individuals to opt out of information sharing.",
    "choice_b": "Organizations must provide individuals with lists of employees with access to information.",
    "choice_c": "Organizations must use proper mechanisms to protect data against unauthorized disclosure.",
    "choice_d": "Organizations must have a dispute resolution process for privacy issues.",
    "correct_answer": "B",
    "explanation": "The EU General Data Protection Regulation does not require that organizations provide individuals with employee lists.",
    "topic_id": 1,
    "practice_test_id": 4,
    "related_articles": [
      108,
      119,
      118,
      688,
      1045
    ],
    "source": ""
  },
  {
    "id": 3277,
    "question": "Tammy is selecting a disaster recovery facility for her organization. She would like to choose a facility that balances the time required to recover operations with the cost involved. <br>What type of facility should she choose?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Red site",
    "correct_answer": "B",
    "explanation": "Tammy should choose a warm site. This type of facility meets her requirements for a good balance between cost and recovery time. It is less expensive than a hot site but facilitates faster recovery than a cold site. A red site is not a type of disaster recovery facility.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      582,
      598,
      580,
      573,
      579
    ],
    "source": ""
  },
  {
    "id": 3278,
    "question": "What layer of the OSI model is associated with datagrams?",
    "choice_a": "Session",
    "choice_b": "Transport",
    "choice_c": "Network",
    "choice_d": "Data Link",
    "correct_answer": "B",
    "explanation": "When data reaches the Transport layer, it is sent as segments (TCP) or datagrams (UDP). Above the Transport layer, data becomes a data stream, while below the Transport layer they are converted to packets at the Network layer, frames at the Data Link layer, and bits at the Physical layer.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      332,
      330,
      742,
      387,
      333
    ],
    "source": ""
  },
  {
    "id": 3279,
    "question": "Which one of the following is not a valid key length for the Advanced Encryption Standard?",
    "choice_a": "128 bits",
    "choice_b": "192 bits",
    "choice_c": "256 bits",
    "choice_d": "384 bits",
    "correct_answer": "D",
    "explanation": "The Advanced Encryption Standard supports encryption with 128-bit keys, 192-bit keys, and 256-bit keys.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      160,
      152,
      171,
      153,
      159
    ],
    "source": ""
  },
  {
    "id": 3280,
    "question": "Which one of the following technologies provides a function interface that allows developers to directly interact with systems without knowing the implementation details of that system?",
    "choice_a": "Data dictionary",
    "choice_b": "Object model",
    "choice_c": "Source code",
    "choice_d": "API",
    "correct_answer": "D",
    "explanation": "An application programming interface (API) allows developers to create a direct method for other users to interact with their systems through an abstraction that does not require knowledge of the implementation details. Access to object models, source code, and data dictionaries also indirectly facilitate interaction but do so in a manner that provides other developers with implementation details.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      826,
      892,
      815,
      621,
      806
    ],
    "source": ""
  },
  {
    "id": 3281,
    "question": "Ian wants to assess the security of his company's new SaaS provider. <br>Which of the following options is the most likely option that he can realistically expect to be able to use to assess a major cloud provider's security?",
    "choice_a": "Run a vulnerability scan against the provider's external services.",
    "choice_b": "Request a SOC 2 Type II report.",
    "choice_c": "Run a vulnerability scan against the provider's internal systems.",
    "choice_d": "Request a SOC 1 Type II report.",
    "correct_answer": "B",
    "explanation": "Ian's best bet is an SOC report, and an SOC 2 Type II report will assess security controls and their application over time, telling him if the organization is responsibly maintaining their security efforts. An SOC 1 report looks at financial controls, and a Type I report only looks at how controls are described, not their application over time. Ian is unlikely to be allowed to run a vulnerability scan against a major provider's infrastructure either internally or externally.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3283,
    "question": "Which of the following types of access control seeks to discover evidence of unwanted, unauthorized, or illicit behavior or activity?",
    "choice_a": "Preventive",
    "choice_b": "Deterrent",
    "choice_c": "Detective",
    "choice_d": "Corrective",
    "correct_answer": "C",
    "explanation": "Detective access controls are used to discover (and document) unwanted or unauthorized activity. Preventive access controls block the ability to perform unwanted activity. Deterrent access controls attempt to persuade the perpetrator not to perform unwanted activity. Corrective access controls restore a system to normal function in the event of a failure or system interruption.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      47,
      69,
      33,
      14,
      23
    ],
    "source": ""
  },
  {
    "id": 3284,
    "question": "Define and detail the aspects of password selection that distinguish good password choices from ultimately poor password choices.",
    "choice_a": "Is difficult to guess or unpredictable",
    "choice_b": "Meets minimum length requirements",
    "choice_c": "Meets specific complexity requirements",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Strong password choices are difficult to guess, unpredictable, and of specified minimum lengths to ensure that password entries cannot be computationally determined. They may be randomly generated and use all the alphabetic, numeric, and punctuation characters; they should never be written down or shared; they should not be stored in publicly accessible or generally readable locations; and they shouldn't be transmitted in the clear.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      485,
      447,
      489,
      845,
      488
    ],
    "source": ""
  },
  {
    "id": 3285,
    "question": "Some adversaries use DoS attacks as their primary weapon to harm targets, whereas others may use them as weapons of last resort when all other attempts to intrude on a target fail. <br>Which of the following is most likely to detect DoS attacks?",
    "choice_a": "Host-based IDS",
    "choice_b": "Network-based IDS",
    "choice_c": "Vulnerability scanner",
    "choice_d": "Penetration testing",
    "correct_answer": "B",
    "explanation": "Network-based IDSs are usually able to detect the initiation of an attack or the ongoing attempts to perpetrate an attack (including denial of service, or DoS). They are, however, unable to provide information about whether an attack was successful or which specific systems, user accounts, files, or applications were affected. Host-based IDSs have some difficulty with detecting and tracking down DoS attacks. Vulnerability scanners don't detect DoS attacks; they test for possible vulnerabilities. Penetration testing may cause a DoS or test for DoS vulnerabilities, but it is not a detection tool.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      547,
      538,
      567,
      546,
      553
    ],
    "source": ""
  },
  {
    "id": 3286,
    "question": "Unfortunately, attackers have many options of attacks to perform against their targets. <br>Which of the following is considered a denial-of-service (DoS) attack?",
    "choice_a": "Pretending to be a technical manager over the phone and asking a receptionist to change their password",
    "choice_b": "While surfing the web, sending to a web server a malformed URL that causes the system to consume 100 percent of the CPU",
    "choice_c": "Intercepting network traffic by copying the packets as they pass through a specific subnet",
    "choice_d": "Sending message packets to a recipient who did not request them, simply to be annoying",
    "correct_answer": "B",
    "explanation": "Not all instances of DoS are the result of a malicious attack. Errors in coding OSs, services, and applications have resulted in DoS conditions. Some examples of this include a process failing to release control of the CPU or a service consuming system resources out of proportion to the service requests it is handling. Social engineering (i.e., pretending to be a technical manager) and sniffing (i.e., intercepting network traffic) are typically not considered DoS attacks. Sending message packets to a recipient who did not request them simply to be annoying may be a type of social engineering and it is definitely spam, but unless the volume of the messages is significant, it does not warrant the label of DoS.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      546,
      567,
      608,
      578,
      541
    ],
    "source": ""
  },
  {
    "id": 3287,
    "question": "Hardware networking devices operate within the protocol stack just like protocols themselves. Thus, hardware networking devices can be associated with an OSI model layer related to the protocols they manage or control. At which layer of the OSI model does a router operate?",
    "choice_a": "Network layer",
    "choice_b": "Layer 1",
    "choice_c": "Transport layer",
    "choice_d": "Layer 5",
    "correct_answer": "A",
    "explanation": "Network hardware devices, including routers, function at layer 3, the Network layer. Layer 1, the Physical layer, is where repeaters and hubs operate, not routers. The Transport layer, layer 4, is where circuit level firewalls and proxies operate, not routers. Layer 5, the Session layer, does not actually exist in a modern TCP/IP network, and thus no hardware directly operates at this layer, but its functions are performed by TCP in the Transport layer, layer 4, when sessions are in use.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      378,
      331,
      1012,
      742,
      330
    ],
    "source": ""
  },
  {
    "id": 3288,
    "question": "Which type of firewall automatically adjusts its filtering rules based on the content and context of the traffic of existing sessions?",
    "choice_a": "Static packet filtering",
    "choice_b": "Application-level gateway",
    "choice_c": "Circuit-level gateway",
    "choice_d": "Stateful inspection firewall",
    "correct_answer": "D",
    "explanation": "Stateful inspection firewalls (aka dynamic packet-filtering firewall) enable the real-time modification of the filtering rules based on traffic content and context. The other firewalls listed as options\u2014static packet filtering, application level, and circuit level\u2014are all stateless and thus do not consider the context when applying filtering rules.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      551,
      544,
      543,
      538,
      560
    ],
    "source": ""
  },
  {
    "id": 3289,
    "question": "A VPN can be a significant security improvement for many communication links. A VPN can be established over which of the following?",
    "choice_a": "Wireless LAN connection",
    "choice_b": "Remote access dial-up connection",
    "choice_c": "WAN link",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "A virtual private network (VPN) link can be established over any network communication connection. This could be a typical LAN cable connection, a wireless LAN connection, a remote access dial-up connection, a WAN link, or even an internet connection used by a client for access to the office LAN.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      417,
      411,
      412,
      413,
      399
    ],
    "source": ""
  },
  {
    "id": 3290,
    "question": "Adversaries will use any and all means to harm their targets. This includes mixing attack concepts together to make a more effective campaign. <br>What type of malware uses social engineering to trick a victim into installing it?",
    "choice_a": "Virus",
    "choice_b": "Worm",
    "choice_c": "Trojan horse",
    "choice_d": "Logic bomb",
    "correct_answer": "C",
    "explanation": "A Trojan horse is a form of malware that uses social engineering tactics to trick a victim into installing it\u2014the trick is to make the victim believe that the only thing they have downloaded or obtained is the host file, when in fact it has a malicious hidden payload. Viruses and logic bombs do not typically use social engineering as an element in their means of infecting a system. A worm sometimes is designed to take advantage of social engineering, such as when the worm is an executable email attachment and the message tricks the victim into opening it. However, not all worms are designed this way\u2014this is a core design concept of a Trojan horse.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3291,
    "question": "Security is established by understanding the assets of an organization that need protection and understanding the threats that could cause harm to those assets. Then, controls are selected that provide protection for the CIA Triad of the assets at risk. The CIA Triad consists of what elements?",
    "choice_a": "Contiguousness, interoperable, arranged",
    "choice_b": "Authentication, authorization, accountability",
    "choice_c": "Capable, available, integral",
    "choice_d": "Availability, confidentiality, integrity",
    "correct_answer": "D",
    "explanation": "The components of the CIA Triad are confidentiality, availability, and integrity. The other options are not the terms that define the CIA Triad, although they are security concepts that need to be evaluated when establishing a security infrastructure.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      3,
      4,
      47,
      8,
      1
    ],
    "source": ""
  },
  {
    "id": 3292,
    "question": "The security concept of AAA services describes the elements that are necessary to establish subject accountability. <br>Which of the following is not a required component in the support of accountability?",
    "choice_a": "Logging",
    "choice_b": "Privacy",
    "choice_c": "Identification verification",
    "choice_d": "Authorization",
    "correct_answer": "B",
    "explanation": "Privacy is not necessary to provide accountability. The required elements of accountability, as defined in AAA services, are as follows: identification (which is sometimes considered an element of authentication, a silent first step of AAA services, or represented by IAAA), authentication (i.e., identification verification), authorization (i.e., access control), auditing (i.e., logging and monitoring), and accounting.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      31,
      7,
      6,
      4,
      112
    ],
    "source": ""
  },
  {
    "id": 3293,
    "question": "Collusion is when two or more people work together to commit a crime or violate a company policy. <br>Which of the following is not a defense against collusion?",
    "choice_a": "Separation of duties",
    "choice_b": "Restricted job responsibilities",
    "choice_c": "Group user accounts",
    "choice_d": "Job rotation",
    "correct_answer": "C",
    "explanation": "Group user accounts allow for multiple people to log in under a single user account. This allows collusion because it prevents individual accountability. Separation of duties, restricted job responsibilities, and job rotation help establish individual accountability and control access (especially to privileged capabilities), which in turn limits or restricts collusion.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      533,
      504,
      505,
      503,
      535
    ],
    "source": ""
  },
  {
    "id": 3294,
    "question": "A data custodian is responsible for securing resources after ______________ has assigned the resource a security label.",
    "choice_a": "Senior management",
    "choice_b": "The data owner",
    "choice_c": "An auditor",
    "choice_d": "Security staff",
    "correct_answer": "B",
    "explanation": "The data owner must first assign a security label to a resource before the data custodian can secure the resource appropriately. Senior management is ultimately responsible for the success or failure of a security endeavor. An auditor is responsible for reviewing and verifying that the security policy is properly implemented, that the derived security solutions are adequate, and that user events are in compliance with security policy. The security staff is responsible for designing, implementing, and managing the security infrastructure once approved by senior management.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      17,
      4,
      22,
      15,
      14
    ],
    "source": ""
  },
  {
    "id": 3295,
    "question": "In what phase of the Capability Maturity Model for Software (SW-CMM) are quantitative measures used to gain a detailed understanding of the software development process?",
    "choice_a": "Repeatable",
    "choice_b": "Defined",
    "choice_c": "Managed",
    "choice_d": "Optimizing",
    "correct_answer": "C",
    "explanation": "The Managed phase (level 4) of the SW-CMM involves the use of quantitative development metrics. The Software Engineering Institute (SEI) defines the key process areas for this level as Quantitative Process Management and Software Quality Management. The Repeatable phase (level 2) is where basic lifecycle processes are introduced. The Defined phase (level 3) is where developers operate according to a set of formal, documented development processes. The Optimizing phase (level 5) is where a process of continuous improvement is achieved.",
    "topic_id": 8,
    "practice_test_id": 5,
    "related_articles": [
      623,
      640,
      622,
      621,
      833
    ],
    "source": ""
  },
  {
    "id": 3296,
    "question": "Which one of the following is a layer of the ring protection scheme design concept that is not normally implemented?",
    "choice_a": "Layer 0",
    "choice_b": "Layer 1",
    "choice_c": "Layer 3",
    "choice_d": "Layer 4",
    "correct_answer": "B",
    "explanation": "Layers 1 and 2 contain device drivers but are not normally implemented in practice, since they are often collapsed into layer 0. Layer 0 always contains the security kernel. Layer 3 contains user applications. Layer 4 does not exist in the design concept, but it may exist in customized implementations.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      718,
      719,
      215,
      236,
      292
    ],
    "source": ""
  },
  {
    "id": 3297,
    "question": "TCP operates at the Transport layer and is a connection-oriented protocol. It uses a special process to establish a session each time a communication takes place. <br>What is the last phase of the TCP three-way handshake sequence?",
    "choice_a": "SYN flagged packet",
    "choice_b": "ACK flagged packet",
    "choice_c": "FIN flagged packet",
    "choice_d": "SYN/ACK flagged packet",
    "correct_answer": "B",
    "explanation": "The SYN flagged packet is first sent from the initiating host to the destination host. The destination host then responds with a SYN/ACK flagged packet. The initiating host sends an ACK flagged packet, and the connection is then established. The FIN flagged packet is not used in the TCP three-way handshake to establish a session; it is used in the session teardown process.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      883,
      869,
      724,
      884,
      332
    ],
    "source": ""
  },
  {
    "id": 3298,
    "question": "The lack of secure coding practices has enabled an uncountable number of software vulnerabilities that hackers have discovered and exploited. <br>Which one of the following vulnerabilities would be best countered by adequate parameter checking?",
    "choice_a": "Time-of-check to time-of-use",
    "choice_b": "Buffer overflow",
    "choice_c": "SYN flood",
    "choice_d": "Distributed denial of service (DDoS)",
    "correct_answer": "B",
    "explanation": "Parameter checking (i.e., confirming input is within reasonable boundaries) is used to prevent the possibility of buffer overflow attacks. Time-of-check to time-of-use (TOCTTOU) attacks are not directly addressed by parameter checking or input filtering; defensive coding practices are needed to eliminate or reduce this issue. SYN flood attacks are a type of DoS, which is not fully protected against with just improved coding practices. A DDoS is also not prohibited by just improved coding practices such as parameter checking. For any type of DoS, adequate filtering and processing capacity are the most effective security responses.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      294,
      211,
      227,
      206,
      262
    ],
    "source": ""
  },
  {
    "id": 3299,
    "question": "Computers are based on binary mathematics. All computer functions are derived from the basic set of Boolean operations. <br><img src=\"/question_assets/CISSP/1_image1_at.png\"/><br>What is the value of the logical operation shown here?",
    "choice_a": "<code>0 1 0 1 1 1</code>",
    "choice_b": "<code>0 0 1 0 0 0</code>",
    "choice_c": "<code>0 1 1 1 1 1</code>",
    "choice_d": "<code>1 0 0 1 0 1</code>",
    "correct_answer": "A",
    "explanation": "The \u2295 symbol represents the XOR function and returns a true value when only one of the input values is true. If both values are false or both values are true, the output of the XOR function is false. Option B is the result if these two values were combined using the AND (the \u2227 symbol) function, which returns a value of true if the two values are both true. Option C is the result if these two values were combined using the OR (the \u2228 symbol) function, which returns a value of true if either input values is true. Option D is the result if only the X value was subjected to the NOR (the ~ symbol) function, which reverses the value of an input.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      924,
      922,
      147,
      145,
      172
    ],
    "source": ""
  },
  {
    "id": 3300,
    "question": "Which of the following are considered standard data type classifications used in either a government/military or a private sector organization?  (Select all that apply.)",
    "choice_a": "Public",
    "choice_b": "Healthy",
    "choice_c": "Private",
    "choice_d": "Inside only",
    "correct_answer": [
      "A",
      "C",
      "E",
      "F",
      "I",
      "J"
    ],
    "explanation": "There are six standard data type classifications used in either a government/military or a private sector organization in this list of options: public, private, sensitive, proprietary, critical, and confidential. The other options (healthy, internal, essential, certified, and for your eyes only) are incorrect since they are not typical or standard classifications.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      121,
      120,
      143,
      128,
      123
    ],
    "source": "",
    "choice_e": "Sensitive",
    "choice_f": "Proprietary",
    "choice_g": "Essential",
    "choice_h": "Certified",
    "choice_i": "Critical",
    "choice_j": "Confidential",
    "choice_k": "For Your Eyes Only"
  },
  {
    "id": 3301,
    "question": "The General Data Protection Regulation (GDPR) has defined several roles in relation to the protection and management of personally identifiable information (PII). <br>Which of the following statements is true?",
    "choice_a": "A data processor is the entity assigned specific responsibility for a data asset in order to ensure its protection for use by the organization.",
    "choice_b": "A data custodian is the entity that performs operations on data.",
    "choice_c": "A data controller is the entity that makes decisions about the data they are collecting.",
    "choice_d": "A data owner is the entity assigned or delegated the day-to-day responsibility of proper storage and transport as well as protecting data, assets, and other organizational objects.",
    "correct_answer": "C",
    "explanation": "The correct statement is regarding the data controller. The other statements are incorrect. The correct versions of those statements are as follows. A data owner is the entity assigned specific responsibility for a data asset in order to ensure its protection for use by the organization. A data processor is the entity that performs operations on data. A data custodian is the entity assigned or delegated the day-to-day responsibility for proper storage and transport as well as protecting data, assets, and other organizational objects.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      139,
      138,
      143,
      988,
      989
    ],
    "source": ""
  },
  {
    "id": 3302,
    "question": "If Renee receives a digitally signed message from Mike, what key does she use to verify that the message truly came from Mike?",
    "choice_a": "Renee's public key",
    "choice_b": "Renee's private key",
    "choice_c": "Mike's public key",
    "choice_d": "Mike's private key",
    "correct_answer": "C",
    "explanation": "Any recipient can use Mike's public key to verify the authenticity of the digital signature. Renee's (the recipient) public key is not used in this scenario. However, it could be used to create a digital envelope to protect a symmetric session encryption key sent from Mike to Renee. Renee's (the recipient) private key is not used in this scenario. However, it could be used if Renee becomes a sender to send Mike a digitally signed message. Mike's (the sender) private key was used to encrypt the hash of the data to be sent to Renee, and this is what creates the digital signature.",
    "topic_id": 3,
    "practice_test_id": 5,
    "related_articles": [
      176,
      175,
      200,
      154,
      198
    ],
    "source": ""
  },
  {
    "id": 3303,
    "question": "A systems administrator is setting up a new data management system. It will be gathering data from numerous locations across the network, even from remote offsite locations. The data will be moved to a centralized facility, where it will be stored on a massive RAID array. The data will be encrypted on the storage system using AES-256, and most files will be signed as well. The location of this data warehouse is secured so that only authorized personnel can enter the room and all digital access is limited to a set of security administrators. <br>Which of the following describes the data?",
    "choice_a": "The data is encrypted in transit.",
    "choice_b": "The data is encrypted in processing.",
    "choice_c": "The data is redundantly stored.",
    "choice_d": "The data is encrypted at rest.",
    "correct_answer": "D",
    "explanation": "In this scenario, the data is encrypted at rest with AES-256. There is no mention of encryption for transfer or processing. The data is not stored redundantly, since it is being moved, not copied, to the central data warehouse, and there is no mention of a backup.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      122,
      144,
      124,
      700,
      702
    ],
    "source": ""
  },
  {
    "id": 3304,
    "question": "The __________ is the entity assigned specific responsibility for a data asset in order to ensure its protection for use by the organization.",
    "choice_a": "Data owner",
    "choice_b": "Data controller",
    "choice_c": "Data processor",
    "choice_d": "Data custodian",
    "correct_answer": "A",
    "explanation": "The data owner is the person(s) (or entity) assigned specific responsibility for a data asset in order to ensure its protection for use by the organization. The data controller is the entity that makes decisions about the data they are collecting. A data processor is the entity that performs operations on data on behalf of a data controller. A data custodian or steward is a subject who has been assigned or delegated the day-to-day responsibility for proper storage and transport as well as protecting data, assets, and other organizational objects.",
    "topic_id": 2,
    "practice_test_id": 5,
    "related_articles": [
      138,
      851,
      143,
      989,
      988
    ],
    "source": ""
  },
  {
    "id": 3305,
    "question": "A security auditor is seeking evidence of how sensitive documents made their way out of the organization and onto a public document distribution site. It is suspected that an insider exfiltrated the data over a network connection to an external server, but this is only a guess. <br>Which of the following would be useful in determining whether this suspicion is accurate? (Choose two.)",
    "choice_a": "NAC",
    "choice_b": "DLP alerts",
    "choice_c": "Syslog",
    "choice_d": "Log analysis",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "In this scenario, the data loss prevention (DLP) alerts and log analysis are the only options that would potentially include useful information in regard to an insider exfiltrating the sensitive documents. The other options are incorrect because they do not provide relevant information. Network access control (NAC) is a security mechanism to prevent rogue devices and ensure authorized systems meet minimum security configuration requirements. Syslog is a logging service used to maintain centralized real-time copies of active log files. Malware scanner reports are not relevant here since there is no suspicious or malicious code being used but only access abuses and unauthorized file distribution. Integrity monitoring is also not relevant to this situation, since there is no indication that the documents were altered, just that they were released to the public.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      498,
      774,
      783,
      502,
      499
    ],
    "source": "",
    "choice_e": "Malware scanner reports",
    "choice_f": "Integrity monitoring"
  },
  {
    "id": 3306,
    "question": "A new Wireless Access Point is being installed to add wireless connectivity to the company network. The configuration policy indicates that WPA3 is to be used and thus only newer or updated endpoint devices can connect. The policy also states that ENT authentication will not be implemented. <br>What authentication mechanism can be implemented in this situation?",
    "choice_a": "IEEE 802.1X",
    "choice_b": "IEEE 802.1q",
    "choice_c": "Simultaneous authentication of equals (SAE)",
    "choice_d": "EAP-FAST",
    "correct_answer": "C",
    "explanation": "WPA3 supports ENT (Enterprise Wi-Fi authentication, aka IEEE 802.1X) and SAE authentication. Simultaneous authentication of equals (SAE) still uses a password, but it no longer encrypts and sends that password across the connection to perform authentication. Instead, SAE performs a zero-knowledge proof process known as Dragonfly Key Exchange, which is itself a derivative of Diffie\u2013Hellman. IEEE 802.1X defines port-based network access control that ensures that clients can't communicate with a resource until proper authentication has taken place. It's based on Extensible Authentication Protocol (EAP) from Point-to-Point Protocol (PPP). However, this is the technology behind the label of ENT; thus, it is not an option in this scenario. IEEE 802.1q defines the use of virtual local area network (VLAN) tags and thus is not relevant to Wi-Fi authentication. Flexible Authentication via Secure Tunneling (EAP-FAST) is a Cisco protocol proposed to replace Lightweight Extensible Authentication Protocol (LEAP), which is now obsolete, thanks to the development of WPA2, and is not supported in WPA3 either.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      361,
      362,
      391,
      392,
      437
    ],
    "source": ""
  },
  {
    "id": 3307,
    "question": "When securing a mobile device, what types of authentication can be used that depend on the user's physical attributes?  (Select all that apply.)",
    "choice_a": "Fingerprint",
    "choice_b": "TOTP (time-based one-time password)",
    "choice_c": "Voice",
    "choice_d": "SMS (short message service)",
    "correct_answer": [
      "A",
      "C",
      "E",
      "H"
    ],
    "explanation": "Biometrics are authentication factors that are based on a user's physical attributes; they include fingerprints, voice, retina, and facial recognition. Gait is a form of biometrics, but it is not appropriate for use as authentication on a mobile device; it is used from a stationary position to monitor people walking toward or past a security point. The other options are valid authentication factors, but they are not biometrics.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      445,
      443,
      459,
      461,
      746
    ],
    "source": "",
    "choice_e": "Retina or iris",
    "choice_f": "Gait",
    "choice_g": "Phone call",
    "choice_h": "Facial recognition",
    "choice_i": "Smartcard",
    "choice_j": "Password"
  },
  {
    "id": 3308,
    "question": "A recently acquired piece of equipment is not working properly. Your organization does not have a trained repair technician on staff, so you have to bring in an outside expert. <br>What type of account should be issued to a trusted third-party repair technician?",
    "choice_a": "Guest account",
    "choice_b": "Privileged account",
    "choice_c": "Service account",
    "choice_d": "User account",
    "correct_answer": "B",
    "explanation": "A repair technician typically requires more than a normal level of access to perform their duties, so a privileged account for even a trusted third-party technician is appropriate. A guest account or user (normal, limited) account is insufficient for this scenario. A service account is to be used by an application or background service, not a repair technician or other user.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      926,
      927,
      470,
      903,
      457
    ],
    "source": ""
  },
  {
    "id": 3309,
    "question": "Security should be designed and integrated into the organization as a means to support and maintain the business objectives. However, the only way to know if the implemented security is sufficient is to test it. <br>Which of the following is a procedure designed to test and perhaps bypass a system's security controls?",
    "choice_a": "Logging usage data",
    "choice_b": "War dialing",
    "choice_c": "Penetration testing",
    "choice_d": "Deploying secured desktop workstations",
    "correct_answer": "C",
    "explanation": "Penetration testing is the attempt to bypass security controls to test overall system security. Logging usage data is a type of auditing and is useful in the authentication, authorization, accounting (AAA) service process in order to hold subjects accountable for their actions. However, it is not a means to test security. War dialing is an attempt to locate modems and fax machines by dialing phone numbers. This process is sometimes still used by penetration testers and adversaries to find targets to attack, but it is not an actual attack or stress test itself. Deploying secured desktop workstations is a security response to the results of a penetration test, not a security testing method.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      1078,
      1080,
      771,
      495,
      494
    ],
    "source": ""
  },
  {
    "id": 3310,
    "question": "Security needs to be designed to support the business objectives, but it also needs to be legally defensible. To defend the security of an organization, a log of events and activities must be created. Auditing is a required factor to sustain and enforce what?",
    "choice_a": "Accountability",
    "choice_b": "Confidentiality",
    "choice_c": "Accessibility",
    "choice_d": "Redundancy",
    "correct_answer": "A",
    "explanation": "Auditing is a required factor to sustain and enforce accountability. Auditing is one of the elements of the AAA services concept of identification, authentication, authorizations, auditing, and accounting (or accountability). Confidentiality is a core security element of the CIA Triad, but it is not dependent on auditing. Accessibility is the assurance that locations and systems are able to be used by the widest range of people/users possible. Redundancy is the implementation of alternatives, backup options, and recovery measures and methods to avoid single points of failure to ensure that downtime is minimized while maintaining availability.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      31,
      7,
      17,
      11,
      14
    ],
    "source": ""
  },
  {
    "id": 3311,
    "question": "Risk assessment is a process by which the assets, threats, probabilities, and likelihoods are evaluated in order to establish criticality prioritization. <br>What is the formula used to compute the ALE?",
    "choice_a": "ALE = AV * EF * ARO",
    "choice_b": "ALE = ARO * EF",
    "choice_c": "ALE = AV * ARO",
    "choice_d": "ALE = EF * ARO",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy (ALE) is computed as the product of the asset value (AV) times the exposure factor (EF) times the annualized rate of occurrence (ARO). This is the longer form of the formula ALE = SLE * ARO, since SLE = AV * EF. The other formulas displayed here do not accurately reflect this calculation, since they are not valid or typical risk formulas.",
    "topic_id": 1,
    "practice_test_id": 5,
    "related_articles": [
      45,
      86,
      875,
      934,
      935
    ],
    "source": ""
  },
  {
    "id": 3312,
    "question": "Incident response plans, business continuity plans, and disaster recovery plans are crafted when implementing business-level redundancy. These plans are derived from the information obtained when performing a business impact assessment (BIA). <br>What is the first step of the BIA process?",
    "choice_a": "Identification of priorities",
    "choice_b": "Likelihood assessment",
    "choice_c": "Risk identification",
    "choice_d": "Resource prioritization",
    "correct_answer": "A",
    "explanation": "Identification of priorities is the first step of the business impact assessment process. Likelihood assessment is the third step or phase of BIA. Risk identification is the second step of BIA. Resource prioritization is the last step of BIA.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      791,
      790,
      792,
      500,
      789
    ],
    "source": ""
  },
  {
    "id": 3313,
    "question": "Many events can threaten the operation, existence, and stability of an organization. Some of those threats are human caused, whereas others are from natural events. <br>Which of the following represent natural events that can pose a threat or risk to an organization?",
    "choice_a": "Earthquake",
    "choice_b": "Flood",
    "choice_c": "Tornado",
    "choice_d": "All of the above",
    "correct_answer": "D",
    "explanation": "Natural events that can threaten organizations include earthquakes, floods, hurricanes, tornadoes, wildfires, and other acts of nature. Thus options A, B, and C are correct because they are natural and not human caused.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      500,
      502,
      789,
      784,
      785
    ],
    "source": ""
  },
  {
    "id": 3314,
    "question": "What kind of recovery facility enables an organization to resume operations as quickly as possible, if not immediately, upon failure of the primary facility?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "All of the above",
    "correct_answer": "A",
    "explanation": "Hot sites provide backup facilities maintained in constant working order and fully capable of taking over business operations. Warm sites consist of preconfigured hardware and software to run the business, neither of which possesses the vital business information. Cold sites are simply facilities designed with power and environmental support systems but no configured hardware, software, or services. Disaster recovery services can facilitate and implement any of these sites on behalf of a company.",
    "topic_id": 6,
    "practice_test_id": 5,
    "related_articles": [
      791,
      792,
      790,
      786,
      500
    ],
    "source": ""
  },
  {
    "id": 3315,
    "question": "During an account review, an auditor provided the following report: <br><img src=\"/question_assets/CISSP/1_image2_at.png\"/><br>The security manager reviews the account policies of the organization and takes note of the following requirements:<li>Passwords must be at least 12 characters long.</li><li>Passwords must include at least one example of three different character types.</li><li>Passwords must be changed every 180 days.</li><li>Passwords cannot be reused. </li><br>Which of the following security controls should be corrected to enforce the password policy?",
    "choice_a": "Minimum password length",
    "choice_b": "Account lockout",
    "choice_c": "Password history and minimum age",
    "choice_d": "Password maximum age",
    "correct_answer": "D",
    "explanation": "The issue revealed by the audit report is that one account has a password that is older than the requirements allow for; thus, correcting the password maximum age security setting should resolve this. There is no information in regard to password length, lockout, or password reuse in the audit report, so these options are not of concern in this situation.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      447,
      907,
      908,
      489,
      441
    ],
    "source": ""
  },
  {
    "id": 3316,
    "question": "Any evidence to be used in a court proceeding must abide by the Rules of Evidence to be admissible. <br>What type of evidence refers to written documents that are brought into court to prove a fact?",
    "choice_a": "Best evidence",
    "choice_b": "Parol evidence",
    "choice_c": "Documentary evidence",
    "choice_d": "Testimonial evidence",
    "correct_answer": "C",
    "explanation": "Written documents brought into court to prove the facts of a case are referred to as documentary evidence. Best evidence is a form of documentary evidence, but specifically it is the original document rather than a copy or description. Parol evidence is based on a rule stating that when an agreement between parties is put into written form, the written document is assumed to contain all the terms of the agreement and no verbal agreements may modify the written agreement. Testimonial evidence consists of the testimony of a witness's experience, either verbal testimony in court or written testimony in a recorded deposition.",
    "topic_id": 7,
    "practice_test_id": 5,
    "related_articles": [
      601,
      615,
      607,
      602,
      541
    ],
    "source": ""
  },
  {
    "id": 3317,
    "question": "DevOps manager John is concerned with the CEO's plan to minimize his department and outsource code development to a foreign programming group. John has a meeting scheduled with the board of directors to encourage them to retain code development in house due to several concerns. <br>Which of the following should John include in his presentation? (Select all that apply.)",
    "choice_a": "Code from third parties will need to be manually reviewed for function and security.",
    "choice_b": "If the third party goes out of business, existing code may need to be abandoned.",
    "choice_c": "Third-party code development is always more expensive.",
    "choice_d": "A software escrow agreement should be established.",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "If your organization depends on custom-developed software or software products produced through outsourced code development, then the risks of that arrangement need to be evaluated and mitigated. First, the quality and security of the code needs to be assessed. Second, if the third-party development group goes out of business, can you continue to operate with the code as is? You may need to abandon the existing code to switch to a new development group. It is not true that third-party code development is always more expensive; it is often less expensive. A software escrow agreement (SEA) is not an issue that John would want to bring up as a reason to keep development in house, since a SEA is a means to reduce the risk of a third-party developer group ceasing to exist.",
    "topic_id": 8,
    "practice_test_id": 5,
    "related_articles": [
      625,
      621,
      628,
      670,
      618
    ],
    "source": ""
  },
  {
    "id": 3318,
    "question": "When TLS is being used to secure web communications, what URL prefix appears in the web browser address bar to signal this fact?",
    "choice_a": "<code>SHTTP:// </code>",
    "choice_b": "<code>TLS:// </code>",
    "choice_c": "<code>FTPS:// </code>",
    "choice_d": "<code>HTTPS:// </code>",
    "correct_answer": "D",
    "explanation": "<code>HTTPS:// </code> is the correct prefix for the use of HTTP (Hypertext Transfer Protocol) over TLS (Transport Layer Security). This was the same prefix when SSL (Secure Sockets Layer) was used to encrypt HTTP, but SSL has been deprecated. <code>SHTTP:// </code> is for Secure HTTP, which was SSH but SHTTP is also deprecated. <code>TLS:// </code> is an invalid prefix. <code>FTPS:// </code> is a valid prefix that can be used in some web browsers, and it uses TLS to encrypt the connection, but it is for securing FTP file exchange rather than web communications.",
    "topic_id": 4,
    "practice_test_id": 5,
    "related_articles": [
      350,
      335,
      906,
      332,
      401
    ],
    "source": ""
  },
  {
    "id": 3319,
    "question": "A new update has been released by the vendor of an important software product that is an essential element of a critical business task. The chief security officer (CSO) indicates that the new software version needs to be tested and evaluated in a virtual lab, which has a cloned simulation of many of the company's production systems. Furthermore, the results of this evaluation must be reviewed before a decision is made as to whether the software update should be installed and, if so, when to install it. <br>What security principle is the CSO demonstrating?",
    "choice_a": "Business continuity planning (BCP)",
    "choice_b": "Onboarding",
    "choice_c": "Change management",
    "choice_d": "Static analysis",
    "correct_answer": "C",
    "explanation": "The CSO in this scenario is demonstrating the need to follow the security principle of change management. Change management usually involves extensive planning, testing, logging, auditing, and monitoring of activities related to security controls and mechanisms. This scenario is not describing a BCP event. A BCP event would involve the evaluation of threats to business processes and then the creation of response scenarios to address those issues. This scenario is not describing onboarding. Onboarding is the process of integrating a new element (such as an employee or device) into an existing system of security infrastructure. Although loosely similar to change management, onboarding focuses more on ensuring compliance with existing security policies by the new member, rather than testing updates for an existing member. Static analysis is used to evaluate source code as a part of a secure development environment. Static analysis may be used as an evaluation tool in change management, but it is a tool, not the principle of security referenced in this scenario.",
    "topic_id": 8,
    "practice_test_id": 5,
    "related_articles": [
      624,
      621,
      640,
      1030,
      1032
    ],
    "source": ""
  },
  {
    "id": 3320,
    "question": "What type of token device produces new time-derived passwords on a specific time interval that can be used only a single time when attempting to authenticate?",
    "choice_a": "HOTP",
    "choice_b": "HMAC",
    "choice_c": "SAML",
    "choice_d": "TOTP",
    "correct_answer": "D",
    "explanation": "The two main types of token devices are TOTP and HOTP. Time-based one-time password (TOTP) tokens or synchronous dynamic password tokens are devices or applications that generate passwords at fixed time intervals, such as every 60 seconds. Thus, TOTP produces new time-derived passwords on a specific time interval that can be used only a single time when attempting to authenticate. HMAC-based one-time password (HOTP) tokens or asynchronous dynamic password tokens are devices or applications that generate passwords not based on fixed time intervals but instead based on a nonrepeating one-way function, such as a hash or hash message authentication code (HMAC\u2014a type of hash that uses a symmetric key in the hashing process) operation. HMAC is a hashing function, not a means to authenticate. Security Assertions Markup Language (SAML) is used to create authentication federation (i.e. sharing) links; it is not itself a means to authenticate.",
    "topic_id": 5,
    "practice_test_id": 5,
    "related_articles": [
      444,
      443,
      489,
      476,
      474
    ],
    "source": ""
  },
  {
    "id": 3321,
    "question": "Your organization is moving a significant portion of their data processing from an on-premises solution to the cloud. When evaluating a cloud service provider (CSP), which of the following is the most important security concern?",
    "choice_a": "Data retention policy",
    "choice_b": "Number of customers",
    "choice_c": "Hardware used to support VMs",
    "choice_d": "Whether they offer MaaS, IDaaS, and SaaS",
    "correct_answer": "A",
    "explanation": "The most important security concern from this list of options in relation to a CSP is the data retention policy. The data retention policy defines what information or data is being collected by the CSP, how long it will be kept, how it is destroyed, why it is kept, and who can access it. The number of customers and what hardware is used are not significant security concerns in comparison to data retention. Whether the CSP offers MaaS, IDaaS, and SaaS is not as important as data retention, especially if these are not services your organization needs or wants. One of the keys to answering this question is to consider the range of CSP options, including software as a service (SaaS), platform as a service (PaaS), and infrastructure as a service (IaaS), and the type of organizations that are technically CSP SaaS but that we don't often think of as such (examples include Facebook, Google, and Amazon). These organizations absolutely have access to customer/user data, and thus, their data retention policies are of utmost concern (at least compared to the other options provided).",
    "topic_id": 8,
    "practice_test_id": 5,
    "related_articles": [
      634,
      636,
      818,
      621,
      623
    ],
    "source": ""
  },
  {
    "id": 3322,
    "question": "Most software vulnerabilities exist because of a lack of secure or defensive coding practices used by the developers. <br>Which of the following are considered secure coding techniques? (Select all that apply.)",
    "choice_a": "Using immutable systems",
    "choice_b": "Using stored procedures",
    "choice_c": "Using code signing",
    "choice_d": "Using server-side validation",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Programmers need to adopt secure coding practices, which include using stored procedures, code signing, and server-side validation. A stored procedure is a subroutine or software module that can be called on or accessed by applications interacting with a relational database management system (RDBMS). Code signing is the activity of crafting a digital signature of a software program in order to confirm that it was not changed and who it is from. Server-side data validation is suited for protecting a system against input submitted by a malicious user. Using immutable systems is not a secure coding technique; instead, an immutable system is a server or software product that, once configured and deployed, is never altered in place. File size optimization may be efficient but is not necessarily a secure coding technique. Using third-party software libraries may reduce workload to minimize the amount of new code to author, but third-party software libraries are a risk because they can introduce vulnerabilities, especially when closed source libraries are used. Thus, use of third-party software libraries is not a secure coding technique unless the security posture of the externally sourced code is verified, which was not mentioned as an answer option.",
    "topic_id": 8,
    "practice_test_id": 5,
    "related_articles": [
      620,
      670,
      668,
      618,
      672
    ],
    "source": "",
    "choice_e": "Optimizing file sizes",
    "choice_f": "Using third-party software libraries"
  },
  {
    "id": 3323,
    "question": "Confidentiality, integrity, and availability are typically viewed as the primary goals and objectives of a security infrastructure. <br>Which of the following is not considered a violation of confidentiality?",
    "choice_a": "Stealing passwords using a keystroke logging tool",
    "choice_b": "Eavesdropping on wireless network communications",
    "choice_c": "Hardware destruction caused by arson",
    "choice_d": "Social engineering that tricks a user into providing personal information to a false website",
    "correct_answer": "C",
    "explanation": "Hardware destruction is a violation of availability and possibly integrity. Violations of confidentiality include stealing passwords, eavesdropping, and social engineering.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      5,
      6,
      61
    ],
    "source": ""
  },
  {
    "id": 3324,
    "question": "Security governance requires a clear understanding of the objectives of the organization as the core concepts of security. <br>Which of the following contains the primary goals and objectives of security?",
    "choice_a": "A network's border perimeter",
    "choice_b": "The CIA Triad",
    "choice_c": "AAA services",
    "choice_d": "Ensuring that subject activities are recorded",
    "correct_answer": "B",
    "explanation": "The primary goals and objectives of security are confidentiality, integrity, and availability, commonly referred to as the CIA Triad. The other options are incorrect. A security infrastructure needs to establish a network's border perimeter security, but that is not a primary goal or objective of security. AAA services is a common component of secured systems, which can provide support for accountability, but the primary goals of security remain the elements of the CIA Triad. Ensuring that subject activities are recorded is the purpose of auditing, but that is not a primary goal or objective of security.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      4,
      6,
      1,
      14
    ],
    "source": ""
  },
  {
    "id": 3325,
    "question": "James recently discovered an attack taking place against his organization that prevented employees from accessing critical records. <br>What element of the CIA Triad was violated?",
    "choice_a": "Identification",
    "choice_b": "Availability",
    "choice_c": "Encryption",
    "choice_d": "Layering",
    "correct_answer": "B",
    "explanation": "Availability means that authorized subjects are granted timely and uninterrupted access to objects. Identification is claiming an identity, the first step of AAA services. Encryption is protecting the confidentiality of data by converting plain text into cipher text. Layering is the use of multiple security mechanisms in series.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      5,
      7,
      8,
      6
    ],
    "source": ""
  },
  {
    "id": 3326,
    "question": "Optimally, security governance is performed by a board of directors, but smaller organizations may simply have the CEO or CISO perform the activities of security governance. <br>Which of the following is true about security governance?",
    "choice_a": "Security governance ensures that the requested activity or access to an object is possible given the rights and privileges assigned to the authenticated identity.",
    "choice_b": "Security governance is used for efficiency. Similar elements are put into groups, classes, or roles that are assigned security controls, restrictions, or permissions as a collective.",
    "choice_c": "Security governance is a documented set of best IT security practices that prescribes goals and requirements for security controls and encourages the mapping of IT security ideals to business objectives.",
    "choice_d": "Security governance seeks to compare the security processes and infrastructure used within the organization with knowledge and insight obtained from external sources.",
    "correct_answer": "D",
    "explanation": "Security governance seeks to compare the security processes and infrastructure used within the organization with knowledge and insight obtained from external sources. The other statements are not related to security governance. Authorization ensures that the requested activity or access to an object is possible given the rights and privileges assigned to the authenticated identity. Abstraction is used for efficiency. Similar elements are put into groups, classes, or roles that are assigned security controls, restrictions, or permissions as a collective. COBIT is a documented set of best IT security practices crafted by the Information Systems Audit and Control Association (ISACA) that prescribes goals and requirements for security controls and encourages the mapping of IT security ideals to business objectives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      11,
      32,
      18,
      14,
      20
    ],
    "source": ""
  },
  {
    "id": 3327,
    "question": "You have been tasked with crafting a long-term security plan that is fairly stable. It needs to define the organization's security purpose. It also needs to define the security function and align it to the goals, mission, and objectives of the organization. <br>What are you being asked to create?",
    "choice_a": "Tactical plan",
    "choice_b": "Operational plan",
    "choice_c": "Strategic plan",
    "choice_d": "Rollback plan",
    "correct_answer": "C",
    "explanation": "A strategic plan is a long-term plan that is fairly stable. It defines the organization's security purpose. It defines the security function and aligns it to the goals, mission, and objectives of the organization. The tactical plan is a midterm plan developed to provide more details on accomplishing the goals set forth in the strategic plan or can be crafted ad hoc based on unpredicted events. An operational plan is a short-term, highly detailed plan based on the strategic and tactical plans. It is valid or useful only for a short time. A rollback plan is a means to return to a prior state after a change does not meet expectations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      16,
      14,
      32,
      15,
      2
    ],
    "source": ""
  },
  {
    "id": 3328,
    "question": "Annaliese's organization is undergoing a period of increased business activity where they are conducting a large number of mergers and acquisitions. She is concerned about the risks associated with those activities. <br>Which of the following are example of those risks?  (Select all that apply.)",
    "choice_a": "Inappropriate information disclosure",
    "choice_b": "Increased worker compliance",
    "choice_c": "Data loss",
    "choice_d": "Downtime",
    "correct_answer": [
      "A",
      "C",
      "D",
      "F"
    ],
    "explanation": "Acquisitions and mergers place an organization at an increased level of risk. Such risks include inappropriate information disclosure, data loss, downtime, and failure to achieve sufficient return on investment (ROI). Increased worker compliance is not a risk, but a desired security precaution against the risks of acquisitions. Additional insight into the motivations of inside attackers is not a risk, but a potential result of investigating breaches or incidents related to acquisitions.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      21,
      95,
      82,
      77,
      93
    ],
    "source": "",
    "choice_e": "Additional insight into the motivations of inside attackers",
    "choice_f": "Failure to achieve a sufficient return on investment (ROI)"
  },
  {
    "id": 3329,
    "question": "Which security framework was initially crafted by a government for domestic use but is now an international standard, which is a set of recommended best practices for optimization of IT services to support business growth, transformation, and change; which focuses on understanding how IT and security need to be integrated with and aligned to the objectives of an organization; and which is often used as a starting point for the crafting of a customized IT security solution within an established infrastructure?",
    "choice_a": "ITIL",
    "choice_b": "ISO 27000",
    "choice_c": "CIS",
    "choice_d": "CSF",
    "correct_answer": "A",
    "explanation": "Information Technology Infrastructure Library (ITIL) was initially crafted by the British government for domestic use but is now an international standard, which is a set of recommended best practices for core IT security and operational processes, and is often used as a starting point for the crafting of a customized IT security solution. The other options were not crafted by the British government. ISO 27000 is a family group of international standards that can be the basis of implementing organizational security and related management practices. The Center for Internet Security (CIS) provides OS, application, and hardware security configuration guides. NIST Cybersecurity Framework (CSF) is designed for critical infrastructure and commercial organizations and consists of five functions: Identify, Protect, Detect, Respond, and Recover. It is a prescription of operational activities that are to be performed on an ongoing basis for the support and improvement of security over time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      19,
      50,
      11,
      1,
      15
    ],
    "source": ""
  },
  {
    "id": 3330,
    "question": "A security role is the part an individual plays in the overall scheme of security implementation and administration within an organization. <br>What is the security role that has the functional responsibility for security, including writing the security policy and implementing it?",
    "choice_a": "Senior management",
    "choice_b": "Security professional",
    "choice_c": "Custodian",
    "choice_d": "Auditor",
    "correct_answer": "B",
    "explanation": "The security professional has the functional responsibility for security, including writing the security policy and implementing it. Senior management is ultimately responsible for the security maintained by an organization and who should be most concerned about the protection of its assets. The custodian role is assigned to the user is responsible for the tasks of implementing the prescribed protection defined by the security policy and senior management. An auditor is responsible for reviewing and verifying that the security policy is properly implemented and the derived security solutions are adequate.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      22,
      14,
      11,
      47
    ],
    "source": ""
  },
  {
    "id": 3331,
    "question": "Control Objectives for Information and Related Technology (COBIT) is a documented set of best IT security practices crafted by the Information Systems Audit and Control Association (ISACA). It prescribes goals and requirements for security controls and encourages the mapping of IT security ideals to business objectives. COBIT is based on six key principles for governance and management of enterprise IT. <br>Which of the following are among these key principles?  (Select all that apply.)",
    "choice_a": "Holistic Approach",
    "choice_b": "End-to-End Governance System",
    "choice_c": "Provide Stakeholder Value",
    "choice_d": "Maintaining Authenticity and Accountability",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "The COBIT key principles are: Provide Stakeholder Value (C), Holistic Approach (A), Dynamic Governance System (E), Governance Distinct From Management (not listed), Tailored to Enterprise Needs (not listed), and End-to-End Governance System (B). The concept of maintaining authenticity and accountability are good security ideas, but not a COBIT key principle.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      12,
      14,
      50,
      53
    ],
    "source": "",
    "choice_e": "Dynamic Governance System"
  },
  {
    "id": 3332,
    "question": "In today's business environment, prudence is mandatory. Showing due diligence and due care is the only way to disprove negligence in an occurrence of loss. <br>Which of the following are true statements?  (Select all that apply.)",
    "choice_a": "Due diligence is establishing a plan, policy, and process to protect the interests of an organization.",
    "choice_b": "Due care is developing a formalized security structure containing a security policy, standards, baselines, guidelines, and procedures.",
    "choice_c": "Due diligence is the continued application of a security structure onto the IT infrastructure of an organization.",
    "choice_d": "Due care is practicing the individual activities that maintain the security effort.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Due diligence is establishing a plan, policy, and process to protect the interests of an organization. Due care is practicing the individual activities that maintain the security effort. The other options are incorrect, they have the terms inverted. The corrected statements are as follows: Due diligence is developing a formalized security structure containing a security policy, standards, baselines, guidelines, and procedures. Due care is the continued application of a security structure onto the IT infrastructure of an organization. Due diligence is knowing what should be done and planning for it. Due care is doing the right action at the right time.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      22,
      32,
      15,
      1
    ],
    "source": "",
    "choice_e": "Due care is knowing what should be done and planning for it.",
    "choice_f": "Due diligence is doing the right action at the right time."
  },
  {
    "id": 3333,
    "question": "Security documentation is an essential element of a successful security program. Understanding the components is an early step in crafting the security documentation. Match the following components to their respective definitions. <ol><li>Policy </li><li>Standard </li><li>Procedure</li><li>Guideline</li></ol><br><ol type=\"I\"><li>A detailed, step-by-step how-to document that describes the exact actions necessary to implement a specific security mechanism, control, or solution. </li><li>A document that defines the scope of security needed by the organization and discusses the assets that require protection and the extent to which security solutions should go to provide the necessary protection. </li><li>A minimum level of security that every system throughout the organization must meet. </li><li>Offers recommendations on how security requirements are implemented and serves as an operational guide for both security professionals and users. </li><li>Defines compulsory requirements for the homogenous use of hardware, software, technology, and security controls. </li></ol>",
    "choice_a": "1 \u2013 I; 2 \u2013 IV; 3 \u2013 II; 4 - V",
    "choice_b": "1 \u2013 II; 2 \u2013 V; 3 \u2013 I; 4 - IV",
    "choice_c": "1 \u2013 IV; 2 \u2013 II; 3 \u2013 V; 4 - I",
    "choice_d": "1 \u2013 V; 2 \u2013 I; 3 \u2013 IV; 4 - III",
    "correct_answer": "B",
    "explanation": "A policy is a document that defines the scope of security needed by the organization and discusses the assets that require protection and the extent to which security solutions should go to provide the necessary protection. A standard defines compulsory requirements for the homogenous use of hardware, software, technology, and security controls. A procedure is a detailed, step-by-step how-to document that describes the exact actions necessary to implement a specific security mechanism, control, or solution. A guideline offers recommendations on how security requirements are implemented and serves as an operational guide for both security professionals and users. III is the definition of a baseline, which was not included as a component option.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      22,
      13,
      14,
      11,
      47
    ],
    "source": ""
  },
  {
    "id": 3334,
    "question": "STRIDE is often used in relation to assessing threats against applications or operating systems. When confidential documents are exposed to unauthorized entities, which element of STRIDE is used to reference that violation?",
    "choice_a": "S",
    "choice_b": "T",
    "choice_c": "R",
    "choice_d": "I",
    "correct_answer": "D",
    "explanation": "When confidential documents are exposed to unauthorized entities, this is described by the I in STRIDE, which represents information disclosure. The elements of STRIDE are spoofing, tampering, repudiation, information disclosure, denial of service, and elevation of privilege.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      24,
      3,
      4,
      26,
      1
    ],
    "source": ""
  },
  {
    "id": 3335,
    "question": "A development team is working on a new project. During the early stages of systems development, the team considers the vulnerabilities, threats, and risks of their solution and integrates protections against unwanted outcomes. <br>What concept of threat modeling is this?",
    "choice_a": "Threat hunting",
    "choice_b": "Proactive approach",
    "choice_c": "Qualitative approach",
    "choice_d": "Adversarial approach",
    "correct_answer": "B",
    "explanation": "This scenario describes a proactive approach to threat modeling, which is also known as the defensive approach. Threat hunting takes place after a product has been created and deployed (this may be referred to as an adversarial approach or even reactive threat management)There is no threat modeling concept known as qualitative approach. Qualitative is typically associated with a form of risk assessment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      23,
      24,
      41,
      44,
      2
    ],
    "source": ""
  },
  {
    "id": 3336,
    "question": "Supply chain risk management (SCRM) is a means to ensure that all the vendors or links in the supply chain are reliable, trustworthy, reputable organizations. <br>Which of the following are true statements?  (Select all that apply.)",
    "choice_a": "Each link in the supply chain should be responsible and accountable to the next link in the chain.",
    "choice_b": "Commodity vendors are unlikely to have mined their own metals, processed the oil for plastics, or etched the silicon of their chips.",
    "choice_c": "If the final product derived from a supply chain meets expectations and functional requirements, it is assured to not have unauthorized elements.",
    "choice_d": "Failing to properly secure a supply chain can result in flawed or less reliable products, or even embedded listening or remote control mechanisms.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "These statements are true: (A) Each link in the supply chain should be responsible and accountable to the next link in the chain; (B) Commodity vendors are unlikely to have mined their own metals or processed the oil for plastics or etched the silicon of their chips; and (D) Failing to properly secure a supply chain can result in flawed or less reliable products, or even embedded listing or remote control mechanisms. The remaining option is incorrect. Even if a final product seems reasonable and performs all necessary functions, that does not provide assurance that it is secure or that it was not tampered with somewhere in the supply chain.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      27,
      28,
      29,
      30,
      17
    ],
    "source": ""
  },
  {
    "id": 3337,
    "question": "Your organization has become concerned with risks associated with the supply chain of their retail products. Fortunately, all coding for their custom product is done in-house. However, a thorough audit of a recently completed product revealed that a listening mechanism was integrated into the solution somewhere along the supply chain. The identified risk is associated with what product component in this scenario?",
    "choice_a": "Software",
    "choice_b": "Services",
    "choice_c": "Data",
    "choice_d": "Hardware",
    "correct_answer": "D",
    "explanation": "Though not explicitly stating hardware, this scenario describes a typical and potential risk of a supply chain, that a hardware risk results in the presence of a listening mechanism in the final product. This scenario does not provide information that would indicate that the supply chain risk is focused on software, services, or data.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      28,
      29,
      27,
      30,
      2
    ],
    "source": ""
  },
  {
    "id": 3338,
    "question": "Cathy's employer has asked her to perform a documentation review of the policies and procedures of a third-party supplier. This supplier is just the final link in a software supply chain. Their components are being used as a key element of an online service operated for high-end customers. Cathy discovers several serious issues with the vendor, such as failing to require encryption for all communications and not requiring multifactor authentication on management interfaces. <br>What should Cathy do in response to this finding?",
    "choice_a": "Write up a report and submit it to the CIO.",
    "choice_b": "Void the ATO of the vendor.",
    "choice_c": "Require that the vendor review their terms and conditions.",
    "choice_d": "Have the vendor sign an NDA.",
    "correct_answer": "B",
    "explanation": "In this scenario, Cathy should void the authorization to operate (ATO) of this vendor. This situation describes the fact that the vendor is not meeting minimal security requirements which are necessary to the protection of the service and its customers. Writing a report is not a sufficient response to this discovery. You may have assumed Cathy does or does not have the authority to perform any of the other options, but there is no indication of Cathy's position in the organization. It is reasonable for a CEO to ask the CISO to perform such an evaluation. Regardless, the report should be submitted to the CISO, not the CIO, whose focus is primarily on ensuring that information is used effectively to accomplish business objectives, not that such use is secure. Reviewing terms and conditions will not make any difference in this scenario, as those typically apply to customers, not internal operations. And reviewing does not necessarily cause a change or improvement to insecure practices. A vendor-signed NDA has no bearing on this scenario.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      13,
      11,
      15,
      17,
      41
    ],
    "source": ""
  },
  {
    "id": 3339,
    "question": "Whenever an organization works with a third party, its supply chain risk management (SCRM) processes should be applied. One of the common requirements is the establishment of minimum security requirements of the third party. <br>What should these requirements be based on?",
    "choice_a": "Existing security policy",
    "choice_b": "Third-party audit",
    "choice_c": "On-site assessment",
    "choice_d": "Vulnerability scan results",
    "correct_answer": "A",
    "explanation": "Minimum security requirements should be modeled on your existing security policy. This is based on the idea that when working with a third party, that third party should have at least the same security as your organization. A third-party audit is when a third-party auditor is brought in to perform an unbiased review of an entity's security infrastructure. This audit may reveal where there are problems, but the audit should not be the basis of minimum security requirements for a third party. On-site assessment is when you visit the site of the organization to interview personnel and observe their operating habits. This is not the basis for establishing minimum security requirements for a third party. Vulnerability scan results, like third-party audits, may reveal concerns, but it is not the basis for establishing minimum security requirements for a third party.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      21,
      1,
      10,
      15
    ],
    "source": ""
  },
  {
    "id": 3340,
    "question": "It's common to pair threats with vulnerabilities to identify threats that can exploit assets and represent significant risks to the organization. An ultimate goal of threat modeling is to prioritize the potential threats against an organization's valuable assets. <br>Which of the following is a risk-centric threat-modeling approach that aims at selecting or developing countermeasures in relation to the value of the assets to be protected?",
    "choice_a": "VAST",
    "choice_b": "SD3+C",
    "choice_c": "PASTA",
    "choice_d": "STRIDE",
    "correct_answer": "C",
    "explanation": "Process for Attack Simulation and Threat Analysis (PASTA) is a seven-stage threat modeling methodology. PASTA is a risk-centric approach that aims at selecting or developing countermeasures in relation to the value of the assets to be protected. Visual, Agile, and Simple Threat (VAST) is a threat modeling concept that integrates threat and risk management into an Agile programming environment on a scalable basis. Microsoft uses a Security Development Lifecycle (SDL) with the motto \"Secure by Design, Secure by Default, Secure in Deployment and Communication\" (also known as SD3+C). STRIDE is a threat categorization scheme developed by Microsoft.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      292,
      222,
      211,
      213
    ],
    "source": ""
  },
  {
    "id": 3341,
    "question": "The next step after threat modeling is reduction analysis. Reduction analysis is also known as decomposing the application, system, or environment. The purpose of this task is to gain a greater understanding of the logic of the product, its internal components, as well as its interactions with external elements. <br>Which of the following are key components to identify when performing decomposition?  (Select all that apply.)",
    "choice_a": "Patch or update versions",
    "choice_b": "Trust boundaries",
    "choice_c": "Dataflow paths",
    "choice_d": "Open vs. closed source code use",
    "correct_answer": [
      "B",
      "C",
      "E",
      "F",
      "G"
    ],
    "explanation": "The five key concepts of decomposition are trust boundaries, dataflow paths, input points, privileged operations, and details about security stance and approach. Patch or update version management is an important part of security management in general; it is just not a specific component of decomposition. Determining open vs. closed source code use is not an element of decomposition.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      229,
      215,
      294,
      226,
      208
    ],
    "source": "",
    "choice_e": "Input points",
    "choice_f": "Privileged operations",
    "choice_g": "Details about security stance and approach"
  },
  {
    "id": 3342,
    "question": "Defense in depth is simply the use of multiple controls in a series. No one control can protect against all possible threats. Using a multilayered solution allows for numerous, different controls to guard against whatever threats come to pass. <br>Which of the following are terms that relate to or are based on defense in depth? (Select all that apply.)",
    "choice_a": "Layering",
    "choice_b": "Classifications",
    "choice_c": "Zones",
    "choice_d": "Realms",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H"
    ],
    "explanation": "All of the listed options are terms that relate to or are based on defense in depth: layering, classifications, zones, realms, compartments, silos, segmentations, lattice structure, and protection rings.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      263,
      217,
      219,
      213,
      305
    ],
    "source": "",
    "choice_e": "Compartments",
    "choice_f": "Segmentations",
    "choice_g": "Lattice structure",
    "choice_h": "Protection rings"
  },
  {
    "id": 3343,
    "question": "You have been tasked with overseeing the security improvement project for your organization. The goal is to reduce the current risk profile to a lower level without spending considerable amounts of money. You decide to focus on the largest concern mentioned by your CISO. <br>Which of the following is likely the element of the organization that is considered the weakest?",
    "choice_a": "Software products",
    "choice_b": "Internet connections",
    "choice_c": "Security policies",
    "choice_d": "Humans",
    "correct_answer": "D",
    "explanation": "Regardless of the specifics of a security solution, humans are often considered the weakest element. No matter what physical or logical controls are deployed, humans can discover ways to avoid them, circumvent or subvert them, or disable them. Thus, it is important to take into account the humanity of your users when designing and deploying security solutions for your environment. Software products, internet connections, and security policies can all be vulnerabilities or otherwise areas of security concern, but they are not considered the most common weakest element of an organization.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      40,
      55,
      65,
      67,
      14
    ],
    "source": ""
  },
  {
    "id": 3344,
    "question": "Due to recent organization restructuring, the CEO believes that new workers should be hired to perform necessary work tasks and support the mission and goals of the organization. When seeking to hire new employees, what is the first step?",
    "choice_a": "Create a job description.",
    "choice_b": "Set position classification.",
    "choice_c": "Screen candidates.",
    "choice_d": "Request r\u00e9sum\u00e9s.",
    "correct_answer": "A",
    "explanation": "The first step in hiring new employees is to create a job description. Without a job description, there is no consensus on what type of individual needs to be found and hired. Crafting job descriptions is the first step in defining security needs related to personnel and being able to seek out new hires. From the job description, a determination can be made as to the education, skills, experience, and classification required by the applicant. Then a job posting can be made to request the submission of r\u00e9sum\u00e9s. Then, candidates can be screened to see if they meet the requirements and if they have any disqualifications.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      676,
      33,
      68,
      20,
      1
    ],
    "source": ""
  },
  {
    "id": 3345,
    "question": "_________________ is the process of adding new employees to the organization, having them review and sign policies, be introduced to managers and coworkers, and be trained in employee operations and logistics.",
    "choice_a": "Reissue",
    "choice_b": "Onboarding",
    "choice_c": "Background checks",
    "choice_d": "Site survey",
    "correct_answer": "B",
    "explanation": "Onboarding is the process of adding new employees to the organization, having them review and sign policies, be introduced to managers and coworkers, and be trained in employee operations and logistics. Reissue is a certification function when a lost certificate is provided to the user by extracting it from the escrow backup database or when a certificate is altered to extend its expiration date. Background checks are used to verify that a job applicant is qualified but not disqualified for a specific work position. A site survey is used to optimize the placement of wireless access points (WAPs) to provide reliable connectivity throughout the organization's facilities.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      68,
      37,
      65,
      69,
      31
    ],
    "source": ""
  },
  {
    "id": 3346,
    "question": "After repeated events of retraining, a particular worker was caught for the fourth time attempting to access documents that were not relevant to their job position. The CSO decides this was the last chance and the worker is to be fired. The CSO reminds you that the organization has a formal termination process that should be followed. <br>Which of the following is an important task to perform during the termination procedure to reduce future security issues related to this ex-employee?",
    "choice_a": "Return the exiting employee's personal belongings.",
    "choice_b": "Review the nondisclosure agreement.",
    "choice_c": "Evaluate the exiting employee's performance.",
    "choice_d": "Cancel the exiting employee's parking permit.",
    "correct_answer": "B",
    "explanation": "A termination process often focuses on eliminating an employee who has become problematic, whether that employee is committing crimes or just violating company policy. Once the worker is fired, the company has little direct control over that person. So, the only remaining leverage is legal, which often relates to a nondisclosure agreement (NDA). Hopefully, reviewing and reminding the ex-employee about their signed NDA will reduce future security issues, such as confidential data dissemination. Returning the exiting employee's personal belongings is not really an important task to protect the company's security interests. Evaluating the exiting employee's performance could be done via an exit interview, but that was not mentioned in this scenario. Often when an adversarial termination occurs, an exit interview is not feasible. Canceling an exiting employee's parking permit is not a high security priority for most organizations, at least not in comparison to the NDA.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      37,
      68,
      39,
      4,
      15
    ],
    "source": ""
  },
  {
    "id": 3347,
    "question": "Which of the following is a true statement in regard to vendor, consultant, and contractor controls?",
    "choice_a": "Using business email compromise (BEC) is a means to ensure that organizations providing services maintain an appropriate level of service agreed on by the service provider, vendor, or contractor and the customer organization.",
    "choice_b": "Outsourcing can be used as a risk response option known as acceptance or appetite.",
    "choice_c": "Multiparty risk exists when several entities or organizations are involved in a project. The risk or threats are often due to the variations of objectives, expectations, timelines, budgets, and security priorities of those involved.",
    "choice_d": "Risk management strategies implemented by one party do not cause additional risks against or from another party.",
    "correct_answer": "C",
    "explanation": "Option C is correct: Multiparty risk exists when several entities or organizations are involved in a project. The risk or threats are often due to the variations of objectives, expectations, timelines, budgets, and security priorities of those involved. The other statements are false. Their corrected and thus true versions would be: (A) Using service- level agreements (SLAs) is a means to ensure that organizations providing services maintain an appropriate level of service agreed on by the service provider, vendor, or contractor and the customer organization; (B) Outsourcing can be used as a risk response option known as transference or assignment; and (D) Risk management strategies implemented by one party may in fact cause additional risks to or from another party.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      38,
      41,
      52,
      20,
      49
    ],
    "source": ""
  },
  {
    "id": 3348,
    "question": "Match the term to its definition: <ol><li>Asset </li><li>Threat </li><li>Vulnerability </li><li>Exposure </li><li>Risk </li></ol><br><ol type=\"I\"><li>The weakness in an asset, or the absence or the weakness of a safeguard or countermeasure. </li><li>Anything used in a business process or task. </li><li>Being susceptible to asset loss because of a threat; there is the possibility that a vulnerability can or will be exploited. </li><li>The possibility or likelihood that a threat will exploit a vulnerability to cause harm to an asset and the severity of damage that could result. </li><li>Any potential occurrence that may cause an undesirable or unwanted outcome for an organization or for a specific asset. </li></ol>",
    "choice_a": "1-II, 2-V, 3-I, 4-III, 5-IV",
    "choice_b": "1-I, 2-II, 3-IV, 4-II, 5-V",
    "choice_c": "1-II, 2-V, 3-I, 4-IV, 5-III",
    "choice_d": "1-IV, 2-V, 3-III, 4-II, 5-I",
    "correct_answer": "A",
    "explanation": "An asset is anything used in a business process or task. A threat is any potential occurrence that may cause an undesirable or unwanted outcome for an organization or for a specific asset. A vulnerability is the weakness in an asset, or the absence or the weakness of a safeguard or countermeasure. An exposure is being susceptible to asset loss because of a threat; there is the possibility that a vulnerability can or will be exploited. Risk is the possibility or likelihood that a threat will exploit a vulnerability to cause harm to an asset and the severity of damage that could result.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      43,
      86,
      2,
      26
    ],
    "source": ""
  },
  {
    "id": 3349,
    "question": "While performing a risk analysis, you identify a threat of fire and a vulnerability of things being flammable because there are no fire extinguishers. Based on this information, which of the following is a possible risk?",
    "choice_a": "Virus infection",
    "choice_b": "Damage to equipment",
    "choice_c": "System malfunction",
    "choice_d": "Unauthorized access to confidential information",
    "correct_answer": "B",
    "explanation": "The threat of a fire and the vulnerability of a lack of fire extinguishers lead to the risk of damage to equipment. This scenario does not relate to virus infection or unauthorized access. Equipment damaged by fire could be considered a system malfunction, but that option is not as direct as \"damage to equipment.\".",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      41,
      26,
      2,
      85
    ],
    "source": ""
  },
  {
    "id": 3350,
    "question": "During a meeting of company leadership and the security team, discussion focuses on defining the value of assets in dollars, inventorying threats, predicting the specific amount of harm of a breach, and determining the number of times a threat could cause harm to the company each year. <br>What is being performed?",
    "choice_a": "Qualitative risk assessment",
    "choice_b": "Delphi technique",
    "choice_c": "Risk avoidance",
    "choice_d": "Quantitative risk assessment",
    "correct_answer": "D",
    "explanation": "This scenario is describing the activity of performing a quantitative risk assessment. The question describes the determination of asset value (AV) as well as the exposure factor (EF) and the annualized rate of occurrence (ARO) for each identified threat. These are the needed values to calculate the annualized loss expectancy (ALE), which is a quantitative factor. This is not an example of a qualitative risk assessment, since specific numbers are being determined rather than relying on ideas, reactions, feelings, and perspectives. This is not the Delphi technique, which is a qualitative risk assessment method that seeks to reach an anonymous consensus. This is not risk avoidance, since that is an optional risk response or treatment, and this scenario is only describing the process of risk assessment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      44,
      86,
      875,
      70
    ],
    "source": ""
  },
  {
    "id": 3351,
    "question": "You have performed a risk assessment and determined the threats that represent the most significant concern to your organization. When evaluating safeguards, what is the rule that should be followed in most cases?",
    "choice_a": "The expected annual cost of asset loss should not exceed the annual costs of safeguards.",
    "choice_b": "The annual costs of safeguards should equal the value of the asset.",
    "choice_c": "The annual costs of safeguards should not exceed the expected annual cost of asset value loss.",
    "choice_d": "The annual costs of safeguards should not exceed 10 percent of the security budget.",
    "correct_answer": "C",
    "explanation": "The annual costs of safeguards should not exceed the expected annual cost of asset value loss. The other statements are not rules to follow. (A) The annual cost of the safeguard should not exceed the annual cost of the asset value or its potential value loss. (B) The cost of the safeguard should be less than the value of the asset. (D) There is no specific maximum percentage of a security budget for the cost of a safeguard. However, the security budget should be used efficiently to reduce overall risk to an acceptable level.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      48,
      41,
      935,
      1,
      42
    ],
    "source": ""
  },
  {
    "id": 3352,
    "question": "During a risk management project, an evaluation of several controls determines that none are cost-effective in reducing the risk related to a specific important asset. <br>What risk response is being exhibited by this situation?",
    "choice_a": "Mitigation",
    "choice_b": "Ignoring",
    "choice_c": "Acceptance",
    "choice_d": "Assignment",
    "correct_answer": "C",
    "explanation": "When controls are not cost effective, they are not worth implementing. Thus, risk acceptance is the risk response in this situation. Mitigation is the application of a control; that was not done in this scenario. Ignoring risk occurs when no action, not even assessment or control evaluation, is performed in relation to a risk. Since controls were evaluated in this scenario, this is not ignoring risk. Assignment is the transfer of risk to a third party; that was not done in this scenario.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      70,
      41,
      26,
      49
    ],
    "source": ""
  },
  {
    "id": 3353,
    "question": "During the annual review of the company's deployed security infrastructure, you have been reevaluating each security control selection. <br>How is the value of a safeguard to a company calculated?",
    "choice_a": "ALE before safeguard \u2013 ALE after implementing the safeguard \u2013 annual cost of safeguard",
    "choice_b": "ALE before safeguard * ARO of safeguard",
    "choice_c": "ALE after implementing safeguard + annual cost of safeguard \u2013 controls gap",
    "choice_d": "Total risk \u2013 controls gap",
    "correct_answer": "A",
    "explanation": "The value of a safeguard to an organization is calculated by ALE before safeguard \u2013 ALE after implementing the safeguard \u2013 annual cost of safeguard [(ALE1 \u2013 ALE2) \u2013 ACS]. This is known as the cost/benefit equation for safeguards. The other options are incorrect. (B) This is an invalid calculation. (C) This is an invalid calculation. (D) This is the concept formula for residual risk: total risk \u2013 controls gap = residual risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      70,
      935,
      48,
      46,
      1
    ],
    "source": ""
  },
  {
    "id": 3354,
    "question": "Which of the following are valid definitions for risk?  (Select all that apply.)",
    "choice_a": "An assessment of probability, possibility, or chance",
    "choice_b": "Anything that removes a vulnerability or protects against one or more specific threats",
    "choice_c": "Risk = threat * vulnerability",
    "choice_d": "The presence of a vulnerability when a related threat exists",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Statements of A, and C are valid definitions of risk. The other two statements are not definitions of risk. (B) Anything that removes a vulnerability or protects against one or more specific threats is considered a safeguard or a countermeasure, not a risk. (D) The presence of a vulnerability when a related threat exists is an exposure, not a risk. A risk is a calculation of the probability of occurrence and the level of damage that could be caused if an exposure is realized (i.e., actually occurs).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      46,
      26,
      85,
      87
    ],
    "source": ""
  },
  {
    "id": 3355,
    "question": "A new web application was installed onto the company's public web server last week. Over the weekend a malicious hacker was able to exploit the new code and gained access to data files hosted on the system. This is an example of what issue?",
    "choice_a": "Inherent risk",
    "choice_b": "Risk matrix",
    "choice_c": "Qualitative assessment",
    "choice_d": "Residual risk",
    "correct_answer": "A",
    "explanation": "This situation is describing inherent risk. Inherent risk is the level of natural, native, or default risk that exists in an environment, system, or product prior to any risk management efforts being performed. The new application had vulnerabilities that were not mitigated, thus enabling the opportunity for the attack. This is not a risk matrix. A risk matrix or risk heat map is a form of risk assessment that is performed on a basic graph or chart, such as a 3 x 3 grid comparing probability and damage potential. This is not a qualitative risk assessment, since this scenario does not describe any evaluation of the risk of the new code. This is not residual risk, since no controls were implemented to reduce risk. Residual risk is the leftover risk after countermeasures and safeguards are implemented in response to original or total risk.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      42,
      41,
      46,
      70,
      44
    ],
    "source": ""
  },
  {
    "id": 3356,
    "question": "Your organization is courting a new business partner. During the negotiations the other party defines several requirements of your organization's security that must be met prior to the signing of the SLA and business partners agreement (BPA). One of the requirements is that your organization demonstrate their level of achievement on the Risk Maturity Model (RMM). The requirement is specifically that a common or standardized risk framework is adopted organization-wide. <br>Which of the five possible levels of RMM is being required of your organization?",
    "choice_a": "Preliminary",
    "choice_b": "Integrated",
    "choice_c": "Defined",
    "choice_d": "Optimized",
    "correct_answer": "C",
    "explanation": "The level of RMM named Defined requires that a common or standardized risk framework be adopted organization-wide. This is effectively level 3. The first level of RMM is not listed as an option; it is ad hoc, which is the chaotic starting point. Preliminary is RMM level 2, which demonstrates loose attempts to follow risk management processes but each department may perform risk assessment uniquely. Integrated is RMM level 4, where risk management operations are integrated into business processes, metrics are used to gather effectiveness data, and risk is considered an element in business strategy decisions. Optimized is RMM level 5, where risk management focuses on achieving objectives rather than just reacting to external threats, increasing strategic planning toward business success rather than just avoiding incidents, and reintegrating lessons learned into the risk management process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      53,
      72,
      50,
      41,
      14
    ],
    "source": ""
  },
  {
    "id": 3357,
    "question": "The Risk Management Framework (RMF) provides a disciplined, structured, and flexible process for managing security and privacy risk that includes information security categorization; control selection, implementation, and assessment; system and common control authorizations; and continuous monitoring. The RMF has seven steps or phases. <br>Which phase of the RMF focuses on determining whether system or common controls based on a determination that the risk to organizational operations and assets, individuals, other organizations, and the nation are reasonable?",
    "choice_a": "Categorize",
    "choice_b": "Authorize",
    "choice_c": "Assess",
    "choice_d": "Monitor",
    "correct_answer": "B",
    "explanation": "The RMF phase 6 is Authorize whether system or common controls based on a determination that the risk to organizational operations and assets, individuals, other organizations, and the nation is acceptable (or reasonable). The phases of RMF are (1) Prepare, (2) Categorize, (3) Select, (4) Implement, (5) Assess, (6) Authorize, and (7) Monitor. (A) RMF phase (2) is categorize the system and the information processed, stored, and transmitted by the system based on an analysis of the impact of loss. (C) RMF phase (5) is assess the controls to determine if the controls are implemented correctly, operating as intended, and producing the desired outcomes with respect to satisfying the security and privacy requirements. (D) RMF phase (7) is monitor the system and the associated controls on an ongoing basis to include assessing control effectiveness, documenting changes to the system and environment of operation, conducting risk assessments and impact analyses, and reporting the security and privacy posture of the system.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      50,
      54,
      49,
      41,
      53
    ],
    "source": ""
  },
  {
    "id": 3358,
    "question": "Company proprietary data are discovered on a public social media posting by the CEO. While investigating, a significant number of similar emails were discovered to have been sent to employees, which included links to malicious sites. Some employees report that they had received similar messages to their personal email accounts as well. <br>What improvements should the company implement to address this issue?  (Select all that apply.)",
    "choice_a": "Deploy a web application firewall.",
    "choice_b": "Block access to personal email from the company network.",
    "choice_c": "Update the company email server.",
    "choice_d": "Implement multifactor authentication (MFA) on the company email server.",
    "correct_answer": [
      "B",
      "F"
    ],
    "explanation": "The leaking of company proprietary data may have been caused by the content of emails received by workers. The computers of workers who clicked links from the suspicious emails may have been infected by malicious code. This malicious code may have exfiltrated documents to the social media site. This issue could occur whether workers were on company computers on the company network, on company computers on their home network, or on personal computers on their home network (especially if the workers copied company files to their personal machines to work from home). Blocking access to social media sites and personal email services from the company network reduces the risk of this same event occurring again. For example, if the suspicious emails are blocked from being received by company email servers and accounts, they could still be received into personal email accounts. Though not mentioned, blocking access to the malicious URLs would be a good security defense as well. This issue is not addressed by deploying a web application firewall, updating the company email server, using MFA on the email server, or performing an access review of company files. Although all of these options are good security practices in general, they do not relate specifically to this issue.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      57,
      67,
      8,
      20
    ],
    "source": "",
    "choice_e": "Perform an access review of all company files.",
    "choice_f": "Prohibit access to social networks on company equipment."
  },
  {
    "id": 3359,
    "question": "What process or event is typically hosted by an organization and is targeted to groups of employees with similar job functions?",
    "choice_a": "Education",
    "choice_b": "Awareness",
    "choice_c": "Training",
    "choice_d": "Termination",
    "correct_answer": "C",
    "explanation": "Training is teaching employees to perform their work tasks and to comply with the security policy. Training is typically hosted by an organization and is targeted to groups of employees with similar job functions. (A) Education is an endeavor in which students and users learn much more than they actually need to know to perform their work tasks. Education is most often associated with users pursuing certification or seeking job promotion or career advancement. Most education programs are not hosted by the employer but by training organizations or colleges or universities. Education is not provided to workers in groups based on their job positions. (B) Awareness establishes a common baseline or foundation of security understanding across the entire organization and focuses on key or basic topics and issues related to security that all employees must understand. Although it is provided by the organization, it is not targeted to groups of workers since it applies to all employees. (D) Termination is usually targeted at individuals rather than groups of workers with similar job positions. Though large layoff events might fire groups of similar workers, this option is not as accurate as training.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      65,
      67,
      66,
      55,
      71
    ],
    "source": ""
  },
  {
    "id": 3360,
    "question": "Which of the following could be classified as a form of social engineering attack?  (Select all that apply.)",
    "choice_a": "A user logs in to their workstation and then decides to get a soda from the vending machine in the stairwell. As soon as the user walks away from their workstation, another person sits down at their desk and copies all the files from a local folder onto a network share.",
    "choice_b": "You receive an email warning about a dangerous new virus spreading across the internet. The message tells you to look for a specific file on your hard drive and delete it, since it indicates the presence of the virus.",
    "choice_c": "A website claims to offer free temporary access to their products and services but requires that you alter the configuration of your web browser and/or firewall in order to download the access software.",
    "choice_d": "A secretary receives a phone call from a person claiming to be a client who is running late to meet the CEO. The caller asks for the CEO's private cell phone number so that they can call them.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The activity described in option A is an opportunistic unauthorized access attack, which is not a social engineering attack since there was no interaction with the victim, just the opportunity when the victim walked away. The activities described in options B (hoax), C (phishing, hoax, watering hole attack), and D (vishing) are all examples of social engineering attacks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      62,
      58,
      71,
      56,
      55
    ],
    "source": ""
  },
  {
    "id": 3361,
    "question": "Often a _____________ is a member of a group who decides (or is assigned) to take charge of leading the adoption and integration of security concepts into the group's work activities. _____________ are often non-security employees who take up the mantle to encourage others to support and adopt more security practices and behaviors.",
    "choice_a": "CISO(s)",
    "choice_b": "Security champion(s)",
    "choice_c": "Security auditor(s",
    "choice_d": "Custodian(s)",
    "correct_answer": "B",
    "explanation": "The correct answer for these blanks is security champion(s). Often a security champion is a member of a group who decides (or is assigned) to take charge of leading the adoption and integration of security concepts into the group's work activities. Security champions are often non-security employees who take up the mantle to encourage others to support and adopt more security practices and behaviors. The other options are incorrect. A CISO, or chief information security officer, defines and enforces security throughout the organization. The security auditor is the person who manages security logging and reviews the audit trails for signs of compliance or violation. The custodian is the security role that accepts assets from owners and then, based on the owner- assigned classifications, places the asset in the proper IT container where the proper security protections are provided.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      17,
      65,
      40,
      15,
      11
    ],
    "source": ""
  },
  {
    "id": 3362,
    "question": "The CSO has expressed concern that after years of security training and awareness programs, the level of minor security violations has actually increased. A new security team member reviews the training materials and notices that it was crafted four years ago. They suggest that the materials be revised to be more engaging and to include elements that allow for the ability to earn recognition, team up with coworkers, and strive toward a common goal. They claim these efforts will improve security compliance and foster security behavior change. <br>What is the approach that is being recommended?",
    "choice_a": "Program effectiveness evaluation",
    "choice_b": "Onboarding",
    "choice_c": "Compliance enforcement",
    "choice_d": "Gamification",
    "correct_answer": "D",
    "explanation": "Security awareness and training can often be improved through gamification. Gamification is a means to encourage compliance and engagement by integrating common elements of game play into other activities, such as security compliance and behavior change. This can include rewarding compliance behaviors and potentially punishing violating behaviors. Many aspects of game play can be integrated into security training and adoption, such as scoring points, earning achievements or badges (i.e., earn recognition), competing with others, cooperating with others (i.e., team up with coworkers), following a set of common/standard rules, having a defined goal, seeking rewards, developing group stories/experiences, and avoiding pitfalls or negative game events. (A) Program effectiveness evaluation is using some means of verification, such as giving a quiz or monitoring security incident rate changes over time, to measure whether the training is beneficial or a waste of time and resources. This question starts by indicating that security incidents are on the rise, which shows that prior training was ineffective. But the recommendations to change the training are gamification focused. (B) Onboarding is the process of adding new employees to the organization. This is not the concept being described in this scenario. (C) Compliance enforcement is the application of sanctions or consequences for failing to follow policy, training, best practices, and/or regulations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      66,
      67,
      65,
      40,
      71
    ],
    "source": ""
  },
  {
    "id": 3363,
    "question": "James was recently asked by his organization's CIO to lead a core team of four experts through a business continuity planning process for his organization. <br>What is the first step that this core team should undertake?",
    "choice_a": "BCP team selection",
    "choice_b": "Business organization analysis",
    "choice_c": "Resource requirements analysis",
    "choice_d": "Legal and regulatory assessment",
    "correct_answer": "B",
    "explanation": "As the first step of the process, the business organization analysis helps guide the remainder of the work. James and his core team should conduct this analysis and use the results to aid in the selection of team members and the design of the BCP process.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      95,
      76,
      78,
      80,
      83
    ],
    "source": ""
  },
  {
    "id": 3364,
    "question": "Tracy is preparing for her organization's annual business continuity exercise and encounters resistance from some managers who don't see the exercise as important and feel that it is a waste of resources. She has already told the managers that it will only take half a day for their employees to participate. <br>What argument could Tracy make to best address these concerns?",
    "choice_a": "The exercise is required by policy.",
    "choice_b": "The exercise is already scheduled and canceling it would be difficult.",
    "choice_c": "The exercise is crucial to ensuring that the organization is prepared for emergencies.",
    "choice_d": "The exercise will not be very time-consuming.",
    "correct_answer": "C",
    "explanation": "This question requires that you exercise some judgment, as do many questions on the CISSP exam. All of these answers are plausible things that Tracy could bring up, but we're looking for the best answer. In this case, that is ensuring that the organization is ready for an emergency\u2014a mission-critical goal. Telling managers that the exercise is already scheduled or required by policy doesn't address their concerns that it is a waste of time. Telling them that it won't be time-consuming is not likely to be an effective argument because they are already raising concerns about the amount of time requested.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      929,
      928,
      594,
      597,
      596
    ],
    "source": ""
  },
  {
    "id": 3365,
    "question": "The board of directors of Clashmore Circuits conducts an annual review of the business continuity planning process to ensure that adequate measures are in place to minimize the effect of a disaster on the organization's continued viability. <br>What obligation are they satisfying by this review?",
    "choice_a": "Corporate responsibility",
    "choice_b": "Disaster requirement",
    "choice_c": "Due diligence",
    "choice_d": "Going concern responsibility",
    "correct_answer": "C",
    "explanation": "A firm's officers and directors are legally bound to exercise due diligence in conducting their activities. This concept creates a fiduciary responsibility on their part to ensure that adequate business continuity plans are in place. This is an element of corporate responsibility, but that term is vague and not commonly used to describe a board's responsibilities. Disaster requirement and going concern responsibilities are also not risk management terms.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      20,
      79,
      74,
      15,
      91
    ],
    "source": ""
  },
  {
    "id": 3366,
    "question": "Darcy is leading the BCP effort for her organization and is currently in the project scope and planning phase. <br>What should she expect will be the major resource consumed by the BCP process during this phase?",
    "choice_a": "Hardware",
    "choice_b": "Software",
    "choice_c": "Processing time",
    "choice_d": "Personnel",
    "correct_answer": "D",
    "explanation": "During the planning phase, the most significant resource utilization will be the time dedicated by members of the BCP team to the planning process. This represents a significant use of business resources and is another reason that buy-in from senior management is essential.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      76,
      80,
      79,
      78,
      932
    ],
    "source": ""
  },
  {
    "id": 3367,
    "question": "Ryan is assisting with his organization's annual business impact analysis effort. He's been asked to assign quantitative values to assets as part of the priority identification exercise. <br>What unit of measure should he use?",
    "choice_a": "Monetary",
    "choice_b": "Utility",
    "choice_c": "Importance",
    "choice_d": "Time",
    "correct_answer": "A",
    "explanation": "The quantitative portion of the priority identification should assign asset values in monetary units. The organization may also choose to assign other values to assets, but non-monetary measures should be part of a qualitative, rather than a quantitative, assessment.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      43,
      86,
      96,
      45
    ],
    "source": ""
  },
  {
    "id": 3368,
    "question": "Renee is reporting the results of her organization's BIA to senior leaders. They express frustration at all of the detail, and one of them says, \"Look, we just need to know how much we should expect these risks to cost us each year.\" What measure could Renee provide to best answer this question?",
    "choice_a": "ARO",
    "choice_b": "SLE",
    "choice_c": "ALE",
    "choice_d": "EF",
    "correct_answer": "C",
    "explanation": "The annualized loss expectancy (ALE) represents the amount of money a business expects to lose to a given risk each year. This figure is quite useful when performing a quantitative prioritization of business continuity resource allocation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      693,
      694,
      83,
      82
    ],
    "source": ""
  },
  {
    "id": 3369,
    "question": "Jake is conducting a business impact analysis for his organization. As part of the process, he asks leaders from different units to provide input on how long the enterprise resource planning (ERP) system could be unavailable without causing irreparable harm to the organization. <br>What measure is he seeking to determine?",
    "choice_a": "SLE",
    "choice_b": "EF",
    "choice_c": "MTD",
    "choice_d": "ARO",
    "correct_answer": "C",
    "explanation": "The maximum tolerable downtime (MTD) represents the longest period a business function can be unavailable before causing irreparable harm to the business. This figure is useful when determining the level of business continuity resources to assign to a particular function.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      84,
      88,
      83,
      74,
      96
    ],
    "source": ""
  },
  {
    "id": 3370,
    "question": "You are concerned about the risk that an avalanche poses to your $3 million shipping facility. Based on expert opinion, you determine that there is a 5 percent chance that an avalanche will occur each year. Experts advise you that an avalanche would completely destroy your building and require you to rebuild on the same land. Ninety percent of the $3 million value of the facility is attributed to the building, and 10 percent is attributed to the land itself. <br>What is the single loss expectancy (SLE) of your shipping facility to avalanches?",
    "choice_a": "$3 million",
    "choice_b": "$2,700,000",
    "choice_c": "$270,000",
    "choice_d": "$135,000",
    "correct_answer": "B",
    "explanation": "The single loss expectancy (SLE) is the product of the asset value (AV) and the exposure factor (EF). From the scenario, you know that the AV is $3 million and the EF is 90 percent; based on that the same land can be used to rebuild the facility. This yields an SLE of $2,700,000.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      45,
      935,
      43,
      695
    ],
    "source": ""
  },
  {
    "id": 3371,
    "question": "You are concerned about the risk that an avalanche poses to your $3 million shipping facility. Based on expert opinion, you determine that there is a 5 percent chance that an avalanche will occur each year. Experts advise you that an avalanche would completely destroy your building and require you to rebuild on the same land. Ninety percent of the $3 million value of the facility is attributed to the building, and 10 percent is attributed to the land itself. <br>What is the annualized loss expectancy?",
    "choice_a": "$3 million",
    "choice_b": "$2,700,000",
    "choice_c": "$270,000",
    "choice_d": "$135,000",
    "correct_answer": "D",
    "explanation": "This problem requires you to compute the annualized loss expectancy (ALE), which is the product of the single loss expectancy (SLE) and the annualized rate of occurrence (ARO). From the scenario, you know that the ARO is 0.05 (or 5 percent). From question 8, you know that the SLE is $2,700,000. This yields an ALE of $135,000.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      86,
      695,
      935,
      694
    ],
    "source": ""
  },
  {
    "id": 3372,
    "question": "You are concerned about the risk that a hurricane poses to your corporate headquarters in South Florida. The building itself is valued at $15 million. After consulting with the National Weather Service, you determine that there is a 10 percent likelihood that a hurricane will strike over the course of a year. You hired a team of architects and engineers, who determined that the average hurricane would destroy approximately 50 percent of the building. <br>What is the annualized loss expectancy (ALE)?",
    "choice_a": "$750,000",
    "choice_b": "$1.5 million",
    "choice_c": "$7.5 million",
    "choice_d": "$15 million",
    "correct_answer": "A",
    "explanation": "This problem requires you to compute the ALE, which is the product of the SLE and the ARO. From the scenario, you know that the ARO is 0.10 (or 10 percent). From the scenario presented, you know that the SLE is $7.5 million. This yields an ALE of $750,000.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      86,
      70,
      85,
      83
    ],
    "source": ""
  },
  {
    "id": 3373,
    "question": "Chris is completing the risk acceptance documentation for his organization's business continuity plan. <br>Which one of the following items is Chris <italic>least</italic> likely to include in this documentation?",
    "choice_a": "Listing of risks deemed acceptable",
    "choice_b": "Listing of future events that might warrant reconsideration of risk acceptance decisions",
    "choice_c": "Risk mitigation controls put in place to address acceptable risks",
    "choice_d": "Rationale for determining that risks were acceptable",
    "correct_answer": "C",
    "explanation": "Risk mitigation controls to address acceptable risks would not be in the BCP. The risk acceptance documentation should contain a thorough review of the risks facing the organization, including the determination as to which risks should be considered acceptable and unacceptable. For acceptable risks, the documentation should include a rationale for that decision and a list of potential future events that might warrant a reconsideration of that determination. The documentation should include a list of controls used to mitigate unacceptable risks, but it would not include controls used to mitigate acceptable risks, since acceptable risks do not require mitigation.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      46,
      49,
      93,
      41,
      88
    ],
    "source": ""
  },
  {
    "id": 3374,
    "question": "Brian is developing continuity plan provisions and processes for his organization. <br>What resource should he protect as the highest priority in those plans?",
    "choice_a": "Physical plant",
    "choice_b": "Infrastructure",
    "choice_c": "Financial",
    "choice_d": "People",
    "correct_answer": "D",
    "explanation": "The safety of human life must always be the paramount concern in business continuity planning. Be sure that your plan reflects this priority, especially in the written documentation that is disseminated to your organization's employees!",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      93,
      92,
      79,
      88
    ],
    "source": ""
  },
  {
    "id": 3375,
    "question": "Ricky is conducting the quantitative portion of his organization's business impact analysis. <br>Which one of the following concerns is <italic>least</italic> suitable for quantitative measurement during this assessment?",
    "choice_a": "Loss of a plant",
    "choice_b": "Damage to a vehicle",
    "choice_c": "Negative publicity",
    "choice_d": "Power outage",
    "correct_answer": "C",
    "explanation": "It is difficult to put a dollar figure on the business lost because of negative publicity. Therefore, this type of concern is better evaluated through a qualitative analysis. The other items listed here are all more easily quantifiable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      83,
      86,
      87,
      44,
      96
    ],
    "source": ""
  },
  {
    "id": 3376,
    "question": "Lighter than Air Industries expects that it would lose $10 million if a tornado struck its aircraft operations facility. It expects that a tornado might strike the facility once every 100 years. <br>What is the single loss expectancy for this scenario?",
    "choice_a": "0.01",
    "choice_b": "$10 million",
    "choice_c": "$100,000",
    "choice_d": "0.1",
    "correct_answer": "B",
    "explanation": "The single loss expectancy (SLE) is the amount of damage that would be caused by a single occurrence of the risk. In this case, the SLE is $10 million, the expected damage from one tornado. The fact that a tornado occurs only once every 100 years is not reflected in the SLE but would be reflected in the annualized loss expectancy (ALE).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      45,
      695,
      86,
      875,
      935
    ],
    "source": ""
  },
  {
    "id": 3377,
    "question": "Lighter than Air Industries expects that it would lose $10 million if a tornado struck its aircraft operations facility. It expects that a tornado might strike the facility once every 100 years.  <br>What is the annualized loss expectancy?",
    "choice_a": "0.01",
    "choice_b": "$10 million",
    "choice_c": "$100,000",
    "choice_d": "0.1",
    "correct_answer": "C",
    "explanation": "The annualized loss expectancy (ALE) is computed by taking the product of the single loss expectancy (SLE), which was $10 million in this scenario, and the annualized rate of occurrence (ARO), which was 0.01 in this example. These figures yield an ALE of $100,000.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      86,
      694,
      695,
      691,
      85
    ],
    "source": ""
  },
  {
    "id": 3378,
    "question": "In which business continuity planning task would you actually design procedures and mechanisms to mitigate risks deemed unacceptable by the BCP team?",
    "choice_a": "Strategy development",
    "choice_b": "Business impact analysis",
    "choice_c": "Provisions and processes",
    "choice_d": "Resource prioritization",
    "correct_answer": "C",
    "explanation": "In the provisions and processes phase, the BCP team designs the procedures and mechanisms to mitigate risks that were deemed unacceptable during the strategy development phase.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      89,
      74,
      88,
      84,
      87
    ],
    "source": ""
  },
  {
    "id": 3379,
    "question": "Matt is supervising the installation of redundant communications links in response to a finding during his organization's BIA. <br>What type of mitigation provision is Matt overseeing?",
    "choice_a": "Hardening systems",
    "choice_b": "Defining systems",
    "choice_c": "Reducing systems",
    "choice_d": "Alternative systems",
    "correct_answer": "D",
    "explanation": "This is an example of alternative systems. Redundant communications circuits provide backup links that may be used when the primary circuits are unavailable.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      90,
      46,
      95,
      88,
      87
    ],
    "source": ""
  },
  {
    "id": 3380,
    "question": "Helen is working on her organization's resilience plans, and her manager asks her whether the organization has sufficient technical controls in place to recover operations after a disruption. <br>What type of plan would address the technical controls associated with alternate processing facilities, backups, and fault tolerance?",
    "choice_a": "Business continuity plan",
    "choice_b": "Business impact analysis",
    "choice_c": "Disaster recovery plan",
    "choice_d": "Vulnerability assessment",
    "correct_answer": "C",
    "explanation": "Disaster recovery plans pick up where business continuity plans leave off. After a disaster strikes and the business is interrupted, the disaster recovery plan guides response teams in their efforts to quickly restore business operations to normal levels.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      75,
      74,
      88,
      89,
      93
    ],
    "source": ""
  },
  {
    "id": 3381,
    "question": "Darren is concerned about the risk of a serious power outage affecting his organization's data center. He consults the organization's business impact analysis and determines that the ARO of a power outage is 20 percent. He notes that the assessment took place three years ago and no power outage has occurred. <br>What ARO should he use in this year's assessment, assuming that none of the circumstances underlying the analysis have changed?",
    "choice_a": "20 percent",
    "choice_b": "50 percent",
    "choice_c": "75 percent",
    "choice_d": "100 percent",
    "correct_answer": "A",
    "explanation": "The annualized rate of occurrence (ARO) is the likelihood that the risk will materialize in any given year. The fact that a power outage did not occur in any of the past three years doesn't change the probability that one will occur in the upcoming year. Unless other circumstances have changed, the ARO should remain the same.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      691,
      45,
      86,
      70,
      83
    ],
    "source": ""
  },
  {
    "id": 3382,
    "question": "Of the individuals listed, who would provide the best endorsement for a business continuity plan's statement of importance?",
    "choice_a": "Vice president of business operations",
    "choice_b": "Chief information officer",
    "choice_c": "Chief executive officer",
    "choice_d": "Business continuity manager",
    "correct_answer": "C",
    "explanation": "You should strive to have the highest-ranking person possible sign the BCP's statement of importance. Of the choices given, the chief executive officer (CEO) has the highest ranking.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      91,
      933,
      76,
      932,
      74
    ],
    "source": ""
  },
  {
    "id": 3383,
    "question": "Which of the following provides the best protection against the loss of confidentiality for sensitive data?",
    "choice_a": "Data labels",
    "choice_b": "Data classifications",
    "choice_c": "Data handling",
    "choice_d": "Data degaussing methods",
    "correct_answer": "B",
    "explanation": "Data classifications provide strong protection against the loss of confidentiality and are the best choice of the available answers. Data labels and proper data handling are based on first identifying data classifications. Data degaussing methods apply only to magnetic media.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      124,
      128,
      121,
      125
    ],
    "source": ""
  },
  {
    "id": 3384,
    "question": "Administrators regularly back up data on all the servers within your organization. They annotate an archive copy with the server it came from and the date it was created, and transfer it to an unstaffed storage warehouse. Later, they discover that someone leaked sensitive emails sent between executives on the internet. Security personnel discovered some archive tapes are missing, and these tapes probably included the leaked emails. Of the following choices, what would have prevented this loss without sacrificing security?",
    "choice_a": "Mark the media kept off site.",
    "choice_b": "Don't store data off site.",
    "choice_c": "Destroy the backups off site.",
    "choice_d": "Use a secure off-site storage facility.",
    "correct_answer": "D",
    "explanation": "Backup media should be protected with the same level of protection afforded the data it contains, and using a secure offsite storage facility would ensure this. The media should be marked, but that won't protect it if it is stored in an unstaffed warehouse. A copy of backups should be stored offsite to ensure availability if a catastrophe affects the primary location. If copies of data are not stored offsite or offsite backups are destroyed, security is sacrificed by risking availability.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      125,
      122,
      131,
      128
    ],
    "source": ""
  },
  {
    "id": 3385,
    "question": "Administrators have been using tapes to back up servers in your organization. However, the organization is converting to a different backup system, storing backups on disk drives. <br>What is the final stage in the lifecycle of tapes used as backup media?",
    "choice_a": "Degaussing",
    "choice_b": "Destruction",
    "choice_c": "Declassification",
    "choice_d": "Retention",
    "correct_answer": "B",
    "explanation": "Destruction is the final stage in the lifecycle of backup media. Because the backup method is no longer using tapes, they should be destroyed. Degaussing and declassifying the tape is done if you plan to reuse it. Retention implies you plan to keep the media, but retention is not needed at the end of its lifecycle.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      129,
      130,
      125,
      850
    ],
    "source": ""
  },
  {
    "id": 3386,
    "question": "You are updating your organization's data policy, and you want to identify the responsibilities of various roles. <br>Which one of the following data roles is responsible for classifying data?",
    "choice_a": "Controller",
    "choice_b": "Custodian",
    "choice_c": "Owner",
    "choice_d": "User",
    "correct_answer": "C",
    "explanation": "The data owner is the person responsible for classifying data. A data controller decides what data to process and directs the data processor to process the data. A data custodian protects the integrity and security of the data by performing day-to-day maintenance. Users simply access the data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      143,
      138,
      988,
      851,
      123
    ],
    "source": ""
  },
  {
    "id": 3387,
    "question": "You are tasked with updating your organization's data policy, and you need to identify the responsibilities of different roles. <br>Which data role is responsible for implementing the protections defined by the security policy?",
    "choice_a": "Data custodian",
    "choice_b": "Data user",
    "choice_c": "Data processor",
    "choice_d": "Data controller",
    "correct_answer": "A",
    "explanation": "The data custodian is responsible for the tasks of implementing the protections defined by the security policy and senior management. A data controller decides what data to process and how. Data users are not responsible for implementing the security policy protections. A data processor controls the processing of data and only does what the data controller tells them to do with the data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      143,
      989,
      851,
      124
    ],
    "source": ""
  },
  {
    "id": 3388,
    "question": "A company maintains an e-commerce server used to sell digital products via the internet. When a customer makes a purchase, the server stores the following information on the buyer: name, physical address, email address, and credit card data. You're hired as an outside consultant and advise them to change their practices. <br>Which of the following can the company implement to avoid an apparent vulnerability?",
    "choice_a": "Anonymization",
    "choice_b": "Pseudonymization",
    "choice_c": "Move the company location",
    "choice_d": "Collection limitation",
    "correct_answer": "D",
    "explanation": "The company can implement a data collection policy of minimization to minimize the amount of data they collect and store. If they are selling digital products, they don't need the physical address. If they are reselling products to the same customers, they can use tokenization to save tokens that match the credit card data, instead of saving and storing credit card data. Anonymization techniques remove all personal data and make the data unusable for reuse on the website. Pseudonymization replaces data with pseudonyms. Although the process can be reversed, it is not necessary.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      132,
      136,
      137,
      143,
      120
    ],
    "source": ""
  },
  {
    "id": 3389,
    "question": "You are performing an annual review of your company's data policy, and you come across some confusing statements related to security labeling. <br>Which of the following could you insert to describe security labeling accurately?",
    "choice_a": "Security labeling is only required on digital media.",
    "choice_b": "Security labeling identifies the classification of data.",
    "choice_c": "Security labeling is only required for hardware assets.",
    "choice_d": "Security labeling is never used for nonsensitive data.",
    "correct_answer": "B",
    "explanation": "Security labeling identifies the classification of data such as sensitive, secret, and so on. Media holding sensitive data should be labeled. Similarly, systems that hold or process sensitive data should also be marked. Many organizations require the labeling of all systems and media, including those that hold or process nonsensitive data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      128,
      123,
      125,
      124,
      697
    ],
    "source": ""
  },
  {
    "id": 3390,
    "question": "A database file includes personally identifiable information (PII) on several individuals, including Karen C. Park. <br>Which of the following is the <italic>best</italic> identifier for the record on Karen C. Park?",
    "choice_a": "Data controller",
    "choice_b": "Data subject",
    "choice_c": "Data processor",
    "choice_d": "Data owner",
    "correct_answer": "B",
    "explanation": "A data subject is a person who can be identified by an identifier such as a name, identification number, or other PII. All of these answers refer to the General Data Protection Regulation (GDPR). A data owner owns the data and has ultimate responsibility for protecting it. A data controller decides what data to process and how it should be processed. A data processor processes the data for the data controller.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      138,
      989,
      139,
      143,
      704
    ],
    "source": ""
  },
  {
    "id": 3391,
    "question": "Administrators regularly back up all the email servers within your company, and they routinely purge on-site emails older than six months to comply with the organization's security policy. They keep a copy of the backups on-site and send a copy to one of the company warehouses for long-term storage. Later, they discover that someone leaked sensitive emails sent between executives over three years ago. Of the following choices, what policy was ignored and allowed this data breach?",
    "choice_a": "Media destruction",
    "choice_b": "Record retention",
    "choice_c": "Configuration management",
    "choice_d": "Versioning",
    "correct_answer": "B",
    "explanation": "Personnel did not follow the record retention policy for the backups sent to the warehouse. The scenario states that administrators purge onsite emails older than six months to comply with the organization's security policy, but the leak was from emails sent over three years ago. Personnel should follow media destruction policies when the organization no longer needs the media, but the issue here is the data on the tapes. Configuration management ensures that systems are configured correctly using a baseline, but this does not apply to backup media. Versioning applies to applications, not backup tapes.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      850,
      129,
      144,
      138
    ],
    "source": ""
  },
  {
    "id": 3392,
    "question": "An executive is reviewing governance and compliance issues and ensuring the security or data policy addresses them. <br>Which of the following security controls is most likely driven by a legal requirement?",
    "choice_a": "Data remanence",
    "choice_b": "Record destruction",
    "choice_c": "Data user role",
    "choice_d": "Data retention",
    "correct_answer": "D",
    "explanation": "Record retention policies define the amount of time to keep data, and laws or regulations often drive these policies. Data remanence is data remnants on media, and proper data destruction procedures remove data remnants. Laws and regulations do outline requirements for some data roles, but they don't specify requirements for the data user role.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      133,
      850,
      144,
      126,
      138
    ],
    "source": ""
  },
  {
    "id": 3393,
    "question": "Your organization is donating several computers to a local school. Some of these computers include solid-state drives (SSDs). <br>Which of the following choices is the <italic>most</italic> reliable method of destroying data on these SSDs?",
    "choice_a": "Erasing",
    "choice_b": "Degaussing",
    "choice_c": "Deleting",
    "choice_d": "Purging",
    "correct_answer": "D",
    "explanation": "Purging is the most reliable method among the given choices. Purging overwrites the media with random bits multiple times and includes additional steps to ensure that data is removed. It ensures there isn't any data remanence. Erasing or deleting processes rarely remove the data from media but instead mark it for deletion. Solid-state drives (SSDs) do not have magnetic flux, so degaussing an SSD doesn't destroy data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      1026,
      1024,
      130,
      144
    ],
    "source": ""
  },
  {
    "id": 3394,
    "question": "A technician is about to remove disk drives from several computers. His supervisor told him to ensure that the disk drives do <italic>not</italic> hold any sensitive data. <br>Which of the following methods will meet the supervisor's requirements?",
    "choice_a": "Overwriting the disks multiple times",
    "choice_b": "Formatting the disks",
    "choice_c": "Degaussing the disks",
    "choice_d": "Defragmenting the disks",
    "correct_answer": "A",
    "explanation": "Overwriting the disks multiple times will remove all existing data. This is called purging, and purged media can then be used again. Formatting the disks isn't secure because it doesn't typically remove the previously stored data. Degaussing the disks often damages the electronics but doesn't reliably remove the data. Defragmenting a disk optimizes it, but it doesn't remove data.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      129,
      1026,
      130,
      125,
      1024
    ],
    "source": ""
  },
  {
    "id": 3395,
    "question": "The IT department is updating the budget for the following year, and they want to include enough money for a hardware refresh for some older systems. Unfortunately, there is a limited budget. <br>Which of the following should be a top priority?",
    "choice_a": "Systems with an end-of-life (EOL) date that occurs in the following year",
    "choice_b": "Systems used for data loss prevention",
    "choice_c": "Systems used to process sensitive data",
    "choice_d": "Systems with an end-of-support (EOS) date that occurs in the following year",
    "correct_answer": "D",
    "explanation": "Systems with an EOS date that occurs in the following year should be a top priority for replacement. The EOS date is the date that the vendor will stop supporting a product. The EOL date is the date that a vendor stops offering a product for sale, but the vendor continues to support the product until the EOS date. Systems used for data loss prevention or to process sensitive data can remain in service.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      847,
      849,
      877,
      878,
      879
    ],
    "source": ""
  },
  {
    "id": 3396,
    "question": "Developers created an application that routinely processes sensitive data. The data is encrypted and stored in a database. When the application processes the data, it retrieves it from the databases, decrypts it for use, and stores it in memory. <br>Which of the following methods can protect the data in memory after the application uses it?",
    "choice_a": "Encrypt it with asymmetric encryption.",
    "choice_b": "Encrypt it in the database.",
    "choice_c": "Implement data loss prevention.",
    "choice_d": "Purge memory buffers.",
    "correct_answer": "D",
    "explanation": "Purging memory buffers removes all remnants of data after a program has used it. Asymmetric encryption (along with symmetric encryption) protects data in transit. The data is already encrypted and stored in the database. The scenario doesn't indicate that the program modified the data, so there's no need to overwrite the existing data in the database. Data loss prevention methods prevent unauthorized data loss but do not protect data in use.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      130,
      144,
      129,
      124
    ],
    "source": ""
  },
  {
    "id": 3397,
    "question": "Your organization's security policy mandates the use of symmetric encryption for sensitive data stored on servers. <br>Which one of the following guidelines are they implementing?",
    "choice_a": "Protecting data at rest",
    "choice_b": "Protecting data in transit",
    "choice_c": "Protecting data in use",
    "choice_d": "Protecting the data lifecycle",
    "correct_answer": "A",
    "explanation": "Symmetric encryption methods protect data at rest, and data at rest is any data stored on media, such as a server. Data in transit is data transferred between two systems. Data in use is data in memory that is used by an application. Steps are taken to protect data from the time it is created to the time it is destroyed, but this question isn't related to the data lifecycle.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      122,
      144,
      702,
      700,
      706
    ],
    "source": ""
  },
  {
    "id": 3398,
    "question": "An administrator is planning to deploy a database server and wants to ensure it is secure. She reviews a list of baseline security controls and identifies the security controls that apply to this database server. <br>What is this called?",
    "choice_a": "Tokenization",
    "choice_b": "Scoping",
    "choice_c": "Standards selection",
    "choice_d": "Imaging",
    "correct_answer": "B",
    "explanation": "Scoping is a part of the tailoring process and refers to reviewing a list of security controls and selecting the security controls that apply. Tokenization is the use of a token, such as a random string of characters, to replace other data and is unrelated to this question. Note that scoping focuses on the security of the system and tailoring ensures that the selected controls align with the organization's mission. If the database server needs to comply with external entities, it's appropriate to select a standard baseline provided by that entity. Imaging is done to deploy an identical configuration to multiple systems, but this is typically done after identifying security controls.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      698,
      140,
      142,
      138
    ],
    "source": ""
  },
  {
    "id": 3399,
    "question": "An organization is planning to deploy an e-commerce site hosted on a web farm. IT administrators have identified a list of security controls they say will provide the best protection for this project. Management is now reviewing the list and removing any security controls that do not align with the organization's mission. <br>What is this called?",
    "choice_a": "Tailoring",
    "choice_b": "Sanitizing",
    "choice_c": "Asset classification",
    "choice_d": "Minimization",
    "correct_answer": "A",
    "explanation": "Tailoring refers to modifying a list of security controls to align with the organization's mission. The IT administrators identified a list of security controls to protect the web farm during the scoping steps. Sanitization methods (such as clearing, purging, and destroying) help ensure that data cannot be recovered and is unrelated to this question. Asset classification identifies the classification of assets based on the classification of data the assets hold or process. Minimization refers to data collection. Organizations should collect and maintain only the data they need.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      698,
      123,
      138
    ],
    "source": ""
  },
  {
    "id": 3400,
    "question": "An organization is planning to use a cloud provider to store some data. Management wants to ensure that all data-based security policies implemented in the organization's internal network can also be implemented in the cloud. <br>Which of the following will support this goal?",
    "choice_a": "CASB",
    "choice_b": "DLP",
    "choice_c": "DRM",
    "choice_d": "EOL",
    "correct_answer": "A",
    "explanation": "A cloud access security broker (CASB) is software placed logically between users and cloud-based resources, and it can enforce security policies used in an internal network. Data loss prevention (DLP) systems attempt to detect and block data exfiltration. CASB systems typically include DLP capabilities. Digital rights management (DRM) methods attempt to provide copyright protection for copyrighted works. End-of-life (EOL) is generally a marketing term and indicates when a company stops selling a product.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      127,
      134,
      124,
      144
    ],
    "source": ""
  },
  {
    "id": 3401,
    "question": "Management is concerned that users may be inadvertently transmitting sensitive data outside the organization. They want to implement a method to detect and prevent this from happening. <br>Which of the following can detect outgoing, sensitive data based on specific data patterns and is the best choice to meet these requirements?",
    "choice_a": "Antimalware software",
    "choice_b": "Data loss prevention systems",
    "choice_c": "Security information and event management systems",
    "choice_d": "Intrusion prevention systems",
    "correct_answer": "B",
    "explanation": "Network-based data loss prevention (DLP) systems can scan outgoing data and look for specific keywords and/or data patterns. DLP systems can block these outgoing transmissions. Antimalware software detects malware. Security information and event management (SIEM) provides real-time analysis of events occurring on systems throughout an organization but doesn't necessarily scan outgoing traffic. Intrusion prevention systems (IPSs) scan incoming traffic to prevent unauthorized intrusions.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      127,
      124,
      144,
      120,
      128
    ],
    "source": ""
  },
  {
    "id": 3402,
    "question": "A software developer created an application and wants to protect it with DRM technologies. <br>Which of the following is she <italic>most</italic> likely to include?  (Select all that apply.)",
    "choice_a": "Virtual licensing",
    "choice_b": "Persistent online authentication",
    "choice_c": "Automatic expiration",
    "choice_d": "Continuous audit trail",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Persistent online authentication, automatic expiration, and a continuous audit trail are all methods used with digital rights management (DRM) technologies. Virtual licensing isn't a valid term within DRM.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      134,
      144,
      125,
      135,
      129
    ],
    "source": ""
  },
  {
    "id": 3403,
    "question": "Ryan is responsible for managing the cryptographic keys used by his organization. <br>Which of the following statements are correct about how he should select and manage those keys? (Select all that apply.)",
    "choice_a": "Keys should be sufficiently long to protect against future attacks if the data is expected to remain sensitive.",
    "choice_b": "Keys should be chosen using an approach that generates them from a predictable pattern.",
    "choice_c": "Keys should be maintained indefinitely.",
    "choice_d": "Longer keys provide greater levels of security.",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Keys must be long enough to withstand attack for as long as the data is expected to remain sensitive. They should not be generated in a predictable way but, rather, should be randomly generated. Keys should be securely destroyed when they are no longer needed and not indefinitely retained. Longer keys do indeed provide greater security against brute-force attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      152,
      153,
      183,
      193,
      291
    ],
    "source": ""
  },
  {
    "id": 3404,
    "question": "John recently received an email message from Bill. <br>What cryptographic goal would need to be met to convince John that Bill was actually the sender of the message?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Confidentiality",
    "choice_c": "Availability",
    "choice_d": "Integrity",
    "correct_answer": "A",
    "explanation": "Nonrepudiation prevents the sender of a message from later denying that they sent it. Confidentiality protects the contents of encrypted data from unauthorized disclosure. Integrity protects data from unauthorized modification. Availability is not a goal of cryptography.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      164,
      175,
      177,
      186
    ],
    "source": ""
  },
  {
    "id": 3405,
    "question": "You are implementing AES encryption for files that your organization plans to store in a cloud storage service and wish to have the strongest encryption possible. <br>What key length should you choose?",
    "choice_a": "192 bits",
    "choice_b": "256 bits",
    "choice_c": "512 bits",
    "choice_d": "1,024 bits",
    "correct_answer": "B",
    "explanation": "The strongest keys supported by the Advanced Encryption Standard are 256 bits. The valid AES key lengths are 128, 192, and 256 bits.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      160,
      165,
      171,
      163,
      152
    ],
    "source": ""
  },
  {
    "id": 3406,
    "question": "You are creating a security product that must facilitate the exchange of symmetric encryption keys between two parties that have no way to securely exchange keys in person. <br>What algorithm might you use to facilitate the exchange?",
    "choice_a": "Rijndael",
    "choice_b": "Blowfish",
    "choice_c": "Vernam",
    "choice_d": "Diffie\u2013Hellman",
    "correct_answer": "D",
    "explanation": "The Diffie\u2013Hellman algorithm allows the exchange of symmetric encryption keys between two parties over an insecure channel.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      169,
      165,
      153,
      146,
      187
    ],
    "source": ""
  },
  {
    "id": 3407,
    "question": "What occurs when the relationship between the plaintext and the key is complicated enough that an attacker can't merely continue altering the plaintext and analyzing the resulting ciphertext to determine the key? (Select all that apply.)",
    "choice_a": "Confusion",
    "choice_b": "Transposition",
    "choice_c": "Polymorphism",
    "choice_d": "Diffusion",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Confusion and diffusion are two principles underlying most cryptosystems. Confusion occurs when the relationship between the plaintext and the key is so complicated that an attacker can't merely continue altering the plaintext and analyzing the resulting ciphertext to determine the key. Diffusion occurs when a change in the plaintext results in multiple changes spread throughout the ciphertext.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      151,
      149,
      196,
      147,
      164
    ],
    "source": ""
  },
  {
    "id": 3408,
    "question": "Randy is implementing an AES-based cryptosystem for use within his organization. He would like to better understand how he might use this cryptosystem to achieve his goals. <br>Which of the following goals are achievable with AES? (Select all that apply.)",
    "choice_a": "Nonrepudiation",
    "choice_b": "Confidentiality",
    "choice_c": "Authentication",
    "choice_d": "Integrity",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "AES provides confidentiality, integrity, and authentication when implemented properly. Nonrepudiation requires the use of a public key cryptosystem to prevent users from falsely denying that they originated a message and cannot be achieved with a symmetric cryptosystem, such as AES.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      145,
      153,
      154,
      165,
      177
    ],
    "source": ""
  },
  {
    "id": 3409,
    "question": "Brian encountered encrypted data left on one of his systems by attackers who were communicating with one another. He has tried many cryptanalytic techniques and was unable to decrypt the data. He believes that the data may be protected with an unbreakable system. When correctly implemented, what is the only cryptosystem known to be unbreakable?",
    "choice_a": "Transposition cipher",
    "choice_b": "Substitution cipher",
    "choice_c": "Advanced Encryption Standard",
    "choice_d": "One-time pad",
    "correct_answer": "D",
    "explanation": "Assuming that it is used properly, the one-time pad is the only known cryptosystem that is not vulnerable to attacks. All other cryptosystems, including transposition ciphers, substitution ciphers, and even AES, are vulnerable to attack, even if no attack has yet been discovered.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      166,
      149,
      151,
      196
    ],
    "source": ""
  },
  {
    "id": 3410,
    "question": "Helen is planning to use a one-time pad to meet a unique cryptographic requirement in her organization. She is trying to identify the requirements for using this cryptosystem. <br>Which of the following are requirements for the use of a one-time pad?  (Select all that apply.)",
    "choice_a": "The encryption key must be at least one-half the length of the message to be encrypted.",
    "choice_b": "The encryption key must be randomly generated.",
    "choice_c": "Each one-time pad must be used only once.",
    "choice_d": "The one-time pad must be physically protected against disclosure.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "The encryption key must be at least as long as the message to be encrypted. This is because each key element is used to encode only one character of the message. The three other facts listed are all characteristics of one-time pad systems.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      166,
      150,
      152,
      146,
      153
    ],
    "source": ""
  },
  {
    "id": 3411,
    "question": "Brian administers a symmetric cryptosystem used by 20 users, each of whom has the ability to communicate privately with any other user. One of those users lost control of their account and Brian believes that user's keys were compromised. <br>How many keys must he change?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "19",
    "choice_d": "190",
    "correct_answer": "C",
    "explanation": "In a symmetric cryptosystem, a unique key exists for each pair of users. In this case, every key involving the compromised user must be changed, meaning that the key that the user shared with each of the other 19 users must be changed.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      153,
      165,
      152,
      712
    ],
    "source": ""
  },
  {
    "id": 3412,
    "question": "Which one of the following cipher types operates on large pieces of a message rather than individual characters or bits of a message?",
    "choice_a": "Stream cipher",
    "choice_b": "Caesar cipher",
    "choice_c": "Block cipher",
    "choice_d": "ROT3 cipher",
    "correct_answer": "C",
    "explanation": "Block ciphers operate on message \"chunks\" rather than on individual characters or bits. The other ciphers mentioned are all types of stream ciphers that operate on individual bits or characters of a message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      150,
      156,
      159,
      162,
      149
    ],
    "source": ""
  },
  {
    "id": 3413,
    "question": "James is the administrator for his organization's symmetric key cryptographic system. He issues keys to users when the need arises. Mary and Beth recently approached him and presented a need to be able to exchange encrypted files securely. <br>How many keys must James generate?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "A",
    "explanation": "Symmetric key cryptography uses a shared secret key. All communicating parties utilize the same key for communication in any direction. Therefore, James only needs to create a single symmetric key to facilitate this communication.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      161,
      154,
      165,
      152
    ],
    "source": ""
  },
  {
    "id": 3414,
    "question": "Dave is developing a key escrow system that requires multiple people to retrieve a key but does not depend on every participant being present. <br>What type of technique is he using?",
    "choice_a": "Split knowledge",
    "choice_b": "M of N Control",
    "choice_c": "Work function",
    "choice_d": "Zero-knowledge proof",
    "correct_answer": "B",
    "explanation": "M of N Control requires that a minimum number of agents (M) out of the total number of agents (N) work together to perform high-security tasks. M of N Control is an example of a split knowledge technique, but not all split knowledge techniques are used for key escrow.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      712,
      713,
      148,
      161,
      219
    ],
    "source": ""
  },
  {
    "id": 3415,
    "question": "What is used to increase the strength of cryptography by creating a unique ciphertext every time the same message is encrypted with the same key?",
    "choice_a": "Initialization vector",
    "choice_b": "Vigen\u00e8re cipher",
    "choice_c": "Steganography",
    "choice_d": "Stream cipher",
    "correct_answer": "A",
    "explanation": "An initialization vector (IV) is a random bit string (a nonce) that is the same length as the block size that is XORed with the message. IVs are used to create a unique ciphertext every time the same message is encrypted with the same key. Vigen\u00e8re ciphers are an example of a substitution cipher technique. Steganography is a technique used to embed hidden messages within a binary file. Stream ciphers are used to encrypt continuous streams of data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      147,
      156,
      150,
      151,
      149
    ],
    "source": ""
  },
  {
    "id": 3416,
    "question": "Tammy is choosing a mode of operation for a symmetric cryptosystem that she will be using in her organization. She wants to choose a mode that is capable of providing both confidentiality and data authenticity. <br>What mode would best meet her needs?",
    "choice_a": "ECB",
    "choice_b": "GCM",
    "choice_c": "OFB",
    "choice_d": "CTR",
    "correct_answer": "B",
    "explanation": "Galois/Counter Mode (GCM) and Counter with Cipher Block Chaining Message Authentication Code mode (CCM) are the only two modes that provide both confidentiality and data authenticity. Other modes, including Electronic Code Book (ECB), Output Feedback (OFB), and Counter (CTR) modes, only provide confidentiality.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      165,
      164,
      145,
      177
    ],
    "source": ""
  },
  {
    "id": 3417,
    "question": "Julie is designing a highly secure system and is concerned about the storage of unencrypted data in RAM. <br>What use case is she considering?",
    "choice_a": "Data in motion",
    "choice_b": "Data at rest",
    "choice_c": "Data in destruction",
    "choice_d": "Data in use",
    "correct_answer": "D",
    "explanation": "Data that is stored in memory is being actively used by a system and is considered data in use. Data at rest is data that is stored on nonvolatile media, such as a disk. Data in motion is being actively transferred over a network.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      239,
      244,
      297,
      185,
      291
    ],
    "source": ""
  },
  {
    "id": 3418,
    "question": "Renee conducted an inventory of encryption algorithms used in her organization and found that they are using all of the algorithms below. <br>Which of these algorithms should be discontinued?  (Select all that apply.)",
    "choice_a": "AES",
    "choice_b": "DES",
    "choice_c": "3DES",
    "choice_d": "RC6",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The Advanced Encryption Standard (AES) and Rivest Cipher 6 (RC6) are modern, secure algorithms. The Data Encryption Standard (DES) and Triple DES (3DES) are outdated and no longer considered secure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      157,
      158,
      160,
      159,
      152
    ],
    "source": ""
  },
  {
    "id": 3419,
    "question": "Which one of the following encryption algorithm modes suffers from the undesirable characteristic of errors propagating between blocks?",
    "choice_a": "Electronic Code Book",
    "choice_b": "Cipher Block Chaining",
    "choice_c": "Output Feedback",
    "choice_d": "Counter",
    "correct_answer": "B",
    "explanation": "One important consideration when using CBC mode is that errors propagate\u2014if one block is corrupted during transmission, it becomes impossible to decrypt that block and the next block as well. The other modes listed here do not suffer from this flaw.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      156,
      165,
      157,
      150,
      147
    ],
    "source": ""
  },
  {
    "id": 3420,
    "question": "Which one of the following key distribution methods is most cumbersome when users are located in different geographic locations?",
    "choice_a": "Diffie\u2013Hellman",
    "choice_b": "Public key encryption",
    "choice_c": "Offline",
    "choice_d": "Escrow",
    "correct_answer": "C",
    "explanation": "Offline key distribution requires a side channel of trusted communication, such as in-person contact. This can be difficult to arrange when users are geographically separated. Alternatively, the individuals could use the Diffie\u2013Hellman algorithm or other asymmetric/public key encryption technique to exchange a secret key. Key escrow is a method for managing the recovery of lost keys and is not used for key distribution.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      161,
      169,
      167,
      184,
      153
    ],
    "source": ""
  },
  {
    "id": 3421,
    "question": "Victoria is choosing an encryption algorithm for use within her organization and would like to choose the most secure symmetric algorithm from a list of those supported by the software package she intends to use. If the package supports the following algorithms, which would be the best option?",
    "choice_a": "AES-256",
    "choice_b": "3DES",
    "choice_c": "RC4",
    "choice_d": "Skipjack",
    "correct_answer": "A",
    "explanation": "The AES-256 algorithm is a modern, secure cryptographic algorithm. 3DES, RC4, and Skipjack are all outdated algorithms that suffer from significant security issues.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      159,
      165,
      163,
      171,
      152
    ],
    "source": ""
  },
  {
    "id": 3422,
    "question": "The Jones Institute has six employees and uses a symmetric key encryption system to ensure confidentiality of communications. If each employee needs to communicate privately with every other employee, how many keys are necessary?",
    "choice_a": "1",
    "choice_b": "6",
    "choice_c": "15",
    "choice_d": "30",
    "correct_answer": "C",
    "explanation": "A separate key is required for each pair of users who want to communicate privately. In a group of six users, this would require a total of 15 secret keys. You can calculate this value by using the formula (n * (n \u2013 1) / 2). In this case, n = 6, resulting in (6 * 5) / 2 = 15 keys.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      153,
      161,
      165,
      152,
      145
    ],
    "source": ""
  },
  {
    "id": 3423,
    "question": "Brian computes the digest of a single sentence of text using a SHA-2 hash function. He then changes a single character of the sentence and computes the hash value again. <br>Which one of the following statements is true about the new hash value?",
    "choice_a": "The new hash value will be one character different from the old hash value.",
    "choice_b": "The new hash value will share at least 50 percent of the characters of the old hash value.",
    "choice_c": "The new hash value will be unchanged.",
    "choice_d": "The new hash value will be completely different from the old hash value.",
    "correct_answer": "D",
    "explanation": "Any change, no matter how minor, to a message will result in a completely different hash value. There is no relationship between the significance of the change in the message and  the significance of the change in the hash value.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      967,
      172,
      155,
      968,
      199
    ],
    "source": ""
  },
  {
    "id": 3424,
    "question": "Alan believes that an attacker is collecting information about the electricity consumption of a sensitive cryptographic device and using that information to compromise encrypted data. <br>What type of attack does he suspect is taking place?",
    "choice_a": "Brute force",
    "choice_b": "Side channel",
    "choice_c": "Known plaintext",
    "choice_d": "Frequency analysis",
    "correct_answer": "B",
    "explanation": "Side-channel attacks use information gathered about a system's use of resources, timing, or other characteristics to contribute to breaking the security of encryption. Brute-force attacks seek to exhaust all possible encryption keys. Known plaintext attacks require access to both plaintext and its corresponding ciphertext. Frequency analysis attacks require access to ciphertext.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      195,
      995,
      193,
      197,
      199
    ],
    "source": ""
  },
  {
    "id": 3425,
    "question": "If Richard wants to send a confidential encrypted message to Sue using a public key cryptosystem, which key does he use to encrypt the message?",
    "choice_a": "Richard's public key",
    "choice_b": "Richard's private key",
    "choice_c": "Sue's public key",
    "choice_d": "Sue's private key",
    "correct_answer": "C",
    "explanation": "Richard must encrypt the message using Sue's public key so that Sue can decrypt it using her private key. If he encrypted the message with his own public key, the recipient would need to know Richard's private key to decrypt the message. If he encrypted it with his own private key, any user could decrypt the message using Richard's freely available public key. Richard could not encrypt the message using Sue's private key because he does not have access to it. If he did, any user could decrypt it using Sue's freely available public key.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      176,
      198,
      200,
      167,
      154
    ],
    "source": ""
  },
  {
    "id": 3426,
    "question": "If a 2,048-bit plaintext message were encrypted with the ElGamal public key cryptosystem, how long would the resulting ciphertext message be?",
    "choice_a": "1,024 bits",
    "choice_b": "2,048 bits",
    "choice_c": "4,096 bits",
    "choice_d": "8,192 bits",
    "correct_answer": "C",
    "explanation": "The major disadvantage of the ElGamal cryptosystem is that it doubles the length of any message it encrypts. Therefore, a 2,048-bit plaintext message would yield a 4,096-bit ciphertext message when ElGamal is used for the encryption process.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      198,
      152,
      146,
      160
    ],
    "source": ""
  },
  {
    "id": 3427,
    "question": "Acme Widgets currently uses a 3,072-bit RSA encryption standard companywide. The company plans to convert from RSA to an elliptic curve cryptosystem. If the company wants to maintain the same cryptographic strength, what ECC key length should it use?",
    "choice_a": "256 bits",
    "choice_b": "512 bits",
    "choice_c": "1,024 bits",
    "choice_d": "2,048 bits",
    "correct_answer": "A",
    "explanation": "The elliptic curve cryptosystem requires significantly shorter keys to achieve encryption that would be the same strength as encryption achieved with the RSA encryption algorithm. A 3,072-bit RSA key is cryptographically equivalent to a 256-bit elliptic curve cryptosystem key.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      168,
      171,
      152,
      163,
      146
    ],
    "source": ""
  },
  {
    "id": 3428,
    "question": "John wants to produce a message digest of a 2,048-byte message he plans to send to Mary. If he uses the SHA-2 hashing algorithm, what is a possible size for the message digest generated?",
    "choice_a": "160 bits",
    "choice_b": "512 bits",
    "choice_c": "1,024 bits",
    "choice_d": "2,048 bits",
    "correct_answer": "B",
    "explanation": "The SHA-2 hashing algorithm comes in four variants. SHA-224 produces 224-bit digests. SHA-256 produces 256-bit digests. SHA-384 produces 384-bit digests, and SHA-512 produces 512-bit digests. Of the options presented here, only 512 bits is a valid SHA-2 hash length.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      173,
      968,
      155,
      172,
      199
    ],
    "source": ""
  },
  {
    "id": 3429,
    "question": "After conducting a survey of encryption technologies used in her organization, Melissa suspects that some may be out of date and pose security risks. <br>Which one of the following technologies is considered flawed and should no longer be used?",
    "choice_a": "SHA-3",
    "choice_b": "TLS 1.2",
    "choice_c": "IPsec",
    "choice_d": "SSL 3.0",
    "correct_answer": "D",
    "explanation": "The Secure Sockets Layer (SSL) protocol is deprecated and no longer considered secure. It should never be used. The Secure Hash Algorithm 3 (SHA-3), Transport Layer Security (TLS) 1.2, and IPsec are all modern, secure protocols and standards.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      187,
      173,
      157,
      152,
      184
    ],
    "source": ""
  },
  {
    "id": 3430,
    "question": "You are developing an application that compares passwords to those stored in a Unix password file. The hash values you compute are not correctly matching those in the file. <br>What might have been added to the stored password hashes?",
    "choice_a": "Salt",
    "choice_b": "Double hash",
    "choice_c": "Added encryption",
    "choice_d": "One-time pad",
    "correct_answer": "A",
    "explanation": "Cryptographic salt values are added to the passwords in password files before hashing to defeat rainbow table and dictionary attacks. Double hashing does not provide any added security. Adding encryption to the passwords is challenging, because then the operating system must possess the decryption key. A one-time pad is only appropriate for use in human-to-human communications and would not be practical here.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      199,
      193,
      172,
      994,
      150
    ],
    "source": ""
  },
  {
    "id": 3431,
    "question": "Richard received an encrypted message sent to him from Sue. Sue encrypted the message using the RSA encryption algorithm. <br>Which key should Richard use to decrypt the message?",
    "choice_a": "Richard's public key",
    "choice_b": "Richard's private key",
    "choice_c": "Sue's public key",
    "choice_d": "Sue's private key",
    "correct_answer": "B",
    "explanation": "Sue would have encrypted the message using Richard's public key. Therefore, Richard needs to use the complementary key in the key pair, his private key, to decrypt the message.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      176,
      200,
      198,
      167,
      168
    ],
    "source": ""
  },
  {
    "id": 3432,
    "question": "Richard wants to digitally sign a message he's sending to Sue so that Sue can be sure the message came from him without modification while in transit. <br>Which key should he use to encrypt the message digest?",
    "choice_a": "Richard's public key",
    "choice_b": "Richard's private key",
    "choice_c": "Sue's public key",
    "choice_d": "Sue's private key",
    "correct_answer": "B",
    "explanation": "Richard should encrypt the message digest with his own private key. When Sue receives the message, she will decrypt the digest with Richard's public key and then compute the digest herself. If the two digests match, she can be assured that the message truly originated from Richard.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      175,
      176,
      198,
      177,
      154
    ],
    "source": ""
  },
  {
    "id": 3433,
    "question": "Which one of the following algorithms is not supported by the Digital Signature Standard under FIPS 186-4?",
    "choice_a": "Digital Signature Algorithm",
    "choice_b": "RSA",
    "choice_c": "ElGamal DSA",
    "choice_d": "Elliptic Curve DSA",
    "correct_answer": "C",
    "explanation": "The Digital Signature Standard allows federal government use of the Digital Signature Algorithm, RSA, or the Elliptic Curve DSA in conjunction with the SHA-1 hashing function to produce secure digital signatures.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      178,
      173,
      168,
      175,
      198
    ],
    "source": ""
  },
  {
    "id": 3434,
    "question": "Which International Telecommunications Union (ITU) standard governs the creation and endorsement of digital certificates for secure electronic communication?",
    "choice_a": "X.500",
    "choice_b": "X.509",
    "choice_c": "X.900",
    "choice_d": "X.905",
    "correct_answer": "B",
    "explanation": "X.509 governs digital certificates and the public key infrastructure (PKI). It defines the appropriate content for a digital certificate and the processes used by certificate authorities to generate and revoke certificates.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      179,
      180,
      181,
      198,
      187
    ],
    "source": ""
  },
  {
    "id": 3435,
    "question": "Ron believes that an attacker accessed a highly secure system in his data center and applied high-voltage electricity to it in an effort to compromise the cryptographic keys that it uses. <br>What type of attack does he suspect?",
    "choice_a": "Implementation attack",
    "choice_b": "Fault injection",
    "choice_c": "Timing",
    "choice_d": "Chosen ciphertext",
    "correct_answer": "B",
    "explanation": "Fault injection attacks compromise the integrity of a cryptographic device by causing some type of external fault, such as the application of high-voltage electricity. Implementation attacks rely on flaws in the cryptographic algorithm. Timing attacks measure the length of time consumed by encryption operations. Chosen ciphertext attacks require access to the algorithm and work by having the attacker perform encryption that results in an expected ciphertext.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      194,
      995,
      196,
      152,
      291
    ],
    "source": ""
  },
  {
    "id": 3436,
    "question": "Brandon is analyzing network traffic and is searching for user attempts to access websites over secure TLS connections. <br>What TCP port should Brandon add to his search filter because it would normally be used by this traffic?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "443",
    "choice_d": "1443",
    "correct_answer": "C",
    "explanation": "HTTPS uses TCP port 443 for encrypted client/server communications over TLS. Port 22 is used by the secure shell (SSH) protocol. Port 80 is used by the unencrypted HTTP protocol. Port 1433 is used for Microsoft SQL Server database connections.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      187,
      179,
      180,
      184,
      189
    ],
    "source": ""
  },
  {
    "id": 3437,
    "question": "Beth is assessing the vulnerability of a cryptographic system to attack. She believes that the cryptographic keys are properly secured and that the system is using a modern, secure algorithm. <br>Which one of the following attacks would most likely still be possible against the system by an external attacker who did not participate in the system and did not have physical access to the facility?",
    "choice_a": "Ciphertext only",
    "choice_b": "Known plaintext",
    "choice_c": "Chosen plaintext",
    "choice_d": "Fault injection",
    "correct_answer": "A",
    "explanation": "An attacker without any special access to the system would only be able to perform ciphertext-only attacks. Known plaintext and chosen plaintext attacks require the ability to encrypt data. Fault injection attacks require physical access to the facility.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      196,
      194,
      195,
      146,
      152
    ],
    "source": ""
  },
  {
    "id": 3438,
    "question": "Which of the following tools can be used to improve the effectiveness of a brute-force password cracking attack?",
    "choice_a": "Rainbow tables",
    "choice_b": "Hierarchical screening",
    "choice_c": "TKIP",
    "choice_d": "Random enhancement",
    "correct_answer": "A",
    "explanation": "Rainbow tables contain precomputed hash values for commonly used passwords and may be used to increase the efficiency of password-cracking attacks.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      994,
      199,
      155,
      172
    ],
    "source": ""
  },
  {
    "id": 3439,
    "question": "Chris is searching a Windows system for binary key files and wishes to narrow his search using file extensions. <br>Which one of the following certificate formats is closely associated with Windows binary certificate files?",
    "choice_a": "CCM",
    "choice_b": "PEM",
    "choice_c": "PFX",
    "choice_d": "P7B",
    "correct_answer": "C",
    "explanation": "The PFX format is most closely associated with Windows systems that store certificates in binary format, whereas the P7B format is used for Windows systems storing files in text format. The PEM format is another text format, and the CCM format does not exist.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      182,
      179,
      180,
      198,
      175
    ],
    "source": ""
  },
  {
    "id": 3440,
    "question": "What is the major disadvantage of using certificate revocation lists?",
    "choice_a": "Key management",
    "choice_b": "Latency",
    "choice_c": "Record keeping",
    "choice_d": "Vulnerability to brute-force attacks",
    "correct_answer": "B",
    "explanation": "Certificate revocation lists (CRLs) introduce an inherent latency to the certificate expiration process due to the time lag between CRL distributions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      938,
      939,
      181,
      937,
      722
    ],
    "source": ""
  },
  {
    "id": 3441,
    "question": "Which one of the following encryption algorithms is now considered insecure?",
    "choice_a": "ElGamal",
    "choice_b": "RSA",
    "choice_c": "Elliptic Curve Cryptography",
    "choice_d": "Merkle\u2013Hellman Knapsack",
    "correct_answer": "D",
    "explanation": "The Merkle\u2013Hellman Knapsack algorithm, which relies on the difficulty of factoring super-increasing sets, has been broken by cryptanalysts.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      159,
      157,
      158,
      160,
      146
    ],
    "source": ""
  },
  {
    "id": 3442,
    "question": "Brian is upgrading a system to support SSH2 rather than SSH1. <br>Which one of the following advantages will he achieve?",
    "choice_a": "Support for multifactor authentication",
    "choice_b": "Support for simultaneous sessions",
    "choice_c": "Support for 3DES encryption",
    "choice_d": "Support for IDEA encryption",
    "correct_answer": "B",
    "explanation": "SSH2 adds support for simultaneous shell sessions over a single SSH connection. Both SSH1 and SSH2 are capable of supporting multifactor authentication. SSH2 actually drops support for the IDEA algorithm, whereas both SSH1 and SSH2 support 3DES.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      190,
      153,
      152,
      187,
      184
    ],
    "source": ""
  },
  {
    "id": 3443,
    "question": "You have been working on crafting a new expansion service to link to the existing computing hardware of a core business function. However, after weeks of research and experimentation, you are unable to get the systems to communicate. The CTO informs you that the computing hardware you are focusing on is a closed system. <br>What is a closed system?",
    "choice_a": "A system designed around final, or closed, standards",
    "choice_b": "A system that includes industry standards",
    "choice_c": "A proprietary system that uses unpublished protocols",
    "choice_d": "Any machine that does not run Windows",
    "correct_answer": "C",
    "explanation": "A closed system is one that uses largely proprietary or unpublished protocols and standards. Options A and D do not describe any particular systems, and option B describes an open system.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      202,
      203,
      229,
      215,
      213
    ],
    "source": ""
  },
  {
    "id": 3444,
    "question": "A compromise of a newly installed Wi-Fi connected baby monitor enabled a hacker to virtually invade a home and play scary sounds to a startled toddler. <br>How was the attacker able to gain access to the baby monitor in this situation?",
    "choice_a": "Outdated malware scanners",
    "choice_b": "A WAP supporting 5 GHz channels",
    "choice_c": "Performing a social engineering attack against the parents",
    "choice_d": "Exploiting default configuration",
    "correct_answer": "D",
    "explanation": "The most likely reason the attacker was able to gain access to the baby monitor was through exploitation of default configuration. Since there is no mention of the exact means used by the attacker in the question, and there is no discussion of any actions of installation, configuration, or security implementation, the only remaining option is to consider the defaults of the device. This is an unfortunately common issue with any device, but especially with IoT equipment connected to Wi-Fi networks. Unless malware was used in the attack, a malware scanner would not be relevant to this situation. This scenario did not mention malware. This type of attack is possible over any network type and all Wi-Fi frequency options. This scenario did not discuss frequencies or network types. There was no mention of any interaction with the parents, which was not required with a device using its default configuration.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      940,
      941,
      258,
      211,
      263
    ],
    "source": ""
  },
  {
    "id": 3445,
    "question": "While working against a deadline, you are frantically trying to finish a report on the current state of security of the organization. You are pulling records and data items from over a dozen sources, including a locally hosted database, several documents, a few spreadsheets, and numerous web pages from an internal server. However, as you start to open another file from your hard drive, the system crashes and displays the Windows Blue Screen of Death. This event is formally known as a stop error and is an example of a(n) _______ approach to software failure.",
    "choice_a": "Fail-open",
    "choice_b": "Fail-secure",
    "choice_c": "Limit check",
    "choice_d": "Object-oriented",
    "correct_answer": "B",
    "explanation": "The Blue Screen of Death (BSoD) stops all processing when a critical failure occurs in Windows. This is an example of a fail-secure approach. The BSoD is not an example of a fail-open approach; a fail-open event would have required the system to continue to operate in spite of the error. A fail-open result would have protected availability, but typically by sacrificing confidentiality and integrity protections. This is not an example of a limit check, which is the verification that input is within a preset range or domain. Object-oriented is a type of programming approach, not a means of handling software failure.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      205,
      228,
      211,
      213,
      940
    ],
    "source": ""
  },
  {
    "id": 3446,
    "question": "As a software designer, you want to limit the actions of the program you are developing. You have considered using bounds and isolation but are not sure they perform the functions you need. Then you realize that the limitation you want can be achieved using confinement. <br>Which best describes a confined or constrained process?",
    "choice_a": "A process that can run only for a limited time",
    "choice_b": "A process that can run only during certain times of the day",
    "choice_c": "A process that can access only certain memory locations",
    "choice_d": "A process that controls access to an object",
    "correct_answer": "C",
    "explanation": "A constrained process is one that can access only certain memory locations. Allowing a process to run for a limited time is a time limit or timeout restriction, not a confinement. Allowing a process to run only during certain times of the day is a scheduling limit, not a confinement. A process that controls access to an object is authorization, not confinement.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      212,
      290,
      213,
      245,
      289
    ],
    "source": ""
  },
  {
    "id": 3447,
    "question": "When a trusted subject violates the star property of Bell\u2013LaPadula in order to write an object into a lower level, what valid operation could be taking place?",
    "choice_a": "Perturbation",
    "choice_b": "Noninterference",
    "choice_c": "Aggregation",
    "choice_d": "Declassification",
    "correct_answer": "D",
    "explanation": "Declassification is the process of moving an object into a lower level of classification once it is determined that it no longer justifies being placed at a higher level. Only a trusted subject can perform declassification because this action is a violation of the verbiage of the star property of Bell\u2013LaPadula, but not the spirit or intent, which is to prevent unauthorized disclosure. Perturbation is the use of false or misleading data in a database management system in order to redirect or thwart information confidentiality attacks. Noninterference is the concept of limiting the actions of a subject at a higher security level so that they do not affect the system state or the actions of a subject at a lower security level. If noninterference was being enforced, the writing of a file to a lower level would be prohibited, not allowed and supported. Aggregation is the act of collecting multiple pieces of nonsensitive or low-value information and combining it or aggregating it to learn sensitive or high-value information.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      228,
      215,
      201,
      216
    ],
    "source": ""
  },
  {
    "id": 3448,
    "question": "What security method, mechanism, or model reveals a capabilities list of a subject across multiple objects?",
    "choice_a": "Separation of duties",
    "choice_b": "Access control matrix",
    "choice_c": "Biba",
    "choice_d": "Clark\u2013Wilson",
    "correct_answer": "B",
    "explanation": "An access control matrix assembles ACLs from multiple objects into a single table. The rows of that table are the ACEs of a subject across those objects, thus a capabilities list. Separation of duties is the division of administrative tasks into compartments or silos; it is effectively the application of the principle of least privilege to administrators. Biba is a security model that focuses on integrity protection across security levels. Clark\u2013Wilson is a security model that protects integrity using an access control triplet.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      214,
      228,
      217,
      229
    ],
    "source": ""
  },
  {
    "id": 3449,
    "question": "What security model has a feature that in theory has one name or label but, when implemented into a solution, takes on the name or label of the security kernel?",
    "choice_a": "Graham\u2013Denning model",
    "choice_b": "Harrison\u2013Ruzzo\u2013Ullman (HRU) model",
    "choice_c": "Trusted computing base",
    "choice_d": "Brewer and Nash model",
    "correct_answer": "C",
    "explanation": "The trusted computing base (TCB) has a component known as the reference monitor in theory, which becomes the security kernel in implementation. The other options do not have this feature. The Graham\u2013Denning model is focused on the secure creation and deletion of both subjects and objects. The Harrison\u2013Ruzzo\u2013Ullman (HRU) model focuses on the assignment of object access rights to subjects as well as the integrity (or resilience) of those assigned rights. The Brewer and Nash model was created to permit access controls to change dynamically based on a user's previous activity.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      228,
      219,
      217,
      216
    ],
    "source": ""
  },
  {
    "id": 3450,
    "question": "The Clark\u2013Wilson model uses a multifaceted approach to enforcing data integrity. Instead of defining a formal state machine, the Clark\u2013Wilson model defines each data item and allowable data transformations. <br>Which of the following is not part of the access control relationship of the Clark\u2013Wilson model?",
    "choice_a": "Object",
    "choice_b": "Interface",
    "choice_c": "Input sanitization",
    "choice_d": "Subject",
    "correct_answer": "C",
    "explanation": "The three parts of the Clark\u2013Wilson model's access control relationship (aka access triple) are subject, object, and program (or interface). Input sanitization is not an element of the Clark\u2013Wilson model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      219,
      217,
      201,
      215,
      216
    ],
    "source": ""
  },
  {
    "id": 3451,
    "question": "While researching security models to base your new computer design around, you discover the concept of the TCB. <br>What is a trusted computing base (TCB)?",
    "choice_a": "Hosts on your network that support secure transmissions",
    "choice_b": "The operating system kernel, other OS components, and device drivers",
    "choice_c": "The combination of hardware, software, and controls that work together to enforce a security policy",
    "choice_d": "The predetermined set or domain (i.e., a list) of objects that a subject can access",
    "correct_answer": "C",
    "explanation": "The TCB is the combination of hardware, software, and controls that work together to enforce a security policy. The other options are incorrect. Hosts on a network that support secure transmissions may be able to support VPN connections, use TLS encryption, or implement some other form of data-in-transit protection mechanism. The operating system kernel, other OS components, and device drivers are located in Rings 0\u20132 of the protection rings concept, or in the Kernel Mode ring in the variation used by Microsoft Windows. The predetermined set or domain (i.e., a list) of objects that a subject can access is the Goguen\u2013Meseguer model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      228,
      229,
      213,
      291
    ],
    "source": ""
  },
  {
    "id": 3452,
    "question": "What is a security perimeter?  (Select all that apply.)",
    "choice_a": "The boundary of the physically secure area surrounding your system",
    "choice_b": "The imaginary boundary that separates the TCB from the rest of the system",
    "choice_c": "The network where your firewall resides",
    "choice_d": "Any connections to your computer system",
    "correct_answer": [
      "A",
      "B"
    ],
    "explanation": "Although the most correct answer in the context of this chapter is option B, the imaginary boundary that separates the TCB from the rest of the system, option A, the boundary of the physically secure area surrounding your system, is also a correct answer in the context of physical security. The network where your firewall resides is not a unique concept or term, since a firewall can exist in any network as either a hardware device or a software service. A border firewall could be considered a security perimeter protection device, but that was not a provided option. Any connections to your computer system are just pathways of communication to a system's interface\u2014they are not labeled as a security perimeter.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      228,
      324,
      208,
      263
    ],
    "source": ""
  },
  {
    "id": 3453,
    "question": "The trusted computing base (TCB) is a combination of hardware, software, and controls that work together to form a trusted base to enforce your security policy. <br>What part of the TCB concept validates access to every resource prior to granting the requested access?",
    "choice_a": "TCB partition",
    "choice_b": "Trusted library",
    "choice_c": "Reference monitor",
    "choice_d": "Security kernel",
    "correct_answer": "C",
    "explanation": "The reference monitor validates access to every resource prior to granting the requested access. The other options are incorrect. Option D, the security kernel, is the collection of TCB components that work together to implement the reference monitor functions. In other words, the security kernel is the implementation of the reference monitor concept. Option A, a TCB partition, and option B, a trusted library, are not valid TCB concept components.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      215,
      229,
      228,
      201,
      218
    ],
    "source": ""
  },
  {
    "id": 3454,
    "question": "A security model provides a way for designers to map abstract statements into a solution that prescribes the algorithms and data structures necessary to build hardware and software. Thus, a security model gives software designers something against which to measure their design and implementation. <br>Which of the following is the best definition of a security model?",
    "choice_a": "A security model states policies an organization must follow.",
    "choice_b": "A security model provides a framework to implement a security policy.",
    "choice_c": "A security model is a technical evaluation of each part of a computer system to assess its concordance with security standards.",
    "choice_d": "A security model is used to host one or more operating systems within the memory of a single host computer or to run applications that are not compatible with the host OS.",
    "correct_answer": "B",
    "explanation": "Option B is the only option that correctly defines a security model. The other options are incorrect. Option A is a definition of a security policy. Option C is a formal evaluation of the security of a system. Option D is the definition of virtualization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      228,
      215,
      292,
      211,
      223
    ],
    "source": ""
  },
  {
    "id": 3455,
    "question": "The state machine model describes a system that is always secure no matter what state it is in. A secure state machine model system always boots into a secure state, maintains a secure state across all transitions, and allows subjects to access resources only in a secure manner compliant with the security policy. <br>Which security models are built on a state machine model?",
    "choice_a": "Bell\u2013LaPadula and take-grant",
    "choice_b": "Biba and Clark\u2013Wilson",
    "choice_c": "Clark\u2013Wilson and Bell\u2013LaPadula",
    "choice_d": "Bell\u2013LaPadula and Biba",
    "correct_answer": "D",
    "explanation": "The Bell\u2013LaPadula and Biba models are built on the state machine model. Take-Grant and Clark\u2013Wilson are not directly based or built on the state machine model.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      228,
      216,
      218,
      220
    ],
    "source": ""
  },
  {
    "id": 3456,
    "question": "You are tasked with designing the core security concept for a new government computing system. The details of its use are classified, but it will need to protect confidentiality across multiple classification levels. <br>Which security model addresses data confidentiality in this context?",
    "choice_a": "Bell\u2013LaPadula",
    "choice_b": "Biba",
    "choice_c": "Clark\u2013Wilson",
    "choice_d": "Brewer and Nash",
    "correct_answer": "A",
    "explanation": "Only the Bell\u2013LaPadula model addresses data confidentiality. The Biba and Clark\u2013Wilson models address data integrity. The Brewer and Nash model prevents conflicts of interest.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      229,
      228,
      219,
      216
    ],
    "source": ""
  },
  {
    "id": 3457,
    "question": "The Bell\u2013LaPadula multilevel security model was derived from the DoD's multilevel security policies. The multilevel security policy states that a subject with any level of clearance can access resources at or below its clearance level. <br>Which Bell\u2013LaPadula property keeps lower-level subjects from accessing objects with a higher security level?",
    "choice_a": "(Star) security property",
    "choice_b": "No write-up property",
    "choice_c": "No read-up property",
    "choice_d": "No read-down property",
    "correct_answer": "C",
    "explanation": "The no read-up property, also called the simple security property, prohibits subjects from reading a higher security level object. The other options are incorrect. Option A, the (star) security property of Bell\u2013LaPadula, is no write-down. Option B, no write-up, is the (star) property of Biba. Option D, no read-down, is the simple property of Biba.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      228,
      292,
      201,
      215
    ],
    "source": ""
  },
  {
    "id": 3458,
    "question": "The Biba model was designed after the Bell\u2013LaPadula model. Whereas the Bell\u2013LaPadula model addresses confidentiality, the Biba model addresses integrity. The Biba model is also built on a state machine concept, is based on information flow, and is a multilevel model. <br>What is the implied meaning of the simple property of Biba?",
    "choice_a": "Write-down",
    "choice_b": "Read-up",
    "choice_c": "No write-up",
    "choice_d": "No read-down",
    "correct_answer": "B",
    "explanation": "The simple property of Biba is no read-down, but the implied allowed opposite is read-up. The other options are incorrect. Option A, write-down, is the implied opposite allow of the (star) property of Biba, which is no write-up. Option C, no write-up, is the (star) property of Biba. Option D, no read-down, is the simple property of Biba.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      217,
      228,
      229,
      216,
      219
    ],
    "source": ""
  },
  {
    "id": 3459,
    "question": "The Common Criteria defines various levels of testing and confirmation of systems' security capabilities, and the number of the level indicates what kind of testing and confirmation has been performed. <br>What part of the Common Criteria specifies the claims of security from the vendor that are built into a target of evaluation?",
    "choice_a": "Protection profiles",
    "choice_b": "Evaluation Assurance Levels",
    "choice_c": "Authorizing Official",
    "choice_d": "Security target",
    "correct_answer": "D",
    "explanation": "Security targets (STs) specify the claims of security from the vendor that are built into a target of evaluation (TOE). STs are considered the implemented security measures or the \"I will provide\" from the vendor. The other options are incorrect. Option A, protection profiles (PPs), specify for a product that is to be evaluated (the TOE) the security requirements and protections, which are considered the security desires or the \"I want\" from a customer. Option B, Evaluation Assurance Levels (EALs), are the various levels of testing and confirmation of systems' security capabilities, and the number of the level indicates what kind of testing and confirmation has been performed. Option C, an Authorizing Official (AO), is the entity with the authority to issue an Authorization to Operate (ATO).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      221,
      228,
      223,
      222,
      226
    ],
    "source": ""
  },
  {
    "id": 3460,
    "question": "The Authorizing Official (AO) has the discretion to determine which breaches or security changes result in a loss of Authorization to Operate (ATO). The AO can also issue four types of authorization decisions. <br>Which of the following are examples of these ATOs?  (Select all that apply.)",
    "choice_a": "Common control authorization",
    "choice_b": "Mutual authorization",
    "choice_c": "Denial of authorization",
    "choice_d": "Authorization to transfer",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "The four types of ATOs are authorization to operate (not listed as an option), common control authorization, authorization to use, and denial of authorization. The other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      222,
      221,
      223,
      226,
      215
    ],
    "source": "",
    "choice_e": "Authorization to use",
    "choice_f": "Verified authorization"
  },
  {
    "id": 3461,
    "question": "A new operating system update has made significant changes to the prior system. While testing, you discover that the system is highly unstable, allows for integrity violations between applications, can be affected easily by local denial-of-service attacks, and allows for information disclosure between processes. You suspect that a key security mechanism has been disabled or broken by the update. <br>What is a likely cause of these problems?",
    "choice_a": "Use of virtualization",
    "choice_b": "Lack of memory protections",
    "choice_c": "Not following the Goguen\u2013Meseguer model",
    "choice_d": "Support for storage and transmission encryption",
    "correct_answer": "B",
    "explanation": "Memory protection is a core security component that must be designed and implemented into an operating system. It must be enforced regardless of the programs executing in the system. Otherwise, instability, violation of integrity, denial of service, and disclosure are likely results. The other options are incorrect. Option A, the use of virtualization, would not cause all of those security issues. Option C, the Goguen\u2013Meseguer model, is based on predetermining the set or domain (i.e., a list) of objects that a subject can access. Option D, the use of encryption, is a protection, not a cause of these security issues.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      224,
      215,
      228,
      292,
      211
    ],
    "source": ""
  },
  {
    "id": 3462,
    "question": "As an application designer, you need to implement various security mechanisms to protect the data that will be accessed and processed by your software. <br>What would be the purpose of implementing a constrained or restricted interface?",
    "choice_a": "To limit the actions of authorized and unauthorized users",
    "choice_b": "To enforce identity verification",
    "choice_c": "To track user events and check for violations",
    "choice_d": "To swap datasets between primary and secondary memory",
    "correct_answer": "A",
    "explanation": "A constrained or restricted interface is implemented within an application to restrict what users can do or see based on their privileges. The purpose of a constrained interface is to limit or restrict the actions of both authorized and unauthorized users. The other options are incorrect. Option B describes authentication. Option C describes auditing and accounting. Option D describes virtual memory.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      225,
      228,
      212,
      211,
      220
    ],
    "source": ""
  },
  {
    "id": 3463,
    "question": "While designing the security for the organization, you realize the importance of not only balancing the objectives of the organization against security goals but also focusing on the shared responsibility of security. <br>Which of the following is considered an element of shared responsibility?  (Select all that apply.)",
    "choice_a": "Everyone in an organization has some level of security responsibility.",
    "choice_b": "Always consider the threat to both tangible and intangible assets.",
    "choice_c": "Organizations are responsible to their stakeholders for making good security decisions to sustain the organization.",
    "choice_d": "When working with third parties, especially with cloud providers, each entity needs to understand their portion of the shared responsibility of performing work operations and maintaining security.",
    "correct_answer": [
      "A",
      "C",
      "D",
      "F"
    ],
    "explanation": "The statements in options A, C, D, and F are all valid elements or considerations of shared responsibility. The other options are incorrect. Always consider the threat to both tangible and intangible assets as a tenet of risk management and BIA. Multiple layers of security are required to protect against adversary attempts to gain access to internal sensitive resources and is a general principle of security known as defense in depth.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      230,
      211,
      263,
      305,
      226
    ],
    "source": "",
    "choice_e": "Multiple layers of security are required to protect against adversary attempts to gain access to internal sensitive resources.",
    "choice_f": "As we become aware of new vulnerabilities and threats, we should consider it our responsibility (if not our duty) to responsibly disclose that information to the proper vendor or to an information sharing center."
  },
  {
    "id": 3464,
    "question": "Many PC OSs provide functionality that enables them to support the simultaneous execution of multiple applications on single-processor systems. <br>What term is used to describe this capability?",
    "choice_a": "Multistate",
    "choice_b": "Multithreading",
    "choice_c": "Multitasking",
    "choice_d": "Multiprocessing",
    "correct_answer": "C",
    "explanation": "Multitasking is processing more than one task at the same time. In most cases, multitasking is simulated by the OS (using multiprogramming or pseudo-simultaneous execution) even when not supported by the processor. Multicore (not listed as an option) is also able to perform simultaneous execution but does so with multiple execution cores on one or more CPUs. Multistate is a type of system that can operate at various security levels (or classifications, risk levels, etc.). Multithreading permits multiple concurrent tasks (i.e., threads) to be performed within a single process. In a multiprocessing environment, a multiprocessor computing system (that is, one with more than one CPU) harnesses the power of more than one processor to complete the execution of a multithreaded application.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      235,
      991,
      250,
      256,
      272
    ],
    "source": ""
  },
  {
    "id": 3465,
    "question": "Based on recent articles about the risk of mobile code and web apps, you want to adjust the security configurations of organizational endpoint devices to minimize the exposure. On a modern Windows system with the latest version of Microsoft's browser and all others disabled or blocked, which of the following is of the highest concern?",
    "choice_a": "Java",
    "choice_b": "Flash",
    "choice_c": "JavaScript",
    "choice_d": "ActiveX",
    "correct_answer": "C",
    "explanation": "JavaScript remains the one mobile code technology that may affect the security of modern browsers and their host OSs. Java is deprecated for general internet use and browsers do not have native support for Java. A Java add-on is still available to install, but it is not preinstalled, and general security guidance recommends avoiding it on any internet-facing browser. Flash is deprecated; no modern browser supports it natively. Adobe has abandoned it, and most browsers actively block the add-on. ActiveX is also deprecated, and though it was always only a Microsoft Windows technology, it was only supported by Internet Explorer, not Edge (either in its original form or the more recent Chromium-based version). Although Internet Explorer is still present on modern Windows 10, this scenario stated that all other browsers were disabled or blocked. Thus, this scenario is limited to the latest Edge browser.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      247,
      246,
      275,
      211,
      215
    ],
    "source": ""
  },
  {
    "id": 3466,
    "question": "Your organization is considering deploying a publicly available screen saver to use spare system resources to process sensitive company data. <br>What is a common security risk when using grid computing solutions that consume available resources from computers over the internet?",
    "choice_a": "Loss of data privacy",
    "choice_b": "Latency of communication",
    "choice_c": "Duplicate work",
    "choice_d": "Capacity fluctuation",
    "correct_answer": "A",
    "explanation": "In many grid computing implementations, grid members can access the contents of the distributed work segments or divisions. This grid computing over the internet is not usually the best platform for sensitive operations. Grid computing is able to handle and compensate for latency of communications, duplicate work, and capacity fluctuation.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      251,
      255,
      252,
      254,
      213
    ],
    "source": ""
  },
  {
    "id": 3467,
    "question": "Your company is evaluating several cloud providers to determine which is the best fit to host your custom services as a custom application solution. There are many aspects of security controls you need to evaluate, but the primary issues include being able to process significant amounts of data in short periods of time, controlling which applications can access which assets, and being able to prohibit VM sprawl or repetition of operations. <br>Which of the following is not relevant to this selection process?",
    "choice_a": "Collections of entities, typically users, but can also be applications and devices, which can be granted or denied access to perform specific tasks or access certain resources or assets",
    "choice_b": "A VDI or VMI instance that serves as a virtual endpoint for accessing cloud assets and services",
    "choice_c": "The ability of a cloud process to use or consume more resources (such as compute, memory, storage, or networking) when needed",
    "choice_d": "A management or security mechanism able to monitor and differentiate between numerous instances of the same VM, service, app, or resource",
    "correct_answer": "B",
    "explanation": "Option B references a VDI or VMI instance that serves as a virtual endpoint for accessing cloud assets and services, but this concept is not specifically relevant to or a requirement of this scenario. The remaining items are relevant to the selection process in this scenario. These are all compute security\u2013related concepts. Option A, security groups, are collections of entities, typically users, but can also be applications and devices, which can be granted or denied access to perform specific tasks or access certain resources or assets. This supports the requirement of controlling which applications can access which assets. Option C, dynamic resource allocation (aka elasticity), is the ability of a cloud process to use or consume more resources (such as compute, memory, storage, or networking) when needed. This supports the requirement of processing significant amounts of data in short periods of time. Option D is a management or security mechanism, which is able to monitor and differentiate between numerous instances of the same VM, service, app, or resource. This supports the requirement of prohibiting VM sprawl or repetition of operations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      269,
      273,
      268,
      201,
      230
    ],
    "source": ""
  },
  {
    "id": 3468,
    "question": "A large city's central utility company has seen a dramatic increase in the number of distribution nodes failing or going offline. An APT group was attempting to take over control of the utility company and was responsible for the system failures. <br>Which of the following systems has the attacker compromised?",
    "choice_a": "MFP",
    "choice_b": "RTOS",
    "choice_c": "SoC",
    "choice_d": "SCADA",
    "correct_answer": "D",
    "explanation": "A large utility company is very likely to be using supervisory control and data acquisition (SCADA) to manage and operate their equipment; therefore, that is the system that the APT group would have compromised. A multifunction printer (MFP) is not likely to be the attack point that granted the APT group access to the utility distribution nodes. A real-time OS (RTOS) may have been present on some of the utility company's systems, but that is not the obvious target for an attack to take over control of an entire utility service. There may be system on chip (SoC) equipment present at the utility, but that would still be controlled and accessed through the SCADA system at a utility company.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      253,
      262,
      211,
      292,
      228
    ],
    "source": ""
  },
  {
    "id": 3469,
    "question": "Your organization is concerned about information leaks due to workers taking home retired equipment. <br>Which one of the following types of memory might retain information after being removed from a computer and therefore represents a security risk?",
    "choice_a": "Static RAM",
    "choice_b": "Dynamic RAM",
    "choice_c": "Secondary memory",
    "choice_d": "Real memory",
    "correct_answer": "C",
    "explanation": "Secondary memory is a term used to describe magnetic, optical, or flash media (i.e., typical storage devices like HDD, SSD, CD, DVD, and thumb drives). These devices will retain their contents after being removed from the computer and may later be read by another user. Static RAM and dynamic RAM are types of real memory and thus are all the same concept in relation to being volatile\u2014meaning they lose any data they were holding when power is lost or cycled. Static RAM is faster and more costly, and dynamic RAM requires regular refreshing of the stored contents. Take notice in this question that three of the options were effectively synonyms (at least from the perspective of volatile versus nonvolatile storage). If you notice synonyms among answer options, realize that none of the synonyms can be a correct answer for single-answer multiple-choice questions.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      244,
      239,
      226,
      324,
      297
    ],
    "source": ""
  },
  {
    "id": 3470,
    "question": "Your organization is considering the deployment of a DCE to support a massively multiplayer online role-playing game (MMORPG) based on the characters of a popular movie franchise. <br>What is the primary concern of a DCE that could allow for propagation of malware or making adversarial pivoting and lateral movement easy?",
    "choice_a": "Unauthorized user access",
    "choice_b": "Identity spoofing",
    "choice_c": "Interconnectedness of the components",
    "choice_d": "Poor authentication",
    "correct_answer": "C",
    "explanation": "The primary security concern of a distributed computing environment (DCE) is the interconnectedness of the components. This configuration could allow for error or malware propagation as well. If an adversary compromises one component, it may grant them the ability to compromise other components in the collective through pivoting and lateral movement. The other options are incorrect. Unauthorized user access, identity spoofing, and poor authentication are potential weaknesses of most systems; they are not unique to DCE solutions. However, these issues can be directly addressed through proper design, coding, and testing. However, the interconnectedness of components is a native characteristic of DCE that cannot be removed without discarding the DCE design concept itself.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      255,
      254,
      208,
      215,
      211
    ],
    "source": ""
  },
  {
    "id": 3471,
    "question": "Your boss wants to automate the control of the building's HVAC system and lighting in order to reduce costs. He instructs you to keep costs low and use off-the-shelf IoT equipment. When you are using IoT equipment in a private environment, what is the best way to reduce risk?",
    "choice_a": "Use public IP addresses",
    "choice_b": "Power off devices when not in use",
    "choice_c": "Keep devices current on updates",
    "choice_d": "Block access from the IoT devices to the internet",
    "correct_answer": "C",
    "explanation": "The best means to reduce IoT risk from these options is to keep devices current on updates. Using public IP addresses will expose the IoT devices to attack from the internet. Powering off devices is not a useful defense\u2014the benefit of IoT is that they are always running and ready to be used or take action when triggered or scheduled. Blocking access to the internet will prevent the IoT devices from obtaining updates themselves, may prevent them from being controlled through a mobile device app, and will prevent communication with any associated cloud service.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      258,
      940,
      941,
      211,
      206
    ],
    "source": ""
  },
  {
    "id": 3472,
    "question": "Service-oriented architecture (SOA) constructs new applications or functions out of existing but separate and distinct software services. The resulting application is often new; thus, its security issues are unknown, untested, and unprotected. <br>Which of the following is a direct extension of SOA that creates single-use functions that can be employed via an API by other software?",
    "choice_a": "Cyber-physical systems",
    "choice_b": "Fog computing",
    "choice_c": "DCS",
    "choice_d": "Microservices",
    "correct_answer": "D",
    "explanation": "Microservices are an emerging feature of web-based solutions and are derivative of service-oriented architecture (SOA). A microservice is simply one element, feature, capability, business logic, or function of a web application that can be called upon or used by other web applications. It is the conversion or transformation of a capability of one web application into a microservice that can be called upon by numerous other web applications. The relationship to an application programming interface (API) is that each microservice must have a clearly defined (and secured!) API to allow for I/O between multi-microservices as well as to and from other applications. The other options are incorrect since they are not derivatives of SOA. Cyber-physical systems are devices that offer a computational means to control something in the physical world. Fog computing relies on sensors, IoT devices, or even edge computing devices to collect data and then transfer it back to a central location for processing. Distributed control systems (DCSs) are typically found in industrial process plants where the need to gather data and implement control over a large-scale environment from a single location is essential.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      264,
      211,
      213,
      187,
      179
    ],
    "source": ""
  },
  {
    "id": 3473,
    "question": "A new local VDI has been deployed in the organization. There have been numerous breaches of security due to issues on typical desktop workstations and laptop computers used as endpoints. Many of these issues stemmed from users installing unapproved software or altering the configuration of essential security tools. In an effort to avoid security compromises originating from endpoints in the future, all endpoint devices are now used exclusively as dumb terminals. Thus, no local data storage or application execution is performed on endpoints. Within the VDI, each worker has been assigned a VM containing all of their business necessary software and datasets. These VMs are configured to block the installation and execution of new software code, data files cannot be exported to the actual endpoints, and each time a worker logs out, the used VM is discarded and a clean version copied from a static snapshot replaces it. <br>What type of system has now been deployed for the workers to use?",
    "choice_a": "Cloud services",
    "choice_b": "Nonpersistent",
    "choice_c": "Thin clients",
    "choice_d": "Fog computing",
    "correct_answer": "B",
    "explanation": "This scenario describes the systems as being nonpersistent. A nonpersistent system or static system is a computer system that does not allow, support, or retain changes. Thus, between uses and/or reboots, the operating environment and installed software are exactly the same. Changes may be blocked or simply discarded after each system use. A nonpersistent system is able to maintain its configuration and security in spite of user attempts to implement change. This scenario is not describing a cloud solution, although a virtual desktop interface (VDI) could be implemented on premises or in the cloud. This scenario is not describing thin clients, since the existing \"standard\" PC endpoints are still in use but a VDI is being used instead of the local system capabilities. A VDI deployment simulates a thin client. This scenario is not describing fog computing. Fog computing relies on sensors, IoT devices, or even edge computing devices to collect data and then transfer it back to a central location for processing.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      261,
      271,
      272,
      289,
      211
    ],
    "source": ""
  },
  {
    "id": 3474,
    "question": "A review of your company's virtualization of operations determines that the hardware resources supporting the VMs are nearly fully consumed. The auditor asks for the plan and layout of VM systems but is told that no such plan exists. This reveals that the company is suffering from what issue?",
    "choice_a": "Use of EOSL systems",
    "choice_b": "VM sprawl",
    "choice_c": "Poor cryptography",
    "choice_d": "VM escaping",
    "correct_answer": "B",
    "explanation": "The issue in this situation is VM sprawl. Sprawl occurs when organizations fail to plan their IT/IS needs and just deploy new systems, software, and VMs whenever their production needs demand it. This often results in obtaining underpowered equipment that is then overtaxed by inefficient implementations of software and VMs. This situation is not specifically related to end-of-service life (EOSL) systems, but EOSL systems would exacerbate the sprawl issue. This situation is not related to poor cryptography, nor is there any evidence of VM escaping issues.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      268,
      273,
      298,
      211,
      226
    ],
    "source": ""
  },
  {
    "id": 3475,
    "question": "A company server is currently operating at near maximum resource capacity, hosting just seven virtual machines. Management has instructed you to deploy six new applications onto additional VMs without purchasing new hardware since the IT/IS budget is exhausted. <br>How can this be accomplished?",
    "choice_a": "Data sovereignty",
    "choice_b": "Infrastructure as code",
    "choice_c": "Containerization",
    "choice_d": "Serverless architecture",
    "correct_answer": "C",
    "explanation": "Containerization is based on the concept of eliminating the duplication of OS elements in a virtual machine. Instead, each application is placed into a container that includes only the actual resources needed to support the enclosed application, and the common or shared OS elements are then part of the hypervisor. The system as a whole could be redeployed using a containerization solution, and each of the applications previously present in the original seven VMs could be placed into containers, as well as the six new applications. This should result in all 13 applications being able to operate reasonably well without the need for new hardware. Data sovereignty is the concept that, once information has been converted into a binary form and stored as digital files, it is subject to the laws of the country within which the storage device resides. Infrastructure as code (IaC) is a change in how hardware management is perceived and handled. Instead of seeing hardware configuration as a manual, direct hands-on, one-on-one administration hassle, it is viewed as just another collection of elements to be managed in the same way that software and code are managed under DevSecOps (security, development, and operations). Serverless architecture is a cloud computing concept where code is managed by the customer, and the platform (i.e., supporting hardware and software) or server is managed by the CSP. This is not a solution that will work in this scenario; if management does not want to purchase additional hardware, they probably won't approve a monthly CSP subscription, either.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      269,
      273,
      264,
      265,
      230
    ],
    "source": ""
  },
  {
    "id": 3477,
    "question": "You have been tasked with designing and implementing a new security policy to address the new threats introduced by the recently installed embedded systems. <br>What is a security risk of an embedded system that is not commonly found in a standard PC?",
    "choice_a": "Software flaws",
    "choice_b": "Access to the internet",
    "choice_c": "Control of a mechanism in the physical world",
    "choice_d": "Power loss",
    "correct_answer": "C",
    "explanation": "Because an embedded system is often in control of a mechanism in the physical world, a security breach could cause harm to people and property (aka cyber-physical). This typically is not true of a standard PC. Power loss, internet access, and software flaws are security risks of both embedded systems and standard PCs.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      262,
      299,
      263,
      324
    ],
    "source": ""
  },
  {
    "id": 3478,
    "question": "A company is developing a new product to perform simple automated tasks related to indoor gardening. The device will be able to turn lights on and off and control a pump to transfer water. The technology to perform these automated tasks needs to be small and inexpensive. It only needs minimal computational capabilities, does not need networking, and should be able to execute C++ commands natively without the need of an OS. The organization thinks that using an embedded system or a microcontroller may be able to provide the functionality necessary for the product. <br>Which of the following is the best choice to use for this new product?",
    "choice_a": "Arduino",
    "choice_b": "RTOS",
    "choice_c": "Raspberry Pi",
    "choice_d": "FPGA",
    "correct_answer": "A",
    "explanation": "Arduino is an open source hardware and software organization that creates single-board 8-bit microcontrollers for building digital devices. An Arduino device has limited RAM, a single USB port, and I/O pins for controlling additional electronics (such as servo motors or LED lights), and does not include an OS or support networking. Instead, Arduino can execute C++ programs specifically written to its limited instruction set. Raspberry Pi is a popular example of a 64-bit microcontroller or a single-board computer, which includes its own custom OS, although many third-party OS alternatives are available. A Raspberry Pi, another microcontroller option, has significantly more processing power than Arduino, is not limited to executing C++ programs, supports networking, and is more expensive than Arduino. Thus, a Raspberry Pi is not the best option for this scenario. A real-time operating system (RTOS) is designed to process or handle data as it arrives on the system with minimal latency or delay. RTOS is a software OS that is usually stored and executed from ROM and thus may be part of an embedded solution or hosted on a microcontroller. An RTOS is designed for mission-critical operations where delay must be eliminated or minimized for safety. Thus, RTOS is not the best option for this scenario since it is about managing a garden, which does not need real-time mission-critical operations. A field-programmable gate array (FPGA) is a flexible computing device intended to be programmed by the end user or customer. FPGAs are often used as embedded devices in a wide range of products, including industrial control systems (ICSs). FPGAs can be challenging to program and are often more expensive than other more limited solutions. Thus, FPGA is not the best fit for this scenario.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      260,
      944,
      947,
      262,
      211
    ],
    "source": ""
  },
  {
    "id": 3479,
    "question": "You are developing a new product that is intended to process data in order to trigger real-world adjustments with minimal latency or delay. The current plan is to embed the code into a ROM chip in order to optimize for mission-critical operations. <br>What type of solution is most appropriate for this scenario?",
    "choice_a": "Containerized application",
    "choice_b": "An Arduino",
    "choice_c": "DCS",
    "choice_d": "RTOS",
    "correct_answer": "D",
    "explanation": "This scenario is describing a product that requires a real-time operating system (RTOS) solution, since it mentions the need to minimize latency and delay, storing code in ROM, and optimizing for mission-critical operations. A containerized application is not a good fit for this situation because it may not be able to operate in near real time due to the virtualization infrastructure, and containerized apps are typically stored as files on the contain host rather than a ROM chip. An Arduino is a type of microcontroller, but not typically robust enough to be considered a near-real-time mechanism; it stores code on a flash chip, has a limited C++ based instruction set, and is not suited for mission-critical operations. A distributed control system (DCS) can be used to manage small-scale industrial processes, but it is not designed as a near-real-time solution. DCSs are not stored in ROM, but they may be used to manage mission-critical operations.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      946,
      948,
      237,
      211,
      228
    ],
    "source": ""
  },
  {
    "id": 3480,
    "question": "A major online data service wants to provide better response and access times for its users and visitors. They plan on deploying thousands of mini-web servers to ISPs across the nation. These mini-servers will host the few dozen main pages of their website so that users will be routed to the logically and geographically closest server for optimal performance and minimal latency. Only if a user requests data not on these mini-servers will they be connecting to the centralized main web cluster hosted at the company's headquarters. <br>What is this type of deployment commonly known as?",
    "choice_a": "Edge computing",
    "choice_b": "Fog computing",
    "choice_c": "Thin clients",
    "choice_d": "Infrastructure as code",
    "correct_answer": "A",
    "explanation": "This scenario is an example of edge computing. In edge computing, the intelligence and processing is contained within each device. Thus, rather than having to send data off to a master processing entity, each device can process its own data locally. The architecture of edge computing performs computations closer to the data source, which is at or near the edge of the network. Fog computing relies on sensors, IoT devices, or even edge computing devices to collect data and then transfer it back to a central location for processing. A thin client is a computer with low to modest capability or a virtual interface that is used to remotely access and control a mainframe, virtual machine, or virtual desktop infrastructure (VDI). Infrastructure as code (IaC) is a change in how hardware management is perceived and handled. Instead of seeing hardware configuration as a manual, direct hands-on, one-on-one administration hassle, it is viewed as just another collection of elements to be managed in the same way that software and code are managed under DevOps.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      259,
      299,
      269,
      271,
      256
    ],
    "source": ""
  },
  {
    "id": 3481,
    "question": "You are working on improving your organization's policy on mobile equipment. Because of several recent and embarrassing breaches, the company wants to increase security through technology as well as user behavior and activities. <br>What is the most effective means of reducing the risk of losing the data on a mobile device, such as a laptop computer?",
    "choice_a": "Defining a strong logon password",
    "choice_b": "Minimizing sensitive data stored on the mobile device",
    "choice_c": "Using a cable lock",
    "choice_d": "Encrypting the hard drive",
    "correct_answer": "B",
    "explanation": "The risk of a lost or stolen laptop is the data loss, not the loss of the system itself, but the value of the data on the system, whether business related or personal. Thus, keeping minimal sensitive data on the system is the only way to reduce the risk. Hard drive encryption, cable locks, and strong passwords, although good ideas, are preventive tools, not means of reducing risk. They don't keep intentional and malicious data compromise from occurring; instead, they encourage honest people to stay honest. Hard drive encryption can be bypassed using the cold boot attack or by taking advantage of an encryption service flaw or configuration mistake. Cable locks can be cut or ripped out of the chassis. Strong passwords do not prevent the theft of a device, and password cracking and/or credential stuffing may be able to overcome the protection. If not, the drive could be extracted and connected to another system to access files directly, even with the native OS running.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      275,
      206,
      185,
      324,
      211
    ],
    "source": ""
  },
  {
    "id": 3482,
    "question": "The CISO has asked you to propose an update to the company's mobile device security strategy. The main concerns are the intermingling of personal information with business data and complexities of assigning responsibility over device security, management, updates, and repairs. <br>Which of the following would be the best option to address these issues?",
    "choice_a": "Bring your own device (BYOD)",
    "choice_b": "Corporate-owned personally enabled (COPE)",
    "choice_c": "Choose your own device (CYOD)",
    "choice_d": "Corporate-owned",
    "correct_answer": "D",
    "explanation": "The best option in this scenario is corporate-owned. A corporate-owned mobile strategy is when the company purchases mobile devices that can support compliance with the security policy. These devices are to be used exclusively for company purposes, and users should not perform any personal tasks on them. This option often requires workers to carry a second device for personal use. Corporate-owned clearly assigns responsibility for device oversight to the organization. The other three options still allow for co-mingling of data and have unclear or vague security responsibility assignments as a concept or policy basis. BYOD is a policy that allows employees to bring their own personal mobile devices to work and use those devices to connect to business resources and/or the internet through the company network. The concept of corporate-owned, personally enabled (COPE) means the organization purchases devices and provides them to employees. Each user is then able to customize the device and use it for both work activities and personal activities. The concept of choose your own device (CYOD) provides users with a list of approved devices from which to select the device to implement.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      283,
      284,
      230,
      211,
      288
    ],
    "source": ""
  },
  {
    "id": 3483,
    "question": "Your organization is planning on building a new facility to house a majority of on-site workers. The current facility has had numerous security issues, such as loitering, theft, graffiti, and even a few physical altercations between employees and non-employees. The CEO has asked you to assist in developing the facility plan to reduce these security concerns. While researching options you discover the concepts of CPTED. <br>Which of the following is not one of its core strategies?",
    "choice_a": "Natural territorial reinforcement",
    "choice_b": "Natural access control",
    "choice_c": "Natural training and enrichment",
    "choice_d": "Natural surveillance",
    "correct_answer": "C",
    "explanation": "Natural training and enrichment is not a core strategy of CPTED. Crime Prevention Through Environmental Design (CPTED) has three main strategies: natural access control, natural surveillance, and natural territorial reinforcement. Natural access control is the subtle guidance of those entering and leaving a building through placement of entranceways, use of fences and bollards, and placement of lights. Natural surveillance is any means to make criminals feel uneasy through the increasing of opportunities for them to be observed. Natural territorial reinforcement is the attempt to make the area feel like an inclusive, caring community.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      304,
      305,
      302,
      324,
      319
    ],
    "source": ""
  },
  {
    "id": 3484,
    "question": "What method is a systematic effort to identify relationships between mission-critical applications, processes, and operations and all the necessary supporting elements when evaluating the security of a facility or designing a new facility?",
    "choice_a": "Log file audit",
    "choice_b": "Critical path analysis",
    "choice_c": "Risk analysis",
    "choice_d": "Taking inventory",
    "correct_answer": "B",
    "explanation": "Critical path analysis is a systematic effort to identify relationships between mission-critical applications, processes, and operations and all the necessary supporting elements when evaluating the security of a facility or designing a new facility. Log file audit can help detect violations to hold users accountable, but it is not a security facility design element. Risk analysis is often involved in facility design, but it is the evaluation of threats against assets in regard to rate of occurrence and levels of consequence. Taking inventory is an important part of facility and equipment management, but it is not an element in overall facility design.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      302,
      324,
      303,
      304,
      226
    ],
    "source": ""
  },
  {
    "id": 3485,
    "question": "Which of the following is a true statement in regard to security cameras?  (Select all that apply.)",
    "choice_a": "Cameras should be positioned to watch exit and entry points.",
    "choice_b": "Cameras are not needed around valuable assets and resources or to provide additional protection in public areas such as parking structures and walkways.",
    "choice_c": "Cameras should be positioned to have clear sight lines of all exterior walls, entrance and exit points, and interior hallways.",
    "choice_d": "Security cameras should only be overt and obvious to provide a deterrent benefit.",
    "correct_answer": [
      "A",
      "C",
      "F"
    ],
    "explanation": "The true statements are option A, cameras should be positioned to watch exit and entry points allowing any change in authorization or access level; option C, cameras should be positioned to have clear sight lines of all exterior walls, entrance and exit points, and interior hallways; and option F, some camera systems include a system on a chip (SoC) or embedded components and may be able to perform various specialty functions, such as time-lapse recording, tracking, facial recognition, object detection, or infrared or color-filtered recording. The remaining answer options are incorrect. The corrected statements for those options are: option B: Cameras should also be used to monitor activities around valuable assets and resources as well as to provide additional protection in public areas such as parking structures and walkways; option D: Security cameras can be overt and obvious in order to provide a deterrent benefit, or hidden and concealed in order to primarily provide a detective benefit; option E: Some cameras are fixed, whereas others support remote control of automated pan, tilt, and zoom (PTZ); and option G: Simple motion recognition or motion-triggered cameras may be fooled by animals, birds, insects, weather, or foliage.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      327,
      316,
      324,
      318,
      308
    ],
    "source": "",
    "choice_e": "Security cameras have a fixed area of view for recording.",
    "choice_f": "Some camera systems include a system on a chip (SoC) or embedded components and may be able to perform various specialty functions, such as time-lapse recording, tracking, facial recognition, object detection, or infrared or color-filtered recording.",
    "choice_g": "Motion detection or sensing cameras can always distinguish between humans and animals."
  },
  {
    "id": 3486,
    "question": "Your organization is planning on building a new primary headquarters in a new town. You have been asked to contribute to the design process, so you have been given copies of the proposed blueprints to review. <br>Which of the following is <italic>not</italic> a security-focused design element of a facility or site?",
    "choice_a": "Separation of work and visitor areas",
    "choice_b": "Restricted access to areas with higher value or importance",
    "choice_c": "Confidential assets located in the heart or center of a facility",
    "choice_d": "Equal access to all locations within a facility",
    "correct_answer": "D",
    "explanation": "Equal access to all locations within a facility is not a security-focused design element. Each area containing assets or resources of different importance, value, and confidentiality should have a corresponding level of security restriction placed on it. A secure facility should have a separation between work and visitor areas and should restrict access to areas with higher value or importance, and confidential assets should be located in the heart or center of a facility.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      324,
      302,
      304,
      328,
      211
    ],
    "source": ""
  },
  {
    "id": 3487,
    "question": "A recent security audit of your organization's facilities has revealed a few items that need to be addressed. A few of them are related to your main data center. But you think at least one of the findings is a false positive. <br>Which of the following does <italic>not</italic> need to be true in order to maintain the most efficient and secure server room?",
    "choice_a": "It must be optimized for workers.",
    "choice_b": "It must include the use of non-water fire suppressants.",
    "choice_c": "The humidity must be kept between 20 and 80 percent.",
    "choice_d": "The temperature must be kept between 59 and 89.6 degrees Fahrenheit.",
    "correct_answer": "A",
    "explanation": "A computer room does not need to be optimized for human workers to be efficient and secure. A server room would be more secure with a non-water fire suppressant system (it would protect against damage caused by water suppressant). A server room should have humidity maintained between 20 and 80 percent relative humidity and maintain a temperature between 59 and 89.6 degrees Fahrenheit.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      326,
      313,
      314,
      308,
      324
    ],
    "source": ""
  },
  {
    "id": 3488,
    "question": "A recent security policy update has restricted the use of portable storage devices when they are brought in from outside. As a compensation, a media storage management process has been implemented. <br>Which of the following is <italic>not</italic> a typical security measure implemented in relation to a media storage facility containing reusable removable media?",
    "choice_a": "Employing a media librarian or custodian",
    "choice_b": "Using a check-in/check-out process",
    "choice_c": "Hashing",
    "choice_d": "Using sanitization tools on returned media",
    "correct_answer": "C",
    "explanation": "Hashing is not a typical security measure implemented in relation to a media storage facility containing reusable removable media. Hashing is used when it is necessary to verify the integrity of a dataset, whereas data on reusable removable media should be removed and not retained. Usually the security features for a media storage facility include using a media librarian or custodian, using a check-in/check-out process, and using sanitization tools on returned media.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      311,
      328,
      239,
      285,
      172
    ],
    "source": ""
  },
  {
    "id": 3489,
    "question": "The company's server room has been updated with raised floors and MFA door locks. You want to ensure that updated facility is able to maintain optimal operational efficiency. <br>What is the ideal humidity range for a server room?",
    "choice_a": "20\u201340 percent",
    "choice_b": "20\u201380 percent",
    "choice_c": "80\u201389.6 percent",
    "choice_d": "70\u201395 percent",
    "correct_answer": "B",
    "explanation": "The humidity in a computer room should ideally be from 20 to 80 percent. Humidity above 80 percent can result in condensation, which causes corrosion. Humidity below 20 percent can result in increased static electricity buildup. However, this does require managing temperature properly as well. The other number ranges are not the relative humidity ranges recommended for a data center.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      313,
      326,
      324,
      318,
      211
    ],
    "source": ""
  },
  {
    "id": 3490,
    "question": "You are mapping out the critical paths of network cables throughout the building. <br>Which of the following items do you need to make sure to include and label on your master cabling map as part of crafting the cable plant management policy?  (Select all that apply.)",
    "choice_a": "Person trap",
    "choice_b": "Entrance facility",
    "choice_c": "Equipment room",
    "choice_d": "Fire escapes",
    "correct_answer": [
      "B",
      "C",
      "E",
      "F",
      "H"
    ],
    "explanation": "The primary elements of a cable plant management policy should include a mapping of the entrance facility (i.e., demarcation point), equipment room, backbone distribution system, telecommunications room, and horizontal distribution system. The other items are not elements of a cable plant. Thus, access control vestibule, fire escapes, UPSs, and the loading dock are not needed elements on a cable map.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      307,
      292,
      305,
      324,
      211
    ],
    "source": "",
    "choice_e": "Backbone distribution system",
    "choice_f": "Telecommunications room",
    "choice_g": "UPSs",
    "choice_h": "Horizontal distribution system",
    "choice_i": "Loading dock"
  },
  {
    "id": 3491,
    "question": "What is the best type of water-based fire suppression system for a computer facility?",
    "choice_a": "Wet pipe system",
    "choice_b": "Dry pipe system",
    "choice_c": "Preaction system",
    "choice_d": "Deluge system",
    "correct_answer": "C",
    "explanation": "A preaction system is the best type of water-based fire suppression system for a computer facility because it provides the opportunity to prevent the release of water in the event of a false alarm or false initial trigger. The other options of wet pipe, dry pipe, and deluge system use only a single trigger mechanism without the ability to prevent accidental water release.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      314,
      326,
      324,
      711
    ],
    "source": ""
  },
  {
    "id": 3492,
    "question": "Your company has a yearly fire detection and suppression system inspection performed by the local authorities. You start up a conversation with the lead inspector and they ask you, \"What is the most common cause of a false positive for a water-based fire suppression system?\" So, what do you answer?",
    "choice_a": "Water shortage",
    "choice_b": "People",
    "choice_c": "Ionization detectors",
    "choice_d": "Placement of detectors in drop ceilings",
    "correct_answer": "B",
    "explanation": "The most common cause of a false positive for a water-based system is human error. If you turn off the water source after a fire and forget to turn it back on, you'll be in trouble for the future. Also, pulling an alarm when there is no fire will trigger damaging water release throughout the office. Water shortage would be a problem, but it is not a cause for a false positive event. Ionization detectors are highly reliable, so they are usually not the cause of a false positive event. Detectors can be placed in drop ceilings in order to monitor that air space; this would only be a problem if another detector was not placed in the main area of the room. If there are only detectors in the drop ceiling, then that could result in a false negative event.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      314,
      710,
      711,
      326
    ],
    "source": ""
  },
  {
    "id": 3493,
    "question": "A data center has had repeated hardware failures. An auditor notices that systems are stacked together in dense groupings with no clear organization. <br>What should be implemented to address this issue?",
    "choice_a": "Visitor logs",
    "choice_b": "Industrial camouflage",
    "choice_c": "Gas-based fire suppression",
    "choice_d": "Hot aisles and cold aisles",
    "correct_answer": "D",
    "explanation": "The cause of the hardware failures is implied by the lack of organization of the equipment, which is heat buildup. This could be addressed by better management of temperature and airflow, which would involve implementing hot aisles and cold aisles in the data center. A data center should have few if any actual visitors (such as outsiders), but anyone entering and leaving a data center should be tracked and recorded in a log. However, whether or not a visitor log is present has little to do with system failure due to poor heat management. Industrial camouflage is not relevant here since it is about hiding the purpose of a facility from outside observers. A gas-based fire suppression system is more appropriate for a data center than a water-based system, but neither would cause heat problems due to poor system organization.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      313,
      324,
      308,
      314,
      315
    ],
    "source": ""
  },
  {
    "id": 3494,
    "question": "Which of the following are benefits of a gas-based fire suppression system?  (Select all that apply.)",
    "choice_a": "Can be deployed throughout a company facility",
    "choice_b": "Will cause the least damage to computer systems",
    "choice_c": "Extinguishes the fire by removing oxygen",
    "choice_d": "May be able to extinguish the fire faster than a water discharge system",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Benefits of gas-based fire suppression include causing the least damage to computer systems and extinguishing the fire quickly by removing oxygen. Also, gas-based fire suppression may be more effective and faster than a water-based system. A gas-based fire suppression system can only be used where human presence is at a minimum, since it removes oxygen from the air.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      315,
      314,
      326,
      329,
      324
    ],
    "source": ""
  },
  {
    "id": 3495,
    "question": "When designing physical security for an environment, it is important to focus on the functional order in which controls should be used. <br>Which of the following is the correct order of the six common physical security control mechanisms?",
    "choice_a": "Decide, Delay, Deny, Detect, Deter, Determine",
    "choice_b": "Deter, Deny, Detect, Delay, Determine, Decide",
    "choice_c": "Deny, Deter, Delay, Detect, Decide, Determine",
    "choice_d": "Decide, Detect, Deny, Determine, Deter, Delay",
    "correct_answer": "B",
    "explanation": "The correct order of the six common physical security control mechanisms is Deter, Deny, Detect, Delay, Determine, Decide. The other options are incorrect.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      305,
      324,
      325,
      318,
      320
    ],
    "source": ""
  },
  {
    "id": 3496,
    "question": "Equipment failure is a common cause of a loss of availability. When deciding on strategies to maintain availability, it is often important to understand the criticality of each asset and business process as well as the organization's capacity to weather adverse conditions. Match the term to the definition. <ol type=\"I\"><li>MTTF </li><li>MTTR </li><li>MTBF </li><li>SLA </li></ol><br><ol><li>Clearly defines the response time a vendor will provide in the event of an equipment failure emergency </li><li>An estimation of the time between the first and any subsequent failures </li><li>The expected typical functional lifetime of the device given a specific operating environment </li><li>The average length of time required to perform a repair on the device</li></ol>",
    "choice_a": "I - 1, II - 2, III - 4, IV - 3",
    "choice_b": "I - 4, II - 3, III - 1, IV - 2",
    "choice_c": "I - 3, II - 4, III - 2, IV - 1",
    "choice_d": "I - 2, II - 1, III - 3, IV - 4",
    "correct_answer": "C",
    "explanation": "Mean time to failure (MTTF) is the expected typical functional lifetime of the device given a specific operating environment. Mean time to repair (MTTR) is the average length of time required to perform a repair on the device. Mean time between failures (MTBF) is an estimation of the time between the first and any subsequent failures. A service level agreement (SLA) clearly defines the response time a vendor will provide in the event of an equipment failure emergency.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      306,
      326,
      205,
      222,
      269
    ],
    "source": ""
  },
  {
    "id": 3497,
    "question": "You have been placed on the facility security planning team. You've been tasked to create a priority list of issues to address during the initial design phase. <br>What is the most important goal of all security solutions?",
    "choice_a": "Prevention of disclosure",
    "choice_b": "Maintaining integrity",
    "choice_c": "Human safety",
    "choice_d": "Sustaining availability",
    "correct_answer": "C",
    "explanation": "Human safety is the most important goal of all security solutions. The top priority of security should always be the protection of the lives and safety of personnel. The protection of CIA (confidentiality, integrity, and availability) of company data and other assets is the second priority after human life and safety.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      322,
      305,
      324,
      292,
      230
    ],
    "source": ""
  },
  {
    "id": 3498,
    "question": "While reviewing the facility design blueprints, you notice several indications of a physical security mechanism being deployed directly into the building's construction. <br>Which of the following is a double set of doors that is often protected by a guard and is used to contain a subject until their identity and authentication are verified?",
    "choice_a": "Gate",
    "choice_b": "Turnstile",
    "choice_c": "Access control vestibule",
    "choice_d": "Proximity detector",
    "correct_answer": "C",
    "explanation": "An access control vestibule is a double set of doors that is often protected by a guard and used to contain a subject until their identity and authentication is verified. A gate is a doorway used to traverse through a fence line. A turnstile is an ingress or egress point that allows travel only in one direction and by one person at a time. A proximity detector determines whether a proximity device is nearby and whether the bearer is authorized to access the area being protected.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      508,
      855,
      853,
      854,
      535
    ],
    "source": ""
  },
  {
    "id": 3499,
    "question": "Due to a recent building intrusion, facility security has become a top priority. You are on the proposal committee that will be making recommendations on how to improve the organization's physical security stance. <br>What is the most common form of perimeter security devices or mechanisms?",
    "choice_a": "Security guards",
    "choice_b": "Fences",
    "choice_c": "CCTV",
    "choice_d": "Lighting",
    "correct_answer": "D",
    "explanation": "Lighting is often claimed to be the most commonly deployed physical security mechanism. However, lighting is only a deterrent and not a strong deterrent. It should not be used as the primary or sole protection mechanism except in areas with a low threat level. Your entire site, inside and out, should be well lit. This provides for easy identification of personnel and makes it easier to notice intrusions. Security guards are not as common as lighting, but they are more flexible in terms of security benefits. Fences are not as common as lighting, but they serve as a preventive control. CCTV is not as common as lighting but serves as a detection control.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      543,
      508,
      505,
      549,
      548
    ],
    "source": ""
  },
  {
    "id": 3500,
    "question": "Your organization has just landed a new contract for a major customer. This will involve increasing production operations at the primary facility, which will entail housing valuable digital and physical assets. You need to ensure that these new assets receive proper protections. <br>Which of the following is <italic>not</italic> a disadvantage of using security guards?",
    "choice_a": "Security guards are usually unaware of the scope of the operations within a facility.",
    "choice_b": "Not all environments and facilities support security guards.",
    "choice_c": "Not all security guards are themselves reliable.",
    "choice_d": "Prescreening, bonding, and training do not guarantee effective and reliable security guards.",
    "correct_answer": "A",
    "explanation": "Security guards are usually unaware of the scope of the operations within a facility and are therefore not thoroughly equipped to know how to respond to every situation. Though this is considered a disadvantage, the lack of knowledge of the scope of the operations within a facility can also be considered an advantage because this supports confidentiality of those operations and thus helps reduce the possibility that a security guard will be involved in the disclosure of confidential information. Thus, even though this answer option is ambiguous, it is still better than the three other options. The other three options are disadvantages of security guards. Not all environments and facilities support security guards. This may be because of actual human incompatibility or the layout, design, location, and construction of the facility. Not all security guards are themselves reliable. Prescreening, bonding, and training do not guarantee that you won't end up with an ineffective or unreliable security guard.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      507,
      508,
      504,
      533,
      511
    ],
    "source": ""
  },
  {
    "id": 3501,
    "question": "While designing the security plan for a proposed facility, you are informed that the budget was just reduced by 30 percent. However, they did not adjust or reduce the security requirements. <br>What is the most common and inexpensive form of physical access control device for both interior and exterior use?",
    "choice_a": "Lighting",
    "choice_b": "Security guard",
    "choice_c": "Key locks",
    "choice_d": "Fences",
    "correct_answer": "C",
    "explanation": "Key locks are the most common and inexpensive form of physical access control device for both interior and exterior use. Lighting, security guards, and fences are all much more costly. Fences are also mostly used outdoors.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      854,
      853,
      855,
      509,
      515
    ],
    "source": ""
  },
  {
    "id": 3502,
    "question": "While implementing a motion detection system to monitor unauthorized access into a secured area of the building, you realize that the current infrared detectors are causing numerous false positives. You need to replace them with another option. <br>What type of motion detector senses changes in the electrical or magnetic field surrounding a monitored object?",
    "choice_a": "Wave",
    "choice_b": "Photoelectric",
    "choice_c": "Heat",
    "choice_d": "Capacitance",
    "correct_answer": "D",
    "explanation": "A capacitance motion detector senses changes in the electrical or magnetic field surrounding a monitored object. A wave pattern motion detector transmits a consistent low ultrasonic or high microwave frequency signal into a monitored area and monitors for significant or meaningful changes or disturbances in the reflected pattern. A photoelectric motion detector senses changes in visible light levels for the monitored area. Photoelectric motion detectors are usually deployed in internal rooms that have no windows and are kept dark. An infrared PIR (passive infrared) or heat-based motion detector monitors for significant or meaningful changes in the heat levels and patterns in a monitored area.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      528,
      526,
      974,
      975,
      524
    ],
    "source": ""
  },
  {
    "id": 3503,
    "question": "Dorothy is using a network sniffer to evaluate network connections. She focuses on the initialization of a TCP session. <br>What is the first phase of the TCP three-way handshake sequence?",
    "choice_a": "SYN flagged packet",
    "choice_b": "ACK flagged packet",
    "choice_c": "FIN flagged packet",
    "choice_d": "SYN/ACK flagged packet",
    "correct_answer": "A",
    "explanation": "The SYN flagged packet is first sent from the initiating host to the destination host; thus it is the first step or phase in the TCP three-way handshake sequence used to establish a TCP session. The destination host then responds with a SYN/ACK flagged packet; this is the second step or phase of the TCP three-way handshake sequence. The initiating host sends an ACK flagged packet, and the connection is then established (the final or third step or phase). The FIN flag is used to gracefully shut down an established session.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      883,
      868,
      869,
      724,
      884
    ],
    "source": ""
  },
  {
    "id": 3504,
    "question": "UDP is a connectionless protocol that operates at the Transport layer of the OSI model and uses ports to manage simultaneous connections. <br>Which of the following terms is also related to UDP?",
    "choice_a": "Bits",
    "choice_b": "Logical addressing",
    "choice_c": "Data reformatting",
    "choice_d": "Simplex",
    "correct_answer": "D",
    "explanation": "UDP is a simplex protocol at the Transport layer (layer 4 of the OSI model). Bits is associated with the Physical layer (layer 1). Logical addressing is associated with the Network layer (layer 3). Data reformatting is associated with the Presentation layer (layer 6).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      332,
      330,
      337,
      742,
      387
    ],
    "source": ""
  },
  {
    "id": 3505,
    "question": "Which of the following is a means for IPv6 and IPv4 to be able to coexist on the same network?  (Select all that apply.)",
    "choice_a": "Dual stack",
    "choice_b": "Tunneling",
    "choice_c": "IPsec",
    "choice_d": "NAT-PT",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The means by which IPv6 and IPv4 can coexist on the same network is to use one or more of three primary options: dual stack, tunneling, or NAT-PT. Dual stack is to have most systems operate both IPv4 and IPv6 and use the appropriate protocol for each conversation. Tunneling allows most systems to operate a single stack of either IPv4 or IPv6 and use an encapsulation tunnel to access systems of the other protocol. Network Address Translation-Protocol Translation (NAT-PT) (RFC-2766) can be used to convert between IPv4 and IPv6 network segments similar to how NAT converts between internal and external addresses. IPsec is a standard of IP security extensions used as an add-on for IPv4 and integrated into IPv6, but it does not enable the use of both IPv4 and IPv6 on the same system (although it doesn't prevent it either). IP sideloading is not a real concept.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      346,
      412,
      423,
      333,
      413
    ],
    "source": "",
    "choice_e": "IP sideloading"
  },
  {
    "id": 3506,
    "question": "Security configuration guidelines issued by your CISO require that all HTTP communications be secure when communicating with internal web services. <br>Which of the following is true in regards to using TLS?  (Select all that apply.)",
    "choice_a": "Allows for use of TCP port 443",
    "choice_b": "Prevents tampering, spoofing, and eavesdropping",
    "choice_c": "Requires two-way authentication",
    "choice_d": "Is backward compatible with SSL sessions",
    "correct_answer": [
      "A",
      "B",
      "E"
    ],
    "explanation": "TLS allows for use of TCP port 443; prevents tampering, spoofing, and eavesdropping; and can be used as a VPN solution. The other answers are incorrect. TLS supports both one-way and two-way authentication. TLS and SSL are not interoperable or backward compatible.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      350,
      401,
      332,
      405,
      335
    ],
    "source": "",
    "choice_e": "Can be used as a VPN solution"
  },
  {
    "id": 3507,
    "question": "Your network supports TCP/IP. TCP/IP is a multilayer protocol. It is primarily based on IPv4, but the organization is planning on deploying IPv6 within the next year. <br>What is both a benefit and a potentially harmful implication of multilayer protocols?",
    "choice_a": "Throughput",
    "choice_b": "Encapsulation",
    "choice_c": "Hash integrity checking",
    "choice_d": "Logical addressing",
    "correct_answer": "B",
    "explanation": "Encapsulation is both a benefit and a potentially harmful implication of multilayer protocols. Encapsulation allows for encryption, flexibility, and resiliency, while also enabling covert channels, filter bypass, and overstepping network segmentation boundaries. Throughput is the capability of moving data across or through a network; this is not an implication of multilayer protocols. Hash integrity checking is a common benefit of multilayer protocols because most layers include a hash function in their header or footer. Logical addressing is a benefit of multilayer protocols; this avoids the restriction of using only physical addressing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      351,
      333,
      742,
      412,
      347
    ],
    "source": ""
  },
  {
    "id": 3508,
    "question": "A new VoIP system is being deployed at a government contractor organization. They require high availability of five nines of uptime for the voice communication system. They are also concerned about introducing new vulnerabilities into their existing data network structure. The IT infrastructure is based on fiber optics and supports over 1 Gbps to each device; the network often reaches near full saturation on a regular basis. <br>What option will provide the best outcome of performance, availability, and security for the VoIP service?",
    "choice_a": "Create a new VLAN on the existing IT network for the VoIP service.",
    "choice_b": "Replace the current switches with routers and increase the interface speed to 1,000 Mbps.",
    "choice_c": "Implement a new, separate network for the VoIP system.",
    "choice_d": "Deploy flood guard protections on the IT network.",
    "correct_answer": "C",
    "explanation": "In this scenario, the only viable option to provide performance, availability, and security for the VoIP service is to implement a new, separate network for the VoIP system that is independent of the existing data network. The current data network is already at capacity, so creating a new VLAN will not provide sufficient insurance that the VoIP service will be highly available. Replacing switches with routers is usually not a valid strategy for increasing network capacity, and 1,000 Mbps is the same as 1 Gbps. Flood guards are useful against DoS and some transmission errors (such as Ethernet floods or broadcast storms), but they do not add more capacity to a network or provide reliable uptime for a VoIP service.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      394,
      404,
      438,
      406,
      412
    ],
    "source": ""
  },
  {
    "id": 3509,
    "question": "Microsegmentation is dividing up an internal network in numerous subzones, potentially as small as a single device, such as a high-value server or even a client or endpoint device. <br>Which of the following is true in regard to microsegmentation?  (Select all that apply.)",
    "choice_a": "It is the assignment of the cores of a CPU to perform different tasks.",
    "choice_b": "It can be implemented using ISFWs.",
    "choice_c": "Transactions between zones are filtered.",
    "choice_d": "It supports edge and fog computing management.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "Microsegmentation can be implemented using internal segmentation firewalls (ISFWs), transactions between zones are filtered, and it can be implemented with virtual systems and virtual networks. Affinity or preference is the assignment of the cores of a CPU to perform different tasks. Microsegmentation is not related to edge and fog computing management.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      357,
      356,
      355,
      971,
      379
    ],
    "source": "",
    "choice_e": "It can be implemented with virtual systems and virtual networks."
  },
  {
    "id": 3510,
    "question": "A new startup company is designing a sensor that needs to connect wirelessly to a PC or IoT hub in order to transmit its gathered data to a local application or cloud service for data analysis. The company wants to ensure that all transferred data from the device cannot be disclosed to unauthorized entities. The device is also intended to be located within 1 meter of the PC or IoT hub it communicates with. <br>Which of the following concepts is the best choice for this device?",
    "choice_a": "Zigbee",
    "choice_b": "Bluetooth",
    "choice_c": "FCoE",
    "choice_d": "5G",
    "correct_answer": "A",
    "explanation": "The device in this scenario would benefit from the use of Zigbee. Zigbee is an IoT equipment communications concept that is based on Bluetooth. Zigbee has low power consumption and a low throughput rate, and it requires close proximity of devices. Zigbee communications are encrypted using a 128-bit symmetric algorithm. Bluetooth is not a good option since it is usually plaintext. Bluetooth Low Energy (BLE) might be a viable option if custom encryption was added. Fiber Channel over Ethernet (FCoE) is not a wireless technology or an IoT technology\u2014it is a high-speed fiber optic\u2013based storage technology. 5G is the latest mobile service technology that is available for use on mobile phones, tablets, and other equipment. Though many IoT devices may support and use 5G, it is mostly used to provide direct access to the internet rather than as a link to a local short-distance device, such as a PC or IoT hub.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      734,
      364,
      733,
      330,
      333
    ],
    "source": ""
  },
  {
    "id": 3511,
    "question": "James has been hired to be a traveling repair technician. He will be visiting customers all over the country in order to provide support services. He has been issued a portable workstation with 4G and 5G data service. <br>What are some concerns when using this capability?  (Select all that apply.)",
    "choice_a": "Eavesdropping",
    "choice_b": "Rogue towers",
    "choice_c": "Data speed limitations",
    "choice_d": "Reliability of establishing a connection",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Cellular services, such as 4G and 5G, raise numerous security and operational concerns. Although cellular service is encrypted from device to tower, there is a risk of being fooled by a false or rogue tower. A rogue tower could offer only plaintext connections, but even if it supported encrypted transactions, the encryption only applies to the radio transmissions between the device and the tower. Once the communication is on the tower, it will be decrypted, allowing for eavesdropping and content manipulation. Even without a rogue tower, eavesdropping can occur across the cellular carrier's interior network as well as across the internet, unless a VPN link is established between the remote mobile device and the network of the organization James works for. Being able to establish a connection can be unreliable depending on exactly where James's travel takes him. 3G, 4G, and 5G coverage is not 100 percent available everywhere. 5G coverage is the most limited since it is the latest technology and still not universally deployed, and each 5G tower covers less area than a 4G tower. If James is able to establish a connection, 4G and 5G speeds should be sufficient for most remote technician activities, since 4G supports 100 Mbps for mobile devices and 5G supports up to 10 Gbps. If connectivity is established, there should be no issues with cloud interaction or duplex conversations.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      372,
      417,
      414,
      400,
      436
    ],
    "source": "",
    "choice_e": "Compatibility with cloud services",
    "choice_f": "Unable to perform duplex communications"
  },
  {
    "id": 3512,
    "question": "A new startup company needs to optimize delivery of high-definition media content to its customers. They are planning the deployment of resource service hosts in numerous data centers across the world in order to provide low latency, high performance, and high availability of the hosted content. <br>What technology is likely being implemented?",
    "choice_a": "VPN",
    "choice_b": "CDN",
    "choice_c": "SDN",
    "choice_d": "CCMP",
    "correct_answer": "B",
    "explanation": "A content distribution network (CDN), or content delivery network, is a collection of resource service hosts deployed in numerous data centers across the world in order to provide low latency, high performance, and high availability of the hosted content. VPNs are used to transport communications over an intermediary medium through the means of encapsulation (i.e., tunneling), authentication, and encryption. Software-defined networking (SDN) aims at separating the infrastructure layer from the control layer on networking hardware in order to reduce management complexity. Counter Mode with Cipher Block Chaining Message Authentication Code Protocol (CCMP) (Counter-Mode/CBC-MAC Protocol) is the combination of two block cipher modes to enable streaming by a block algorithm.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      405,
      406,
      354,
      430
    ],
    "source": ""
  },
  {
    "id": 3513,
    "question": "Which of the following is a true statement about ARP poisoning or MAC spoofing?",
    "choice_a": "MAC spoofing is used to overload the memory of a switch.",
    "choice_b": "ARP poisoning is used to falsify the physical address of a system to impersonate that of another authorized device.",
    "choice_c": "MAC spoofing relies on ICMP communications to traverse routers.",
    "choice_d": "ARP poisoning can use unsolicited or gratuitous replies.",
    "correct_answer": "D",
    "explanation": "The true statement is: ARP poisoning can use unsolicited or gratuitous replies\u2014specifically, ARP replies for which the local device did not transmit an ARP broadcast request. Many systems accept all ARP replies regardless of who requested them. The other statements are false. The correct versions of those statements would be: (A) MAC flooding is used to overload the memory of a switch, specifically the CAM table stored in switch memory when bogus information will cause the switch to function only in flooding mode. (B) MAC spoofing is used to falsify the physical address of a system to impersonate that of another authorized device. ARP poisoning associates an IP address with the wrong MAC address. (C) MAC spoofing relies on plaintext Ethernet headers to initially gather valid MAC addresses of legitimate network devices. ICMP crosses routers because it is carried as the payload of an IP packet.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      349,
      338,
      420,
      418,
      331
    ],
    "source": ""
  },
  {
    "id": 3514,
    "question": "An organization stores group project data files on a central SAN. Many projects have numerous files in common but are organized into separate project containers. A member of the incident response team is attempting to recover files from the SAN after a malware infection. However, many files are unable to be recovered. <br>What is the most likely cause of this issue?",
    "choice_a": "Using Fibre Channel",
    "choice_b": "Performing real-time backups",
    "choice_c": "Using file encryption",
    "choice_d": "Deduplication",
    "correct_answer": "D",
    "explanation": "The most likely cause of the inability to recover files from the SAN in this scenario is deduplication. Deduplication replaces multiple copies of a file with a pointer to one copy. If the one remaining file is damaged, then all of the linked copies are damaged or inaccessible as well. File encryption could be an issue, but the scenario mentions that groups of people work on projects and typically file encryption is employed by individuals, not by groups. Whole-drive encryption would be more appropriate for group-accessed files as well as for a SAN in general. This issue is not related to what SAN technology is used, such as Fibre Channel. This problem might be solvable by restoring files from a backup, whether real-time or not, but the loss of files is not caused by performing backups.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      352,
      379,
      385,
      406,
      744
    ],
    "source": ""
  },
  {
    "id": 3515,
    "question": "Jim was tricked into clicking on a malicious link contained in a spam email message. This caused malware to be installed on his system. The malware initiated a MAC flooding attack. Soon, Jim's system and everyone else's in the same local network began to receive all transmissions from all other members of the network as well as communications from other parts of the next-to-local members. The malware took advantage of what condition in the network?",
    "choice_a": "Social engineering",
    "choice_b": "Network segmentation",
    "choice_c": "ARP queries",
    "choice_d": "Weak switch configuration",
    "correct_answer": "D",
    "explanation": "In this scenario, the malware is performing a MAC flooding attack, which causes the switch to get stuck in flooding mode. This has taken advantage of the condition that the switch had weak configuration settings. The switch should have MAC limiting enabled in order to prevent MAC flooding attacks from being successful. Although Jim was initially fooled by a social engineering email, the question asked about the malware's activity. A MAC flooding attack is limited by network segmentation to the local switch, but the malware took advantage of weak or poor configuration on the switch and was still successful. MAC flooding is blocked by routers from crossing between switched network segments. The malware did not use ARP queries in its attack. ARP queries can be abused in an ARP poisoning attack, but that was not described in this scenario.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      418,
      393,
      378,
      331,
      349
    ],
    "source": ""
  },
  {
    "id": 3516,
    "question": "A ______________ is an intelligent hub because it knows the hardware addresses of the systems connected on each outbound port. Instead of repeating traffic on every outbound port, it repeats traffic only out of the port on which the destination is known to exist.",
    "choice_a": "Repeater",
    "choice_b": "Switch",
    "choice_c": "Bridge",
    "choice_d": "Router",
    "correct_answer": "B",
    "explanation": "A switch is an intelligent hub. It is considered to be intelligent because it knows the addresses of the systems connected on each outbound port. Repeaters are used to strengthen the communication signal over a cable segment as well as connect network segments that use the same protocol. A bridge is used to connect two networks together\u2014even networks of different topologies, cabling types, and speeds\u2014in order to connect network segments that use the same protocol. Routers are used to control traffic flow on networks and are often used to connect similar networks and control traffic flow between the two. Routers manage traffic based on logical IP addressing.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      330,
      338,
      419,
      349,
      422
    ],
    "source": ""
  },
  {
    "id": 3517,
    "question": "What type of security zone can be positioned so that it operates as a buffer between the secured private network and the internet and can host publicly accessible services?",
    "choice_a": "Honeypot",
    "choice_b": "Screened subnet",
    "choice_c": "Extranet",
    "choice_d": "Intranet",
    "correct_answer": "B",
    "explanation": "A screened subnet is a type of security zone that can be positioned so that it operates as a buffer network between the secured private network and the internet and can host publicly accessible services. A honeypot is a false network used to trap intruders; it isn't used to host public services. An extranet is for limited outside partner access, not public. An intranet is the private secured network.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      374,
      355,
      950,
      427,
      423
    ],
    "source": ""
  },
  {
    "id": 3518,
    "question": "An organization wants to use a wireless network internally, but they do not want any possibility of external access or detection. <br>What security tool should be used?",
    "choice_a": "Air gap",
    "choice_b": "Faraday cage",
    "choice_c": "Biometric authentication",
    "choice_d": "Screen filters",
    "correct_answer": "B",
    "explanation": "A Faraday cage is an enclosure that blocks or absorbs electromagnetic fields or signals. Faraday cage containers, computer cases, rack-mount systems, rooms, or even building materials are used to create a blockage against the transmission of data, information, metadata, or other emanations from computers and other electronics. Devices inside a Faraday cage can use EM fields for communications, such as wireless or Bluetooth, but devices outside of the cage will not be able to eavesdrop on the signals of the systems within the cage. Air gaps do not contain or restrict wireless communications\u2014in fact, for an air gap to be effective, wireless cannot even be available. Biometric authentication has nothing to do with controlling radio signals. Screen filters reduce shoulder surfing but do not address radio signals.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      379,
      388,
      363,
      370,
      389
    ],
    "source": ""
  },
  {
    "id": 3519,
    "question": "Neo is the security manager for the southern division of the company. He thinks that deploying a NAC will assist in improving network security. However, he needs to convince the CISO of this at a presentation next week. <br>Which of the following are goals of NAC that Neo should highlight?  (Select all that apply.)",
    "choice_a": "Reduce social engineering threats",
    "choice_b": "Detect rogue devices",
    "choice_c": "Map internal private addresses to external public addresses",
    "choice_d": "Distribute IP address configurations",
    "correct_answer": [
      "B",
      "E",
      "F"
    ],
    "explanation": "Network access control (NAC) involves controlling access to an environment through strict adherence to and implementation of security policy. The goals of NAC are to detect/block rogue devices, prevent or reduce zero-day attacks, confirm compliance with updates and security settings, enforce security policy throughout the network, and use identities to perform access control. NAC does not address social engineering, mapping IP addresses, or distributing IP addresses\u2014those are handled by training, NAT, and DHCP, respectively.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      377,
      388,
      392,
      379,
      363
    ],
    "source": "",
    "choice_e": "Reduce zero-day attacks",
    "choice_f": "Confirm compliance with updates and security settings"
  },
  {
    "id": 3520,
    "question": "The CISO wants to improve the organization's ability to manage and prevent malware infections. Some of her goals are to (1) detect, record, evaluate, and respond to suspicious activities and events, which may be caused by problematic software or by valid and invalid users, (2) collect event information and report it to a central ML analysis engine, and (3) detect abuses that are potentially more advanced than what can be detected by traditional antivirus or HIDSs. The solution needs to be able to reduce response and remediation time, reduce false positives, and manage multiple threats simultaneously. <br>What solution is the CISO wanting to implement?",
    "choice_a": "EDR",
    "choice_b": "NGFW",
    "choice_c": "WAF",
    "choice_d": "XSRF",
    "correct_answer": "A",
    "explanation": "Endpoint detection and response (EDR) is a security mechanism that is an evolution of traditional anti-malware products. EDR seeks to detect, record, evaluate, and respond to suspicious activities and events, which may be caused by problematic software or by valid and invalid users. It is a natural extension of continuous, monitoring focusing on both the endpoint device itself and network communications reaching the local interface. Some EDR solutions employ an on-device analysis engine whereas others report events back to a central analysis server or to a cloud solution. The goal of EDR is to detect abuses that are potentially more advanced than what can be detected by traditional antivirus or HIDSs, while optimizing the response time of incident response, discarding false positives, implementing blocking for advanced threats, and protecting against multiple threats occurring simultaneously and via various threat vectors. A next-generation firewall (NGFW) is a unified threat management (UTM) device that is based on a traditional firewall with numerous other integrated network and security services and is thus not the security solution needed in this scenario. A web application firewall (WAF) is an appliance, server add-on, virtual service, or system filter that defines a strict set of communication rules for a website and is not the security solution needed in this scenario. Cross-site request forgery (XSRF) is an attack against web-based services, not a malware defense.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      380,
      379,
      375,
      400,
      401
    ],
    "source": ""
  },
  {
    "id": 3521,
    "question": "A(n) _________________ firewall is able to make access control decisions based on the content of communications as well as the parameters of the associated protocol and software.",
    "choice_a": "Application-level",
    "choice_b": "Stateful inspection",
    "choice_c": "Circuit-level",
    "choice_d": "Static packet filtering",
    "correct_answer": "A",
    "explanation": "An application-level firewall is able to make access control decisions based on the content of communications as well as the parameters of the associated protocol and software. Stateful inspection firewalls make access control decisions based on the content and context of communications, but are not typically limited to a single application-layer protocol. Circuit-level firewalls are able to make permit and deny decisions in regard to circuit establishment either based on simple rules for IP and port, using captive portals, requiring port authentication via 802.1X, or more complex elements such as context- or attribute-based access control. Static packet-filtering firewalls filter traffic by examining data from a message header. Usually, the rules are concerned with source and destination IP address (layer 3) and port numbers (layer 4).",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      551,
      548,
      544,
      554,
      542
    ],
    "source": ""
  },
  {
    "id": 3522,
    "question": "Which of the following is true regarding appliance firewalls?  (Select all that apply.)",
    "choice_a": "They are able to log traffic information.",
    "choice_b": "They are able to block new phishing scams.",
    "choice_c": "They are able to issue alarms based on suspected attacks.",
    "choice_d": "They are unable to prevent internal attacks.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Most appliance (i.e., hardware) firewalls offer extensive logging, auditing, and monitoring capabilities as well as alarms/alerts and even basic IDS functions. It is also true that firewalls are unable to prevent internal attacks that do not cross the firewall. Firewalls are unable to block new phishing scams. Firewalls could block a phishing scam's URL if it was already on a block list, but a new scam likely uses a new URL that is not yet known to be malicious.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      551,
      556,
      548,
      550,
      841
    ],
    "source": ""
  },
  {
    "id": 3523,
    "question": "Among the many aspects of a security solution, the most important is whether it addresses a specific need (i.e., a threat) for your assets. But there are many other aspects of security you should consider as well. A significant benefit of a security control is when it goes unnoticed by users. <br>What is this called?",
    "choice_a": "Invisibility",
    "choice_b": "Transparency",
    "choice_c": "Diversion",
    "choice_d": "Hiding in plain sight",
    "correct_answer": "B",
    "explanation": "When transparency is a characteristic of a service, security control, or access mechanism, it is unseen by users. Invisibility is not the proper term for a security control that goes unnoticed by valid users. Invisibility is sometimes used to describe a feature of a rootkit, which attempts to hide itself and other files or processes. Diversion is a feature of a honeypot but not of a typical security control. Hiding in plain sight is not a security concept; it is a mistake on the part of the observer not to notice something that they should notice. This is not the same concept as camouflage, which is when an object or subject attempts to blend into the surroundings.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      401,
      400,
      379,
      393,
      394
    ],
    "source": ""
  },
  {
    "id": 3524,
    "question": "Extensible Authentication Protocol (EAP) is one of the three authentication options provided by Point-to-Point Protocol (PPP). EAP allows customized authentication security solutions. <br>Which of the following are examples of actual EAP methods?  (Select all that apply.)",
    "choice_a": "LEAP",
    "choice_b": "EAP-VPN",
    "choice_c": "PEAP",
    "choice_d": "EAP-SIM",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E",
      "G",
      "I",
      "J",
      "K"
    ],
    "explanation": "More than 40 EAP methods have been defined, including LEAP, PEAP, EAP-SIM, EAP-FAST, EAP-MD5, EAP-POTP, EAP-TLS, and EAP-TTLS. The other options are not valid EAP methods.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      391,
      390,
      362,
      437,
      392
    ],
    "source": "",
    "choice_e": "EAP-FAST",
    "choice_f": "EAP-MBL",
    "choice_g": "EAP-MD5",
    "choice_h": "VEAP",
    "choice_i": "EAP-POTP",
    "choice_j": "EAP-TLS",
    "choice_k": "EAP-TTLS"
  },
  {
    "id": 3525,
    "question": "In addition to maintaining an updated system and controlling physical access, which of the following is the most effective countermeasure against PBX fraud and abuse?",
    "choice_a": "Encrypting communications",
    "choice_b": "Changing default passwords",
    "choice_c": "Using transmission logs",
    "choice_d": "Taping and archiving all conversations",
    "correct_answer": "B",
    "explanation": "Changing default passwords on PBX systems provides the most effective increase in security. PBX systems typically do not support encryption, although some VoIP PBX systems may support encryption in specific conditions. PBX transmission logs may provide a record of fraud and abuse, but they are not a preventive measure to stop it from happening. Taping and archiving all conversations is also a detective measure rather than a preventive one against fraud and abuse.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      438,
      353,
      398,
      396
    ],
    "source": ""
  },
  {
    "id": 3526,
    "question": "A phreaker has been apprehended who had been exploiting the technology deployed in your office building. Several handcrafted tools and electronics were taken in as evidence that the phreaker had in their possession when they were arrested. <br>What was this adversary likely focusing on with their attempts to compromise the organization?",
    "choice_a": "Accounting",
    "choice_b": "NAT",
    "choice_c": "PBX",
    "choice_d": "Wi-Fi",
    "correct_answer": "C",
    "explanation": "Malicious attackers known as phreakers abuse phone systems in much the same way that attackers abuse computer networks. In this scenario, they were most likely focused on the PBX. Private branch exchange (PBX) is a telephone switching or exchange system deployed in private organizations in order to enable multistation use of a small number of external PSTN lines. Phreakers generally do not focus on accounting (that would be an invoice scam), NAT (that would be a network intrusion attack), or Wi-Fi (another type of network intrusion attack).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      397,
      396,
      353,
      398,
      400
    ],
    "source": ""
  },
  {
    "id": 3527,
    "question": "Multimedia collaboration is the use of various multimedia-supporting communication solutions to enhance distance collaboration (people working on a project together remotely). Often, collaboration allows workers to work simultaneously as well as across different time frames. <br>Which of the following are important security mechanisms to impose on multimedia collaboration tools?  (Select all that apply.)",
    "choice_a": "Encryption of communications",
    "choice_b": "Multifactor authentication",
    "choice_c": "Customization of avatars and filters",
    "choice_d": "Logging of events and activities",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "It is important to verify that multimedia collaboration connections are encrypted, that robust multifactor authentication is in use, and that tracking and logging of events and activities is available for the hosting organization to review. Customization of avatars and filters is not a security concern.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      403,
      401,
      400,
      416,
      391
    ],
    "source": ""
  },
  {
    "id": 3528,
    "question": "Michael is configuring a new web server to offer instruction manuals and specification sheets to customers. The web server has been positioned in the screened subnet and assigned an IP address of 172.31.201.17, and the public side of the company's split-DNS has associated the <code>documents.myexamplecompany.com</code> domain name with the assigned IP. After verifying that the website is accessible from his management station (which accesses the screened subnet via a jumpbox) as well as from several worker desktop systems, he declares the project completed and heads home. A few hours later, Michael thinks of a few additional modifications to perform to improve site navigation. However, when he attempts to connect to the new website using the FQDN, he receives a connection error stating that the site cannot be reached. <br>What is the reason for this issue?",
    "choice_a": "The jumpbox was not rebooted.",
    "choice_b": "Split-DNS does not support internet domain name resolution.",
    "choice_c": "The browser is not compatible with the site's coding.",
    "choice_d": "A private IP address from RFC 1918 is assigned to the web server.",
    "correct_answer": "D",
    "explanation": "The issue in this scenario is that a private IP address from RFC 1918 is assigned to the web server. RFC 1918 addresses are not internet routable or accessible because they are reserved for private or internal use only. So, even with the domain name linked to the address, any attempt to access it from an internet location will fail. Local access via jumpbox or LAN system likely uses an address in the same private IP address range and has no issues locally. The issue of the scenario (i.e., being unable to access a website using its FQDN)  could be resolved by either using a public IP address or implementing static NAT on the screened subnet's boundary firewall. The jumpbox would not prevent access to the website regardless of whether it was rebooted, in active use, or turned off. That would only affect Michael's use of it from his desktop workstation. Split-DNS does support internet-based domain name resolution; it separates internal-only domain information from external domain information. A web browser should be compatible with the coding of most websites. Since there was no mention of custom coding and the site was intended for public use, it is probably using standard web technologies. Also, since Michael's workstation and several worker desktops could access the website, the problem is probably not related to the browser.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      949,
      425,
      951,
      423,
      374
    ],
    "source": ""
  },
  {
    "id": 3529,
    "question": "Mark is configuring the remote access server to receive inbound connections from remote workers. He is following a configuration checklist to ensure that the telecommuting links are compliant with company security policy. <br>What authentication protocol offers no encryption or protection for logon credentials?",
    "choice_a": "PAP",
    "choice_b": "CHAP",
    "choice_c": "EAP",
    "choice_d": "RADIUS",
    "correct_answer": "A",
    "explanation": "Password Authentication Protocol (PAP) is a standardized authentication protocol for PPP. PAP transmits usernames and passwords in the clear. It offers no form of encryption. It provides a means to transport the logon credentials from the client to the authentication server. CHAP protects the password by never sending it across the network; it is used in computing a response along with a random challenge number issued by the server. EAP offers some means of authentication that protects and/or encrypts credentials, but not all of the options do. RADIUS supports a range of options to protect and encrypt logon credentials.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      390,
      437,
      391,
      400,
      401
    ],
    "source": ""
  },
  {
    "id": 3531,
    "question": "While evaluating network traffic, you discover several addresses that you are not familiar with. Several of the addresses are in the range of addresses assigned to internal network segments. <br>Which of the following IP addresses are private IPv4 addresses as defined by RFC 1918?  (Select all that apply.)",
    "choice_a": "10.0.0.18",
    "choice_b": "169.254.1:.119",
    "choice_c": "172.31.8.204",
    "choice_d": "192.168.6.43",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The addresses in RFC 1918 are 10.0.0.0\u201310.255.255.255, 172.16.0.0\u2013172.31.255.255, and 192.168.0.0\u2013192.168.255.255. Therefore, 10.0.0.18, 172.31.8.204, and 192.168.6.43 are private IPv4 addresses. The 169.254.x.x subnet is in the APIPA range, which is not part of RFC 1918.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      425,
      949,
      896,
      423,
      738
    ],
    "source": ""
  },
  {
    "id": 3532,
    "question": "The CISO has requested a report on the potential communication partners throughout the company. There is a plan to implement VPNs between all network segments in order to improve security against eavesdropping and data manipulation. <br>Which of the following cannot be linked over a VPN?",
    "choice_a": "Two distant internet-connected LANs",
    "choice_b": "Two systems on the same LAN",
    "choice_c": "A system connected to the internet and a LAN connected to the internet",
    "choice_d": "Two systems without an intermediary network connection",
    "correct_answer": "D",
    "explanation": "An intermediary network connection is required for a VPN link to be established. A VPN can be established between devices over the internet, between devices over a LAN, or between a system on the internet and a LAN.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      417,
      412,
      439,
      413,
      374
    ],
    "source": ""
  },
  {
    "id": 3533,
    "question": "What networking device can be used to create digital virtual network segments that can be altered as needed by adjusting the settings internal to the device?",
    "choice_a": "Router",
    "choice_b": "Switch",
    "choice_c": "Proxy",
    "choice_d": "Firewall",
    "correct_answer": "B",
    "explanation": "A switch is a networking device that can be used to create digital virtual network segments (i.e., VLANs) that can be altered as needed by adjusting the settings internal to the device. A router connects disparate networks (i.e., subnets) rather than creating network segments. Subnets are created by IP address and subnet mask assignment. Proxy and firewall devices do not create digital virtual network segments, but they may be positioned between network segments to control and manage traffic.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      419,
      1013,
      356,
      355,
      354
    ],
    "source": ""
  },
  {
    "id": 3534,
    "question": "The CISO is concerned that the use of subnets as the only form of network segments is limiting growth and flexibility of the network. They are considering the implementation of switches to support VLANs but aren't sure VLANs are the best option. <br>Which of the following is not a benefit of VLANs?",
    "choice_a": "Traffic isolation",
    "choice_b": "Data/traffic encryption",
    "choice_c": "Traffic management",
    "choice_d": "Reduced vulnerability to sniffers",
    "correct_answer": "B",
    "explanation": "VLANs do not impose encryption on data or traffic. Encrypted traffic can occur within a VLAN, but encryption is not imposed by the VLAN. VLANs do provide traffic isolation, traffic management and control, and a reduced vulnerability to sniffers.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      419,
      1013,
      421,
      418,
      375
    ],
    "source": ""
  },
  {
    "id": 3535,
    "question": "The CISO has tasked you to design and implement an IT port security strategy. While researching the options, you realize there are several potential concepts that are labeled as port security. You prepare a report to present options to the CISO. <br>Which of the following are port security concepts you should include on this report?  (Select all that apply.)",
    "choice_a": "Shipping container storage",
    "choice_b": "NAC",
    "choice_c": "Transport Layer",
    "choice_d": "RJ-45\u00a0jacks",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Port security can refer to several concepts, including network access control (NAC), Transport layer ports, and RJ-45 jack ports. NAC requires authentication before devices can communicate on the network. Transport-layer port security involves using firewalls to grant or deny communications to TCP and UDP ports. RJ-45 jacks should be managed so that unused ports are disabled and that when a cable is disconnected, the port is disabled. This approach prevents the connection of unauthorized devices. Shipping container storage relates to shipping ports, which is a type of port that is not specifically related to IT or typically managed by a CISO.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      393,
      337,
      437,
      349,
      419
    ],
    "source": ""
  },
  {
    "id": 3536,
    "question": "______________ is the oversight and management of the efficiency and performance of network communications. Items to measure include throughput rate, bit rate, packet loss, latency, jitter, transmission delay, and availability.",
    "choice_a": "VPN",
    "choice_b": "QoS",
    "choice_c": "SDN",
    "choice_d": "Sniffing",
    "correct_answer": "B",
    "explanation": "Quality of service (QoS) is the oversight and management of the efficiency and performance of network communications. Items to measure include throughput rate, bit rate, packet loss, latency, jitter, transmission delay, and availability. A virtual private network (VPN) is a communication channel between two entities across an intermediary untrusted network. Software-defined networking (SDN) aims at separating the infrastructure layer from the control layer on networking hardware in order to reduce management complexity. Sniffing captures network packers for analysis. QoS uses sniffing, but sniffing itself is not QoS.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      394,
      404,
      1071,
      386,
      333
    ],
    "source": ""
  },
  {
    "id": 3537,
    "question": "You are configuring a VPN to provide secure communications between systems. You want to minimize the information left in plaintext by the encryption mechanism of the chosen solution. <br>Which IPsec mode provides for encryption of complete packets, including header information?",
    "choice_a": "Transport",
    "choice_b": "Encapsulating Security Payload",
    "choice_c": "Authentication Header",
    "choice_d": "Tunnel",
    "correct_answer": "D",
    "explanation": "When IPsec is used in tunnel mode, entire packets, rather than just the payload, are encrypted. Transport mode only encrypts the original payload, not the original header. Encapsulating Security Payload (ESP) is the encrypter of IPsec, not the mode of VPN connection. Authentication Header (AH) is the primary authentication mechanism of IPsec.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      413,
      416,
      412,
      350,
      414
    ],
    "source": ""
  },
  {
    "id": 3538,
    "question": "Internet Protocol Security (IPsec) is a standard of IP security extensions used as an add-on for IPv4 and integrated into IPv6. <br>What IPsec component provides assurances of message integrity and nonrepudiation?",
    "choice_a": "Authentication Header",
    "choice_b": "Encapsulating Security Payload",
    "choice_c": "IP Payload Compression protocol",
    "choice_d": "Internet Key Exchange",
    "correct_answer": "A",
    "explanation": "Authentication Header (AH) provides assurances of message integrity and nonrepudiation. Encapsulating Security Payload (ESP) provides confidentiality and integrity of payload contents. ESP also provides encryption, offers limited authentication, and prevents replay attacks. IP Payload Compression (IPComp) is a compression tool used by IPsec to compress data prior to ESP encrypting it in order to attempt to keep up with wire speed transmission. Internet Key Exchange (IKE) is the mechanism of IPsec that manages cryptography keys and is composed of three elements: OAKLEY, SKEME, and ISAKMP.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      416,
      411,
      413,
      439,
      346
    ],
    "source": ""
  },
  {
    "id": 3539,
    "question": "When you're designing a security system for internet-delivered email, which of the following is least important?",
    "choice_a": "Nonrepudiation",
    "choice_b": "Data remanent destruction",
    "choice_c": "Message integrity",
    "choice_d": "Access restriction",
    "correct_answer": "B",
    "explanation": "Data remanent destruction is a security concern related to storage technologies more so than an email solution. Essential email concepts, which local systems can enforce and protect, include nonrepudiation, message integrity, and access restrictions.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      409,
      407,
      408,
      410,
      379
    ],
    "source": ""
  },
  {
    "id": 3540,
    "question": "You have been tasked with crafting the organization's email retention policy. <br>Which of the following is typically not an element that must be discussed with end users in regard to email retention policies?",
    "choice_a": "Privacy",
    "choice_b": "Auditor review",
    "choice_c": "Length of retainer",
    "choice_d": "Backup method",
    "correct_answer": "D",
    "explanation": "The backup method is not an important factor to discuss with end users regarding email retention. The details of an email retention policy may need to be shared with affected subjects, which may include privacy implications, how long the messages are maintained (i.e., length of retainer), and for what purposes the messages can be used (such as auditing or violation investigations).",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      407,
      410,
      430,
      379,
      427
    ],
    "source": ""
  },
  {
    "id": 3541,
    "question": "Modern networks are built on multilayer protocols, such as TCP/IP. This provides for flexibility and resiliency in complex network structures. All of the following are implications of multilayer protocols except which one?",
    "choice_a": "VLAN hopping",
    "choice_b": "Multiple encapsulation",
    "choice_c": "Filter evasion using tunneling",
    "choice_d": "Static IP addressing",
    "correct_answer": "D",
    "explanation": "Static IP addressing is not an implication of multilayer protocols; it is a feature of the IP protocol when an address is defined on the local system rather than being dynamically assigned by DHCP. Multilayer protocols include the risk of VLAN hopping, multiple encapsulation, and filter evasion using tunneling.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      351,
      333,
      412,
      331,
      345
    ],
    "source": ""
  },
  {
    "id": 3542,
    "question": "Which of the following is a type of connection that can be described as a logical circuit that always exists and is waiting for the customer to send data?",
    "choice_a": "SDN",
    "choice_b": "PVC",
    "choice_c": "VPN",
    "choice_d": "SVC",
    "correct_answer": "B",
    "explanation": "A permanent virtual circuit (PVC) can be described as a logical circuit that always exists and is waiting for the customer to send data. Software-defined networking (SDN) is a unique approach to network operation, design, and management. SDN aims at separating the infrastructure layer (hardware and hardware-based settings) from the control layer (network services of data transmission management). A virtual private network (VPN) is a communication channel between two entities across an intermediary untrusted network. A switched virtual circuit (SVC) has to be created each time it is needed using the best paths currently available before it can be used and then disassembled after the transmission is complete.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      432,
      431,
      354,
      427,
      439
    ],
    "source": ""
  },
  {
    "id": 3543,
    "question": "Which of the following <italic>best</italic> describes an implicit deny principle?",
    "choice_a": "All actions that are not expressly denied are allowed.",
    "choice_b": "All actions that are not expressly allowed are denied.",
    "choice_c": "All actions must be expressly denied.",
    "choice_d": "None of the above.",
    "correct_answer": "B",
    "explanation": "The implicit deny principle ensures that access to an object is denied unless access has been expressly allowed (or explicitly granted) to a subject. It does not allow all actions that are not denied, and it doesn't require all actions to be denied.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      463,
      470,
      465,
      468,
      467
    ],
    "source": ""
  },
  {
    "id": 3544,
    "question": "A table includes multiple objects and subjects, and it identifies the specific access each subject has to different objects. <br>What is this table?",
    "choice_a": "Access control list",
    "choice_b": "Access control matrix",
    "choice_c": "Federation",
    "choice_d": "Creeping privilege",
    "correct_answer": "B",
    "explanation": "An access control matrix includes multiple objects and subjects. It identifies access granted to subjects (such as users) to objects (such as files). A single list of subjects for any specific object within an access control matrix is an access control list. A federation refers to a group of companies that share a federated identity management (FIM) system for single sign-on (SSO). Creeping privileges refers to excessive privileges a subject gathers over time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      463,
      465,
      462,
      457,
      472
    ],
    "source": ""
  },
  {
    "id": 3545,
    "question": "You are reviewing access control models and want to implement a model that allows the owner of an object to grant privileges to other users. <br>Which of the following meets this requirement?",
    "choice_a": "Mandatory Access Control (MAC) model",
    "choice_b": "Discretionary Access Control (DAC) model",
    "choice_c": "Role-Based Access Control (RBAC) model",
    "choice_d": "Rule-based access control model",
    "correct_answer": "B",
    "explanation": "A discretionary access control model allows the owner (or data custodian) of a resource to grant permissions at the owner's discretion. The other answers (MAC, RBAC, and rule-based access control) are nondiscretionary models.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      465,
      491,
      472,
      493,
      466
    ],
    "source": ""
  },
  {
    "id": 3546,
    "question": "Which of the following access control models allows the owner of data to modify permissions?",
    "choice_a": "Discretionary Access Control (DAC)",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Rule-based access control",
    "choice_d": "Risk-based access control",
    "correct_answer": "A",
    "explanation": "The DAC model allows the owner of data to modify permissions on the data. In the DAC model, objects have owners, and the owners can grant or deny access to objects that they own. The MAC model uses labels to assign access based on a user's need to know and organization policies. A rule-based access control model uses rules to grant or block access. A risk-based access control model examines the environment, the situation, and policies coded in software to determine access.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      465,
      491,
      472,
      467,
      466
    ],
    "source": ""
  },
  {
    "id": 3547,
    "question": "A central authority determines which files a user can access based on the organization's hierarchy. <br>Which of the following best describes this?",
    "choice_a": "DAC model",
    "choice_b": "An access control list (ACL)",
    "choice_c": "Rule-based access control model",
    "choice_d": "RBAC model",
    "correct_answer": "D",
    "explanation": "A role-based access control (RBAC) model can group users into roles based on the organization's hierarchy, and it is a non-discretionary access control model. A non-discretionary access control model uses a central authority to determine which objects that subjects can access. In contrast, a Discretionary Access Control (DAC) model allows users to grant or reject access to any objects they own. An ACL is an example of a rule-based access control model uses rules, not roles.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      466,
      491,
      465,
      493,
      472
    ],
    "source": ""
  },
  {
    "id": 3548,
    "question": "Which of the following statements is true related to the RBAC model?",
    "choice_a": "A RBAC model allows users membership in multiple groups.",
    "choice_b": "A RBAC model allows users membership in a single group.",
    "choice_c": "A RBAC model is nonhierarchical.",
    "choice_d": "A RBAC model uses labels.",
    "correct_answer": "A",
    "explanation": "The role-based access control (RBAC) model is based on role or group membership, and users can be members of multiple groups. Users are not limited to only a single role. RBAC models are based on the hierarchy of an organization, so they are hierarchy based. The mandatory access control (MAC) model uses assigned labels to identify access.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      466,
      491,
      472,
      470,
      465
    ],
    "source": ""
  },
  {
    "id": 3549,
    "question": "You are reviewing different access control models. <br>Which of the following <italic>best</italic> describes a rule-based access control model?",
    "choice_a": "It uses local rules applied to users individually.",
    "choice_b": "It uses global rules applied to users individually.",
    "choice_c": "It uses local rules applied to all users equally.",
    "choice_d": "It uses global rules applied to all users equally.",
    "correct_answer": "D",
    "explanation": "A rule-based access control model uses global rules applied to all users and other subjects equally. It does not apply rules locally or to individual users.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      467,
      472,
      491,
      466,
      463
    ],
    "source": ""
  },
  {
    "id": 3550,
    "question": "Your organization is considering deploying a software-defined network (SDN) in the data center. <br>Which of the following access control models is commonly used in a SDN?",
    "choice_a": "Mandatory Access Control (MAC) model",
    "choice_b": "Attribute-Based Access Control (ABAC) model",
    "choice_c": "Role-Based Access Control (RBAC) model",
    "choice_d": "Discretionary Access Control (DAC) model",
    "correct_answer": "B",
    "explanation": "The ABAC model is commonly used in SDNs. None of the other answers are normally used in SDNs. The MAC model uses labels to define access, and the RBAC model uses groups. In the DAC model, the owner grants access to others.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      491,
      472,
      469,
      466,
      463
    ],
    "source": ""
  },
  {
    "id": 3551,
    "question": "The MAC model supports different environment types. <br>Which of the following grants users access using predefined labels for specific labels?",
    "choice_a": "Compartmentalized environment",
    "choice_b": "Hierarchical environment",
    "choice_c": "Centralized environment",
    "choice_d": "Hybrid environment",
    "correct_answer": "B",
    "explanation": "In a hierarchical environment, the various classification labels are assigned in an ordered structure from low security to high security. The mandatory access control (MAC) model supports three environments: hierarchical, compartmentalized, and hybrid. A compartmentalized environment ignores the levels, and instead only allows access for individual compartments on any level. A hybrid environment is a combination of a hierarchical and compartmentalized environment. A MAC model doesn't use a centralized environment.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      491,
      472,
      465,
      462
    ],
    "source": ""
  },
  {
    "id": 3552,
    "question": "Which of the following access control models identifies the upper and lower bounds of access for subjects with labels?",
    "choice_a": "Non-discretionary access control",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Discretionary Access Control (DAC)",
    "choice_d": "Attribute-Based Access Control (ABAC)",
    "correct_answer": "B",
    "explanation": "The MAC model uses labels to identify the upper and lower bounds of classification levels, and these define the level of access for subjects. MAC is a nondiscretionary access control model that uses labels. However, not all non-discretionary access control models use labels. DAC and ABAC models do not use labels.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      472,
      491,
      467,
      493
    ],
    "source": ""
  },
  {
    "id": 3553,
    "question": "Which of the following access control models uses labels and is commonly referred to as a lattice-based model?",
    "choice_a": "DAC",
    "choice_b": "Non-discretionary",
    "choice_c": "MAC",
    "choice_d": "RBAC",
    "correct_answer": "C",
    "explanation": "Mandatory access control (MAC) models rely on the use of labels for subjects and objects. They look similar to a lattice when drawn, so the MAC model is often referred to as a lattice-based model. None of the other answers use labels. Discretionary Access Control (DAC) models allow an owner of an object to control access to the object. Non-discretionary access controls have centralized management, such as a rule-based access control model deployed on a firewall. Role-based access control (RBAC) models define a subject's access based on job-related roles.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      468,
      491,
      472,
      466,
      467
    ],
    "source": ""
  },
  {
    "id": 3554,
    "question": "Management wants users to use multifactor authentication any time they access cloud-based resources. <br>Which of the following access control models can meet this requirement?",
    "choice_a": "Risk-based access control",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Role-Based Access Control (RBAC)",
    "choice_d": "Discretionary Access Control (DAC)",
    "correct_answer": "A",
    "explanation": "A risk-based access control model can require users to authenticate with multi-factor authentication. None of the other access control models listed can evaluate how a user has logged on. A MAC model uses labels to grant access. An RBAC model grants access based on job roles or groups. In a DAC model, the owner grants access to resources.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      469,
      472,
      491,
      459,
      489
    ],
    "source": ""
  },
  {
    "id": 3555,
    "question": "Which of the following access control models determines access based on the environment and the situation?",
    "choice_a": "Risk-based access control",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Role-Based Access Control (RBAC)",
    "choice_d": "Attribute-Based Access Control (ABAC)",
    "correct_answer": "A",
    "explanation": "A risk-based access control model evaluates the environment and the situation and then makes access decisions based on coded policies. A MAC model grants access using labels. An RBAC model uses a well-defined collection of named job roles for access control. Administrators grant each job role with the privileges they need to perform their jobs. An ABAC model uses attributes to grant access and is often used in software-defined networks (SDNs).",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      469,
      491,
      472,
      467,
      464
    ],
    "source": ""
  },
  {
    "id": 3556,
    "question": "A cloud-based provider has implemented an SSO technology using JSON Web Tokens. The tokens provide authentication information and include user profiles. <br>Which of the following best identifies this technology?",
    "choice_a": "OIDC",
    "choice_b": "OAuth",
    "choice_c": "SAML",
    "choice_d": "OpenID",
    "correct_answer": "A",
    "explanation": "OpenID Connect (OIDC) uses a JavaScript Object Notation (JSON) Web Token (JWT) that provides both authentication and profile information for internet-based single sign-on (SSO). None of the other answers use tokens. OIDC is built on the OAuth 2.0 framework. OpenID provides authentication but doesn't include profile information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1019,
      476,
      475,
      1018,
      492
    ],
    "source": ""
  },
  {
    "id": 3557,
    "question": "Some users in your network are having problems authenticating with a Kerberos server. While troubleshooting the problem, you verified you can log on to your regular work computer. However, you are unable to log on to the user's computer with your credentials. <br>Which of the following is most likely to solve this problem?",
    "choice_a": "Advanced Encryption Standard (AES)",
    "choice_b": "Network Access Control (NAC)",
    "choice_c": "Security Assertion Markup Language (SAML)",
    "choice_d": "Network Time Protocol (NTP)",
    "correct_answer": "D",
    "explanation": "Configuring a central computer to synchronize its time with an external NTP server and all other systems to synchronize their time with the NTP will likely solve the problem and is the best choice of the available options. Kerberos requires computer times to be within 5 minutes of each other and the scenario, along with the available answers, suggested the user's computer is not synchronized with the Kerberos server. Kerberos uses AES. However, because a user successfully logs on to one computer, it indicates Kerberos is working, and AES is installed. NAC checks a system's health after the user authenticates. NAC doesn't prevent a user from logging on. Some federated systems use SAML, but Kerberos doesn't require SAML.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      478,
      477,
      492,
      487,
      476
    ],
    "source": ""
  },
  {
    "id": 3558,
    "question": "Your organization has a large network supporting thousands of employees, and it utilizes Kerberos. Of the following choices, what is the primary purpose of Kerberos?",
    "choice_a": "Confidentiality",
    "choice_b": "Integrity",
    "choice_c": "Authentication",
    "choice_d": "Accountability",
    "correct_answer": "C",
    "explanation": "The primary purpose of Kerberos is authentication, since it allows users to prove their identity. It also provides a measure of confidentiality and integrity using symmetric key encryption, but these are not the primary purpose. Kerberos does not include logging capabilities, so it does not provide accountability.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      477,
      492,
      441,
      478,
      476
    ],
    "source": ""
  },
  {
    "id": 3559,
    "question": "What is the function of the network access server within a RADIUS architecture?",
    "choice_a": "Authentication server",
    "choice_b": "Client",
    "choice_c": "AAA server",
    "choice_d": "Firewall",
    "correct_answer": "B",
    "explanation": "The network access server is the client within a RADIUS architecture. The RADIUS server is the authentication server, and it provides authentication, authorization, and accounting (AAA) services. The network access server might have a host firewall enabled, but that isn't the primary function.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      479,
      492,
      441,
      450,
      461
    ],
    "source": ""
  },
  {
    "id": 3560,
    "question": "Larry manages a Linux server. Occasionally, he needs to run commands that require root-level privileges. Management wants to ensure that an attacker cannot run these commands if the attacker compromises Larry's account. <br>Which of the following is the best choice?",
    "choice_a": "Grant Larry sudo access.",
    "choice_b": "Give Larry the root password.",
    "choice_c": "Add Larry's account to the administrator's group.",
    "choice_d": "Add Larry's account to the LocalSystem account.",
    "correct_answer": "B",
    "explanation": "The best choice is to give the administrator the root password. The administrator would enter it manually when running commands that need elevated privileges by running the <code>su</code> command. If the user is granted sudo access, it would allow the user to run commands requiring root-level privileges, under the context of the user account. If an attacker compromised the user account, the attacker could run the elevated commands with <code>sudo</code>. Linux systems don't have an administrator group or a LocalSystem account.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1073,
      751,
      752,
      470,
      925
    ],
    "source": ""
  },
  {
    "id": 3561,
    "question": "An attacker used a tool to exploit a weakness in NTLM. They identified an administrator's user account. Although the attacker didn't discover the administrator's password, they did access remote systems by impersonating the administrator. <br>Which of the following best identifies this attack?",
    "choice_a": "Pass the ticket",
    "choice_b": "Golden ticket",
    "choice_c": "Rainbow table",
    "choice_d": "Pass the hash",
    "correct_answer": "D",
    "explanation": "NTLM is known to be susceptible to pass-the-hash attacks, and this scenario describes a pass-the-hash attack. Kerberos attacks attempt to manipulate tickets, such as in pass-the-ticket and golden ticket attacks, but these are not NTLM attacks. A rainbow table attack uses a rainbow table in an offline brute-force attack.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      193,
      199,
      194,
      197,
      195
    ],
    "source": ""
  },
  {
    "id": 3562,
    "question": "Your organization recently suffered a major data breach. After an investigation, security analysts discovered that attackers were using golden tickets to access network resources. <br>Which of the following did the attackers exploit?",
    "choice_a": "RADIUS",
    "choice_b": "SAML",
    "choice_c": "Kerberos",
    "choice_d": "OIDC",
    "correct_answer": "C",
    "explanation": "Attackers can create golden tickets after successfully exploiting Kerberos and obtaining the Kerberos service account (KRBTGT). Golden tickets are not associated with Remote Authentication Dial-in User Service (RADIUS), Security Assertion Markup Language (SAML), or OpenID Connect (OIDC).",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      254,
      255,
      215,
      189,
      145
    ],
    "source": ""
  },
  {
    "id": 3563,
    "question": "Which one of the following tools is used primarily to perform network discovery scans?",
    "choice_a": "Nmap",
    "choice_b": "OpenVAS",
    "choice_c": "Metasploit Framework",
    "choice_d": "<code>lsof</code>",
    "correct_answer": "A",
    "explanation": "Nmap is a network discovery scanning tool that reports the open ports on a remote system and the firewall status of those ports. OpenVAS is a network vulnerability scanning tool. Metasploit Framework is an exploitation framework used in penetration testing. <code>lsof</code> is a Linux command used to list open files on a system.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      763,
      788,
      860,
      771
    ],
    "source": ""
  },
  {
    "id": 3564,
    "question": "Adam recently ran a network port scan of a web server running in his organization. He ran the scan from an external network to get an attacker's perspective on the scan. <br>Which one of the following results is the greatest cause for alarm?",
    "choice_a": "<code>80/open</code>",
    "choice_b": "<code>22/filtered</code>",
    "choice_c": "<code>443/open</code>",
    "choice_d": "<code>1433/open</code>",
    "correct_answer": "D",
    "explanation": "Only open ports represent potentially significant security risks. Ports 80 and 443 are expected to be open on a web server. Port 1433 is a database port and should never be exposed to an external network. Port 22 is used for the Secure Shell protocol (SSH), and the filtered status indicates that nmap can't determine whether it is open or closed. This situation does require further investigation, but it is not as alarming as a definitely exposed database server port.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      765,
      763,
      787,
      788,
      859
    ],
    "source": ""
  },
  {
    "id": 3565,
    "question": "Which one of the following factors should <italic>not</italic> be taken into consideration when planning a security testing schedule for a particular system?",
    "choice_a": "Sensitivity of the information stored on the system",
    "choice_b": "Difficulty of performing the test",
    "choice_c": "Desire to experiment with new testing tools",
    "choice_d": "Desirability of the system to attackers",
    "correct_answer": "C",
    "explanation": "The sensitivity of information stored on the system, difficulty of performing the test, and likelihood of an attacker targeting the system are all valid considerations when planning a security testing schedule. The desire to experiment with new testing tools should not influence the production testing schedule.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      863,
      1008,
      771,
      776,
      780
    ],
    "source": ""
  },
  {
    "id": 3566,
    "question": "Which one of the following is not normally included in a security assessment?",
    "choice_a": "Vulnerability scan",
    "choice_b": "Risk assessment",
    "choice_c": "Mitigation of vulnerabilities",
    "choice_d": "Threat assessment",
    "correct_answer": "C",
    "explanation": "Security assessments include many types of tests designed to identify vulnerabilities, and the assessment report normally includes recommendations for mitigation. The assessment does not, however, include actual mitigation of those vulnerabilities.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      789,
      787,
      1006,
      1007,
      502
    ],
    "source": ""
  },
  {
    "id": 3567,
    "question": "Who is the intended audience for a security assessment report?",
    "choice_a": "Management",
    "choice_b": "Security auditor",
    "choice_c": "Security professional",
    "choice_d": "Customers",
    "correct_answer": "A",
    "explanation": "Security assessment reports should be addressed to the organization's management. For this reason, they should be written in plain English and avoid technical jargon.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      795,
      793,
      766,
      502,
      863
    ],
    "source": ""
  },
  {
    "id": 3568,
    "question": "Wendy is considering the use of a vulnerability scanner in her organization. <br>What is the proper role of a vulnerability scanner?",
    "choice_a": "They actively scan for intrusion attempts.",
    "choice_b": "They serve as a form of enticement.",
    "choice_c": "They locate known security holes.",
    "choice_d": "They automatically reconfigure a system to a more secured state.",
    "correct_answer": "C",
    "explanation": "Vulnerability scanners are used to test a system for known security vulnerabilities and weaknesses. They are not active detection tools for intrusion, they offer no form of enticement, and they do not configure system security. In addition to testing a system for security weaknesses, they produce evaluation reports and make recommendations.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      859,
      860,
      789,
      861
    ],
    "source": ""
  },
  {
    "id": 3569,
    "question": "Alan ran a nmap scan against a server and determined that port 80 is open on the server. <br>What tool would likely provide him the best additional information about the server's purpose and the identity of the server's operator?",
    "choice_a": "SSH",
    "choice_b": "Web browser",
    "choice_c": "Telnet",
    "choice_d": "Ping",
    "correct_answer": "B",
    "explanation": "The server is likely running a website on port 80. Using a web browser to access the site may provide important information about the site's purpose.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      763,
      787,
      788,
      495,
      496
    ],
    "source": ""
  },
  {
    "id": 3570,
    "question": "What port is typically used to accept administrative connections using the SSH utility?",
    "choice_a": "20",
    "choice_b": "22",
    "choice_c": "25",
    "choice_d": "80",
    "correct_answer": "B",
    "explanation": "The SSH protocol uses port 22 to accept administrative connections to a server.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      763,
      787,
      788,
      498,
      774
    ],
    "source": ""
  },
  {
    "id": 3571,
    "question": "Which one of the following tests provides the most accurate and detailed information about the security state of a server?",
    "choice_a": "Unauthenticated scan",
    "choice_b": "Port scan",
    "choice_c": "Half-open scan",
    "choice_d": "Authenticated scan",
    "correct_answer": "D",
    "explanation": "Authenticated scans can read configuration information from the target system and reduce the instances of false positive and false negative reports.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      860,
      859,
      787,
      788,
      494
    ],
    "source": ""
  },
  {
    "id": 3572,
    "question": "What type of network discovery scan only uses the first two steps of the TCP handshake?",
    "choice_a": "TCP connect scan",
    "choice_b": "Xmas scan",
    "choice_c": "TCP SYN scan",
    "choice_d": "TCP ACK scan",
    "correct_answer": "C",
    "explanation": "The TCP SYN scan sends a SYN packet and receives a SYN ACK packet in response, but it does not send the final ACK required to complete the three-way handshake.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3573,
    "question": "Matthew would like to test systems on his network for SQL injection vulnerabilities. <br>Which one of the following tools would be best suited to this task?",
    "choice_a": "Port scanner",
    "choice_b": "Network vulnerability scanner",
    "choice_c": "Network discovery scanner",
    "choice_d": "Web vulnerability scanner",
    "correct_answer": "D",
    "explanation": "SQL injection attacks are web vulnerabilities, and Matthew would be best served by a web vulnerability scanner. A network vulnerability scanner might also pick up this vulnerability, but the web vulnerability scanner is specifically designed for the task and more likely to be successful.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      775,
      777,
      859,
      860
    ],
    "source": ""
  },
  {
    "id": 3575,
    "question": "Grace is performing a penetration test against a client's network and would like to use a tool to assist in automatically executing common exploits. <br>Which one of the following security tools will best meet her needs?",
    "choice_a": "nmap",
    "choice_b": "Metasploit Framework",
    "choice_c": "OpenVAS",
    "choice_d": "Nikto",
    "correct_answer": "B",
    "explanation": "Metasploit Framework is an automated exploit tool that allows attackers to easily execute common attack techniques. Nmap is a port scanning tool. OpenVAS is a network vulnerability scanner and Nikto is a web application scanner. While these other tools might identify potential vulnerabilities, they do not go as far as to exploit them.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      775,
      776,
      771,
      1078
    ],
    "source": ""
  },
  {
    "id": 3576,
    "question": "Paul would like to test his application against slightly modified versions of previously used input. <br>What type of test does Paul intend to perform?",
    "choice_a": "Code review",
    "choice_b": "Application vulnerability review",
    "choice_c": "Mutation fuzzing",
    "choice_d": "Generational fuzzing",
    "correct_answer": "C",
    "explanation": "Mutation fuzzing uses bit flipping and other techniques to slightly modify previous inputs to a program in an attempt to detect software flaws.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      775,
      776,
      777,
      1003,
      494
    ],
    "source": ""
  },
  {
    "id": 3577,
    "question": "Users of a banking application may try to withdraw funds that don't exist from their account. Developers are aware of this threat and implemented code to protect against it. <br>What type of software testing would most likely catch this type of vulnerability if the developers have not already remediated it?",
    "choice_a": "Misuse case testing",
    "choice_b": "SQL injection testing",
    "choice_c": "Fuzzing",
    "choice_d": "Code review",
    "correct_answer": "A",
    "explanation": "Misuse case testing identifies known ways that an attacker might exploit a system and tests explicitly to see if those attacks are possible in the proposed code.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      494,
      496,
      775,
      776
    ],
    "source": ""
  },
  {
    "id": 3578,
    "question": "What type of interface testing would identify flaws in a program's command-line interface?",
    "choice_a": "Application programming interface testing",
    "choice_b": "User interface testing",
    "choice_c": "Physical interface testing",
    "choice_d": "Security interface testing",
    "correct_answer": "B",
    "explanation": "User interface testing includes assessments of both graphical user interfaces (GUIs) and command-line interfaces (CLIs) for a software program.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      495,
      494,
      775,
      777,
      1003
    ],
    "source": ""
  },
  {
    "id": 3579,
    "question": "During what type of penetration test does the tester always have access to system configuration information?",
    "choice_a": "Black-box penetration test",
    "choice_b": "White-box penetration test",
    "choice_c": "Gray-box penetration test",
    "choice_d": "Red-box penetration test",
    "correct_answer": "B",
    "explanation": "During a white-box penetration test, the testers have access to detailed configuration information about the system being tested.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1078,
      1080,
      771,
      788,
      765
    ],
    "source": ""
  },
  {
    "id": 3580,
    "question": "What port is typically open on a system that runs an unencrypted HTTP server?",
    "choice_a": "22",
    "choice_b": "80",
    "choice_c": "143",
    "choice_d": "443",
    "correct_answer": "B",
    "explanation": "Unencrypted HTTP communications take place over TCP port 80 by default.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      763,
      788,
      787,
      495,
      496
    ],
    "source": ""
  },
  {
    "id": 3581,
    "question": "Robert recently completed a SOC engagement for a customer and is preparing a report that describes his firm's opinion on the suitability and effectiveness of security controls after evaluating them over a six-month period. <br>What type of report is he preparing?",
    "choice_a": "Type I",
    "choice_b": "Type II",
    "choice_c": "Type III",
    "choice_d": "Type IV",
    "correct_answer": "B",
    "explanation": "There are only two types of SOC report: Type I and Type II. Both reports provide information on the suitability of the design of security controls. Only a Type II report also provides an opinion on the operating effectiveness of those controls over an extended period of time.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      767,
      766,
      793,
      768,
      795
    ],
    "source": ""
  },
  {
    "id": 3582,
    "question": "What information security management task ensures that the organization's data protection requirements are met effectively?",
    "choice_a": "Account management",
    "choice_b": "Backup verification",
    "choice_c": "Log review",
    "choice_d": "Key performance indicators",
    "correct_answer": "B",
    "explanation": "The backup verification process ensures that backups are running properly and thus meeting the organization's data protection objectives.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      500,
      786,
      784,
      792,
      785
    ],
    "source": ""
  },
  {
    "id": 3583,
    "question": "Which security principle involves the knowledge and possession of sensitive material as an aspect of one's occupation?",
    "choice_a": "Principle of least privilege",
    "choice_b": "Separation of duties",
    "choice_c": "Need to know",
    "choice_d": "As-needed basis",
    "correct_answer": "C",
    "explanation": "The need-to-know policy operates on the basis that any given system user should be granted access only to portions of sensitive information or materials necessary to perform some task. The principle of least privilege ensures that personnel are granted only the permissions they need to perform their job and no more. Separation of duties ensures that no single person has total control over a critical function or system. There isn't a standard principle called \"as-needed basis.\".",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      503,
      533,
      535,
      504,
      593
    ],
    "source": ""
  },
  {
    "id": 3584,
    "question": "An organization ensures that users are granted access to only the data they need to perform specific work tasks. <br>What principle are they following?",
    "choice_a": "Principle of least permission",
    "choice_b": "Separation of duties (SoD)",
    "choice_c": "Need to know",
    "choice_d": "Job rotation",
    "correct_answer": "C",
    "explanation": "Need to know is the requirement to have access to, knowledge about, or possession of data to perform specific work tasks, but no more. The principle of least privilege includes both rights and permissions, but the term <italic>principle of least permission</italic> is not valid within IT security. Separation of duties (SoD) ensures that a single person doesn't control all the elements of a process. A separation of duties policy ensures that no single person has total control over a critical function. A job rotation policy requires employees to rotate to different jobs periodically.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      533,
      503,
      535,
      504,
      505
    ],
    "source": ""
  },
  {
    "id": 3585,
    "question": "What concept is used to grants users only the rights and permissions they need to complete their job responsibilities?",
    "choice_a": "Need to know",
    "choice_b": "Mandatory vacations",
    "choice_c": "Least privilege principle",
    "choice_d": "Service-level agreement (SLA)",
    "correct_answer": "C",
    "explanation": "An organization applies the least privilege principle to ensure employees receive only the access they need to complete their job responsibilities. Need to know refers to permissions only, whereas privileges include both rights and permissions. A mandatory vacation policy requires employees to take a vacation in one- or two-week increments. An SLA identifies performance expectations and can include monetary penalties.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      715,
      213,
      228,
      220,
      212
    ],
    "source": ""
  },
  {
    "id": 3586,
    "question": "A large organization using a Microsoft domain wants to limit the amount of time users have elevated privileges. <br>Which of the following security operation concepts can be used to support this goal?",
    "choice_a": "Principle of least permission",
    "choice_b": "Separation of duties",
    "choice_c": "Need to know",
    "choice_d": "Privileged account management",
    "correct_answer": "D",
    "explanation": "Microsoft domains include a privileged account management solution that grants administrators elevated privileges when they need them but restrict the access using a time-limited ticket. The principle of least privilege includes both rights and permissions, but the term <italic>principle of least permission</italic> is not valid within IT security. Separation of duties ensures that a single person doesn't control all the elements of a process or a critical function. Need to know is the requirement to have access to, knowledge about, or possession of data to perform specific work tasks, but no more.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      506,
      533,
      535,
      504,
      503
    ],
    "source": ""
  },
  {
    "id": 3587,
    "question": "An administrator is granting permissions to a database. <br>What is the default level of access the administrator should grant to new users in the organization?",
    "choice_a": "Read",
    "choice_b": "Modify",
    "choice_c": "Full access",
    "choice_d": "No access",
    "correct_answer": "D",
    "explanation": "The default level of access should be no access. The principle of least privilege dictates that users should only be granted the level of access they need for their job, and the question doesn't indicate that new users need any access to the database. Read access, modify access, and full access grants users some level of access, which violates the principle of least privilege.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      503,
      533,
      555,
      526
    ],
    "source": ""
  },
  {
    "id": 3588,
    "question": "You want to apply the least privilege principle when creating new accounts in the software development department. <br>Which of the following should you do?",
    "choice_a": "Create each account with only the rights and permissions needed by the employee to perform their job.",
    "choice_b": "Give each account full rights and permissions to the servers in the software development department.",
    "choice_c": "Create each account with no rights and permissions.",
    "choice_d": "Add the accounts to the local Administrators group on the new employee's computer.",
    "correct_answer": "A",
    "explanation": "Each account should have only the rights and permissions needed to perform their job when following the least privilege policy. New employees would not need full rights and permissions to a server. Employees will need some rights and permissions in order to do their jobs. Regular user accounts should not be added to the Administrators group.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      533,
      535,
      503,
      506,
      526
    ],
    "source": ""
  },
  {
    "id": 3589,
    "question": "Your organization has divided a high-level auditing function into several individual job tasks. These tasks are divided between three administrators. None of the administrators can perform all of the tasks. <br>What does this describe?",
    "choice_a": "Job rotation",
    "choice_b": "Mandatory vacation",
    "choice_c": "Separation of duties",
    "choice_d": "Least privilege",
    "correct_answer": "C",
    "explanation": "Separation of duties ensures that no single entity can perform all the tasks for a job or function. A job rotation policy moves employees to different jobs periodically. A mandatory vacation policy requires employees to take vacations. A least privilege policy ensures users have only the privileges they need, and no more.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      715,
      219,
      712,
      228,
      213
    ],
    "source": ""
  },
  {
    "id": 3590,
    "question": "A financial organization commonly has employees switch duty responsibilities every 6 months. <br>What security principle are they employing?",
    "choice_a": "Job rotation",
    "choice_b": "Separation of duties",
    "choice_c": "Mandatory vacations",
    "choice_d": "Least privilege",
    "correct_answer": "A",
    "explanation": "A job rotation policy has employees rotate jobs or job responsibilities and can help detect collusion and fraud. A separation of duties policy ensures that a single person doesn't control all elements of a specific function. Mandatory vacation policies ensure that employees take an extended time away from their jobs, requiring someone else to perform their job responsibilities, which increases the likelihood of discovering fraud. Least privilege ensures that users have only the permissions they need to perform their jobs and no more.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      505,
      533,
      504,
      543,
      611
    ],
    "source": ""
  },
  {
    "id": 3591,
    "question": "Which of the following is one of the primary reasons an organization enforces a mandatory vacation policy?",
    "choice_a": "To rotate job responsibilities",
    "choice_b": "To detect fraud",
    "choice_c": "To increase employee productivity",
    "choice_d": "To reduce employee stress levels",
    "correct_answer": "B",
    "explanation": "Mandatory vacation policies help detect fraud. They require employees to take an extended time away from their jobs, requiring someone else to perform their job responsibilities, which increases the likelihood of discovering fraud. It does not rotate job responsibilities. Although mandatory vacations might help employees reduce their overall stress levels and increase productivity, these are not the primary reasons for mandatory vacation policies.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      505,
      543,
      533,
      611,
      599
    ],
    "source": ""
  },
  {
    "id": 3592,
    "question": "Your organization has contracted with a third-party provider to host cloud-based servers. Management wants to ensure there are monetary penalties if the third party doesn't meet their contractual responsibilities related to uptimes and downtimes. <br>Which of the following is the best choice to meet this requirement?",
    "choice_a": "MOU",
    "choice_b": "ISA",
    "choice_c": "SLA",
    "choice_d": "SED",
    "correct_answer": "C",
    "explanation": "A service-level agreement (SLA) can provide monetary penalties if a third-party provider doesn't meet its contractual requirements. Neither a memorandum of understanding (MOU) nor an interconnection security agreement (ISA) includes monetary penalties. Separation of duties is sometimes shortened to SED, but this is unrelated to third-party relationships.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      507,
      583,
      590,
      522,
      796
    ],
    "source": ""
  },
  {
    "id": 3593,
    "question": "Which one of the following is a cloud-based service model that gives an organization the most control and requires the organization to perform all maintenance on operating systems and applications?",
    "choice_a": "Infrastructure as a service (IaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Software as a service (SaaS)",
    "choice_d": "Public",
    "correct_answer": "A",
    "explanation": "The IaaS service model provides an organization with the most control compared to the other models, and this model requires the organization to perform all maintenance on operating systems and applications. The SaaS model gives the organization the least control, and the cloud service provider (CSP) is responsible for all maintenance. The PaaS model splits control and maintenance responsibilities between the CSP and the organization.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      623,
      621,
      640,
      643
    ],
    "source": ""
  },
  {
    "id": 3594,
    "question": "Which one of the following is a cloud-based service model that allows users to access email via a web browser?",
    "choice_a": "Infrastructure as a service (IaaS)",
    "choice_b": "Platform as a service (PaaS)",
    "choice_c": "Software as a service (SaaS)",
    "choice_d": "Public",
    "correct_answer": "C",
    "explanation": "The SaaS service model provides services such as email available via a web browser. IaaS provides the infrastructure (such as servers), and PaaS provides a platform (such as an operating system and application installed on a server). Public is a deployment method, not a service model.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3595,
    "question": "The IT department routinely uses images when deploying new systems. Of the following choices, what is a primary benefit of using images?",
    "choice_a": "Provides a baseline for configuration management",
    "choice_b": "Improves patch management response times",
    "choice_c": "Reduces vulnerabilities from unpatched systems",
    "choice_d": "Provides documentation for changes",
    "correct_answer": "A",
    "explanation": "When images are used to deploy systems, the systems start with a common baseline, which is important for configuration management. Images don't necessarily improve the evaluation, approval, deployment, and audits of patches to systems within the network. Although images can include current patches to reduce their vulnerabilities, this is because the image provides a baseline. Change management provides documentation for changes.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      524,
      523,
      525,
      797,
      798
    ],
    "source": ""
  },
  {
    "id": 3596,
    "question": "A server administrator recently modified the configuration for a server to improve performance. Unfortunately, when an automated script runs once a week, the modification causes the server to reboot. It took several hours of troubleshooting to ultimately determine the problem wasn't with the script but instead with the modification. <br>What could have prevented this?",
    "choice_a": "Vulnerability management",
    "choice_b": "Patch management",
    "choice_c": "Change management",
    "choice_d": "Blocking all scripts",
    "correct_answer": "C",
    "explanation": "An effective change management program helps prevent outages from unauthorized changes. Vulnerability management helps detect weaknesses but wouldn't block the problems from this modification. Patch management ensures systems are kept up to date. Blocking scripts removes automation, which would increase the overall workload.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      526,
      527,
      534,
      975,
      528
    ],
    "source": ""
  },
  {
    "id": 3597,
    "question": "Which of the following steps would be included in a change management process?  (Select all that apply.)",
    "choice_a": "Immediately implement the change if it will improve performance.",
    "choice_b": "Request the change.",
    "choice_c": "Create a rollback plan for the change.",
    "choice_d": "Document the change.",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Change management processes include requesting a change, creating a rollback plan for the change, and documenting the change. Changes should not be implemented immediately without evaluating the change.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      974,
      527,
      528,
      534,
      529
    ],
    "source": ""
  },
  {
    "id": 3598,
    "question": "A new CIO learned that an organization doesn't have a change management program. The CIO insists one be implemented immediately. Of the following choices, what is a primary goal of a change management program?",
    "choice_a": "Personnel safety",
    "choice_b": "Allowing rollback of changes",
    "choice_c": "Ensuring that changes do not reduce security",
    "choice_d": "Auditing privilege access",
    "correct_answer": "C",
    "explanation": "Change management aims to ensure that any change does not result in unintended outages or reduce security. Change management doesn't affect personnel safety. A change management plan will commonly include a rollback plan, but that isn't a specific goal of the program. Change management doesn't perform any type of auditing.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      526,
      973,
      527,
      534,
      543
    ],
    "source": ""
  },
  {
    "id": 3599,
    "question": "Systems within an organization are configured to receive and apply patches automatically. After receiving a patch, 55 of the systems automatically restarted and booted into a stop error. <br>What could have prevented this problem without sacrificing security?",
    "choice_a": "Disable the setting to apply the patches automatically.",
    "choice_b": "Implement a patch management program to approve all patches.",
    "choice_c": "Ensure systems are routinely audited for patches.",
    "choice_d": "Implement a patch management program that tests patches before deploying them.",
    "correct_answer": "D",
    "explanation": "An effective patch management program evaluates and tests patches before deploying them and would have prevented this problem. Approving all patches would not prevent this problem because the same patch would be deployed. Systems should be audited after deploying patches, not to test for the impact of new patches.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      529,
      534,
      523,
      528,
      596
    ],
    "source": ""
  },
  {
    "id": 3600,
    "question": "A security administrator wants to verify the existing systems are up to date with current patches. Of the following choices, what is the <italic>best</italic> method to ensure systems have the required patches?",
    "choice_a": "Patch management system",
    "choice_b": "Patch scanner",
    "choice_c": "Penetration tester",
    "choice_d": "Fuzz tester",
    "correct_answer": "A",
    "explanation": "A patch management system ensures that systems have required patches. In addition to deploying patches, it would also check the systems to verify they accepted the patches. There is no such thing as a patch scanner. A penetration test will attempt to exploit a vulnerability, but it can be intrusive and cause an outage, so it isn't appropriate in this scenario. A fuzz tester sends random data to a system to check for vulnerabilities but doesn't test for patches.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      529,
      530,
      532,
      544,
      526
    ],
    "source": ""
  },
  {
    "id": 3601,
    "question": "A recent attack on servers within your organization caused an excessive outage. You need to check systems for known issues that attackers may use to exploit other systems in your network. <br>Which of the following is the best choice to meet this need?",
    "choice_a": "Versioning tracker",
    "choice_b": "Vulnerability scanner",
    "choice_c": "Security audit",
    "choice_d": "Security review",
    "correct_answer": "B",
    "explanation": "Vulnerability scanners are used to check systems for known issues and are part of an overall vulnerability management program. Versioning is used to track software versions and is unrelated to detecting vulnerabilities. Security audits and reviews help ensure that an organization is following its policies but wouldn't directly check systems for vulnerabilities.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      531,
      534,
      529,
      523,
      544
    ],
    "source": ""
  },
  {
    "id": 3602,
    "question": "Which one of the following processes is most likely to list all security risks within a system?",
    "choice_a": "Configuration management",
    "choice_b": "Patch management",
    "choice_c": "Hardware inventory",
    "choice_d": "Vulnerability scan",
    "correct_answer": "D",
    "explanation": "A vulnerability scan will list or enumerate all security risks within a system. None of the other answers will list security risks within a system. Configuration management systems check and modify configuration settings. Patch management systems can deploy patches and verify patches are deployed, but they don't check for all security risks. Hardware inventories only verify the hardware is still present.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      531,
      534,
      529,
      523,
      544
    ],
    "source": ""
  },
  {
    "id": 3603,
    "question": "Which of the following are valid incident management steps or phases as listed in the CISSP objectives? <ol type=\"A\"><li> Prevention</li><li> Detection</li><li> Reporting</li><li> Lessons learned</li><li> Backup</li></ol>(Select all that apply.)",
    "choice_a": "Prevention",
    "choice_b": "Detection",
    "choice_c": "Reporting",
    "choice_d": "Lessons learned",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Detection, reporting, and lessons learned are valid incident management steps. Prevention is done before an incident. Creating backups can help recover systems, but it isn't one of the incident management steps. The seven steps (in order) are detection, response, mitigation, reporting, recovery, remediation, and lessons learned.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      537,
      538,
      539,
      540,
      565
    ],
    "source": "",
    "choice_e": "Backup"
  },
  {
    "id": 3604,
    "question": "You are troubleshooting a problem on a user's  computer. After viewing the host-based intrusion detection system (HIDS) logs, you determine that the computer has been compromised by malware. Of the following choices, what should you do next?",
    "choice_a": "Isolate the computer from the network.",
    "choice_b": "Review the HIDS logs of neighboring computers.",
    "choice_c": "Run an antivirus scan.",
    "choice_d": "Analyze the system to discover how it was infected.",
    "correct_answer": "A",
    "explanation": "Your next step is to isolate the computer from the network as part of the mitigation phase. You might look at other computers later, but you should try to mitigate the problem first. Similarly, you might run an antivirus scan, but later. The lessons learned phase is last and will analyze an incident to determine the cause.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      539,
      537,
      538,
      565,
      540
    ],
    "source": ""
  },
  {
    "id": 3605,
    "question": "In the incident management steps identified by ISC2, which of the following occurs first?",
    "choice_a": "Response",
    "choice_b": "Mitigation",
    "choice_c": "Remediation",
    "choice_d": "Lessons learned",
    "correct_answer": "A",
    "explanation": "The first step of those listed is response. The first step is detection, but detection isn't listed as a possible answer. The seven steps (in order) are detection, response, mitigation, reporting, recovery, remediation, and lessons learned.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      537,
      565,
      538,
      539,
      540
    ],
    "source": ""
  },
  {
    "id": 3606,
    "question": "Which of the following are basic security controls that can prevent many attacks? (Choose three.)",
    "choice_a": "Keep systems and applications up-to-date.",
    "choice_b": "Implement security orchestration, automation, and response (SOAR) technologies.",
    "choice_c": "Remove or disable unneeded services or protocols.",
    "choice_d": "Use up-to-date anti-malware software.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "The three basic security controls listed are 1) keep systems and applications up to date, 2) remove or unneeded services or protocols, and 3) use up-to-date anti-malware software. SOAR technologies implement advanced methods to detect and automatically respond to incidents. It's appropriate to place a network firewall at the border (between the internet and the internal network), but web application firewalls (WAF) should only filter traffic going to a web server.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      544,
      568,
      550,
      551,
      532
    ],
    "source": "",
    "choice_e": "Use WAF firewalls at the border."
  },
  {
    "id": 3607,
    "question": "Security administrators are reviewing all the data gathered by event logging. <br>Which of the following best describes this body of data?",
    "choice_a": "Identification",
    "choice_b": "Audit trails",
    "choice_c": "Authorization",
    "choice_d": "Confidentiality",
    "correct_answer": "B",
    "explanation": "Audit trails provide documentation on what happened, when it happened, and who did it. IT personnel create audit trails by examining logs. Authentication of individuals is also needed to ensure that the audit trails provide proof of identities listed in the logs. Identification occurs when an individual claims an identity, but identification without authentication doesn't provide accountability. Authorization grants individuals access to resources based on their proven identity. Confidentiality ensures that unauthorized entities can't access sensitive data and is unrelated to this question.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      556,
      554,
      555,
      602,
      558
    ],
    "source": ""
  },
  {
    "id": 3608,
    "question": "A file server in your network recently crashed. An investigation showed that logs grew so much that they filled the disk drive. You decide to enable rollover logging to prevent this from happening again. <br>Which of the following should you do first?",
    "choice_a": "Configure the logs to overwrite old entries automatically.",
    "choice_b": "Copy existing logs to a different drive.",
    "choice_c": "Review the logs for any signs of attacks.",
    "choice_d": "Delete the oldest log entries.",
    "correct_answer": "B",
    "explanation": "The first step should be to copy existing logs to a different drive so that they are not lost. If you enable rollover logging, you are configuring the logs to overwrite old entries. It's not necessary to review the logs before copying them. If you delete the oldest log entries first, you may delete valuable data.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      555,
      558,
      604,
      607,
      596
    ],
    "source": ""
  },
  {
    "id": 3609,
    "question": "You suspect an attacker has launched a fraggle attack on a system. You check the logs and filter your search with the protocol used by fraggle. <br>What protocol would you use in the filter?",
    "choice_a": "User Datagram Protocol (UDP)",
    "choice_b": "Transmission Control Protocol (TCP)",
    "choice_c": "Internet Control Message Protocol (ICMP)",
    "choice_d": "Security orchestration, automation, and response (SOAR)",
    "correct_answer": "A",
    "explanation": "Fraggle is a denial of service (DoS) attack that uses UDP. Other attacks, such as a SYN flood attack, use TCP. A smurf attack is similar to a fraggle attack, but it uses ICMP. SOAR is a group of technologies that provide automated responses to common attacks, not a protocol.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      546,
      567,
      553,
      556,
      544
    ],
    "source": ""
  },
  {
    "id": 3610,
    "question": "You are updating the training manual for security administrators and want to add a description of a zero-day exploit. <br>Which of the following best describes a zero-day exploit?",
    "choice_a": "An attack that exploits a vulnerability that doesn't have a patch or fix",
    "choice_b": "A newly discovered vulnerability that doesn't have a patch or fix",
    "choice_c": "An attack on systems without an available patch",
    "choice_d": "Malware that delivers its payload after a user starts an application",
    "correct_answer": "A",
    "explanation": "A zero-day exploit is an attack that exploits a vulnerability that doesn't have a patch or fix. A newly discovered vulnerability is only a vulnerability until someone tries to exploit it. Attacks on unpatched systems aren't zero-day exploits. A virus is a type of malware that delivers its payload after a user launches an application.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      531,
      530,
      529,
      532,
      544
    ],
    "source": ""
  },
  {
    "id": 3611,
    "question": "Users in an organization complain that they can't access several websites that are usually available. After troubleshooting the issue, you discover that an intrusion protection system (IPS) is blocking the traffic, but the traffic is not malicious. <br>What does this describe?",
    "choice_a": "A false negative",
    "choice_b": "A honeynet",
    "choice_c": "A false positive",
    "choice_d": "Sandboxing",
    "correct_answer": "C",
    "explanation": "This is a false positive. The IPS falsely identified normal web traffic as an attack and blocked it. A false negative occurs when a system doesn't detect an actual attack. A honeynet is a group of honeypots used to lure attackers. Sandboxing provides an isolated environment for testing and is unrelated to this question.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      566,
      548,
      560,
      549,
      562
    ],
    "source": ""
  },
  {
    "id": 3612,
    "question": "You are installing a new intrusion detection system (IDS). It requires you to create a baseline before fully implementing it. <br>Which of the following <italic>best</italic> describes this IDS?",
    "choice_a": "A pattern-matching IDS",
    "choice_b": "A knowledge-based IDS",
    "choice_c": "A signature-based IDS",
    "choice_d": "An anomaly-based IDS",
    "correct_answer": "D",
    "explanation": "An anomaly-based IDS requires a baseline, and it then monitors traffic for any anomalies or changes when compared to the baseline. It's also called behavior based and heuristics based. Pattern-based detection (also known as knowledge-based detection and signature-based detection) uses known signatures to detect attacks.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      566,
      1043,
      562,
      1042,
      524
    ],
    "source": ""
  },
  {
    "id": 3613,
    "question": "An administrator is implementing an intrusion detection system. Once installed, it will monitor all traffic and raise alerts when it detects suspicious traffic. <br>Which of the following best describes this system?",
    "choice_a": "A host-based intrusion detection system (HIDS)",
    "choice_b": "A network-based intrusion detection system (NIDS)",
    "choice_c": "A honeynet",
    "choice_d": "A network firewall",
    "correct_answer": "B",
    "explanation": "An NIDS will monitor all traffic and raise alerts when it detects suspicious traffic. A HIDS only monitors a single system. A honeynet is a network of honeypots used to lure attackers away from live networks. A network firewall filters traffic, but it doesn't raise alerts on suspicious traffic.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      547,
      566,
      548,
      549,
      560
    ],
    "source": ""
  },
  {
    "id": 3614,
    "question": "You are installing a system that management hopes will reduce incidents in the network. The setup instructions require you to configure it in line with traffic so that all traffic goes through it before reaching the internal network. <br>Which of the following choices <italic>best</italic> identifies this system?",
    "choice_a": "A network-based intrusion prevention system (NIPS)",
    "choice_b": "A network-based intrusion detection system (NIDS)",
    "choice_c": "A host-based intrusion prevention system (HIPS)",
    "choice_d": "A host-based intrusion detection system (HIDS)",
    "correct_answer": "A",
    "explanation": "This describes an NIPS. It is monitoring network traffic, and it is placed in line with the traffic. An NIDS isn't placed in line with the traffic, so it isn't the best choice. Host-based systems only monitor traffic sent to specific hosts, not network traffic.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      548,
      547,
      538,
      543,
      539
    ],
    "source": ""
  },
  {
    "id": 3615,
    "question": "After installing an application on a user's system, your supervisor told you to remove it because it is consuming most of the system's resources. <br>Which of the following prevention systems did you most likely install?",
    "choice_a": "A network-based intrusion detection system (NIDS)",
    "choice_b": "A web application firewall (WAF)",
    "choice_c": "A security information and event management (SIEM) system",
    "choice_d": "A host-based intrusion detection system (HIDS)",
    "correct_answer": "D",
    "explanation": "A drawback of some HIDSs is that they interfere with a single system's normal operation by consuming too many resources. The other options refer to applications that aren't installed on user systems.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      548,
      544,
      550,
      531,
      575
    ],
    "source": ""
  },
  {
    "id": 3616,
    "question": "You are replacing a failed switch. The configuration documentation for the original switch indicates a specific port needs to be configured as a mirrored port. <br>Which of the following network devices would connect to this port?",
    "choice_a": "An intrusion prevention system (IPS)",
    "choice_b": "An intrusion detection system (IDS)",
    "choice_c": "A honeypot",
    "choice_d": "A sandbox",
    "correct_answer": "B",
    "explanation": "An IDS is most likely to connect to a switch port configured as a mirrored port. An IPS is placed in line with traffic, so it is placed before the switch. A honeypot doesn't need to see all traffic going through a switch. A sandbox is an isolated area often used for testing and would not need all traffic from a switch.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      547,
      548,
      556,
      841,
      528
    ],
    "source": ""
  },
  {
    "id": 3617,
    "question": "A network includes a network-based intrusion detection system (NIDS). However, security administrators discovered that an attack entered the network and the NIDS did not raise an alarm. <br>What does this describe?",
    "choice_a": "A false positive",
    "choice_b": "A false negative",
    "choice_c": "A fraggle attack",
    "choice_d": "A smurf attack",
    "correct_answer": "B",
    "explanation": "A false negative occurs when there is an attack but the IDS doesn't detect it and raise an alarm. In contrast, a false positive occurs when an IDS incorrectly raises an alarm, even though there isn't an attack. The attack may be a UDP-based fraggle attack or an ICMP-based smurf attack, but the attack is real, and since the IDS doesn't detect it, it is a false negative.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      547,
      538,
      546,
      560,
      556
    ],
    "source": ""
  },
  {
    "id": 3618,
    "question": "Management wants to add an intrusion detection system (IDS) that will detect new security threats. <br>Which of the following is the best choice?",
    "choice_a": "A signature-based IDS",
    "choice_b": "An anomaly detection IDS",
    "choice_c": "An active IDS",
    "choice_d": "A network-based IDS",
    "correct_answer": "B",
    "explanation": "An anomaly-based IDS (also known as a behavior-based IDS) can detect new security threats. A signature-based IDS only detects attacks from known threats. An active IDS identifies the response after a threat is detected. A network-based IDS can be both signature based and anomaly based.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      566,
      1043,
      562,
      547,
      548
    ],
    "source": ""
  },
  {
    "id": 3619,
    "question": "Your organization recently implemented a centralized application for monitoring. <br>Which of the following best describes this?",
    "choice_a": "SOAR",
    "choice_b": "SIEM",
    "choice_c": "HIDS",
    "choice_d": "Threat feed",
    "correct_answer": "B",
    "explanation": "A security information and event management (SIEM) system is a centralized application that monitors multiple systems. Security orchestration, automation, and response (SOAR) is a group of technologies that provide automated responses to common attacks. A host-based intrusion detection system (HIDS) is decentralized because it is on one system only. A threat feed is a stream of data on current threats.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      557,
      566,
      561,
      547,
      538
    ],
    "source": ""
  },
  {
    "id": 3620,
    "question": "After a recent attack, management decided to implement an egress monitoring system that will prevent data exfiltration. <br>Which of the following is the best choice?",
    "choice_a": "An NIDS",
    "choice_b": "An NIPS",
    "choice_c": "A firewall",
    "choice_d": "A DLP system",
    "correct_answer": "D",
    "explanation": "A network-based data loss prevention (DLP) system monitors outgoing traffic (egress monitoring) and can thwart data exfiltration attempts. Network-based intrusion detection systems (NIDSs) and intrusion protection systems (IPSs) primarily monitor incoming traffic for threats. Firewalls can block traffic or allow traffic based on rules in an access control list (ACL), but they can't detect unauthorized data exfiltration attacks.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      559,
      548,
      566,
      547,
      538
    ],
    "source": ""
  },
  {
    "id": 3621,
    "question": "Security administrators are regularly monitoring threat feeds and using that information to check systems within the network. Their goal is to discover any infections or attacks that haven't been detected by existing tools. <br>What does this describe?",
    "choice_a": "Threat hunting",
    "choice_b": "Threat intelligence",
    "choice_c": "Implementing the kill chain",
    "choice_d": "Using artificial intelligence",
    "correct_answer": "A",
    "explanation": "Threat hunting is the process of actively searching for infections or attacks within a network. Threat intelligence refers to the actionable intelligence created after analyzing incoming data, such as threat feeds. Threat hunters use threat intelligence to search for specific threats. Additionally, they may use a kill chain model to mitigate these threats. Artificial intelligence (AI) refers to actions by a machine, but the scenario indicates administrators are doing the work.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      564,
      563,
      1043,
      562,
      561
    ],
    "source": ""
  },
  {
    "id": 3622,
    "question": "Administrators find that they are repeating the same steps to verify intrusion detection system alerts and perform more repetitive steps to mitigate well-known attacks. Of the following choices, what can automate these steps?",
    "choice_a": "SOAR",
    "choice_b": "SIEM",
    "choice_c": "NIDS",
    "choice_d": "DLP",
    "correct_answer": "A",
    "explanation": "Security orchestration, automation, and response (SOAR) technologies provide automated responses to common attacks, reducing an administrator's workload. A security information and event management (SIEM) system is a centralized application that monitors log entries from multiple sources. A network-based intrusion detection system (NIDS) raises the alerts. A data loss prevention (DLP) system helps with egress monitoring and is unrelated to this question.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      653,
      674,
      651,
      675,
      621
    ],
    "source": ""
  },
  {
    "id": 3623,
    "question": "James is working with his organization's leadership to help them understand the role that disaster recovery plays in their cybersecurity strategy. The leaders are confused about the differences between disaster recovery and business continuity. <br>What is the end goal of disaster recovery planning?",
    "choice_a": "Preventing business interruption",
    "choice_b": "Setting up temporary business operations",
    "choice_c": "Restoring normal business activity",
    "choice_d": "Minimizing the impact of a disaster",
    "correct_answer": "C",
    "explanation": "Once a disaster interrupts the business operations, the goal of DRP is to restore regular business activity as quickly as possible. Thus, disaster recovery planning picks up where business continuity planning leaves off. Preventing business interruption is the goal of business continuity, not disaster recovery programs. Although disaster recovery programs are involved in restoring normal activity and minimizing the impact of disasters, this is not their end goal.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      569,
      591,
      581,
      586,
      595
    ],
    "source": ""
  },
  {
    "id": 3624,
    "question": "Kevin is attempting to determine an appropriate backup frequency for his organization's database server and wants to ensure that any data loss is within the organization's risk appetite. <br>Which one of the following security process metrics would best assist him with this task?",
    "choice_a": "RTO",
    "choice_b": "MTD",
    "choice_c": "RPO",
    "choice_d": "MTBF",
    "correct_answer": "C",
    "explanation": "The recovery point objective (RPO) specifies the maximum amount of data that may be lost during a disaster and should be used to guide backup strategies. The maximum tolerable downtime (MTD) and recovery time objective (RTO) are related to the duration of an outage, rather than the amount of data lost. The mean time between failures (MTBF) is related to the frequency of failure events.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      502,
      791,
      792,
      786,
      500
    ],
    "source": ""
  },
  {
    "id": 3625,
    "question": "Brian's organization recently suffered a disaster and wants to improve their disaster recovery program based on their experience. <br>Which one of the following activities will best assist with this task?",
    "choice_a": "Training programs",
    "choice_b": "Awareness efforts",
    "choice_c": "BIA review",
    "choice_d": "Lessons learned",
    "correct_answer": "D",
    "explanation": "The lessons learned session captures discoveries made during the disaster recovery process and facilitates continuous improvement. It may identify deficiencies in training and awareness or in the business impact analysis.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      595,
      596,
      593,
      581,
      540
    ],
    "source": ""
  },
  {
    "id": 3626,
    "question": "Adam is reviewing the fault-tolerance controls used by his organization and realizes that they currently have a single point of failure in the disks used to support a critical server. <br>Which one of the following controls can provide fault tolerance for these disks?",
    "choice_a": "Load balancing",
    "choice_b": "RAID",
    "choice_c": "Clustering",
    "choice_d": "HA pairs",
    "correct_answer": "B",
    "explanation": "Redundant arrays of inexpensive disks (RAID) are a fault-tolerance control that allow an organization's storage service to withstand the loss of one or more individual disks. Load balancing, clustering, and high-availability (HA) pairs are all fault-tolerance services designed for server compute capacity, not storage.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      576,
      835,
      575,
      577,
      578
    ],
    "source": ""
  },
  {
    "id": 3627,
    "question": "Brad is helping to design a disaster recovery strategy for his organization and is analyzing possible storage locations for backup data. He is not certain where the organization will recover operations in the event of a disaster and would like to choose an option that allows them the flexibility to easily retrieve data from any DR site. <br>Which one of the following storage locations provides the best option for Brad?",
    "choice_a": "Primary data center",
    "choice_b": "Field office",
    "choice_c": "Cloud computing",
    "choice_d": "IT manager's home",
    "correct_answer": "C",
    "explanation": "Cloud computing services provide an excellent location for backup storage because they are accessible from any location. The primary data center is a poor choice, since it may be damaged during a disaster. A field office is reasonable, but it is in a specific location and is not as flexible as a cloud-based approach. The IT manager's home is a poor choice\u2014the IT manager may leave the organization or may not have appropriate environmental and physical security controls in place.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      589,
      598,
      592,
      586,
      573
    ],
    "source": ""
  },
  {
    "id": 3628,
    "question": "Which of the following statements about business continuity planning and disaster recovery planning are correct?  (Select all that apply.)",
    "choice_a": "Business continuity planning is focused on keeping business functions uninterrupted when a disaster strikes.",
    "choice_b": "Organizations can choose whether to develop business continuity planning or disaster recovery planning plans.",
    "choice_c": "Business continuity planning picks up where disaster recovery planning leaves off.",
    "choice_d": "Disaster recovery planning guides an organization through recovery of normal operations at the primary facility.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The only incorrect statement here is that business continuity planning picks up where disaster recovery planning leaves off. In fact, the opposite is true: disaster recovery planning picks up where business continuity planning leaves off. The other three statements are all accurate reflections of the role of business continuity planning and disaster recovery planning. Business continuity planning is focused on keeping business functions uninterrupted when a disaster strikes. Organizations can choose whether to develop business continuity planning or disaster recovery planning plans, although it is highly recommended that they do so. Disaster recovery planning guides an organization through recovery of normal operations at the primary facility.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      569,
      586,
      591,
      581,
      596
    ],
    "source": ""
  },
  {
    "id": 3629,
    "question": "Tonya is reviewing the flood risk to her organization and learns that their primary data center resides within a 100-year flood plain. <br>What conclusion can she draw from this information?",
    "choice_a": "The last flood of any kind to hit the area was more than 100 years ago.",
    "choice_b": "The odds of a flood at this level are 1 in 100 in any given year.",
    "choice_c": "The area is expected to be safe from flooding for at least 100 years.",
    "choice_d": "The last significant flood to hit the area was more than 100 years ago.",
    "correct_answer": "B",
    "explanation": "The term <italic>100-year flood plain</italic> is used to describe an area where flooding is expected once every 100 years. It is, however, more mathematically correct to say that this label indicates a 1 percent probability of flooding in any given year.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      953,
      952,
      911,
      954,
      910
    ],
    "source": ""
  },
  {
    "id": 3630,
    "question": "Randi is designing a disaster recovery mechanism for her organization's critical business databases. She selects a strategy where an exact, up-to-date copy of the database is maintained at an alternative location. <br>What term describes this approach?",
    "choice_a": "Transaction logging",
    "choice_b": "Remote journaling",
    "choice_c": "Electronic vaulting",
    "choice_d": "Remote mirroring",
    "correct_answer": "D",
    "explanation": "When you use remote mirroring, an exact copy of the database is maintained at an alternative location. You keep the remote copy up to date by executing all transactions on both the primary and remote sites at the same time. Electronic vaulting follows a similar process of storing all data at the remote location, but it does not do so in real time. Transaction logging and remote journaling options send logs, rather than full data replicas, to the remote location.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      584,
      598,
      594,
      597,
      586
    ],
    "source": ""
  },
  {
    "id": 3631,
    "question": "Bryn runs a corporate website and currently uses a single server, which is capable of handling the site's entire load. She is concerned, however, that an outage on that server could cause the organization to exceed its RTO. <br>What action could she take that would best protect against this risk?",
    "choice_a": "Install dual power supplies in the server.",
    "choice_b": "Replace the server's hard drives with RAID arrays.",
    "choice_c": "Deploy multiple servers behind a load balancer.",
    "choice_d": "Perform regular backups of the server.",
    "correct_answer": "C",
    "explanation": "All of these are good practices that could help improve the quality of service that Bryn provides from her website. Installing dual power supplies or deploying RAID arrays could reduce the likelihood of a server failure, but these measures only protect against a single risk each. Deploying multiple servers behind a load balancer is the best option because it protects against any type of risk that would cause a server failure. Backups are an important control for recovering operations after a disaster and different backup strategies could indeed alter the RTO, but it is even better if Bryn can design a web architecture that lowers the risk of the outage occurring in the first place.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      500,
      502,
      496,
      789,
      779
    ],
    "source": ""
  },
  {
    "id": 3632,
    "question": "Carl recently completed his organization's annual business continuity plan refresh and is now turning his attention to the disaster recovery plan. <br>What output from the business continuity plan can he use to prepare the business unit prioritization task of disaster recovery planning?",
    "choice_a": "Vulnerability analysis",
    "choice_b": "Business impact analysis",
    "choice_c": "Risk management",
    "choice_d": "Continuity planning",
    "correct_answer": "B",
    "explanation": "During the business impact analysis phase, you must identify the business priorities of your organization to assist with the allocation of BCP resources. You can use this same information to drive the disaster recovery planning business unit prioritization.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      580,
      569,
      587,
      581,
      596
    ],
    "source": ""
  },
  {
    "id": 3633,
    "question": "Nolan is considering the use of several different types of alternate processing facility for his organization's data center. <br>Which one of the following alternative processing sites takes the longest time to activate but has the lowest cost to implement?",
    "choice_a": "Hot site",
    "choice_b": "Mobile site",
    "choice_c": "Cold site",
    "choice_d": "Warm site",
    "correct_answer": "C",
    "explanation": "The cold site contains none of the equipment necessary to restore operations. All of the equipment must be brought in and configured and data must be restored to it before operations can commence. This process often takes weeks, but cold sites also have the lowest cost to implement. Hot sites, warm sites, and mobile sites all have quicker recovery times.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      582,
      598,
      580,
      592,
      594
    ],
    "source": ""
  },
  {
    "id": 3634,
    "question": "Ingrid is concerned that one of her organization's data centers has been experiencing a series of momentary power outages. <br>Which one of the following controls would best preserve their operating status?",
    "choice_a": "Generator",
    "choice_b": "Dual power supplies",
    "choice_c": "UPS",
    "choice_d": "Redundant network links",
    "correct_answer": "C",
    "explanation": "Uninterruptible power supplies (UPSs) provide a battery-backed source of power that is capable of preserving operations in the event of brief power outages. Generators take a significant amount of time to start and are more suitable for longer-term outages. Dual power supplies protect against power supply failures and not power outages. Redundant network links are a network continuity control and do not provide power.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      577,
      575,
      571,
      578,
      596
    ],
    "source": ""
  },
  {
    "id": 3635,
    "question": "Which one of the following items is a characteristic of hot sites but not a characteristic of warm sites?",
    "choice_a": "Communications circuits",
    "choice_b": "Workstations",
    "choice_c": "Servers",
    "choice_d": "Current data",
    "correct_answer": "D",
    "explanation": "Warm sites and hot sites both contain workstations, servers, and the communications circuits necessary to achieve operational status. The main difference between the two alternatives is the fact that hot sites contain near-real-time copies of the operational data and warm sites require the restoration of data from backup.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      582,
      598,
      585,
      597,
      592
    ],
    "source": ""
  },
  {
    "id": 3636,
    "question": "Harry is conducting a disaster recovery test. He moved a group of personnel to the alternate recovery site, where they are mimicking the operations of the primary site but do not have operational responsibility. <br>What type of disaster recovery test is he performing?",
    "choice_a": "Checklist test",
    "choice_b": "Structured walk-through",
    "choice_c": "Simulation test",
    "choice_d": "Parallel test",
    "correct_answer": "D",
    "explanation": "The parallel test involves relocating personnel to the alternate recovery site and implementing site activation procedures. Checklist tests, structured walk-throughs, and simulations are all test types that do not involve actually activating the alternate site.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      594,
      597,
      595,
      596,
      581
    ],
    "source": ""
  },
  {
    "id": 3637,
    "question": "What type of document will help public relations specialists and other individuals who need a high-level summary of disaster recovery efforts while they are under way?",
    "choice_a": "Executive summary",
    "choice_b": "Technical guides",
    "choice_c": "Department-specific plans",
    "choice_d": "Checklists",
    "correct_answer": "A",
    "explanation": "The executive summary provides a high-level view of the entire organization's disaster recovery efforts. This document is useful for the managers and leaders of the firm as well as public relations personnel who need a nontechnical perspective on this complex effort.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      586,
      581,
      587,
      591,
      569
    ],
    "source": ""
  },
  {
    "id": 3638,
    "question": "What disaster recovery planning tool can be used to protect an organization against the failure of a critical software firm to provide appropriate support for their products?",
    "choice_a": "Differential backups",
    "choice_b": "Business impact analysis",
    "choice_c": "Incremental backups",
    "choice_d": "Software escrow agreement",
    "correct_answer": "D",
    "explanation": "Software escrow agreements place the application source code in the hands of an independent third party, thus providing firms with a \"safety net\" in the event a developer goes out of business or fails to honor the terms of a service agreement.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      590,
      569,
      586,
      598,
      595
    ],
    "source": ""
  },
  {
    "id": 3639,
    "question": "What type of backup involves always storing copies of all files modified since the most recent full backup?",
    "choice_a": "Differential backups",
    "choice_b": "Partial backup",
    "choice_c": "Incremental backups",
    "choice_d": "Database backup",
    "correct_answer": "A",
    "explanation": "Differential backups involve always storing copies of all files modified since the most recent full backup, regardless of any incremental or differential backups created during the intervening time period.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      588,
      589,
      569,
      575,
      590
    ],
    "source": ""
  },
  {
    "id": 3640,
    "question": "You operate a grain processing business and are developing your restoration priorities. <br>Which one of the following systems would likely be your highest priority?",
    "choice_a": "Order-processing system",
    "choice_b": "Fire suppression system",
    "choice_c": "Payroll system",
    "choice_d": "Website",
    "correct_answer": "B",
    "explanation": "People should always be your highest priority in business continuity planning. As  life safety systems, fire suppression systems should always receive high prioritization.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      508,
      580,
      591,
      577,
      596
    ],
    "source": ""
  },
  {
    "id": 3641,
    "question": "What combination of backup strategies provides the fastest backup restoration time?",
    "choice_a": "Full backups and differential backups",
    "choice_b": "Partial backups and incremental backups",
    "choice_c": "Full backups and incremental backups",
    "choice_d": "Incremental backups and differential backups",
    "correct_answer": "A",
    "explanation": "Any backup strategy must include full backups at some point in the process. If a combination of full and differential backups is used, a maximum of two backups must be restored. If a combination of full and incremental backups is chosen, the number of required restorations may be large.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      588,
      589,
      596,
      598,
      592
    ],
    "source": ""
  },
  {
    "id": 3642,
    "question": "What type of disaster recovery plan test fully evaluates operations at the backup facility but does not shift primary operations responsibility from the main site?",
    "choice_a": "Structured walk-through",
    "choice_b": "Parallel test",
    "choice_c": "Full-interruption test",
    "choice_d": "Simulation test",
    "correct_answer": "B",
    "explanation": "Parallel tests involve moving personnel to the recovery site and gearing up operations, but responsibility for conducting day-to-day operations of the business remains at the primary operations center.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      594,
      597,
      582,
      585,
      596
    ],
    "source": ""
  },
  {
    "id": 3668,
    "question": "Devin is revising the policies and procedures used by his organization to conduct investigations and would like to include a definition of computer crime. <br>Which one of the following definitions would best meet his needs?",
    "choice_a": "Any attack specifically listed in your security policy",
    "choice_b": "Any illegal attack that compromises a protected computer",
    "choice_c": "Any violation of a law or regulation that involves a computer",
    "choice_d": "Failure to practice due diligence in computer security",
    "correct_answer": "C",
    "explanation": "A crime is any violation of a law or regulation. The violation stipulation defines the action as a crime. It is a computer crime if the violation involves a computer, either as the target or as a tool. Computer crimes may not be defined in an organization's policy, since crimes are only defined in law. Illegal attacks are indeed crimes, but this is too narrow a definition. The failure to practice due diligence may be a liability but, in most cases, is not a criminal action.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      97,
      101,
      20,
      15,
      13
    ],
    "source": ""
  },
  {
    "id": 3669,
    "question": "What is the main purpose of a military and intelligence attack?",
    "choice_a": "To attack the availability of military systems",
    "choice_b": "To obtain secret and restricted information from military or law enforcement sources",
    "choice_c": "To utilize military or intelligence agency systems to attack other, nonmilitary sites",
    "choice_d": "To compromise military systems for use in attacks against other systems",
    "correct_answer": "B",
    "explanation": "A military and intelligence attack targets the classified data that resides on the system. To the attacker, the value of the information justifies the risk associated with such an attack. The information extracted from this type of attack is often used to plan subsequent attacks.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      4,
      3,
      6,
      41,
      43
    ],
    "source": ""
  },
  {
    "id": 3670,
    "question": "Which of the following is not a canon of the ISC2 Code of Ethics?",
    "choice_a": "Protect your colleagues.",
    "choice_b": "Provide diligent and competent service to principals.",
    "choice_c": "Advance and protect the profession.",
    "choice_d": "Protect society.",
    "correct_answer": "A",
    "explanation": "The Code of Ethics does not require that you protect your colleagues.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      955,
      956,
      957,
      17,
      65
    ],
    "source": ""
  },
  {
    "id": 3671,
    "question": "Which of the following are examples of financially motivated attacks? (Select all that apply.)",
    "choice_a": "Accessing services that you have not purchased",
    "choice_b": "Disclosing confidential personal employee information",
    "choice_c": "Transferring funds from an unapproved source into your account",
    "choice_d": "Selling a botnet for use in a DDoS attack",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "A financial attack focuses primarily on obtaining services and funds illegally. Accessing services that you have not purchased is an example of obtaining services illegally. Transferring funds from an unapproved source is obtaining funds illegally, as is leasing out a botnet for use in DDoS attacks. Disclosing confidential information is not necessarily financially motivated.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      41,
      62,
      60,
      61,
      4
    ],
    "source": ""
  },
  {
    "id": 3672,
    "question": "Which one of the following attacker actions is most indicative of a terrorist attack?",
    "choice_a": "Altering sensitive trade secret documents",
    "choice_b": "Damaging the ability to communicate and respond to a physical attack",
    "choice_c": "Stealing unclassified information",
    "choice_d": "Transferring funds to other countries",
    "correct_answer": "B",
    "explanation": "A terrorist attack is launched to interfere with a way of life by creating an atmosphere of fear. A computer terrorist attack can reach this goal by reducing the ability to respond to a simultaneous physical attack. Although terrorists may engage in other actions, such as altering information, stealing data, or transferring funds, as part of their attacks, these items alone are not indicators of terrorist activity.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      64,
      97,
      101,
      55,
      15
    ],
    "source": ""
  },
  {
    "id": 3673,
    "question": "Which of the following would not be a primary goal of a grudge attack?",
    "choice_a": "Disclosing embarrassing personal information",
    "choice_b": "Launching a virus on an organization's system",
    "choice_c": "Sending inappropriate email with a spoofed origination address of the victim organization",
    "choice_d": "Using automated tools to scan the organization's systems for vulnerable ports",
    "correct_answer": "D",
    "explanation": "Any action that can harm a person or organization, either directly or through embarrassment, would be a valid goal of a grudge attack. The purpose of such an attack is to \"get back\" at someone.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      55,
      61,
      101,
      15,
      11
    ],
    "source": ""
  },
  {
    "id": 3674,
    "question": "What are the primary reasons attackers engage in thrill attacks?  (Select all that apply.)",
    "choice_a": "Bragging rights",
    "choice_b": "Money from the sale of stolen documents",
    "choice_c": "Pride of conquering a secure system",
    "choice_d": "Retaliation against a person or organization",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Thrill attacks have no reward other than providing a boost to pride and ego. The thrill of launching the attack comes from the act of participating in the attack (and not getting caught).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      71,
      56,
      62,
      40,
      1
    ],
    "source": ""
  },
  {
    "id": 3675,
    "question": "What is the most important rule to follow when collecting evidence?",
    "choice_a": "Do not turn off a computer until you photograph the screen.",
    "choice_b": "List all people present while collecting evidence.",
    "choice_c": "Avoid the modification of evidence during the collection process.",
    "choice_d": "Transfer all equipment to a secure storage location.",
    "correct_answer": "C",
    "explanation": "Although the other options have some merit in individual cases, the most important rule is to never modify, or taint, evidence. If you modify evidence, it becomes inadmissible in court.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      605,
      607,
      541,
      601,
      509
    ],
    "source": ""
  },
  {
    "id": 3676,
    "question": "What would be a valid argument for not immediately removing power from a machine when an incident is discovered?",
    "choice_a": "All of the damage has been done. Turning the machine off would not stop additional damage.",
    "choice_b": "There is no other system that can replace this one if it is turned off.",
    "choice_c": "Too many users are logged in and using the system.",
    "choice_d": "Valuable evidence in memory will be lost.",
    "correct_answer": "D",
    "explanation": "The most compelling reason for not removing power from a machine is that you will lose the contents of memory. Carefully consider the pros and cons of removing power. After all is considered, it may be the best choice.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      541,
      605,
      601,
      565,
      604
    ],
    "source": ""
  },
  {
    "id": 3677,
    "question": "What type of evidence refers to written documents that are brought into court to prove a fact?",
    "choice_a": "Best evidence",
    "choice_b": "Parol evidence",
    "choice_c": "Documentary evidence",
    "choice_d": "Testimonial evidence",
    "correct_answer": "C",
    "explanation": "Written documents brought into court to prove the facts of a case are referred to as documentary evidence. The best evidence rule states that when a document is used as evidence in a court proceeding, the original document must be introduced. The parol evidence rule states that when an agreement between parties is put into written form, the written document is assumed to contain all the terms of the agreement, and no verbal agreements may modify the written agreement. Testimonial evidence is evidence consisting of the testimony of a witness, either verbal testimony in court or written testimony in a recorded deposition.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      979,
      981,
      13,
      105,
      101
    ],
    "source": ""
  },
  {
    "id": 3678,
    "question": "Which one of the following investigation types has the highest standard of evidence?",
    "choice_a": "Administrative",
    "choice_b": "Civil",
    "choice_c": "Criminal",
    "choice_d": "Regulatory",
    "correct_answer": "C",
    "explanation": "Criminal investigations may result in the imprisonment of individuals and, therefore, have the highest standard of evidence to protect the rights of the accused.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      981,
      97,
      100,
      105,
      6
    ],
    "source": ""
  },
  {
    "id": 3679,
    "question": "During an operational investigation, what type of analysis might an organization undertake to prevent similar incidents in the future?",
    "choice_a": "Forensic analysis",
    "choice_b": "Root cause analysis",
    "choice_c": "Network traffic analysis",
    "choice_d": "Fagan analysis",
    "correct_answer": "B",
    "explanation": "Root cause analysis seeks to identify the reason that an operational issue occurred. The root cause analysis often highlights issues that require remediation to prevent similar incidents in the future. Forensic analysis is used to obtain evidence from digital systems. Network traffic analysis is an example of a forensic analysis category. Fagan inspection is a software testing technique.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      540,
      565,
      595,
      543,
      527
    ],
    "source": ""
  },
  {
    "id": 3680,
    "question": "What step of the Electronic Discovery Reference Model ensures that information that may be subject to discovery is not altered?",
    "choice_a": "Preservation",
    "choice_b": "Production",
    "choice_c": "Processing",
    "choice_d": "Presentation",
    "correct_answer": "A",
    "explanation": "Preservation ensures that potentially discoverable information is protected against alteration or deletion. Production places the information into a format that may be shared with others and delivers it to other parties, such as opposing counsel. Processing screens the collected information to perform a \"rough cut\" of irrelevant information, reducing the amount of information requiring detailed screening. Presentation displays the information to witnesses, the court, and other parties.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      600,
      541,
      605,
      599,
      604
    ],
    "source": ""
  },
  {
    "id": 3681,
    "question": "Gary is a system administrator and is testifying in court about a cybercrime incident. He brings server logs to support his testimony. <br>What type of evidence are the server logs?",
    "choice_a": "Real evidence",
    "choice_b": "Documentary evidence",
    "choice_c": "Parol evidence",
    "choice_d": "Testimonial evidence",
    "correct_answer": "B",
    "explanation": "Server logs are an example of documentary evidence. Gary may ask that they be introduced in court and will then be asked to offer testimonial evidence about how he collected and preserved the evidence. This testimonial evidence authenticates the documentary evidence.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      601,
      602,
      607,
      615,
      541
    ],
    "source": ""
  },
  {
    "id": 3682,
    "question": "You are a law enforcement officer and you need to confiscate a PC from a suspected attacker who does not work for your organization. You are concerned that if you approach the individual, they may destroy evidence. <br>What legal avenue is most appropriate?",
    "choice_a": "Consent agreement signed by employees",
    "choice_b": "Search warrant",
    "choice_c": "No legal avenue necessary",
    "choice_d": "Voluntary consent",
    "correct_answer": "B",
    "explanation": "In this case, you need a search warrant to confiscate equipment without giving the suspect time to destroy evidence. If the suspect worked for your organization and you had all employees sign consent agreements, you could simply confiscate the equipment.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      605,
      607,
      615,
      599,
      541
    ],
    "source": ""
  },
  {
    "id": 3683,
    "question": "Gavin is considering altering his organization's log retention policy to delete logs at the end of each day. <br>What is the most important reason that he should avoid this approach?",
    "choice_a": "An incident may not be discovered for several days and valuable evidence could be lost.",
    "choice_b": "Disk space is cheap, and log files are used frequently.",
    "choice_c": "Log files are protected and cannot be altered.",
    "choice_d": "Any information in a log file is useless after it is several hours old.",
    "correct_answer": "A",
    "explanation": "Log files contain a large volume of generally useless information. However, when you are trying to track down a problem or an incident, log files can be invaluable. Even if an incident is discovered as it is happening, it may have been preceded by other incidents. Log files provide valuable clues and should be protected and archived, often by forwarding log entries to a centralized log management system.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      843,
      555,
      557,
      541,
      556
    ],
    "source": ""
  },
  {
    "id": 3684,
    "question": "What phase of the Electronic Discovery Reference Model examines information to remove information subject to attorney-client privilege?",
    "choice_a": "Identification",
    "choice_b": "Collection",
    "choice_c": "Processing",
    "choice_d": "Review",
    "correct_answer": "D",
    "explanation": "Review examines the information resulting from the Processing phase to determine what information is responsive to the request and remove any information protected by attorney-client privilege. Identification locates the information that may be responsive to a discovery request when the organization believes that litigation is likely. Collection gathers the relevant information centrally for use in the eDiscovery process. Processing screens the collected information to perform a \"rough cut\" of irrelevant information, reducing the amount of information requiring detailed screening.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      600,
      615,
      605,
      599,
      604
    ],
    "source": ""
  },
  {
    "id": 3685,
    "question": "What are ethics?",
    "choice_a": "Mandatory actions required to fulfill job requirements",
    "choice_b": "Laws of professional conduct",
    "choice_c": "Regulations set forth by a professional organization",
    "choice_d": "Rules of personal behavior",
    "correct_answer": "D",
    "explanation": "Ethics are simply rules of personal behavior. Many professional organizations establish formal codes of ethics to govern their members, but ethics are personal rules individuals use to guide their lives.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      955,
      956,
      957,
      40,
      20
    ],
    "source": ""
  },
  {
    "id": 3686,
    "question": "According to the ISC2 Code of Ethics, how are CISSPs expected to act?",
    "choice_a": "Honestly, diligently, responsibly, and legally",
    "choice_b": "Honorably, honestly, justly, responsibly, and legally",
    "choice_c": "Upholding the security policy and protecting the organization",
    "choice_d": "Trustworthy, loyally, friendly, courteously",
    "correct_answer": "B",
    "explanation": "The second canon of the ISC2 Code of Ethics states how a CISSP should act, which is honorably, honestly, justly, responsibly, and legally.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      955,
      956,
      957,
      1,
      15
    ],
    "source": ""
  },
  {
    "id": 3687,
    "question": "Which of the following actions are considered unacceptable and unethical according to RFC 1087, Ethics and the Internet?",
    "choice_a": "Actions that compromise the privacy of classified information",
    "choice_b": "Actions that compromise the privacy of users",
    "choice_c": "Actions that disrupt organizational activities",
    "choice_d": "Actions in which a computer is used in a manner inconsistent with a stated security policy",
    "correct_answer": "B",
    "explanation": "RFC 1087 does not specifically address the statements in option A, C, or D. Although each type of activity listed is unacceptable, only \"actions that compromise the privacy of users\" are explicitly identified in RFC 1087.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      108,
      4,
      955,
      1
    ],
    "source": ""
  },
  {
    "id": 3688,
    "question": "Christine is helping her organization implement a DevOps approach to deploying code. <br>Which one of the following is <italic>not</italic> a component of the DevOps model?",
    "choice_a": "Information security",
    "choice_b": "Software development",
    "choice_c": "Quality assurance",
    "choice_d": "IT operations",
    "correct_answer": "A",
    "explanation": "The three elements of the DevOps model are software development, quality assurance, and IT operations. Information security is only introduced in the DevSecOps model.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      625,
      640,
      832,
      833,
      622
    ],
    "source": ""
  },
  {
    "id": 3689,
    "question": "Bob is developing a software application and has a field where users may enter a date. He wants to ensure that the values provided by the users are accurate dates to prevent security issues. <br>What technique should Bob use?",
    "choice_a": "Polyinstantiation",
    "choice_b": "Input validation",
    "choice_c": "Contamination",
    "choice_d": "Screening",
    "correct_answer": "B",
    "explanation": "Input validation ensures that the input provided by users matches the design parameters. Polyinstantiation includes additional records in a database for presentation to users with differing security levels as a defense against inference attacks. Contamination is the mixing of data from a higher classification level and/or need-to-know requirement with data from a lower classification level and/or need-to-know requirement. Screening is a generic term and does not represent any specific security technique in this context.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      668,
      620,
      654,
      661,
      675
    ],
    "source": ""
  },
  {
    "id": 3690,
    "question": "Vincent is a software developer who is working through a backlog of change tasks. He is not sure which tasks should have the highest priority. <br>What portion of the change management process would help him to prioritize tasks?",
    "choice_a": "Release control",
    "choice_b": "Configuration control",
    "choice_c": "Request control",
    "choice_d": "Change audit",
    "correct_answer": "C",
    "explanation": "Request control provides users with a framework to request changes and developers with the opportunity to prioritize those requests. Configuration control ensures that changes to software versions are made in accordance with the change and configuration management policies. Request control provides an organized framework for users to request modifications. Change auditing is used to ensure that the production environment is consistent with the change accounting records.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      624,
      621,
      1032,
      628,
      640
    ],
    "source": ""
  },
  {
    "id": 3691,
    "question": "Frank is conducting a risk analysis of his software development environment and, as a mitigation measure, would like to introduce an approach to failure management that places the system in a high level of security in the event of a failure. <br>What approach should he use?",
    "choice_a": "Fail-open",
    "choice_b": "Fail mitigation",
    "choice_c": "Fail-secure",
    "choice_d": "Fail clear",
    "correct_answer": "C",
    "explanation": "In a fail-secure state, the system remains in a high level of security until an administrator intervenes. In a fail-open state, the system defaults to a low level of security, disabling controls until the failure is resolved. Failure mitigation seeks to reduce the impact of a failure. Fail clear is not a valid approach.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      620,
      621,
      672,
      625,
      623
    ],
    "source": ""
  },
  {
    "id": 3692,
    "question": "What software development model uses a seven-stage approach with a feedback loop that allows progress one step backward?",
    "choice_a": "Boyce-Codd",
    "choice_b": "Iterative waterfall",
    "choice_c": "Spiral",
    "choice_d": "Agile",
    "correct_answer": "B",
    "explanation": "The iterative waterfall model uses a seven-stage approach to software development and includes a feedback loop that allows development to return to the previous phase to correct defects discovered during the subsequent phase.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      622,
      640,
      621,
      1034,
      1033
    ],
    "source": ""
  },
  {
    "id": 3693,
    "question": "Jane is conducting a threat assessment using threat modeling techniques as she develops security requirements for a software package her team is developing. <br>Which business function is she engaging in under the Software Assurance Maturity Model (SAMM)?",
    "choice_a": "Governance",
    "choice_b": "Design",
    "choice_c": "Implementation",
    "choice_d": "Verification",
    "correct_answer": "B",
    "explanation": "The activities of threat assessment, threat modeling, and security requirements are all part of the Design function under SAMM.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      640,
      807,
      621,
      1035
    ],
    "source": ""
  },
  {
    "id": 3694,
    "question": "Which one of the following key types is used to enforce referential integrity between database tables?",
    "choice_a": "Candidate key",
    "choice_b": "Primary key",
    "choice_c": "Foreign key",
    "choice_d": "Alternate key",
    "correct_answer": "C",
    "explanation": "Foreign keys are used to enforce referential integrity constraints between tables that participate in a relationship. Candidate keys are sets of fields that may potentially serve as the primary key, the key used to uniquely identify database records.  Alternate keys are candidate keys that are not selected as the primary key.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      840,
      630,
      839,
      838,
      632
    ],
    "source": ""
  },
  {
    "id": 3695,
    "question": "Richard believes that a database user is misusing his privileges to gain information about the company's overall business trends by issuing queries that combine data from a large number of records. <br>What process is the database user taking advantage of?",
    "choice_a": "Inference",
    "choice_b": "Contamination",
    "choice_c": "Polyinstantiation",
    "choice_d": "Aggregation",
    "correct_answer": "D",
    "explanation": "In this case, the process the database user is taking advantage of is aggregation. Aggregation attacks involve the use of specialized database functions to combine information from a large number of database records to reveal information that may be more sensitive than the information in individual records would reveal. Inference attacks use deductive reasoning to reach conclusions from existing data. Contamination is the mixing of data from a higher classification level and/or need-to-know requirement with data from a lower classification level and/or need-to-know requirement. Polyinstantiation is the creation of different database records for users of differing security levels.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      634,
      633,
      641,
      636,
      669
    ],
    "source": ""
  },
  {
    "id": 3696,
    "question": "What database technique can be used to prevent unauthorized users from determining classified information by noticing the absence of information normally available to them?",
    "choice_a": "Inference",
    "choice_b": "Manipulation",
    "choice_c": "Polyinstantiation",
    "choice_d": "Aggregation",
    "correct_answer": "C",
    "explanation": "Polyinstantiation allows the insertion of multiple records that appear to have the same primary key values into a database at different classification levels. Aggregation attacks involve the use of specialized database functions to combine information from a large number of database records to reveal information that may be more sensitive than the information in individual records would reveal. Inference attacks use deductive reasoning to reach conclusions from existing data. Manipulation is the authorized or unauthorized alteration of data in a database.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      633,
      634,
      636,
      630,
      632
    ],
    "source": ""
  },
  {
    "id": 3697,
    "question": "Which one of the following is <italic>not</italic> a principle of Agile development?",
    "choice_a": "Satisfy the customer through early and continuous delivery.",
    "choice_b": "Businesspeople and developers work together.",
    "choice_c": "Pay continuous attention to technical excellence.",
    "choice_d": "Prioritize security over other requirements.",
    "correct_answer": "D",
    "explanation": "In Agile, the highest priority is to satisfy the customer through early and continuous delivery of valuable software. It is not to prioritize security over other requirements. The Agile principles also include satisfying the customer through early and continuous delivery, businesspeople and developers working together, and paying continuous attention to technical excellence.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1035,
      1033,
      622,
      640,
      625
    ],
    "source": ""
  },
  {
    "id": 3698,
    "question": "What type of information is used to form the basis of an expert system's decision-making process?",
    "choice_a": "A series of weighted layered computations",
    "choice_b": "Combined input from a number of human experts, weighted according to past performance",
    "choice_c": "A series of \"if/then\" rules codified in a knowledge base",
    "choice_d": "A biological decision-making process that simulates the reasoning process used by the human mind",
    "correct_answer": "C",
    "explanation": "Expert systems use a knowledge base consisting of a series of \"if/then\" statements to form decisions based on the previous experience of human experts.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      637,
      641,
      1037,
      638,
      639
    ],
    "source": ""
  },
  {
    "id": 3699,
    "question": "In which phase of the SW-CMM does an organization use quantitative measures to gain a detailed understanding of the development process?",
    "choice_a": "Initial",
    "choice_b": "Repeatable",
    "choice_c": "Defined",
    "choice_d": "Managed",
    "correct_answer": "D",
    "explanation": "In the Managed phase, level 4 of the SW-CMM, the organization uses quantitative measures to gain a detailed understanding of the development process.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      623,
      622,
      621,
      832,
      833
    ],
    "source": ""
  },
  {
    "id": 3700,
    "question": "Which of the following acts as a proxy between an application and a database to support interaction and simplify the work of programmers?",
    "choice_a": "SDLC",
    "choice_b": "ODBC",
    "choice_c": "PCI DSS",
    "choice_d": "Abstraction",
    "correct_answer": "B",
    "explanation": "Open Database Connectivity (ODBC) acts as a proxy between applications and the back-end DBMS. The software development lifecycle (SDLC) is a model for the software development process that incorporates all necessary activities.  The Payment Card Industry Data Security Standard (PCI DSS) is a regulatory framework for credit card processing.  Abstraction is a software development concept that generalizes common behaviors of software objects into more abstract classes.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      815,
      621,
      668,
      630,
      640
    ],
    "source": ""
  },
  {
    "id": 3701,
    "question": "In what type of software testing does the tester have access to the underlying source code?",
    "choice_a": "Static testing",
    "choice_b": "Dynamic testing",
    "choice_c": "Cross-site scripting testing",
    "choice_d": "Black-box testing",
    "correct_answer": "A",
    "explanation": "In order to conduct a static test, the tester must have access to the underlying source code. Black-box testing does not require access to source code. Dynamic testing is an example of black-box testing. Cross-site scripting is a specific type of vulnerability, and it may be discovered using both static and dynamic techniques, with or without access to the source code.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      626,
      963,
      671,
      628,
      621
    ],
    "source": ""
  },
  {
    "id": 3702,
    "question": "What type of chart provides a graphical illustration of a schedule that helps to plan, coordinate, and track project tasks?",
    "choice_a": "Gantt",
    "choice_b": "Venn",
    "choice_c": "Bar",
    "choice_d": "PERT",
    "correct_answer": "A",
    "explanation": "A Gantt chart is a type of bar chart that shows the interrelationships over time between projects and schedules. It provides a graphical illustration of a schedule that helps to plan, coordinate, and track specific tasks in a project. A PERT chart focuses on the interrelationships between tasks rather than the specific details of the schedule. Bar charts are used to present data, and Venn diagrams are used to show the relationships between sets.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      821,
      824,
      820,
      822,
      624
    ],
    "source": ""
  },
  {
    "id": 3703,
    "question": "Which database security risk occurs when data from a higher classification level is mixed with data from a lower classification level?",
    "choice_a": "Aggregation",
    "choice_b": "Inference",
    "choice_c": "Contamination",
    "choice_d": "Polyinstantiation",
    "correct_answer": "C",
    "explanation": "Contamination is the mixing of data from a higher classification level and/or need-to-know requirement with data from a lower classification level and/or need-to-know requirement. Aggregation attacks involve the use of specialized database functions to combine information from a large number of database records to reveal information that may be more sensitive than the information in individual records would reveal. Inference attacks use deductive reasoning to reach conclusions from existing data. Polyinstantiation includes additional records in a database for presentation to users with differing security levels as a defense against inference attacks.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      633,
      634,
      641,
      636,
      635
    ],
    "source": ""
  },
  {
    "id": 3704,
    "question": "Tonya is performing a risk assessment of a third-party software package for use within her organization. She plans to purchase a product from a vendor that is very popular in her industry. <br>What term best describes this software?",
    "choice_a": "Open source",
    "choice_b": "Custom-developed",
    "choice_c": "ERP",
    "choice_d": "COTS",
    "correct_answer": "D",
    "explanation": "Tonya is purchasing the software, so it is not open source. It is used widely in her industry, so it is not custom developed for her organization. There is no indication in the question that the software is an enterprise resource planning (ERP) system. The best answer here is commercial-off-the-shelf software (COTS).",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      961,
      962,
      963,
      622,
      621
    ],
    "source": ""
  },
  {
    "id": 3705,
    "question": "Which one of the following is not part of the change management process?",
    "choice_a": "Request control",
    "choice_b": "Release control",
    "choice_c": "Configuration audit",
    "choice_d": "Change control",
    "correct_answer": "C",
    "explanation": "Configuration audit is part of the configuration management process rather than the change control process. Request control, release control, and change control are all components of the change management process.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      624,
      640,
      628,
      621,
      818
    ],
    "source": ""
  },
  {
    "id": 3706,
    "question": "What transaction management principle ensures that two transactions do not interfere with each other as they operate on the same data?",
    "choice_a": "Atomicity",
    "choice_b": "Consistency",
    "choice_c": "Isolation",
    "choice_d": "Durability",
    "correct_answer": "C",
    "explanation": "The isolation principle states that two transactions operating on the same data must be temporarily separated from each other so that one does not interfere with the other. The atomicity principle says that if any part of the transaction fails, the entire transaction must be rolled back. The consistency principle says that the database must always be in a state that complies with the database model's rules. The durability principle says that transactions committed to the database must be preserved.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      632,
      811,
      813,
      840,
      630
    ],
    "source": ""
  },
  {
    "id": 3707,
    "question": "Tom built a database table consisting of the names, telephone numbers, and customer IDs for his business. The table contains information on 30 customers. <br>What is the degree of this table?",
    "choice_a": "Two",
    "choice_b": "Three",
    "choice_c": "Thirty",
    "choice_d": "Undefined",
    "correct_answer": "B",
    "explanation": "The cardinality of a table refers to the number of rows in the table, whereas the degree of a table is the number of columns. In this case, the table has three columns (name, telephone number, and customer ID), so it has a degree of three.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      964,
      966,
      630,
      965,
      634
    ],
    "source": ""
  },
  {
    "id": 3708,
    "question": "Dylan is reviewing the security controls currently used by his organization and realizes that he lacks a tool that might identify abnormal actions taken by an end user. <br>What type of tool would best meet this need?",
    "choice_a": "EDR",
    "choice_b": "Integrity monitoring",
    "choice_c": "Signature detection",
    "choice_d": "UEBA",
    "correct_answer": "D",
    "explanation": "User and entity behavior analytics (UEBA) tools develop profiles of individual behavior and then monitor users for deviations from those profiles that may indicate malicious activity and/or compromised accounts. This type of tool would meet Dylan's requirements. Endpoint detection and response (EDR) tools watch for unusual endpoint behavior but do not analyze user activity. Integrity monitoring is used to identify unauthorized system/file changes. Signature detection is a malware detection technique.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      1042,
      1043,
      566,
      557,
      547
    ],
    "source": ""
  },
  {
    "id": 3709,
    "question": "Tim is working to improve his organization's antimalware defenses and would also like to reduce the operational burden on his security team. <br>Which one of the following solutions would best meet his needs?",
    "choice_a": "UEBA",
    "choice_b": "MDR",
    "choice_c": "EDR",
    "choice_d": "NGEP",
    "correct_answer": "B",
    "explanation": "All of these technologies are able to play important roles in defending against malware and other endpoint threats. User and entity behavior analysis (UEBA) looks for behavioral anomalies. Endpoint detection and response (EDR) and next-generation endpoint protection (NGEP) identify and respond to malware infections. However, only managed detection and response (MDR) combines anti-malware capabilities with a managed service that reduces the burden on the IT team.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      522,
      519,
      550,
      561,
      1042
    ],
    "source": ""
  },
  {
    "id": 3710,
    "question": "Carl works for a government agency that has suffered a ransomware attack and has lost access to critical data but does have access to backups. <br>Which one of the following actions would best restore this access while minimizing the risk facing the organization?",
    "choice_a": "Pay the ransom",
    "choice_b": "Rebuild systems from scratch",
    "choice_c": "Restore backups",
    "choice_d": "Install antivirus software",
    "correct_answer": "C",
    "explanation": "If Carl has backups available, that would be his best option to recover operations. He could also pay the ransom, but this would expose his organization to legal risks and incur unnecessary costs. Rebuilding the systems from scratch would not restore his data. Installing antivirus software would be helpful in preventing future compromises, but these packages would not likely be able to decrypt the missing data.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      226,
      215,
      291,
      219,
      244
    ],
    "source": ""
  },
  {
    "id": 3711,
    "question": "What attack technique is often leveraged by advanced persistent threat groups but not commonly available to other attackers, such as script kiddies and hacktivists?",
    "choice_a": "Zero-day exploit",
    "choice_b": "Social engineering",
    "choice_c": "Trojan horse",
    "choice_d": "SQL injection",
    "correct_answer": "A",
    "explanation": "Although an advanced persistent threat (APT) may leverage any of these attacks, they are most closely associated with zero-day attacks due to the cost and complexity of the research required to discover or purchase them. Social engineering, Trojans (and other malware), and SQL injection attacks are often attempted by many different types of attackers.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      642,
      649,
      674,
      644,
      656
    ],
    "source": ""
  },
  {
    "id": 3712,
    "question": "John found a vulnerability in his code where an attacker can enter too much input and then force the system running the code to execute targeted commands. <br>What type of vulnerability has John discovered?",
    "choice_a": "TOCTTOU",
    "choice_b": "Buffer overflow",
    "choice_c": "XSS",
    "choice_d": "XSRF",
    "correct_answer": "B",
    "explanation": "Buffer overflow vulnerabilities exist when a developer does not properly validate user input to ensure that it is of an appropriate size. Input that is too large can \"overflow\" a data structure to affect other data stored in the computer's memory. Time-of-check to time-of-use (TOCTTOU) attacks exploit timing differences that lead to race conditions. Cross-site scripting (XSS) attacks force the execution of malicious scripts in the user's browser. Cross-site request forgery (XSRF) attacks exploit authentication trust between browser tabs.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      654,
      668,
      620,
      660,
      661
    ],
    "source": ""
  },
  {
    "id": 3713,
    "question": "Mary identified a vulnerability in her code where it fails to check during a session to determine whether a user's permission has been revoked. <br>What type of vulnerability is this?",
    "choice_a": "Backdoor",
    "choice_b": "TOC/TOU",
    "choice_c": "Buffer overflow",
    "choice_d": "SQL injection",
    "correct_answer": "B",
    "explanation": "TOC/TOU is a type of timing vulnerability that occurs when a program checks access permissions too far in advance of a resource request. Backdoors are code that allows those with knowledge of the backdoor to bypass authentication mechanisms. Buffer overflow vulnerabilities exist when a developer does not properly validate user input to ensure that it is of an appropriate size. Input that is too large can \"overflow\" a data structure to affect other data stored in the computer's memory. SQL injection attacks include SQL code in user input in the hopes that it will be passed to and executed by the backend database.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      655,
      667,
      668,
      620,
      657
    ],
    "source": ""
  },
  {
    "id": 3714,
    "question": "What programming language construct is commonly used to perform error handling?",
    "choice_a": "<code>If\u2026then</code>",
    "choice_b": "<code>Case\u2026when</code>",
    "choice_c": "<code>Do\u2026while</code>",
    "choice_d": "<code>Try\u2026catch</code>",
    "correct_answer": "D",
    "explanation": "The <code>try\u2026catch</code> clause is used to attempt to evaluate code contained in the <code>try</code> clause and then handle errors with the code located in the <code>catch</code> clause. The other constructs listed here (<code>if\u2026then, case\u2026when, </code> and <code>do\u2026while</code>) are all used for control flow.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      672,
      620,
      617,
      654,
      618
    ],
    "source": ""
  },
  {
    "id": 3715,
    "question": "Fred is reviewing the logs from his web server for malicious activity and finds this request: <code>http://www.mycompany.com/../../../etc/passwd. </code> What type of attack was most likely attempted?",
    "choice_a": "SQL injection",
    "choice_b": "Session hijacking",
    "choice_c": "Directory traversal",
    "choice_d": "File upload",
    "correct_answer": "C",
    "explanation": "In this case, the <code>.. </code> operators are the telltale giveaway that the attacker was attempting to conduct a directory traversal attack. This particular attack sought to break out of the web server's root directory and access the <code>/etc/passwd</code> file on the server. SQL injection attacks would contain SQL code. File upload attacks seek to upload a file to the server. Session hijacking attacks require the theft of authentication tokens or other credentials.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      664,
      825,
      668,
      665,
      661
    ],
    "source": ""
  },
  {
    "id": 3716,
    "question": "A developer added a subroutine to a web application that checks to see whether the date is April 1 and, if it is, randomly changes user account balances. <br>What type of malicious code is this?",
    "choice_a": "Logic bomb",
    "choice_b": "Worm",
    "choice_c": "Trojan horse",
    "choice_d": "Virus",
    "correct_answer": "A",
    "explanation": "Logic bombs wait until certain conditions are met before delivering their malicious payloads. Worms are malicious code objects that move between systems under their own power, whereas viruses require some type of human intervention. Trojan horses masquerade as useful software but then carry out malicious functions after installation.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      568,
      550,
      611,
      543,
      538
    ],
    "source": ""
  },
  {
    "id": 3717,
    "question": "Francis is reviewing the source code for a database-driven web application that his company is planning to deploy. He is paying particular attention to the use of input validation within that application.  Of the characters listed here, which is most commonly used in SQL injection attacks?",
    "choice_a": "<code>!</code>",
    "choice_b": "<code>&</code>",
    "choice_c": "<code>*</code>",
    "choice_d": "<code>'</code>",
    "correct_answer": "D",
    "explanation": "The single quote character (<code>'</code>) is used in SQL queries and must be handled carefully on web forms to protect against SQL injection attacks.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      658,
      668,
      669,
      661,
      672
    ],
    "source": ""
  },
  {
    "id": 3718,
    "question": "Katie is concerned about the potential for SQL injection attacks against her organization. She has already put a web application firewall in place and conducted a review of the organization's web application source code. She would like to add an additional control at the database level. <br>What database technology could further limit the potential for SQL injection attacks?",
    "choice_a": "Triggers",
    "choice_b": "Parameterized queries",
    "choice_c": "Column encryption",
    "choice_d": "Concurrency control",
    "correct_answer": "B",
    "explanation": "Developers of web applications should leverage parameterized queries to limit the application's ability to execute arbitrary code. With stored procedures, the SQL statement resides on the database server and may only be modified by database developers or administrators. With parameterized queries, the SQL statement is defined within the application and variables are bound to that statement in a safe manner.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      669,
      658,
      659,
      668,
      672
    ],
    "source": ""
  },
  {
    "id": 3719,
    "question": "What type of malicious software is specifically used to leverage stolen computing power for the attacker's financial gain?",
    "choice_a": "RAT",
    "choice_b": "PUP",
    "choice_c": "Cryptomalware",
    "choice_d": "Worm",
    "correct_answer": "C",
    "explanation": "Although any malware may be leveraged for financial gain, depending on its payload, cryptomalware is specifically designed for this purpose. It steals computing power and uses it to mine cryptocurrency. Remote access Trojans (RATs) are designed to grant attackers remote administrative access to systems. Potentially unwanted programs (PUPs) are any type of software that is initially approved by the user but then performs undesirable actions. Worms are malicious code objects that move between systems under their own power.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      550,
      568,
      610,
      532,
      608
    ],
    "source": ""
  },
  {
    "id": 3720,
    "question": "David is responsible for reviewing a series of web applications for vulnerabilities to cross-site scripting attacks. <br>What characteristic should he watch out for that would indicate a high susceptibility to this type of attack?",
    "choice_a": "Reflected input",
    "choice_b": "Database-driven content",
    "choice_c": ".NET technology",
    "choice_d": "CGI scripts",
    "correct_answer": "A",
    "explanation": "Cross-site scripting attacks are often successful against web applications that include reflected input. This is one of the two main categories of XSS attack. In a reflected attack, the attacker can embed the attack within the URL so that it is reflected to users who follow a link.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      1010,
      662,
      666,
      669,
      674
    ],
    "source": ""
  },
  {
    "id": 3728,
    "question": "If a security mechanism offers availability, then it offers a high level of assurance that authorized subjects can _____________________ the data, objects, and resources.",
    "choice_a": "Control",
    "choice_b": "Audit",
    "choice_c": "Access",
    "choice_d": "Repudiate",
    "correct_answer": "C",
    "explanation": "Accessibility of data, objects, and resources is the goal of availability. If a security mechanism offers availability, then it is highly likely that the data, objects, and resources are accessible to authorized subjects. Control is managed by authorization or access control. Auditing is the recording of events into a log file, which is part of AAA services. To repudiate is to deny having done something, nonrepudiation is the prevention of that denial by proving that a subject performed an action.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      5,
      7,
      31,
      6,
      4
    ],
    "source": ""
  },
  {
    "id": 3729,
    "question": "Which of the following statements is false?",
    "choice_a": "Security governance is the collection of practices related to supporting, defining, and directing the security efforts of an organization.",
    "choice_b": "Security governance is the implementation of a security solution and a management method that are tightly interconnected.",
    "choice_c": "Security governance is an IT issue only.",
    "choice_d": "Security governance directly oversees and gets involved in all levels of security.",
    "correct_answer": "C",
    "explanation": "Security governance is not and should not be treated as an IT issue only. Security governance is a business operations issue. The other statements are true.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      11,
      32,
      1,
      14,
      15
    ],
    "source": ""
  },
  {
    "id": 3731,
    "question": "The DREAD risk rating system is designed to provide a flexible rating solution that is based on the answers to five main questions about each threat. <br>Which of the following are subjects of those questions?  (Select all that apply.)",
    "choice_a": "Exploitability",
    "choice_b": "Elevation of privilege",
    "choice_c": "Damage potential",
    "choice_d": "Repudiation",
    "correct_answer": [
      "A",
      "C",
      "E",
      "F",
      "H"
    ],
    "explanation": "The DREAD questions are about Damage potential, Reproducibility, Exploitability, Affected users, and Discoverability. The other options are related to STRIDE: Elevation of privilege, Repudiation, and Denial of service.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      26,
      24,
      41,
      46,
      50
    ],
    "source": "",
    "choice_e": "Affected users",
    "choice_f": "Discoverability",
    "choice_g": "Denial of service",
    "choice_h": "Reproducibility"
  },
  {
    "id": 3732,
    "question": "Third-party governance is the system of external entity oversight that may be mandated by law, regulation, industry standards, contractual obligation, or licensing requirements. Often third-party assessment is necessary to evaluate the security of a supply chain. <br>Which of the following means of third-party assessment is used to interview personnel and observe their operating habits?",
    "choice_a": "On-site assessment",
    "choice_b": "Document exchange and review",
    "choice_c": "Process/policy review",
    "choice_d": "Third-party audit",
    "correct_answer": "A",
    "explanation": "An on-site assessment is a third-party assessment tool where auditors visit the site of the organization to interview personnel and observe their operating habits. Document exchange and review is a mechanism to investigate the means by which datasets and documentation are exchanged as well as the formal processes by which they perform assessments and reviews. Process/policy review is a mechanism that requests copies of their security policies, processes/procedures, and documentation of incidents and responses for review. A third-party audit is performed by a third-party, such as defined by AICPA, to provide an unbiased review of an entity's security infrastructure.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      12,
      2,
      54,
      21,
      11
    ],
    "source": ""
  },
  {
    "id": 3733,
    "question": "No one control can protect against all possible threats. Using a multilayered solution allows for numerous, different controls to guard against whatever threats come to pass. <br>Which of the following is the most important and distinctive concept in relation to layered security?",
    "choice_a": "Multiple",
    "choice_b": "Series",
    "choice_c": "Parallel",
    "choice_d": "Filter",
    "correct_answer": "B",
    "explanation": "Layering is the deployment of multiple security mechanisms in a series. When security restrictions are performed in a series, they are performed one after the other in a linear fashion. Therefore, a single failure of a security control does not render the entire solution ineffective. Multiple security controls are only important so you can use them in a series, rather than have only one protection. Parallel is no better than a single protection. Filtering is a common feature of many security measures, such as firewalls, but it is not an essential element of layered security.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      302,
      305,
      228,
      213,
      1027
    ],
    "source": ""
  },
  {
    "id": 3734,
    "question": "You are updating the employee termination procedures in order to reduce risk and avoid liability. A few recent termination events did not go well, which resulted in several very uncomfortable confrontations between the to-be-fired employee and the company leadership. <br>When an employee is to be terminated, which of the following should be done?",
    "choice_a": "Inform the employee a few hours before they are officially terminated.",
    "choice_b": "Disable the employee's network access just as they are informed of the termination.",
    "choice_c": "Send out a broadcast email informing everyone that a specific employee is to be terminated.",
    "choice_d": "Wait until the manager and the employee are the only people remaining in the building before announcing the termination.",
    "correct_answer": "B",
    "explanation": "You should remove or disable the employee's network user account immediately before or at the same time they are informed of their termination, such as when the door closes on their exit interview. When an employee is to be terminated, it is not in the company's security best interest to inform them hours prior to the official termination process, notify everyone in a memo that someone is going to be terminated, or to wait until the employee-to-be-fired is the last person in the building. These all put the company (and the manager) at greater risk than necessary.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      37,
      68,
      69,
      20,
      41
    ],
    "source": ""
  },
  {
    "id": 3736,
    "question": "Which of the following is <italic>not</italic> an element of the risk analysis process?",
    "choice_a": "Analyzing an environment for risks",
    "choice_b": "Creating a cost/benefit report for safeguards to present to upper management",
    "choice_c": "Selecting appropriate safeguards and implementing them",
    "choice_d": "Evaluating each threat event as to its likelihood of occurring and cost of the resulting damage",
    "correct_answer": "C",
    "explanation": "Risk analysis includes analyzing an environment for risks, evaluating each threat event as to its likelihood of occurring and the cost of the damage it would cause, assessing the cost of various countermeasures for each risk, and creating a cost/benefit report for safeguards to present to upper management. Selecting safeguards is a task of upper management based on the results of risk analysis known as risk response. It is a task that falls under risk management, but it is not part of the risk analysis/assessment process.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      41,
      70,
      44,
      45,
      48
    ],
    "source": ""
  },
  {
    "id": 3737,
    "question": "There is a risk that an avalanche may damage your $3 million manufacturing facility. Experts claim that there is a 5 percent chance that an avalanche will occur each year. They further advise you that an avalanche would completely destroy your building. Your business insurance will cover the loss, but such coverage would require you to rebuild on the same land. The building and its contents account for 90 percent of the value of the facility; the remainder is attributed to the land itself. <br>What is the single loss expectancy of your shipping facility to avalanches?",
    "choice_a": "$3 million",
    "choice_b": "$2,700,000",
    "choice_c": "$270,000",
    "choice_d": "$135,000",
    "correct_answer": "B",
    "explanation": "The single loss expectancy (SLE) is calculated by multiplying the AV ($3 million) by the EF (90%). Thus SLE = $2,700,000. The EF is only the portion of the value lost due to the risk of avalanche, which is indicated as 90%. The 10% of the remaining value is assigned to the land, which is required as the location for rebuilding (i.e., its value is not lost in this scenario). (A) $3 million is the overall value of the facility, contents, and land combined. (D) $135,000 is the annualized loss expectancy (ALE), which is calculated by multiplying the SLE by the annualized rate of occurrence (ARO) of 5% per year. (C) The $270,000 is not a valid result of any standard quantitative risk analyses calculation based on the parameters of this scenario.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      45,
      86,
      935,
      694,
      43
    ],
    "source": ""
  },
  {
    "id": 3738,
    "question": "Which of the following best describes an access control category that includes hiring and firing policies, data classifications and labels, and security awareness and training?",
    "choice_a": "Administrative controls",
    "choice_b": "Technical controls",
    "choice_c": "Logical controls",
    "choice_d": "Physical controls",
    "correct_answer": "A",
    "explanation": "Administrative controls are also referred to as management controls and include policies and procedures such as hiring and firing policies, data classifications and labels, and security awareness training. Technical and logical controls are synonymous and include hardware or software mechanisms used to manage access. Physical access controls are physical controls deployed to prevent direct contact with systems or areas within a facility.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      47,
      73,
      65,
      37,
      40
    ],
    "source": ""
  },
  {
    "id": 3739,
    "question": "Which of the following is true?",
    "choice_a": "A security control should only support external monitoring.",
    "choice_b": "If a security control's benefits cannot be quantified, evaluated, or compared, then it does not actually provide any security.",
    "choice_c": "Measuring the effectiveness of a countermeasure is always an absolute value.",
    "choice_d": "Most countermeasures offer specific hard numbers as to the number of breaches prevented or attack attempts thwarted.",
    "correct_answer": "B",
    "explanation": "There is only one true statement from these options: (B) If a security control's benefits cannot be quantified, evaluated, or compared, then it does not actually provide any security. The other options are incorrect. Corrected versions of those statements are: (A) A security control may provide native or internal monitoring, or external monitoring might be required; (C) Measuring the effectiveness of a countermeasure is <italic>not</italic> always an absolute value;(D) Many countermeasures offer degrees of improvement rather than specific hard numbers as to the number of breaches prevented or attack attempts thwarted.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      54,
      48,
      67,
      2,
      47
    ],
    "source": ""
  },
  {
    "id": 3741,
    "question": "The CISO has put you in charge of improving the security awareness and training program. The concern they want you to focus on is that it is unknown whether the training efforts are having any affect or benefit. If you cannot establish proof of a positive ROSI, then the program will be terminated. <br>Which of the following would be useful in establishing an effectiveness evaluation procedure? (Select all that apply.)",
    "choice_a": "Taking attendance",
    "choice_b": "Administering a quiz immediately after the awareness event",
    "choice_c": "Requiring workers to pay $10 for each security incident they are involved in",
    "choice_d": "Have workers take a test 6 months after a training class",
    "correct_answer": [
      "B",
      "D",
      "E"
    ],
    "explanation": "Training and awareness program effectiveness evaluation should take place on an ongoing or continuous basis. This can often include administering a quiz or exam immediately after an awareness or training event and a follow-up quiz/exam months later. Also, event and incident logs should be reviewed for the rate of occurrences of security violations due to employee actions and behaviors to see if there is any noticeable difference in the rate of occurrence or trends of incidents before and after a training presentation. The other options are not useful for training program effectiveness evaluation. (A) Never assume that just because a worker was marked as attending or completing a training event that they actually learned anything or will be changing their behavior. (C) Forcing employees to pay a fine for each security infraction is not a means to assess effectiveness; it is a crude means to force compliance. (F) Posting a list of employees who cause a security incident is not a means to assess effectiveness; it is a mechanism of using shame to force compliance and it is not an ethical practice.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      67,
      66,
      40,
      1,
      54
    ],
    "source": "",
    "choice_e": "Collect key security indicators that relate to insider security incidents over time",
    "choice_f": "Posting a list of employees who cause a security incident on the primary bulletin board in the break room"
  },
  {
    "id": 3742,
    "question": "The Roscommon Rangers baseball team is concerned about the risk that a storm might result in the cancellation of a baseball game. There is a 30 percent chance that the storm will occur, and if it does, the team must refund all single-game tickets because the game cannot be rescheduled. Season ticket holders will not receive a refund and account for 20 percent of ticket sales. The ticket sales for the game are $1,500,000. <br>What is the single loss expectancy in this scenario?",
    "choice_a": "$300,000",
    "choice_b": "$1,050,000",
    "choice_c": "$1,200,000",
    "choice_d": "$1,500,000",
    "correct_answer": "C",
    "explanation": "The single loss expectancy is calculated as the product of the exposure factor (80 percent) and the asset value ($1,500,000). In this example, the single loss expectancy is $1,200,000.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      45,
      86,
      695,
      43,
      935
    ],
    "source": ""
  },
  {
    "id": 3743,
    "question": "Patricia recently discovered that passwords to systems and user accounts belonging to her organization were for sale on the dark web. She believes that she knows the individual who stole and is selling those passwords and wishes to contact law enforcement. <br>What law has most likely been violated?",
    "choice_a": "Electronic Communications Privacy Act",
    "choice_b": "Computer Fraud and Abuse Act",
    "choice_c": "Federal Sentencing Guidelines",
    "choice_d": "National Infrastructure Protection Act",
    "correct_answer": "B",
    "explanation": "The Computer Fraud and Abuse Act (CFAA) explicitly covers trafficking in passwords. This is the activity that Patricia discovered and she could refer the matter for possible federal prosecution. The Electronic Communications Privacy Act (ECPA) protects against eavesdropping on electronic communications. The Federal Sentencing Guidelines are not law and do not contain privacy protection provisions. The National Infrastructure Protection Act would only apply if the system were part of a critical infrastructure system. That is not indicated in the scenario.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      101,
      117,
      105,
      97,
      100
    ],
    "source": ""
  },
  {
    "id": 3744,
    "question": "What U.S. federal law prohibits attempts to circumvent copyright protection mechanisms placed on a protected work by the copyright holder?",
    "choice_a": "Digital Millennium Copyright Act",
    "choice_b": "Trade Secrets Act",
    "choice_c": "Copyright Enhancement Act",
    "choice_d": "USA PATRIOT Act",
    "correct_answer": "A",
    "explanation": "The Digital Millennium Copyright Act contains provisions prohibiting the circumvention of copyright protection mechanisms. The Trade Secrets Act applies to trade secrets, not copyrights. The USA PATRIOT Act enhances government surveillance capabilities. The Copyright Enhancement Act does not exist as a U.S. federal law.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      103,
      117,
      987,
      104,
      100
    ],
    "source": ""
  },
  {
    "id": 3745,
    "question": "Barry is the privacy officer for a college that accepts federal funds. He is reviewing the security of student educational records and want to ensure that his college is compliant with all relevant laws and regulations. <br>What law protects the privacy rights of students?",
    "choice_a": "HIPAA",
    "choice_b": "SOX",
    "choice_c": "GLBA",
    "choice_d": "FERPA",
    "correct_answer": "D",
    "explanation": "The Family Educational Rights and Privacy Act (FERPA) protects the rights of students and the parents of minor students. The Gramm\u2013Leach\u2013Bliley Act (GLBA) covers the customer records of financial institutions, whereas the Health Insurance Portability and Accountability Act (HIPAA) regulates healthcare providers. The Sarbanes\u2013Oxley (SOX) Act governs the financial records of publicly traded companies.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      107,
      106,
      118,
      105,
      102
    ],
    "source": ""
  },
  {
    "id": 3746,
    "question": "An organization plans to donate several older computers to a local school. Chad will sanitize the hard drives in these computers. <br>Which of the following methods is Chad most likely to use?",
    "choice_a": "Erasing",
    "choice_b": "Clearing",
    "choice_c": "Purging",
    "choice_d": "Overwriting",
    "correct_answer": "C",
    "explanation": "Purging media removes all data by writing over existing data multiple times to ensure that the data is not recoverable using any known methods. Purged media can then be reused in less secure environments. Erasing the media performs a delete, but the data remains and can easily be restored. Clearing, or overwriting, writes unclassified data over existing data, but some sophisticated forensics techniques may be able to recover the original data, so this method should not be used to reduce the classification of media.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      129,
      130,
      144,
      125,
      1026
    ],
    "source": ""
  },
  {
    "id": 3747,
    "question": "Which of the following choices would be the most important consideration when identifying the classification of assets?",
    "choice_a": "Value of the asset",
    "choice_b": "Value of the data it holds or processes",
    "choice_c": "Security controls used to protect the asset",
    "choice_d": "The user of the assets",
    "correct_answer": "B",
    "explanation": "Assets are classified based on the data that they hold or process. Data is classified based on its value to the organization. Assets are protected using various security controls, and these controls are selected based on the classification of the data. The user of the assets is responsible for following policies related to classifications.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      123,
      143,
      124,
      138,
      128
    ],
    "source": ""
  },
  {
    "id": 3748,
    "question": "You are creating a data policy identifying data that should be destroyed at the end of its lifecycle. You want to stress one of the problems that can result from incomplete sanitization. <br>Which of the following statements correctly identifies a problem statement you should add?",
    "choice_a": "Methods are not available to remove data, ensuring that unauthorized personnel cannot retrieve data.",
    "choice_b": "Even fully incinerated media can offer extractable data.",
    "choice_c": "Personnel can perform sanitization steps improperly.",
    "choice_d": "Stored data is physically etched into the media.",
    "correct_answer": "C",
    "explanation": "Sanitization can be unreliable because personnel can perform the purging, degaussing, or other processes improperly. When done properly, purged data is not recoverable using any known methods. Data cannot be retrieved from incinerated or burned media. Data is not physically etched into the media.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      129,
      130,
      144,
      133,
      125
    ],
    "source": ""
  },
  {
    "id": 3749,
    "question": "A small business is planning to outsource payroll. This requires the business to pass some data to the payroll company to handle payroll functions. In this scenario, which of the following roles best describes the payroll company?",
    "choice_a": "Data controller",
    "choice_b": "Data subject",
    "choice_c": "Data processor",
    "choice_d": "Data custodian",
    "correct_answer": "C",
    "explanation": "The payroll company is fulfilling the role of data processor by processing the payroll data. The data controller identifies what data to pass to the data processor and how that data should be processed. A data subject is like a data user and simply accesses data. A data custodian is responsible for the day-to-day maintenance of data.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      139,
      988,
      990,
      138,
      989
    ],
    "source": ""
  },
  {
    "id": 3750,
    "question": "A grocery store chain collects customer data used in a customer loyalty program. When registering, customers fill out a lengthy form about themselves. The chain uses this data to email customers and allows customers to claim discounts when checking out using their customer loyalty cards. <br>Which of the following identifies a best practice to reduce risks when implementing this program?",
    "choice_a": "Data retention",
    "choice_b": "Data labeling",
    "choice_c": "Collection limitation",
    "choice_d": "Destruction",
    "correct_answer": "C",
    "explanation": "A best practice when collecting customer data is to limit the amount of data collected to only what is needed. The company's lengthy form might include physical addresses, phone numbers, cellphone numbers, birthdates, social security numbers, and more. A data breach can reveal all this personal data even though the company never planned to use it. If they don't collect the data, they eliminate the risk of losing it in a data breach. Legal requirements typically drive data retention rules, but this scenario is unrelated to a legal issue. Assets and media are labeled with the classification of data they process or hold, but this scenario doesn't refer to assets. Destruction is at the end of the data lifecycle, not the beginning.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      132,
      133,
      125,
      143,
      138
    ],
    "source": ""
  },
  {
    "id": 3751,
    "question": "You need to identify a method to embed unobtrusive labels in digital data. After they are embedded, other methods should be able to detect these labels. <br>Which of the following is the best choice to meet these requirements?",
    "choice_a": "Watermarking",
    "choice_b": "Remanence",
    "choice_c": "Signature",
    "choice_d": "Encryption",
    "correct_answer": "A",
    "explanation": "Digital watermarking places labels or marking in files (digital data). Other methods, such as data loss prevention (DLP) and digital rights management (DRM), can detect the labels. Remanence refers to data left on media after it should have been removed. A digital signature is used in emails to validate the sender's identity. Encryption scrambles data so that it is unreadable, but it doesn't add labels.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      128,
      134,
      127,
      144,
      124
    ],
    "source": ""
  },
  {
    "id": 3752,
    "question": "An organization is decommissioning several older computers and replacing them with new ones. The CIO wants to ensure that data remanence is not a problem with the disk drives within these computers. <br>Which of the following methods will <italic>most</italic> likely result in data remanence?",
    "choice_a": "Clearing",
    "choice_b": "Purging",
    "choice_c": "Cryptoshredding",
    "choice_d": "Erasing",
    "correct_answer": "D",
    "explanation": "Erasing data on a hard disk drive is likely to leave some data on a hard disk drive, also known as data remanence. Clearing (sometimes called overwriting) overwrites the disk drive with different bits in three separate passes. Purging is a more intense method of clearing the disk and repeats the clearing process multiple times. Cryptoshredding deletes encryption keys, but the question doesn't indicate data is encrypted.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      130,
      1026,
      129,
      1024,
      144
    ],
    "source": ""
  },
  {
    "id": 3753,
    "question": "Which of the following best describes the difference between end-of-service (EOS) and end-of-life (EOL)?",
    "choice_a": "EOL identifies when a vendor will no longer support a product, and EOS identifies when a vendor will no longer offer a product for sale.",
    "choice_b": "EOL identifies when an organization destroyed a product, and EOS identifies when a vendor stopped selling a product.",
    "choice_c": "EOS identifies when a product is removed from service, and EOL identifies when a product is destroyed.",
    "choice_d": "EOS identifies when a vendor will no longer support a product, and EOL identifies when a vendor will no longer offer a product for sale.",
    "correct_answer": "D",
    "explanation": "EOS identifies when a vendor will no longer support a product, and EOL identifies when a vendor will no longer offer a product for sale. EOL is not related to the destruction of a product. EOS does not refer to when a vendor stopped selling a product.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      847,
      849,
      877,
      133,
      879
    ],
    "source": ""
  },
  {
    "id": 3754,
    "question": "Which of the following actions is the best method to protect data in transit?",
    "choice_a": "Disk-level encryption",
    "choice_b": "Column-level encryption",
    "choice_c": "Purging memory buffers",
    "choice_d": "Network-level encryption",
    "correct_answer": "D",
    "explanation": "Network-level encryption protects data in transit. Disk-level encryption and column-level encryption protects data at rest. Purging memory buffers after data has been used protects data in use.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      122,
      144,
      700,
      125,
      702
    ],
    "source": ""
  },
  {
    "id": 3755,
    "question": "Your company is planning to launch an e-commerce website. Management wants to ensure this website has adequate security controls in place before the site goes live. Administrators started with a baseline of security controls. <br>What else should be a primary consideration related to security controls?",
    "choice_a": "Identifying the data controller",
    "choice_b": "Identifying the data processor",
    "choice_c": "Selecting a standard",
    "choice_d": "Preventing data loss",
    "correct_answer": "C",
    "explanation": "Standards selection refers to adding security controls based on external standards. The Payment Card Industry Data Security Standard (PCI DSS) is an example of an external standard, and it mandates the use of several specific controls. The identification of the data controller and data processor isn't related to the selection of security controls. Data loss prevention methods attempt to prevent data from leaving a network but are less of a concern on a public-facing e-commerce server.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      142,
      140,
      141,
      126,
      143
    ],
    "source": ""
  },
  {
    "id": 3756,
    "question": "Your organization has a database that includes residents of the EU. Management wants to transfer this to a third party for research and aggregation, but they want to modify the data so it can be transferred without GDPR compliance problems. <br>Which of the following techniques will meet these requirements?",
    "choice_a": "Pseudonymization",
    "choice_b": "Anonymization",
    "choice_c": "Tokenization",
    "choice_d": "None of the above",
    "correct_answer": "B",
    "explanation": "Anonymization techniques remove all data so that it is difficult to identify the original identities. When done correctly, the GDPR no longer applies. Pseudonymization is the process of replacing some data with an identifier, such as apseudonym. An external dataset holds the original data along with the pseudonym. However, if applying pseudonymization techniques, the GDPR still applies. Tokenization replaces some data with tokens or aliases. A third party typically keeps the original data along with the token.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      137,
      136,
      139,
      142,
      143
    ],
    "source": ""
  },
  {
    "id": 3757,
    "question": "You recently wrote and published a book on how to pass the CISSP exam. You want to protect your rights under copyright law. <br>Which of the following would you use?",
    "choice_a": "DLP",
    "choice_b": "DRM",
    "choice_c": "CASB",
    "choice_d": "EOS",
    "correct_answer": "B",
    "explanation": "Digital rights management (DRM) methods attempt to provide copyright protection for copyrighted works. Data loss prevention (DLP) systems detect and prevent data from leaving a network. A cloud access security broker (CASB) is software placed logically between users and cloud-based resources to enforce security policies used in an internal network.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      134,
      144,
      128,
      124,
      127
    ],
    "source": ""
  },
  {
    "id": 3758,
    "question": "Which of the following actions, when made to a file, would result in a change in the hash value created by running the SHA-2 algorithm against the contents of that file?  (Select all that apply.)",
    "choice_a": "Changing a single character in the file",
    "choice_b": "Removing a line from the file",
    "choice_c": "Adding a blank line to end of the file",
    "choice_d": "Backing up the file",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Any change to the contents of a file changes the hash value generated for that file. This would include changing a single character, removing a line, or adding a line (even if that line is blank). Backing up the file would not change the file's contents and, therefore, would not result in a change in the hash value.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      172,
      968,
      967,
      173,
      199
    ],
    "source": ""
  },
  {
    "id": 3759,
    "question": "What is the maximum key length supported by the Advanced Encryption Standard's Rijndael encryption algorithm?",
    "choice_a": "128 bits",
    "choice_b": "192 bits",
    "choice_c": "256 bits",
    "choice_d": "512 bits",
    "correct_answer": "C",
    "explanation": "The AES/Rijndael algorithm is capable of operating with 128-, 192-, or 256-bit keys. The algorithm uses a block size equal to the length of the key.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      160,
      165,
      159,
      171,
      163
    ],
    "source": ""
  },
  {
    "id": 3760,
    "question": "Which of the following is the best method to protect against rainbow-table attacks?",
    "choice_a": "Encrypting passwords sent over the network",
    "choice_b": "Enabling firewalls",
    "choice_c": "Locking out accounts",
    "choice_d": "Salting passwords",
    "correct_answer": "D",
    "explanation": "Salting passwords can reduce the effectiveness of rainbow table attacks. Rainbow-table attacks are offline password attacks, so encrypting data sent over the network doesn't directly protect against rainbow-table attacks. Although enabling firewalls is always a good idea, it does not directly protect against rainbow-table attacks. Account lockout is a good defense against online brute-force attacks, but it would not work against a rainbow-table attack that takes place offline.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      193,
      199,
      994,
      172,
      153
    ],
    "source": ""
  },
  {
    "id": 3761,
    "question": "What protocol replaces certificate revocation lists with a real-time method of verifying the status of a digital certificate?",
    "choice_a": "SAE",
    "choice_b": "LDAP",
    "choice_c": "OCSP",
    "choice_d": "BGP",
    "correct_answer": "C",
    "explanation": "The Online Certificate Status Protocol (OCSP) provides real-time query/response services to digital certificate users. This overcomes the latency inherent in the traditional certificate revocation list download and cross-check process. Simultaneous Authentication of Equals (SAE) is an authentication protocol used in WPA3 wireless networking. The Lightweight Directory Access Protocol (LDAP) is a directory services protocol. The Border Gateway Protocol (BGP) is used to establish network routes.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      181,
      939,
      937,
      938,
      722
    ],
    "source": ""
  },
  {
    "id": 3762,
    "question": "You are deploying a new product into the production environment. It is a self-contained next-generation firewall(NGFW), which should be able to filter unwanted traffic by keyword, application, and protocol. You position the new device between the client network segment and the server network segment. However, once it is installed, users report that they can no longer access company servers or the internet. <br>What is the potential cause of this issue?",
    "choice_a": "There is poor network segmentation.",
    "choice_b": "The firewall is a fail-open solution.",
    "choice_c": "The new device has secure defaults.",
    "choice_d": "The new product is a closed system.",
    "correct_answer": "C",
    "explanation": "This scenario's problems are caused by the new device having secure defaults. This is a common problem with security products\u2014they are often configured with strong security defaults so that adjustments must be made to allow for typical communications and operations. Option A is incorrect because network segmentation is not the issue since the network was already divided prior to the deployment of the new device. Option A is incorrect because a fail-open system will allow for open communications when a failure event occurs in order to protect availability. This situation does not indicate that the new device itself experienced a failure, just that end users are unable to access resources after its deployment. So, even if the firewall was a fail-open system, it did not experience a failure and did not revert to its open-upon-fault state. Option D is incorrect because the issue of whether the new product is a closed or open system is not the cause of the communication problems. A closed system firewall can be just as effective as an open system firewall; the difference is that no third-party products can directly or easily interface with a closed system product.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      211,
      213,
      263,
      940,
      228
    ],
    "source": ""
  },
  {
    "id": 3763,
    "question": "\"Trust but verify\" is a security approach that leaves an organization vulnerable to insider attacks and grants intruders the ability to easily perform lateral movement among internal systems. Often this approach depends on an initial authentication process to gain access to the internal \"secured\" environment, and then relies on generic access control methods. <br>What new security approach replaces trust but verify?",
    "choice_a": "Keep it simple",
    "choice_b": "Zero trust",
    "choice_c": "Fail securely",
    "choice_d": "Privacy by design",
    "correct_answer": "B",
    "explanation": "Zero trust is the recommended replacement security approach for trust but verify. This is due to the rapid growth and changes in the modern threatscape, such as the proliferation of endpoint devices, so that the trust but verify model of security is no longer sufficient. The other options are incorrect. Although they are all secure design principles, they are not the direct replacement for trust but verify. The other options are based on trust by default, and then block or remove trust only after a violation or breach. This is the same concept behind the difference between allow listing (i.e., block by default) and block listing (i.e., allow by default).",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      208,
      207,
      227,
      213,
      215
    ],
    "source": ""
  },
  {
    "id": 3764,
    "question": "Security needs to be designed, architectured, engineered, integrated, and implemented in order to be reliable and cost-effective. There are numerous security design principles that can be adopted and woven into the crafting of company policies as well as deployed solutions. <br>Which of the following are considered secure design principles?  (Select all that apply.)",
    "choice_a": "People are the weakest link",
    "choice_b": "Least privilege",
    "choice_c": "Secure defaults",
    "choice_d": "Fail securely",
    "correct_answer": [
      "B",
      "C",
      "D",
      "F",
      "G",
      "I",
      "J",
      "K"
    ],
    "explanation": "The standard secure design principles are: least privilege, secure defaults, fail securely, threat modeling, keep it simple, separation of duties, zero trust, and privacy by design. The not listed but also secure design principles are defense in depth and trust but verify. The other options are incorrect. \"People are the weakest link\" is not a secure design principle and is also not accurate. Although people can cause security breaches intentionally, accidentally, or via coercion, they are also a key component in a successful security solution. \"Security is always top priority\" is not a secure design principle. Security should always be limited by business objectives. The most secure solution may interfere with a mission-critical business function, so security must support the business rather than get in the way of it. \"Risk should be eliminated\" is not a secure design principle and is false. All risk cannot be eliminated. There may be some individual risks that can be eliminated, but in most circumstances risk reduction, management (i.e., deterrence, transfer, avoidance), or acceptance are the only real options.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      227,
      211,
      206,
      209,
      207
    ],
    "source": "",
    "choice_e": "Security is always top priority",
    "choice_f": "Threat modeling",
    "choice_g": "Keep it simple",
    "choice_h": "Risk should be eliminated",
    "choice_i": "Separation of duties",
    "choice_j": "Zero trust",
    "choice_k": "Privacy by design"
  },
  {
    "id": 3765,
    "question": "An industrial processing facility has implemented SCADA systems to monitor and manage the mission-critical production lines. These ICSs cannot adhere to the company's 14-day patch application policy. <br>How can these systems be secured in order to minimize malware infection?",
    "choice_a": "Prohibit non-authorized nonessential software from executing",
    "choice_b": "Implement software firewalls",
    "choice_c": "Deploy the devices in a screened subnet",
    "choice_d": "Use an IDS",
    "correct_answer": "A",
    "explanation": "In this scenario, the best option is to prohibit non-authorized nonessential software from executing. A software firewall might limit network communication sessions, but will not necessarily reduce the risk of malware traversing a network link. Deployment in a screened subnet is not a good option as it may expose the ICS to the internet; deployment in a private network segment or an air-gapped network would be a better option. An IDS would only notify about a breach or intrusion or malware infection after it occurred, but an IPS might be a reasonable option.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      253,
      263,
      289,
      213,
      948
    ],
    "source": ""
  },
  {
    "id": 3766,
    "question": "Your organization has decided to update their IT environment to take advantage of advancements in virtualization solutions. They are primarily focused on containerization products. <br>Which of the following are features or capabilities of some containerization solutions?  (Select all that apply.)",
    "choice_a": "Operate a full guest OS within a cell",
    "choice_b": "Allow for multiple concurrent applications within a single container",
    "choice_c": "Automate the processes of network monitoring and response",
    "choice_d": "Offer customization of interaction between applications in separate containers",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "Containerization or OS virtualization is based on the concept of eliminating the duplication of OS elements in a virtual machine. Some containerization solutions allow for multiple concurrent applications withing a single container, whereas others are limited to one per container. Many containerization solutions allow for customization of how much interaction applications in separate containers is allowed. The other options are incorrect. A virtual machine\u2013based system uses a hypervisor installed onto the bare metal of the host server and then operates a full guest OS within each virtual machine, and each virtual machine often supports only a single primary application. Software-defined visibility (SDV) is a framework to automate the processes of network monitoring and response.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      274,
      298,
      270,
      268,
      272
    ],
    "source": ""
  },
  {
    "id": 3767,
    "question": "A large manufacturer is deploying various sensors and devices throughout its operation to monitor and remotely control certain aspects of its operations. It is essential that all data collected by these devices be analyzed on a central server. <br>What type of system is likely being installed?",
    "choice_a": "Edge computing",
    "choice_b": "MSSP",
    "choice_c": "Microservices",
    "choice_d": "Fog computing",
    "correct_answer": "D",
    "explanation": "This situation is describing a fog computing deployment. Fog computing relies on sensors, IoT devices, or even edge computing devices to collect data and then transfer it back to a central location for processing. In edge computing, the intelligence and processing is contained within each device. This is not specifically a managed security service provider (MSSP) since there is no mention of a thirdparty performing the data collection and analysis or any mention of cloud integration. This is also not microservices because the situation is focusing on deploying hardware rather than crafting new applications out of software.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      259,
      299,
      251,
      256,
      226
    ],
    "source": ""
  },
  {
    "id": 3768,
    "question": "Which of the following is typically <italic>not</italic> a culprit in causing damage to computer equipment in the event of a fire and a triggered suppression?",
    "choice_a": "Heat",
    "choice_b": "Suppression medium",
    "choice_c": "Smoke",
    "choice_d": "Light",
    "correct_answer": "D",
    "explanation": "Light is usually not damaging to most computer equipment, but fire, smoke, and the suppression medium (typically water) are very destructive.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      314,
      326,
      329,
      313,
      318
    ],
    "source": ""
  },
  {
    "id": 3769,
    "question": "Mark approaches the building where he works. At the door a small black box is attached to the wall. Mark retrieves an object from his pocket and waves it near the black box. The door to the building unlocks and opens automatically. Once Mark reaches his work area, he sits down at the desk in front of his workstation. He takes the same object he used earlier to enter the building and slides it into a slot on the side of his keyboard. The computer wakes up and he is prompted for a password. The two events of authentication performed by Mark are known as?",
    "choice_a": "\"Something you have\"",
    "choice_b": "\"Something you are\"",
    "choice_c": "\"Something you know\"",
    "choice_d": "\"Something you can do\"",
    "correct_answer": "A",
    "explanation": "In this scenario the object Mark was using is a smartcard. A smartcard is an example of a \"something you have\" authentication factor. A biometric is \"something you are,\" a password and PINs are \"something you know,\" and solving a puzzle, a secret handshake, or a private knock are examples of \"something you can do.\".",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      308,
      213,
      201,
      215,
      228
    ],
    "source": ""
  },
  {
    "id": 3770,
    "question": "An important reason to maintain separate work areas between different levels of employees is the prevention of which of the following?",
    "choice_a": "Collision",
    "choice_b": "Collusion",
    "choice_c": "Shoulder surfing",
    "choice_d": "Loss of portable storage devices",
    "correct_answer": "C",
    "explanation": "If an employee with a lower level of clearance can be present in an area of higher clearance, then that employee may be able to see sensitive information on displays (i.e., shoulder surfing). The other options are incorrect. A collision is when two data sets produce the same hash value. Collusion is when two or more people work together to commit a policy violation or a crime. Separating personnel authority levels does not really address collusion. It is arguable that it might encourage it as a lower level employee may need the cooperation of a higher level employee to gain access to a valuable asset. Separating employee areas does not affect the loss of portable storage devices. It would make it more challenging for a lower-level employee to use a portable storage device with a higher-level computer system.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      328,
      311,
      213,
      220,
      717
    ],
    "source": ""
  },
  {
    "id": 3771,
    "question": "Your facility has just been upgraded with a new burglar alarm system. This intrusion monitoring mechanism is able to detect both perimeter breaches as well as internal movement. <br>Which of the following is not a typical type of alarm that can be triggered for physical security?",
    "choice_a": "Preventive",
    "choice_b": "Deterrent",
    "choice_c": "Repellant",
    "choice_d": "Notification",
    "correct_answer": "A",
    "explanation": "There is no such thing as a preventive alarm. Alarms are triggered in response to a detected intrusion or attack. Whenever a motion detector registers a significant or meaningful change in the environment, it triggers an alarm. Common types of alarms include deterrent, repellent, and notification.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      543,
      566,
      548,
      509,
      551
    ],
    "source": ""
  },
  {
    "id": 3772,
    "question": "Your organization has recently decided to allow workers to telecommute from home. However, the CISO requires that the connections be protected by encryption using a standard VPN solution. <br>Which of the following secure protocols can be used as a VPN?  (Select all that apply.)",
    "choice_a": "Kerberos",
    "choice_b": "IPsec",
    "choice_c": "SSH",
    "choice_d": "Signal",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "IPsec, SSH, and TLS are all able to be used as a VPN. While IPsec and TLS can be used as either transport mode or tunnel mode VPNs, SSH is limited to be used only as a transport mode VPN. The others are not VPN protocols. Kerberos offers a single sign-on solution for users and provides protection for logon credentials. Modern implementations of Kerberos use hybrid encryption to provide reliable authentication protection. Signal is a cryptographic protocol that provides end-to-end encryption for voice communications, videoconferencing, and text message services. S-RPC is an authentication service and is simply a means to prevent unauthorized execution of code on remote systems.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      350,
      415,
      413,
      412,
      417
    ],
    "source": "",
    "choice_e": "TLS",
    "choice_f": "S-RPC"
  },
  {
    "id": 3773,
    "question": "Your organization is considering an upgrade of the internal network to support IPv6. You have been asked to provide an evaluation of the benefits and drawbacks of this project. <br>Which of the following are true in regard to IPv6? (Select all that apply.)",
    "choice_a": "Uses 32 bit addresses",
    "choice_b": "Uses 16-byte addresses",
    "choice_c": "Reserves an entire subnet for loopback",
    "choice_d": "Supports auto-configuration without DHCP",
    "correct_answer": [
      "B",
      "D",
      "F"
    ],
    "explanation": "IPv6 uses 16-byte (128-bit) addresses, supports auto-configuration without DHCP, and supports Quality of Service (QoS) priority values. IPv4 uses 32-bit addresses, reserves an entire subnet (127.0.0.1\u2013127.255.255.254) for loopback, and requires NAT to convert between internal and external addresses. IPv4 also supports QoS priority values, but it is called \"type of service\" in the IPv4 header.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      346,
      394,
      423,
      426,
      425
    ],
    "source": "",
    "choice_e": "Requires NAT to convert between internal and external addresses",
    "choice_f": "Supports Quality of Service (QoS) priority values"
  },
  {
    "id": 3774,
    "question": "Johnnie is learning about the network protocol stack. While evaluating the Data Link and Network layers she notices a protocol, ARP, that is indicated as operating in between those layers. <br>What function does ARP perform in typical network communications?",
    "choice_a": "It is a routing protocol.",
    "choice_b": "It resolves IP addresses into MAC addresses.",
    "choice_c": "It resolves logical addresses into a FQDN.",
    "choice_d": "It manages multicasting streaming.",
    "correct_answer": "B",
    "explanation": "Address Resolution Protocol (ARP) resolves IP addresses (logical addresses) into MAC addresses (physical addresses). ARP is not a routing protocol. RIP, IGRP, IS-IS, OSPF, BGP, and EIGRP are routing protocols. DNS reverse lookup or a PTR query resolves a logical address into a FQDN. Multicasting streaming is managed by IGMP.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      338,
      387,
      331,
      330,
      418
    ],
    "source": ""
  },
  {
    "id": 3775,
    "question": "A worker attempts to use a 15-year-old laptop under the BYOD policy of his organization. When connecting to the company Wi-Fi network, it shows connectivity, but there is no network access. The network admin confirms that the WAP is requiring WPA3. No other worker is reporting a problem with their mobile device. <br>What is the cause of this connection problem?",
    "choice_a": "The WAP's antenna are disconnected.",
    "choice_b": "The DHCP has a reservation for the MAC address of the laptop.",
    "choice_c": "DLP is blocking access.",
    "choice_d": "The laptop supports only WEP and WPA.",
    "correct_answer": "D",
    "explanation": "The likely issue is that the old laptop does not support WPA3 and might only support WEP and WPA. This would allow for the wireless connection to be established, but without encryption no communications are being allowed to occur across or through the WAP. If the WAP's antenna were disconnected, other workers might have complained about connectivity, plus the old laptop is getting a radio signal connection. A DHCP reservation would not affect network connectivity, as it would specifically reserve an IP address configuration for the specific device. And DHCP negotiation would occur after a wireless connection was established. DLP is not usually related to Wi-Fi connectivity; it is more typically used to block application features or external data transfers that breach confidentiality restrictions.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      361,
      391,
      369,
      367,
      744
    ],
    "source": ""
  },
  {
    "id": 3776,
    "question": "Xavier has been tasked with redesigning the network in order to minimize the risk related to users in one department accessing the systems in another. <br>Which of the following is <italic>not</italic> used to segment a network?",
    "choice_a": "Screened subnet",
    "choice_b": "VPN",
    "choice_c": "VLAN",
    "choice_d": "ISFW",
    "correct_answer": "B",
    "explanation": "A VPN is not a network segmentation; it is a secured encapsulation tunnel used to connect networks (or network segments) together. Screened subnets, VLANs, and an internal segmentation firewalls (ISFW) are used to segment a network.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      357,
      374,
      1013,
      412,
      375
    ],
    "source": ""
  },
  {
    "id": 3777,
    "question": "Which of the following are technologies specifically defined as part of 802.11 wireless networking?  (Select all that apply.)",
    "choice_a": "802.1X",
    "choice_b": "WPA3",
    "choice_c": "SAE",
    "choice_d": "802.11i",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E"
    ],
    "explanation": "WPA3, 802.11i, SAE, and WPS are all technologies that are specifically defined as part of wireless networking. 802.1X is an IEEE standard for port authentication, which is not strictly related to wireless use. It is, however, the basis of the ENT authentication option on wireless networks, but it is widely used to manage authentication throughout a wired network as well.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      361,
      359,
      367,
      388,
      389
    ],
    "source": "",
    "choice_e": "WPS"
  },
  {
    "id": 3778,
    "question": "While traveling, a worker connects their company-issued computer to a hotel Wi-Fi network, rather than the cellular data service included with the system. After checking email, performing online research, posting a message to a company discussion forum, and updating his itinerary in the company scheduling service, he disconnects. A few days later, the company experiences an intrusion and trade secrets are stolen by an unknown attacker. The incident investigation revealed that the credentials used to gain access to company during the breach belonged to the remote worker. <br>What was the cause of the company compromise?",
    "choice_a": "Social engineering",
    "choice_b": "Not using a 4G or 5G link",
    "choice_c": "Pivoting",
    "choice_d": "ARP poisoning",
    "correct_answer": "B",
    "explanation": "The most likely cause of this incident was an acceptable use policy violation of not using the 4G/5G cellular service included on the mobile system. If a company-issued computer has a cellular data service, it is likely there is a prohibition of using open Wi-Fi networks. The use of hotel network may have exposed the worker's connection to interception and eavesdropping, granting the attacker knowledge of the company network and the worker's credentials. There is no indication that the incident was related to social engineering by the information provided in the scenario. Pivoting is not a reason for a breach, but it is a technique used by attackers to target additional systems once an initial system compromise is successful. ARP poisoning might have been involved in the attack if the adversary was in the same hotel and on the same Wi-Fi network as the victim, but this is not the primary reason the attack occurred.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      401,
      400,
      412,
      367,
      349
    ],
    "source": ""
  },
  {
    "id": 3779,
    "question": "A review of end-user and endpoint security has uncovered the concern that most systems will indefinitely display confidential data on the screen even when a user is no longer sitting at the workstation. <br>How should this issue be resolved?",
    "choice_a": "Enforce screensavers after a timeout.",
    "choice_b": "Implement MFA.",
    "choice_c": "Implement TEMPEST countermeasures.",
    "choice_d": "Require WPA3.",
    "correct_answer": "A",
    "explanation": "Enforcing screensavers after a timeout will hide any confidential materials behind a screensaver, which should then require a valid logon to regain access to the desktop, applications, and so forth. Multi-factor authentication (MFA) is a solid security measure, but it is irrelevant here. Implementing TEMPEST countermeasures is not the right solution since the security issues are not related to emanations. WPA3 is a strong security measure, but it is a wireless encryption concept and not related to display-based disclosure of data.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      379,
      400,
      361,
      393,
      389
    ],
    "source": ""
  },
  {
    "id": 3780,
    "question": "Michael has been asked to perform an analysis of company network traffic in order to look for anomalies, inefficiencies, or potential vulnerabilities. Michael was asked to specifically divide the assessment report into two sections, one focusing on east-west traffic and the other on north-south traffic. <br>What do those terms mean?",
    "choice_a": "East-west traffic is the traffic flow that occurs between servers/resource hosts and clients/endpoint devices. North-south traffic is the traffic flow that occurs between the layers of the OSI stack.",
    "choice_b": "East-west traffic is the traffic flow that occurs within a specific network, datacenter, or cloud environment. North-south traffic is the traffic flow that occurs inbound or outbound between internal systems and external systems.",
    "choice_c": "East-west traffic is the traffic flow that occurs inbound or outbound between internal systems and external systems. North-south traffic is the traffic flow that occurs within a specific network, datacenter, or cloud environment.",
    "choice_d": "East-west traffic is the traffic flow that occurs between host and guest OSs within a hypervisor. North-south traffic is the traffic flow that occurs between data in storage and data in transit.",
    "correct_answer": "B",
    "explanation": "The correct definitions of these terms are: East-west traffic is the traffic flow that occurs within a specific network, datacenter, or cloud environment. North-south traffic is the traffic flow that occurs inbound or outbound between internal systems and external systems. The other options are incorrect. Options A and D are just wrong, whereas option C has the correct definitions switched.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      970,
      971,
      972,
      375,
      419
    ],
    "source": ""
  },
  {
    "id": 3781,
    "question": "Transmission media is used to carry network traffic. This can include copper wires, fiber-optic cables, and radio waves. <br>What are the three media management or control modes that can be used on typical transmission media? (Select all that apply.)",
    "choice_a": "Full-duplex",
    "choice_b": "Simplex",
    "choice_c": "802.1X",
    "choice_d": "Half-duplex",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The three media management or control modes are simplex (one-direction), half-duplex (two-way, but only one direction can send data at a time), and full-duplex (two-way, in which data can be sent in both directions simultaneously) communications. 802.1X is the IEEE standard for port authentication. Multiplexing is the mechanism of combining or integrating numerous signals into a single communication over a transmission media.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      332,
      386,
      381,
      366,
      330
    ],
    "source": "",
    "choice_e": "Multiplexing"
  },
  {
    "id": 3782,
    "question": "A security manager is implementing technologies to prohibit rogue devices from gaining network access. After they install a NAC, what additional tool would be able to ensure that only known and authenticated systems gain connectivity?",
    "choice_a": "IEEE 802.1X",
    "choice_b": "PFX",
    "choice_c": "CRL",
    "choice_d": "PEAP",
    "correct_answer": "A",
    "explanation": "IEEE 802.1X provides port-based access control and is useful both on wired and wireless connections to block access to systems and users that are unknown or that fail authentication. It is a common companion to NAC implementations. PFX or PKCS #12 is a certificate format and not relevant to this scenario. A certificate revocation list (CRL) is used to confirm whether certificates are revoked, which does relate to blocking access to systems or users whose certificates have been canceled, but CRL on its own is insufficient and would need to implemented in concert with a PKI solution and/or 802.1X. PEAP provides for TLS-encrypted EAP methods, but it is not specifically useful in keeping out rogue devices.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      392,
      391,
      377,
      437,
      363
    ],
    "source": ""
  },
  {
    "id": 3783,
    "question": "Wireless clients connect to the private network through a firewall after being properly authenticated by authentication, authorization, and accounting (AAA) services. The network uses both TACACS+ and RADIUS. <br>What ports should be open in order to support the logon process?",
    "choice_a": "TCP 389 and UDP 53",
    "choice_b": "UDP 1812 and TCP 49",
    "choice_c": "TCP 49 and UDP 162",
    "choice_d": "UDP 19 and TCP 3389",
    "correct_answer": "B",
    "explanation": "The ports from this list that are relevant to this scenario are UDP 1812 for RADIUS and TCP 49 for TACACS+. Only with these ports open on the firewall between the WAP and the intranet will wireless endpoints be able to authenticate via ENT to one of these AAA services. TCP 389 is for plaintext LDAP, UDP 53 is for DNS queries, UDP 162 is for SNMP trap messages, UDP 19 is for CHARGEN (Character Generator Protocol), and TCP 3389 is for RDP.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      362,
      392,
      337,
      375,
      388
    ],
    "source": ""
  },
  {
    "id": 3784,
    "question": "A worker reports that they are unable to access an internal web application from their workstation. After you confirm that the worker has been assigned correct authorization, you review the logs from the workstation for clues. You discover the following entries. <br><code>2020-01-08 12:15:36 DROP TCP 192.168.6.104 192.168.255.255 443 ---------- RECEIVE</code> <br><code>2020-01-08 12:15:51 DROP UDP 192.168.6.104 192.168.255.255 443 ---------- RECEIVE</code> <br>Based on this information, which of the following should you adjust to address this situation?",
    "choice_a": "Host-based firewall",
    "choice_b": "VLAN membership",
    "choice_c": "WAF",
    "choice_d": "Proxy",
    "correct_answer": "A",
    "explanation": "These log items are from a firewall log. They indicate that TCP and UDP traffic from the 192.168.x.x subnet to the workstation was dropped. Since this log is from the workstation, this indicates that there is a bad rule in the host-based firewall that is blocking all communications to the workstation from the local subnet. There is no mention of VLAN membership. These log entries would not be present on the workstation if the communications were being blocked by a WAF, since those are either on the web server system or on their own standalone system in front of the web server. These entries would not be present on the workstation if a proxy was dropping the communications, because those entries would be in the proxy server's logs.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      554,
      544,
      565,
      841,
      558
    ],
    "source": ""
  },
  {
    "id": 3785,
    "question": "While performing a risk assessment, you need to create a list of threats. You are focusing on email as an asset, but you then realize email can be used as a weapon as well. <br>What is it called when email itself is used as an attack mechanism?",
    "choice_a": "Masquerading",
    "choice_b": "Mail-bombing",
    "choice_c": "Spoofing",
    "choice_d": "Smurf attack",
    "correct_answer": "B",
    "explanation": "Mail-bombing is the use of email as an attack mechanism by flooding a system with messages, causing a denial of service. Masquerading is claiming to be someone or something else and is a form of spoofing. Spoofing is the falsification of the source of a communication, such as spoofing an IP address, email address, or MAC address. A Smurf attack is an ICMP-based DoS.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      408,
      409,
      410,
      407,
      436
    ],
    "source": ""
  },
  {
    "id": 3786,
    "question": "Remi is evaluating several multimedia collaboration products for use in her company. She needs to determine which products provide the best solution for her organization's business objectives. The product will be used in-house as well as by remote workers using broadband internet services. <br>Which of the following questions should she ask when evaluating each option?  (Select all that apply.)",
    "choice_a": "Does the communication occur across an open protocol or an encrypted tunnel?",
    "choice_b": "Are icons and graphics used as avatars in the user profiles?",
    "choice_c": "Does the service use strong authentication techniques?",
    "choice_d": "Are activities of users audited and logged?",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "Most questions that relate to the security of the multimedia collaboration product would be relevant to supporting business objectives. This includes the following questions: Does the communication occur across an open protocol or an encrypted tunnel? Does the service use strong authentication techniques? Are activities of users audited and logged? What tracking mechanisms are used, can the tracking be disabled, and what is the data collected for? The other optionsprobably are not relevant to security or support business objectives. Whether or not icons or graphics are used for avatars is not that important. Also, questions about minimum bandwidth requirements for chat and voice are likely unneeded since those services do not require much bandwidth and the remote users are all working over broadband internet services.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      403,
      401,
      400,
      412,
      395
    ],
    "source": "",
    "choice_e": "What tracking mechanisms are used, can the tracking be disabled, and what is the data collected for?",
    "choice_f": "What is the minimum bandwidth requirement for chat and voice services?"
  },
  {
    "id": 3787,
    "question": "Telecommuting is performing work at a remote location. Telecommuting clients use many remote access techniques to establish connectivity to the central office LAN. <br>Which of the following are examples of a remote access techniques? (Select all that apply.)",
    "choice_a": "Remote node operation",
    "choice_b": "Cross-site request forgery",
    "choice_c": "Remote control",
    "choice_d": "Port address translation",
    "correct_answer": [
      "A",
      "C",
      "E",
      "F"
    ],
    "explanation": "The primary examples of remote access techniques are remote node operation, remote control, screen scraping, and service specific. The other options are not remote access techniques. Cross-site request forgery (XSRF) is a form of web attack that plants malware on a victim's system in order to forge commands against target websites that seem to originate from the user. Port address translation (PAT) converts internal IP and port numbers to external IP and port numbers.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      399,
      417,
      400,
      401,
      437
    ],
    "source": "",
    "choice_e": "Screen scraping",
    "choice_f": "Service specific"
  },
  {
    "id": 3788,
    "question": "While researching the deployment of a new firewall solution, you realize that it supports several services that could benefit your organization that you did not initially consider evaluating when making the firewall selection. <br>Which of the following is a benefit of NAT?  (Select all that apply.)",
    "choice_a": "Hiding the internal IP addressing scheme",
    "choice_b": "Sharing a few public internet addresses with a large number of internal clients",
    "choice_c": "Using the private IP addresses from RFC 1918 on an internal network",
    "choice_d": "Filtering network traffic to prevent brute-force attacks",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "NAT offers many benefits. NAT hides the internal IP addressing scheme and enables the sharing of a few public internet addresses with a large number of internal clients. NAT supports the use of the private IP addresses from RFC 1918 on an internal network. NAT does not protect against or prevent brute-force attacks.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      423,
      736,
      425,
      424,
      738
    ],
    "source": ""
  },
  {
    "id": 3789,
    "question": "The previous PSTN system is being replaced by a VoIP solution. The CEO wants a briefing of the benefits of the technology. <br>Which of the following is not a typical security concern with VoIP?",
    "choice_a": "VLAN hopping",
    "choice_b": "Caller ID falsification",
    "choice_c": "Vishing",
    "choice_d": "Remote dialing",
    "correct_answer": "A",
    "explanation": "VLAN hopping is a switch security issue, not a VoIP security issue. Caller ID falsification and vishing are VoIP security concerns. Remote dialing is a VoIP PBX concern.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      353,
      396,
      397,
      438,
      421
    ],
    "source": ""
  },
  {
    "id": 3790,
    "question": "Your company has just initiated an IPsec policy that requires all systems to request an encrypted session for each communication. While attempting to monitor the network, you want to configure a capture filter in Wireshark to collect just the IPsec negotiations. At which OSI model layer does the IPsec protocol function?",
    "choice_a": "Data Link",
    "choice_b": "Transport",
    "choice_c": "Session",
    "choice_d": "Network",
    "correct_answer": "D",
    "explanation": "IPsec operates at the Network layer (layer 3). IPsec does not operate at the Data Link, Transport, or Session layer. The primary Data Link VPNs are L2TP and PPTP, although wireless encryption occurs here as well. The primary VPNs at the Transport layer are TLS and SSH. There is no actual Session layer in TCP/IP networks\u2014that function (when performed at all) is handled by TCP at the Transport layer.",
    "topic_id": 4,
    "practice_test_id": 6,
    "related_articles": [
      345,
      331,
      416,
      350,
      334
    ],
    "source": ""
  },
  {
    "id": 3791,
    "question": "Users normally log on with a username and password. Management wants to increase security by adding an authentication method in the something you are category. <br>Which of the following is the <italic>best</italic> choice?",
    "choice_a": "A smartcard",
    "choice_b": "The maiden name of the user's mother",
    "choice_c": "Fingerprints",
    "choice_d": "A PIN",
    "correct_answer": "C",
    "explanation": "Fingerprints is the only answer in the something you are factor. A smartcard is in the something you have factor. The maiden name of the user's mother and a personal identification number (PIN) are both in the something you know factor.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      443,
      445,
      446,
      750,
      444
    ],
    "source": ""
  },
  {
    "id": 3792,
    "question": "Administrators are installing a database application on server in the server room. Management wants to ensure only authorized personnel can access the server and modify any of the application settings. <br>Which of the following is the best choice of a logical access control that can help meet this goal?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Single sign-on",
    "choice_d": "Turnstile",
    "correct_answer": "B",
    "explanation": "Authorization is the best choice. For example, certain users (such as database administrators) can be granted authorization to modify settings, but all other users will be denied access. Users provide credentials (such as a username and password) to authenticate, but all users should not be able to modify server settings simply because they authenticated. Single sign-on (SSO) is not relevant to this scenario. SSO is a centralized access control technique that allows users to be authenticated once and access multiple systems within a network without authenticating again. A turnstile is a physical security control.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      441,
      461,
      462,
      470,
      472
    ],
    "source": ""
  },
  {
    "id": 3793,
    "question": "An administrator set the password expiration for 7 days. <br>Which of the following is a benefit of this change?",
    "choice_a": "It prevents users from reusing the same passwords.",
    "choice_b": "It forces all active users to change their password within a week.",
    "choice_c": "It identifies the minimum age of a password.",
    "choice_d": "It identifies the lockout period after a user enters the incorrect password time.",
    "correct_answer": "B",
    "explanation": "Setting the password expiration to 7 days will force all active users to change their password within a week. This is the same as setting the maximum age of a password. A password history can remember previously used passwords and prevent users from reusing the same passwords. Password history is often combined with a minimum password age. This prevents users from changing their password repeatedly to get back to their original password. A lockout policy (not a password policy) identifies how long an account is locked out after a password is entered incorrectly too many times.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      447,
      908,
      907,
      489,
      446
    ],
    "source": ""
  },
  {
    "id": 3795,
    "question": "A bank has a website that allows customers to log on and access their accounts, pay bills, and transfer funds. Of the following choices, when should online customer sessions automatically be closed?",
    "choice_a": "Never",
    "choice_b": "After 5 minutes",
    "choice_c": "After an hour of inactivity",
    "choice_d": "After 2 minutes of inactivity",
    "correct_answer": "D",
    "explanation": "Closing the session after 2 minutes of inactivity is the best choice of the given options. A bank account where users can transfer funds is a high-value application, so the session should be closed at some time. Never closing a session isn't a secure option. It's common to close sessions of high-value applications sometime between 2 and 5 minutes of inactivity. If it's closed after 5 minutes, it may be closing while a customer is in the middle of a transaction.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      454,
      976,
      977,
      978,
      460
    ],
    "source": ""
  },
  {
    "id": 3796,
    "question": "A customer created an online saving account using a web browser. Before the bank created the account, it asked the customer a series of questions about past addresses where they'd lived and current payment amounts for their car and mortgage. <br>Which of the following best describes this process?",
    "choice_a": "A cognitive password",
    "choice_b": "Knowledge-based authentication",
    "choice_c": "Registration",
    "choice_d": "Two-factor authentication",
    "correct_answer": "B",
    "explanation": "Knowledge-based authentication (KBA) processes ask a user a series of questions based on their history that is recorded in authoritative sources. A cognitive password asks a series of questions, but these are questions that the user previously answered, such as your favorite color. The registration process is used for internal employees and collect biometric data. Two-factor authentication uses two separate types of authentication, but KBA is only one type of authentication.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      442,
      443,
      446,
      441,
      445
    ],
    "source": ""
  },
  {
    "id": 3797,
    "question": "An organization wants to enforce strong passwords, with most users logging on with a single set of credentials. <br>Which of the following is the best choice to meet these needs?",
    "choice_a": "Single sign-on",
    "choice_b": "Password policy",
    "choice_c": "Service accounts",
    "choice_d": "Tokens",
    "correct_answer": "A",
    "explanation": "Single sign-on (SSO) is the best solution. It allows regular users to log on with a single account. Administrators may have two accounts. A password policy can enforce strong passwords, but every system will need a different password policy without SSO. Service accounts are used to start services or applications. Tokens are used for two-factor authentication and do not use passwords.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      451,
      480,
      477,
      447,
      446
    ],
    "source": ""
  },
  {
    "id": 3798,
    "question": "A software company with a worldwide footprint recently bought out another software company based in the United States. The U.S. company needs to maintain its name and domain infrastructure. However, employees in both companies need to access resources in the other network. <br>Which of the following would best meet this need?",
    "choice_a": "A federation",
    "choice_b": "Session management",
    "choice_c": "Credential management",
    "choice_d": "Single sign-on",
    "correct_answer": "A",
    "explanation": "A federation can include two or more networks and allow users in each network to share network resources. Session management closes inactive sessions, and credential management provides a means to store user credentials. Federations provide single sign-on (SSO) capabilities, but SSO will not share network resources.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      480,
      451,
      452,
      460,
      476
    ],
    "source": ""
  },
  {
    "id": 3799,
    "question": "Security administrators suspect that many users have excessive privileges due to creeping privileges. <br>What can be used to verify this?",
    "choice_a": "Account provisioning",
    "choice_b": "Disabling an account",
    "choice_c": "Account review",
    "choice_d": "Account revocation",
    "correct_answer": "C",
    "explanation": "Account reviews can detect instances of creeping privileges or excessive privileges. Account provisioning grants privileges. Disabling an account ensures it isn't used, and account revocation deletes the account.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      457,
      458,
      470,
      456,
      760
    ],
    "source": ""
  },
  {
    "id": 3800,
    "question": "A company's security policy states that user accounts should be disabled during the exit interview for any employee leaving the company. <br>Which of the following is the <italic>most</italic> likely reason for this policy?",
    "choice_a": "To prevent supervisors from accessing the employee's data",
    "choice_b": "To ensure employees return company property",
    "choice_c": "To terminate employee benefits",
    "choice_d": "To retain the decryption key",
    "correct_answer": "D",
    "explanation": "The most likely reason (of the provided answers) is the retention of the account's decryption key. Data encrypted by a user is typically encrypted with a key tied to the user account, and deleting the account may result in the data staying encrypted and unavailable. Though not available as an option, disabling the account also prevents an employee from logging on after leaving the company. Disabling the account allows supervisors to review the user's data. Employees should return company property, but disabling an account won't ensure they do so. Disabling a user account won't terminate employee benefits.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      456,
      1064,
      1065,
      458,
      457
    ],
    "source": ""
  },
  {
    "id": 3801,
    "question": "Attackers have exploited the KRBTGT account in an organization's domain. <br>What will this allow them to do?",
    "choice_a": "Create golden tickets",
    "choice_b": "Create silver tickets",
    "choice_c": "Run Python scripts",
    "choice_d": "Identify accounts with Kerberos pre-authentication disabled",
    "correct_answer": "A",
    "explanation": "Attackers can create golden tickets after successfully exploiting the Kerberos service account (KRBTGT). This allows them to create any tickets within an Active Directory domain. Silver tickets use a captured hash-of-service account to create a ticket-granting service (TGS) ticket. The KRBTGT account is unrelated to running Python scripts. The ASREPRoast Kerberos exploit allows attackers to identify accounts with pre-authentication disabled.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3802,
    "question": "Firewalls use a set of administrator-defined filters. <br>Which of the following access control models does this describe?",
    "choice_a": "Rule-based access control",
    "choice_b": "Role-Based Access Control (RBAC)",
    "choice_c": "Mandatory Access Control (MAC)",
    "choice_d": "Attribute-BasedAccess Control (ABAC)",
    "correct_answer": "A",
    "explanation": "A rule-based access control model defines access using a set of rules, such as the rules in a firewall's access control list. An RBAC model grants access based on a subject's membership in a group or role. The MAC model uses labels to identify access. An ABAC model grants access based on attributes.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      467,
      491,
      472,
      463,
      466
    ],
    "source": ""
  },
  {
    "id": 3803,
    "question": "A small business owner has created a network to support employees. When an employee creates a file, the employee is the owner and can assign access to the file. <br>Which of the following access control models does this describe?",
    "choice_a": "Mandatory Access Control (MAC)",
    "choice_b": "Rule-based access control",
    "choice_c": "Discretionary Access Control (DAC)",
    "choice_d": "Role-Based Access Control (RBAC)",
    "correct_answer": "C",
    "explanation": "In a DAC model, every object has an owner, and the owner assigns access to the object. The MAC model uses labels to assign access and is sometimes referred to as a lattice-based model. A rule-based access control model uses rules to grant access. RBAC models use groups or roles to assign access.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      465,
      491,
      466,
      467,
      472
    ],
    "source": ""
  },
  {
    "id": 3804,
    "question": "IT personnel are concerned that attackers may take over some Internet of Things (IoT) devices on the network's border. They want to ensure that any malicious traffic from these devices is blocked. <br>Which of the following access control models has the best chance of blocking this traffic?",
    "choice_a": "Attribute-Based Access Control (ABAC)",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Role-Based AccessControl (RBAC)",
    "choice_d": "Risk-based access control",
    "correct_answer": "D",
    "explanation": "A risk-based access control model can be coded to block malicious traffic from infected IoT devices. It evaluates the environment and the situation and makes decisions to block traffic that is abnormal. An ABAC model uses attributes to grant access and is often used in software-defined networks (SDNs). A MAC model grants access with the use of labels. RBAC uses a well-defined collection of named job roles for access control. Administrators grant each job role with the privileges they need to perform their jobs.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      469,
      491,
      472,
      468,
      466
    ],
    "source": ""
  },
  {
    "id": 3805,
    "question": "A junior administrator is installing an application on a Windows server. The application needs to run in the context of an account with specific privileges. <br>Which of the following is the best choice?",
    "choice_a": "LocalSystem account",
    "choice_b": "Service account",
    "choice_c": "Administrator account",
    "choice_d": "Sudo account",
    "correct_answer": "B",
    "explanation": "It's best to create a service account and assign the specific privileges to the account needed by the application. The LocalSystem account and the Administrator account both have full administrative privileges, but the scenario doesn't indicate the application needs administrative privileges. Users are granted sudo permissions on Linux systems, allowing them to run commands with root-level permissions, but sudo is not an account.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      926,
      470,
      751,
      458,
      457
    ],
    "source": ""
  },
  {
    "id": 3806,
    "question": "Which of the following is the best choice to support authentication and authorization in federated organizations?",
    "choice_a": "Kerberos",
    "choice_b": "Hypertext Markup Language (HTML)",
    "choice_c": "Extensible Markup Language (XML)",
    "choice_d": "Security Assertion Markup Language (SAML)",
    "correct_answer": "D",
    "explanation": "SAML is an XML-based framework used to exchange user information for single sign-on(SSO) between federated organizations within a federated identity management system. Kerberos supports SSO in a single organization, not a federation. HTML only describes how data is displayed. Although XML could be used, it would require redefining tags already defined inSAML.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      474,
      480,
      477,
      476,
      492
    ],
    "source": ""
  },
  {
    "id": 3807,
    "question": "Which of the following AAA services does Remote Authentication Dial-in User Service (RADIUS) provide?  (Select all that apply.)",
    "choice_a": "Authentication",
    "choice_b": "Availability",
    "choice_c": "Authorization",
    "choice_d": "Accounting",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "RADIUS provides authentication, authorization, and accounting. Although it is possible to add multiple RADIUS servers in failover clusters to increase availability, this isn't a RADIUS function. Instead, the failover clusters provide availability.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      479,
      459,
      441,
      492,
      451
    ],
    "source": ""
  },
  {
    "id": 3808,
    "question": "When performing access review audits, which type of account is the most important to audit?",
    "choice_a": "None is more important. They are all equal.",
    "choice_b": "Regular user accounts.",
    "choice_c": "Auditor accounts.",
    "choice_d": "Privileged accounts.",
    "correct_answer": "D",
    "explanation": "Privileged accounts (such as administrator accounts) are granted the most access and should be a primary focus in an access review audit. Regular user and auditor accounts don't have as many rights and permissions as privileged accounts and are not as important to audit.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      499,
      502,
      862,
      1007,
      1006
    ],
    "source": ""
  },
  {
    "id": 3809,
    "question": "What contractual obligation requires credit card merchants to report the potential compromise of credit card data?",
    "choice_a": "GLBA",
    "choice_b": "Sarbanes-Oxley",
    "choice_c": "FERPA",
    "choice_d": "PCI DSS",
    "correct_answer": "D",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) requires that credit card merchants immediately report any known or suspected compromise of cardholder data.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3810,
    "question": "Mark is planning to conduct a penetration test against his organization's systems and is documenting the tactics he will use. <br>Which one of the following would not be considered a penetration testing best practice?",
    "choice_a": "Mimicking attacks previously perpetrated against your system",
    "choice_b": "Performing the attacks without management's consent",
    "choice_c": "Using manual and automated attack tools",
    "choice_d": "Reconfiguring the system to resolve any discovered vulnerabilities",
    "correct_answer": "B",
    "explanation": "You should never conduct a formal or informal penetration test against any company without the advanced knowledge and express consent of management.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      863,
      864,
      1007,
      1080,
      497
    ],
    "source": ""
  },
  {
    "id": 3811,
    "question": "What type of network discovery scan attempts to simulate an already open network connection?",
    "choice_a": "TCP connect scan",
    "choice_b": "Xmas scan",
    "choice_c": "TCP SYN scan",
    "choice_d": "TCP ACK scan",
    "correct_answer": "D",
    "explanation": "The TCP ACK scan sends an ACK packet, simulating a packet from the middle of an already established connection.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      763,
      764,
      765,
      775,
      776
    ],
    "source": ""
  },
  {
    "id": 3812,
    "question": "Kevin is conducting a software assessment and does not have access to the underlying source code. <br>What type of test is he performing?",
    "choice_a": "Static testing",
    "choice_b": "White box testing",
    "choice_c": "Gray box testing",
    "choice_d": "Black box testing",
    "correct_answer": "D",
    "explanation": "In a black box test, the tester must not have access to the application's source code.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      494,
      496,
      778,
      1003,
      1005
    ],
    "source": ""
  },
  {
    "id": 3813,
    "question": "Juniper Enterprises' data center lies in a 500-year FEMA flood plain. <br>What is the likelihood that a flood will affect the data center in any given year?",
    "choice_a": "1%",
    "choice_b": "5%",
    "choice_c": "0.20%",
    "choice_d": "0.10%",
    "correct_answer": "C",
    "explanation": "Flooding is expected once every 500 years in a 500-year flood plain. This is equivalent to a 0.2% annual risk of flood.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      1023
    ],
    "source": ""
  },
  {
    "id": 3814,
    "question": "What type of interface testing would identify flaws in a program's ability to interact with other programs via web services?",
    "choice_a": "Application programming interface testing",
    "choice_b": "User interface testing",
    "choice_c": "Physical interface testing",
    "choice_d": "Security interface testing",
    "correct_answer": "A",
    "explanation": "Application programming interfaces (APIs) provide standard mechanisms for web services to interact with each other.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      495,
      494,
      776,
      775,
      777
    ],
    "source": ""
  },
  {
    "id": 3815,
    "question": "Victoria is conducting a third-party audit of a cloud service provider and is preparing to generate a SOC audit report.  During her engagement, she limited her review to assessing the organization's controls that might impact the accuracy of financial reporting. <br>What type of engagement did she conduct under SSAE 18?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SOC 4",
    "correct_answer": "A",
    "explanation": "SOC 1 engagements assess the organization's controls that might impact the accuracy of financial reporting.  SOC 2 and 3 engagements extend into controls protecting confidentiality, integrity, and availability more generally.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      766,
      793,
      794,
      795,
      767
    ],
    "source": ""
  },
  {
    "id": 3816,
    "question": "Tom is preparing to conduct a penetration test and would like to use a testing framework that allows him to easily deploy exploits. <br>Which one of the following tools would best meet his needs?",
    "choice_a": "OpenVAS",
    "choice_b": "Nmap",
    "choice_c": "Sqlmap",
    "choice_d": "Metasploit Framework",
    "correct_answer": "D",
    "explanation": "Metasploit Framework is a penetration testing framework that allows the easy deployment of exploits against target systems.  It would be the best tool for Tom to use during his penetration test.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      1080,
      1078,
      771,
      776,
      775
    ],
    "source": ""
  },
  {
    "id": 3817,
    "question": "Jon is testing a new software application.  He has developed a list of possible ways that an attacker might exploit the application and is now working through each scenario, testing the application to see if it is vulnerable to that exploit. <br>What type of testing is Jon conducting?",
    "choice_a": "Test coverage analysis",
    "choice_b": "Fagan inspection",
    "choice_c": "Synthetic transactions",
    "choice_d": "Misuse case testing",
    "correct_answer": "D",
    "explanation": "In misuse case testing the testers first enumerate known misuse/abuse cases.  They then attempt to exploit those use cases with manual and/or automated attack techniques.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      495,
      775,
      776,
      494,
      1003
    ],
    "source": ""
  },
  {
    "id": 3818,
    "question": "Eric is conducting a compliance check to determine whether controls in his organization are effectively enforcing credit card processing requirements. <br>What security standard would be most appropriate for this check?",
    "choice_a": "HIPAA",
    "choice_b": "GLBA",
    "choice_c": "PCI DSS",
    "choice_d": "SOX",
    "correct_answer": "C",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) contains security requirements for processing credit card transactions and would be the most appropriate resource for this testing.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      864,
      793,
      768,
      863,
      1006
    ],
    "source": ""
  },
  {
    "id": 3819,
    "question": "Which one of the following techniques would be the least effective way to perform backup verification?",
    "choice_a": "Interview of backup administrator",
    "choice_b": "Review of system logs",
    "choice_c": "Restoration of requested files",
    "choice_d": "Inspection of hash values",
    "correct_answer": "A",
    "explanation": "Interviewing a backup administrator is not generally an effective technique because it does not confirm that the backup was actually performed properly. The other techniques all do this to some extent.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      500,
      786,
      784,
      785,
      498
    ],
    "source": ""
  },
  {
    "id": 3821,
    "question": "Which one of the following third-party frameworks is commonly used during audits of information technology systems?",
    "choice_a": "COBIT",
    "choice_b": "ATT&CK",
    "choice_c": "Cyber Kill Chain",
    "choice_d": "PCI DSS",
    "correct_answer": "A",
    "explanation": "The Control Objectives for Information Technology (COBIT) are a framework for evaluating the controls organizations implement around information systems.  ATT&CK and the Cyber Kill Chain are tools used to conduct threat intelligence.  PCI DSS is a standard used specifically for audits of credit card processing systems, which are not mentioned in this question.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      864,
      1008,
      793,
      766,
      862
    ],
    "source": ""
  },
  {
    "id": 3822,
    "question": "An administrator is tasked with provisioning eight computers for new software developers. Each computer needs the same applications and settings. <br>Which of the following is the easiest method of configuring these computers?",
    "choice_a": "Set up the computers individually",
    "choice_b": "Using baselines",
    "choice_c": "Change management",
    "choice_d": "Using images",
    "correct_answer": "D",
    "explanation": "Images would be the easiest way to provision these computers. Images ensure that all the systems have identical settings. It would take too long to set up the computers individually, and this increases the chance of errors. Baselines are starting points, generally using lists, and they typically require modifications. Baselines are often used when creating images. Change management processes are used after a system has been deployed.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      140,
      141,
      698,
      848,
      847
    ],
    "source": ""
  },
  {
    "id": 3823,
    "question": "An organization wants to reduce vulnerabilities against fraud from malicious employees. Of the following choices, what would help with this goal?  (Select all that apply.)",
    "choice_a": "Job rotation",
    "choice_b": "Separation of duties",
    "choice_c": "Mandatory vacations",
    "choice_d": "Baselining",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Job rotation, separation of duties, and mandatory vacation policies will all help reduce fraud. Baselining is used for configuration management and would not help reduce collusion or fraud.",
    "topic_id": 3,
    "practice_test_id": 6,
    "related_articles": [
      219,
      715,
      712,
      296,
      213
    ],
    "source": ""
  },
  {
    "id": 3824,
    "question": "Security administrators want to implement a method to identify when personnel are using elevated privileges, and detect violations of the least privilege principle. <br>Which of the following is the BEST choice to meet these requirements?",
    "choice_a": "Privileged account management",
    "choice_b": "Review of security logs",
    "choice_c": "Review of inactive accounts",
    "choice_d": "Traffic analysis",
    "correct_answer": "A",
    "explanation": "Privileged account management ensures that personnel do not have more privileges than they need and do not misuse their privileges. It can identify whether users have excessive privileges violating the least privilege principle. Security logs would be used, but not alone. A review of inactive accounts and traffic analysis are not part of privileged account management.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      506,
      533,
      535,
      554,
      1042
    ],
    "source": ""
  },
  {
    "id": 3825,
    "question": "Several desktop PCs have reached the end of their lifecycle. Management wants to donate these to a charity if possible. <br>What should employees do before giving the equipment away?",
    "choice_a": "Remove all CDs and DVDs.",
    "choice_b": "Remove all software licenses.",
    "choice_c": "Sanitize it.",
    "choice_d": "Install the original software.",
    "correct_answer": "C",
    "explanation": "Systems should be sanitized when they reach the end of their lifecycle and are being donated to charity. This ensures that they do not include any sensitive data. Removing CDs and DVDs is part of the sanitation process, but other elements of the system, such as disk drives, should also be checked to ensure that they don't include sensitive information. Removing software licenses or installing the original software is not necessarily required unless the organization's sanitization process requires it.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      518,
      513,
      541,
      607,
      605
    ],
    "source": ""
  },
  {
    "id": 3826,
    "question": "Employees regularly travel to foreign countries as a routine part of their jobs. <br>Which of the following represents a significant risk that they should avoid while traveling?",
    "choice_a": "Free Wi-Fi",
    "choice_b": "VPNs",
    "choice_c": "Encryption",
    "choice_d": "Physical control",
    "correct_answer": "A",
    "explanation": "Employees should avoid the use of free Wi-Fi networks. Attackers can configure free Wi-Fi networks and capture all traffic going through the free wireless network. The other answers are all useful. Virtual Private Networks (VPNs) create secure encrypted connections. Encryption can provide a layer of protection for sensitive data. Physical control can prevent attackers from installing malware or monitoring devices on employee's electronic systems.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      510,
      511,
      516,
      515,
      574
    ],
    "source": ""
  },
  {
    "id": 3827,
    "question": "Some cloud-based service models require an organization to perform some maintenance and take responsibility for some security. <br>Which of the following is a service model that places the most responsibilities on the organization leasing the cloud-based resources?",
    "choice_a": "IaaS",
    "choice_b": "PaaS",
    "choice_c": "SaaS",
    "choice_d": "Hybrid",
    "correct_answer": "A",
    "explanation": "Organizations have the most responsibility for maintenance and security when leasing Infrastructure as a Service (IaaS) cloud resources. The cloud service provider takes more responsibility with the Platform as a Service (PaaS) model and the most responsibility with the Software as a Service (SaaS) model. Hybrid refers to a cloud deployment model (not a service model) and indicates that two or more deployment models are used (such as private, public, and/or community.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      834,
      818,
      621,
      833,
      628
    ],
    "source": ""
  },
  {
    "id": 3828,
    "question": "Management wants to ensure that an IT network supports accountability. <br>Which of the following is necessary to meet this requirement?",
    "choice_a": "Identification",
    "choice_b": "Integrity",
    "choice_c": "Audit trails",
    "choice_d": "Confidentiality",
    "correct_answer": "C",
    "explanation": "Audit trails provide a record of events in audit logs. They include what happened and who did it. Users can be held accountable for their actions when the logs show what they did. Authentication (not available as a possible answer) is also necessary. Users claim an identity with identification and prove their identity with authentication (such as a password). However, identification without authentication doesn't support accountability. Integrity provides assurances that unauthorized entities have not modified data or system settings. Confidentiality ensures that unauthorized entities can't access sensitive data and is unrelated to this question.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      556,
      554,
      560,
      541,
      602
    ],
    "source": ""
  },
  {
    "id": 3829,
    "question": "What is used to keep subjects accountable for their actions while they are authenticated to a system?",
    "choice_a": "Authentication",
    "choice_b": "Monitoring",
    "choice_c": "Account lockout",
    "choice_d": "User entitlement reviews",
    "correct_answer": "B",
    "explanation": "Accountability is maintained by monitoring the activities of subjects and objects as well as monitoring core system functions that maintain the operating environment and the security mechanisms. Authentication is required for effective monitoring, but it doesn't provide accountability by itself. Account lockout prevents login to an account if the wrong password is entered too many times. User entitlement reviews can identify excessive privileges.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      556,
      554,
      560,
      533,
      506
    ],
    "source": ""
  },
  {
    "id": 3830,
    "question": "Your organization recently updated the incident response plan using the incident management steps identified in the CISSP objectives. <br>Which of the following steps should be identified as the first step?",
    "choice_a": "Response",
    "choice_b": "Recovery",
    "choice_c": "Remediation",
    "choice_d": "Detection",
    "correct_answer": "D",
    "explanation": "Detection is the first step. The order of the next steps are response, mitigation, reporting, recovery, remediation, and lessons learned.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      537,
      538,
      539,
      540,
      565
    ],
    "source": ""
  },
  {
    "id": 3831,
    "question": "After learning that sensitive data was leaked to the Internet, you discover it was retrieved from a specific Windows server. You suspect that malware started a service on the server, sent the data to an Internet IP address, and stopped the service. You want to find out when this was done. <br>Which of the following logs is MOST likely to show when the service was started and stopped?",
    "choice_a": "Application log",
    "choice_b": "Firewall log",
    "choice_c": "Proxy log",
    "choice_d": "System log",
    "correct_answer": "D",
    "explanation": "System logs record system events such as when services start or stop. None of the other logs listed as available answers will log when a service is started or stopped. Application logs record information for specific applications. Firewall logs can record events related to any traffic that reaches a firewall.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      554,
      841,
      842,
      538,
      604
    ],
    "source": ""
  },
  {
    "id": 3832,
    "question": "Network-based intrusion detection systems (NIDSs) and network-based intrusion prevention systems (NIPSs) have some differences and some similarities. <br>Which of the following describes a similarity?",
    "choice_a": "They can both detect attacks using pattern-matching",
    "choice_b": "They are both placed inline with incoming traffic",
    "choice_c": "They can both prevent attacks from reaching the internal network",
    "choice_d": "They both connect to network switch ports using mirror mode",
    "correct_answer": "A",
    "explanation": "NIDSs and NIPSs can both detect attacks using pattern-matching (also known as signature-based detection and knowledge-based detection). A NIPS is placed inline with traffic and can prevent attacks from reaching an internal network. While a NIDS can be placed inline with the traffic, it isn't placed inline by default. An IDS may be connected to a network switch port using mirror mode to collect data, but an NIPS would be inline with all traffic.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      548,
      547,
      566,
      538,
      562
    ],
    "source": ""
  },
  {
    "id": 3833,
    "question": "Your organization wants to reduce the administrative workload by implementing automated responses to common attacks. <br>Which of the following will meet this need?",
    "choice_a": "Web application firewall",
    "choice_b": "Clipping levels",
    "choice_c": "SOAR",
    "choice_d": "Sampling",
    "correct_answer": "C",
    "explanation": "Security Orchestration, Automation, and Response (SOAR) technologies provide automated responses to common attacks, reducing an administrator's workload. A web application firewall protects a web server, but it doesn't address all attacks. Sampling and clipping are methods used to reduce what needs to be examined in logs, and they do not automate any attack responses.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      653,
      674,
      651,
      652,
      669
    ],
    "source": ""
  },
  {
    "id": 3834,
    "question": "Gavin is conducting a test of his organization's disaster recovery plan and reached the phase of the test where they shut down the primary data center. <br>What type of test is he running?",
    "choice_a": "Parallel test",
    "choice_b": "Simulation",
    "choice_c": "Walkthrough",
    "choice_d": "Full interruption",
    "correct_answer": "D",
    "explanation": "Full interruption tests are the only type of test where the primary data center is shut down.  Parallel tests also activate the alternate processing facility but do not shift operational responsibility away from the primary data center.  Simulations and walkthroughs do not activate the alternate site.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      594,
      597,
      598,
      569,
      596
    ],
    "source": ""
  },
  {
    "id": 3835,
    "question": "What nontraditional alternative recovery site is made up of transportable relocation units?",
    "choice_a": "Cloud service provider",
    "choice_b": "Hot site",
    "choice_c": "Mobile site",
    "choice_d": "Mobility suite",
    "correct_answer": "C",
    "explanation": "Mobile sites are non-mainstream alternatives to traditional recovery sites. They typically consist of self-contained trailers or other easily relocated units.  Hot sites are stationary locations and not mobile.  Cloud service providers do not offer the exclusive use of facilities but operate on a multi-tenancy model. Mobility suites are not a type of disaster recovery site.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      582,
      598,
      592,
      573,
      581
    ],
    "source": ""
  },
  {
    "id": 3836,
    "question": "Cindy is concerned that high priority network traffic will be dropped when her organization's network becomes overwhelmed and would like to implement a control that prioritizes this traffic. <br>What control would best meet her needs?",
    "choice_a": "Quality of service",
    "choice_b": "Fault tolerance",
    "choice_c": "System resilience",
    "choice_d": "High availability",
    "correct_answer": "A",
    "explanation": "Quality of service (QoS) controls allow administrators to prioritize different types of network traffic and would meet Cindy's needs.  Fault tolerance, system resilience, and high availability are all controls designed to reduce the likelihood and/or impact of a technical failure.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      578,
      575,
      577,
      560,
      526
    ],
    "source": ""
  },
  {
    "id": 3837,
    "question": "David gathered his organization's disaster recovery team on a videoconference and asked them to consider how they would respond if the area suffered an earthquake and they were unable to return to their primary facility. <br>What type of testing is he conducting?",
    "choice_a": "Full-interruption test",
    "choice_b": "Parallel test",
    "choice_c": "Simulation test",
    "choice_d": "Structured walk-through",
    "correct_answer": "C",
    "explanation": "Simulation tests are similar to the structured walk-throughs. In simulation tests, disaster recovery team members are presented with a scenario and asked to develop an appropriate response.  That is the case in David's earthquake exercise.  There is no activation of any alternate facility, as would take place in a full-interruption or parallel test.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      597,
      594,
      593,
      581,
      595
    ],
    "source": ""
  },
  {
    "id": 3838,
    "question": "What type of alternate processing facility contains a full complement of computing equipment in working order with copies of data ready to go?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Cloud site",
    "correct_answer": "A",
    "explanation": "Hot sites are ready to assume full operational capacity at a moment's notice.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      582,
      598,
      585,
      573,
      588
    ],
    "source": ""
  },
  {
    "id": 3839,
    "question": "Brian is planning to conduct a disaster recovery test.  During the test, he will relocate personnel to the hot site, activate the site, and simulate live operations by processing the same data at the hot site as the organization processes at the primary site.  The primary site will be taken offline once the test is underway. <br>What type of test is Brian planning?",
    "choice_a": "Parallel test",
    "choice_b": "Full-interruption test",
    "choice_c": "Structured walk-through",
    "choice_d": "Simulation test",
    "correct_answer": "B",
    "explanation": "Full-interruption tests activate the alternate processing facility and take the primary site offline.  Parallel tests also activate the alternate facility but keep operational responsibility at the primary site.  Structured walk-throughs and simulation tests do not activate the alternate site.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      594,
      597,
      598,
      582,
      596
    ],
    "source": ""
  },
  {
    "id": 3840,
    "question": "What evidence standard do most criminal investigations follow?",
    "choice_a": "Beyond a reasonable doubt",
    "choice_b": "Beyond the shadow of a doubt",
    "choice_c": "Preponderance of the evidence",
    "choice_d": "Clear and convincing evidence",
    "correct_answer": "A",
    "explanation": "Criminal investigations typically follow the \"beyond a reasonable doubt\" standard of evidence.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      981,
      100,
      97,
      117,
      98
    ],
    "source": ""
  },
  {
    "id": 3841,
    "question": "What rule of evidence states that a written agreement is assumed to contain all terms of the agreement?",
    "choice_a": "Real evidence",
    "choice_b": "Best evidence",
    "choice_c": "Parol evidence",
    "choice_d": "Chain of evidence",
    "correct_answer": "C",
    "explanation": "The parol evidence rule states that when an agreement between parties is put into written form, the written document is assumed to contain all the terms of the agreement, and no verbal agreements may modify the written agreement.",
    "topic_id": 1,
    "practice_test_id": 6,
    "related_articles": [
      979,
      981,
      35,
      38,
      96
    ],
    "source": ""
  },
  {
    "id": 3842,
    "question": "Tina is preparing to create a forensic image of a hard drive from a system involved in a security incident. <br>What hardware device can she use to help ensure that creating the image does not alter the original evidence?",
    "choice_a": "Network tap",
    "choice_b": "Write blocker",
    "choice_c": "Protocol analyzer",
    "choice_d": "Cryptographic hash",
    "correct_answer": "B",
    "explanation": "Write blockers are hardware devices used to prevent the accidental writing of data to media that was collected as evidence.  Network taps and protocol analyzers are used in the collection of evidence from networks, rather than storage.  Cryptographic hashes may be used to detect unauthorized changes to evidence, but they do not prevent those changes from occurring.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      603,
      602,
      605,
      606,
      604
    ],
    "source": ""
  },
  {
    "id": 3843,
    "question": "What concept was first introduced by the U.S. Department of Defense in the 1990s as a way to use multifunctional groups to foster parallel decisions in software development?",
    "choice_a": "COTS",
    "choice_b": "IPT",
    "choice_c": "Agile",
    "choice_d": "DevOps",
    "correct_answer": "B",
    "explanation": "Integrated Product Teams (IPTs) were introduced in 1995 by DoD to bring together stakeholders and foster parallel decision-making.  The Agile and DevOps approaches also foster this approach, but they came into practice many years later and were first embraced in the private sector.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      983,
      982,
      984,
      622,
      640
    ],
    "source": ""
  },
  {
    "id": 3844,
    "question": "Gene is reviewing the shared software libraries used within his organization.  He notices that developers widely use open source libraries. <br>Which of the following statements about these libraries are true?  (Select all that apply.)",
    "choice_a": "Open-source libraries generally have higher security risks than commercial libraries.",
    "choice_b": "Open-source libraries should not be used unless absolutely necessary.",
    "choice_c": "Open-source libraries should be tested for security vulnerabilities.",
    "choice_d": "Open-source library use within the organization should be tracked.",
    "correct_answer": [
      "C",
      "D"
    ],
    "explanation": "Open-source libraries are commonly used by software developers and do not necessarily pose a higher risk than commercially available libraries.  The use of these libraries should be tracked and subject to regular security testing, as should any other closed-source library use.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      961,
      670,
      618,
      816,
      962
    ],
    "source": ""
  },
  {
    "id": 3845,
    "question": "What portion of the software configuration management (SCM) process ensures that changes to software versions are made in accordance with the change control and configuration management policies?",
    "choice_a": "Configuration Control",
    "choice_b": "Configuration Identification",
    "choice_c": "Configuration Status Accounting",
    "choice_d": "Configuration Audit",
    "correct_answer": "A",
    "explanation": "The configuration control process ensures that changes to software versions are made in accordance with the change control and configuration management policies. Updates can be made only from authorized distributions in accordance with those policies.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      624,
      1032,
      628,
      623,
      621
    ],
    "source": ""
  },
  {
    "id": 3846,
    "question": "Which one of the following is a cloud-based software delivery model that allows users to access email via a web browser?",
    "choice_a": "Infrastructure as a Service (IaaS)",
    "choice_b": "Platform as a Service (PaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Public",
    "correct_answer": "C",
    "explanation": "The SaaS service model provides services such as email available via a web browser. IaaS provides the infrastructure (such as servers) and PaaS provides a platform (such as an operating system and application installed on a server). Public is a deployment method, not service model.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 3847,
    "question": "Which database principle ensures that transactions execute in an all-or-nothing fashion?",
    "choice_a": "Atomicity",
    "choice_b": "Consistency",
    "choice_c": "Isolation",
    "choice_d": "Durability",
    "correct_answer": "A",
    "explanation": "The atomicity of database transactions requires transaction execution in an all-or-nothing fashion. If any part of the transaction fails, the entire transaction is rolled back. The isolation principle states that two transactions operating on the same data must be temporarily separated from each other such that one does not interfere with the other.  The consistency principle says that the database must always be in a state that complies with the database model's rules.  The durability principle says that transactions committed to the database must be preserved.  Together, these four principles are known as the ACID model.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      632,
      811,
      633,
      813,
      840
    ],
    "source": ""
  },
  {
    "id": 3848,
    "question": "What software development methodology focuses on the iterative creation of new prototypes?",
    "choice_a": "Software Capability Maturity Model",
    "choice_b": "Waterfall model",
    "choice_c": "Software Assurance Maturity Model",
    "choice_d": "Spiral model",
    "correct_answer": "D",
    "explanation": "The spiral model seeks to iteratively produce new prototypes of a system during the development process.  The waterfall model allows the development process to return only to the immediately preceding phase of development at any given time.  The SW-CMM and SAMM are maturity models that assess an organization's software development practices and are not development methodologies.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      622,
      640,
      1033,
      1034,
      621
    ],
    "source": ""
  },
  {
    "id": 3849,
    "question": "Which software development life cycle model allows for multiple iterations of the development process, resulting in multiple prototypes, each produced according to a complete design and testing process?",
    "choice_a": "Software Capability Maturity model",
    "choice_b": "Waterfall model",
    "choice_c": "Development cycle",
    "choice_d": "Spiral model",
    "correct_answer": "D",
    "explanation": "The spiral model allows developers to repeat iterations of another life cycle model (such as the waterfall model) to produce a number of fully tested prototypes.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      622,
      640,
      621,
      626,
      1034
    ],
    "source": ""
  },
  {
    "id": 3850,
    "question": "Which of the following best describes change management?",
    "choice_a": "Preventing changes to systems",
    "choice_b": "Ensuring only approved changes are implemented",
    "choice_c": "Ensuring that changes do not require too many resources to complete",
    "choice_d": "Auditing privilege access",
    "correct_answer": "B",
    "explanation": "The goal of change management is to ensure that changes are made to systems in an orderly manner, not to prevent changes.  It does verify that all changes are properly tested and approved prior to implementation. Change management programs review and approve changes but do not prioritize their use of development resources.  Change management doesn't perform any type of auditing of access controls.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      624,
      640,
      1032,
      1030,
      833
    ],
    "source": ""
  },
  {
    "id": 3851,
    "question": "Gwen is developing a security awareness and training program for software developers. <br>What business function is she engaging in under the Software Assurance Maturity Model (SAMM)?",
    "choice_a": "Governance",
    "choice_b": "Design",
    "choice_c": "Verification",
    "choice_d": "Operations",
    "correct_answer": "A",
    "explanation": "Education and guidance programs, including training & awareness and organization & culture are components of the Governance function under the Software Assurance Maturity Model (SAMM).",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      623,
      640,
      621,
      625,
      622
    ],
    "source": ""
  },
  {
    "id": 3852,
    "question": "Wendy is analyzing an attack that took place against a web-based discussion forum run by her organization.  She discovered that the attacker submitted a post containing embedded code so that future visitors to the site were redirected to a malicious site. <br>What type of attack most likely took place?",
    "choice_a": "Buffer overflow",
    "choice_b": "Directory traversal",
    "choice_c": "Cross-site scripting",
    "choice_d": "SQL injection",
    "correct_answer": "C",
    "explanation": "A cross-site scripting (XSS) attack exploits scripting flaws in a targeted website. There are many ways by which XSS can be implemented; one technique involves submitting script content with a discussion forum posting. The script content will then be processed each time another visitor views the posting from the attacker. The injected script code can cause additional browser pop-ups leading to URLs of the attacker's choosing.",
    "topic_id": 8,
    "practice_test_id": 6,
    "related_articles": [
      1010,
      661,
      659,
      665,
      824
    ],
    "source": ""
  },
  {
    "id": 3853,
    "question": "Vulnerabilities and risks are evaluated based on their threats against which of the following?",
    "choice_a": "One or more of the CIA Triad principles",
    "choice_b": "Data usefulness",
    "choice_c": "Due care",
    "choice_d": "Extent of liability",
    "correct_answer": "A",
    "explanation": "Vulnerabilities and risks are evaluated based on their threats against one or more of the CIA Triad principles. Data usefulness is an element in determining asset value, but not as a direct concern of vulnerabilities and risk. Due care is practicing the individual activities that maintain the due diligence effort (which is protecting the interest of the organization). Extent of liability is a legal issue that contributes to the amount of harm a threat could cause.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      3,
      41,
      20,
      1,
      6
    ],
    "source": ""
  },
  {
    "id": 3854,
    "question": "Security management planning ensures proper creation, implementation, and enforcement of a security policy. Security management planning aligns the security functions to the strategy, goals, mission, and objectives of the organization. <br>What type of planning or security management should be the primary tool used to address the security concerns of acquisitions, divestitures, and governance committees?",
    "choice_a": "Disaster recovery planning",
    "choice_b": "Security governance",
    "choice_c": "Standards and baselines",
    "choice_d": "Trusted recovery planning",
    "correct_answer": "B",
    "explanation": "Security governance should include acquisitions, divestitures, and governance committees. Disaster recovery planning focuses on preventing interruptions and recovering from disasters. Standards and baselines focus on establishing mandatory configuration requirements for systems. Trusted recovery planning focuses on restoring the assurance of a system after a failure.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      32,
      14,
      21,
      11,
      20
    ],
    "source": ""
  },
  {
    "id": 3855,
    "question": "Applying risk-based management concepts to the supply chain is a means to ensure a more robust and successful security strategy in organizations of all sizes. <br>Which of the following is a valid definition for supply chain risk management (SCRM)?",
    "choice_a": "The system of external entity oversight that may be mandated by law, regulation, industry standards, contractual obligation, or licensing requirements",
    "choice_b": "The process of reading the exchanged materials and verifying them against standards and expectations",
    "choice_c": "A means to ensure that all the vendors or links in the supply chain are reliable, trustworthy, reputable organizations that disclose their practices and security requirements to their business partners",
    "choice_d": "A security control established by linking an individual to the activities of an online identity through the security services and mechanisms of auditing, authorization, authentication, and identification",
    "correct_answer": "C",
    "explanation": "Supply chain risk management (SCRM) is means to ensure that all the vendors or links in the supply chain are reliable, trustworthy, reputable organizations that disclose their practices and security requirements to their business partners. Third-party governance is the system of external entity oversight that may be mandated by law, regulation, industry standards, contractual obligation, or licensing requirements. Documentation review is the process of reading the exchanged materials and verifying them against standards and expectations. Accountability is established by linking an individual to the activities of an online identity through the security services and mechanisms of auditing, authorization, authentication, and identification.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      27,
      116,
      13,
      31,
      20
    ],
    "source": ""
  },
  {
    "id": 3856,
    "question": "While establishing a relationship with a commodity vendor, you are working through your organization's procedure for supply chain risk management (SCRM). One of the steps includes defining and establishing minimum security requirements for the third party. <br>Where should these requirements be documented?",
    "choice_a": "SOC",
    "choice_b": "MOU",
    "choice_c": "SLA",
    "choice_d": "NDA",
    "correct_answer": "C",
    "explanation": "The primary place where the minimum-security requirements for a third-party should be documented is in the contract or service-level agreement (SLA) established with that vendor. A business partners agreement (BPA) and interconnection security agreement (ISA) could also be viable answers (although not offered in this question). Service Organization Control (SOC) reports are not the appropriate place to define minimum security requirements for a third-party, because an SOC is a review of the existing security of the entity. A memorandum of understanding (MOU) is not the optimal place to define minimum security requirements because it is only a statement of intentions and not a legal contract. A nondisclosure agreement (NDA) is not an appropriate location to define minimum security requirements for a third-party.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      38,
      81,
      1045,
      35,
      48
    ],
    "source": ""
  },
  {
    "id": 3857,
    "question": "The HR department has requested that you draft a description of the work responsibilities that a recently fired coworker was performing. This information is needed to guide the hiring process to locate a proper replacement. <br>Which of the following is not an element of a job description?",
    "choice_a": "Necessary roles and responsibilities",
    "choice_b": "Security classification",
    "choice_c": "Type and extent of access needed",
    "choice_d": "Promotion opportunities",
    "correct_answer": "D",
    "explanation": "Promotion opportunities involve an entire organization, not a specific job, and thus are not an element of a job description. A job description for any position within an organization should address relevant security issues. You must consider items such as whether the position requires the handling of sensitive material or access to classified information. In effect, the job description defines the roles to which an employee needs to be assigned to perform their work tasks. The job description should define the type and extent of access the position requires on the secured network. Once these issues have been resolved, assigning a security classification to the job description is fairly standard.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      33,
      676,
      17,
      37,
      11
    ],
    "source": ""
  },
  {
    "id": 3858,
    "question": "While reviewing the company firing policy and related procedures, you notice a suggestion for an activity that seems out of place. <br>Which of the following is not an element of a secure termination process and thus should be removed from the termination policy?",
    "choice_a": "Onboarding",
    "choice_b": "Returning company property",
    "choice_c": "Having a witness for the exit interview",
    "choice_d": "Escorting off premises",
    "correct_answer": "A",
    "explanation": "Onboarding is used to bring a new employee into the organization, not for terminating an employee. An off-boarding process would be appropriate for termination. An exit interview, a standard element of a termination process, typically includes reminding the ex-employee about their NDA obligations and the return of company property and organization-specific identification, access, or security badges as well as devices, cards, keys, and access tokens. A termination process should take place with at least one witness, preferably a higher-level manager and/or a security guard. At the end of the termination process, the ex-employee should be escorted off the premises and not allowed to return to their work area without an escort for any reason.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      68,
      37,
      35,
      40,
      17
    ],
    "source": ""
  },
  {
    "id": 3859,
    "question": "Which of the following is a valid statement in regard to risk management?  (Select all that apply.)",
    "choice_a": "Risk awareness is evaluation of countermeasures, safeguards, and security controls using a cost/benefit analysis; adjusting findings based on other conditions, concerns, priorities, and resources; and providing a proposal of response options in a report to senior management.",
    "choice_b": "Risk management is composed of two primary elements: risk assessment and risk response.",
    "choice_c": "Risk response is the effort to increase the knowledge of risks within an organization.",
    "choice_d": "Risk assessment or risk analysis is the examination of an environment for risks, evaluating each threat event as to its likelihood of occurring and the severity of the damage it would cause if it did occur, and assessing the cost of various countermeasures for each risk.",
    "correct_answer": [
      "B",
      "D"
    ],
    "explanation": "There are two correct statements from this list: (B) Risk management is composed of two primary elements: risk assessment and risk response; and (D) Risk assessment or risk analysis is the examination of an environment for risks, evaluating each threat event as to its likelihood of occurring and the severity of the damage it would cause if it did occur, and assessing the cost of various countermeasures for each risk. The other two options are incorrect. Their corrected version are: (A) Risk response is evaluation of countermeasures, safeguards, and security controls using a cost/benefit analysis; adjusting findings based on other conditions, concerns, priorities, and resources; and providing a proposal of response options in a report to senior management; and (C) Risk awareness is the effort to increase the knowledge of risks within an organization.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      41,
      70,
      46,
      44,
      42
    ],
    "source": ""
  },
  {
    "id": 3860,
    "question": "You've performed a standard quantitative risk analysis on a specific threat/vulnerability/risk relation. You select a possible countermeasure. <br>When performing the calculations again, which of the following factors will change?",
    "choice_a": "Exposure factor",
    "choice_b": "Threat focus",
    "choice_c": "Asset value",
    "choice_d": "Annualized rate of occurrence",
    "correct_answer": "D",
    "explanation": "A countermeasure primary affects the annualized rate of occurrence (ARO), because the countermeasure is designed to prevent (or mitigate or reduce) the occurrence of the risk, thus reducing its frequency per year. It is possible that a countermeasure will also reduce the exposure factor (EF) or the amount of loss per incident, but this is not as common as ARO reduction. When performing post-countermeasure calculations, the threat focus should not change; otherwise, the entire process would need to be started again. The asset value would not change when performing post-countermeasure calculations.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      45,
      875,
      48,
      935,
      691
    ],
    "source": ""
  },
  {
    "id": 3861,
    "question": "You are concerned about the risk that a hurricane poses to your corporate headquarters in south Florida. The building itself is valued at $15 million. After consulting with the National Weather Service (NWS), you determine that there is a 10 percent likelihood that a hurricane will strike over the course of a year. You hired a team of architects and engineers who determined that the average hurricane would destroy approximately 50 percent of the building. <br>What is the annualized rate of occurrence (ARO)?",
    "choice_a": "5 percent",
    "choice_b": "10 percent",
    "choice_c": "50 percent",
    "choice_d": "100 percent",
    "correct_answer": "B",
    "explanation": "The ARO is the probability that a given disaster will strike over the course of a year. According to the experts quoted in the scenario, this chance is 10 percent. The other options are incorrect. (A) and (D) are not relevant to this scenario. (C) is the exposure factor (EF).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      45,
      85,
      83,
      96,
      82
    ],
    "source": ""
  },
  {
    "id": 3863,
    "question": "Which of the following are true statements?  (Select all that apply.)",
    "choice_a": "Risk reporting involves the production of a risk report and a presentation of that report to the interested/relevant parties.",
    "choice_b": "A risk register or risk log is a document that inventories all of the identified risks to an organization or system or within an individual project.",
    "choice_c": "A risk license can serve as a project management document to track completion of risk response activities as well as a historical record of risk management over time.",
    "choice_d": "A risk matrix or risk heat map is a form of risk assessment that is performed on a basic graph or chart.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "There are three correct and true statements in this list of options: (A) Risk reporting involves the production of a risk report and a presentation of that report to the interested/relevant parties; (B) A risk register or risk log is a document that inventories all of the identified risks to an organization or system or within an individual project; and (D) A risk matrix or risk heat map is a form of risk assessment that is performed on a basic graph or chart. The remaining statement (C) is incorrect. There is no such term as risk license. The corrected version of that statement is: A risk register can serve as a project management document to track completion of risk response activities as well as a historical record of risk management over time.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      49,
      26,
      42,
      70,
      44
    ],
    "source": ""
  },
  {
    "id": 3864,
    "question": "Risk analysis identifies risks, quantifies the impact of threats, and aids in budgeting for security. It helps integrate the needs and objectives of the security policy with the organization's business goals and intentions. The risk analysis/risk assessment is a \"point in time\" metric. <br>What is the implication of this statement?",
    "choice_a": "Any issues not resolved by the deadline can be considered accepted.",
    "choice_b": "Security is always changing thus continuous improvement is required.",
    "choice_c": "Security should be maintained at a constant level in order to defend against identified threats.",
    "choice_d": "Future predictions of EF and ARO ensure that no unexpected loss events will take place.",
    "correct_answer": "B",
    "explanation": "The implication of this statement is that security is always changing thus continuous improvement is required. The other options are incorrect. (A) A risk is only considered accepted if a formal evaluation makes that determination and it is agreed to my upper management. A deadline of completing risk management operations does not determine what is or is not acceptable risk. (C) While security is initially implemented based on identified threats, threats and risks and vulnerabilities change over time and thus security should be adjusted as needs arise, not forced to be maintained at a constant level. (D) The future predictions of EF and ARO are used only to establish criticality prioritization, not to ensure against unexpected loss events. It is not possible to accurately predict the future, even when performing risk analysis.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      53,
      41,
      70,
      2,
      44
    ],
    "source": ""
  },
  {
    "id": 3865,
    "question": "Mary receives several calls asking to talk to Sue. But since Mary doesn't know Sue, she asks if she can help them instead. The caller asks for odd information, but as soon as Mary starts to question why they want to know, they hang up. Mary mentions this to other coworkers, and many of them report getting similar calls. <br>What is taking place at this organization?",
    "choice_a": "Social networking attacks",
    "choice_b": "Smishing",
    "choice_c": "Familiarity",
    "choice_d": "Resource exhaustion",
    "correct_answer": "C",
    "explanation": "This is an example of a familiarity social engineering pretext attack where the victim, Mary, is asked about a coworker Sue (who doesn't actually exist, but Mary does not know that initially). Familiarity or liking as a social engineering principle attempts to exploit a person's native trust in that which is familiar. This could include claiming to know a coworker even when that person doesn't exist. This is designed to put Mary in a mindset that might be more willing to help the caller by providing answers to questions, since the person they asked to talk to is either not there or unknown. This is not an example of a social networking or social media attack. Smishing would involve SMS text messaging, not phone calls. This attack is not involving resource exhaustion\u2014that would be a denial of service (DoS).",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      56,
      61,
      55,
      71,
      58
    ],
    "source": ""
  },
  {
    "id": 3866,
    "question": "Your manager is concerned that the business impact analysis recently completed by the BCP team doesn't adequately take into account the loss of goodwill among customers that might result from a particular type of disaster. <br>Where should items like this be addressed?",
    "choice_a": "Continuity strategy",
    "choice_b": "Quantitative analysis",
    "choice_c": "Likelihood assessment",
    "choice_d": "Qualitative analysis",
    "correct_answer": "D",
    "explanation": "The qualitative analysis portion of the business impact analysis (BIA) allows you to introduce intangible concerns, such as loss of customer goodwill, into the BIA planning process. Quantitative analysis uses numeric ratings to address tangible risks, not intangible ones.  The likelihood assessment is a component of a risk assessment that determines the likelihood that a risk will materialize, not the impact of intangible issues such as the loss of customer goodwill.  The continuity strategy defines how the organization will attempt to withstand disruptions and does not address the impact of intangible issues such as the loss of customer goodwill.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      83,
      87,
      96,
      44,
      70
    ],
    "source": ""
  },
  {
    "id": 3867,
    "question": "You are developing a business continuity plan for your organization and want to document a set of guiding principles for the planning process. <br>What objective should have the highest priority in your plan?",
    "choice_a": "Data restoration",
    "choice_b": "Personal safety",
    "choice_c": "Containing damage",
    "choice_d": "Activating an alternate site",
    "correct_answer": "B",
    "explanation": "The primary concern in any business continuity or disaster recovery effort is ensuring personal safety for everyone involved.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      89,
      93,
      74,
      79,
      78
    ],
    "source": ""
  },
  {
    "id": 3868,
    "question": "Tonya is designing a security awareness program for staff at a hospital. <br>Which one of the following privacy compliance obligations would be most relevant to include in her training program?",
    "choice_a": "HIPAA",
    "choice_b": "COPPA",
    "choice_c": "ECPA",
    "choice_d": "GLBA",
    "correct_answer": "A",
    "explanation": "Although it is always possible that the organization may encounter any of these privacy regulations, the most relevant is the Health Insurance Portability and Accountability Act (HIPAA). HIPAA covers protected health information and almost certainly covers much of the work performed at the hospital. The Children's Online Privacy Protection Act (COPPA) covers the personal information of children. The Electronic Communications Privacy Act (ECPA) protects against eavesdropping on electronic communications. The Gramm\u2013Leach\u2013Bliley Act (GLBA) regulates financial institutions, not healthcare providers.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      105,
      106,
      1046,
      65,
      118
    ],
    "source": ""
  },
  {
    "id": 3869,
    "question": "Christopher recently received word that his application for a trademark was approved by the U.S. Patent and Trademark Office (USPTO). <br>What symbol should he use next to the name to indicate its protected status?",
    "choice_a": "\u00a9",
    "choice_b": "\u00ae",
    "choice_c": "\u2122",
    "choice_d": "\u2020",
    "correct_answer": "B",
    "explanation": "The \u00ae symbol is reserved for trademarks that have received official registration status by the U.S. Patent and Trademark Office. The \u2122 symbol would be used before receiving USPTO approval. The \u00a9 symbol is used to represent a copyright. The \u2020 symbol is not associated with intellectual property protections.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      986,
      985,
      987,
      103,
      104
    ],
    "source": ""
  },
  {
    "id": 3870,
    "question": "Jeremy is tasked with writing a data policy for the company where he works. He wants to stress the importance of accurate data classification identification. <br>Which one of the following identifies the primary purpose of information classification processes?",
    "choice_a": "Define the requirements for protecting sensitive data.",
    "choice_b": "Define the requirements for backing up data.",
    "choice_c": "Define the requirements for storing data.",
    "choice_d": "Define the requirements for transmitting data.",
    "correct_answer": "A",
    "explanation": "A primary purpose of information classification processes is to identify security classifications for sensitive data and define the requirements to protect it. Information classification processes will typically include requirements to protect sensitive data at rest (in backups and stored on media), but not requirements for backing up and storing all data. Similarly, information classification processes will typically include requirements to protect sensitive data in transit but not necessarily all data in transit.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      143,
      124,
      122,
      125,
      128
    ],
    "source": ""
  },
  {
    "id": 3871,
    "question": "Administrators regularly back up data from servers in the data center onto magnetic tapes. They regularly delete data on some of the tapes and place the tapes back into service to be reused. <br>Which of the following is the best way to delete the data on these tapes?",
    "choice_a": "Degaussing",
    "choice_b": "Clearing",
    "choice_c": "Purging",
    "choice_d": "Destruction",
    "correct_answer": "A",
    "explanation": "Degaussing is the best way to delete data on magnetic media before reusing it. Clearing writes a series of characters over the media to overwrite the original data. Purging repeats the clearing process multiple times. Clearing and purging are effective methods of removing data on disk drives, but these methods will reduce the lifetime of tapes. Destruction of the tapes will remove the data, but the tapes can't be placed back into service.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      1026,
      129,
      130,
      144,
      133
    ],
    "source": ""
  },
  {
    "id": 3872,
    "question": "A small business has decided to outsource payroll tasks. The business will pass relevant data to the payroll company, and the payroll will handle all payroll functions for the company. In this scenario, which of the following roles best describes the small business?",
    "choice_a": "Data controller",
    "choice_b": "Data subject",
    "choice_c": "Data processor",
    "choice_d": "Data custodian",
    "correct_answer": "A",
    "explanation": "The small business is the data controller. The data controller identifies what data to pass to the data processor and how that data should be processed. The payroll company is fulfilling the role of data processor by processing the payroll data. A data subject is the employee whose personal information is being processed in order to generate payment. A data custodian is responsible for the day-to-day maintenance of data.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      988,
      139,
      989,
      990,
      143
    ],
    "source": ""
  },
  {
    "id": 3873,
    "question": "A major hurricane hit your geographical area, and your company's building flooded with water. As a result, several servers failed, and backup tapes were unusable. You are updating the data policy and want to ensure this data loss cannot happen again. Of the following choices, what would you include?",
    "choice_a": "Perform backups more often.",
    "choice_b": "Store backups offsite.",
    "choice_c": "Move the company location.",
    "choice_d": "Implement a cloud access security broker.",
    "correct_answer": "B",
    "explanation": "At least one current set of backups should be stored offsite. In a geographical location susceptible to natural disasters, the backups should be stored far enough away that the same disaster won't destroy the backups. Performing backups more often won't help if they are all stored in the same location. Moving the company location may prevent a loss from a hurricane, but a copy of backups should still be stored offsite. A cloud access security broker (CASB) is a security mechanism to protect cloud resources, but a CASB is unrelated to this scenario.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      132,
      133,
      125,
      124,
      138
    ],
    "source": ""
  },
  {
    "id": 3874,
    "question": "You are updating the data policy at your company, and you want to include retention requirements related to sensitive data. <br>Which of the following is the best determining factor for maintaining sensitive data?",
    "choice_a": "Data remanence",
    "choice_b": "Record retention",
    "choice_c": "Data diddling",
    "choice_d": "Data mining",
    "correct_answer": "B",
    "explanation": "Record retention policies define the amount of time to keep any data, including logs. Data remanence is data that remains on media after being deleted. Data diddling refers to the modification of data before or during data entry, resulting in incorrect or corrupted data. Data mining refers to extracting meaningful knowledge from large amounts of data.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      133,
      143,
      120,
      851,
      126
    ],
    "source": ""
  },
  {
    "id": 3875,
    "question": "A new CIO has directed that a security control baseline be selected for all servers in the network holding sensitive data. <br>Which of the following best describes the purpose of a security control baseline?",
    "choice_a": "A listing of security controls that an organization must implement",
    "choice_b": "A listing of security controls that ensures a maximum level of security",
    "choice_c": "A listing of security controls that provide a minimum level of security",
    "choice_d": "A listing of applied security controls",
    "correct_answer": "C",
    "explanation": "A baseline is a listing of security controls that provide a minimum level of security. Organizations can tailor a baseline to meet their needs. The baseline is a starting point, and it does not ensure maximum security. A baseline provides a listing of controls an organization can apply, but it isn't necessarily a listing of applied controls.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      140,
      141,
      142,
      124,
      125
    ],
    "source": ""
  },
  {
    "id": 3876,
    "question": "Your organization recently suffered a data breach. You are reviewing your organization's data policy to see if it addresses protections that could have thwarted this attack. <br>Which of the following actions will provide the <italic>best</italic> protection for data at rest?",
    "choice_a": "Tokenization",
    "choice_b": "Marking",
    "choice_c": "Encryption",
    "choice_d": "Destruction",
    "correct_answer": "C",
    "explanation": "Encryption protects data at rest (and data in transit). Tokenization replaces some data with tokens or artificial identifiers, but it's not used with all data, so it won't protect data at rest. Marking data and assets makes them easier to identify, but marking doesn't protect data at rest. The destruction of the data will eliminate data at the end of its lifecycle, but data should be used when it is still needed.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      122,
      124,
      144,
      702,
      136
    ],
    "source": ""
  },
  {
    "id": 3877,
    "question": "Your company is planning to process credit cards on a new e-commerce website. Management wants to implement controls recommended by a well-known standard. <br>Which of the following should they select?",
    "choice_a": "GDPR",
    "choice_b": "PCI DSS",
    "choice_c": "NIST SP-800-88",
    "choice_d": "NIST SP-800-122",
    "correct_answer": "B",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) is an example of an external standard, and it mandates the use of several specific controls for organizations that want to process credit cards. The General Data Protection Regulation (GDPR) provides guidance on protecting privacy. NIST documents generally apply to government agencies, though civilian organizations can use them. NIST SP 800-88 provides guidelines for media sanitization. NIST SP 800-122 is theGuide to Protecting the Confidentiality of Personally Identifiable Information (PII).",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      142,
      126,
      120,
      140,
      125
    ],
    "source": ""
  },
  {
    "id": 3878,
    "question": "Which of the following security controls cannot be reversed and is the <italic>best</italic> choice to permanently protect personal information in a dataset transferred out of the EU?",
    "choice_a": "Pseudonymization",
    "choice_b": "Encryption",
    "choice_c": "Tokenization",
    "choice_d": "Randomized masking",
    "correct_answer": "D",
    "explanation": "Randomized masking is one of many anonymization methods and is the best choice of the given answers. When done correctly, it cannot be reversed to discover the original data. The EU GDPR does not apply to effectively anonymized data. All of the other options use methods that can be reversed. Pseudonymization replaces some data with an identifier, such as apseudonym. An external dataset holds the original data along with the pseudonym so that the original dataset can be re-created. Encryption scrambles the data, making it unreadable, but decryption returns the data to its original state. Tokenization replaces some data with tokens or aliases. A third party typically keeps the original data along with the token, so the original data can still be used.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      137,
      136,
      139,
      143,
      142
    ],
    "source": ""
  },
  {
    "id": 3879,
    "question": "Which of the following <italic>best</italic> describes the scoping process?",
    "choice_a": "Selecting compensating controls",
    "choice_b": "Identifying common controls",
    "choice_c": "Assigning different values for a control",
    "choice_d": "Removing controls from a suggested baseline",
    "correct_answer": "D",
    "explanation": "The scoping process removes controls from a list of controls from a suggested baseline. All of the other options are part of the tailoring process but not part of the scoping process.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      141,
      140,
      698,
      142,
      143
    ],
    "source": ""
  },
  {
    "id": 3880,
    "question": "Ron is implementing an asymmetric encryption algorithm for his department, which has eight team members. <br>How many keys are required to fully implement an asymmetric encryption algorithm with eight participants?",
    "choice_a": "8",
    "choice_b": "16",
    "choice_c": "28",
    "choice_d": "56",
    "correct_answer": "B",
    "explanation": "The number of keys required to fully implement asymmetric encryption is computed using the formula 2n. This is based on the fact that most asymmetric encryption systems are public key cryptography. In public key cryptography, each participant needs a key pair set composed of a public key and a private key. Thus, two keys are needed per subject. In this case, 2 * 8 = 16.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      167,
      154,
      198,
      176,
      200
    ],
    "source": ""
  },
  {
    "id": 3881,
    "question": "Temporary internet files or the internet files cache is the temporary storage of files downloaded from internet sites that are being held by the client's utility (typically a browser) for current and possibly future use. <br>What type of attack is possible if an adversary is able to gain access to this cache?  (Select all that apply.)",
    "choice_a": "Split-response attack",
    "choice_b": "Cache poisoning",
    "choice_c": "Identity theft",
    "choice_d": "DOM XSS",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "The temporary internet files cache if accessed by an adversary could result in a split-response attack, cache poisoning, and/or DOM XSS. Split-response attacks can cause the client to download content and store it in the cache that was not an intended element of a requested web page. Once files have been poisoned in the cache, then even when a legitimate web document calls on a cached item, the malicious item will be activated. DOM XSS may be able to access and use locally cached files to execute malicious code or exfiltrate data. Internet files cache access will not likely result in identity theft. Identity theft is the act of stealing someone's identity. Cache access might allow for some forms of spoofing, masquerading, or impersonation of websites, but it is unlikely to contain enough information about the person using the system to be able to perform actual identity theft.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      246,
      187,
      213,
      215,
      208
    ],
    "source": ""
  },
  {
    "id": 3882,
    "question": "Tina is selecting a cryptographic algorithm that will be used in a parallelized environment to distribute the workload of encryption and decryption among multiple processors. <br>What cryptographic mode would best support this computing model?",
    "choice_a": "Electronic Code Book",
    "choice_b": "Cipher Block Chaining",
    "choice_c": "Cipher Feedback",
    "choice_d": "Counter",
    "correct_answer": "D",
    "explanation": "Counter mode allows you to break an encryption or decryption operation into multiple independent steps. This makes Counter mode well suited for use in parallel computing.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      165,
      147,
      250,
      255,
      151
    ],
    "source": ""
  },
  {
    "id": 3883,
    "question": "Flo and Ricky are sending messages to each other using an asymmetric encryption algorithm. Flo wants to send Ricky a private message. <br>What key should she use to encrypt it?",
    "choice_a": "Flo's public key",
    "choice_b": "Flo's private key",
    "choice_c": "Ricky's public key",
    "choice_d": "Ricky's private key",
    "correct_answer": "C",
    "explanation": "Flo should encrypt the message with Ricky's public key. This will allow Ricky to decrypt the message with his private key.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      176,
      167,
      200,
      198,
      184
    ],
    "source": ""
  },
  {
    "id": 3884,
    "question": "Which of the following algorithms/protocols provides inherent support for nonrepudiation?",
    "choice_a": "HMAC",
    "choice_b": "ECDSA",
    "choice_c": "MD5",
    "choice_d": "SHA-1",
    "correct_answer": "B",
    "explanation": "The Elliptic Curve Digital Signature Algorithm (ECDSA) is the only one of the algorithms listed here that supports true digital signatures, providing integrity verification and nonrepudiation. HMAC allows for the authentication of message digests but supports only integrity verification. MD5 and SHA-1 are message digest creation algorithms and can be used in the generation of digital signatures, but they provide no guarantees of integrity or nonrepudiation in and of themselves.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      175,
      178,
      177,
      168,
      176
    ],
    "source": ""
  },
  {
    "id": 3885,
    "question": "What type of attack can be used against cryptographic algorithms that do not incorporate temporal protections?",
    "choice_a": "Chosen plaintext attack",
    "choice_b": "Meet-in-the-middle attack",
    "choice_c": "Man-in-the-middle attack",
    "choice_d": "Replay attack",
    "correct_answer": "D",
    "explanation": "In a replay attack, the malicious individual intercepts an encrypted message between two parties (often a request for authentication) and then later replays the captured message to open a new session. Challenge-response protocols and the use of ephemeral session keys also provide protection against replay attacks.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      195,
      187,
      153,
      169,
      199
    ],
    "source": ""
  },
  {
    "id": 3886,
    "question": "James is communicating with a remote server using public key cryptography. <br>Which of the following items should he verify before relying on the digital certificate provided by the server?  (Select all that apply.)",
    "choice_a": "The digital signature of the CA is authentic.",
    "choice_b": "The certificate has not expired.",
    "choice_c": "The certificate has not been revoked.",
    "choice_d": "The sender's public key is valid.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "James should verify that the digital signature is authentic, that the certificate has not expired, and that the certificate has not been revoked. Once he has verified all of these things and makes the decision to trust the certificate, he may then rely on the sender's public key contained within the certificate. He does not need to validate the public key prior to trusting the certificate.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      181,
      179,
      175,
      198,
      200
    ],
    "source": ""
  },
  {
    "id": 3887,
    "question": "Slayde and Remi are both at work performing their assigned work tasks in their respective work areas. Slayde works in the testing/piloting/lab area, where new product prototypes are evaluated and tested. Remi works in the sales area, where she manages contracts with numerous distributors. A fire breaks out in another part of the building, triggering the fire alarm. Remi is able to follow the escape plan and exits the building easily along with her coworkers. However, Slayde discovers that when he tries to leave the test area, the door won't open. <br>What is the issue here?",
    "choice_a": "Fail-safe vs. fail-secure",
    "choice_b": "Open source vs. closed source",
    "choice_c": "Biba vs. Bell\u2013LaPadula",
    "choice_d": "Having an ATO vs. using noncompliant systems",
    "correct_answer": "A",
    "explanation": "This scenario demonstrates that certain areas of a building may be deemed highly critical where assets are to be protected in priority over personnel. These areas may use fail-secure doors, which will stay closed and locked during adverse conditions. Fail-safe doors allow for easy egress in the event of adverse conditions as they prioritize personnel safety. Option B is incorrect because this is not a situation dealing with open vs. closed source\u2014whether or not the source code of a program is accessible to third parties (open) vs. being protected and restricted (closed). Option C is incorrect because this scenario is not a variation between the security models of Biba and Bell\u2013LaPadula. Option D is incorrect because this is not a scenario where an Authorization to Operate (ATO) is relevant or where noncompliant systems are in use. Also, there is no indication of what standard, framework, or regulation a system is not compliant with.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      205,
      324,
      229,
      228,
      213
    ],
    "source": ""
  },
  {
    "id": 3888,
    "question": "Which of the following is not an element defined under the Clark\u2013Wilson model?",
    "choice_a": "Constrained data item",
    "choice_b": "Transformation procedures",
    "choice_c": "Redundant commit statement",
    "choice_d": "Integrity verification procedure",
    "correct_answer": "C",
    "explanation": "A redundant commit statement is not associated with the Clark\u2013Wilson model; it is instead an element in database replication. The Clark\u2013Wilson model does define the constrained data item, transformation procedures, and integrity verification procedure.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      219,
      217,
      216,
      220,
      218
    ],
    "source": ""
  },
  {
    "id": 3889,
    "question": "You have three applications running on a dual-core single-processor system that supports multitasking. One of those applications is a word processing program that is managing two threads simultaneously. The other two applications are using only one thread of execution. <br>How many application threads are running on the processor at any given time?",
    "choice_a": "One",
    "choice_b": "Two",
    "choice_c": "Three",
    "choice_d": "Four",
    "correct_answer": "B",
    "explanation": "A dual-core single-processor system can operate on two threads at a time (one by each core). There would be a total of four application threads in this scenario (ignoring any threads created by the OS), but the OS would be responsible for deciding which single thread is running on the processor at any given time. A single-core single processor system would be limited to one thread executing at a time. Other multicore and/or multiprocessor configurations would be needed to execute three or four (or more) threads simultaneously.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      991,
      992,
      245,
      250,
      256
    ],
    "source": ""
  },
  {
    "id": 3890,
    "question": "A DCE typically includes an interface definition language (IDL). An IDL is a language used to define the interface between client and server processes or objects in a distributed system. <br>Which of the following are considered examples of DCE IDL?  (Select all that apply.)",
    "choice_a": "RPC",
    "choice_b": "SAML",
    "choice_c": "CORBA",
    "choice_d": "OCSP",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "There are numerous examples DCE IDL or frameworks, such as remote procedure calls (RPC), the Common Object Request Broker Architecture (CORBA), and the Distributed Component Object Model (DCOM). The other options are incorrect. Security Assertion Markup Language (SAML) is used for authentication federation. Online Certificate Status Protocol (OCSP) is used to check on the revocation status of a certificate. Structured Query Language (SQL) is a means to interact with a database management system and its hosted databases.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      254,
      255,
      187,
      191,
      301
    ],
    "source": "",
    "choice_e": "DCOM",
    "choice_f": "SQL"
  },
  {
    "id": 3891,
    "question": "Applications developed on __________ are similar to microservices, and each function is crafted to operate independently and autonomously. This allows each function to be independently scaled by the CSP. With this technology, the functions run only when called and then terminate when their operations are completed.",
    "choice_a": "JavaScript",
    "choice_b": "AMP",
    "choice_c": "Smart devices",
    "choice_d": "Serverless architecture",
    "correct_answer": "D",
    "explanation": "Applications developed on serverless architecture are similar to microservices, and each function is crafted to operate independently and autonomously. This allows each function to be independently scaled by the CSP. With this technology, the functions run only when called and then terminate when their operations are completed. The other options are incorrect. JavaScript is the most widely used scripting language in the world and is embedded into HTML documents using <br><img src=\"/question_assets/CISSP/sg_image_2.png\"/> enclosure tags. In asymmetric multiprocessing (AMP), the processors are often operating independently of one another. Usually, each processor has its own OS and/or task instruction set. Smart devices are a range of devices that offer the user a plethora of customization options, typically through installing apps, and may take advantage of on-device or in-the-cloud machine learning (ML) processing.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      269,
      254,
      211,
      250,
      291
    ],
    "source": ""
  },
  {
    "id": 3892,
    "question": "A CTO is reviewing the configuration of a new system recently deployed in the company's data center. It is using extremely high-end server hardware to support over 40 server virtual machines. The goal of this server is to host a variety of essential company services as well as their related data management processes to improve productivity, efficiency, and potentially develop new capabilities. The CTO notices that there is a risk that malicious code infecting one of the VMs may be able to affect code and data operating in other hypervisor containers. <br>What is the issue the CTO has discovered is missing from the new deployment?",
    "choice_a": "Data sovereignty",
    "choice_b": "VM escape protection",
    "choice_c": "Guest OS malware scanning",
    "choice_d": "Containerization",
    "correct_answer": "B",
    "explanation": "In this scenario, the CTO has discovered that the deployment is missing VM escape protection. VM escaping occurs when software within a guest OS is able to breach the isolation protection provided by the hypervisor in order to violate the container of other guest OSs or to infiltrate a host OS. This is a serious concern that must be addressed before full deployment into production of this new infrastructure solution. This is not a data sovereignty issue. Data sovereignty is the concept that, once information has been converted into a binary form and stored as digital files, it is subject to the laws of the country within which the storage device resides. Guest OS malware scanning may or may not be present in this new system design, but even with malware protection, new unknown zero-day malware could still infect a VM, and then through an escape vulnerability affect other VMs. This is not a containerization issue. Containerization is based on the concept of eliminating the duplication of OS elements in a virtual machine. Instead, each application is placed into a container that includes only the actual resources needed to support the enclosed application; the common or shared OS elements are then part of the hypervisor.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      268,
      267,
      272,
      211,
      289
    ],
    "source": ""
  },
  {
    "id": 3893,
    "question": "Which of the following statements are not true in regard to static electricity?",
    "choice_a": "Electrostatic discharge can damage most computing components.",
    "choice_b": "Static charge accumulation is more prevalent when there is high humidity.",
    "choice_c": "Static discharge from a person to a metal object can be over 1,000 volts.",
    "choice_d": "Static electricity is not managed by the deployment of a UPS.",
    "correct_answer": "B",
    "explanation": "Static charge accumulation is more prevalent when there is low humidity. High humidity is the cause of condensation, not static charge accumulation.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      313,
      326,
      238,
      260,
      263
    ],
    "source": ""
  },
  {
    "id": 3894,
    "question": "Proximity devices can be used to control physical access. The proximity device is worn or held by the authorized bearer. When it passes near a proximity reader, the reader device is able to determine who the bearer is and whether they have authorized access. <br>Which of the following is a proximity technology that is the equivalent of RFID?",
    "choice_a": "Field-powered proximity device",
    "choice_b": "Passive proximity device",
    "choice_c": "Self-powered proximity device",
    "choice_d": "TOTP proximity token",
    "correct_answer": "A",
    "explanation": "RFID (radio-frequency identification) is effectively a field-powered proximity device. A passive proximity device is often a magnet; an RFID does not use a magnet, but an antenna to generate current from a magnet field provided by an external source. A self-powered proximity device has its own battery, which RFID does not, but NFC may. A TOTP token is a device with an LCD screen that displays a one-time use password that is based on time and that changes at fixed time intervals. There is no such thing as a TOTP proximity token.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      309,
      327,
      329,
      324,
      318
    ],
    "source": ""
  },
  {
    "id": 3895,
    "question": "A mission-critical server has experienced a compromise that caused it to go offline for seven hours. This nearly caused the organization to go out of business. After the attack, investigations revealed malicious code that would have corrupted the core database, but it was coded poorly and did not execute. This incident has caused the organization to rethink their security precautions against compromise, downtime, and disaster events. In order to prevent future downtime or at least reduce it significantly, which of the following technologies should be deployed? (Select all that apply.)",
    "choice_a": "FDE",
    "choice_b": "RAID",
    "choice_c": "UPS",
    "choice_d": "Dual power supplies",
    "correct_answer": [
      "B",
      "C",
      "D",
      "E",
      "H",
      "I"
    ],
    "explanation": "For this scenario, many different redundancy, resiliency, or uptime management options should be considered. This includes option B: Redundant array of inexpensive disks (RAID) to maintain data availability; option C: Uninterruptible power supply (UPS) to protect against power issues; option D: Dual power supplies to provide redundancy against power supply failures; option E: Offsite backups to provide a recovery path in the event of a major disaster' option H: Replication to ensure multiple similar servers are hosting cloned material so that no matter which server is accessed the most current version of data is available; and option I: Clustering that is used to operate numerous servers as a collective to support a single or primary resource and provide high availability. The following options are incorrect for this scenario: option A: Full-disk encryption (FDE),though a good security practice, is not related to redundancy, resiliency, or uptime management; option F: Multifactor authentication (MFA),though a good security practice, is not related to redundancy, resiliency, or uptime management; and option G: Security information and event management (SIEM) is a centralized application to automate the monitoring of network systems, which a good security practice, but is not related to redundancy, resiliency, or uptime management.",
    "topic_id": 3,
    "practice_test_id": 7,
    "related_articles": [
      312,
      308,
      226,
      213,
      230
    ],
    "source": "",
    "choice_e": "Offsite backups of system images and snapshots",
    "choice_f": "MFA",
    "choice_g": "SIEM",
    "choice_h": "Replication",
    "choice_i": "Clustering"
  },
  {
    "id": 3896,
    "question": "A user is attempting to access a website, but when they type the FQDN into the address bar of their browser, a different site appears. The user opens a command prompt and performs an <code>nslookup</code> query to obtain the IP address their system is receiving when resolving the FQDN of the website. The user then checks with a colleague who is working from home and they get a different IP address and they have no issue accessing the website. The user checks their IP configuration and sees that the correct DNS server is listed as their query target. The user runs <code>ipconfig /flushdns</code> and then the <code>ipconfig /displaydns</code> commands but does not see the correct website's identity listed in the final result. <br>Which of the following is the <italic>most</italic> likely cause for this situation?",
    "choice_a": "Modified <code>hosts</code>file",
    "choice_b": "Falsification of DHCP details",
    "choice_c": "Local DNS caching server poisoning",
    "choice_d": "Alteration of the zonefile on the authoritative DNS server",
    "correct_answer": "C",
    "explanation": "The most likely cause of this situation is the poisoning of the local DNS caching server. This is the DNS server that the user's computer is using to send DNS queries to. When the user types in the fully qualified domain name (FQDN), the resolution returns the wrong IP address. The investigations performed by the user demonstrated that this is the only remaining option. After a DNS flush, the <code>display</code> command would have shown the FQDN and the wrong IP address if the <code>hosts</code> file had been modified since those entries would not be removed from the DNS cache as they are boot persistent. When their local IP configuration is correct, it shows that DHCP was not altered to hand out an invalid DNS server IP address. Since their colleague had no issue getting to the correct website, the authoritative DNS server's zone file was not modified.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      340,
      344,
      341,
      339,
      343
    ],
    "source": ""
  },
  {
    "id": 3897,
    "question": "John is configuring a router that connects his internal network (10.8.6.0/24) to the internet. He wants to apply filtering rules to prevent malicious hackers from using his network to launch a DDoS attack. <br>Where should the filtering be applied, and what type of traffic should be filtered out to achieve this goal?",
    "choice_a": "Inbound traffic with a source private IP address",
    "choice_b": "Outbound traffic with a destination private IP address",
    "choice_c": "Inbound traffic with a source address in the range 10.8.6.0/24",
    "choice_d": "Outbound traffic with a source address outside the range 10.8.6.0/24",
    "correct_answer": "D",
    "explanation": "To prevent attackers from using spoofed IP addresses within John's network to launch a DDoS attack, filtering should ideally be applied on the internal interface of the router. Specifically, inbound traffic on the internal interface with a source IP address outside the 10.8.6.0/24 range should be denied. This ensures that only traffic from legitimate internal IP addresses is allowed to exit the network. If the filtering were applied on the internet-facing interface, it could potentially block NAT-translated public IP traffic, which is why applying the filter at the internal interface is the more appropriate choice.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      375,
      423,
      949,
      333,
      345
    ],
    "source": ""
  },
  {
    "id": 3898,
    "question": "While performing network analysis, you detect an Ethernet frame that seems odd. You determine that the communication is making its way out of the intranet onto the public network. It has the following structure. <br><code>[Ethernet [IP [TCP [HTTP [FTP [Payload]]]]]</code> <br>What is the most likely concern with this communication?",
    "choice_a": "Data is being encrypted",
    "choice_b": "Bypassing a filter",
    "choice_c": "SQLi",
    "choice_d": "VLAN hopping",
    "correct_answer": "B",
    "explanation": "The Ethernet frame in this scenario is an example of an attempt to bypass a filter. In this instance, the filter is likely related to blocking FTP, so the user is employing a utility that is taking advantage of the multilayer protocol feature of encapsulation to enclose the blocked protocol in an allowed protocol, namely HTTP. There is no indication of data being encrypted, since there is no listing of an encryption mechanism (such as TLS) or protocol (such as SSH or IPsec) (i.e., VPN). This is not SQL injection (SQLi), as that would require seeing the payload of HTTP (or HTTPS) and recognizing SQL expressions. This is not VLAN hopping as that is often performed by including double IEEE 802.1q VLAN tags in the Ethernet header, which is not present in this example.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      351,
      421,
      330,
      333,
      436
    ],
    "source": ""
  },
  {
    "id": 3899,
    "question": "Your CISO is implementing a new technology to enable the various satellite offices to be connected to the central headquarters. This will increase business operations efficiency as well as allow for a more consistent application of company security policy. The technology is based on an encapsulation protocol that enables switch-created network segments to be stretched across subnets and geographic distances. <br>What technology is being implemented in this scenario?",
    "choice_a": "SDWAN",
    "choice_b": "SDN",
    "choice_c": "VXLAN",
    "choice_d": "VPN",
    "correct_answer": "C",
    "explanation": "Virtual eXtensible LAN (VXLAN) is an encapsulation protocol that enables switch-created network segments (i.e., VLANs) to be stretched across subnets and geographic distances. Software-defined wide-area networks (SDWANs or SD-WANs) is an evolution of SDN that can be used to manage the connectivity and control services between distant data centers, remote locations, and cloud services over WAN links. SDN offers a new network design that is directly programmable from a central location, flexible, vendor neutral, and open standards based. A VPN is a secured encapsulation tunnel used to connect networks (or network segments) together.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      357,
      354,
      351,
      417,
      355
    ],
    "source": ""
  },
  {
    "id": 3900,
    "question": "Cathy is designing a new wireless network for her organization. It will be used as an extension of the existing traditional wired network. She would like to use a single SSID across multiple access points so that only a single network logon event is needed for workers connecting to the network no matter where in the building they are located. <br>What type of Wi-Fi network should be deployed in this situation?",
    "choice_a": "Standalone",
    "choice_b": "Wired extension",
    "choice_c": "Enterprise extension",
    "choice_d": "Bridge",
    "correct_answer": "C",
    "explanation": "Enterprise extended infrastructure mode exists when a wireless network is designed to support a large physical environment through the use of a single SSID but numerous access points. An enterprise extension is often used as an extension to a wired network and requires only a single logon event for each connected session for workers no matter where in the building they are located. A standalone WAP is not even connected to a wired network. A wired extension is a single WAP. A wireless bridge is used to connect to moderate distant networks together using two bridge access points.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      359,
      369,
      392,
      391,
      389
    ],
    "source": ""
  },
  {
    "id": 3901,
    "question": "Colin was recently hired by your organization as a product tester. Colin has been issued a company notebook with cellular data service. After a few weeks, you notice that there are blog postings that include details about a product in development that has not been publicly announced. You suspect that Colin is an espionage agent from a competitor. You carefully review the network edge DLP and firewall logs and see no indication that Colin transferred the confidential files out of the company network. You also confirm that the company computer never left the building. <br>How could Colin have leaked the data?",
    "choice_a": "Sending the files out as email attachments",
    "choice_b": "Accessing the company's cloud backup storage",
    "choice_c": "Using his company-issued device to create a bypass",
    "choice_d": "Installing an alternate OS onto his mobile device",
    "correct_answer": "C",
    "explanation": "In this scenario, the fact that the device issued to Colin has cellular data service would enable him to create a bypass, which would avoid using the company's local network to send files to an external entity by using cellular data. This would therefore not cause any detection by the edge DLP or record in the firewall logs of the files' transmission. If Colin had attempted sending the files as email attachments (assuming they were sent via the company network and/or company email server), then the DLP and firewall systems would have detected this attempt of data exfiltration. It is unlikely that a recently hired product tester would have been granted access to the company's cloud backup service. But if so, there would still be the need to transfer the files to an external entity and there is no record of that, so accessing the backup alone is not enough of an explanation. Replacing the OS on a mobile device might have removed any local security mechanisms that could have blocked or detected the confidential file transfer. However, since the scenario only states that the edge DLP and firewall do not have a record of the transmission, changing the device's OS isn't relevant.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      1001,
      1000,
      1002,
      375,
      401
    ],
    "source": ""
  },
  {
    "id": 3902,
    "question": "A company server is under direct remote attack from an internet source. This attack is in fact a repeat occurrence that has already compromised three other systems. The CSO wants to prevent future connections from the source of the attack. <br>How can this result be achieved?",
    "choice_a": "Disable all ingress access to the systems in the screened subnet.",
    "choice_b": "Use a web proxy and disable caching services.",
    "choice_c": "Use a protocol analyzer to determine the source IP address and add it to the firewall's blocklist.",
    "choice_d": "Install an IDS and update the anti-malware scanner.",
    "correct_answer": "C",
    "explanation": "In this scenario, the source IP address of the attack needs to be discovered in order to prevent future connections. This can be accomplished using a protocol analyzer to determine the source IP address and then add that IP address to the firewall's blocklist. The other options will not result in the desired outcome. Disabling ingress access to screened subnet systems will block all outsiders from using the provided resources and services; this is too extreme of a response and not tailored specifically for the attacker. A web proxy without caching is not going to stop future attacks. An IDS and anti-malware scanner will not stop the attack, although an IDS might notice the attack and inform security personnel of the reoccurrence.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      436,
      345,
      347,
      333,
      393
    ],
    "source": ""
  },
  {
    "id": 3903,
    "question": "You are the network manager for a large organization. Over the weekend a storm caused a power surge, which damaged the main router between the company network and the internet service. On Monday morning you realize that the entire intranet is unable to connect to any outside resource and mission-critical tasks are not functioning. <br>What is the problem that the organization is experiencing?",
    "choice_a": "Sustained redundancy",
    "choice_b": "Switch VLAN isolation failure",
    "choice_c": "Load-balanced distribution of job tasks",
    "choice_d": "A single point of failure",
    "correct_answer": "D",
    "explanation": "A single point of failure is any individual or sole device, connection, or pathway that is of moderate to mission-critical importance to the organization. If that one item fails, the whole organization suffers loss. Infrastructures should be designed with redundancies of all moderately or highly important elements in order to avoid single points of failure. Removing single points of failure involves adding redundancy, recovery options, or alternative means to perform business tasks and processes. Avoiding or resolving single points of failure will improve stability, uptime, and availability. The problem in this scenario is a failure to sustain redundancy and maintain availability. This scenario does not reference switches or VLANs, and therefore they are not relevant. This scenario does not represent a load-balanced distribution of job tasks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      406,
      385,
      394,
      330,
      333
    ],
    "source": ""
  },
  {
    "id": 3904,
    "question": "You need to run networking cables between two office buildings. Between the buildings are several electrical boxes that manage the primary power for the entire business park. <br>Which of the following cable is the worst option to use?",
    "choice_a": "Wireless",
    "choice_b": "UTP",
    "choice_c": "STP",
    "choice_d": "Fiber",
    "correct_answer": "B",
    "explanation": "UTP is the least resistant to EMI because it is unshielded. STP is a shielded form of twisted pair that resists EMI. Fiber is not affected by terrestrial EMI. Wireless is not a cable, but it could be affected by EMI if the interference occurred in the wireless transmission frequencies.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      381,
      389,
      744,
      330,
      333
    ],
    "source": ""
  },
  {
    "id": 3905,
    "question": "A recent network device survey discovered that numerous rogue or unauthorized devices were present on the network. Most were owned by employees, but one may have been planted by a contractor. As the CISO, you are considering the installation of NAC to address this situation. <br>Which of the following statements are true in regard to NAC?  (Select all that apply.)",
    "choice_a": "Agent-based NACs can quarantine noncompliant devices and implement updates automatically.",
    "choice_b": "Preadmission-based NAC requires a system to meet all current security requirements (such as patch application and malware scanner updates) before it is allowed to communicate with the network.",
    "choice_c": "An agentless NAC can automatically quarantine and resolve security issues on hosts.",
    "choice_d": "A dissolvable NAC agent can be set to run once and then terminate.",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "There are four true statements in this list. (A) Agent-based NACs can quarantine noncompliant devices and implement updates automatically. (B) Preadmission-based NAC requires a system to meet all current security requirements (such as patch application and malware scanner updates) before it is allowed to communicate with the network. (D) A dissolvable NAC agent can be set to run once and then terminate. (E) An agentless NAC performs port scans, service queries, and vulnerability scans against networked systems to determine whether devices are authorized and baseline compliant. The other statements are incorrect. The correct version of these statements would be: (C) An agentless NAC is unable to automatically quarantine and resolve security issues on hosts. An agentless system requires an administrator to manually resolve any discovered issues. (F) IEEE 802.1X can be used by a NAC solution as a means to grant or deny network access based on authentication, but NAC does not require the use of IEEE 802.1X.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      377,
      388,
      392,
      379,
      393
    ],
    "source": "",
    "choice_e": "An agentless NAC performs port scans, service queries, and vulnerability scans against networked systems to determine whether devices are authorized and baseline compliant.",
    "choice_f": "NAC requires that all systems authenticate using IEEE 802.1X credentials."
  },
  {
    "id": 3906,
    "question": "When you install a new wireless access point to extend your company's network into a newly opened portion of the building, someone raises the concern of interference between the existing Wi-Fi network and the new extension. <br>What media access technology is used by 802.11 networks to manage collisions?",
    "choice_a": "Token passing",
    "choice_b": "CSMA/CD",
    "choice_c": "CSMA/CA",
    "choice_d": "Polling",
    "correct_answer": "C",
    "explanation": "IEEE 802.11 wireless networks use Carrier-Sense Multiple Access with Collision Avoidance (CSMA/CA) to manage (technically avoid) collisions. Ethernet (IEEE 802.3) uses Carrier-Sense Multiple Access with Collision Detection (CSMA/CD). Token Ring networks used token passing. Polling is used by some mainframe systems.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      382,
      359,
      366,
      388,
      389
    ],
    "source": ""
  },
  {
    "id": 3907,
    "question": "Your telco has just announced that it is terminating PSTN landline service in your area. <br>What technology allows for phone conversations to occur over an existing TCP/IP network and internet connection?",
    "choice_a": "IPsec",
    "choice_b": "VoIP",
    "choice_c": "SSH",
    "choice_d": "TLS",
    "correct_answer": "B",
    "explanation": "Voice over IP (VoIP) allows for phone conversations to occur over an existing TCP/IP network and internet connection. IPsec and SSH are VPN protocols, which do not directly enable voice or phone conversations. TLS can be used to encrypt VoIP, but TLS is a general Transport-layer encrypter of any Application layer protocol and does not directly enable voice or phone conversations.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      398,
      395,
      438,
      350,
      333
    ],
    "source": ""
  },
  {
    "id": 3908,
    "question": "Which security protocol automatically performs reauthentication of the client system throughout the connected session in order to detect session hijacking?",
    "choice_a": "TLS",
    "choice_b": "SSH",
    "choice_c": "IPsec",
    "choice_d": "LEAP",
    "correct_answer": "C",
    "explanation": "IPsec is a security protocol that automatically performs reauthentication of the client system throughout the connected session in order to detect session hijacking. TLS, SSH, and LEAP do not include periodic midstream reauthentication.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      350,
      416,
      885,
      870,
      412
    ],
    "source": ""
  },
  {
    "id": 3909,
    "question": "A recent update to networking equipment has provided the IT management and security teams with many new capabilities. These include the ability to implement customized network segments and use NATing between them. <br>Which of the following is an appropriate container where static NAT can be used to grant external entities access to resources that are otherwise using private IP addresses?  (Select all that apply.)",
    "choice_a": "Screenedsubnet",
    "choice_b": "VLAN",
    "choice_c": "Extranet",
    "choice_d": "LAN",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Static NAT can be appropriately and securely used to grant external entities access to resources positioned in a screenedsubnet or an extranet, especially when those resource hosts are using private IP addresses. VLANs are typically not relevant to NAT because NAT operates at layers 3 and 4 and a VLAN exists at layer 2. It is not appropriate or secure to use static NAT to grant external entities access into the LAN.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      424,
      423,
      421,
      736,
      375
    ],
    "source": ""
  },
  {
    "id": 3910,
    "question": "What is a hardware-imposed network segmentation that requires a routing function to support intersegment communications otherwise known as?",
    "choice_a": "Subnet",
    "choice_b": "ISFW",
    "choice_c": "VLAN",
    "choice_d": "Extranet",
    "correct_answer": "C",
    "explanation": "A VLAN (virtual LAN) is a hardware-imposed network segmentation created by switches that requires a routing function to support communication between different segments. A subnet is defined by IP address and subnet mask assignment. Subnets are not defined by routers, but subnets do require a routing function to support intersegment communications. An internal segmentation firewall (ISFW) is not the name of a network segment, but it can be used to create network segments by dividing subnets. An extranet is a type of screened subnet typically separated from the intranet and internet by firewalls.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      419,
      1013,
      356,
      374,
      866
    ],
    "source": ""
  },
  {
    "id": 3911,
    "question": "A risk assessment includes the evaluation of threats for each identified asset. <br>What are the potential areas of concern related to third-party connectivity?  (Select all that apply.)",
    "choice_a": "Business partnerships",
    "choice_b": "Cloud services",
    "choice_c": "Telecommuting",
    "choice_d": "Business branch VPN links",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "The potential areas of concern related to third-party connectivity are those in which an actual outsider is to be directly connected to on-premises networks; these situations include business partnerships, cloud services, and telecommuting. Third-party connectivity is not involved when using VPN links to connect business branches.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      427,
      430,
      428,
      399,
      417
    ],
    "source": ""
  },
  {
    "id": 3912,
    "question": "Internet Protocol Security (IPsec) is a standard of IP security extensions used as an add-on for IPv4 and integrated into IPv6. IPsec isn't a single protocol but rather a collection of protocols. <br>Which component of IPsec enables multiple simultaneous VPNs?",
    "choice_a": "ESP",
    "choice_b": "SKEME",
    "choice_c": "ISAKMP",
    "choice_d": "AH",
    "correct_answer": "C",
    "explanation": "Internet Security Association and Key Management Protocol (ISAKMP), an element of Internet Key Exchange (IKE), is used to organize and manage the encryption keys that have been generated and exchanged by OAKLEYand SKEME. A security association is the agreed-on method of authentication and encryption used by two entities (a bit like a digital keyring). ISAKMPs' use of security associations is what enables IPsec to support multiple simultaneous VPNs from each host. Encapsulating Security Payload (ESP) provides confidentiality and integrity of packet contents. ESP provides encryption and limited authentication, and prevents replay attacks. Secure Key Exchange Mechanism (SKEME), an element of Internet Key Exchange (IKE), is a means of exchanging keys securely. Authentication Header (AH) provides assurances of message integrity and nonrepudiation. AH also provides authentication and access control, and prevents replay attacks.",
    "topic_id": 4,
    "practice_test_id": 7,
    "related_articles": [
      416,
      411,
      350,
      413,
      412
    ],
    "source": ""
  },
  {
    "id": 3913,
    "question": "Your organization includes about 200 servers housed in a server room. <br>Which of the following are physical security controls that can protect these servers?  (Select all that apply.)",
    "choice_a": "Cipher lock",
    "choice_b": "Authentication",
    "choice_c": "HVAC",
    "choice_d": "Authorization",
    "correct_answer": [
      "A",
      "C"
    ],
    "explanation": "Cipher locks and heating, ventilation, and air-conditioning (HVAC) systems are physical security controls that can protect servers in a server room. Security controls protect Availability, Integrity, and Confidentiality (AIC). A server room can't do without an HVAC system and if HVAC system in a server room fails, it can impact the availability of the servers. Authentication and authorization methods are logical access controls.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      440,
      461,
      471,
      846,
      470
    ],
    "source": ""
  },
  {
    "id": 3914,
    "question": "Which of the following best describes a service account?",
    "choice_a": "It is used to run applications.",
    "choice_b": "It is used to install applications.",
    "choice_c": "It is used to service applications.",
    "choice_d": "It is shared by administrators.",
    "correct_answer": "A",
    "explanation": "Service accounts are regular accounts that are used to run applications and services. They are not used to install or service applications, and administrators do not share them.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      926,
      453,
      455,
      456,
      457
    ],
    "source": ""
  },
  {
    "id": 3915,
    "question": "A user logs in with a login ID and a password. <br>What is the purpose of the login ID?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accountability",
    "choice_d": "Identification",
    "correct_answer": "D",
    "explanation": "A user professes an identity with a login ID. The combination of the login ID and the password provides authentication. Subjects are authorized access to objects after authentication. Logging and auditing provide accountability.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      441,
      443,
      448,
      451,
      480
    ],
    "source": ""
  },
  {
    "id": 3916,
    "question": "Employees regularly connect to a VPN server when working from home. You want to ensure that employees don't reveal their credentials to a rogue VPN server. <br>Which of the following will meet this need?",
    "choice_a": "Multifactor authentication",
    "choice_b": "Mutual authentication",
    "choice_c": "Device authentication",
    "choice_d": "Service authentication",
    "correct_answer": "B",
    "explanation": "Mutual authentication ensures that a server provides authentication before the client provides authentication. This prevents employees from revealing their credentials to rogue servers. Multifactor authentication uses more than one factor of authentication. Devices authenticate with a server in internal networks. Service accounts are used to run services or applications.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      449,
      477,
      446,
      479,
      488
    ],
    "source": ""
  },
  {
    "id": 3917,
    "question": "Developers of a web application want to ensure that users are logged off automatically after 20 minutes of inactivity. <br>Which of the following choices indicates the easiest way to do this?",
    "choice_a": "Python",
    "choice_b": "JavaScript",
    "choice_c": "A web development framework",
    "choice_d": "Transport Layer Security (TLS)",
    "correct_answer": "C",
    "explanation": "The easiest way (and the best way) to implement session management is with a web development framework, such as one recommended by the Open Web Application Security Project (OWASP). Writing the code from scratch in Python or JavaScript would not be the easiest way and may introduce vulnerabilities,whereas established frameworks are reliable and well tested. TLS should be used in session management, but TLS doesn't close sessions.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      454,
      976,
      978,
      460,
      471
    ],
    "source": ""
  },
  {
    "id": 3918,
    "question": "Which of the following is the best choice to support federated identity management (FIM) systems?",
    "choice_a": "Extensible Markup Language (XML)",
    "choice_b": "Hypertext Markup Language (HTML)",
    "choice_c": "Just-in-time (JIT)",
    "choice_d": "Security Assertion Markup Language (SAML)",
    "correct_answer": "D",
    "explanation": "SAML is an XML-based framework used to exchange user information for single sign-on(SSO) between organizations within a federated identity management system. XML could be used, but it would require redefining tags already defined inSAML. HTML only describes how data is displayed. JIT is a special type of federated identify solution that creates accounts automatically. JIT provisioning also uses SAML.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      474,
      476,
      480,
      460,
      481
    ],
    "source": ""
  },
  {
    "id": 3919,
    "question": "Which of the following is an advantage of a single sign-on (SSO) solution within an internal network?",
    "choice_a": "It can be a single point of failure.",
    "choice_b": "It can give an attacker greater access to a compromised account.",
    "choice_c": "It improves the administrator's ability to manage user accounts.",
    "choice_d": "It easily supports all operating systems.",
    "correct_answer": "C",
    "explanation": "SSO solutions and centralized administration and make it easier for administrators to manage user accounts. SSO solutions can be a single point of failure, but this is a vulnerability. Another vulnerability is that compromise of a single account can give an attacker access to multiple resources. Although SSO solutions typically can support more than one operating system, it isn't always easy to support all operating systems in internal networks.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      451,
      754,
      450,
      460,
      492
    ],
    "source": ""
  },
  {
    "id": 3920,
    "question": "An organization has merged with another organization. The two organizations are using different network operating systems. Management wants to implement a solution that will give them the most control while allowing both organizations to access resources in both networks. <br>Which of the following choices is the best to meet these needs?",
    "choice_a": "On-premises identity management",
    "choice_b": "Cloud-based identity management",
    "choice_c": "Hybrid identity management",
    "choice_d": "Single-sign on",
    "correct_answer": "A",
    "explanation": "An on-premises identity management system will provide the organization with the most control and is the best choice. A cloud-based solution is controlled by a third party. There's no need to have both an on-premises and a cloud-based solution in this situation, which would be a hybrid solution. Identity management solutions provide single sign-on (SSO), but SSO is a benefit of identity management, not a type of identity management.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      452,
      451,
      450,
      480,
      474
    ],
    "source": ""
  },
  {
    "id": 3921,
    "question": "A security auditor recently completed an account access review. <br>Which of the following privileged accounts did they most likely include?  (Select all that apply.)",
    "choice_a": "User accounts",
    "choice_b": "Root accounts",
    "choice_c": "Service accounts",
    "choice_d": "Guest accounts",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Root accounts and service accounts should be monitored. Linux systems have a root account, which is similar to a built-in Administrator account on Windows systems. Applications or services use service accounts, and these accounts typically have elevated privileges. Privilege monitoring helps ensure that the privileges aren't misused, and entities do not have more privileges than they need. Regular user accounts and guest accounts aren't granted elevated privileges.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      926,
      927,
      457,
      470,
      462
    ],
    "source": ""
  },
  {
    "id": 3922,
    "question": "An organization is planning to launch a website selling digital products. It's the first website they created, so they hired two web developers to create it. <br>Which of the following methods best describes how the organization should give the developers the privileges they need to perform their job?",
    "choice_a": "Add the developer accounts to existing groups.",
    "choice_b": "Define new roles and assign privileges to these roles.",
    "choice_c": "Assign the rights and permissions individually to each developer.",
    "choice_d": "Add the developers to the administrator's group on the webserver.",
    "correct_answer": "B",
    "explanation": "When creating new job positions, it's best to define new roles and assign privileges to these roles. Because this is the first website for the organization, it's unlikely existing groups would grant the developers the privileges they need without granting them excessive privileges. Even if rights and permissions were assigned individually, the role should still be defined first to identify the rights and permissions they need. Adding the developers to the administrator's group violates the least privilege policy.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      466,
      458,
      470,
      471,
      455
    ],
    "source": ""
  },
  {
    "id": 3923,
    "question": "A user logged on with a username and password. <br>Which of the following grants the user access to an object based on the user's rights and permissions?",
    "choice_a": "Identification",
    "choice_b": "Authentication",
    "choice_c": "Accountability",
    "choice_d": "Authorization",
    "correct_answer": "D",
    "explanation": "Authorization grants access to an object based on a user's proven identity. Identification is the process of claiming an identity, such as with a username. Authentication is the process of proving a claimed identity, such as logging on with a username and a password. Auditing, logging, and monitoring provide accountability.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      441,
      462,
      448,
      491,
      465
    ],
    "source": ""
  },
  {
    "id": 3924,
    "question": "What type of access control model is used on a firewall?",
    "choice_a": "MAC model",
    "choice_b": "DAC model",
    "choice_c": "Rule-based access control model",
    "choice_d": "RBAC model",
    "correct_answer": "C",
    "explanation": "Firewalls use a rule-based access control model with rules expressed in an access control list. A Mandatory Access Control (MAC) model uses labels. A Discretionary Access Control (DAC) model allows users to assign permissions. A Role-Based Access Control (RBAC) model organizes users in groups.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      467,
      491,
      463,
      472,
      466
    ],
    "source": ""
  },
  {
    "id": 3925,
    "question": "When Sally create files, she becomes the file owner, and she can grant access to these files to other users. <br>Which of the following access control models does this describe?",
    "choice_a": "Mandatory Access Control (MAC)",
    "choice_b": "Attribute-Based Access Control (ABAC)",
    "choice_c": "Discretionary Access Control (DAC)",
    "choice_d": "Risk-based access control",
    "correct_answer": "C",
    "explanation": "In a DAC model, the creator of a file is the owner, and the owner can grant access to others. The MAC model uses labels to assign access. An ABAC model gives access based on attributes. Software-defined networks (SDNs) often use an ABAC model. A risk-based access control model evaluates the environment and the situation to determine access.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      465,
      491,
      472,
      467,
      466
    ],
    "source": ""
  },
  {
    "id": 3926,
    "question": "An organization's security policy allows users to connect their mobile devices to the internal network. However, it requires that their devices are up-to-date with a current operating system. <br>Which of the following access control models can enforce this requirement?",
    "choice_a": "Rule-based access control",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Attribute-Based Access Control (ABAC)",
    "choice_d": "Role-Based AccessControl (RBAC)",
    "correct_answer": "C",
    "explanation": "An ABAC model can require user devices to meet specific requirements, such as being up-to-date with a current operating system. A rule-based access control model defines access using a set of rules, such as the rules in a firewall's access control list. A MAC model uses matching labels to grant access. An RBAC model uses job roles, or groups, for access control.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      491,
      472,
      467,
      469,
      471
    ],
    "source": ""
  },
  {
    "id": 3927,
    "question": "A web developer implemented an authentication solution on a website allowing users to authenticate with a third party. The website doesn't see or store the user's credentials. The solution uses technologies described in RFC 6749 but is not maintained by IETF. <br>What does this describe?",
    "choice_a": "OAuth",
    "choice_b": "OIDC",
    "choice_c": "OpenID",
    "choice_d": "SAML",
    "correct_answer": "B",
    "explanation": "OpenID Connect (OIDC) uses the OAuth framework (described in RFC 6749) and is maintained by the OpenID Foundation. RFC 6749 describes OAuth and is maintained by the Internet Engineering Task Force (IETF). The OpenID foundation also maintains OpenID. Security Assertion Markup Language (SAML) is an open XML-based standard and it isn't based on OAuth (RFC 6749).",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      475,
      476,
      1018,
      480,
      492
    ],
    "source": ""
  },
  {
    "id": 3928,
    "question": "Your network is using Kerberos. <br>Which of the following best describes a ticket-granting ticket (TGT)?",
    "choice_a": "It verifies the existence of a user account.",
    "choice_b": "It is a message that proves a user can access an object.",
    "choice_c": "It allows authenticated users to request access to network services.",
    "choice_d": "It is an encrypted message with a timestamp used for accounting.",
    "correct_answer": "C",
    "explanation": "A TGT provides proof that a subject has authenticated with a key distribution center (KDC) and can request network service access. The TGT does verify the existence of a user account, but it does much more. It proves the user has authenticated and can request a ticket. A ticket (not a ticket-granting ticket) is an encrypted message that proves a user can access an object. TGTs are not used for accounting.",
    "topic_id": 5,
    "practice_test_id": 7,
    "related_articles": [
      477,
      492,
      487,
      480,
      478
    ],
    "source": ""
  },
  {
    "id": 3929,
    "question": "Which one of the following tools is used primarily to perform network vulnerability scans?",
    "choice_a": "nmap",
    "choice_b": "OpenVAS",
    "choice_c": "Metasploit Framework",
    "choice_d": "lsof",
    "correct_answer": "B",
    "explanation": "OpenVASis a network vulnerability scanning tool that searches systems for known vulnerabilities while minimizing damage caused during the assessment. The tool nmap is used to detect live systems and the status of ports; it is not considered a vulnerability scanner. MetasploitFramework is an exploitation framework that can cause damage to assessed systems. The Linux command <code>lsof</code> is used to \"list open files.\".",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      787,
      860,
      859,
      776,
      789
    ],
    "source": ""
  },
  {
    "id": 3930,
    "question": "What type of contractual terms may require you to meet business continuity obligations to your own customers?",
    "choice_a": "Nondisclosure agreement",
    "choice_b": "Mutual indemnification agreement",
    "choice_c": "Noncompete agreement",
    "choice_d": "Service-level agreement",
    "correct_answer": "D",
    "explanation": "A service-level agreement may require you to meet the business continuity objectives of your customers.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      795,
      766,
      768,
      864,
      502
    ],
    "source": ""
  },
  {
    "id": 3931,
    "question": "Which of the following is a documented set of best IT security practices crafted by ISACA?",
    "choice_a": "ISO 27001",
    "choice_b": "COBIT",
    "choice_c": "OSSTMM",
    "choice_d": "Common Criteria (IS 15408)",
    "correct_answer": "B",
    "explanation": "Control Objectives for Information and Related Technologies (COBIT) is a documented set of best IT security practices crafted by ISACA and the IT Governance Institute (ITGI).",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      863,
      793,
      768,
      1006,
      1008
    ],
    "source": ""
  },
  {
    "id": 3932,
    "question": "Chris would like to test systems on his network for cross-site scripting (XSS) vulnerabilities. <br>Which one of the following tools would be best suited to this task?",
    "choice_a": "Port scanner",
    "choice_b": "Regression testing tool",
    "choice_c": "Network discovery scanner",
    "choice_d": "Web vulnerability scanner",
    "correct_answer": "D",
    "explanation": "Cross-site scripting attacks are web vulnerabilities, and Chris would be best served by a web vulnerability scanner. A network vulnerability scanner might also pick up this vulnerability, but the web vulnerability scanner is specifically designed for the task and more likely to be successful. Regression testing tools are designed to verify that software updates have not introduced any unanticipated changes. There is no indication in this scenario that there was a code change that would require regression testing.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      787,
      494,
      775,
      776,
      859
    ],
    "source": ""
  },
  {
    "id": 3933,
    "question": "Alan conducted a vulnerability scan of a system and discovered that it is susceptible to a SQL injection attack. <br>Which one of the following ports would an attacker most likely use to carry out this attack?",
    "choice_a": "443",
    "choice_b": "565",
    "choice_c": "1433",
    "choice_d": "1521",
    "correct_answer": "A",
    "explanation": "While SQL injection attacks do target databases, they do so by using web servers as intermediaries. Therefore, SQL injection attacks take place over web ports, such as 80 and 443, and not database ports, such as 1433 and 1521.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      763,
      787,
      777,
      764,
      859
    ],
    "source": ""
  },
  {
    "id": 3934,
    "question": "Why should access to penetration testing reports be controlled and restricted?",
    "choice_a": "They contain copies of confidential data stored on the network.",
    "choice_b": "They contain information about the vulnerabilities of the system.",
    "choice_c": "They are useful only to upper management.",
    "choice_d": "They include the details about the configuration of security controls.",
    "correct_answer": "B",
    "explanation": "Pentest reports should be secured because they contain information about the vulnerabilities of the system and disclosure of such vulnerabilities to the wrong person could lead to security breaches. They would not normally contain confidential data from the network. They are useful to both upper management and security professionals. They would not normally include details about security control configuration.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      497,
      783,
      795,
      1007,
      862
    ],
    "source": ""
  },
  {
    "id": 3935,
    "question": "The Roscommon Rangers baseball team is concerned about the risk that a storm might result in the cancellation of a baseball game. There is a 30 percent chance that the storm will occur, and if it does, the team must refund all single-game tickets because the game cannot be rescheduled. Season ticket holders will not receive a refund and account for 20 percent of ticket sales. The ticket sales for the game are $1.5 million. <br>What is the exposure factor in this scenario?",
    "choice_a": "20 percent",
    "choice_b": "30 percent",
    "choice_c": "70 percent",
    "choice_d": "80 percent",
    "correct_answer": "D",
    "explanation": "The exposure factor is the amount of the asset that is at risk. In this case, the 80 percent of the tickets that are single-game sales must be refunded, so the exposure factor is 80 percent of the game's revenue.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      502,
      789,
      768,
      861,
      500
    ],
    "source": ""
  },
  {
    "id": 3936,
    "question": "Gavin is preparing the report from an audit engagement he conducted under SSAE 18.  The report he is preparing covers security and privacy controls and is designed for public consumption. <br>What kind of engagement did he conduct?",
    "choice_a": "SOC 1",
    "choice_b": "SOC 2",
    "choice_c": "SOC 3",
    "choice_d": "SOC 4",
    "correct_answer": "C",
    "explanation": "SOC 3 engagements assess the organization's controls that affect the security and privacy of information stored in a system.  The results of a SOC 3 audit are intended for public disclosure.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      794,
      793,
      766,
      795,
      864
    ],
    "source": ""
  },
  {
    "id": 3937,
    "question": "Norma is reviewing the logs from several systems in her organization and notices that the time offset is different on log records generated by different sources. <br>What protocol can help her resolve this issue?",
    "choice_a": "SSH",
    "choice_b": "TLS",
    "choice_c": "NTP",
    "choice_d": "Telnet",
    "correct_answer": "C",
    "explanation": "The Network Time Protocol (NTP) may be used to synchronize the clocks of all devices in an organization with a centralized source, improving the ability to correlate log entries from different sources.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      498,
      772,
      774,
      781,
      783
    ],
    "source": ""
  },
  {
    "id": 3938,
    "question": "What test coverage analysis technique verifies that every if statement in the code has been executed under all if and else conditions?",
    "choice_a": "Condition coverage",
    "choice_b": "Function coverage",
    "choice_c": "Loop coverage",
    "choice_d": "Branch coverage",
    "correct_answer": "D",
    "explanation": "Branch coverage evaluates whether every if statement has been executed under all if and else conditions.  Condition coverage tests whether every logical test in the code has been executed under all sets of input.  Function coverage verifies that every function in the code has been called and returned results.  Loop coverage verifies that every loop in the code has been executed under conditions that cause code execution multiple times, only once, and not at all.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      1004,
      496,
      1003,
      778,
      1005
    ],
    "source": ""
  },
  {
    "id": 3939,
    "question": "Jen is conducting a review of privileged account activity and does not have time to review 100% of accounts. <br>What technique would be the best way to conduct this review?",
    "choice_a": "Review the first 20% of accounts alphabetically",
    "choice_b": "Review the 20% of accounts most recently used",
    "choice_c": "Review a random sample of 20% of accounts",
    "choice_d": "Review the 20% of accounts least recently used",
    "correct_answer": "C",
    "explanation": "The best path for Jen to follow would be to check a randomly generated sample of accounts that is representative of the full account population.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      499,
      502,
      498,
      862,
      1007
    ],
    "source": ""
  },
  {
    "id": 3940,
    "question": "Eimear recently conducted a social engineering awareness campaign and would like to assess its effectiveness. <br>Which one of the following would be the best measure of the campaign's effectiveness?",
    "choice_a": "Phishing simulation",
    "choice_b": "Penetration test",
    "choice_c": "Web application scan",
    "choice_d": "User survey",
    "correct_answer": "A",
    "explanation": "Phishing simulations test the effectiveness of security training by actually identifying the percentage of users likely to fall victim to a phishing attack.  Surveys would also measure this but with lesser effectiveness because they depend upon self-reported perceptions.  Penetration tests and web application scans are technical control evaluations and would not be helpful in assessing the effectiveness of an awareness campaign.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      501,
      502,
      499,
      768,
      767
    ],
    "source": ""
  },
  {
    "id": 3941,
    "question": "Paula recently discovered a security vulnerability in a product produced by a vendor. <br>Who should she inform first of this vulnerability?",
    "choice_a": "Vendor",
    "choice_b": "Security community",
    "choice_c": "Media",
    "choice_d": "Government authorities",
    "correct_answer": "A",
    "explanation": "Under the principle of ethical disclosure, Paula should first report the vulnerability to the vendor and provide them with the opportunity to fix it before informing anyone else of the issue.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      497,
      861,
      789,
      864,
      1006
    ],
    "source": ""
  },
  {
    "id": 3942,
    "question": "The Board of Directors of a firm would like to hire an auditor to review the firm's financial statements. <br>Which one of the following groups would be best suited for this engagement?",
    "choice_a": "Internal audit group",
    "choice_b": "Finance team",
    "choice_c": "Independent auditor",
    "choice_d": "Board committee",
    "correct_answer": "C",
    "explanation": "External audits, such as the one requested by the Board, should always be conducted by independent, qualified audit firms.",
    "topic_id": 6,
    "practice_test_id": 7,
    "related_articles": [
      1007,
      1006,
      862,
      864,
      1008
    ],
    "source": ""
  },
  {
    "id": 3943,
    "question": "A new CIO at your organization wants to reduce risks of data loss due to data theft. <br>Which of the following is the BEST choice to support this goal?",
    "choice_a": "Modify the security policy to prohibit the use of USB flash drives",
    "choice_b": "Block the use of USB flash drives using a technical control",
    "choice_c": "Data custodian",
    "choice_d": "Department heads",
    "correct_answer": "B",
    "explanation": "Blocking the use of USB flash drives using a technical will reduce the risk of data loss due to theft. Adding to the written security policy prohibiting the use of USB drives will deter their use, but won't be as effective as a technical control.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      127,
      124,
      144,
      131,
      128
    ],
    "source": ""
  },
  {
    "id": 3944,
    "question": "An organization has recently implemented an asset management program. <br>Which of the following BEST represents the primary goal of this program?",
    "choice_a": "Ensure accurate inventories",
    "choice_b": "Identify intangible assets",
    "choice_c": "Keep systems up-to-date",
    "choice_d": "Prevent losses",
    "correct_answer": "D",
    "explanation": "An effective asset management program helps prevent losses by tracking and protecting assets throughout their lifetime. The other answers indicate actions that may be a part of an asset management program but not the overall goal.",
    "topic_id": 2,
    "practice_test_id": 7,
    "related_articles": [
      849,
      847,
      851,
      850,
      133
    ],
    "source": ""
  },
  {
    "id": 3945,
    "question": "Security administrators are considering different configuration management methods. <br>Which of the following is the MOST effective method of configuration management provisioning?",
    "choice_a": "Implementing change management",
    "choice_b": "Using images",
    "choice_c": "Implementing vulnerability management",
    "choice_d": "Implementing patch management",
    "correct_answer": "B",
    "explanation": "Images are an effective provisioning method that ensures systems receive an initial, known baseline configuration. Change management processes help prevent outages from unauthorized changes. Vulnerability management processes help to identify vulnerabilities, and patch management processes help to ensure that systems are kept up-to-date.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      523,
      524,
      534,
      798,
      525
    ],
    "source": ""
  },
  {
    "id": 3946,
    "question": "You're working for a financial institution that has job rotation and separation of duties policies. <br>What is a primary benefit of these policies?",
    "choice_a": "Preventing collusion",
    "choice_b": "Preventing fraud",
    "choice_c": "Encouraging collusion",
    "choice_d": "Correcting incidents",
    "correct_answer": "B",
    "explanation": "Job rotation and separation of duties policies help prevent fraud. Collusion is an agreement among multiple persons to perform some unauthorized or illegal actions, and implementing these policies doesn't prevent collusion, nor does it encourage employees to collude against an organization. They help deter and prevent incidents, but they do not correct them.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      504,
      505,
      533,
      543,
      506
    ],
    "source": ""
  },
  {
    "id": 3947,
    "question": "A company has not been implementing patches consistently, and you are tasked with writing a policy related to patch management. <br>Which of the following should you include in the policy?  (Select all that apply.)",
    "choice_a": "Evaluate patches.",
    "choice_b": "Test patches.",
    "choice_c": "Deploy all patches.",
    "choice_d": "Audit patches.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "A patch management process includes evaluating patches, testing patches, and auditing patches. Evaluating patches determines what patches should be deployed. Testing helps discover unintended problems before they are deployed. Auditing ensures required patches have been deployed. All patches should not be deployed. Instead, only patches that apply to a system and have been approved should be applied.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      529,
      534,
      544,
      528,
      532
    ],
    "source": ""
  },
  {
    "id": 3948,
    "question": "You are developing a training and awareness program to address personnel safety and security. <br>Which of the following should be the highest priority?",
    "choice_a": "Value of tangible assets",
    "choice_b": "Value of intangible assets",
    "choice_c": "Safety of personnel",
    "choice_d": "Protection of data",
    "correct_answer": "C",
    "explanation": "The safety of personnel should be the highest priority when addressing safety and security in a training and awareness program. The value of both tangible and intangible assets is important, but not as important as human life. Similarly, protecting data is also important but not as important as personnel safety.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      508,
      511,
      509,
      587,
      505
    ],
    "source": ""
  },
  {
    "id": 3949,
    "question": "A cloud application has been deployed and shared among several organisations with similar concerns. <br>What type of cloud-based deployment model does this describe?",
    "choice_a": "Public",
    "choice_b": "Private",
    "choice_c": "Community",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "A community cloud deployment model provides cloud-based assets to two or more organizations. A public cloud model includes assets available for any consumers to rent or lease. A private cloud deployment model includes cloud-based assets that are exclusive to a single organization. A hybrid model includes a combination of two or more deployment models. It doesn't matter if it is a Software as a Service (SaaS) model or any other service model.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      622,
      623,
      640,
      621,
      661
    ],
    "source": ""
  },
  {
    "id": 3950,
    "question": "Your organization stores archived logs on drives within a backup server. However, the drives are reaching capacity and management wants to implement a process that can reduce the amount of hard drive space required to store the archived logs. <br>Which of the following will reduce the amount of logged or audited data stored on the drives using non-statistical methods?",
    "choice_a": "Clipping levels",
    "choice_b": "Sampling",
    "choice_c": "Log analysis",
    "choice_d": "Alarm triggers",
    "correct_answer": "A",
    "explanation": "Clipping is a form of non-statistical sampling that reduces the amount of logged databased on a clipping-level threshold. Sampling is a statistical method that extracts meaningful data from audit logs. Log analysis reviews log information looking for trends, patterns, and abnormal or unauthorized events. An alarm trigger is a notification sent to administrators when specific events or thresholds occur.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      558,
      889,
      891,
      554,
      556
    ],
    "source": ""
  },
  {
    "id": 3951,
    "question": "Which of the following focuses more on the patterns and trends of data than on the actual content?",
    "choice_a": "Keystroke monitoring",
    "choice_b": "Traffic analysis",
    "choice_c": "Event logging",
    "choice_d": "Security auditing",
    "correct_answer": "B",
    "explanation": "Traffic analysis focuses more on the patterns and trends of data rather than the actual content. Keystroke monitoring records specific keystrokes to capture data. Event logging logs specific events to record data. Security auditing records security events and/or reviews logs to detect security incidents.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      560,
      554,
      559,
      558,
      548
    ],
    "source": ""
  },
  {
    "id": 3952,
    "question": "Security administrators recently detected an attack that allowed attackers to exfiltrate data from several servers. They implemented the incident response plan on response. <br>Which of the following would security personnel do during the remediation stage of incident management?",
    "choice_a": "Contain the incident",
    "choice_b": "Collect evidence",
    "choice_c": "Rebuild system",
    "choice_d": "Root cause analysis",
    "correct_answer": "D",
    "explanation": "Security personnel perform a root cause analysis during the remediation stage. A root cause analysis attempts to discover the source of the problem. After discovering the cause, the review will often identify a solution to help prevent a similar occurrence in the future. Containing the incident and collecting evidence is done early in the incident management process. Rebuilding a system may be needed during the recovery stage.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      540,
      537,
      920,
      539,
      595
    ],
    "source": ""
  },
  {
    "id": 3953,
    "question": "A security information and event management (SIEM) system detected suspicious activity going to a web server. It reported that the server is receiving the beginning of multiple Transmission Control Protocol (TCP) handshake packets. <br>Which of the following provides the best description for this attack?",
    "choice_a": "DoS attack",
    "choice_b": "SYN flood attack",
    "choice_c": "Smurf attack",
    "choice_d": "Teardrop attack",
    "correct_answer": "B",
    "explanation": "This describes a SYN flood attack. The attacker starts a TCP handshake but does not complete it. A denial-of-service (DoS) attack attempts to overwhelm a system by consuming its resources. While a SYN flood attack is a type of DoS attack, SYN flood is more specific and is the best answer. Said another way, all DoS attacks do not use SYN flood techniques. A Smurf attack uses ICMP each packets instead of TCP SYN packets. A teardrop attack mangles IP packets so that the recipient can't put them back together.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      567,
      546,
      553,
      544,
      563
    ],
    "source": ""
  },
  {
    "id": 3954,
    "question": "Which of the following is an example of technical preventive control?",
    "choice_a": "A SIEM system",
    "choice_b": "SOAR technologies",
    "choice_c": "A firewall",
    "choice_d": "Log management",
    "correct_answer": "C",
    "explanation": "A firewall installed at the border of a network (between the Internet and the internal network) is a technical preventive control. A security information and event management (SIEM) system is a detective control. It is centralized application that monitors multiple systems and can detect attacks after they occur, not prevent them. Security Orchestration, Automation, and Response (SOAR) technologies are a combination of detective and corrective controls. They can detect attacks and apply automated actions to mitigate the attacks. Log management includes steps to protect logs, and logs are a detective control.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      551,
      543,
      548,
      561,
      544
    ],
    "source": ""
  },
  {
    "id": 3955,
    "question": "Security administrators are implementing Security Orchestration, Automation, and Response (SOAR) technologies within an organization. They are creating checklists that they typically follow when verifying common incidents and lists of their responses. <br>What does this describe?",
    "choice_a": "Playbook",
    "choice_b": "Runbook",
    "choice_c": "Intrusion prevention system (IPS)",
    "choice_d": "Intrusion detection system (IDS)",
    "correct_answer": "A",
    "explanation": "A playbook is a document or checklist that defines steps taken to validate an incident and steps taken in response to an incident. A runbook implements the checklists from a playbook. An IPS attempts to prevent attacks, and SOAR technologies may use it, but doesn't typically use checklists.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      637,
      638,
      639,
      653,
      651
    ],
    "source": ""
  },
  {
    "id": 3956,
    "question": "Paul is conducting a review of the potential disasters that his organization may suffer and realizes that one of their facilities lies within a 500-year flood plain. <br>What conclusion can he draw from this information?",
    "choice_a": "The last flood of any kind to hit the area was more than 500 years ago.",
    "choice_b": "The odds of a flood at the location described are 1 in 500 in any given year.",
    "choice_c": "The area is expected to be safe from flooding for at least 500 years.",
    "choice_d": "The last significant flood to hit the area was more than 500 years ago.",
    "correct_answer": "B",
    "explanation": "Areas in a 500-year flood plain should expect flooding once every 500 years.  This is a probabilistic measure and can not be used to draw conclusions about the actual occurrence of past or future floods in any specific timeframe.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      953,
      952,
      954,
      569,
      586
    ],
    "source": ""
  },
  {
    "id": 3957,
    "question": "Which of the following activities would normally trigger the invocation of an organization's disaster recovery plan, assuming that they disrupted normal operations?  (Select all that apply.)",
    "choice_a": "Power outage",
    "choice_b": "Terrorist attack",
    "choice_c": "Hurricane",
    "choice_d": "Scheduled maintenance",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Scheduled maintenance is an operational activity that, if it causes an outage, would not trigger a disaster recovery plan. Power outages, terrorist attacks, and hurricanes are all unplanned events that would trigger the disaster recovery plan if they impacted business operations.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      569,
      571,
      570,
      587,
      581
    ],
    "source": ""
  },
  {
    "id": 3958,
    "question": "Which one of the following disaster types is not usually covered by standard business insurance?",
    "choice_a": "Earthquake",
    "choice_b": "Flood",
    "choice_c": "Fire",
    "choice_d": "Theft",
    "correct_answer": "B",
    "explanation": "Most general business insurance and homeowner's insurance policies do not provide any protection against the risk of flooding or flash floods. If floods pose a risk to your organization, you should consider purchasing supplemental flood insurance under FEMA's National Flood Insurance Program.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      579,
      952,
      953,
      954,
      911
    ],
    "source": ""
  },
  {
    "id": 3959,
    "question": "Under what method are database backups bulk transferred to off-site recovery locations?",
    "choice_a": "Electronic billing",
    "choice_b": "Electronic payment",
    "choice_c": "Electronic vaulting",
    "choice_d": "Electronic safekeeping",
    "correct_answer": "C",
    "explanation": "Electronic vaulting automatically backs up data to a secure site where storage professionals at the vaulting company's site handle the details.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      584,
      598,
      589,
      517,
      582
    ],
    "source": ""
  },
  {
    "id": 3960,
    "question": "Which backup facility is large enough to support current operational capacity and load but lacks the supportive infrastructure?",
    "choice_a": "Mobile site",
    "choice_b": "Service bureau",
    "choice_c": "Hot site",
    "choice_d": "Cold site",
    "correct_answer": "D",
    "explanation": "A cold site is any facility that provides only the physical space for recovery operations while the organization using the space provides its own hardware and software systems.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      582,
      598,
      585,
      583,
      588
    ],
    "source": ""
  },
  {
    "id": 3961,
    "question": "Which backup format stores only those files that have been set with the archive bit and have been modified since the last complete backup?",
    "choice_a": "Differential backup",
    "choice_b": "Partial backup",
    "choice_c": "Incremental backup",
    "choice_d": "Full backup",
    "correct_answer": "A",
    "explanation": "Differential backups store all files that have been modified since the time of the most recent full backup; they affect only those files that have the archive bit turned on, enabled, or set to 1.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      588,
      589,
      580,
      586,
      598
    ],
    "source": ""
  },
  {
    "id": 3962,
    "question": "What type of disaster recovery test is the simplest to perform?",
    "choice_a": "Structured walk-through",
    "choice_b": "Read-through",
    "choice_c": "Simulation",
    "choice_d": "Parallel",
    "correct_answer": "B",
    "explanation": "In the read-through test, you distribute copies of the disaster recovery plan to key personnel for review but do not actually meet or perform live testing.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      594,
      597,
      593,
      581,
      596
    ],
    "source": ""
  },
  {
    "id": 3963,
    "question": "Jane is selecting a backup strategy for her organization. She wants to choose a combination of two backup types that will provide full coverage of modified files and require restoring the minimum number of backup tapes. <br>What strategy should she choose?",
    "choice_a": "Full and incremental backups",
    "choice_b": "Full and transaction logging",
    "choice_c": "Full and differential backups",
    "choice_d": "Incremental and differential backups",
    "correct_answer": "C",
    "explanation": "A combination of full and differential backups requires that administrators only restore two backups: the most recent full backup and the most recent differential backup.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      588,
      589,
      596,
      586,
      592
    ],
    "source": ""
  },
  {
    "id": 3964,
    "question": "Which one of the following is not one of the canons of the ISC2 code of ethics?",
    "choice_a": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_b": "Advance and protect the profession.",
    "choice_c": "Preserve the integrity of the CISSP exam.",
    "choice_d": "Provide diligent and competent service to principals.",
    "correct_answer": "C",
    "explanation": "The code of ethics does not explicitly mention the CISSP exam.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      955,
      956,
      957,
      15,
      47
    ],
    "source": ""
  },
  {
    "id": 3965,
    "question": "What evidence standard do most civil investigations follow?",
    "choice_a": "Beyond a reasonable doubt",
    "choice_b": "Beyond the shadow of a doubt",
    "choice_c": "Preponderance of the evidence",
    "choice_d": "Clear and convincing evidence",
    "correct_answer": "C",
    "explanation": "Civil investigations typically follow the \"preponderance of the evidence\" standard.",
    "topic_id": 1,
    "practice_test_id": 7,
    "related_articles": [
      981,
      100,
      98,
      117,
      979
    ],
    "source": ""
  },
  {
    "id": 3966,
    "question": "Kevin is evaluating different software development approaches for his organization and would like to select an approach that facilitates the tight integration of software creation, maintenance, and security. <br>Which one of the following approaches would best meet his needs?",
    "choice_a": "Agile",
    "choice_b": "Waterfall",
    "choice_c": "Spiral",
    "choice_d": "DevSecOps",
    "correct_answer": "D",
    "explanation": "The DevSecOps approach integrates software development, cybersecurity, and operations into a single approach where the teams work closely together.  Teams using the Agile philosophy often embrace this approach, but it is not a necessary component of Agile development.  The waterfall and spiral models are older development processes that do not necessarily support DevSecOps well.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      625,
      640,
      622,
      1035,
      832
    ],
    "source": ""
  },
  {
    "id": 3967,
    "question": "Helen's organization would like to move to a process where they can release new code many times per day. <br>Which one of the following software development practices would most directly enable this approach?",
    "choice_a": "CI/CD",
    "choice_b": "Agile",
    "choice_c": "SCM",
    "choice_d": "Code repository",
    "correct_answer": "A",
    "explanation": "Continuous integration/continuous delivery approaches are designed to facilitate the release of code on an extremely frequent basis.  Agile software development may assist with this goal, but it does not directly facilitate it as much as CI/CD does.  Software configuration management (SCM) and code repositories are used to manage code and, again, are supporting tools.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      817,
      625,
      640,
      1033,
      624
    ],
    "source": ""
  },
  {
    "id": 3968,
    "question": "Rory is deploying Java code to a variety of machines in his environment and must install the JVM on those machines first. <br>What term best describes the JVM in this case?",
    "choice_a": "Repository",
    "choice_b": "Change manager",
    "choice_c": "Runtime",
    "choice_d": "Sandbox",
    "correct_answer": "C",
    "explanation": "The JVM is the runtime virtual machine that allows the execution of Java code on a device.  The JVM implements the Java sandbox but that is only one of its many functions.  Rory's code may be stored in a code repository and tracked using change management tools, but the JVM does not play either of those roles.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      617,
      621,
      628,
      670,
      818
    ],
    "source": ""
  },
  {
    "id": 3969,
    "question": "Roger found the following command in a list of logged activity from a system on his network. <br><code>curl -H \"Content-Type: application/json\" -X POST -d '{\"week\": 10, \"hrv\": 80, \"sleephrs\": 9, \"sleepquality\": 2, \"stress\": 3, \"paxid\": 1</code> <br><code>}' https://execute.mysite.com/v1</code> <br>What technology is in use here?",
    "choice_a": "API",
    "choice_b": "COTS",
    "choice_c": "SQLi",
    "choice_d": "XSS",
    "correct_answer": "A",
    "explanation": "This is an example of an API call to an external service.  It is not possible to tell whether it used a commercial-off-the-shelf (COTS) package.  Curl itself is an open-source tool.  There is no indication of a cross-site scripting (XSS) or SQL injection (SQLi) attack.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      892,
      828,
      802,
      1010,
      658
    ],
    "source": ""
  },
  {
    "id": 3970,
    "question": "Which of the following is not an element of configuration management?",
    "choice_a": "Supporting rollback",
    "choice_b": "Detailed documentation",
    "choice_c": "Auditing of current status",
    "choice_d": "Use of the spiral model of project management",
    "correct_answer": "D",
    "explanation": "The spiral model of project management does not directly relate to configuration management. Configuration management is about managing change that could result in reduced security.  This includes supporting rollback of changes, maintaining detailed documentation, and running configuration audits.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      624,
      622,
      623,
      1032,
      1030
    ],
    "source": ""
  },
  {
    "id": 3971,
    "question": "Darren is working to understand the different software engineering tools used in his organization. <br>Which of the following is an example of an interpreted programming language?",
    "choice_a": "C++",
    "choice_b": "VBScript",
    "choice_c": "Java",
    "choice_d": "Fortran",
    "correct_answer": "B",
    "explanation": "VBScript is the only example of an interpreted language listed. C++, Java, and Fortran are compiled languages.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      617,
      814,
      815,
      619,
      622
    ],
    "source": ""
  },
  {
    "id": 3972,
    "question": "The ____________ data model has data stored in more than one database, but the data is still logically connected. The user perceives the database as a single entity, even though it comprises numerous parts interconnected over a network.",
    "choice_a": "Hierarchical",
    "choice_b": "Normalized",
    "choice_c": "Distributed",
    "choice_d": "Relational",
    "correct_answer": "C",
    "explanation": "The distributed data model has data stored in more than one database, but the data is still logically connected. The user perceives the database as a single entity, even though it comprises numerous parts interconnected over a network.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      631,
      630,
      633,
      634,
      635
    ],
    "source": ""
  },
  {
    "id": 3973,
    "question": "In an Agile software development process, how often should business users be involved in development?",
    "choice_a": "Daily",
    "choice_b": "Weekly",
    "choice_c": "Monthly",
    "choice_d": "At each release",
    "correct_answer": "A",
    "explanation": "The Agile development process requires that business users interact with developers on a daily basis.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      1033,
      622,
      640,
      625,
      982
    ],
    "source": ""
  },
  {
    "id": 3974,
    "question": "A server administrator recently modified the configuration for a server to improve performance. Unfortunately, when an automated script runs once a week, the modification causes the server to reboot. It took several hours of troubleshooting to ultimately determine the problem wasn't with the script but instead with the modification. <br>What could have prevented this?",
    "choice_a": "Vulnerability management",
    "choice_b": "Patch management",
    "choice_c": "Change management",
    "choice_d": "Blocking all scripts",
    "correct_answer": "C",
    "explanation": "An effective change management program helps prevent outages from unauthorized changes. Vulnerability management helps detect weaknesses but wouldn't block the problems from this modification. Patch management ensures systems are kept up-to-date. Blocking scripts removes automation, which would increase the overall workload.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      624,
      640,
      1032,
      1030,
      818
    ],
    "source": ""
  },
  {
    "id": 3975,
    "question": "Renee is a software developer seeking to access information stored in her organization's database from code she is writing. <br>Which one of the following standards might provide a mechanism for retrieving this data?",
    "choice_a": "IDE",
    "choice_b": "TCO",
    "choice_c": "OWASP",
    "choice_d": "ODBC",
    "correct_answer": "D",
    "explanation": "Open Database Connectivity (ODBC) is a database feature that allows applications to communicate with different types of databases without having to be directly programmed for interaction with each type. ODBC acts as a proxy between applications and backend database drivers, giving application programmers greater freedom in creating solutions without having to worry about the backend database system.  TCO is the total cost of ownership, not a data access methodology.  Integrated development environments (IDE) may provide Renee with the ability to improve her code-writing efficiency, but it is not a means for her code to access a database.  The Open Web Application Security Project (OWASP) provides web application security standards and tools.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      630,
      631,
      632,
      628,
      669
    ],
    "source": ""
  },
  {
    "id": 3976,
    "question": "Tom is investigating a security incident and found that the attacker was able to directly modify the contents of a system's memory. <br>What type of application vulnerability would most directly facilitate this action?",
    "choice_a": "Rootkit",
    "choice_b": "Back door",
    "choice_c": "TOC/TOU",
    "choice_d": "Buffer overflow",
    "correct_answer": "D",
    "explanation": "Buffer overflow attacks allow an attacker to modify the contents of a system's memory by writing beyond the space allocated for a variable.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      654,
      673,
      668,
      674,
      660
    ],
    "source": ""
  },
  {
    "id": 3977,
    "question": "Which one of the following attacks allows an attacker to execute targeted commands against the database supporting a web application?",
    "choice_a": "SQL injection",
    "choice_b": "Transaction manipulation",
    "choice_c": "Cross-site scripting",
    "choice_d": "Parameter manipulation",
    "correct_answer": "A",
    "explanation": "SQL injection attacks allow attackers to include their own SQL commands in the commands issued by a web application to a database.",
    "topic_id": 8,
    "practice_test_id": 7,
    "related_articles": [
      658,
      661,
      669,
      672,
      668
    ],
    "source": ""
  },
  {
    "id": 3978,
    "question": "There's an almost infinite possibility of threats, so it's important to use a structured approach to accurately identify relevant threats. <br>What are the common examples of threat modeling approaches? (Select all that apply.)",
    "choice_a": "Focus on attackers",
    "choice_b": "Focus on insiders",
    "choice_c": "Focus on assets",
    "choice_d": "Focus on stakeholders",
    "correct_answer": [
      "A",
      "C",
      "E"
    ],
    "explanation": "The three common threat modeling approaches from this list of options are focus on attackers, focus on assets, and focus on software. Focus on insiders and focus on stakeholders may have some benefit for threat evaluation, but they are not widely recognized as common approaches to threat modeling.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      228,
      221,
      226,
      230,
      324
    ],
    "source": "",
    "choice_e": "Focus on software"
  },
  {
    "id": 3979,
    "question": "The absence of which of the following can result in the perception that due care is not being maintained?",
    "choice_a": "Periodic security audits",
    "choice_b": "Deployment of all necessary security controls as determined by risk management",
    "choice_c": "Crafting of policies, standards, guidelines, and procedures",
    "choice_d": "Establishment of a board of directors",
    "correct_answer": "A",
    "explanation": "Failing to perform periodic security audits can result in the perception that due care is not being maintained. Due care is practicing the individual activities that maintain the due diligence effort. Due diligence is establishing a plan, policy, and process to protect the interests of an organization. Due diligence often includes deployment of all necessary security controls as determined by risk management; crafting of policies, standards, guidelines, and procedures; and establishment of a board of directors.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      20,
      15,
      32,
      47,
      53
    ],
    "source": ""
  },
  {
    "id": 3980,
    "question": "Which of the following is not true?",
    "choice_a": "Violations of confidentiality include human error.",
    "choice_b": "Violations of confidentiality include management oversight.",
    "choice_c": "Violations of confidentiality are limited to direct intentional attacks.",
    "choice_d": "Violations of confidentiality can occur when a transmission is not properly encrypted.",
    "correct_answer": "C",
    "explanation": "Violations of confidentiality are not limited to direct intentional attacks. Many instances of unauthorized disclosure of sensitive or confidential information are due to human error, oversight, or ineptitude (i.e., not using security mechanisms properly such as transportation encryption).",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      4,
      40,
      67,
      20,
      8
    ],
    "source": ""
  },
  {
    "id": 3981,
    "question": "A divestiture or any form of asset or employee reduction is another time period of increased risk and thus increased need for focused security governance. <br>Which of the following are security processes that should be implemented to reduce the risk associated with a divestiture event?  (Select all that apply.)",
    "choice_a": "Update firmware.",
    "choice_b": "Sanitize assets.",
    "choice_c": "Storage media should be removed and destroyed.",
    "choice_d": "Renew system certificates.",
    "correct_answer": [
      "B",
      "C",
      "E"
    ],
    "explanation": "A divestiture occurs when something is being removed from the organization, whether a device, service, employee, or partnership. Security processes should be implemented at these times to reduce the risk of data loss and leakage, such as sanitizing assets, remove and destroy storage media, and debrief ex-employees. <br>What is not needed is to update the firmware of, renew system certificates for, or propose feature improvements for devices being disposed of.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      37,
      41,
      46,
      14,
      42
    ],
    "source": "",
    "choice_e": "Employees released from duty need to be debriefed.",
    "choice_f": "Propose feature improvements."
  },
  {
    "id": 3982,
    "question": "Once the main security policies are set, then the remaining security documentation can be crafted under the guidance of those policies. Standards define compulsory requirements for the homogenous use of hardware, software, technology, and security controls. From the standards are derived baselines. <br>Which of the following is true in regard to baselines?  (Select all that apply.)",
    "choice_a": "A baseline defines a minimum level of security that every system throughout the organization must meet.",
    "choice_b": "A baseline offers recommendations on how security requirements are implemented and serves as an operational guide for both security professionals and users.",
    "choice_c": "A baseline is a more operationally focused form of a standard.",
    "choice_d": "All systems not complying with the baseline should be taken out of production until they can be brought up to the baseline.",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E"
    ],
    "explanation": "A baseline defines a minimum level of security that every system throughout the organization must meet. A baseline is a more operationally focused form of a standard. All systems not complying with the baseline should be taken out of production until they can be brought up to the baseline. Baselines are usually system specific and often refer to an industry or government standard. The other options are not true for baselines. A guideline offers recommendations on how security requirements (i.e., standards and baselines) are implemented and serves as an operational guide for both security professionals and users. The security policy is an overview or generalization of an organization's security needs.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      22,
      11,
      14,
      15,
      47
    ],
    "source": "",
    "choice_e": "Baselines are usually system specific and often refer to an industry or government standard.",
    "choice_f": "A baseline is an overview or generalization of an organization's security needs."
  },
  {
    "id": 3983,
    "question": "A supply chain is the concept that most computers, devices, networks, systems, and even cloud services are not built by a single entity. <br>Which of the following is a hardware asset related risk associated with a compromised supply chain?",
    "choice_a": "Out of date software",
    "choice_b": "Short term service support",
    "choice_c": "Compatibility with existing products",
    "choice_d": "Embedded listening devices",
    "correct_answer": "D",
    "explanation": "The primary risk from this list of options of hardware assets related to a compromised supply chain is the presence of an embedded listening device. Out of date software is always an issue, independent of supply chain concerns. For this to be a hardware supply chain risk, it would need to mention firmware or imbedded software. Short term service support is not related to supply chain issues, but the length of the warranty or service provided by the vendor to the customer. Compatibility with existing products is typically not dependent on or related to supply chain issues.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      28,
      29,
      27,
      30,
      116
    ],
    "source": ""
  },
  {
    "id": 3984,
    "question": "Remi is working on establishing a new relationship with a resource provider\u2014specifically, a software company that claims to be able to provide custom code components for a product and to provide ongoing support and management. Based on previous failures where vendors overpromised and under delivered, Remi's organization has adopted much more rigid supply chain risk management (SCRM) procedures. One of these new steps is to disclose to the third-party the security requirements and expectations of the product. <br>What is the mechanism by which these requirements are communicated to the vendor?",
    "choice_a": "SLR",
    "choice_b": "SLA",
    "choice_c": "BCP",
    "choice_d": "RoE",
    "correct_answer": "A",
    "explanation": "A service-level requirement (SLR) is a statement of the expectations of service and performance from the product or service of a vendor. Often, an SLR is provided by the customer/client prior to the establishment of the service-level agreement (SLA) (which should incorporate the elements of the SLR if the vendor expects the customer to sign the agreement). A business continuity plan (BCP) is not the right vehicle for this scenario. Rules-of-engagement (RoE) are typically the terms and limitations for a penetration testing team, and thus not relevant to this scenario.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      1,
      14,
      30,
      110,
      15
    ],
    "source": ""
  },
  {
    "id": 3985,
    "question": "Your organization works with several third-party suppliers for a wide range of services, including accounting, payroll, benefits management, help desk, incident response, log analysis, and more. The CEO has recently complained that the organization is likely wasting money due to paying for the same services from multiple providers and not taking full advantage of the services from those providers and still performing some of those tasks in-house. In order to gain a better understanding of the outsourced services as well as improve ordering convenience, manage related training, and consolidate billing, which of the following should be implemented?",
    "choice_a": "SIEM",
    "choice_b": "SLR",
    "choice_c": "VMS",
    "choice_d": "BPA",
    "correct_answer": "C",
    "explanation": "This scenario describes a situation that would benefit from a vendor management system (VMS). VMS is a software solution that assists with the management and procurement of staffing services, hardware, software, and other needed products and services. A VMS can offer ordering convenience, order distribution, order training, consolidated billing, and more. The other three options do not apply to this scenario since they are not a means to view, manage, or optimize the relationship between an organization and third-party suppliers. Security information and event management (SIEM) can be used to aggregate data sources, such as log files, perform real-time network traffic capture, and perform data analytics to provide near-real-time alerts and reports on security issues and incidents. A service-level requirement (SLR) is a statement of the expectations of service and performance from the product or service of a vendor. This is the wrong tool in this scenario since existing vendor services need to be managed and a new relationship with another vendor is not being established. A business partners agreement (BPA) is a contract between two entities dictating the terms of their business relationship. It clearly defines the expectations and obligations of each partner in the endeavor. A BPA is the closest but still an incorrect option, since it focuses on the business partner relationship rather than that of a customer to a vendor.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      38,
      116,
      20,
      81,
      15
    ],
    "source": ""
  },
  {
    "id": 3986,
    "question": "Link the term to the definition. <ol><li>Threat </li><li>Threat agent </li><li>Threat event </li><li>Threat vector </li></ol><br><ol type=\"I\"><li>Accidental occurrences and intentional exploitations of vulnerabilities </li><li>The path or means by which an attack or attacker can gain access to a target in order to cause harm </li><li>Any potential occurrence that may cause an undesirable or unwanted outcome for an organization or for a specific asset. </li><li>Entities that intentionally exploit vulnerabilities</li></ol>",
    "choice_a": "1-II, 2-I, 3-IV, 4-III",
    "choice_b": "1-I, 2-II, 3-II, 4-IV",
    "choice_c": "1-III, 2-IV, 3-I, 4-II",
    "choice_d": "1-IV, 2-III, 3-III, 4-I",
    "correct_answer": "C",
    "explanation": "The correct mapping of term to definition are as follows. Threats\u2014Any potential occurrence that may cause an undesirable or unwanted outcome for an organization or for a specific asset is a threat. Threat agents or threat actors\u2014Entities that intentionally exploit vulnerabilities. Threat events\u2014Accidental occurrences and intentional exploitations of vulnerabilities. Threat vector\u2014The path or means by which an attack or attacker can gain access to a target in order to cause harm.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      42,
      24,
      23,
      26,
      25
    ],
    "source": ""
  },
  {
    "id": 3987,
    "question": "Which of the following are true?  (Select all that apply.)",
    "choice_a": "A purely quantitative analysis is not possible.",
    "choice_b": "Qualitative risk analysis employs complex formulas and calculations.",
    "choice_c": "Quantitative risk analysis assigns real dollar figures to the loss of an asset.",
    "choice_d": "Qualitative risk analysis assigns subjective and intangible values to the loss of an asset.",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Three of these statements are true. (A) A purely quantitative analysis is not possible; (C) Quantitative risk analysis assigns real dollar figures to the loss of an asset; and (D) Qualitative risk analysis assigns subjective and intangible values to the loss of an asset. The other statement is false. Its corrected version is (B) Qualitative risk analysis <italic>does not</italic> employ complex formulas and calculations. Scenario discussions and simple value assignments are used to evaluate risk, incidents, losses, and safeguards in a qualitative risk assessment.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      44,
      70,
      45,
      73,
      46
    ],
    "source": ""
  },
  {
    "id": 3988,
    "question": "The risk management team has been diligently assessing risk and selecting appropriate response. Only a few unresolved issues remain, but they are still above the risk acceptance threshold. A member of the team recommends insurance to cover the loss potential. The purchasing of insurance is a form of ___________________.",
    "choice_a": "Risk mitigation",
    "choice_b": "Risk assignment",
    "choice_c": "Risk acceptance",
    "choice_d": "Risk rejection",
    "correct_answer": "B",
    "explanation": "Insurance is a form of risk assignment or transference. (A) Reducing risk, or risk mitigation, is the implementation of safeguards, security controls, and countermeasures to reduce and/or eliminate vulnerabilities or block threats. (C) Accepting risk or acceptance of risk is the result after a cost/benefit analysis shows that countermeasure costs would outweigh the possible cost of loss due to a risk. (D) An unacceptable possible response to risk is to reject risk or ignore risk. Denying that a risk exists and hoping that it will never be realized are not valid or prudent due care/due diligence responses to risk.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      46,
      70,
      52,
      41,
      45
    ],
    "source": ""
  },
  {
    "id": 3989,
    "question": "Which type of control provides extended options to existing controls and is used in addition to, or in place of, another control?",
    "choice_a": "Recovery control",
    "choice_b": "Corrective control",
    "choice_c": "Deterrent control",
    "choice_d": "Compensation control",
    "correct_answer": "D",
    "explanation": "A compensation control is deployed to provide various options to other existing controls to aid in enforcement and support of security policies. They can be any controls used in addition to, or in place of, another control. They can be a means to improve the effectiveness of a primary control or as the alternate or fail-over option in the event of a primary control failure. (A) Recovery controls are an extension of corrective controls but have more advanced or complex abilities. A recovery control attempts to repair or restore resources, functions, and capabilities after a security policy violation. (B) A corrective control modifies the environment to return systems to normal after an unwanted or unauthorized activity has occurred. It attempts to correct any problems that occurred as a result of a security incident. (C) A deterrent control is deployed to discourage security policy violations.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      47,
      18,
      54,
      8,
      2
    ],
    "source": ""
  },
  {
    "id": 3990,
    "question": "Which of the following are examples of risk management frameworks?  (Select all that apply.)",
    "choice_a": "RMF",
    "choice_b": "CMPP",
    "choice_c": "COSO's ERM",
    "choice_d": "ISACA's Risk IT",
    "correct_answer": [
      "A",
      "C",
      "D",
      "F",
      "H",
      "I"
    ],
    "explanation": "There are six actual risk management frameworks included in this list of options. They are: (A) Risk Management Framework (RMF) defined by NIST, (C) The Committee of Sponsoring Organizations (COSO) of the Treadway Commission's Enterprise Risk Management \u2014 Integrated Framework, (D) ISACA's Risk IT Framework, (F) Operationally Critical Threat, Asset, And Vulnerability Evaluation (OCTAVE), (H) Factor Analysis of Information Risk (FAIR), and (I) Threat Agent Risk Assessment (TARA). The other options listed are not risk management frameworks. The incorrect answers are: (B) CCMP (Counter Mode Cipher Block Chaining Message Authentication Code Protocol) is the streaming cipher variation of block ciphers, such as AES, (E) EC Council (ECC)'s Certified Ethical Hacker (CEH) is a certification focusing on penetration testing, (G) annualized rate of occurrence (ARO) is an element used in quantitative risk analysis, and (J) The National Institute of Standards and Technology (NIST) is an agency of the U.S. government that establishes security standards, including the RMF.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      50,
      44,
      45,
      49,
      53
    ],
    "source": "",
    "choice_e": "ECC's CEH",
    "choice_f": "OCTAVE",
    "choice_g": "ARO",
    "choice_h": "FAIR",
    "choice_i": "TARA",
    "choice_j": "NIST"
  },
  {
    "id": 3991,
    "question": "A company has been the victim of business email compromise. The primary manager in the accounting department paid a fraudulent invoice for $132,000. She did so based on the instructions sent to her in a message received from the CEO's email address. <br>What social engineering principle was used in this situation?",
    "choice_a": "Tailgating",
    "choice_b": "Authority",
    "choice_c": "Scarcity",
    "choice_d": "Familiarity",
    "correct_answer": "B",
    "explanation": "Business email compromise (BEC) is often performed by taking advantage of the social engineering principle of authority. The false invoice that was apparently received from the CEO makes it seem as if it originated from a proper authority. Tailgating is the abuse of someone's access into a system or facility without their consent or knowledge in order for an unauthorized person to intrude. Tailgating is not a social engineering principle. Scarcity is the social engineering principle of limited opportunity, which was not used in this situation. Familiarity is the social engineering principle of establishing or perceiving similarity, which was not used in this situation.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      56,
      57,
      60,
      62,
      71
    ],
    "source": ""
  },
  {
    "id": 3992,
    "question": "You were hired to perform a business impact analysis for a company located in Southern California and are evaluating the firm's exposure to wildfires. You've determined that the value of the firm's facilities and equipment is $10million. After consulting fire experts, you've determined that there is a 10 percent chance that the facility will be 75 percent destroyed by wildfire in a given year. <br>What is the annualized loss expectancy (ALE)?",
    "choice_a": "$100,000",
    "choice_b": "$750,000",
    "choice_c": "$7,500,000",
    "choice_d": "$10million",
    "correct_answer": "B",
    "explanation": "The annualized loss expectancy is computed by multiplying the asset value ($10million) by the exposure factor (75 percent) and then multiplying that (the SLE) by the ARO, in this example 10 percent, resulting in $750,000 ALE.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      86,
      45,
      935,
      874,
      83
    ],
    "source": ""
  },
  {
    "id": 3993,
    "question": "Which one of the following activities best ensures that individuals remain familiar with their roles in carrying out the organization's business continuity plan?",
    "choice_a": "Plan documentation",
    "choice_b": "Exercises",
    "choice_c": "Periodic reminders",
    "choice_d": "Performance reviews",
    "correct_answer": "B",
    "explanation": "All of these activities may help team members remain familiar with their business continuity responsibilities, but the best method for doing so is conducting regular business continuity exercises. These exercises include practical continuity work that keeps knowledge fresh.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      597,
      929,
      511,
      921,
      582
    ],
    "source": ""
  },
  {
    "id": 3994,
    "question": "Kevin is negotiating the software license agreement for an enterprise resource planning (ERP) system. The total value of the contract will exceed $3 million. <br>What type of software license agreement would be most appropriate for this relationship?",
    "choice_a": "Contractual agreements",
    "choice_b": "Shrink-wrap agreements",
    "choice_c": "Verbal agreements",
    "choice_d": "Click-wrap agreements",
    "correct_answer": "A",
    "explanation": "Licenses for high-value software often use contractual agreements to outline the responsibilities of both parties. Other forms of agreement, such as shrink-wrap, click-wrap, and verbal agreements, are generally not used for this type of high-stakes transaction.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      110,
      38,
      1045,
      679,
      103
    ],
    "source": ""
  },
  {
    "id": 3995,
    "question": "Which one of the following products is least likely to be regulated under import/export controls?",
    "choice_a": "Email encryption software",
    "choice_b": "High-performance computers",
    "choice_c": "Security software",
    "choice_d": "Governance, risk, and compliance management packages",
    "correct_answer": "D",
    "explanation": "Governance, risk, and compliance (GRC) solutions are generally not covered by import/export control regulations. These regulations tend to cover more technical items, such as high-performance computing, security software, and encryption technology.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      111,
      99,
      880,
      32,
      1
    ],
    "source": ""
  },
  {
    "id": 3996,
    "question": "An executive is responsible for classifying data used within the organization. However, the classification of some of the data is unclear to him. When determining the classification of data, which one of the following would be the <italic>most</italic> important consideration?",
    "choice_a": "Processing system",
    "choice_b": "Value",
    "choice_c": "Storage media",
    "choice_d": "Access controls",
    "correct_answer": "B",
    "explanation": "Data is classified based on its value to the organization. In some cases, the value is based on the potential negative impact if unauthorized personnel can access it. Data is not classified based on the processing system, but the processing system is classified based on the data it processes. Similarly, the storage media is classified based on the data classification, but the data is not classified based on where it is stored. Access controls are affected by the classification, but accessibility does not determine the classification. Personnel implement controls to limit the accessibility of sensitive data.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      143,
      121,
      124,
      138,
      125
    ],
    "source": ""
  },
  {
    "id": 3997,
    "question": "Administrators regularly back up sensitive data on servers within a data center. Security controls restrict access to the datacenter, and all systems that process sensitive information are marked. After backing up data, they send an unmarked copy to an unstaffed company warehouse for long-term storage. Recently, someone posted some of this data on the internet. Investigators determined much of the backup media is no longer in the warehouse. <br>Which of the following administrator actions would have the best chance of preventing this incident?",
    "choice_a": "Mark the tapes before sending them to the warehouse.",
    "choice_b": "Purge the tapes before backing up data to them.",
    "choice_c": "Degauss the tapes before backing up data to them.",
    "choice_d": "Add the tapes to an asset management database.",
    "correct_answer": "A",
    "explanation": "If the tapes were marked before they left the datacenter, employees would recognize their value, and it is more likely someone would challenge their storage in an unstaffed warehouse. Purging or degaussing the tapes before using them will erase previously held data but won't help if sensitive information is backed up to the tapes after they are purged or degaussed. Adding the tapes to an asset management database will help track them but wouldn't prevent this incident.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      128,
      123,
      132,
      125,
      129
    ],
    "source": ""
  },
  {
    "id": 3998,
    "question": "Which of the following provides the best description of data purging?",
    "choice_a": "Writing a series of 1s and 0s over media",
    "choice_b": "Writing a series of 1s and 0s over media multiple times",
    "choice_c": "Erasing data",
    "choice_d": "Using a magnetic field to remove data",
    "correct_answer": "B",
    "explanation": "Purging writes a series of 1s and 0s over media multiple times, and it removes all data remnants. Purging leaves media in a reusable state, instead of destroying it. Clearing writes a series of 1s and 0s over media, but this process is repeated much more when purging media. Erasing data uses system tools, such as the delete command, to delete files, but the files remain on the disk and can be retrieved. Degaussing uses a magnetic field to remove data from a magnetic tape or magnetic hard disk drive.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      129,
      1026,
      144,
      130,
      133
    ],
    "source": ""
  },
  {
    "id": 3999,
    "question": "Your company's data policy identifies several data roles and their responsibilities. It mentions the data custodian. <br>Which of the following tasks would the data custodian be responsible for completing?",
    "choice_a": "Classifying data",
    "choice_b": "Backing up data",
    "choice_c": "Processing data",
    "choice_d": "Deciding what a data processor should do",
    "correct_answer": "B",
    "explanation": "The data custodian is responsible for day-to-day tasks to protect data, such as backing up data. Data owners have the ultimate responsibility for protecting data, and they identify the classification of data. A data processor controls the processing of the data, based on what the data controller tells them. A data controller decides what data to process and how to process it.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      138,
      989,
      143,
      988,
      139
    ],
    "source": ""
  },
  {
    "id": 4000,
    "question": "A large financial organization maintains a data center within its building. A recent audit told them they need to have all the data mirrored offsite. <br>Which of the following is a primary consideration for this mirrored data?",
    "choice_a": "Data collection",
    "choice_b": "Data retention",
    "choice_c": "Data location",
    "choice_d": "Data remanence",
    "correct_answer": "C",
    "explanation": "A primary consideration for this mirrored site is the location. Some financial guidelines require a mirrored site to be a minimum distance away, such as at least 20 miles away. Data collection refers to limiting the amount of data collected, data retention refers to how long the data should be maintained, and data remanence refers to data that remains on media. However, this scenario focuses on the mirrored site, which holds a mirror copy of the data at the primary location.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      132,
      708,
      133,
      131,
      125
    ],
    "source": ""
  },
  {
    "id": 4001,
    "question": "Administrators are required to keep logs for a minimum of five years on several servers. <br>Which of the following is the most likely reason for this policy?",
    "choice_a": "Data remanence guidelines",
    "choice_b": "Record retention policies",
    "choice_c": "Data destruction processes",
    "choice_d": "Data collection procedures",
    "correct_answer": "B",
    "explanation": "Record retention policies define the amount of time to keep any data, including logs. Laws and regulations that apply to an organization often dictate how long to save data. Still, all organizations should keep data as long as they are required to do so. Data remanence is data remnants on media, and proper data destruction processes ensure discarded media don't retain any data. Data collection procedures indicate that organizations should collect only the minimum amount of data they need.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      133,
      126,
      851,
      850,
      852
    ],
    "source": ""
  },
  {
    "id": 4002,
    "question": "A technician came across a collection of DVDs. Some appear to be blank, but others have data written to them and the classification of the data isn't clear. A supervisor tells the technician to dispose of them. <br>Which of the following methods would be the most secure method of disposing of the DVDs?",
    "choice_a": "Formatting them and throwing them in the trash",
    "choice_b": "Deleting them and throwing them in the trash",
    "choice_c": "Destroying them in an incinerator",
    "choice_d": "Degaussing them and throwing them in the trash",
    "correct_answer": "C",
    "explanation": "Physical destruction is the most secure method of deleting data on optical media such asa DVD. Formatting and deleting processes rarely remove the data from any media. DVDs do not have magnetic flux, so degaussing a DVD doesn't destroy data.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      1026,
      129,
      130,
      144,
      133
    ],
    "source": ""
  },
  {
    "id": 4003,
    "question": "Which of the following <italic>best</italic> describes the tailoring process?",
    "choice_a": "Assigning different values for a control",
    "choice_b": "Removing controls from a suggested baseline",
    "choice_c": "Selecting a baseline",
    "choice_d": "Creating an image of a system",
    "correct_answer": "A",
    "explanation": "The tailoring process refers to modifying a list of controls to align with the organization's mission. One way it does so is by modifying control parameters, such as changing the account lockout threshold. Scoping is specifically used to remove controls from a suggested baseline. While tailoring includes scoping, assigning different values for controls only apples to tailoring. Tailoring is done after selecting a baseline. Tailoring doesn't include creating an image.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      141,
      140,
      142,
      138,
      143
    ],
    "source": ""
  },
  {
    "id": 4004,
    "question": "A hospital maintains patient medical records. Management has decided to modify all the records by replacing the patient names with a patient number. A separate database holds the mapping for each patient number to the correct patient name so that the hospital can retrieve the original data. <br>What does this describe?",
    "choice_a": "Anonymization",
    "choice_b": "Tokenization",
    "choice_c": "Pseudonymization",
    "choice_d": "Encryption",
    "correct_answer": "C",
    "explanation": "Pseudonymization replaces data with a pseudonym or alias to protect the privacy of individuals identified in the original dataset. A separate database holds the actual identities so that authorized entities can retrieve them when necessary. Anonymization attempts to permanently remove all privacy data from a database to ensure the original data can't be recovered. Tokenization replaces sensitive data with a string of characters, or a token. The original data is held by a third party but not retrievable. Encryption converts plaintext into ciphertext.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      136,
      137,
      143,
      120,
      126
    ],
    "source": ""
  },
  {
    "id": 4005,
    "question": "You are implementing digital rights management (DRM) security controls to protect the intellectual property created by your company. <br>Which of the following will these controls <italic>most</italic> likely protect?",
    "choice_a": "Trademarks",
    "choice_b": "Patents",
    "choice_c": "Trade secrets",
    "choice_d": "Copyright",
    "correct_answer": "D",
    "explanation": "DRM methods attempt to provide copyright protection for copyrighted works, including intellectual property. They do not provide protection for trademarks, patents, or trade secrets.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      134,
      144,
      143,
      120,
      136
    ],
    "source": ""
  },
  {
    "id": 4006,
    "question": "Your organization has a database of customer data. To comply with the EU GDPR, administrators plan to use pseudonymization. <br>Which of the following <italic>best</italic> describes pseudonymization?",
    "choice_a": "The process of replacing some data with another identifier",
    "choice_b": "The process of removing all personal data",
    "choice_c": "The process of encrypting data",
    "choice_d": "The process of storing data",
    "correct_answer": "A",
    "explanation": "Pseudonymization is the process of replacing some data with an identifier, such as apseudonym. This makes it challenging to identify an individual from the data. Removing personal data without using an identifier is closer to anonymization. Encrypting data is alogical alternative to pseudonymization because it makes it difficult to view the data. Data should be stored in such a way that it is protected against any type of loss, but this is unrelated to pseudonymization.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      136,
      137,
      143,
      139,
      126
    ],
    "source": ""
  },
  {
    "id": 4007,
    "question": "Kaitlyn is concerned about the security of data users are retrieving from a website and would like to apply an appropriate cryptographic solution. <br>What type of use case is she attempting to secure?",
    "choice_a": "Data at rest",
    "choice_b": "Data in use",
    "choice_c": "Data in motion",
    "choice_d": "Data in disposal",
    "correct_answer": "C",
    "explanation": "Kaitlyn is specifically concerned about information that users are retrieving. Therefore, she is considering a data in motion use case.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      145,
      172,
      179,
      181,
      186
    ],
    "source": ""
  },
  {
    "id": 4008,
    "question": "Matthew receives a digitally signed message from Christopher. <br>What key should Matthew use in the process of verifying the digital signature?",
    "choice_a": "Christopher's public key",
    "choice_b": "Christopher's private key",
    "choice_c": "Matthew's public key",
    "choice_d": "Matthew's private key",
    "correct_answer": "A",
    "explanation": "Matthew uses Christopher's public key to verify the digital signature on the message. Christopher created the digital signature using his own private key. Matthew's keys are not used in the case where Christopher creates the signature.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      176,
      175,
      200,
      154,
      198
    ],
    "source": ""
  },
  {
    "id": 4009,
    "question": "Christopher would like to send Renee a message using a digital signature. <br>What key should he use to create the digital signature?",
    "choice_a": "Christopher's public key",
    "choice_b": "Christopher's private key",
    "choice_c": "Renee's public key",
    "choice_d": "Renee's private key",
    "correct_answer": "B",
    "explanation": "The sender of a message uses their own private key to create a digital signature. They first use a hash function to generate a message digest and then encrypt that digest with their private key to create the digital signature. The recipient can then decrypt the digital signature with the sender's public key to verify that it contains a valid hash.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      176,
      175,
      198,
      154,
      200
    ],
    "source": ""
  },
  {
    "id": 4010,
    "question": "Matthew and Richard want to communicate with each other using a public key cryptosystem. <br>What is the total number of keys they must have to successfully communicate in either direction securely?",
    "choice_a": "1",
    "choice_b": "2",
    "choice_c": "3",
    "choice_d": "4",
    "correct_answer": "D",
    "explanation": "To use public key cryptography, Matthew and Richard must each have their own pair of public and private cryptographic keys.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      167,
      198,
      200,
      154,
      176
    ],
    "source": ""
  },
  {
    "id": 4011,
    "question": "What encryption technology was introduced with the release of WPA3 to provide an alternative to the use of preshared keys?",
    "choice_a": "TKIP",
    "choice_b": "CCMP",
    "choice_c": "SAE",
    "choice_d": "AES",
    "correct_answer": "C",
    "explanation": "Simultaneous Authentication of Equals (SAE) was introduced with WPA3 as an alternative to preshared keys. TKIP was introduced with the original version of WPA and was replaced with the AES-based CCMP in WPA2.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      187,
      169,
      179,
      199,
      186
    ],
    "source": ""
  },
  {
    "id": 4012,
    "question": "Cathy has been assigned the task of adding security to an existing business process. The process was first implemented 7 years ago by a developer who is no longer with the organization. Several other programmers have crafted new features, added compensation code, or expanded on the original software. The code now has a massive feature and capability list, but the company only uses a small number of functions. After a thorough evaluation and consulting with numerous experts, Cathy proposes to the CISO that the current program be discarded and new software be created that supports only the current business tasks. <br>What is the issue that was violated here that led to the recommendation?",
    "choice_a": "Don't Repeat Yourself",
    "choice_b": "Rule of least power",
    "choice_c": "You aren't gonna need it",
    "choice_d": "Keep it simple",
    "correct_answer": "D",
    "explanation": "This scenario describes an overly complex program that has been expanded and extended over time and that has many more features than is actually required for current business tasks. This is a clear violation of \"keep it simple.\" In the realm of security, this concept is the encouragement to avoid overcomplicating the environment, organization, or product design. The more complex a system, the more difficult it is to secure. The other options are incorrect, since they don't directly reference the size/complexity vs. security issue. Option A is incorrect because Don't Repeat Yourself (DRY) is the idea of eliminating redundancy in software by not repeating the same code in multiple places, which would increase the difficulty if changes are needed. Option B is incorrect because the rule of least power specifies using the least powerful programming language that is suitable for the needed solution. Option D, \"You aren't gonna need it (YAGNI),\"is the concept that programmers should not add capabilities and functions until they are actually necessary, so rather than create it when you think of it, instead create it only when you actually need it.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      206,
      211,
      226,
      215,
      228
    ],
    "source": ""
  },
  {
    "id": 4013,
    "question": "What is the primary distinction of the current Common Criteria from the previous security evaluation criteria systems it replaced?",
    "choice_a": "It only assesses confidentiality.",
    "choice_b": "It is limited to evaluate standalone systems.",
    "choice_c": "It is a dynamic and subjective evaluation.",
    "choice_d": "It is based onlyon mandatory access controls.",
    "correct_answer": "C",
    "explanation": "The primary distinction of the current Common Criteria (CC) from the previous security evaluation criteria systems it replaced is that the CC is a dynamic and subjective evaluation of security mechanisms and functions via the protection profiles (PPs) and security targets (STs) comparison mechanism. Most previous systems were static in their evaluation of security protection mechanisms. The other options are incorrect. CC is not limited to confidentiality assessment, is not limited to evaluate standalone systems, and is not based only on mandatory access controls. These are characteristics of prior evaluation criteria systems, which were replaced by CC.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      223,
      221,
      228,
      226,
      292
    ],
    "source": ""
  },
  {
    "id": 4014,
    "question": "A recent DDoS attack kept several e-commerce platforms offline for hours. Analysis of the attack has determined that most of the traffic originated from home automation equipment, IP cameras, and even medical equipment. Each of these systems were using a common OS extension that had a vulnerability that was exploited to plant the botnet code. A patch was released by the vendors of these products to allow customers to update their devices. <br>What type of equipment was being inappropriately accessed in this situation?",
    "choice_a": "SoC",
    "choice_b": "ICS",
    "choice_c": "IoT",
    "choice_d": "NGFW",
    "correct_answer": "C",
    "explanation": "This scenario describes the botnet as running from devices which can be labeled as Internet of Things (IoT). This scenario does not describe devices that are system on chip (SoC), industrial control system (ICS), or next-generation firewall (NGFW).",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      258,
      262,
      253,
      289,
      211
    ],
    "source": ""
  },
  {
    "id": 4015,
    "question": "What is the concept of a computer implemented as part of a larger system that is typically designed around a limited set of specific functions (such as management, monitoring, and control) in relation to the larger product of which it's a component?",
    "choice_a": "IoT",
    "choice_b": "Microservice",
    "choice_c": "SoC",
    "choice_d": "Embedded system",
    "correct_answer": "D",
    "explanation": "An embedded system is a computer implemented as part of a larger system. The embedded system is typically designed around a limited set of specific functions in relation to the larger product of which it's a component. It may consist of the same components found in a typical computer system, or it may be a microcontroller. The Internet of Things (IoT) is a class of smart devices that are internet-connected in order to provide automation, remote control, or AI processing to appliances or devices. A micro-service is simply one element, feature, capability, business logic, or function of a web application that can be called on or used by other web applications. It is a software concept, not a hardware device. A system on a chip (SoC) is an integrated circuit (IC) or chip that has all of the elements of a computer integrated into a single chip. An SoC may be the main component of a microcontroller that is used to control or manage another system. An SoC is not considered an embedded device.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      262,
      258,
      940,
      243,
      211
    ],
    "source": ""
  },
  {
    "id": 4016,
    "question": "Your company has recently decided to allow mobile devices to be used to access certain business data and to be another means by which some work tasks can be accomplished. <br>What technology provides an organization with the best security control over mobile device equipment?",
    "choice_a": "Application allow listing",
    "choice_b": "UEM",
    "choice_c": "Encrypted removable storage",
    "choice_d": "Geotagging",
    "correct_answer": "B",
    "explanation": "Unified endpoint management (UEM) is type of software tool that provides a single management platform to control mobile, PC, IoT, wearables, ICSs, and other devices. UEM is intended to replace MDM and enterprise mobility management (EMM) products by combining the features of numerous products into one solution. UEM and MDM are a software solution to the challenging task of managing the myriad mobile devices that employees use to access company resources. The goals of UEM and MDM are to improve security, provide monitoring, enable remote management, and support troubleshooting. Application allow listing may be an element of mobile device management but is only part of a full UEM/MDM solution. Not all mobile devices support removable storage, and even fewer support encrypted removable storage. Geotagging is used to mark photos and social network posts, not for mobile device management.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      277,
      281,
      283,
      284,
      276
    ],
    "source": ""
  },
  {
    "id": 4017,
    "question": "You have been asked to review the security zones of the facility and evaluate the worker travel paths. <br>Which of the following should be generally worker/user accessible?",
    "choice_a": "Mission-critical data center",
    "choice_b": "Main workspaces",
    "choice_c": "Server vault",
    "choice_d": "Wiring closet",
    "correct_answer": "B",
    "explanation": "Only the main workspaces should be generally worker/user accessible. The mission-critical data center, server vault, and wiring closets should be restricted to administrators and other specialized and authorized personnel.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      324,
      305,
      308,
      307,
      201
    ],
    "source": ""
  },
  {
    "id": 4018,
    "question": "Your company is installing new physical intrusion detection systems in its four separate buildings. There is some concern that a burglar may be able to bypass the detectors or block the alert notifications. The installers assure you that the system has a heartbeat sensor that addresses those concerns. <br>What is a heartbeat sensor?",
    "choice_a": "A type of motion detection that can sense the presence of a living being's pulse",
    "choice_b": "A tool that ensures that if power is lost a battery backup is present to provide temporary electrical supply",
    "choice_c": "A mechanism by which the communication pathway is either constantly or periodically checked with a test signal",
    "choice_d": "A device that transmits a consistent low ultrasonic or high microwave frequency signal into a monitored area and monitors for significant or meaningful changes or disturbances in the reflected pattern",
    "correct_answer": "C",
    "explanation": "A heartbeat sensor is a mechanism by which the communication pathway is either constantly or periodically checked with a test signal. If the receiving station detects a failed heartbeat signal, such as the loss of the constant signal or missing one or two interval checks, the alarm triggers automatically. This measure is designed to prevent intruders from circumventing the detection and alarm system by cutting power, cutting communication cables, or jamming radio signals. The other answer options are incorrect. There is not a current technology that can generally sense the presence of a living being's pulse from a distance as a form of motion or intrusion detection. Battery backup or a UPS ensures that if power is lost that a battery backup is present to provide temporary electrical supply. A wave pattern motion detector transmits a consistent low ultrasonic or high microwave frequency signal into a monitored area and monitors for significant or meaningful changes or disturbances in the reflected pattern.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      327,
      309,
      324,
      318,
      262
    ],
    "source": ""
  },
  {
    "id": 4019,
    "question": "The CISO has requested that you establish a monitoring plan in order to track how well the security efforts are performing through the organization. You've been asked to start collecting data immediately and then provide quarterly reports starting six months from now. You realize that in order to obtain the most useful information for these reports you need to monitor the organization's KPIs. <br>Which of the following are likely relevant KPI for physical security?  (Select all that apply.)",
    "choice_a": "Number of successful intrusions",
    "choice_b": "Number of compromised accounts",
    "choice_c": "Number of successful disruptions",
    "choice_d": "Number of unsuccessful incidents",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E",
      "H",
      "I",
      "K"
    ],
    "explanation": "There are many key performance indicators(KPIs) that are relevant to physical security. The ones from this list of options are: number of successful intrusions, number of successful disruptions, number of unsuccessful incidents, time to detect incidents, time to respond to incidents, level of organizational impact of incidents, and number of false positives (i.e., false detection alerts/alarms). The other options are incorrect.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      536,
      538,
      548,
      531,
      580
    ],
    "source": "",
    "choice_e": "Time to detect incidents",
    "choice_f": "Rate of session disconnects",
    "choice_g": "Transmission errors per second",
    "choice_h": "Time to respond to incidents",
    "choice_i": "Level of organizational impact of incidents",
    "choice_j": "Number of transactions per minute",
    "choice_k": "Number of false positives (i.e., false detection alerts/alarms)"
  },
  {
    "id": 4020,
    "question": "Network-layer traffic is designed to use logical addresses. These addresses are used in making routing decisions to direct the communication toward its destination. <br>Which of the following protocol header items can be used to prevent infinite transmission?  (Select all that apply.)",
    "choice_a": "Sliding windows",
    "choice_b": "Hop limit",
    "choice_c": "Time to live",
    "choice_d": "QoS",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "The hop limit IPv6 header value and the time to live (TTL) IPv4 header values are both used to prevent infinite transmission. Sliding windows are used to control the number of packets sent in a set before an acknowledgment is expected; this is a TCP header field. QoS is an IPv6 header field used to prioritize traffic transmission. The acknowledgment sequence number is a TCP header field used to confirm the receipt of segments.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      345,
      346,
      333,
      394,
      868
    ],
    "source": "",
    "choice_e": "Acknowledgment sequence number"
  },
  {
    "id": 4021,
    "question": "Your organization is redesigning its IT infrastructure to increase ease of management and add new capabilities. The leadership has issued a mandate that a SAN solution is needed and that all landline-based telephone services are to be removed. The mandate also indicates that replacement solutions should integrate into the overall IT environment seamlessly. <br>Which of the following technologies would be worth considering in this scenario? (Select all that apply.)",
    "choice_a": "Iscsi",
    "choice_b": "VoIP",
    "choice_c": "FCoE",
    "choice_d": "TFTP",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "VoIP, iSCSI and FCoE are converged protocols, which provide for a SAN and voice communication services. Trivial File Transfer Protocol (TFTP) is not an example of a converged protocol, nor is it relevant to this scenario.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      352,
      353,
      398,
      330,
      333
    ],
    "source": ""
  },
  {
    "id": 4022,
    "question": "The CISO is concerned with recent news reports of intrusions that were able to compromise all internal systems from a single breached edge device. You've been tasked with designing a network segmentation strategy to limit this risk. <br>Which of the following is not an example of network segmentation?",
    "choice_a": "Intranet",
    "choice_b": "subnet",
    "choice_c": "Extranet",
    "choice_d": "VPN",
    "correct_answer": "D",
    "explanation": "A VPN is a secure tunnel used to establish connections across a potentially insecure intermediary network. Intranet, subnet, extranet, and VLAN are examples of network segmentation.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      866,
      356,
      421,
      412,
      417
    ],
    "source": ""
  },
  {
    "id": 4023,
    "question": "You notice a message on your system that asks you to visit a web URL in order to confirm your identity. You don't recognize the site. You also realize that the message seems to be handled by your Bluetooth subsystem. You think you have been the victim of bluejacking. <br>What was compromised?",
    "choice_a": "Your firewall",
    "choice_b": "Your switch",
    "choice_c": "Your cell phone",
    "choice_d": "Your account",
    "correct_answer": "C",
    "explanation": "This scenario is describing a bluejacking attack. A bluejacking attack is a wireless attack on Bluetooth, and the most common device compromised in a bluejacking attack is a cell phone. Firewalls and switches do not usually support Bluetooth; therefore, they are not subject to bluejacking attacks. Although the bluejacking attack included an inducement to visit a web URL to confirm identity, the scenario does not indicate that the URL was visited or that the requested information was provided. Thus, there is no evidence that your account was compromised.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      364,
      330,
      1012,
      379,
      389
    ],
    "source": ""
  },
  {
    "id": 4025,
    "question": "An organization wants to improve the security of their DNS operations by implementing DNSSEC. <br>Which of the following is most important to support this new security mechanism?",
    "choice_a": "HTTPS",
    "choice_b": "HSM",
    "choice_c": "LDAPS",
    "choice_d": "PKI",
    "correct_answer": "D",
    "explanation": "DNSSEC uses certificates to perform mutual authentication between DNS servers, and thus public key infrastructure (PKI) is needed to provide and support those certificates. HTTPS is not involved in DNSSEC but is the basis for DoH. A hardware security module(HSM) is not used in DNSSEC. LDAPS is not related to DNSSEC.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      343,
      341,
      409,
      391,
      339
    ],
    "source": ""
  },
  {
    "id": 4026,
    "question": "What is a distinctive benefit of deploying an application-aware device as compared to a generic firewall appliance when applying mitigation techniques to resolve issues related to endpoint incidents?",
    "choice_a": "Traffic filtering",
    "choice_b": "NAT services",
    "choice_c": "Deep packet inspection",
    "choice_d": "Network segmentation",
    "correct_answer": "C",
    "explanation": "Often application-aware devices are able to provide deep packet or content inspection and filtering based on their focus on specific applications and protocols. A web application firewall (WAF) is an example of an application-aware device that can provide deep packet or content inspection. This is a distinct benefit compared to a generic firewall appliance. Both devices can typically provide traffic filtering, NAT services, and network segmentation.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      375,
      376,
      379,
      357,
      330
    ],
    "source": ""
  },
  {
    "id": 4027,
    "question": "A recent update to network devices has resulted in some communication failures. Workers are complaining that they are unable to access external resources that they typically use for work functions. While evaluating the issue, you determine that internal resources are still being accessed without issue. <br>Which of the following is likely related to the networking issue?",
    "choice_a": "BGP",
    "choice_b": "RIP",
    "choice_c": "OSPF",
    "choice_d": "IGRP",
    "correct_answer": "A",
    "explanation": "Border Gateway Protocol (BGP) is the primary example of an exterior routing protocol. This scenario describes a situation where network device updates caused problems with external communications. If the device was a border router, maybe the update corrupted its BGP table, which is preventing proper routing to external systems. The other options are all interior routing protocols: Routing Information Protocol (RIP), Open Shortest Path First (OSPF), and Interior Gateway Routing Protocol (IGRP), which were seemingly not affected since internal communications are taking place without issue.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      331,
      345,
      333,
      743,
      358
    ],
    "source": ""
  },
  {
    "id": 4028,
    "question": "Which wireless frequency access method offers the greatest throughput with the least interference?",
    "choice_a": "FHSS",
    "choice_b": "DSSS",
    "choice_c": "OFDM",
    "choice_d": "OSPF",
    "correct_answer": "C",
    "explanation": "Orthogonal Frequency-Division Multiplexing (OFDM) offers high throughput with the least interference. OFDM employs a digital multi-carrier modulation scheme that allows for a more tightly compacted transmission. The modulated signals are perpendicular (orthogonal) and thus do not cause interference with each other. This makes OFDM superior to FHSS and DSSS in throughput and interference. OSPF is a routing protocol, not a wireless frequency access method.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      366,
      388,
      359,
      360,
      370
    ],
    "source": ""
  },
  {
    "id": 4029,
    "question": "System hardening is an important element of security management. It involves removing what is not needed and securing what is left. <br>What security concept encourages administrators to install firewalls, malware scanners, and an IDS on every host?",
    "choice_a": "Endpoint security",
    "choice_b": "Network access control (NAC)",
    "choice_c": "VLAN",
    "choice_d": "RADIUS",
    "correct_answer": "A",
    "explanation": "Endpoint security is the security concept that encourages administrators to install firewalls, malware scanners, and an IDS on every host. NAC is the concept of controlling access to an environment through strict adherence to and enforcement of security policy. VLANs are virtual network segments created by a switch. RADIUS is an authentication, authorization, and accounting (AAA) service or remote authentication technology.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      379,
      388,
      377,
      357,
      393
    ],
    "source": ""
  },
  {
    "id": 4030,
    "question": "Literally hundreds of protocols are supported by TCP/IP. While working with a network sniffer, you discover several packets containing protocols that you had not seen on the local network before. Before reporting these as anomalies to be investigated, you need to determine what they are used for and if they work together. <br>What communications concept is related to both TFTP and IGMP?",
    "choice_a": "Simplex",
    "choice_b": "Analog",
    "choice_c": "Broadband",
    "choice_d": "Multicasting",
    "correct_answer": "D",
    "explanation": "Multicasting is the transmission of data to multiple specific recipients. Internet Group Management Protocol (IGMP) is used to register a host's dynamic multicast group membership in order to receive a copy of the data stream. TFTP systems can be used to host or cache multicast datasets that are to be sent to the multiple recipients. The other options are incorrect. Simplex is a one-way communication. Although multiplexing is typically one-way, and TFTP operates over the UDP protocol (which is itself a simplex protocol), TFTP supports duplex transactions (uploading and downloading of files). Analog communications occur with a continuous signal that varies in frequency, amplitude, phase, voltage, and so on. This is relevant to the actual transmission media of a network (i.e., cables or radio waves) and is not relevant to the protocols of TFTP and IGMP directly. Broadband technology can support multiple simultaneous signals. This is also only relevant to the transmission media, not the protocols of TFTP and IGMP.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      333,
      330,
      338,
      345,
      394
    ],
    "source": ""
  },
  {
    "id": 4031,
    "question": "Remi is working through a setup and deployment procedure for a new network server. She has completed most of the initial installation operations and is now working through the system hardening tasks. The next step requires the installation and configuration of a TCP Wrapper. <br>What is a TCP Wrapper?",
    "choice_a": "An encapsulation protocol used by switches",
    "choice_b": "An application that can serve as a basic firewall by restricting access based on user IDs or system IDs",
    "choice_c": "A security protocol used to protect TCP/IP traffic over WAN links",
    "choice_d": "A mechanism to tunnel TCP/IP through non-IP networks",
    "correct_answer": "B",
    "explanation": "A TCP Wrapper is an application that can serve as a basic firewall by restricting access based on user IDs or system IDs. IEEE 802.1q is an encapsulation protocol used by switches. IPsec (or other VPNs) is a security protocol used to protect TCP/IP traffic over WAN links. L2TP is a mechanism to tunnel TCP/IP through non-IP networks.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      523,
      524,
      535,
      553,
      567
    ],
    "source": ""
  },
  {
    "id": 4032,
    "question": "An invitation-only VoIP call among the members of the board of directors took place last month. You just received notice that a partial recording of that call was found on a hacker discussion forum. After investigating the breach, you discover that your VoIP solution was the focus of the security breach and someone was able to eavesdrop on the conversation midstream. <br>Which of the following would be the best option to prevent this incident from reoccurring?",
    "choice_a": "Multimedia collaboration",
    "choice_b": "DISA",
    "choice_c": "SRTP",
    "choice_d": "DMARC",
    "correct_answer": "C",
    "explanation": "Implementing Secure Real-time Transport Protocol (SRTP) is the best option to secure VoIP and prevent the reoccurrence of the eavesdropping attack. Most likely the VoIP service used for the call last month was using plaintext RTP. Note that VoIP recording can still occur at the endpoints even if SRTP or other communication encryption is in use. Multimedia collaboration is not likely to be a security improvement over the existing solution. Adding other features, such as video and whiteboard sharing, would not address the problem. Direct inward system access (DISA) is a security solution for PBX, not VoIP. Domain Message Authentication Reporting and Conformance (DMARC) is a DNS- based email authentication system, not a VoIP security solution.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      353,
      395,
      436,
      438,
      403
    ],
    "source": ""
  },
  {
    "id": 4033,
    "question": "You are planning the deployment of an encrypted VPN to provide increased protections for business-critical network communications. A tunnel mode VPN is used to connect which types of systems?",
    "choice_a": "Hosts and servers",
    "choice_b": "Clients and terminals",
    "choice_c": "Hosts and networks",
    "choice_d": "Servers and domain controllers",
    "correct_answer": "C",
    "explanation": "Tunnel mode VPNs are used to connect networks to networks or hosts to networks. Transport mode is used to connect hosts to hosts. The terms <italic>host, server, client, terminal</italic>, and <italic>domain controller</italic> are all synonyms in this context.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      413,
      416,
      412,
      417,
      414
    ],
    "source": ""
  },
  {
    "id": 4034,
    "question": "What is needed to allow an external client to initiate a communication session with an internal system if the network uses a NAT proxy?",
    "choice_a": "IPsec tunnel",
    "choice_b": "Static NAT",
    "choice_c": "Static private IP address",
    "choice_d": "Reverse DNS",
    "correct_answer": "B",
    "explanation": "Static NAT is needed to allow an outside entity to initiate communications with an internal system behind a NAT proxy. An IPsec tunnel would require the use of NAT-T in order to traverse the NAT proxy. Also, IPsec tunnels are usually implemented for known entities, rather than unknown. A static private IP address is not strictly required, as long as any change to the internal address is reflected in the mapping of static NAT. Reverse DNS is used to resolve an IP address into its associated domain name. Reverse DNS is not required for this scenario.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      424,
      423,
      412,
      416,
      738
    ],
    "source": ""
  },
  {
    "id": 4035,
    "question": "A new intern has been hired to provide assistance to the security team. The intern is not as familiar with enterprise network concepts as the CISO would like. The CISO is gathering some facts that they want the intern to learn. But the CISO needs to confirm that they are providing only true statements. <br>Which of the following statements is <italic>not</italic> true?",
    "choice_a": "VLANs are created by switches.",
    "choice_b": "A subnet is created by a router.",
    "choice_c": "Multilayer switches can allow cross-VLAN communications by providing a routing function.",
    "choice_d": "VLANs contain or restrict traffic by default.",
    "correct_answer": "B",
    "explanation": "A subnet is not created by a router; a subnet is created through the assignment of an IP address and a subnet mask. Routers only manage traffic between subnets. The other statements are true. VLANs are created by switches. Multilayer switches can allow cross-VLAN communications by providing a routing function. VLANs contain or restrict traffic by default.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      1013,
      419,
      1012,
      355,
      374
    ],
    "source": ""
  },
  {
    "id": 4036,
    "question": "A(n) ______________________ is a formal declaration of the security stance, risks, and technical requirements of a link between two organizations' IT infrastructures. The goal is to define the expectations and responsibilities of maintaining security over a communications path between two networks. Connecting networks can be mutually beneficial, but it also raises additional risks that are related to third-party connectivity that need to be identified and addressed.",
    "choice_a": "CSP",
    "choice_b": "ISA",
    "choice_c": "VLAN",
    "choice_d": "MOU",
    "correct_answer": "B",
    "explanation": "An interconnection security agreement (ISA) is a formal declaration of the security stance, risks, and technical requirements of a link between two organizations' IT infrastructures. The goal of an ISA is to define the expectations and responsibilities of maintaining security over a communications path between two networks. Connecting networks can be mutually beneficial, but it also raises additional risks that are related to third-party connectivity. A cloud security policy (CSP) contains the rules of the cloud service provider (CSP) and is not typically an agreement of mutually beneficial security conditions (i.e., it is typically defined by one side). A VLAN (virtual LAN) is a hardware-imposed network segmentation created by switches. A memorandum of understanding (MOU) or memorandum of agreement (MOA) is an expression of agreement or aligned intent, will, or purpose between two entities. It is not typically a legal agreement or commitment but rather a more formal form of a reciprocal agreement or handshake.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      428,
      427,
      430,
      401,
      400
    ],
    "source": ""
  },
  {
    "id": 4037,
    "question": "Which VPN protocol can be implemented as the payload encryption mechanism when L2TP is used to craft the VPN connection for an IP communication?",
    "choice_a": "L2F",
    "choice_b": "PPTP",
    "choice_c": "IPsec",
    "choice_d": "SSH",
    "correct_answer": "C",
    "explanation": "IPsec is a VPN protocol that can be implemented as the payload encryption mechanism when L2TP is used to craft the VPN connection for an IP communication. Specifically, the ESP element of IPsec is used by L2TP rather than the entire IPsec protocol suite. L2F is a predecessor to L2TP, not an encryption feature of L2TP. PPTP is a layer 2 VPN protocol, but it is otherwise distinct from L2TP. SSH is a layer 4 VPN protocol and not related to L2TP.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      415,
      416,
      412,
      350,
      439
    ],
    "source": ""
  },
  {
    "id": 4038,
    "question": "Your organization's server room includes network devices such as routers and switches. <br>Which of the following is a physical security control used to protect these devices?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Strong passwords",
    "choice_d": "Cipher lock",
    "correct_answer": "D",
    "explanation": "A cipher lock can limit physical access to a server room and is a physical security control. Authentication and authorizations can help protect network devices, but these are logical access controls. Strong passwords are part of authentication.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      440,
      461,
      462,
      463,
      465
    ],
    "source": ""
  },
  {
    "id": 4039,
    "question": "A biometric system is matching subjects to a database using a one-to-many search. <br>What is this providing?",
    "choice_a": "Authentication",
    "choice_b": "Authorization",
    "choice_c": "Accountability",
    "choice_d": "Identification",
    "correct_answer": "D",
    "explanation": "Biometric systems using a one-to-many search provide identification by searching a database for a match. Biometric systems using a one-to-one search provide authentication. Biometric systems do not provide authorization or accountability.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      445,
      748,
      459,
      441,
      461
    ],
    "source": ""
  },
  {
    "id": 4040,
    "question": "Which of the following provides the strongest authentication?",
    "choice_a": "Requiring users to authenticate using biometrics",
    "choice_b": "Requiring users to authenticate with something they know and something they have",
    "choice_c": "Requiring users to authenticate with strong passwords and a personal identification number (PIN)",
    "choice_d": "Requiring users to authenticate with a hardware token",
    "correct_answer": "B",
    "explanation": "Requiring users to authenticate with something they know (such as a password) and something they have (such as a hardware token) provides two-factor authentication and is the strongest method of those listed. Biometrics provides strong authentication but is only a single factor of authentication. A password and PIN are both in the something you know factor of authentication, so they are only a single authentication factor. Using a hardware token (without a PIN or password) is only a single factor of authentication.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      443,
      446,
      444,
      445,
      447
    ],
    "source": ""
  },
  {
    "id": 4041,
    "question": "An administrator has been tasked with reviewing the Human Resources server log files looking for malicious activity. <br>Which of the following identifies the purpose of this activity?",
    "choice_a": "Identification",
    "choice_b": "Authentication",
    "choice_c": "Audit trails",
    "choice_d": "Accountability",
    "correct_answer": "D",
    "explanation": "Accountability is possible by reviewing logs and tracking user activity. Accountability depends on strong identification and authentication methods, but reviewing logs doesn't provide identification or authentication. Audit trails are the entire body of data gathered by event logging.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      441,
      1074,
      1073,
      471,
      927
    ],
    "source": ""
  },
  {
    "id": 4042,
    "question": "On their first day of work, a new employee is asked to bring a passport and a birth certificate. <br>What do these documents provide?",
    "choice_a": "Registration",
    "choice_b": "Proofing",
    "choice_c": "Accountability",
    "choice_d": "Establishment of identity",
    "correct_answer": "D",
    "explanation": "A passport and a birth certificate establish the identity of the new hire. Registration refers to creating the account and capturing biometric data. Proofing requires users to answer questions to prove their identity. Accountability happens after identification.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      442,
      459,
      455,
      445,
      461
    ],
    "source": ""
  },
  {
    "id": 4043,
    "question": "Which of the following is a key benefit of a centralized identity management solution?",
    "choice_a": "It is never a single point of failure.",
    "choice_b": "It can scale up to support additional traffic.",
    "choice_c": "It requires a large administrative team.",
    "choice_d": "It doesn't require single sign-on.",
    "correct_answer": "B",
    "explanation": "A centralized identity management solution can scale up to handle additional traffic. It can be a single point of failure, but there are ways to eliminate it as a single point of failure. Centralized identity management solutions require fewer administrators. Centralized identity management solutions provide single sign-on as a key benefit.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      451,
      450,
      453,
      460,
      756
    ],
    "source": ""
  },
  {
    "id": 4044,
    "question": "An organization has decided to outsource the management of its benefit plans. Management wants to minimize the administrative workload when implementing this. <br>Which of the following solutions would meet this need?",
    "choice_a": "Send a database of accounts to the other company.",
    "choice_b": "Use just-in-time provisioning.",
    "choice_c": "Duplicate the accounts internally.",
    "choice_d": "Create a trust between both organizations.",
    "correct_answer": "B",
    "explanation": "Just-in-time (JIT) provisioning will create the accounts automatically the first time the employee accesses the benefits site. The other solutions require much more administrator work. Sending a database of accounts requires administrators to export the accounts, and the other company to import them. Duplicating the accounts internally won't grant them access to the other site. Creating a trust also won't grant employees access to the other site.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      761,
      1017,
      460,
      455,
      450
    ],
    "source": ""
  },
  {
    "id": 4045,
    "question": "An organization provides online training to employees of multiple organizations. Employees log on normally, and they can then access the training website without logging on again. <br>Which of the following best identifies the system the training company is using?",
    "choice_a": "On-premises identity management",
    "choice_b": "Cloud-based identity management",
    "choice_c": "Hybrid identity management",
    "choice_d": "Credential management",
    "correct_answer": "B",
    "explanation": "The training company is most likely using a cloud-based identity management system. On-premises identity management systems are used when users are from the same organization, not multiple different organizations. Hybrid solutions implement both an on-premises and a cloud-based solution, but both are not needed in this scenario. A credential management system provides storage space for credentials.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      480,
      451,
      452,
      460,
      453
    ],
    "source": ""
  },
  {
    "id": 4046,
    "question": "An employee retained access to sensitive data from previous job assignments. Investigators later caught the employee selling some of this sensitive data to competitors. <br>What could have prevented the employee from stealing and selling the secret data?",
    "choice_a": "Asset valuation",
    "choice_b": "Threat modeling",
    "choice_c": "Vulnerability analysis",
    "choice_d": "Account access review",
    "correct_answer": "D",
    "explanation": "An account access review can detect when employees have excessive privileges. Asset valuation identifies the value of assets. Threat modeling identifies threats to valuable assets. Vulnerability analysis detects vulnerabilities or weaknesses that can be exploited by threats.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      457,
      456,
      470,
      458,
      927
    ],
    "source": ""
  },
  {
    "id": 4047,
    "question": "A company is installing several Linux servers in the server room. These are the first Linux servers for the company, so they hired an administrator with Linux experience to manage them and train other administrators on Linux. <br>How should the company assign privileges for the new administrator?",
    "choice_a": "Add the administrator to the Administrators group.",
    "choice_b": "Add the administrator to the sudo group.",
    "choice_c": "Give the administrator the sudo password.",
    "choice_d": "Define a new role for Linux administrators.",
    "correct_answer": "D",
    "explanation": "The best choice is to define a new role for Linux administrators and assign privileges based on the role definition. Linux systems do not have an Administrators group or a sudo group. However, you can grant root account access to users by adding them to the sudoers file. There isn't a sudo password. Instead, users execute root-level commands in the context of their own account, and their own password.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      458,
      472,
      1073,
      751,
      470
    ],
    "source": ""
  },
  {
    "id": 4048,
    "question": "You are comparing the different access control models. <br>Which access control model defines subject access through subject roles (job descriptions) and subject tasks (job functions)?",
    "choice_a": "Rule-based access control",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Role-Based AccessControl (RBAC)",
    "choice_d": "Risk-based access control",
    "correct_answer": "C",
    "explanation": "RBAC uses a well-defined collection of named job roles for access control. Administrators grant each job role with the privileges they need to perform their jobs. A rule-based access control model grants access using predefined rules. A MAC model grants access with the use of labels. A risk-based access control model evaluates the environment and the situation to grant access based on coded security policies.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      466,
      491,
      472,
      473,
      467
    ],
    "source": ""
  },
  {
    "id": 4049,
    "question": "An access control model assigns access based on a user's need to know combined with organizational policies. <br>Which of the following fits this description?",
    "choice_a": "Discretionary Access Control (DAC)",
    "choice_b": "Mandatory Access Control (MAC)",
    "choice_c": "Attribute-Based Access Control (ABAC)",
    "choice_d": "Risk-based access control",
    "correct_answer": "B",
    "explanation": "The MAC model assigns access based on a user's need to know and organization policies. In the DAC model, the owner assigns access based on the owner's desires. An ABAC model uses attributes to grant access. A risk-based access control model examines the environment, the situation, and policies coded in software to determine access.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      468,
      491,
      470,
      467,
      472
    ],
    "source": ""
  },
  {
    "id": 4050,
    "question": "A web developer is implementing single sign-on (SSO) in a web application. The SSO solution is using a JSON token. <br>Which of the following is the developer implementing?",
    "choice_a": "Security Assertion Markup Language (SAML)",
    "choice_b": "OpenID",
    "choice_c": "XML",
    "choice_d": "OpenID Connect (OIDC)",
    "correct_answer": "D",
    "explanation": "OIDC provides SSO and uses a JavaScript Object Notation (JSON) Web Token (JWT). Neither SAML nor OpenID uses a JSON token. SAML is based on Extensible Markup Language (XML), but XML by itself doesn't provide SSO.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      1019,
      476,
      475,
      1018,
      492
    ],
    "source": ""
  },
  {
    "id": 4051,
    "question": "Sally uses a Linux system for application development. The Linux system is on a network, and Sally can access other network resources as a regular user. An attacker compromised her account and began to run root-level commands as Sally. <br>Which of the following allowed the attacker to run root-level commands?",
    "choice_a": "The <code>su</code> command",
    "choice_b": "Access to the local system account",
    "choice_c": "Membership in the administrator's group",
    "choice_d": "The <code>sudo</code> command",
    "correct_answer": "D",
    "explanation": "The <code>sudo</code> command allows users to run root-level commands by prefixing the command with <code>sudo</code>, and the command will use the user's credentials. In contrast, the <code>su</code> command requires the password for the root account, and an attacker couldn't run root-level commands with just the user's credentials. Windows systems have a local system account and administrators groups, but Linux systems do not.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      752,
      470,
      927,
      462,
      457
    ],
    "source": ""
  },
  {
    "id": 4052,
    "question": "You previously configured a web application to use your social media account credentials. Today, you logged onto your social media account and then connected to the web-based application without authenticating again. The technology supporting this is based on RFC 6749. <br>Which of the following best identifies the SSO technology being used in this scenario?",
    "choice_a": "OAuth 2.0",
    "choice_b": "OIDC",
    "choice_c": "OpenID",
    "choice_d": "Kerberos",
    "correct_answer": "A",
    "explanation": "This describes OAuth 2.0, an authorization framework described in Request for Comments (RFC) 6749. OpenID and OIDC (short for Open ID Connect) are open standards maintained by the OpenID foundation. Kerberos provides single sign-on (SSO) services in an internal network not internet web applications.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      475,
      476,
      492,
      757,
      480
    ],
    "source": ""
  },
  {
    "id": 4053,
    "question": "A network administrator recently replaced a failed firewall in a network. Afterward, some users have reported they are unable to authenticate with the Kerberos server. <br>Which of the following is a possible reason?",
    "choice_a": "The firewall is blocking traffic on port 80.",
    "choice_b": "The firewall is blocking traffic on port 88.",
    "choice_c": "The firewall is blocking traffic on port 443.",
    "choice_d": "The firewall is blocking traffic on port 1701.",
    "correct_answer": "B",
    "explanation": "Kerberos uses port 88, and if the replacement firewall is blocking traffic going to port 88, it will block access to any users trying to authenticate through the firewall. HTTP uses port 80 and HTTPS uses port 443. Layer 2 Tunneling Protocol (L2TP) uses port 1701.",
    "topic_id": 5,
    "practice_test_id": 8,
    "related_articles": [
      477,
      478,
      492,
      467,
      449
    ],
    "source": ""
  },
  {
    "id": 4054,
    "question": "Beth is planning to run a network port scan against her organization's web server. <br>What ports should she expect will be open to the world?",
    "choice_a": "80 and 443",
    "choice_b": "22 and 80",
    "choice_c": "80 and 1433",
    "choice_d": "22, 80, and 443",
    "correct_answer": "A",
    "explanation": "Web servers should expose ports 80 and/or 443 to the world to support HTTP and/or HTTPS connections. Port 22, used by SSH, and port 1433, used by SQL Server databases, should not normally be publicly exposed.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      763,
      787,
      788,
      765,
      864
    ],
    "source": ""
  },
  {
    "id": 4055,
    "question": "Once a system is compromised, _______________ is deployed to restore it to its previous known-good state.",
    "choice_a": "Compensation access control",
    "choice_b": "Recovery access control",
    "choice_c": "Restorative access control",
    "choice_d": "Corrective access control",
    "correct_answer": "D",
    "explanation": "Corrective access control is deployed to restore systems to normal after an unwanted or unauthorized activity has occurred.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      500,
      786,
      502,
      498,
      499
    ],
    "source": ""
  },
  {
    "id": 4056,
    "question": "During what type of penetration test does the tester have no access to system configuration information?",
    "choice_a": "Black-box penetration test",
    "choice_b": "White-box penetration test",
    "choice_c": "Gray-box penetration test",
    "choice_d": "Red-box penetration test",
    "correct_answer": "A",
    "explanation": "During a black-box penetration test the testers have no access to configuration information about the system being tested.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      1078,
      1080,
      771,
      788,
      495
    ],
    "source": ""
  },
  {
    "id": 4057,
    "question": "What business continuity metric identifies the longest period of time that a business function may be unavailable without causing irreparable harm to the business?",
    "choice_a": "MTD",
    "choice_b": "RTO",
    "choice_c": "SLE",
    "choice_d": "ALE",
    "correct_answer": "A",
    "explanation": "The maximum tolerable downtime (MTD) is the maximum length of time a business function can be inoperable without causing irreparable harm to the business.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      790,
      500,
      784,
      502,
      501
    ],
    "source": ""
  },
  {
    "id": 4058,
    "question": "Which one of the following is the final step of the Fagan inspection process?",
    "choice_a": "Inspection",
    "choice_b": "Rework",
    "choice_c": "Follow-up",
    "choice_d": "None of the above",
    "correct_answer": "C",
    "explanation": "The Fagan inspection process concludes with the follow-up phase.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      1022,
      1021,
      494,
      496,
      495
    ],
    "source": ""
  },
  {
    "id": 4060,
    "question": "Karen's firm is undergoing a review of their security controls conducted by an independent firm at the request of her company's Board of Directors. <br>What term best describes this review?",
    "choice_a": "Analysis",
    "choice_b": "Test",
    "choice_c": "Assessment",
    "choice_d": "Audit",
    "correct_answer": "D",
    "explanation": "This type of review, conducted by an independent auditor at the request of the governing body, is best described as an audit.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      1006,
      1007,
      862,
      864,
      767
    ],
    "source": ""
  },
  {
    "id": 4061,
    "question": "Charlie is seeking a common naming scheme that he can use to describe system configurations during vulnerability analysis. <br>Which one of the following SCAP components would be best suited to this task?",
    "choice_a": "CVE",
    "choice_b": "CPE",
    "choice_c": "CVSS",
    "choice_d": "CCE",
    "correct_answer": "D",
    "explanation": "Common Configuration Enumeration (CCE) provides a naming system for system configuration issues.  Common Vulnerabilities and Exposures (CVE) provides a naming system for describing security vulnerabilities.  Common Platform Enumeration (CPE) provides a naming system for operating systems, applications, and devices.  The Common Vulnerability Scoring System (CVSS) provides a standardized scoring system for describing the severity of security vulnerabilities.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      789,
      787,
      861,
      860,
      859
    ],
    "source": ""
  },
  {
    "id": 4062,
    "question": "What application security testing technique uses scripts containing routine activity with known results and then compares the actual results of executing the script with expected outcomes?",
    "choice_a": "Fuzzing",
    "choice_b": "Static testing",
    "choice_c": "Synthetic transactions",
    "choice_d": "Mutation testing",
    "correct_answer": "C",
    "explanation": "Synthetic transactions are scripted transactions with known expected results.  This is a type of dynamic, not static, application security testing.  Mutation testing and other fuzzing techniques are also a dynamic testing option but they do not use predefined scripts of known transactions.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      496,
      494,
      775,
      776,
      778
    ],
    "source": ""
  },
  {
    "id": 4063,
    "question": "Kevin is evaluating the security of a web service offered by his organization and wants to test that the interface used to interact with the service programmatically is secure. <br>What type of interface testing should Kevin perform?",
    "choice_a": "API",
    "choice_b": "UI",
    "choice_c": "Physical interface",
    "choice_d": "Interactive interface",
    "correct_answer": "A",
    "explanation": "Application programming interfaces (APIs) offer a standardized way for code modules to interact and may be exposed to the outside world through web services.  Developers must test APIs to ensure that they enforce all security requirements.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      495,
      494,
      775,
      777,
      496
    ],
    "source": ""
  },
  {
    "id": 4064,
    "question": "Kelly is reviewing privileged accounts and would like to ensure that each account was appropriately authorized. <br>What process should she verify?",
    "choice_a": "Management review and approval",
    "choice_b": "Privilege use audit",
    "choice_c": "Authentication verification",
    "choice_d": "Emergency use authorization",
    "correct_answer": "A",
    "explanation": "The management review and approval process ensures that each account was appropriately authorized and remains necessary to meet business needs.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      499,
      502,
      863,
      861,
      501
    ],
    "source": ""
  },
  {
    "id": 4065,
    "question": "Sasha is comparing the relative risks associated with different threat vectors as she conducts her business continuity planning work. <br>What metric would be the most appropriate to compare relative risk?",
    "choice_a": "ALE",
    "choice_b": "SLE",
    "choice_c": "ARO",
    "choice_d": "EF",
    "correct_answer": "A",
    "explanation": "The annualized loss expectancy (ALE) is the best metric to compare relative risks because it incorporates both the likelihood and the impact of those risks.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      502,
      1023,
      1008,
      500,
      1021
    ],
    "source": ""
  },
  {
    "id": 4066,
    "question": "What clause is commonly used for exception handling in software applications?",
    "choice_a": "If\u2026then\u2026else",
    "choice_b": "Try\u2026catch",
    "choice_c": "Case\u2026when",
    "choice_d": "Do\u2026while",
    "correct_answer": "B",
    "explanation": "The try\u2026catch clause is an exception handling construct that catches errors and handles them appropriately.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      494,
      775,
      779,
      1021,
      1005
    ],
    "source": ""
  },
  {
    "id": 4067,
    "question": "Sharif is preparing an audit report after completing an SSAE 18 engagement.  His report offers an opinion on the controls described by management and the results of his testing of the effectiveness of those controls over the last year. <br>What type report is he preparing?",
    "choice_a": "Type I",
    "choice_b": "Type II",
    "choice_c": "Type III",
    "choice_d": "Type IV",
    "correct_answer": "B",
    "explanation": "Type I reports provide the auditor's opinion on the description of controls provided by management and the suitability of the design of those controls.  Type II reports go further and also provide the auditor's opinion on the operating effectiveness of the controls over an extended period of time.  Type III and IV reports do not exist under SSAE 18.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      793,
      794,
      767,
      768,
      795
    ],
    "source": ""
  },
  {
    "id": 4068,
    "question": "An organization regularly backs up sensitive data onto tapes. Administrators regularly reuse these tapes until they reach the end of their lifetime. <br>Which of the following lets technicians know when they should stop using a tape?",
    "choice_a": "When the tape reaches the MTBF",
    "choice_b": "When backup operations generate errors",
    "choice_c": "After it has been reused 10 times",
    "choice_d": "After it has been reused 100 times",
    "correct_answer": "B",
    "explanation": "Backup tapes should be removed from service when they begin to generate errors. The mean time to failure (MTTF) indicates the number of times a tape can be reused before removing it from service, but the mean time between failures (MTBF) refers to the amount of time expected to elapse between failures of an item that personnel will repair. Tapes are not repaired. The number of times a tape can be reused varies, and there isn't a specific number that applies to all tapes.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      133,
      130,
      144,
      122,
      131
    ],
    "source": ""
  },
  {
    "id": 4069,
    "question": "An organization has recently added a configuration management system (CMS) to automate configuration management. Of the following choices, what else can this provide?",
    "choice_a": "Change management",
    "choice_b": "Hardware asset management",
    "choice_c": "Media management",
    "choice_d": "Intangible inventory",
    "correct_answer": "B",
    "explanation": "An automated CMS connects to systems over the network and can assist with hardware asset management by verifying systems are in the network and operational. A CMS can verify changes are implemented, but it doesn't include the entire change management process. A CMS system can not access all media, such as removable drives, so it isn't effective for media management. A CMS system connects to tangible hardware inventory, but it does not track intangibles.",
    "topic_id": 2,
    "practice_test_id": 8,
    "related_articles": [
      698,
      847,
      849,
      123,
      701
    ],
    "source": ""
  },
  {
    "id": 4070,
    "question": "Which of the following identifies vendor responsibilities and can include monetary penalties if the vendor doesn't meet the stated responsibilities?",
    "choice_a": "Service-level agreement (SLA)",
    "choice_b": "Memorandum of understanding (MOU)",
    "choice_c": "Interconnection security agreement (ISA)",
    "choice_d": "Software as a Service (SaaS)",
    "correct_answer": "A",
    "explanation": "A service-level agreement identifies a third party's responsibilities and can include monetary penalties if the third-party (the vendor in this scenario) doesn't meet the stated responsibilities. An MOU is an informal agreement and does not include monetary penalties. An ISA defines requirements for establishing, maintaining, and disconnecting a connection. SaaS is one of the cloud-based service models and does not specify vendor responsibilities.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      507,
      915,
      519,
      583,
      796
    ],
    "source": ""
  },
  {
    "id": 4071,
    "question": "While troubleshooting a network problem, a technician realized the problem could be resolved by opening a port on a firewall. The technician opened the port and verified the system was now working. However, an attacker accessed this port and launched a successful attack. <br>What could have prevented this problem?",
    "choice_a": "Patch management processes",
    "choice_b": "Vulnerability management processes",
    "choice_c": "Configuration management processes",
    "choice_d": "Change management processes",
    "correct_answer": "D",
    "explanation": "Change management processes would ensure that changes are evaluated before being implemented to prevent unintended outages or needlessly weakening security. Patch management ensures that systems are up-to-date, vulnerability management checks systems for known vulnerabilities, and configuration management ensures that systems are deployed similarly, but these other processes wouldn't prevent problems caused by an unauthorized change.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      526,
      527,
      974,
      534,
      975
    ],
    "source": ""
  },
  {
    "id": 4072,
    "question": "Which of the following should be the highest priority when responding to a disaster?",
    "choice_a": "Protecting the facilities",
    "choice_b": "Employee safety",
    "choice_c": "Data",
    "choice_d": "Servers",
    "correct_answer": "B",
    "explanation": "Employee safety should be the highest priority when responding to a disaster. The other answers represent things that can be replaced, but it's not possible to replace human life.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      508,
      592,
      586,
      596,
      507
    ],
    "source": ""
  },
  {
    "id": 4073,
    "question": "Your organization is considering subscribing to Office 365 for employees. This will allow them to access email and other services via the cloud. <br>Which of the following cloud-based service models does this describe.",
    "choice_a": "Platform as a Service (PaaS)",
    "choice_b": "Infrastructure as a Service (IaaS)",
    "choice_c": "Software as a Service (SaaS)",
    "choice_d": "Hybrid",
    "correct_answer": "C",
    "explanation": "The SaaS service model provides services such as email available via a web browser. IaaS provides the infrastructure (such as servers), and PaaS provides a platform (such as an operating system and application installed on a server). Hybrid is a deployment method, not a service model.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      230,
      210,
      225,
      213,
      208
    ],
    "source": ""
  },
  {
    "id": 4074,
    "question": "Of the following choices, what best indicates the primary purpose of an intrusion detection system (IDS)?",
    "choice_a": "Detect abnormal activity",
    "choice_b": "Diagnose system failures",
    "choice_c": "Rate system performance",
    "choice_d": "Test a system for vulnerabilities",
    "correct_answer": "A",
    "explanation": "An IDS automates the inspection of logs and real-time system events to detect abnormal activity indicating unauthorized system access. Although IDSs can detect system failures and monitor system performance, they don't include the ability to diagnose system failures or rate system performance. Vulnerability scanners are used to test systems for vulnerabilities.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      566,
      547,
      538,
      554,
      548
    ],
    "source": ""
  },
  {
    "id": 4075,
    "question": "An administrator is rebuilding a compromised system and restoring data after an attack. <br>Which incident management step does this describe?",
    "choice_a": "Mitigation",
    "choice_b": "Recovery",
    "choice_c": "Detection",
    "choice_d": "Response",
    "correct_answer": "B",
    "explanation": "This describes the recovery step where systems are rebuilt, and data is restored. The mitigation step attempts to contain an incident. The first step is detection, where personnel detect and verify an incident. Personnel then respond to the incident in the response step.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      537,
      565,
      539,
      540,
      595
    ],
    "source": ""
  },
  {
    "id": 4076,
    "question": "Which of the following is the best response after detecting, verifying, and responding to an incident?",
    "choice_a": "Contain it.",
    "choice_b": "Report it.",
    "choice_c": "Remediate it.",
    "choice_d": "Gather evidence.",
    "correct_answer": "A",
    "explanation": "Mitigation is the next step after detecting, verifying, and responding to an incident, and responders attempt to contain the incident in the mitigation step. This limits the effect or scope of an incident. Organizations report the incident based on policies and governing laws, but this is not the first step. Remediation attempts to identify the cause of the incident and steps that can be taken to prevent a reoccurrence. It is important to protect evidence while trying to contain an incident, but gathering the evidence will occur after containment.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      537,
      539,
      540,
      541,
      538
    ],
    "source": ""
  },
  {
    "id": 4077,
    "question": "The Chief Information Officer (CIO) asks the IT department to install a honeypot. <br>Which of the following BEST describes the purpose of a honeypot?",
    "choice_a": "It blocks malware",
    "choice_b": "It collects log data",
    "choice_c": "It gathers information about intruders",
    "choice_d": "It controls access to servers",
    "correct_answer": "C",
    "explanation": "A honeypot gathers information about intruders. Honeypots don't block malware, collect log data, or control access to servers. While not available as a possible answer, honeypots also act as a decoy to distract attackers.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      549,
      604,
      556,
      607,
      608
    ],
    "source": ""
  },
  {
    "id": 4078,
    "question": "Administrators suspect a distributed denial of service (DDoS) is currently attacking one of their web servers. Assuming the organization has all of the following security controls in place, what could they check to verify their suspicions?  (Select all that apply.)",
    "choice_a": "Data loss prevention (DLP) system",
    "choice_b": "A network-based intrusion detection systems (NIDS)",
    "choice_c": "Logs on a border firewall",
    "choice_d": "A security information and event management (SIEM) system",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Administrators can confirm the DDoS attack by checking the NIDS, border firewall logs, and logs on the SIEM system. A NIDS is designed to detect such attacks. A firewall installed at the border of a network (between the Internet and the internal network) would show traffic from the attacker to the attacked system. A SIEM system includes collect logs and would have relevant traffic. A DLP system monitors outgoing traffic, but the DDoS attack is incoming traffic. Security cameras monitor physical activity, but they don't monitor incoming traffic.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      546,
      554,
      548,
      538,
      604
    ],
    "source": "",
    "choice_e": "Security cameras"
  },
  {
    "id": 4079,
    "question": "What database backup technology applies database transactions in real time at both primary and alternate sites?",
    "choice_a": "Remote mirroring",
    "choice_b": "Electronic vaulting",
    "choice_c": "Remote journaling",
    "choice_d": "Fault tolerance",
    "correct_answer": "A",
    "explanation": "Remote mirroring technology maintains mirrored images of servers at both the primary and alternate sites.  Electronic vaulting copies full data to a backup site but does not do so in real time.  Remote journaling copies only transaction log entries to the remote site.  Fault tolerance is a mechanism to increase the resilience of technology systems against failures.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      584,
      598,
      582,
      575,
      588
    ],
    "source": ""
  },
  {
    "id": 4080,
    "question": "Barbara configures a system to perform full backups on Sundays and differential backups on Mondays through Saturdays. The system fails on Thursday. <br>What backups must be applied?",
    "choice_a": "Sunday only",
    "choice_b": "Sunday, Monday, Tuesday, and Wednesday",
    "choice_c": "Sunday and Wednesday only",
    "choice_d": "Sunday, Monday, and Wednesday only",
    "correct_answer": "C",
    "explanation": "With differential backups, Barbara must first restore the most recent full backup and then apply the most recent differential backup.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      588,
      598,
      596,
      587,
      539
    ],
    "source": ""
  },
  {
    "id": 4081,
    "question": "What technology can be used to minimize the impact of a server failure immediately before the next backup was scheduled?",
    "choice_a": "Clustering",
    "choice_b": "Differential backups",
    "choice_c": "Remote journaling",
    "choice_d": "Tape rotation",
    "correct_answer": "A",
    "explanation": "Clustering servers adds a degree of fault tolerance, protecting against the impact of a single server failure.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      577,
      575,
      598,
      580,
      597
    ],
    "source": ""
  },
  {
    "id": 4082,
    "question": "Julia's facility is experiencing power issues.  After investigating the situation, she determines that the site is experiencing prolonged periods of low voltage. <br>What term best describes this scenario?",
    "choice_a": "Blackout",
    "choice_b": "Inrush",
    "choice_c": "Transient",
    "choice_d": "Brownout",
    "correct_answer": "D",
    "explanation": "A brownout is a reduction of electrical power or a temporary drop in power, but voltage is still present.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      571,
      577,
      573,
      598,
      592
    ],
    "source": ""
  },
  {
    "id": 4083,
    "question": "What are the consequences for CISSPs who violate the ISC2 Code of Ethics?",
    "choice_a": "Criminal sanctions",
    "choice_b": "Civil sanctions",
    "choice_c": "Loss of certification",
    "choice_d": "Public humiliation",
    "correct_answer": "C",
    "explanation": "CISSPs who violate the ISC2 Code of Ethics are subject to certification revocation.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      957,
      955,
      956,
      14,
      47
    ],
    "source": ""
  },
  {
    "id": 4084,
    "question": "Which of the following is not related to verifying that a candidate for employment is qualified as well as not disqualified for a position?",
    "choice_a": "Verifying education",
    "choice_b": "Checking references",
    "choice_c": "Validating security clearance",
    "choice_d": "Signing an NDA",
    "correct_answer": "D",
    "explanation": "Signing an NDA may be a part of the hiring process, but it is not related to verifying that a candidate for employment is qualified as well as not disqualified for a position. Employment candidate screening, background checks, reference checks, education verification, and security clearance validation are essential elements in proving that a candidate is adequate, qualified, and trustworthy for a secured position.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      34,
      677,
      68,
      35,
      39
    ],
    "source": ""
  },
  {
    "id": 4085,
    "question": "Which of the following individuals are responsible for preserving the chain of custody of evidence? (Select all that apply.)",
    "choice_a": "Police investigators",
    "choice_b": "Court reporters",
    "choice_c": "Evidence technicians",
    "choice_d": "Attorneys",
    "correct_answer": [
      "A",
      "C",
      "D"
    ],
    "explanation": "Police investigators, evidence technicians, attorneys, and anyone else involved in the collection, processing, analysis, and production of evidence must maintain the chain of custody.  Court reporters generally do not handle evidence and are not subject to maintaining the chain of custody.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      602,
      603,
      605,
      615,
      541
    ],
    "source": ""
  },
  {
    "id": 4086,
    "question": "When conducting an internal investigation, what is the most common source of evidence?",
    "choice_a": "Historical data",
    "choice_b": "Search warrant",
    "choice_c": "Subpoena",
    "choice_d": "Voluntary surrender",
    "correct_answer": "D",
    "explanation": "Internal investigations usually operate under the authority of senior managers, who grant access (i.e., voluntary surrender) to all information and resources necessary to conduct the investigation.",
    "topic_id": 7,
    "practice_test_id": 8,
    "related_articles": [
      607,
      605,
      601,
      799,
      599
    ],
    "source": ""
  },
  {
    "id": 4087,
    "question": "Harold is a Certified Public Accountant (CPA) conducting an administrative investigation of a member of the cybersecurity team of an outside organization.  During the course of the investigation, he believes that he has uncovered evidence that may raise ethical issues.  The individual is certified by ISC2.  Assuming the canon applies to the circumstances of the situation, which of the following canons might Harold have standing under which to file a complaint?   (Select all that apply.)",
    "choice_a": "Canon I",
    "choice_b": "Canon II",
    "choice_c": "Canon III",
    "choice_d": "Canon IV",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "Under the terms of the ISC2 code of ethics, any member of the general public may bring complaints under Canons I or II of the code.  Therefore, assuming the circumstances apply, Harold may bring a complaint under those canons.  The question also specifies that Harold is a CPA, qualifying him as a professional and providing him with standing to bring a complaint under Canon IV.  Only an employer or contracted organization may bring complaints under Canon III.  This does not apply in this situation.",
    "topic_id": 1,
    "practice_test_id": 8,
    "related_articles": [
      955,
      957,
      17,
      956,
      11
    ],
    "source": ""
  },
  {
    "id": 4088,
    "question": "Carla's organization recently suffered a security incident where the attackers exploited a SQL injection vulnerability.  As she reviewed the situation, she determined that the organization's incident response process was lacking maturity. <br>What business function should she focus on under the Software Assurance Maturity Model (SAMM)?",
    "choice_a": "Governance",
    "choice_b": "Implementation",
    "choice_c": "Verification",
    "choice_d": "Operations",
    "correct_answer": "D",
    "explanation": "Incident management, detection, and response are all security practices under the Operations business function in the Software Assurance Maturity Model.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      623,
      640,
      653,
      832,
      658
    ],
    "source": ""
  },
  {
    "id": 4089,
    "question": "Gavin is a software developer who is using external code in his own applications to simplify his work. <br>What term best describes the code he is using?",
    "choice_a": "COTS",
    "choice_b": "Open source",
    "choice_c": "API",
    "choice_d": "Library",
    "correct_answer": "D",
    "explanation": "Software libraries are reusable code that programmers can use to simplify their work.  It is possible that the library is either commercial-off-the-shelf (COTS) or open source, but the question does not specify this.  APIs are interfaces to external services and they are not mentioned in this question.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      670,
      816,
      618,
      961,
      627
    ],
    "source": ""
  },
  {
    "id": 4090,
    "question": "Don's organization is having a difficult time tracking different versions of software being worked on by different developers. <br>What type of tool would best assist with this problem?",
    "choice_a": "IDE",
    "choice_b": "IPT",
    "choice_c": "Code repository",
    "choice_d": "Runtime",
    "correct_answer": "C",
    "explanation": "The use of a code repository would provide a central location for the storage of code as well as version control to manage different releases.  Integrated development environments (IDE) are tools used to improve the efficiency of individual programmers and do not assist with collaboration.  Integrated product teams (IPTs) are a team organizational approach and not a development tool.  Runtimes execute code on a system and are not development tools.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      1031,
      628,
      1030,
      814,
      983
    ],
    "source": ""
  },
  {
    "id": 4091,
    "question": "In object-oriented programming, what term describes a collection of the common methods from a set of objects that defines the behavior of those objects?",
    "choice_a": "Class",
    "choice_b": "Instance",
    "choice_c": "Message",
    "choice_d": "Polymorphism",
    "correct_answer": "A",
    "explanation": "A class is a collection of the common methods from a set of objects that defines the behavior of those objects.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      805,
      806,
      629,
      621,
      660
    ],
    "source": ""
  },
  {
    "id": 4092,
    "question": "What database security feature uses a locking mechanism to prevent simultaneous edits of cells?",
    "choice_a": "Semantic integrity mechanism",
    "choice_b": "Concurrency",
    "choice_c": "Polyinstantiation",
    "choice_d": "Database partitioning",
    "correct_answer": "B",
    "explanation": "Concurrency uses a \"lock\" feature to allow an authorized user to make changes and then \"unlock\" the data elements only after the changes are complete. This is done so another user is unable able to access the database to view and/or make changes to the same elements at the same time.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      633,
      632,
      634,
      630,
      635
    ],
    "source": ""
  },
  {
    "id": 4093,
    "question": "Allen is a database administrator who is concerned that users in his organization might engage in inference attacks. <br>What technique can he use to prevent inference attacks by presenting different data to users of different security clearance levels?",
    "choice_a": "Polyinstantiation",
    "choice_b": "Aggregation",
    "choice_c": "Provisioning",
    "choice_d": "Referential integrity",
    "correct_answer": "A",
    "explanation": "Polyinstantiation includes multiple records in a table with the same primary key. Each record is designed for users of a specific security clearance level.  Aggregation is the use of multiple queries that summarize information to obtain sensitive information.  Provisioning is the process of providing access to a system or resource.  Referential integrity ensures that the contents of a database maintain relationships according to foreign key constraints.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      228,
      219,
      220,
      201,
      213
    ],
    "source": ""
  },
  {
    "id": 4094,
    "question": "What software development technique includes as a basic principle that it values responding to change over following a plan?",
    "choice_a": "Spiral",
    "choice_b": "Waterfall",
    "choice_c": "Agile",
    "choice_d": "CMM",
    "correct_answer": "C",
    "explanation": "The agile software development methodology prioritizes flexible development that emphasizes responding to change over following a plan.  This is one of the core principles of the Agile manifesto and it is not necessarily embraced by the spiral or waterfall models.  The capability maturity model is an assessment tool and not a development technique.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      622,
      640,
      1033,
      1035,
      624
    ],
    "source": ""
  },
  {
    "id": 4095,
    "question": "Tom built a database table consisting of the names, telephone numbers, and customer IDs for his business. The table contains information on 30 customers. <br>What is the cardinality of this table?",
    "choice_a": "Two",
    "choice_b": "Three",
    "choice_c": "Thirty",
    "choice_d": "Undefined",
    "correct_answer": "C",
    "explanation": "The cardinality of a table refers to the number of rows in the table, whereas the degree of a table is the number of columns.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      964,
      966,
      630,
      965,
      633
    ],
    "source": ""
  },
  {
    "id": 4096,
    "question": "What stage of the SW-CMM model is characterized by formal, documented software development processes?",
    "choice_a": "Initial",
    "choice_b": "Repeatable",
    "choice_c": "Defined",
    "choice_d": "Managed",
    "correct_answer": "C",
    "explanation": "The Defined stage of SW-CMM is characterized by the use of formal, documented software development processes.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      623,
      640,
      622,
      628,
      1033
    ],
    "source": ""
  },
  {
    "id": 4097,
    "question": "Paul is evaluating a set of security requirements and determines that a mission critical application must be allowed to continue operating even if security controls surrounding it fail. <br>What term best describes this design approach?",
    "choice_a": "Fail-open",
    "choice_b": "Fail mitigation",
    "choice_c": "Fail-secure",
    "choice_d": "Fail clear",
    "correct_answer": "A",
    "explanation": "The <italic>fail-open state</italic> allows users to bypass failed security controls, erring on the side of permissiveness. In a fail-secure state, the system remains in a high level of security until an administrator intervenes.  In a fail-open state, the system defaults to a low level of security, disabling controls until the failure is resolved.  Failure mitigation seeks to reduce the impact of a failure.  Fail clear is not a valid approach.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      620,
      621,
      672,
      833,
      618
    ],
    "source": ""
  },
  {
    "id": 4098,
    "question": "Recently, a piece of malicious code was distributed over the Internet in the form of software claiming to allow users to play Xbox games on their PCs. The software actually launched the malicious code on the machines of users who attempted to execute it. <br>What type of malicious code does this describe?",
    "choice_a": "Logic bomb",
    "choice_b": "Virus",
    "choice_c": "Trojan horse",
    "choice_d": "Worm",
    "correct_answer": "C",
    "explanation": "Trojan horses masquerade as useful programs (such as a game) but really contain malicious code that runs in the background.  Logic bombs contain malicious code that is executed if certain specified conditions are met.  Worms are malicous code objects that spread under their own power, while viruses spread through some human intervention.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      289,
      294,
      247,
      246,
      948
    ],
    "source": ""
  },
  {
    "id": 4099,
    "question": "Syed visited the desktop of a user who was experiencing system issues.  He saw an error message that said his files were encrypted with a unique key for his computer and that he should click a button for further instructions. <br>What type of malware infection is Syed most likely dealing with?",
    "choice_a": "Ransomware",
    "choice_b": "Logic bomb",
    "choice_c": "Virus",
    "choice_d": "Worm",
    "correct_answer": "A",
    "explanation": "Ransomware's signature characteristic is the encryption of files using a key known only to the author and then demanding payment in exchange for the decryption key.",
    "topic_id": 3,
    "practice_test_id": 8,
    "related_articles": [
      262,
      145,
      153,
      200,
      228
    ],
    "source": ""
  },
  {
    "id": 4100,
    "question": "Malware that does not leave any trace of its presence nor saves itself to a storage device, but is still able to stay resident and active on a computer is known as what?",
    "choice_a": "Rootkit",
    "choice_b": "Cryptomalware",
    "choice_c": "Fileless malware",
    "choice_d": "Spyware",
    "correct_answer": "C",
    "explanation": "Malware that leaves no trace of its presence nor saves itself to a storage device, but is still able to stay resident and active on a computer is fileless malware. This is similar to a rootkit, which can be described as an invisibility shield. But its core features are that it interferes with low-level communications of the operating environment to hide itself and then hide other things, such as files and/or processes. A rootkit is usually deposited on a system as a file that is then executed upon system load or application launch. Cryptomalware installs a cryptominer on a victim system. Spyware collects information about the system user.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      649,
      657,
      653,
      650,
      675
    ],
    "source": ""
  },
  {
    "id": 4101,
    "question": "The internal development team has performed an assessment of the reliability, stability, resilience, and security of their newly developed business application. The code personnel who wrote the code were on the team that performed the live security assessment. <br>What type of evaluation method was used?",
    "choice_a": "Lateral movement",
    "choice_b": "Passive reconnaissance",
    "choice_c": "Integration testing",
    "choice_d": "White box",
    "correct_answer": "D",
    "explanation": "This scenario describes a white box test, since those performing the testing are fully knowledgeable about the software code and its operations and functions. This is not lateral movement, which is when an intruder is able to gain remote control over another internal system after pivoting from the initial system they compromised. This is not passive reconnaissance which is gather information about a target in such a way as to not to be noticed by said target. This is not integration testing as it seems to have taken place in the development environment, as there was no mention of the new application already being placed into production. Integration testing is performed when a new product is deployed or integrated into a real or simulated production environment to ensure that all previously function work tasks still work and all newly added or expected work tasks work as well.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      626,
      621,
      625,
      623,
      628
    ],
    "source": ""
  },
  {
    "id": 4102,
    "question": "A code developer is running out of time to complete a software project. The deadline is only three days away and several essential software functions are still not written. In order to meet the deadline, which of the following would be worth considering?",
    "choice_a": "OWASP",
    "choice_b": "Code reuse",
    "choice_c": "Normalization",
    "choice_d": "Stored procedures",
    "correct_answer": "B",
    "explanation": "Code reuse is the inclusion of preexisting code in a new program. Code reuse can be a way to quicken the development process by adopting and reusing existing code. If there are software libraries that have code elements that perform the functions needed by the project, this can be a way to meet the project requirements and the deadline. However, third-party code could introduce vulnerabilities so this technique should be used with caution. Open Web Application Security Project (OWASP) is a nonprofit security project focusing on improving security for online or web-based applications, mobile device applications, and IoT equipment. It is not a means to resolve the coding deadline issue in this scenario, but is a source of guidance of crafting more secure code of Web, IoT, and mobile applications. Normalization is a programming and management technique used to reduce redundancy, often related to database management. This is not a useful mechanism in this scenario. A stored procedure is a subroutine or software module that can be called on or accessed by applications interacting with a relational database management system (RDBMS). Stored procedures may be used for data validation during input, managing access control, assessing the logic of data, and more. Stored procedures can make some database applications more efficient, consistent, and secure. Stored procedures are an allow lists of existing software functions where users or other applications are limited to the pre-determined range of functions. Thus, stored procedures is not helpful in this scenario.",
    "topic_id": 8,
    "practice_test_id": 8,
    "related_articles": [
      670,
      816,
      618,
      669,
      621
    ],
    "source": ""
  },
  {
    "id": 4103,
    "question": "What aspect of security governance is based on the idea that senior management is responsible for the success or failure of a security endeavor?",
    "choice_a": "Documentation review",
    "choice_b": "COBIT",
    "choice_c": "Abstraction",
    "choice_d": "Top-down approach",
    "correct_answer": "D",
    "explanation": "The top-down approach is the aspect of security governance that is based on the idea that senior management is responsible for the success or failure of a security endeavor. Documentation review is the process of reading the exchanged materials and verifying them against standards and expectations. Control Objectives for Information and Related Technology (COBIT) is a documented set of best IT security practices based around six key principles. Abstraction is the process where similar elements are put into groups, classes, or roles that are assigned security controls, restrictions, or permissions as a collective.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      15,
      11,
      20,
      14,
      17
    ],
    "source": ""
  },
  {
    "id": 4104,
    "question": "Which security role is ultimately responsible for due diligence in protecting a company's data?",
    "choice_a": "The user",
    "choice_b": "The asset owner",
    "choice_c": "The custodian",
    "choice_d": "The administrator",
    "correct_answer": "B",
    "explanation": "The asset owner is the person who has final corporate responsibility for the protection and storage of data. Owners may be liable for negligence if they fail to perform due diligence in establishing and enforcing security policy to protect and sustain sensitive data. The user interacts with assets and is responsible for abiding by company security policy, but is not ultimately responsible for company due diligence. The custodian is to follow the guidance of the asset owner in securing the asset, but it not ultimately responsible for company due diligence. The administrator is the IT operator who performs privileged tasks and must do so within the restrictions of their assigned responsibilities and security policy, but they are not ultimately responsible for company due diligence.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      17,
      20,
      32,
      11,
      1
    ],
    "source": ""
  },
  {
    "id": 4105,
    "question": "Threat hunting is an essential tool in tracking down and addressing threats. Examples of threat hunting include ethical hacking, penetration testing, source code review, and fuzz testing. <br>What type of threat modeling approach encompasses these examples?",
    "choice_a": "Reactive threat modeling",
    "choice_b": "Proactive approach",
    "choice_c": "Quantitative evaluation",
    "choice_d": "Defensive approach",
    "correct_answer": "B",
    "explanation": "A proactive approach to threat modeling involves identifying and addressing vulnerabilities before they are exploited. The examples listed, including penetration testing, ethical hacking, source code review, and fuzz testing, are preventive security techniques used to discover weaknesses in systems during development or prior to deployment.<br>These activities simulate attacks or analyze systems to uncover flaws early, which helps reduce the likelihood of a successful real-world attack.<br>In contrast, a reactive approach focuses on responding to security incidents after they occur, such as through incident response or forensic analysis.<br>Because the techniques listed are used to anticipate and prevent threats, the correct answer is Proactive approach.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      23,
      2,
      24,
      26,
      44
    ],
    "source": ""
  },
  {
    "id": 4106,
    "question": "Mark's company has just signed a two-year SLA with a major cloud service provider. The company is developing a new line of product based on their own internally developed technology that has not been published or revealed to any external entity. A few months after the company has integrated the cloud service into their production processes, Mark receives an advertisement from a vendor claiming to sell a product based on new features never before seen. After further research, Mark realizes that those new features are the exact technology their company developed and maintained as an internal trade secret. Mark is confident that he knows where the leak occurred. <br>What is the basis of Mark's conclusion?",
    "choice_a": "Hardware-focused supply chain risk",
    "choice_b": "Software-focused supply chain risk",
    "choice_c": "Service-focused supply chain risk",
    "choice_d": "Mechanism-focused supply chain risk",
    "correct_answer": "C",
    "explanation": "This scenario describes a service-focused supply chain risk based around the insecure services provided by the cloud company. This scenario is not describing supply chain risk related to hardware, software, or mechanisms.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      27,
      116,
      81,
      28,
      4
    ],
    "source": ""
  },
  {
    "id": 4107,
    "question": "Several bank customers have reported numerous unrecognized withdrawals from their account. An account manager has recently purchased a new car, is showing off flashy jewelry, and has been buying lunch for the entire department. In order to discover evidence of fraud and theft, which of the following could be used?",
    "choice_a": "Offboarding",
    "choice_b": "Gamification",
    "choice_c": "MOU",
    "choice_d": "Mandatory vacation",
    "correct_answer": "D",
    "explanation": "In this scenario, mandatory vacation is the most likely means to discover evidence of fraud and theft. Offboarding is used to terminate an employee using a formal procedure, not for collecting evidence of violations. Gamification is a means to encourage compliance and engagement by integrating common elements of game play into other activities. It is more often used to encourage compliance rather than discover violations. A memorandum of understanding (MOU) or memorandum of agreement (MOA) is an expression of agreement or aligned intent, will, or purpose between two entities and thus is not relevant to this scenario.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      36,
      69,
      37,
      17,
      11
    ],
    "source": ""
  },
  {
    "id": 4109,
    "question": "As a member of the security team, you have been asked to collect information prior to the start of this year's risk management process. One of your tasks is to inventory assets and threats. <br>Which of the following represents a possible threat to assets within an organization? (Select all that apply.)",
    "choice_a": "Malware",
    "choice_b": "Cascade errors",
    "choice_c": "Reorganization",
    "choice_d": "Disgruntled employees",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "E",
      "F",
      "G",
      "H",
      "I",
      "J"
    ],
    "explanation": "All of these items listed, and much more, are potential threats to an organization's assets.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      23,
      24,
      85,
      41,
      46
    ],
    "source": "",
    "choice_e": "Natural disasters",
    "choice_f": "Misuse of data",
    "choice_g": "Processing error",
    "choice_h": "Energy anomalies",
    "choice_i": "Intruders",
    "choice_j": "Equipment failure"
  },
  {
    "id": 4110,
    "question": "You are evaluating the benefit of a safeguard to a specific threat. The asset is a customer database, which is estimated to be worth $10 million. The threat is an intrusion that could cause a 50 percent value loss. The attack has already been attempted three times in the last 6 months. The best countermeasure would be able to reduce the success rate to only once per year, but the cost of the protection is $350,000. <br>What is the benefit of this countermeasure?",
    "choice_a": "$5 million",
    "choice_b": "$30 million",
    "choice_c": "$24,650,000",
    "choice_d": "$9,650,000",
    "correct_answer": "C",
    "explanation": "The benefit of this countermeasure is $24,650,000. This is calculated by first establishing the pre-countermeasure annualized loss expectancy (ALE1). From the scenario, we know that the asset value (AV) =$10,000,000 and the exposure factor (EF) = 50%, so the single loss expectancy (SLE) = AV * EF = $5,000,000. The ARO = 6/year (3 times in six months is 6 times per year). Thus, ALE1 = SLE * ARO = $30,000,000. The post-countermeasure ARO=1/year, so the ALE2 is = $5,000,000. The annual cost of the countermeasure/safeguard (ACS) is $350,000. Thus, the cost benefit is [ALE1 \u2013 ALE2] \u2013 ACS = $24,650,000. The other options are incorrect. (A) $5 million is the SLE. (B) $30 million is the ALE1. (D) $9,650,000 is AV \u2013 ACS, which is not a valid quantitative risk assessment formula.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      45,
      86,
      48,
      43,
      70
    ],
    "source": ""
  },
  {
    "id": 4111,
    "question": "Which of the following is a true statement in regard to the selection of countermeasures?  (Select all that apply.)",
    "choice_a": "The result of the applied countermeasure should make the cost of an attack greater for the perpetrator than the derived benefit from an attack.",
    "choice_b": "The countermeasure should provide a solution to a real and identified problem.",
    "choice_c": "The benefit of the countermeasure should be testable and verifiable.",
    "choice_d": "The countermeasure should require ongoing human intervention to manage deployment and configuration.",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Three statements are true: (A) The result of the applied countermeasure should make the cost of an attack greater for the perpetrator than the derived benefit from an attack; (B) The countermeasure should provide a solution to a real and identified problem; and (C) The benefit of the countermeasure should be testable and verifiable. The final statement is false. The corrected statement would be (D) The countermeasure should require minimal human intervention after initial deployment and configuration.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      48,
      47,
      1,
      43,
      53
    ],
    "source": ""
  },
  {
    "id": 4112,
    "question": "Which of the following are goals of a security control assessment (SCA)?  (Select all that apply.)",
    "choice_a": "Ensure the effectiveness of the security mechanisms.",
    "choice_b": "Evaluate the quality and thoroughness of the risk management processes of the organization.",
    "choice_c": "Verify the cost-effectiveness of the security endeavor.",
    "choice_d": "Produce a report of the relative strengths and weaknesses of the deployed security infrastructure.",
    "correct_answer": [
      "A",
      "B",
      "D"
    ],
    "explanation": "An SCA is the formal evaluation of a security infrastructure's individual mechanisms against a baseline or reliability expectation. The goals of an SCA are to (A) ensure the effectiveness of the security mechanisms, (B) evaluate the quality and thoroughness of the risk management processes of the organization, and (D) produce a report of the relative strengths and weaknesses of the deployed security infrastructure. The other options are incorrect. (C) Checking cost-effectiveness and (E) assessing risks are elements of risk management in general, but they are not specifically part of an SCA.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      54,
      72,
      41,
      47,
      50
    ],
    "source": "",
    "choice_e": "Assess the risk and threats to mission-critical assets."
  },
  {
    "id": 4113,
    "question": "In areas where technical controls cannot be used to prevent virus infections, what should be used to prevent them?",
    "choice_a": "Security baselines",
    "choice_b": "Awareness training",
    "choice_c": "Traffic filtering",
    "choice_d": "Network design",
    "correct_answer": "B",
    "explanation": "Educating users is an important part of preventing virus infections and works with technical controls such as anti-malware software. Awareness establishes a common baseline or foundation of security understanding across the entire organization and focuses on key or basic topics and issues related to security that all employees must understand. Security baselines provide a secure starting point for a system as a technical control. Traffic filtering is another technical control that can block viruses. Network design can be used to control the flow of traffic as a technical control.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      65,
      47,
      55,
      54,
      67
    ],
    "source": ""
  },
  {
    "id": 4114,
    "question": "You have been asked by the CISO to perform an assessment of the company's security training material. <br>What is the primary purpose of a periodic content review that you are performing?",
    "choice_a": "Check for content relevancy",
    "choice_b": "Establish new security guidelines for workers",
    "choice_c": "Integrating gamification elements",
    "choice_d": "Determine if the training is cost effective",
    "correct_answer": "A",
    "explanation": "The primary purpose of periodic content review is to check for content relevancy. An assessment of the appropriate levels of awareness, training, and education required within the organization should be revised on a regular basis using periodic content reviews. Training efforts need to be updated and tuned as the organization evolves over time. Without periodic reviews for content relevancy, materials will become stale and workers will likely resort to making up their own guidelines and procedures. The other options are incorrect. (B) Content reviews are not used to establish new security guidelines for workers; that would be done as part of a risk management process or based on the results of an access review of worker user accounts. (C) Integrating gamification elements is a means to encourage compliance and engagement by integrating common elements of game play, but that is not the purpose of content reviews. (D) A content review is not the tool to determine if training is cost-effective. Cost-effectiveness requires evaluating effectiveness and judging training adoption and retention over time compared to security incidents caused by internal personnel.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      67,
      65,
      66,
      40,
      11
    ],
    "source": ""
  },
  {
    "id": 4115,
    "question": "Darcy's Doodles is an electronic content provider hosting websites related to art. The IT staff of Darcy's Doodles is concerned about the risk of an earthquake destroying their data center, which is valued at $8 million. After consulting with seismologists, they determined that an earthquake is likely to occur once every 50 years and, if one occurred, it would completely destroy the facility. <br>What is the ALE?",
    "choice_a": "$80,000",
    "choice_b": "$160,000",
    "choice_c": "$1,600,000",
    "choice_d": "$8 million",
    "correct_answer": "B",
    "explanation": "The annualized loss expectancy (ALE) is the product of the annualized rate of occurrence (ARO) and the single loss expectancy (SLE). In this example, we first calculate the ARO as once every 50 years equals 1 / 50, or 2 percent. The SLE is $8 million, giving an ALE of $160,000.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      45,
      695,
      86,
      691,
      85
    ],
    "source": ""
  },
  {
    "id": 4116,
    "question": "Edward is helping his employer install software designed to monitor employee email communications through the organization's email server. <br>Which one of the following statements is correct?",
    "choice_a": "The company must notify employees of this monitoring when they log on to the system.",
    "choice_b": "The company must notify employees of this monitoring before it begins.",
    "choice_c": "Employees must consent to this monitoring in written employment agreements.",
    "choice_d": "No notice or consent is required in this case.",
    "correct_answer": "D",
    "explanation": "Court rulings have consistently stated that employees do not have a reasonable expectation of privacy while using business systems. Therefore, though notice and consent may be desirable, they are not required.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      112,
      105,
      119,
      117,
      20
    ],
    "source": ""
  },
  {
    "id": 4117,
    "question": "Which one of the following requires that merchants handling credit card information promptly report security incidents involving a breach of cardholder data?",
    "choice_a": "GLBA",
    "choice_b": "SOX",
    "choice_c": "PCI DSS",
    "choice_d": "HIPAA",
    "correct_answer": "C",
    "explanation": "The Payment Card Industry Data Security Standard includes requirements that merchants promptly report incidents affecting the security of credit card information. The Gramm\u2013Leach\u2013Bliley Act (GLBA) covers the customer records of financial institutions, whereas the Health Insurance Portability and Accountability Act (HIPAA) regulates healthcare providers. The Sarbanes\u2013Oxley (SOX) Act governs the financial records of publicly traded companies.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      115,
      19,
      106,
      108,
      114
    ],
    "source": ""
  },
  {
    "id": 4118,
    "question": "Ken's organization has several subsidiaries that share information across EU boundaries. <br>What mechanism could he use to ensure this information sharing is consistent with GDPR?  (Select all that apply.)",
    "choice_a": "Privacy shield",
    "choice_b": "Standard contractual clauses",
    "choice_c": "Binding corporate rules",
    "choice_d": "Safe harbor",
    "correct_answer": [
      "B",
      "C"
    ],
    "explanation": "Organizations seeking to ensure that their data transfers comply with GDPR may choose to take advantage of standard contractual clauses or binding corporate rules. The EU/US Privacy Shield was a safe harbor agreement that would previously have allowed the transfer but that is no longer valid.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      108,
      119,
      116,
      1045,
      38
    ],
    "source": ""
  },
  {
    "id": 4119,
    "question": "An organization is implementing security controls to protect sensitive data. <br>Which of the following choices identifies data that they would protect with additional security controls?",
    "choice_a": "Name of the CEO",
    "choice_b": "Public data",
    "choice_c": "Personally identifiable information",
    "choice_d": "Data posted on a public website",
    "correct_answer": "C",
    "explanation": "Personally identifiable information (PII) is an example of sensitive data that should be protected. All the other options are examples of data that is accessible to the public.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      120,
      703,
      143,
      124,
      121
    ],
    "source": ""
  },
  {
    "id": 4120,
    "question": "A data policy mandates the use of watermarks on photos created by an organization. <br>Which one of the following best describes the reason for this policy?",
    "choice_a": "To enhance the quality of the photos",
    "choice_b": "To support encryption of the photos",
    "choice_c": "To detect the unauthorized copying of the photos",
    "choice_d": "To embed hidden messages in the photos",
    "correct_answer": "C",
    "explanation": "Watermarks can detect the unauthorized copying of documents, including photos. They do not enhance the quality of the photos, and watermarks are not related to encryption. Watermarks are visible, not hidden.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      128,
      134,
      123,
      124,
      143
    ],
    "source": ""
  },
  {
    "id": 4121,
    "question": "You are updating the data policy for your company and adding responsibilities for various data roles. <br>Which of the following roles is ultimately responsible for due diligence in protecting the company's data?",
    "choice_a": "The user",
    "choice_b": "The data owner",
    "choice_c": "The data custodian",
    "choice_d": "Data controller",
    "correct_answer": "B",
    "explanation": "The data owner is the person who has final corporate responsibility for the protection and storage of data. Owners may be liable for negligence if they fail to perform due diligence in establishing and enforcing security policies to protect and sustain sensitive data. Users simply use the data. A data custodian is responsible for the daily maintenance tasks required to protect the data. A data controller decides what data to process and how it is processed.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      138,
      143,
      851,
      989,
      139
    ],
    "source": ""
  },
  {
    "id": 4122,
    "question": "Your organization has defined the data classifications within a data policy. <br>Which of the following data roles is most likely to implement data protection tasks based on the data classification?",
    "choice_a": "Data custodian",
    "choice_b": "Data owner",
    "choice_c": "Data user",
    "choice_d": "Data processor",
    "correct_answer": "A",
    "explanation": "The data custodian will implement data protection tasks for data. This includes performing backups, monitoring data for integrity, and any other tasks defined in data or security policies. Data owners have the ultimate responsibility for protecting data, but they delegate day-to-day tasks to the data custodian. A data user (or subject) accesses the data. A data processor controls the processing of the data, based on what the data controller tells them.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      138,
      143,
      124,
      989,
      125
    ],
    "source": ""
  },
  {
    "id": 4123,
    "question": "Which of the following is most likely to protect the confidentiality of data on storage media?",
    "choice_a": "Erasing",
    "choice_b": "Marking",
    "choice_c": "Formatting",
    "choice_d": "Collection limitation",
    "correct_answer": "B",
    "explanation": "Marking and labeling practices protect the confidentiality of data held on storage media. Erasing data or formatting media removes the data, so it doesn't protect it. Collection limitation refers to minimizing the collection of data but doesn't protect the confidentiality of data already collected.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      128,
      123,
      124,
      132,
      125
    ],
    "source": ""
  },
  {
    "id": 4124,
    "question": "The data policy in your company mandates specific procedures to eliminate data remanence in disk drives. It outlines methods to eliminate slack space. <br>Which of the following best describes slack space?",
    "choice_a": "Clusters overwritten with random bits",
    "choice_b": "Areas of the disk that don't contain files",
    "choice_c": "Unused space in a cluster",
    "choice_d": "Deleted files that haven't been overwritten",
    "correct_answer": "C",
    "explanation": "Slack space is the unused space in a cluster. However, slack space can still contain data previously stored in memory. Clusters are groups of sectors. One way of eliminating data remanence is by overwriting clusters with random bits. However, overwriting a cluster with random bits does not create slack space. Slack space isn't directly related to files, even though files take up one or more clusters. Deleted files remain on the drive until the systems overwrites them, but deleted files are not slack space.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      1025,
      1024,
      1026,
      130,
      144
    ],
    "source": ""
  },
  {
    "id": 4125,
    "question": "Your organization has several servers in use that they purchased from a hardware vendor. You just learned that the vendor announced that the end-of-life (EOL) date for these servers is in 60 days. <br>What does this mean?",
    "choice_a": "The vendor will stop supporting the servers after the EOL date.",
    "choice_b": "The vendor will discontinue sales of the servers after the EOL date.",
    "choice_c": "The vendor will disable the servers after the EOL date.",
    "choice_d": "The lease of the servers will end after the EOL date.",
    "correct_answer": "B",
    "explanation": "The end-of-life (EOL) date is the date when the vendor will stop offering a product for sale. The end-of-support (EOS) date, not the end-of-life (EOL) date, is the date when the vendor will stop supporting a product. Vendors don't disable servers that they sold to customers. The scenario states that the organization purchased the servers, not that they leased them.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      877,
      847,
      849,
      133,
      878
    ],
    "source": ""
  },
  {
    "id": 4126,
    "question": "Administrators routinely connect to servers in the data center from remote locations using their administrator accounts. Of the following, what should be a prime concern when doing so?",
    "choice_a": "Protecting data at rest",
    "choice_b": "Protecting data in transit",
    "choice_c": "Protecting data in use",
    "choice_d": "Preventing data remanence",
    "correct_answer": "B",
    "explanation": "They should take steps to protect data in transit by using encryption algorithms that encrypt data sent between their computers and the servers. Data at rest is data stored on media, but data sent between two systems is data in transit. Data in use refers to data in memory and used by a program. Data remaining on media after trying to remove it is data remanence, but this is unrelated to this question.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      122,
      144,
      700,
      706,
      127
    ],
    "source": ""
  },
  {
    "id": 4127,
    "question": "An organization is implementing a preselected baseline of security controls but finds that some of the controls aren't relevant to their needs. <br>What should they do?",
    "choice_a": "Implement all the controls anyway.",
    "choice_b": "Identify another baseline.",
    "choice_c": "Re-create a baseline.",
    "choice_d": "Tailor the baseline to their needs.",
    "correct_answer": "D",
    "explanation": "Scoping and tailoring processes allow an organization to tailor security baselines to its needs, and tailoring includes scoping. There is no need to implement security controls that do not apply, and it is not necessary to identify or re-create a different baseline.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      141,
      140,
      142,
      698,
      143
    ],
    "source": ""
  },
  {
    "id": 4128,
    "question": "A hospital system includes several hospitals and medical centers spread throughout a geographical area. Their databases include a significant amount of information about a relatively new health issue impacting patients. Medical researchers have asked for these records to study treatments and outcomes, but the hospital system wants to protect the privacy of the patients. <br>Which of the following would be the best choice?",
    "choice_a": "Data masking",
    "choice_b": "Data minimization",
    "choice_c": "Data encryption",
    "choice_d": "Data tailoring",
    "correct_answer": "A",
    "explanation": "Data masking is a method used to anonymize data and protect the privacy of individuals in a dataset. It replaces privacy data (such as names) with incorrect data, but the dataset still retains usable data. Data minimization refers to limiting the collection of data, but it doesn't change existing data. Encryption makes the data unreadable. Although it may be possible to encrypt some columns, this would prevent the researchers from performing aggregation functions on the dataset to identify trends. Tailoring refers to customizing a set baseline of security controls, and it is unrelated to data anonymization.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      137,
      136,
      143,
      120,
      126
    ],
    "source": ""
  },
  {
    "id": 4129,
    "question": "Management is concerned that users may copy sensitive data onto USB devices. You're asked what technology will prevent this activity. <br>Which of the following would be the most cost-effective to implement?",
    "choice_a": "CASB",
    "choice_b": "Data loss prevention",
    "choice_c": "Security information and event management",
    "choice_d": "Intrusion detection systems",
    "correct_answer": "B",
    "explanation": "Endpoint data loss prevention (DLP) systems can prevent the copying of any data to external devices such as Universal Serial Bus (USB) drives. A cloud access security broker (CASB) helps enforce security policies for cloud-based assets. Security information and event management (SIEM) systems provide real-time analysis of events occurring on systems throughout an organization but don't block activity on an endpoint device. Intrusion detection systems (IDSs) scan incoming traffic, but they don't block traffic leaving a user's computer.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      127,
      144,
      124,
      135,
      122
    ],
    "source": ""
  },
  {
    "id": 4130,
    "question": "Administrators manage several servers in your network. They are required to keep the audit logs for a minimum of three years on several servers. <br>Which of the following is the most likely reason why they must keep archives of audit logs for this long?",
    "choice_a": "Data remanence policies",
    "choice_b": "Record retention policies",
    "choice_c": "Data collection policies",
    "choice_d": "Data maintenance policies",
    "correct_answer": "B",
    "explanation": "Record retention policies define the amount of time to keep any data, including logs. Data remanence is data remnants on media, and data destruction methods remove data remnants. Data collection policies define what data to collect, and often stress that only data that is needed should be collected and maintained. Data maintenance refers to the maintenance of data, such as marking and labeling.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      133,
      850,
      126,
      144,
      130
    ],
    "source": ""
  },
  {
    "id": 4131,
    "question": "Paul is selecting a cryptographic algorithm and would like to provide users with a high level of confidence that data, objects, and resources are unaltered from their original state. <br>What goal is he attempting to achieve?",
    "choice_a": "Confidentiality",
    "choice_b": "Nonrepudiation",
    "choice_c": "Integrity",
    "choice_d": "Hash values",
    "correct_answer": "C",
    "explanation": "If a security mechanism offers integrity, then it offers a high level of confidence that data, objects, and resources are unaltered from their original protected state.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      164,
      145,
      172,
      152,
      146
    ],
    "source": ""
  },
  {
    "id": 4132,
    "question": "Which one of the following is not a requirement for a cryptographic hash function?",
    "choice_a": "The hash function is one-way.",
    "choice_b": "The output can be any length.",
    "choice_c": "The hash function is relatively easy to compute.",
    "choice_d": "The hash function is collision resistant.",
    "correct_answer": "B",
    "explanation": "The output of a hash function must be a fixed length, not any length. Hash functions must also be one-way, collision resistant, and relatively easy to compute.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      172,
      199,
      155,
      173,
      197
    ],
    "source": ""
  },
  {
    "id": 4133,
    "question": "Which of the following is not a valid security measure to protect against brute-force and dictionary attacks?",
    "choice_a": "Enforce strong passwords through a security policy.",
    "choice_b": "Maintain strict control over physical access.",
    "choice_c": "Require all users to log in remotely.",
    "choice_d": "Use two-factor authentication.",
    "correct_answer": "C",
    "explanation": "Requiring users to log in remotely does not protect against password attacks such as brute-force or dictionary attacks. Strong password policies, physical access control, and two-factor authentication all improve the protection against brute-force and dictionary password attacks.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      994,
      193,
      199,
      288,
      320
    ],
    "source": ""
  },
  {
    "id": 4134,
    "question": "Kolin believes that an attacker is measuring the electricity consumption of a cryptographic device deployed in the field to attempt to gain access to encrypted data. <br>What type of attack is taking place?",
    "choice_a": "Timing attack",
    "choice_b": "Side-channel attack",
    "choice_c": "Man-in-the-middle attack",
    "choice_d": "Replay attack",
    "correct_answer": "B",
    "explanation": "Side-channel attacks use information about a system's footprint, such as electricity consumption, to undermine the cryptographic system. Timing attacks require measuring the amount of time used to perform cryptographic operations. Man-in-the-middle attacks require intercepting communications. Replay attacks take advantage of authentication requests that do not include a timestamp by later replaying the message to open a new authenticated session.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      195,
      197,
      262,
      152,
      145
    ],
    "source": ""
  },
  {
    "id": 4135,
    "question": "Which of the following is a true statement in regard to managing engineering processes using secure design principles?",
    "choice_a": "Security is more cost-effective when added after functionality has been established.",
    "choice_b": "It's much easier to build security into a system during development than it is to add security to an existing system.",
    "choice_c": "Security requires that functions and capabilities be minimized.",
    "choice_d": "It is more important to integrate security into a solution for common or standard environments than for sensitive or critical ones.",
    "correct_answer": "B",
    "explanation": "It's extremely important to consider the security implications of a development project from the early stages because it's much easier to build security into a system during development than it is to add security to an existing system. Security should be a consideration at every stage of a system's development. Option A is incorrect because security is usually more cost-effective when integrated early in development. Option C is incorrect because security can sometimes be a trade-off between security, functions, and capabilities but does not require that, in order to optimize security, functions and capabilities must be minimized. Option D is incorrect because it is more important to integrate security into solutions for sensitive or critical environments than into common or standard ones; however, programmers should strive to build security into every application they develop.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      211,
      226,
      292,
      230,
      213
    ],
    "source": ""
  },
  {
    "id": 4136,
    "question": "Zero trust is an alternate approach to security where nothing is automatically trusted. Instead, each request for activity or access is assumed to be from an unknown and untrusted location until otherwise verified. <br>What has been the major driver behind the adoption of the zero trust model?",
    "choice_a": "Emergence of APTs",
    "choice_b": "Proliferation of endpoint devices",
    "choice_c": "Poor authentication technologies",
    "choice_d": "Use of micro-segmentation",
    "correct_answer": "B",
    "explanation": "The primary driver behind the adoption of the zero trust model has been the proliferation of endpoint devices. An endpoint device could be a user's workstation, a tablet, a smartphone, an IoT device, an ICS system, an edge computing sensor, and any public-facing servers in a screened subnet or extranet. Being able to control, much less trust, all of these devices has caused the loss of a clearly defined security perimeter between the outside untrusted world and the inside trusted organization. This results in the \"assume breach\" stance, which requires organizations to \"never trust, always verify.\" The other options are incorrect. Option A, advanced persistent threats (APTs), are a serious security concern, but they are primarily external entities attacking from foreign lands, so they are not the primary cause of the switch to the zero trust model. Option C, poor authentication technologies, are primarily an issue of choice; there are reliable and robust authentication options available, such as mutual certificate authentication and multi-factor authentication. Poor authentication is not the primary reason to adopt zero trust, since zero trust requires reliable authentication to be effective. Option D, micro-segmentation, is not a reason to adopt the zero trust model, but it is a core element of implementing the zero trust model.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      207,
      208,
      210,
      227,
      289
    ],
    "source": ""
  },
  {
    "id": 4137,
    "question": "Privacy by Design (PbD) is a guideline to integrate privacy protections into products during the early design phase rather than attempting to tack it on at the end of development. There are seven foundational principles of PbD. <br>Which of the following are among them?  (Select all that apply.)",
    "choice_a": "Proactive not reactive; preventive not remedial",
    "choice_b": "Access control triplet interface management",
    "choice_c": "Privacy embedded into design",
    "choice_d": "Respect for user privacy\u2014keep it user-centric",
    "correct_answer": [
      "A",
      "C",
      "D",
      "E",
      "G",
      "H",
      "J"
    ],
    "explanation": "The seven foundational principles of Privacy by Design (PbD) are: proactive not reactive; preventive not remedial, privacy as the default setting, privacy embedded into design, full functionality\u2014positive-sum, not zero-sum, end-to-end security\u2014full lifecycle protection, visibility and transparency\u2014keep it open, and respect for user privacy\u2014keep it user-centric. The other options are incorrect. Option B is a statement of the Clark\u2013Wilson security model. Option F is the principle of zero trust. Option I is a statement related to \"keep it simple\" known as New Jersey style, which indicates that the quality of software does not necessarily increase with an increase in capabilities and functions. Option K is a classical security management approach that is replaced by zero trust.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      209,
      227,
      211,
      230,
      206
    ],
    "source": "",
    "choice_e": "Full functionality\u2014positive-sum, not zero-sum",
    "choice_f": "Never trust, always verify",
    "choice_g": "Privacy as the default setting",
    "choice_h": "Visibility and transparency\u2014keep it open",
    "choice_i": "Worse is better",
    "choice_j": "End-to-end security\u2014full lifecycle protection",
    "choice_k": "Trust but verify"
  },
  {
    "id": 4138,
    "question": "A constrained interface or restricted interface can be used to protect what security functions or benefits? (Select all that apply.)",
    "choice_a": "Confidentiality",
    "choice_b": "Availability",
    "choice_c": "Nonrepudiation",
    "choice_d": "Integrity",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "A constrained interface or restricted interface can be used to protect integrity (such as the focus of the Clark\u2013Wilson model) or confidentiality. Constrained/restricted interfaces do not protect availability, nonrepudiation, or proximity.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      225,
      219,
      228,
      145,
      172
    ],
    "source": "",
    "choice_e": "Proximity"
  },
  {
    "id": 4139,
    "question": "Your organization is planning a massive data processing solution rollout. The requirements are that the individual processors operate independently. Each processor will be assigned its own instruction set to follow. Each processor is granted its own memory space and bus pathways. The goal is to have over 3,000 separate processors working together under the management of a single master control and coordination system. <br>What type of large-scale parallel data system would be most appropriate for this scenario?",
    "choice_a": "SMP",
    "choice_b": "MPP",
    "choice_c": "AMP",
    "choice_d": "Multicore",
    "correct_answer": "B",
    "explanation": "This scenario would be best served by a massive parallel processing (MPP) system. An MPP is usually constructed of numerous AMPs linked together. MPP systems can encompass thousands of processors. MPPs are managed by a central coordination system. Asymmetric multiprocessing (AMP) systems usually have independent processors, each with their own assigned instruction set, memory, and bus. AMP on its own is not quite suited for very large processing requirements. Symmetric multiprocessing (SMP) systems have multiple processors, but they share a common OS, bus, and memory resources. Multicore, the ability to process multiple execution threads simultaneously, is often a key component of modern SMP, AMP, and MPP deployments in addition to standard single CPU systems. But multicore on its own is not a complete solution for this scenario.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      250,
      256,
      235,
      251,
      991
    ],
    "source": ""
  },
  {
    "id": 4140,
    "question": "Your organization operates a large complex set of web applications. Market research has revealed that a significant number of other business entities could benefit from some of the functions of your company's web environment. A project has been initiated to transform these capabilities into microservices that can be offered via subscription to external customers. <br>Which of the following are true in regard to microservices? (Select all that apply.)",
    "choice_a": "Supports purpose-specific business capabilities through services that are independently deployed",
    "choice_b": "Designed with few dependencies",
    "choice_c": "Based on fast short-term development cycles (similar to Agile)",
    "choice_d": "Crafted to host a single application, including only the OS resources needed, and sharing common binaries and libraries",
    "correct_answer": [
      "A",
      "B",
      "C",
      "E"
    ],
    "explanation": "Microservices are often created as a means to provide purpose-specific business capabilities through services that are independently deployed. Often, microservices are small and focused on a singular operation, are designed with few dependencies, and are based on fast short-term development cycles (similar to Agile). It is also common to deploy microservices based on immutable architecture. The statement \"Crafted to host a single application, including only the OS resources needed, and sharing a common binaries and libraries\" describes containerization rather than microservices.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      264,
      226,
      211,
      230,
      254
    ],
    "source": "",
    "choice_e": "Commonly deployed based on immutable architecture"
  },
  {
    "id": 4141,
    "question": "________ systems are used when real-time or near-real-time processing of massive data is necessary for a particular task or application. These applications can include scientific studies, industrial research, medical analysis, societal solutions, and commercial endeavors. This type of solution is composed of three main elements: compute resources, network capabilities, and storage capacity. Each element must be able to provide equivalent capabilities in order to optimize overall performance.",
    "choice_a": "EOSL",
    "choice_b": "IoT",
    "choice_c": "HPC",
    "choice_d": "Grid computing",
    "correct_answer": "C",
    "explanation": "High-performance computing (HPC) systems are used when real-time or near-real-time processing of massive data is necessary for a particular task or application. These applications can include scientific studies, industrial research, medical analysis, societal solutions, and commercial endeavors. This type of solution is composed of three main elements: compute resources, network capabilities, and storage capacity. Each element must be able to provide equivalent capabilities in order to optimize overall performance. The other answers are incorrect. An end-of-service life (EOSL) is a system that is no longer supported by its vendor. Internet of Things (IoT) is a class of smart devices that are internet-connected in order to provide automation, remote control, or AI processing to traditional or new appliances or devices in a home or office setting. Grid computing is a form of parallel distributed processing that loosely groups a significant number of processing nodes to work toward a specific processing goal.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      256,
      250,
      258,
      259,
      301
    ],
    "source": ""
  },
  {
    "id": 4142,
    "question": "The tendency for various technologies, solutions, utilities, and systems to evolve and merge over time is known as what?",
    "choice_a": "Security governance",
    "choice_b": "Technology convergence",
    "choice_c": "OWASP",
    "choice_d": "Threat modeling",
    "correct_answer": "B",
    "explanation": "Technology convergence is the tendency for various technologies, solutions, utilities, and systems to evolve and merge over time. Often this results in multiple systems performing similar or redundant tasks or one system taking over the feature and abilities of another. Though in some instances this can result in improved efficiency and cost savings, it can also represent a single point of failure and become a more valuable target for hackers and intruders. Security governance is the guidance from entities such as a board of directors or steering committee to bring new insights, knowledge, and solutions from the broader world to improve the security posture of an organization. OWASP is the Open Web Application Security Project, which aims at improving web app, mobile app, and IoT programming security. Threat modeling is the security process where potential threats are identified, categorized, and analyzed.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      1027,
      302,
      263,
      258,
      211
    ],
    "source": ""
  },
  {
    "id": 4143,
    "question": "A small fire has occurred in the kitchen area of the facility. You look around for the fire extinguisher to attempt to put out the flames. A Type B fire extinguisher may use all <italic>except</italic> which of the following suppression mediums?",
    "choice_a": "Water",
    "choice_b": "CO2",
    "choice_c": "Halon or an acceptable halon substitute",
    "choice_d": "Soda acid",
    "correct_answer": "A",
    "explanation": "Water is never the suppression medium in Type B fire extinguishers because they are used on liquid fires. CO2, Halon or an acceptable halon substitute, and soda acid are all suppression media options for a Type B fire extinguisher.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      314,
      315,
      329,
      326,
      324
    ],
    "source": ""
  },
  {
    "id": 4144,
    "question": "While reviewing the building's design and layout plans, you are concerned about the facilities support for security while balancing efficiency. <br>What infrastructure component is often located in the same position across multiple floors in order to provide a convenient means of linking floor-based networks together?",
    "choice_a": "Server room",
    "choice_b": "Wiring closet",
    "choice_c": "Data center",
    "choice_d": "Media cabinets",
    "correct_answer": "B",
    "explanation": "A wiring closet is the infrastructure component often located in the same position across multiple floors in order to provide a convenient means of linking floor-based networks together. A wiring closet is where the networking cables are connected to other essential equipment, such as patch panels, switches, routers, local area network (LAN) extenders, and WAN backbone channels. A server room or data center are enclosed, restricted, and protected rooms where your mission-critical servers and network devices are housed. There is typically only one main server room or data center in a building. A media cabinet is where removable media is stored.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      307,
      328,
      308,
      324,
      311
    ],
    "source": ""
  },
  {
    "id": 4145,
    "question": "Recent changes in local policing patrols have resulted in an increase in burglaries in the general area of your business headquarters. You are considering several physical security mechanisms to improve the prevention capabilities of your facility. <br>Which option provides clear corridors for security guards to walk, provides for a means to sense when an intruder attempts entry, and will reduce the nuisance alarm rate?",
    "choice_a": "CPTED",
    "choice_b": "PIDAS",
    "choice_c": "SCIF",
    "choice_d": "MDF",
    "correct_answer": "B",
    "explanation": "A PIDAS (perimeter intrusion detection and assessment system) is a fence system that has two or three fences used in concert to optimize security. The space between the fences can serve as a corridor for guard patrols or wandering guard dogs. One or more fences can support touch detection technologies. An exterior fence is used to keep animals and casual trespassers from accessing the main fence. This reduces the nuisance alarm rate (NAR) or false positives. Crime Prevention Through Environmental Design (CPTED) is the concept to structure the physical environment and surroundings to influence individual decisions that potential offenders make before committing any criminal acts. PIDAS is to direct and obvious of a security mechanism to be an element of CPTED. A sensitive compartmented information facility (SCIF) is often used by government and military agencies, divisions, and contractors to provide a secure environment for highly sensitive data storage and computation. An SCIF is typically located within a structure, although an entire structure can be implemented as an SCIF. A main distribution frame (MDF) is a primary wiring closet of a facility.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      508,
      509,
      538,
      548,
      556
    ],
    "source": ""
  },
  {
    "id": 4146,
    "question": "There are several models that are used to describe the methods by which network protocols operate. Those models include the OSI model and the TCP/IP model. In the DoD model, what is the layer number for the layer known as Application?",
    "choice_a": "Layer 7",
    "choice_b": "Layer 4",
    "choice_c": "Layer 5",
    "choice_d": "Layer 2",
    "correct_answer": "B",
    "explanation": "In the DoD, DARPA, or TCP/IP model (a four-layer model), the Application layer is layer 4. In the OSI model, the Application layer is layer 7. There is no layer 5 in the DoD, DARPA, or TCP/IP model, since it only has four layers. In the OSI model, layer 5 is the Session layer. Layer 2 in the DoD, DARPA, or TCP/IP model is the Internetworking or Internet layer. In the OSI model, layer 2 is the Data Link layer.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      333,
      387,
      742,
      330,
      389
    ],
    "source": ""
  },
  {
    "id": 4147,
    "question": "A recent intrusion has caused growing concern in the executive group that the company network is not locked down sufficiently. Recent mandates have required that only unicast communications occur with IP and that IPv6 not be deployed until further evaluation. You have been tasked with performing network monitoring to make an accounting of all IP addresses actually in use on the local network. <br>Which of the following IP address groups do you expect to see in the intranet?  (Select all that apply.)",
    "choice_a": "Class A",
    "choice_b": "IP addresses with an initial octet of 128\u2013191",
    "choice_c": "IP addresses with initial binary bits of 100",
    "choice_d": "Class D",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "In this scenario, the IP addresses that are expected to be seen would be Classes A\u2013-C (which are also used for unicast communications). Class A addresses start with a binary 0 and a first octet in dotted-decimal notation of 1\u2013126. Class B addresses start with binary 10 and a first octet in dotted-decimal notation of 128\u2013191. Class C addresses start with binary 110 and a first octet in dotted-decimal notation of 192\u2013223. Class D addresses, which are used for multicasting, start with binary 1110 and a first octet in dotted-decimal notation of 224\u2013239. Class E addresses, which are reserved for experimentation, start with binary 1111 and a first octet in dotted-decimal notation of 240\u2013255. IPv6 does not use class groupings.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      348,
      741,
      949,
      425,
      345
    ],
    "source": "",
    "choice_e": "IP addresses starting with 240\u2013255 when written in dotted-decimal notation"
  },
  {
    "id": 4148,
    "question": "TCP/IP is a multilayer protocol. Using a network sniffer, you capture several frames. There is quite a lot of information available for examination for each captured packet. You notice that most of the frames collected have several areas of expandible detail, which is due to the protocol stack supporting multilayer protocols that use encapsulation. <br>What is encapsulation doing to these network communications?",
    "choice_a": "Changing the source addresses of a packet",
    "choice_b": "Adding a header and possibly a footer to data as it moves down the OSI stack",
    "choice_c": "Verifying a person's identity",
    "choice_d": "Protecting evidence until it has been properly collected",
    "correct_answer": "B",
    "explanation": "Encapsulation is adding a header and possibly a footer to data as it moves down the OSI stack. Changing the source address of a packet is spoofing and is also performed by NAT in outbound packets. Verifying a person's identity is authentication. Protecting evidence until it has been properly collected may be called containment, but it is the responsibility of the first responder or the incident response team.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      351,
      330,
      333,
      742,
      387
    ],
    "source": ""
  },
  {
    "id": 4149,
    "question": "The CTO has informed you that a new technology is being deployed to link together numerous separate networks that are distributed throughout the organization's campus. These networks have not been linked previously because they support a wide range of protocols. The new linking system is able to address this concern through encapsulation and provides a high-throughput, high-performance network technology that directs data across a network based on short path labels rather than longer network addresses. This decision was based on the significant increase in efficiency compare to traditional IP-based routing processes. <br>What technology is likely being deployed?",
    "choice_a": "FCoE",
    "choice_b": "MPLS",
    "choice_c": "SDN",
    "choice_d": "IaC",
    "correct_answer": "B",
    "explanation": "MPLS (Multiprotocol Label Switching) is a high-throughput, high-performance network technology that directs data across a network based on short path labels rather than longer network addresses. It uses encapsulation to handle a wide range of protocols. This technique saves significant time over traditional IP-based routing processes, which can be quite complex. FCoE is used to encapsulate Fibre Channel storage communications over Ethernet networks and is primarily used in the deployment of a SAN. Software-defined networking (SDN) aims at separating the infrastructure layer from the control layer on networking hardware in order to reduce management complexity. SDN is not relevant to this scenario. Infrastructure as code (IaC) changes how hardware management is perceived to just another collection of elements to be managed in the same way that software and code are managed under SecDevOps. IaC is not relevant to this scenario.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      352,
      412,
      354,
      331,
      333
    ],
    "source": ""
  },
  {
    "id": 4150,
    "question": "Your organization has recently implemented an SDN to separate the control plane from the data plane. This should allow for greater control and flexibility over the network structure as well as greater access control over communications. <br>Which of the following models will the SDN most likely use?",
    "choice_a": "ABAC",
    "choice_b": "DAC",
    "choice_c": "MAC",
    "choice_d": "RBAC",
    "correct_answer": "A",
    "explanation": "A software-defined network (SDN) typically uses an attribute-based access control (ABAC) model. SDNs don't normally use the discretionary access control (DAC), mandatory access control (MAC), or role-based access control (RBAC) models.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      354,
      377,
      386,
      375,
      419
    ],
    "source": ""
  },
  {
    "id": 4151,
    "question": "Mark is the manager of a massive warehouse used to store essential equipment for a medical provider. A complete inventory is needed yearly. Last year it took over three weeks to complete the inventory. Mark wants to implement a solution that will significantly reduce the time required to perform this important management task. <br>What is a field-powered technology that can be used for inventory management without requiring direct physical contact?",
    "choice_a": "VXLAN",
    "choice_b": "RFID",
    "choice_c": "SSID",
    "choice_d": "SDN",
    "correct_answer": "B",
    "explanation": "Radio-frequency identification (RFID) is a tracking technology based on the ability to power a radio transmitter using current generated in an antenna when placed in a magnetic field. RFID can be triggered/powered and read from a considerable distance away (often hundreds of meters). Virtual eXtensible LAN (VXLAN) is an encapsulation protocol that enables switch-created network segments (i.e., VLANs) to be stretched across subnets and geographic distances. SSID is the name of wireless networks and is not relevant to inventory management. SDN is software-defined networking and is not relevant to inventory management.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      365,
      384,
      1012,
      368,
      389
    ],
    "source": ""
  },
  {
    "id": 4152,
    "question": "Renee's organization has deployed her to an uninhabited region of the continent in order to research pollution effects on the flora and fauna in the area. She requires the ability to interact with the cloud services to record her research, and she wants to maintain contact with friends and family. She needs high-speed connectivity with minimal latency. <br>Which of the following will be the best option?",
    "choice_a": "Wi-Fi",
    "choice_b": "Cellular",
    "choice_c": "GEO",
    "choice_d": "LEO",
    "correct_answer": "D",
    "explanation": "Low Earth orbit (LEO) satellite internet service will be the best option in this scenario. LEO offers high-speed communications with minimal latency when compared to other satellite offerings. Geostationary orbit (GEO) satellite internet service would offer slower throughput with higher latency compared to LEO. Wi-Fi and cellular are unlikely to be available in uninhabited areas of any continent.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      371,
      434,
      394,
      358,
      417
    ],
    "source": ""
  },
  {
    "id": 4153,
    "question": "A content distribution network (CDN), or content delivery network, is a collection of resource services deployed in numerous data centers across the internet in order to provide low latency, high performance, and high availability of the hosted content. <br>Which of the following are true in regard to a CDN?  (Select all that apply.)",
    "choice_a": "A CDN is able to maintain customer demand levels of multimedia performance quality.",
    "choice_b": "Using a CDN avoids straining individual servers.",
    "choice_c": "All servers are data cloned and members of a distributed cluster.",
    "choice_d": "Data is stored close to customers.",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E"
    ],
    "explanation": "It is true that a CDN is able to maintain customer demand levels of multimedia performance quality, avoids straining individual servers, and stores data close to customers, and that a client-based CDN (aka P2P) can support high-speed file exchange (i.e., BitTorrent). It is not true that CDN servers are data cloned and members of a distributed cluster. Each remote server is configured to optimize operations for its local customers, which means each individual server of a CDN will be somewhat different, especially in terms of hosted data.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      373,
      405,
      406,
      394,
      379
    ],
    "source": "",
    "choice_e": "Client-based CDN can support high-speed file exchange."
  },
  {
    "id": 4154,
    "question": "You are designing the network deployment at a new facility. The organization leadership wants to avoid issues related to internal network communication reliability that occur at the existing location. <br>Which network topology offers multiple routes to each node to protect from multiple segment failures?",
    "choice_a": "Ring",
    "choice_b": "Star",
    "choice_c": "Bus",
    "choice_d": "Mesh",
    "correct_answer": "D",
    "explanation": "Mesh topologies provide redundant connections to systems, allowing multiple segment failures without seriously affecting connectivity. A ring topology is a single point of failure at any location around the cable ring. A star topology has a single point of failure at its center device. A bus topology has a single point of failure at its central backbone cable.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      865,
      866,
      1012,
      744,
      389
    ],
    "source": ""
  },
  {
    "id": 4155,
    "question": "David wants to be able to manage the company web servers located in a screened subnet. The IT configuration currently prohibits an internal system from directly accessing systems in the screened subnet. Currently, he has to walk into the server vault to access the systems directly. He would rather have a secure connection to manage them remotely from his desk. <br>What should David implement?",
    "choice_a": "WAP with WEP",
    "choice_b": "Telnet through the internet",
    "choice_c": "Jump server",
    "choice_d": "VPN from the private network to the screened subnet",
    "correct_answer": "C",
    "explanation": "The best option for David to remotely manage systems in a screened subnet is to deploy a jump server. A jump server or jumpbox is a remote access system deployed to make accessing a specific system or network easier or more secure. A jump server can be deployed in the screened subnet to receive an in-band secure VPN connection, but most are configured to accept out-of-band connections, such as direct dial-up or internet-origin broadband links. A wireless access point (WAP) with wired equivalent privacy (WEP) is an insecure option because WEP encryption can be compromised easily. Telnet through the internet is also an insecure option, and it would open the screened subnet to attacks from everywhere. A VPN would not work in this situation since there is already a prohibition from connecting between the private network and the screened subnet.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      401,
      400,
      374,
      427,
      335
    ],
    "source": ""
  },
  {
    "id": 4156,
    "question": "The organization is using a NAC solution to cut down on unauthorized devices connecting to the network and reducing security compromises on authorized ones. The NAC is using a pre-admittance agent-based evaluation system. An employee who had been working remotely for three months has just returned to the office. However, after connecting to a known active network cable and booting, she discovers that her company-issued endpoint device has no connectivity to the company LAN or the internet. <br>What is the most likely cause for this situation?",
    "choice_a": "The device has invalid Wi-Fi drivers",
    "choice_b": "The endpoint device was quarantined.",
    "choice_c": "She is using a personal device.",
    "choice_d": "The VLAN membership is restricted.",
    "correct_answer": "B",
    "explanation": "In this scenario, the most likely reason the endpoint device has no network access is that it was quarantined by NAC. The scenario states the endpoint is company issued, so it is authorized. But with it being away from the LAN for three months, it is likely missing approved updates and required configuration changes. If these issues are resolved, NAC will return the system to the production network. The other options are not relevant reasons for the system's connectivity issues. Wi-Fi drivers are not involved with a working network cable connection. She is not using a personal device, since it is a company-issued endpoint device. There is no mention of switches or VLANs (although switches can be assumed to be present in most company networks), so VLAN restrictions is not as likely, especially since NAC was clearly emphasized in the scenario.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      377,
      392,
      379,
      388,
      400
    ],
    "source": ""
  },
  {
    "id": 4157,
    "question": "As the IT manager for a large enterprise, you have been tasked with upgrading the worker desktop and notebook systems. The CISO recommends using a system imaging solution to accomplish this operation more efficiently. <br>What security benefit is gained by following this suggestion?",
    "choice_a": "Eliminates the need for subsequent patching",
    "choice_b": "Allows for all systems to be updated simultaneously",
    "choice_c": "Blocks all future exploitations from external attackers",
    "choice_d": "Ensures a consistent baseline across the upgraded endpoint devices",
    "correct_answer": "D",
    "explanation": "The use of system imaging will ensure a consistent baseline across the upgraded endpoint devices, which is a security benefit. The use of system imaging will not eliminate the need to perform future patching. System imaging might allow for simultaneous deployment but that is not a security benefit. System imaging will not block future exploitations from external hackers. Only ongoing security management will potentially provide sufficient defense against future attacks.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      379,
      400,
      401,
      744,
      389
    ],
    "source": ""
  },
  {
    "id": 4158,
    "question": "By examining the source and destination addresses, the application usage, the source of origin, and the relationship between current packets with the previous packets of the same session, ______________ firewalls are able to grant a broader range of access for authorized users and activities and actively watch for and block unauthorized users and activities.",
    "choice_a": "Static packet-filtering",
    "choice_b": "Application-level",
    "choice_c": "Stateful inspection",
    "choice_d": "Circuit-level",
    "correct_answer": "C",
    "explanation": "Stateful inspection firewalls are able to grant a broader range of access for authorized users and activities and actively watch for and block unauthorized users and activities. Static packet-filtering firewalls are stateless and do not consider context of the communications. Application-level firewalls operate at the Application layer (layer 7) and therefore do not evaluate source and destination address; however, they may perform stateful inspection of the packet payload specific to the Application-layer protocol it is focused on (such as HTTP for a WAF). Circuit-level firewalls are able to make permit and deny decisions in regard to circuit establishment either based on simple rules for IP and port, using captive portals, requiring port authentication via 802.1X, or more complex elements such as context- or attribute-based access control.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      551,
      544,
      547,
      548,
      538
    ],
    "source": ""
  },
  {
    "id": 4159,
    "question": "Cathy is installing a new VoIP solution that supports encrypted connections. She is also crafting the acceptable use policy and how-to guides for the employees to follow. <br>Which of these communication situations can be protected by the VoIP encryption?",
    "choice_a": "VoIP app to VoIP desk phone",
    "choice_b": "VoIP desk phone to mobile phone",
    "choice_c": "PSTN to VoIP",
    "choice_d": "Skype caller to company VoIP solution",
    "correct_answer": "A",
    "explanation": "In most cases, VoIP is only able to be encrypted between compatible VoIP solutions, which is usually only those products provided by the same VoIP vendor. In this situation, the only example that could provide a fully encrypted VoIP connection is when using a VoIP app to call a VoIP desk phone. But the assumption is both these VoIP endpoints are from the same VoIP vendor or provider. The other options will not support full connection encryption; either the endpoint devices will not support VoIP security or the features are from different VoIP providers. VoIP calls to a mobile phone or PSTN landline will not be encrypted. VoIP calls between different VoIP solutions, such as Skype and the company's VoIP service provider, will not support end-to-end encryption either.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      395,
      353,
      398,
      438,
      396
    ],
    "source": ""
  },
  {
    "id": 4160,
    "question": "Slayde is crafting the remote access policy for the organization. He needs to list all the methods of connection that are considered remote access by the organization in order to define rules and guidelines for each option. <br>Which of the following are examples of remote access connections? (Select all that apply.)",
    "choice_a": "Using a modem to dial up directly to a remote access server",
    "choice_b": "Connecting to a network over the internet through a VPN",
    "choice_c": "Connecting to a WAP",
    "choice_d": "Connecting to a terminal server system, mainframe, VPC, VDI, or VMI through a thin-client connection",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D",
      "F",
      "G"
    ],
    "explanation": "All but one of these options are examples of remote access connection methods. They include modem, VPN, WAP, thin-client, remote desktop service, and cloud-based desktop solutions. The only option listed that is not a remote access connection method is using a drop cable from an RJ-45 jack, which is a local-direct connection.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      399,
      401,
      400,
      417,
      427
    ],
    "source": "",
    "choice_e": "Using a drop cable from an RJ-45 jack",
    "choice_f": "Connecting to an office-located PC using a remote desktop service",
    "choice_g": "Using cloud-based desktop solutions"
  },
  {
    "id": 4161,
    "question": "Which of the following VPN protocols has always offered native data encryption?",
    "choice_a": "GRE",
    "choice_b": "L2TP",
    "choice_c": "IPsec",
    "choice_d": "PPTP",
    "correct_answer": "C",
    "explanation": "From this list of VPN protocols, only IPsec has always offered native data encryption. Generic Routing Encapsulation (GRE) is a proprietary Cisco tunneling protocol that can be used to establish VPNs. GRE provides encapsulation but not encryption. L2TP does not offer native data encryption, but it can support IPsec's ESP to provide encryption. PPTP did not originally provide native data encryption, but with the adoption of MS-CHAPv2 that feature was added.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      416,
      415,
      413,
      412,
      350
    ],
    "source": ""
  },
  {
    "id": 4162,
    "question": "A ___________________ is the combination of hardware and software networking components into a single integrated entity. The resultant system allows software control over all network functions, management, traffic shaping, address assignment, and so on. A single management console or interface can be used to oversee every aspect of the network, a task requiring physical presence at each hardware component in the past.",
    "choice_a": "Wireless network",
    "choice_b": "Virtualized network",
    "choice_c": "Private network",
    "choice_d": "VLAN network",
    "correct_answer": "B",
    "explanation": "A virtualized network, or network virtualization, is the combination of hardware and software networking components into a single integrated entity. The resultant system allows for software control over all network functions, management, traffic shaping, address assignment, and so on. A single management console or interface can be used to oversee every aspect of the network, a task requiring physical presence at each hardware component in the past. This statement does not describe wireless networks (there is no mention of radio channels or frequencies), private networks (this could describe an extranet, screened subnet, external networks, and cloud networks), or VLAN networks (there is no mention of switches).",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      354,
      404,
      419,
      355,
      429
    ],
    "source": ""
  },
  {
    "id": 4163,
    "question": "Which type of connection created by a packet-switching networking system reuses the same basic parameters or virtual pathway each time it connects?",
    "choice_a": "Switched virtual circuit (SVC)",
    "choice_b": "Bandwidth on-demand connection",
    "choice_c": "Permanent virtual circuit (PVC)",
    "choice_d": "VLAN connection",
    "correct_answer": "C",
    "explanation": "A PVC reestablishes a link using the same basic parameters or virtual pathway each time it connects. SVCs use unique settings each time. Bandwidth on-demand links can be either PVCs or SVCs. VLAN is not a packet-switching technology.",
    "topic_id": 4,
    "practice_test_id": 9,
    "related_articles": [
      432,
      431,
      439,
      412,
      419
    ],
    "source": ""
  },
  {
    "id": 4164,
    "question": "John has been tasked by the CISO to help establish a new asset protection plan. Recent audits reveal that compromises have occurred due to a lack of adequate protection for sensitive and critical assets. <br>Which of the following would be an asset that an organization would want to protect with access controls?  (Select all that apply.)",
    "choice_a": "Information",
    "choice_b": "Systems",
    "choice_c": "Devices",
    "choice_d": "Sessions",
    "correct_answer": [
      "A",
      "B",
      "C"
    ],
    "explanation": "Information, systems, and devices are assets that an organization would want to protect. Though not listed, facilities and applications are also assets that an organization would want to protect. Sessions are not assets.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      440,
      448,
      472,
      465,
      466
    ],
    "source": ""
  },
  {
    "id": 4165,
    "question": "Management wants to add a biometric access control into the main server room. They want to add a method that is the most accurate without being invasive. <br>Which of the following would meet these requirements?",
    "choice_a": "Retina",
    "choice_b": "Iris",
    "choice_c": "Smartcards",
    "choice_d": "Fingerprints",
    "correct_answer": "B",
    "explanation": "Iris scanners are the most accurate, noninvasive biometric control from those listed. Though retina scans are more accurate that iris scans, they are invasive and can reveal medical conditions such as pregnancy. Smartcards are not biometric controls. Fingerprints are not the most accurate.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      748,
      445,
      750,
      749,
      459
    ],
    "source": ""
  },
  {
    "id": 4166,
    "question": "Which of the following identifies a characteristic of a decentralized access control?",
    "choice_a": "It scales up easily.",
    "choice_b": "It can be a single point of failure.",
    "choice_c": "It always uses a single authenticator app.",
    "choice_d": "Administrative overhead is high.",
    "correct_answer": "D",
    "explanation": "Administrative overhead is high in a decentralized access control model. Decentralized access control does not scale up easily and it does not have a single point of failure. It has multiple entities checking authentication, such as at every computer. Although a decentralized access control model may use a single authenticator application, all implementations of decentralized access controls would not use a single authenticator application.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      450,
      472,
      491,
      493,
      469
    ],
    "source": ""
  },
  {
    "id": 4167,
    "question": "Which of the following best describes two-factor authentication?",
    "choice_a": "It requires users to authenticate with two independent proofs of identity.",
    "choice_b": "It requires users to authenticate with text messages and a password.",
    "choice_c": "It requires users to authenticate with single sign-on technologies.",
    "choice_d": "It requires users to provide both a unique identifier and a password.",
    "correct_answer": "A",
    "explanation": "Two-factor authentication (2FA) requires users to authenticate with two independent proofs of identity, such as a fingerprint and a password. Requiring users to authenticate with text messages and a password is an example of 2FA, but it doesn't describe 2FA. 2FA describes how someone logs on, but it doesn't require the use of single sign-on (SSO). A unique identifier is a username, and it is used for identification. A unique identifier with only a password is a single factor of authentication.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      446,
      444,
      469,
      449,
      454
    ],
    "source": ""
  },
  {
    "id": 4168,
    "question": "You want to ensure your IT network supports accountability. <br>Which of the following is necessary to meet this requirement?",
    "choice_a": "Identification",
    "choice_b": "Audit trails",
    "choice_c": "Authorization",
    "choice_d": "Confidentiality",
    "correct_answer": "B",
    "explanation": "Audit trails provide documentation on what happened, when it happened, and who did it. IT personnel create audit trails by examining logs. Authentication of individuals is also needed to ensure the audit trails provide proof of identities listed in the logs. Identification occurs when an individual claims an identity, but identification without authentication doesn't provide accountability. Authorization grants individuals access to resources based on their proven identity. Confidentiality ensures that unauthorized entities can't access sensitive data and is unrelated to this question.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      441,
      1074,
      1073,
      479,
      461
    ],
    "source": ""
  },
  {
    "id": 4169,
    "question": "Human resources personnel are setting up a new employee with a user account. They are also capturing the new employee's fingerprints as an authentication mechanism. <br>What is this process called?",
    "choice_a": "Establishment of identity",
    "choice_b": "Proofing",
    "choice_c": "Registration",
    "choice_d": "Biometric authentication",
    "correct_answer": "C",
    "explanation": "Registration occurs when capturing an individual's biometric data. New employees provide paperwork, such as a driver's license and birth certificate to establish their identity. Identity proofing requires users to answer questions to prove their identity. The fingerprints will be used for biometric authentication, but capturing the fingerprints is the registration process.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      442,
      445,
      459,
      455,
      443
    ],
    "source": ""
  },
  {
    "id": 4170,
    "question": "Customers frequently return to an e-commerce site to make additional purchases. The company wants to allow customers to be automatically logged on when they visit. <br>Which of the following will meet this need?",
    "choice_a": "Service authentication",
    "choice_b": "The Credential Management API",
    "choice_c": "Single sign-on (SSO)",
    "choice_d": "Session management",
    "correct_answer": "B",
    "explanation": "The Credential Management application programming interface (API) will meet this need. It was published by the World Wide Web Consortium (W3C) as a working draft in January 2019. Service authentication refers to using service accounts to run services or applications. SSO allows users to log on once and access multiple resources. SSO isn't used for a single site. Session management is used to close inactive sessions.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      453,
      460,
      454,
      451,
      976
    ],
    "source": ""
  },
  {
    "id": 4171,
    "question": "New employees can choose their health plan by accessing a third-party website from the company website. When they access the third-party website, it automatically creates a user account for the employee. <br>What is being used?",
    "choice_a": "Security Assertion Markup Language (SAML)",
    "choice_b": "Credential management",
    "choice_c": "Identity as a service (IDaaS)",
    "choice_d": "Just-in-time (JIT)",
    "correct_answer": "D",
    "explanation": "Just-in-time provisioning creates a user account after accessing a third-party website. JIT systems commonly use SAML, but SAML is used for many other purposes. Credential management processes store credentials, but they don't create accounts. IDaaS provides SSO for cloud resources but doesn't create accounts.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      761,
      1016,
      762,
      460,
      452
    ],
    "source": ""
  },
  {
    "id": 4172,
    "question": "An organization is using a cloud-based federated identity management system to share resources with several partners. After merging with another company, they decide to implement another internally controlled identity management system to share resources with the other company. <br>Which of the following best describes the identity management system after this implementation?",
    "choice_a": "On-premises",
    "choice_b": "Cloud",
    "choice_c": "Hybrid",
    "choice_d": "Session management",
    "correct_answer": "C",
    "explanation": "This describes a hybrid identity management system. They started with a cloud-based identity management system to share resources with partners, and the scenario doesn't say they stopped using it. The internally controlled identity management system is an on-premises system, and it was added to the existing cloud-based identity management system, creating a hybrid system. Session management closes unattended sessions and is unrelated to this question.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      452,
      451,
      474,
      460,
      450
    ],
    "source": ""
  },
  {
    "id": 4173,
    "question": "Sally has been hired by an organization, and the personnel department is configuring an account for her. <br>Which of the following must be included in the account configuration?",
    "choice_a": "Account identifier",
    "choice_b": "Full name",
    "choice_c": "Email address",
    "choice_d": "Department",
    "correct_answer": "A",
    "explanation": "A user account must have an account identifier (also known as a username). Other information such as a full name, an email address, and the department where an employee works can also be added, but they are optional. Note that email addresses are sometimes used as the username, but not all systems use the email address as the username.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      455,
      461,
      458,
      760,
      1065
    ],
    "source": ""
  },
  {
    "id": 4174,
    "question": "After a recent attack on your network, a security analyst discovered the attacker took advantage of a pass-the-hash vulnerability. <br>Which of the following has the best chance of mitigating this risk?",
    "choice_a": "Disable NT LAN Manager (NTLM).",
    "choice_b": "Enable Kerberos.",
    "choice_c": "Enable Challenge Handshake Authentication Protocol (CHAP).",
    "choice_d": "Disable Network Time Protocol (NTP).",
    "correct_answer": "A",
    "explanation": "NTLM has known vulnerabilities to pass-the-hash attacks, so disabling it is the best answer. Enabling Kerberos or CHAP won't eliminate the NTLM vulnerability to pass-the-hash attacks. A pass-the-hash attack is an authentication attack, and NTP is unrelated.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      187,
      195,
      197,
      228,
      215
    ],
    "source": ""
  },
  {
    "id": 4175,
    "question": "An organization has an access control model that applies to all sales managers in the organization. <br>What type of access control model is this?",
    "choice_a": "Identity based",
    "choice_b": "Label based",
    "choice_c": "Rule based",
    "choice_d": "Role based",
    "correct_answer": "D",
    "explanation": "A Role-Based Access Control (RBAC) model is based on job functions such as a salesperson or a sales manager, and it groups users into roles. A Discretionary Access Control (DAC) model is an identity-based access control model. A Mandatory Access Control (MAC) model uses assigned labels to identify access. A rule-based access control model is based on rules within an ACL.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      466,
      491,
      472,
      467,
      462
    ],
    "source": ""
  },
  {
    "id": 4176,
    "question": "The MAC model supports different environment types. <br>Which of the following is based on levels of access and compartments within each level?",
    "choice_a": "Hybrid environment",
    "choice_b": "Hierarchical environment",
    "choice_c": "Compartmentalized environment",
    "choice_d": "Security environment",
    "correct_answer": "A",
    "explanation": "Hybrid environments combine both hierarchical and compartmentalized environments so that security levels have sub-compartments. The hierarchical environment uses levels to assign access. A compartmentalized environment ignores the levels and only allows access for individual compartments on any level. The Mandatory Access Control (MAC) model doesn't specify a security environment.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      468,
      472,
      491,
      470,
      462
    ],
    "source": ""
  },
  {
    "id": 4177,
    "question": "Your organization has recently implemented an SDN to separate the control plane from the data plane. <br>Which of the following models will the SDN most likely use?",
    "choice_a": "Attribute-Based Access Control (ABAC)",
    "choice_b": "Discretionary Access Control (DAC)",
    "choice_c": "Mandatory Access Control (MAC)",
    "choice_d": "Role-Based Access Control (RBAC)",
    "correct_answer": "A",
    "explanation": "A software-defined network (SDN) typically uses an Attribute-Based Access Control (ABAC) model. SDNs don't usually use the DAC, MAC, or RBAC model.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      491,
      467,
      469,
      472,
      465
    ],
    "source": ""
  },
  {
    "id": 4178,
    "question": "An attacker exploited a regular user's Windows system and then began collecting information on other computers within the network using PowerShell. After running a script on a remote machine, the attacker captured an administrator account's password and began running commands with administrator rights and permissions. <br>What does this describe?",
    "choice_a": "Pass-the-hash attack",
    "choice_b": "Kerberos exploitation",
    "choice_c": "Privilege escalation",
    "choice_d": "Using sudo",
    "correct_answer": "C",
    "explanation": "The scenario describes privilege escalation. The attacker used different techniques to get administrator privileges after having only regular user privileges. A pass-the-hash attack uses a hash of a password. Kerberos exploitation techniques exploit Kerberos, but Kerberos isn't mentioned in this scenario. The <code>sudo</code> command is used on Linux systems, not Windows systems.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      484,
      490,
      493,
      487,
      462
    ],
    "source": ""
  },
  {
    "id": 4179,
    "question": "Which of the following technologies use SAML?  (Select all that apply.)",
    "choice_a": "Federated organizations",
    "choice_b": "Kerberos",
    "choice_c": "TACACS+",
    "choice_d": "RADIUS",
    "correct_answer": [
      "A",
      "E"
    ],
    "explanation": "Federated organizations use the Security Assertion Markup Language (SAML) to support single sign-on (SSO) capabilities on the internet. SAML is an open-XML-based standard. Kerberos, Terminal Access Controller Access-Control System Plus (TACACS+), and Remote Authentication Dial-in User Service (RADIUS) do not use SAML.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      474,
      481,
      492,
      480,
      1020
    ],
    "source": "",
    "choice_e": "Single sign-on"
  },
  {
    "id": 4180,
    "question": "Which of the following best describes a benefit of RADIUS?",
    "choice_a": "RADIUS always uses TCP for guaranteed delivery.",
    "choice_b": "RADIUS separates authentication, authorization, and accounting into three different processes.",
    "choice_c": "RADIUS provides both authentication and authorization.",
    "choice_d": "RADIUS uses tickets.",
    "correct_answer": "C",
    "explanation": "Remote Authentication Dial-in User Service (RADIUS) provides centralized authentication, authorization, and accounting (AAA) services. RADIUS typically uses User Datagram Protocol (UDP), not Transmission Control Protocol (TCP). RADIUS combines authentication and authorization in one process and accounting in a second process. Terminal Access Controller Access-Control System Plus (TACACS+) separates authentication, authorization, and accounting into three processes. Kerberos uses tickets, but RADIUS doesn't use tickets.",
    "topic_id": 5,
    "practice_test_id": 9,
    "related_articles": [
      479,
      441,
      492,
      477,
      478
    ],
    "source": ""
  },
  {
    "id": 4181,
    "question": "Which of the following security assessment and testing program components may be performed by security professionals in the IT organization?",
    "choice_a": "Internal audit",
    "choice_b": "External audit",
    "choice_c": "Criminal investigation",
    "choice_d": "Security Assessment",
    "correct_answer": "D",
    "explanation": "IT staff may perform security assessments to evaluate the security of their systems and applications. Audits must be performed by internal or external auditors who are independent of the IT organization. Criminal investigations must be performed by certified law enforcement personnel.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      1007,
      1006,
      862,
      1008,
      1080
    ],
    "source": ""
  },
  {
    "id": 4182,
    "question": "Beth would like to run an nmap scan against all of the systems on her organization's private network. These include systems in the 10.0.0.0 private address space. She would like to scan this entire private address space because she is not certain what subnets are used. <br>What network address should Beth specify as the target of her scan?",
    "choice_a": "10.0.0.0/0",
    "choice_b": "10.0.0.0/8",
    "choice_c": "10.0.0.0/16",
    "choice_d": "10.0.0.0/24",
    "correct_answer": "B",
    "explanation": "The use of an 8-bit subnet mask means that the first octet of the IP address represents the network address. In this case, that means 10.0.0.0/8 will scan any IP address beginning with 10.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      769,
      771,
      859,
      776,
      772
    ],
    "source": ""
  },
  {
    "id": 4183,
    "question": "David ran an nmap scan against a server and determined that port 443 is open on the server. <br>What tool would likely provide him the best additional information about the server's purpose and the identity of the server's operator?",
    "choice_a": "SSH",
    "choice_b": "Web browser",
    "choice_c": "Telnet",
    "choice_d": "Ping",
    "correct_answer": "B",
    "explanation": "The server is likely running a secure website on port 443. Using a web browser to access the site may provide important information about the site's purpose.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      763,
      787,
      788,
      495,
      861
    ],
    "source": ""
  },
  {
    "id": 4184,
    "question": "What phase of a business impact assessment calculates the SLE for a given risk scenario?",
    "choice_a": "Risk identification",
    "choice_b": "Likelihood assessment",
    "choice_c": "Impact assessment",
    "choice_d": "Resource prioritization",
    "correct_answer": "C",
    "explanation": "The single loss expectancy (SLE) is a measure of how much damage would occur each time a risk materializes. It is a measure of risk impact.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      502,
      790,
      768,
      500,
      789
    ],
    "source": ""
  },
  {
    "id": 4185,
    "question": "An organization has a patch management program but wants to implement another method to ensure that systems are kept up-to-date. <br>What could they use?",
    "choice_a": "Change management program",
    "choice_b": "Configuration management program",
    "choice_c": "Port scanners",
    "choice_d": "Vulnerability scanners",
    "correct_answer": "D",
    "explanation": "Vulnerability scanners can check systems to ensure they are up-to-date with current patches (along with other checks) and are an effective tool to verify the patch management program. Change and configuration management programs ensure systems are configured as expected and unauthorized changes are not allowed. A port scanner is often part of a vulnerability scanner, but it will check only for open ports, not patches.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      787,
      860,
      861,
      859,
      789
    ],
    "source": ""
  },
  {
    "id": 4186,
    "question": "Alice would like to perform mutation fuzzing as part of her testing of new code moving into production. <br>What tool would help her perform this fuzzing?",
    "choice_a": "Nmap",
    "choice_b": "Metasploit Framework",
    "choice_c": "OpenVAS",
    "choice_d": "zzuf",
    "correct_answer": "D",
    "explanation": "zzuf is a tool that automates the process of mutation fuzzing.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      776,
      775,
      777,
      496,
      778
    ],
    "source": ""
  },
  {
    "id": 4187,
    "question": "Brian is conducting an internal assessment of a U.S. federal government system to determine whether it has appropriate security and privacy controls. <br>Which one of the following NIST documents would best guide him through this process?",
    "choice_a": "NIST SP 800-53",
    "choice_b": "NIST SP 800-53A",
    "choice_c": "NIST SP 800-171",
    "choice_d": "NIST SP 800-171A",
    "correct_answer": "B",
    "explanation": "NIST SP 800-53A is entitled Security and Privacy Controls for Information Systems and Organizations and would be the best guide for Brian's assessment.  NIST SP 800-53 itself is a description of controls, while NIST SP 800-171 applies specifically to environments containing controlled unclassified information.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      863,
      864,
      1007,
      1006,
      502
    ],
    "source": ""
  },
  {
    "id": 4188,
    "question": "Analyze the output of a nmap scan shown below: <br><br><img src=\"/question_assets/CISSP/sg_image_3.png\"/><br>What type of server most likely generated these results?",
    "choice_a": "Web server",
    "choice_b": "Database server",
    "choice_c": "IAM server",
    "choice_d": "FTP server",
    "correct_answer": "A",
    "explanation": "The key indicators in this report are the presence of TCP ports 80 and 443.  These ports correspond to the HTTP and HTTPS services, respectively, and are indicative of a web server. Port 22 is used for SSH connections and may be open on any server that accepts administrative connections. It is not typically associated with the type of server being scanned.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      763,
      787,
      765,
      764,
      771
    ],
    "source": ""
  },
  {
    "id": 4189,
    "question": "Joe's organization uses a rigorous code review process that includes six formal steps: planning, overview, preparation, inspection, rework, and follow-up. <br>What term best describes this approach?",
    "choice_a": "Fagan inspection",
    "choice_b": "Agile development",
    "choice_c": "Waterfall method",
    "choice_d": "Spiral model",
    "correct_answer": "A",
    "explanation": "The Fagan inspection model uses the six formal steps of planning, overview, preparation, inspection, rework, and follow-up to conduct a formal code review process.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      1021,
      1022,
      494,
      1023,
      1003
    ],
    "source": ""
  },
  {
    "id": 4190,
    "question": "Roger would like to verify that his organization's intrusion prevention system is working properly. <br>What type of system would conduct this verification on an ongoing basis?",
    "choice_a": "SIEM",
    "choice_b": "BAS",
    "choice_c": "IDS",
    "choice_d": "GRC",
    "correct_answer": "B",
    "explanation": "Breach and attack simulation (BAS) systems are designed to inject threat indicators onto systems and networks in an effort to trigger other security controls.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      502,
      501,
      1079,
      1080,
      494
    ],
    "source": ""
  },
  {
    "id": 4191,
    "question": "Which one of the following is least likely to be used as a key performance and risk indicator for an organization's cybersecurity program?",
    "choice_a": "Number of open vulnerabilities",
    "choice_b": "Time to process user requests",
    "choice_c": "Repeat audit findings",
    "choice_d": "Number of compromised accounts",
    "correct_answer": "B",
    "explanation": "The number of open vulnerabilities, repeat audit findings, and the number of compromised accounts are all commonly used as key performance and risk indicators.  The time required to process a user request is not generally included in this list.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      502,
      789,
      861,
      499,
      498
    ],
    "source": ""
  },
  {
    "id": 4192,
    "question": "After completing a vulnerability scan, Mike determined that the operating system on one of his servers has a two-year old vulnerability. He consulted the organization's risk documentation and finds no mention of the vulnerability. <br>What would be the best way for Mike to correct this issue?",
    "choice_a": "Apply a patch",
    "choice_b": "Remove the server from service",
    "choice_c": "Deploy a new firewall configuration",
    "choice_d": "Update intrusion prevention rules",
    "correct_answer": "A",
    "explanation": "While any of these techniques may resolve the issue, the best approach would be to apply a patch and correct the underlying problem.  The issue is two years old, so a patch is most likely available and this approach would allow the machine to stay in service. By consulting the risk documentation, Mike determined that the organization has not already accepted this risk and, therefore, the direct approach of patching it is most appropriate.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      861,
      789,
      502,
      860,
      787
    ],
    "source": ""
  },
  {
    "id": 4193,
    "question": "Who is generally the recipient of audit reports generated by an internal audit function?",
    "choice_a": "Executives",
    "choice_b": "Shareholders",
    "choice_c": "Customers",
    "choice_d": "Partners",
    "correct_answer": "A",
    "explanation": "Internal audit reports are generally performed by an organization's own internal audit staff and are typically intended for internal audiences, such as executives.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      862,
      863,
      768,
      795,
      1008
    ],
    "source": ""
  },
  {
    "id": 4194,
    "question": "After completing a SOC 1 engagement, Helen prepared a report providing her opinion on the description of controls provided by management and the suitability of the design of those controls.  She did not perform any testing of the controls. <br>What type of report did she prepare?",
    "choice_a": "Type I",
    "choice_b": "Type II",
    "choice_c": "Type III",
    "choice_d": "Type IV",
    "correct_answer": "A",
    "explanation": "Type I reports provide the auditor's opinion on the description of controls provided by management and the suitability of the design of those controls.  Type II reports go further and also provide the auditor's opinion on the operating effectiveness of the controls based upon testing.  Type III and IV reports do not exist under SSAE 18.",
    "topic_id": 6,
    "practice_test_id": 9,
    "related_articles": [
      767,
      793,
      794,
      795,
      768
    ],
    "source": ""
  },
  {
    "id": 4195,
    "question": "A new CIO realizes that an organization doesn't have an inventory of intangible assets. She directs department heads to create inventories held in their department. <br>Which of the following BEST represents an example of an intangible asset that department heads should include?",
    "choice_a": "Servers",
    "choice_b": "Removable media",
    "choice_c": "Software license keys",
    "choice_d": "Company reputation",
    "correct_answer": "D",
    "explanation": "Of the given choices, the company's reputation is the best example of an intangible assets. The other answers are examples of tangible asset items.",
    "topic_id": 2,
    "practice_test_id": 9,
    "related_articles": [
      123,
      143,
      849,
      133,
      125
    ],
    "source": ""
  },
  {
    "id": 4196,
    "question": "Administrators implement a least privilege policy when creating accounts. <br>What does this do?",
    "choice_a": "Enforce the most restrictive rights required by users to run system processes.",
    "choice_b": "Enforce the least restrictive rights required by users to run system processes.",
    "choice_c": "Enforce the most restrictive rights required by users to complete assigned tasks.",
    "choice_d": "Enforce the least restrictive rights required by users to complete assigned tasks.",
    "correct_answer": "C",
    "explanation": "The least privilege principle ensures that users (subjects) are granted only the most restrictive rights they need to perform their work tasks and job functions. Users don't execute system processes. The least privilege principle does not enforce the least restrictive rights but rather the most restrictive rights.",
    "topic_id": 3,
    "practice_test_id": 9,
    "related_articles": [
      715,
      229,
      215,
      718,
      717
    ],
    "source": ""
  },
  {
    "id": 4197,
    "question": "A new CIO is modifying policies to increase overall security. She wants to ensure that a separation of duties policy is applied for employees working in key positions. <br>Which of the following statements best describes why a separation of duties policy is essential for security purposes?",
    "choice_a": "It ensures that multiple people can do the same job.",
    "choice_b": "It prevents an organization from losing important information when they lose important people.",
    "choice_c": "It prevents any single IT security person from making major security changes without involving other individuals.",
    "choice_d": "It helps employees concentrate their talents where they will be most useful.",
    "correct_answer": "C",
    "explanation": "A separation of duties (SoD) policy prevents a single person from controlling all elements of a process. When applied to security settings, it can prevent a person from making major security changes without assistance. Job rotation helps ensure that multiple people can do the same job and can help prevent the organization from losing information when a single person leaves. Having employees concentrate their talents is unrelated to separation of duties.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      533,
      504,
      505,
      543,
      556
    ],
    "source": ""
  },
  {
    "id": 4198,
    "question": "Backup tapes have reached the end of their lifecycle and need to be disposed of. <br>Which of the following is the most appropriate disposal method?",
    "choice_a": "Throw them away. Because they are at the end of their lifecycle, it is not possible to read data from them.",
    "choice_b": "Purge the tapes of all data before disposing of them.",
    "choice_c": "Erase data off the tapes before disposing of them.",
    "choice_d": "Store the tapes in a storage facility.",
    "correct_answer": "B",
    "explanation": "The tapes should be purged, ensuring that data cannot be recovered using any known means. Even though tapes may be at the end of their lifecycle, they can still hold data and should be purged before throwing them away. Erasing doesn't  remove all usable data from media, but purging does. There is no need to store the tapes if they are at the end of their lifecycle.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      518,
      517,
      515,
      541,
      512
    ],
    "source": ""
  },
  {
    "id": 4199,
    "question": "An organization has a high-value data center in the center of a building. Management wants to upgrade the security allowing employees to raise a silent duress alarm as they enter. <br>Which of the following would support this goal?",
    "choice_a": "Motion detection",
    "choice_b": "Face recognition door lock",
    "choice_c": "Proximity card lock",
    "choice_d": "Cipher door lock",
    "correct_answer": "D",
    "explanation": "Some cipher locks can be programmed with more than one code. One code can open the door, and another code can open the door and also raise a silent alarm. None of the other answers support dual use of the same physical security control. Motion detection would detect all motion and can't differentiate between normal activity and a duress situation. A proximity card lock opens a door when an employee places a proximity card close to a proximity card reader. A face recognition door lock will open the door if the employee's face is recognized, or it won't open the door if the employee's face is not recognized. The face recognition system doesn't have a third option to open the door and raise a silent alarm.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      509,
      508,
      855,
      854,
      543
    ],
    "source": ""
  },
  {
    "id": 4200,
    "question": "A web server hosted on the Internet was recently attacked, exploiting a vulnerability in the operating system. The operating system vendor assisted in the incident investigation and verified that the vulnerability was not previously known. <br>What type of attack does this describe?",
    "choice_a": "Botnet",
    "choice_b": "Zero-day exploit",
    "choice_c": "Denial-of-service",
    "choice_d": "Distributed denial-of-service",
    "correct_answer": "B",
    "explanation": "A zero-day exploit takes advantage of a previously unknown vulnerability. A botnet is a group of computers controlled by a bot herder that can launch attacks, but they can exploit both known vulnerabilities and previously unknown vulnerabilities. Similarly, denial-of-service (DoS) and distributed DoS (DDoS) attacks could use zero-day exploits or use known methods.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      531,
      530,
      544,
      545,
      546
    ],
    "source": ""
  },
  {
    "id": 4201,
    "question": "You are updating your organization's security policy and want to include the phases of incident management in the correct order. <br>Which of the following correctly lists the order of incident management?",
    "choice_a": "Response, mitigation, reporting, recovery, remediation, and lessons learned",
    "choice_b": "Detection, response, mitigation, recovery, reporting, remediation, and lessons learned",
    "choice_c": "Remediation, detection, response, mitigation, reporting, recovery, and lessons learned",
    "choice_d": "Detection, response, mitigation, reporting, recovery, remediation, and lessons learned",
    "correct_answer": "D",
    "explanation": "The correct order is detection, response, mitigation, reporting, recovery, remediation, and lessons learned. Response comes after detection. Incidents should be reported before recovery. Remediation is the sixth step, not the first step.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      537,
      565,
      539,
      540,
      538
    ],
    "source": ""
  },
  {
    "id": 4202,
    "question": "Your network is using an intrusion detection system (IDS) to detect attacks with pattern matching algorithms. <br>Which of the following describes a primary benefit of this system?",
    "choice_a": "A high false-negative rate",
    "choice_b": "It can detect new attacks",
    "choice_c": "It can prevent attacks from entering a network",
    "choice_d": "A low false-positive rate",
    "correct_answer": "D",
    "explanation": "A pattern-matching IDS (also known as signature-based detection) has a low false-positive rate. A high false-negative rate isn't a benefit because it is not reporting on an active attack. A pattern-matching IDS often misses new attacks because it doesn't have the signature for the new attacks. An IDS can detect an attack after it enters a network. An intrusion prevention system (IPS) can prevent an attack from entering a network because it is placed in-line.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      566,
      548,
      547,
      538,
      544
    ],
    "source": ""
  },
  {
    "id": 4203,
    "question": "What type of alternate processing facility takes advantage of Infrastructure-as-a-Service (IaaS) providers?",
    "choice_a": "Hot site",
    "choice_b": "Warm site",
    "choice_c": "Cold site",
    "choice_d": "Cloud site",
    "correct_answer": "D",
    "explanation": "Cloud service providers offer Infrastructure-as-a-Service options that are ideal backup sites.  Hot sites, warm sites, and cold sites are all dedicated facilities that are operated by either an organization's own team or a collocation site provider.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      582,
      913,
      519,
      589,
      598
    ],
    "source": ""
  },
  {
    "id": 4204,
    "question": "Which of the following disasters is unpreventable but still considered a part of any formal security-planning phase?",
    "choice_a": "Utility failure",
    "choice_b": "Infrastructure failure",
    "choice_c": "Power outage",
    "choice_d": "Natural disaster",
    "correct_answer": "D",
    "explanation": "Natural disasters are always factored into any formal recovery plan because they are unpreventable and unavoidable interruptions to business and business processes.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      569,
      952,
      570,
      592,
      586
    ],
    "source": ""
  },
  {
    "id": 4205,
    "question": "Vince would like to perform a backup that will copy only those files that have been modified since the most recent full backup. <br>What type of backup should he perform?",
    "choice_a": "Full backup",
    "choice_b": "Incremental backup",
    "choice_c": "Transaction log backup",
    "choice_d": "Differential backup",
    "correct_answer": "D",
    "explanation": "Differential backups copy all files modified since the most recent full backup. Incremental backups copy all files that have been modified since the most recent full or incremental backup.  Full backups copy all files. Transaction log backups copy database transactions, rather than files.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      588,
      589,
      584,
      596,
      592
    ],
    "source": ""
  },
  {
    "id": 4206,
    "question": "What combination of backup strategies provides the fastest backup creation time?",
    "choice_a": "Full backups and differential backups",
    "choice_b": "Partial backups and incremental backups",
    "choice_c": "Full backups and incremental backups",
    "choice_d": "Incremental backups and differential backups",
    "correct_answer": "C",
    "explanation": "Any backup strategy must include full backups at some point in the process. Incremental backups are created faster than differential backups because of the number of files it is necessary to back up each time.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      588,
      589,
      594,
      597,
      518
    ],
    "source": ""
  },
  {
    "id": 4207,
    "question": "What type of database backup strategy involves maintenance of a live backup server at the remote site?",
    "choice_a": "Transaction logging",
    "choice_b": "Remote journaling",
    "choice_c": "Electronic vaulting",
    "choice_d": "Remote mirroring",
    "correct_answer": "D",
    "explanation": "Remote mirroring is the only backup option in which a live backup server at a remote site maintains a bit-for-bit copy of the contents of the primary server, synchronized as closely as the latency in the link between primary and remote systems will allow.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      584,
      598,
      588,
      589,
      596
    ],
    "source": ""
  },
  {
    "id": 4208,
    "question": "The backup administrator configures a system to perform full backups on Sundays at 1AM and incremental backups on Mondays through Saturdays at 1AM. The system fails on Wednesday at 4PM. <br>What backups must be applied?",
    "choice_a": "Sunday only",
    "choice_b": "Sunday, Monday, Tuesday, and Wednesday",
    "choice_c": "Sunday and Wednesday only",
    "choice_d": "Sunday, Monday, and Wednesday only",
    "correct_answer": "B",
    "explanation": "With incremental backups, you must first restore the most recent full backup and then apply all incremental backups that occurred since that full backup.  Therefore, the administrator must restore the backups from Sunday, Monday, Tuesday, and Wednesday.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      588,
      589,
      586,
      598,
      595
    ],
    "source": ""
  },
  {
    "id": 4209,
    "question": "What type of evidence must be authenticated by a witness who can uniquely identify it or through a documented chain of custody?",
    "choice_a": "Documentary evidence",
    "choice_b": "Testimonial evidence",
    "choice_c": "Real evidence",
    "choice_d": "Hearsay evidence",
    "correct_answer": "C",
    "explanation": "Real evidence must be either uniquely identified by a witness or authenticated through a documented chain of custody.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      981,
      980,
      979,
      17,
      1
    ],
    "source": ""
  },
  {
    "id": 4210,
    "question": "Which one of the following is <italic>not</italic> a canon of the ISC2 Code of Ethics?",
    "choice_a": "Protect society, the commonwealth, and the infrastructure.",
    "choice_b": "Take no action that jeopardizes the business interests of principals.",
    "choice_c": "Act honorably, honestly, justly, responsibly, and legally.",
    "choice_d": "Advance and protect the profession.",
    "correct_answer": "B",
    "explanation": "The Code of Ethics does not require that you protect the business interests of the principals. In fact, you may find yourself ethically bound to take action that jeopardizes those business interests.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      955,
      956,
      15,
      14,
      11
    ],
    "source": ""
  },
  {
    "id": 4211,
    "question": "What standard of evidence is required for investigators to obtain a search warrant?",
    "choice_a": "Probable cause",
    "choice_b": "Reasonable certainty",
    "choice_c": "Beyond a shadow of a doubt",
    "choice_d": "Due care",
    "correct_answer": "A",
    "explanation": "To obtain a search warrant, investigators must have probable cause that demonstrates that they will likely collect evidence related to a crime.  The standards of reasonable certainty, beyond a shadow of a doubt, and due care do not apply to the procurement of a search warrant.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      981,
      979,
      20,
      112,
      11
    ],
    "source": ""
  },
  {
    "id": 4212,
    "question": "David is gathering evidence in support of an investigation and wishes to collect network traffic. <br>Which methods provide the most reliable means of collecting and preserving the contents of network traffic?  (Select all that apply.)",
    "choice_a": "SPAN port",
    "choice_b": "NetFlow data",
    "choice_c": "Packet capture software on workstation",
    "choice_d": "Network tap",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "SPAN ports and network taps are the most reliable mechanisms for gathering network traffic.  Packet capture software is also a possible technique, but it is less reliable because it must run on one of the targeted systems.  NetFlow data is a reliable source of evidence, but it only captures information about the parties involved in a communication and the amount of data exchanged.  It does not include the contents of network traffic.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      603,
      602,
      541,
      601,
      605
    ],
    "source": ""
  },
  {
    "id": 4213,
    "question": "Kayla is preparing to testify in court about an attack waged against her organization.  She understands that the material she is presenting is complex and is preparing a diagram of the attack to bring into court to help explain the concept. <br>What term best describes the chart she is preparing?",
    "choice_a": "Documentary evidence",
    "choice_b": "Testimonial evidence",
    "choice_c": "Real evidence",
    "choice_d": "Demonstrative evidence",
    "correct_answer": "D",
    "explanation": "Kayla will be providing testimonial evidence when she is in court.  The diagram that she will use to support this testimony is best classified as demonstrative evidence.  It is not real or documentary evidence because it is not being used as proof itself, but rather to illustrate a concept.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      601,
      602,
      605,
      607,
      615
    ],
    "source": ""
  },
  {
    "id": 4214,
    "question": "Gina is responsible for the operations and maintenance activities within her organization's software development group and would like to use a tool to help manage the organization's code repository. <br>Which one of the following tools would be best suited to this task?",
    "choice_a": "nmap",
    "choice_b": "git",
    "choice_c": "netcat",
    "choice_d": "tripwire",
    "correct_answer": "B",
    "explanation": "Git is a code repository management tool that would work well for Gina's task.  Nmap is a port scanning tool.  Netcat is a tool used to read and write to network connections.  Tripwire is a file integrity management package.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      628,
      670,
      1030,
      1031,
      640
    ],
    "source": ""
  },
  {
    "id": 4215,
    "question": "Carla is considering the use of new toolsets in her work as a software developer.  She would like to use a tool that allows her to code, troubleshoot, and compile all in a single interface. <br>Which one of the following tool categories would best meet her needs?",
    "choice_a": "IDE",
    "choice_b": "IPT",
    "choice_c": "IDS",
    "choice_d": "IPS",
    "correct_answer": "A",
    "explanation": "An integrated development environment (IDE) provides a single interface for writing, testing, and deploying code and would meet Carla's needs.  Integrated product teams (IPT) are an organization approach to system development used by the U.S. Department of Defense.  Intrusion detection systems (IDS) and intrusion prevention systems (IPS) are security controls used to protect endpoints and networks from malicious activity.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      814,
      815,
      625,
      628,
      1031
    ],
    "source": ""
  },
  {
    "id": 4216,
    "question": "Which of the following are common reasons to support the logging of changes in a software development environment?  (Select all that apply.)",
    "choice_a": "Support audits",
    "choice_b": "Support investigations",
    "choice_c": "Support troubleshooting",
    "choice_d": "Support analysis efforts",
    "correct_answer": [
      "A",
      "B",
      "C",
      "D"
    ],
    "explanation": "Changes should be logged to support all of these activities: auditing, investigations, troubleshooting, and analysis efforts.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      628,
      621,
      623,
      622,
      629
    ],
    "source": ""
  },
  {
    "id": 4217,
    "question": "Which one of the following software development methodologies produces interim deliverables using a process known as sprints?",
    "choice_a": "Waterfall",
    "choice_b": "Boyce-Codd",
    "choice_c": "Spiral",
    "choice_d": "Agile",
    "correct_answer": "D",
    "explanation": "The Agile approach to software development embraces the idea of rapidly producing deliverables that iteratively improve during each phase. Each of these phases is known as a sprint.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      1033,
      622,
      640,
      1034,
      1035
    ],
    "source": ""
  },
  {
    "id": 4218,
    "question": "Which of the following approaches uses mathematical algorithms to analyze data, developing models that may be used to predict future activity?",
    "choice_a": "Expert systems",
    "choice_b": "Machine learning",
    "choice_c": "Data warehousing",
    "choice_d": "Data governance",
    "correct_answer": "B",
    "explanation": "Machine learning uses mathematical approaches to analyze data, searching for patterns that predict future activity.  Expert systems contain business logic and do not build models.  Data warehousing maintains information stores for analytic efforts.  Data governance introduces policies and practices around data management into an organization.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      1036,
      1038,
      1037,
      638,
      641
    ],
    "source": ""
  },
  {
    "id": 4219,
    "question": "Vincent was recently invited to attend a daily meeting of the software developers working on the development of a new security tool.  At the meeting, they discuss the work that will be accomplished that day and any impediments to their progress. <br>What approach is this team most likely using?",
    "choice_a": "Waterfall",
    "choice_b": "Spiral",
    "choice_c": "Scrum",
    "choice_d": "Agile",
    "correct_answer": "C",
    "explanation": "The daily stand-up meeting is a hallmark of the Scrum methodology.  The meetings are called scrums and are essential to the process.  Scrum is a methodology that embraces the Agile philosophy, but not all Agile approaches use the daily scrum.  The waterfall and spiral models do not normally use these daily meetings.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      622,
      1033,
      640,
      1034,
      623
    ],
    "source": ""
  },
  {
    "id": 4220,
    "question": "Which one of the following is not a core principle of the Agile Manifesto?",
    "choice_a": "Simplicity is essential.",
    "choice_b": "Build projects around all team members equally.",
    "choice_c": "Working software is the primary measure of progress.",
    "choice_d": "The best designs emerge from self-organizing teams.",
    "correct_answer": "B",
    "explanation": "The Agile Manifesto says that you should build projects around motivated individuals and give them the support they need.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      1033,
      1035,
      622,
      625,
      1034
    ],
    "source": ""
  },
  {
    "id": 4221,
    "question": "During what phase of the IDEAL model does the organization develop, test, refine, and implement solutions?",
    "choice_a": "Initiating",
    "choice_b": "Diagnosing",
    "choice_c": "Establishing",
    "choice_d": "Acting",
    "correct_answer": "D",
    "explanation": "In the acting phase, it's time to stop \"talking the talk\" and \"walk the walk.\" The organization develops solutions and then tests, refines, and implements them.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      623,
      640,
      622,
      621,
      833
    ],
    "source": ""
  },
  {
    "id": 4222,
    "question": "Thomas is preparing to conduct a dynamic software test and will not have access to any of the source code. <br>What type of testing is he conducting?",
    "choice_a": "White box",
    "choice_b": "Grey box",
    "choice_c": "Black box",
    "choice_d": "Blue box",
    "correct_answer": "C",
    "explanation": "Black box testing is conducted without any access to the source code.  White box and grey box testing require source code access.  Blue box testing is not a software testing technique.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      626,
      963,
      962,
      621,
      662
    ],
    "source": ""
  },
  {
    "id": 4223,
    "question": "Dylan is using a machine learning approach to model normal activity on his network. He is training a model based upon a large dataset of activity that is labeled as either normal or malicious. <br>What type of technique is he using?",
    "choice_a": "Supervised learning",
    "choice_b": "Unsupervised learning",
    "choice_c": "Generalized learning",
    "choice_d": "Deep learning",
    "correct_answer": "A",
    "explanation": "The use of labeled datasets is found in supervised learning approaches.  The other major category of machine learning techniques, unsupervised learning, uses unlabeled datasets.  Generalized learning is not a machine learning technique and deep learning involves the use of neural networks, which is not indicated here.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      638,
      1036,
      1038,
      641,
      639
    ],
    "source": ""
  },
  {
    "id": 4224,
    "question": "Bob is developing a database-driven website, and he is worried that end users will insert content onto the site that, when viewed by a third party, causes them to perform an undesirable action. <br>What type of attack is Bob attempting to defend against?",
    "choice_a": "SQL injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Buffer overflow",
    "choice_d": "Evil twin",
    "correct_answer": "B",
    "explanation": "Cross-site scripting (XSS) attacks insert content on a website that causes viewers of that content to execute a script. Although this website is backed by a database, the threat that Bob is worried about does not affect the back-end database and, therefore, is not a SQL injection attack. Buffer overflow attacks attempt to manipulate the contents of memory, and evil twin attacks are against wireless networks, not websites.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      658,
      659,
      668,
      674,
      1010
    ],
    "source": ""
  },
  {
    "id": 4225,
    "question": "Rhonda is looking for a software solution that would help her monitor end user activity for signs of account compromise. <br>Which one of the following tools would best assist with this task?",
    "choice_a": "UEBA",
    "choice_b": "IPS",
    "choice_c": "EDR",
    "choice_d": "CASB",
    "correct_answer": "A",
    "explanation": "User and entity behavior analytics (UEBA) tools develop profiles of individual behavior and then monitor users for deviations from those profiles that may indicate malicious activity and/or compromised accounts.  This type of tool would meet Rhonda's requirements.",
    "topic_id": 7,
    "practice_test_id": 9,
    "related_articles": [
      1042,
      557,
      506,
      538,
      543
    ],
    "source": ""
  },
  {
    "id": 4226,
    "question": "Automation and scripting can be essential elements of security management and software development. <br>Which of the following are operations or functions that would benefit from applying automation and/or scripting?  (Select all that apply.)",
    "choice_a": "Configure a set of commands to occur based on a triggering event.",
    "choice_b": "Periodically perform vulnerability scans",
    "choice_c": "Craft new code in a development project",
    "choice_d": "Run code at a specific time every day",
    "correct_answer": [
      "A",
      "B",
      "D",
      "E",
      "G",
      "H"
    ],
    "explanation": "Automation and scripting can be used in several areas of security management and software development. Automation is the control of systems on a regular scheduled, periodic, or triggered basis that does not require manual hands-on interaction. Automation is often critical to a resilient security infrastructure. (A) A script can be configured to execute based on a triggering event. (B) Automation of vulnerability scans can ensure the evaluation is performed without relying upon a human to remember to perform the scan. (D) A script can be set to run code based on date and time. (E) Fuzzing tests can be automated to run a various time intervals. (G) Code scanners can be configured to run on a schedule. (H) Blocking communications based on invalid content is an automated filtering process. Automation and scripting are not useful in relation to (C) crafting new code, nor (F) approving software to be deployed into production. These two functions require human real-time manual focus and attention.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      817,
      818,
      621,
      652,
      653
    ],
    "source": "",
    "choice_e": "Performing fuzzing evaluation of deployed software",
    "choice_f": "Approve software to be deployed into production",
    "choice_g": "Run code scanners to discover coding flaws",
    "choice_h": "Blocking communications based on invalid content"
  },
  {
    "id": 4227,
    "question": "What should a DevOps manager verify or do before releasing code from the developers into the production environment?",
    "choice_a": "Code size",
    "choice_b": "Activate rollback",
    "choice_c": "Hashes",
    "choice_d": "Roll out system images",
    "correct_answer": "C",
    "explanation": "Before releasing any code into production, the DevOps manager should verify the hashes of the files to be released. This is to ensure that only the actual final, tested, and approved version of files is released and that those files were not corrupted or infected with malware prior to distribution. The size of the code is not as relevant as the hashes, although a change in the size of code would result in a change in the hash value. Activating rollback is only performed if a deployment goes bad and systems need to be restored back to their pre-rollout state. System images do not need to be rolled out or installed prior to installing or distributing new software. Doing so would likely result in lost data, customizations, and configurations performed on those system since the previous system image update.",
    "topic_id": 8,
    "practice_test_id": 9,
    "related_articles": [
      652,
      670,
      621,
      818,
      628
    ],
    "source": ""
  },
  {
    "id": 5000,
    "question": "Brianna is working with a U.S. software firm that uses encryption in its products and plans to export their product outside of the United States. What federal government agency has the authority to regulate the export of encryption software?",
    "choice_a": "NSA",
    "choice_b": "NIST",
    "choice_c": "BIS",
    "choice_d": "FTC",
    "correct_answer": "C",
    "explanation": "The Bureau of Industry and Security within the Department of Commerce sets regulations on the export of encryption products outside of the United States. The other agencies listed here are not involved in regulating exports.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      111,
      100,
      99,
      101,
      103
    ],
    "source": ""
  },
  {
    "id": 5001,
    "question": "Wendy recently accepted a position as a senior cybersecurity administrator at a U.S. government agency and is concerned about the legal requirements affecting her new position. Which law governs information security operations at federal agencies?",
    "choice_a": "FISMA",
    "choice_b": "FERPA",
    "choice_c": "CFAA",
    "choice_d": "ECPA",
    "correct_answer": "A",
    "explanation": "The Federal Information Security Management Act (FISMA) includes provisions regulating information security at federal agencies. It places authority for classified systems in the hands of the National Security Agency (NSA) and authority for all other systems with the National Institute for Standards and Technology (NIST).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      102,
      881,
      100,
      19,
      99
    ],
    "source": ""
  },
  {
    "id": 5002,
    "question": "What type of law does not require an act of Congress to implement at the federal level but rather is enacted by the executive branch in the form of regulations, policies, and procedures?",
    "choice_a": "Criminal law",
    "choice_b": "Common law",
    "choice_c": "Civil law",
    "choice_d": "Administrative law",
    "correct_answer": "D",
    "explanation": "Administrative laws do not require an act of the legislative branch to implement at the federal level. Administrative laws consist of the policies, procedures, and regulations promulgated by agencies of the executive branch of government. Although they do not require an act of Congress, these laws are subject to judicial review and must comply with criminal and civil laws enacted by the legislative branch.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      99,
      100,
      117,
      97,
      102
    ],
    "source": ""
  },
  {
    "id": 5003,
    "question": "What U.S. state was the first to pass a comprehensive privacy law modeled after the requirements of the European Union's General Data Protection Regulation?",
    "choice_a": "California",
    "choice_b": "New York",
    "choice_c": "Vermont",
    "choice_d": "Texas",
    "correct_answer": "A",
    "explanation": "The California Consumer Privacy Act (CCPA) of 2018 was the first sweeping data privacy law enacted by a U.S. state. This follows California's passing of the first data breach notification law, which was modeled after the requirements of the European Union's General Data Protection Regulation (GDPR).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      114,
      108,
      118,
      106,
      105
    ],
    "source": ""
  },
  {
    "id": 5004,
    "question": "Congress passed CALEA in 1994, requiring that what type of organizations cooperate with law enforcement investigations?",
    "choice_a": "Financial institutions",
    "choice_b": "Communications carriers",
    "choice_c": "Healthcare organizations",
    "choice_d": "Websites",
    "correct_answer": "B",
    "explanation": "The Communications Assistance for Law Enforcement Act (CALEA) required that communications carriers assist law enforcement with the implementation of wiretaps when done under an appropriate court order. CALEA only applies to communications carriers and does not apply to financial institutions, healthcare organizations, or websites.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      682,
      683,
      107,
      105,
      97
    ],
    "source": ""
  },
  {
    "id": 5005,
    "question": "What law protects the right of citizens to privacy by placing restrictions on the authority granted to government agencies to search private residences and facilities?",
    "choice_a": "Privacy Act",
    "choice_b": "Fourth Amendment",
    "choice_c": "Second Amendment",
    "choice_d": "Gramm\u2013Leach\u2013Bliley Act",
    "correct_answer": "B",
    "explanation": "The Fourth Amendment to the U.S. Constitution sets the \"probable cause\" standard that law enforcement officers must follow when conducting searches and/or seizures of private property. It also states that those officers must obtain a warrant before gaining involuntary access to such property. The Privacy Act regulates what information government agencies may collect and maintain about individuals. The Second Amendment grants the right to keep and bear arms. The Gramm\u2013Leach\u2013Bliley Act regulates financial institutions, not the federal government.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      107,
      100,
      97,
      117
    ],
    "source": ""
  },
  {
    "id": 5006,
    "question": "Matthew recently authored an innovative algorithm for solving a mathematical problem, and he wants to share it with the world. However, prior to publishing the software code in a technical journal, he wants to obtain some sort of intellectual property (IP) protection. Which type of protection is best suited to his needs?",
    "choice_a": "Copyright",
    "choice_b": "Trademark",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "A",
    "explanation": "Copyright law is the only type of intellectual property protection available to Matthew. It covers only the specific software code that Matthew used. It does not cover the process or ideas behind the software. Trademark protection is not appropriate for this type of situation because it would only protect the name and/or logo of the software, not its algorithms. Patent protection does not apply to mathematical algorithms. Matthew can't seek trade secret protection because he plans to publish the algorithm in a public technical journal.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1054,
      1056,
      152,
      179,
      219
    ],
    "source": ""
  },
  {
    "id": 5007,
    "question": "Mary is the cofounder of Acme Widgets, a manufacturing firm. Together with her partner, Joe, she has developed a special oil that will dramatically improve the widget manufacturing process. To keep the formula secret, Mary and Joe plan to make large quantities of the oil by themselves in the plant after the other workers have left. They want to protect this formula for as long as possible. What type of intellectual property (IP) protection best suits their needs?",
    "choice_a": "Copyright",
    "choice_b": "Trademark",
    "choice_c": "Patent",
    "choice_d": "Trade secret",
    "correct_answer": "D",
    "explanation": "Mary and Joe should treat their oil formula as a trade secret. As long as they do not publicly disclose the formula, they can keep it a company secret indefinitely. Copyright and patent protection both have expiration dates and would not meet Mary and Joe's requirements. Trademark protection is for names and logos and would not be appropriate in this case.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1054,
      1056,
      203,
      221,
      230
    ],
    "source": ""
  },
  {
    "id": 5008,
    "question": "Richard recently developed a great name for a new product that he plans to begin using immediately. He spoke with his attorney and filed the appropriate application to protect his product name but has not yet received a response from the government regarding his application. He wants to begin using the name immediately. What symbol should he use next to the name to indicate its protected status?",
    "choice_a": "\u00a9",
    "choice_b": "\u00ae",
    "choice_c": "\u2122",
    "choice_d": "\u2020",
    "correct_answer": "C",
    "explanation": "Richard's product name should be protected under trademark law. Until his registration is granted, he can use the \u2122 symbol next to it to inform others that it is protected under trademark law. Once his application is approved, the name becomes a registered trademark, and Richard can begin using the \u00ae symbol. The \u00a9 symbol is used to represent a copyright. The \u2020 symbol is not associated with intellectual property protections.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      985,
      986,
      987,
      103,
      110
    ],
    "source": ""
  },
  {
    "id": 5009,
    "question": "Tom is an adviser to a federal government agency that collects personal information from constituents. He would like to facilitate a research relationship between that firm that involves the sharing of personal information with several universities. What law prevents government agencies from disclosing personal information that an individual supplies to the government under protected circumstances?",
    "choice_a": "Privacy Act",
    "choice_b": "Electronic Communications Privacy Act",
    "choice_c": "Health Insurance Portability and Accountability Act",
    "choice_d": "Gramm\u2013Leach\u2013Bliley Act",
    "correct_answer": "A",
    "explanation": "The Privacy Act of 1974 limits the ways government agencies may use information that private citizens disclose to them under certain circumstances. The Electronic Communications Privacy Act (ECPA) implements safeguards against electronic eavesdropping. The Health Insurance Portability and Accountability Act (HIPAA) regulates the protection and sharing of health records. The Gramm\u2013Leach\u2013Bliley Act requires that financial institutions protect customer records.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      106,
      107,
      100,
      99
    ],
    "source": ""
  },
  {
    "id": 5010,
    "question": "Renee's organization is establishing a partnership with a firm located in France that will involve the exchange of personal information. Her partners in France want to ensure that the transfer will be compliant with the GDPR. What mechanism would be most appropriate?",
    "choice_a": "Binding corporate rules",
    "choice_b": "Privacy Shield",
    "choice_c": "Privacy Lock",
    "choice_d": "Standard contractual clauses",
    "correct_answer": "D",
    "explanation": "The European Union provides standard contractual clauses that may be used to facilitate data transfer. That would be the best choice in a case where two different companies are sharing data. If the data were being shared internally within a company, binding corporate rules would also be an option. The EU/US Privacy Shield was a safe harbor agreement that would previously have allowed the transfer but that is no longer valid. Privacy Lock is a made-up term.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      108,
      109,
      118,
      114,
      105
    ],
    "source": ""
  },
  {
    "id": 5011,
    "question": "The Children's Online Privacy Protection Act (COPPA) was designed to protect the privacy of children using the Internet. What is the minimum age a child must be before companies can collect personal identifying information from them without parental consent?",
    "choice_a": "13",
    "choice_b": "14",
    "choice_c": "15",
    "choice_d": "16",
    "correct_answer": "A",
    "explanation": "The Children's Online Privacy Protection Act (COPPA) provides severe penalties for companies that collect information from young children without parental consent. COPPA states that this consent must be obtained from the parents of children younger than the age of 13 before any information is collected (other than basic information required to obtain that consent).",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      688,
      689,
      690,
      118
    ],
    "source": ""
  },
  {
    "id": 5012,
    "question": "Kevin is assessing his organization's obligations under state data breach notification laws. Which one of the following pieces of information would generally not be covered by a data breach notification law when it appears in conjunction with a person's name?",
    "choice_a": "Social Security number",
    "choice_b": "Driver's license number",
    "choice_c": "Credit card number",
    "choice_d": "Student identification number",
    "correct_answer": "D",
    "explanation": "Although state data breach notification laws vary, they generally apply to Social Security numbers, driver's license numbers, state identification card numbers, credit/debit card numbers, and bank account numbers. These laws generally do not cover other identifiers, such as a student identification number.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      106,
      118,
      107,
      105,
      115
    ],
    "source": ""
  },
  {
    "id": 5013,
    "question": "Roger is the CISO at a healthcare organization covered under HIPAA. He would like to enter into a partnership with a vendor who will manage some of the organization's data. As part of the relationship, the vendor will have access to protected health information (PHI). Under what circumstances is this arrangement permissible under HIPAA?",
    "choice_a": "This is permissible if the service provider is certified by the Department of Health and Human Services.",
    "choice_b": "This is permissible if the service provider enters into a business associate agreement.",
    "choice_c": "This is permissible if the service provider is within the same state as Roger's organization.",
    "choice_d": "This is not permissible under any circumstances.",
    "correct_answer": "B",
    "explanation": "Organizations subject to HIPAA may enter into relationships with service providers as long as the provider's use of protected health information is regulated under a formal business associate agreement (BAA). The BAA makes the service provider liable under HIPAA.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1046,
      105,
      116,
      38,
      11
    ],
    "source": ""
  },
  {
    "id": 5014,
    "question": "Frances learned that a user in her organization recently signed up for a cloud service without the knowledge of her supervisor and is storing corporate information in that service. Which one of the following statements is correct?",
    "choice_a": "If the user did not sign a written contract, the organization has no obligation to the service provider.",
    "choice_b": "The user most likely agreed to a click-through license agreement binding the organization.",
    "choice_c": "The user's actions likely violate federal law.",
    "choice_d": "The user's actions likely violate state law.",
    "correct_answer": "B",
    "explanation": "Cloud services almost always include binding click-through license agreements that the user may have agreed to when signing up for the service. If that is the case, the user may have bound the organization to the terms of that agreement. This agreement does not need to be in writing. There is no indication that the user violated any laws.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      1048,
      110,
      116,
      35,
      15
    ],
    "source": ""
  },
  {
    "id": 5015,
    "question": "Greg recently accepted a position as the cybersecurity compliance officer with a privately held bank. What law most directly impacts the manner in which his organization handles personal information?",
    "choice_a": "HIPAA",
    "choice_b": "GLBA",
    "choice_c": "SOX",
    "choice_d": "FISMA",
    "correct_answer": "B",
    "explanation": "The Gramm\u2013Leach\u2013Bliley Act (GLBA) provides, among other things, regulations regarding the way financial institutions can handle private information belonging to their customers.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      105,
      118,
      99,
      100,
      117
    ],
    "source": ""
  },
  {
    "id": 5016,
    "question": "Ruth recently obtained a utility patent covering a new invention that she created. How long will she retain legal protection for her invention?",
    "choice_a": "14 years from the application date",
    "choice_b": "14 years from the date the patent is granted",
    "choice_c": "20 years from the application date",
    "choice_d": "20 years from the date the patent is granted",
    "correct_answer": "C",
    "explanation": "U.S. patent law provides for an exclusivity period of 20 years beginning at the time a utility patent application is submitted to the Patent and Trademark Office.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      104,
      103,
      987,
      105,
      111
    ],
    "source": ""
  },
  {
    "id": 5017,
    "question": "Ryan is reviewing the terms of a proposed vendor agreement between the financial institution where he works and a cloud service provider. Which one of the following items should represent the <italic>least</italic> concern to Ryan?",
    "choice_a": "What security audits does the vendor perform?",
    "choice_b": "What provisions are in place to protect the confidentiality, integrity, and availability of data?",
    "choice_c": "Is the vendor compliant with HIPAA?",
    "choice_d": "What encryption algorithms and key lengths are used?",
    "correct_answer": "C",
    "explanation": "Ryan does not likely need to be concerned about HIPAA compliance because that law applies to healthcare organizations and Ryan works for a financial institution. Instead, he should be more concerned about compliance with the Gramm\u2013Leach\u2013Bliley Act (GLBA). The other concerns should all be part of Ryan's contract review.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      116,
      105,
      118,
      21,
      110
    ],
    "source": ""
  },
  {
    "id": 5018,
    "question": "Justin is a cybersecurity consultant working with a retailer on the design of their new point-of-sale (POS) system. What compliance obligation relates to the processing of credit card information that might take place through this system?",
    "choice_a": "SOX",
    "choice_b": "HIPAA",
    "choice_c": "PCI DSS",
    "choice_d": "FERPA",
    "correct_answer": "C",
    "explanation": "The Payment Card Industry Data Security Standard (PCI DSS) applies to organizations involved in storing, transmitting, and processing credit card information.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      115,
      19,
      116,
      38,
      118
    ],
    "source": ""
  },
  {
    "id": 5019,
    "question": "Leonard and Sheldon recently coauthored a paper describing a new superfluid vacuum theory. How long will the copyright on their paper last?",
    "choice_a": "70 years after publication",
    "choice_b": "70 years after completion of the first draft",
    "choice_c": "70 years after the death of the first author",
    "choice_d": "70 years after the death of the last author",
    "correct_answer": "D",
    "explanation": "Copyright protection generally lasts for 70 years after the death of the last surviving author of the work.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      1054,
      1056,
      209,
      211,
      230
    ],
    "source": ""
  },
  {
    "id": 5020,
    "question": "Which of the following is a primary concern when implementing security measures for industrial control systems (ICSs)?",
    "choice_a": "Confidentiality of sensor data",
    "choice_b": "Availability of real-time control signals",
    "choice_c": "Integrity of historical system logs",
    "choice_d": "Nonrepudiation of operator commands",
    "correct_answer": "B",
    "explanation": "In industrial control systems (ICSs), ensuring the availability of real-time control signals is a primary concern. Confidentiality, integrity, and nonrepudiation are important security concerns, but the immediate and continuous availability of control signals is critical for the proper functioning of industrial processes.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      440,
      482,
      469,
      472,
      478
    ],
    "source": ""
  },
  {
    "id": 5021,
    "question": "Users have reported data loss and the inability to maintain connections throughout the workday. You suspect that something about the network structure has changed to cause this QoS reduction. Which of the following are aspects of networking you need to investigate to track down the issue? (Select all that apply.)",
    "choice_a": "Bandwidth",
    "choice_b": "System uptime",
    "choice_c": "Latency",
    "choice_d": "Jitter",
    "correct_answer": [
      "A",
      "C",
      "D",
      "F",
      "G",
      "H",
      "J"
    ],
    "explanation": "Network quality of service (QoS) depends on numerous factors, including bandwidth, latency, jitter, packet loss, interference, throughput, and signal-to-noise ratio. System uptime, application layer protocol, and OS versions are unlikely to be relevant related to network QoS investigations.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [],
    "source": "",
    "choice_e": "Application Layer protocol",
    "choice_f": "Packet loss",
    "choice_g": "Interference",
    "choice_h": "Throughput",
    "choice_i": "OS versions",
    "choice_j": "Signal-to-noise ratio"
  },
  {
    "id": 5022,
    "question": "An organization is considering creating a cloud-based federation using a third-party service to share federated identities. After it's completed, what will people use as their login ID?",
    "choice_a": "Their normal account",
    "choice_b": "An account given to them from the cloud-based federation",
    "choice_c": "Hybrid identity management",
    "choice_d": "Single-sign on",
    "correct_answer": "A",
    "explanation": "Upon implementing a cloud-based federation for identity sharing, individuals will typically use their existing normal account credentials to log in. This is facilitated by the federation service, which allows for the secure sharing of identities across different systems and providers. The use of an account provided by the cloud-based federation or a hybrid identity management approach is not necessary for the user's perspective, as these are backend solutions that enable the federation to function. Single-sign on is a related concept where a user logs in once and gains access to multiple systems without being prompted to log in again for each one, but it is a feature or capability that results from federation rather than the type of account used for login.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      480,
      460,
      477,
      453
    ],
    "source": ""
  },
  {
    "id": 5023,
    "question": "Which of the following best expresses the primary goal when controlling access to assets?",
    "choice_a": "Preserve confidentiality, integrity, and availability of systems and data.",
    "choice_b": "Ensure that only valid objects can authenticate on a system.",
    "choice_c": "Prevent unauthorized access to subjects.",
    "choice_d": "Ensure that all subjects are authenticated.",
    "correct_answer": "A",
    "explanation": "A primary goal when controlling access to assets is to protect against losses, including any loss of confidentiality, loss of availability, or loss of integrity. Subjects authenticate on a system, but objects do not authenticate. Subjects access objects, but objects do not access subjects. Identification and authentication are important as the first step in access control, but much more is needed to protect assets.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      3,
      31,
      5,
      33,
      1
    ],
    "source": ""
  },
  {
    "id": 5024,
    "question": "Which of the following is true related to a subject?",
    "choice_a": "A subject is always a user account.",
    "choice_b": "The subject is always the entity that provides or hosts information or data.",
    "choice_c": "The subject is always the entity that receives information about or data from an object.",
    "choice_d": "A single entity can never change roles between subject and object.",
    "correct_answer": "C",
    "explanation": "The subject is active and is always the entity that receives information about, or data from, the object. A subject can be a user, a program, a process, a file, a computer, a database, and so on. The object is always the entity that provides or hosts information or data. The roles of subject and object can switch while two entities communicate to accomplish a task.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      448,
      441,
      462,
      465,
      466
    ],
    "source": ""
  },
  {
    "id": 5025,
    "question": "Based on advice from the National Institute of Standards and Technology (NIST), when should regular users be required to change their passwords?",
    "choice_a": "Every 30 days",
    "choice_b": "Every 60 days",
    "choice_c": "Every 90 days",
    "choice_d": "Only if the current password is compromised",
    "correct_answer": "D",
    "explanation": "NIST SP 800-63B recommends users only be required to change their password if their current password is compromised. They do not recommend that users be required to change their password regularly at any interval.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      18,
      102,
      50,
      7,
      54
    ],
    "source": ""
  },
  {
    "id": 5026,
    "question": "Security administrators have learned that users are switching between two passwords. When the system prompts them to change their password, they use the second password. When the system prompts them to change their password again, they use the first password. What can prevent users from rotating between two passwords?",
    "choice_a": "Password complexity",
    "choice_b": "Password history",
    "choice_c": "Password length",
    "choice_d": "Password age",
    "correct_answer": "B",
    "explanation": "Password history can prevent users from rotating between two passwords. It remembers previously used passwords. Password complexity and password length help ensure that users create strong passwords. Password age ensures that users change their password regularly.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      7,
      35,
      16,
      11,
      1
    ],
    "source": ""
  },
  {
    "id": 5027,
    "question": "Which of the following best identifies the benefit of a passphrase?",
    "choice_a": "It is short.",
    "choice_b": "It is easy to remember.",
    "choice_c": "It includes a single set of characters.",
    "choice_d": "It is easy to crack.",
    "correct_answer": "B",
    "explanation": "A passphrase is a long string of characters that is easy to remember, such as IP@$$edTheCISSPEx@m. It is not short and typically includes at least three sets of character types. It is strong and complex, making it difficult to crack.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      443,
      447,
      907,
      446,
      453
    ],
    "source": ""
  },
  {
    "id": 5028,
    "question": "Your organization issues devices to employees. These devices generate one-time passwords every 60 seconds. A server hosted within the organization knows what this password is at any given time. What type of device is this?",
    "choice_a": "Synchronous authenticator",
    "choice_b": "Asynchronous authenticator",
    "choice_c": "Smartcard",
    "choice_d": "Common access card",
    "correct_answer": "A",
    "explanation": "A synchronous authenticator generates and displays one-time passwords that are synchronized with an authentication server. An asynchronous token uses a challenge-response process to generate the one-time password. Smartcards do not generate one-time passwords, and common access cards are a version of a smartcard that includes a picture of the user.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      308,
      275,
      278,
      152,
      145
    ],
    "source": ""
  },
  {
    "id": 5029,
    "question": "What does the CER for a biometric device indicate?",
    "choice_a": "It indicates that the sensitivity is too high.",
    "choice_b": "It indicates that the sensitivity is too low.",
    "choice_c": "It indicates the point where the false rejection rate equals the false acceptance rate.",
    "choice_d": "When high enough, it indicates the biometric device is highly accurate.",
    "correct_answer": "C",
    "explanation": "The point at which the biometric false rejection rate and the false acceptance rate are equal is the crossover error rate (CER). It does not indicate that sensitivity is too high or too low. A lower CER indicates a more accurate biometric device, and a higher CER indicates a less accurate device.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      459,
      446,
      748,
      750
    ],
    "source": ""
  },
  {
    "id": 5030,
    "question": "Sally has a user account and has previously logged on using a biometric system. Today, the biometric system didn't recognize her, so she wasn't able to log on. What does this describe?",
    "choice_a": "False rejection",
    "choice_b": "False acceptance",
    "choice_c": "Crossover error",
    "choice_d": "Equal error",
    "correct_answer": "A",
    "explanation": "A false rejection, sometimes called a false negative authentication or a Type I error, occurs when an authentication system doesn't recognize a valid subject (Sally in this example). A false acceptance, sometimes called a false positive authentication or a Type II error, occurs when an authentication system incorrectly recognizes an invalid subject. Crossover errors and equal errors aren't valid terms related to biometrics. However, the crossover error rate (also called equal error rate) compares the false rejection rate to the false acceptance rate and provides an accuracy measurement for a biometric system.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      459,
      748,
      443,
      446
    ],
    "source": ""
  },
  {
    "id": 5031,
    "question": "Users log on with a username when accessing the company network from home. Management wants to implement a second factor of authentication for these users. They want a secure solution, but they also want to limit costs. Which of the following best meets these requirements?",
    "choice_a": "Short Message Service (SMS)",
    "choice_b": "Fingerprint scans",
    "choice_c": "Authenticator app",
    "choice_d": "Personal identification number (PIN)",
    "correct_answer": "C",
    "explanation": "An authenticator app on a smartphone or tablet device is the best solution. SMS has vulnerabilities, and NIST has deprecated its use for two-factor authentication. Biometric authentication methods, such as fingerprint scans, provide strong authentication. However, purchasing biometric readers for each employee's home would be expensive. A PIN is in the something you know factor of authentication, so it doesn't provide two-factor authentication when used with a password.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      446,
      443,
      444,
      445,
      459
    ],
    "source": ""
  },
  {
    "id": 5032,
    "question": "Which of the following provides authentication based on a physical characteristic of a subject?",
    "choice_a": "Account ID",
    "choice_b": "Biometrics",
    "choice_c": "Authenticator",
    "choice_d": "PIN",
    "correct_answer": "B",
    "explanation": "Physical biometric methods such as fingerprints and iris scans provide authentication for subjects. An account ID provides identification. An authenticator is something you have, and it creates one-time passwords, but it is not related to a person's physical characteristics. A personal identification number (PIN) is something you know.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      443,
      748,
      446,
      461
    ],
    "source": ""
  },
  {
    "id": 5033,
    "question": "Fingerprint readers match minutiae from a fingerprint to data in a database. Which of the following accurately identify fingerprint minutiae? (Choose three.)",
    "choice_a": "Vein pattern",
    "choice_b": "Ridges",
    "choice_c": "Bifurcations",
    "choice_d": "Whorls",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Ridges, bifurcations, and whorls are fingerprint minutiae. Ridges are the lines in a fingerprint. Some ridges abruptly end, and some ridges bifurcate or fork into branch ridges. Whorls are a series of circles. Palm scans measure vein patterns in a palm.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1060,
      1062,
      1061,
      748,
      445
    ],
    "source": ""
  },
  {
    "id": 5034,
    "question": "An organization wants to implement biometrics for authentication, but management doesn't want to use fingerprints. Which of the following is the most likely reason why management doesn't want to use fingerprints?",
    "choice_a": "Fingerprints can be counterfeited.",
    "choice_b": "Fingerprints can be changed.",
    "choice_c": "Fingerprints aren't always available.",
    "choice_d": "Registration takes too long.",
    "correct_answer": "A",
    "explanation": "Fingerprints can be counterfeited or duplicated. It is not possible to change fingerprints. Users will always have a finger available (except for major medical events). It usually takes less than a minute for registration of a fingerprint.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      445,
      750,
      749,
      446,
      459
    ],
    "source": ""
  },
  {
    "id": 5035,
    "question": "Which of the following items are required to ensure logs accurately support accountability? (Choose two.)",
    "choice_a": "Identification",
    "choice_b": "Authorization",
    "choice_c": "Auditing",
    "choice_d": "Authentication",
    "correct_answer": [
      "A",
      "D"
    ],
    "explanation": "Accurate identification and authentication are required to ensure logs accurately support accountability. Logs record events, including who took an action, but without accurate identification and authentication, the logs can't be relied on. Authorization grants access to resources after proper authentication. Auditing occurs after logs are created, but identification and authentication must occur first.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      556,
      554,
      560,
      541,
      607
    ],
    "source": ""
  },
  {
    "id": 5036,
    "question": "A company is installing several Linux servers in the server room. These are the first Linux servers for the company, so they hired an administrator with Linux experience to manage them and train other administrators on Linux. How should the company assign privileges for the new administrator?",
    "choice_a": "Add the administrator to the Administrators group.",
    "choice_b": "Add the administrator to the sudo group.",
    "choice_c": "Give the administrator the sudo password.",
    "choice_d": "Define a new role for Linux administrators.",
    "correct_answer": "D",
    "explanation": "The best choice is to define a new role for Linux administrators and assign privileges based on the role definition. Linux systems do not have an Administrators group or a sudo group. However, you can grant root account access to users by adding them to the sudoers file. There isn't a sudo password. Instead, users execute root-level commands in the context of their own account, and their own password or if configured, the root user's password.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      218,
      201,
      215,
      222,
      211
    ],
    "source": ""
  },
  {
    "id": 5037,
    "question": "A company's security policy states that user accounts should be disabled during the exit interview for any employee leaving the company. Which of the following is the most likely reason for this policy?",
    "choice_a": "To remove the account",
    "choice_b": "To remove privileges assigned to the account",
    "choice_c": "To prevent sabotage",
    "choice_d": "To encrypt user data",
    "correct_answer": "C",
    "explanation": "The most likely reason (of the provided options) is to prevent sabotage. If the user's account remains enabled, the user may log on later and cause damage. Disabling the account doesn't remove the account or remove assigned privileges. Disabling an account doesn't encrypt any data, but it does retain encryption keys that supervisors can use to decrypt any data encrypted by the user.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      456,
      1065,
      1064,
      471,
      470
    ],
    "source": ""
  },
  {
    "id": 5038,
    "question": "When an employee leaves the organization under normal circumstances, what is the most appropriate action to take at the conclusion of their final day of work?",
    "choice_a": "Delete their account.",
    "choice_b": "Force them to change their password.",
    "choice_c": "Disable their account.",
    "choice_d": "Take no action for at least 7 days.",
    "correct_answer": "C",
    "explanation": "The most appropriate action to take when an employee leaves an organization is to disable their account. This action immediately prevents any further access to the organization's systems and data while preserving the account's data and audit trail. This is essential for any necessary follow-up investigations or in cases where access may need to be temporarily reinstated, for example, if the employee returns to the organization or if there are disputes regarding their work that need to be resolved post-departure. Deleting their account would limit the potential to audit the account's history, which could be necessary for future reference. Forcing them to change their password would allow them to retain access to their account once they have left, as they would know the new password. Taking no action for a period of time leaves unnecessary security risks, as the departing employee would still have access to the system.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      456,
      1065,
      1063,
      461,
      457
    ],
    "source": ""
  },
  {
    "id": 5039,
    "question": "Karen is taking maternity leave and will be away from the job for at least 12 weeks. Which of the following actions should be taken while she is taking this leave of absence?",
    "choice_a": "Delete the account.",
    "choice_b": "Reset the account's password.",
    "choice_c": "Do nothing.",
    "choice_d": "Disable the account.",
    "correct_answer": "D",
    "explanation": "It's appropriate to disable an account when an employee takes a leave of absence of 30 days or more. The account should not be deleted because the employee is expected to return after the leave of absence. If the password is reset, someone could still log on. If nothing is done to the account, someone else may access it and impersonate the employee.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1063,
      1065,
      458,
      455,
      925
    ],
    "source": ""
  },
  {
    "id": 5040,
    "question": "Security investigators discovered that after attackers exploited a Microsoft SQL (database) server, they identified the password for the sa account. They then used this to access other servers on the network. What can be implemented to prevent this from happening in the future?",
    "choice_a": "Account deprovisioning",
    "choice_b": "Disabling an account",
    "choice_c": "Account access review",
    "choice_d": "Account revocation",
    "correct_answer": "C",
    "explanation": "Account access reviews can detect security issues for service accounts such as the sa (short for system administrator) account in Microsoft SQL Server systems. Reviews can ensure that service account passwords are strong and changed often. The other options suggest removing, disabling, or deleting the sa account, but doing so is likely to affect the database server's performance. Account deprovisioning ensures accounts are removed when they are no longer needed. Disabling an account ensures it isn't used, and account revocation deletes the account.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      635,
      657,
      658,
      667,
      672
    ],
    "source": ""
  },
  {
    "id": 5041,
    "question": "Fred, an administrator, has been working within an organization for over 10 years. He previously maintained database servers while working in a different division. He now works in the programming department but still retains privileges on the database servers. He recently modified a setting on a database server so that a script he wrote will run. Unfortunately, his change disabled the server for several hours before database administrators discovered the change and reversed it. Which of the following could have prevented this outage?",
    "choice_a": "A policy requiring strong authentication",
    "choice_b": "Multifactor authentication",
    "choice_c": "Logging",
    "choice_d": "Account access review",
    "correct_answer": "D",
    "explanation": "A periodic account access review can discover when users have more privileges than they need and could have been used to discover that this employee had permissions from several positions. Strong authentication methods (including multifactor authentication methods) would not have prevented the problems in this scenario. Logging records what happened, but it doesn't prevent events.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      535,
      506,
      527,
      526,
      511
    ],
    "source": ""
  },
  {
    "id": 5042,
    "question": "Tina is searching for potential gaps in her organization's incident response plan and gathers the team together for an exercise. They do not use any actual IT systems (production or test) in their work but simply discuss how they would respond to a scenario. What term best describes this test?",
    "choice_a": "Red team exercise",
    "choice_b": "Blue team exercise",
    "choice_c": "Tabletop exercise",
    "choice_d": "Purple team exercise",
    "correct_answer": "C",
    "explanation": "The scenario does not provide us with enough information to determine whether this exercise involved red team, blue team, or purple team tactics, and in fact, those exercises typically involve live access to systems. Tabletop exercises, on the other hand, are designed to walk teams through a scenario, and that is what Tina is doing in this instance.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      594,
      597,
      593,
      921,
      929
    ],
    "source": ""
  },
  {
    "id": 5043,
    "question": "Tom is investigating a security incident and found that the attacker was able to directly modify the contents of a system's memory. What type of application vulnerability would most directly facilitate this action?",
    "choice_a": "Rootkit",
    "choice_b": "Back door",
    "choice_c": "TOC/TOU",
    "choice_d": "Buffer overflow",
    "correct_answer": "D",
    "explanation": "Buffer overflow attacks allow an attacker to modify the contents of a system's memory by writing beyond the space allocated for a variable.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      379,
      389,
      333,
      330,
      1012
    ],
    "source": ""
  },
  {
    "id": 5044,
    "question": "When designing firewall rules to prevent IP spoofing, which of the following principles should you follow?",
    "choice_a": "Packets with internal source IP addresses don't enter the network from the outside.",
    "choice_b": "Packets with internal source IP addresses don't exit the network from the inside.",
    "choice_c": "Packets with public IP addresses don't pass through the router in either direction.",
    "choice_d": "Packets with external source IP addresses don't enter the network from the outside.",
    "correct_answer": "A",
    "explanation": "Packets with internal source IP addresses should not be allowed to enter the network from the outside because they are likely spoofed. Packets with internal source IP addresses should be able to exit the network from the inside, and packets with external source IP addresses should be able to enter the network from the outside, as these are both normal network activity. Packets with public IP addresses should be able to pass through the firewall in both directions, assuming that they meet other security requirements.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      551,
      544,
      543,
      554,
      559
    ],
    "source": ""
  },
  {
    "id": 5045,
    "question": "Bob is developing a database-driven website, and he is worried that end users will insert content onto the site that, when viewed by a third party, causes them to perform an undesirable action. <br>What type of attack is Bob attempting to defend against?",
    "choice_a": "SQL injection",
    "choice_b": "Cross-site scripting",
    "choice_c": "Buffer overflow",
    "choice_d": "Evil twin",
    "correct_answer": "B",
    "explanation": "Cross-site scripting (XSS) attacks insert content on a website that causes viewers of that content to execute a script. Although this website is backed by a database, the threat that Bob is worried about does not affect the back-end database and, therefore, is not a SQL injection attack. Buffer overflow attacks attempt to manipulate the contents of memory, and evil twin attacks are against wireless networks, not websites.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      658,
      659,
      668,
      674,
      1010
    ],
    "source": ""
  },
  {
    "id": 5046,
    "question": "What techniques are commonly used to protect against SQL injection attacks? (Select all that apply.)",
    "choice_a": "User acceptance testing",
    "choice_b": "Metacharacter escaping",
    "choice_c": "Stored procedures",
    "choice_d": "Input validation",
    "correct_answer": [
      "B",
      "C",
      "D"
    ],
    "explanation": "Input validation protects against a wide variety of web-based attacks, including SQL injection. Input validation typically includes checking for appropriate length, checking for known examples of malware or abusive input, and escaping meta characters. Developers may also defend against SQL injection attacks by using stored procedures and parameterized queries. User acceptance testing verifies the proper functioning of code and is not a protection against SQL injection attacks.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      668,
      669,
      620,
      658,
      675
    ],
    "source": ""
  },
  {
    "id": 5047,
    "question": "Which one of the following attacks allows an attacker to execute targeted commands against the database supporting a web application?",
    "choice_a": "SQL injection",
    "choice_b": "Transaction manipulation",
    "choice_c": "Cross-site scripting",
    "choice_d": "Parameter manipulation",
    "correct_answer": "A",
    "explanation": "SQL injection attacks allow attackers to include their own SQL commands in the commands issued by a web application to a database.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      658,
      661,
      669,
      672,
      668
    ],
    "source": ""
  },
  {
    "id": 5048,
    "question": "Syed visited the desktop of a user who was experiencing system issues. He saw an error message that said his files were encrypted with a unique key for his computer and that he should click a button for further instructions. What type of malware infection is Syed most likely dealing with?",
    "choice_a": "Ransomware",
    "choice_b": "Logic bomb",
    "choice_c": "Virus",
    "choice_d": "Worm",
    "correct_answer": "A",
    "explanation": "Ransomware's signature characteristic is the encryption of files using a key known only to the attacker and then demanding payment in exchange for the decryption key.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      615,
      608,
      542,
      541,
      599
    ],
    "source": ""
  },
  {
    "id": 5049,
    "question": "Rhonda is looking for a software solution that would help her monitor end user activity for signs of account compromise. <br>Which one of the following tools would best assist with this task?",
    "choice_a": "UEBA",
    "choice_b": "IPS",
    "choice_c": "EDR",
    "choice_d": "CASB",
    "correct_answer": "A",
    "explanation": "User and entity behavior analytics (UEBA) tools develop profiles of individual behavior and then monitor users for deviations from those profiles that may indicate malicious activity and/or compromised accounts.  This type of tool would meet Rhonda's requirements.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      1042,
      557,
      506,
      538,
      543
    ],
    "source": ""
  },
  {
    "id": 5050,
    "question": "One of the first and most important security planning steps is to consider the overall security control framework or structure of the security solution desired by the organization. Which of the following frameworks establish a U.S. government-wide program designed to standardize the security assessment, authorization, and continuous monitoring processes for cloud products and services used by federal agencies?",
    "choice_a": "FedRAMP",
    "choice_b": "Cybersecurity Framework",
    "choice_c": "ISO 27001",
    "choice_d": "Center for Internet Security",
    "correct_answer": "A",
    "explanation": "The Federal Risk and Authorization Management Program (FedRAMP) is a U.S. government-wide program designed to standardize the security assessment, authorization, and continuous monitoring processes for cloud products and services used by federal agencies. The Cybersecurity Framework (CSF) is designed for critical infrastructure and commercial organizations. ISO 27001 establishes the guidelines for implementing an information security management system (ISMS) but is nation- and industry-agnostic. The Center for Internet Security (CIS) provides OS, application, and hardware security configuration guides for a wide range of products.",
    "topic_id": 2,
    "practice_test_id": 6,
    "related_articles": [
      140,
      141,
      142,
      125,
      143
    ],
    "source": ""
  },
  {
    "id": 5051,
    "question": "What term is used to reference the different lenses through which organizations and individuals can view and address risks?",
    "choice_a": "Risk response",
    "choice_b": "Risk perspectives",
    "choice_c": "Risk register",
    "choice_d": "Risk acceptance",
    "correct_answer": "B",
    "explanation": "Risk perspectives, also known as risk management perspectives or approaches, are different lenses through which organizations and individuals can view and address risks. Risk response involves evaluating countermeasures, safeguards, and security controls using a cost/benefit analysis; adjusting findings based on other conditions, concerns, priorities, and resources; and providing a proposal of response options in a report to senior management. A risk register or risk log is a document that inventories all the identified risks to an organization or system or within an individual project. Risk acceptance occurs as a risk response when management has agreed to accept the consequences and the loss if a risk is realized.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      531,
      538,
      540,
      586,
      599
    ],
    "source": ""
  },
  {
    "id": 5052,
    "question": "Your organization has a strictly enforced email security policy that attempts to block problematic messages. However, you have received a message which seems odd and notice several concerning characteristics. Which of the following are indicators that this message is a hoax? (Choose three.)",
    "choice_a": "Claimed sender confirms they did not send the message",
    "choice_b": "Use of poor grammar",
    "choice_c": "Lack of correct spelling",
    "choice_d": "Threat of damage to your computer system",
    "correct_answer": [
      "A",
      "D",
      "E"
    ],
    "explanation": "A hoax is a social engineering attack that is attempting to trick a user into taking actions that will harm them through the use of fear that not taking action would actually cause harm. If you contact the claimed sender and they confirm they did not send the message, then it could be a hoax or at least a spoofed message. Hoaxes often use the threat of damage or harm to encourage the victim to take action, and those actions are often provided steps that will actually cause the victim harm. (B) Poor grammar, (C) bad spelling, and (G) hyperlinks in the message are all characteristics of both valid and invalid email messages. (F) Claiming to be from a trusted authority is the attempt to use the social engineering principle of authority and/or intimidation, which is not uniquely a feature of a hoax, but many spam, business email compromise (BEC), and phishing attacks do as well. But the claim of being a trusted authority could be valid as well.",
    "topic_id": 7,
    "practice_test_id": 6,
    "related_articles": [
      511,
      542,
      541,
      538,
      550
    ],
    "source": "",
    "choice_e": "Encouragement to take specific steps to resolve a concern",
    "choice_f": "Claim to be from a trusted authority",
    "choice_g": "Inclusion of hyperlinks in the body of the message"
  },
  {
    "id": 5053,
    "question": "Which of the following is in the something you have factor of authentication and doesn't generate a password?",
    "choice_a": "A TOTP authenticator",
    "choice_b": "An HOTP authenticator device",
    "choice_c": "An HOTP authenticator app",
    "choice_d": "Smartcard",
    "correct_answer": "D",
    "explanation": "A smartcard is in the something you have factor of authentication, but it doesn't generate a password. A TOTP authenticator is synchronized with an authentication server and generates synchronous one-time passwords. An HOTP authenticator or device generates and displays one-time passwords when a button is pushed.",
    "topic_id": 5,
    "practice_test_id": 6,
    "related_articles": [
      444,
      443,
      446,
      442,
      449
    ],
    "source": ""
  },
  {
    "id": 5054,
    "question": "Which one of the following tools is specifically designed to identify database vulnerabilities in web applications?",
    "choice_a": "Nessus",
    "choice_b": "Nexpose",
    "choice_c": "QualysGuard",
    "choice_d": "sqlmap",
    "correct_answer": "D",
    "explanation": "All of these tools are capable of detecting database vulnerabilities, but only sqlmap is custom-designed for that purpose. Nessus, Nexpose, and QualysGuard are all general-purpose vulnerability scanners.",
    "topic_id": 6,
    "practice_test_id": 6,
    "related_articles": [
      787,
      789,
      860,
      775,
      777
    ],
    "source": ""
  },
  {
    "id": 5055,
    "question": "A CISO has spent considerable time investigating the issues regarding a newly identified threat. After considering as many aspects of the concern as possible, a risk response decision has been made to implement specific security technology changes as well as adjustments to certain work procedures. The activity performed by the CISO can be considered what?",
    "choice_a": "Prudent action",
    "choice_b": "Threat hunting",
    "choice_c": "Reasonable action",
    "choice_d": "Risk assignment",
    "correct_answer": "A",
    "explanation": "Prudent actions refer to actions or decisions that are marked by a high degree of caution, care, and foresight. They are characterized by careful consideration of potential risks, a focus on preventing harm, and a commitment to acting in a manner that is consistent with established best practices or industry standards. Threat hunting is the process of actively searching for indicators of compromise (IoCs) of cyberthreats on a network. Reasonable actions refer to actions or decisions that are in line with what a person of ordinary prudence and judgment would do in similar circumstances. Risk assignment is the placement of the responsibility of loss due to a risk onto another entity or organization.",
    "topic_id": 7,
    "practice_test_id": 7,
    "related_articles": [
      507,
      564,
      607,
      531,
      528
    ],
    "source": ""
  },
  {
    "id": 5056,
    "question": "Annaliese is designing the network for the new facility that the organization will be building. When considering the switching infrastructure, there is a need to ensure the integrity of transmissions above optimization for low latency. In other words, accuracy is more important than speed. Which of the following forms of transport architecture is best suited for this scenario?",
    "choice_a": "Arbitration switching",
    "choice_b": "Cut-through switching",
    "choice_c": "Deconfliction switching",
    "choice_d": "Store-and-forward switching",
    "correct_answer": "D",
    "explanation": "Store-and-forward switching receives and stores the entire frame in a buffer before forwarding, offering greater error checking and suitability for ensuring data integrity. Arbitration is a media access protocol where a central authority or a predefined set of rules determines which device has the right to access the communication medium at any given time. It does not address integrity. Cut-through switching forwards a frame as soon as it reads the destination address, providing low latency and suitability for low-latency applications. It does not address integrity. Deconfliction is a media access protocol that aims to avoid collisions and conflicts by assigning specific time slots or frequency bands to different devices for communication. It does not address integrity.",
    "topic_id": 4,
    "practice_test_id": 8,
    "related_articles": [
      386,
      431,
      394,
      330,
      331
    ],
    "source": ""
  },
  {
    "id": 5057,
    "question": "Kevin is participating in a security exercise for his organization. His role in the exercise is to use hacking techniques to attempt to gain access to the organization's systems. What role is Kevin playing in this exercise?",
    "choice_a": "Red team",
    "choice_b": "Blue team",
    "choice_c": "Purple team",
    "choice_d": "White team",
    "correct_answer": "A",
    "explanation": "Offensive hacking is used by red teams as they attempt to gain access to systems on the target network. Blue teams are responsible for managing the organization's defenses. White teams serve as the neutral moderators of the exercise. Purple teaming is conducted after an exercise to bring together the red and blue teams for knowledge sharing.",
    "topic_id": 6,
    "practice_test_id": 8,
    "related_articles": [
      1080,
      1078,
      1079,
      771,
      495
    ],
    "source": ""
  },
  {
    "id": 5058,
    "question": "What is a legal contract between an employer and an employee whose primary purpose is to restrict the ability of one party from engaging in competitive activities or working for a competing entity, typically within a specific geographical area and for a defined duration, after the termination of their relationship with the other party?",
    "choice_a": "Acceptable use policy (AUP)",
    "choice_b": "Nondisclosure agreement (NDA)",
    "choice_c": "Non-compete agreement (NCA)",
    "choice_d": "Memorandum of understanding (MOU)",
    "correct_answer": "C",
    "explanation": "A non-compete agreement (NCA) is a legal contract between an employer and an employee whose primary purpose is to restrict the ability of one party from engaging in competitive activities or working for a competing entity, typically within a specific geographical area and for a defined duration, after the termination of their relationship with the other party. An acceptable use policy (AUP) defines what is and what is not an acceptable activity, practice, or use for company equipment and resources. A nondisclosure agreement (NDA) is used to protect the confidential information within an organization from being disclosed by a current or former employee. A memorandum of understanding (MOU) is an expression of agreement or aligned intent, will, or purpose between two entities.",
    "topic_id": 1,
    "practice_test_id": 9,
    "related_articles": [
      39,
      35,
      37,
      4,
      17
    ],
    "source": ""
  },
  {
    "id": 5059,
    "question": "Renee is purchasing a new software product and is working with the vendor on the negotiation of a license agreement that will specify customized terms of use and a discounted price. What type of agreement would normally be used to document the results of this negotiation?",
    "choice_a": "Perpetual license",
    "choice_b": "Subscription license",
    "choice_c": "Enterprise license agreement",
    "choice_d": "End-user license agreement",
    "correct_answer": "C",
    "explanation": "Renee's situation calls for an enterprise license agreement as it typically allows customization of terms and pricing, reflecting the negotiated details between the vendor and a corporate client. The license agreement may be written as a perpetual or subscription license, but there is no information provided in the scenario about which one is being used. An end-user license agreement usually accompanies software to dictate the terms of use but is not designed for custom negotiations and pricing agreements.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      110,
      38,
      679,
      1048,
      35
    ],
    "source": ""
  },
  {
    "id": 5060,
    "question": "Shahla is reviewing the privacy laws that apply to a new enterprise that her company will be launching in South Africa. This is the company's first expansion into that country, and the enterprise will involve handling the personal information of residents of South Africa. What law will likely affect this operation?",
    "choice_a": "PIPL",
    "choice_b": "PCI DSS",
    "choice_c": "PIPEDA",
    "choice_d": "POPIA",
    "correct_answer": "D",
    "explanation": "South Africa's Protection of Personal Information Act (POPIA) governs the processing of personal data and would affect any new enterprise operating within its jurisdiction that handles personal information. PIPL refers to China's Personal Information Protection Law, which would not apply in South Africa. PCI DSS is a set of security standards for entities that handle credit cards and does not relate to privacy law but rather to the security of cardholder data. PIPEDA, the Personal Information Protection and Electronic Documents Act, is Canada's data privacy law and would not be applicable to operations in South Africa.",
    "topic_id": 1,
    "practice_test_id": null,
    "related_articles": [
      109,
      118,
      114,
      105,
      115
    ],
    "source": ""
  },
  {
    "id": 5061,
    "question": "Angela wants to implement data security controls that are part of the NIST 800-53 Security and Privacy controls. As part of the process, she works to determine which controls are appropriate to her organization's business processes and data handling needs. What term best describes the action that she has performed?",
    "choice_a": "Scoping",
    "choice_b": "Bounds checking",
    "choice_c": "Data stewardship",
    "choice_d": "Tailoring",
    "correct_answer": "A",
    "explanation": "Scoping is the process of determining which controls are appropriate to an organization, environment, or implementation. Bounds checking is the process of making sure that data does not overflow a variable. Data stewards provide oversight and data governance. Tailoring modifies controls to fit a specific situation or need.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      142,
      698,
      143
    ],
    "source": ""
  },
  {
    "id": 5062,
    "question": "Steve wants to ensure that assets in his organization are properly secured. What should he do to make sure security practices match the data security requirements for each device in his organization?",
    "choice_a": "Sanitization",
    "choice_b": "Asset tagging",
    "choice_c": "Tailoring",
    "choice_d": "Encryption",
    "correct_answer": "B",
    "explanation": "Asset tagging is used to make sure that individuals working with assets can determine the security level or practices they require. Tailoring adjusts security requirements to organizational needs. Other controls, such as sanitization and encryption, may be required by a specific asset classification but are not sufficient to meet a full range of security requirements.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      123,
      141,
      128,
      124,
      697
    ],
    "source": ""
  },
  {
    "id": 5063,
    "question": "Michelle wants to ensure that her organization's policies are enforced across all of the cloud services that it has adopted. What type of tool would be best suited to ensuring her organization's policies are enforced, regardless of the cloud service her users are accessing?",
    "choice_a": "A SIEM",
    "choice_b": "A DLP",
    "choice_c": "A CASB",
    "choice_d": "A NGFW",
    "correct_answer": "C",
    "explanation": "Cloud access security brokers (CASBs) can be on-site or cloud-based and are security policy enforcement points that operate between users and cloud services. A CASB can provide insight into what users are doing, enforce policies, provide threat protection, and even provide data loss prevention capabilities. A SIEM collects logs and event information as part of security monitoring and event management. A DLP system focuses on data loss prevention and data security but won't address an organization's full set of security policies and practices in the cloud, and NGFWs, or next-generation firewalls, provide a variety of security services but are not specifically designed to implement cloud policy.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      135,
      127,
      124,
      144,
      125
    ],
    "source": ""
  },
  {
    "id": 5064,
    "question": "Devices in Adam's organization are no longer receiving updates, and hardware support contracts cannot be extended. How should Adam describe the devices that are impacted by this?",
    "choice_a": "End of support",
    "choice_b": "End of development",
    "choice_c": "End of life",
    "choice_d": "End of sales",
    "correct_answer": "A",
    "explanation": "The devices have reached end of support (EOS), and the vendor will no longer provide updates or support for it. End of development occurs when no new software updates or patches are being released. End of life and end of sales often occur at the same time when the vendor no longer sells the device. Support will typically continue even after end of life (EOL).",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      877,
      847,
      849,
      133,
      878
    ],
    "source": ""
  },
  {
    "id": 5065,
    "question": "Gary is responsible for the procurement, management, and life cycle of network devices in his organization. What role best describes him?",
    "choice_a": "Data owner",
    "choice_b": "Asset custodian",
    "choice_c": "Data custodian",
    "choice_d": "Asset owner",
    "correct_answer": "D",
    "explanation": "Asset owners are responsible for assets in an organization, including their procurement, management, and life cycle. Unlike data roles, there are typically fewer asset roles in play, and asset custodian is not a commonly recognized role. Since these are hardware devices, Gary's role is not as a data custodian or owner in the scope of this question.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      849,
      138,
      851,
      847,
      133
    ],
    "source": ""
  },
  {
    "id": 5066,
    "question": "Jessica has adopted the CIS benchmark for Windows 11\u00a0workstations for her organization. She has modified what settings are called for in the benchmark to fit her organization's needs as well. What has she done?",
    "choice_a": "Tailoring",
    "choice_b": "Scoping",
    "choice_c": "Editing",
    "choice_d": "Defining",
    "correct_answer": "A",
    "explanation": "Modifying baselines to better suit an organization is known as tailoring. Scoping occurs when baselines are reviewed to ensure that only controls suited to the environment or system are used. Editing and defining are not terms used on the exam for these activities.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      141,
      140,
      142,
      698,
      697
    ],
    "source": ""
  },
  {
    "id": 5067,
    "question": "Why is data location a significant concern for data owners, controllers, and custodians?",
    "choice_a": "It prevents the data from being lost.",
    "choice_b": "Geographic location may impact compliance requirements.",
    "choice_c": "Geographic location may drive storage costs.",
    "choice_d": "It ensures that the proper data custodian works with it.",
    "correct_answer": "B",
    "explanation": "Data location, particularly at rest, may drive compliance requirements based on local or national laws. This concern drives the majority of data location concerns. Ensuring data is not lost is a data handling and management practice topic, geographic location may be related to cost but storage media and services drive cost far more than physical location, and data custodians are likely to work with data regardless of location.",
    "topic_id": 2,
    "practice_test_id": null,
    "related_articles": [
      139,
      138,
      708,
      126,
      143
    ],
    "source": ""
  },
  {
    "id": 5068,
    "question": "In a zero trust network architecture, what component is responsible for making policy decisions based upon rules and external data sources?",
    "choice_a": "Policy engine",
    "choice_b": "Policy administrator",
    "choice_c": "Policy enforcement point",
    "choice_d": "Subject",
    "correct_answer": "A",
    "explanation": "In a zero trust network architecture, the policy engine is responsible for making policy decisions based upon rules and external data sources. It uses a trust algorithm to decide whether to grant, deny, or revoke access, considering factors like identity management, threat intelligence, and security information and event management (SIEM) data. The policy administrator, on the other hand, acts based on the decisions made by the policy engine, establishing or removing communication paths and managing session-specific credentials. The policy enforcement point enforces these decisions by controlling access to resources based on instructions from the policy administrator. Lastly, the subject refers to users, services, or systems that request access or attempt to use rights and is not involved in decision-making.",
    "topic_id": 3,
    "practice_test_id": null,
    "related_articles": [
      207,
      213,
      201,
      211,
      227
    ],
    "source": ""
  },
  {
    "id": 5069,
    "question": "What is the purpose of a virtual domain (VDOM)?",
    "choice_a": "They combine multiple virtual instances into a single domain.",
    "choice_b": "They divide a firewall device or appliance into two or more virtual firewalls.",
    "choice_c": "They create a virtual domain controller.",
    "choice_d": "They allow the hosting of multiple domain names for a single host.",
    "correct_answer": "B",
    "explanation": "VDOMs are instances of firewalls, each with their own interfaces and rulesets allowing granular configurations based on security requirements. VDOMs are commonly used to accommodate different purposes, customers, or other needs where separately managed firewall instances are desirable. They don't combine instances; instead, they create separate instances, they aren't domain controllers, and hosting multiple domain names does not require a VDOM.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      375,
      419,
      405,
      406,
      388
    ],
    "source": ""
  },
  {
    "id": 5070,
    "question": "Gary is deploying a wireless network and wants to deploy the fastest possible wireless technology. Which one of the following wireless networking standards should he use?",
    "choice_a": "802.11ac",
    "choice_b": "802.11g",
    "choice_c": "802.11n",
    "choice_d": "802.11ax",
    "correct_answer": "D",
    "explanation": "He should choose 802.11ax, which supports theoretical speeds up to 9.6 Gbps. 802.11ac supports up to 5.9 Gbps, 802.11n supports up to 600 Mbps, and 802.11g is only capable up to 54 Mbps.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      359,
      366,
      361,
      389,
      360
    ],
    "source": ""
  },
  {
    "id": 5071,
    "question": "Brian is analyzing his network traffic and is focused on the variance of the delay between packets of data that are sent between two of his sites. What is he analyzing?",
    "choice_a": "Latency",
    "choice_b": "Jitter",
    "choice_c": "Throughput",
    "choice_d": "Signal-to-noise ratio",
    "correct_answer": "B",
    "explanation": "Brian is analyzing the jitter, which is the variance in delay between packets. This can indicate issues along the path the packets take. Latency is the time it takes a packet to reach its destination, throughput is a measure of the volume of traffic that can be sent, and signal to noise ratios compare the amount of desired information that is received versus the level of background noise or unwanted data.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      394,
      404,
      333,
      386,
      330
    ],
    "source": ""
  },
  {
    "id": 5072,
    "question": "Chris is designing layered network security for his organization. <br><img src=\"/question_assets/CISSP/4_image1.png\"/> <br>Chris wants to implement security controls in his data center at the level of individual ser vices and workloads. He plans to use firewall rules and other controls as well as on-demand access to services as part of his security design. What design concept is he implementing?",
    "choice_a": "Converged protocols",
    "choice_b": "Physical segmentation",
    "choice_c": "Edge network-based design",
    "choice_d": "Micro-segmentation",
    "correct_answer": "D",
    "explanation": "Micro-segmentation is used to logically separate systems and services by defining boundaries between them. This is often part of a zero trust architecture including the use of on-demand access to services. Converged protocols implement other protocols over another protocol like iSCSI or InfiniBand over Ethernet. Physical segmentation uses separate physical devices and infrastructure to provide segmentation. Edge networks place computation and storage closer to the end user.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      357,
      356,
      375,
      412,
      333
    ],
    "source": ""
  },
  {
    "id": 5073,
    "question": "As part of his segmentation approach, Chris also wants to segment network routes. What type of solution should he select?",
    "choice_a": "VPCs",
    "choice_b": "VRF",
    "choice_c": "VLANs",
    "choice_d": "A CD",
    "correct_answer": "B",
    "explanation": "Virtual routing and forwarding (VRF) is used to allow multiple routing tables to exist in a virtual router, all working simultaneously as defined by network traffic rules. A VPC may include VRF capabilities, but VRF would still be required to complete this requirement. VLANs are used to separate network segments, not to provide routing, and a content distribution network is used to provide high-performance, denial-of-service-resistant content replication and access from a large-scale network of replicas.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      419,
      356,
      357,
      331,
      355
    ],
    "source": ""
  },
  {
    "id": 5074,
    "question": "Chuck is in charge of a commercial data center that handles many customers who host their servers there. He wants to be able to configure his data center network to adjust to traffic pattern changes and to manage bandwidth and other options. What technology should he implement to allow central, programmatic control of his network?",
    "choice_a": "SDN",
    "choice_b": "SD-WAN",
    "choice_c": "Proxy routing",
    "choice_d": "Agile networking",
    "correct_answer": "A",
    "explanation": "Software-defined networking (SDN) uses code to configure and control the network. This allows for agile, programmatic control and configuration as needed from a central control point. SD-WAN provides the same sort of control for wide area network links, which aren't mentioned in this question. Proxy routing occurs when a proxy server routes traffic between clients and other systems, and agile networking is not a commonly used term.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      354,
      386,
      394,
      419,
      378
    ],
    "source": ""
  },
  {
    "id": 5075,
    "question": "Susan wants to access her company's SAN via Ethernet and knows that she can access it as a block-level storage device. What converged protocol is she most likely to use?",
    "choice_a": "CXL",
    "choice_b": "SDWAN",
    "choice_c": "iSCSI",
    "choice_d": "Zigbee",
    "correct_answer": "C",
    "explanation": "iSCSI is a converged protocol that supports SCSI storage access via Ethernet. CXL is Compute Express Link, often used to interconnect memory, CPUs, and accelerators. SD-WAN is a software-defined wide area network, and Zigbee is a low-power wireless protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      352,
      354,
      333,
      335,
      330
    ],
    "source": ""
  },
  {
    "id": 5076,
    "question": "Melissa wants to leverage a cloud service provider's edge services. What will peering allow her to do in this scenario?",
    "choice_a": "Ensure that a copy of any data stored in the cloud is also replicated in her local data center",
    "choice_b": "Provide a direct path from her on-premises network to the cloud provider's services.",
    "choice_c": "Control traffic flows via software-defined routes.",
    "choice_d": "Host copies of her sites at multiple locations hosted by her cloud computing service provider.",
    "correct_answer": "B",
    "explanation": "Peering allows you to connect directly to a provider's network at a peering location where they provide edge facilities. This can reduce ingress/egress costs as well as provide direct paths to their networks and services. Replication of data is not an artifact of or a result of peering. Controlling traffic flows via software-defined routes is done using SD-WAN, and hosting copies of sites at multiple locations is a typical result of using a CDN.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      358,
      1068,
      1067,
      394,
      430
    ],
    "source": ""
  },
  {
    "id": 5077,
    "question": "Jake wants to describe traffic sent between servers in his data center. What common terminology should he use to describe this?",
    "choice_a": "North/South",
    "choice_b": "Privilege/Unprivileged",
    "choice_c": "East/West",
    "choice_d": "Store/Forward",
    "correct_answer": "C",
    "explanation": "Traffic sent between systems in the same data center is called east/west traffic since it does not flow across network boundaries. East/west traffic requires additional design work in many organizations if monitoring and other security is desired. Traffic that is external to the data center, either inbound or outbound, is called north/south traffic. Privileged/unprivileged and store/forward are not typically used to describe the traffic flows in the question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      970,
      971,
      972,
      419,
      375
    ],
    "source": ""
  },
  {
    "id": 5078,
    "question": "Sarah has been asked to improve the observability of her network. Which of the following is not a common step to improve observability?",
    "choice_a": "Aggregate and centralize data.",
    "choice_b": "Enable alerts for critical errors.",
    "choice_c": "Implement logging using a standardized format.",
    "choice_d": "Avoid feedback loops.",
    "correct_answer": "D",
    "explanation": "Observability focuses on the ability to see how an entire system, service, or environment is performing and behaving based on its external outputs. That means that telemetry data\u2014information about what components are doing\u2014is critical and will be gathered using logs, metrics, and real-time analysis. This means that centralizing and aggregating data, enabling alerts for critical errors, and implementing logging using standardized formats are all common practices. Feedback loops are also important, allowing administrators and others to take action when problems or issues are detected.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      404,
      422,
      436,
      394,
      330
    ],
    "source": ""
  },
  {
    "id": 5079,
    "question": "Mark's organization hosts their infrastructure in a cloud IaaS environment. They operate in a private, isolated, and secure cloud that they configure. What term best describes this?",
    "choice_a": "VLAN",
    "choice_b": "VPC",
    "choice_c": "SDN",
    "choice_d": "CXL",
    "correct_answer": "B",
    "explanation": "AVPC, or virtual private cloud, is the environment many organizations operate inside of public clouds. They provide on-demand access to configurable, shared resources operated by the cloud provider inside of their isolated boundaries. VLANs are used to logically separate networks; SDN is software-defined networking, which is typically part of how a VPC is implemented; and CXL, or Compute Express Link, is a converged protocol used to connect CPUs, GPUs, accelerators, and other components at high speeds.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      355,
      354,
      411,
      430,
      416
    ],
    "source": ""
  },
  {
    "id": 5080,
    "question": "Olga wants to provide out-of-band management for her SCADA devices, which are deployed across her organization's large physical infrastructure in production facilities and environment. Which of the following is an appropriate solution to meet her needs?",
    "choice_a": "Administrative access via a web client installed on each system that requires Windows-based domain authentication",
    "choice_b": "Administrative access via nonstandard ports using a secure protocol like SSH",
    "choice_c": "Administrative access via a second, physically separate Ethernet network with access controlled via VPN and multifactor authentication",
    "choice_d": "Administrative access via physical access to the devices when needed",
    "correct_answer": "C",
    "explanation": "Separate, physically isolated Ethernet networks that require strong authentication are a commonly used out-of-band (OOB) option. While direct physical access is also an acceptable out-of-band option, it does not work well in a complex, production-oriented environment where devices may not be safe or easy to access. Web clients and nonstandard ports are not out-of-band options as described.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      356,
      401,
      412,
      413,
      417
    ],
    "source": ""
  },
  {
    "id": 5081,
    "question": "What mode of switching is best suited to low-latency, high-throughput data transfer?",
    "choice_a": "Store-and-forward switching",
    "choice_b": "Blind switching",
    "choice_c": "Forward switching",
    "choice_d": "Cut-through switching",
    "correct_answer": "D",
    "explanation": "Cut-through switching forwards packets as soon as the destination address is known without waiting for the rest of the frame to arrive. This means that packets are not checked for integrity before being forwarded, optimizing throughput and reducing latency at the expense of error checking. Store-and-forward waits for the entire frame to allow it to be checked using a cyclic redundancy check (CRC) before forwarding it. Blind and forward switching were made up for this question.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      386,
      405,
      373,
      438,
      333
    ],
    "source": ""
  },
  {
    "id": 5082,
    "question": "Chris wants to ensure that traffic sent via his backhaul networks provided by third-party telecom providers is secure. Which of the following options is best suited to ensuring that all traffic sent through the connection is secure?",
    "choice_a": "Use TLS for all web services.",
    "choice_b": "Use an on-demand, client-based VPN.",
    "choice_c": "Use a point-to-point VPN.",
    "choice_d": "Tunnel traffic via SSH.",
    "correct_answer": "C",
    "explanation": "For long-term connections like backhaul networks, a point-to-point VPN that is connected at all times is the most common choice to ensure all traffic is secured. TLS and SSH are commonly used to tunnel data but require additional attention to ensure that all traffic is tunneled. On-demand VPNs are more commonly used by users than for a connection like a backhaul network link.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      429,
      414,
      413,
      417,
      401
    ],
    "source": ""
  },
  {
    "id": 5083,
    "question": "Kim wants to protect her Zoom meetings from Zoom bombing. What security option should she enable?",
    "choice_a": "Require HTTPS connections.",
    "choice_b": "Turn on the waiting room.",
    "choice_c": "Randomize meeting links.",
    "choice_d": "Require a meeting passcode.",
    "correct_answer": "B",
    "explanation": "Enabling waiting rooms allows hosts to allow only intended attendees for events and meetings. Unfortunately, passcodes are easily shared, resulting in Zoom bombing despite the security they appear to offer. Meeting links are automatically generated and randomized, preventing brute forcing, and HTTPS is enabled by default for meetings.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      403,
      400,
      367,
      395,
      430
    ],
    "source": ""
  },
  {
    "id": 5084,
    "question": "Olivia wants to use a network fault management tool that can provide real-time fault detection. What capabilities are most commonly associated with this type of monitoring?",
    "choice_a": "SNMP and ICMP-based monitoring and diagnostic data retrieval",
    "choice_b": "Netflow and syslog-based monitoring",
    "choice_c": "SNMP and Netflow-based monitoring",
    "choice_d": "ICMP and syslog-based monitoring",
    "correct_answer": "A",
    "explanation": "Real-time fault monitoring for network devices and connections often relies on SNMP and ICMP-based monitoring capabilities. Netflow and syslog are more commonly used for diagnostic and analysis tasks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      404,
      336,
      1071,
      402,
      378
    ],
    "source": ""
  },
  {
    "id": 5085,
    "question": "Susan wants to provide 100 gigabit network connections to devices in the facility where the new branch will operate. What connectivity options does she have for structured wiring that can meet those speeds?",
    "choice_a": "Cat5e",
    "choice_b": "Fiber",
    "choice_c": "Cat6",
    "choice_d": "Coaxial cable",
    "correct_answer": "B",
    "explanation": "Fiber-optic cable is best suited to running 100 gigabit speeds. Cat5e, Cat6, and coaxial cable are not rated to those speeds.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      381,
      731,
      435,
      333,
      375
    ],
    "source": ""
  },
  {
    "id": 5086,
    "question": "Selah's networking team has been asked to identify a technology that will allow them to separate the routing process for the network from the packet switching process while increasing centralization?",
    "choice_a": "A network that follows the 5-4-3 rule",
    "choice_b": "A converged network",
    "choice_c": "A software-defined network",
    "choice_d": "A hypervisor-based network",
    "correct_answer": "C",
    "explanation": "Software-defined networking provides a network architecture that can be defined and configured as code or software and separates routing processes from packet switching while centralizing control. The 5-4-3 rule is an old design rule for networks that relied on repeaters or hubs. A converged network carries multiple types of traffic like voice, video, and data. A hypervisor-based network may be software defined, but it could also use traditional network devices running as virtual machines.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      354,
      386,
      331,
      439,
      438
    ],
    "source": ""
  },
  {
    "id": 5087,
    "question": "When a TCP packet is sent, what is added as datagrams are sent from the Transport Layer to the Internet Layer and from the Internet Layer to the Data-Link Layer?",
    "choice_a": "Headers are added",
    "choice_b": "Information is added to the main body of the packet data",
    "choice_c": "The data is encrypted with a new secret key",
    "choice_d": "A security envelope that provides perfect forward secrecy",
    "correct_answer": "A",
    "explanation": "As packets are handled at the Transport Layer they receive a header with information like ports, segment order information, and a checksum. At the Internet Layer, an IP header is attached with the IP addresses of the sender and receiver, the datagram sequence order, and the datagram length. At the Data-Link layer another header is added for CRC error checks.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      742,
      330,
      332,
      389,
      744
    ],
    "source": ""
  },
  {
    "id": 5088,
    "question": "Lisa wants to explain the difference between network throughput and bandwidth to her team. Which of the following best describes the difference between the two terms?",
    "choice_a": "Bandwidth describes the number of parallel data channels available to a network, and throughput describes how many can be used at once.",
    "choice_b": "Bandwidth is the maximum amount of data that can be sent via a channel or connection, and throughput is the actual amount of data that is sent via the channel or connection in a given period of time.",
    "choice_c": "Bandwidth and throughput are the same and can be used interchangeably.",
    "choice_d": "Bandwidth is a measure of the amount of data sent over a given period of time, and throughput is the maximum amount of data that could be sent via the channel.",
    "correct_answer": "B",
    "explanation": "Bandwidth describes the maximum amount of data that can be sent via a connection or network in a given period of time, and throughput describes the actual amount of traffic that is sent via the network or connection in a given period of time. The terms are not interchangeable but are closely related.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      1069,
      1070,
      404,
      333,
      345
    ],
    "source": ""
  },
  {
    "id": 5089,
    "question": "Traffic entering and leaving a network through a WAN link is often described as what sort of traffic?",
    "choice_a": "Foreign/domestic",
    "choice_b": "North/south",
    "choice_c": "East/west",
    "choice_d": "Trusted/untrusted",
    "correct_answer": "B",
    "explanation": "Traffic entering and leaving a network is often called north/south traffic. East/west traffic is traffic between systems inside of a network. Foreign/domestic is not a commonly used term, and trusted/untrusted cannot be determined without additional information.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      970,
      972,
      971,
      433,
      429
    ],
    "source": ""
  },
  {
    "id": 5090,
    "question": "What converged protocol is designed to allow high-speed communication to devices like CPUs, GPUs, and accelerators?",
    "choice_a": "CXL",
    "choice_b": "VoIP",
    "choice_c": "CDN",
    "choice_d": "iSCSI",
    "correct_answer": "A",
    "explanation": "CXL, or Compute Express Link, is a converged protocol that is an open standard for high-speed communications with accelerators, GPUs, CPUs, and similar devices. VoIP is a telephony protocol, CDNs are content distribution networks, and iSCSI is a converged storage protocol.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      352,
      354,
      435,
      330,
      351
    ],
    "source": ""
  },
  {
    "id": 5091,
    "question": "Srini is building a high-performance computing cluster that requires very high bandwidth and very low latency. What converged protocol is he most likely to select for this purpose?",
    "choice_a": "iSCSI",
    "choice_b": "VoIP",
    "choice_c": "Infiniband over Ethernet",
    "choice_d": "CXL",
    "correct_answer": "C",
    "explanation": "Infiniband over Ethernet is commonly used for purposes like this, allowing direct memory access over Ethernet while providing high bandwidth and low latency. iSCSI is used for storage, VoIP is used for telephony, and Compute Express Link (CXL) is used for CPU to device and CPU to memory connections.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      352,
      394,
      353,
      434,
      404
    ],
    "source": ""
  },
  {
    "id": 5092,
    "question": "Angela needs access to manage IoT devices at multiple sites that her organization manages. What solution should she suggest to ensure access and security for the devices?",
    "choice_a": "VPNs to protected VLANs",
    "choice_b": "An IDS located at the network edge protecting a network using only private IP addresses",
    "choice_c": "A DLP system configured to prevent attacks against IoT devices",
    "choice_d": "An iSCSI-based security solution accessed using a VPN and jump boxes",
    "correct_answer": "A",
    "explanation": "A VPN that allows access to secured VLANs is the most common security design for this type of infrastructure. This allows secured remote access while protecting IoT devices that are often unable to be properly secured and thus cannot be trusted on a more exposed network. IPS does not provide remote access, and private IP addresses alone do not provide a protected network. DLP is used to prevent data exfiltration and won't stop other attacks or provide remote management access. iSCSI is a storage protocol, not a security solution. A VPN and jump boxes are useful, but the devices would not be provided with additional security by iSCSi.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      411,
      401,
      413,
      414,
      427
    ],
    "source": ""
  },
  {
    "id": 5093,
    "question": "Aadita's company wants to ensure that their website is highly available and resistant to potential denial-of-service attacks. What type of solution would be best suited to this if the company operates an e-commerce site that serves multiple countries and regions with a very large number of customers?",
    "choice_a": "A load-balanced web server cluster",
    "choice_b": "A CDN",
    "choice_c": "Micro-segmentation of virtual servers",
    "choice_d": "A VPC",
    "correct_answer": "B",
    "explanation": "Content distribution networks are used to both improve performance and reduce the impacts of denial-of-service attacks. Load-balanced server clusters may be part of the underlying design, but a CDN will more completely address Aadita's needs at the scale described. Micro-segmentation is used to isolate systems and services, not to address multiregion content accessibility and denial-of-service issues. A VPC may be part of a solution, but nothing about a VPC makes it a sufficient solution on its own.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      373,
      405,
      358,
      394,
      376
    ],
    "source": ""
  },
  {
    "id": 5094,
    "question": "Jake's company keeps their certificate signing server disconnected from the network to prevent it from being compromised by network attacks. What is this type of solution called?",
    "choice_a": "Store-and-forward",
    "choice_b": "Out-of-band",
    "choice_c": "In-band",
    "choice_d": "Air-gapping",
    "correct_answer": "D",
    "explanation": "Air-gaps are physical separations between systems or devices that prevent communications or connections between them. This prevents network-based attacks and limits the ways that attackers could access the devices. Store-and-forward stores communications and send them after checking for errors. In-band administration occurs over existing interfaces or connections; out-of-band administration uses a separate network or management interface.",
    "topic_id": 4,
    "practice_test_id": null,
    "related_articles": [
      356,
      386,
      400,
      402,
      349
    ],
    "source": ""
  },
  {
    "id": 5095,
    "question": "Henry uses his organizationally provided credentials to log into his workstation and is then able to use services across the organization and in the cloud. What identity solution has his organization implemented?",
    "choice_a": "An access control list",
    "choice_b": "Single sign-on",
    "choice_c": "Multifactor authentication",
    "choice_d": "Role-based access control",
    "correct_answer": "B",
    "explanation": "Single sign-on provides a single authentication process to allow authorization to multiple services. An access control list, or ACL, is a ruleset used to determine if a subject can gain access to a service or system. Multifactor requires multiple factors, and the specifics of how Henry logged in were not discussed in the question. Finally, role-based access control uses a subject's role(s) to determine if they can access a service or system, and no mention of roles was made.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      477,
      480,
      474,
      441
    ],
    "source": ""
  },
  {
    "id": 5096,
    "question": "What role does a policy enforcement point play in a zero trust environment?",
    "choice_a": "It makes decisions for the policy engine.",
    "choice_b": "It is the workstation or mobile device used by the end user.",
    "choice_c": "It deploys role-based access controls based on local policy",
    "choice_d": "It receives authorization requests and sends them to the policy decision point.",
    "correct_answer": "D",
    "explanation": "A policy enforcement point in a zero trust environment receives authorization requests and then sends them to the policy decision point. They are used anywhere that authorization controls are needed. They do not make decisions for the policy engine, can exist beyond workstations and mobile devices, and use policies set at the zero trust control layer rather than just at the endpoint device.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      482,
      441,
      463,
      470,
      481
    ],
    "source": ""
  },
  {
    "id": 5097,
    "question": "When Sally attempts to authenticate to her organization's services, she knows that the organization uses a mobile device management tool to check her location and whether she's logging in from her company-issued mobile device. What type of authentication is this?",
    "choice_a": "Context-aware",
    "choice_b": "Knowledge-based",
    "choice_c": "Identity factoring",
    "choice_d": "Zero trust",
    "correct_answer": "A",
    "explanation": "Authentication that takes attributes such as location, device, and time of day into account is context-aware authentication. This allows organizations to make choices about whether the authentication is appropriate and allowed in addition to the use of credentials. The decision is based on contextual information, not user knowledge or identity factors, which are used only to authenticate. Zero trust may leverage context information, but context-aware authentication alone does not indicate zero trust.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      469,
      446,
      449,
      482,
      459
    ],
    "source": ""
  },
  {
    "id": 5098,
    "question": "What common behavior drives the NIST recommendation that passwords should not expire?",
    "choice_a": "Attackers would not have enough time to compromise passwords if they expired.",
    "choice_b": "Users often make minimal changes to passwords to handle change requirements.",
    "choice_c": "Password expiration leads to too little support overhead.",
    "choice_d": "Re-hashing passwords when changes are required is computationally intensive.",
    "correct_answer": "B",
    "explanation": "The NIST recommendation to not expire passwords recognizes that users often make minimal changes to their passwords when they are required to change them. In addition, password changes drive significant support overhead as users forget their passwords or otherwise face challenges with them. Longer password lives do create the potential for attackers to have longer to compromise them, but modern password recommendations look for multifactor authentication, which means a compromised password is less of a threat. Hashing new passwords does require computation, but not a significant amount using modern hardware.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      447,
      908,
      755,
      489,
      446
    ],
    "source": ""
  },
  {
    "id": 5099,
    "question": "What three functions make up the AAA model?",
    "choice_a": "Access control, authentication, and authorization",
    "choice_b": "Access, administration, and authorization",
    "choice_c": "Authentication, authorization, and accounting",
    "choice_d": "Accounting, auditing, and assessment",
    "correct_answer": "C",
    "explanation": "AAA refers to a set of security protocols that are used to identify and authorize users and record their activities. The acronym stands for authentication, authorization, and accounting.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      441,
      459,
      492,
      479,
      443
    ],
    "source": ""
  },
  {
    "id": 5100,
    "question": "What directory-based technology underlies Microsoft Active Directory single sign-on?",
    "choice_a": "LDAP",
    "choice_b": "zero trust",
    "choice_c": "Shibboleth",
    "choice_d": "RADIUS",
    "correct_answer": "A",
    "explanation": "Active Directory relies on the Lightweight Directory Access Protocol (LDAP) as part of its single sign-on (SSO) implementation. Zero trust is not a SSO implementation, and Shibboleth is an open-source identity management system. RADIUS is not a single sign-on implementation, although some vendors use it behind the scenes to provide authentication for proprietary SSO.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      477,
      492,
      474,
      481
    ],
    "source": ""
  },
  {
    "id": 5101,
    "question": "Sameer's organization needs to perform identity proofing for new customers. What type of authentication is best suited to identity proofing in this scenario?",
    "choice_a": "Cognitive passwords",
    "choice_b": "Knowledge-based authentication",
    "choice_c": "Palm scans",
    "choice_d": "USB tokens",
    "correct_answer": "B",
    "explanation": "Knowledge-based authentication relies on information that only the individual who wants to prove their identity is likely to know. This might include a mortgage payment amount, vehicle information, or driver's license number among many options. Cognitive passwords, or security questions, are created by users, which means they aren't suited to this type of identity proofing. Palm scans and USB tokens both require prior engagement with the user as well and thus aren't suited for identity proofing with users who are new customers.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      442,
      459,
      443,
      446,
      461
    ],
    "source": ""
  },
  {
    "id": 5102,
    "question": "Ifemoa wants to ensure that users in her organization cannot change their password to a previously used password. What setting should she configure?",
    "choice_a": "Password length",
    "choice_b": "Maximum password age",
    "choice_c": "An MFA requirement",
    "choice_d": "Password history",
    "correct_answer": "D",
    "explanation": "Password history tracks what passwords have been set previously and will not allow reuse. A specific number of past passwords is typically set, and passwords themselves should not be retained. Instead, properly secured hashes are retained and compared to hashes of the new passwords. Length, maximum age, and MFA do not solve the issue of password reuse.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      447,
      907,
      845,
      489,
      486
    ],
    "source": ""
  },
  {
    "id": 5103,
    "question": "With a password history set, Ifeoma wants to prevent users from resetting their password multiple times to allow them to return to their original password. What setting should she apply?",
    "choice_a": "A password complexity requirement",
    "choice_b": "A maximum password age",
    "choice_c": "A minimum password age",
    "choice_d": "A password length requirement",
    "correct_answer": "C",
    "explanation": "Ifeoma knows that a minimum password age of one day will discourage users from resetting their passwords to attempt to return to their original password. Length and complexity do not prevent this if the original password met these requirements, and a maximum age is set in organizations that require password changes on a recurring basis.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      447,
      908,
      489,
      907,
      444
    ],
    "source": ""
  },
  {
    "id": 5104,
    "question": "With her organization's password behavior under control, Ifeoma wants to ensure that a lost password will not result in easy compromise of her company's accounts. Which of the following controls provides the best protection against password loss or exposure-related compromise?",
    "choice_a": "MFA",
    "choice_b": "SSO",
    "choice_c": "Federation",
    "choice_d": "Password rotation",
    "correct_answer": "A",
    "explanation": "Requiring multifactor authentication (MFA) is a common security measure used to prevent unauthorized access to an account in case of password loss or exposure. SSO allows the use of an account throughout systems or services. Federation connects different organizations together, allowing the use of credentials between trusted partners, and password rotation can help, but lost passwords remain dangerous until the rotation happens allowing days, weeks, or even months of potential vulnerable time.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      489,
      908,
      469,
      453,
      755
    ],
    "source": ""
  },
  {
    "id": 5105,
    "question": "Angela uses her smartphone's built-in biometric authentication and an application provided by her employer to log into her account. What type of authentication has she used?",
    "choice_a": "Extended",
    "choice_b": "Passwordless",
    "choice_c": "Alternative",
    "choice_d": "SPOT",
    "correct_answer": "B",
    "explanation": "Passwordless authentication leverages applications and capabilities such as built-in biometric authentication mechanisms. Extended and alternative authentication are not terms used on the exam. The Fast Identity Online Alliance (FIDO) is an open industry association that provides frameworks for passwordless authentication, but SPOT is not a type of passwordless authentication.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      446,
      443,
      445,
      459,
      461
    ],
    "source": ""
  },
  {
    "id": 5106,
    "question": "Which of the following is a common account setting for a service account?",
    "choice_a": "Disable password expiration.",
    "choice_b": "Set maximum password age to 90\u00a0days.",
    "choice_c": "Set minimum password age to 1\u00a0day.",
    "choice_d": "Disable complexity requirements.",
    "correct_answer": "A",
    "explanation": "Service accounts are commonly set to not have expiring passwords to prevent service outages. Organizations may choose to rotate passwords on a regular basis using automation tools as part of their password management strategy to help avoid issues with exposed or compromised service passwords. Disabling complexity requirements and setting a minimum password age are not commonly done for service accounts.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      926,
      449,
      447,
      453,
      484
    ],
    "source": ""
  },
  {
    "id": 5107,
    "question": "Jessica wants to adopt an open standard to provide authentication, authorization, and attribute information as part of her cloud identity federation efforts. What standard should she adopt to leverage the flexibility of XML as part of her efforts?",
    "choice_a": "SAML",
    "choice_b": "SOAP",
    "choice_c": "OAuth",
    "choice_d": "OpenID Connect",
    "correct_answer": "A",
    "explanation": "SAML is an open, XML-based standard used to provide authorization, attribute information, and authentication data. SOAP, or Simple Object Access Protocol, is a messaging protocol and could be used for any XML messaging but is not a markup language itself. OAuth is an authorization framework that exchanges information using APIs, and OpenID Connect is an authentication layer using OAuth that provides both authentication and authorization, but not attribute information.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      474,
      476,
      481,
      1020,
      452
    ],
    "source": ""
  },
  {
    "id": 5108,
    "question": "Jesse wants to access a resource protected by a zero trust solution. What component of the system will he connect through to conduct a transaction?",
    "choice_a": "The constrained interface",
    "choice_b": "The policy engine",
    "choice_c": "The policy decision point",
    "choice_d": "A policy enforcement point",
    "correct_answer": "D",
    "explanation": "In a zero trust reference model-based design, subjects connect through a policy enforcement point. The policy engine makes policy decisions based on rules that are then acted on by the policy administrator, granting or denying access to enterprise resources. Constrained interfaces limit user actions but are not the component connected through to conduct transactions.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      482,
      464,
      448,
      471,
      469
    ],
    "source": ""
  },
  {
    "id": 5109,
    "question": "Which of the following is not a commonly used single sign-on solution for internal networks?",
    "choice_a": "Kerberos",
    "choice_b": "SENTRY",
    "choice_c": "RADIUS",
    "choice_d": "TACACS+",
    "correct_answer": "B",
    "explanation": "Kerberos, RADIUS, and TACACS+ are all commonly used for internal networks. SENTRY was made up for this question.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      477,
      479,
      492,
      451,
      480
    ],
    "source": ""
  },
  {
    "id": 5110,
    "question": "Naomi's organization employs an access control system that evaluates the security readiness of a device before granting network access. The system checks whether the device is fully patched, if the latest antimalware scans are clean, and if the firewall is active. If there are potential issues that may indicate a compromise, she is not permitted to connect and must contact support. What type of access control scheme best describes this type of process?",
    "choice_a": "MAC",
    "choice_b": "Rule-based access control",
    "choice_c": "Role-based access control",
    "choice_d": "Risk-based access control",
    "correct_answer": "D",
    "explanation": "Risk-based access control models risk using information that is available when the access request is created. Information about the request and the risk it may create is calculated based on risk values and compared to access policies. If the risk value is acceptable, access is granted. One of the most common examples of this in organizations is NAC, or network access control, where a system is profiled to determine security risk and compliance before admission to a network. This can be seen as a more specific example of rule-based access control. Role-based access control bases its decisions on the roles of the individuals, whereas mandatory access control is enforced by the operating system.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      469,
      472,
      467,
      491,
      441
    ],
    "source": ""
  },
  {
    "id": 5111,
    "question": "In the NIST zero trust model, what component includes the Policy Engine and the Policy Administrator as shown here?<br><img src=\"/question_assets/CISSP/5_image9.png\"/>",
    "choice_a": "The control plane module",
    "choice_b": "The policy decision point",
    "choice_c": "The enterprise management console",
    "choice_d": "The zero trust engine",
    "correct_answer": "B",
    "explanation": "The NIST zero trust reference design includes both the Policy Engine and the Policy Administrator as part of the policy decision point. The terms <italic>control plane module, enterprise management console, and zero trust engine </italic>are not used in this context.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      482,
      469,
      463,
      441,
      450
    ],
    "source": ""
  },
  {
    "id": 5112,
    "question": "Jim's organization has joined a federation and has begun to allow users from other organizations in the federation to use their services. What services will the members of other organizations be able to use?",
    "choice_a": "All of the services provided by Jim's company",
    "choice_b": "Only the services their own organization provides",
    "choice_c": "Services that Jim's company grants access to on a per-user or per-organization basis",
    "choice_d": "Only services that they pay for that Jim's company provides",
    "correct_answer": "C",
    "explanation": "Federation does not necessarily guarantee that services will be shared or made accessible. Member organizations can choose which services they provide and can use more granular controls like role- or organization-based permissions to grant access to services. Payment may be part of a federation agreement or service access, but simply federating does not create or prevent a financial requirement.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      451,
      452,
      466,
      470,
      465
    ],
    "source": ""
  },
  {
    "id": 5113,
    "question": "Samantha wants to log all sudo activity under individual user accounts. What first step should she take to ensure that she captures privileged use like this?",
    "choice_a": "Prevent the use of sudo su -",
    "choice_b": "Add all users to the sudoers file.",
    "choice_c": "Remove all users from the sudoers .",
    "choice_d": "Disable sudo .",
    "correct_answer": "A",
    "explanation": "Ensure that users cannot bypass logging by switching to the root user using sudo su -. Instead, users who need the ability to perform privileged actions should be added to the sudoers list and then logged as themselves performing the actions. Adding all users is likely an overly broad action, whereas removing all users would not allow individual logging under their accounts, nor would they have rights to take administrative actions. Disabling sudo doesn't allow administrative tasks except as root, which defeats this requirement as well.",
    "topic_id": 5,
    "practice_test_id": null,
    "related_articles": [
      1073,
      752,
      753,
      751,
      927
    ],
    "source": ""
  },
  {
    "id": 5114,
    "question": "During a wireless network penetration test, Susan runs aircrack-ng against the network intending to capture a password as part of the four-way handshake and then crack the password offline. What might cause her to fail in her password-cracking efforts if the target is using WPA3\u00a0in Personal network mode?",
    "choice_a": "WPA3 uses complex passwords.",
    "choice_b": "WPA3 uses SAE and does not transfer the password over the air.",
    "choice_c": "WPA3 requires multifactor, making a password alone insufficient.",
    "choice_d": "The password crack will work due to flaws in WPA3.",
    "correct_answer": "B",
    "explanation": "WPA3 uses SAE, or simultaneous authentication of equals, and does not send the password over the air. Traditional cracking methods used against previous versions of WPA and WPA2 no longer work. This is not because of complex passwords or MFA, but because of how the handshake's elements are created to avoid sending the password.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 5115,
    "question": "Kara wants to conduct a security audit of her cloud IaaS vendor's systems, infrastructure, and practices. What type of audit is she most likely to be able to conduct?",
    "choice_a": "A third-party audit.",
    "choice_b": "She cannot conduct an audit.",
    "choice_c": "An internal audit.",
    "choice_d": "She may request the vendor's third-party audit results.",
    "correct_answer": "D",
    "explanation": "Most IaaS vendors will not allow customers to conduct an audit of their systems and infrastructure. Kara is likely to be able to obtain third-party audit reports from her vendor, and the major IaaS vendors typically either make these available publicly or to paying or prospective customers. An internal audit will not assess the underlying infrastructure and services, only those that the organization uses.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      793,
      766,
      1006,
      1076,
      795
    ],
    "source": ""
  },
  {
    "id": 5116,
    "question": "Michelle wants to assess her organization's disaster recovery readiness. What type of test could she run to most effectively assess readiness without the potential for disruption?",
    "choice_a": "Conduct a tabletop exercise.",
    "choice_b": "Conduct a failover test.",
    "choice_c": "Conduct a simulation.",
    "choice_d": "Conduct a plan review.",
    "correct_answer": "C",
    "explanation": "Simulations are the most complete test that can be conducted without the risk that a full failover test creates. Michelle should conduct a simulation to validate as much of her organization's plan as possible. Tabletop exercises and plan reviews provide less complete coverage.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      792,
      791,
      500,
      790,
      501
    ],
    "source": ""
  },
  {
    "id": 5117,
    "question": "Lucca wants to conduct an audit of a hybrid cloud environment. What potential challenge should he identify for his management team?",
    "choice_a": "On-premises audits are difficult to complete.",
    "choice_b": "Hybrid audits cannot be conducted by third parties.",
    "choice_c": "Underlying cloud infrastructure may not be auditable.",
    "choice_d": "There are no differences between hybrid and cloud audits.",
    "correct_answer": "C",
    "explanation": "Hybrid environment audits involve the complexity of both cloud and on-premises audits. That means that the underlying cloud infrastructure may not be auditable, although Lucca's organization's use and configuration of the cloud will be. On-premises audits are not any more challenging to complete than other audits, hybrid audits can be conducted by third parties, and hybrid audits include both on-premises and cloud auditing challenges and requirements as they are not the same as a cloud-only audit.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      1075,
      1077,
      1076,
      1006,
      1007
    ],
    "source": ""
  },
  {
    "id": 5118,
    "question": "Brian has discovered a vulnerability in a website and has notified the company that owns the website about the issue. What has he done?",
    "choice_a": "A penetration test",
    "choice_b": "Ethical disclosure",
    "choice_c": "A web application test",
    "choice_d": "OSINT",
    "correct_answer": "B",
    "explanation": "Notifying third parties of security issues and vulnerabilities in a confidential manner to allow them to address the issues is considered ethical disclosure. There is not enough information in the question to determine how it was found, and disclosure is not necessarily part of either penetration tests or application tests. How the information as found is not listed, so OSINT is not a useful answer either.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      497,
      501,
      502,
      499,
      864
    ],
    "source": ""
  },
  {
    "id": 5119,
    "question": "What action might a pen tester perform to identify potential exploitable services to gain an initial foothold in a network?",
    "choice_a": "Data gathering",
    "choice_b": "Port scanning",
    "choice_c": "Getting permission",
    "choice_d": "Planning",
    "correct_answer": "B",
    "explanation": "Port scanning is the first step toward identifying potentially exploitable services. Data gathering is used to acquire information to prepare for port scanning and other activities. Permission and planning are not used to identify exploitable services but are critical to the overall process.",
    "topic_id": 6,
    "practice_test_id": null,
    "related_articles": [
      787,
      763,
      764,
      765,
      788
    ],
    "source": ""
  },
  {
    "id": 5120,
    "question": "Which of the following topics is least likely to be included in a company's user security training and awareness program?",
    "choice_a": "Insider threat",
    "choice_b": "Social media impact",
    "choice_c": "2FA fatigue",
    "choice_d": "Secure router configuration guidelines",
    "correct_answer": "D",
    "explanation": "Secure router configuration guidelines are typically more technical and specific to IT professionals, making them less likely to be included in a general security training and awareness program. These programs usually focus on broader and more universally applicable topics like insider threats, which address risks from employees or contractors; social media impact, which covers the risks of sharing information online; and 2FA fatigue, which relates to the weariness or complacency in using two-factor authentication. These are relevant to a wider audience and are crucial for overall organizational security awareness. In contrast, the specifics of router configuration are usually handled by specialized IT staff.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      511,
      611,
      550,
      510,
      516
    ],
    "source": ""
  },
  {
    "id": 5121,
    "question": "Anne wants to gather information about security settings as well as build an overall view of her organization's assets by gathering data about a group of Windows 11 workstations spread throughout her company. <br>What Windows tool is best suited to this type of configuration management task?",
    "choice_a": "ConfigMgr",
    "choice_b": "Group Policy",
    "choice_c": "SCOM",
    "choice_d": "A custom PowerShell script",
    "correct_answer": "A",
    "explanation": "Microsoft Configuration Manager (ConfigMgr) provides this capability and is designed to allow administrators to evaluate the configuration status of Windows workstations and servers, as well as providing asset management data. System Center Operations Manager (SCOM) is primarily used to monitor for health and performance. Group Policy can be used for a variety of tasks including deploying settings and software, and custom PowerShell scripts could do this but should not be required for a configuration check.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      534,
      797,
      523,
      524,
      513
    ],
    "source": ""
  },
  {
    "id": 5122,
    "question": "Chas is a cybersecurity manager who is concerned that the cloud provider his organization relies upon for disaster recovery may not be able to meet their needs in the event that a disaster strikes multiple customers simultaneously. What type of agreement should Chas enter into with this provider?",
    "choice_a": "Nondisclosure agreement",
    "choice_b": "Resource capacity agreement",
    "choice_c": "Mutual assistance agreement",
    "choice_d": "Business partnership agreement",
    "correct_answer": "B",
    "explanation": "A resource capacity agreement is the most appropriate for Chas's concern, as it specifically addresses the availability of resources in a disaster scenario. This type of agreement ensures that the cloud provider has sufficient resources to meet the needs of their clients, even in the event of multiple simultaneous disasters. It directly tackles the issue of resource allocation and availability, which is Chas's primary concern. In contrast, a nondisclosure agreement is more about confidentiality and doesn't address resource capacity. A mutual assistance agreement typically involves agreements between organizations for support during emergencies but doesn't guarantee specific resource availability. A business partnership agreement is broader and may not specifically cover the detailed aspects of resource availability in disaster scenarios.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      507,
      575,
      521,
      583,
      586
    ],
    "source": ""
  },
  {
    "id": 5123,
    "question": "Rob is conducting a forensic investigation and is looking for elements of trace digital evidence. Which one of the following principles applies most closely to his work?",
    "choice_a": "Kerckhoff's principle",
    "choice_b": "Principle of least privilege",
    "choice_c": "Defense-in-depth principle",
    "choice_d": "Locard's principle",
    "correct_answer": "D",
    "explanation": "Locard's principle is most relevant to Rob's forensic investigation for trace digital evidence, as it suggests that any contact between two objects results in an exchange of materials. In the context of digital forensics, this principle implies that there is always some form of digital trace or residue left behind when devices interact or when data is transferred. <br>Kerckhoff's principle states that a system's security should not depend on the secrecy of its algorithm but rather on the secrecy of its keys. The principle of least privilege is a security concept in which a user is given the minimum levels of access\u2014or permissions\u2014needed to perform his job functions. Lastly, the defense-in-depth principle is a layered security approach that establishes multiple levels of defense to protect information. While these other three principles are important in cybersecurity, they do not directly relate to the collection and analysis of digital trace evidence like Locard's principle does.",
    "topic_id": 7,
    "practice_test_id": null,
    "related_articles": [
      604,
      603,
      602,
      606,
      605
    ],
    "source": ""
  },
  {
    "id": 5124,
    "question": "Which of the following configurations within the Scaled Agile Framework (SAFe) is specifically designed to support enterprises in building and maintaining large integrated solutions with the collaboration of hundreds of practitioners?",
    "choice_a": "Large Solution SAFe",
    "choice_b": "Portfolio SAFe",
    "choice_c": "Essential SAFe",
    "choice_d": "Full SAFe",
    "correct_answer": "D",
    "explanation": "Full SAFe is designed to support enterprises in building and maintaining large integrated solutions with the collaboration of hundreds of practitioners. It provides the most extensive level of guidance, with roles, responsibilities, and activities needed to sustainably deliver complex solutions. Essential SAFe focuses on the basic elements of the framework needed to be agile, Large Solution SAFe is for developing large and complex solutions that do not require the constructs of the portfolio level, and Portfolio SAFe is for aligning enterprise strategy with execution but does not address the complexity of building large solutions that Full SAFe is designed for.",
    "topic_id": 8,
    "practice_test_id": null,
    "related_articles": [
      625,
      622,
      623,
      834,
      833
    ],
    "source": ""
  },
  {
    "id": 5125,
    "question": "Shahla's organization handles personally identifiable information as part of its routine business. The organization currently operates only in the United States but is considering an expansion into Canada. What new law is most likely to affect the organization if they undertake this expansion?",
    "choice_a": "PIPL",
    "choice_b": "POPIA",
    "choice_c": "PIPEDA",
    "choice_d": "CCPA",
    "correct_answer": "C",
    "explanation": "If Shahla's organization expands into Canada and handles personally identifiable information as part of its routine business, the most likely new law to affect the organization would be the Personal Information Protection and Electronic Documents Act (PIPEDA). This Canadian federal privacy law governs the collection, use, and disclosure of personal information in the course of commercial business.<br> PIPL is China's Personal Information Protection Law, POPIA is South Africa's Protection of Personal Information Act, and the CCPA is the California Consumer Privacy Act. Each of these laws governs the handling of personal information within their respective jurisdictions, but would not be the primary concern for a U.S. organization considering expansion into Canada.",
    "topic_id": 1,
    "practice_test_id": 1,
    "related_articles": [
      109,
      118,
      108,
      114,
      105
    ],
    "source": ""
  },
  {
    "id": 5126,
    "question": "Ade is part of a penetration testing exercise. As part of the process his role is to act as a defender. What color is frequently used to describe defenders in penetration testing exercises?",
    "choice_a": "Red teams",
    "choice_b": "Yellow teams",
    "choice_c": "Green teams",
    "choice_d": "Blue teams",
    "correct_answer": "D",
    "explanation": "Blue teams are defenders, red teams are attackers, and purple teams combine both attack and defense activities. Yellow and green teams are not commonly described as part of penetration testing.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      1080,
      1078,
      1079,
      771,
      495
    ],
    "source": ""
  },
  {
    "id": 5127,
    "question": "Sharif's U.S.-based company wants to build a data center with AI-focused GPU-based computation nodes in China. What concern about regulations should Sharif express about the hardware needed?",
    "choice_a": "AI hardware may not be legal in China.",
    "choice_b": "The total dollar value of the hardware may exceed what can be shipped to China.",
    "choice_c": "Export controls may limit what hardware can be imported to China.",
    "choice_d": "There may be ethical issues with the use of AI hardware across international borders.",
    "correct_answer": "C",
    "explanation": "Hardware and software can be subject to import and export controls. In the case of AI computation hardware, there are specific limits on what can be exported to China, including limits on performance. Sharif needs to engage the appropriate experts to determine what can and cannot be exported. AI hardware is legal in China, dollar values are not typically the limiting factor for hardware import/export restrictions, and ethics are not a regulatory issue.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      111,
      28,
      99,
      103,
      1
    ],
    "source": ""
  },
  {
    "id": 5128,
    "question": "Brian's organization has a remote facility that it could move operations to in an emergency. While the facility has basic utilities, no additional work has been done to prepare it for datacenter operations. What type of site is this?",
    "choice_a": "A hot site",
    "choice_b": "A warm site",
    "choice_c": "A cold site",
    "choice_d": "A frozen site",
    "correct_answer": "C",
    "explanation": "Cold sites are facilities large enough to use for recovery operations with appropriate power and environmental capabilities but without any additional readiness work done for computing, connectivity, or other needs. Warm sites have equipment and connectivity in place but are not actively handling live data. Hot sites have live data and could take over operations immediately. Frozen site is not a term used to describe a failover or recovery site.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      582,
      598,
      573,
      592,
      594
    ],
    "source": ""
  },
  {
    "id": 5129,
    "question": "Michele's company operates a private cloud inside of an environment provided by their IaaS service provider. What term describes these isolated pools of resources that organizations can configure to serve their purposes?",
    "choice_a": "A VLAN",
    "choice_b": "A VPC",
    "choice_c": "An SDN",
    "choice_d": "A CDN",
    "correct_answer": "B",
    "explanation": "Virtual private clouds (VPCs) run on cloud-hosted infrastructure providing a secure, isolated pool of resources to be used by organizations to meet their needs. A VLAN is a virtual local area network. While VLANs are part of how most VPCs work, they alone aren't sufficient to create a VPC. An SDN, or software defined network, is used to manage networks through code, and CDNs are content delivery networks used to provide access to content around the globe that helps offload traffic while protecting against denial-of-service (DoS) attacks and other issues.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      355,
      419,
      357,
      430,
      411
    ],
    "source": ""
  },
  {
    "id": 5130,
    "question": "Jill wants to use a breach attack system to test her organization's security. Which of the following is not typically part of a BAS solution's portfolio of testing platforms?",
    "choice_a": "User-owned mobile devices",
    "choice_b": "Software agents",
    "choice_c": "Software-as-a-service platforms",
    "choice_d": "Virtual machines",
    "correct_answer": "A",
    "explanation": "Breach-and-attack simulation (BAS) tools typically leverage SaaS platforms as well as software agents and virtual machines to perform simulated attacks, which they leverage to provide detailed reports about security issues and their relative risk levels.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      501,
      776,
      789,
      494,
      496
    ],
    "source": ""
  },
  {
    "id": 5131,
    "question": "CAPEC, STIX, and TAXII are all used for what purpose?",
    "choice_a": "Federated authentication",
    "choice_b": "Vulnerability scanning",
    "choice_c": "Threat intelligence feeds",
    "choice_d": "Risk assessment and relative ranking",
    "correct_answer": "C",
    "explanation": "CAPEC, or Common Attack Pattern Enumeration and Classification, is a dictionary of known attack patterns. STIX is the Structured Threat Information eXpression language used to describe threats in a standardized way, and TAXII, the Trusted Automated eXchange of Indicator Information, defines how threat information can be shared and exchanged. All of these are examples of threat intelligence feed standards.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      564,
      563,
      531,
      561,
      538
    ],
    "source": ""
  },
  {
    "id": 5132,
    "question": "Which group is best suited to evaluate an organization's administrative controls and provide credible reports to a third party?",
    "choice_a": "Internal auditors",
    "choice_b": "Penetration testers",
    "choice_c": "External auditors",
    "choice_d": "Employees who design, implement, and monitor the controls",
    "correct_answer": "C",
    "explanation": "External auditors can provide an unbiased and impartial view of an organization's controls to third parties. Internal auditors are useful when reporting to senior management of the organization but are typically not asked to report to third parties. Penetration tests test technical controls but are not as well suited to testing many administrative controls. The employees who build and maintain controls are more likely to bring a bias to the testing of those controls and should not be asked to report on them to third parties.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      1007,
      862,
      795,
      793,
      499
    ],
    "source": ""
  },
  {
    "id": 5133,
    "question": "Gurvinder wants to test a potentially malicious file while observing what it does when executed. What type of tool should he identify to allow him to do this?",
    "choice_a": "A SIEM",
    "choice_b": "A SOAR",
    "choice_c": "A SAST tool",
    "choice_d": "A sandboxing tool",
    "correct_answer": "D",
    "explanation": "Sandboxing tools allow defenders to execute potentially malicious software in an isolated environment that provides instrumentation to capture all actions and changes performed when it is run. SIEM, or security information and event management, tools and SOAR, or security orchestration, automation, and response, tools are used to monitor environments and to respond to incidents but do not provide the ability to test and observe malicious software. SAST, or Static Application Security Testing, tools analyze source code to identify security issues.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [
      568,
      550,
      557,
      561,
      564
    ],
    "source": ""
  },
  {
    "id": 5134,
    "question": "Sharon wants to help her company's developers understand the risks of API calls that allow over-consumption of resources like CPU, memory, or network bandwidth. What is the primary risk created by unconstrained API calls in this scenario?",
    "choice_a": "Inability to attribute actions to an account",
    "choice_b": "Denial of service",
    "choice_c": "Malicious access to files",
    "choice_d": "The potential for request forgery attacks",
    "correct_answer": "B",
    "explanation": "Unconstrained API calls can lead to denial-of-service conditions, one of the top 10 API security risks identified by OWASP in 2023. Attributing actions to an account requires proper authentication and logging, which are not tied to resource over-consumption. Malicious file access is typically due to improperly configured security, and request forgery attacks typically occur when user-supplied URIs are not validated.",
    "topic_id": 8,
    "practice_test_id": 2,
    "related_articles": [
      803,
      804,
      627,
      893,
      802
    ],
    "source": ""
  },
  {
    "id": 5135,
    "question": "What type of authenticator generates dynamic passwords using time- or algorithm-based methods?",
    "choice_a": "A biometric scanner",
    "choice_b": "A smart card",
    "choice_c": "A token",
    "choice_d": "A CAC",
    "correct_answer": "C",
    "explanation": "Tokens are hardware devices (something you have) that generate a one-time password (OTP) based on time or an algorithm. They are typically combined with another factor like a password to authenticate users. CAC and PIV cards are U.S. government\u2013issued smartcards.",
    "topic_id": 5,
    "practice_test_id": 2,
    "related_articles": [
      444,
      443,
      745,
      489,
      492
    ],
    "source": ""
  },
  {
    "id": 5136,
    "question": "Dawson is preparing to hire a new staff member for a role that requires very high levels of integrity and trust. Which of the following is most commonly used as part of the hiring process to determine if an employee is likely to be trustworthy?",
    "choice_a": "Signing an NDA",
    "choice_b": "A background check",
    "choice_c": "Signing a noncompete",
    "choice_d": "A COA",
    "correct_answer": "B",
    "explanation": "Background checks are frequently performed to identify potential issues before hiring a new employee. They can identify a variety of concerns and are commonly used across many industries. Nondisclosure agreements (NDAs) are used during and after employment to protect confidential information. Noncompetes are used to prevent employees from working in a similar industry for a given period of time after departure. COA, or certificate of authenticity, is not used in employment situations.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      34,
      677,
      68,
      35,
      39
    ],
    "source": ""
  },
  {
    "id": 5137,
    "question": "Ben's organization has purchased cybersecurity insurance. What type of risk treatment has the organization engaged in?",
    "choice_a": "Acceptance",
    "choice_b": "Avoidance",
    "choice_c": "Mitigation",
    "choice_d": "Transfer",
    "correct_answer": "D",
    "explanation": "Insurance is a form of risk transfer. Organizations pay insurers premiums, transferring the risk to them in exchange for the payment. Insurers may mitigate their risk through the terms of the insurance policy and may also insure themselves. Acceptance simply means acknowledging the risk, avoidance would require means to prevent the risk from occurring, and mitigation attempts to reduce the impact of the risk if it occurs.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      46,
      52,
      70,
      41,
      45
    ],
    "source": ""
  },
  {
    "id": 5138,
    "question": "Brad wants to engage third-party auditors to assess a vendor that his company will be signing a contract with. If Brad wants to assess the vendor's security policies and controls as well as the effectiveness of those controls as implemented over time, what SOC level and type should he request the auditors perform?",
    "choice_a": "A SOC 1, Type 2",
    "choice_b": "A SOC 2, Type 1",
    "choice_c": "A SOC 1, Type 1",
    "choice_d": "A SOC 2, Type 2",
    "correct_answer": "D",
    "explanation": "A SOC 2 assessment looks at controls that affect security, and a Type 2 report validates the operating effectiveness of the controls. SOC 1 engagement assesses controls that might impact financial reporting, and a Type 1 report provides the auditors opinions of the descriptions of controls provided by management at a single point in time\u2014not the actual implementations of the controls.",
    "topic_id": 7,
    "practice_test_id": 2,
    "related_articles": [],
    "source": ""
  },
  {
    "id": 5139,
    "question": "Amanda's company has been looking for ways to reduce their costs for network switches and routers and has started to acquire devices from the gray market. Which of the following is not a typical concern for gray-market devices?",
    "choice_a": "API vulnerabilities",
    "choice_b": "Product tampering",
    "choice_c": "Implants",
    "choice_d": "Counterfeits",
    "correct_answer": "A",
    "explanation": "Product tampering, implants of software or hardware, and counterfeits are all common concerns for gray-market hardware. API vulnerabilities are a concern based on vendor software and may exist and require patching whether a device is purchased through an OEM or the gray market.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      864,
      768,
      795,
      863,
      862
    ],
    "source": ""
  },
  {
    "id": 5140,
    "question": "Andre has implemented virtual routing and forwarding (VRF) on his router. Which of the following descriptions best explains what this allows him to do?",
    "choice_a": "VRF is used to support VPCs.",
    "choice_b": "VRF is like a VPN at layer 3.",
    "choice_c": "VRF is like a VLAN at layer 3.",
    "choice_d": "VRF is used to support multilayer protocols.",
    "correct_answer": "C",
    "explanation": "Virtual routing and forwarding (VRF) allows multiple routing tables to be used on the same device simultaneously. This is similar to the concept of VLANs on a layer 2 switch but operating at layer 3. Routing instances operate independently, allowing IP addresses to overlap without conflict, supporting segmentation and thus permitting flexibility for zero trust implementations and other security solutions. VRF can be used to support VPCs, but that is not its only use. It is not like a VPN, and while it can be used with multilayer protocols, that isn't a primary purpose.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      331,
      419,
      378,
      345,
      356
    ],
    "source": ""
  },
  {
    "id": 5141,
    "question": "Grace uses her cloud service provider's function-as-a-service (FaaS) environment to deploy her organization's new application. What term should she use to describe this to her organization's leadership?",
    "choice_a": "ICS",
    "choice_b": "A VPC",
    "choice_c": "Embedded",
    "choice_d": "Serverless",
    "correct_answer": "D",
    "explanation": "Function-as-a-service deployments are an example of a serverless deployment running on the cloud provider's cloud environment. Serverless computing solutions like AWS Lambda, Microsoft Azure Functions, and Google Cloud functions require less overhead when applications are designed from the ground up to leverage function as a service technology. ICS is an industrial control system used to manage systems and processes such as utilities or factories. VPCs are virtual private clouds where infrastructure is provisioned and used like a virtual data center, and embedded systems are built into other devices.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      265,
      269,
      256,
      226,
      261
    ],
    "source": ""
  },
  {
    "id": 5142,
    "question": "Sameer's company has begun to deploy computation and storage capabilities to their industrial plants to gather and process data where it is created. What term best describes this type of deployment?",
    "choice_a": "Cloud computing",
    "choice_b": "Edge computing",
    "choice_c": "Hybrid cloud",
    "choice_d": "Microservices",
    "correct_answer": "B",
    "explanation": "Edge computing is a technology that involves placing infrastructure closer to the point of use. This approach offers several benefits such as reduced latency, improved performance for local processing, and reduced traffic to remote data centers or the cloud. On the other hand, cloud computing is typically provided at a remote facility, is scalable and frequently multitenant. Hybrid cloud is a combination of local and remote clouds. Finally, microservices utilize loosely coupled services that communicate via lightweight protocols to accomplish specific tasks that are then combined to achieve overall goals.",
    "topic_id": 3,
    "practice_test_id": 2,
    "related_articles": [
      259,
      256,
      269,
      254,
      191
    ],
    "source": ""
  },
  {
    "id": 5143,
    "question": "Sharif wants to improve his organization's security awareness. He implements a process that gives points for identifying phishing emails and rewards departments based on their point scores. What awareness technique is he using?",
    "choice_a": "Security champions",
    "choice_b": "Gamification",
    "choice_c": "Social engineering",
    "choice_d": "Awareness training",
    "correct_answer": "B",
    "explanation": "Sharif is using gamification, the process of making awareness efforts like a game to motivate users. Security champions are staff members who are selected or volunteer to advocate for and raise security awareness in their teams and divisions. Social engineering efforts leverage human behaviors, and awareness training is training intended to raise awareness of security risks, issues, and attacker techniques.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      66,
      65,
      71,
      40,
      1
    ],
    "source": ""
  },
  {
    "id": 5144,
    "question": "Colin's organization has decommissioned multifunction photocopier/printer devices used throughout its administrative headquarters. What concern would be most likely to drive physical destruction of the device rather than allowing them to be sold as surplus?",
    "choice_a": "Data remanence",
    "choice_b": "Asset inventory",
    "choice_c": "Asset management",
    "choice_d": "Compliance",
    "correct_answer": "A",
    "explanation": "Data remanence is a concern due to the storage devices often found in multifunction photocopier/printer devices, particularly for devices used in an administrative headquarters. While compliance may be a concern, we don't know enough about Colin's organization to know if compliance concerns would require this. Asset management and asset inventory can both handle either destruction or sale for most organizations.",
    "topic_id": 2,
    "practice_test_id": 2,
    "related_articles": [
      130,
      1024,
      129,
      1026,
      144
    ],
    "source": ""
  },
  {
    "id": 5145,
    "question": "Henry's organization wants to meet federal security standards for the cloud services it provides. What program should he investigate to meet this goal?",
    "choice_a": "COBIT",
    "choice_b": "SABSA",
    "choice_c": "FedRAMP",
    "choice_d": "PCI",
    "correct_answer": "C",
    "explanation": "FedRAMP is a U.S. government compliance program that standardizes how cloud services are assessed, monitored, and handle authorization. There is a FedRAMP marketplace for service providers and services that have been authorized by FedRAMP. COBIT is an IT management and governance framework, SABSA is a risk-based enterprise information security model, and PCI is a security standard created by and used by the payment card industry.",
    "topic_id": 1,
    "practice_test_id": 2,
    "related_articles": [
      19,
      18,
      102,
      12,
      116
    ],
    "source": ""
  },
  {
    "id": 5146,
    "question": "Which of the following terms best describes the IP address 10.14.124.240?",
    "choice_a": "Public IP address",
    "choice_b": "Private IP address",
    "choice_c": "APIPA address",
    "choice_d": "Loopback address",
    "correct_answer": "B",
    "explanation": "Any 10.x.x.x address is a private address as defined by RFC 1918. APIPA addresses are self-assigned by Windows when they cannot contact a DHCP server. 127.0.0.1 is a loopback address that systems use to connect with themselves. Public IP addresses compose the majority of IP addresses with the exception of reserved addresses like those described in RFC 1918.",
    "topic_id": 4,
    "practice_test_id": 2,
    "related_articles": [
      425,
      949,
      423,
      895,
      348
    ],
    "source": ""
  },
  {
    "id": 5147,
    "question": "Jim is performing a security assessment of his company and would like to use a testing tool to perform a web vulnerability scan. Which of the following tools is best suited for identifying this form of vulnerability?",
    "choice_a": "Nmap",
    "choice_b": "Hydra",
    "choice_c": "Metasploit",
    "choice_d": "Nikto",
    "correct_answer": "D",
    "explanation": "Nikto is a web application and server scanning tool and is best suited to Jim's needs. Nmap is a port scanner, Hydra is a login cracking tool, and Metasploit is a complete penetration testing framework but isn't designed specifically to test web applications and servers.",
    "topic_id": 6,
    "practice_test_id": 2,
    "related_articles": [
      787,
      776,
      775,
      789,
      860
    ],
    "source": ""
  },
  {
    "id": 5148,
    "question": "Kayla recently took a position at a new start-up company that runs entirely in the cloud. The company leverages a major IaaS provider for hosting its web services and a SaaS email system. Both of these providers operate multitenant environments. What term best describes the type of cloud environment this organization uses?",
    "choice_a": "Public cloud",
    "choice_b": "Dedicated cloud",
    "choice_c": "Private cloud",
    "choice_d": "Hybrid cloud",
    "correct_answer": "A",
    "explanation": "The term that best describes the type of cloud environment used by Kayla's company, which leverages a major IaaS provider for hosting its web services and a SaaS email system operating in multitenant environments, is a public cloud. A public cloud is where the services are delivered over the public Internet and shared across different organizations. A dedicated cloud, also known as a private cloud, is operated solely for one organization, and this is not the case for Kayla's company. A private cloud is infrastructure operated solely for a single organization, whether managed internally or by a third-party, and hosted either internally or externally, which also does not apply here. A hybrid cloud is a composition of two or more cloud delivery models (private, community, or public) that remain distinct entities but are bound together, offering the benefits of multiple deployment models, which again does not match the company's use of exclusively public cloud services.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      19,
      116,
      90,
      1049,
      107
    ],
    "source": ""
  },
  {
    "id": 5149,
    "question": "Jen's firm received a new contract to develop information systems for use by a U.S. federal government agency. She is concerned about identifying any required security controls that must be in place. Which one of the following standards describes controls mandatory for use on U.S. government systems?",
    "choice_a": "PCI DSS",
    "choice_b": "ISO 27001",
    "choice_c": "SABSA",
    "choice_d": "NIST 800-53",
    "correct_answer": "D",
    "explanation": "NIST 800-53 is the standard that describes the security controls mandatory for use on U.S. federal government systems. It provides a catalog of security and privacy controls for all U.S. federal information systems except those related to national security. PCI DSS is a proprietary information security standard for organizations that handle payment cards and is not specific to government systems. ISO 27001 is an international standard on how to manage information security and is not specific to U.S. federal systems. SABSA is a framework and methodology for enterprise security architecture and service management, again not specific to the mandatory controls required by U.S. government systems.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      102,
      19,
      47,
      11,
      99
    ],
    "source": ""
  },
  {
    "id": 5150,
    "question": "Rob believes that an individual he met on an online forum used unapproved resources to cheat on the CISSP\u00ae exam. He has evidence to back up his claim. Which one of the following statements is most correct?",
    "choice_a": "Rob may report this situation to ISC2 as a violation of the Code of Ethics.",
    "choice_b": "Rob does not have standing to report this situation to ISC2 unless he is an employer of the individual in question.",
    "choice_c": "Rob does not have standing to report this situation to ISC2 unless he holds a professional license or certification that includes a code of ethics.",
    "choice_d": "Rob does not have standing to report this situation to ISC2 unless he is a member of ISC2 or holds an ISC2 certification.",
    "correct_answer": "A",
    "explanation": "Whether Rob has standing to report this situation to ISC2 depends upon the canon(s) violated by the activity. This behavior violates canon II, \"Act honorably, honestly, justly, responsibly, and legally.\" Any member of the public may file a claim under canons I or II. Only an employer or someone with a contracting relationship with the individual may file a complaint under canon III. Anyone who is certified or licensed as a professional and subscribes to a code of ethics as part of that licensure or certification is eligible to file a canon IV complaint.",
    "topic_id": 1,
    "practice_test_id": 3,
    "related_articles": [
      955,
      957,
      956,
      17,
      11
    ],
    "source": ""
  },
  {
    "id": 5151,
    "question": "Mikayla's organization has been notified about an authentication bypass vulnerability in their product by a security researcher. The researcher has stated that they will share details about the vulnerability in question within the next 90\u00a0days if Mikayla's company fails to remediate it. However, they are also willing to collaborate with the company to help them understand the issue and provide them with full details on how to re-create the problem. What process has the researcher followed?",
    "choice_a": "A CVE creation process",
    "choice_b": "A bug bounty",
    "choice_c": "Ethical disclosure",
    "choice_d": "Blackmail",
    "correct_answer": "C",
    "explanation": "Ethical disclosure involves informing organizations of flaws and issues. Unlike bug bounties, this does not rely on organizations providing financial or other rewards. Ethical disclosure may involve timeframes to ensure that companies do not ignore issues, but a focus on collaboration and public safety is common. CVEs are created when flaws are reported to the CVE program. There is no blackmail behavior involved in this description.",
    "topic_id": 6,
    "practice_test_id": 4,
    "related_articles": [
      497,
      861,
      502,
      501,
      793
    ],
    "source": ""
  },
  {
    "id": 5152,
    "question": "Carlos' team has detected a compromise and initiated the incident response process. What\u00a0will happen next?",
    "choice_a": "Remediation",
    "choice_b": "Mitigation",
    "choice_c": "Reporting",
    "choice_d": "Lessons learned",
    "correct_answer": "B",
    "explanation": "A typical incident response (IR) process will begin mitigation efforts after response has started and then will move into the recovery, reporting, and lessons learned phases. It is important to remember that while the IR cycle is drawn as a cycle, it often moves back and forth between phases as new issues or details are identified.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      537,
      539,
      565,
      540,
      595
    ],
    "source": ""
  },
  {
    "id": 5153,
    "question": "Marco wants to deploy a network security device that can detect and stop network-based attacks without additional external intervention. What type of device should he employ and in what configuration?",
    "choice_a": "An inline IDS",
    "choice_b": "An IDS connected through a network tap",
    "choice_c": "An inline IPS",
    "choice_d": "An IPS connected through a network tap",
    "correct_answer": "C",
    "explanation": "While both an intrusion detection system (IDS) and an intrusion prevention system (IPS) can detect attacks, only an IPS can stop attacks. This requires the IPS to be placed inline. A connection via a network tap, span port, or other similar tool for replicating network traffic will not allow defensive actions to be taken directly by the device.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      548,
      566,
      547,
      538,
      543
    ],
    "source": ""
  },
  {
    "id": 5154,
    "question": "Jake is updating his disaster recovery plan and wants to ensure that the third-party data center his organization contracts with can handle the scaling requirements needed in a disaster. What type of agreement should Jake sign with the hosting provider?",
    "choice_a": "A resource capacity agreement",
    "choice_b": "A cold-site agreement",
    "choice_c": "An NDA",
    "choice_d": "A business continuity agreement",
    "correct_answer": "A",
    "explanation": "Resource capacity agreements are used to ensure that appropriate resources will be available in a recovery scenario. Cold sites have only space and utilities and don't provide full recovery resources. Nondisclosure agreements protect information and won't ensure resource availability, and business continuity agreements are not a term used in the CISSP exam.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      598,
      583,
      521,
      915,
      588
    ],
    "source": ""
  },
  {
    "id": 5155,
    "question": "Diana's organization teaches employees to use a pre-arranged code if they are kidnapped or under threat and contact the organization. What type of solution is this?",
    "choice_a": "A duress code",
    "choice_b": "A panic button",
    "choice_c": "A kidnap code",
    "choice_d": "A threat code",
    "correct_answer": "A",
    "explanation": "Duress codes are pre-arranged codes used to indicate that the staff member is under duress. They are typically designed to be easy to communicate during normal conversation without alarming whomever may be listening in. Panic buttons are physical buttons used to summon emergency services or responders. Kidnap codes and threat codes were made up for this question.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      509,
      508,
      510,
      511,
      542
    ],
    "source": ""
  },
  {
    "id": 5156,
    "question": "Ben's team has been tasked with ensuring that devices that leave his organization do not contain organizational data. They have wiped and re-formatted drives in systems that are being sent to a third-party electronics recycler as part of the process, but a journalist recently reported that organization entrusted to Ben's company was recovered from drives bought from the recycler. What issue is Ben's team encountering, and what solution should they select to prevent it most effectively?",
    "choice_a": "Data permanence, process certification",
    "choice_b": "Data remanence, drive destruction",
    "choice_c": "Data permanence, using a degausser",
    "choice_d": "Data remanence, zero fill",
    "correct_answer": "B",
    "explanation": "Data remanence describes data that is still on media after an attempt has been made to remove it. Destroying the drive is a way to ensure that no data is recoverable. Data permanence describes how long data lasts and is not used in the context of data remaining on devices.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      518,
      517,
      520,
      515,
      512
    ],
    "source": ""
  },
  {
    "id": 5157,
    "question": "Manesh wants to help his organization build secure software. Which of the following is not a common security best practice for working with security frameworks and libraries?",
    "choice_a": "Use internally developed libraries and frameworks whenever possible to reduce third-party threats.",
    "choice_b": "Identify and inventory all third-party libraries.",
    "choice_c": "Encapsulate libraries to prevent the use of functions that are not needed.",
    "choice_d": "Update libraries and components on a regular basis.",
    "correct_answer": "A",
    "explanation": "OWASP recommends four critical best practices for libraries and frameworks: using libraries and frameworks from trusted sources that are broadly used and well maintained, maintaining an inventory of third-party libraries, updating libraries and components proactively, and reducing attack surface by limiting what functions can be used. Building your own frameworks and libraries is more likely to result in vulnerabilities for most organizations than using well-maintained and supported existing options.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      670,
      618,
      816,
      662,
      620
    ],
    "source": ""
  },
  {
    "id": 5158,
    "question": "Beth's company uses cloud-based infrastructure that uses a combination of policies and automated security controls to ensure security. The company deploys firewalls, endpoint security tools, and management capabilities to ensure that every virtual system is protected as it is brought online. What term describes this type of implementation?",
    "choice_a": "Root of trust",
    "choice_b": "Software-defined security",
    "choice_c": "A policy engine",
    "choice_d": "Software-defined networks",
    "correct_answer": "B",
    "explanation": "Software-defined security (SDS) is an increasingly common approach to security that involves using software solutions and policies to secure environments, rather than traditional hardware-based approaches. This strategy allows for flexible and dynamic security configurations, particularly suited to the cloud's scalable nature. While a root of trust provides a foundational security element in cryptographic systems, policy engines contribute to decision-making in SDS and other frameworks by enforcing security policies. Software-defined networks focus on network management through software, showcasing the broader move toward software-defined approaches in IT infrastructure.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      522,
      797,
      524,
      544,
      543
    ],
    "source": ""
  },
  {
    "id": 5159,
    "question": "Ian wants to ensure that his organization is using appropriate secure coding techniques. Which of the following is not a common practice for input validation?",
    "choice_a": "Conduct data validation on a trusted system.",
    "choice_b": "Validate data length.",
    "choice_c": "Validate all client-provided data before it is processed.",
    "choice_d": "Convert all data to the same data type.",
    "correct_answer": "D",
    "explanation": "OWASP's secure coding practices checklist provides a wide variety of input validation recommendations, including conducting data validation on trusted systems, validating data length, range, and types, and validating all client-provided data before it is processed. Converting all data to the same data type isn't possible because multiple data types are needed for most programs and applications.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      294,
      228,
      213,
      219,
      243
    ],
    "source": ""
  },
  {
    "id": 5160,
    "question": "Val is testing her organization's software using a tool that simulates an attacker's actions against it. What type of testing is Val conducting?",
    "choice_a": "SAST",
    "choice_b": "LAST",
    "choice_c": "DAST",
    "choice_d": "FAST",
    "correct_answer": "C",
    "explanation": "Val is conducting dynamic application security testing, or DAST. DAST simulates an attacker's actions against software to test it. SAST reviews source code to identify vulnerabilities. FAST and LAST are not software testing methodologies or tools.",
    "topic_id": 8,
    "practice_test_id": 4,
    "related_articles": [
      963,
      962,
      626,
      662,
      621
    ],
    "source": ""
  },
  {
    "id": 5161,
    "question": "Asha's team wants to ensure that all of the functions of their software are tested. What are they ensuring?",
    "choice_a": "Proper misuse case testing",
    "choice_b": "That a breach attack simulation is conducted",
    "choice_c": "Complete interface testing",
    "choice_d": "Complete coverage",
    "correct_answer": "D",
    "explanation": "Coverage analysis is performed to ensure that functionality, requirements, or other elements are completely tested. No misuse cases are described in the question, no interfaces are described, and breach attack simulations are intended to act like an attacker, rather than test for all functions.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      144,
      125,
      143,
      142,
      141
    ],
    "source": ""
  },
  {
    "id": 5162,
    "question": "Sylvia's company's new application allows users to sign up for banking services. Sylvia needs to identify a way to ensure that users are who they claim to be. What is this process called?",
    "choice_a": "Proofing",
    "choice_b": "Registration",
    "choice_c": "FIM",
    "choice_d": "Single sign-on",
    "correct_answer": "A",
    "explanation": "Identity proofing is the process of validating that the entity or individual claiming an identity is the actual person or organization that they claim to be. This commonly relies on additional information like documents or knowledge that others would not have. Registration is the process of creating an account. FIM is federated identity management, and SSO allows a single sign-on to be used across multiple systems or services.",
    "topic_id": 2,
    "practice_test_id": 4,
    "related_articles": [
      139,
      138,
      136,
      120,
      143
    ],
    "source": ""
  },
  {
    "id": 5163,
    "question": "The company that Felipe works for has connected servers they have hosted in a third-party data center to vendor-owned systems using fiber-optic cables for a direct connection to them. What is this called?",
    "choice_a": "Ingress",
    "choice_b": "Peering",
    "choice_c": "East/west",
    "choice_d": "Egress",
    "correct_answer": "B",
    "explanation": "This is an example of peering. Peering can be either public peering, a connection through an Internet Exchange Point via a network connection, or private peering done directly with another entity in a colocation facility. Ingress is traffic coming into a network, egress is traffic that is leaving a network, and east/west refers to network traffic in the same zone or layer of a network.",
    "topic_id": 4,
    "practice_test_id": 4,
    "related_articles": [
      1066,
      358,
      1068,
      427,
      374
    ],
    "source": ""
  },
  {
    "id": 5164,
    "question": "Kyle wants to ensure that his organization's backups are stored securely in case of a natural disaster or other event. What type of solution should he choose if he needs to store backup tapes?",
    "choice_a": "A cloud backup service",
    "choice_b": "A hot site",
    "choice_c": "A media storage facility",
    "choice_d": "A BaaS provider",
    "correct_answer": "C",
    "explanation": "Media storage facilities are frequently used when organizations want to securely store backups like tapes in a secure, temperature-controlled facility. Cloud services are not used for physical backup media; hot sites are used to restore operations, not to store backup media; and BaaS is backup as a service\u2014another description for a cloud backup service.",
    "topic_id": 7,
    "practice_test_id": 4,
    "related_articles": [
      517,
      589,
      582,
      515,
      598
    ],
    "source": ""
  },
  {
    "id": 5165,
    "question": "Sharon wants to conduct a pass-the-hash attack. Which of the following is not a common means of acquiring NTLM hashes for the attack?",
    "choice_a": "Dumping the system's SAM",
    "choice_b": "Dumping credentials from active memory",
    "choice_c": "Capturing network traffic",
    "choice_d": "Downloading the hashes from a third-party site",
    "correct_answer": "D",
    "explanation": "Pass-the-hash attacks (PtH) often rely on dumped local account databases (the SAM), capturing credentials from the network while they are in transit or from active memory. Pass-the-hash attacks are not typically conducted by downloading hashes from third-party sites.",
    "topic_id": 3,
    "practice_test_id": 4,
    "related_articles": [
      199,
      195,
      153,
      152,
      228
    ],
    "source": ""
  }
];
